module.exports = {
	RECORDS: [
		{
		  "id": "00107e4057ac15e394c5099af508df4b",
		  "name": "Torey",
		  "createdDate": "2022-01-28 16:39:36",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 594,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1989,
		  "schedulePercent": 0.711355,
		  "totalGuests": 1322,
		  "guestPercent": 0.890639,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0012845d2156d7e9ed50c15bf435ed55",
		  
		  "name": "Hannah",
		  "createdDate": "2018-07-16 19:04:54",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 418,
		  "totalCountries": 8,
		  "totalStates": 48,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1179,
		  "schedulePercent": 0.541931,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "001862ce461ad61492c4357416579fa0",
		  
		  "name": "Adam",
		  "createdDate": "2021-12-10 17:16:02",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 749,
		  "totalCountries": 13,
		  "totalStates": 53,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 4098,
		  "schedulePercent": 0.918518,
		  "totalGuests": 2531,
		  "guestPercent": 0.969742,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0022de149e4a6f20102e8415d2ff0474",
		  
		  "name": "Grayton",
		  "createdDate": "2023-10-21 02:34:40",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 334,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 846,
		  "schedulePercent": 0.439257,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Pioneer Courthouse Square",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "00250b06362a6f58c896ebb0fe72c654",
		  
		  "name": "Sarah",
		  "createdDate": "2019-02-07 11:41:12",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 121,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 1070,
		  "schedulePercent": 0.510426,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "00275b229f2df975d2e4c9ad1a2d5e84",
		  
		  "name": "Tori",
		  "createdDate": "2013-08-25 17:39:59",
		  "totalOrganizations": 18,
		  "totalTours": 13,
		  "totalDays": 1771,
		  "totalCountries": 39,
		  "totalStates": 69,
		  "totalEvents": 250,
		  "eventPercent": 0.87092,
		  "totalScheduleItems": 3406,
		  "schedulePercent": 0.875907,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "NOS Alive",
		  "mostGuestCity": "Alges",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0031f56cab5b421fbdcf3097524d4bf2",
		  
		  "name": "Eddie",
		  "createdDate": "2010-11-12 23:04:39",
		  "totalOrganizations": 9,
		  "totalTours": 18,
		  "totalDays": 587,
		  "totalCountries": 31,
		  "totalStates": 91,
		  "totalEvents": 261,
		  "eventPercent": 0.88248,
		  "totalScheduleItems": 2004,
		  "schedulePercent": 0.714415,
		  "totalGuests": 602,
		  "guestPercent": 0.75884,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "WestWorld of Scottsdale",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "003435bc42803adbb7bbb925f579d12f",
		  
		  "name": "Austin",
		  "createdDate": "2019-04-18 04:05:58",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 1044,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 2835,
		  "schedulePercent": 0.826269,
		  "totalGuests": 1032,
		  "guestPercent": 0.851541,
		  "mostGuestDate": "2025-06-22 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "00453741ad8ee53b91ba1e7ec807ff52",
		  
		  "name": "Tops",
		  "createdDate": "2017-04-13 13:40:37",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 443,
		  "totalCountries": 15,
		  "totalStates": 40,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1499,
		  "schedulePercent": 0.618087,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "00577fff8e2fa7513413b5e0b7e77ed1",
		  
		  "name": "Lily",
		  "createdDate": "2022-06-13 15:22:22",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 202,
		  "totalCountries": 10,
		  "totalStates": 22,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 152,
		  "schedulePercent": 0.131006,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Thalia Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "005a23a8f9dc56b37942f692a0057ecd",
		  
		  "name": "Joe",
		  "createdDate": "2018-09-14 13:51:12",
		  "totalOrganizations": 15,
		  "totalTours": 23,
		  "totalDays": 923,
		  "totalCountries": 26,
		  "totalStates": 70,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 3054,
		  "schedulePercent": 0.847915,
		  "totalGuests": 668,
		  "guestPercent": 0.777199,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0082a6221d7ab8542964ef555300b86a",
		  
		  "name": "Tom",
		  "createdDate": "2014-07-17 10:22:05",
		  "totalOrganizations": 31,
		  "totalTours": 34,
		  "totalDays": 1355,
		  "totalCountries": 46,
		  "totalStates": 135,
		  "totalEvents": 582,
		  "eventPercent": 0.986627,
		  "totalScheduleItems": 7825,
		  "schedulePercent": 0.990027,
		  "totalGuests": 4470,
		  "guestPercent": 0.99592,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "008318f275f8efc8d1ac7a7eb38a3d64",
		  
		  "name": "Maarten",
		  "createdDate": "2019-01-03 17:53:53",
		  "totalOrganizations": 10,
		  "totalTours": 14,
		  "totalDays": 534,
		  "totalCountries": 31,
		  "totalStates": 44,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 3572,
		  "schedulePercent": 0.887126,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "00f1d08882b021d40b3cf43ae47616f5",
		  
		  "name": "Rena ",
		  "createdDate": "2016-12-28 20:05:48",
		  "totalOrganizations": 21,
		  "totalTours": 12,
		  "totalDays": 108,
		  "totalCountries": 5,
		  "totalStates": 21,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 484,
		  "schedulePercent": 0.303604,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "Masonic Lodge at Hollywood Forever",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "00f29f56b832d8492eb3440e47c8f06c",
		  
		  "name": "Suzanne",
		  "createdDate": "2012-06-13 16:51:20",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 255,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1192,
		  "schedulePercent": 0.545444,
		  "totalGuests": 205,
		  "guestPercent": 0.598368,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "The Brighton Centre",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "00f2b59fff94fe8e0d3ad05d528d65bc",
		  
		  "name": "Avery",
		  "createdDate": "2016-03-21 05:24:06",
		  "totalOrganizations": 38,
		  "totalTours": 3,
		  "totalDays": 731,
		  "totalCountries": 8,
		  "totalStates": 18,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 8,
		  "schedulePercent": 0.0181324,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "00f5d878205f0719949e97ecaef97a8b",
		  
		  "name": "Bonnie",
		  "createdDate": "2018-11-07 05:30:40",
		  "totalOrganizations": 22,
		  "totalTours": 48,
		  "totalDays": 1429,
		  "totalCountries": 23,
		  "totalStates": 87,
		  "totalEvents": 370,
		  "eventPercent": 0.949683,
		  "totalScheduleItems": 4943,
		  "schedulePercent": 0.952403,
		  "totalGuests": 1329,
		  "guestPercent": 0.891206,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0100271e75df669f127d8ad45aea8cbf",
		  
		  "name": "Gabriella",
		  "createdDate": "2016-10-19 16:17:58",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 338,
		  "totalCountries": 8,
		  "totalStates": 38,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 2508,
		  "schedulePercent": 0.787625,
		  "totalGuests": 1347,
		  "guestPercent": 0.892566,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0104f702e530287bdfd11692a4471a6b",
		  
		  "name": "William",
		  "createdDate": "2023-09-13 15:37:23",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 688,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 927,
		  "schedulePercent": 0.467362,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "010823e669497cfe1acbec2d164123be",
		  
		  "name": "Sean",
		  "createdDate": "2018-02-26 10:15:00",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 289,
		  "totalCountries": 21,
		  "totalStates": 35,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 2055,
		  "schedulePercent": 0.724388,
		  "totalGuests": 1318,
		  "guestPercent": 0.889733,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Blackpool Opera House",
		  "mostGuestCity": "Blackpool",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01085eaf367eb91bc9b3e36957658be5",
		  
		  "name": "Hidemi ",
		  "createdDate": "2025-01-04 07:37:01",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 98,
		  "totalCountries": 8,
		  "totalStates": 15,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0109eca4a7c9d7eb6a9fb16bfdd82936",
		  
		  "name": "Kathrine",
		  "createdDate": "2025-05-01 07:47:04",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 589,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 285,
		  "schedulePercent": 0.209542,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0109f48b4551e7c436b91b3be9a2149d",
		  
		  "name": "Laurent",
		  "createdDate": "2024-03-01 17:49:32",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 101,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-02-09 00:00:00",
		  "mostGuestName": "Palais de Congres",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01179dff9637d10b4301604382827c82",
		  
		  "name": "Guillermo",
		  "createdDate": "2025-02-23 09:28:10",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 639,
		  "totalCountries": 6,
		  "totalStates": 27,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 741,
		  "schedulePercent": 0.401859,
		  "totalGuests": 240,
		  "guestPercent": 0.61922,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "011a6e23ffd6b0d45d5099b684ec4878",
		  
		  "name": "Guillaume",
		  "createdDate": "2018-07-25 08:31:26",
		  "totalOrganizations": 22,
		  "totalTours": 18,
		  "totalDays": 122,
		  "totalCountries": 8,
		  "totalStates": 11,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01255a82b9feecb6c38c9dd851623b3e",
		  
		  "name": "Tom",
		  "createdDate": "2023-04-26 20:12:26",
		  "totalOrganizations": 2,
		  "totalTours": 24,
		  "totalDays": 624,
		  "totalCountries": 5,
		  "totalStates": 17,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1000,
		  "schedulePercent": 0.490141,
		  "totalGuests": 517,
		  "guestPercent": 0.735041,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Gare du Midi Biarritz",
		  "mostGuestCity": "Biarritz",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0135564a4de2e62a82489f27d90919c6",
		  
		  "name": "David",
		  "createdDate": "2023-01-13 17:37:59",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 273,
		  "totalCountries": 26,
		  "totalStates": 58,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1778,
		  "schedulePercent": 0.672144,
		  "totalGuests": 923,
		  "guestPercent": 0.834655,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "013 Poppodium",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "013799151a83679abf5f6a5535255dde",
		  
		  "name": "David",
		  "createdDate": "2022-11-13 21:19:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 260,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 77,
		  "schedulePercent": 0.0801224,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "013bf150f6996cfe9e9222f611807d3c",
		  
		  "name": "Kevin",
		  "createdDate": "2021-12-16 10:49:41",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 955,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1089,
		  "schedulePercent": 0.517566,
		  "totalGuests": 136,
		  "guestPercent": 0.549524,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "NRG Stadium",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "014000fed41870dec243b5e4f0d32561",
		  
		  "name": "Jenna",
		  "createdDate": "2025-09-10 08:28:36",
		  "totalOrganizations": 40,
		  "totalTours": 39,
		  "totalDays": 302,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 305,
		  "eventPercent": 0.915798,
		  "totalScheduleItems": 880,
		  "schedulePercent": 0.451269,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0141d95d64a5c937a4249a7af6f06e44",
		  
		  "name": "Drew",
		  "createdDate": "2022-07-26 23:10:29",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 97,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 518,
		  "schedulePercent": 0.320603,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Zepp DiverCity",
		  "mostGuestCity": "",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01448b81f6db5690ca30b931768ba82b",
		  
		  "name": "Joe",
		  "createdDate": "2023-10-06 14:00:44",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 995,
		  "totalCountries": 2,
		  "totalStates": 46,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1706,
		  "schedulePercent": 0.659451,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Middle Tennessee District Fair- Rotary Park",
		  "mostGuestCity": "Lawrenceburg",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "014609b45b5feb74d14afc444f4ccb6a",
		  
		  "name": "Andy",
		  "createdDate": "2024-04-29 07:01:36",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 757,
		  "totalCountries": 8,
		  "totalStates": 22,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 388,
		  "schedulePercent": 0.263486,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Beach Ballroom",
		  "mostGuestCity": "Aberdeen",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "015f995b70c21825c6350c675e5f3396",
		  
		  "name": "David",
		  "createdDate": "2019-06-18 05:55:40",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 890,
		  "totalCountries": 22,
		  "totalStates": 58,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 3268,
		  "schedulePercent": 0.865594,
		  "totalGuests": 678,
		  "guestPercent": 0.780372,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01639df288d11c32bc7cf9647ad505be",
		  
		  "name": "Amanda",
		  "createdDate": "2020-08-02 20:38:57",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 739,
		  "totalCountries": 32,
		  "totalStates": 39,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2784,
		  "schedulePercent": 0.819923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0164728e2556314e72c7e1d8a5342f16",
		  
		  "name": "Francois",
		  "createdDate": "2018-07-25 14:13:57",
		  "totalOrganizations": 21,
		  "totalTours": 17,
		  "totalDays": 115,
		  "totalCountries": 8,
		  "totalStates": 11,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 422,
		  "schedulePercent": 0.278898,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0176af54cda1eda4037113c4354ce916",
		  
		  "name": "Leigh",
		  "createdDate": "2025-04-02 22:40:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 113,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "017bcb85481d5054bc85061166b9ee77",
		  
		  "name": "M4",
		  "createdDate": "2012-11-27 00:43:38",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 59,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 210,
		  "schedulePercent": 0.166251,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Skipper's Smokehouse",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "019132eaa5a4c876b97b1692a24bfec8",
		  
		  "name": "Tyler",
		  "createdDate": "2019-06-24 00:27:33",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 1455,
		  "totalCountries": 17,
		  "totalStates": 71,
		  "totalEvents": 365,
		  "eventPercent": 0.948096,
		  "totalScheduleItems": 3799,
		  "schedulePercent": 0.902765,
		  "totalGuests": 1315,
		  "guestPercent": 0.888713,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01918c15223ebc9763623fe367a0b314",
		  
		  "name": "Eric",
		  "createdDate": "2022-10-10 23:02:41",
		  "totalOrganizations": 11,
		  "totalTours": 15,
		  "totalDays": 826,
		  "totalCountries": 7,
		  "totalStates": 54,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 3651,
		  "schedulePercent": 0.892679,
		  "totalGuests": 722,
		  "guestPercent": 0.790798,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "019a11d4e47b70eca98460cb634c743a",
		  
		  "name": "Danielle",
		  "createdDate": "2023-07-04 15:36:11",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 1071,
		  "totalCountries": 19,
		  "totalStates": 38,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 2775,
		  "schedulePercent": 0.818676,
		  "totalGuests": 192,
		  "guestPercent": 0.587262,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Chicago Theatre",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "019e32da08835581cecf5b0ba7cb5dfc",
		  
		  "name": "Jacob",
		  "createdDate": "2019-10-23 18:57:22",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 21,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 140,
		  "schedulePercent": 0.12432,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Tioga-Sequoia Brewing Company Beer Garden",
		  "mostGuestCity": "Fresno",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01a0d5208f67ef371b22894963882771",
		  
		  "name": "Francine",
		  "createdDate": "2020-03-25 10:53:28",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 1209,
		  "totalCountries": 26,
		  "totalStates": 65,
		  "totalEvents": 373,
		  "eventPercent": 0.951383,
		  "totalScheduleItems": 5952,
		  "schedulePercent": 0.975181,
		  "totalGuests": 105,
		  "guestPercent": 0.524932,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Market Rasen Racecourse",
		  "mostGuestCity": "Market Rasen",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01a3e5082b3245bf7c50a8ee08143ac4",
		  
		  "name": "Erik",
		  "createdDate": "2010-07-16 19:29:01",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 733,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 1100,
		  "schedulePercent": 0.519492,
		  "totalGuests": 399,
		  "guestPercent": 0.694016,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Ford Amphitheater",
		  "mostGuestCity": "Colorado Springs",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01a8c6771ff49ffee371eddd7710cc8a",
		  
		  "name": "Keith",
		  "createdDate": "2022-09-06 22:53:27",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 246,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 455,
		  "schedulePercent": 0.292611,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Celebrity Theatre",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01b91745b6ed5358ab63ac908ce0cdbd",
		  
		  "name": "Francois",
		  "createdDate": "2012-06-29 11:56:19",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 216,
		  "totalCountries": 25,
		  "totalStates": 49,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1168,
		  "schedulePercent": 0.539665,
		  "totalGuests": 1089,
		  "guestPercent": 0.861967,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01bfd72eb0517fef732d7d09494b55fa",
		  
		  "name": "Nathan",
		  "createdDate": "2017-07-06 19:55:22",
		  "totalOrganizations": 19,
		  "totalTours": 9,
		  "totalDays": 1111,
		  "totalCountries": 10,
		  "totalStates": 61,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 3129,
		  "schedulePercent": 0.853581,
		  "totalGuests": 1648,
		  "guestPercent": 0.923844,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01c79d1d00aa1e90ebe83f249a8c431e",
		  
		  "name": "Charlotte",
		  "createdDate": "2019-09-12 13:21:01",
		  "totalOrganizations": 33,
		  "totalTours": 17,
		  "totalDays": 583,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 1188,
		  "schedulePercent": 0.544084,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Horseshoe Tavern",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01c90b614791856ace0e2146f30f2f9f",
		  
		  "name": "Alexia",
		  "createdDate": "2021-08-10 00:16:32",
		  "totalOrganizations": 17,
		  "totalTours": 15,
		  "totalDays": 1212,
		  "totalCountries": 20,
		  "totalStates": 40,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 2254,
		  "schedulePercent": 0.755553,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Wembley Stadium",
		  "mostGuestCity": "Wembley",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01ca2243d9f8395f7fc6ffd56f1ee907",
		  
		  "name": "David",
		  "createdDate": "2022-03-04 20:51:50",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 315,
		  "totalCountries": 11,
		  "totalStates": 41,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1041,
		  "schedulePercent": 0.5017,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Mr. Smalls Theatre",
		  "mostGuestCity": "Millvale",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01ce865f6ce2b267b30635ab76290875",
		  
		  "name": "JORGE ",
		  "createdDate": "2024-03-14 00:51:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 314,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 353,
		  "schedulePercent": 0.24422,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01dfdb1422ecc780e64f037e6926f7d8",
		  
		  "name": "Stephanie",
		  "createdDate": "2023-09-12 23:20:15",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 228,
		  "totalCountries": 12,
		  "totalStates": 46,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1730,
		  "schedulePercent": 0.663758,
		  "totalGuests": 1321,
		  "guestPercent": 0.890186,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01f475a40b36aca2c6b5eb820fc902ce",
		  
		  "name": "Jake",
		  "createdDate": "2025-06-23 22:49:54",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 34,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 116,
		  "schedulePercent": 0.108228,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Stickyz",
		  "mostGuestCity": "Little Rock",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "01f661b16b7bb7cddad6f818742e454c",
		  
		  "name": "KALANDRA",
		  "createdDate": "2023-09-25 10:12:02",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 51,
		  "totalCountries": 16,
		  "totalStates": 22,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 391,
		  "schedulePercent": 0.265073,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "TivoliVredenburg Pandora",
		  "mostGuestCity": "Utrecht",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0205982bfbe1917686599328a2b1fc6f",
		  
		  "name": "Craig",
		  "createdDate": "2024-01-17 18:16:54",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 32,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 199,
		  "schedulePercent": 0.160245,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02123b28999c103dbb06230f6c4b382d",
		  
		  "name": "Pierre-Arnold",
		  "createdDate": "2022-07-30 17:45:33",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 57,
		  "totalCountries": 10,
		  "totalStates": 16,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 132,
		  "guestPercent": 0.546124,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "024acdbe9b01f845f3ef6819421a6a17",
		  
		  "name": "Andre",
		  "createdDate": "2012-03-29 21:15:42",
		  "totalOrganizations": 19,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 9,
		  "totalStates": 6,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 185,
		  "schedulePercent": 0.150725,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "024b1be45dd5e524e2efa2ca7200ff8d",
		  
		  "name": "David",
		  "createdDate": "2024-08-16 09:01:31",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 229,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2825,
		  "schedulePercent": 0.825136,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "024e45e04429c06cf16259836500f736",
		  
		  "name": "Bart",
		  "createdDate": "2013-04-28 19:31:13",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "024f7d02b90efd688c3b185469219580",
		  
		  "name": "Gianpiero",
		  "createdDate": "2025-03-20 03:35:12",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 142,
		  "schedulePercent": 0.126587,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Uptown Theater",
		  "mostGuestCity": "KCMO",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02505f69f26bae693fce290c719d752f",
		  
		  "name": "Andy",
		  "createdDate": "2010-02-12 10:16:12",
		  "totalOrganizations": 10,
		  "totalTours": 24,
		  "totalDays": 672,
		  "totalCountries": 15,
		  "totalStates": 50,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2019,
		  "schedulePercent": 0.717248,
		  "totalGuests": 673,
		  "guestPercent": 0.779238,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "025e5b6192fc8ffea1db70d91624e01c",
		  
		  "name": "Lisa",
		  "createdDate": "2017-12-26 04:34:10",
		  "totalOrganizations": 27,
		  "totalTours": 27,
		  "totalDays": 705,
		  "totalCountries": 22,
		  "totalStates": 87,
		  "totalEvents": 364,
		  "eventPercent": 0.947983,
		  "totalScheduleItems": 4323,
		  "schedulePercent": 0.932117,
		  "totalGuests": 191,
		  "guestPercent": 0.586582,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Globe Iron",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "025fd9d5c7afc201b2d3d526189b67cc",
		  
		  "name": "CRAIG",
		  "createdDate": "2013-05-29 23:44:14",
		  "totalOrganizations": 7,
		  "totalTours": 1,
		  "totalDays": 116,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 909,
		  "schedulePercent": 0.461242,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Mississippi Coliseum",
		  "mostGuestCity": "Jackson",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02663287fad8085b7940ee27a87cedeb",
		  
		  "name": "Ross",
		  "createdDate": "2019-08-29 18:18:01",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 218,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 565,
		  "schedulePercent": 0.338735,
		  "totalGuests": 129,
		  "guestPercent": 0.543518,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Glasgow Green",
		  "mostGuestCity": "",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0276fab8a28458c6f069b2b38bbf448c",
		  
		  "name": "Annastezhaa",
		  "createdDate": "2024-06-27 22:10:06",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 408,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 389,
		  "schedulePercent": 0.264279,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "027f312b2eb86b46736cfa2f40bde82a",
		  
		  "name": "Tim",
		  "createdDate": "2022-01-10 23:45:15",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 489,
		  "totalCountries": 19,
		  "totalStates": 60,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 2190,
		  "schedulePercent": 0.7466,
		  "totalGuests": 555,
		  "guestPercent": 0.74524,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Scala",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02861eda0dd17b468a58bbeade4e1338",
		  
		  "name": "Beanie",
		  "createdDate": "2022-05-18 02:34:29",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 49,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Motorco Music Hall",
		  "mostGuestCity": "Durham",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0288d60e523d33b86a0a138c5857c49b",
		  
		  "name": "Black",
		  "createdDate": "2022-04-20 23:52:26",
		  "totalOrganizations": 24,
		  "totalTours": 58,
		  "totalDays": 2103,
		  "totalCountries": 30,
		  "totalStates": 85,
		  "totalEvents": 722,
		  "eventPercent": 0.991727,
		  "totalScheduleItems": 7247,
		  "schedulePercent": 0.987874,
		  "totalGuests": 1454,
		  "guestPercent": 0.905825,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Dolby Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "028983e771204089f8c45eea582eef7b",
		  
		  "name": "Imogen",
		  "createdDate": "2024-08-10 15:20:37",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 674,
		  "totalCountries": 24,
		  "totalStates": 23,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 3222,
		  "schedulePercent": 0.861627,
		  "totalGuests": 655,
		  "guestPercent": 0.772552,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The SSE Hydro",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "029114a8016d02c94d79abbbe95511bd",
		  
		  "name": "Sarah",
		  "createdDate": "2022-07-25 23:00:17",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 77,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 547,
		  "schedulePercent": 0.332956,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "029247049e83136dfa0f27beae914f18",
		  
		  "name": "Adrian",
		  "createdDate": "2020-01-02 21:27:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 303,
		  "schedulePercent": 0.218608,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "USF Verftet",
		  "mostGuestCity": "Bergen",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0294072510629b1ffc51992818477571",
		  
		  "name": "John",
		  "createdDate": "2025-03-19 21:22:04",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 242,
		  "totalCountries": 12,
		  "totalStates": 50,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1330,
		  "schedulePercent": 0.579896,
		  "totalGuests": 553,
		  "guestPercent": 0.7449,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Town Ballroom",
		  "mostGuestCity": "Buffalo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02940a8272ec538ea3baaaea8c3fc737",
		  
		  "name": "Samantha",
		  "createdDate": "2019-07-01 23:01:18",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 95,
		  "totalCountries": 9,
		  "totalStates": 14,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 112,
		  "guestPercent": 0.529805,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0294662bbeb4e877e9bbf9abc3733232",
		  
		  "name": "Patrick",
		  "createdDate": "2012-02-01 19:41:48",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 913,
		  "totalCountries": 19,
		  "totalStates": 63,
		  "totalEvents": 288,
		  "eventPercent": 0.904465,
		  "totalScheduleItems": 5448,
		  "schedulePercent": 0.966682,
		  "totalGuests": 2285,
		  "guestPercent": 0.961129,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "029c091c6a58685ea25946f0150f124e",
		  
		  "name": "Chris",
		  "createdDate": "2022-04-06 00:50:09",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 443,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 281,
		  "schedulePercent": 0.206256,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "029f86deaf4515bc234b3dc07b927d20",
		  
		  "name": "Shelby",
		  "createdDate": "2017-07-12 21:58:37",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 964,
		  "totalCountries": 22,
		  "totalStates": 52,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 3680,
		  "schedulePercent": 0.894719,
		  "totalGuests": 451,
		  "guestPercent": 0.713055,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Magazine London",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02a245e93b3a60d00440bc61187bd4f9",
		  
		  "name": "Cian",
		  "createdDate": "2023-10-18 14:05:04",
		  "totalOrganizations": 9,
		  "totalTours": 19,
		  "totalDays": 435,
		  "totalCountries": 19,
		  "totalStates": 49,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 1802,
		  "schedulePercent": 0.676564,
		  "totalGuests": 231,
		  "guestPercent": 0.613327,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Lincoln Theatre",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02ad553830def312ebe0c4901bdaad99",
		  
		  "name": "shaun",
		  "createdDate": "2013-08-26 20:19:22",
		  "totalOrganizations": 20,
		  "totalTours": 8,
		  "totalDays": 625,
		  "totalCountries": 15,
		  "totalStates": 47,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 1756,
		  "schedulePercent": 0.669538,
		  "totalGuests": 659,
		  "guestPercent": 0.773572,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02aec539506ebe4be6fbd20e7ebd0785",
		  
		  "name": "Jay",
		  "createdDate": "2025-03-24 03:56:29",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 92,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 683,
		  "schedulePercent": 0.380326,
		  "totalGuests": 244,
		  "guestPercent": 0.6216,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Centennial Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02b409579ff195b1780ac204efe947f0",
		  
		  "name": "Justin",
		  "createdDate": "2018-04-09 23:23:01",
		  "totalOrganizations": 12,
		  "totalTours": 24,
		  "totalDays": 309,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 3260,
		  "schedulePercent": 0.865027,
		  "totalGuests": 419,
		  "guestPercent": 0.701496,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Moody Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02b7dc698de78160ed260c440bc72ae7",
		  
		  "name": "Weston",
		  "createdDate": "2013-08-26 21:48:53",
		  "totalOrganizations": 15,
		  "totalTours": 14,
		  "totalDays": 1258,
		  "totalCountries": 8,
		  "totalStates": 55,
		  "totalEvents": 304,
		  "eventPercent": 0.915231,
		  "totalScheduleItems": 3523,
		  "schedulePercent": 0.883273,
		  "totalGuests": 2638,
		  "guestPercent": 0.973481,
		  "mostGuestDate": "2025-07-21 00:00:00",
		  "mostGuestName": "Desert 5 Spot",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02c02d85c2d176ade1869bd5e5e9f072",
		  
		  "name": "Matthew ",
		  "createdDate": "2019-02-25 18:05:46",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 93,
		  "totalCountries": 5,
		  "totalStates": 21,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 516,
		  "schedulePercent": 0.31947,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02cb7f860349ff680c37c0e2350d0b2a",
		  
		  "name": "Jaska",
		  "createdDate": "2019-07-23 02:53:32",
		  "totalOrganizations": 8,
		  "totalTours": 18,
		  "totalDays": 512,
		  "totalCountries": 22,
		  "totalStates": 82,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 3018,
		  "schedulePercent": 0.844062,
		  "totalGuests": 1983,
		  "guestPercent": 0.946283,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "1720",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02cd15be6952459da9989b0a361f4da8",
		  
		  "name": "Simon",
		  "createdDate": "2018-11-21 19:10:52",
		  "totalOrganizations": 2,
		  "totalTours": 39,
		  "totalDays": 206,
		  "totalCountries": 10,
		  "totalStates": 30,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1337,
		  "schedulePercent": 0.582729,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02cf362b1af4b582ff7a2eee23767457",
		  
		  "name": "Nandor",
		  "createdDate": "2013-02-05 18:02:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 162,
		  "totalCountries": 4,
		  "totalStates": 52,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 998,
		  "schedulePercent": 0.489687,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02d2e3edba3721e1002daafaf2093823",
		  
		  "name": "Laurie",
		  "createdDate": "2022-06-22 14:43:35",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 768,
		  "totalCountries": 10,
		  "totalStates": 26,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1482,
		  "schedulePercent": 0.613554,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02e23272473b38ebc5b8cc811500034a",
		  
		  "name": "Kassie",
		  "createdDate": "2025-06-26 16:23:54",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 73,
		  "schedulePercent": 0.0766092,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02e685c21b2f33a29c65faf221675b5a",
		  
		  "name": "Daniel",
		  "createdDate": "2025-02-18 02:20:38",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 624,
		  "totalCountries": 10,
		  "totalStates": 42,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1380,
		  "schedulePercent": 0.592702,
		  "totalGuests": 97,
		  "guestPercent": 0.516092,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Downtown Las Vegas Events Center",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02eec1d2cf6d9a7a2b350f2a56532cc1",
		  
		  "name": "Ricki",
		  "createdDate": "2017-08-24 03:54:44",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 798,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 977,
		  "schedulePercent": 0.483568,
		  "totalGuests": 324,
		  "guestPercent": 0.663191,
		  "mostGuestDate": "2025-01-05 00:00:00",
		  "mostGuestName": "Miami Marketta",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02efcb163beee121a055c99110a23bfc",
		  
		  "name": "Bradley",
		  "createdDate": "2021-10-04 15:14:05",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 604,
		  "schedulePercent": 0.352335,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-12-05 00:00:00",
		  "mostGuestName": "Capitol Center for the Arts",
		  "mostGuestCity": "Concord",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02f040ca7bf6b756a980af9eb8caec91",
		  
		  "name": "George",
		  "createdDate": "2012-02-20 16:14:30",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 304,
		  "totalCountries": 36,
		  "totalStates": 45,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 2033,
		  "schedulePercent": 0.719742,
		  "totalGuests": 776,
		  "guestPercent": 0.801564,
		  "mostGuestDate": "2025-02-11 00:00:00",
		  "mostGuestName": "Cirkus Arena",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "02fbb4f91334037560bb63143a772f2b",
		  
		  "name": "Craig",
		  "createdDate": "2013-02-25 20:20:19",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 1028,
		  "totalCountries": 7,
		  "totalStates": 42,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1020,
		  "schedulePercent": 0.49626,
		  "totalGuests": 217,
		  "guestPercent": 0.606528,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "The Theater at Virgin Hotels",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0309c7628707323efd17d6ebdf2a85fb",
		  
		  "name": "Brian",
		  "createdDate": "2014-01-20 06:57:25",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 205,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1199,
		  "schedulePercent": 0.547257,
		  "totalGuests": 262,
		  "guestPercent": 0.630553,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Montauk Lighthouse",
		  "mostGuestCity": "Montauk",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "030d6f474ea08b7a7d3b3b4c8ca35117",
		  
		  "name": "Amanda",
		  "createdDate": "2022-07-29 18:06:54",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0319b864aad92f82a8317a9c495e7088",
		  
		  "name": "Dave",
		  "createdDate": "2019-03-11 16:54:19",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 470,
		  "totalCountries": 21,
		  "totalStates": 44,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 976,
		  "schedulePercent": 0.483114,
		  "totalGuests": 191,
		  "guestPercent": 0.586582,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0319e1e6613780acea15a9fdc161f070",
		  
		  "name": "Walk Off Entertainment",
		  "createdDate": "2025-02-26 17:12:34",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 81,
		  "totalCountries": 10,
		  "totalStates": 23,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 377,
		  "schedulePercent": 0.256346,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Nalen",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "031bf8e7671397cb5f6e06a6d1d681bd",
		  
		  "name": "Paige",
		  "createdDate": "2015-04-08 20:55:16",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 118,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 1039,
		  "schedulePercent": 0.50102,
		  "totalGuests": 562,
		  "guestPercent": 0.746827,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "031f30078fe52e90b1a4ed59d3088cf6",
		  
		  "name": "Mike",
		  "createdDate": "2018-08-30 12:47:59",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 329,
		  "totalCountries": 17,
		  "totalStates": 27,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1037,
		  "schedulePercent": 0.50068,
		  "totalGuests": 183,
		  "guestPercent": 0.581482,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "O2 Ritz Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "032697f76b250d9e635a35f4c79eef30",
		  
		  "name": "jennifer",
		  "createdDate": "2019-01-28 20:18:37",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 269,
		  "totalCountries": 12,
		  "totalStates": 13,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 352,
		  "schedulePercent": 0.243994,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03329fa12b8b6f819c2ea7cf642c0255",
		  
		  "name": "Chris",
		  "createdDate": "2014-03-12 18:27:18",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 82,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03341bd3181ad5249657e2d92b3eed18",
		  
		  "name": "Caisa",
		  "createdDate": "2018-09-20 08:08:32",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 194,
		  "totalCountries": 21,
		  "totalStates": 48,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1647,
		  "schedulePercent": 0.649705,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "033528f2e59bc3b1eda8aed27e20ff59",
		  
		  "name": "connor",
		  "createdDate": "2022-06-08 09:17:13",
		  "totalOrganizations": 22,
		  "totalTours": 16,
		  "totalDays": 642,
		  "totalCountries": 26,
		  "totalStates": 77,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 2664,
		  "schedulePercent": 0.804057,
		  "totalGuests": 263,
		  "guestPercent": 0.63078,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "The Garage",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "033cedaee494574c1093f7f789627a20",
		  
		  "name": "Amanda",
		  "createdDate": "2023-01-13 21:25:52",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 1149,
		  "totalCountries": 15,
		  "totalStates": 50,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 1634,
		  "schedulePercent": 0.646306,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Tacoma Dome",
		  "mostGuestCity": "Tacoma",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "033f9ce14de30c28e468e159170bf00c",
		  
		  "name": "Scott",
		  "createdDate": "2009-07-15 23:35:16",
		  "totalOrganizations": 24,
		  "totalTours": 2,
		  "totalDays": 189,
		  "totalCountries": 5,
		  "totalStates": 29,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 916,
		  "schedulePercent": 0.463735,
		  "totalGuests": 139,
		  "guestPercent": 0.551677,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "Stephens Auditorium",
		  "mostGuestCity": "Ames",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "035eeaca2f3ef13b323068996b7d7c8a",
		  
		  "name": "Sarah",
		  "createdDate": "2025-03-03 10:07:53",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 54,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 180,
		  "schedulePercent": 0.146419,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "035f202a9bf070c20f176687368e8cb4",
		  
		  "name": "MIk",
		  "createdDate": "2023-04-19 14:00:54",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 370,
		  "totalCountries": 3,
		  "totalStates": 51,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 3422,
		  "schedulePercent": 0.87738,
		  "totalGuests": 1865,
		  "guestPercent": 0.937103,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "035f2b78d85d1badb2f208ce0cff18fc",
		  
		  "name": "Kevin",
		  "createdDate": "2021-09-04 19:02:48",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 301,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1827,
		  "schedulePercent": 0.681097,
		  "totalGuests": 413,
		  "guestPercent": 0.698663,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Intuit Dome",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03676d05b9b2604205ae58c7f1eaa905",
		  
		  "name": "Sneeha",
		  "createdDate": "2024-07-09 21:50:46",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 373,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03716e2f2382321a23188555f8aa288a",
		  
		  "name": "Mike",
		  "createdDate": "2021-10-13 10:52:14",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 52,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Matullia Lands at Rock Bay",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0397f0a71795305014010f7478438a33",
		  
		  "name": "Rosalie",
		  "createdDate": "2025-05-15 16:58:18",
		  "totalOrganizations": 11,
		  "totalTours": 43,
		  "totalDays": 615,
		  "totalCountries": 29,
		  "totalStates": 65,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 3068,
		  "schedulePercent": 0.848935,
		  "totalGuests": 1152,
		  "guestPercent": 0.871487,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0398e7777bc193355c04adf1d123588d",
		  
		  "name": "Charley ",
		  "createdDate": "2022-10-27 13:28:51",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 2400,
		  "schedulePercent": 0.775272,
		  "totalGuests": 1079,
		  "guestPercent": 0.860381,
		  "mostGuestDate": "2025-06-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "039a9b4222adfcf00480b6e164416455",
		  
		  "name": "NATHAN",
		  "createdDate": "2018-08-01 04:07:53",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 218,
		  "totalCountries": 7,
		  "totalStates": 10,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 595,
		  "schedulePercent": 0.349501,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03a6007f704c1e9dff8b3927f56c636e",
		  
		  "name": "Aaron",
		  "createdDate": "2016-10-17 07:06:36",
		  "totalOrganizations": 8,
		  "totalTours": 25,
		  "totalDays": 601,
		  "totalCountries": 24,
		  "totalStates": 50,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 3713,
		  "schedulePercent": 0.896872,
		  "totalGuests": 897,
		  "guestPercent": 0.829329,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03abe8ac8ad9168f259b76b67d735731",
		  
		  "name": "Elena",
		  "createdDate": "2018-01-23 19:17:52",
		  "totalOrganizations": 16,
		  "totalTours": 15,
		  "totalDays": 2184,
		  "totalCountries": 29,
		  "totalStates": 109,
		  "totalEvents": 531,
		  "eventPercent": 0.981868,
		  "totalScheduleItems": 8600,
		  "schedulePercent": 0.992067,
		  "totalGuests": 1011,
		  "guestPercent": 0.848595,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "The Fillmore Silver Spring",
		  "mostGuestCity": "Silver Spring",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03b1ef3e0bc555ca0fe9d1f610a2fe4f",
		  
		  "name": "Ricky",
		  "createdDate": "2018-01-18 21:42:24",
		  "totalOrganizations": 6,
		  "totalTours": 20,
		  "totalDays": 161,
		  "totalCountries": 26,
		  "totalStates": 30,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 612,
		  "schedulePercent": 0.354941,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03b7abf249ad3f216c9a68491a411383",
		  
		  "name": "Frank",
		  "createdDate": "2019-08-08 15:42:47",
		  "totalOrganizations": 23,
		  "totalTours": 25,
		  "totalDays": 1205,
		  "totalCountries": 28,
		  "totalStates": 59,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 3377,
		  "schedulePercent": 0.873527,
		  "totalGuests": 672,
		  "guestPercent": 0.778785,
		  "mostGuestDate": "2025-03-05 00:00:00",
		  "mostGuestName": "Bristol Beacon",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03bdf5fb2fb11ee8daa8897610b4ee8c",
		  
		  "name": "Lui",
		  "createdDate": "2022-11-05 11:26:45",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 72,
		  "totalCountries": 15,
		  "totalStates": 14,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 800,
		  "schedulePercent": 0.422597,
		  "totalGuests": 198,
		  "guestPercent": 0.593155,
		  "mostGuestDate": "2025-02-09 00:00:00",
		  "mostGuestName": "Kaiserkeller | Hamburger Musikclub",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03c226b6efcd080fbabf686aad5f7854",
		  
		  "name": "Kathryn",
		  "createdDate": "2009-11-02 16:10:43",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 83,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 233,
		  "schedulePercent": 0.179964,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03d024e5f6a6dee92d33375f2e7f969d",
		  
		  "name": "Jennifer",
		  "createdDate": "2018-04-26 22:32:14",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 90,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 427,
		  "schedulePercent": 0.280938,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Majestic Theatre",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03d6fbe91f857b11a3bf26ee27a0f3f1",
		  
		  "name": "Tracy",
		  "createdDate": "2022-06-23 14:20:16",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 2504,
		  "totalCountries": 25,
		  "totalStates": 79,
		  "totalEvents": 475,
		  "eventPercent": 0.974615,
		  "totalScheduleItems": 7742,
		  "schedulePercent": 0.989347,
		  "totalGuests": 1623,
		  "guestPercent": 0.921804,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03da635c37ab371a2eff523873ee24bd",
		  
		  "name": "Amber",
		  "createdDate": "2019-04-04 02:48:58",
		  "totalOrganizations": 8,
		  "totalTours": 20,
		  "totalDays": 1415,
		  "totalCountries": 27,
		  "totalStates": 90,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 3405,
		  "schedulePercent": 0.87568,
		  "totalGuests": 1593,
		  "guestPercent": 0.918858,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03e294d0d93c313151e436da6077f6a6",
		  
		  "name": "Shayna",
		  "createdDate": "2023-04-18 21:28:30",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 581,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 678,
		  "schedulePercent": 0.377946,
		  "totalGuests": 369,
		  "guestPercent": 0.68087,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Barclays Center",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03e7899087096c593baaa79caba281b8",
		  
		  "name": "Bobby",
		  "createdDate": "2009-12-11 20:33:11",
		  "totalOrganizations": 18,
		  "totalTours": 4,
		  "totalDays": 244,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 855,
		  "schedulePercent": 0.442203,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03e982bc255f19d82c171106027ec73c",
		  
		  "name": "Mike",
		  "createdDate": "2022-04-12 12:52:41",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 58,
		  "totalCountries": 9,
		  "totalStates": 22,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 345,
		  "schedulePercent": 0.24116,
		  "totalGuests": 208,
		  "guestPercent": 0.600521,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "London Palladium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 128,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03eaffff1b7fca5fa74b94ee55d22be4",
		  
		  "name": "Andy ",
		  "createdDate": "2016-07-14 15:04:22",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 1151,
		  "totalCountries": 24,
		  "totalStates": 32,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 3078,
		  "schedulePercent": 0.849388,
		  "totalGuests": 629,
		  "guestPercent": 0.764959,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03eb9afd840c081014082aec757f08d6",
		  
		  "name": "Miriam ",
		  "createdDate": "2025-02-15 18:37:42",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 637,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1122,
		  "schedulePercent": 0.525499,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03ecbd33a9f1c36075cc05124943e641",
		  
		  "name": "Brandon",
		  "createdDate": "2013-10-03 02:45:43",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 219,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 1609,
		  "schedulePercent": 0.641999,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Tahoe Blue Event Center",
		  "mostGuestCity": "Stateline",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03f5440e6f16d94639d791d6ddba079f",
		  
		  "name": "Gabe ",
		  "createdDate": "2025-01-10 02:07:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 329,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 505,
		  "schedulePercent": 0.31369,
		  "totalGuests": 114,
		  "guestPercent": 0.531505,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Cervantes' Masterpiece Ballroom & Cervantes' Other Side",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03f60cb16622f4749d9e5be2cb8a16c4",
		  
		  "name": "Jonas",
		  "createdDate": "2021-10-03 20:13:33",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 390,
		  "totalCountries": 6,
		  "totalStates": 4,
		  "totalEvents": 383,
		  "eventPercent": 0.954216,
		  "totalScheduleItems": 1382,
		  "schedulePercent": 0.593268,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03f883023450c105ddb4d8bbb4961913",
		  
		  "name": "TROGDOR",
		  "createdDate": "2021-09-01 17:21:34",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 739,
		  "totalCountries": 32,
		  "totalStates": 39,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2784,
		  "schedulePercent": 0.819923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "03fe4a7762d211783b086a1ded90eb16",
		  
		  "name": "Imogen",
		  "createdDate": "2022-10-01 14:10:03",
		  "totalOrganizations": 10,
		  "totalTours": 21,
		  "totalDays": 1741,
		  "totalCountries": 32,
		  "totalStates": 86,
		  "totalEvents": 461,
		  "eventPercent": 0.972801,
		  "totalScheduleItems": 9486,
		  "schedulePercent": 0.995694,
		  "totalGuests": 2890,
		  "guestPercent": 0.979601,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04096a01b28201100d5915b63535330e",
		  
		  "name": "Eboni",
		  "createdDate": "2018-08-11 17:57:43",
		  "totalOrganizations": 37,
		  "totalTours": 47,
		  "totalDays": 3761,
		  "totalCountries": 37,
		  "totalStates": 94,
		  "totalEvents": 713,
		  "eventPercent": 0.991387,
		  "totalScheduleItems": 10615,
		  "schedulePercent": 0.997393,
		  "totalGuests": 1304,
		  "guestPercent": 0.886673,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0410fcd588199a771a9a9b260948309a",
		  
		  "name": "Krissy",
		  "createdDate": "2016-10-04 01:59:41",
		  "totalOrganizations": 18,
		  "totalTours": 51,
		  "totalDays": 384,
		  "totalCountries": 8,
		  "totalStates": 24,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1814,
		  "schedulePercent": 0.678377,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "City Recital Hall",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "041361e25ab55fbee729ba5f84267034",
		  
		  "name": "Sydney",
		  "createdDate": "2022-01-02 17:51:10",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 1552,
		  "totalCountries": 10,
		  "totalStates": 50,
		  "totalEvents": 269,
		  "eventPercent": 0.889393,
		  "totalScheduleItems": 5219,
		  "schedulePercent": 0.960109,
		  "totalGuests": 2907,
		  "guestPercent": 0.980168,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04143afc22256fba69512a1822543235",
		  
		  "name": "Mary",
		  "createdDate": "2016-06-20 21:11:03",
		  "totalOrganizations": 16,
		  "totalTours": 14,
		  "totalDays": 2221,
		  "totalCountries": 26,
		  "totalStates": 53,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 3043,
		  "schedulePercent": 0.846328,
		  "totalGuests": 169,
		  "guestPercent": 0.573096,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Academy Nightclub",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "041b513cc97f84fa96eec091e6821de7",
		  
		  "name": "Carl",
		  "createdDate": "2018-05-21 16:48:24",
		  "totalOrganizations": 19,
		  "totalTours": 30,
		  "totalDays": 1311,
		  "totalCountries": 4,
		  "totalStates": 54,
		  "totalEvents": 406,
		  "eventPercent": 0.960335,
		  "totalScheduleItems": 2837,
		  "schedulePercent": 0.826496,
		  "totalGuests": 1877,
		  "guestPercent": 0.938123,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "041be0683d915154e13cd239715c660c",
		  
		  "name": "James",
		  "createdDate": "2023-04-10 19:27:41",
		  "totalOrganizations": 14,
		  "totalTours": 16,
		  "totalDays": 1068,
		  "totalCountries": 23,
		  "totalStates": 49,
		  "totalEvents": 270,
		  "eventPercent": 0.890299,
		  "totalScheduleItems": 4016,
		  "schedulePercent": 0.914098,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "San Jose Civic Auditorium",
		  "mostGuestCity": "San Jose",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "041c73982b4f3c51a6a2e111982c41e1",
		  
		  "name": "Morgan",
		  "createdDate": "2013-04-26 23:56:18",
		  "totalOrganizations": 12,
		  "totalTours": 35,
		  "totalDays": 519,
		  "totalCountries": 22,
		  "totalStates": 68,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 3062,
		  "schedulePercent": 0.848255,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0435a42d12df668d3fb441645781746a",
		  
		  "name": "Pamela",
		  "createdDate": "2023-05-21 21:46:18",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 380,
		  "totalCountries": 9,
		  "totalStates": 47,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1861,
		  "schedulePercent": 0.687103,
		  "totalGuests": 582,
		  "guestPercent": 0.753626,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "043f6f222781ddb57ad76e1acc950c11",
		  
		  "name": "Ruben ",
		  "createdDate": "2024-12-20 23:55:31",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 398,
		  "totalCountries": 11,
		  "totalStates": 14,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 40,
		  "schedulePercent": 0.0504306,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04413a7c2588d40445f2f1066cf292e1",
		  
		  "name": "Marie",
		  "createdDate": "2024-07-04 08:15:30",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 436,
		  "totalCountries": 8,
		  "totalStates": 13,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 424,
		  "schedulePercent": 0.279692,
		  "totalGuests": 113,
		  "guestPercent": 0.530598,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Vannes scenes du golf",
		  "mostGuestCity": "",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "044448dceb25f30341a2fc25e16d3ddc",
		  
		  "name": "Megan",
		  "createdDate": "2021-10-22 15:32:12",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 173,
		  "totalCountries": 22,
		  "totalStates": 44,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1354,
		  "schedulePercent": 0.586129,
		  "totalGuests": 941,
		  "guestPercent": 0.837942,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "044e83428fc7203b481f415f30cdf833",
		  
		  "name": "Chris",
		  "createdDate": "2018-05-09 21:42:31",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 250,
		  "schedulePercent": 0.189937,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Guernsey County Fairgrounds",
		  "mostGuestCity": "Old Washington",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0450dbf888ef7b8171313b25fe3c3162",
		  
		  "name": "Ryan",
		  "createdDate": "2017-05-07 22:09:02",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 36,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 217,
		  "schedulePercent": 0.170104,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "045450136b4adf9ddbd4a01ea1ef19c4",
		  
		  "name": "Max",
		  "createdDate": "2019-03-02 22:34:23",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 457,
		  "totalCountries": 17,
		  "totalStates": 46,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 2156,
		  "schedulePercent": 0.740707,
		  "totalGuests": 280,
		  "guestPercent": 0.639393,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Montauk Lighthouse",
		  "mostGuestCity": "Montauk",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04600dd3cc9c3addbd34798e01824e49",
		  
		  "name": "Julien ",
		  "createdDate": "2022-05-05 09:54:12",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 852,
		  "totalCountries": 22,
		  "totalStates": 45,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 1112,
		  "schedulePercent": 0.521419,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0469d1c091903933897544823dabeaaf",
		  
		  "name": "Frank",
		  "createdDate": "2013-05-10 04:23:14",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 816,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 779,
		  "schedulePercent": 0.415798,
		  "totalGuests": 135,
		  "guestPercent": 0.548844,
		  "mostGuestDate": "2025-04-16 00:00:00",
		  "mostGuestName": "Venetian Hotel",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04851d5855cf862c41b814212ac24222",
		  
		  "name": "Josef",
		  "createdDate": "2023-05-20 09:00:23",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 84,
		  "totalCountries": 4,
		  "totalStates": 37,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 408,
		  "schedulePercent": 0.272892,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "The National",
		  "mostGuestCity": "Richmond",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "048c8c8eb3343c1481d9e6b5bed865d0",
		  
		  "name": "DON",
		  "createdDate": "2024-02-02 11:02:02",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 84,
		  "totalCountries": 7,
		  "totalStates": 2,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 229,
		  "schedulePercent": 0.177131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "048f8fb17484a2731714139586a192f4",
		  
		  "name": "Lindsey",
		  "createdDate": "2021-12-09 23:36:24",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 512,
		  "totalCountries": 8,
		  "totalStates": 48,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 2262,
		  "schedulePercent": 0.757026,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Wakefield Exchange Shed",
		  "mostGuestCity": "Wakefield",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "049299947fcc83039ccffd965188bfc0",
		  
		  "name": "Gene",
		  "createdDate": "2013-02-02 18:36:22",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 108,
		  "totalCountries": 6,
		  "totalStates": 34,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 487,
		  "schedulePercent": 0.30485,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Bayou Music Center",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04afde0b45c9dba1f03f5b2802d964d2",
		  
		  "name": "Nicola",
		  "createdDate": "2012-10-22 18:08:40",
		  "totalOrganizations": 18,
		  "totalTours": 14,
		  "totalDays": 402,
		  "totalCountries": 22,
		  "totalStates": 70,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 1952,
		  "schedulePercent": 0.703762,
		  "totalGuests": 908,
		  "guestPercent": 0.831709,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04b6ab53906d04553ad2a1a6971d4843",
		  
		  "name": "Chris",
		  "createdDate": "2012-10-18 13:14:06",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 138,
		  "totalCountries": 5,
		  "totalStates": 25,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 695,
		  "schedulePercent": 0.384406,
		  "totalGuests": 321,
		  "guestPercent": 0.660471,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Studio Instrument Rentals",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04b95dcfd93a7d9c316b2db8f25263d6",
		  
		  "name": "Piotr",
		  "createdDate": "2011-02-19 14:08:48",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 107,
		  "totalCountries": 13,
		  "totalStates": 19,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 517,
		  "schedulePercent": 0.32015,
		  "totalGuests": 338,
		  "guestPercent": 0.670104,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Whisky a Go Go",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04d035e17a65b21b99e9616bb00e5a03",
		  
		  "name": "Ipo",
		  "createdDate": "2020-01-14 18:47:00",
		  "totalOrganizations": 8,
		  "totalTours": 47,
		  "totalDays": 328,
		  "totalCountries": 13,
		  "totalStates": 40,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1632,
		  "schedulePercent": 0.646192,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Ventura Music Hall",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04ddc0166e5fc4872ce4ed62102b311a",
		  
		  "name": "Bryant",
		  "createdDate": "2021-07-14 13:51:20",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 669,
		  "totalCountries": 7,
		  "totalStates": 59,
		  "totalEvents": 358,
		  "eventPercent": 0.945376,
		  "totalScheduleItems": 6037,
		  "schedulePercent": 0.976201,
		  "totalGuests": 779,
		  "guestPercent": 0.802244,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04e1f4b719e6973a65cad76c1618027c",
		  
		  "name": "Tim",
		  "createdDate": "2017-01-27 00:33:33",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 427,
		  "totalCountries": 5,
		  "totalStates": 48,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 2488,
		  "schedulePercent": 0.785471,
		  "totalGuests": 1412,
		  "guestPercent": 0.901292,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04e3b8e6d34f4ab397bba781d127ddd0",
		  
		  "name": "Chris",
		  "createdDate": "2020-10-03 04:31:24",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 543,
		  "totalCountries": 16,
		  "totalStates": 30,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1743,
		  "schedulePercent": 0.666591,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Young Showground Camping",
		  "mostGuestCity": "Young",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04fd60afab3579371db8097cfa032f62",
		  
		  "name": "No&#233;mie",
		  "createdDate": "2024-12-30 15:52:41",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 160,
		  "totalCountries": 19,
		  "totalStates": 8,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 565,
		  "schedulePercent": 0.338735,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "04fe908a150cae3f893738a6d3b97e1e",
		  
		  "name": "Emily",
		  "createdDate": "2024-03-22 00:24:13",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 1079,
		  "totalCountries": 7,
		  "totalStates": 52,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2536,
		  "schedulePercent": 0.790231,
		  "totalGuests": 808,
		  "guestPercent": 0.809723,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05021d9b8bfa511a4b5a06e594ac3110",
		  
		  "name": "Pekka",
		  "createdDate": "2022-08-01 13:16:14",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 194,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 747,
		  "schedulePercent": 0.403785,
		  "totalGuests": 141,
		  "guestPercent": 0.55315,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Mummotunneli",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "050298c5e4dce624d55510c1872cb201",
		  
		  "name": "Cameron",
		  "createdDate": "2025-02-03 13:42:46",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 122,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 890,
		  "schedulePercent": 0.453989,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Aviva Studios, home of Factory International",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "050bde189844375f5bfef03ab3db1d0e",
		  
		  "name": "Keith",
		  "createdDate": "2023-03-17 00:30:39",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 138,
		  "totalCountries": 10,
		  "totalStates": 26,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 723,
		  "schedulePercent": 0.395512,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "051413155dceab7b7090661952e50d00",
		  
		  "name": "Joe",
		  "createdDate": "2009-10-07 13:43:43",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 289,
		  "totalCountries": 9,
		  "totalStates": 31,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 696,
		  "schedulePercent": 0.385313,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-09-09 00:00:00",
		  "mostGuestName": "Fine Line Music Cafe",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05184d81b787e21d18b5875ac49b6178",
		  
		  "name": "Andy",
		  "createdDate": "2023-02-17 22:51:28",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 199,
		  "totalCountries": 12,
		  "totalStates": 52,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2225,
		  "schedulePercent": 0.752267,
		  "totalGuests": 1385,
		  "guestPercent": 0.898572,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0518cdca0b3e6aae3045b95f34f55899",
		  
		  "name": "Alex",
		  "createdDate": "2024-05-16 11:40:09",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 463,
		  "totalCountries": 2,
		  "totalStates": 44,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1151,
		  "schedulePercent": 0.535245,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0532d81d663783ca5327896a5d23c0f8",
		  
		  "name": "Mike ",
		  "createdDate": "2011-09-15 18:01:02",
		  "totalOrganizations": 32,
		  "totalTours": 11,
		  "totalDays": 862,
		  "totalCountries": 25,
		  "totalStates": 55,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2442,
		  "schedulePercent": 0.780032,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0535ac8551efd54eda8017ca60da3285",
		  
		  "name": "Amos",
		  "createdDate": "2011-03-21 17:48:23",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 6,
		  "totalStates": 17,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 502,
		  "schedulePercent": 0.312783,
		  "totalGuests": 304,
		  "guestPercent": 0.651972,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0543ba416512dbd7508eb3056030d9c4",
		  
		  "name": "Jake",
		  "createdDate": "2023-05-23 13:45:13",
		  "totalOrganizations": 25,
		  "totalTours": 38,
		  "totalDays": 1651,
		  "totalCountries": 38,
		  "totalStates": 86,
		  "totalEvents": 308,
		  "eventPercent": 0.917271,
		  "totalScheduleItems": 4034,
		  "schedulePercent": 0.915345,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Fabric",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0547021bc0ed3b8861485baf8ea7d8d7",
		  
		  "name": "Isabel",
		  "createdDate": "2016-09-08 20:35:42",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 198,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 695,
		  "schedulePercent": 0.384406,
		  "totalGuests": 77,
		  "guestPercent": 0.49456,
		  "mostGuestDate": "2025-11-14 00:00:00",
		  "mostGuestName": "HISTORY",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "054ff1630b767cb3b739ab7ce58752e2",
		  
		  "name": "Piers",
		  "createdDate": "2017-09-29 03:37:32",
		  "totalOrganizations": 22,
		  "totalTours": 2,
		  "totalDays": 250,
		  "totalCountries": 15,
		  "totalStates": 22,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 748,
		  "schedulePercent": 0.404125,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05530c1e16dbc5ccea3c099779550e79",
		  
		  "name": "Benjamin",
		  "createdDate": "2022-03-23 16:27:52",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 536,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1353,
		  "schedulePercent": 0.585902,
		  "totalGuests": 235,
		  "guestPercent": 0.616047,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Lincoln Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "056c72d005c68cee3b666b42a7229010",
		  
		  "name": "Josh",
		  "createdDate": "2021-06-17 15:34:52",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 40,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 129,
		  "schedulePercent": 0.11718,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Zepp DiverCity",
		  "mostGuestCity": "",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "057685b560d0f1654ad6563c9d24458e",
		  
		  "name": "Anthony",
		  "createdDate": "2013-02-16 03:11:45",
		  "totalOrganizations": 40,
		  "totalTours": 43,
		  "totalDays": 1405,
		  "totalCountries": 32,
		  "totalStates": 93,
		  "totalEvents": 542,
		  "eventPercent": 0.983454,
		  "totalScheduleItems": 7800,
		  "schedulePercent": 0.989687,
		  "totalGuests": 3066,
		  "guestPercent": 0.983341,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "057eed9dd95c136616ad9b1e89e2c661",
		  
		  "name": "Office",
		  "createdDate": "2018-10-31 19:28:17",
		  "totalOrganizations": 21,
		  "totalTours": 11,
		  "totalDays": 542,
		  "totalCountries": 12,
		  "totalStates": 45,
		  "totalEvents": 279,
		  "eventPercent": 0.897439,
		  "totalScheduleItems": 1945,
		  "schedulePercent": 0.702743,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Hyatt Regency Newport Beach",
		  "mostGuestCity": "Newport Beach",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "059019acf6eb0d8fd6795d45f2772192",
		  
		  "name": "Dennis",
		  "createdDate": "2022-05-12 18:05:38",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 326,
		  "totalCountries": 21,
		  "totalStates": 45,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1450,
		  "schedulePercent": 0.607321,
		  "totalGuests": 80,
		  "guestPercent": 0.49728,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "House of Yes",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "059579e52d71dbc76eced60d615dd1a3",
		  
		  "name": "Zina",
		  "createdDate": "2023-10-10 17:35:35",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 496,
		  "totalCountries": 12,
		  "totalStates": 39,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 999,
		  "schedulePercent": 0.490027,
		  "totalGuests": 193,
		  "guestPercent": 0.588169,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "House of Yes",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05aa68a010897c20721243aa43411dc5",
		  
		  "name": "Kasper",
		  "createdDate": "2018-05-22 07:38:13",
		  "totalOrganizations": 40,
		  "totalTours": 15,
		  "totalDays": 394,
		  "totalCountries": 9,
		  "totalStates": 19,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 1900,
		  "schedulePercent": 0.695036,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "USF Verftet",
		  "mostGuestCity": "Bergen",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05ad0bbb4ccc12e1251964462d1555d4",
		  
		  "name": "Kris ",
		  "createdDate": "2013-05-01 10:17:03",
		  "totalOrganizations": 19,
		  "totalTours": 10,
		  "totalDays": 1286,
		  "totalCountries": 29,
		  "totalStates": 71,
		  "totalEvents": 245,
		  "eventPercent": 0.866047,
		  "totalScheduleItems": 2642,
		  "schedulePercent": 0.802131,
		  "totalGuests": 611,
		  "guestPercent": 0.761899,
		  "mostGuestDate": "2025-08-26 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05b27d77bf0f4a9870fb435d685ba588",
		  
		  "name": "Joy",
		  "createdDate": "2016-07-07 16:40:31",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 214,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1117,
		  "schedulePercent": 0.523119,
		  "totalGuests": 2696,
		  "guestPercent": 0.975635,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05b4e17e0e13349f67aec1a0ba523f48",
		  
		  "name": "Martin",
		  "createdDate": "2013-05-25 22:10:20",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 233,
		  "totalCountries": 21,
		  "totalStates": 26,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1706,
		  "schedulePercent": 0.659451,
		  "totalGuests": 1068,
		  "guestPercent": 0.857661,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 220,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05b736bb0936d1a916c4ecad3026668c",
		  
		  "name": "Jay",
		  "createdDate": "2024-09-10 15:45:25",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 346,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1115,
		  "schedulePercent": 0.522439,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Globe Hall",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05c013fcb2ca1a7ceb220a1646766c02",
		  
		  "name": "Richard",
		  "createdDate": "2022-08-03 15:48:11",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 205,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 1842,
		  "schedulePercent": 0.68393,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Fort Mose Historic State Park",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05ed6b7bbfafe0e6be7d1ab3eb803c3e",
		  
		  "name": "Kia",
		  "createdDate": "2020-01-24 06:04:31",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 214,
		  "totalCountries": 7,
		  "totalStates": 25,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 322,
		  "schedulePercent": 0.227901,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05f74539e0d7e447d499b68d7355a9c5",
		  
		  "name": "Carolina",
		  "createdDate": "2022-07-05 19:59:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 10,
		  "totalStates": 7,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 106,
		  "schedulePercent": 0.102108,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "05fa68cb580ba03c8c4db02e14bd9306",
		  
		  "name": "Sawyer",
		  "createdDate": "2025-02-28 20:22:43",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 201,
		  "totalCountries": 11,
		  "totalStates": 37,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 731,
		  "schedulePercent": 0.398572,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0606fee896397e7b7bee11135d6a9701",
		  
		  "name": "Bob",
		  "createdDate": "2011-10-04 01:17:27",
		  "totalOrganizations": 21,
		  "totalTours": 5,
		  "totalDays": 326,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 694,
		  "schedulePercent": 0.38418,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0608c4330ffa46d19cac6faa7cb85197",
		  
		  "name": "Walker",
		  "createdDate": "2014-08-20 13:05:39",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 633,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2926,
		  "schedulePercent": 0.833749,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "060d34477d526e6a4a6301789242409d",
		  
		  "name": "Jenn",
		  "createdDate": "2020-11-26 01:31:41",
		  "totalOrganizations": 28,
		  "totalTours": 31,
		  "totalDays": 614,
		  "totalCountries": 12,
		  "totalStates": 43,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2230,
		  "schedulePercent": 0.75272,
		  "totalGuests": 1366,
		  "guestPercent": 0.895852,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "063919448cc2684190c788a7d1baa4ba",
		  
		  "name": "Caleb",
		  "createdDate": "2021-09-24 12:22:10",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 556,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 571,
		  "schedulePercent": 0.340322,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "063a6e280a3536a3ec0774b6dace29e1",
		  
		  "name": "Bobby",
		  "createdDate": "2021-11-09 00:21:27",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 115,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 145,
		  "schedulePercent": 0.12772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "064a09b02b5d74c7605496f0f7867b18",
		  
		  "name": "Brad",
		  "createdDate": "2024-08-12 07:41:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 320,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 340,
		  "schedulePercent": 0.238441,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "The Park Theater",
		  "mostGuestCity": "McMinnville",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0650c6198192e801a5e50fe73d1d8c47",
		  
		  "name": "Nate",
		  "createdDate": "2025-03-10 18:39:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 44,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 279,
		  "schedulePercent": 0.205009,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Stadium Theatre",
		  "mostGuestCity": "Woonsocket",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06659958bca18778e2da617e510319f8",
		  
		  "name": "Luca",
		  "createdDate": "2018-09-04 10:01:39",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 20,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 32,
		  "schedulePercent": 0.042951,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Radialsystem",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0667bf8f70aac41fd64b80c098eb7e47",
		  
		  "name": "Anthony",
		  "createdDate": "2023-05-16 21:20:16",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 319,
		  "totalCountries": 16,
		  "totalStates": 65,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 1936,
		  "schedulePercent": 0.701043,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "The National",
		  "mostGuestCity": "Richmond",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06753de353951f5439e027c4cca358c3",
		  
		  "name": "Kate",
		  "createdDate": "2017-02-15 18:36:48",
		  "totalOrganizations": 13,
		  "totalTours": 15,
		  "totalDays": 444,
		  "totalCountries": 26,
		  "totalStates": 55,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 4113,
		  "schedulePercent": 0.919764,
		  "totalGuests": 2320,
		  "guestPercent": 0.963169,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The SSE Hydro",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0676a2c5007fed395f6b194272e5fcba",
		  
		  "name": "Mark",
		  "createdDate": "2016-12-27 21:46:16",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 881,
		  "totalCountries": 13,
		  "totalStates": 61,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2289,
		  "schedulePercent": 0.760313,
		  "totalGuests": 190,
		  "guestPercent": 0.585902,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "067a2e4b294afc6367b62a2f9a0c9ef1",
		  
		  "name": "Bryony",
		  "createdDate": "2012-04-17 08:04:24",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 877,
		  "totalCountries": 19,
		  "totalStates": 26,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1066,
		  "schedulePercent": 0.508726,
		  "totalGuests": 46,
		  "guestPercent": 0.446623,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Hudson River Recreation - Croton Point Park",
		  "mostGuestCity": "Croton-On-Hudson",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "067e7d51bfd815fcbe4f354d277428fc",
		  
		  "name": "Kerry",
		  "createdDate": "2012-03-08 16:35:00",
		  "totalOrganizations": 53,
		  "totalTours": 28,
		  "totalDays": 768,
		  "totalCountries": 8,
		  "totalStates": 42,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 2674,
		  "schedulePercent": 0.80621,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Sidney Myer Music Bowl",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06828a415981a5f00069f6f845bca344",
		  
		  "name": "Chip",
		  "createdDate": "2017-01-24 16:22:16",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 965,
		  "totalCountries": 6,
		  "totalStates": 52,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 3187,
		  "schedulePercent": 0.858568,
		  "totalGuests": 1237,
		  "guestPercent": 0.878966,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "069cd149c4be3fb22879f13fa464bde7",
		  
		  "name": "Garry",
		  "createdDate": "2023-10-10 16:47:44",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 78,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 527,
		  "schedulePercent": 0.325136,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "069e21f559517bf1f5f6d7ba5d47326e",
		  
		  "name": "Kathleen",
		  "createdDate": "2017-02-20 15:29:21",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 264,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 1805,
		  "schedulePercent": 0.676791,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06a5f71b128d0411168a170e9801afe7",
		  
		  "name": "Anthony",
		  "createdDate": "2019-06-06 20:09:37",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 1353,
		  "totalCountries": 17,
		  "totalStates": 46,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1138,
		  "schedulePercent": 0.531165,
		  "totalGuests": 444,
		  "guestPercent": 0.710449,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Barclays Center",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06a7f3e242c9c3bd5abfda13365c6942",
		  
		  "name": "Cello",
		  "createdDate": "2017-10-09 23:53:43",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 190,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 354,
		  "schedulePercent": 0.244787,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Grand ThÃ©Ã¢tre de QuÃ©bec",
		  "mostGuestCity": "QuÃ©bec",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06aa358350d87d60a4b26778f5ca8ffb",
		  
		  "name": "Amanda",
		  "createdDate": "2014-12-11 02:07:56",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 251,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1288,
		  "schedulePercent": 0.568903,
		  "totalGuests": 1031,
		  "guestPercent": 0.851088,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stone Pony Summer Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06b05626c6acab928cf05e320dfc0384",
		  
		  "name": "BRIT",
		  "createdDate": "2018-10-30 19:25:14",
		  "totalOrganizations": 7,
		  "totalTours": 31,
		  "totalDays": 540,
		  "totalCountries": 18,
		  "totalStates": 52,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 1789,
		  "schedulePercent": 0.674637,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06b10319b99d1d1c271eb6eaac7dc398",
		  
		  "name": "John",
		  "createdDate": "2013-10-01 18:27:42",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 418,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1398,
		  "schedulePercent": 0.597461,
		  "totalGuests": 292,
		  "guestPercent": 0.645739,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06c179d93dde6eb18ee82b506ed003ce",
		  
		  "name": "Bera",
		  "createdDate": "2022-05-25 09:52:05",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 61,
		  "totalCountries": 6,
		  "totalStates": 4,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 156,
		  "schedulePercent": 0.132706,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Crystal Palace Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06d3aaffc6ad5ca0befa6da92d4c8bbc",
		  
		  "name": "Sam",
		  "createdDate": "2014-11-30 21:54:54",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 215,
		  "totalCountries": 18,
		  "totalStates": 27,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1347,
		  "schedulePercent": 0.584655,
		  "totalGuests": 1135,
		  "guestPercent": 0.869787,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06d3bcbda8533ff5e8eea88ee04ef0b5",
		  
		  "name": "Brianne",
		  "createdDate": "2017-11-07 23:15:21",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 167,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 854,
		  "schedulePercent": 0.44141,
		  "totalGuests": 169,
		  "guestPercent": 0.573096,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "T-Mobile Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06d537b2928a4061b0f20a798535e396",
		  
		  "name": "Darcy",
		  "createdDate": "2015-08-18 20:16:06",
		  "totalOrganizations": 28,
		  "totalTours": 10,
		  "totalDays": 507,
		  "totalCountries": 27,
		  "totalStates": 54,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 3505,
		  "schedulePercent": 0.882366,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06df5e0b52a66d03d2d42faaa77f8332",
		  
		  "name": "Pamela",
		  "createdDate": "2021-04-24 22:00:19",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1003,
		  "schedulePercent": 0.490934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06e48d2634123cdec1e4bb9909d3c5fd",
		  
		  "name": "Theo",
		  "createdDate": "2022-02-01 22:13:34",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 116,
		  "totalCountries": 6,
		  "totalStates": 35,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 559,
		  "schedulePercent": 0.336809,
		  "totalGuests": 473,
		  "guestPercent": 0.721668,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06f2edbb042351973624341db554e709",
		  
		  "name": "James",
		  "createdDate": "2022-11-18 23:19:12",
		  "totalOrganizations": 18,
		  "totalTours": 14,
		  "totalDays": 253,
		  "totalCountries": 18,
		  "totalStates": 27,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1528,
		  "schedulePercent": 0.622733,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "06ff5e8f1f899ed48656f07fa85a8e84",
		  
		  "name": "Tim",
		  "createdDate": "2023-10-12 19:47:00",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 200,
		  "totalCountries": 4,
		  "totalStates": 27,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 402,
		  "schedulePercent": 0.270739,
		  "totalGuests": 113,
		  "guestPercent": 0.530598,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Crescent Ballroom",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07011d1bb8b23340f46d441db1c94caf",
		  
		  "name": "Chris",
		  "createdDate": "2015-09-21 14:17:11",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 175,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "The Brighton Centre",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0708e70c76e34eb966c28b8681684ce5",
		  
		  "name": "BA",
		  "createdDate": "2017-12-27 11:36:49",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 116,
		  "totalCountries": 10,
		  "totalStates": 17,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 860,
		  "schedulePercent": 0.44481,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "071e08ec5f66ba9e29dfed8382d6cf2f",
		  
		  "name": "Megan",
		  "createdDate": "2020-02-04 19:57:42",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 218,
		  "totalCountries": 20,
		  "totalStates": 48,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1091,
		  "schedulePercent": 0.518246,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0730ab460931370469ab7e335868c63b",
		  
		  "name": "TM",
		  "createdDate": "2021-05-12 19:49:04",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 231,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 645,
		  "schedulePercent": 0.365594,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "House of Blues San Diego",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "073234c2d6bfab2deb417dfa067ab0d1",
		  
		  "name": "Jim",
		  "createdDate": "2024-06-07 13:46:41",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 41,
		  "totalCountries": 4,
		  "totalStates": 11,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "First Unitarian Church of Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0732f8063236b24b0a1a764d1ed37230",
		  
		  "name": "Ben",
		  "createdDate": "2017-04-15 19:47:57",
		  "totalOrganizations": 17,
		  "totalTours": 31,
		  "totalDays": 603,
		  "totalCountries": 33,
		  "totalStates": 75,
		  "totalEvents": 295,
		  "eventPercent": 0.909678,
		  "totalScheduleItems": 3453,
		  "schedulePercent": 0.879306,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07534f2dad3abc94348fdfa1f1e0c313",
		  
		  "name": "Jim",
		  "createdDate": "2022-07-12 00:45:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 48,
		  "schedulePercent": 0.0583636,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0757a3165a535c56ed634702769d9f49",
		  
		  "name": "Ole",
		  "createdDate": "2011-08-02 21:40:00",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 242,
		  "totalCountries": 20,
		  "totalStates": 16,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 868,
		  "schedulePercent": 0.448096,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "075af1d78ecf31913236e0a2e1729bbb",
		  
		  "name": "Erica",
		  "createdDate": "2014-09-02 13:54:27",
		  "totalOrganizations": 33,
		  "totalTours": 19,
		  "totalDays": 816,
		  "totalCountries": 22,
		  "totalStates": 57,
		  "totalEvents": 243,
		  "eventPercent": 0.864347,
		  "totalScheduleItems": 4300,
		  "schedulePercent": 0.930757,
		  "totalGuests": 80,
		  "guestPercent": 0.49728,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "100 Club",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "075d9713a8d812f1d317675dfe3615a3",
		  
		  "name": "Alex",
		  "createdDate": "2017-10-18 16:50:31",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 765,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1187,
		  "schedulePercent": 0.543744,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Marquee Theatre",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0762ba410bef464e9a0675a9d4d77f0d",
		  
		  "name": "Suzanne",
		  "createdDate": "2023-04-11 13:57:00",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 294,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 771,
		  "schedulePercent": 0.412625,
		  "totalGuests": 453,
		  "guestPercent": 0.713962,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Heaton Park",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0766a909d3d4ac143676786871a91d5f",
		  
		  "name": "Jane",
		  "createdDate": "2017-02-09 20:51:18",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 10,
		  "totalStates": 21,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 854,
		  "schedulePercent": 0.44141,
		  "totalGuests": 447,
		  "guestPercent": 0.711695,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Orpheum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0767580c3321ada831d5449facf15700",
		  
		  "name": "Walter",
		  "createdDate": "2014-05-20 02:29:31",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 126,
		  "totalCountries": 13,
		  "totalStates": 35,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 1025,
		  "schedulePercent": 0.497733,
		  "totalGuests": 706,
		  "guestPercent": 0.787058,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "170 Russell",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "076a80b71f2fc44b69caf17b52989206",
		  
		  "name": "Katie",
		  "createdDate": "2022-05-26 14:21:42",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 556,
		  "totalCountries": 16,
		  "totalStates": 41,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1534,
		  "schedulePercent": 0.624207,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0774ccc7e75d92030d9236f2a4b7d8a8",
		  
		  "name": "Brian",
		  "createdDate": "2024-02-14 14:09:28",
		  "totalOrganizations": 4,
		  "totalTours": 24,
		  "totalDays": 284,
		  "totalCountries": 27,
		  "totalStates": 77,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1357,
		  "schedulePercent": 0.586809,
		  "totalGuests": 196,
		  "guestPercent": 0.591568,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "Sanders Theatre",
		  "mostGuestCity": "Cambridge",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "077734dba95e5d0d4ed6062d0d90a5c4",
		  
		  "name": "Live",
		  "createdDate": "2019-07-08 13:50:58",
		  "totalOrganizations": 83,
		  "totalTours": 113,
		  "totalDays": 2502,
		  "totalCountries": 12,
		  "totalStates": 186,
		  "totalEvents": 2183,
		  "eventPercent": 0.99966,
		  "totalScheduleItems": 10146,
		  "schedulePercent": 0.997054,
		  "totalGuests": 1471,
		  "guestPercent": 0.906732,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0779e9f9a53d2fb592d4119c8f217477",
		  
		  "name": "Aaron",
		  "createdDate": "2024-07-15 23:21:40",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 688,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 502,
		  "eventPercent": 0.979034,
		  "totalScheduleItems": 4020,
		  "schedulePercent": 0.914551,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "077c8180efa941c0bf8093119069556e",
		  
		  "name": "Molly",
		  "createdDate": "2025-07-22 20:25:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 162,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 243,
		  "schedulePercent": 0.186083,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Evans Towne Center Park",
		  "mostGuestCity": "Evans",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0782a4cc14f7f5a564c6476555f45382",
		  
		  "name": "Tripp",
		  "createdDate": "2014-03-19 23:25:05",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 873,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1918,
		  "schedulePercent": 0.697416,
		  "totalGuests": 375,
		  "guestPercent": 0.683477,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Rupp Arena",
		  "mostGuestCity": "Lexington",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07902f89332c14f9d3b472bd499d7c17",
		  
		  "name": "Simon",
		  "createdDate": "2019-01-14 08:20:16",
		  "totalOrganizations": 21,
		  "totalTours": 19,
		  "totalDays": 705,
		  "totalCountries": 25,
		  "totalStates": 57,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 4356,
		  "schedulePercent": 0.933137,
		  "totalGuests": 760,
		  "guestPercent": 0.798277,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07a52a9d2a987b4767635d70f1a901e0",
		  
		  "name": "Jon",
		  "createdDate": "2017-03-06 16:36:08",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 30,
		  "totalCountries": 10,
		  "totalStates": 11,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 112,
		  "schedulePercent": 0.106641,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Oslo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07aa0ffafd42cad2137a49be739b69dd",
		  
		  "name": "Chazz",
		  "createdDate": "2018-04-06 11:30:15",
		  "totalOrganizations": 15,
		  "totalTours": 13,
		  "totalDays": 286,
		  "totalCountries": 25,
		  "totalStates": 39,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1333,
		  "schedulePercent": 0.581142,
		  "totalGuests": 148,
		  "guestPercent": 0.556664,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Archer Music Hall",
		  "mostGuestCity": "Allentown",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07b1bae8120bf7d50547f9c8897f96ed",
		  
		  "name": "Steven",
		  "createdDate": "2010-11-09 21:02:00",
		  "totalOrganizations": 20,
		  "totalTours": 16,
		  "totalDays": 1289,
		  "totalCountries": 13,
		  "totalStates": 57,
		  "totalEvents": 358,
		  "eventPercent": 0.945376,
		  "totalScheduleItems": 6475,
		  "schedulePercent": 0.981754,
		  "totalGuests": 1984,
		  "guestPercent": 0.946396,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07b437f7d1bdfabc9e8c9d76481a5da8",
		  
		  "name": "Matty",
		  "createdDate": "2016-05-25 18:59:51",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 831,
		  "totalCountries": 8,
		  "totalStates": 20,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 510,
		  "schedulePercent": 0.315503,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Wonderfront Festival",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07cc153b2eaeafaf0de35bda58065cac",
		  
		  "name": "Mark",
		  "createdDate": "2024-09-24 16:36:25",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 121,
		  "totalCountries": 17,
		  "totalStates": 45,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1026,
		  "schedulePercent": 0.498073,
		  "totalGuests": 801,
		  "guestPercent": 0.807684,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07cc31a4493b7c8469e0c7c63f7a1370",
		  
		  "name": "Drew",
		  "createdDate": "2021-09-14 14:38:21",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1021,
		  "totalCountries": 7,
		  "totalStates": 52,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 3243,
		  "schedulePercent": 0.863101,
		  "totalGuests": 477,
		  "guestPercent": 0.722915,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07cfdbbf1282cc5bcc40f7bae741bab9",
		  
		  "name": "Etienne",
		  "createdDate": "2023-04-10 17:05:05",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 186,
		  "totalCountries": 13,
		  "totalStates": 29,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 666,
		  "schedulePercent": 0.373413,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07d62c111f7771f2a065624d68bb4457",
		  
		  "name": "Jonny",
		  "createdDate": "2023-06-16 10:30:29",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 127,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 631,
		  "schedulePercent": 0.361287,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Linda Ronstadt Music Hall",
		  "mostGuestCity": "Tucson",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07dfc991631dba043611d91049d218d1",
		  
		  "name": "Russell",
		  "createdDate": "2023-04-24 16:45:00",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 2351,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 2906,
		  "schedulePercent": 0.832389,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07e513b75ae226bac4653d43e227f8d1",
		  
		  "name": "Debi",
		  "createdDate": "2017-05-31 01:57:56",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 1042,
		  "totalCountries": 7,
		  "totalStates": 42,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1418,
		  "schedulePercent": 0.602108,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "City National Grove of Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07eb518151010b2b1e9e8ff3139a6831",
		  
		  "name": "Dan",
		  "createdDate": "2015-05-29 13:39:30",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 189,
		  "totalCountries": 18,
		  "totalStates": 38,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 638,
		  "schedulePercent": 0.363781,
		  "totalGuests": 357,
		  "guestPercent": 0.677244,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Shepherd's Bush Empire",
		  "mostGuestCity": "Shepherd's Bush",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07f3ff509e3f9741c1d0f7e4544ac829",
		  
		  "name": "Cole",
		  "createdDate": "2023-07-01 16:52:08",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 256,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 716,
		  "schedulePercent": 0.392339,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07f5850fa50cc710ca301b3ba1c127fe",
		  
		  "name": "Lukas ",
		  "createdDate": "2024-01-07 15:00:07",
		  "totalOrganizations": 13,
		  "totalTours": 18,
		  "totalDays": 2107,
		  "totalCountries": 13,
		  "totalStates": 56,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2658,
		  "schedulePercent": 0.803377,
		  "totalGuests": 2265,
		  "guestPercent": 0.960789,
		  "mostGuestDate": "2025-02-10 00:00:00",
		  "mostGuestName": "Jahrhunderthalle",
		  "mostGuestCity": "Frankfurt",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "07fd8bce5b04db3832d186ef115bc080",
		  
		  "name": "Conor",
		  "createdDate": "2024-02-21 11:21:15",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 627,
		  "totalCountries": 7,
		  "totalStates": 12,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1229,
		  "schedulePercent": 0.554284,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0804f479b40e451a0674ae6bb9469593",
		  
		  "name": "James",
		  "createdDate": "2025-08-13 18:16:23",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 99,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 683,
		  "schedulePercent": 0.380326,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Eccles Theater",
		  "mostGuestCity": "Salt Lake City",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0809dc826cdbbe97fd76ad5486d71406",
		  
		  "name": "Victor",
		  "createdDate": "2024-10-01 07:34:34",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 167,
		  "totalCountries": 7,
		  "totalStates": 21,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 1310,
		  "schedulePercent": 0.574116,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Rockhal",
		  "mostGuestCity": "Esch-sur-Alzette",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08183246718f27f28fde6206a2eb0e3f",
		  
		  "name": "Stefan",
		  "createdDate": "2024-10-23 12:49:12",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 142,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1063,
		  "schedulePercent": 0.507253,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Admiralspalast",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08235457cfd9b028d0c002d49adaac41",
		  
		  "name": "Andreas",
		  "createdDate": "2023-09-08 14:41:56",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 90,
		  "totalCountries": 1,
		  "totalStates": 4,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 682,
		  "schedulePercent": 0.379873,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Romssa Arena",
		  "mostGuestCity": "TromsÃ¸",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08378ae0de64899874b8e2f33131f292",
		  
		  "name": "Rachel",
		  "createdDate": "2014-07-31 14:59:53",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 446,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 3131,
		  "schedulePercent": 0.853808,
		  "totalGuests": 880,
		  "guestPercent": 0.825363,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Abba's House",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "083b62b2ecab84c2db81a3deceba7bfd",
		  
		  "name": "Sam",
		  "createdDate": "2016-05-13 18:02:55",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 410,
		  "totalCountries": 5,
		  "totalStates": 4,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 965,
		  "schedulePercent": 0.479714,
		  "totalGuests": 344,
		  "guestPercent": 0.672144,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "083e28ce0bc139579cc9dd6fd94da6da",
		  
		  "name": "Dahlia",
		  "createdDate": "2022-09-19 19:14:08",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 126,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 510,
		  "schedulePercent": 0.315503,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Las Vegas, NV",
		  "mostGuestCity": "",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08636112f342ccbb00471d97de172339",
		  
		  "name": "Kristi",
		  "createdDate": "2012-01-25 21:50:16",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 1167,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1687,
		  "schedulePercent": 0.656392,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "The Paramount",
		  "mostGuestCity": "Huntington",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "086d9b2648469b933e3366bd83e94c44",
		  
		  "name": "Eric ",
		  "createdDate": "2023-05-31 22:01:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 9,
		  "totalStates": 21,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0873d0a15641de83d1625f29bcaa89fd",
		  
		  "name": "Kai",
		  "createdDate": "2017-09-25 21:27:56",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 1006,
		  "totalCountries": 12,
		  "totalStates": 45,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 2273,
		  "schedulePercent": 0.7585,
		  "totalGuests": 988,
		  "guestPercent": 0.843948,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Orpheum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0874cb074548677376abffca57302c65",
		  
		  "name": "Stian",
		  "createdDate": "2018-07-20 14:29:56",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 213,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 640,
		  "schedulePercent": 0.364461,
		  "totalGuests": 140,
		  "guestPercent": 0.552357,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "OverOslo",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08790b0ce0e24a881d709f4788f088e1",
		  
		  "name": "Tavi",
		  "createdDate": "2018-06-06 00:08:17",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 47,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 241,
		  "schedulePercent": 0.184723,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "087bd0df48497ad5a492e989987037be",
		  
		  "name": "Kelvin",
		  "createdDate": "2023-01-10 17:56:13",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 1016,
		  "totalCountries": 29,
		  "totalStates": 77,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 2370,
		  "schedulePercent": 0.771532,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08836559f09a4fd6bbde5d7f2d8ca08a",
		  
		  "name": "Anni-Sofia",
		  "createdDate": "2023-02-10 09:14:54",
		  "totalOrganizations": 16,
		  "totalTours": 27,
		  "totalDays": 546,
		  "totalCountries": 8,
		  "totalStates": 8,
		  "totalEvents": 528,
		  "eventPercent": 0.981528,
		  "totalScheduleItems": 2629,
		  "schedulePercent": 0.800997,
		  "totalGuests": 255,
		  "guestPercent": 0.627493,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Espoon Viinijuhlat",
		  "mostGuestCity": "Espoo",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "088988ab0d093ae51be129eac2d71504",
		  
		  "name": "Morgan",
		  "createdDate": "2022-01-07 14:18:55",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 160,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 1585,
		  "schedulePercent": 0.637466,
		  "totalGuests": 481,
		  "guestPercent": 0.724615,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "The Theater @ MGM National Harbor",
		  "mostGuestCity": "Oxon Hill",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "088acade6c32ed38a7ab98aee9deaaec",
		  
		  "name": "Aaron",
		  "createdDate": "2022-02-23 17:43:23",
		  "totalOrganizations": 9,
		  "totalTours": 17,
		  "totalDays": 507,
		  "totalCountries": 12,
		  "totalStates": 48,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 3650,
		  "schedulePercent": 0.892452,
		  "totalGuests": 708,
		  "guestPercent": 0.787398,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08919ff45d18668ef3f72e7599953c6e",
		  
		  "name": "AGUDELO",
		  "createdDate": "2022-06-16 15:28:23",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 442,
		  "totalCountries": 6,
		  "totalStates": 18,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 84,
		  "schedulePercent": 0.0851088,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0896d887a7e4d8696167b9735274d91d",
		  
		  "name": "Gino",
		  "createdDate": "2011-08-14 23:07:23",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 668,
		  "totalCountries": 8,
		  "totalStates": 41,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1734,
		  "schedulePercent": 0.664551,
		  "totalGuests": 1338,
		  "guestPercent": 0.891886,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08a14c0cc2f3ca8e928889b132902362",
		  
		  "name": "Robert",
		  "createdDate": "2018-03-08 18:08:29",
		  "totalOrganizations": 19,
		  "totalTours": 25,
		  "totalDays": 2179,
		  "totalCountries": 13,
		  "totalStates": 76,
		  "totalEvents": 394,
		  "eventPercent": 0.957389,
		  "totalScheduleItems": 4993,
		  "schedulePercent": 0.954329,
		  "totalGuests": 1799,
		  "guestPercent": 0.933364,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08aa19d7efce8bbba78c30925cd18891",
		  
		  "name": "Renee",
		  "createdDate": "2025-01-29 01:03:07",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 232,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08af76b1fe7045f6cb26d66b9bdef2f1",
		  
		  "name": "Kai",
		  "createdDate": "2011-06-15 09:32:11",
		  "totalOrganizations": 17,
		  "totalTours": 20,
		  "totalDays": 1187,
		  "totalCountries": 15,
		  "totalStates": 63,
		  "totalEvents": 453,
		  "eventPercent": 0.971895,
		  "totalScheduleItems": 3607,
		  "schedulePercent": 0.889959,
		  "totalGuests": 839,
		  "guestPercent": 0.817656,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Daily's Place Amphitheater",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08b0f91851c0286657dcb3eaa0ae8fd3",
		  
		  "name": "Belle",
		  "createdDate": "2023-05-24 09:11:04",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 250,
		  "totalCountries": 15,
		  "totalStates": 23,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 458,
		  "schedulePercent": 0.293858,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Gessnerallee",
		  "mostGuestCity": "Zurich",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08b39b42519486409a1accaff25ce3a4",
		  
		  "name": "Christian",
		  "createdDate": "2025-03-02 16:34:18",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 300,
		  "totalCountries": 16,
		  "totalStates": 43,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1208,
		  "schedulePercent": 0.548844,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08b5428ed973d77f5bbf838edeb9e921",
		  
		  "name": "Thomas",
		  "createdDate": "2017-06-08 10:54:54",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 285,
		  "totalCountries": 9,
		  "totalStates": 18,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2670,
		  "schedulePercent": 0.80519,
		  "totalGuests": 418,
		  "guestPercent": 0.701043,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre de la croisette",
		  "mostGuestCity": "Cannes",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08bd26e2bee97139149f7a9ed341900c",
		  
		  "name": "Tom",
		  "createdDate": "2013-03-14 19:42:38",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 745,
		  "totalCountries": 21,
		  "totalStates": 56,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2677,
		  "schedulePercent": 0.80655,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08bd7f511e6c9e13c0704123d40078ff",
		  
		  "name": "Bobby",
		  "createdDate": "2014-02-27 22:22:19",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 486,
		  "totalCountries": 12,
		  "totalStates": 44,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 2082,
		  "schedulePercent": 0.729488,
		  "totalGuests": 1016,
		  "guestPercent": 0.849841,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08c367f8363df899770bc60250454bc1",
		  
		  "name": "SOFIA ISELLA",
		  "createdDate": "2024-09-12 00:56:45",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 251,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 672,
		  "schedulePercent": 0.375793,
		  "totalGuests": 138,
		  "guestPercent": 0.550997,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08ccfdf956778cc8a6672aa75ca3365d",
		  
		  "name": "Roy",
		  "createdDate": "2025-01-28 05:56:41",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 59,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 572,
		  "schedulePercent": 0.340435,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-02-24 00:00:00",
		  "mostGuestName": "The Drive Adelaide",
		  "mostGuestCity": "North Adelaide",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08d8b91026106e99bdb8e11acecc8bc6",
		  
		  "name": "Andrew",
		  "createdDate": "2016-09-03 17:37:04",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 372,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 230,
		  "schedulePercent": 0.177697,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08ed840f742dbff8e732096c0fbc93f6",
		  
		  "name": "Joel",
		  "createdDate": "2024-02-07 02:26:09",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 122,
		  "totalCountries": 18,
		  "totalStates": 41,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 701,
		  "schedulePercent": 0.387466,
		  "totalGuests": 572,
		  "guestPercent": 0.75034,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08f302e27afe1eec236a847966becea0",
		  
		  "name": "Justin",
		  "createdDate": "2019-09-30 20:32:59",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 828,
		  "totalCountries": 8,
		  "totalStates": 44,
		  "totalEvents": 318,
		  "eventPercent": 0.924411,
		  "totalScheduleItems": 4213,
		  "schedulePercent": 0.926677,
		  "totalGuests": 1952,
		  "guestPercent": 0.942883,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08f52e89bde5c4a9ab4d6b3d834f31d5",
		  
		  "name": "Paul",
		  "createdDate": "2023-08-23 05:11:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 123,
		  "schedulePercent": 0.113327,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "08fc171745c50984d8aa144c968d95ba",
		  
		  "name": "Joe",
		  "createdDate": "2020-03-06 03:01:55",
		  "totalOrganizations": 5,
		  "totalTours": 11,
		  "totalDays": 223,
		  "totalCountries": 16,
		  "totalStates": 54,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1637,
		  "schedulePercent": 0.647212,
		  "totalGuests": 1530,
		  "guestPercent": 0.913305,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0903bbe7613bd237974019b75a69b699",
		  
		  "name": "Steve",
		  "createdDate": "2014-10-07 14:50:04",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 207,
		  "schedulePercent": 0.164438,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-12-20 00:00:00",
		  "mostGuestName": "Elements",
		  "mostGuestCity": "Kitchener",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0905ec37cb2c026534d28f1fa2d51148",
		  
		  "name": "Thomas",
		  "createdDate": "2018-05-15 09:43:21",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 33,
		  "totalCountries": 10,
		  "totalStates": 5,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 184,
		  "schedulePercent": 0.150272,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "090749141c7b0517882f569143b7aa66",
		  
		  "name": "Evie",
		  "createdDate": "2022-03-21 14:38:26",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 498,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1922,
		  "schedulePercent": 0.698096,
		  "totalGuests": 443,
		  "guestPercent": 0.710109,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0912267095a10cd3159ab82ad9a55749",
		  
		  "name": "Phil ",
		  "createdDate": "2011-09-26 19:18:10",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 132,
		  "totalCountries": 15,
		  "totalStates": 22,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 721,
		  "schedulePercent": 0.394832,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "GARDEN AMP",
		  "mostGuestCity": "Garden Grove",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09150f0fc5362c7da185434d2dce13e3",
		  
		  "name": "Matthew ",
		  "createdDate": "2014-11-17 02:28:59",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 110,
		  "totalCountries": 4,
		  "totalStates": 24,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1022,
		  "schedulePercent": 0.497054,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "091ab5839e134640735c50190e292670",
		  
		  "name": "Melanie",
		  "createdDate": "2012-10-17 09:16:11",
		  "totalOrganizations": 28,
		  "totalTours": 45,
		  "totalDays": 1113,
		  "totalCountries": 39,
		  "totalStates": 90,
		  "totalEvents": 286,
		  "eventPercent": 0.902765,
		  "totalScheduleItems": 3568,
		  "schedulePercent": 0.886673,
		  "totalGuests": 257,
		  "guestPercent": 0.628286,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Aviva Studios, home of Factory International",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "091b70ba59104021b31cd7930cf2485e",
		  
		  "name": "Sam",
		  "createdDate": "2016-06-01 19:32:57",
		  "totalOrganizations": 24,
		  "totalTours": 12,
		  "totalDays": 348,
		  "totalCountries": 23,
		  "totalStates": 43,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1219,
		  "schedulePercent": 0.551677,
		  "totalGuests": 658,
		  "guestPercent": 0.773005,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "091bd6e378885270a8d92358226f1446",
		  
		  "name": "MINISTERIO",
		  "createdDate": "2023-12-05 23:45:41",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 356,
		  "totalCountries": 13,
		  "totalStates": 40,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 743,
		  "schedulePercent": 0.402312,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0921cd2f06e9e0e50f83dd966b2384bc",
		  
		  "name": "Bennett",
		  "createdDate": "2022-05-09 18:26:46",
		  "totalOrganizations": 4,
		  "totalTours": 17,
		  "totalDays": 341,
		  "totalCountries": 20,
		  "totalStates": 42,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1502,
		  "schedulePercent": 0.618767,
		  "totalGuests": 445,
		  "guestPercent": 0.710675,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "  5004 National Western Drive   ",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0946af8c1a4834b97ec80c3829c894ae",
		  
		  "name": "Sarah",
		  "createdDate": "2022-01-24 07:27:09",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 644,
		  "totalCountries": 8,
		  "totalStates": 43,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2322,
		  "schedulePercent": 0.765299,
		  "totalGuests": 767,
		  "guestPercent": 0.800204,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0947224be6725b724dd8dbae99e7d087",
		  
		  "name": "Joona",
		  "createdDate": "2025-05-28 08:10:00",
		  "totalOrganizations": 22,
		  "totalTours": 18,
		  "totalDays": 71,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 145,
		  "schedulePercent": 0.12772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0948f43ec178f0498d6ebca93674c5b4",
		  
		  "name": "Sarah ",
		  "createdDate": "2023-05-31 17:58:07",
		  "totalOrganizations": 11,
		  "totalTours": 32,
		  "totalDays": 263,
		  "totalCountries": 23,
		  "totalStates": 42,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1448,
		  "schedulePercent": 0.606981,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Le Trianon",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0952242b6afeecf11a9e826dd352058c",
		  
		  "name": "Marie Kjerstine Lindholdt",
		  "createdDate": "2022-08-03 10:49:45",
		  "totalOrganizations": 16,
		  "totalTours": 15,
		  "totalDays": 374,
		  "totalCountries": 6,
		  "totalStates": 6,
		  "totalEvents": 367,
		  "eventPercent": 0.948663,
		  "totalScheduleItems": 2341,
		  "schedulePercent": 0.767112,
		  "totalGuests": 230,
		  "guestPercent": 0.612534,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "Det Kongelige Teater",
		  "mostGuestCity": "KÃ¸benhavn K",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "095f2571024a71e2ee65d7c84bb58ead",
		  
		  "name": "Beatrice",
		  "createdDate": "2022-04-21 06:18:05",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 139,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 221,
		  "schedulePercent": 0.172257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "096462fa1be121d76c75c88288717ac9",
		  
		  "name": "Mak",
		  "createdDate": "2023-04-28 09:04:34",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 265,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1229,
		  "schedulePercent": 0.554284,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0968ca465775028610be7d95b391dec9",
		  
		  "name": "Tommy",
		  "createdDate": "2023-11-12 23:41:14",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 1301,
		  "totalCountries": 31,
		  "totalStates": 76,
		  "totalEvents": 362,
		  "eventPercent": 0.94719,
		  "totalScheduleItems": 6210,
		  "schedulePercent": 0.978581,
		  "totalGuests": 1300,
		  "guestPercent": 0.885993,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "096c20d805683d2d1de1dc5a190bc6d4",
		  
		  "name": "Brian",
		  "createdDate": "2018-01-11 17:33:12",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 579,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2807,
		  "schedulePercent": 0.823436,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "097575df86214a8b87a5e09fbf5af5d0",
		  
		  "name": "Mike",
		  "createdDate": "2024-03-27 21:43:47",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 360,
		  "totalCountries": 17,
		  "totalStates": 38,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 727,
		  "schedulePercent": 0.397099,
		  "totalGuests": 860,
		  "guestPercent": 0.82117,
		  "mostGuestDate": "2025-05-11 00:00:00",
		  "mostGuestName": "",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "097636e07a1d0311cf3e92001ca4d5e0",
		  
		  "name": "Paula",
		  "createdDate": "2025-05-06 10:33:38",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 475,
		  "totalCountries": 20,
		  "totalStates": 28,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1193,
		  "schedulePercent": 0.545898,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Centro de Eventos El Pedregal ",
		  "mostGuestCity": "",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "098200a6fffc9072bbffd29f5912723e",
		  
		  "name": "Chuck ",
		  "createdDate": "2019-01-09 19:26:27",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 534,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 803,
		  "schedulePercent": 0.423617,
		  "totalGuests": 162,
		  "guestPercent": 0.56777,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Mahaffey Theater",
		  "mostGuestCity": "St. Petersburg",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09847d3e4dc9563f3660e1a462fb749f",
		  
		  "name": "Thomas",
		  "createdDate": "2025-11-03 08:43:12",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09874e1fb75759bac8fed67935a88300",
		  
		  "name": "Laurel",
		  "createdDate": "2019-05-02 21:50:06",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 307,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 376,
		  "schedulePercent": 0.25612,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "098e40552b400833120431c488a059bb",
		  
		  "name": "Rhonda",
		  "createdDate": "2020-02-17 20:27:13",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 48,
		  "schedulePercent": 0.0583636,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0990e9db9d28b82ac3278cfc46c3a3ca",
		  
		  "name": "Alexa",
		  "createdDate": "2025-04-01 15:33:37",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 58,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 78,
		  "schedulePercent": 0.0804624,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Shoreline Waterfront",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09a48e64f90591976be323c03fd28298",
		  
		  "name": "Arcadio",
		  "createdDate": "2025-03-21 20:50:37",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 115,
		  "totalCountries": 12,
		  "totalStates": 8,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09a4bebdd0a77fa9ad520cfc68ba7dbd",
		  
		  "name": "Fiona &#9;",
		  "createdDate": "2023-01-31 22:07:24",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 211,
		  "totalCountries": 13,
		  "totalStates": 26,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 773,
		  "schedulePercent": 0.413758,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Lincoln Theatre",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09baf4ce826152f9b7059c90b0a2aedd",
		  
		  "name": "John",
		  "createdDate": "2022-07-21 22:33:21",
		  "totalOrganizations": 5,
		  "totalTours": 21,
		  "totalDays": 613,
		  "totalCountries": 43,
		  "totalStates": 86,
		  "totalEvents": 292,
		  "eventPercent": 0.907185,
		  "totalScheduleItems": 3928,
		  "schedulePercent": 0.910245,
		  "totalGuests": 305,
		  "guestPercent": 0.652199,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09cb13127b11ec5df58f737b2c0f3c14",
		  
		  "name": "Clara",
		  "createdDate": "2023-07-06 12:21:52",
		  "totalOrganizations": 62,
		  "totalTours": 68,
		  "totalDays": 1573,
		  "totalCountries": 21,
		  "totalStates": 45,
		  "totalEvents": 838,
		  "eventPercent": 0.99388,
		  "totalScheduleItems": 6409,
		  "schedulePercent": 0.980961,
		  "totalGuests": 1487,
		  "guestPercent": 0.908092,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Banan-Kompaniet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09d564cd3e31779bf513e814cc3830ee",
		  
		  "name": "Tyler ",
		  "createdDate": "2019-03-30 20:38:09",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 126,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 289,
		  "schedulePercent": 0.211809,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Masonic Lodge at Hollywood Forever",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "09fe6704d97a2ea2c43c77f65cd9ce07",
		  
		  "name": "Lou",
		  "createdDate": "2022-03-18 23:53:18",
		  "totalOrganizations": 23,
		  "totalTours": 8,
		  "totalDays": 1026,
		  "totalCountries": 41,
		  "totalStates": 32,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 2194,
		  "schedulePercent": 0.747167,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a06b791730fec3c494914c80f3f66d6",
		  
		  "name": "Paw",
		  "createdDate": "2015-04-15 18:21:31",
		  "totalOrganizations": 43,
		  "totalTours": 27,
		  "totalDays": 437,
		  "totalCountries": 16,
		  "totalStates": 19,
		  "totalEvents": 392,
		  "eventPercent": 0.956822,
		  "totalScheduleItems": 2436,
		  "schedulePercent": 0.779125,
		  "totalGuests": 606,
		  "guestPercent": 0.760539,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Tivoli",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a08355330389a0f32e4c5f525c486c4",
		  
		  "name": "Charles",
		  "createdDate": "2024-08-16 19:11:30",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 36,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 387,
		  "schedulePercent": 0.262579,
		  "totalGuests": 416,
		  "guestPercent": 0.699909,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Fox Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a0afde8a1fffe2d868bd077a3d60316",
		  
		  "name": "John",
		  "createdDate": "2022-02-19 21:37:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 220,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 752,
		  "schedulePercent": 0.406052,
		  "totalGuests": 924,
		  "guestPercent": 0.834882,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "South Side Ballroom",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a0def79f4ca88a74a0d778b58ae0276",
		  
		  "name": "Henrik",
		  "createdDate": "2024-04-30 09:39:37",
		  "totalOrganizations": 18,
		  "totalTours": 11,
		  "totalDays": 311,
		  "totalCountries": 7,
		  "totalStates": 18,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 1423,
		  "schedulePercent": 0.602788,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Skalldyrfestivalen",
		  "mostGuestCity": "Mandal",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a14054fd6e0909fe9c96f9fbe23d754",
		  
		  "name": "Zachary",
		  "createdDate": "2021-11-09 19:22:16",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 6,
		  "totalStates": 14,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 212,
		  "schedulePercent": 0.166931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a169c334a302f98b9b789de8b976d09",
		  
		  "name": "Jenny",
		  "createdDate": "2022-04-26 09:11:56",
		  "totalOrganizations": 26,
		  "totalTours": 31,
		  "totalDays": 489,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 493,
		  "eventPercent": 0.978015,
		  "totalScheduleItems": 1824,
		  "schedulePercent": 0.68019,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a202badc4a3f26b1faec5aa70bf3258",
		  
		  "name": "Sam",
		  "createdDate": "2023-10-29 15:29:52",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 176,
		  "totalCountries": 16,
		  "totalStates": 22,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a25bb1261bfeb332a55b2f3364d0198",
		  
		  "name": "Gemma",
		  "createdDate": "2018-01-04 18:44:47",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 396,
		  "totalCountries": 11,
		  "totalStates": 46,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1748,
		  "schedulePercent": 0.668291,
		  "totalGuests": 418,
		  "guestPercent": 0.701043,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Kia Center",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a2665d431a7ad13b237862d3b31d104",
		  
		  "name": "joshua",
		  "createdDate": "2019-10-01 08:39:44",
		  "totalOrganizations": 16,
		  "totalTours": 34,
		  "totalDays": 644,
		  "totalCountries": 23,
		  "totalStates": 83,
		  "totalEvents": 292,
		  "eventPercent": 0.907185,
		  "totalScheduleItems": 3984,
		  "schedulePercent": 0.912171,
		  "totalGuests": 794,
		  "guestPercent": 0.806437,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a2765f6f2b3a4b6430578926a8420bd",
		  
		  "name": "Jonah",
		  "createdDate": "2022-02-16 08:37:33",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 703,
		  "totalCountries": 12,
		  "totalStates": 57,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 1480,
		  "schedulePercent": 0.612647,
		  "totalGuests": 880,
		  "guestPercent": 0.825363,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Roadrunner",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a2e17115da4d186279dab94b1e0d162",
		  
		  "name": "CJ",
		  "createdDate": "2020-09-25 05:03:43",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 545,
		  "totalCountries": 2,
		  "totalStates": 51,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 2476,
		  "schedulePercent": 0.784338,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a30529509e7d030aec3c4767482515f",
		  
		  "name": "Shawn",
		  "createdDate": "2022-11-24 12:27:43",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 435,
		  "totalCountries": 7,
		  "totalStates": 29,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 676,
		  "schedulePercent": 0.37704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a3ff519bbb16ac7a653a85e45ffe382",
		  
		  "name": "Jack",
		  "createdDate": "2024-11-16 13:06:01",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 904,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1482,
		  "schedulePercent": 0.613554,
		  "totalGuests": 519,
		  "guestPercent": 0.735494,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Intuit Dome",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a412d1cb993c5bf7f784b9dbd7f94ed",
		  
		  "name": "Juli",
		  "createdDate": "2022-11-11 21:20:59",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 598,
		  "totalCountries": 5,
		  "totalStates": 46,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 2010,
		  "schedulePercent": 0.715095,
		  "totalGuests": 2619,
		  "guestPercent": 0.972688,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a448a529bece069fe8bed7403047dcd",
		  
		  "name": "Daniel Engholt",
		  "createdDate": "2017-06-21 13:28:35",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 67,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 396,
		  "schedulePercent": 0.267452,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a46670693fb49509cb743db2d763fc4",
		  
		  "name": "Temidayo",
		  "createdDate": "2022-06-20 19:59:27",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 205,
		  "totalCountries": 13,
		  "totalStates": 27,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 599,
		  "schedulePercent": 0.350975,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a547a323aee06530dda344ab3ebe815",
		  
		  "name": "Alex",
		  "createdDate": "2024-01-04 18:24:10",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 593,
		  "totalCountries": 1,
		  "totalStates": 23,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a55a3531f26fc8a29b8675ea2987231",
		  
		  "name": "Paige",
		  "createdDate": "2022-06-16 23:43:42",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 686,
		  "totalCountries": 12,
		  "totalStates": 46,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2449,
		  "schedulePercent": 0.781052,
		  "totalGuests": 427,
		  "guestPercent": 0.705576,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a564295c91ebbd110324cf6279db1fd",
		  
		  "name": "Matt",
		  "createdDate": "2022-03-08 22:38:48",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 1170,
		  "totalCountries": 24,
		  "totalStates": 47,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2244,
		  "schedulePercent": 0.754193,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a5b301f58d2cc3bc7a33e0c9caf32ab",
		  
		  "name": "Fernanda",
		  "createdDate": "2022-07-27 21:09:56",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 276,
		  "totalCountries": 6,
		  "totalStates": 19,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 1864,
		  "schedulePercent": 0.687783,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a61cc92258a07d4f5de9dd158fba530",
		  
		  "name": "Christine ",
		  "createdDate": "2019-09-16 15:29:24",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 163,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1876,
		  "schedulePercent": 0.690163,
		  "totalGuests": 1377,
		  "guestPercent": 0.896985,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a8561131c6014ad7e245e969bec8862",
		  
		  "name": "Steven",
		  "createdDate": "2013-04-03 02:07:44",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 110,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 531,
		  "schedulePercent": 0.327176,
		  "totalGuests": 142,
		  "guestPercent": 0.553604,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a8ecc15d81c044a2f4ccfe33c27a1ba",
		  
		  "name": "Kevin",
		  "createdDate": "2017-10-30 21:55:36",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 642,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 261,
		  "eventPercent": 0.88248,
		  "totalScheduleItems": 3787,
		  "schedulePercent": 0.901745,
		  "totalGuests": 811,
		  "guestPercent": 0.811083,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a96b43b9ba07c4e4c9dc36f1dc4ad0e",
		  
		  "name": "Carl-Philip",
		  "createdDate": "2015-07-27 16:26:05",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 631,
		  "totalCountries": 15,
		  "totalStates": 37,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 2361,
		  "schedulePercent": 0.770059,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Amaze Festival",
		  "mostGuestCity": "SmÃ¶gen",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a97fb00aad57433760a0d9136858cb4",
		  
		  "name": "Micah",
		  "createdDate": "2021-01-07 19:34:17",
		  "totalOrganizations": 9,
		  "totalTours": 17,
		  "totalDays": 746,
		  "totalCountries": 19,
		  "totalStates": 72,
		  "totalEvents": 287,
		  "eventPercent": 0.903672,
		  "totalScheduleItems": 3604,
		  "schedulePercent": 0.889619,
		  "totalGuests": 2834,
		  "guestPercent": 0.978694,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0a98135cff337bcff9f5234796e03523",
		  
		  "name": "Tomas",
		  "createdDate": "2016-10-17 06:14:46",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 419,
		  "totalCountries": 32,
		  "totalStates": 67,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1825,
		  "schedulePercent": 0.680417,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Belly Up",
		  "mostGuestCity": "Solana Beach",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0aa3c34f092245f1604f99de3218d137",
		  
		  "name": "Michael",
		  "createdDate": "2012-08-20 21:08:34",
		  "totalOrganizations": 7,
		  "totalTours": 24,
		  "totalDays": 523,
		  "totalCountries": 30,
		  "totalStates": 86,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 3320,
		  "schedulePercent": 0.86854,
		  "totalGuests": 534,
		  "guestPercent": 0.738441,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ab12c9380d3b9de51f8598b75db83d5",
		  
		  "name": "Taylor",
		  "createdDate": "2023-01-31 21:12:49",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 1757,
		  "totalCountries": 10,
		  "totalStates": 40,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 1089,
		  "schedulePercent": 0.517566,
		  "totalGuests": 169,
		  "guestPercent": 0.573096,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Academy Nightclub",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ab4e118e5d197bd4d99df25231a3eb8",
		  
		  "name": "Joey",
		  "createdDate": "2010-06-10 16:58:56",
		  "totalOrganizations": 17,
		  "totalTours": 36,
		  "totalDays": 716,
		  "totalCountries": 32,
		  "totalStates": 89,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 4629,
		  "schedulePercent": 0.941523,
		  "totalGuests": 2083,
		  "guestPercent": 0.953196,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0abaa3875157405d556e2a63112b58be",
		  
		  "name": "Milena",
		  "createdDate": "2025-06-25 13:01:57",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 49,
		  "schedulePercent": 0.0596102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Bar Levi Ihku",
		  "mostGuestCity": "Sirkka",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0abbecc1533e1f40b2337beaac2dc437",
		  
		  "name": "CCM",
		  "createdDate": "2025-03-21 14:01:55",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 257,
		  "totalCountries": 10,
		  "totalStates": 36,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 930,
		  "schedulePercent": 0.468835,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ac0b82852e815cbdc78491d40b513ba",
		  
		  "name": "Emily",
		  "createdDate": "2025-07-28 21:22:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 93,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0acd4431d547520fc43c64a13470eed2",
		  
		  "name": "Sofie",
		  "createdDate": "2015-05-27 12:09:40",
		  "totalOrganizations": 16,
		  "totalTours": 6,
		  "totalDays": 405,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 707,
		  "schedulePercent": 0.389166,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Hwitans TrÃ¤dgÃ¥rd",
		  "mostGuestCity": "Falkenberg",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ad5b1a166ace811a51fc7a3537dbdb0",
		  
		  "name": "Alliz",
		  "createdDate": "2018-03-04 03:38:23",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 76,
		  "totalCountries": 20,
		  "totalStates": 20,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 370,
		  "schedulePercent": 0.253173,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ae9feff89719c6773683a978a498bfa",
		  
		  "name": "Madelene",
		  "createdDate": "2021-07-02 14:21:35",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 228,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1428,
		  "schedulePercent": 0.604488,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0af0a5ea9cf76af7166b1c0a04e3a0a7",
		  
		  "name": "Thomas",
		  "createdDate": "2021-07-06 13:47:33",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 368,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 716,
		  "schedulePercent": 0.392339,
		  "totalGuests": 213,
		  "guestPercent": 0.604261,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre National Wallonie-Bruxelles",
		  "mostGuestCity": "Bruxelles",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0af269560c277271fa09a2ae5c7ab6d6",
		  
		  "name": "Kara",
		  "createdDate": "2019-06-21 23:24:52",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 743,
		  "totalCountries": 8,
		  "totalStates": 38,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 2792,
		  "schedulePercent": 0.821056,
		  "totalGuests": 783,
		  "guestPercent": 0.80383,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Chicago Theatre",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0afbdcfb3f9d9e65d741f7951e384d78",
		  
		  "name": "Jesse",
		  "createdDate": "2024-09-12 11:13:14",
		  "totalOrganizations": 52,
		  "totalTours": 71,
		  "totalDays": 1725,
		  "totalCountries": 11,
		  "totalStates": 4,
		  "totalEvents": 360,
		  "eventPercent": 0.94617,
		  "totalScheduleItems": 1935,
		  "schedulePercent": 0.700816,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Festivaali",
		  "mostGuestCity": "Tampere",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0afce080a3d2aa6a4c54d3e30b9f50b0",
		  
		  "name": "Adam",
		  "createdDate": "2019-01-08 21:56:16",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 306,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 1878,
		  "schedulePercent": 0.690616,
		  "totalGuests": 71,
		  "guestPercent": 0.486174,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "First Baptist Church",
		  "mostGuestCity": "New Port Richey",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b01081b41a08b44a441e70cf2001f29",
		  
		  "name": "Gilles",
		  "createdDate": "2019-10-01 04:44:41",
		  "totalOrganizations": 29,
		  "totalTours": 19,
		  "totalDays": 422,
		  "totalCountries": 38,
		  "totalStates": 46,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2092,
		  "schedulePercent": 0.730961,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "GrÃ¶na Lund",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b123726e4b1b4901fc3e0e68aae89fc",
		  
		  "name": "Nathan",
		  "createdDate": "2014-08-16 16:52:17",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 209,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1194,
		  "schedulePercent": 0.546124,
		  "totalGuests": 1099,
		  "guestPercent": 0.864007,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "The Wharf Amphitheater",
		  "mostGuestCity": "Orange Beach",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b19a6a1bee6760ea5a124d42d1911b6",
		  
		  "name": "Cynthia",
		  "createdDate": "2020-02-21 18:43:04",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 197,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Fallsview Casino Resort",
		  "mostGuestCity": "Niagara Falls",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b2113411babbe709824ac44c1564ba9",
		  
		  "name": "Jeremy",
		  "createdDate": "2018-06-12 04:50:38",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 302,
		  "totalCountries": 15,
		  "totalStates": 32,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 948,
		  "schedulePercent": 0.474728,
		  "totalGuests": 352,
		  "guestPercent": 0.675884,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b23fdf9e75f94ee8279e94e9a3c9edd",
		  
		  "name": "Victor",
		  "createdDate": "2022-10-07 10:10:22",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 370,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1746,
		  "schedulePercent": 0.668064,
		  "totalGuests": 135,
		  "guestPercent": 0.548844,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "Salle MÃ©tropole",
		  "mostGuestCity": "Lausanne",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b333f4f6a9b0ceb78b1b6ba51c2e0ac",
		  
		  "name": "Tanja",
		  "createdDate": "2025-03-03 22:29:01",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 41,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 148,
		  "schedulePercent": 0.129646,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b3abf1d8cff2ebb9eb6e143d5054d84",
		  
		  "name": "Arnault",
		  "createdDate": "2018-05-07 16:20:51",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 78,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 422,
		  "schedulePercent": 0.278898,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre des Bouffes du Nord",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b3cc3987508d9872d851e5ee082aca8",
		  
		  "name": "Pierce",
		  "createdDate": "2021-07-20 10:18:24",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 157,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 1938,
		  "schedulePercent": 0.701836,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b525ff7ba3229fd6c22441a01a7b93f",
		  
		  "name": "Malcolm",
		  "createdDate": "2022-10-12 18:08:40",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 570,
		  "totalCountries": 14,
		  "totalStates": 45,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1619,
		  "schedulePercent": 0.644039,
		  "totalGuests": 286,
		  "guestPercent": 0.642792,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "The Torch At The LA Memorial Coliseum",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b5843dd17bf3fe6c901c90386050a6b",
		  
		  "name": "petr",
		  "createdDate": "2016-02-13 04:06:10",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 386,
		  "totalCountries": 17,
		  "totalStates": 27,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 361,
		  "schedulePercent": 0.248753,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "MK11 Live Music Venue & Sports Bar",
		  "mostGuestCity": "Milton Keynes",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b5a4daad06c9c7b996a580adb25dd79",
		  
		  "name": "Daniel",
		  "createdDate": "2023-01-12 16:44:57",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 50,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 105,
		  "schedulePercent": 0.101315,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Daytona International Speedway",
		  "mostGuestCity": "Daytona Beach",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b6d00798a1b5f5b9468767313c3c5de",
		  
		  "name": "Josefina",
		  "createdDate": "2023-10-26 18:00:46",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 52,
		  "totalCountries": 6,
		  "totalStates": 15,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 262,
		  "schedulePercent": 0.19583,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b71082230972b732a96e6df846a92c0",
		  
		  "name": "Carol",
		  "createdDate": "2017-02-16 22:00:47",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 526,
		  "totalCountries": 30,
		  "totalStates": 90,
		  "totalEvents": 308,
		  "eventPercent": 0.917271,
		  "totalScheduleItems": 4853,
		  "schedulePercent": 0.949343,
		  "totalGuests": 1452,
		  "guestPercent": 0.905032,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b82b2b5c149a11f9d7eb4e4237794b0",
		  
		  "name": "Scott",
		  "createdDate": "2015-02-18 20:44:37",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 295,
		  "totalCountries": 9,
		  "totalStates": 37,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1273,
		  "schedulePercent": 0.56607,
		  "totalGuests": 716,
		  "guestPercent": 0.789551,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stone Pony Summer Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b836f7a2ee7ed57eb8d1bfd51e219f2",
		  
		  "name": "Chris",
		  "createdDate": "2013-04-17 00:15:54",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 541,
		  "totalCountries": 15,
		  "totalStates": 57,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 2358,
		  "schedulePercent": 0.769606,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b8a2ff8a328dbaf50aefbe23805f193",
		  
		  "name": "Anna",
		  "createdDate": "2022-02-01 20:28:23",
		  "totalOrganizations": 13,
		  "totalTours": 22,
		  "totalDays": 1547,
		  "totalCountries": 10,
		  "totalStates": 61,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 3453,
		  "schedulePercent": 0.879306,
		  "totalGuests": 1565,
		  "guestPercent": 0.916251,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b96ba50cf8be7827b3d9fa508c578d9",
		  
		  "name": "Rory",
		  "createdDate": "2016-07-13 02:27:57",
		  "totalOrganizations": 28,
		  "totalTours": 55,
		  "totalDays": 1898,
		  "totalCountries": 26,
		  "totalStates": 98,
		  "totalEvents": 725,
		  "eventPercent": 0.99184,
		  "totalScheduleItems": 9032,
		  "schedulePercent": 0.993654,
		  "totalGuests": 3276,
		  "guestPercent": 0.987307,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "The Met Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0b9aa1ad475ca4a7970c74e873878f00",
		  
		  "name": "Richard",
		  "createdDate": "2010-06-18 01:19:00",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 451,
		  "totalCountries": 13,
		  "totalStates": 30,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1089,
		  "schedulePercent": 0.517566,
		  "totalGuests": 1098,
		  "guestPercent": 0.863781,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ba3642456cd02195bdf725f3b85f2d3",
		  
		  "name": "Jamie",
		  "createdDate": "2013-06-04 17:29:34",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 102,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 415,
		  "schedulePercent": 0.276292,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-12-06 00:00:00",
		  "mostGuestName": "Exeter Corn Exchange",
		  "mostGuestCity": "Exeter",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ba4bc243cc49cd70e5e3ad26f8f7413",
		  
		  "name": "Todd",
		  "createdDate": "2013-05-16 04:16:03",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 121,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 241,
		  "schedulePercent": 0.184723,
		  "totalGuests": 156,
		  "guestPercent": 0.563577,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0bbace1435f101651046a0cf49726d60",
		  
		  "name": "Thomas",
		  "createdDate": "2022-03-14 11:34:16",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 72,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 629,
		  "schedulePercent": 0.360381,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "E-Werk",
		  "mostGuestCity": "Koln",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0bc0fe83a15642f6f9da6664c9fe7157",
		  
		  "name": "Kendall",
		  "createdDate": "2024-02-15 17:10:12",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 198,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1062,
		  "schedulePercent": 0.5068,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0bcf26d0ce61a2f9cbc20023bdb03521",
		  
		  "name": "Zachary",
		  "createdDate": "2017-10-10 21:26:11",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 107,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 353,
		  "schedulePercent": 0.24422,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "Lincoln Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0bed2747b96784bf487f54f7af80f384",
		  
		  "name": "Klas",
		  "createdDate": "2014-09-09 09:20:50",
		  "totalOrganizations": 19,
		  "totalTours": 8,
		  "totalDays": 164,
		  "totalCountries": 21,
		  "totalStates": 29,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1156,
		  "schedulePercent": 0.536151,
		  "totalGuests": 693,
		  "guestPercent": 0.783998,
		  "mostGuestDate": "2025-05-06 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0bf48174a47d7911cc9fbe061500bdbc",
		  
		  "name": "Sarah",
		  "createdDate": "2024-04-04 09:08:06",
		  "totalOrganizations": 95,
		  "totalTours": 64,
		  "totalDays": 766,
		  "totalCountries": 13,
		  "totalStates": 10,
		  "totalEvents": 719,
		  "eventPercent": 0.991614,
		  "totalScheduleItems": 3089,
		  "schedulePercent": 0.850635,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0bff2e2abd85b0d1f91702875520ee58",
		  
		  "name": "Josh ",
		  "createdDate": "2015-11-07 17:04:13",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 367,
		  "totalCountries": 19,
		  "totalStates": 19,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 1960,
		  "schedulePercent": 0.705576,
		  "totalGuests": 67,
		  "guestPercent": 0.480734,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c04dc40f6f29657a15bd7a23ed9a62b",
		  
		  "name": "Brian",
		  "createdDate": "2024-07-23 20:07:04",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 249,
		  "totalCountries": 13,
		  "totalStates": 25,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1120,
		  "schedulePercent": 0.524932,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c1174c87398345f20ca2bfaf11439ac",
		  
		  "name": "Andrew",
		  "createdDate": "2011-06-17 18:34:50",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 399,
		  "totalCountries": 20,
		  "totalStates": 54,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1064,
		  "schedulePercent": 0.507593,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-02-11 00:00:00",
		  "mostGuestName": "Academy 2",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c14f6cfd4957031321910b3cebaffab",
		  
		  "name": "Aya",
		  "createdDate": "2023-04-10 20:37:44",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 133,
		  "schedulePercent": 0.120467,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c1aeef6a8dc68e341d2a9991d99d5ed",
		  
		  "name": "Allyson",
		  "createdDate": "2019-06-11 20:29:19",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 519,
		  "totalCountries": 16,
		  "totalStates": 77,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 3645,
		  "schedulePercent": 0.892226,
		  "totalGuests": 792,
		  "guestPercent": 0.805984,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c3f0910c86e58c43f60f0a4a8d02c2a",
		  
		  "name": "Sean",
		  "createdDate": "2022-05-18 02:57:53",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 281,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1140,
		  "schedulePercent": 0.531958,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "The Sultan Room",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c46c7a3771955dcb2e4d2a086a84596",
		  
		  "name": "Drew",
		  "createdDate": "2012-05-10 20:17:37",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 469,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 1787,
		  "schedulePercent": 0.674071,
		  "totalGuests": 1513,
		  "guestPercent": 0.911151,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 157,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c481b0210c8aa8f6d17acc00edeee42",
		  
		  "name": "Don",
		  "createdDate": "2022-04-11 16:29:34",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 775,
		  "schedulePercent": 0.414551,
		  "totalGuests": 323,
		  "guestPercent": 0.662511,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Credit Union 1 Amphitheatre",
		  "mostGuestCity": "Tinley Park",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c487d34d2f149543e20acbbfce80e4b",
		  
		  "name": "Carrie",
		  "createdDate": "2022-09-06 20:08:02",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 141,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 304,
		  "schedulePercent": 0.218948,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-11-13 00:00:00",
		  "mostGuestName": "The ELM",
		  "mostGuestCity": "Bozeman",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c6cf525ad1e3b89bdc5b000b2979980",
		  
		  "name": "Nino",
		  "createdDate": "2024-03-16 19:46:32",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 60,
		  "totalCountries": 13,
		  "totalStates": 14,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c785defbf8ea03a78b724f46706052e",
		  
		  "name": "Jaren",
		  "createdDate": "2021-06-15 21:45:11",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 863,
		  "totalCountries": 7,
		  "totalStates": 49,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 2118,
		  "schedulePercent": 0.735381,
		  "totalGuests": 236,
		  "guestPercent": 0.6165,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "Nissan Stadium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c8298bfb8c08987af7f0217fc4aa215",
		  
		  "name": "Michael",
		  "createdDate": "2019-01-22 19:13:32",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 720,
		  "totalCountries": 5,
		  "totalStates": 46,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 3606,
		  "schedulePercent": 0.889733,
		  "totalGuests": 363,
		  "guestPercent": 0.67917,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Hard Rock Live at Etess Arena",
		  "mostGuestCity": "Atlantic City",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c88f94150a6f55647e29a31311af37c",
		  
		  "name": "Jasmine",
		  "createdDate": "2019-01-08 00:57:05",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 595,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1290,
		  "schedulePercent": 0.569583,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c89ca63bd5481edbb84ec7b1bccc633",
		  
		  "name": "Kevin",
		  "createdDate": "2023-04-03 11:59:26",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 239,
		  "totalCountries": 24,
		  "totalStates": 30,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1294,
		  "schedulePercent": 0.570263,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "O2 Academy Islington",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c93c39b69bfd3075427b7eac7ae0759",
		  
		  "name": "Anthony",
		  "createdDate": "2018-10-29 01:15:24",
		  "totalOrganizations": 16,
		  "totalTours": 34,
		  "totalDays": 415,
		  "totalCountries": 19,
		  "totalStates": 48,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 1946,
		  "schedulePercent": 0.702969,
		  "totalGuests": 662,
		  "guestPercent": 0.775159,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0c9578404cc953401ab74fa8dcb75ea2",
		  
		  "name": "Darren",
		  "createdDate": "2013-08-11 00:59:54",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 394,
		  "totalCountries": 23,
		  "totalStates": 50,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 2031,
		  "schedulePercent": 0.719175,
		  "totalGuests": 165,
		  "guestPercent": 0.56947,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0cb4ed312552c8dc0708e78929e5a259",
		  
		  "name": "Quinn",
		  "createdDate": "2024-10-18 18:32:00",
		  "totalOrganizations": 3,
		  "totalTours": 37,
		  "totalDays": 150,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 968,
		  "schedulePercent": 0.480621,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0cb9f89313839f66ebd7b088a6082795",
		  
		  "name": "Marius",
		  "createdDate": "2017-01-29 23:44:30",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 180,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 108,
		  "schedulePercent": 0.103921,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0cd3fbe85eaed1343d0f4dde90e82b88",
		  
		  "name": "Drew",
		  "createdDate": "2023-02-24 20:16:03",
		  "totalOrganizations": 12,
		  "totalTours": 35,
		  "totalDays": 563,
		  "totalCountries": 24,
		  "totalStates": 42,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 2798,
		  "schedulePercent": 0.821963,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Rock City",
		  "mostGuestCity": "Nottingham",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0cf5707f867d155b062e8b591cdb25bc",
		  
		  "name": "Henrik",
		  "createdDate": "2023-11-27 18:37:06",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 97,
		  "totalCountries": 6,
		  "totalStates": 4,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 368,
		  "schedulePercent": 0.252153,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d02ed3ed77086bd79e731adb8b16a27",
		  
		  "name": "Brendan",
		  "createdDate": "2009-07-22 23:13:49",
		  "totalOrganizations": 34,
		  "totalTours": 23,
		  "totalDays": 1897,
		  "totalCountries": 29,
		  "totalStates": 76,
		  "totalEvents": 359,
		  "eventPercent": 0.94583,
		  "totalScheduleItems": 5089,
		  "schedulePercent": 0.957049,
		  "totalGuests": 2685,
		  "guestPercent": 0.975408,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Boone Pickens Stadium",
		  "mostGuestCity": "Stillwater",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d0439968210fef33096722f5fede3b9",
		  
		  "name": "Caitlin",
		  "createdDate": "2019-09-10 23:05:59",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 626,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 828,
		  "schedulePercent": 0.433477,
		  "totalGuests": 62,
		  "guestPercent": 0.473368,
		  "mostGuestDate": "2025-06-03 00:00:00",
		  "mostGuestName": "Webster Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d120252354633cdbd0683c7a63ccb00",
		  
		  "name": "Elinor",
		  "createdDate": "2024-05-15 13:26:13",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 170,
		  "totalCountries": 7,
		  "totalStates": 32,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 711,
		  "schedulePercent": 0.391319,
		  "totalGuests": 403,
		  "guestPercent": 0.69583,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Tipitina's Uptown",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d1d61735766ef91669a7f74666b3fc0",
		  
		  "name": "Armand",
		  "createdDate": "2022-08-30 18:19:52",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 933,
		  "totalCountries": 10,
		  "totalStates": 33,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 1982,
		  "schedulePercent": 0.709995,
		  "totalGuests": 587,
		  "guestPercent": 0.75544,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "L'Olympia Bruno Coquatrix",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d24e184813f1a705b0c1a0b81af2047",
		  
		  "name": "Nikkita",
		  "createdDate": "2023-08-23 04:37:45",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 87,
		  "totalCountries": 5,
		  "totalStates": 7,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 412,
		  "schedulePercent": 0.275272,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-05-20 00:00:00",
		  "mostGuestName": "The Camden Assembly",
		  "mostGuestCity": "Camden",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d2a99c1f9b86b168a12abdabc6510a6",
		  
		  "name": "Kevin",
		  "createdDate": "2016-10-24 17:26:12",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 186,
		  "totalCountries": 5,
		  "totalStates": 26,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 763,
		  "schedulePercent": 0.409678,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d2f9711d25fd96cae424e91f395307d",
		  
		  "name": "Stephen",
		  "createdDate": "2010-03-25 07:30:34",
		  "totalOrganizations": 25,
		  "totalTours": 32,
		  "totalDays": 471,
		  "totalCountries": 8,
		  "totalStates": 43,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 3619,
		  "schedulePercent": 0.890752,
		  "totalGuests": 631,
		  "guestPercent": 0.765639,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d37bfa04862dbc71d73f555140c71b4",
		  
		  "name": "Jeff",
		  "createdDate": "2023-06-01 06:34:59",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 613,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 321,
		  "schedulePercent": 0.227788,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d38db1b78c42d57e48356d003ebd776",
		  
		  "name": "Staffan",
		  "createdDate": "2015-01-26 16:01:41",
		  "totalOrganizations": 18,
		  "totalTours": 8,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d48471d9e510279ed7f03b00c83f4b8",
		  
		  "name": "Lauren",
		  "createdDate": "2025-04-01 18:35:54",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 628,
		  "totalCountries": 4,
		  "totalStates": 54,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1249,
		  "schedulePercent": 0.56063,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "The Zoo Amphitheatre",
		  "mostGuestCity": "Oklahoma City",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d500a0216e8822fe4fe8d7c4154f1ac",
		  
		  "name": "Timothy",
		  "createdDate": "2023-07-26 17:35:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 35,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 95,
		  "schedulePercent": 0.0933817,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Barboza",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d546147a4670eef70ca799ec71f90ce",
		  
		  "name": "Will",
		  "createdDate": "2020-01-10 22:08:53",
		  "totalOrganizations": 11,
		  "totalTours": 37,
		  "totalDays": 2098,
		  "totalCountries": 24,
		  "totalStates": 72,
		  "totalEvents": 328,
		  "eventPercent": 0.932004,
		  "totalScheduleItems": 4473,
		  "schedulePercent": 0.93733,
		  "totalGuests": 694,
		  "guestPercent": 0.784111,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d5f950e8d338cbe734a2492d81c169e",
		  
		  "name": "produccionryan@gmail.com",
		  "createdDate": "2022-04-13 02:13:34",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 361,
		  "totalCountries": 14,
		  "totalStates": 14,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 355,
		  "schedulePercent": 0.245127,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Sant Jordi Club",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d6d94cad96bfd037b7d55ec24de5985",
		  
		  "name": "Robert ",
		  "createdDate": "2016-05-26 17:03:14",
		  "totalOrganizations": 26,
		  "totalTours": 14,
		  "totalDays": 719,
		  "totalCountries": 29,
		  "totalStates": 92,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 3792,
		  "schedulePercent": 0.902199,
		  "totalGuests": 2376,
		  "guestPercent": 0.964529,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "South Side Ballroom",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d7361cccb9e67a23d735d2c1e39e184",
		  
		  "name": "Amanda",
		  "createdDate": "2021-11-16 16:34:42",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 694,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2391,
		  "schedulePercent": 0.773912,
		  "totalGuests": 1671,
		  "guestPercent": 0.925997,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d8a882278a2f6b0da119eca2dab39e9",
		  
		  "name": "Keith",
		  "createdDate": "2022-05-30 22:35:42",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d8c6bf4b1a4662bf6729fef71945abf",
		  
		  "name": "Maria",
		  "createdDate": "2025-02-18 15:37:05",
		  "totalOrganizations": 17,
		  "totalTours": 14,
		  "totalDays": 1768,
		  "totalCountries": 27,
		  "totalStates": 43,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1128,
		  "schedulePercent": 0.527425,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "All Points East",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d9ae2377e8f2fba26689b4f2a85120c",
		  
		  "name": "Mike",
		  "createdDate": "2010-09-01 14:27:40",
		  "totalOrganizations": 18,
		  "totalTours": 6,
		  "totalDays": 777,
		  "totalCountries": 7,
		  "totalStates": 51,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 2057,
		  "schedulePercent": 0.725181,
		  "totalGuests": 540,
		  "guestPercent": 0.740594,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0d9bb038e4a355bbb8852f92eb6537d8",
		  
		  "name": "Sofia",
		  "createdDate": "2025-04-30 22:06:37",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 70,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Cache Creek Casino Resort",
		  "mostGuestCity": "Brooks",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dac6661e8046e2a51f789692c217d3d",
		  
		  "name": "Gabe ",
		  "createdDate": "2017-07-27 14:11:47",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 119,
		  "totalCountries": 19,
		  "totalStates": 56,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 633,
		  "guestPercent": 0.766546,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0daf246717f666364d18ec5ee79909cd",
		  
		  "name": "Jennifer",
		  "createdDate": "2017-03-30 23:46:23",
		  "totalOrganizations": 26,
		  "totalTours": 18,
		  "totalDays": 1838,
		  "totalCountries": 18,
		  "totalStates": 43,
		  "totalEvents": 402,
		  "eventPercent": 0.958862,
		  "totalScheduleItems": 4805,
		  "schedulePercent": 0.947869,
		  "totalGuests": 1271,
		  "guestPercent": 0.882593,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0db147da3196f143f6c7db724aef69cf",
		  
		  "name": "Logan",
		  "createdDate": "2016-10-02 15:22:19",
		  "totalOrganizations": 12,
		  "totalTours": 18,
		  "totalDays": 1172,
		  "totalCountries": 20,
		  "totalStates": 94,
		  "totalEvents": 357,
		  "eventPercent": 0.944696,
		  "totalScheduleItems": 5558,
		  "schedulePercent": 0.968835,
		  "totalGuests": 567,
		  "guestPercent": 0.748413,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0db3386495d978ce6e720218b4b6a7a8",
		  
		  "name": "Carlos",
		  "createdDate": "2010-10-20 19:49:54",
		  "totalOrganizations": 18,
		  "totalTours": 19,
		  "totalDays": 247,
		  "totalCountries": 7,
		  "totalStates": 33,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1021,
		  "schedulePercent": 0.496374,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dbabc0f5b110aaa31b2a9d70a679b1b",
		  
		  "name": "Katie",
		  "createdDate": "2022-04-18 18:28:28",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 547,
		  "totalCountries": 30,
		  "totalStates": 50,
		  "totalEvents": 253,
		  "eventPercent": 0.874093,
		  "totalScheduleItems": 3908,
		  "schedulePercent": 0.909111,
		  "totalGuests": 940,
		  "guestPercent": 0.837262,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dbb2d47208e0c37b444d4465f2f3856",
		  
		  "name": "Tim",
		  "createdDate": "2014-01-28 17:43:29",
		  "totalOrganizations": 30,
		  "totalTours": 11,
		  "totalDays": 606,
		  "totalCountries": 21,
		  "totalStates": 46,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 2770,
		  "schedulePercent": 0.818223,
		  "totalGuests": 644,
		  "guestPercent": 0.770172,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "The Torch",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dbf304b64f49847333bafa81518ffa1",
		  
		  "name": "Tyler",
		  "createdDate": "2021-07-12 16:29:12",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 768,
		  "totalCountries": 7,
		  "totalStates": 47,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1143,
		  "schedulePercent": 0.532298,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dc89914198a8711314adf9f8589c2cd",
		  
		  "name": "Garry",
		  "createdDate": "2013-07-23 19:00:05",
		  "totalOrganizations": 3,
		  "totalTours": 18,
		  "totalDays": 108,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 559,
		  "schedulePercent": 0.336809,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dcb1d824c1d3b1033c25a8f62cc1a68",
		  
		  "name": "Daniel",
		  "createdDate": "2023-09-23 18:04:19",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 442,
		  "totalCountries": 26,
		  "totalStates": 33,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1076,
		  "schedulePercent": 0.512466,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dcf96034f5566e3d14c514e346b474a",
		  
		  "name": "Ian",
		  "createdDate": "2014-09-11 16:48:03",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 646,
		  "totalCountries": 26,
		  "totalStates": 78,
		  "totalEvents": 240,
		  "eventPercent": 0.861854,
		  "totalScheduleItems": 4174,
		  "schedulePercent": 0.924297,
		  "totalGuests": 2594,
		  "guestPercent": 0.971895,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dd5af4d28076e516689ccb7021d858e",
		  
		  "name": "Katelyn",
		  "createdDate": "2018-08-23 03:51:39",
		  "totalOrganizations": 16,
		  "totalTours": 11,
		  "totalDays": 490,
		  "totalCountries": 8,
		  "totalStates": 44,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1461,
		  "schedulePercent": 0.609248,
		  "totalGuests": 492,
		  "guestPercent": 0.728015,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ddb4516da7b5d8c69bcae0b45880187",
		  
		  "name": "Katie",
		  "createdDate": "2018-07-21 14:30:23",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 437,
		  "totalCountries": 24,
		  "totalStates": 30,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1163,
		  "schedulePercent": 0.538871,
		  "totalGuests": 180,
		  "guestPercent": 0.580009,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0deefd204b92a7c754bb815828a44f3d",
		  
		  "name": "Samantha",
		  "createdDate": "2019-02-25 08:41:21",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 408,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 2777,
		  "schedulePercent": 0.81913,
		  "totalGuests": 3415,
		  "guestPercent": 0.988667,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0dfff2cd818893c21d25c334a47663fe",
		  
		  "name": "Lisa",
		  "createdDate": "2017-12-01 09:09:48",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 151,
		  "totalCountries": 7,
		  "totalStates": 18,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e04e1e0e77d7389f9dd8104cd934028",
		  
		  "name": "Zachary",
		  "createdDate": "2013-05-12 23:12:39",
		  "totalOrganizations": 10,
		  "totalTours": 18,
		  "totalDays": 1366,
		  "totalCountries": 26,
		  "totalStates": 32,
		  "totalEvents": 523,
		  "eventPercent": 0.981188,
		  "totalScheduleItems": 4957,
		  "schedulePercent": 0.953083,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e102a881a802d7a742ec79c656326d7",
		  
		  "name": "Justin",
		  "createdDate": "2023-07-18 18:08:02",
		  "totalOrganizations": 2,
		  "totalTours": 29,
		  "totalDays": 212,
		  "totalCountries": 8,
		  "totalStates": 34,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1265,
		  "schedulePercent": 0.564597,
		  "totalGuests": 335,
		  "guestPercent": 0.668064,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "America Gardens Theatre",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e25b2a6a464914e23f569412c47aba0",
		  
		  "name": "Norman",
		  "createdDate": "2025-10-30 07:21:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e2d05dee1b60f024d5898d5275b8648",
		  
		  "name": "Ilari",
		  "createdDate": "2022-05-04 13:32:55",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 324,
		  "totalCountries": 15,
		  "totalStates": 15,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 823,
		  "schedulePercent": 0.432117,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e32dceed0eae06d17d25b6e31a4433b",
		  
		  "name": "Alexandra",
		  "createdDate": "2023-10-02 22:57:59",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 182,
		  "totalCountries": 11,
		  "totalStates": 19,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 1169,
		  "schedulePercent": 0.539778,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e3a6867b9ac5e3814ae90988de8a104",
		  
		  "name": "Jonah",
		  "createdDate": "2023-07-26 07:42:14",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 205,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1030,
		  "schedulePercent": 0.498753,
		  "totalGuests": 1109,
		  "guestPercent": 0.865707,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e3b9c93926d8c101518089dce208dc3",
		  
		  "name": "Andre",
		  "createdDate": "2009-11-11 00:17:54",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 329,
		  "totalCountries": 22,
		  "totalStates": 38,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1313,
		  "schedulePercent": 0.574569,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Rock In Roma",
		  "mostGuestCity": "Roma",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e3db9f7e4e3a1892c39f54f55c16a7b",
		  
		  "name": "Matthew",
		  "createdDate": "2022-04-28 17:53:30",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 77,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 425,
		  "schedulePercent": 0.280032,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e5346e714ea572fa4331675d231e95f",
		  
		  "name": "Steve",
		  "createdDate": "2013-06-12 13:53:52",
		  "totalOrganizations": 44,
		  "totalTours": 47,
		  "totalDays": 1209,
		  "totalCountries": 23,
		  "totalStates": 65,
		  "totalEvents": 369,
		  "eventPercent": 0.949229,
		  "totalScheduleItems": 4461,
		  "schedulePercent": 0.936423,
		  "totalGuests": 1052,
		  "guestPercent": 0.855054,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e5be1aa3f8b0a8dc2fd9b4388ab57a9",
		  
		  "name": "Chris",
		  "createdDate": "2012-07-30 21:02:04",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 423,
		  "totalCountries": 22,
		  "totalStates": 31,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1987,
		  "schedulePercent": 0.711015,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e688fc56ea0ef0cbeff96c220f10e89",
		  
		  "name": "Terence ",
		  "createdDate": "2013-08-05 01:22:17",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 889,
		  "totalCountries": 11,
		  "totalStates": 21,
		  "totalEvents": 242,
		  "eventPercent": 0.863667,
		  "totalScheduleItems": 3907,
		  "schedulePercent": 0.908998,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Stade de France",
		  "mostGuestCity": "Saint-Denis",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e76aeeb0916df098a611d98aff5d2d0",
		  
		  "name": "Ryan",
		  "createdDate": "2022-09-19 13:21:39",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 784,
		  "totalCountries": 21,
		  "totalStates": 66,
		  "totalEvents": 370,
		  "eventPercent": 0.949683,
		  "totalScheduleItems": 6102,
		  "schedulePercent": 0.977108,
		  "totalGuests": 1401,
		  "guestPercent": 0.900272,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "MGM Grand",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e788f803f2d59d52300bd397a62c4bb",
		  
		  "name": "Daniel",
		  "createdDate": "2016-08-19 19:10:52",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 223,
		  "totalCountries": 13,
		  "totalStates": 47,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 954,
		  "schedulePercent": 0.477335,
		  "totalGuests": 694,
		  "guestPercent": 0.784111,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "Brooklyn paramount",
		  "mostGuestCity": "",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e81776ad3218bcacf3db12547943a75",
		  
		  "name": "Guy",
		  "createdDate": "2025-10-23 08:13:19",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 69,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 314,
		  "schedulePercent": 0.224388,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e82b2811d74f1d448570f398042a0ac",
		  
		  "name": "Mildlife",
		  "createdDate": "2022-01-17 19:03:33",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 84,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 43,
		  "schedulePercent": 0.0541704,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Hotel Brunswick",
		  "mostGuestCity": "Brunswick Heads",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e8cccf63ecfb84cbb74009988b22e03",
		  
		  "name": "Jaclyn",
		  "createdDate": "2025-04-09 19:41:22",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 97,
		  "totalCountries": 8,
		  "totalStates": 27,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Soho Live",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e98dce28527605aba59e42195d5f07e",
		  
		  "name": "Alexander",
		  "createdDate": "2022-04-12 20:48:15",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 278,
		  "schedulePercent": 0.204216,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0e9a184fb5b7b55bfcb31d0aa190bfa0",
		  
		  "name": "Nicholas",
		  "createdDate": "2025-04-03 01:31:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 272,
		  "totalCountries": 4,
		  "totalStates": 25,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 659,
		  "schedulePercent": 0.37126,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 150,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0eb35bd909ff4b966361579481d8b541",
		  
		  "name": "Kate",
		  "createdDate": "2022-03-11 11:04:23",
		  "totalOrganizations": 49,
		  "totalTours": 37,
		  "totalDays": 583,
		  "totalCountries": 23,
		  "totalStates": 53,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 3131,
		  "schedulePercent": 0.853808,
		  "totalGuests": 2192,
		  "guestPercent": 0.957389,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Freo.Social",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ebbd7f4fcfd7f31f70eafbfd9f6eadc",
		  
		  "name": "Ashley",
		  "createdDate": "2013-08-21 01:08:29",
		  "totalOrganizations": 10,
		  "totalTours": 34,
		  "totalDays": 810,
		  "totalCountries": 27,
		  "totalStates": 80,
		  "totalEvents": 387,
		  "eventPercent": 0.955349,
		  "totalScheduleItems": 6064,
		  "schedulePercent": 0.976541,
		  "totalGuests": 866,
		  "guestPercent": 0.822303,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ec046a265f6be342a6346a93becdd56",
		  
		  "name": "Oona",
		  "createdDate": "2022-01-03 10:54:18",
		  "totalOrganizations": 43,
		  "totalTours": 24,
		  "totalDays": 447,
		  "totalCountries": 18,
		  "totalStates": 19,
		  "totalEvents": 422,
		  "eventPercent": 0.963962,
		  "totalScheduleItems": 2265,
		  "schedulePercent": 0.75748,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Tulisuudelma",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ec4e5a29c7559f92f6ca53430393d31",
		  
		  "name": "Nick",
		  "createdDate": "2011-03-03 05:46:31",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 182,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 946,
		  "schedulePercent": 0.474275,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ecdee3063ebc497caaf781154470c77",
		  
		  "name": "Troels ",
		  "createdDate": "2015-08-18 09:00:00",
		  "totalOrganizations": 20,
		  "totalTours": 7,
		  "totalDays": 242,
		  "totalCountries": 9,
		  "totalStates": 17,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 1393,
		  "schedulePercent": 0.596102,
		  "totalGuests": 290,
		  "guestPercent": 0.644266,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "Det Kongelige Teater",
		  "mostGuestCity": "KÃ¸benhavn K",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ee5f60da8760065fd43214b180c6ec8",
		  
		  "name": "John",
		  "createdDate": "2024-10-23 02:12:24",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 168,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 507,
		  "schedulePercent": 0.314257,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-02-24 00:00:00",
		  "mostGuestName": "Herald Theatre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0eea0e6def6f6c738f3fafdab149b664",
		  
		  "name": "Angelique",
		  "createdDate": "2012-09-06 01:27:26",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 374,
		  "totalCountries": 27,
		  "totalStates": 41,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 1704,
		  "schedulePercent": 0.659111,
		  "totalGuests": 1185,
		  "guestPercent": 0.874433,
		  "mostGuestDate": "2025-06-23 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0eec02891737738830c0ce2514b494e1",
		  
		  "name": "Matthew",
		  "createdDate": "2024-07-05 16:20:01",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 93,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 541,
		  "schedulePercent": 0.331142,
		  "totalGuests": 106,
		  "guestPercent": 0.525385,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0ef48450cba981d0f7e20bf1efcb9868",
		  
		  "name": "Jim",
		  "createdDate": "2012-01-25 05:31:18",
		  "totalOrganizations": 19,
		  "totalTours": 14,
		  "totalDays": 279,
		  "totalCountries": 14,
		  "totalStates": 44,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 552,
		  "guestPercent": 0.744674,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Echo-Plex",
		  "mostGuestCity": "Echo Park",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0efe5c0b1484f6b1552c4028e5b80791",
		  
		  "name": "Mitch",
		  "createdDate": "2023-04-10 18:57:16",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 858,
		  "totalCountries": 20,
		  "totalStates": 68,
		  "totalEvents": 221,
		  "eventPercent": 0.835449,
		  "totalScheduleItems": 2136,
		  "schedulePercent": 0.737761,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "House of Blues San Diego",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f02063a393d59105516c17956d208f2",
		  
		  "name": "Melissa",
		  "createdDate": "2022-08-27 18:23:33",
		  "totalOrganizations": 15,
		  "totalTours": 19,
		  "totalDays": 1443,
		  "totalCountries": 31,
		  "totalStates": 98,
		  "totalEvents": 430,
		  "eventPercent": 0.966002,
		  "totalScheduleItems": 4698,
		  "schedulePercent": 0.94413,
		  "totalGuests": 1572,
		  "guestPercent": 0.916591,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f07e8f85a8325eea33eec9899dac036",
		  
		  "name": " Warnessa ",
		  "createdDate": "2024-01-05 11:42:57",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 155,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 442,
		  "schedulePercent": 0.287738,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f0a9d4724239736d399a921afcc24a0",
		  
		  "name": "Pietari",
		  "createdDate": "2019-05-22 14:05:02",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 471,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Wanaja festival",
		  "mostGuestCity": "HÃ¤meenlinna",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f1cc32407e0146348efa3555a45ba76",
		  
		  "name": "Ryan",
		  "createdDate": "2017-04-19 21:03:46",
		  "totalOrganizations": 15,
		  "totalTours": 6,
		  "totalDays": 158,
		  "totalCountries": 9,
		  "totalStates": 40,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 904,
		  "schedulePercent": 0.459882,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Red Flag",
		  "mostGuestCity": "St. Louis",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f220c34ae6ef90569bf981144f71e2e",
		  
		  "name": "Dorothy",
		  "createdDate": "2022-03-03 17:33:27",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 144,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 713,
		  "schedulePercent": 0.391432,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f2b735d9d579af323640e539762accf",
		  
		  "name": "Jack",
		  "createdDate": "2023-01-20 22:18:55",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 81,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 450,
		  "schedulePercent": 0.290911,
		  "totalGuests": 313,
		  "guestPercent": 0.655372,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f331dd58c0eb90fd933bc1646edc8b3",
		  
		  "name": "Andrew",
		  "createdDate": "2025-03-24 20:58:21",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 76,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 67,
		  "guestPercent": 0.480734,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f36c57a233281d7f3359f90aff934af",
		  
		  "name": "Gary",
		  "createdDate": "2013-06-14 19:29:30",
		  "totalOrganizations": 32,
		  "totalTours": 9,
		  "totalDays": 685,
		  "totalCountries": 8,
		  "totalStates": 56,
		  "totalEvents": 334,
		  "eventPercent": 0.934497,
		  "totalScheduleItems": 5136,
		  "schedulePercent": 0.958409,
		  "totalGuests": 1840,
		  "guestPercent": 0.93529,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "PNC Bank Arts Center",
		  "mostGuestCity": "Holmdel",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f3cda1ee20599463a31c4b8457f89bf",
		  
		  "name": "Rob",
		  "createdDate": "2019-11-05 23:06:17",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 63,
		  "totalCountries": 12,
		  "totalStates": 10,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 440,
		  "schedulePercent": 0.286491,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f4342a55653b59cec0699f7a3c094be",
		  
		  "name": "Mark",
		  "createdDate": "2016-06-15 02:48:56",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 193,
		  "totalCountries": 6,
		  "totalStates": 19,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 943,
		  "schedulePercent": 0.473368,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "The Palms",
		  "mostGuestCity": "Southbank",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f4c1f7ee20f6a84ef6165684d645e7d",
		  
		  "name": "Matt",
		  "createdDate": "2013-05-11 16:01:32",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 26,
		  "totalStates": 27,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 527,
		  "schedulePercent": 0.325136,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f4eef0945035bf0d767ff2c16ae7212",
		  
		  "name": "Max",
		  "createdDate": "2018-04-17 16:34:32",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 365,
		  "totalCountries": 7,
		  "totalStates": 46,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 1663,
		  "schedulePercent": 0.651745,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "The Barns At Wolf Trap",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f5d724a3fb8396983c95615df2f3199",
		  
		  "name": "David",
		  "createdDate": "2014-03-03 00:29:08",
		  "totalOrganizations": 16,
		  "totalTours": 6,
		  "totalDays": 219,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 951,
		  "schedulePercent": 0.475861,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Jacksonville Symphony",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f65c009c196b3eaef4bdda185073a4c",
		  
		  "name": "David",
		  "createdDate": "2022-09-30 01:40:27",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 796,
		  "totalCountries": 8,
		  "totalStates": 55,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 3525,
		  "schedulePercent": 0.8835,
		  "totalGuests": 700,
		  "guestPercent": 0.785925,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Germania Insurance Amphitheater",
		  "mostGuestCity": "Del Valle",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f6fe578137ecdd5d2135c8ffefb6d6b",
		  
		  "name": "Matthew",
		  "createdDate": "2011-05-05 12:19:39",
		  "totalOrganizations": 17,
		  "totalTours": 15,
		  "totalDays": 1286,
		  "totalCountries": 27,
		  "totalStates": 54,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2453,
		  "schedulePercent": 0.781505,
		  "totalGuests": 668,
		  "guestPercent": 0.777199,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Intuit Dome",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f708ee0e885a4736424ae5ed718e9d4",
		  
		  "name": "Jess",
		  "createdDate": "2019-05-08 22:32:04",
		  "totalOrganizations": 11,
		  "totalTours": 23,
		  "totalDays": 1129,
		  "totalCountries": 45,
		  "totalStates": 112,
		  "totalEvents": 430,
		  "eventPercent": 0.966002,
		  "totalScheduleItems": 6319,
		  "schedulePercent": 0.979601,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Teatro Villa de Molina",
		  "mostGuestCity": "Molina de Segura",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f7d4fdb2611750510e7c858b2e2b41e",
		  
		  "name": "Nicholas",
		  "createdDate": "2023-05-21 20:29:23",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 137,
		  "totalCountries": 14,
		  "totalStates": 31,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 864,
		  "schedulePercent": 0.446056,
		  "totalGuests": 955,
		  "guestPercent": 0.839982,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f858d29ede75e98ed6e81748f145ecd",
		  
		  "name": "Wallice",
		  "createdDate": "2021-09-29 18:52:30",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 504,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 677,
		  "schedulePercent": 0.377493,
		  "totalGuests": 399,
		  "guestPercent": 0.694016,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f861e88a07026c2f80945dfffd407f0",
		  
		  "name": "Amanda",
		  "createdDate": "2021-12-17 00:42:24",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 551,
		  "totalCountries": 4,
		  "totalStates": 14,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 501,
		  "schedulePercent": 0.312443,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f8822f8eb8f52ede46db0fe175c1ab9",
		  
		  "name": "Stan",
		  "createdDate": "2024-01-30 22:07:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 34,
		  "totalCountries": 1,
		  "totalStates": 4,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 118,
		  "schedulePercent": 0.109587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f8f9d43a16516baf88cd3cb8f9e4272",
		  
		  "name": "Alexia ",
		  "createdDate": "2025-03-26 18:43:19",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 253,
		  "schedulePercent": 0.191976,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "713 Music Hall",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f92d506efd6c516e096f8d8e69f31ab",
		  
		  "name": "Emily",
		  "createdDate": "2025-07-07 15:49:57",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 385,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 573,
		  "schedulePercent": 0.340888,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Kiri Te Kanawa Theatre, Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0f98ca01a4212e4a7730bf2b7ac7d24d",
		  
		  "name": "Jeff",
		  "createdDate": "2014-07-24 10:36:13",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 54,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 217,
		  "schedulePercent": 0.170104,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Fox Theater",
		  "mostGuestCity": "Oakland",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fb56111da2d19ae53c1be9ca323a209",
		  
		  "name": "Austin",
		  "createdDate": "2023-03-25 17:30:06",
		  "totalOrganizations": 6,
		  "totalTours": 33,
		  "totalDays": 346,
		  "totalCountries": 25,
		  "totalStates": 43,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1715,
		  "schedulePercent": 0.661151,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-01-21 00:00:00",
		  "mostGuestName": "The Crocodile",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fb5bbc1e152a7ab1ffe77c14b78d897",
		  
		  "name": "Adrian",
		  "createdDate": "2016-05-04 02:07:36",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 57,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 411,
		  "schedulePercent": 0.274365,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fc13bddcba817527a845bc8811f8997",
		  
		  "name": "Michael",
		  "createdDate": "2014-02-13 21:50:25",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 195,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1015,
		  "schedulePercent": 0.494674,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fcabec7ee93e4e2676cbf03db127f24",
		  
		  "name": "Julian",
		  "createdDate": "2019-01-26 15:09:14",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 1364,
		  "totalCountries": 16,
		  "totalStates": 56,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 3733,
		  "schedulePercent": 0.898005,
		  "totalGuests": 522,
		  "guestPercent": 0.736627,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Diamante de BÃ©isbol - Sede de los Living Conciertos",
		  "mostGuestCity": "Cali",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fcc0f8ff47c0af70f6c8bbf499362d6",
		  
		  "name": "james ",
		  "createdDate": "2022-01-13 13:51:03",
		  "totalOrganizations": 18,
		  "totalTours": 37,
		  "totalDays": 317,
		  "totalCountries": 16,
		  "totalStates": 23,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 2077,
		  "schedulePercent": 0.728694,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fcd16574c8b4b9cefa20ca4041accc9",
		  
		  "name": "Jackson",
		  "createdDate": "2018-03-16 15:06:33",
		  "totalOrganizations": 14,
		  "totalTours": 23,
		  "totalDays": 793,
		  "totalCountries": 22,
		  "totalStates": 79,
		  "totalEvents": 445,
		  "eventPercent": 0.969288,
		  "totalScheduleItems": 4976,
		  "schedulePercent": 0.953649,
		  "totalGuests": 1587,
		  "guestPercent": 0.918178,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Electric Ballroom",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fd79a5cc9564bcbaf1e815c0e532187",
		  
		  "name": "Harley ",
		  "createdDate": "2024-11-27 16:01:46",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 350,
		  "totalCountries": 15,
		  "totalStates": 16,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1238,
		  "schedulePercent": 0.556664,
		  "totalGuests": 351,
		  "guestPercent": 0.675317,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Scala",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fd82750a8673c23a404babe81a8b7d4",
		  
		  "name": "Reuben",
		  "createdDate": "2022-01-12 06:21:38",
		  "totalOrganizations": 14,
		  "totalTours": 17,
		  "totalDays": 898,
		  "totalCountries": 22,
		  "totalStates": 54,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 1982,
		  "schedulePercent": 0.709995,
		  "totalGuests": 284,
		  "guestPercent": 0.641206,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Tsutaya O-East",
		  "mostGuestCity": "Shibuya-ku",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fe5d7cdd0f5535d0472cad8fb5875c7",
		  
		  "name": "Sasha",
		  "createdDate": "2024-01-23 03:06:36",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 498,
		  "totalCountries": 12,
		  "totalStates": 25,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 605,
		  "schedulePercent": 0.352675,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "0fe968bd17f076293a364f6107cd4d3e",
		  
		  "name": "Hayley",
		  "createdDate": "2023-04-07 15:02:43",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 569,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1965,
		  "schedulePercent": 0.706482,
		  "totalGuests": 2619,
		  "guestPercent": 0.972688,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1005bf03c0abd88b00a938dc63e8004f",
		  
		  "name": "Micaela",
		  "createdDate": "2022-06-06 16:22:13",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 201,
		  "totalCountries": 17,
		  "totalStates": 43,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1016,
		  "schedulePercent": 0.49524,
		  "totalGuests": 365,
		  "guestPercent": 0.679624,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "100fa99c11ca6570c49fc99dfbdc2751",
		  
		  "name": "Evelyne",
		  "createdDate": "2022-04-05 20:52:02",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 231,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 1543,
		  "schedulePercent": 0.625907,
		  "totalGuests": 5073,
		  "guestPercent": 0.99762,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 675,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10115cfe9886a54e73d406fa4c033ce3",
		  
		  "name": "Peter",
		  "createdDate": "2018-10-22 12:29:41",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 496,
		  "totalCountries": 24,
		  "totalStates": 27,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1742,
		  "schedulePercent": 0.665911,
		  "totalGuests": 432,
		  "guestPercent": 0.706936,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "101171b93acbd9744e69c5b25433bb76",
		  
		  "name": "Ryan",
		  "createdDate": "2024-01-23 13:39:17",
		  "totalOrganizations": 13,
		  "totalTours": 23,
		  "totalDays": 1114,
		  "totalCountries": 28,
		  "totalStates": 70,
		  "totalEvents": 260,
		  "eventPercent": 0.881573,
		  "totalScheduleItems": 3274,
		  "schedulePercent": 0.866274,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-06-09 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10130c456bf556b3d6a58a250e80be2b",
		  
		  "name": "Anthony",
		  "createdDate": "2012-11-12 18:51:38",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 193,
		  "totalCountries": 16,
		  "totalStates": 46,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 2089,
		  "schedulePercent": 0.730394,
		  "totalGuests": 1663,
		  "guestPercent": 0.925317,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "101eccbc728f61794b4149e888b52a0d",
		  
		  "name": "Scott",
		  "createdDate": "2019-12-09 19:44:49",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 469,
		  "totalCountries": 37,
		  "totalStates": 33,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1985,
		  "schedulePercent": 0.710449,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-01-21 00:00:00",
		  "mostGuestName": "The Crocodile",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "102b133bd5d3f033fbc3fa5d9063fd68",
		  
		  "name": "Ashleigh",
		  "createdDate": "2023-01-04 17:53:15",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 639,
		  "totalCountries": 6,
		  "totalStates": 28,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1078,
		  "schedulePercent": 0.513146,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "102e451386b63b526f99afdebbd02e11",
		  
		  "name": "Brian",
		  "createdDate": "2023-07-04 01:47:54",
		  "totalOrganizations": 1,
		  "totalTours": 22,
		  "totalDays": 88,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 428,
		  "schedulePercent": 0.281505,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1030d0f5f165cd928694d941acb0311c",
		  
		  "name": "Alexandra",
		  "createdDate": "2022-06-27 16:54:43",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 148,
		  "totalCountries": 19,
		  "totalStates": 39,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 1395,
		  "schedulePercent": 0.596668,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1033950c037c451a17bb47adedcc0d50",
		  
		  "name": "Daniel ",
		  "createdDate": "2017-06-16 01:47:24",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 445,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 819,
		  "schedulePercent": 0.430304,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1040d2b1ec0854b7e98dc72458e7cf5e",
		  
		  "name": "Ulrich",
		  "createdDate": "2023-01-20 16:23:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 326,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 526,
		  "schedulePercent": 0.324683,
		  "totalGuests": 415,
		  "guestPercent": 0.699456,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Elbphilharmonie",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1046ae7d51f8a21332546d079d8bdd4c",
		  
		  "name": "Roland",
		  "createdDate": "2012-04-03 08:12:34",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 266,
		  "totalCountries": 15,
		  "totalStates": 19,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1515,
		  "schedulePercent": 0.620694,
		  "totalGuests": 2043,
		  "guestPercent": 0.949796,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1057d6d4b26aa62f05ee54dd0910db64",
		  
		  "name": "Robert",
		  "createdDate": "2025-10-30 00:23:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 50,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 179,
		  "schedulePercent": 0.145852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1067de23175619402b18a8593e15caca",
		  
		  "name": "JP",
		  "createdDate": "2023-01-05 12:29:20",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-22 00:00:00",
		  "mostGuestName": "Red Wing Roots Music Festival",
		  "mostGuestCity": "Mt Solon",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "106b330dbd79330153a866e8767602f8",
		  
		  "name": "Abby",
		  "createdDate": "2025-03-05 16:35:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 66,
		  "totalCountries": 10,
		  "totalStates": 18,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 383,
		  "schedulePercent": 0.259859,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Baby's All Right",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "106c1fc2512fe28c744101a28e34c073",
		  
		  "name": "Michael",
		  "createdDate": "2019-04-17 17:37:18",
		  "totalOrganizations": 14,
		  "totalTours": 12,
		  "totalDays": 664,
		  "totalCountries": 25,
		  "totalStates": 49,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 4718,
		  "schedulePercent": 0.94515,
		  "totalGuests": 2100,
		  "guestPercent": 0.954216,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "108089cd0a4544e1da9d6f40164f5823",
		  
		  "name": "Matthew",
		  "createdDate": "2021-07-21 22:27:03",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 220,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1038,
		  "schedulePercent": 0.500793,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "108ba3a9cd5b064f3bd924eb1b70b523",
		  
		  "name": "Alexander",
		  "createdDate": "2025-03-03 10:06:18",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 34,
		  "totalCountries": 4,
		  "totalStates": 1,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 113,
		  "schedulePercent": 0.106754,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10977abd1bab5cf2e793677f9ff305bc",
		  
		  "name": "Caspar",
		  "createdDate": "2022-12-28 18:21:04",
		  "totalOrganizations": 28,
		  "totalTours": 8,
		  "totalDays": 506,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 976,
		  "schedulePercent": 0.483114,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "109894bc4d9c5b0515a5781748447cad",
		  
		  "name": "C",
		  "createdDate": "2022-02-18 00:41:45",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 64,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 278,
		  "schedulePercent": 0.204216,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "Blue Note Tokyo",
		  "mostGuestCity": "Minato-ku",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "109b42fc1465d1bffe947d519e6ee76a",
		  
		  "name": "Ben",
		  "createdDate": "2014-05-28 21:27:40",
		  "totalOrganizations": 15,
		  "totalTours": 23,
		  "totalDays": 494,
		  "totalCountries": 23,
		  "totalStates": 61,
		  "totalEvents": 244,
		  "eventPercent": 0.86514,
		  "totalScheduleItems": 5210,
		  "schedulePercent": 0.959995,
		  "totalGuests": 2198,
		  "guestPercent": 0.957729,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Cardiff Utilita Arena",
		  "mostGuestCity": "Cardiff",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "109ccd0a6d60c42c43a9b47eac9470eb",
		  
		  "name": "Anthony",
		  "createdDate": "2018-02-16 22:07:20",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1377,
		  "schedulePercent": 0.592022,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Bayfront Festival Park",
		  "mostGuestCity": "Duluth",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10a7f9bb59e128e6ed2676b180fceeb8",
		  
		  "name": "Sandbox",
		  "createdDate": "2015-10-13 21:42:31",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 828,
		  "totalCountries": 17,
		  "totalStates": 52,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2690,
		  "schedulePercent": 0.80791,
		  "totalGuests": 1049,
		  "guestPercent": 0.854148,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10aa264e8df72a261e7899f429652b02",
		  
		  "name": "Fran",
		  "createdDate": "2016-05-19 00:02:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 31,
		  "totalStates": 6,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1351,
		  "schedulePercent": 0.585222,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10ab1fdef39def8a2057e395824187f0",
		  
		  "name": "Juanjo",
		  "createdDate": "2024-06-21 13:00:07",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 119,
		  "totalCountries": 23,
		  "totalStates": 23,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 679,
		  "schedulePercent": 0.378626,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-02-17 00:00:00",
		  "mostGuestName": "La Machine du Moulin Rouge",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10b1307aaf0d8359ea500d6fae29b4e4",
		  
		  "name": "Jonny",
		  "createdDate": "2015-07-15 21:55:49",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 104,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 651,
		  "schedulePercent": 0.36786,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10b1a29c766c6202bd6e95238d0c20b2",
		  
		  "name": "BRYAN",
		  "createdDate": "2018-09-06 03:52:52",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 230,
		  "totalCountries": 10,
		  "totalStates": 47,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1387,
		  "schedulePercent": 0.594175,
		  "totalGuests": 393,
		  "guestPercent": 0.691296,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "Radio City Music Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10ba30d33e78dbaf1d9d1b9fd8a4d901",
		  
		  "name": "Lawrence",
		  "createdDate": "2022-11-29 23:13:48",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 1115,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 300,
		  "schedulePercent": 0.217475,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Kiri Te Kanawa Theatre, Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10bfe7185069b7c01d8dabe0dbd416a9",
		  
		  "name": "Justin",
		  "createdDate": "2022-08-07 06:59:40",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 105,
		  "totalCountries": 11,
		  "totalStates": 12,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 215,
		  "schedulePercent": 0.169198,
		  "totalGuests": 46,
		  "guestPercent": 0.446623,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Yaamava' Resort & Casino",
		  "mostGuestCity": "Highland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10c9f4b2b7e44ddece71e6e49d4e96fc",
		  
		  "name": "Seth",
		  "createdDate": "2024-06-18 20:53:09",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 669,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1788,
		  "schedulePercent": 0.674411,
		  "totalGuests": 545,
		  "guestPercent": 0.74218,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10cbf21ef7d51cb71aa1db0f57cffeff",
		  
		  "name": "Jesse",
		  "createdDate": "2025-07-15 03:22:00",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 35,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 300,
		  "guestPercent": 0.649705,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Gas South Arena",
		  "mostGuestCity": "Duluth",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10d3986af17f9acba22f8c79b5a77bdc",
		  
		  "name": "Stokley",
		  "createdDate": "2025-07-11 04:57:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10d426fdb63a738fa048f286d5b9226c",
		  
		  "name": "Lindsay ",
		  "createdDate": "2015-05-11 19:50:07",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 432,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-06-02 00:00:00",
		  "mostGuestName": "Austin City Limits Live (ACL Live & 3TEN ACL Live)",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10d6a5eac339c98cafd7db5509b06898",
		  
		  "name": "Kris",
		  "createdDate": "2014-01-12 22:18:31",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 517,
		  "totalCountries": 10,
		  "totalStates": 50,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2237,
		  "schedulePercent": 0.753626,
		  "totalGuests": 108,
		  "guestPercent": 0.527199,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "AT&T Stadium",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10d7159273daaea45330d02624180601",
		  
		  "name": "Sarah",
		  "createdDate": "2017-11-01 17:58:10",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 114,
		  "totalCountries": 6,
		  "totalStates": 10,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 832,
		  "schedulePercent": 0.435177,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10dca55d7704a4db00248a095ed87790",
		  
		  "name": "Stefano",
		  "createdDate": "2019-02-04 14:50:25",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 160,
		  "totalCountries": 25,
		  "totalStates": 43,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1937,
		  "schedulePercent": 0.701609,
		  "totalGuests": 1375,
		  "guestPercent": 0.896645,
		  "mostGuestDate": "2025-06-16 00:00:00",
		  "mostGuestName": "Cavea Auditorium",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10e42f10b535750c6e06047616ca0e5d",
		  
		  "name": "Joshua",
		  "createdDate": "2021-07-22 23:48:22",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 290,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 282,
		  "schedulePercent": 0.206936,
		  "totalGuests": 110,
		  "guestPercent": 0.528105,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "TSB Bank Arena",
		  "mostGuestCity": "Wellington",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10e7dd83eb8505bd1db30884a4e49106",
		  
		  "name": "William",
		  "createdDate": "2013-07-03 13:28:55",
		  "totalOrganizations": 13,
		  "totalTours": 30,
		  "totalDays": 874,
		  "totalCountries": 8,
		  "totalStates": 59,
		  "totalEvents": 306,
		  "eventPercent": 0.916251,
		  "totalScheduleItems": 4216,
		  "schedulePercent": 0.927017,
		  "totalGuests": 1971,
		  "guestPercent": 0.945036,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10f0f9d71ab4534c14e4d6c5ade7662a",
		  
		  "name": "Lewis",
		  "createdDate": "2016-02-24 19:06:18",
		  "totalOrganizations": 24,
		  "totalTours": 15,
		  "totalDays": 298,
		  "totalCountries": 23,
		  "totalStates": 37,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 1930,
		  "schedulePercent": 0.700023,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10f1b4b730958ffaf10a89bcad06be7c",
		  
		  "name": "Jack",
		  "createdDate": "2024-07-30 14:43:39",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 651,
		  "totalCountries": 4,
		  "totalStates": 22,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 446,
		  "schedulePercent": 0.289098,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Mercury Lounge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "10fd63c63fb2ee229087376fb38626b8",
		  
		  "name": "Connor",
		  "createdDate": "2017-05-24 10:07:12",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 486,
		  "totalCountries": 11,
		  "totalStates": 43,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 2585,
		  "schedulePercent": 0.796238,
		  "totalGuests": 1119,
		  "guestPercent": 0.866727,
		  "mostGuestDate": "2025-05-11 00:00:00",
		  "mostGuestName": "",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "110386e185ddc5b3d6ccfc38b57e61cd",
		  
		  "name": "Filip",
		  "createdDate": "2024-04-26 19:15:51",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 192,
		  "totalCountries": 27,
		  "totalStates": 31,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 729,
		  "schedulePercent": 0.397665,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Borgholms Slott",
		  "mostGuestCity": "Borgholm",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "110e5bfe485213c45ae7b849e50a1d10",
		  
		  "name": "Roxanne",
		  "createdDate": "2014-07-21 02:25:15",
		  "totalOrganizations": 7,
		  "totalTours": 54,
		  "totalDays": 912,
		  "totalCountries": 6,
		  "totalStates": 15,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1455,
		  "schedulePercent": 0.608341,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11194a88e5d2a4eb68a47e828facf154",
		  
		  "name": "Justin",
		  "createdDate": "2025-04-09 14:32:48",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 269,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 318,
		  "schedulePercent": 0.225748,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11259d35d316146fd2ced1ef06b18416",
		  
		  "name": "Ben ",
		  "createdDate": "2025-02-17 18:48:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 50,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 419,
		  "schedulePercent": 0.278105,
		  "totalGuests": 229,
		  "guestPercent": 0.612194,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11280b79e95df39fcb74beaa3ee7e0d9",
		  
		  "name": "Ash",
		  "createdDate": "2018-01-31 20:38:54",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 406,
		  "totalCountries": 24,
		  "totalStates": 75,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 2981,
		  "schedulePercent": 0.840889,
		  "totalGuests": 1043,
		  "guestPercent": 0.853241,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "112aae20fba28c3a34994481d56fa2d0",
		  
		  "name": "Will",
		  "createdDate": "2014-07-25 19:04:50",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 373,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 928,
		  "schedulePercent": 0.467928,
		  "totalGuests": 914,
		  "guestPercent": 0.833069,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 263,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "112e866c005a873ccd51df3f92a8874c",
		  
		  "name": "Rob",
		  "createdDate": "2022-02-10 16:59:53",
		  "totalOrganizations": 18,
		  "totalTours": 25,
		  "totalDays": 655,
		  "totalCountries": 28,
		  "totalStates": 100,
		  "totalEvents": 417,
		  "eventPercent": 0.962715,
		  "totalScheduleItems": 4954,
		  "schedulePercent": 0.952743,
		  "totalGuests": 1365,
		  "guestPercent": 0.895626,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11360bd26922cf1483ca99fc8632ab90",
		  
		  "name": "Ryan",
		  "createdDate": "2014-09-03 00:24:37",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 928,
		  "totalCountries": 5,
		  "totalStates": 50,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 3158,
		  "schedulePercent": 0.856074,
		  "totalGuests": 111,
		  "guestPercent": 0.529125,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Pioneer Courthouse Square",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11378d4331e3a7eb49bd98f65b0bd3db",
		  
		  "name": "Nina",
		  "createdDate": "2022-04-17 07:34:05",
		  "totalOrganizations": 14,
		  "totalTours": 37,
		  "totalDays": 446,
		  "totalCountries": 22,
		  "totalStates": 52,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2253,
		  "schedulePercent": 0.755213,
		  "totalGuests": 492,
		  "guestPercent": 0.728015,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11413686697e345b27fa0fc33e4686e7",
		  
		  "name": "Michael",
		  "createdDate": "2017-04-27 10:24:05",
		  "totalOrganizations": 15,
		  "totalTours": 12,
		  "totalDays": 815,
		  "totalCountries": 26,
		  "totalStates": 42,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 877,
		  "schedulePercent": 0.450136,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "114e5047b766296f043ef05b885dfb27",
		  
		  "name": "Michael",
		  "createdDate": "2022-04-26 21:17:25",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 328,
		  "totalCountries": 23,
		  "totalStates": 59,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 2128,
		  "schedulePercent": 0.736287,
		  "totalGuests": 1603,
		  "guestPercent": 0.920218,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "115f5c712ca0b8724d3ad7e25f54cb70",
		  
		  "name": "Helle",
		  "createdDate": "2024-03-25 18:29:30",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 114,
		  "totalCountries": 8,
		  "totalStates": 2,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "116726b323a9037491fa73a950ef940c",
		  
		  "name": "Jimmy",
		  "createdDate": "2021-10-15 01:56:52",
		  "totalOrganizations": 13,
		  "totalTours": 23,
		  "totalDays": 552,
		  "totalCountries": 26,
		  "totalStates": 75,
		  "totalEvents": 274,
		  "eventPercent": 0.894719,
		  "totalScheduleItems": 3209,
		  "schedulePercent": 0.860721,
		  "totalGuests": 2238,
		  "guestPercent": 0.959429,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "The Met Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11829ef08c21592e17689d55f05f81c0",
		  
		  "name": "Sara Lily",
		  "createdDate": "2025-04-24 17:38:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 120,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 475,
		  "schedulePercent": 0.300091,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1184abb56587cb7304656b8c9c85e5da",
		  
		  "name": "Mary Isabelle",
		  "createdDate": "2024-01-15 14:10:02",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 545,
		  "totalCountries": 37,
		  "totalStates": 94,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 2385,
		  "schedulePercent": 0.773232,
		  "totalGuests": 164,
		  "guestPercent": 0.569016,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Borgholms Slott",
		  "mostGuestCity": "Borgholm",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "118728a23ef50731aa3cd9cbe3dd3d54",
		  
		  "name": "Artist ",
		  "createdDate": "2022-01-24 19:57:38",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 2070,
		  "totalCountries": 23,
		  "totalStates": 56,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 4124,
		  "schedulePercent": 0.920558,
		  "totalGuests": 1290,
		  "guestPercent": 0.884406,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1194ec7609a05578ce5813fb1a5ce482",
		  
		  "name": "Stefan",
		  "createdDate": "2022-06-28 04:37:31",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 111,
		  "totalCountries": 5,
		  "totalStates": 14,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 411,
		  "schedulePercent": 0.274365,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11a700a2a9c18d1c4f9c798283d8d768",
		  
		  "name": "Aymeric",
		  "createdDate": "2018-05-09 18:04:00",
		  "totalOrganizations": 30,
		  "totalTours": 15,
		  "totalDays": 1436,
		  "totalCountries": 12,
		  "totalStates": 38,
		  "totalEvents": 403,
		  "eventPercent": 0.959429,
		  "totalScheduleItems": 5318,
		  "schedulePercent": 0.962942,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Paradiso",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11b8f57c7b7fed954d92267c3e41ee46",
		  
		  "name": "Scott",
		  "createdDate": "2016-06-24 19:56:38",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 45,
		  "totalCountries": 7,
		  "totalStates": 9,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 266,
		  "schedulePercent": 0.197076,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11c2061b9aa7b3329756919374c2a62a",
		  
		  "name": "Rob",
		  "createdDate": "2016-05-11 21:50:09",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 247,
		  "totalCountries": 15,
		  "totalStates": 35,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1144,
		  "schedulePercent": 0.532638,
		  "totalGuests": 567,
		  "guestPercent": 0.748413,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wythenshawe Park and Gardens",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11c3149a77a81f056becb084e728b79f",
		  
		  "name": "Benjamin",
		  "createdDate": "2019-04-11 19:46:36",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 337,
		  "totalCountries": 8,
		  "totalStates": 22,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2056,
		  "schedulePercent": 0.724841,
		  "totalGuests": 2259,
		  "guestPercent": 0.960335,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Wiener Stadthalle",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11cab6977e00e1b9978411291318ec36",
		  
		  "name": "Patrick",
		  "createdDate": "2021-06-17 13:43:31",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 311,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 715,
		  "schedulePercent": 0.392112,
		  "totalGuests": 159,
		  "guestPercent": 0.56573,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "House of Blues - Chicago",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11d036bb5ab3a2556a6d134f35d73297",
		  
		  "name": "Chris ",
		  "createdDate": "2018-03-27 21:44:16",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 447,
		  "totalCountries": 6,
		  "totalStates": 46,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 931,
		  "schedulePercent": 0.469402,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Cobra Lounge",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11d6f06c65db46cb0cb89b79d970649c",
		  
		  "name": "Thorsten",
		  "createdDate": "2016-10-10 11:11:33",
		  "totalOrganizations": 115,
		  "totalTours": 41,
		  "totalDays": 776,
		  "totalCountries": 24,
		  "totalStates": 60,
		  "totalEvents": 308,
		  "eventPercent": 0.917271,
		  "totalScheduleItems": 2835,
		  "schedulePercent": 0.826269,
		  "totalGuests": 609,
		  "guestPercent": 0.761559,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Stadtpark",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11e8ea59542c44f37a7e0db8aa0d97fd",
		  
		  "name": "Lauren",
		  "createdDate": "2020-02-20 21:28:24",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 551,
		  "totalCountries": 27,
		  "totalStates": 37,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 2644,
		  "schedulePercent": 0.802244,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "11fa7cec06367ce9ad28552f6ddea9a1",
		  
		  "name": "Charity",
		  "createdDate": "2022-09-03 04:38:35",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 395,
		  "totalCountries": 11,
		  "totalStates": 34,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1698,
		  "schedulePercent": 0.658318,
		  "totalGuests": 296,
		  "guestPercent": 0.647665,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Champion Forest Baptist Church - Champions Campus",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12157cf4afd1a9f3564560e9d511fc00",
		  
		  "name": "Middle8",
		  "createdDate": "2015-10-28 08:22:10",
		  "totalOrganizations": 22,
		  "totalTours": 8,
		  "totalDays": 165,
		  "totalCountries": 5,
		  "totalStates": 45,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 654,
		  "schedulePercent": 0.368994,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Le Poisson Rouge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "121d46e3e82f42355289ed7dbe64b3f2",
		  
		  "name": "Andrew",
		  "createdDate": "2024-09-10 14:27:25",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 247,
		  "totalCountries": 17,
		  "totalStates": 58,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 1976,
		  "schedulePercent": 0.708975,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Red Flag",
		  "mostGuestCity": "St. Louis",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1227987aff4fdbc9bcf72a920f076e0d",
		  
		  "name": "Mark",
		  "createdDate": "2012-01-05 23:44:35",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 284,
		  "schedulePercent": 0.208862,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "124011613ccc3b39f4ba9eacc1e8ac81",
		  
		  "name": "Bryan",
		  "createdDate": "2009-09-17 20:39:50",
		  "totalOrganizations": 35,
		  "totalTours": 31,
		  "totalDays": 3839,
		  "totalCountries": 50,
		  "totalStates": 99,
		  "totalEvents": 542,
		  "eventPercent": 0.983454,
		  "totalScheduleItems": 10075,
		  "schedulePercent": 0.99694,
		  "totalGuests": 2099,
		  "guestPercent": 0.953989,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "Barclays Center",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 178,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "125186568fee375d70c38aa1a54b1559",
		  
		  "name": "Clothilde",
		  "createdDate": "2025-01-20 16:43:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 7,
		  "totalStates": 13,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 236,
		  "schedulePercent": 0.182344,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Le Bikini",
		  "mostGuestCity": "Ramonville-Saint-Agne",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1251c116ead50ae420b9b6bbf4c33cad",
		  
		  "name": "Matt",
		  "createdDate": "2014-02-20 22:10:23",
		  "totalOrganizations": 20,
		  "totalTours": 5,
		  "totalDays": 364,
		  "totalCountries": 16,
		  "totalStates": 22,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 657,
		  "schedulePercent": 0.370354,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "FÃ¥llan",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1254bb9a399cc65c61e3666e5d927e35",
		  
		  "name": "Nathalie",
		  "createdDate": "2017-09-07 15:01:25",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 526,
		  "totalCountries": 20,
		  "totalStates": 59,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 5848,
		  "schedulePercent": 0.973481,
		  "totalGuests": 190,
		  "guestPercent": 0.585902,
		  "mostGuestDate": "2025-03-31 00:00:00",
		  "mostGuestName": "The Danforth Music Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "126221528fd1b1a3cc7cc55e5512b915",
		  
		  "name": "Thomas",
		  "createdDate": "2025-02-21 02:17:14",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 46,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 159,
		  "schedulePercent": 0.134519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1274127a9094f430e75b61eb51903696",
		  
		  "name": "Tia",
		  "createdDate": "2022-12-28 04:52:51",
		  "totalOrganizations": 2,
		  "totalTours": 36,
		  "totalDays": 566,
		  "totalCountries": 18,
		  "totalStates": 37,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 2464,
		  "schedulePercent": 0.782865,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Ocean Resort Casino - Ovation Hall",
		  "mostGuestCity": "Atlantic City",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "127e2d4dfdbc692f51016cdbc54f76e3",
		  
		  "name": "Amanda",
		  "createdDate": "2024-06-13 18:53:24",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 400,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1792,
		  "schedulePercent": 0.675317,
		  "totalGuests": 686,
		  "guestPercent": 0.782298,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "St. Augustine Amphitheatre",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1286455cf7282aa2d7313786bdb5c435",
		  
		  "name": "Lo",
		  "createdDate": "2025-06-28 11:56:53",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 69,
		  "totalCountries": 13,
		  "totalStates": 9,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 300,
		  "schedulePercent": 0.217475,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "Sun Splash Festival",
		  "mostGuestCity": "Vreeswijkstraat",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1289dafe18933eddf35a0ba766f38c36",
		  
		  "name": "Jeremy ",
		  "createdDate": "2022-12-23 23:28:07",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 202,
		  "totalCountries": 11,
		  "totalStates": 35,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1609,
		  "schedulePercent": 0.641999,
		  "totalGuests": 1669,
		  "guestPercent": 0.925884,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Freo.Social",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "129e9b447be64f59d8d9de040dd55303",
		  
		  "name": "Amanda",
		  "createdDate": "2018-03-05 18:20:34",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 444,
		  "totalCountries": 25,
		  "totalStates": 28,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1923,
		  "schedulePercent": 0.698436,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12a7fe3f7a3f13a1b7bff37133b9fd38",
		  
		  "name": "Mike",
		  "createdDate": "2023-04-19 02:26:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 919,
		  "schedulePercent": 0.464415,
		  "totalGuests": 413,
		  "guestPercent": 0.698663,
		  "mostGuestDate": "2025-02-11 00:00:00",
		  "mostGuestName": "Benaroya Hall",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12adfa43e2ac0952eb172040425599fe",
		  
		  "name": "Jon",
		  "createdDate": "2020-02-06 01:17:14",
		  "totalOrganizations": 7,
		  "totalTours": 29,
		  "totalDays": 879,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 2346,
		  "schedulePercent": 0.767452,
		  "totalGuests": 1312,
		  "guestPercent": 0.887919,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12b744fb8502e6a8d9189c419898cbcb",
		  
		  "name": "Bryan",
		  "createdDate": "2024-09-12 16:21:18",
		  "totalOrganizations": 2,
		  "totalTours": 13,
		  "totalDays": 424,
		  "totalCountries": 16,
		  "totalStates": 56,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 2451,
		  "schedulePercent": 0.781165,
		  "totalGuests": 784,
		  "guestPercent": 0.80417,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12b90ccbccd92d645390e54a9513453a",
		  
		  "name": "Marcus",
		  "createdDate": "2023-05-05 09:42:29",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 166,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1562,
		  "schedulePercent": 0.633046,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12bbcc24509f05ea003797c14a9e3318",
		  
		  "name": "Kelly",
		  "createdDate": "2018-05-25 18:41:11",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1003,
		  "schedulePercent": 0.490934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12c4c1e2147d72ee9e374564005de049",
		  
		  "name": "Tyler",
		  "createdDate": "2023-08-10 07:53:05",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 41,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 276,
		  "schedulePercent": 0.202969,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-11-05 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12ceff29fb69e753e65ff9d29dae89a5",
		  
		  "name": "Tiona",
		  "createdDate": "2024-10-06 19:47:59",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 131,
		  "totalCountries": 8,
		  "totalStates": 22,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 737,
		  "schedulePercent": 0.400272,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12da9f5cb37f2f291a5ab5064444966e",
		  
		  "name": "Josh",
		  "createdDate": "2015-02-22 14:25:11",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 98,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 810,
		  "schedulePercent": 0.427131,
		  "totalGuests": 553,
		  "guestPercent": 0.7449,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12dd22b528c1c6c9c73f7c7a5f5d8981",
		  
		  "name": "Spike",
		  "createdDate": "2017-05-30 23:49:00",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 207,
		  "totalCountries": 17,
		  "totalStates": 52,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1212,
		  "schedulePercent": 0.549637,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-05-06 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12ddc6a8208463b9363acdbe144372b6",
		  
		  "name": "Clayton",
		  "createdDate": "2022-02-07 23:54:08",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 750,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1066,
		  "schedulePercent": 0.508726,
		  "totalGuests": 185,
		  "guestPercent": 0.583069,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Freo Social",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12f4f30f73171f68c03b3af4a7c2a0cf",
		  
		  "name": "Carol",
		  "createdDate": "2015-08-11 17:41:55",
		  "totalOrganizations": 17,
		  "totalTours": 10,
		  "totalDays": 287,
		  "totalCountries": 20,
		  "totalStates": 37,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 1372,
		  "schedulePercent": 0.590095,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "12ff13f6081dbf833a7ea659a1a9f425",
		  
		  "name": "Erwin",
		  "createdDate": "2018-10-04 12:15:19",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 979,
		  "totalCountries": 19,
		  "totalStates": 36,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1045,
		  "schedulePercent": 0.502493,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "130a18b7f4132a7aa4717be8285b3510",
		  
		  "name": "Gon&#231;alo",
		  "createdDate": "2025-04-05 22:14:21",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 223,
		  "schedulePercent": 0.173051,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "131ef1a46e085c8157fb0a4c746232c6",
		  
		  "name": "Christy",
		  "createdDate": "2009-09-09 01:35:46",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 234,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1064,
		  "schedulePercent": 0.507593,
		  "totalGuests": 965,
		  "guestPercent": 0.840435,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13203f8b0ea0436c8c2f4ac503a4fdb5",
		  
		  "name": "Svenja",
		  "createdDate": "2018-10-05 22:23:39",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 154,
		  "totalCountries": 18,
		  "totalStates": 24,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 1221,
		  "schedulePercent": 0.552924,
		  "totalGuests": 139,
		  "guestPercent": 0.551677,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "La Seine Musicale",
		  "mostGuestCity": "Boulogne-Billancourt",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "132709f2d93a0f920100cf2c5b5394ee",
		  
		  "name": "Kelli",
		  "createdDate": "2025-03-27 18:27:06",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 108,
		  "totalCountries": 5,
		  "totalStates": 20,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 228,
		  "schedulePercent": 0.176451,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "133a3440207d50aa42494438354c87d0",
		  
		  "name": "Joel",
		  "createdDate": "2013-01-02 21:59:59",
		  "totalOrganizations": 14,
		  "totalTours": 39,
		  "totalDays": 1316,
		  "totalCountries": 30,
		  "totalStates": 69,
		  "totalEvents": 474,
		  "eventPercent": 0.974388,
		  "totalScheduleItems": 5851,
		  "schedulePercent": 0.973821,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13482e3267ea76a108e273cea9b52c64",
		  
		  "name": "Isaiah",
		  "createdDate": "2022-04-05 21:58:58",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 315,
		  "totalCountries": 14,
		  "totalStates": 48,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 3521,
		  "schedulePercent": 0.883046,
		  "totalGuests": 1574,
		  "guestPercent": 0.916818,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "135604d6cd26efe7290aafab8f69b275",
		  
		  "name": "BRANDON",
		  "createdDate": "2016-02-25 23:04:53",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 355,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 551,
		  "schedulePercent": 0.334655,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "MacKinnon Brothers Brewing Company",
		  "mostGuestCity": "Bath",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "135727f91979077a4895501b04fcea20",
		  
		  "name": "Nele",
		  "createdDate": "2025-10-31 14:21:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1368fdda437bd668737d4313c585fbc1",
		  
		  "name": "Daniel",
		  "createdDate": "2025-07-14 17:16:50",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 315,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 18,
		  "schedulePercent": 0.0286718,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "136cee6a13ec754ba8ce6722ca25d513",
		  
		  "name": "Holly",
		  "createdDate": "2022-11-09 10:28:22",
		  "totalOrganizations": 67,
		  "totalTours": 72,
		  "totalDays": 5765,
		  "totalCountries": 25,
		  "totalStates": 51,
		  "totalEvents": 1485,
		  "eventPercent": 0.99864,
		  "totalScheduleItems": 9711,
		  "schedulePercent": 0.996374,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "The Marlowe",
		  "mostGuestCity": "Canterbury",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "137102f7968d9a0f95ec12f7bb6c9bec",
		  
		  "name": "Mike",
		  "createdDate": "2010-07-05 18:26:42",
		  "totalOrganizations": 18,
		  "totalTours": 14,
		  "totalDays": 277,
		  "totalCountries": 21,
		  "totalStates": 44,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1135,
		  "schedulePercent": 0.529805,
		  "totalGuests": 535,
		  "guestPercent": 0.738894,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Finsbury Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1371f86b3d03f6833f00a5ead8386a42",
		  
		  "name": "Jeff",
		  "createdDate": "2014-08-19 16:30:45",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 784,
		  "totalCountries": 5,
		  "totalStates": 40,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2102,
		  "schedulePercent": 0.733114,
		  "totalGuests": 1280,
		  "guestPercent": 0.883273,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1383a12d2e74220feb8e370072541e0f",
		  
		  "name": "Dan",
		  "createdDate": "2017-04-18 22:06:38",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 754,
		  "totalCountries": 2,
		  "totalStates": 42,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2549,
		  "schedulePercent": 0.792384,
		  "totalGuests": 1448,
		  "guestPercent": 0.904465,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1384b7184069e75f7a2ff7658acfec0a",
		  
		  "name": "George",
		  "createdDate": "2016-03-06 00:30:00",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 784,
		  "totalCountries": 18,
		  "totalStates": 36,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1653,
		  "schedulePercent": 0.650725,
		  "totalGuests": 632,
		  "guestPercent": 0.765979,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "138e9b90e121bdc775bfd25ac17174cb",
		  
		  "name": "Autumn",
		  "createdDate": "2024-09-17 21:01:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 114,
		  "totalCountries": 14,
		  "totalStates": 30,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 806,
		  "schedulePercent": 0.424751,
		  "totalGuests": 948,
		  "guestPercent": 0.839189,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13938a474a9a167903722246e72974e4",
		  
		  "name": "Emily",
		  "createdDate": "2024-04-22 16:12:44",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1398dbc4f5720e95757a24dc92310a08",
		  
		  "name": "Giacomo",
		  "createdDate": "2023-07-24 06:24:39",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 196,
		  "totalCountries": 19,
		  "totalStates": 45,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 862,
		  "schedulePercent": 0.445603,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Garage",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13a53701ed88f387078b2f307d126218",
		  
		  "name": "Adam",
		  "createdDate": "2022-03-31 17:50:59",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 790,
		  "totalCountries": 12,
		  "totalStates": 56,
		  "totalEvents": 291,
		  "eventPercent": 0.906618,
		  "totalScheduleItems": 4928,
		  "schedulePercent": 0.951836,
		  "totalGuests": 782,
		  "guestPercent": 0.80349,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 214,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13aed26f8fae6de0d2afff868a1ffe66",
		  
		  "name": "Simon",
		  "createdDate": "2015-04-13 15:19:43",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 1222,
		  "totalCountries": 23,
		  "totalStates": 40,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2876,
		  "schedulePercent": 0.829782,
		  "totalGuests": 1952,
		  "guestPercent": 0.942883,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13c0eb9e709603dd25a6231f64b314a3",
		  
		  "name": "Hadley",
		  "createdDate": "2024-03-01 20:37:29",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 959,
		  "totalCountries": 4,
		  "totalStates": 52,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 3228,
		  "schedulePercent": 0.861967,
		  "totalGuests": 922,
		  "guestPercent": 0.834542,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13c1c4682b9cf5a1dcffabd9293c3d5f",
		  
		  "name": "Samuel",
		  "createdDate": "2019-03-26 18:58:29",
		  "totalOrganizations": 42,
		  "totalTours": 10,
		  "totalDays": 236,
		  "totalCountries": 21,
		  "totalStates": 34,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1606,
		  "schedulePercent": 0.641319,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Bonnaroo Arts And Music Festival",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13c71a6fc92d4ce7214e7c1ae183cde7",
		  
		  "name": "Greg",
		  "createdDate": "2021-03-17 18:43:48",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 485,
		  "totalCountries": 22,
		  "totalStates": 57,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1424,
		  "schedulePercent": 0.603355,
		  "totalGuests": 1071,
		  "guestPercent": 0.858568,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "The Great Saltair",
		  "mostGuestCity": "Magna",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13c76f254fe9e1dab4ec46eeab974f56",
		  
		  "name": "Terry",
		  "createdDate": "2017-03-28 19:58:26",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 327,
		  "totalCountries": 2,
		  "totalStates": 33,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 1819,
		  "schedulePercent": 0.67917,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Southern Kentucky Performing Arts Center (SKyPAC)",
		  "mostGuestCity": "Bowling Green",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13d49120faf3b248470b48e1c891fdd8",
		  
		  "name": "Gilles",
		  "createdDate": "2017-03-15 17:03:24",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 72,
		  "totalCountries": 16,
		  "totalStates": 13,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 579,
		  "schedulePercent": 0.343155,
		  "totalGuests": 211,
		  "guestPercent": 0.603128,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Salle Wilfrid-Pelletier",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13d50affd32f18c5523f91fb62e80d2a",
		  
		  "name": "Jonny",
		  "createdDate": "2023-02-15 21:15:15",
		  "totalOrganizations": 9,
		  "totalTours": 13,
		  "totalDays": 373,
		  "totalCountries": 5,
		  "totalStates": 51,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2819,
		  "schedulePercent": 0.824683,
		  "totalGuests": 562,
		  "guestPercent": 0.746827,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The Beacham",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13df0a105d7ef2e881342755acfbe35f",
		  
		  "name": "Josh",
		  "createdDate": "2014-08-24 20:19:17",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1637,
		  "totalCountries": 10,
		  "totalStates": 59,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2390,
		  "schedulePercent": 0.773799,
		  "totalGuests": 196,
		  "guestPercent": 0.591568,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13df23b96498b32167a1012eb829fb4f",
		  
		  "name": "Joy",
		  "createdDate": "2022-08-05 12:06:03",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 207,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 326,
		  "schedulePercent": 0.229601,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13e3e0903a66f8cbb9a3c5304f6e8ef6",
		  
		  "name": "Eric",
		  "createdDate": "2018-05-31 01:22:25",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 919,
		  "schedulePercent": 0.464415,
		  "totalGuests": 413,
		  "guestPercent": 0.698663,
		  "mostGuestDate": "2025-02-11 00:00:00",
		  "mostGuestName": "Benaroya Hall",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13f3549298882777df20103275580bf5",
		  
		  "name": "Bobby",
		  "createdDate": "2017-06-24 00:28:36",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 17,
		  "totalStates": 23,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 879,
		  "schedulePercent": 0.451043,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13f63565e5cfd0a922811e5a2ee29593",
		  
		  "name": "Nesto",
		  "createdDate": "2021-11-09 18:31:23",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 405,
		  "totalCountries": 16,
		  "totalStates": 62,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2340,
		  "schedulePercent": 0.766999,
		  "totalGuests": 225,
		  "guestPercent": 0.610041,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "13f7b91ae4cf8b29916e723cb452e709",
		  
		  "name": "Micheal",
		  "createdDate": "2017-02-07 05:07:44",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 909,
		  "totalCountries": 25,
		  "totalStates": 60,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 4171,
		  "schedulePercent": 0.923731,
		  "totalGuests": 145,
		  "guestPercent": 0.555077,
		  "mostGuestDate": "2025-02-23 00:00:00",
		  "mostGuestName": "Annexet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "140256ce903a2c47e4ca66cc06366f1e",
		  
		  "name": "Terrie",
		  "createdDate": "2019-09-16 14:44:53",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 182,
		  "totalCountries": 23,
		  "totalStates": 31,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1334,
		  "schedulePercent": 0.581369,
		  "totalGuests": 93,
		  "guestPercent": 0.511786,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1411fe1bc5600c5d647efe81981409ad",
		  
		  "name": "Kristian",
		  "createdDate": "2022-11-29 02:12:55",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 35,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 136,
		  "schedulePercent": 0.122507,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1414840cb9542e70094677df996fc35e",
		  
		  "name": "David",
		  "createdDate": "2015-02-09 04:27:41",
		  "totalOrganizations": 10,
		  "totalTours": 2,
		  "totalDays": 171,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1262,
		  "schedulePercent": 0.56335,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "141de371234aa95f5a053eb4100da839",
		  
		  "name": "elisabeth",
		  "createdDate": "2024-06-04 16:39:01",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 678,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1763,
		  "schedulePercent": 0.670558,
		  "totalGuests": 231,
		  "guestPercent": 0.613327,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Hoyt Sherman Place",
		  "mostGuestCity": "Des Moines",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "142e799a22e31839eadb37cfe32f3957",
		  
		  "name": "Caleb",
		  "createdDate": "2017-01-10 22:08:51",
		  "totalOrganizations": 22,
		  "totalTours": 27,
		  "totalDays": 336,
		  "totalCountries": 26,
		  "totalStates": 75,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 1841,
		  "schedulePercent": 0.68359,
		  "totalGuests": 405,
		  "guestPercent": 0.69617,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": " Sri Shanmukhananda Chandrasekarendra Saraswathi Auditorium",
		  "mostGuestCity": "Mumbai",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1430049a5b120bbffc976b0cd429f80c",
		  
		  "name": "Lulu",
		  "createdDate": "2023-05-13 20:37:10",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 1071,
		  "totalCountries": 36,
		  "totalStates": 68,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 2125,
		  "schedulePercent": 0.735947,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Tsutaya O-East",
		  "mostGuestCity": "Shibuya-ku",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1434d6748569c022424c34072620764d",
		  
		  "name": "Max",
		  "createdDate": "2016-10-08 18:34:17",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 610,
		  "totalCountries": 14,
		  "totalStates": 42,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1785,
		  "schedulePercent": 0.673731,
		  "totalGuests": 151,
		  "guestPercent": 0.558817,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Downtown Las Vegas Events Center",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1435ccf9c658d6cd428ce2f439822520",
		  
		  "name": "Dwayne",
		  "createdDate": "2011-07-08 19:57:30",
		  "totalOrganizations": 16,
		  "totalTours": 12,
		  "totalDays": 256,
		  "totalCountries": 9,
		  "totalStates": 24,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 988,
		  "schedulePercent": 0.487421,
		  "totalGuests": 334,
		  "guestPercent": 0.667384,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "713 Music Hall",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "143eef59e51de059c8a9fd6dfa27c048",
		  
		  "name": "Carine",
		  "createdDate": "2024-07-09 17:26:25",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 730,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "Schermerhorn Symphony Hall",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "144a013202ff7a833b5be0a15bcab270",
		  
		  "name": "Shelby",
		  "createdDate": "2017-09-18 14:25:48",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 539,
		  "totalCountries": 27,
		  "totalStates": 92,
		  "totalEvents": 342,
		  "eventPercent": 0.93767,
		  "totalScheduleItems": 4636,
		  "schedulePercent": 0.941976,
		  "totalGuests": 2006,
		  "guestPercent": 0.947869,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "145508764db2ab6aa1cfc284879f68d2",
		  
		  "name": "Andrew",
		  "createdDate": "2024-05-07 03:22:20",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 335,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 243,
		  "schedulePercent": 0.186083,
		  "totalGuests": 71,
		  "guestPercent": 0.486174,
		  "mostGuestDate": "2025-01-15 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "145612b0910fafc140634ce27366c701",
		  
		  "name": "JImmy",
		  "createdDate": "2024-12-30 20:11:20",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 223,
		  "totalCountries": 23,
		  "totalStates": 30,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 883,
		  "schedulePercent": 0.452063,
		  "totalGuests": 158,
		  "guestPercent": 0.565277,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Ogden Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1456d1db9a79fd5e9fda286b0399f117",
		  
		  "name": "Mary",
		  "createdDate": "2016-10-19 22:13:19",
		  "totalOrganizations": 20,
		  "totalTours": 31,
		  "totalDays": 2411,
		  "totalCountries": 35,
		  "totalStates": 114,
		  "totalEvents": 783,
		  "eventPercent": 0.992974,
		  "totalScheduleItems": 13650,
		  "schedulePercent": 0.99864,
		  "totalGuests": 4874,
		  "guestPercent": 0.99728,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1459fb958cf351d7c941f1776465ff7f",
		  
		  "name": "Anna-Chiara",
		  "createdDate": "2023-09-15 15:39:16",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 407,
		  "totalCountries": 6,
		  "totalStates": 16,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 2164,
		  "schedulePercent": 0.741727,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1464182683ccd76288d90a67b9fc7933",
		  
		  "name": "Elizabeth",
		  "createdDate": "2025-03-13 14:40:55",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 537,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1932,
		  "schedulePercent": 0.700249,
		  "totalGuests": 381,
		  "guestPercent": 0.686197,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "The Fillmore Silver Spring",
		  "mostGuestCity": "Silver Spring",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14856a9fffece2e5a5a0a3a75767f706",
		  
		  "name": "Heather",
		  "createdDate": "2010-12-21 03:00:42",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 151,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 1111,
		  "schedulePercent": 0.521079,
		  "totalGuests": 562,
		  "guestPercent": 0.746827,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "148bb44a6260efb762e5af4c6b2dc255",
		  
		  "name": "Jalena",
		  "createdDate": "2021-07-20 15:47:57",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 914,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 3788,
		  "schedulePercent": 0.901859,
		  "totalGuests": 1048,
		  "guestPercent": 0.853694,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "148f8b01c4a907e2041ed2902db3fd46",
		  
		  "name": "Anja",
		  "createdDate": "2024-04-12 09:59:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 97,
		  "totalCountries": 18,
		  "totalStates": 19,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 568,
		  "guestPercent": 0.749207,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Festung Kufstein",
		  "mostGuestCity": "Kufstein",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14959966d9942cfce087006acde6b9a8",
		  
		  "name": "steve",
		  "createdDate": "2025-06-14 18:57:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14a70a8b540ac3d83a450982ef670372",
		  
		  "name": "Sean",
		  "createdDate": "2015-05-08 13:44:28",
		  "totalOrganizations": 20,
		  "totalTours": 12,
		  "totalDays": 556,
		  "totalCountries": 8,
		  "totalStates": 50,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 1815,
		  "schedulePercent": 0.678604,
		  "totalGuests": 903,
		  "guestPercent": 0.830689,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14ac0036b9fe3dbde26ca2a6d30e0934",
		  
		  "name": "MÃ©lissa",
		  "createdDate": "2014-06-28 20:30:19",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 243,
		  "totalCountries": 20,
		  "totalStates": 20,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1535,
		  "schedulePercent": 0.62432,
		  "totalGuests": 992,
		  "guestPercent": 0.844628,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Turbinenhalle",
		  "mostGuestCity": "Oberhausen",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14ac7d506774326e18cfdb62716eaf4a",
		  
		  "name": "Parker",
		  "createdDate": "2019-01-30 18:47:49",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 838,
		  "totalCountries": 7,
		  "totalStates": 62,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 3867,
		  "schedulePercent": 0.906052,
		  "totalGuests": 970,
		  "guestPercent": 0.841228,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Koka Booth Amphitheatre",
		  "mostGuestCity": "Cary",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14ae2d34777cf1b17dcd2d66ca20dd0e",
		  
		  "name": "Kory",
		  "createdDate": "2024-08-28 07:24:16",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 258,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 865,
		  "schedulePercent": 0.446623,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Xfinity Center",
		  "mostGuestCity": "Mansfield",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14c1185060fc0aa3911ce99c6f593313",
		  
		  "name": "Greg ",
		  "createdDate": "2021-01-05 19:08:09",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 379,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1232,
		  "schedulePercent": 0.555417,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14c6b181e9881c4056a2756c3eecd39c",
		  
		  "name": "Romain",
		  "createdDate": "2025-08-28 09:43:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 6,
		  "totalStates": 4,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 272,
		  "schedulePercent": 0.200929,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "L'Autre Canal",
		  "mostGuestCity": "Nancy",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14cab545c914e94ba454bdf0e05b7ae9",
		  
		  "name": "Morgan",
		  "createdDate": "2025-01-14 23:52:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 332,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 309,
		  "schedulePercent": 0.222235,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Danny Zottoli HOA Concert",
		  "mostGuestCity": "Port St. Lucie",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14d8bea25622d912611cb1b680583194",
		  
		  "name": "Michael",
		  "createdDate": "2018-10-23 16:43:57",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 441,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 253,
		  "eventPercent": 0.874093,
		  "totalScheduleItems": 4251,
		  "schedulePercent": 0.929284,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14e658b8162613b1c5a459b7784e375f",
		  
		  "name": "Laura",
		  "createdDate": "2025-01-31 00:55:55",
		  "totalOrganizations": 16,
		  "totalTours": 17,
		  "totalDays": 555,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 444,
		  "eventPercent": 0.969175,
		  "totalScheduleItems": 1045,
		  "schedulePercent": 0.502493,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14ef107f2aabbee0db6c0f90a2cef41f",
		  
		  "name": "Mackenzie",
		  "createdDate": "2025-07-09 23:08:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 174,
		  "totalCountries": 4,
		  "totalStates": 25,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 497,
		  "schedulePercent": 0.310857,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "14f9bdd6c24ea5ae5817f126749e0068",
		  
		  "name": "Maxime2",
		  "createdDate": "2023-10-02 15:51:42",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 30,
		  "totalCountries": 6,
		  "totalStates": 9,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 208,
		  "schedulePercent": 0.165005,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-01-28 00:00:00",
		  "mostGuestName": "L'Olympia Bruno Coquatrix",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "150823d629759875044a539c81fcdf5a",
		  
		  "name": "Chris",
		  "createdDate": "2015-09-16 21:08:53",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 423,
		  "totalCountries": 7,
		  "totalStates": 44,
		  "totalEvents": 306,
		  "eventPercent": 0.916251,
		  "totalScheduleItems": 3966,
		  "schedulePercent": 0.911378,
		  "totalGuests": 4356,
		  "guestPercent": 0.995354,
		  "mostGuestDate": "2025-07-21 00:00:00",
		  "mostGuestName": "Desert 5 Spot",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15089ab27603318aa6902a36f3e5ef50",
		  
		  "name": "Sam ",
		  "createdDate": "2015-08-11 16:53:42",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 511,
		  "totalCountries": 2,
		  "totalStates": 39,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1986,
		  "schedulePercent": 0.710675,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Irvine Barclay Theater",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "150af6e32a2b4598911a232fe0ca569b",
		  
		  "name": "Jane",
		  "createdDate": "2010-06-24 16:26:18",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 212,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1856,
		  "schedulePercent": 0.686537,
		  "totalGuests": 2376,
		  "guestPercent": 0.964529,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "150c3c7e635f0ef481c6414e166656c1",
		  
		  "name": "Linda",
		  "createdDate": "2024-06-22 21:17:32",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 10,
		  "totalStates": 12,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 372,
		  "schedulePercent": 0.254193,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "150cd805ea4c78c9ae8b6504d5c1c229",
		  
		  "name": "Henry",
		  "createdDate": "2009-08-15 23:50:47",
		  "totalOrganizations": 11,
		  "totalTours": 4,
		  "totalDays": 392,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1785,
		  "schedulePercent": 0.673731,
		  "totalGuests": 132,
		  "guestPercent": 0.546124,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "150d348c976a8ea83e0a6afe2cb73949",
		  
		  "name": "Todd",
		  "createdDate": "2012-02-01 16:27:56",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 437,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1164,
		  "schedulePercent": 0.538985,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "151c3de38c1b1ae65d1f0b1571e380d1",
		  
		  "name": "David",
		  "createdDate": "2022-06-08 21:52:04",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1635,
		  "totalCountries": 5,
		  "totalStates": 48,
		  "totalEvents": 482,
		  "eventPercent": 0.975635,
		  "totalScheduleItems": 6123,
		  "schedulePercent": 0.977448,
		  "totalGuests": 4910,
		  "guestPercent": 0.997393,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 214,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "152250e0d45441d8da82a3a264914b5e",
		  
		  "name": "Mike",
		  "createdDate": "2019-09-06 22:16:14",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 173,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 650,
		  "schedulePercent": 0.36752,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Lisa Smith Wengler Center for the Arts at Pepperdine",
		  "mostGuestCity": "Malibu",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15250eda41835e8f8259caf544f5f211",
		  
		  "name": "Tom",
		  "createdDate": "2019-05-10 18:27:03",
		  "totalOrganizations": 24,
		  "totalTours": 10,
		  "totalDays": 533,
		  "totalCountries": 20,
		  "totalStates": 55,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1644,
		  "schedulePercent": 0.648232,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "152f554aa588309eb87c848fba87f9eb",
		  
		  "name": "Ollie",
		  "createdDate": "2024-12-27 15:41:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 44,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 259,
		  "schedulePercent": 0.194356,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Elsewhere",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1536ec8a6ac66941e7d8fe641cad44a4",
		  
		  "name": "Morgane",
		  "createdDate": "2013-06-13 18:56:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1567,
		  "schedulePercent": 0.63384,
		  "totalGuests": 2485,
		  "guestPercent": 0.967362,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "153e91753275f432492bece859f53074",
		  
		  "name": "Steve",
		  "createdDate": "2017-10-17 17:22:06",
		  "totalOrganizations": 26,
		  "totalTours": 17,
		  "totalDays": 384,
		  "totalCountries": 12,
		  "totalStates": 32,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 1451,
		  "schedulePercent": 0.607548,
		  "totalGuests": 647,
		  "guestPercent": 0.770852,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Station SC",
		  "mostGuestCity": "Birtinya",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "153ef5706851e975b6c9ef86d66298f0",
		  
		  "name": "Madelyn",
		  "createdDate": "2016-09-17 19:36:15",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 14,
		  "totalStates": 28,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 800,
		  "schedulePercent": 0.422597,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "Governor's Ball Music Festival",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "154a4e01a7196cb892c551795d53f2d6",
		  
		  "name": "Chris",
		  "createdDate": "2023-12-19 18:10:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 90,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 358,
		  "guestPercent": 0.677471,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "154d6e2c4d2eda454e752c5dfa9627f3",
		  
		  "name": "Meghan",
		  "createdDate": "2017-08-18 00:06:28",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 356,
		  "totalCountries": 6,
		  "totalStates": 34,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 750,
		  "schedulePercent": 0.405032,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Carol's Pub",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "155711dbbd5645eaedee5636e9ea33b3",
		  
		  "name": "Brian",
		  "createdDate": "2023-10-03 20:58:30",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 944,
		  "totalCountries": 13,
		  "totalStates": 41,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 921,
		  "schedulePercent": 0.465095,
		  "totalGuests": 331,
		  "guestPercent": 0.666364,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Velvet Underground",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15575a47c373cb64b1c25469db5c394c",
		  
		  "name": "Abraham",
		  "createdDate": "2015-10-05 03:45:04",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 185,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "155b323c4de0178f4936f808dac497db",
		  
		  "name": "Carrie",
		  "createdDate": "2018-02-14 00:20:06",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 1330,
		  "totalCountries": 6,
		  "totalStates": 45,
		  "totalEvents": 232,
		  "eventPercent": 0.850408,
		  "totalScheduleItems": 1919,
		  "schedulePercent": 0.697643,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1563aedfa49a172c4e864d957fe96462",
		  
		  "name": "Jonathan",
		  "createdDate": "2024-03-18 22:16:43",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 358,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 1708,
		  "schedulePercent": 0.660131,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Centro de Eventos El Pedregal ",
		  "mostGuestCity": "",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1563c9de55c8bc3c36bfdb3ed1c2058b",
		  
		  "name": "Stephanie",
		  "createdDate": "2019-04-18 09:04:18",
		  "totalOrganizations": 17,
		  "totalTours": 8,
		  "totalDays": 131,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 755,
		  "schedulePercent": 0.407752,
		  "totalGuests": 298,
		  "guestPercent": 0.648685,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Mosebacketerrassen",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1569def3cffff28c51f1c88de28dac54",
		  
		  "name": "Jim",
		  "createdDate": "2012-03-03 22:11:18",
		  "totalOrganizations": 28,
		  "totalTours": 5,
		  "totalDays": 231,
		  "totalCountries": 15,
		  "totalStates": 34,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1436,
		  "schedulePercent": 0.605281,
		  "totalGuests": 319,
		  "guestPercent": 0.659565,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15736f68d74f8bc50980d4a30d3c87b6",
		  
		  "name": "Tayla",
		  "createdDate": "2025-04-01 07:05:39",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 74,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 355,
		  "schedulePercent": 0.245127,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Crowbar Brisbane",
		  "mostGuestCity": "Fortitude Valley",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15766bb3801cd6142c51a1e897af4fd9",
		  
		  "name": "Miles ",
		  "createdDate": "2017-05-10 15:04:18",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 709,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1214,
		  "schedulePercent": 0.550317,
		  "totalGuests": 515,
		  "guestPercent": 0.734361,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "157a734e9be39a3421a26e6ae7646dac",
		  
		  "name": "Joe",
		  "createdDate": "2024-05-15 18:23:38",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 186,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 508,
		  "schedulePercent": 0.31471,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Saint Louis Music Park",
		  "mostGuestCity": "Maryland Heights",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "157ffda48223d3d9e5eaad0f560be847",
		  
		  "name": "Pete",
		  "createdDate": "2023-06-20 22:25:05",
		  "totalOrganizations": 12,
		  "totalTours": 44,
		  "totalDays": 814,
		  "totalCountries": 30,
		  "totalStates": 59,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 3769,
		  "schedulePercent": 0.900272,
		  "totalGuests": 1286,
		  "guestPercent": 0.883953,
		  "mostGuestDate": "2025-02-10 00:00:00",
		  "mostGuestName": "Jahrhunderthalle",
		  "mostGuestCity": "Frankfurt",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15856b947fbe6a2b8e04a416687dd491",
		  
		  "name": "Mike",
		  "createdDate": "2022-05-05 19:41:10",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 344,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Eastside Bowl",
		  "mostGuestCity": "Madison",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15866ceb639e235aa87733007e31a059",
		  
		  "name": "Victoria ",
		  "createdDate": "2013-03-07 19:24:30",
		  "totalOrganizations": 21,
		  "totalTours": 12,
		  "totalDays": 737,
		  "totalCountries": 15,
		  "totalStates": 55,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2181,
		  "schedulePercent": 0.745127,
		  "totalGuests": 370,
		  "guestPercent": 0.68121,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Moody Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "158a2eaf4ad1aa5261c6ca933a7a9d63",
		  
		  "name": "Jack",
		  "createdDate": "2021-08-10 23:32:26",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 558,
		  "totalCountries": 13,
		  "totalStates": 63,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 1774,
		  "schedulePercent": 0.671804,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-16 00:00:00",
		  "mostGuestName": "The Chicken Box",
		  "mostGuestCity": "Nantucket",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "158c580d0dd18303db1be4dc71697ede",
		  
		  "name": "Christopher",
		  "createdDate": "2019-06-18 16:38:43",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 690,
		  "totalCountries": 10,
		  "totalStates": 47,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1444,
		  "schedulePercent": 0.606528,
		  "totalGuests": 665,
		  "guestPercent": 0.775725,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "158daba54f2af48f4d4cda656d3a63f7",
		  
		  "name": "Jose",
		  "createdDate": "2013-01-29 01:20:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 116,
		  "totalCountries": 20,
		  "totalStates": 27,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 494,
		  "schedulePercent": 0.30995,
		  "totalGuests": 375,
		  "guestPercent": 0.683477,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "North Beach Bandshell",
		  "mostGuestCity": "Miami Beach",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "158e97d358cc48d215eebe6d6fb9a075",
		  
		  "name": "Erik",
		  "createdDate": "2024-03-09 23:28:31",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 358,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 1006,
		  "schedulePercent": 0.49184,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "159efa8fcb3273ac15847d6da294b095",
		  
		  "name": "Helena",
		  "createdDate": "2015-03-06 07:56:27",
		  "totalOrganizations": 15,
		  "totalTours": 4,
		  "totalDays": 221,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 2115,
		  "schedulePercent": 0.734701,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15a1ac911d88d71dc532a5fb564694a6",
		  
		  "name": "Daniel",
		  "createdDate": "2023-01-09 11:05:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 91,
		  "totalCountries": 1,
		  "totalStates": 18,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 655,
		  "schedulePercent": 0.3699,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Enjoy Santiago",
		  "mostGuestCity": "ValparaÃ\u00ADso, Rinconada",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15aeba7e8fed9b0d3912f3ab9737a833",
		  
		  "name": "Jazmin",
		  "createdDate": "2024-07-29 13:01:52",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 227,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15afb038b188910c636df4d551288136",
		  
		  "name": "Marc",
		  "createdDate": "2025-02-05 14:03:14",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 251,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 327,
		  "schedulePercent": 0.230054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15be23ba693a8d5413fbaf764a7a1d61",
		  
		  "name": "John",
		  "createdDate": "2023-06-07 22:35:35",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 163,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 2526,
		  "schedulePercent": 0.789098,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15c61218b01aa4a19bb89b72637d518d",
		  
		  "name": "Bradley",
		  "createdDate": "2012-04-03 00:20:41",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 2177,
		  "totalCountries": 7,
		  "totalStates": 54,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 3692,
		  "schedulePercent": 0.895512,
		  "totalGuests": 893,
		  "guestPercent": 0.828196,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15d138fc3aa2b5c48a79f1b51ae5b9f2",
		  
		  "name": "Neil",
		  "createdDate": "2023-12-01 09:41:07",
		  "totalOrganizations": 15,
		  "totalTours": 25,
		  "totalDays": 772,
		  "totalCountries": 20,
		  "totalStates": 59,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2529,
		  "schedulePercent": 0.789778,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15d45bda72916f6df7d77554977f4a41",
		  
		  "name": "Adam",
		  "createdDate": "2010-12-26 08:34:02",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 378,
		  "totalCountries": 15,
		  "totalStates": 56,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2547,
		  "schedulePercent": 0.791704,
		  "totalGuests": 323,
		  "guestPercent": 0.662511,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Fortitude Music Hall",
		  "mostGuestCity": "Fortitude Valley",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15d503d9b04912da98b00821adfa89fa",
		  
		  "name": "Andrew",
		  "createdDate": "2018-04-07 20:04:30",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 282,
		  "totalCountries": 13,
		  "totalStates": 51,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1596,
		  "schedulePercent": 0.640073,
		  "totalGuests": 290,
		  "guestPercent": 0.644266,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Mercedes-Benz Stadium",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15d7a9f2e5e6502ac16218edf596b0db",
		  
		  "name": "Thomas",
		  "createdDate": "2014-05-21 17:31:53",
		  "totalOrganizations": 21,
		  "totalTours": 4,
		  "totalDays": 833,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1896,
		  "schedulePercent": 0.693676,
		  "totalGuests": 1067,
		  "guestPercent": 0.857434,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15deba58f25195d0ff05411cc10be6b6",
		  
		  "name": "SBM",
		  "createdDate": "2020-03-10 01:34:28",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 126,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 821,
		  "schedulePercent": 0.431324,
		  "totalGuests": 507,
		  "guestPercent": 0.732774,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "170 Russell",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15ee97f19b60373ab61d2c91efaf1e1e",
		  
		  "name": "Reid",
		  "createdDate": "2018-02-20 16:58:02",
		  "totalOrganizations": 15,
		  "totalTours": 42,
		  "totalDays": 1429,
		  "totalCountries": 12,
		  "totalStates": 53,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 2485,
		  "schedulePercent": 0.784905,
		  "totalGuests": 451,
		  "guestPercent": 0.713055,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15f9919ed4dbc2e62c2c7ee8cc18b2f5",
		  
		  "name": "CJ",
		  "createdDate": "2022-02-21 02:39:50",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 150,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "15fd0bf0768e482d59c05a0fdf0b3bbc",
		  
		  "name": "Aleksey",
		  "createdDate": "2022-04-04 22:16:49",
		  "totalOrganizations": 17,
		  "totalTours": 23,
		  "totalDays": 1462,
		  "totalCountries": 10,
		  "totalStates": 55,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 2860,
		  "schedulePercent": 0.828536,
		  "totalGuests": 606,
		  "guestPercent": 0.760539,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "162404d5d8d0f521f87e4432e8970e95",
		  
		  "name": "Casey ",
		  "createdDate": "2014-07-07 19:10:08",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 476,
		  "schedulePercent": 0.300884,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "162588ccbb3e06310177a38d2518b99f",
		  
		  "name": "Andrew",
		  "createdDate": "2014-09-23 18:06:32",
		  "totalOrganizations": 5,
		  "totalTours": 27,
		  "totalDays": 415,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 283,
		  "eventPercent": 0.900499,
		  "totalScheduleItems": 2302,
		  "schedulePercent": 0.762126,
		  "totalGuests": 97,
		  "guestPercent": 0.516092,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Jacksonville Symphony",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1625a880c84e880fcada8147e15ee7cd",
		  
		  "name": "Cara",
		  "createdDate": "2018-09-27 21:49:17",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 1467,
		  "totalCountries": 9,
		  "totalStates": 51,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 2626,
		  "schedulePercent": 0.800544,
		  "totalGuests": 351,
		  "guestPercent": 0.675317,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "AT&T Stadium",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "162eb10b1da2b35eaf0597b4eea450b0",
		  
		  "name": "jackie",
		  "createdDate": "2021-09-19 17:08:54",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 126,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 388,
		  "schedulePercent": 0.263486,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "16356b3f0ec947ccf87fb1ab156f1dfe",
		  
		  "name": "Jack",
		  "createdDate": "2012-04-02 17:55:42",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 210,
		  "totalCountries": 12,
		  "totalStates": 44,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1071,
		  "schedulePercent": 0.511106,
		  "totalGuests": 320,
		  "guestPercent": 0.659791,
		  "mostGuestDate": "2025-08-25 00:00:00",
		  "mostGuestName": "The Ford",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "163677d6268201f341048d755dce0b9e",
		  
		  "name": "Bonnie",
		  "createdDate": "2025-05-13 19:13:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 263,
		  "schedulePercent": 0.196056,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Cottonwood Creek Church",
		  "mostGuestCity": "Allen",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "16379d7074bcf3bb2a8ffc8c10a96adf",
		  
		  "name": "Cate",
		  "createdDate": "2022-04-25 23:19:50",
		  "totalOrganizations": 3,
		  "totalTours": 27,
		  "totalDays": 929,
		  "totalCountries": 18,
		  "totalStates": 48,
		  "totalEvents": 341,
		  "eventPercent": 0.936877,
		  "totalScheduleItems": 4388,
		  "schedulePercent": 0.934723,
		  "totalGuests": 201,
		  "guestPercent": 0.595422,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "164108350346084a294f8678d34836cc",
		  
		  "name": "Christopher ",
		  "createdDate": "2014-01-16 13:18:15",
		  "totalOrganizations": 14,
		  "totalTours": 62,
		  "totalDays": 962,
		  "totalCountries": 23,
		  "totalStates": 65,
		  "totalEvents": 311,
		  "eventPercent": 0.919878,
		  "totalScheduleItems": 5346,
		  "schedulePercent": 0.964189,
		  "totalGuests": 577,
		  "guestPercent": 0.751813,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Rocket Mortgage FieldHouse",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "164539aab213cf3008ada5d645def2ce",
		  
		  "name": "Kyle",
		  "createdDate": "2018-05-07 20:54:33",
		  "totalOrganizations": 8,
		  "totalTours": 28,
		  "totalDays": 418,
		  "totalCountries": 8,
		  "totalStates": 44,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 3124,
		  "schedulePercent": 0.853468,
		  "totalGuests": 2943,
		  "guestPercent": 0.980508,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1647c0cf5ccdeb012b1e678bc86c1083",
		  
		  "name": "Ximena",
		  "createdDate": "2023-03-24 02:13:54",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 46,
		  "totalCountries": 5,
		  "totalStates": 24,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 210,
		  "schedulePercent": 0.166251,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "165134ab032557ab7942f705f0e38d18",
		  
		  "name": "Mary",
		  "createdDate": "2025-10-25 15:19:17",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 56,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Ovens Auditorium",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1651cbff25f7425cee6b7506eee02c2a",
		  
		  "name": "Christine",
		  "createdDate": "2020-06-11 07:06:46",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 693,
		  "totalCountries": 21,
		  "totalStates": 40,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1907,
		  "schedulePercent": 0.695943,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1651fdaead94b0fae7020282150e502f",
		  
		  "name": "Franki",
		  "createdDate": "2022-02-18 19:07:25",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 223,
		  "totalCountries": 7,
		  "totalStates": 40,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1985,
		  "schedulePercent": 0.710449,
		  "totalGuests": 987,
		  "guestPercent": 0.843608,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "The Salt Shed",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1658624ee8ba9cc639e489b1208dced0",
		  
		  "name": "Ryan",
		  "createdDate": "2018-12-04 23:22:43",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 722,
		  "totalCountries": 12,
		  "totalStates": 63,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 2712,
		  "schedulePercent": 0.810517,
		  "totalGuests": 199,
		  "guestPercent": 0.594062,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "165c3092073555b4fe68bcaedaacae87",
		  
		  "name": "Sarah",
		  "createdDate": "2018-09-29 08:46:52",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 606,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 436,
		  "schedulePercent": 0.284338,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "165e3a7131ad404abe3a954289702ae2",
		  
		  "name": "Tommy",
		  "createdDate": "2022-05-08 06:28:03",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 281,
		  "totalCountries": 4,
		  "totalStates": 61,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1234,
		  "schedulePercent": 0.555757,
		  "totalGuests": 943,
		  "guestPercent": 0.838509,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1671840da27c83e161a4f0ab52cc1515",
		  
		  "name": "Ana",
		  "createdDate": "2023-06-24 16:22:14",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 136,
		  "totalCountries": 20,
		  "totalStates": 27,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 714,
		  "schedulePercent": 0.391772,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Delta festival",
		  "mostGuestCity": "Marseille",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "169b42b28dbab29e2c6433b5b355b7a2",
		  
		  "name": "Alexandra ",
		  "createdDate": "2021-07-01 13:31:34",
		  "totalOrganizations": 18,
		  "totalTours": 17,
		  "totalDays": 803,
		  "totalCountries": 14,
		  "totalStates": 47,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 4054,
		  "schedulePercent": 0.916364,
		  "totalGuests": 1013,
		  "guestPercent": 0.849048,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rden Under Bron",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "169d169093b3f4972f1f747c68c66531",
		  
		  "name": "Dylan",
		  "createdDate": "2022-04-29 02:19:23",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 1433,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 380,
		  "eventPercent": 0.953536,
		  "totalScheduleItems": 5048,
		  "schedulePercent": 0.955349,
		  "totalGuests": 1616,
		  "guestPercent": 0.921011,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "169ec18ead5b82b8ed476a927c0c8d7d",
		  
		  "name": "Kevin",
		  "createdDate": "2016-09-20 14:03:33",
		  "totalOrganizations": 17,
		  "totalTours": 21,
		  "totalDays": 1100,
		  "totalCountries": 17,
		  "totalStates": 71,
		  "totalEvents": 374,
		  "eventPercent": 0.951609,
		  "totalScheduleItems": 4258,
		  "schedulePercent": 0.92951,
		  "totalGuests": 2552,
		  "guestPercent": 0.970422,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "The Met Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "16a7404206daad7865aa3707780ff91a",
		  
		  "name": "David",
		  "createdDate": "2010-02-17 16:42:05",
		  "totalOrganizations": 33,
		  "totalTours": 22,
		  "totalDays": 228,
		  "totalCountries": 6,
		  "totalStates": 39,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1494,
		  "schedulePercent": 0.61616,
		  "totalGuests": 1519,
		  "guestPercent": 0.911831,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "16b2196971e0fd85ffba6af85cede89e",
		  
		  "name": "Thomas",
		  "createdDate": "2017-03-31 23:07:18",
		  "totalOrganizations": 31,
		  "totalTours": 12,
		  "totalDays": 667,
		  "totalCountries": 25,
		  "totalStates": 54,
		  "totalEvents": 283,
		  "eventPercent": 0.900499,
		  "totalScheduleItems": 3971,
		  "schedulePercent": 0.911605,
		  "totalGuests": 1843,
		  "guestPercent": 0.93563,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Revolution Concert House",
		  "mostGuestCity": "Garden City",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "16c6d5eaae8bf4a1ba964eb92ecd4f64",
		  
		  "name": "Joey",
		  "createdDate": "2022-04-11 23:25:47",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 921,
		  "totalCountries": 22,
		  "totalStates": 65,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 1994,
		  "schedulePercent": 0.712602,
		  "totalGuests": 329,
		  "guestPercent": 0.665685,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Immersive Media Performing Arts Center (iMPAC)",
		  "mostGuestCity": "Gulfport",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "16cef6bbc2ea984b1870fd8f2f662dbe",
		  
		  "name": "Agustina",
		  "createdDate": "2022-04-29 23:52:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 241,
		  "totalCountries": 9,
		  "totalStates": 12,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 268,
		  "schedulePercent": 0.198209,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "16e72b19271468fd797a654fe6630586",
		  
		  "name": "Johnny",
		  "createdDate": "2022-05-17 18:41:51",
		  "totalOrganizations": 6,
		  "totalTours": 34,
		  "totalDays": 489,
		  "totalCountries": 18,
		  "totalStates": 34,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 1862,
		  "schedulePercent": 0.687557,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "16f1f16fa58bafd7c392f5026efcf74c",
		  
		  "name": "brandon",
		  "createdDate": "2022-04-13 19:38:28",
		  "totalOrganizations": 18,
		  "totalTours": 14,
		  "totalDays": 333,
		  "totalCountries": 12,
		  "totalStates": 44,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 819,
		  "schedulePercent": 0.430304,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "The Crocodile",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "170ca274f7ad92d3c64310894bd5b9f1",
		  
		  "name": "Jason \"Loopy\"",
		  "createdDate": "2011-09-18 00:42:04",
		  "totalOrganizations": 10,
		  "totalTours": 24,
		  "totalDays": 817,
		  "totalCountries": 22,
		  "totalStates": 82,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 3406,
		  "schedulePercent": 0.875907,
		  "totalGuests": 1451,
		  "guestPercent": 0.904692,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "170e561c2f99d8164c1a870de9c9f78b",
		  
		  "name": "Derek ",
		  "createdDate": "2018-01-21 23:15:49",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 229,
		  "totalCountries": 9,
		  "totalStates": 15,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 695,
		  "schedulePercent": 0.384406,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Freo.Social",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17148c39d9b9fe7fd1638b771a4f7967",
		  
		  "name": "DUBOIS",
		  "createdDate": "2022-02-25 12:12:59",
		  "totalOrganizations": 16,
		  "totalTours": 15,
		  "totalDays": 3730,
		  "totalCountries": 10,
		  "totalStates": 22,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1533,
		  "schedulePercent": 0.624093,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Rose Festival",
		  "mostGuestCity": "Aussonne",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17183f16e08050613e11b8a437b4eb63",
		  
		  "name": "Carl",
		  "createdDate": "2025-03-24 16:22:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 30,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 132,
		  "schedulePercent": 0.119674,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1725116e5eaed274052b066779567c1d",
		  
		  "name": "Tessa",
		  "createdDate": "2023-09-05 12:25:17",
		  "totalOrganizations": 72,
		  "totalTours": 74,
		  "totalDays": 1503,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 1502,
		  "eventPercent": 0.998753,
		  "totalScheduleItems": 5063,
		  "schedulePercent": 0.956256,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "KesÃ¤rauha",
		  "mostGuestCity": "Turku",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17256ff284647bc247d151952b1581a5",
		  
		  "name": "Erika",
		  "createdDate": "2012-08-20 18:37:27",
		  "totalOrganizations": 17,
		  "totalTours": 11,
		  "totalDays": 420,
		  "totalCountries": 28,
		  "totalStates": 83,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 3154,
		  "schedulePercent": 0.855848,
		  "totalGuests": 1627,
		  "guestPercent": 0.922257,
		  "mostGuestDate": "2025-06-16 00:00:00",
		  "mostGuestName": "Cavea Auditorium",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "172826110544a79132bc17a42f5ebf6c",
		  
		  "name": "Stephen",
		  "createdDate": "2016-08-30 17:29:21",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 516,
		  "totalCountries": 12,
		  "totalStates": 58,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 4106,
		  "schedulePercent": 0.919424,
		  "totalGuests": 2643,
		  "guestPercent": 0.973935,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "172ee202efb5ac9aa3262ea18d3b52e7",
		  
		  "name": "Email",
		  "createdDate": "2013-05-17 02:51:52",
		  "totalOrganizations": 9,
		  "totalTours": 17,
		  "totalDays": 229,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 941,
		  "schedulePercent": 0.472575,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Manning Bar",
		  "mostGuestCity": "Camperdown",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "172f7abfcb7caf12f81ffe2cd779406e",
		  
		  "name": "Benjamin",
		  "createdDate": "2018-06-19 01:17:42",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 307,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1332,
		  "schedulePercent": 0.580916,
		  "totalGuests": 199,
		  "guestPercent": 0.594062,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17442908b066b1cf6a1468b2b8198ac8",
		  
		  "name": "Joe",
		  "createdDate": "2022-02-24 23:12:46",
		  "totalOrganizations": 6,
		  "totalTours": 22,
		  "totalDays": 340,
		  "totalCountries": 11,
		  "totalStates": 30,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1014,
		  "schedulePercent": 0.494447,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Fox Cabaret",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1745cbe96fa74c7e89ea504f9666da31",
		  
		  "name": "Jesse",
		  "createdDate": "2025-07-01 00:40:32",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 103,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 621,
		  "schedulePercent": 0.357548,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Hamer Hall",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17551c5cb6914571405a91cd1d4baf31",
		  
		  "name": "Eric ",
		  "createdDate": "2022-04-19 02:48:55",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 77,
		  "totalCountries": 8,
		  "totalStates": 31,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 632,
		  "schedulePercent": 0.361514,
		  "totalGuests": 632,
		  "guestPercent": 0.765979,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "The Dome",
		  "mostGuestCity": "Virginia Beach",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "175f9938081eca1ea461baf1a0876417",
		  
		  "name": "Eric",
		  "createdDate": "2015-09-04 19:42:42",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 1120,
		  "totalCountries": 24,
		  "totalStates": 61,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 2395,
		  "schedulePercent": 0.774365,
		  "totalGuests": 320,
		  "guestPercent": 0.659791,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1768a8698318487ff5d1a3b4af374509",
		  
		  "name": "Joey",
		  "createdDate": "2025-03-26 04:32:19",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 77,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 832,
		  "schedulePercent": 0.435177,
		  "totalGuests": 936,
		  "guestPercent": 0.836582,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "1720",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1779db5b9ba438399deca8989010f6ba",
		  
		  "name": "Jib",
		  "createdDate": "2023-08-14 21:33:04",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 533,
		  "totalCountries": 7,
		  "totalStates": 21,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 64,
		  "schedulePercent": 0.069583,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "The Midway",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1786661da1f6d32412d395ecbadd2ef9",
		  
		  "name": "Seth",
		  "createdDate": "2014-02-05 02:25:30",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 1627,
		  "totalCountries": 3,
		  "totalStates": 46,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 3062,
		  "schedulePercent": 0.848255,
		  "totalGuests": 600,
		  "guestPercent": 0.757933,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1789402ef08bd3a8b3878ad5461acaa4",
		  
		  "name": "Bryan",
		  "createdDate": "2014-08-20 09:49:21",
		  "totalOrganizations": 16,
		  "totalTours": 12,
		  "totalDays": 868,
		  "totalCountries": 31,
		  "totalStates": 73,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 2150,
		  "schedulePercent": 0.739914,
		  "totalGuests": 184,
		  "guestPercent": 0.582276,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Tottenham Hotspur Stadium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "178af467faddd175b96ff7f97da41dbb",
		  
		  "name": "Kai",
		  "createdDate": "2019-12-15 15:14:36",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 60,
		  "totalCountries": 6,
		  "totalStates": 14,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 280,
		  "schedulePercent": 0.205576,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "178d0e9499d83d1ff7d4efc0c79a0873",
		  
		  "name": "David",
		  "createdDate": "2014-11-01 18:00:30",
		  "totalOrganizations": 13,
		  "totalTours": 40,
		  "totalDays": 732,
		  "totalCountries": 20,
		  "totalStates": 56,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 5189,
		  "schedulePercent": 0.959315,
		  "totalGuests": 2028,
		  "guestPercent": 0.948889,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "179c7cf6600f7054d9938139515d00fd",
		  
		  "name": "Christian",
		  "createdDate": "2011-01-11 05:52:35",
		  "totalOrganizations": 48,
		  "totalTours": 42,
		  "totalDays": 1189,
		  "totalCountries": 13,
		  "totalStates": 51,
		  "totalEvents": 269,
		  "eventPercent": 0.889393,
		  "totalScheduleItems": 3680,
		  "schedulePercent": 0.894719,
		  "totalGuests": 667,
		  "guestPercent": 0.776745,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "179df0dec2e58d5b360b0308b8b5bb8c",
		  
		  "name": "Kiya",
		  "createdDate": "2023-02-10 17:12:17",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 253,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17a4acd1e88c0bbdbb9c1643bfdea252",
		  
		  "name": "Tim",
		  "createdDate": "2025-09-23 16:15:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 43,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 146,
		  "schedulePercent": 0.128173,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Loft",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17abec88d6fa7faa44e398a1d14d5cea",
		  
		  "name": "Sam",
		  "createdDate": "2023-01-18 22:08:21",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 373,
		  "totalCountries": 11,
		  "totalStates": 38,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1248,
		  "schedulePercent": 0.560063,
		  "totalGuests": 670,
		  "guestPercent": 0.777879,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17af7505f816748970ab55acb7877aa8",
		  
		  "name": "Erika",
		  "createdDate": "2010-06-03 16:49:48",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17b83298339f61fc8f9a94de3ee7f575",
		  
		  "name": "David",
		  "createdDate": "2009-08-15 20:38:31",
		  "totalOrganizations": 14,
		  "totalTours": 13,
		  "totalDays": 715,
		  "totalCountries": 31,
		  "totalStates": 56,
		  "totalEvents": 281,
		  "eventPercent": 0.898912,
		  "totalScheduleItems": 5256,
		  "schedulePercent": 0.960789,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17bc7aadd44c5e80e622577a83787925",
		  
		  "name": "Gaby",
		  "createdDate": "2023-09-29 14:18:29",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 164,
		  "totalCountries": 6,
		  "totalStates": 25,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 873,
		  "schedulePercent": 0.449456,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Prudential Center",
		  "mostGuestCity": "Newark",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17c3c19cdabff4846ab7c82591f100b4",
		  
		  "name": "Emily",
		  "createdDate": "2022-07-07 22:13:47",
		  "totalOrganizations": 13,
		  "totalTours": 14,
		  "totalDays": 634,
		  "totalCountries": 14,
		  "totalStates": 62,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 2929,
		  "schedulePercent": 0.834202,
		  "totalGuests": 1304,
		  "guestPercent": 0.886673,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stone Pony Summer Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17c650232dae2ad8d2049c1b60c0f0b8",
		  
		  "name": "Kristie",
		  "createdDate": "2025-02-28 22:33:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 89,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 954,
		  "schedulePercent": 0.477335,
		  "totalGuests": 1301,
		  "guestPercent": 0.886106,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "MGM Music Hall at Fenway",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17cca611dd887b7b65f53f0aa9730f31",
		  
		  "name": "Norman",
		  "createdDate": "2019-03-07 23:18:42",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 1101,
		  "totalCountries": 13,
		  "totalStates": 57,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 3494,
		  "schedulePercent": 0.882026,
		  "totalGuests": 1553,
		  "guestPercent": 0.915345,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17ddef995c03201da8a6a934478423a4",
		  
		  "name": "Deni",
		  "createdDate": "2021-08-31 17:38:13",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 250,
		  "totalCountries": 5,
		  "totalStates": 1,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 1069,
		  "schedulePercent": 0.510199,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17f371a031ce7da0bfd05c1d20d32e07",
		  
		  "name": "Nyasha",
		  "createdDate": "2023-06-06 23:02:58",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 66,
		  "totalCountries": 6,
		  "totalStates": 9,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 224,
		  "schedulePercent": 0.173844,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "17f703ac83fa1dd091ebeb0656b8d74d",
		  
		  "name": "Summer",
		  "createdDate": "2024-07-22 07:31:07",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 9,
		  "totalStates": 12,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 353,
		  "schedulePercent": 0.24422,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1812c9c3fb65470f38d48b89ffd95992",
		  
		  "name": "Amanda",
		  "createdDate": "2013-07-26 19:05:57",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 180,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 1870,
		  "schedulePercent": 0.689257,
		  "totalGuests": 1425,
		  "guestPercent": 0.902879,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1813b576b23227b41a41bcc428f07f18",
		  
		  "name": "Tod",
		  "createdDate": "2010-01-27 20:25:33",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 6,
		  "totalStates": 11,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 440,
		  "schedulePercent": 0.286491,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "MacKinnon Brothers Brewing Company",
		  "mostGuestCity": "Bath",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18141f3cf3dbeb2602957961add84c98",
		  
		  "name": "Laura",
		  "createdDate": "2023-02-20 16:13:17",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 970,
		  "totalCountries": 14,
		  "totalStates": 41,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1838,
		  "schedulePercent": 0.68257,
		  "totalGuests": 522,
		  "guestPercent": 0.736627,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Diamante de BÃ©isbol - Sede de los Living Conciertos",
		  "mostGuestCity": "Cali",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1814c9171700f0a6e60b96a377d66343",
		  
		  "name": "Tyler",
		  "createdDate": "2017-03-10 23:08:36",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 754,
		  "schedulePercent": 0.407298,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Mars Music Hall",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1816fd029457623a9f1bebe880f4418d",
		  
		  "name": "Julie",
		  "createdDate": "2023-11-16 21:14:02",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 38,
		  "totalCountries": 1,
		  "totalStates": 2,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "181f6cfd14c8c53c068b892fdbb44ecd",
		  
		  "name": "Bruce",
		  "createdDate": "2017-10-18 21:18:16",
		  "totalOrganizations": 5,
		  "totalTours": 34,
		  "totalDays": 1011,
		  "totalCountries": 18,
		  "totalStates": 72,
		  "totalEvents": 483,
		  "eventPercent": 0.975861,
		  "totalScheduleItems": 5389,
		  "schedulePercent": 0.966115,
		  "totalGuests": 346,
		  "guestPercent": 0.673277,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1821bcff9eb62e587231efcce3de86f0",
		  
		  "name": "Hilary",
		  "createdDate": "2022-07-03 18:38:59",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 64,
		  "totalCountries": 14,
		  "totalStates": 9,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 330,
		  "schedulePercent": 0.230961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1830f83100e3aad77ff356760038a568",
		  
		  "name": "Samantha",
		  "createdDate": "2021-01-19 18:21:54",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 759,
		  "totalCountries": 4,
		  "totalStates": 19,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 272,
		  "schedulePercent": 0.200929,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Eddie's Attic",
		  "mostGuestCity": "Decatur",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1833a446809acba7e9149217a65d747d",
		  
		  "name": "Joe",
		  "createdDate": "2013-10-17 03:23:46",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 635,
		  "totalCountries": 27,
		  "totalStates": 63,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1706,
		  "schedulePercent": 0.659451,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "184a5a1ac46ff490f416580bdf807c19",
		  
		  "name": "Brian",
		  "createdDate": "2011-09-27 23:57:41",
		  "totalOrganizations": 18,
		  "totalTours": 17,
		  "totalDays": 388,
		  "totalCountries": 23,
		  "totalStates": 63,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2154,
		  "schedulePercent": 0.740594,
		  "totalGuests": 777,
		  "guestPercent": 0.801904,
		  "mostGuestDate": "2025-07-22 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "184c36295f71781a3b366ea758891927",
		  
		  "name": "Carl",
		  "createdDate": "2019-01-31 13:55:29",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 485,
		  "totalCountries": 14,
		  "totalStates": 20,
		  "totalEvents": 286,
		  "eventPercent": 0.902765,
		  "totalScheduleItems": 1668,
		  "schedulePercent": 0.652992,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18594f899cdd61cf3258948d48bad17c",
		  
		  "name": "Mike",
		  "createdDate": "2012-03-29 01:09:28",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 210,
		  "schedulePercent": 0.166251,
		  "totalGuests": 288,
		  "guestPercent": 0.643246,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18608de0d13f359506bf13bf18199725",
		  
		  "name": "Shandy",
		  "createdDate": "2015-04-23 22:25:54",
		  "totalOrganizations": 70,
		  "totalTours": 50,
		  "totalDays": 699,
		  "totalCountries": 36,
		  "totalStates": 50,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 2410,
		  "schedulePercent": 0.776065,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Folketeateret",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "186fb544b452164235eb4024b73c11ed",
		  
		  "name": "Mathieu",
		  "createdDate": "2025-01-27 11:22:10",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 78,
		  "totalCountries": 15,
		  "totalStates": 22,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 438,
		  "schedulePercent": 0.285131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1875dfb449abc34c44088f01604717e3",
		  
		  "name": "Dylan",
		  "createdDate": "2021-11-02 02:57:23",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 168,
		  "totalCountries": 5,
		  "totalStates": 26,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1011,
		  "schedulePercent": 0.493654,
		  "totalGuests": 391,
		  "guestPercent": 0.690277,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Soldiers and Sailors Memorial Auditorium",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "187b3cee0854edb57521ee843a666873",
		  
		  "name": "Greg",
		  "createdDate": "2025-09-22 15:33:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 98,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 102,
		  "schedulePercent": 0.0980281,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "George's Majestic Lounge",
		  "mostGuestCity": "Fayetteville",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1899622cdb3ec6c0f406bcceecc801f5",
		  
		  "name": "Marc",
		  "createdDate": "2016-09-11 22:20:21",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 236,
		  "totalCountries": 20,
		  "totalStates": 58,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1371,
		  "schedulePercent": 0.589529,
		  "totalGuests": 339,
		  "guestPercent": 0.670558,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "189b71cba18cdeb11331e0924c13d153",
		  
		  "name": "Isaiah",
		  "createdDate": "2024-01-24 03:38:36",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 319,
		  "totalCountries": 15,
		  "totalStates": 48,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 2314,
		  "schedulePercent": 0.763713,
		  "totalGuests": 480,
		  "guestPercent": 0.724161,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18b26f395f5130218910412cb587d7ea",
		  
		  "name": "Abishai",
		  "createdDate": "2017-11-22 17:33:27",
		  "totalOrganizations": 5,
		  "totalTours": 14,
		  "totalDays": 572,
		  "totalCountries": 13,
		  "totalStates": 34,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 968,
		  "schedulePercent": 0.480621,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Reggae Rise Up Arizona",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18b98c5963c9dcc4494af9ca4cbfb03d",
		  
		  "name": "Brandon",
		  "createdDate": "2019-09-13 18:58:47",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 772,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 2261,
		  "schedulePercent": 0.7568,
		  "totalGuests": 1385,
		  "guestPercent": 0.898572,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18bcf0437c757bfa8452668965cfb103",
		  
		  "name": "Peter ",
		  "createdDate": "2022-11-14 03:30:21",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 223,
		  "totalCountries": 26,
		  "totalStates": 46,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1464,
		  "schedulePercent": 0.609927,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Lido",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18c0bdf8fe254bceae884f94ec7c9c2a",
		  
		  "name": "David",
		  "createdDate": "2015-03-05 00:50:32",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 1610,
		  "totalCountries": 14,
		  "totalStates": 62,
		  "totalEvents": 335,
		  "eventPercent": 0.935063,
		  "totalScheduleItems": 4959,
		  "schedulePercent": 0.953196,
		  "totalGuests": 789,
		  "guestPercent": 0.805417,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18c180376283641df4c1823525af3817",
		  
		  "name": "Michael",
		  "createdDate": "2014-05-14 15:12:51",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 437,
		  "totalCountries": 11,
		  "totalStates": 30,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1150,
		  "schedulePercent": 0.535018,
		  "totalGuests": 3256,
		  "guestPercent": 0.986627,
		  "mostGuestDate": "2025-05-13 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 176,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18c557c43939a3666c30d888a69b7256",
		  
		  "name": "Jon",
		  "createdDate": "2018-02-27 22:15:58",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 166,
		  "totalCountries": 17,
		  "totalStates": 47,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1288,
		  "schedulePercent": 0.568903,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-04-29 00:00:00",
		  "mostGuestName": "Town Ballroom",
		  "mostGuestCity": "Buffalo",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18c6b0a3d3a7930038eee55b159f3861",
		  
		  "name": "Jill",
		  "createdDate": "2023-08-26 18:35:14",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 207,
		  "totalCountries": 8,
		  "totalStates": 26,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 2270,
		  "schedulePercent": 0.757933,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18c9df508a7d9093b597476d037aa28a",
		  
		  "name": "Tom",
		  "createdDate": "2018-03-07 19:23:48",
		  "totalOrganizations": 18,
		  "totalTours": 17,
		  "totalDays": 499,
		  "totalCountries": 21,
		  "totalStates": 38,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1330,
		  "schedulePercent": 0.579896,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "O2 Apollo Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18cc0b899ce36682aba0902ec7bc67c4",
		  
		  "name": "Helen",
		  "createdDate": "2018-07-16 13:08:36",
		  "totalOrganizations": 11,
		  "totalTours": 22,
		  "totalDays": 929,
		  "totalCountries": 26,
		  "totalStates": 32,
		  "totalEvents": 428,
		  "eventPercent": 0.964982,
		  "totalScheduleItems": 7250,
		  "schedulePercent": 0.987987,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18d3847debf2687ae06f039cab806281",
		  
		  "name": "Daniel",
		  "createdDate": "2022-02-02 20:46:29",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 36,
		  "totalCountries": 10,
		  "totalStates": 10,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Signature Brew Blackhorse Road",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18e5c10b680733087dabbc71ee314d91",
		  
		  "name": "Devin",
		  "createdDate": "2023-09-15 20:57:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 11,
		  "totalStates": 45,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1516,
		  "schedulePercent": 0.620807,
		  "totalGuests": 795,
		  "guestPercent": 0.80689,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18ef6fb0ca4a9a10e38e02398dcde4bf",
		  
		  "name": "Jamey",
		  "createdDate": "2016-10-26 22:30:00",
		  "totalOrganizations": 8,
		  "totalTours": 22,
		  "totalDays": 285,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 2141,
		  "schedulePercent": 0.738441,
		  "totalGuests": 1237,
		  "guestPercent": 0.878966,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "18fb7b7529329d64f8cb6ab03be028cd",
		  
		  "name": "Tom",
		  "createdDate": "2022-03-25 15:33:47",
		  "totalOrganizations": 14,
		  "totalTours": 27,
		  "totalDays": 1137,
		  "totalCountries": 30,
		  "totalStates": 79,
		  "totalEvents": 343,
		  "eventPercent": 0.938463,
		  "totalScheduleItems": 3688,
		  "schedulePercent": 0.895399,
		  "totalGuests": 392,
		  "guestPercent": 0.690956,
		  "mostGuestDate": "2025-08-26 00:00:00",
		  "mostGuestName": "Libbey Bowl",
		  "mostGuestCity": "Ojai",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "190e66e931bc72c2534e98c8603aa10c",
		  
		  "name": "Sam",
		  "createdDate": "2017-04-12 19:48:36",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 774,
		  "totalCountries": 17,
		  "totalStates": 64,
		  "totalEvents": 275,
		  "eventPercent": 0.895059,
		  "totalScheduleItems": 3170,
		  "schedulePercent": 0.857321,
		  "totalGuests": 1157,
		  "guestPercent": 0.871714,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Grand Sierra Theater",
		  "mostGuestCity": "Reno",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "192e52ea3101e64703c89b57b1834427",
		  
		  "name": "Jean-Philippe",
		  "createdDate": "2025-10-23 19:05:02",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 2,
		  "eventPercent": 0.0163191,
		  "totalScheduleItems": 29,
		  "schedulePercent": 0.0398912,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-11-04 00:00:00",
		  "mostGuestName": "Centre EvÃ©nÃ©mentiel et Culturel - Salle Rouge",
		  "mostGuestCity": "Courbevoie",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19322cb6930ac1cc9296680b761eb440",
		  
		  "name": "Ada",
		  "createdDate": "2024-07-24 18:27:03",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 79,
		  "totalCountries": 17,
		  "totalStates": 26,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 311,
		  "schedulePercent": 0.222801,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "193c8c13dc206dd25e16e6ed1b984254",
		  
		  "name": "Dean",
		  "createdDate": "2016-04-13 05:15:00",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 539,
		  "schedulePercent": 0.330009,
		  "totalGuests": 503,
		  "guestPercent": 0.731528,
		  "mostGuestDate": "2025-11-13 00:00:00",
		  "mostGuestName": "YouTube Theater",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "194342635eda925b43cd12121337a213",
		  
		  "name": "Dallas",
		  "createdDate": "2019-09-10 17:16:32",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 74,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 275,
		  "schedulePercent": 0.202403,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Les Foufounes Ã‰lectriques",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1948b603f9544b831edcbc6f85841e54",
		  
		  "name": "Eliisa",
		  "createdDate": "2023-09-05 12:25:36",
		  "totalOrganizations": 72,
		  "totalTours": 74,
		  "totalDays": 1503,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 1502,
		  "eventPercent": 0.998753,
		  "totalScheduleItems": 5063,
		  "schedulePercent": 0.956256,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "KesÃ¤rauha",
		  "mostGuestCity": "Turku",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "194c6164ce056619765836c1283c2eb9",
		  
		  "name": "TOUR MANAGEMENT",
		  "createdDate": "2024-02-07 16:45:45",
		  "totalOrganizations": 2,
		  "totalTours": 35,
		  "totalDays": 163,
		  "totalCountries": 14,
		  "totalStates": 35,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 981,
		  "schedulePercent": 0.484814,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "194d05814ee2593ddb4bc673ddd2d5e5",
		  
		  "name": "Anna",
		  "createdDate": "2022-03-16 14:07:52",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 6,
		  "totalStates": 9,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 544,
		  "schedulePercent": 0.331709,
		  "totalGuests": 383,
		  "guestPercent": 0.68699,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Studenternas Arena",
		  "mostGuestCity": "Uppsala",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "194ea542a243855112e22a08efc65fb6",
		  
		  "name": "Megan",
		  "createdDate": "2022-02-22 22:56:39",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 1181,
		  "totalCountries": 15,
		  "totalStates": 56,
		  "totalEvents": 365,
		  "eventPercent": 0.948096,
		  "totalScheduleItems": 4219,
		  "schedulePercent": 0.927357,
		  "totalGuests": 898,
		  "guestPercent": 0.829556,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1951b4ef8195ace12c966102483bca0c",
		  
		  "name": "Kyle",
		  "createdDate": "2024-01-18 00:20:54",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 151,
		  "totalCountries": 13,
		  "totalStates": 49,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1482,
		  "schedulePercent": 0.613554,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1952af9b75c1e55428c0c7f7a4c510ac",
		  
		  "name": "Anthony ",
		  "createdDate": "2015-09-22 04:30:59",
		  "totalOrganizations": 24,
		  "totalTours": 14,
		  "totalDays": 575,
		  "totalCountries": 19,
		  "totalStates": 71,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 3213,
		  "schedulePercent": 0.861174,
		  "totalGuests": 2286,
		  "guestPercent": 0.961242,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1967551de8867c268cecdb6d65478067",
		  
		  "name": "Mackenzie",
		  "createdDate": "2025-06-01 20:20:08",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 163,
		  "schedulePercent": 0.137579,
		  "totalGuests": 244,
		  "guestPercent": 0.6216,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Stage AE",
		  "mostGuestCity": "Pittsburgh",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "196904dbdf1f8678bb703129137bd792",
		  
		  "name": "Nita",
		  "createdDate": "2018-11-18 20:01:35",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 77,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 713,
		  "schedulePercent": 0.391432,
		  "totalGuests": 289,
		  "guestPercent": 0.643699,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "The Orpheum Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "196c2dd814277023cd3ff5f2c7cdd332",
		  
		  "name": "Torben",
		  "createdDate": "2023-05-31 09:17:42",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 225,
		  "totalCountries": 21,
		  "totalStates": 32,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 933,
		  "schedulePercent": 0.470535,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1977acf51feaf8f2448214970ab88531",
		  
		  "name": "Michael",
		  "createdDate": "2012-10-07 13:53:23",
		  "totalOrganizations": 12,
		  "totalTours": 20,
		  "totalDays": 1325,
		  "totalCountries": 28,
		  "totalStates": 84,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 5332,
		  "schedulePercent": 0.963622,
		  "totalGuests": 1318,
		  "guestPercent": 0.889733,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "SunBet Arena at Time Square Casino",
		  "mostGuestCity": "Pretoria",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "197ddd2d7872724a6a907c932239e6b8",
		  
		  "name": "Marc",
		  "createdDate": "2019-11-02 01:33:06",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 509,
		  "totalCountries": 5,
		  "totalStates": 34,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 843,
		  "schedulePercent": 0.438237,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Soaring Eagle Casino",
		  "mostGuestCity": "Mt Pleasant",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "198320efe34bccacbc82d3560758c6d8",
		  
		  "name": "Steven",
		  "createdDate": "2023-03-16 01:00:40",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 76,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 397,
		  "schedulePercent": 0.268019,
		  "totalGuests": 236,
		  "guestPercent": 0.6165,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "The Ranch",
		  "mostGuestCity": "Barrie",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19933e7aff84b7c9add3ae74eb461791",
		  
		  "name": "Chris ",
		  "createdDate": "2014-07-02 16:29:58",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 427,
		  "totalCountries": 5,
		  "totalStates": 51,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2209,
		  "schedulePercent": 0.748867,
		  "totalGuests": 2542,
		  "guestPercent": 0.970082,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19a4a3a4d482a33c232ddb2496af8703",
		  
		  "name": "Katie",
		  "createdDate": "2015-03-04 20:48:12",
		  "totalOrganizations": 20,
		  "totalTours": 50,
		  "totalDays": 1751,
		  "totalCountries": 18,
		  "totalStates": 60,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 4182,
		  "schedulePercent": 0.925091,
		  "totalGuests": 335,
		  "guestPercent": 0.668064,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19b0373dc821d2f3536bf0d8fb7317dd",
		  
		  "name": "Lexie",
		  "createdDate": "2024-10-15 15:45:32",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 511,
		  "totalCountries": 16,
		  "totalStates": 39,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 942,
		  "schedulePercent": 0.473028,
		  "totalGuests": 862,
		  "guestPercent": 0.82151,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19b56769055416bbc989e834c4c15344",
		  
		  "name": "Caly",
		  "createdDate": "2024-05-25 15:48:48",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 201,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 743,
		  "schedulePercent": 0.402312,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19b71bde0c56c488141ea65e5fbe066d",
		  
		  "name": "Colin",
		  "createdDate": "2016-08-12 18:48:22",
		  "totalOrganizations": 14,
		  "totalTours": 9,
		  "totalDays": 414,
		  "totalCountries": 14,
		  "totalStates": 27,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 2024,
		  "schedulePercent": 0.718268,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19ce571172d1fa0886680d9e400887c0",
		  
		  "name": "Jo",
		  "createdDate": "2019-01-14 17:43:24",
		  "totalOrganizations": 13,
		  "totalTours": 18,
		  "totalDays": 689,
		  "totalCountries": 26,
		  "totalStates": 50,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 4134,
		  "schedulePercent": 0.921124,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19ce75ad766a2d3bc0092abe3aa2263f",
		  
		  "name": "Jessica",
		  "createdDate": "2014-03-21 16:28:30",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 784,
		  "totalCountries": 21,
		  "totalStates": 57,
		  "totalEvents": 232,
		  "eventPercent": 0.850408,
		  "totalScheduleItems": 3082,
		  "schedulePercent": 0.849955,
		  "totalGuests": 1055,
		  "guestPercent": 0.855734,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19d858154b3522278114a7952de1c533",
		  
		  "name": "Gentry",
		  "createdDate": "2022-04-07 01:15:43",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 1529,
		  "totalCountries": 20,
		  "totalStates": 38,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 3361,
		  "schedulePercent": 0.871827,
		  "totalGuests": 1290,
		  "guestPercent": 0.884406,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19d8cd80207bdace4c2e7f3b15f8edc5",
		  
		  "name": "Carmen",
		  "createdDate": "2016-02-19 21:49:18",
		  "totalOrganizations": 43,
		  "totalTours": 17,
		  "totalDays": 848,
		  "totalCountries": 15,
		  "totalStates": 35,
		  "totalEvents": 321,
		  "eventPercent": 0.926904,
		  "totalScheduleItems": 6600,
		  "schedulePercent": 0.983114,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Stade de France",
		  "mostGuestCity": "Saint-Denis",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19e0fa5a720185d1317aff4443c09494",
		  
		  "name": "Wilkie",
		  "createdDate": "2013-08-12 12:32:44",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 1093,
		  "totalCountries": 36,
		  "totalStates": 50,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 3762,
		  "schedulePercent": 0.899705,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Pomona Fox Theater",
		  "mostGuestCity": "Pomona",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19eaf3360ced705f11a5c9e4c35d8273",
		  
		  "name": "Amanda",
		  "createdDate": "2016-02-22 06:20:06",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 579,
		  "totalCountries": 24,
		  "totalStates": 25,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1967,
		  "schedulePercent": 0.707389,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "19ff6f24caae3dabd20ec3e39128fcdb",
		  
		  "name": "LiveSource",
		  "createdDate": "2022-05-12 13:15:14",
		  "totalOrganizations": 24,
		  "totalTours": 22,
		  "totalDays": 329,
		  "totalCountries": 16,
		  "totalStates": 33,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1033,
		  "schedulePercent": 0.499547,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a0a87dab02b549c92720a6855ee212f",
		  
		  "name": "Jeff",
		  "createdDate": "2011-11-30 21:05:33",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 506,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 950,
		  "schedulePercent": 0.475635,
		  "totalGuests": 883,
		  "guestPercent": 0.826269,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Orion Amphitheater",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 121,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a0b5dca2a2e052a6a0bd848444d2afd",
		  
		  "name": "Kenneth",
		  "createdDate": "2019-01-11 10:51:51",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 196,
		  "totalCountries": 7,
		  "totalStates": 13,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1261,
		  "schedulePercent": 0.563123,
		  "totalGuests": 448,
		  "guestPercent": 0.711922,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a17bb7b68886aa5223a538d935ed852",
		  
		  "name": "Thomas",
		  "createdDate": "2024-07-15 20:06:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 622,
		  "schedulePercent": 0.358114,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "The Senate",
		  "mostGuestCity": "Columbia",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a1815b39042e620888ff3b7b9d3bd12",
		  
		  "name": "Doug",
		  "createdDate": "2012-09-14 17:34:58",
		  "totalOrganizations": 44,
		  "totalTours": 39,
		  "totalDays": 469,
		  "totalCountries": 22,
		  "totalStates": 59,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 2000,
		  "schedulePercent": 0.713622,
		  "totalGuests": 951,
		  "guestPercent": 0.839642,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Knockdown Center",
		  "mostGuestCity": "Maspeth",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a1e4a351b22e584a364738c4bb5968c",
		  
		  "name": "James",
		  "createdDate": "2024-01-08 14:37:55",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 99,
		  "totalCountries": 14,
		  "totalStates": 34,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Lemon Grove",
		  "mostGuestCity": "Exeter",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a202c5d848438da1e2a1808d2c986b5",
		  
		  "name": "Gia",
		  "createdDate": "2025-03-07 18:10:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 139,
		  "totalCountries": 10,
		  "totalStates": 35,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 1117,
		  "schedulePercent": 0.523119,
		  "totalGuests": 1676,
		  "guestPercent": 0.926564,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a2e6664cd5689d75b50700caa501ee1",
		  
		  "name": "Carol",
		  "createdDate": "2023-02-02 01:58:26",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 449,
		  "totalCountries": 12,
		  "totalStates": 17,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 864,
		  "schedulePercent": 0.446056,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Brisbane Entertainment Centre",
		  "mostGuestCity": "Boondall",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a38d427b5324d5532042eb4769b1f2d",
		  
		  "name": "Dayn",
		  "createdDate": "2013-07-18 16:01:38",
		  "totalOrganizations": 16,
		  "totalTours": 8,
		  "totalDays": 734,
		  "totalCountries": 13,
		  "totalStates": 51,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1956,
		  "schedulePercent": 0.704442,
		  "totalGuests": 525,
		  "guestPercent": 0.737307,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a3d784c3905f1992b07435aa5faad40",
		  
		  "name": "Evan",
		  "createdDate": "2022-08-10 12:58:05",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 1221,
		  "totalCountries": 17,
		  "totalStates": 62,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 2375,
		  "schedulePercent": 0.772099,
		  "totalGuests": 887,
		  "guestPercent": 0.827176,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "The Orpheum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a3f6684e3002dec6a4c63b8ace3bd07",
		  
		  "name": "Billie",
		  "createdDate": "2025-08-25 21:55:34",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 174,
		  "totalCountries": 5,
		  "totalStates": 24,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 605,
		  "schedulePercent": 0.352675,
		  "totalGuests": 247,
		  "guestPercent": 0.623753,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a444f5863b904e626551309e76aa7ec",
		  
		  "name": "Oliver",
		  "createdDate": "2023-07-26 10:22:24",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 572,
		  "totalCountries": 8,
		  "totalStates": 35,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1308,
		  "schedulePercent": 0.573323,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "4118 Old Poole Road, NC 27610",
		  "mostGuestCity": "",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a52388d3dde48334e002d49d1dced7c",
		  
		  "name": "Duncan",
		  "createdDate": "2022-02-28 12:43:47",
		  "totalOrganizations": 47,
		  "totalTours": 24,
		  "totalDays": 2211,
		  "totalCountries": 29,
		  "totalStates": 64,
		  "totalEvents": 477,
		  "eventPercent": 0.974728,
		  "totalScheduleItems": 6683,
		  "schedulePercent": 0.984021,
		  "totalGuests": 1404,
		  "guestPercent": 0.900385,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a5d80e1ecad5a25b11a87ed42b9eec5",
		  
		  "name": "Terrance",
		  "createdDate": "2012-10-23 22:01:06",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 35,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 123,
		  "schedulePercent": 0.113327,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Orleans Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a6214e35332428f79ea59b62c5c0e2f",
		  
		  "name": "William",
		  "createdDate": "2009-08-05 01:38:45",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 556,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2134,
		  "schedulePercent": 0.737307,
		  "totalGuests": 1361,
		  "guestPercent": 0.895059,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a6a77e1042f0d990e53815042e36317",
		  
		  "name": "Stuart",
		  "createdDate": "2019-01-16 08:11:37",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 705,
		  "totalCountries": 23,
		  "totalStates": 44,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 2900,
		  "schedulePercent": 0.831709,
		  "totalGuests": 140,
		  "guestPercent": 0.552357,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a72dce0c7ddc3213ab27ca30ae4a42f",
		  
		  "name": "Lisa",
		  "createdDate": "2025-04-30 19:14:50",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 79,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 224,
		  "schedulePercent": 0.173844,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a7437f39543b215365fa907761f8301",
		  
		  "name": "David ",
		  "createdDate": "2017-08-15 21:39:03",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 549,
		  "totalCountries": 16,
		  "totalStates": 51,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2481,
		  "schedulePercent": 0.784565,
		  "totalGuests": 468,
		  "guestPercent": 0.719515,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a7f435bac11b8f7972a0476bad2a14b",
		  
		  "name": "Drew",
		  "createdDate": "2023-12-01 23:01:45",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 732,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 1119,
		  "schedulePercent": 0.524592,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a8c451c5d7d0bf00a36f23832aaba19",
		  
		  "name": "Company",
		  "createdDate": "2024-02-05 17:35:14",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 346,
		  "totalCountries": 7,
		  "totalStates": 50,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 2943,
		  "schedulePercent": 0.836129,
		  "totalGuests": 437,
		  "guestPercent": 0.708522,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Terrace Theatre",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a91dc49d49f032ece2c93e0b58d5c57",
		  
		  "name": "Drew",
		  "createdDate": "2020-01-13 22:13:34",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 143,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 929,
		  "schedulePercent": 0.468495,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "The Espee",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a93a9bb1a47b8dded1e26f6b69382f2",
		  
		  "name": "Ashley",
		  "createdDate": "2020-01-29 20:25:41",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 1117,
		  "totalCountries": 26,
		  "totalStates": 63,
		  "totalEvents": 341,
		  "eventPercent": 0.936877,
		  "totalScheduleItems": 4823,
		  "schedulePercent": 0.948096,
		  "totalGuests": 3048,
		  "guestPercent": 0.982888,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Cadence Bank Amphitheatre At Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1a9d3b9df7532542bcf1ce1f46a08e36",
		  
		  "name": "Susan",
		  "createdDate": "2018-01-31 06:02:27",
		  "totalOrganizations": 5,
		  "totalTours": 24,
		  "totalDays": 889,
		  "totalCountries": 6,
		  "totalStates": 15,
		  "totalEvents": 468,
		  "eventPercent": 0.973481,
		  "totalScheduleItems": 4771,
		  "schedulePercent": 0.94685,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1aa429248fe41c6fa0e082b709e66020",
		  
		  "name": "Tammie",
		  "createdDate": "2025-06-30 18:28:07",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 79,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1aa8f9a2e030c641e916b7b6469182fb",
		  
		  "name": "Michael",
		  "createdDate": "2024-10-02 16:03:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 288,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 543,
		  "schedulePercent": 0.331369,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "Bluebird Theater",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1aba14ef840e644c97c803baa6a3c8b2",
		  
		  "name": "Ella",
		  "createdDate": "2025-02-27 07:54:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 306,
		  "totalCountries": 13,
		  "totalStates": 23,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 359,
		  "schedulePercent": 0.24762,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "CRSSD",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1abc2b7a3293fa1fee1991d874f5ace1",
		  
		  "name": "Alison",
		  "createdDate": "2017-07-27 18:33:32",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 297,
		  "totalCountries": 16,
		  "totalStates": 46,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 1520,
		  "schedulePercent": 0.621827,
		  "totalGuests": 598,
		  "guestPercent": 0.75748,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1abdaa23263e42ad023b8bc54a6651ac",
		  
		  "name": "Miia",
		  "createdDate": "2025-02-06 10:25:04",
		  "totalOrganizations": 49,
		  "totalTours": 87,
		  "totalDays": 2785,
		  "totalCountries": 4,
		  "totalStates": 4,
		  "totalEvents": 492,
		  "eventPercent": 0.977901,
		  "totalScheduleItems": 2706,
		  "schedulePercent": 0.809157,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Festivaali",
		  "mostGuestCity": "Tampere",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ac3213c3d9024544539de573c525081",
		  
		  "name": "Lloyd",
		  "createdDate": "2017-09-30 03:41:53",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 260,
		  "totalCountries": 17,
		  "totalStates": 46,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1334,
		  "schedulePercent": 0.581369,
		  "totalGuests": 503,
		  "guestPercent": 0.731528,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ac767e3b3d033a6757751a3c8ab41f6",
		  
		  "name": "Mark",
		  "createdDate": "2019-07-16 12:35:05",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 73,
		  "totalCountries": 9,
		  "totalStates": 21,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 468,
		  "schedulePercent": 0.297484,
		  "totalGuests": 107,
		  "guestPercent": 0.526292,
		  "mostGuestDate": "2025-05-12 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ac96c0ab0202c7289e5a9caa0209c3d",
		  
		  "name": "Darrick",
		  "createdDate": "2023-07-17 18:49:19",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 893,
		  "totalCountries": 6,
		  "totalStates": 35,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1071,
		  "schedulePercent": 0.511106,
		  "totalGuests": 144,
		  "guestPercent": 0.554624,
		  "mostGuestDate": "2025-12-05 00:00:00",
		  "mostGuestName": "Sphere",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ad94581b390fc45798d193b2279110f",
		  
		  "name": "Marko",
		  "createdDate": "2025-02-06 10:25:46",
		  "totalOrganizations": 59,
		  "totalTours": 86,
		  "totalDays": 2783,
		  "totalCountries": 4,
		  "totalStates": 4,
		  "totalEvents": 491,
		  "eventPercent": 0.977561,
		  "totalScheduleItems": 2692,
		  "schedulePercent": 0.808024,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Festivaali",
		  "mostGuestCity": "Tampere",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1afa04f6cc12c76dfcd970f2fa8b4cdb",
		  
		  "name": "Jose",
		  "createdDate": "2018-07-26 20:32:23",
		  "totalOrganizations": 10,
		  "totalTours": 21,
		  "totalDays": 1019,
		  "totalCountries": 29,
		  "totalStates": 79,
		  "totalEvents": 311,
		  "eventPercent": 0.919878,
		  "totalScheduleItems": 4769,
		  "schedulePercent": 0.946736,
		  "totalGuests": 900,
		  "guestPercent": 0.830236,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Myth Live",
		  "mostGuestCity": "Maplewood",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1aff2679c7ceb806f95dabb8d5a89aac",
		  
		  "name": "Jordan",
		  "createdDate": "2011-01-31 22:44:29",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 254,
		  "totalCountries": 4,
		  "totalStates": 30,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 797,
		  "schedulePercent": 0.421464,
		  "totalGuests": 392,
		  "guestPercent": 0.690956,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b0214d3122424fe80bf53aad66f1da7",
		  
		  "name": "Tara",
		  "createdDate": "2013-03-04 18:39:34",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 66,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 392,
		  "schedulePercent": 0.265866,
		  "totalGuests": 132,
		  "guestPercent": 0.546124,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Warehouse Live",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b1172654bc8238872b7c4e3a63487c5",
		  
		  "name": "Chelsey",
		  "createdDate": "2024-11-01 18:55:44",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 185,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1400,
		  "schedulePercent": 0.597801,
		  "totalGuests": 1756,
		  "guestPercent": 0.93053,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b37314c79c853e20e51ae4f60d9b9ff",
		  
		  "name": "Libby",
		  "createdDate": "2025-09-05 15:10:40",
		  "totalOrganizations": 74,
		  "totalTours": 41,
		  "totalDays": 2529,
		  "totalCountries": 19,
		  "totalStates": 34,
		  "totalEvents": 652,
		  "eventPercent": 0.990027,
		  "totalScheduleItems": 4204,
		  "schedulePercent": 0.925884,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Buxton Opera House",
		  "mostGuestCity": " Buxton, Derbyshire, SK17 6AZ",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b44e89e02c48f953f4823a9da9bca9d",
		  
		  "name": "Olive",
		  "createdDate": "2022-04-22 13:52:33",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 59,
		  "totalCountries": 10,
		  "totalStates": 9,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 329,
		  "schedulePercent": 0.230508,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Wider than Pictures",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b4bb7a60a935bb225125e15a2ef40c8",
		  
		  "name": "Eliza",
		  "createdDate": "2023-08-28 17:58:39",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 66,
		  "totalCountries": 14,
		  "totalStates": 12,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 247,
		  "schedulePercent": 0.18835,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b4c5b825ad08376f88adcbcf465760f",
		  
		  "name": "Kenia",
		  "createdDate": "2025-04-24 15:40:27",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 52,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 243,
		  "schedulePercent": 0.186083,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b5c5d0bd6a0ece480790c5f3c9c9a7a",
		  
		  "name": "Miriam",
		  "createdDate": "2023-10-30 23:00:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 129,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 121,
		  "schedulePercent": 0.111627,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Bonnaroo Arts And Music Festival",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b631824ab7fa9d6a74ded41e56aa0c5",
		  
		  "name": "Stu",
		  "createdDate": "2024-03-12 03:20:56",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 929,
		  "totalCountries": 4,
		  "totalStates": 24,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 983,
		  "schedulePercent": 0.486061,
		  "totalGuests": 163,
		  "guestPercent": 0.568223,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Arms Pub",
		  "mostGuestCity": "Port Coquitlam",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b8477581febc2895333e1eeac9ce180",
		  
		  "name": "Alex",
		  "createdDate": "2024-01-02 03:06:17",
		  "totalOrganizations": 9,
		  "totalTours": 18,
		  "totalDays": 2450,
		  "totalCountries": 24,
		  "totalStates": 66,
		  "totalEvents": 491,
		  "eventPercent": 0.977561,
		  "totalScheduleItems": 6547,
		  "schedulePercent": 0.982548,
		  "totalGuests": 1953,
		  "guestPercent": 0.94345,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Champion Forest Baptist Church - Champions Campus",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1b84e0ea42df3d1160e4ecc44ddc6336",
		  
		  "name": "Monique",
		  "createdDate": "2022-05-12 13:11:34",
		  "totalOrganizations": 14,
		  "totalTours": 36,
		  "totalDays": 709,
		  "totalCountries": 30,
		  "totalStates": 93,
		  "totalEvents": 387,
		  "eventPercent": 0.955349,
		  "totalScheduleItems": 4733,
		  "schedulePercent": 0.945716,
		  "totalGuests": 2828,
		  "guestPercent": 0.978355,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ba2d29d0700d8a695c0ab1348c2e6b1",
		  
		  "name": "Witty",
		  "createdDate": "2024-08-20 07:41:08",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 187,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1519,
		  "schedulePercent": 0.6216,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ba356fa5474d7b4166db01f7e342117",
		  
		  "name": "Ivan",
		  "createdDate": "2015-11-09 23:41:23",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 336,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 982,
		  "schedulePercent": 0.485267,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ba7aba97d75e73f0203cd8621d19efb",
		  
		  "name": "Jesse",
		  "createdDate": "2020-03-02 20:31:23",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 279,
		  "totalCountries": 11,
		  "totalStates": 50,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1886,
		  "schedulePercent": 0.692316,
		  "totalGuests": 1637,
		  "guestPercent": 0.923277,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1bb2fa2d57e511f698114a1070182ddc",
		  
		  "name": "Steve",
		  "createdDate": "2023-01-09 20:00:12",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 840,
		  "schedulePercent": 0.437443,
		  "totalGuests": 586,
		  "guestPercent": 0.755213,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1bb3919c20179bee10e375c53887effb",
		  
		  "name": "DEREK",
		  "createdDate": "2019-07-14 00:03:22",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 1679,
		  "totalCountries": 26,
		  "totalStates": 48,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 1583,
		  "schedulePercent": 0.637126,
		  "totalGuests": 131,
		  "guestPercent": 0.545444,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1bc0acdd9f35d0b11aa5fce78d91dd6d",
		  
		  "name": "Liad",
		  "createdDate": "2025-07-28 17:28:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 20,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 154,
		  "schedulePercent": 0.132026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1bd30ea72841102f96e895c23f0320d2",
		  
		  "name": "Milo",
		  "createdDate": "2022-06-04 07:04:48",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 693,
		  "totalCountries": 23,
		  "totalStates": 34,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1235,
		  "schedulePercent": 0.555984,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Lab11",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1bda9f0c74357e831198021042661204",
		  
		  "name": "Jennifer",
		  "createdDate": "2017-09-19 14:14:04",
		  "totalOrganizations": 15,
		  "totalTours": 16,
		  "totalDays": 1373,
		  "totalCountries": 39,
		  "totalStates": 85,
		  "totalEvents": 325,
		  "eventPercent": 0.93053,
		  "totalScheduleItems": 5438,
		  "schedulePercent": 0.966455,
		  "totalGuests": 523,
		  "guestPercent": 0.736967,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Avondale Brewing Company",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1bf1c648853de5c13611534276832648",
		  
		  "name": "Aaron",
		  "createdDate": "2014-10-26 17:52:24",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 124,
		  "totalCountries": 16,
		  "totalStates": 33,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 756,
		  "schedulePercent": 0.407978,
		  "totalGuests": 236,
		  "guestPercent": 0.6165,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "House of Blues Chicago",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1bfa1b42acb9f7961b07b76f1637b8de",
		  
		  "name": "Toby",
		  "createdDate": "2018-10-05 16:16:31",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 64,
		  "totalCountries": 11,
		  "totalStates": 26,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c02600b000f202224160dec48bd3aa6",
		  
		  "name": "Scot",
		  "createdDate": "2021-11-12 01:23:06",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 196,
		  "schedulePercent": 0.158772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c0d5bfc372286eb50c2197f1e9271d3",
		  
		  "name": "Amber",
		  "createdDate": "2024-12-30 16:53:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Bryce Jordan Center",
		  "mostGuestCity": "University Park",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c0e936ab73d64a0fba9a3c1d420e232",
		  
		  "name": "Emma",
		  "createdDate": "2021-10-23 22:33:50",
		  "totalOrganizations": 10,
		  "totalTours": 19,
		  "totalDays": 637,
		  "totalCountries": 16,
		  "totalStates": 57,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 1968,
		  "schedulePercent": 0.707616,
		  "totalGuests": 416,
		  "guestPercent": 0.699909,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c1da2305d672f04a38b19ed71b02e6e",
		  
		  "name": "Joel",
		  "createdDate": "2018-06-19 03:41:40",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 653,
		  "totalCountries": 14,
		  "totalStates": 50,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 2486,
		  "schedulePercent": 0.785018,
		  "totalGuests": 1257,
		  "guestPercent": 0.88146,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c22ca5a54101d9cdce93b21210f5d28",
		  
		  "name": "Andy ",
		  "createdDate": "2020-01-10 20:10:12",
		  "totalOrganizations": 11,
		  "totalTours": 16,
		  "totalDays": 653,
		  "totalCountries": 7,
		  "totalStates": 52,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 3695,
		  "schedulePercent": 0.895626,
		  "totalGuests": 1272,
		  "guestPercent": 0.882706,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c24f497ed92b8cc10a4139522445fda",
		  
		  "name": "B",
		  "createdDate": "2023-05-23 05:47:36",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 598,
		  "totalCountries": 17,
		  "totalStates": 77,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1065,
		  "schedulePercent": 0.50816,
		  "totalGuests": 496,
		  "guestPercent": 0.729148,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c2e07c29f8cc06141e4a1b594020d90",
		  
		  "name": "Circa",
		  "createdDate": "2015-12-08 17:00:07",
		  "totalOrganizations": 43,
		  "totalTours": 29,
		  "totalDays": 1362,
		  "totalCountries": 14,
		  "totalStates": 23,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 3285,
		  "schedulePercent": 0.867067,
		  "totalGuests": 62,
		  "guestPercent": 0.473368,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Hamer Hall",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c355f9baf29263c44528fc4d98079bf",
		  
		  "name": "Laurie",
		  "createdDate": "2024-02-01 13:40:16",
		  "totalOrganizations": 1,
		  "totalTours": 23,
		  "totalDays": 423,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 218,
		  "schedulePercent": 0.170558,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "La Place, centre culturel Hip-Hop",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c3df2fac9badd6350625d6bbe8aed2b",
		  
		  "name": "Jorge",
		  "createdDate": "2018-05-13 22:00:45",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 368,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 490,
		  "schedulePercent": 0.307344,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c5506ab1e21657e505fac32530b3980",
		  
		  "name": "Sweet",
		  "createdDate": "2022-09-11 11:52:43",
		  "totalOrganizations": 5,
		  "totalTours": 17,
		  "totalDays": 384,
		  "totalCountries": 16,
		  "totalStates": 55,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 2355,
		  "schedulePercent": 0.769379,
		  "totalGuests": 1074,
		  "guestPercent": 0.859134,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c5e78182494b155c27d2c035e4d0918",
		  
		  "name": "Luke",
		  "createdDate": "2013-03-04 22:07:26",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 480,
		  "totalCountries": 16,
		  "totalStates": 52,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 2639,
		  "schedulePercent": 0.801904,
		  "totalGuests": 1582,
		  "guestPercent": 0.917838,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Thompson's Point",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c61dd2c5c2b7c6678278b15ece2fa09",
		  
		  "name": "Gift",
		  "createdDate": "2024-09-05 03:28:04",
		  "totalOrganizations": 2,
		  "totalTours": 43,
		  "totalDays": 173,
		  "totalCountries": 9,
		  "totalStates": 26,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 783,
		  "schedulePercent": 0.416704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c72cf02be35fbbaf746f4aa5275610c",
		  
		  "name": "Evan",
		  "createdDate": "2025-09-17 18:08:03",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 32,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 117,
		  "schedulePercent": 0.108794,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c824f6971e8a5c3709e726b743be58d",
		  
		  "name": "Nataliia",
		  "createdDate": "2021-10-06 12:49:32",
		  "totalOrganizations": 14,
		  "totalTours": 38,
		  "totalDays": 652,
		  "totalCountries": 42,
		  "totalStates": 98,
		  "totalEvents": 318,
		  "eventPercent": 0.924411,
		  "totalScheduleItems": 5850,
		  "schedulePercent": 0.973708,
		  "totalGuests": 1429,
		  "guestPercent": 0.903219,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c9a9f46de464b6f71129bd44ea6d97e",
		  
		  "name": "Trina",
		  "createdDate": "2011-03-22 17:41:05",
		  "totalOrganizations": 17,
		  "totalTours": 21,
		  "totalDays": 1540,
		  "totalCountries": 30,
		  "totalStates": 85,
		  "totalEvents": 369,
		  "eventPercent": 0.949229,
		  "totalScheduleItems": 5695,
		  "schedulePercent": 0.971442,
		  "totalGuests": 2208,
		  "guestPercent": 0.958182,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c9dc2caa63709fcf8d346be9e4650e7",
		  
		  "name": "Hilarie",
		  "createdDate": "2025-03-02 21:24:00",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 90,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 388,
		  "schedulePercent": 0.263486,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1c9e8e089a1ab778c4ed5ab03249b2f1",
		  
		  "name": "Cody ",
		  "createdDate": "2017-08-30 15:51:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1448,
		  "schedulePercent": 0.606981,
		  "totalGuests": 557,
		  "guestPercent": 0.74558,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "The Today Show",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ca0b62089fcc32eb4c8f04fd2500305",
		  
		  "name": "Curtis",
		  "createdDate": "2013-07-15 20:55:34",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 570,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 826,
		  "schedulePercent": 0.433024,
		  "totalGuests": 933,
		  "guestPercent": 0.836355,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Orion Amphitheater",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 121,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ca0eef59eaeeea0a91bc9d12a43ca07",
		  
		  "name": "Adrian",
		  "createdDate": "2022-11-07 17:12:03",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 691,
		  "totalCountries": 8,
		  "totalStates": 62,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 3654,
		  "schedulePercent": 0.893019,
		  "totalGuests": 895,
		  "guestPercent": 0.828536,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Amica Mutual Pavilion",
		  "mostGuestCity": "Providence",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ca727baab99885ce4629f349427beff",
		  
		  "name": "Bryan",
		  "createdDate": "2021-09-08 16:52:51",
		  "totalOrganizations": 20,
		  "totalTours": 14,
		  "totalDays": 1866,
		  "totalCountries": 29,
		  "totalStates": 52,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1396,
		  "schedulePercent": 0.597008,
		  "totalGuests": 330,
		  "guestPercent": 0.666138,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ca7d77ce2f1c542abc78101963a1945",
		  
		  "name": "DOMINIC",
		  "createdDate": "2025-02-23 16:43:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 176,
		  "totalCountries": 17,
		  "totalStates": 11,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 1354,
		  "schedulePercent": 0.586129,
		  "totalGuests": 510,
		  "guestPercent": 0.733001,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Magazine London",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ca9a290244f06d466f51388ba73706d",
		  
		  "name": "Scott",
		  "createdDate": "2019-04-11 16:51:12",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 202,
		  "totalCountries": 20,
		  "totalStates": 53,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 2013,
		  "schedulePercent": 0.715662,
		  "totalGuests": 2015,
		  "guestPercent": 0.948209,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1cae440d6e758148a6b27ee805094cdf",
		  
		  "name": "Phillippa",
		  "createdDate": "2024-05-11 12:50:31",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 137,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 734,
		  "schedulePercent": 0.399705,
		  "totalGuests": 1210,
		  "guestPercent": 0.876813,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Utilita Arena Birmingham",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1cb3f9d42d1ed4602277c9d38cf63ab7",
		  
		  "name": "Ben",
		  "createdDate": "2024-09-18 04:22:20",
		  "totalOrganizations": 2,
		  "totalTours": 23,
		  "totalDays": 152,
		  "totalCountries": 6,
		  "totalStates": 10,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1cc3f0eb898d08648c9bb4ce67466339",
		  
		  "name": "Peter",
		  "createdDate": "2020-01-09 10:06:23",
		  "totalOrganizations": 125,
		  "totalTours": 90,
		  "totalDays": 1750,
		  "totalCountries": 27,
		  "totalStates": 93,
		  "totalEvents": 997,
		  "eventPercent": 0.99558,
		  "totalScheduleItems": 8653,
		  "schedulePercent": 0.99252,
		  "totalGuests": 2678,
		  "guestPercent": 0.975181,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1cceddf1e470a7fc81ba8dce376738c8",
		  
		  "name": "Carey",
		  "createdDate": "2015-12-03 19:55:49",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 299,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 949,
		  "schedulePercent": 0.475181,
		  "totalGuests": 526,
		  "guestPercent": 0.737534,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Boulder Theater",
		  "mostGuestCity": "Boulder",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1cd3734ef62d5b1f57e54d22ef79d87a",
		  
		  "name": "Si",
		  "createdDate": "2014-04-25 06:45:32",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 78,
		  "totalCountries": 8,
		  "totalStates": 28,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 427,
		  "schedulePercent": 0.280938,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-03 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1cd72263b08b0878e8ed544dba1bd7bf",
		  
		  "name": "Marius",
		  "createdDate": "2025-07-04 06:33:55",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 70,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ce7997bdeccf98baa4c65605c905033",
		  
		  "name": "Tour",
		  "createdDate": "2016-03-01 18:04:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 98,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 425,
		  "schedulePercent": 0.280032,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "Great Stage Park",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1cf2c01edb09579006b51653a31c3473",
		  
		  "name": "jerry",
		  "createdDate": "2023-06-27 19:49:08",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 407,
		  "totalCountries": 6,
		  "totalStates": 52,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1618,
		  "schedulePercent": 0.643586,
		  "totalGuests": 932,
		  "guestPercent": 0.836129,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d06262e4fb9a3f2f1fd8d19e6ace742",
		  
		  "name": "Sean",
		  "createdDate": "2011-11-16 19:05:09",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 812,
		  "totalCountries": 21,
		  "totalStates": 39,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 4229,
		  "schedulePercent": 0.928037,
		  "totalGuests": 472,
		  "guestPercent": 0.721328,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Innings Festival - Tempe Beach Park Ampitheatre",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d10d2de0193def97b9f40a45e87c283",
		  
		  "name": "Bill",
		  "createdDate": "2023-03-20 21:44:52",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 1133,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Republic NOLA",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d14c613c62f63eacdebab80e0c01a7e",
		  
		  "name": "Abbey",
		  "createdDate": "2016-02-02 14:27:34",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 263,
		  "totalCountries": 14,
		  "totalStates": 31,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 385,
		  "schedulePercent": 0.260993,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Kesselhaus in der Kulturbrauerei",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d18e7db4b354bbc5977333916988327",
		  
		  "name": "Tawnya",
		  "createdDate": "2025-10-20 16:03:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 53,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 16,
		  "schedulePercent": 0.0260653,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d1fef776e23cbc1b15b26053b750bda",
		  
		  "name": "Dimitri",
		  "createdDate": "2015-06-10 12:47:49",
		  "totalOrganizations": 20,
		  "totalTours": 18,
		  "totalDays": 443,
		  "totalCountries": 14,
		  "totalStates": 11,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1327,
		  "schedulePercent": 0.578309,
		  "totalGuests": 138,
		  "guestPercent": 0.550997,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Hurricane Festival",
		  "mostGuestCity": "ScheeÃŸel",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d235fe0c3cf294bf1e8283943048277",
		  
		  "name": "Kessiah",
		  "createdDate": "2013-08-23 11:33:59",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 467,
		  "totalCountries": 19,
		  "totalStates": 57,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 2737,
		  "schedulePercent": 0.814483,
		  "totalGuests": 2647,
		  "guestPercent": 0.974048,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "The Met Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d2c81d111144cfb7c48fc7828ebcd05",
		  
		  "name": "Yolanda",
		  "createdDate": "2024-10-21 16:40:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 362,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 913,
		  "schedulePercent": 0.462602,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d2e7c789b6bfe6e87eb36b7f7fb47ea",
		  
		  "name": "Darien",
		  "createdDate": "2015-09-16 14:45:43",
		  "totalOrganizations": 8,
		  "totalTours": 17,
		  "totalDays": 133,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 804,
		  "schedulePercent": 0.424071,
		  "totalGuests": 1074,
		  "guestPercent": 0.859134,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d3a4e030cd903efc667cc2d2e26d3e3",
		  
		  "name": "Jonathan",
		  "createdDate": "2017-11-09 21:36:08",
		  "totalOrganizations": 2,
		  "totalTours": 18,
		  "totalDays": 117,
		  "totalCountries": 9,
		  "totalStates": 24,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 508,
		  "schedulePercent": 0.31471,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d420cb5825083dde71bf4d63c530a70",
		  
		  "name": "Lauren",
		  "createdDate": "2017-05-07 08:34:43",
		  "totalOrganizations": 13,
		  "totalTours": 19,
		  "totalDays": 799,
		  "totalCountries": 14,
		  "totalStates": 62,
		  "totalEvents": 271,
		  "eventPercent": 0.891092,
		  "totalScheduleItems": 4133,
		  "schedulePercent": 0.921011,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d46d329c35087f1989f945426262a4f",
		  
		  "name": "Caroline",
		  "createdDate": "2023-02-28 23:04:07",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 894,
		  "totalCountries": 21,
		  "totalStates": 78,
		  "totalEvents": 344,
		  "eventPercent": 0.93937,
		  "totalScheduleItems": 4026,
		  "schedulePercent": 0.915005,
		  "totalGuests": 678,
		  "guestPercent": 0.780372,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "TQL Stadium",
		  "mostGuestCity": "Cincinnati",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d54d845f79d591efe885eeeb9a8fa3d",
		  
		  "name": "Twiggy",
		  "createdDate": "2022-07-09 20:01:03",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 274,
		  "totalCountries": 24,
		  "totalStates": 50,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 2168,
		  "schedulePercent": 0.74218,
		  "totalGuests": 671,
		  "guestPercent": 0.778332,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d55c5a18ec84d71f7480bcba1d97534",
		  
		  "name": "Alexis",
		  "createdDate": "2024-06-13 23:08:52",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 500,
		  "totalCountries": 13,
		  "totalStates": 27,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1132,
		  "schedulePercent": 0.528785,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d593adb7c33b3e89bb73384ef6849dc",
		  
		  "name": "Graham",
		  "createdDate": "2020-02-10 23:49:27",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 7,
		  "totalStates": 13,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 230,
		  "schedulePercent": 0.177697,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Williams Center",
		  "mostGuestCity": "Rutherford",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d640660a2435b6c7644a8383c3bc699",
		  
		  "name": "Adam",
		  "createdDate": "2019-09-25 16:08:03",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 58,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 136,
		  "schedulePercent": 0.122507,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Rose Music Hall",
		  "mostGuestCity": "Columbia",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d7335100d8a55f50ce9d5d1b0b2b8a8",
		  
		  "name": "Hayo",
		  "createdDate": "2020-01-27 21:01:52",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 490,
		  "totalCountries": 29,
		  "totalStates": 31,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 953,
		  "schedulePercent": 0.477108,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d7decc29c5faa424770883e67da2515",
		  
		  "name": "Brad",
		  "createdDate": "2014-12-29 20:07:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 120,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 671,
		  "schedulePercent": 0.375227,
		  "totalGuests": 440,
		  "guestPercent": 0.709315,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Luckenbach Texas",
		  "mostGuestCity": "Fredericksburg",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d808ea878e4aa1da82042e83e5f6b7c",
		  
		  "name": "Glen",
		  "createdDate": "2017-06-15 16:15:16",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 132,
		  "totalCountries": 6,
		  "totalStates": 33,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 503,
		  "schedulePercent": 0.313123,
		  "totalGuests": 677,
		  "guestPercent": 0.780145,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d81a3aaf528854975c17ac45d9e80ce",
		  
		  "name": "Devan",
		  "createdDate": "2024-02-09 18:22:13",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 736,
		  "totalCountries": 5,
		  "totalStates": 40,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2711,
		  "schedulePercent": 0.81029,
		  "totalGuests": 665,
		  "guestPercent": 0.775725,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d8340d3ed831837450111a179b3e188",
		  
		  "name": "Megan",
		  "createdDate": "2024-01-29 17:13:38",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 2191,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 1138,
		  "schedulePercent": 0.531165,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Constellation Room",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d91ba81c97f4809f004a1f4d95343b9",
		  
		  "name": "Sydney",
		  "createdDate": "2024-08-20 02:51:27",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 109,
		  "totalCountries": 17,
		  "totalStates": 45,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 795,
		  "schedulePercent": 0.420784,
		  "totalGuests": 373,
		  "guestPercent": 0.682457,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "The Van Buren",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d9a8c15de19d3c23a83cc40e954d9b2",
		  
		  "name": "Michael",
		  "createdDate": "2014-04-02 16:29:12",
		  "totalOrganizations": 5,
		  "totalTours": 14,
		  "totalDays": 833,
		  "totalCountries": 15,
		  "totalStates": 42,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 3381,
		  "schedulePercent": 0.87398,
		  "totalGuests": 51,
		  "guestPercent": 0.454329,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "Sidney Myer Music Bowl",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d9de07639295386f1b694a49ad27f5d",
		  
		  "name": "Claus",
		  "createdDate": "2019-02-27 08:46:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 4,
		  "totalStates": 1,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 132,
		  "schedulePercent": 0.119674,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1d9eddb0155eb9b1090a6e97a44d8ce9",
		  
		  "name": "Mark",
		  "createdDate": "2012-06-24 16:38:00",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 381,
		  "totalCountries": 18,
		  "totalStates": 21,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1280,
		  "schedulePercent": 0.567316,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Studebaker Theater",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1da3f430e734416deb14c7dc626839d5",
		  
		  "name": "Nemo",
		  "createdDate": "2023-09-13 20:08:09",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 297,
		  "totalCountries": 19,
		  "totalStates": 50,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1148,
		  "schedulePercent": 0.533885,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-01-10 00:00:00",
		  "mostGuestName": "Thunder Valley Casino Resort",
		  "mostGuestCity": "Lincoln",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1da8063cdeba65a9c434b9959b8292f2",
		  
		  "name": "Riley",
		  "createdDate": "2024-05-30 19:02:00",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 123,
		  "totalCountries": 5,
		  "totalStates": 25,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 621,
		  "schedulePercent": 0.357548,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "Cambridge Room",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1db1166bcd6a1f0602ea54f56cf572fe",
		  
		  "name": "DaithÃ\u00AD",
		  "createdDate": "2022-11-11 17:35:26",
		  "totalOrganizations": 15,
		  "totalTours": 13,
		  "totalDays": 615,
		  "totalCountries": 28,
		  "totalStates": 64,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 2628,
		  "schedulePercent": 0.800884,
		  "totalGuests": 659,
		  "guestPercent": 0.773572,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1dbea447517b5027625a6db7f4cdd33c",
		  
		  "name": "Mayumi",
		  "createdDate": "2025-05-21 19:40:16",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 131,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 638,
		  "schedulePercent": 0.363781,
		  "totalGuests": 1824,
		  "guestPercent": 0.934497,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1dc0246aca1583ac55fd02c72ec8b0ba",
		  
		  "name": "Art",
		  "createdDate": "2021-12-12 01:37:07",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 290,
		  "totalCountries": 15,
		  "totalStates": 39,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 899,
		  "schedulePercent": 0.457842,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1dc8ea581780908d202184cf9cc421f9",
		  
		  "name": "Clyde",
		  "createdDate": "2018-05-22 05:48:54",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 338,
		  "totalCountries": 20,
		  "totalStates": 30,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1490,
		  "schedulePercent": 0.615594,
		  "totalGuests": 718,
		  "guestPercent": 0.790005,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1dd3d1016d7b369e3054d06ec91ee446",
		  
		  "name": "Mahssa",
		  "createdDate": "2018-09-19 02:23:45",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 60,
		  "totalCountries": 14,
		  "totalStates": 17,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 330,
		  "schedulePercent": 0.230961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1dd524bfee94353fce44db9142f14fd6",
		  
		  "name": "Dogwood",
		  "createdDate": "2025-03-05 17:54:21",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 478,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1df12d607705443d253a5fc0f7a38f9a",
		  
		  "name": "Lauren",
		  "createdDate": "2023-02-24 15:09:45",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 351,
		  "totalCountries": 13,
		  "totalStates": 38,
		  "totalEvents": 230,
		  "eventPercent": 0.848595,
		  "totalScheduleItems": 2201,
		  "schedulePercent": 0.74796,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1df157971b9023f371018ef804dd0aa0",
		  
		  "name": "Mitch",
		  "createdDate": "2019-09-04 19:13:08",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 894,
		  "totalCountries": 25,
		  "totalStates": 64,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 3998,
		  "schedulePercent": 0.913418,
		  "totalGuests": 660,
		  "guestPercent": 0.774252,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1df7cdd67446df593a0b3bfa483d2cf2",
		  
		  "name": "MATT",
		  "createdDate": "2016-03-26 21:03:58",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 621,
		  "totalCountries": 14,
		  "totalStates": 45,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 2984,
		  "schedulePercent": 0.841228,
		  "totalGuests": 417,
		  "guestPercent": 0.700363,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "MGM Grand",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1dff9396bb4eee7ae29ed45e35c04050",
		  
		  "name": "Harry",
		  "createdDate": "2019-04-25 18:25:16",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 269,
		  "totalCountries": 23,
		  "totalStates": 33,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1214,
		  "schedulePercent": 0.550317,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "O2 Apollo Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e0d0198d6ec37963735347694596a59",
		  
		  "name": "Alana",
		  "createdDate": "2023-06-08 17:11:47",
		  "totalOrganizations": 6,
		  "totalTours": 21,
		  "totalDays": 655,
		  "totalCountries": 26,
		  "totalStates": 86,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 3847,
		  "schedulePercent": 0.905485,
		  "totalGuests": 1651,
		  "guestPercent": 0.924184,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e1a519797d6506166095dc7a2908680",
		  
		  "name": "Marc",
		  "createdDate": "2012-12-09 15:10:47",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 197,
		  "totalCountries": 4,
		  "totalStates": 19,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 458,
		  "schedulePercent": 0.293858,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e239c63cc5210b21f9444d378bdeecf",
		  
		  "name": "Mike",
		  "createdDate": "2019-04-10 11:38:08",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 170,
		  "totalCountries": 16,
		  "totalStates": 24,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 758,
		  "schedulePercent": 0.408885,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Capitol ",
		  "mostGuestCity": "Mannheim",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e28f01234276afab480ff6d9ae78fe3",
		  
		  "name": "James",
		  "createdDate": "2023-10-13 21:39:09",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 250,
		  "totalCountries": 8,
		  "totalStates": 43,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 2197,
		  "schedulePercent": 0.74762,
		  "totalGuests": 1082,
		  "guestPercent": 0.861061,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Moody Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e2b1fb227767ea6da6523cd0de756a8",
		  
		  "name": "Alyssa",
		  "createdDate": "2018-05-14 17:27:20",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 218,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1701,
		  "schedulePercent": 0.658772,
		  "totalGuests": 990,
		  "guestPercent": 0.844062,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 184,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e2c418d7ee6dc972bef918b3c38337b",
		  
		  "name": "Mark",
		  "createdDate": "2014-12-12 18:23:07",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 287,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1521,
		  "schedulePercent": 0.622054,
		  "totalGuests": 2696,
		  "guestPercent": 0.975635,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e3eba2c7b7f74c89acc952730a613b3",
		  
		  "name": "Niklas",
		  "createdDate": "2023-11-12 20:17:30",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 171,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 30,
		  "schedulePercent": 0.0407978,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e62b64d8d88f6b8ff310b465bb456ec",
		  
		  "name": "Letisha ",
		  "createdDate": "2024-01-05 07:24:10",
		  "totalOrganizations": 4,
		  "totalTours": 28,
		  "totalDays": 516,
		  "totalCountries": 16,
		  "totalStates": 62,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 2795,
		  "schedulePercent": 0.82151,
		  "totalGuests": 879,
		  "guestPercent": 0.824569,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e6309b2a088376ecddb2a5355dcf735",
		  
		  "name": "Scott",
		  "createdDate": "2017-07-03 23:03:54",
		  "totalOrganizations": 16,
		  "totalTours": 11,
		  "totalDays": 1393,
		  "totalCountries": 30,
		  "totalStates": 86,
		  "totalEvents": 348,
		  "eventPercent": 0.941523,
		  "totalScheduleItems": 3751,
		  "schedulePercent": 0.898799,
		  "totalGuests": 784,
		  "guestPercent": 0.80417,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e63b6eaf56b72aeea67ad45b4900f22",
		  
		  "name": "Andy",
		  "createdDate": "2019-06-20 11:48:58",
		  "totalOrganizations": 23,
		  "totalTours": 11,
		  "totalDays": 806,
		  "totalCountries": 38,
		  "totalStates": 49,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 2804,
		  "schedulePercent": 0.822643,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "NOS Alive",
		  "mostGuestCity": "Alges",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e6d84a03dcdae707f30ad77116e5763",
		  
		  "name": "Keaton",
		  "createdDate": "2018-09-11 19:36:10",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 356,
		  "totalCountries": 18,
		  "totalStates": 53,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1040,
		  "schedulePercent": 0.501587,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "After Hours Concerts",
		  "mostGuestCity": "Doswell",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e722c82fc8499c2dd1c5bd4cccfcfe7",
		  
		  "name": "Elyse",
		  "createdDate": "2024-08-07 14:45:03",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 139,
		  "totalCountries": 6,
		  "totalStates": 36,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 1409,
		  "schedulePercent": 0.599955,
		  "totalGuests": 1728,
		  "guestPercent": 0.929397,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Huntington Bank Pavilion at Northerly Island",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 272,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e75cc5048b4299a99b0a4609610e672",
		  
		  "name": "Michael",
		  "createdDate": "2021-05-27 04:07:58",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 52,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 189,
		  "schedulePercent": 0.152539,
		  "totalGuests": 271,
		  "guestPercent": 0.635653,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e87010b1a0d65caef7c0dca88d0a7e7",
		  
		  "name": "Carlos",
		  "createdDate": "2024-09-19 18:35:06",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 94,
		  "totalCountries": 16,
		  "totalStates": 13,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 150,
		  "schedulePercent": 0.129873,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "The Cosmopolitan of Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e91f6bedd4ff39fb0d1bbef54424bfd",
		  
		  "name": "Kelsey",
		  "createdDate": "2015-03-23 19:49:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 375,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1936,
		  "schedulePercent": 0.701043,
		  "totalGuests": 3249,
		  "guestPercent": 0.986174,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Ak-Chin Pavilion",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 173,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1e95cb8f1bf30a5fc5b84b017882910d",
		  
		  "name": "Neil ",
		  "createdDate": "2017-07-19 20:04:46",
		  "totalOrganizations": 35,
		  "totalTours": 22,
		  "totalDays": 592,
		  "totalCountries": 27,
		  "totalStates": 65,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 2544,
		  "schedulePercent": 0.791251,
		  "totalGuests": 338,
		  "guestPercent": 0.670104,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "O2 Ritz Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ea9bc846b56cdb0353669d5abd641f2",
		  
		  "name": "Justin",
		  "createdDate": "2024-03-08 19:34:49",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 1061,
		  "totalCountries": 14,
		  "totalStates": 48,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 979,
		  "schedulePercent": 0.484361,
		  "totalGuests": 190,
		  "guestPercent": 0.585902,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "The Theater at Virgin Hotels",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1eb1e7ee459441e8bc496881637437a6",
		  
		  "name": "Sheri",
		  "createdDate": "2017-11-13 13:35:48",
		  "totalOrganizations": 32,
		  "totalTours": 20,
		  "totalDays": 866,
		  "totalCountries": 15,
		  "totalStates": 47,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 1495,
		  "schedulePercent": 0.6165,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "PEI Brewing Company",
		  "mostGuestCity": "Charlottetown",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1eb24888ebacdb9b35539b62e2e24d24",
		  
		  "name": "Arman",
		  "createdDate": "2020-01-08 01:34:55",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 810,
		  "schedulePercent": 0.427131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1eb842fced64704048b21a737eb2f028",
		  
		  "name": "Seth",
		  "createdDate": "2025-05-10 02:49:57",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 265,
		  "totalCountries": 11,
		  "totalStates": 22,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 2057,
		  "schedulePercent": 0.725181,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ebe36805f080ed15281d1a837e48327",
		  
		  "name": "Cami",
		  "createdDate": "2025-07-24 21:10:16",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 51,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 432,
		  "schedulePercent": 0.282638,
		  "totalGuests": 479,
		  "guestPercent": 0.723935,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ecf390c4ca25dee0dcbf7159d481efa",
		  
		  "name": "Erica",
		  "createdDate": "2025-08-01 09:57:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 275,
		  "schedulePercent": 0.202403,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ed873db1a1792721639bb230ab076bf",
		  
		  "name": "Jeff",
		  "createdDate": "2018-01-11 23:10:39",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 481,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2135,
		  "schedulePercent": 0.737647,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ee4b68df22b572be73e9fb96cd1d724",
		  
		  "name": "The Core",
		  "createdDate": "2024-09-09 21:11:32",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 2152,
		  "totalCountries": 13,
		  "totalStates": 72,
		  "totalEvents": 358,
		  "eventPercent": 0.945376,
		  "totalScheduleItems": 6647,
		  "schedulePercent": 0.983681,
		  "totalGuests": 1121,
		  "guestPercent": 0.867067,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ef0c97e2f49c20307ff28c202bfe247",
		  
		  "name": "Ravi",
		  "createdDate": "2016-07-05 10:19:01",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 319,
		  "totalCountries": 14,
		  "totalStates": 29,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 606,
		  "schedulePercent": 0.353014,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ef5a903e7748237128f470d5917efa2",
		  
		  "name": "Ben",
		  "createdDate": "2017-05-02 20:50:51",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 810,
		  "totalCountries": 3,
		  "totalStates": 48,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 2441,
		  "schedulePercent": 0.779805,
		  "totalGuests": 1487,
		  "guestPercent": 0.908092,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Akins Ford Arena",
		  "mostGuestCity": "Athens",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ef7bb6103a611662aece272f5dff974",
		  
		  "name": "Charlie",
		  "createdDate": "2024-02-20 23:59:56",
		  "totalOrganizations": 2,
		  "totalTours": 19,
		  "totalDays": 327,
		  "totalCountries": 10,
		  "totalStates": 38,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 4085,
		  "schedulePercent": 0.917838,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1efc6d1ccc2908354aabe89137c85bf4",
		  
		  "name": "Sterling",
		  "createdDate": "2025-03-28 17:59:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 273,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 437,
		  "schedulePercent": 0.284905,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-06-25 00:00:00",
		  "mostGuestName": "The Regency",
		  "mostGuestCity": "Springfield",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f00e0fc5af0f8ed4484dd9b6e90e35f",
		  
		  "name": "Stephen",
		  "createdDate": "2015-09-09 04:29:21",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 154,
		  "totalCountries": 9,
		  "totalStates": 23,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 739,
		  "schedulePercent": 0.401179,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Melbourne Recital Centre",
		  "mostGuestCity": "Southbank",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f0ea80288eb129c206a74b97e561f7c",
		  
		  "name": "artemii",
		  "createdDate": "2023-10-17 18:19:51",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 24,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 111,
		  "schedulePercent": 0.106074,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f113910643cdfc2a1709b438885f21d",
		  
		  "name": "Chief",
		  "createdDate": "2025-09-12 15:27:18",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 111,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 357,
		  "schedulePercent": 0.246714,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Rocket Mortgage FieldHouse",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f13c34ecc385ebfd3f278cbffc8e0c0",
		  
		  "name": "David",
		  "createdDate": "2017-11-07 22:56:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 213,
		  "totalCountries": 6,
		  "totalStates": 28,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1745,
		  "schedulePercent": 0.667271,
		  "totalGuests": 2354,
		  "guestPercent": 0.963622,
		  "mostGuestDate": "2025-07-21 00:00:00",
		  "mostGuestName": "Desert 5 Spot",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f243460e7aed78c3702a1c8c90a0016",
		  
		  "name": "Aidan",
		  "createdDate": "2021-11-17 00:40:44",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 475,
		  "schedulePercent": 0.300091,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Miami Marketta",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f2e27abdb23c6d653b7ccea95ddc2d9",
		  
		  "name": "Amanda",
		  "createdDate": "2021-07-03 16:24:00",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 213,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1372,
		  "schedulePercent": 0.590095,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f3257c10bac51d90a6138245c5492db",
		  
		  "name": "Carlos",
		  "createdDate": "2025-03-27 20:38:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 70,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 53,
		  "schedulePercent": 0.0618767,
		  "totalGuests": 71,
		  "guestPercent": 0.486174,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f337a79a0fbdeefd963ceaed2e5b7d1",
		  
		  "name": "Andrew",
		  "createdDate": "2022-03-06 18:17:06",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 152,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 636,
		  "schedulePercent": 0.363101,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f3c00b930db9909613fd8c1eef5b5d2",
		  
		  "name": "Doug",
		  "createdDate": "2019-10-02 15:27:02",
		  "totalOrganizations": 8,
		  "totalTours": 19,
		  "totalDays": 1552,
		  "totalCountries": 14,
		  "totalStates": 73,
		  "totalEvents": 391,
		  "eventPercent": 0.956482,
		  "totalScheduleItems": 3411,
		  "schedulePercent": 0.87636,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f3c6048164bd200cdd152e6c3b7f70e",
		  
		  "name": "Treiva",
		  "createdDate": "2017-11-10 18:16:42",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 234,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 469,
		  "schedulePercent": 0.297937,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f4afccc41aca7a686ebac2424338def",
		  
		  "name": "Kriss",
		  "createdDate": "2023-05-25 21:25:25",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 175,
		  "totalCountries": 22,
		  "totalStates": 53,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1070,
		  "schedulePercent": 0.510426,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "X-tra",
		  "mostGuestCity": "Zurich",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f4f7f588f8113a1dfc2b3eee600b4d1",
		  
		  "name": "Monica",
		  "createdDate": "2022-02-11 17:43:51",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 435,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 4897,
		  "schedulePercent": 0.951269,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "100 Club",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f589a40f8ed88d0e5425052cfa66af3",
		  
		  "name": "Robin",
		  "createdDate": "2016-09-14 21:31:22",
		  "totalOrganizations": 34,
		  "totalTours": 67,
		  "totalDays": 1687,
		  "totalCountries": 39,
		  "totalStates": 95,
		  "totalEvents": 587,
		  "eventPercent": 0.986854,
		  "totalScheduleItems": 7087,
		  "schedulePercent": 0.987194,
		  "totalGuests": 2903,
		  "guestPercent": 0.980054,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f5b97d9ecd6421d33012e18141b7a3b",
		  
		  "name": "Jason",
		  "createdDate": "2009-12-23 16:55:55",
		  "totalOrganizations": 18,
		  "totalTours": 3,
		  "totalDays": 135,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 330,
		  "schedulePercent": 0.230961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f5cc8ef0a651ac6c72bc08dcfaf20f3",
		  
		  "name": "Craig",
		  "createdDate": "2012-11-17 01:23:09",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 106,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 989,
		  "schedulePercent": 0.487874,
		  "totalGuests": 1388,
		  "guestPercent": 0.899252,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 128,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f6093cce032bd9f46f5426a09c0695f",
		  
		  "name": "Amalie",
		  "createdDate": "2023-01-26 10:35:37",
		  "totalOrganizations": 36,
		  "totalTours": 29,
		  "totalDays": 976,
		  "totalCountries": 39,
		  "totalStates": 49,
		  "totalEvents": 437,
		  "eventPercent": 0.968155,
		  "totalScheduleItems": 3776,
		  "schedulePercent": 0.900839,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Rockefeller Music Hall",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f6e339cb5c9b19adf2428d298abad23",
		  
		  "name": "Gary",
		  "createdDate": "2022-01-04 15:09:31",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 683,
		  "schedulePercent": 0.380326,
		  "totalGuests": 80,
		  "guestPercent": 0.49728,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Analog at Hutton Hotel",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f7e1f74faa85adb2c446b648686d0ec",
		  
		  "name": "Janne",
		  "createdDate": "2023-09-12 14:10:49",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 283,
		  "totalCountries": 29,
		  "totalStates": 53,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 679,
		  "schedulePercent": 0.378626,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f89129488de1b8fe9fe8f54c8270849",
		  
		  "name": "Steph",
		  "createdDate": "2025-04-15 18:20:53",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 79,
		  "totalCountries": 4,
		  "totalStates": 22,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 609,
		  "schedulePercent": 0.353921,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f901c861827b618515198ff8d4e3aac",
		  
		  "name": "Freddie",
		  "createdDate": "2016-07-02 15:40:32",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 751,
		  "totalCountries": 22,
		  "totalStates": 50,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1974,
		  "schedulePercent": 0.708522,
		  "totalGuests": 743,
		  "guestPercent": 0.794764,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f93bcca12da45a807a035ae2f9e7343",
		  
		  "name": "Jeremy",
		  "createdDate": "2022-05-28 14:45:28",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 166,
		  "totalCountries": 11,
		  "totalStates": 11,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 1129,
		  "schedulePercent": 0.527992,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1f974656e4232abd3b7533277da3f840",
		  
		  "name": "Adam",
		  "createdDate": "2024-03-09 21:53:52",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 340,
		  "totalCountries": 2,
		  "totalStates": 33,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 721,
		  "schedulePercent": 0.394832,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fa224f4421444b34ae8e0b20bbdbe15",
		  
		  "name": "Jimmy",
		  "createdDate": "2023-08-04 05:34:34",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 326,
		  "totalCountries": 21,
		  "totalStates": 16,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 272,
		  "schedulePercent": 0.200929,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Circo Volador",
		  "mostGuestCity": "MÃ©xico D.F.",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fa52eabf371a758f1b1af6e2d1c6baf",
		  
		  "name": "Shane ",
		  "createdDate": "2018-04-06 18:34:17",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 375,
		  "totalCountries": 11,
		  "totalStates": 44,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1186,
		  "schedulePercent": 0.543518,
		  "totalGuests": 558,
		  "guestPercent": 0.74626,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fb0a59393ff903520bb9dab193b22e6",
		  
		  "name": "Brian",
		  "createdDate": "2012-09-20 17:57:17",
		  "totalOrganizations": 19,
		  "totalTours": 4,
		  "totalDays": 155,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1784,
		  "schedulePercent": 0.673504,
		  "totalGuests": 3089,
		  "guestPercent": 0.983681,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fc7afd6c64fd5270a5d936e0ced23f6",
		  
		  "name": "Gavin",
		  "createdDate": "2025-02-15 22:38:48",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 63,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Stable Hall",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fcb5d04b56c1c4a890d5fa2deae09c3",
		  
		  "name": "Matthew",
		  "createdDate": "2018-03-09 00:00:44",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 218,
		  "totalCountries": 14,
		  "totalStates": 48,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 973,
		  "schedulePercent": 0.482321,
		  "totalGuests": 148,
		  "guestPercent": 0.556664,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "170 Russell",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fcd1f08b5d35323602e912ff9156c67",
		  
		  "name": "Bill",
		  "createdDate": "2018-03-31 18:23:26",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1123,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Republic NOLA",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fcef60b79b291e8f5086b38026e6760",
		  
		  "name": "Sage Anthony",
		  "createdDate": "2016-12-15 04:22:45",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 452,
		  "totalCountries": 13,
		  "totalStates": 50,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 1005,
		  "schedulePercent": 0.491727,
		  "totalGuests": 467,
		  "guestPercent": 0.719288,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "The Factory",
		  "mostGuestCity": "Chesterfield",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fd5214c4afda9ce4b1475455c892144",
		  
		  "name": "Erich",
		  "createdDate": "2013-01-17 14:03:06",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 225,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1620,
		  "schedulePercent": 0.644152,
		  "totalGuests": 323,
		  "guestPercent": 0.662511,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Deer Valley Music Festival",
		  "mostGuestCity": "Park City",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fd825d7dae6f64f76d999523dd6d13d",
		  
		  "name": "Trey",
		  "createdDate": "2009-08-06 18:06:47",
		  "totalOrganizations": 22,
		  "totalTours": 21,
		  "totalDays": 515,
		  "totalCountries": 16,
		  "totalStates": 48,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 2730,
		  "schedulePercent": 0.813123,
		  "totalGuests": 1625,
		  "guestPercent": 0.921917,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fd839b5ed7aec2a4b9f87c4e0ca5e3f",
		  
		  "name": "Alison",
		  "createdDate": "2015-08-20 18:01:11",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 218,
		  "totalCountries": 6,
		  "totalStates": 47,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1825,
		  "schedulePercent": 0.680417,
		  "totalGuests": 482,
		  "guestPercent": 0.725181,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fdd559fe7bf82a1bbf29ff9197e57ad",
		  
		  "name": "Terry",
		  "createdDate": "2015-06-03 05:00:59",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 93,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 722,
		  "schedulePercent": 0.395172,
		  "totalGuests": 1000,
		  "guestPercent": 0.845875,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fe91cf7e6c25147788fd9d39c9a46b4",
		  
		  "name": "Bryan",
		  "createdDate": "2014-02-09 21:29:00",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 782,
		  "totalCountries": 20,
		  "totalStates": 60,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 3500,
		  "schedulePercent": 0.882253,
		  "totalGuests": 1887,
		  "guestPercent": 0.939483,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1fea52e1e61719044792d79ffa96e310",
		  
		  "name": "Anna",
		  "createdDate": "2021-10-15 12:10:26",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 574,
		  "totalCountries": 12,
		  "totalStates": 50,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 2092,
		  "schedulePercent": 0.730961,
		  "totalGuests": 903,
		  "guestPercent": 0.830689,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ff0f7333537781d9b7f413e9f3fd612",
		  
		  "name": "Gabriel",
		  "createdDate": "2014-12-04 10:45:46",
		  "totalOrganizations": 15,
		  "totalTours": 4,
		  "totalDays": 182,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 1212,
		  "schedulePercent": 0.549637,
		  "totalGuests": 570,
		  "guestPercent": 0.750113,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "Det Kongelige Teater",
		  "mostGuestCity": "KÃ¸benhavn K",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ff2fbe2fb541159d8b53f8cf4e31d22",
		  
		  "name": "Melissa",
		  "createdDate": "2011-04-29 16:51:01",
		  "totalOrganizations": 16,
		  "totalTours": 20,
		  "totalDays": 446,
		  "totalCountries": 14,
		  "totalStates": 57,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 4325,
		  "schedulePercent": 0.93223,
		  "totalGuests": 3290,
		  "guestPercent": 0.987534,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "1ff8ad3e4307867fdf31f40630c0b85d",
		  
		  "name": "Cameron",
		  "createdDate": "2021-01-22 01:26:12",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 342,
		  "totalCountries": 6,
		  "totalStates": 39,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 609,
		  "schedulePercent": 0.353921,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-09-16 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20058a0c6974eb4e86ef3c2e4739beaa",
		  
		  "name": "Chelsae",
		  "createdDate": "2016-11-19 02:53:12",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 569,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1965,
		  "schedulePercent": 0.706482,
		  "totalGuests": 2619,
		  "guestPercent": 0.972688,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "200da4a947e65720f0a1f2904a18bfc2",
		  
		  "name": "OLIVER",
		  "createdDate": "2012-02-26 22:38:06",
		  "totalOrganizations": 14,
		  "totalTours": 21,
		  "totalDays": 820,
		  "totalCountries": 32,
		  "totalStates": 54,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2299,
		  "schedulePercent": 0.761673,
		  "totalGuests": 367,
		  "guestPercent": 0.679964,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Aviva Studios",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20102e48e7e70c94ed6e14ef7689e4e9",
		  
		  "name": "Kaylee",
		  "createdDate": "2017-09-20 09:46:46",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 264,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2010d5e957c868d4fb6baaef90f0eb26",
		  
		  "name": "Fleur",
		  "createdDate": "2025-09-08 22:21:42",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20180c712e4a9442ed79d24c813ce244",
		  
		  "name": "Stephen",
		  "createdDate": "2014-06-19 15:56:38",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 216,
		  "totalCountries": 8,
		  "totalStates": 47,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 2120,
		  "schedulePercent": 0.735607,
		  "totalGuests": 461,
		  "guestPercent": 0.716228,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "SSE Arena Belfast",
		  "mostGuestCity": "Belfast",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2019c7b42500e70a5edc0bad3d60789e",
		  
		  "name": "Richard",
		  "createdDate": "2018-05-29 19:32:38",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 326,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1988,
		  "schedulePercent": 0.711129,
		  "totalGuests": 334,
		  "guestPercent": 0.667384,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Northwell Health at Jones Beach Theater",
		  "mostGuestCity": "Wantagh",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "201f39c245dd447338cf8e74e3bc7f26",
		  
		  "name": "Tina",
		  "createdDate": "2019-02-07 08:55:49",
		  "totalOrganizations": 18,
		  "totalTours": 5,
		  "totalDays": 388,
		  "totalCountries": 18,
		  "totalStates": 38,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2050,
		  "schedulePercent": 0.723141,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "201fef4f857e139d66514b3c13f18094",
		  
		  "name": "Rostam",
		  "createdDate": "2017-10-01 18:27:21",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 66,
		  "totalCountries": 19,
		  "totalStates": 29,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 536,
		  "schedulePercent": 0.329329,
		  "totalGuests": 378,
		  "guestPercent": 0.685063,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Electric Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2023a2272d63f3fe5222c5c5311ff0c6",
		  
		  "name": "Alanna",
		  "createdDate": "2023-12-18 20:07:48",
		  "totalOrganizations": 1,
		  "totalTours": 16,
		  "totalDays": 192,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 2058,
		  "schedulePercent": 0.725635,
		  "totalGuests": 740,
		  "guestPercent": 0.794198,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "John Anson Ford Amphitheatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "202aa01eab428a26830b41155678b639",
		  
		  "name": "Neus",
		  "createdDate": "2023-08-08 10:35:33",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 533,
		  "schedulePercent": 0.328196,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "203ca35540fd09aa63ec1a6545998a25",
		  
		  "name": "Sam",
		  "createdDate": "2023-03-23 19:34:18",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 241,
		  "totalCountries": 15,
		  "totalStates": 48,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1052,
		  "schedulePercent": 0.505326,
		  "totalGuests": 334,
		  "guestPercent": 0.667384,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Scotiabank Saddledome",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "204a291d5e3adef7d820be43b146be35",
		  
		  "name": "Dean",
		  "createdDate": "2022-12-20 18:53:43",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 629,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1472,
		  "schedulePercent": 0.611174,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Shovelhead Lounge",
		  "mostGuestCity": "Longwood",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "204fa70b50daa097e3f06009af779982",
		  
		  "name": "Signe",
		  "createdDate": "2024-02-02 11:54:37",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 97,
		  "totalCountries": 4,
		  "totalStates": 1,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 548,
		  "schedulePercent": 0.333522,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Grimfest",
		  "mostGuestCity": "Brabrand",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2058e8b67beefb722f1b7154ede71fd7",
		  
		  "name": "G&G",
		  "createdDate": "2018-03-18 13:39:46",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 661,
		  "totalCountries": 23,
		  "totalStates": 79,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 2685,
		  "schedulePercent": 0.807457,
		  "totalGuests": 410,
		  "guestPercent": 0.697303,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Pepsi Center WTC",
		  "mostGuestCity": "Benito Juarez",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "205cce99c9d89255fca25dfd69f34447",
		  
		  "name": "Paddy",
		  "createdDate": "2009-11-18 00:11:53",
		  "totalOrganizations": 18,
		  "totalTours": 15,
		  "totalDays": 823,
		  "totalCountries": 23,
		  "totalStates": 80,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 1872,
		  "schedulePercent": 0.689823,
		  "totalGuests": 1607,
		  "guestPercent": 0.920671,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "3 Arena",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "206b6a6200a5ffe150f2155dae46dbf9",
		  
		  "name": "David",
		  "createdDate": "2025-03-28 00:45:58",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 154,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 757,
		  "schedulePercent": 0.408658,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "207f38565db9af3be9f2f3827da5962f",
		  
		  "name": "Chris",
		  "createdDate": "2017-04-11 23:30:32",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 126,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 324,
		  "schedulePercent": 0.228354,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Dosey Doe - The Big Barn",
		  "mostGuestCity": "Spring",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "208274e4db980f499f76079cfc0bcda4",
		  
		  "name": "Gehrig",
		  "createdDate": "2019-09-06 12:39:42",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 809,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 4432,
		  "schedulePercent": 0.93597,
		  "totalGuests": 808,
		  "guestPercent": 0.809723,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2084b943c29e33d98dc8e29dae782755",
		  
		  "name": "Neil",
		  "createdDate": "2018-02-04 12:14:24",
		  "totalOrganizations": 12,
		  "totalTours": 36,
		  "totalDays": 579,
		  "totalCountries": 28,
		  "totalStates": 64,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 3166,
		  "schedulePercent": 0.856641,
		  "totalGuests": 1663,
		  "guestPercent": 0.925317,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "208940e0845695165f510ab0251c1e4c",
		  
		  "name": "Nina",
		  "createdDate": "2020-01-30 16:29:04",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 1266,
		  "totalCountries": 12,
		  "totalStates": 24,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1644,
		  "schedulePercent": 0.648232,
		  "totalGuests": 174,
		  "guestPercent": 0.576156,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Cepac Silo",
		  "mostGuestCity": "Marseille",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2093659e15255d85116deec2fe9ed454",
		  
		  "name": "Leon",
		  "createdDate": "2017-12-04 04:30:40",
		  "totalOrganizations": 20,
		  "totalTours": 14,
		  "totalDays": 395,
		  "totalCountries": 17,
		  "totalStates": 24,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1517,
		  "schedulePercent": 0.621487,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Hamer Hall",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "209a16eb5c3ea96e8050f63ac7946fdd",
		  
		  "name": "Xavier",
		  "createdDate": "2016-05-01 12:38:24",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 310,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 887,
		  "schedulePercent": 0.452856,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "The Regal Theatre",
		  "mostGuestCity": "Subiaco",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "209a5b53c8c4ca71d8d5c2282818bf62",
		  
		  "name": "Chugg",
		  "createdDate": "2025-05-09 03:14:21",
		  "totalOrganizations": 7,
		  "totalTours": 31,
		  "totalDays": 267,
		  "totalCountries": 19,
		  "totalStates": 41,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 859,
		  "schedulePercent": 0.444243,
		  "totalGuests": 120,
		  "guestPercent": 0.536945,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Night at the Barracks",
		  "mostGuestCity": "Manly",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20a1005700af840a5a9027e143f07e80",
		  
		  "name": "Andrew",
		  "createdDate": "2015-06-03 01:06:28",
		  "totalOrganizations": 4,
		  "totalTours": 10,
		  "totalDays": 297,
		  "totalCountries": 3,
		  "totalStates": 49,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1595,
		  "schedulePercent": 0.639733,
		  "totalGuests": 226,
		  "guestPercent": 0.610607,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "The Mystic Theatre",
		  "mostGuestCity": "Petaluma",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20ab20e36ef112c67423c169733a5b94",
		  
		  "name": "Drew",
		  "createdDate": "2012-09-22 21:13:41",
		  "totalOrganizations": 21,
		  "totalTours": 12,
		  "totalDays": 663,
		  "totalCountries": 29,
		  "totalStates": 58,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 4193,
		  "schedulePercent": 0.925657,
		  "totalGuests": 970,
		  "guestPercent": 0.841228,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20aef794a5ffeb6cde409608b65b87d7",
		  
		  "name": "Kaitlin",
		  "createdDate": "2022-07-11 20:19:58",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 924,
		  "totalCountries": 4,
		  "totalStates": 51,
		  "totalEvents": 248,
		  "eventPercent": 0.868654,
		  "totalScheduleItems": 4898,
		  "schedulePercent": 0.951383,
		  "totalGuests": 1291,
		  "guestPercent": 0.884973,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 177,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20b498a992fe9bef318bd9ea82f9d35d",
		  
		  "name": "Paddy",
		  "createdDate": "2011-06-13 17:36:16",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 282,
		  "totalCountries": 11,
		  "totalStates": 56,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2621,
		  "schedulePercent": 0.799751,
		  "totalGuests": 580,
		  "guestPercent": 0.752607,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20bfa36cabd1b168a05f2c08dc9a58e6",
		  
		  "name": "Chris",
		  "createdDate": "2018-07-11 18:25:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 333,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1138,
		  "schedulePercent": 0.531165,
		  "totalGuests": 1131,
		  "guestPercent": 0.868767,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Riverfront Park",
		  "mostGuestCity": "Charelston",
		  "mostGuestAmount": 189,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20d8066326b2102d40dc9cd894a24de9",
		  
		  "name": "Lex",
		  "createdDate": "2024-05-23 17:17:23",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 34,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 199,
		  "schedulePercent": 0.160245,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Aguere Cultural",
		  "mostGuestCity": "La Laguna",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20e679aa9f2d430d72eeffdd54b9fd17",
		  
		  "name": "Sam ",
		  "createdDate": "2012-10-31 16:52:09",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 295,
		  "totalCountries": 12,
		  "totalStates": 45,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1965,
		  "schedulePercent": 0.706482,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Yaamava' Resort & Casino",
		  "mostGuestCity": "Highland",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20e93cba2329a8b4e329352b5762e1bd",
		  
		  "name": "Lance",
		  "createdDate": "2019-10-01 10:34:58",
		  "totalOrganizations": 15,
		  "totalTours": 34,
		  "totalDays": 470,
		  "totalCountries": 10,
		  "totalStates": 19,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 2456,
		  "schedulePercent": 0.781732,
		  "totalGuests": 397,
		  "guestPercent": 0.69277,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20ea0014c7d3a5c9ca57c69b76ad89eb",
		  
		  "name": "Carlo Maria",
		  "createdDate": "2025-03-29 16:51:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 202,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1084,
		  "schedulePercent": 0.515299,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20ea1f0e87f0db65e7f72844dd7a66c7",
		  
		  "name": "Alex",
		  "createdDate": "2022-05-20 21:53:01",
		  "totalOrganizations": 12,
		  "totalTours": 14,
		  "totalDays": 839,
		  "totalCountries": 20,
		  "totalStates": 49,
		  "totalEvents": 276,
		  "eventPercent": 0.895626,
		  "totalScheduleItems": 4669,
		  "schedulePercent": 0.942883,
		  "totalGuests": 2309,
		  "guestPercent": 0.962715,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "20f9ea1ece9e11be18ea0ebe9573049f",
		  
		  "name": "Phil",
		  "createdDate": "2022-03-22 12:53:48",
		  "totalOrganizations": 14,
		  "totalTours": 18,
		  "totalDays": 471,
		  "totalCountries": 8,
		  "totalStates": 45,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2501,
		  "schedulePercent": 0.786945,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Bruce Mason Centre",
		  "mostGuestCity": "Takapuna Beach",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "210083a39d1b65a7fcda1f1925d79628",
		  
		  "name": "Chris",
		  "createdDate": "2012-09-28 15:49:11",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 481,
		  "totalCountries": 26,
		  "totalStates": 37,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1377,
		  "schedulePercent": 0.592022,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "All Points East Festival",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21065eb831d17687c73933a055b45cef",
		  
		  "name": "Danielle ",
		  "createdDate": "2025-01-14 02:26:07",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 128,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1466,
		  "schedulePercent": 0.610267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "210ec334c793b72bd5d773cd224dc3bf",
		  
		  "name": "Alex",
		  "createdDate": "2024-09-09 17:57:20",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 139,
		  "totalCountries": 15,
		  "totalStates": 20,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 974,
		  "schedulePercent": 0.482434,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "211512f921fb238c321bb73908438ea7",
		  
		  "name": "Jannie",
		  "createdDate": "2023-01-05 10:53:52",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 329,
		  "totalCountries": 27,
		  "totalStates": 52,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 2040,
		  "schedulePercent": 0.720875,
		  "totalGuests": 710,
		  "guestPercent": 0.787965,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2118b0104fad82c0a26d233c3514e85d",
		  
		  "name": "Jake",
		  "createdDate": "2024-01-04 19:10:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 85,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 832,
		  "schedulePercent": 0.435177,
		  "totalGuests": 1292,
		  "guestPercent": 0.885199,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "211e90eff46499ce39dd397a4a6a5294",
		  
		  "name": "Gauthier",
		  "createdDate": "2019-11-11 09:42:14",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 310,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1068,
		  "schedulePercent": 0.509633,
		  "totalGuests": 588,
		  "guestPercent": 0.755553,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Gare du Midi Biarritz",
		  "mostGuestCity": "Biarritz",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21325affd7980920b70fcb0a7e36d74c",
		  
		  "name": "Sierra",
		  "createdDate": "2023-12-13 16:37:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 275,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1709,
		  "schedulePercent": 0.660358,
		  "totalGuests": 1069,
		  "guestPercent": 0.857774,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2135ccdf5d3019cf46512ddc77009e92",
		  
		  "name": "Elena",
		  "createdDate": "2022-10-03 17:47:17",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 491,
		  "totalCountries": 23,
		  "totalStates": 52,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 3047,
		  "schedulePercent": 0.846895,
		  "totalGuests": 867,
		  "guestPercent": 0.822529,
		  "mostGuestDate": "2025-07-14 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "213619c56f9e33eb6a19a7b3798b8be3",
		  
		  "name": "Avery",
		  "createdDate": "2025-03-24 19:57:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 243,
		  "totalCountries": 16,
		  "totalStates": 23,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 2066,
		  "schedulePercent": 0.726881,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2136ece1f3285b291f7fc68084743ba9",
		  
		  "name": "Katy",
		  "createdDate": "2016-09-14 21:29:39",
		  "totalOrganizations": 10,
		  "totalTours": 20,
		  "totalDays": 410,
		  "totalCountries": 15,
		  "totalStates": 44,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 2753,
		  "schedulePercent": 0.816863,
		  "totalGuests": 2432,
		  "guestPercent": 0.966228,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "213a764a027c3ae6994d2e01447be145",
		  
		  "name": "Will",
		  "createdDate": "2025-07-31 16:47:09",
		  "totalOrganizations": 23,
		  "totalTours": 5,
		  "totalDays": 357,
		  "totalCountries": 6,
		  "totalStates": 53,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2035,
		  "schedulePercent": 0.719855,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Fox Performing Arts Center",
		  "mostGuestCity": "Riverside",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21550e687b83dd5188f5e86ef7c463e5",
		  
		  "name": "Anthony",
		  "createdDate": "2016-03-03 01:07:32",
		  "totalOrganizations": 17,
		  "totalTours": 11,
		  "totalDays": 454,
		  "totalCountries": 13,
		  "totalStates": 13,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 1241,
		  "schedulePercent": 0.558024,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2156cc41ed6092bdd1be41dd4664be4a",
		  
		  "name": "Darren ",
		  "createdDate": "2011-12-15 03:47:11",
		  "totalOrganizations": 98,
		  "totalTours": 62,
		  "totalDays": 1433,
		  "totalCountries": 39,
		  "totalStates": 64,
		  "totalEvents": 569,
		  "eventPercent": 0.985721,
		  "totalScheduleItems": 6903,
		  "schedulePercent": 0.985721,
		  "totalGuests": 550,
		  "guestPercent": 0.743994,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "John Cain Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "215ce734112ccd1c2129af8495599d78",
		  
		  "name": "Lachlan",
		  "createdDate": "2013-08-07 05:20:59",
		  "totalOrganizations": 4,
		  "totalTours": 20,
		  "totalDays": 356,
		  "totalCountries": 12,
		  "totalStates": 49,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 814,
		  "schedulePercent": 0.42849,
		  "totalGuests": 410,
		  "guestPercent": 0.697303,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "216355b9ad88c33070c9df81e0d4f64e",
		  
		  "name": "Eric",
		  "createdDate": "2019-12-18 23:00:58",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 129,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 1023,
		  "schedulePercent": 0.497393,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21641c9df05627ce48638a238667c1d7",
		  
		  "name": "Jonathan",
		  "createdDate": "2024-03-12 00:36:20",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 258,
		  "totalCountries": 18,
		  "totalStates": 33,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1253,
		  "schedulePercent": 0.561197,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Lido",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2166f03dd5c9a4b2bc0101fc60905fb9",
		  
		  "name": "Manuel ",
		  "createdDate": "2025-07-23 22:26:09",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 312,
		  "totalCountries": 15,
		  "totalStates": 36,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1114,
		  "schedulePercent": 0.521872,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "217261b8f4d259cd7cfe37d355a7a63d",
		  
		  "name": "Ian",
		  "createdDate": "2021-08-01 21:29:09",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1032,
		  "totalCountries": 12,
		  "totalStates": 64,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 3072,
		  "schedulePercent": 0.849275,
		  "totalGuests": 1872,
		  "guestPercent": 0.937443,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "217314e2d82b6a4d9b1aff667d7c4c7f",
		  
		  "name": "Andy",
		  "createdDate": "2017-11-10 11:43:23",
		  "totalOrganizations": 28,
		  "totalTours": 26,
		  "totalDays": 1604,
		  "totalCountries": 31,
		  "totalStates": 93,
		  "totalEvents": 352,
		  "eventPercent": 0.94311,
		  "totalScheduleItems": 3875,
		  "schedulePercent": 0.906618,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21748018cf52383f03716f578dad8379",
		  
		  "name": "Henry",
		  "createdDate": "2022-04-03 03:08:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 62,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 3,
		  "eventPercent": 0.0250453,
		  "totalScheduleItems": 109,
		  "schedulePercent": 0.105054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "217dd633dcc3e881a616235a54c44f92",
		  
		  "name": "Lindsay",
		  "createdDate": "2019-11-02 16:32:34",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 910,
		  "totalCountries": 5,
		  "totalStates": 51,
		  "totalEvents": 284,
		  "eventPercent": 0.901292,
		  "totalScheduleItems": 2946,
		  "schedulePercent": 0.836469,
		  "totalGuests": 678,
		  "guestPercent": 0.780372,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Boulder Theater",
		  "mostGuestCity": "Boulder",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2182d44a7867285a158738954af18580",
		  
		  "name": "Aidan",
		  "createdDate": "2022-09-21 13:54:01",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 377,
		  "totalCountries": 24,
		  "totalStates": 25,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1044,
		  "schedulePercent": 0.502153,
		  "totalGuests": 499,
		  "guestPercent": 0.730168,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Nissan Stadium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2186460f7cf6f7e9b32b524d831c754e",
		  
		  "name": "Rick",
		  "createdDate": "2010-07-25 09:15:25",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 41,
		  "totalCountries": 8,
		  "totalStates": 9,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 188,
		  "schedulePercent": 0.152085,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2187d972ff5b4e0c870d972d4af3c29f",
		  
		  "name": "Stephanie",
		  "createdDate": "2013-02-23 01:56:19",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 179,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 1,
		  "eventPercent": 0.0074796,
		  "totalScheduleItems": 109,
		  "schedulePercent": 0.105054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "218e77d3522e68d69aea21d03f2bc6dd",
		  
		  "name": "Johnny",
		  "createdDate": "2022-01-11 15:21:16",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 125,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 660,
		  "schedulePercent": 0.371714,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21910703810da241ef4988dfd4bcb27e",
		  
		  "name": "Chris",
		  "createdDate": "2013-10-28 18:22:54",
		  "totalOrganizations": 18,
		  "totalTours": 9,
		  "totalDays": 867,
		  "totalCountries": 25,
		  "totalStates": 59,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 2537,
		  "schedulePercent": 0.790345,
		  "totalGuests": 391,
		  "guestPercent": 0.690277,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21982a37ef01c6fe347e52ef43452d0f",
		  
		  "name": "Thomas",
		  "createdDate": "2009-07-21 18:48:10",
		  "totalOrganizations": 22,
		  "totalTours": 8,
		  "totalDays": 190,
		  "totalCountries": 12,
		  "totalStates": 9,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 615,
		  "schedulePercent": 0.355734,
		  "totalGuests": 440,
		  "guestPercent": 0.709315,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Dolby Live",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "219bb780489de89c5481d5f682065b34",
		  
		  "name": "Shelby",
		  "createdDate": "2019-07-02 11:36:15",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 995,
		  "totalCountries": 6,
		  "totalStates": 51,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 1549,
		  "schedulePercent": 0.626927,
		  "totalGuests": 480,
		  "guestPercent": 0.724161,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21a1748060151030fba23932a99886df",
		  
		  "name": "Jono",
		  "createdDate": "2022-08-21 00:47:59",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 78,
		  "totalCountries": 7,
		  "totalStates": 9,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 373,
		  "schedulePercent": 0.254646,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21b33f3e5b525012e9c4e545e381bf5d",
		  
		  "name": "Brent",
		  "createdDate": "2013-01-09 04:53:38",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 536,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 3455,
		  "schedulePercent": 0.879533,
		  "totalGuests": 1004,
		  "guestPercent": 0.847008,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 177,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21b61d7c40819e837d3349f414d0b7ba",
		  
		  "name": "Nick",
		  "createdDate": "2010-04-30 16:37:06",
		  "totalOrganizations": 18,
		  "totalTours": 13,
		  "totalDays": 1429,
		  "totalCountries": 33,
		  "totalStates": 63,
		  "totalEvents": 334,
		  "eventPercent": 0.934497,
		  "totalScheduleItems": 3861,
		  "schedulePercent": 0.905712,
		  "totalGuests": 344,
		  "guestPercent": 0.672144,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21bd00905d07bd693bb9cee7dc7c9ab0",
		  
		  "name": "Cale",
		  "createdDate": "2025-04-10 16:45:52",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 159,
		  "totalCountries": 13,
		  "totalStates": 26,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 598,
		  "schedulePercent": 0.350521,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21bd2db7624861ba65fe47501763ea70",
		  
		  "name": "Rob",
		  "createdDate": "2012-03-08 02:19:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 921,
		  "schedulePercent": 0.465095,
		  "totalGuests": 1125,
		  "guestPercent": 0.867407,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21bec351679e5b0047d83425fb0154c4",
		  
		  "name": "Grant",
		  "createdDate": "2022-03-07 16:29:06",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 1110,
		  "totalCountries": 4,
		  "totalStates": 58,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 1841,
		  "schedulePercent": 0.68359,
		  "totalGuests": 292,
		  "guestPercent": 0.645739,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21bf7b06ef8875f37e73db62a709c580",
		  
		  "name": "Jack ",
		  "createdDate": "2012-04-25 16:37:09",
		  "totalOrganizations": 8,
		  "totalTours": 29,
		  "totalDays": 517,
		  "totalCountries": 27,
		  "totalStates": 65,
		  "totalEvents": 270,
		  "eventPercent": 0.890299,
		  "totalScheduleItems": 4588,
		  "schedulePercent": 0.940503,
		  "totalGuests": 2048,
		  "guestPercent": 0.950363,
		  "mostGuestDate": "2025-07-16 00:00:00",
		  "mostGuestName": "The Criterion",
		  "mostGuestCity": "Oklahoma City",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21d0f72ee8fbdb272aec5a1fa9c6f739",
		  
		  "name": "Scott",
		  "createdDate": "2010-12-15 01:21:12",
		  "totalOrganizations": 29,
		  "totalTours": 15,
		  "totalDays": 622,
		  "totalCountries": 19,
		  "totalStates": 57,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2132,
		  "schedulePercent": 0.737081,
		  "totalGuests": 985,
		  "guestPercent": 0.843382,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "21decf694f65814e7f8580b516d6e06d",
		  
		  "name": "Hollie",
		  "createdDate": "2020-03-03 12:27:28",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 445,
		  "totalCountries": 21,
		  "totalStates": 43,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1733,
		  "schedulePercent": 0.664325,
		  "totalGuests": 1062,
		  "guestPercent": 0.856754,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wythenshawe Park and Gardens",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22046719004bbd0654108ab6c1d20bba",
		  
		  "name": "Jason ",
		  "createdDate": "2016-07-07 16:54:19",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 40,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 200,
		  "schedulePercent": 0.161038,
		  "totalGuests": 160,
		  "guestPercent": 0.565956,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Michigan Lottery Amphitheatre at Freedom Hill",
		  "mostGuestCity": "Sterling Heights",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2216c6b7ade9d1d810557a2cf092c788",
		  
		  "name": "Marissa",
		  "createdDate": "2022-10-04 13:23:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 28,
		  "totalStates": 40,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 952,
		  "schedulePercent": 0.476541,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22268af918e07656de888d6cc9b56283",
		  
		  "name": "Dara",
		  "createdDate": "2011-04-07 07:24:05",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 34,
		  "totalCountries": 5,
		  "totalStates": 7,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 114,
		  "guestPercent": 0.531505,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "Lee's Palace",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2232826397ee14b62be0f5ae49daa9c7",
		  
		  "name": "Maxime",
		  "createdDate": "2022-11-14 16:10:38",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 86,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 385,
		  "schedulePercent": 0.260993,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22432f15449f131c319b7aec3836a415",
		  
		  "name": "Tony",
		  "createdDate": "2017-02-22 19:55:18",
		  "totalOrganizations": 23,
		  "totalTours": 15,
		  "totalDays": 545,
		  "totalCountries": 14,
		  "totalStates": 52,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2914,
		  "schedulePercent": 0.832729,
		  "totalGuests": 160,
		  "guestPercent": 0.565956,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2244a470662b8dbf87dc255db3ecc9b4",
		  
		  "name": "Marco",
		  "createdDate": "2017-06-27 22:23:59",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 304,
		  "totalCountries": 9,
		  "totalStates": 9,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 453,
		  "schedulePercent": 0.291931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2256ec7aa532994617f801e1f00bc67d",
		  
		  "name": "Levi",
		  "createdDate": "2017-01-23 23:31:08",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 454,
		  "totalCountries": 24,
		  "totalStates": 57,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 2797,
		  "schedulePercent": 0.821623,
		  "totalGuests": 1032,
		  "guestPercent": 0.851541,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22578c59b7963e6849ad5ff40e992647",
		  
		  "name": "Rome",
		  "createdDate": "2016-06-20 22:17:34",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 383,
		  "totalCountries": 22,
		  "totalStates": 18,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 476,
		  "schedulePercent": 0.300884,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "225e783a5d46547a24d711d4af424a20",
		  
		  "name": "Harlee",
		  "createdDate": "2016-05-25 16:07:20",
		  "totalOrganizations": 33,
		  "totalTours": 12,
		  "totalDays": 986,
		  "totalCountries": 17,
		  "totalStates": 41,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 5025,
		  "schedulePercent": 0.954896,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "226cf63bc30689553b91dd8cc7c6af17",
		  
		  "name": "Jindra",
		  "createdDate": "2025-03-03 10:06:25",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 58,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 199,
		  "schedulePercent": 0.160245,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2272079303c63f23738ea682cc1f6fb6",
		  
		  "name": "Espinoza",
		  "createdDate": "2021-09-12 22:21:27",
		  "totalOrganizations": 17,
		  "totalTours": 10,
		  "totalDays": 402,
		  "totalCountries": 19,
		  "totalStates": 58,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 3278,
		  "schedulePercent": 0.866614,
		  "totalGuests": 1690,
		  "guestPercent": 0.92781,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "227ec3c822ec3c13b3b9c6da6e0e6a5f",
		  
		  "name": "Magic",
		  "createdDate": "2024-10-16 23:01:08",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 128,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2287a1063a8827fb9832024f27c49d39",
		  
		  "name": "Julie",
		  "createdDate": "2022-03-17 14:01:49",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 253,
		  "totalCountries": 18,
		  "totalStates": 10,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1941,
		  "schedulePercent": 0.702403,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2294f11472468e9ac7142e7163e178c5",
		  
		  "name": "Michael",
		  "createdDate": "2025-01-15 03:02:48",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 819,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 825,
		  "schedulePercent": 0.43257,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "The Senate",
		  "mostGuestCity": "Columbia",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "229c01eb3595fe6cdb95c5b53ec02bd1",
		  
		  "name": "Julie",
		  "createdDate": "2019-08-09 01:42:26",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 286,
		  "totalCountries": 15,
		  "totalStates": 41,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1960,
		  "schedulePercent": 0.705576,
		  "totalGuests": 1128,
		  "guestPercent": 0.8682,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Exchange LA",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22a0f746142ee535bc987eea39acf81b",
		  
		  "name": "Bernie",
		  "createdDate": "2013-11-28 12:44:15",
		  "totalOrganizations": 4,
		  "totalTours": 21,
		  "totalDays": 291,
		  "totalCountries": 18,
		  "totalStates": 21,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 612,
		  "schedulePercent": 0.354941,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-02-17 00:00:00",
		  "mostGuestName": "Teatro degli Arcimboldi",
		  "mostGuestCity": "Milano",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22aa8cecd8e34d124d252b7f295af017",
		  
		  "name": "Megan",
		  "createdDate": "2024-12-06 05:18:49",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 311,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 2010,
		  "schedulePercent": 0.715095,
		  "totalGuests": 477,
		  "guestPercent": 0.722915,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Southern Kentucky Performing Arts Center (SKyPAC)",
		  "mostGuestCity": "Bowling Green",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22b6c0446af37e90bd8a4ce434f18b94",
		  
		  "name": "Kristina",
		  "createdDate": "2016-11-10 09:46:56",
		  "totalOrganizations": 50,
		  "totalTours": 33,
		  "totalDays": 958,
		  "totalCountries": 8,
		  "totalStates": 7,
		  "totalEvents": 906,
		  "eventPercent": 0.994674,
		  "totalScheduleItems": 3996,
		  "schedulePercent": 0.913305,
		  "totalGuests": 252,
		  "guestPercent": 0.626247,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Tivoli",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22c91a94e9e7d1146ac8cb0383dd05eb",
		  
		  "name": "Greg",
		  "createdDate": "2019-03-16 18:56:21",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 151,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 834,
		  "schedulePercent": 0.435743,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22c9bd10a1b8b79fd2c1782a3ea01297",
		  
		  "name": "Tim",
		  "createdDate": "2022-09-16 20:59:42",
		  "totalOrganizations": 5,
		  "totalTours": 17,
		  "totalDays": 442,
		  "totalCountries": 2,
		  "totalStates": 43,
		  "totalEvents": 331,
		  "eventPercent": 0.933364,
		  "totalScheduleItems": 2359,
		  "schedulePercent": 0.769832,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22d4b1444909e5bd1bcf2313d3f0feb6",
		  
		  "name": "Hap",
		  "createdDate": "2017-06-27 06:03:39",
		  "totalOrganizations": 15,
		  "totalTours": 45,
		  "totalDays": 311,
		  "totalCountries": 22,
		  "totalStates": 35,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 1235,
		  "schedulePercent": 0.555984,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "Blue Note Tokyo",
		  "mostGuestCity": "Minato-ku",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22d500c217782afb4115c2f838532b33",
		  
		  "name": "Blake",
		  "createdDate": "2022-04-01 05:43:33",
		  "totalOrganizations": 18,
		  "totalTours": 14,
		  "totalDays": 964,
		  "totalCountries": 5,
		  "totalStates": 49,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 2656,
		  "schedulePercent": 0.803264,
		  "totalGuests": 1323,
		  "guestPercent": 0.890752,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22d525eeea715800c0c9aa892dfd3e8a",
		  
		  "name": "Florian",
		  "createdDate": "2024-10-16 12:54:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 46,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 659,
		  "schedulePercent": 0.37126,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22da4779dca846de6924efa366d89998",
		  
		  "name": "Liam",
		  "createdDate": "2018-03-02 23:27:13",
		  "totalOrganizations": 17,
		  "totalTours": 79,
		  "totalDays": 456,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 4357,
		  "schedulePercent": 0.93325,
		  "totalGuests": 1348,
		  "guestPercent": 0.892792,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22dee3ec39aec0d03aafdff907eaf576",
		  
		  "name": "Mandy",
		  "createdDate": "2019-05-10 10:50:13",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 466,
		  "totalCountries": 25,
		  "totalStates": 29,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1228,
		  "schedulePercent": 0.554057,
		  "totalGuests": 1014,
		  "guestPercent": 0.849161,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "ParkbÃ¼hne Wuhlheide",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 268,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22e914b4f360f1aba1f9e18c8075d190",
		  
		  "name": "Sandrine",
		  "createdDate": "2021-06-22 09:18:38",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 69,
		  "totalCountries": 5,
		  "totalStates": 9,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 575,
		  "schedulePercent": 0.341455,
		  "totalGuests": 189,
		  "guestPercent": 0.585222,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Ocean Fest",
		  "mostGuestCity": "Biarritz",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22ece3eb4b42bce59708baa6eff5f3ae",
		  
		  "name": "Hemeli",
		  "createdDate": "2025-04-12 00:11:35",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 88,
		  "totalCountries": 12,
		  "totalStates": 28,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 406,
		  "schedulePercent": 0.272099,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "22fa6b19f6f9001913c2f69eb2d368a7",
		  
		  "name": "amber",
		  "createdDate": "2025-01-21 16:09:13",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 111,
		  "totalCountries": 8,
		  "totalStates": 22,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1110,
		  "schedulePercent": 0.520852,
		  "totalGuests": 188,
		  "guestPercent": 0.584882,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "The Mohawk",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2310e1d61696e1a25e319cd2c29819c2",
		  
		  "name": "Charles",
		  "createdDate": "2016-04-12 20:36:41",
		  "totalOrganizations": 21,
		  "totalTours": 20,
		  "totalDays": 557,
		  "totalCountries": 17,
		  "totalStates": 60,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 3369,
		  "schedulePercent": 0.873073,
		  "totalGuests": 158,
		  "guestPercent": 0.565277,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "ICON Festival stage at small park",
		  "mostGuestCity": "Cincinnati",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23110f1fe7a19606e1c397a4cf859a80",
		  
		  "name": "Keith",
		  "createdDate": "2016-10-25 02:38:44",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 91,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 926,
		  "schedulePercent": 0.467022,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "231600f659c3324636ff5dce0bb4fc3d",
		  
		  "name": "Kent",
		  "createdDate": "2013-08-29 01:18:16",
		  "totalOrganizations": 13,
		  "totalTours": 27,
		  "totalDays": 276,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1817,
		  "schedulePercent": 0.678944,
		  "totalGuests": 948,
		  "guestPercent": 0.839189,
		  "mostGuestDate": "2025-04-07 00:00:00",
		  "mostGuestName": "Ball Arena",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "231ab9e08497d3ce338077c30fb9fb47",
		  
		  "name": "Paul",
		  "createdDate": "2012-08-29 18:23:13",
		  "totalOrganizations": 17,
		  "totalTours": 13,
		  "totalDays": 233,
		  "totalCountries": 19,
		  "totalStates": 48,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1328,
		  "schedulePercent": 0.578989,
		  "totalGuests": 625,
		  "guestPercent": 0.764053,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "231d50ef3cac21987bb00d513995bd68",
		  
		  "name": "Shaun",
		  "createdDate": "2011-04-05 01:11:11",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 51,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 146,
		  "schedulePercent": 0.128173,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "232447cfefca6ea2688fe2391d2b1d8d",
		  
		  "name": "Elle",
		  "createdDate": "2025-08-12 21:32:14",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 52,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 250,
		  "schedulePercent": 0.189937,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Living Arts Centre",
		  "mostGuestCity": "Mississauga",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2332bbe398ec0e0906b053f4057fd58c",
		  
		  "name": "Jose",
		  "createdDate": "2013-07-07 21:29:13",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 17,
		  "totalStates": 27,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 402,
		  "schedulePercent": 0.270739,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thomas Jefferson Library of Congress",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23355c0e8c27ed1073a5746b6d7cf718",
		  
		  "name": "Tommy",
		  "createdDate": "2016-06-06 14:22:40",
		  "totalOrganizations": 21,
		  "totalTours": 81,
		  "totalDays": 664,
		  "totalCountries": 28,
		  "totalStates": 67,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 2766,
		  "schedulePercent": 0.817656,
		  "totalGuests": 688,
		  "guestPercent": 0.782978,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Bramall Lane",
		  "mostGuestCity": "Sheffield",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "233623dda0902a9653711ca5e3e8d6d8",
		  
		  "name": "Brett",
		  "createdDate": "2021-09-04 17:49:53",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 374,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1017,
		  "schedulePercent": 0.495354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "233c336af468db10cde87b111af95414",
		  
		  "name": "Catalina",
		  "createdDate": "2023-05-25 14:36:57",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 267,
		  "totalCountries": 17,
		  "totalStates": 37,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1280,
		  "schedulePercent": 0.567316,
		  "totalGuests": 237,
		  "guestPercent": 0.617294,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Roy Thomson Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "234caaf3c6f1870c1c6bfc881e49d39e",
		  
		  "name": "Houda",
		  "createdDate": "2025-03-25 22:38:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 44,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 312,
		  "schedulePercent": 0.223481,
		  "totalGuests": 281,
		  "guestPercent": 0.640299,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23500368675f1bfa809356edba2ad830",
		  
		  "name": "Jimmy",
		  "createdDate": "2023-07-26 18:12:39",
		  "totalOrganizations": 2,
		  "totalTours": 16,
		  "totalDays": 730,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1965,
		  "schedulePercent": 0.706482,
		  "totalGuests": 2502,
		  "guestPercent": 0.968155,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "236136032cd646e142a5d4af5ea2d5a7",
		  
		  "name": "Janne",
		  "createdDate": "2023-10-11 05:36:33",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 91,
		  "totalCountries": 19,
		  "totalStates": 24,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 458,
		  "schedulePercent": 0.293858,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "236530997abecd8ed9e6df66fa5a8baf",
		  
		  "name": "Kaylei",
		  "createdDate": "2022-04-04 17:37:08",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 122,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "237c067b72cf5c9424cc89eeb80a8969",
		  
		  "name": "Abigail",
		  "createdDate": "2017-12-29 18:10:24",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 1102,
		  "totalCountries": 30,
		  "totalStates": 94,
		  "totalEvents": 312,
		  "eventPercent": 0.920671,
		  "totalScheduleItems": 4381,
		  "schedulePercent": 0.934497,
		  "totalGuests": 1452,
		  "guestPercent": 0.905032,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2380ca6a942f21dfb90e1ea176561a1a",
		  
		  "name": "Scott",
		  "createdDate": "2010-10-01 22:37:18",
		  "totalOrganizations": 15,
		  "totalTours": 5,
		  "totalDays": 560,
		  "totalCountries": 3,
		  "totalStates": 52,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 2012,
		  "schedulePercent": 0.715435,
		  "totalGuests": 3113,
		  "guestPercent": 0.984248,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "239cff904488516df86d56223f6d8d15",
		  
		  "name": "Shadowgrass",
		  "createdDate": "2023-09-02 19:56:51",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 129,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 687,
		  "schedulePercent": 0.381573,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23abf34496bbcb58d8f2bfb6ed092d20",
		  
		  "name": "Jacob",
		  "createdDate": "2009-06-03 22:01:35",
		  "totalOrganizations": 14,
		  "totalTours": 23,
		  "totalDays": 452,
		  "totalCountries": 24,
		  "totalStates": 68,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 3396,
		  "schedulePercent": 0.875,
		  "totalGuests": 2072,
		  "guestPercent": 0.951949,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23ac297ddf766c7c3389bba709e69abe",
		  
		  "name": "Poppy",
		  "createdDate": "2025-07-26 03:27:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 164,
		  "totalCountries": 8,
		  "totalStates": 13,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 226,
		  "schedulePercent": 0.174977,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Neumos",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23b8435ec9d2de22626c710ba7939bcc",
		  
		  "name": "Mikella",
		  "createdDate": "2025-03-05 15:38:00",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 232,
		  "totalCountries": 12,
		  "totalStates": 16,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 593,
		  "schedulePercent": 0.348595,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23b8e6f6edb1e451430b5377544157c6",
		  
		  "name": "Kevin",
		  "createdDate": "2023-03-13 21:06:45",
		  "totalOrganizations": 15,
		  "totalTours": 24,
		  "totalDays": 1091,
		  "totalCountries": 20,
		  "totalStates": 82,
		  "totalEvents": 318,
		  "eventPercent": 0.924411,
		  "totalScheduleItems": 3658,
		  "schedulePercent": 0.893472,
		  "totalGuests": 1124,
		  "guestPercent": 0.867294,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Mercury Lounge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23b8ec53ae46ac38c2a58a14898960a7",
		  
		  "name": "Mattx",
		  "createdDate": "2024-02-14 05:23:45",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 91,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 476,
		  "schedulePercent": 0.300884,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Last Exit Live",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23c788ec76b3b04bbeb7d4e4d4c91839",
		  
		  "name": "Jodi",
		  "createdDate": "2021-01-28 15:35:38",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 134,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Temple Theater for the Performing Arts",
		  "mostGuestCity": "Meridian",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23c7927f85e150a0748b23508d9c6aee",
		  
		  "name": "Scott",
		  "createdDate": "2025-09-04 22:37:03",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 67,
		  "totalCountries": 8,
		  "totalStates": 8,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 216,
		  "schedulePercent": 0.169538,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23c8835d7772f2ada645de8a6f113cc9",
		  
		  "name": "Kenny",
		  "createdDate": "2013-10-02 19:40:31",
		  "totalOrganizations": 9,
		  "totalTours": 30,
		  "totalDays": 580,
		  "totalCountries": 26,
		  "totalStates": 77,
		  "totalEvents": 345,
		  "eventPercent": 0.939937,
		  "totalScheduleItems": 3904,
		  "schedulePercent": 0.908772,
		  "totalGuests": 662,
		  "guestPercent": 0.775159,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Punk In The Park - Cow Palace",
		  "mostGuestCity": "Daly City",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23d8a0a826f6c17c1495cb8f55692e9d",
		  
		  "name": "GRANT",
		  "createdDate": "2025-07-16 03:06:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 168,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1700,
		  "schedulePercent": 0.658545,
		  "totalGuests": 1079,
		  "guestPercent": 0.860381,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23da0b39952f461bcf45c24c17c1f994",
		  
		  "name": "JULIEN",
		  "createdDate": "2024-10-09 08:39:35",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 102,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 268,
		  "schedulePercent": 0.198209,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23e476cce8ea5c5b4f11279e248e983c",
		  
		  "name": "Derek",
		  "createdDate": "2016-04-21 21:11:48",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 139,
		  "totalCountries": 14,
		  "totalStates": 32,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 663,
		  "schedulePercent": 0.372507,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23ee5d47d7ca8a9a7612b8bb047c1719",
		  
		  "name": "Ben",
		  "createdDate": "2021-06-13 23:37:38",
		  "totalOrganizations": 10,
		  "totalTours": 22,
		  "totalDays": 584,
		  "totalCountries": 13,
		  "totalStates": 17,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1061,
		  "schedulePercent": 0.506686,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23eeedd47c31a3cbb97c495b74e4a156",
		  
		  "name": "Mark",
		  "createdDate": "2015-12-09 03:43:19",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 829,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 1621,
		  "schedulePercent": 0.644719,
		  "totalGuests": 451,
		  "guestPercent": 0.713055,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Lake Martin Amphitheater",
		  "mostGuestCity": "Eclectic",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "23f36d606047d4d7bfb20c53639251cc",
		  
		  "name": "Kahlil ",
		  "createdDate": "2011-05-06 19:25:49",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2414f05e4664d36a58b26c1bad24acad",
		  
		  "name": "Ernesto",
		  "createdDate": "2011-07-06 22:24:47",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 966,
		  "totalCountries": 18,
		  "totalStates": 77,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 4174,
		  "schedulePercent": 0.924297,
		  "totalGuests": 422,
		  "guestPercent": 0.703536,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2421f9cb3ccff2bbec02c8c69405d8c9",
		  
		  "name": "Chad",
		  "createdDate": "2023-08-02 21:23:29",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 612,
		  "totalCountries": 12,
		  "totalStates": 58,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 4141,
		  "schedulePercent": 0.921578,
		  "totalGuests": 1171,
		  "guestPercent": 0.8733,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Grand Sierra Theater",
		  "mostGuestCity": "Reno",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "242255a8d7a71998b884e31a0d3ff5df",
		  
		  "name": "Reid",
		  "createdDate": "2022-06-13 15:36:44",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 1074,
		  "totalCountries": 6,
		  "totalStates": 48,
		  "totalEvents": 270,
		  "eventPercent": 0.890299,
		  "totalScheduleItems": 3924,
		  "schedulePercent": 0.910018,
		  "totalGuests": 2088,
		  "guestPercent": 0.953422,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2435858a6c6b98dd8c519fb6b9860928",
		  
		  "name": "Deborah",
		  "createdDate": "2024-09-09 14:24:22",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 350,
		  "totalCountries": 14,
		  "totalStates": 24,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 585,
		  "schedulePercent": 0.345648,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Stylus",
		  "mostGuestCity": "Leeds",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24358845973454ef39cb8677e1efa3d5",
		  
		  "name": "Jordan",
		  "createdDate": "2025-04-24 19:31:46",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 121,
		  "totalCountries": 18,
		  "totalStates": 43,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 903,
		  "schedulePercent": 0.459089,
		  "totalGuests": 215,
		  "guestPercent": 0.605281,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Teh Aztec theatre",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24398ba42d722c93bf602330ff24c424",
		  
		  "name": "Maggie",
		  "createdDate": "2023-08-01 18:41:54",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 170,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 656,
		  "schedulePercent": 0.37024,
		  "totalGuests": 532,
		  "guestPercent": 0.738327,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24460b3d67b6f27620008d53484bc122",
		  
		  "name": "Thomas",
		  "createdDate": "2015-10-29 21:05:03",
		  "totalOrganizations": 15,
		  "totalTours": 15,
		  "totalDays": 927,
		  "totalCountries": 35,
		  "totalStates": 84,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 4181,
		  "schedulePercent": 0.924864,
		  "totalGuests": 1101,
		  "guestPercent": 0.864121,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24461cc787b5151026febc899129f60e",
		  
		  "name": "Sam ",
		  "createdDate": "2023-10-20 02:19:09",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-03-05 00:00:00",
		  "mostGuestName": "Whammy Bar",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2447d2b620e5fbedbd619ee936b532d1",
		  
		  "name": "Ulrika",
		  "createdDate": "2025-03-02 10:51:19",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 44,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 124,
		  "schedulePercent": 0.114007,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24663c30e4f9c7a1be89c58b3ba30a93",
		  
		  "name": "Lora",
		  "createdDate": "2025-01-22 18:53:35",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 2186,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 1137,
		  "schedulePercent": 0.530825,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Constellation Room",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2473f76cbd87bd42860c9ee93b926046",
		  
		  "name": "Andrew",
		  "createdDate": "2019-04-07 19:50:37",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 51,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 393,
		  "schedulePercent": 0.266432,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2494b3216c2666d522699983bb50fe27",
		  
		  "name": "Sepi",
		  "createdDate": "2023-02-13 02:57:17",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 1041,
		  "totalCountries": 33,
		  "totalStates": 41,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 2893,
		  "schedulePercent": 0.831369,
		  "totalGuests": 460,
		  "guestPercent": 0.715775,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "249c00112f454151946032de17f155e6",
		  
		  "name": "Justin",
		  "createdDate": "2014-01-17 15:20:40",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 260,
		  "totalCountries": 27,
		  "totalStates": 64,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 3102,
		  "schedulePercent": 0.851541,
		  "totalGuests": 712,
		  "guestPercent": 0.788418,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Jyske Bank BOXEN",
		  "mostGuestCity": "Herning",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24a0082c0f13dbf33b07349546ee9b12",
		  
		  "name": "Jean-Louis",
		  "createdDate": "2018-10-27 06:32:10",
		  "totalOrganizations": 3,
		  "totalTours": 15,
		  "totalDays": 324,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2708,
		  "schedulePercent": 0.80961,
		  "totalGuests": 1454,
		  "guestPercent": 0.905825,
		  "mostGuestDate": "2025-04-28 00:00:00",
		  "mostGuestName": "Arena CDMX",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24a6a0b1ff06abd60eed132142d615c1",
		  
		  "name": "travis",
		  "createdDate": "2022-06-13 20:21:00",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 159,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1343,
		  "schedulePercent": 0.584089,
		  "totalGuests": 602,
		  "guestPercent": 0.75884,
		  "mostGuestDate": "2025-01-04 00:00:00",
		  "mostGuestName": "Billy Bob's Texas",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24ab146325c8c3d3dc6aa091cb4d2c48",
		  
		  "name": "Joseph",
		  "createdDate": "2019-05-31 22:32:25",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 1312,
		  "totalCountries": 18,
		  "totalStates": 36,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1466,
		  "schedulePercent": 0.610267,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Tacoma Dome",
		  "mostGuestCity": "Tacoma",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24afee0f162cfcf96c0fba503252bc88",
		  
		  "name": "Ted",
		  "createdDate": "2025-03-25 14:31:29",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 101,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 601,
		  "schedulePercent": 0.351315,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24b13cb16a66c0cbd6dfbd07c12c3733",
		  
		  "name": "Cordell",
		  "createdDate": "2021-12-10 17:33:12",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 376,
		  "totalCountries": 12,
		  "totalStates": 37,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 2159,
		  "schedulePercent": 0.741047,
		  "totalGuests": 1027,
		  "guestPercent": 0.850975,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24b18fca81d5e3611f39ea9c646953ae",
		  
		  "name": "Kyle",
		  "createdDate": "2016-11-10 18:22:46",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 1090,
		  "totalCountries": 7,
		  "totalStates": 59,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 3271,
		  "schedulePercent": 0.866047,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Sidney Myer Music Bowl",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24b2afd3050f58fbddf3b25fa650456a",
		  
		  "name": "Ayla",
		  "createdDate": "2022-07-02 04:22:13",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 48,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 417,
		  "schedulePercent": 0.276972,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "The Espee",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24cb27ac5b2ebac7f8b3b8d16fdee19f",
		  
		  "name": "Jason",
		  "createdDate": "2023-05-23 17:35:00",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 447,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1391,
		  "schedulePercent": 0.595195,
		  "totalGuests": 360,
		  "guestPercent": 0.67815,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24cdaa34009254d91a25bc142a0f70d8",
		  
		  "name": "Adam",
		  "createdDate": "2025-04-18 14:46:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 255,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 147,
		  "schedulePercent": 0.128853,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24ce29e5b55a31c8772884792b077590",
		  
		  "name": "Pierre-Philippe",
		  "createdDate": "2014-07-30 18:05:12",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 254,
		  "totalCountries": 17,
		  "totalStates": 27,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 1878,
		  "schedulePercent": 0.690616,
		  "totalGuests": 213,
		  "guestPercent": 0.604261,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Paleo Festival Nyon",
		  "mostGuestCity": "Nyon",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24d79c295a76c44b04a0f189b2be1999",
		  
		  "name": "Andrew",
		  "createdDate": "2021-07-18 19:35:40",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 1000,
		  "totalCountries": 26,
		  "totalStates": 71,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 2370,
		  "schedulePercent": 0.771532,
		  "totalGuests": 418,
		  "guestPercent": 0.701043,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24d857546e8ab22a28dd88294977a589",
		  
		  "name": "Tanner",
		  "createdDate": "2016-07-17 04:32:52",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 392,
		  "totalCountries": 23,
		  "totalStates": 58,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 3952,
		  "schedulePercent": 0.910925,
		  "totalGuests": 4099,
		  "guestPercent": 0.99388,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24df474242ad580c16fe59ace969397c",
		  
		  "name": "Aaron",
		  "createdDate": "2023-06-02 19:00:08",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 60,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 397,
		  "schedulePercent": 0.268019,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Lion's Park",
		  "mostGuestCity": "Brantford ",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24e1e891521ae8ec9f4e7c77dab4d13d",
		  
		  "name": "kizzie",
		  "createdDate": "2022-11-08 09:53:48",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 122,
		  "totalCountries": 15,
		  "totalStates": 11,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 309,
		  "schedulePercent": 0.222235,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Victoria Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24ed92f93cd6e60bb0e9c9bc1cd183de",
		  
		  "name": "Andrerica",
		  "createdDate": "2022-07-07 23:19:39",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 171,
		  "totalCountries": 8,
		  "totalStates": 18,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1483,
		  "schedulePercent": 0.613894,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24ee686ed2e9c887492e53e864c6a5f8",
		  
		  "name": "nathan",
		  "createdDate": "2024-11-07 03:48:10",
		  "totalOrganizations": 93,
		  "totalTours": 70,
		  "totalDays": 1479,
		  "totalCountries": 22,
		  "totalStates": 53,
		  "totalEvents": 537,
		  "eventPercent": 0.982661,
		  "totalScheduleItems": 5550,
		  "schedulePercent": 0.968608,
		  "totalGuests": 1215,
		  "guestPercent": 0.877493,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "24f1472537c066a5ecf5274690f40239",
		  
		  "name": "Brandon",
		  "createdDate": "2011-07-28 05:10:10",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 562,
		  "totalCountries": 3,
		  "totalStates": 47,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 1957,
		  "schedulePercent": 0.704669,
		  "totalGuests": 1125,
		  "guestPercent": 0.867407,
		  "mostGuestDate": "2025-08-04 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "250fdc4540a753200d4555cec65d2932",
		  
		  "name": "Damb",
		  "createdDate": "2021-11-08 16:21:42",
		  "totalOrganizations": 10,
		  "totalTours": 27,
		  "totalDays": 621,
		  "totalCountries": 19,
		  "totalStates": 71,
		  "totalEvents": 295,
		  "eventPercent": 0.909678,
		  "totalScheduleItems": 4124,
		  "schedulePercent": 0.920558,
		  "totalGuests": 2305,
		  "guestPercent": 0.962602,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2510ac2afab894b8524bf010e8422757",
		  
		  "name": "Joost",
		  "createdDate": "2018-06-28 16:12:01",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 657,
		  "totalCountries": 25,
		  "totalStates": 75,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 1865,
		  "schedulePercent": 0.68835,
		  "totalGuests": 473,
		  "guestPercent": 0.721668,
		  "mostGuestDate": "2025-02-11 00:00:00",
		  "mostGuestName": "Benaroya Hall",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2513b8b6fa8e2e6ac72f8a01aa4db69b",
		  
		  "name": "Militarie",
		  "createdDate": "2022-09-28 20:10:52",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 85,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 395,
		  "schedulePercent": 0.266772,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "170 Russell",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "251b6916689e8eccab2e6d0f9b91f813",
		  
		  "name": "Michael",
		  "createdDate": "2023-09-20 18:42:45",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 500,
		  "schedulePercent": 0.31199,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "252195cea1b16666b47130c71faf6fc2",
		  
		  "name": "Theo",
		  "createdDate": "2025-10-31 11:28:48",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 46,
		  "totalCountries": 1,
		  "totalStates": 11,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 189,
		  "schedulePercent": 0.152539,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "253042e5291c43aa30e7b60418231417",
		  
		  "name": "Jonathan",
		  "createdDate": "2016-01-25 13:50:28",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 194,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 1440,
		  "schedulePercent": 0.605961,
		  "totalGuests": 358,
		  "guestPercent": 0.677471,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Fredagsrock i Tivoli",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "253540d73f2af3fb1c8df1b42829fe86",
		  
		  "name": "Dan",
		  "createdDate": "2019-04-30 02:53:02",
		  "totalOrganizations": 9,
		  "totalTours": 37,
		  "totalDays": 496,
		  "totalCountries": 23,
		  "totalStates": 39,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 2831,
		  "schedulePercent": 0.825929,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Cheese & Grain",
		  "mostGuestCity": "Frome",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "253646a3d8d2fa94646f96ff5a6d0b82",
		  
		  "name": "Matthew",
		  "createdDate": "2015-05-29 06:56:47",
		  "totalOrganizations": 11,
		  "totalTours": 4,
		  "totalDays": 224,
		  "totalCountries": 24,
		  "totalStates": 36,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 796,
		  "schedulePercent": 0.421238,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Alcatraz",
		  "mostGuestCity": "Milano",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25381a0885195694034004d1900870e0",
		  
		  "name": "Cole ",
		  "createdDate": "2025-05-15 12:10:58",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 320,
		  "totalCountries": 18,
		  "totalStates": 38,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 915,
		  "schedulePercent": 0.463055,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-09-15 00:00:00",
		  "mostGuestName": "Trabendo",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25394cc2362fa3990616fb95ee1a7bd3",
		  
		  "name": "Production",
		  "createdDate": "2021-10-28 14:18:25",
		  "totalOrganizations": 38,
		  "totalTours": 29,
		  "totalDays": 510,
		  "totalCountries": 11,
		  "totalStates": 5,
		  "totalEvents": 497,
		  "eventPercent": 0.978468,
		  "totalScheduleItems": 2506,
		  "schedulePercent": 0.787398,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Hotel Cecil",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "253c099c7bae695449775f4d6d2915d0",
		  
		  "name": "Kelly",
		  "createdDate": "2018-09-02 20:18:03",
		  "totalOrganizations": 14,
		  "totalTours": 33,
		  "totalDays": 693,
		  "totalCountries": 20,
		  "totalStates": 68,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 4145,
		  "schedulePercent": 0.921917,
		  "totalGuests": 1636,
		  "guestPercent": 0.922937,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25576316e14ff4e93d276098a6dc235a",
		  
		  "name": "Eric",
		  "createdDate": "2016-02-02 21:06:07",
		  "totalOrganizations": 26,
		  "totalTours": 34,
		  "totalDays": 773,
		  "totalCountries": 22,
		  "totalStates": 72,
		  "totalEvents": 393,
		  "eventPercent": 0.957162,
		  "totalScheduleItems": 3591,
		  "schedulePercent": 0.888486,
		  "totalGuests": 2143,
		  "guestPercent": 0.955462,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Thompson's Point",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25577ff22565e466fa3fdd64864896e8",
		  
		  "name": "Joshua",
		  "createdDate": "2016-05-09 09:46:00",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 667,
		  "totalCountries": 18,
		  "totalStates": 41,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 646,
		  "schedulePercent": 0.36582,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thomas Jefferson Library of Congress",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "255a8c83d453dd6334d0da0757534408",
		  
		  "name": "Steven",
		  "createdDate": "2017-06-01 11:05:01",
		  "totalOrganizations": 10,
		  "totalTours": 17,
		  "totalDays": 422,
		  "totalCountries": 21,
		  "totalStates": 68,
		  "totalEvents": 202,
		  "eventPercent": 0.804397,
		  "totalScheduleItems": 2719,
		  "schedulePercent": 0.811877,
		  "totalGuests": 308,
		  "guestPercent": 0.653105,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "255fd9a79cf76d050edb09bc3762aa5e",
		  
		  "name": "Eldis",
		  "createdDate": "2025-03-01 19:00:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 72,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 5,
		  "schedulePercent": 0.0151859,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "256c8b180d141129c1a72cfaa51e5c01",
		  
		  "name": "Taylor",
		  "createdDate": "2012-11-07 17:16:46",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 1077,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 2827,
		  "schedulePercent": 0.825249,
		  "totalGuests": 2015,
		  "guestPercent": 0.948209,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "256efd12e06f8e9ba0349bf95b2c0854",
		  
		  "name": "Alexander",
		  "createdDate": "2017-04-25 10:34:04",
		  "totalOrganizations": 10,
		  "totalTours": 2,
		  "totalDays": 424,
		  "totalCountries": 17,
		  "totalStates": 42,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 368,
		  "schedulePercent": 0.252153,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2589c88fe201217dca56cf1612d5554f",
		  
		  "name": "Matt",
		  "createdDate": "2013-06-01 21:59:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 1080,
		  "schedulePercent": 0.514279,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "258a610c6a20291dec071e4ba6d1d28b",
		  
		  "name": "Sophia",
		  "createdDate": "2025-08-19 18:04:25",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 540,
		  "totalCountries": 9,
		  "totalStates": 34,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 710,
		  "schedulePercent": 0.390639,
		  "totalGuests": 183,
		  "guestPercent": 0.581482,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Stranahan Theatre",
		  "mostGuestCity": "Toledo",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "258af77e550fe15d9ccea8207e4d11ad",
		  
		  "name": "Chris",
		  "createdDate": "2022-06-10 23:36:18",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 184,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1685,
		  "schedulePercent": 0.655938,
		  "totalGuests": 661,
		  "guestPercent": 0.774932,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25946fdca547e57987743ef6ebaa224a",
		  
		  "name": "Clayton",
		  "createdDate": "2023-07-28 19:23:46",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 100,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 699,
		  "schedulePercent": 0.386333,
		  "totalGuests": 196,
		  "guestPercent": 0.591568,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Goldfield Trading Post",
		  "mostGuestCity": "Roseville",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "259d55495f47310d53f5b128761f892d",
		  
		  "name": "Shawn",
		  "createdDate": "2024-02-26 18:09:08",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 461,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 430,
		  "schedulePercent": 0.281958,
		  "totalGuests": 166,
		  "guestPercent": 0.570263,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Cook County Saloon",
		  "mostGuestCity": "Edmonton",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25a15078d83e6ea55070ae83c8b9241c",
		  
		  "name": "Lou ",
		  "createdDate": "2025-01-10 03:09:37",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 331,
		  "totalCountries": 8,
		  "totalStates": 13,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 579,
		  "schedulePercent": 0.343155,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25a2ee8c29407fe5e20dcbf950cad0a5",
		  
		  "name": "Samantha",
		  "createdDate": "2023-05-02 17:12:26",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 732,
		  "totalCountries": 23,
		  "totalStates": 49,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1228,
		  "schedulePercent": 0.554057,
		  "totalGuests": 230,
		  "guestPercent": 0.612534,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25b278e6cb4066c1c605eec917765829",
		  
		  "name": "James",
		  "createdDate": "2023-07-06 17:51:42",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 49,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 486,
		  "schedulePercent": 0.304397,
		  "totalGuests": 413,
		  "guestPercent": 0.698663,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Intuit Dome",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25b574f80dc15fcafb2c36dc741655d4",
		  
		  "name": "Meggan",
		  "createdDate": "2013-12-03 14:15:00",
		  "totalOrganizations": 12,
		  "totalTours": 4,
		  "totalDays": 144,
		  "totalCountries": 12,
		  "totalStates": 12,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 448,
		  "schedulePercent": 0.289778,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25b9c8de248147ef38e14532cdcdebb1",
		  
		  "name": "Mark",
		  "createdDate": "2023-05-18 14:29:24",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 38,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 196,
		  "schedulePercent": 0.158772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25b9cbd94789033307739bbc701c45e4",
		  
		  "name": "Maria",
		  "createdDate": "2024-06-03 13:54:20",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 69,
		  "totalCountries": 10,
		  "totalStates": 7,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 355,
		  "schedulePercent": 0.245127,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Patronaat",
		  "mostGuestCity": "Haarlem",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25b9d10f6d80c6d6fb80e7dae401c813",
		  
		  "name": "Steve",
		  "createdDate": "2010-05-06 17:06:48",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 1033,
		  "totalCountries": 13,
		  "totalStates": 55,
		  "totalEvents": 260,
		  "eventPercent": 0.881573,
		  "totalScheduleItems": 4026,
		  "schedulePercent": 0.915005,
		  "totalGuests": 1332,
		  "guestPercent": 0.891432,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25bace51fc7a8ed0b084b0e798a24c25",
		  
		  "name": "Erik",
		  "createdDate": "2024-06-27 18:35:50",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 358,
		  "schedulePercent": 0.247167,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25bba0788861445a9faa445070a05e9c",
		  
		  "name": "Ethan",
		  "createdDate": "2024-01-14 17:11:40",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 67,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 82,
		  "schedulePercent": 0.0838622,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25be62996611775fe9b0a7f65398b198",
		  
		  "name": "Angelo",
		  "createdDate": "2025-07-24 11:25:02",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 67,
		  "totalCountries": 16,
		  "totalStates": 14,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 533,
		  "schedulePercent": 0.328196,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Columbia Theater",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25c91a5175eda91720f33ef6d9220b67",
		  
		  "name": "Vanessa",
		  "createdDate": "2024-03-09 20:20:03",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 1005,
		  "totalCountries": 11,
		  "totalStates": 14,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1041,
		  "schedulePercent": 0.5017,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-07-07 00:00:00",
		  "mostGuestName": "jazz a vienne",
		  "mostGuestCity": "",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25ca0737c694bb4d65b01a3f52eb90a9",
		  
		  "name": "Drew ",
		  "createdDate": "2023-12-07 15:57:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1012,
		  "schedulePercent": 0.493994,
		  "totalGuests": 481,
		  "guestPercent": 0.724615,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Soldiers and Sailors Memorial Auditorium",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25cb4875886fef35cd370d16630b3b25",
		  
		  "name": "Jose",
		  "createdDate": "2015-07-04 15:27:54",
		  "totalOrganizations": 14,
		  "totalTours": 21,
		  "totalDays": 389,
		  "totalCountries": 7,
		  "totalStates": 47,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1682,
		  "schedulePercent": 0.655032,
		  "totalGuests": 1274,
		  "guestPercent": 0.882933,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25dd83a1c4a56ea888f9e9965ce17a73",
		  
		  "name": "Corbett â€œCorbyâ€\u009D ",
		  "createdDate": "2021-10-30 03:09:20",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 189,
		  "totalCountries": 8,
		  "totalStates": 34,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 726,
		  "schedulePercent": 0.396646,
		  "totalGuests": 835,
		  "guestPercent": 0.816296,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "The Torch",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25e39e43881187c7d1db2dd1a8b29ddc",
		  
		  "name": "Priscila",
		  "createdDate": "2024-05-27 16:29:31",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 83,
		  "totalCountries": 12,
		  "totalStates": 26,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 444,
		  "schedulePercent": 0.288078,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-05-11 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25eb57cedda8cdb0b6fab5f2f2da239d",
		  
		  "name": "Arthur",
		  "createdDate": "2024-11-23 09:07:25",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 207,
		  "totalCountries": 10,
		  "totalStates": 27,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1945,
		  "schedulePercent": 0.702743,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Foreztival",
		  "mostGuestCity": "Trelins",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25f8c381d5e20703f04e14f41e035ec6",
		  
		  "name": "David",
		  "createdDate": "2011-03-11 23:24:28",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 107,
		  "totalCountries": 6,
		  "totalStates": 20,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 876,
		  "schedulePercent": 0.449683,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25fd999887be818357b6273925302e4a",
		  
		  "name": "Ben",
		  "createdDate": "2017-06-03 03:26:23",
		  "totalOrganizations": 22,
		  "totalTours": 38,
		  "totalDays": 747,
		  "totalCountries": 16,
		  "totalStates": 53,
		  "totalEvents": 246,
		  "eventPercent": 0.866954,
		  "totalScheduleItems": 3472,
		  "schedulePercent": 0.880666,
		  "totalGuests": 2079,
		  "guestPercent": 0.952743,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "25fdcafd7074cacb60b8c2c397b5ae7b",
		  
		  "name": "Michael",
		  "createdDate": "2022-08-24 19:39:52",
		  "totalOrganizations": 18,
		  "totalTours": 22,
		  "totalDays": 2532,
		  "totalCountries": 22,
		  "totalStates": 65,
		  "totalEvents": 342,
		  "eventPercent": 0.93767,
		  "totalScheduleItems": 3274,
		  "schedulePercent": 0.866274,
		  "totalGuests": 367,
		  "guestPercent": 0.679964,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "260c0069d44875be6e9f04118d4db233",
		  
		  "name": "Richie ",
		  "createdDate": "2015-02-05 17:05:16",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 871,
		  "totalCountries": 23,
		  "totalStates": 66,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 3189,
		  "schedulePercent": 0.858908,
		  "totalGuests": 566,
		  "guestPercent": 0.74796,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "260eed9b467da01ac940e3c1c139a1b7",
		  
		  "name": "SÃ©verine",
		  "createdDate": "2025-03-18 19:41:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 63,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 153,
		  "schedulePercent": 0.131686,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "Jazz au phare",
		  "mostGuestCity": "Saint-ClÃ©ment-des-Baleines",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "261bb13b600b096599e1bb7b7fa59f98",
		  
		  "name": "Rene",
		  "createdDate": "2023-03-11 08:36:42",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 101,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "261d242e266a5642258ac4b7b8cd76f9",
		  
		  "name": "Sebastian",
		  "createdDate": "2018-02-07 02:59:01",
		  "totalOrganizations": 13,
		  "totalTours": 40,
		  "totalDays": 489,
		  "totalCountries": 41,
		  "totalStates": 60,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 3493,
		  "schedulePercent": 0.8818,
		  "totalGuests": 680,
		  "guestPercent": 0.781165,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "Backstage Halle",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2624cdff26601fd909beeba450b6ccea",
		  
		  "name": "Anthony",
		  "createdDate": "2012-08-06 05:31:54",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 325,
		  "totalCountries": 19,
		  "totalStates": 33,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1260,
		  "schedulePercent": 0.562897,
		  "totalGuests": 427,
		  "guestPercent": 0.705576,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Metropolis",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2643d2bbc39682ee5eb705bda2e9971a",
		  
		  "name": "Sofia Agostina",
		  "createdDate": "2025-04-02 13:45:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 382,
		  "schedulePercent": 0.259406,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26534c86f46c503f3b0d66260b38ba44",
		  
		  "name": "Lukas",
		  "createdDate": "2025-01-07 21:29:22",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 122,
		  "totalCountries": 4,
		  "totalStates": 11,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 537,
		  "schedulePercent": 0.329556,
		  "totalGuests": 138,
		  "guestPercent": 0.550997,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "HebebÃ¼hne",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2664a21acdc71cb069d9db77620a5b84",
		  
		  "name": "Elijah",
		  "createdDate": "2012-01-09 18:41:53",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 109,
		  "totalCountries": 7,
		  "totalStates": 14,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 671,
		  "schedulePercent": 0.375227,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "267253c58601d7311777f469646a1dc1",
		  
		  "name": "Max",
		  "createdDate": "2022-11-30 16:31:40",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 1096,
		  "totalCountries": 15,
		  "totalStates": 33,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1240,
		  "schedulePercent": 0.557344,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2672883e3f2d91c6fe13704171d1b63f",
		  
		  "name": "Matthew",
		  "createdDate": "2018-06-19 15:12:13",
		  "totalOrganizations": 23,
		  "totalTours": 11,
		  "totalDays": 991,
		  "totalCountries": 27,
		  "totalStates": 72,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 2684,
		  "schedulePercent": 0.80723,
		  "totalGuests": 182,
		  "guestPercent": 0.581142,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Velvet Underground",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26835bb28d9c233fcd73b55bbaf16bfd",
		  
		  "name": "Scott",
		  "createdDate": "2024-04-16 03:00:24",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 286,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 431,
		  "schedulePercent": 0.282412,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2683fbeaf4091d6b8263479a0bf8fd61",
		  
		  "name": "Cory",
		  "createdDate": "2011-04-26 19:06:13",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 467,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1084,
		  "schedulePercent": 0.515299,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Voodoo Lounge",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "268a2e5e7c6d02b4e9b694850f83f3e0",
		  
		  "name": "Sean",
		  "createdDate": "2015-03-14 09:36:18",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 83,
		  "totalCountries": 9,
		  "totalStates": 40,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 775,
		  "schedulePercent": 0.414551,
		  "totalGuests": 751,
		  "guestPercent": 0.796464,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "The Dome",
		  "mostGuestCity": "Virginia Beach",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "269481041fa9566efc39bbdee8e7cc2b",
		  
		  "name": "Rebecca",
		  "createdDate": "2022-04-18 15:31:11",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2697486058eb7d4398fac070d0c7caf3",
		  
		  "name": "Jeff",
		  "createdDate": "2016-08-24 05:18:18",
		  "totalOrganizations": 13,
		  "totalTours": 38,
		  "totalDays": 390,
		  "totalCountries": 31,
		  "totalStates": 76,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2148,
		  "schedulePercent": 0.739347,
		  "totalGuests": 1303,
		  "guestPercent": 0.886446,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The Fillmore Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "269ca173ddd131960c8feac1783f6394",
		  
		  "name": "Dustin",
		  "createdDate": "2014-10-17 06:13:11",
		  "totalOrganizations": 11,
		  "totalTours": 20,
		  "totalDays": 1241,
		  "totalCountries": 27,
		  "totalStates": 99,
		  "totalEvents": 451,
		  "eventPercent": 0.971215,
		  "totalScheduleItems": 6023,
		  "schedulePercent": 0.975748,
		  "totalGuests": 2634,
		  "guestPercent": 0.973368,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 122,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "269dc210cb87b5fab4a52fa996a86694",
		  
		  "name": "Valerie",
		  "createdDate": "2024-08-19 16:30:52",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "269f7ff235ef3aad4d4cf4fd8a70cd24",
		  
		  "name": "Kevin",
		  "createdDate": "2024-08-10 16:31:40",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 104,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 897,
		  "schedulePercent": 0.457162,
		  "totalGuests": 471,
		  "guestPercent": 0.720762,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Wang Theater",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26cb0bc0781a648833f3ce41ab59831c",
		  
		  "name": "Eduardo",
		  "createdDate": "2025-06-11 11:44:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 20,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 204,
		  "schedulePercent": 0.163531,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Plaza de Toros La Malagueta",
		  "mostGuestCity": "MÃ¡laga",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26d58f2f1a1269c98593c403ac73730c",
		  
		  "name": "Adam",
		  "createdDate": "2021-06-11 17:17:02",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 89,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 359,
		  "schedulePercent": 0.24762,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26dfa5af8c72bd3ffff375031e6a02ad",
		  
		  "name": "MEAN",
		  "createdDate": "2023-08-01 17:18:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 153,
		  "totalCountries": 4,
		  "totalStates": 24,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 898,
		  "schedulePercent": 0.457502,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26e051e6785c505fedc5dde38923cf10",
		  
		  "name": "Sam",
		  "createdDate": "2023-08-16 13:31:09",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 115,
		  "totalCountries": 11,
		  "totalStates": 12,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 591,
		  "schedulePercent": 0.347915,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-02-11 00:00:00",
		  "mostGuestName": "Die Kantine",
		  "mostGuestCity": "Koln",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26eaa71ead46dd1ffce4339c3e3f601b",
		  
		  "name": "Ross",
		  "createdDate": "2017-04-07 02:09:10",
		  "totalOrganizations": 10,
		  "totalTours": 20,
		  "totalDays": 684,
		  "totalCountries": 26,
		  "totalStates": 65,
		  "totalEvents": 245,
		  "eventPercent": 0.866047,
		  "totalScheduleItems": 4162,
		  "schedulePercent": 0.922824,
		  "totalGuests": 176,
		  "guestPercent": 0.577743,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Decca Live",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26edc7b087e3e28162478e78b15df5ef",
		  
		  "name": "Kate",
		  "createdDate": "2019-09-04 23:13:56",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 153,
		  "totalCountries": 7,
		  "totalStates": 20,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1182,
		  "schedulePercent": 0.542838,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "New York City Center",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26edcb20e1ea9f2d120d1cb003f13641",
		  
		  "name": "Braden",
		  "createdDate": "2022-03-31 18:05:28",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 756,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 2313,
		  "schedulePercent": 0.763599,
		  "totalGuests": 1032,
		  "guestPercent": 0.851541,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "26ef4c51eeb6d7d85a43da6a4ec10f79",
		  
		  "name": "Gerald ",
		  "createdDate": "2021-06-09 17:50:20",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 522,
		  "totalCountries": 4,
		  "totalStates": 22,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 1484,
		  "schedulePercent": 0.614121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "270a320156dc388a3bd1e4604b37f3ce",
		  
		  "name": "Sofia",
		  "createdDate": "2022-03-22 10:09:42",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 197,
		  "totalCountries": 6,
		  "totalStates": 17,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 990,
		  "schedulePercent": 0.488554,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "270fee394f42404d6264b4d7d29130c6",
		  
		  "name": "Rachel",
		  "createdDate": "2017-03-06 00:14:19",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 127,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 594,
		  "schedulePercent": 0.349275,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27101df2d0157036dfbc9336f60d7c71",
		  
		  "name": "Jacqueline",
		  "createdDate": "2018-07-31 15:39:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 38,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 217,
		  "schedulePercent": 0.170104,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-09-16 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "271f8a10eaefe36baaf11aec1c10c1e0",
		  
		  "name": "Jamie",
		  "createdDate": "2013-10-16 00:11:37",
		  "totalOrganizations": 103,
		  "totalTours": 43,
		  "totalDays": 1173,
		  "totalCountries": 36,
		  "totalStates": 95,
		  "totalEvents": 353,
		  "eventPercent": 0.94345,
		  "totalScheduleItems": 4410,
		  "schedulePercent": 0.935177,
		  "totalGuests": 681,
		  "guestPercent": 0.781392,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Roy Thomson Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2722e9ac126476532f437a85c16381d7",
		  
		  "name": "Rommel",
		  "createdDate": "2024-01-12 19:18:24",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 72,
		  "totalCountries": 15,
		  "totalStates": 36,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 377,
		  "schedulePercent": 0.256346,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2724797561dc01bf17f1d8bfd93a51d7",
		  
		  "name": "Derek",
		  "createdDate": "2017-07-20 16:05:36",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 445,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 2019,
		  "schedulePercent": 0.717248,
		  "totalGuests": 2013,
		  "guestPercent": 0.948096,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27271e6b0a296d50da9ddf9026a9557b",
		  
		  "name": "Jose Luis",
		  "createdDate": "2012-08-27 14:17:17",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 101,
		  "totalCountries": 8,
		  "totalStates": 9,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2741e43017a17c21dc031994d4f98e42",
		  
		  "name": "Valerie",
		  "createdDate": "2024-11-18 00:44:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 104,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 414,
		  "schedulePercent": 0.275612,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "274c521bc9526b35722cd3cb9488af98",
		  
		  "name": "Ellie ",
		  "createdDate": "2018-11-13 17:41:32",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 824,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1119,
		  "schedulePercent": 0.524592,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Pitt Street Uniting Church",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "274d8fde0023e02f9e873e0871eef5dc",
		  
		  "name": "Kenny",
		  "createdDate": "2012-01-03 23:41:41",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 56,
		  "totalCountries": 6,
		  "totalStates": 14,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 526,
		  "schedulePercent": 0.324683,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "275da5126a54284676fa51382e63261a",
		  
		  "name": "Gary ",
		  "createdDate": "2013-07-16 14:02:27",
		  "totalOrganizations": 7,
		  "totalTours": 42,
		  "totalDays": 482,
		  "totalCountries": 29,
		  "totalStates": 53,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 2814,
		  "schedulePercent": 0.824116,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Fremantle Prison",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2763218e6cfeb4b386fbe38ee6567f64",
		  
		  "name": "Syd",
		  "createdDate": "2023-08-23 14:39:33",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 194,
		  "totalCountries": 19,
		  "totalStates": 50,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 739,
		  "schedulePercent": 0.401179,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Sand Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27643500540f6781110652f045485295",
		  
		  "name": "Giulia",
		  "createdDate": "2022-08-28 08:42:32",
		  "totalOrganizations": 9,
		  "totalTours": 36,
		  "totalDays": 301,
		  "totalCountries": 27,
		  "totalStates": 62,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 2523,
		  "schedulePercent": 0.788645,
		  "totalGuests": 605,
		  "guestPercent": 0.759973,
		  "mostGuestDate": "2025-05-12 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre Beanfield",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2764e5bf08a053eff955d85410536485",
		  
		  "name": "Charlie",
		  "createdDate": "2014-01-10 22:26:17",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 256,
		  "schedulePercent": 0.193676,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27685186d7ac2941b0084e6c1d4ec276",
		  
		  "name": "Ryan",
		  "createdDate": "2023-12-05 15:04:09",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 67,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 7,
		  "schedulePercent": 0.0172257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "276917009a22a75b764be74398a03e91",
		  
		  "name": "Ron",
		  "createdDate": "2024-05-01 16:17:09",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "277093f61e80d12f83a1f86cc4f4c279",
		  
		  "name": "Robert",
		  "createdDate": "2025-04-07 15:55:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 654,
		  "schedulePercent": 0.368994,
		  "totalGuests": 765,
		  "guestPercent": 0.799637,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2780f85c00e0e949e754302646e85949",
		  
		  "name": "Ike ",
		  "createdDate": "2025-10-29 10:09:17",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 82,
		  "totalCountries": 7,
		  "totalStates": 9,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 206,
		  "schedulePercent": 0.163871,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27844fd23af2d167b2a3f7834d37e6a6",
		  
		  "name": "Jennifer",
		  "createdDate": "2016-04-16 22:21:18",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 731,
		  "totalCountries": 14,
		  "totalStates": 55,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 3870,
		  "schedulePercent": 0.906278,
		  "totalGuests": 2482,
		  "guestPercent": 0.967022,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2786d14376fd22fc205865c7bd6578fa",
		  
		  "name": "Zachary",
		  "createdDate": "2024-09-30 02:14:25",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 215,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "278c86b88f42ce65d779d8e4b05b2623",
		  
		  "name": "Austin ",
		  "createdDate": "2021-11-30 17:03:19",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 187,
		  "schedulePercent": 0.151859,
		  "totalGuests": 206,
		  "guestPercent": 0.598821,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "House of Blues Dallas",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "278d7b322cee806b2578c5ef2560107a",
		  
		  "name": "Ryan",
		  "createdDate": "2022-07-05 16:31:04",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 208,
		  "schedulePercent": 0.165005,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2795e0c77ecc5b37d7b9bafe38c8fede",
		  
		  "name": "Neil",
		  "createdDate": "2011-11-01 07:35:29",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 150,
		  "schedulePercent": 0.129873,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "279e725de4751ec0cf5f012a256f8d3d",
		  
		  "name": "Stephen ",
		  "createdDate": "2023-07-05 20:38:19",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 315,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 414,
		  "schedulePercent": 0.275612,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27a74ec8ced611c283df19ecc94e1828",
		  
		  "name": "Ailey",
		  "createdDate": "2019-05-23 20:25:02",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27ab3b8693d14c11f172f3945373b9f9",
		  
		  "name": "Andrew",
		  "createdDate": "2015-08-19 19:55:43",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 388,
		  "totalCountries": 12,
		  "totalStates": 18,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 125,
		  "schedulePercent": 0.114914,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Budapest Park",
		  "mostGuestCity": "Budapest",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27af82c45ef54122bdd386194d7fed46",
		  
		  "name": "Carl",
		  "createdDate": "2021-07-13 21:13:35",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 181,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 889,
		  "schedulePercent": 0.453649,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Soboba Casino Resort",
		  "mostGuestCity": "San Jacinto",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27b9263d6f86be34fd4745926a2d6888",
		  
		  "name": "Nathalia",
		  "createdDate": "2021-07-12 19:00:19",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 93,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 724,
		  "schedulePercent": 0.395852,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "The Burl",
		  "mostGuestCity": "Lexington",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27bed83e5c86d196bab62ec30c48f9d9",
		  
		  "name": "Greg ",
		  "createdDate": "2015-09-11 18:38:42",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 441,
		  "totalCountries": 10,
		  "totalStates": 51,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2847,
		  "schedulePercent": 0.827516,
		  "totalGuests": 1961,
		  "guestPercent": 0.944243,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27c17d5bdfe3ed52122a69fa13b46ade",
		  
		  "name": "Jil",
		  "createdDate": "2014-07-23 00:50:44",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 8,
		  "totalStates": 4,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27c9c1a5f3259c9bbd2488fe3b6851e8",
		  
		  "name": "Jean Marc",
		  "createdDate": "2025-03-12 13:15:04",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 209,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 611,
		  "schedulePercent": 0.354374,
		  "totalGuests": 199,
		  "guestPercent": 0.594062,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "6MIC",
		  "mostGuestCity": "Aix-en-Provence",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27cd40e07d37114897994d448d4a1647",
		  
		  "name": "Mike",
		  "createdDate": "2012-06-12 19:25:43",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 484,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 2346,
		  "schedulePercent": 0.767452,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27d6487183e579ab0e6ca8ec52c0d8be",
		  
		  "name": "Simon",
		  "createdDate": "2017-02-12 10:58:07",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 235,
		  "totalCountries": 14,
		  "totalStates": 42,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1844,
		  "schedulePercent": 0.68461,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-11-19 00:00:00",
		  "mostGuestName": "Festival Hall",
		  "mostGuestCity": "West Melbourne",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27ddee2dbfbb87d9fde842f9d75994a3",
		  
		  "name": "ROBERT",
		  "createdDate": "2011-09-07 00:13:31",
		  "totalOrganizations": 6,
		  "totalTours": 18,
		  "totalDays": 333,
		  "totalCountries": 19,
		  "totalStates": 42,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1936,
		  "schedulePercent": 0.701043,
		  "totalGuests": 591,
		  "guestPercent": 0.755893,
		  "mostGuestDate": "2025-02-10 00:00:00",
		  "mostGuestName": "Tokyo Garden Theater",
		  "mostGuestCity": "",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27e4efec16975a573f4a18671a0e8153",
		  
		  "name": "Heartstop",
		  "createdDate": "2016-06-27 05:27:42",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 104,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 466,
		  "schedulePercent": 0.296804,
		  "totalGuests": 558,
		  "guestPercent": 0.74626,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27f43a8cb6d50cd89aebf42e040bbdad",
		  
		  "name": "Ryan",
		  "createdDate": "2013-01-22 22:00:21",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 1226,
		  "totalCountries": 13,
		  "totalStates": 60,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 3896,
		  "schedulePercent": 0.908092,
		  "totalGuests": 224,
		  "guestPercent": 0.609474,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Fiddler's Green Amphitheatre",
		  "mostGuestCity": "Englewood",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "27ff19ba485ae62c789dcebf7e37b620",
		  
		  "name": "Emma",
		  "createdDate": "2014-02-26 10:24:46",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 1040,
		  "totalCountries": 20,
		  "totalStates": 30,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 4105,
		  "schedulePercent": 0.919311,
		  "totalGuests": 347,
		  "guestPercent": 0.673844,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28050f3a86c2bbd0dd7c924fbb52cdc1",
		  
		  "name": "Brian",
		  "createdDate": "2024-10-10 14:52:44",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 705,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 9134,
		  "schedulePercent": 0.993994,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28093e5ddcacf56ea25610d13dbfee2a",
		  
		  "name": "Brandon",
		  "createdDate": "2011-06-15 16:20:21",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 982,
		  "totalCountries": 10,
		  "totalStates": 38,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1638,
		  "schedulePercent": 0.647325,
		  "totalGuests": 376,
		  "guestPercent": 0.68427,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Smart Financial Centre at Sugar Land",
		  "mostGuestCity": "Sugar Land",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28113b67ca8d8280ed69430e06229932",
		  
		  "name": "Jeff",
		  "createdDate": "2012-01-05 19:29:23",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 545,
		  "totalCountries": 9,
		  "totalStates": 49,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2060,
		  "schedulePercent": 0.726088,
		  "totalGuests": 1010,
		  "guestPercent": 0.848255,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Analog at Hutton Hotel",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 191,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2819a705fab35d8e8f0f1134b6b5e286",
		  
		  "name": "Ian",
		  "createdDate": "2018-09-06 05:56:27",
		  "totalOrganizations": 11,
		  "totalTours": 27,
		  "totalDays": 534,
		  "totalCountries": 17,
		  "totalStates": 46,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 2137,
		  "schedulePercent": 0.738101,
		  "totalGuests": 794,
		  "guestPercent": 0.806437,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Croxton Bandroom",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "281de5c6f8584cb3a45fbce9947e3160",
		  
		  "name": "Billy ",
		  "createdDate": "2019-01-25 22:17:16",
		  "totalOrganizations": 11,
		  "totalTours": 23,
		  "totalDays": 420,
		  "totalCountries": 17,
		  "totalStates": 62,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2668,
		  "schedulePercent": 0.80485,
		  "totalGuests": 1171,
		  "guestPercent": 0.8733,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "281ee8338c437dffc276bcf9a23a52df",
		  
		  "name": "Simon",
		  "createdDate": "2014-02-04 17:52:51",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 206,
		  "totalCountries": 20,
		  "totalStates": 39,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1090,
		  "schedulePercent": 0.518019,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28232c22a5a553006d7ceb4a06b4220f",
		  
		  "name": "Kayla",
		  "createdDate": "2019-11-09 17:09:13",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 1141,
		  "totalCountries": 25,
		  "totalStates": 49,
		  "totalEvents": 318,
		  "eventPercent": 0.924411,
		  "totalScheduleItems": 5326,
		  "schedulePercent": 0.963282,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2828492a2243a42d063084c53edec1eb",
		  
		  "name": "Doug",
		  "createdDate": "2022-12-19 18:14:02",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 213,
		  "totalCountries": 14,
		  "totalStates": 34,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1025,
		  "schedulePercent": 0.497733,
		  "totalGuests": 1069,
		  "guestPercent": 0.857774,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2828868b627c93494c5f1bdba346371b",
		  
		  "name": "Adam",
		  "createdDate": "2017-08-16 18:20:18",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 542,
		  "totalCountries": 29,
		  "totalStates": 57,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2547,
		  "schedulePercent": 0.791704,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "100 Club",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "282a3c964a1fcf000c182f2028e557e6",
		  
		  "name": "Martin",
		  "createdDate": "2023-05-08 10:13:18",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 918,
		  "totalCountries": 28,
		  "totalStates": 42,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1893,
		  "schedulePercent": 0.693223,
		  "totalGuests": 182,
		  "guestPercent": 0.581142,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "282b68b00d33f800d36da8cccb4030f4",
		  
		  "name": "Jordan",
		  "createdDate": "2025-09-10 01:51:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 425,
		  "schedulePercent": 0.280032,
		  "totalGuests": 237,
		  "guestPercent": 0.617294,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2833291e7045333d68f575d792d112e6",
		  
		  "name": "Alx",
		  "createdDate": "2017-12-22 17:46:46",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 427,
		  "totalCountries": 6,
		  "totalStates": 22,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1729,
		  "schedulePercent": 0.663645,
		  "totalGuests": 300,
		  "guestPercent": 0.649705,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Zenith Paris - La Villette",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2836f2c66f7033f968beffe6e30543dc",
		  
		  "name": "scott",
		  "createdDate": "2014-02-15 19:03:06",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 571,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 286,
		  "eventPercent": 0.902765,
		  "totalScheduleItems": 1735,
		  "schedulePercent": 0.664778,
		  "totalGuests": 488,
		  "guestPercent": 0.726995,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "283a13ac69f257ee5348f0181aa1978c",
		  
		  "name": "Joseph",
		  "createdDate": "2015-09-02 22:07:08",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 1022,
		  "totalCountries": 29,
		  "totalStates": 70,
		  "totalEvents": 299,
		  "eventPercent": 0.912398,
		  "totalScheduleItems": 4512,
		  "schedulePercent": 0.93869,
		  "totalGuests": 992,
		  "guestPercent": 0.844628,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Grand Sierra Theater",
		  "mostGuestCity": "Reno",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "283af8a9cc5908d3c9fcb4e9ebdac2c2",
		  
		  "name": "David S",
		  "createdDate": "2019-06-19 00:01:30",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 294,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "World Cafe Live ",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "284a0737bd60e9b6432e83de54203dbe",
		  
		  "name": "Raquel",
		  "createdDate": "2025-07-07 17:55:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 175,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 281,
		  "schedulePercent": 0.206256,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "285246cb58164a17a2c6558d19395f24",
		  
		  "name": "Rebecca",
		  "createdDate": "2022-09-14 18:15:37",
		  "totalOrganizations": 53,
		  "totalTours": 17,
		  "totalDays": 279,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 106,
		  "schedulePercent": 0.102108,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2858bb042d28f9916541894592f11ed0",
		  
		  "name": "Danielle",
		  "createdDate": "2022-09-03 19:26:14",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 553,
		  "totalCountries": 25,
		  "totalStates": 86,
		  "totalEvents": 245,
		  "eventPercent": 0.866047,
		  "totalScheduleItems": 5318,
		  "schedulePercent": 0.962942,
		  "totalGuests": 3035,
		  "guestPercent": 0.982661,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28598f9dd66478fefd2157ab195a47d4",
		  
		  "name": "James",
		  "createdDate": "2018-10-09 20:20:07",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 99,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 507,
		  "schedulePercent": 0.314257,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "The Palace Theatre",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28640cf397166568bee7095e50971933",
		  
		  "name": "Isaac",
		  "createdDate": "2022-03-11 00:01:11",
		  "totalOrganizations": 27,
		  "totalTours": 32,
		  "totalDays": 4345,
		  "totalCountries": 21,
		  "totalStates": 62,
		  "totalEvents": 495,
		  "eventPercent": 0.978241,
		  "totalScheduleItems": 4468,
		  "schedulePercent": 0.937103,
		  "totalGuests": 1164,
		  "guestPercent": 0.872733,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "The Night Cat",
		  "mostGuestCity": "Fitzroy",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28664181b5179138bb835ce4bb8669fd",
		  
		  "name": "Matthew",
		  "createdDate": "2011-03-02 02:21:08",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 161,
		  "totalCountries": 14,
		  "totalStates": 37,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1324,
		  "schedulePercent": 0.576609,
		  "totalGuests": 1683,
		  "guestPercent": 0.927244,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "286b7e523ee65b7c88f4e6804cba1fe7",
		  
		  "name": "Veronica",
		  "createdDate": "2025-04-08 01:30:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 269,
		  "schedulePercent": 0.198889,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "The Grand Theatre",
		  "mostGuestCity": "Kingston",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "287261c015fb401776d651e51c7beada",
		  
		  "name": "Michael",
		  "createdDate": "2022-08-22 18:41:37",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 364,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "The Vixen",
		  "mostGuestCity": "McHenry",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2880e28b78290eecbd4cf67e6a656b68",
		  
		  "name": "Suzin",
		  "createdDate": "2018-11-19 20:55:35",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 445,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 841,
		  "schedulePercent": 0.437557,
		  "totalGuests": 239,
		  "guestPercent": 0.618314,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "London Palladium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2880f262d64fcf90ee874a60d36a5e3d",
		  
		  "name": "jamz",
		  "createdDate": "2023-05-11 00:27:23",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 8,
		  "totalStates": 28,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 529,
		  "schedulePercent": 0.326609,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "288b87368c9efaf756a94acdb1fbd0eb",
		  
		  "name": "Ant",
		  "createdDate": "2013-03-22 16:18:32",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 27,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 118,
		  "schedulePercent": 0.109587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28923c491254b780dfd192e2cf5a892c",
		  
		  "name": "Frederik",
		  "createdDate": "2017-03-01 13:27:02",
		  "totalOrganizations": 133,
		  "totalTours": 51,
		  "totalDays": 1528,
		  "totalCountries": 23,
		  "totalStates": 28,
		  "totalEvents": 1428,
		  "eventPercent": 0.998413,
		  "totalScheduleItems": 6348,
		  "schedulePercent": 0.979941,
		  "totalGuests": 148,
		  "guestPercent": 0.556664,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "K.B. Hallen",
		  "mostGuestCity": "Frederiksberg",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "289c819954c7c71c0ad6c9bfe12400d3",
		  
		  "name": "Clint",
		  "createdDate": "2015-09-14 16:31:55",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 803,
		  "totalCountries": 16,
		  "totalStates": 52,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 4415,
		  "schedulePercent": 0.93529,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28a165d1d51dbc8d4ae31d1e6240823c",
		  
		  "name": "Andrea ",
		  "createdDate": "2022-10-01 02:31:46",
		  "totalOrganizations": 13,
		  "totalTours": 12,
		  "totalDays": 532,
		  "totalCountries": 4,
		  "totalStates": 27,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1993,
		  "schedulePercent": 0.712489,
		  "totalGuests": 314,
		  "guestPercent": 0.656052,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28cf83ef3363f75315ee07495f4e7fa2",
		  
		  "name": "Isabelle",
		  "createdDate": "2025-07-14 16:19:13",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 245,
		  "totalCountries": 10,
		  "totalStates": 13,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1184,
		  "schedulePercent": 0.543178,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Tottenham Hotspur Stadium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28d0e490b98a55b1363849aa14b0e88e",
		  
		  "name": "Daniel",
		  "createdDate": "2014-04-17 14:04:35",
		  "totalOrganizations": 3,
		  "totalTours": 17,
		  "totalDays": 421,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 308,
		  "eventPercent": 0.917271,
		  "totalScheduleItems": 2625,
		  "schedulePercent": 0.800317,
		  "totalGuests": 125,
		  "guestPercent": 0.541025,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28dbee5648591268b6018676761d255c",
		  
		  "name": "Camden",
		  "createdDate": "2012-08-14 11:37:21",
		  "totalOrganizations": 14,
		  "totalTours": 18,
		  "totalDays": 428,
		  "totalCountries": 11,
		  "totalStates": 32,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1995,
		  "schedulePercent": 0.712829,
		  "totalGuests": 382,
		  "guestPercent": 0.686537,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Mann Center For Performing Arts",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28df649c04c21a975da2d089c079fea9",
		  
		  "name": "Paul",
		  "createdDate": "2011-10-07 21:00:06",
		  "totalOrganizations": 17,
		  "totalTours": 25,
		  "totalDays": 673,
		  "totalCountries": 22,
		  "totalStates": 57,
		  "totalEvents": 221,
		  "eventPercent": 0.835449,
		  "totalScheduleItems": 3066,
		  "schedulePercent": 0.848821,
		  "totalGuests": 4246,
		  "guestPercent": 0.994787,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28e88c3d30eec7408aa876dcd13e315d",
		  
		  "name": "Kenneth",
		  "createdDate": "2013-11-19 02:22:31",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 303,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1602,
		  "schedulePercent": 0.641092,
		  "totalGuests": 773,
		  "guestPercent": 0.800997,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 157,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28eeb808a3942c7cf7163e1a386e2247",
		  
		  "name": "Chiara",
		  "createdDate": "2022-06-02 00:19:33",
		  "totalOrganizations": 2,
		  "totalTours": 34,
		  "totalDays": 893,
		  "totalCountries": 25,
		  "totalStates": 55,
		  "totalEvents": 314,
		  "eventPercent": 0.921917,
		  "totalScheduleItems": 3614,
		  "schedulePercent": 0.890526,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28fa9790302d59f4861e6e7d9f3ea30e",
		  
		  "name": "Martin",
		  "createdDate": "2018-05-16 21:16:19",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 325,
		  "totalCountries": 24,
		  "totalStates": 49,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1046,
		  "schedulePercent": 0.503173,
		  "totalGuests": 820,
		  "guestPercent": 0.81301,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "28fdaeee386dff471d9be3f253958747",
		  
		  "name": "Ap LIVE ",
		  "createdDate": "2025-08-27 17:52:01",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 256,
		  "totalCountries": 13,
		  "totalStates": 20,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 445,
		  "schedulePercent": 0.288758,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "291b03b17f7a52cb778682ebb33bbe66",
		  
		  "name": "Skillet",
		  "createdDate": "2019-04-30 14:52:37",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 27,
		  "totalStates": 49,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1587,
		  "schedulePercent": 0.637806,
		  "totalGuests": 112,
		  "guestPercent": 0.529805,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Bojangles' Coliseum",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "291f82dfed0e67925b784e758125fa25",
		  
		  "name": "Shane",
		  "createdDate": "2018-03-30 08:18:28",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 155,
		  "totalCountries": 16,
		  "totalStates": 22,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1077,
		  "schedulePercent": 0.512919,
		  "totalGuests": 196,
		  "guestPercent": 0.591568,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "LukiÅ¡kiÅ³ kalÄ—jimas 2.0",
		  "mostGuestCity": "Vilnius",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "292246d0690c87035000a9ab646fc541",
		  
		  "name": "Tim",
		  "createdDate": "2014-10-23 19:27:15",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 337,
		  "totalCountries": 14,
		  "totalStates": 55,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1104,
		  "schedulePercent": 0.519946,
		  "totalGuests": 420,
		  "guestPercent": 0.702289,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29277f1777ada7f08d274e52552c7537",
		  
		  "name": "Guy",
		  "createdDate": "2014-04-26 16:19:53",
		  "totalOrganizations": 14,
		  "totalTours": 9,
		  "totalDays": 612,
		  "totalCountries": 21,
		  "totalStates": 61,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 4973,
		  "schedulePercent": 0.953309,
		  "totalGuests": 1379,
		  "guestPercent": 0.897892,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "292966e230874278254036596f0e86bd",
		  
		  "name": "Constance",
		  "createdDate": "2016-10-03 20:22:07",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 725,
		  "totalCountries": 5,
		  "totalStates": 45,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 1742,
		  "schedulePercent": 0.665911,
		  "totalGuests": 504,
		  "guestPercent": 0.732208,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "292e6b4245168e2ccd2f61f5b4ad7bd6",
		  
		  "name": "Leah",
		  "createdDate": "2010-07-08 23:02:34",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 414,
		  "totalCountries": 12,
		  "totalStates": 47,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 2039,
		  "schedulePercent": 0.720648,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "292ead9dfb744ba53e682b0b905bac53",
		  
		  "name": "Nick",
		  "createdDate": "2022-05-27 14:56:34",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 713,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2270,
		  "schedulePercent": 0.757933,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "293677445316cdea6c4b02b53a9c30e1",
		  
		  "name": "Peyton",
		  "createdDate": "2024-10-17 16:02:46",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 234,
		  "totalCountries": 11,
		  "totalStates": 43,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1479,
		  "schedulePercent": 0.612421,
		  "totalGuests": 848,
		  "guestPercent": 0.81947,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "293df7da0cb3a31656ad818f689dec05",
		  
		  "name": "Sonti",
		  "createdDate": "2022-08-15 23:12:46",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 220,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 752,
		  "schedulePercent": 0.406052,
		  "totalGuests": 924,
		  "guestPercent": 0.834882,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "South Side Ballroom",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2943b52c24e92d98e1ed4d4741767b08",
		  
		  "name": "Simon",
		  "createdDate": "2023-06-26 11:53:08",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 36,
		  "totalCountries": 10,
		  "totalStates": 15,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 306,
		  "schedulePercent": 0.220875,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Backstage Concerts GmbH",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "294694613283f129ef6ecbf7eff485e1",
		  
		  "name": "Karla",
		  "createdDate": "2016-06-20 18:03:57",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 335,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 234,
		  "schedulePercent": 0.18053,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29508a484347cef427f8acbb5948bdb1",
		  
		  "name": "Tomas",
		  "createdDate": "2012-09-19 22:33:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 205,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 236,
		  "schedulePercent": 0.182344,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-07-22 00:00:00",
		  "mostGuestName": "The Theater at Virgin Hotels",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29558fce75b0a67ab06faaec79a8c858",
		  
		  "name": "Julia",
		  "createdDate": "2025-10-06 21:28:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 85,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 144,
		  "schedulePercent": 0.127267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2955e3e19560786dbd42c54bbf8fd3a0",
		  
		  "name": "Angela",
		  "createdDate": "2016-05-02 18:32:35",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 193,
		  "schedulePercent": 0.155485,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Jacksonville Center for the Performing Arts",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2963abdc5953895bd67b0d697c694a84",
		  
		  "name": "Riley",
		  "createdDate": "2025-01-02 22:17:54",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 85,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 826,
		  "guestPercent": 0.814257,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Palace Theater",
		  "mostGuestCity": "Waterbury",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "296538cee71fbc8e459c1e2a0588c53d",
		  
		  "name": "Lily",
		  "createdDate": "2025-01-02 17:23:45",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 157,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 665,
		  "schedulePercent": 0.3733,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "296bc298d4004f4f30c9ac0d8669dc94",
		  
		  "name": "Maya",
		  "createdDate": "2016-05-19 16:10:42",
		  "totalOrganizations": 6,
		  "totalTours": 32,
		  "totalDays": 412,
		  "totalCountries": 25,
		  "totalStates": 56,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 2624,
		  "schedulePercent": 0.800091,
		  "totalGuests": 1384,
		  "guestPercent": 0.898232,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "296d8b407908d5da8cded94e6a064380",
		  
		  "name": "Manon",
		  "createdDate": "2018-05-23 10:33:22",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 450,
		  "totalCountries": 21,
		  "totalStates": 47,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 3580,
		  "schedulePercent": 0.887579,
		  "totalGuests": 2057,
		  "guestPercent": 0.951043,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Zenith Nantes Metropole",
		  "mostGuestCity": "St Herblain",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29762f75e0753dca192a9df82e3321f3",
		  
		  "name": "Jon",
		  "createdDate": "2009-07-20 22:27:31",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 487,
		  "totalCountries": 14,
		  "totalStates": 39,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 3115,
		  "schedulePercent": 0.852675,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2977c49131c545c2696be84fc55512d7",
		  
		  "name": "Company",
		  "createdDate": "2024-03-04 17:57:36",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 219,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2072,
		  "schedulePercent": 0.727335,
		  "totalGuests": 471,
		  "guestPercent": 0.720762,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "297b7bf8aa9dd472f5d6b62c5266e4ba",
		  
		  "name": "Carlos ",
		  "createdDate": "2017-06-09 00:15:49",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 270,
		  "totalCountries": 16,
		  "totalStates": 50,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1070,
		  "schedulePercent": 0.510426,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "United Center",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "298424c4d3245e5ee4cd13846348a08e",
		  
		  "name": "Luka",
		  "createdDate": "2017-10-15 19:12:36",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 767,
		  "totalCountries": 24,
		  "totalStates": 49,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 3461,
		  "schedulePercent": 0.879986,
		  "totalGuests": 173,
		  "guestPercent": 0.575816,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "Revolution Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2987ee6730fecd96f3017256bd5ce122",
		  
		  "name": "Lauren",
		  "createdDate": "2022-06-07 01:37:43",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 627,
		  "totalCountries": 4,
		  "totalStates": 49,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 3464,
		  "schedulePercent": 0.880213,
		  "totalGuests": 527,
		  "guestPercent": 0.737647,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Santa Barbara Bowl",
		  "mostGuestCity": "Santa Barbara",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "298b18fa32a8cbd5a9fc1dceab8a9cc9",
		  
		  "name": "Courtney",
		  "createdDate": "2025-07-22 16:52:40",
		  "totalOrganizations": 4,
		  "totalTours": 28,
		  "totalDays": 298,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1256,
		  "schedulePercent": 0.561877,
		  "totalGuests": 575,
		  "guestPercent": 0.75102,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Willow Creek Community Church Crystal Lake",
		  "mostGuestCity": "Crystal Lake",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "298b4956011a104266ac411dde172016",
		  
		  "name": "Pastache",
		  "createdDate": "2021-07-07 20:50:13",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 205,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 385,
		  "schedulePercent": 0.260993,
		  "totalGuests": 166,
		  "guestPercent": 0.570263,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Toyota Center",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "299af4e9d55eb2b9548052c2af286b8f",
		  
		  "name": "Brian",
		  "createdDate": "2019-06-05 03:12:58",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 466,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 2554,
		  "schedulePercent": 0.793404,
		  "totalGuests": 1342,
		  "guestPercent": 0.892226,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Boone Pickens Stadium",
		  "mostGuestCity": "Stillwater",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "299eb94a9b6ae889bed6e5651109d4b5",
		  
		  "name": "S&#233;verine",
		  "createdDate": "2023-10-19 10:18:03",
		  "totalOrganizations": 3,
		  "totalTours": 33,
		  "totalDays": 1112,
		  "totalCountries": 32,
		  "totalStates": 55,
		  "totalEvents": 616,
		  "eventPercent": 0.988327,
		  "totalScheduleItems": 6066,
		  "schedulePercent": 0.976768,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "299f7b01634880a63825a570ab005a86",
		  
		  "name": "Katharina",
		  "createdDate": "2018-08-10 20:03:51",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 346,
		  "totalCountries": 15,
		  "totalStates": 31,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2488,
		  "schedulePercent": 0.785471,
		  "totalGuests": 1095,
		  "guestPercent": 0.862874,
		  "mostGuestDate": "2025-09-16 00:00:00",
		  "mostGuestName": "L'Olympia Bruno Coquatrix",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29a7e6aded731f2a278e75bce1f2909d",
		  
		  "name": "Steve ",
		  "createdDate": "2019-03-11 20:20:43",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 28,
		  "totalCountries": 9,
		  "totalStates": 8,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 129,
		  "schedulePercent": 0.11718,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Vaz  St Pol",
		  "mostGuestCity": "",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29afe871cd51ea45f77d75547a6f288a",
		  
		  "name": "Christopher",
		  "createdDate": "2022-08-25 22:24:11",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 481,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 404,
		  "schedulePercent": 0.271532,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Garden Amphitheatre",
		  "mostGuestCity": "Garden Grove",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29be28c5a1f9cc8636ce604efed49727",
		  
		  "name": "Clancy",
		  "createdDate": "2013-10-08 19:31:03",
		  "totalOrganizations": 7,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 14,
		  "totalStates": 31,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 1645,
		  "schedulePercent": 0.649139,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29c4454752c520603b3c1c903a83313b",
		  
		  "name": "Natasha",
		  "createdDate": "2024-02-29 16:33:46",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 330,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 320,
		  "schedulePercent": 0.226995,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "Outremont Theatre",
		  "mostGuestCity": "Outremont",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29d260b37ca4ff4e7e2f5017016af043",
		  
		  "name": "Shannon",
		  "createdDate": "2023-10-30 21:27:18",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 882,
		  "totalCountries": 19,
		  "totalStates": 52,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2724,
		  "schedulePercent": 0.812443,
		  "totalGuests": 762,
		  "guestPercent": 0.798731,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29d5197e8a7cb6cb76abea64c454c39b",
		  
		  "name": "AEG",
		  "createdDate": "2023-06-01 13:16:33",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 132,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 871,
		  "schedulePercent": 0.448776,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Rock School Barbey",
		  "mostGuestCity": "Bordeaux",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29d6c4d74418d122ddfcdcac78af52f2",
		  
		  "name": "Christian",
		  "createdDate": "2019-02-06 14:00:38",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 141,
		  "totalCountries": 11,
		  "totalStates": 18,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1426,
		  "schedulePercent": 0.604148,
		  "totalGuests": 1938,
		  "guestPercent": 0.941636,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Galopprennbahn KÃ¶ln-Weidenpesch",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29e07356eb3655540d0507f08cb47313",
		  
		  "name": "Hunter",
		  "createdDate": "2022-12-18 20:33:59",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 408,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 1190,
		  "schedulePercent": 0.545104,
		  "totalGuests": 1318,
		  "guestPercent": 0.889733,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29e2d4f1a31df002019b6d0bfc114cba",
		  
		  "name": "Pete",
		  "createdDate": "2015-01-05 13:05:16",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 498,
		  "totalCountries": 17,
		  "totalStates": 40,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1671,
		  "schedulePercent": 0.653558,
		  "totalGuests": 225,
		  "guestPercent": 0.610041,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29e75356a94855e7e942f61c6d3efd12",
		  
		  "name": "Sherwood",
		  "createdDate": "2024-01-03 19:22:05",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 8,
		  "totalStates": 26,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 588,
		  "schedulePercent": 0.346895,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Echostage",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29e79f7be7f821e4f3691571a4dcb7f9",
		  
		  "name": "Jeremy",
		  "createdDate": "2020-01-18 21:37:35",
		  "totalOrganizations": 19,
		  "totalTours": 12,
		  "totalDays": 2087,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 3332,
		  "schedulePercent": 0.86956,
		  "totalGuests": 815,
		  "guestPercent": 0.812443,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29e7ebb9ae4445876cff43fab35f4db7",
		  
		  "name": "Lisa",
		  "createdDate": "2023-08-16 15:05:39",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 114,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 439,
		  "schedulePercent": 0.285811,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "SAP Arena",
		  "mostGuestCity": "MA",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29ea72677c3aa4b00b90b466cc3eec7f",
		  
		  "name": "Hailey",
		  "createdDate": "2022-04-15 19:54:42",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 63,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 496,
		  "schedulePercent": 0.310403,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Under The Big Sky",
		  "mostGuestCity": "Whitefish",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29f369e3ea9a4a24f91faf2a6d896bed",
		  
		  "name": "Evan",
		  "createdDate": "2023-09-14 17:17:11",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 439,
		  "totalCountries": 10,
		  "totalStates": 53,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1130,
		  "schedulePercent": 0.528105,
		  "totalGuests": 265,
		  "guestPercent": 0.631686,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Jacob's Pavilion at Nautica",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "29f7e17b25c892d6f8ee26c8214600a2",
		  
		  "name": "Vendela",
		  "createdDate": "2023-01-17 11:07:09",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 206,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 206,
		  "schedulePercent": 0.163871,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a01b3ede74c97fc17e8664d66129ba5",
		  
		  "name": "Chelsea",
		  "createdDate": "2015-09-24 21:09:39",
		  "totalOrganizations": 15,
		  "totalTours": 2,
		  "totalDays": 223,
		  "totalCountries": 3,
		  "totalStates": 47,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1744,
		  "schedulePercent": 0.667044,
		  "totalGuests": 667,
		  "guestPercent": 0.776745,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Cobb Energy Centre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a0aa47ac66faafda5eb1dfad1db49bd",
		  
		  "name": "Clare",
		  "createdDate": "2023-09-08 10:42:50",
		  "totalOrganizations": 3,
		  "totalTours": 11,
		  "totalDays": 398,
		  "totalCountries": 14,
		  "totalStates": 24,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1248,
		  "schedulePercent": 0.560063,
		  "totalGuests": 502,
		  "guestPercent": 0.731301,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a137f9bf573f89219dd44fee75466f8",
		  
		  "name": "Angus",
		  "createdDate": "2025-04-03 01:42:23",
		  "totalOrganizations": 5,
		  "totalTours": 21,
		  "totalDays": 224,
		  "totalCountries": 7,
		  "totalStates": 18,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 886,
		  "schedulePercent": 0.452516,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Princess Theatre",
		  "mostGuestCity": "Launceston",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a16358866740b8d8924376b5aef4355",
		  
		  "name": "Jackson",
		  "createdDate": "2021-03-15 23:43:56",
		  "totalOrganizations": 6,
		  "totalTours": 25,
		  "totalDays": 692,
		  "totalCountries": 12,
		  "totalStates": 64,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 2488,
		  "schedulePercent": 0.785471,
		  "totalGuests": 830,
		  "guestPercent": 0.815277,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Waikiki Shell",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a1be0cce480dc5d74c10ec6ce35870a",
		  
		  "name": "David",
		  "createdDate": "2018-06-27 20:09:00",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 105,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 453,
		  "schedulePercent": 0.291931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a24fc15e088ebfd47a329d52870bba2",
		  
		  "name": "Kiertue",
		  "createdDate": "2019-05-15 13:00:21",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 62,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 294,
		  "schedulePercent": 0.214415,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a33fa8225dab2068afb505d42db23b0",
		  
		  "name": "Luciano",
		  "createdDate": "2023-08-03 15:09:42",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 59,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 308,
		  "schedulePercent": 0.221782,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a35e959b218fb91d3af485a10760c90",
		  
		  "name": "Christopher",
		  "createdDate": "2025-03-27 00:42:28",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 53,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 293,
		  "schedulePercent": 0.213849,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Whisky a Go Go",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a3945436bc1d83282b4e4c0980368d4",
		  
		  "name": "Matt ",
		  "createdDate": "2015-09-29 01:07:31",
		  "totalOrganizations": 22,
		  "totalTours": 26,
		  "totalDays": 384,
		  "totalCountries": 15,
		  "totalStates": 26,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2076,
		  "schedulePercent": 0.728468,
		  "totalGuests": 914,
		  "guestPercent": 0.833069,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a41c3b2410a19cb344871cc0f8756ca",
		  
		  "name": "Joseph",
		  "createdDate": "2019-05-21 16:29:24",
		  "totalOrganizations": 5,
		  "totalTours": 23,
		  "totalDays": 282,
		  "totalCountries": 9,
		  "totalStates": 13,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1007,
		  "schedulePercent": 0.49252,
		  "totalGuests": 215,
		  "guestPercent": 0.605281,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a4587ce16ed7e43e9ba16dc32671ca6",
		  
		  "name": "Shaun",
		  "createdDate": "2024-11-28 17:39:33",
		  "totalOrganizations": 3,
		  "totalTours": 13,
		  "totalDays": 347,
		  "totalCountries": 8,
		  "totalStates": 62,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1966,
		  "schedulePercent": 0.707049,
		  "totalGuests": 891,
		  "guestPercent": 0.827743,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a46647e7d1720245eb1d46e86b22ad7",
		  
		  "name": "Michel",
		  "createdDate": "2016-02-08 19:15:19",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 331,
		  "totalCountries": 16,
		  "totalStates": 13,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 354,
		  "schedulePercent": 0.244787,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a4666d512e5a983bac4a07dc10d9a57",
		  
		  "name": "Andres",
		  "createdDate": "2016-08-10 15:08:25",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 762,
		  "totalCountries": 12,
		  "totalStates": 65,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 3058,
		  "schedulePercent": 0.848141,
		  "totalGuests": 916,
		  "guestPercent": 0.833522,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a4d49ec9d788368b4a6200439ef936d",
		  
		  "name": "Kyle",
		  "createdDate": "2019-06-13 16:22:32",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 186,
		  "totalCountries": 13,
		  "totalStates": 49,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 930,
		  "schedulePercent": 0.468835,
		  "totalGuests": 189,
		  "guestPercent": 0.585222,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a50b4d44ad42bbf2a81fdd51fa9869a",
		  
		  "name": "Paul \"Boyo\"",
		  "createdDate": "2015-04-07 15:07:44",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1448,
		  "schedulePercent": 0.606981,
		  "totalGuests": 557,
		  "guestPercent": 0.74558,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "The Today Show",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a50cb7c09c46d75219e72039e6ec246",
		  
		  "name": "Molly",
		  "createdDate": "2014-03-21 12:01:48",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 819,
		  "totalCountries": 13,
		  "totalStates": 36,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 3320,
		  "schedulePercent": 0.86854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a5950ed687c8a3a81ea555431145e4c",
		  
		  "name": "Stage ",
		  "createdDate": "2023-10-10 20:50:46",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 154,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1352,
		  "schedulePercent": 0.585449,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a5a4751c87121852629eb1edc424b91",
		  
		  "name": "Simon",
		  "createdDate": "2014-09-08 17:15:43",
		  "totalOrganizations": 25,
		  "totalTours": 16,
		  "totalDays": 756,
		  "totalCountries": 12,
		  "totalStates": 58,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 2149,
		  "schedulePercent": 0.739461,
		  "totalGuests": 1003,
		  "guestPercent": 0.846668,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a6b28775145aade4396a5fd37df4db5",
		  
		  "name": "Marc",
		  "createdDate": "2023-04-11 20:15:35",
		  "totalOrganizations": 12,
		  "totalTours": 19,
		  "totalDays": 2142,
		  "totalCountries": 16,
		  "totalStates": 78,
		  "totalEvents": 446,
		  "eventPercent": 0.969968,
		  "totalScheduleItems": 4908,
		  "schedulePercent": 0.951496,
		  "totalGuests": 1064,
		  "guestPercent": 0.856981,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a7a5eabdf3f862544ec712fbd58c9a7",
		  
		  "name": "Tracy",
		  "createdDate": "2012-04-25 14:52:54",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 292,
		  "totalCountries": 15,
		  "totalStates": 33,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1066,
		  "schedulePercent": 0.508726,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a87601498dbe04ead7a9300676fd3b8",
		  
		  "name": "Mark",
		  "createdDate": "2018-10-01 07:42:04",
		  "totalOrganizations": 20,
		  "totalTours": 46,
		  "totalDays": 569,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2934,
		  "schedulePercent": 0.835335,
		  "totalGuests": 845,
		  "guestPercent": 0.81879,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Metropolis",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a95e8380854e1bf33a3a4435a52029f",
		  
		  "name": "Ryan",
		  "createdDate": "2016-08-03 18:12:06",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 729,
		  "totalCountries": 6,
		  "totalStates": 44,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 2857,
		  "schedulePercent": 0.827969,
		  "totalGuests": 679,
		  "guestPercent": 0.780825,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a9697d936f5c4522ad661e4f1e490f8",
		  
		  "name": "Lesley ",
		  "createdDate": "2022-04-07 02:15:54",
		  "totalOrganizations": 3,
		  "totalTours": 16,
		  "totalDays": 47,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 331,
		  "schedulePercent": 0.231754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a993614709734218c7b5bef3c8ac788",
		  
		  "name": "Rob",
		  "createdDate": "2019-11-09 10:49:08",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 426,
		  "totalCountries": 13,
		  "totalStates": 18,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 1425,
		  "schedulePercent": 0.603581,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2a9a58162ff1587de3fcf44c05251bb0",
		  
		  "name": "Nichole",
		  "createdDate": "2018-01-23 23:20:46",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 595,
		  "totalCountries": 15,
		  "totalStates": 51,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2201,
		  "schedulePercent": 0.74796,
		  "totalGuests": 1394,
		  "guestPercent": 0.899819,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2aa6740f858f0d450ccc3085b72587d3",
		  
		  "name": "JJE",
		  "createdDate": "2025-03-03 21:30:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 70,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 331,
		  "schedulePercent": 0.231754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ab23389054222f49e9db090b25e0a10",
		  
		  "name": "Raymond",
		  "createdDate": "2019-05-20 19:29:42",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 854,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 2167,
		  "schedulePercent": 0.742067,
		  "totalGuests": 1312,
		  "guestPercent": 0.887919,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Ravinia",
		  "mostGuestCity": "Highland Park",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ab8fb6d902d80ec69b07da45a5eb6cb",
		  
		  "name": "Edwin",
		  "createdDate": "2022-01-19 16:42:06",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 428,
		  "totalCountries": 7,
		  "totalStates": 28,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1340,
		  "schedulePercent": 0.583749,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Mann Center For Performing Arts",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2abd85580ea975f8add27926124db3bd",
		  
		  "name": "Kyleigh",
		  "createdDate": "2021-09-14 14:18:14",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1060,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 2294,
		  "schedulePercent": 0.761106,
		  "totalGuests": 666,
		  "guestPercent": 0.776292,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ac9ee127b3107f9774b4ae0678f5292",
		  
		  "name": "John",
		  "createdDate": "2015-04-03 15:52:36",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 379,
		  "totalCountries": 22,
		  "totalStates": 56,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2828,
		  "schedulePercent": 0.825476,
		  "totalGuests": 2419,
		  "guestPercent": 0.965662,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ad97e3e75f0b4f7403075e49d2e3e02",
		  
		  "name": "Paxton",
		  "createdDate": "2024-10-24 12:15:06",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 289,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 2296,
		  "schedulePercent": 0.761333,
		  "totalGuests": 538,
		  "guestPercent": 0.740027,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Deer Valley Music Festival",
		  "mostGuestCity": "Park City",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ad9b16f5f1b515ba69c76d9b6bdd9d8",
		  
		  "name": "Adam",
		  "createdDate": "2023-09-16 23:12:37",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 440,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 25,
		  "schedulePercent": 0.0360381,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2adbdbaabc66af85b8dca3b8de10ec64",
		  
		  "name": "Dave",
		  "createdDate": "2011-07-12 20:14:55",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 289,
		  "totalCountries": 5,
		  "totalStates": 40,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 2329,
		  "schedulePercent": 0.765979,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2adc7c732c48f1ed51db9f71dcaedd05",
		  
		  "name": "Jonas",
		  "createdDate": "2018-05-31 12:37:55",
		  "totalOrganizations": 10,
		  "totalTours": 23,
		  "totalDays": 423,
		  "totalCountries": 25,
		  "totalStates": 46,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 2413,
		  "schedulePercent": 0.776405,
		  "totalGuests": 837,
		  "guestPercent": 0.817203,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Dalhalla",
		  "mostGuestCity": "RÃ¤ttvik",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ae6c61d4c46d0c78b5518b49d8ba09f",
		  
		  "name": "Chris",
		  "createdDate": "2012-04-19 11:29:44",
		  "totalOrganizations": 20,
		  "totalTours": 14,
		  "totalDays": 607,
		  "totalCountries": 36,
		  "totalStates": 91,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 2818,
		  "schedulePercent": 0.824456,
		  "totalGuests": 1095,
		  "guestPercent": 0.862874,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2aee090659bafe5ebfa302b1209f179b",
		  
		  "name": "Thomas",
		  "createdDate": "2023-05-29 13:34:45",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 208,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 191,
		  "schedulePercent": 0.153672,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Rennes 4bis",
		  "mostGuestCity": "Rennes",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2af5f685955c253163f9d0d8a31f4841",
		  
		  "name": "Emily",
		  "createdDate": "2011-02-06 04:11:22",
		  "totalOrganizations": 17,
		  "totalTours": 8,
		  "totalDays": 899,
		  "totalCountries": 8,
		  "totalStates": 49,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 3699,
		  "schedulePercent": 0.895852,
		  "totalGuests": 3966,
		  "guestPercent": 0.992974,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2af63324c85e8fcb2d1d3d53f9578d16",
		  
		  "name": "Josh",
		  "createdDate": "2023-03-17 20:45:48",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 215,
		  "totalCountries": 19,
		  "totalStates": 48,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1444,
		  "schedulePercent": 0.606528,
		  "totalGuests": 198,
		  "guestPercent": 0.593155,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2affe0f334c63172e4c4f6d7eb6fbd23",
		  
		  "name": "Ivan",
		  "createdDate": "2024-12-07 21:53:02",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 469,
		  "totalCountries": 24,
		  "totalStates": 98,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 2741,
		  "schedulePercent": 0.81505,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Desert Diamond Arena",
		  "mostGuestCity": "Glendale",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b0ff1524cbeb14480d8b2813b7b5947",
		  
		  "name": "Rebecca",
		  "createdDate": "2018-10-03 22:24:19",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 1074,
		  "totalCountries": 24,
		  "totalStates": 45,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1333,
		  "schedulePercent": 0.581142,
		  "totalGuests": 345,
		  "guestPercent": 0.672711,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b1459a1506b6828876f406dc6dfed12",
		  
		  "name": "Joshua",
		  "createdDate": "2019-04-17 04:25:32",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 1172,
		  "totalCountries": 6,
		  "totalStates": 31,
		  "totalEvents": 430,
		  "eventPercent": 0.966002,
		  "totalScheduleItems": 2974,
		  "schedulePercent": 0.839982,
		  "totalGuests": 9915,
		  "guestPercent": 0.999433,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 523,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b1b4e01d2a261584f02453f5ee0ff76",
		  
		  "name": "SURVOLTA",
		  "createdDate": "2024-05-01 09:49:15",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 748,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 411,
		  "schedulePercent": 0.274365,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b1f243ff0ebce8313a4e9bfadc80159",
		  
		  "name": "Danny",
		  "createdDate": "2022-05-13 16:42:40",
		  "totalOrganizations": 13,
		  "totalTours": 20,
		  "totalDays": 412,
		  "totalCountries": 21,
		  "totalStates": 65,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 1812,
		  "schedulePercent": 0.678264,
		  "totalGuests": 171,
		  "guestPercent": 0.574683,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Masonic Lodge at Hollywood Forever",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b290e9062058dfbd48dcc1cc658e529",
		  
		  "name": "Victoria",
		  "createdDate": "2021-09-04 18:42:49",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 746,
		  "totalCountries": 12,
		  "totalStates": 64,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 3886,
		  "schedulePercent": 0.907525,
		  "totalGuests": 2152,
		  "guestPercent": 0.955802,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b2a69bdc5a4792bfcbf280e4e487b96",
		  
		  "name": "Clay",
		  "createdDate": "2012-05-30 15:01:03",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 159,
		  "totalCountries": 13,
		  "totalStates": 34,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 654,
		  "schedulePercent": 0.368994,
		  "totalGuests": 275,
		  "guestPercent": 0.637579,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Cadogan Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b3a9ccf9e60d698238475fdee0ee7e3",
		  
		  "name": "Kaylen",
		  "createdDate": "2018-03-20 16:47:41",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 134,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 785,
		  "schedulePercent": 0.417384,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Tioga-Sequoia Brewing Company Beer Garden",
		  "mostGuestCity": "Fresno",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b3f8a4ef6bf88034790d566581b4e7f",
		  
		  "name": "Tom",
		  "createdDate": "2019-11-09 15:39:25",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 316,
		  "totalCountries": 6,
		  "totalStates": 36,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1757,
		  "schedulePercent": 0.669878,
		  "totalGuests": 191,
		  "guestPercent": 0.586582,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Capitol Theatre",
		  "mostGuestCity": "Davenport",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b4d626476a3697fc0f94ac28f6b6450",
		  
		  "name": "Thomas",
		  "createdDate": "2020-01-02 11:40:49",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 66,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 432,
		  "schedulePercent": 0.282638,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b51ce9ec443bb683200a0be25bbb85e",
		  
		  "name": "Helena",
		  "createdDate": "2025-10-31 13:51:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b53a1c3effe877c6495a2be0699efd6",
		  
		  "name": "Laura",
		  "createdDate": "2024-04-03 08:01:46",
		  "totalOrganizations": 7,
		  "totalTours": 23,
		  "totalDays": 576,
		  "totalCountries": 10,
		  "totalStates": 21,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1405,
		  "schedulePercent": 0.599388,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "QPAC Concert Hall",
		  "mostGuestCity": "Brisbane",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b5738112f2bbba46803fcc1a717edc9",
		  
		  "name": "Davy",
		  "createdDate": "2015-02-26 22:01:32",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 1836,
		  "totalCountries": 21,
		  "totalStates": 77,
		  "totalEvents": 253,
		  "eventPercent": 0.874093,
		  "totalScheduleItems": 4035,
		  "schedulePercent": 0.915458,
		  "totalGuests": 1422,
		  "guestPercent": 0.902652,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b66bf9c29d77e040e88214f5033a345",
		  
		  "name": "Philippe",
		  "createdDate": "2023-10-05 10:46:26",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 164,
		  "totalCountries": 15,
		  "totalStates": 36,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 587,
		  "schedulePercent": 0.346668,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Teatro Villa de Molina",
		  "mostGuestCity": "Molina de Segura",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b70f9c4632fc49a62df61792a76a69c",
		  
		  "name": "Nahko",
		  "createdDate": "2013-07-26 13:26:07",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 149,
		  "totalCountries": 4,
		  "totalStates": 47,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 284,
		  "schedulePercent": 0.208862,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "The Gov",
		  "mostGuestCity": "Hindmarsh",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b733aaf239443ca28f3dd1c65359a95",
		  
		  "name": "Kristy",
		  "createdDate": "2018-02-15 13:30:57",
		  "totalOrganizations": 6,
		  "totalTours": 16,
		  "totalDays": 521,
		  "totalCountries": 12,
		  "totalStates": 31,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 706,
		  "schedulePercent": 0.389053,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-05-05 00:00:00",
		  "mostGuestName": "GRAMMY Museum at L.A. LIVE",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b74070c197fa04669663df288564345",
		  
		  "name": "Henry",
		  "createdDate": "2023-06-15 13:29:34",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 502,
		  "totalCountries": 22,
		  "totalStates": 65,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 2805,
		  "schedulePercent": 0.822869,
		  "totalGuests": 433,
		  "guestPercent": 0.707389,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Crane",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b7a4da8717bca65ca4ec45458142118",
		  
		  "name": "Zack",
		  "createdDate": "2025-01-28 09:00:37",
		  "totalOrganizations": 2,
		  "totalTours": 20,
		  "totalDays": 273,
		  "totalCountries": 16,
		  "totalStates": 41,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 2456,
		  "schedulePercent": 0.781732,
		  "totalGuests": 1048,
		  "guestPercent": 0.853694,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b7dc39b4f21d07f94ee2c4d8f36af99",
		  
		  "name": "Adela",
		  "createdDate": "2017-01-03 15:30:06",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 58,
		  "totalCountries": 7,
		  "totalStates": 24,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 339,
		  "schedulePercent": 0.237874,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Auditorio Nacional",
		  "mostGuestCity": "Mexico City",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b857884291b55b95de67d7ebe03044d",
		  
		  "name": "GTLO",
		  "createdDate": "2022-03-10 22:01:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 199,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1159,
		  "schedulePercent": 0.537171,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b8d248cedef7b7f55adbc51812be8fd",
		  
		  "name": "David",
		  "createdDate": "2022-04-21 13:56:24",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 690,
		  "totalCountries": 13,
		  "totalStates": 25,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 809,
		  "schedulePercent": 0.426337,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b956d4a7008e5bc752da96a856494b1",
		  
		  "name": "Brad",
		  "createdDate": "2023-11-03 00:10:49",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 137,
		  "totalCountries": 6,
		  "totalStates": 30,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1158,
		  "schedulePercent": 0.536718,
		  "totalGuests": 647,
		  "guestPercent": 0.770852,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b99678c2f61a43130de04897efe82c7",
		  
		  "name": "Connor",
		  "createdDate": "2022-07-13 20:20:56",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 133,
		  "totalCountries": 14,
		  "totalStates": 34,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 828,
		  "schedulePercent": 0.433477,
		  "totalGuests": 235,
		  "guestPercent": 0.616047,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2b9e817b1031eda3cd9c89ef50477cef",
		  
		  "name": "Bert",
		  "createdDate": "2022-03-10 18:30:04",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 129,
		  "totalCountries": 11,
		  "totalStates": 7,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 1358,
		  "schedulePercent": 0.587262,
		  "totalGuests": 1120,
		  "guestPercent": 0.86684,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Galopprennbahn KÃ¶ln-Weidenpesch",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2baa8578b5403a81cd06bf97a89c0263",
		  
		  "name": "SILAS",
		  "createdDate": "2024-02-09 17:41:11",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 72,
		  "totalCountries": 5,
		  "totalStates": 18,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 124,
		  "schedulePercent": 0.114007,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2baf18248e4117ad4a947284304d7375",
		  
		  "name": "Oskar",
		  "createdDate": "2022-08-25 21:53:09",
		  "totalOrganizations": 14,
		  "totalTours": 14,
		  "totalDays": 1282,
		  "totalCountries": 23,
		  "totalStates": 58,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 2537,
		  "schedulePercent": 0.790345,
		  "totalGuests": 856,
		  "guestPercent": 0.820716,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Public Records",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bbce122055118795b8c2a94d4e4368e",
		  
		  "name": "Sebastian",
		  "createdDate": "2019-01-22 13:32:31",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 289,
		  "totalCountries": 24,
		  "totalStates": 31,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 888,
		  "schedulePercent": 0.453083,
		  "totalGuests": 165,
		  "guestPercent": 0.56947,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "Backstage Club",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bc080d4e763edcf470ad73638c2cbaf",
		  
		  "name": "Candice",
		  "createdDate": "2015-09-30 15:44:16",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 363,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 276,
		  "guestPercent": 0.638259,
		  "mostGuestDate": "2025-03-16 00:00:00",
		  "mostGuestName": "Knuckleheads Saloon - The Garage",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bc100c4b6073c2827add6116d35ede4",
		  
		  "name": "MaRynn",
		  "createdDate": "2025-01-02 19:30:05",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 448,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1358,
		  "schedulePercent": 0.587262,
		  "totalGuests": 211,
		  "guestPercent": 0.603128,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bcc0fbd1513cbb7281e58f6001b5a03",
		  
		  "name": "Danelle",
		  "createdDate": "2022-11-01 14:55:31",
		  "totalOrganizations": 14,
		  "totalTours": 12,
		  "totalDays": 404,
		  "totalCountries": 14,
		  "totalStates": 22,
		  "totalEvents": 270,
		  "eventPercent": 0.890299,
		  "totalScheduleItems": 1326,
		  "schedulePercent": 0.577743,
		  "totalGuests": 810,
		  "guestPercent": 0.81063,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Sadlon Arena",
		  "mostGuestCity": "Barrie",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bcd26da383ad2e1c6618ce15de896c7",
		  
		  "name": "Stephan",
		  "createdDate": "2024-06-07 09:22:50",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 65,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 347,
		  "schedulePercent": 0.2415,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Lido",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bd83c2393fc220be1988a508eba005c",
		  
		  "name": "Teenage",
		  "createdDate": "2021-08-12 07:20:24",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 205,
		  "totalCountries": 5,
		  "totalStates": 40,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 846,
		  "schedulePercent": 0.439257,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Les Foufounes Ã‰lectriques",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bd93ef6780e49f093ce6cfcb3c2affe",
		  
		  "name": "Stephen",
		  "createdDate": "2010-10-13 18:38:47",
		  "totalOrganizations": 15,
		  "totalTours": 24,
		  "totalDays": 509,
		  "totalCountries": 23,
		  "totalStates": 86,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 2704,
		  "schedulePercent": 0.808704,
		  "totalGuests": 417,
		  "guestPercent": 0.700363,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bdc9b6d16f47e2d6fdee34cb74f0a44",
		  
		  "name": "Jaimee",
		  "createdDate": "2015-11-08 03:30:40",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 921,
		  "schedulePercent": 0.465095,
		  "totalGuests": 1125,
		  "guestPercent": 0.867407,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2be0fcc2b66f5bee379aed0f32840f69",
		  
		  "name": "Haley",
		  "createdDate": "2016-02-17 23:57:24",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 102,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 216,
		  "schedulePercent": 0.169538,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "ICA",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bf4b898a555534218149bfaabe17fc6",
		  
		  "name": "Ronan",
		  "createdDate": "2016-10-01 20:05:34",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 332,
		  "totalCountries": 16,
		  "totalStates": 25,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 561,
		  "schedulePercent": 0.337829,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2bfaf9f4d7f61df8c868bfe3a889b23e",
		  
		  "name": "Leland ",
		  "createdDate": "2019-05-14 16:56:46",
		  "totalOrganizations": 16,
		  "totalTours": 11,
		  "totalDays": 1815,
		  "totalCountries": 33,
		  "totalStates": 71,
		  "totalEvents": 297,
		  "eventPercent": 0.910811,
		  "totalScheduleItems": 3013,
		  "schedulePercent": 0.843268,
		  "totalGuests": 1378,
		  "guestPercent": 0.897325,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c159c7c8813a11c5642f059a8f73d89",
		  
		  "name": "Tommi",
		  "createdDate": "2020-11-11 10:06:00",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 142,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 590,
		  "schedulePercent": 0.347575,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c1721466aa80a0937d49243c76c5ab7",
		  
		  "name": "Lewis",
		  "createdDate": "2025-10-28 12:34:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 51,
		  "schedulePercent": 0.0606301,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c1bfec4ffbe1efffdb607121b9ed640",
		  
		  "name": "Becca",
		  "createdDate": "2022-04-05 17:34:09",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 318,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2175,
		  "schedulePercent": 0.744107,
		  "totalGuests": 254,
		  "guestPercent": 0.627153,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c2634689bac7761c01ff30d85a9f4b9",
		  
		  "name": "Laura ",
		  "createdDate": "2023-08-01 16:18:07",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 228,
		  "totalCountries": 19,
		  "totalStates": 28,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 850,
		  "schedulePercent": 0.440163,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c26de186358568ad76add87ca8cdfaf",
		  
		  "name": "Josh",
		  "createdDate": "2017-04-06 13:39:36",
		  "totalOrganizations": 14,
		  "totalTours": 13,
		  "totalDays": 1337,
		  "totalCountries": 8,
		  "totalStates": 54,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 2649,
		  "schedulePercent": 0.80315,
		  "totalGuests": 393,
		  "guestPercent": 0.691296,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c3b9d42d5db75940a37093f5aa14834",
		  
		  "name": "Michael",
		  "createdDate": "2011-08-20 15:38:52",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 165,
		  "totalCountries": 15,
		  "totalStates": 45,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1600,
		  "schedulePercent": 0.640639,
		  "totalGuests": 995,
		  "guestPercent": 0.845082,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "St. Augustine Amphitheatre",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c3d1c2a732415d059320490ba2d1223",
		  
		  "name": "Alan",
		  "createdDate": "2009-09-11 19:32:29",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1003,
		  "schedulePercent": 0.490934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c48a2ae2a852f735c7fe3dbb743d3f3",
		  
		  "name": "Agust",
		  "createdDate": "2023-03-11 18:45:31",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 105,
		  "totalCountries": 15,
		  "totalStates": 21,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 634,
		  "schedulePercent": 0.361854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c4bda40573765e879ae4da1b54b0579",
		  
		  "name": "Lynette",
		  "createdDate": "2023-05-31 17:38:58",
		  "totalOrganizations": 3,
		  "totalTours": 15,
		  "totalDays": 104,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 339,
		  "schedulePercent": 0.237874,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c4d142d44a40c67940b0f404af5252f",
		  
		  "name": "Aidan",
		  "createdDate": "2022-10-18 20:35:22",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 41,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 389,
		  "schedulePercent": 0.264279,
		  "totalGuests": 446,
		  "guestPercent": 0.711355,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "The Mod Club ",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c4d1cf0e2b1ac2b9481a79856a0da49",
		  
		  "name": "Nich",
		  "createdDate": "2014-08-11 20:19:54",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 271,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1521,
		  "schedulePercent": 0.622054,
		  "totalGuests": 3045,
		  "guestPercent": 0.982774,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c502a788aa532421248f0b53c29ed59",
		  
		  "name": "John",
		  "createdDate": "2009-07-22 15:49:21",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 112,
		  "totalCountries": 5,
		  "totalStates": 21,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 814,
		  "schedulePercent": 0.42849,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Charles Krug Winery",
		  "mostGuestCity": "St Helena",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c5828b989bb60e8f29cae444daa8ad9",
		  
		  "name": "James",
		  "createdDate": "2012-01-16 19:44:16",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 1141,
		  "totalCountries": 25,
		  "totalStates": 29,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1778,
		  "schedulePercent": 0.672144,
		  "totalGuests": 305,
		  "guestPercent": 0.652199,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c61566b58387796cd169502fb6ebb66",
		  
		  "name": "Blake",
		  "createdDate": "2025-03-18 18:27:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 89,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 329,
		  "schedulePercent": 0.230508,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c6175aa695d151d88755967b7180646",
		  
		  "name": "Fo Yo",
		  "createdDate": "2024-02-28 06:40:00",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 31,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 351,
		  "schedulePercent": 0.24354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c6307cf0527a894a50944a8938f1757",
		  
		  "name": "Ashley",
		  "createdDate": "2012-09-06 16:14:49",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 63,
		  "schedulePercent": 0.069243,
		  "totalGuests": 305,
		  "guestPercent": 0.652199,
		  "mostGuestDate": "2025-12-16 00:00:00",
		  "mostGuestName": "Grand Ole Opry",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c68957b4e4c6587f8b87cf0c008bba4",
		  
		  "name": "Kenny",
		  "createdDate": "2023-05-24 14:35:42",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 141,
		  "totalCountries": 5,
		  "totalStates": 30,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 896,
		  "schedulePercent": 0.456596,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-02-23 00:00:00",
		  "mostGuestName": "Orpheum Theatre",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c6a3a9909467d63cf9a99e03770d11c",
		  
		  "name": "Emily",
		  "createdDate": "2016-11-04 03:59:15",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 610,
		  "totalCountries": 11,
		  "totalStates": 25,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1554,
		  "schedulePercent": 0.631233,
		  "totalGuests": 649,
		  "guestPercent": 0.771306,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Coca-Cola Roxy",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c6b13beb65d7d8f1985d00594e9be17",
		  
		  "name": "Alicia",
		  "createdDate": "2014-04-28 19:39:40",
		  "totalOrganizations": 13,
		  "totalTours": 15,
		  "totalDays": 527,
		  "totalCountries": 24,
		  "totalStates": 35,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 1846,
		  "schedulePercent": 0.685063,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c705ba32a033c6636049c9eeab7c656",
		  
		  "name": "Rob",
		  "createdDate": "2015-06-13 05:46:50",
		  "totalOrganizations": 22,
		  "totalTours": 7,
		  "totalDays": 487,
		  "totalCountries": 7,
		  "totalStates": 58,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 4239,
		  "schedulePercent": 0.928717,
		  "totalGuests": 779,
		  "guestPercent": 0.802244,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c707370792143bfa528bebfee860128",
		  
		  "name": "Sander ",
		  "createdDate": "2024-10-24 21:48:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 330,
		  "schedulePercent": 0.230961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c7ccdfc59c797f62d40dee5bcb97b76",
		  
		  "name": "Stephanie",
		  "createdDate": "2017-02-16 17:44:46",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 375,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1936,
		  "schedulePercent": 0.701043,
		  "totalGuests": 3249,
		  "guestPercent": 0.986174,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Ak-Chin Pavilion",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 173,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2c807ecdcc7a90fe3c11c91f8c677a2f",
		  
		  "name": "Rick",
		  "createdDate": "2022-03-03 03:51:01",
		  "totalOrganizations": 16,
		  "totalTours": 15,
		  "totalDays": 617,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 5370,
		  "schedulePercent": 0.964642,
		  "totalGuests": 1089,
		  "guestPercent": 0.861967,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ca68c09e970f7eb924afb0d2f7b16de",
		  
		  "name": "Katie",
		  "createdDate": "2019-10-04 00:47:50",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 248,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1572,
		  "schedulePercent": 0.635199,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Bryce Jordan Center",
		  "mostGuestCity": "University Park",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2cb18fa0ae24d20c10ef8029c9dd134b",
		  
		  "name": "Jose",
		  "createdDate": "2019-01-05 01:53:13",
		  "totalOrganizations": 13,
		  "totalTours": 11,
		  "totalDays": 627,
		  "totalCountries": 9,
		  "totalStates": 38,
		  "totalEvents": 268,
		  "eventPercent": 0.888599,
		  "totalScheduleItems": 2555,
		  "schedulePercent": 0.793518,
		  "totalGuests": 379,
		  "guestPercent": 0.685403,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2cb380f7dea418bb16df18fda0c07b41",
		  
		  "name": "Kevin",
		  "createdDate": "2013-06-07 00:17:03",
		  "totalOrganizations": 15,
		  "totalTours": 15,
		  "totalDays": 3095,
		  "totalCountries": 12,
		  "totalStates": 58,
		  "totalEvents": 396,
		  "eventPercent": 0.957956,
		  "totalScheduleItems": 5809,
		  "schedulePercent": 0.972915,
		  "totalGuests": 686,
		  "guestPercent": 0.782298,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2cb491228fc9fc0224ebe93c529f0f47",
		  
		  "name": "Linda-marie",
		  "createdDate": "2016-01-23 12:46:52",
		  "totalOrganizations": 12,
		  "totalTours": 14,
		  "totalDays": 316,
		  "totalCountries": 32,
		  "totalStates": 64,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 2778,
		  "schedulePercent": 0.819243,
		  "totalGuests": 1386,
		  "guestPercent": 0.898912,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2cbbd795558fec6f6730b6db62996a54",
		  
		  "name": "Katarina",
		  "createdDate": "2022-04-01 12:39:31",
		  "totalOrganizations": 25,
		  "totalTours": 38,
		  "totalDays": 650,
		  "totalCountries": 10,
		  "totalStates": 14,
		  "totalEvents": 470,
		  "eventPercent": 0.973821,
		  "totalScheduleItems": 2779,
		  "schedulePercent": 0.81947,
		  "totalGuests": 123,
		  "guestPercent": 0.539211,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Ulriksdals slott",
		  "mostGuestCity": "Solna",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2cbfa6257d493fa208d30da26e5fc9fa",
		  
		  "name": "Mark",
		  "createdDate": "2013-05-02 11:55:07",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 462,
		  "totalCountries": 9,
		  "totalStates": 31,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 2015,
		  "schedulePercent": 0.716455,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ccbe008cf2fe68eac177ef3930a0d7a",
		  
		  "name": "Domenico",
		  "createdDate": "2015-07-26 18:06:12",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 63,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 514,
		  "schedulePercent": 0.318336,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ccbfddb9eaa5eb59ff5ae64581ed7b1",
		  
		  "name": "Anna",
		  "createdDate": "2025-03-04 16:47:49",
		  "totalOrganizations": 3,
		  "totalTours": 16,
		  "totalDays": 384,
		  "totalCountries": 29,
		  "totalStates": 48,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 2662,
		  "schedulePercent": 0.80383,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2cd25e35ba7b76c1f386a84bcf673e2e",
		  
		  "name": "Carl",
		  "createdDate": "2016-05-23 16:59:44",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 723,
		  "totalCountries": 7,
		  "totalStates": 40,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 564,
		  "schedulePercent": 0.338509,
		  "totalGuests": 107,
		  "guestPercent": 0.526292,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Museum Gardens",
		  "mostGuestCity": "York",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2cd70db54c076741a61a6c3c67bbd611",
		  
		  "name": "Beau",
		  "createdDate": "2013-07-20 20:51:37",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 659,
		  "totalCountries": 5,
		  "totalStates": 49,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1824,
		  "schedulePercent": 0.68019,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ce4beb96368cbf551dd203e5ada5c98",
		  
		  "name": "Jessica",
		  "createdDate": "2023-09-02 19:15:05",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 326,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 1959,
		  "schedulePercent": 0.705349,
		  "totalGuests": 1198,
		  "guestPercent": 0.875907,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Santa Barbara Bowl",
		  "mostGuestCity": "Santa Barbara",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2cf8c9f3f13fb5ed1a71de4af6fa72b3",
		  
		  "name": "ChloÃ«",
		  "createdDate": "2024-07-25 10:47:48",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 470,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 736,
		  "schedulePercent": 0.399932,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d0026d57e7f489ac0700b99d0db8cf4",
		  
		  "name": "Showcase ",
		  "createdDate": "2025-07-17 21:58:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 44,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 137,
		  "schedulePercent": 0.123187,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d073ffc352183fb8e758c87220f8b09",
		  
		  "name": "Kip ",
		  "createdDate": "2016-08-27 10:32:23",
		  "totalOrganizations": 18,
		  "totalTours": 11,
		  "totalDays": 234,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1886,
		  "schedulePercent": 0.692316,
		  "totalGuests": 345,
		  "guestPercent": 0.672711,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d0b969b97205cd0a8cd4a3fa5443380",
		  
		  "name": "Matthew",
		  "createdDate": "2024-04-24 22:50:21",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 562,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1850,
		  "schedulePercent": 0.68597,
		  "totalGuests": 151,
		  "guestPercent": 0.558817,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d1516efd36e4220438a2d8f49c10bf9",
		  
		  "name": "Tyrone",
		  "createdDate": "2023-07-03 10:28:44",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 185,
		  "totalCountries": 12,
		  "totalStates": 5,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 113,
		  "schedulePercent": 0.106754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d17d37d6eed77ca3a8b4104f8027050",
		  
		  "name": "Dave",
		  "createdDate": "2022-09-21 04:05:11",
		  "totalOrganizations": 17,
		  "totalTours": 12,
		  "totalDays": 550,
		  "totalCountries": 5,
		  "totalStates": 49,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1855,
		  "schedulePercent": 0.686423,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Rosemount Hotel",
		  "mostGuestCity": "North Perth",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d1edb34afdce231681935fa0c7688f5",
		  
		  "name": "Keegan",
		  "createdDate": "2023-05-26 03:30:29",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 1400,
		  "totalCountries": 3,
		  "totalStates": 55,
		  "totalEvents": 346,
		  "eventPercent": 0.940503,
		  "totalScheduleItems": 4358,
		  "schedulePercent": 0.933364,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Ford Amphitheater",
		  "mostGuestCity": "Colorado Springs",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d1f8dde6d9c8b88f4184d9a16002478",
		  
		  "name": "Sean",
		  "createdDate": "2019-07-04 13:48:53",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 828,
		  "totalCountries": 6,
		  "totalStates": 45,
		  "totalEvents": 230,
		  "eventPercent": 0.848595,
		  "totalScheduleItems": 1935,
		  "schedulePercent": 0.700816,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Boardwalk Rock Music Fest",
		  "mostGuestCity": "Ocean City",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d278fcdf448c399790b324282e8da5c",
		  
		  "name": "Terrance",
		  "createdDate": "2019-10-17 18:39:46",
		  "totalOrganizations": 10,
		  "totalTours": 22,
		  "totalDays": 2914,
		  "totalCountries": 8,
		  "totalStates": 59,
		  "totalEvents": 455,
		  "eventPercent": 0.972008,
		  "totalScheduleItems": 5758,
		  "schedulePercent": 0.972008,
		  "totalGuests": 679,
		  "guestPercent": 0.780825,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Fillmore New Orleans",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d2bd0538284de7ca2cbfd3a9981a939",
		  
		  "name": "Richie",
		  "createdDate": "2018-04-17 00:02:00",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 105,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 492,
		  "schedulePercent": 0.30893,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Tulips FTW",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d4720644992bc981368e6e6ec012d36",
		  
		  "name": "Peter",
		  "createdDate": "2018-11-08 17:16:42",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 497,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2089,
		  "schedulePercent": 0.730394,
		  "totalGuests": 608,
		  "guestPercent": 0.761219,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Rocket Mortgage FieldHouse",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d53a4efb59993341386324ce3b270d0",
		  
		  "name": "Savannah ",
		  "createdDate": "2025-03-26 04:59:50",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 381,
		  "totalCountries": 10,
		  "totalStates": 27,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 518,
		  "schedulePercent": 0.320603,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d55e5de3bf6c46961d911f7cf0fa9fa",
		  
		  "name": "Hunter",
		  "createdDate": "2020-03-04 20:31:04",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 69,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 408,
		  "schedulePercent": 0.272892,
		  "totalGuests": 103,
		  "guestPercent": 0.522779,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Downtown Las Vegas Event Center",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d5929749d14a94f9807c260ef08f688",
		  
		  "name": "Rick ",
		  "createdDate": "2015-08-11 16:02:39",
		  "totalOrganizations": 7,
		  "totalTours": 19,
		  "totalDays": 1094,
		  "totalCountries": 14,
		  "totalStates": 69,
		  "totalEvents": 312,
		  "eventPercent": 0.920671,
		  "totalScheduleItems": 3820,
		  "schedulePercent": 0.903672,
		  "totalGuests": 1317,
		  "guestPercent": 0.889053,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Commodore Ballroom",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d59fadbc82a3dd7c5160d3df3e08abe",
		  
		  "name": "Drea",
		  "createdDate": "2019-12-02 22:50:08",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 38,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 209,
		  "schedulePercent": 0.165798,
		  "totalGuests": 134,
		  "guestPercent": 0.548164,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d5d6f0ad421df8327a4acf1ede36e40",
		  
		  "name": "Adam",
		  "createdDate": "2013-07-17 12:58:25",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 294,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 970,
		  "schedulePercent": 0.481188,
		  "totalGuests": 184,
		  "guestPercent": 0.582276,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Grey Eagle Resort and Casino",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d621ca614b9904fa2704df6d174e249",
		  
		  "name": "Liina",
		  "createdDate": "2022-06-08 00:02:33",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 15,
		  "totalStates": 8,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 438,
		  "schedulePercent": 0.285131,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Huvila-teltta",
		  "mostGuestCity": "Hakaniemi",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d69ebe9b9efad081c0a4a390ca8d530",
		  
		  "name": "Josh",
		  "createdDate": "2015-04-11 23:10:45",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 1489,
		  "totalCountries": 4,
		  "totalStates": 64,
		  "totalEvents": 282,
		  "eventPercent": 0.899819,
		  "totalScheduleItems": 3753,
		  "schedulePercent": 0.899025,
		  "totalGuests": 1551,
		  "guestPercent": 0.915231,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d6fe44957fb691939087cc236da0f82",
		  
		  "name": "Kieran",
		  "createdDate": "2021-08-18 20:49:45",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 413,
		  "totalCountries": 11,
		  "totalStates": 25,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 475,
		  "schedulePercent": 0.300091,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d73515abf4a1a41ecfdea5ab75684e1",
		  
		  "name": "Mike",
		  "createdDate": "2024-11-06 01:58:03",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 362,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 913,
		  "schedulePercent": 0.462602,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d83c973a41636a31e41b2edd898d7ae",
		  
		  "name": "Paul",
		  "createdDate": "2015-01-20 15:19:44",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 181,
		  "totalCountries": 19,
		  "totalStates": 35,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1064,
		  "schedulePercent": 0.507593,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2d9380aa792e6b376cfbbb94ca057271",
		  
		  "name": "Richard",
		  "createdDate": "2018-09-20 12:53:13",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 54,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 265,
		  "schedulePercent": 0.196849,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Iridium",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2da3577a6f9ee8f4aeb827cf7043136e",
		  
		  "name": "Ava",
		  "createdDate": "2023-02-16 18:48:09",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 795,
		  "totalCountries": 11,
		  "totalStates": 47,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 2976,
		  "schedulePercent": 0.840322,
		  "totalGuests": 134,
		  "guestPercent": 0.548164,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2dad4b862709f9c39fd4772afcd17784",
		  
		  "name": "Emma ",
		  "createdDate": "2022-10-05 07:54:47",
		  "totalOrganizations": 64,
		  "totalTours": 42,
		  "totalDays": 1372,
		  "totalCountries": 13,
		  "totalStates": 12,
		  "totalEvents": 1339,
		  "eventPercent": 0.99796,
		  "totalScheduleItems": 4890,
		  "schedulePercent": 0.951043,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2db9b6530800888c8fdb71219c8e69c8",
		  
		  "name": "Nikki",
		  "createdDate": "2024-02-21 23:52:53",
		  "totalOrganizations": 3,
		  "totalTours": 14,
		  "totalDays": 421,
		  "totalCountries": 2,
		  "totalStates": 42,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 788,
		  "schedulePercent": 0.418178,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2dc4352cd54ca4b5fcf665d273c811fe",
		  
		  "name": "Invent",
		  "createdDate": "2022-10-31 17:32:09",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 389,
		  "totalCountries": 14,
		  "totalStates": 59,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 2869,
		  "schedulePercent": 0.829329,
		  "totalGuests": 943,
		  "guestPercent": 0.838509,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Varsity Theater",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2dc6a8b68456adc68b6d2065cd0e09e6",
		  
		  "name": "Paula",
		  "createdDate": "2024-08-28 13:48:31",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 375,
		  "totalCountries": 11,
		  "totalStates": 15,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 57,
		  "schedulePercent": 0.0656165,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2dc8e9461d500fa9e50c91076d8736b7",
		  
		  "name": "Patrick",
		  "createdDate": "2023-04-13 15:16:12",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 442,
		  "totalCountries": 6,
		  "totalStates": 36,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 661,
		  "schedulePercent": 0.372054,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Vibrant Music Hall",
		  "mostGuestCity": "Waukee",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2dca279d096810059ba307a0f4e9cd5f",
		  
		  "name": "Travis",
		  "createdDate": "2025-04-08 21:03:02",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 500,
		  "schedulePercent": 0.31199,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2dde4cb1a6b2fa3e6a6bd0bf2180aac2",
		  
		  "name": "Brianna",
		  "createdDate": "2024-02-27 23:21:56",
		  "totalOrganizations": 1,
		  "totalTours": 21,
		  "totalDays": 504,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 2736,
		  "schedulePercent": 0.813803,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2df0c1849f3a543a53515db3f1c9999d",
		  
		  "name": "Dante",
		  "createdDate": "2017-09-15 12:50:53",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 515,
		  "totalCountries": 21,
		  "totalStates": 55,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1135,
		  "schedulePercent": 0.529805,
		  "totalGuests": 215,
		  "guestPercent": 0.605281,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Teh Aztec theatre",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2df35d118cebdcc58ce9d09c4ff451fb",
		  
		  "name": "Haily",
		  "createdDate": "2020-01-04 04:20:25",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 676,
		  "totalCountries": 12,
		  "totalStates": 53,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 1694,
		  "schedulePercent": 0.657525,
		  "totalGuests": 1377,
		  "guestPercent": 0.896985,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2df9e32856782982ee60555f9012465b",
		  
		  "name": "Arnaud",
		  "createdDate": "2022-06-09 14:11:19",
		  "totalOrganizations": 3,
		  "totalTours": 14,
		  "totalDays": 118,
		  "totalCountries": 18,
		  "totalStates": 17,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 336,
		  "schedulePercent": 0.234587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2dfc330874a1871070e3ecd71a6dcafd",
		  
		  "name": "Vickie",
		  "createdDate": "2019-10-09 17:43:04",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 343,
		  "totalCountries": 20,
		  "totalStates": 34,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 690,
		  "schedulePercent": 0.382593,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Osheaga",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e026f8d1c21eb46bcc055d5681c32be",
		  
		  "name": "Renaud",
		  "createdDate": "2015-05-22 16:44:23",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 317,
		  "totalCountries": 14,
		  "totalStates": 26,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 680,
		  "schedulePercent": 0.379306,
		  "totalGuests": 275,
		  "guestPercent": 0.637579,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e056c70a0d355e17f7d3c1a5d592e1f",
		  
		  "name": "CHRISTOPHER",
		  "createdDate": "2024-03-07 00:06:15",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 386,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 391,
		  "schedulePercent": 0.265073,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "The Dirty Drummer",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e1a04944a8b9d76aeae538cb74a6bbc",
		  
		  "name": "Stacey",
		  "createdDate": "2023-04-20 00:56:23",
		  "totalOrganizations": 9,
		  "totalTours": 19,
		  "totalDays": 574,
		  "totalCountries": 16,
		  "totalStates": 38,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1147,
		  "schedulePercent": 0.533545,
		  "totalGuests": 393,
		  "guestPercent": 0.691296,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Manning Bar",
		  "mostGuestCity": "Camperdown",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e2ad5cdb9093725fbb9d4b305a79054",
		  
		  "name": "Ben",
		  "createdDate": "2016-03-26 15:52:14",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 849,
		  "totalCountries": 6,
		  "totalStates": 39,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 3662,
		  "schedulePercent": 0.893926,
		  "totalGuests": 1664,
		  "guestPercent": 0.925544,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Boone Pickens Stadium",
		  "mostGuestCity": "Stillwater",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e2bca91c2f3df646132be0304036718",
		  
		  "name": "Anthony",
		  "createdDate": "2010-07-15 14:42:50",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 1153,
		  "totalCountries": 15,
		  "totalStates": 50,
		  "totalEvents": 346,
		  "eventPercent": 0.940503,
		  "totalScheduleItems": 3558,
		  "schedulePercent": 0.885313,
		  "totalGuests": 898,
		  "guestPercent": 0.829556,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e303ee45b4453c8cd2dee91b0d13126",
		  
		  "name": "Betthia Mae",
		  "createdDate": "2024-08-23 23:12:03",
		  "totalOrganizations": 3,
		  "totalTours": 19,
		  "totalDays": 298,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 3016,
		  "schedulePercent": 0.843608,
		  "totalGuests": 1391,
		  "guestPercent": 0.899592,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Thompson's Point",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e374b1e34a3658fbc9ced4577817ed2",
		  
		  "name": "Irving",
		  "createdDate": "2025-07-31 03:34:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 107,
		  "schedulePercent": 0.102675,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e385da3dfd0447ed40bb78a23443738",
		  
		  "name": "Mathilde",
		  "createdDate": "2025-05-15 17:01:17",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 35,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 345,
		  "schedulePercent": 0.24116,
		  "totalGuests": 139,
		  "guestPercent": 0.551677,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Festival Pause Guitare",
		  "mostGuestCity": "Albi",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e3994ce8cf5e2384f723a216b4cd12b",
		  
		  "name": "Lucia ",
		  "createdDate": "2021-10-29 09:24:36",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 516,
		  "totalCountries": 22,
		  "totalStates": 57,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 2269,
		  "schedulePercent": 0.75782,
		  "totalGuests": 941,
		  "guestPercent": 0.837942,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 125,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e3f473e00459842ed70e5796ece9ad9",
		  
		  "name": "Justin",
		  "createdDate": "2025-01-10 22:47:49",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 102,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 214,
		  "guestPercent": 0.604828,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e478661744f71fda1ac7f9d2a00254a",
		  
		  "name": "ATHALY",
		  "createdDate": "2025-05-14 02:21:38",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 115,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 438,
		  "schedulePercent": 0.285131,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Roxy Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e4f1c081542786f39e0c335fe072554",
		  
		  "name": "Ari ",
		  "createdDate": "2023-06-05 23:45:22",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 372,
		  "schedulePercent": 0.254193,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "Tipitina's Uptown",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e4f381b4bf92984e1ce3cb87b5d8fdc",
		  
		  "name": "Maggie",
		  "createdDate": "2024-04-19 16:28:11",
		  "totalOrganizations": 7,
		  "totalTours": 18,
		  "totalDays": 551,
		  "totalCountries": 24,
		  "totalStates": 65,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 3321,
		  "schedulePercent": 0.868767,
		  "totalGuests": 1499,
		  "guestPercent": 0.908772,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Magazine London",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e4f539555a83a7ded846b8ac044fb81",
		  
		  "name": "Alex",
		  "createdDate": "2012-10-26 23:28:50",
		  "totalOrganizations": 18,
		  "totalTours": 34,
		  "totalDays": 1754,
		  "totalCountries": 29,
		  "totalStates": 82,
		  "totalEvents": 538,
		  "eventPercent": 0.982774,
		  "totalScheduleItems": 8507,
		  "schedulePercent": 0.99184,
		  "totalGuests": 4583,
		  "guestPercent": 0.99626,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e568395d52271661b59a7dcfbce550a",
		  
		  "name": "Logan",
		  "createdDate": "2015-11-08 04:20:42",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1281,
		  "schedulePercent": 0.567656,
		  "totalGuests": 671,
		  "guestPercent": 0.778332,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "First Bank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e6f14b4e1cbb6d35e85dcf2ce91fbc5",
		  
		  "name": "John",
		  "createdDate": "2013-11-20 12:25:52",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 366,
		  "totalCountries": 7,
		  "totalStates": 44,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2114,
		  "schedulePercent": 0.734474,
		  "totalGuests": 113,
		  "guestPercent": 0.530598,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Masonic Lodge at Hollywood Forever",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e717d023318c0db1cf23ab7c97fc060",
		  
		  "name": "Ryan",
		  "createdDate": "2023-02-10 18:56:01",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 736,
		  "totalCountries": 20,
		  "totalStates": 69,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 3393,
		  "schedulePercent": 0.87466,
		  "totalGuests": 940,
		  "guestPercent": 0.837262,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "DCU Center",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e7854920c215bf02429506b2915e38c",
		  
		  "name": "Dave",
		  "createdDate": "2014-12-18 12:28:29",
		  "totalOrganizations": 14,
		  "totalTours": 44,
		  "totalDays": 1881,
		  "totalCountries": 35,
		  "totalStates": 99,
		  "totalEvents": 430,
		  "eventPercent": 0.966002,
		  "totalScheduleItems": 6060,
		  "schedulePercent": 0.976428,
		  "totalGuests": 1487,
		  "guestPercent": 0.908092,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e7b3dc3b7efa6442802813f63144037",
		  
		  "name": "Donalee",
		  "createdDate": "2024-07-12 23:06:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 202,
		  "schedulePercent": 0.162058,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2e859420d32957b3ebf14ccf8ded4e8e",
		  
		  "name": "Steffen",
		  "createdDate": "2021-12-12 21:56:41",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 110,
		  "totalCountries": 24,
		  "totalStates": 53,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1008,
		  "schedulePercent": 0.492747,
		  "totalGuests": 239,
		  "guestPercent": 0.618314,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "1720",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ea885a2a7b0b03407239d0911f566f3",
		  
		  "name": "Thomas",
		  "createdDate": "2025-04-13 01:23:28",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 54,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 80,
		  "schedulePercent": 0.0822756,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ead1ac8945839210bf3a0584bede32e",
		  
		  "name": "Clement",
		  "createdDate": "2018-08-08 06:39:21",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 787,
		  "totalCountries": 5,
		  "totalStates": 17,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 804,
		  "schedulePercent": 0.424071,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2eb1ed307579d1a0468d62256a09a2c4",
		  
		  "name": "Erik",
		  "createdDate": "2025-01-17 17:40:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 20,
		  "totalStates": 14,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 320,
		  "schedulePercent": 0.226995,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2eb43f2bc2a64919256bab1e27818ff9",
		  
		  "name": "Sooze",
		  "createdDate": "2017-06-29 17:14:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 149,
		  "totalCountries": 19,
		  "totalStates": 30,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 852,
		  "schedulePercent": 0.440843,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Auditorium Parco Della Musica - Sala Sinopoli",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ed25da773511ec0cb3ed8101974a028",
		  
		  "name": "Elin",
		  "createdDate": "2025-03-03 10:08:49",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 31,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ee21e3749173f9a744742a4aa367db1",
		  
		  "name": "Joe",
		  "createdDate": "2022-11-09 18:12:22",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 127,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 663,
		  "schedulePercent": 0.372507,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "The Capitol Theatre",
		  "mostGuestCity": "Port Chester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ef4af417eb300e1d146defdc81b750c",
		  
		  "name": "Katrina",
		  "createdDate": "2022-06-07 10:25:15",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 225,
		  "totalCountries": 11,
		  "totalStates": 45,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1484,
		  "schedulePercent": 0.614121,
		  "totalGuests": 298,
		  "guestPercent": 0.648685,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2efbeab13928ae4371f5182948df1d1a",
		  
		  "name": "Ryan",
		  "createdDate": "2022-09-26 15:55:02",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 631,
		  "totalCountries": 5,
		  "totalStates": 40,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 2056,
		  "schedulePercent": 0.724841,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Stage AE",
		  "mostGuestCity": "Pittsburgh",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f002a30ccd0c82a79929b1ebd84806e",
		  
		  "name": "Ian",
		  "createdDate": "2011-04-04 18:53:01",
		  "totalOrganizations": 57,
		  "totalTours": 16,
		  "totalDays": 733,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2249,
		  "schedulePercent": 0.754986,
		  "totalGuests": 873,
		  "guestPercent": 0.823663,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f11e1f75b00f2946f4af28f05d962c5",
		  
		  "name": "Tara",
		  "createdDate": "2010-05-06 17:05:47",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 446,
		  "totalCountries": 22,
		  "totalStates": 26,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1740,
		  "schedulePercent": 0.665571,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f1a7a74505b80e700c8fe5b3439c98d",
		  
		  "name": "Mahalia",
		  "createdDate": "2019-04-30 23:29:27",
		  "totalOrganizations": 29,
		  "totalTours": 28,
		  "totalDays": 894,
		  "totalCountries": 26,
		  "totalStates": 92,
		  "totalEvents": 387,
		  "eventPercent": 0.955349,
		  "totalScheduleItems": 5035,
		  "schedulePercent": 0.955009,
		  "totalGuests": 690,
		  "guestPercent": 0.783545,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f20cbbc1ec485b5af2c8dc5f89a95ef",
		  
		  "name": "Daniel",
		  "createdDate": "2013-09-14 10:17:22",
		  "totalOrganizations": 22,
		  "totalTours": 23,
		  "totalDays": 2417,
		  "totalCountries": 5,
		  "totalStates": 54,
		  "totalEvents": 417,
		  "eventPercent": 0.962715,
		  "totalScheduleItems": 5797,
		  "schedulePercent": 0.972801,
		  "totalGuests": 995,
		  "guestPercent": 0.845082,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f258cd2d0ddbeeed1a8a16f79b7f224",
		  
		  "name": "Matthew",
		  "createdDate": "2024-07-07 18:01:30",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 244,
		  "totalCountries": 8,
		  "totalStates": 44,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 857,
		  "schedulePercent": 0.442656,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f2ff475db356d402fa4e6965878ca33",
		  
		  "name": "Abel",
		  "createdDate": "2011-07-13 20:37:45",
		  "totalOrganizations": 18,
		  "totalTours": 45,
		  "totalDays": 1124,
		  "totalCountries": 15,
		  "totalStates": 51,
		  "totalEvents": 344,
		  "eventPercent": 0.93937,
		  "totalScheduleItems": 4187,
		  "schedulePercent": 0.925544,
		  "totalGuests": 2949,
		  "guestPercent": 0.980734,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f3e5f706b33270324e0350396dde250",
		  
		  "name": "Rocki",
		  "createdDate": "2025-10-27 18:52:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 1,
		  "totalStates": 17,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 261,
		  "schedulePercent": 0.195603,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "House of Blues Orlando",
		  "mostGuestCity": "Lake Buena Vista",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f4b9c7ca3b4dddabfb4c20d5a980170",
		  
		  "name": "Paul",
		  "createdDate": "2012-12-26 01:36:46",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 241,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 678,
		  "schedulePercent": 0.377946,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f4f35319fede0e672db1c47e8e556a4",
		  
		  "name": "Bob",
		  "createdDate": "2024-02-12 14:03:59",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 272,
		  "totalCountries": 22,
		  "totalStates": 72,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 981,
		  "schedulePercent": 0.484814,
		  "totalGuests": 323,
		  "guestPercent": 0.662511,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Lido",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f5ffabf61e30be773932d1d444d3b28",
		  
		  "name": "Jennifer",
		  "createdDate": "2023-03-07 17:22:55",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 83,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 751,
		  "schedulePercent": 0.405598,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Summit Music Hall",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f66a651133e3c7cb863d4dbdcfee90c",
		  
		  "name": "Lincoln",
		  "createdDate": "2023-02-17 19:40:57",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 295,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 558,
		  "schedulePercent": 0.336582,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Fremont Abbey",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f690c9833a20a094b321eaa462aa7f2",
		  
		  "name": "Matthew",
		  "createdDate": "2025-05-09 05:39:30",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 128,
		  "schedulePercent": 0.116614,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f69af6e9dc8554f847c57fbc910959d",
		  
		  "name": "Antonio",
		  "createdDate": "2025-03-29 16:53:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 202,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1084,
		  "schedulePercent": 0.515299,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f70101523e9923346418d7c3566cce2",
		  
		  "name": "Tim",
		  "createdDate": "2011-05-03 15:41:14",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 703,
		  "totalCountries": 15,
		  "totalStates": 60,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 3415,
		  "schedulePercent": 0.876813,
		  "totalGuests": 1739,
		  "guestPercent": 0.929737,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f8b7edd65baab77f0436d16c48a3146",
		  
		  "name": "Toni",
		  "createdDate": "2023-12-26 20:17:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 126,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 646,
		  "schedulePercent": 0.36582,
		  "totalGuests": 657,
		  "guestPercent": 0.772892,
		  "mostGuestDate": "2025-09-01 00:00:00",
		  "mostGuestName": "John T. Floore's Country Store",
		  "mostGuestCity": "Helotes",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f92774896f89081a3419da3c6582016",
		  
		  "name": "Irving",
		  "createdDate": "2024-01-30 04:56:00",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 1195,
		  "totalCountries": 5,
		  "totalStates": 65,
		  "totalEvents": 297,
		  "eventPercent": 0.910811,
		  "totalScheduleItems": 3161,
		  "schedulePercent": 0.856414,
		  "totalGuests": 510,
		  "guestPercent": 0.733001,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2f9ae9151a8b7e20a88bad9efc98967a",
		  
		  "name": "Sherry",
		  "createdDate": "2025-07-14 17:29:30",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 237,
		  "totalCountries": 10,
		  "totalStates": 45,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 911,
		  "schedulePercent": 0.462149,
		  "totalGuests": 382,
		  "guestPercent": 0.686537,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2fa41897e4f50254eb1bc391f3560880",
		  
		  "name": "Joseph",
		  "createdDate": "2018-01-10 01:53:21",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 717,
		  "totalCountries": 17,
		  "totalStates": 50,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 3270,
		  "schedulePercent": 0.86582,
		  "totalGuests": 1034,
		  "guestPercent": 0.851995,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2fb865d22401f50e1463bf4269b6ace9",
		  
		  "name": "Tobias",
		  "createdDate": "2025-03-22 10:31:30",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 125,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1174,
		  "schedulePercent": 0.540911,
		  "totalGuests": 2043,
		  "guestPercent": 0.949796,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2fbb319ca9b98ffe2168aace3d00304a",
		  
		  "name": "Lily",
		  "createdDate": "2016-07-04 04:10:25",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 2,
		  "eventPercent": 0.0163191,
		  "totalScheduleItems": 2,
		  "schedulePercent": 0.0105394,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "QPAC Concert Hall",
		  "mostGuestCity": "Brisbane",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2fde7648f9cf0f12e913a79960c7f82c",
		  
		  "name": "Emma",
		  "createdDate": "2021-10-17 08:05:03",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 1469,
		  "totalCountries": 6,
		  "totalStates": 6,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1334,
		  "schedulePercent": 0.581369,
		  "totalGuests": 362,
		  "guestPercent": 0.67883,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Glasgow Royal Concert Hall",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2feecd29cf366de56bb2a7fa34c29300",
		  
		  "name": "FPC",
		  "createdDate": "2022-11-19 03:31:00",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 43,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 270,
		  "schedulePercent": 0.199569,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-04-28 00:00:00",
		  "mostGuestName": "House of Blues Chicago",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ff4489706db9e474d2fd64756d73a93",
		  
		  "name": "Jeff",
		  "createdDate": "2025-01-25 22:01:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 342,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 710,
		  "schedulePercent": 0.390639,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "State Farm Arena",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ff4b8b34a4118e97e936b3cfd13d407",
		  
		  "name": "Douglas",
		  "createdDate": "2025-02-06 18:08:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 52,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 171,
		  "schedulePercent": 0.141319,
		  "totalGuests": 67,
		  "guestPercent": 0.480734,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Caverns",
		  "mostGuestCity": "Pelham",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "2ffda31c23f30972fe30b63f2435a474",
		  
		  "name": "Grace",
		  "createdDate": "2025-02-24 16:20:58",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 99,
		  "totalCountries": 8,
		  "totalStates": 14,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 293,
		  "schedulePercent": 0.213849,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30104081db384d01b05f1aad3b4c3238",
		  
		  "name": "Kevin ",
		  "createdDate": "2011-06-21 03:53:05",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 271,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 2712,
		  "schedulePercent": 0.810517,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "301d6bf853e7f90961f0028219b97e64",
		  
		  "name": "Thunderstorm",
		  "createdDate": "2021-08-18 22:22:37",
		  "totalOrganizations": 4,
		  "totalTours": 35,
		  "totalDays": 379,
		  "totalCountries": 4,
		  "totalStates": 30,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1256,
		  "schedulePercent": 0.561877,
		  "totalGuests": 97,
		  "guestPercent": 0.516092,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "The Intersection",
		  "mostGuestCity": "Grand Rapids",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3042a4fccd254403abea9ec648a57d57",
		  
		  "name": "Matt",
		  "createdDate": "2012-06-14 01:16:45",
		  "totalOrganizations": 13,
		  "totalTours": 1,
		  "totalDays": 51,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 107,
		  "schedulePercent": 0.102675,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3043d8bbe6c1a74da4426a310c0c747c",
		  
		  "name": "Mike",
		  "createdDate": "2016-09-26 14:31:34",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 209,
		  "totalCountries": 31,
		  "totalStates": 37,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1079,
		  "schedulePercent": 0.513826,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Capitol ",
		  "mostGuestCity": "Mannheim",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3059a926c20d98b197b4916dcd4468ce",
		  
		  "name": "Storefront",
		  "createdDate": "2022-04-27 21:28:04",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 340,
		  "totalCountries": 16,
		  "totalStates": 27,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 496,
		  "schedulePercent": 0.310403,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "4 Star Theater",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "305f30104bb11a83b953313dd0cd8539",
		  
		  "name": "Sammy",
		  "createdDate": "2021-07-11 14:28:24",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 124,
		  "totalCountries": 6,
		  "totalStates": 27,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 643,
		  "schedulePercent": 0.365254,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "House of Yes",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "306f32eab4df3b8c4b5b1e890ec26d22",
		  
		  "name": "Ismael",
		  "createdDate": "2014-03-01 02:37:38",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 94,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 201,
		  "schedulePercent": 0.161491,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "307114fc7e373fb61acfa6d7aca025e6",
		  
		  "name": "Ran",
		  "createdDate": "2024-09-23 11:55:02",
		  "totalOrganizations": 8,
		  "totalTours": 15,
		  "totalDays": 218,
		  "totalCountries": 23,
		  "totalStates": 28,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1403,
		  "schedulePercent": 0.598368,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3072cd15314226ec8260f92b4bbc6664",
		  
		  "name": "Ben",
		  "createdDate": "2013-01-11 23:27:38",
		  "totalOrganizations": 20,
		  "totalTours": 7,
		  "totalDays": 1281,
		  "totalCountries": 33,
		  "totalStates": 54,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 3056,
		  "schedulePercent": 0.848028,
		  "totalGuests": 2354,
		  "guestPercent": 0.963622,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 230,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "307497b4f9c8e51f8283bd5d1ab627a6",
		  
		  "name": "Alan",
		  "createdDate": "2010-01-29 20:15:43",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 1314,
		  "totalCountries": 20,
		  "totalStates": 60,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 2413,
		  "schedulePercent": 0.776405,
		  "totalGuests": 743,
		  "guestPercent": 0.794764,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "307c31d988f77aff8e42ec329880cb1a",
		  
		  "name": "Nick",
		  "createdDate": "2018-02-18 19:29:44",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 391,
		  "totalCountries": 24,
		  "totalStates": 71,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 1627,
		  "schedulePercent": 0.645512,
		  "totalGuests": 308,
		  "guestPercent": 0.653105,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "309e1618171a721047ee298c6b0b945f",
		  
		  "name": "Max",
		  "createdDate": "2025-06-11 06:19:54",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 102,
		  "totalCountries": 17,
		  "totalStates": 27,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 128,
		  "schedulePercent": 0.116614,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30ad86411ea4e5239fd15e3eb8f53b77",
		  
		  "name": "Carl",
		  "createdDate": "2018-07-06 17:28:45",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 364,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Cult Classic",
		  "mostGuestCity": "Stevensville",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30be4bd59dd3aa1e821d55b134b74393",
		  
		  "name": "Noah",
		  "createdDate": "2023-02-09 18:59:43",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 159,
		  "totalCountries": 13,
		  "totalStates": 33,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 676,
		  "schedulePercent": 0.37704,
		  "totalGuests": 261,
		  "guestPercent": 0.6301,
		  "mostGuestDate": "2025-02-05 00:00:00",
		  "mostGuestName": "Starland Ballroom",
		  "mostGuestCity": "Sayreville",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30beb1f3505aac7d066d2dcbe254c0ed",
		  
		  "name": "Iran",
		  "createdDate": "2015-01-10 13:48:12",
		  "totalOrganizations": 9,
		  "totalTours": 2,
		  "totalDays": 64,
		  "totalCountries": 17,
		  "totalStates": 15,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30c7d9a41cee5d737e9c5e339ef9a86d",
		  
		  "name": "Jesper",
		  "createdDate": "2018-09-22 23:48:00",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 184,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 952,
		  "schedulePercent": 0.476541,
		  "totalGuests": 83,
		  "guestPercent": 0.499773,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "The Brighton Centre",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30ce6b6cb2a326e9bccde791823721f8",
		  
		  "name": "Robby",
		  "createdDate": "2015-07-16 21:40:47",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 1529,
		  "totalCountries": 5,
		  "totalStates": 39,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1676,
		  "schedulePercent": 0.654125,
		  "totalGuests": 699,
		  "guestPercent": 0.785358,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30cef9d3341459e04d428c3b7acab43d",
		  
		  "name": "Nick",
		  "createdDate": "2024-01-10 17:20:29",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 1402,
		  "totalCountries": 9,
		  "totalStates": 52,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 1830,
		  "schedulePercent": 0.681437,
		  "totalGuests": 1194,
		  "guestPercent": 0.875453,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Barstool Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30d9db1767ac82792647bc23afa29839",
		  
		  "name": "Katie",
		  "createdDate": "2022-08-12 20:19:12",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1028,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 2718,
		  "schedulePercent": 0.811537,
		  "totalGuests": 712,
		  "guestPercent": 0.788418,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30dec5375f32983a3a30043f1d9981e6",
		  
		  "name": "Charissa",
		  "createdDate": "2021-05-05 18:20:05",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 372,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 2149,
		  "schedulePercent": 0.739461,
		  "totalGuests": 387,
		  "guestPercent": 0.688803,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Gas South Arena",
		  "mostGuestCity": "Duluth",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "30f4234f8801b8611f61ddc6d8c21ac6",
		  
		  "name": "Delanie",
		  "createdDate": "2022-06-18 19:39:53",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 204,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 201,
		  "schedulePercent": 0.161491,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3103f4b3a86d62969cf20d60aa54fe07",
		  
		  "name": "Veikko",
		  "createdDate": "2018-02-08 13:49:00",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 279,
		  "totalCountries": 14,
		  "totalStates": 20,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3108cbc20c96a16e64b01a3d607416ba",
		  
		  "name": "George",
		  "createdDate": "2009-09-03 01:15:55",
		  "totalOrganizations": 10,
		  "totalTours": 14,
		  "totalDays": 659,
		  "totalCountries": 12,
		  "totalStates": 53,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 2473,
		  "schedulePercent": 0.783998,
		  "totalGuests": 909,
		  "guestPercent": 0.832502,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Studio Instrument Rentals",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3119a878a9cd77db7e7cb0aae2a21f88",
		  
		  "name": "Lauren",
		  "createdDate": "2022-01-13 02:37:15",
		  "totalOrganizations": 11,
		  "totalTours": 19,
		  "totalDays": 523,
		  "totalCountries": 13,
		  "totalStates": 56,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 2096,
		  "schedulePercent": 0.732208,
		  "totalGuests": 538,
		  "guestPercent": 0.740027,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "House of Yes",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31256e5498c70e7e696b1428c535dac0",
		  
		  "name": "Stanley",
		  "createdDate": "2014-04-22 22:46:38",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 105,
		  "totalCountries": 9,
		  "totalStates": 37,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 767,
		  "schedulePercent": 0.410925,
		  "totalGuests": 601,
		  "guestPercent": 0.758273,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "312d52fb69414628652e3d2ca555f77b",
		  
		  "name": "Matthew",
		  "createdDate": "2016-11-24 18:42:52",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 490,
		  "totalCountries": 23,
		  "totalStates": 56,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 3030,
		  "schedulePercent": 0.844855,
		  "totalGuests": 2983,
		  "guestPercent": 0.981528,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "OVO Arena Wembley",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 401,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "312e5adadfae9290993b68897f98b735",
		  
		  "name": "Amy",
		  "createdDate": "2020-11-05 06:28:47",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 215,
		  "totalCountries": 17,
		  "totalStates": 27,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "312f80a9d1996a58c73346bdbf037cb4",
		  
		  "name": "Luke",
		  "createdDate": "2023-09-29 03:56:49",
		  "totalOrganizations": 3,
		  "totalTours": 14,
		  "totalDays": 300,
		  "totalCountries": 6,
		  "totalStates": 27,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 750,
		  "schedulePercent": 0.405032,
		  "totalGuests": 270,
		  "guestPercent": 0.634746,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Lincoln Financial Field",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31532d2201376867102b708f54712a3f",
		  
		  "name": "Jeremy",
		  "createdDate": "2017-04-05 16:44:03",
		  "totalOrganizations": 17,
		  "totalTours": 10,
		  "totalDays": 1006,
		  "totalCountries": 8,
		  "totalStates": 54,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1736,
		  "schedulePercent": 0.665118,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Pioneer Courthouse Square",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31561a0c96e3fff01124ba70e2d68c7a",
		  
		  "name": "Youngmyung",
		  "createdDate": "2018-10-03 15:56:10",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 140,
		  "totalCountries": 19,
		  "totalStates": 37,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 890,
		  "schedulePercent": 0.453989,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3157b15ebf285ba1394d9a0740cc59cf",
		  
		  "name": "Laurens",
		  "createdDate": "2016-11-25 07:46:07",
		  "totalOrganizations": 13,
		  "totalTours": 12,
		  "totalDays": 601,
		  "totalCountries": 22,
		  "totalStates": 59,
		  "totalEvents": 230,
		  "eventPercent": 0.848595,
		  "totalScheduleItems": 3307,
		  "schedulePercent": 0.867974,
		  "totalGuests": 445,
		  "guestPercent": 0.710675,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "317818543b588bb03e516dc87a59997a",
		  
		  "name": "Erika",
		  "createdDate": "2022-03-07 22:25:05",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 188,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 634,
		  "schedulePercent": 0.361854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31809186f8748eb732113319afefd20e",
		  
		  "name": "Chris",
		  "createdDate": "2017-09-14 01:23:18",
		  "totalOrganizations": 16,
		  "totalTours": 27,
		  "totalDays": 348,
		  "totalCountries": 31,
		  "totalStates": 53,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1216,
		  "schedulePercent": 0.550657,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-07-22 00:00:00",
		  "mostGuestName": "Zebulon",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "318e9726c1e55e0a2574c1926526bd3f",
		  
		  "name": "Katie",
		  "createdDate": "2011-06-14 22:02:44",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 862,
		  "totalCountries": 24,
		  "totalStates": 73,
		  "totalEvents": 366,
		  "eventPercent": 0.948436,
		  "totalScheduleItems": 6259,
		  "schedulePercent": 0.978921,
		  "totalGuests": 1561,
		  "guestPercent": 0.916025,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31928be91f80c2b61a2f698ea238b4a6",
		  
		  "name": "Amber",
		  "createdDate": "2022-03-14 19:38:50",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 557,
		  "totalCountries": 27,
		  "totalStates": 93,
		  "totalEvents": 311,
		  "eventPercent": 0.919878,
		  "totalScheduleItems": 4008,
		  "schedulePercent": 0.913531,
		  "totalGuests": 1452,
		  "guestPercent": 0.905032,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31965e73282ec0df03a2056992ab9d8d",
		  
		  "name": "Gabe",
		  "createdDate": "2022-11-15 02:57:55",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 626,
		  "totalCountries": 28,
		  "totalStates": 62,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 1887,
		  "schedulePercent": 0.692543,
		  "totalGuests": 829,
		  "guestPercent": 0.81505,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31b06b1b364925b4b12ffa30b6ecfa40",
		  
		  "name": "Simon",
		  "createdDate": "2011-01-17 22:41:39",
		  "totalOrganizations": 10,
		  "totalTours": 28,
		  "totalDays": 590,
		  "totalCountries": 34,
		  "totalStates": 65,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 3990,
		  "schedulePercent": 0.912965,
		  "totalGuests": 478,
		  "guestPercent": 0.723255,
		  "mostGuestDate": "2025-03-09 00:00:00",
		  "mostGuestName": "Bord Gais Energy Theatre",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31b1243b9f48cf365924b261206812ec",
		  
		  "name": "Mark",
		  "createdDate": "2016-10-24 21:48:04",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 1921,
		  "totalCountries": 7,
		  "totalStates": 58,
		  "totalEvents": 266,
		  "eventPercent": 0.887579,
		  "totalScheduleItems": 4216,
		  "schedulePercent": 0.927017,
		  "totalGuests": 1314,
		  "guestPercent": 0.888599,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31bbdc3835afca5a54be60a7037538c1",
		  
		  "name": "Daniel",
		  "createdDate": "2013-01-11 19:09:27",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 334,
		  "totalCountries": 17,
		  "totalStates": 66,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 1922,
		  "schedulePercent": 0.698096,
		  "totalGuests": 390,
		  "guestPercent": 0.69005,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 91,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31cfbf2735fcf44d7bf483aeec9f30be",
		  
		  "name": "rob ",
		  "createdDate": "2023-08-29 11:59:41",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 1237,
		  "totalCountries": 27,
		  "totalStates": 63,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 3003,
		  "schedulePercent": 0.842362,
		  "totalGuests": 1324,
		  "guestPercent": 0.890866,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31dad93301c5dd5073e951448c7400ca",
		  
		  "name": "Rocco",
		  "createdDate": "2018-12-06 13:28:26",
		  "totalOrganizations": 6,
		  "totalTours": 40,
		  "totalDays": 229,
		  "totalCountries": 10,
		  "totalStates": 30,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1567,
		  "schedulePercent": 0.63384,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31ec6fe04b7294d2bf33ca0b1f12b9ce",
		  
		  "name": "Adrian",
		  "createdDate": "2017-07-20 23:56:41",
		  "totalOrganizations": 22,
		  "totalTours": 10,
		  "totalDays": 1475,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 1536,
		  "schedulePercent": 0.624547,
		  "totalGuests": 306,
		  "guestPercent": 0.652539,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "The Night Cat",
		  "mostGuestCity": "Fitzroy",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31ef5c11c6c5df67c216dcd3f911a2e0",
		  
		  "name": "Darian",
		  "createdDate": "2021-05-25 19:26:19",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 1714,
		  "totalCountries": 5,
		  "totalStates": 71,
		  "totalEvents": 316,
		  "eventPercent": 0.923164,
		  "totalScheduleItems": 5340,
		  "schedulePercent": 0.963849,
		  "totalGuests": 2891,
		  "guestPercent": 0.979714,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "31ff5ab92da38b853c204c8195f45223",
		  
		  "name": "Anna",
		  "createdDate": "2025-01-07 12:02:25",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 114,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 60,
		  "schedulePercent": 0.0679964,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "320311a34a403735d10ad998015fd62d",
		  
		  "name": "Rosanna",
		  "createdDate": "2014-11-30 14:37:19",
		  "totalOrganizations": 23,
		  "totalTours": 19,
		  "totalDays": 236,
		  "totalCountries": 39,
		  "totalStates": 51,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1313,
		  "schedulePercent": 0.574569,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-06-04 00:00:00",
		  "mostGuestName": "Zepp Shinjuku (TOKYO)",
		  "mostGuestCity": "",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32087c7b6ef268eadf55348ab9bc405c",
		  
		  "name": "Adrian",
		  "createdDate": "2020-03-11 13:59:57",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 369,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 1,
		  "eventPercent": 0.0074796,
		  "totalScheduleItems": 125,
		  "schedulePercent": 0.114914,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "320f8bdf9db71e85e8aa529f6e53bfdf",
		  
		  "name": "Neilsen",
		  "createdDate": "2016-06-13 02:13:44",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 719,
		  "totalCountries": 18,
		  "totalStates": 48,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 3718,
		  "schedulePercent": 0.897325,
		  "totalGuests": 3534,
		  "guestPercent": 0.989914,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 160,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "320f9206c69ccf7cb7ea6ee1cff23125",
		  
		  "name": "Nicole",
		  "createdDate": "2018-07-23 17:47:51",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 556,
		  "totalCountries": 8,
		  "totalStates": 54,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 1747,
		  "schedulePercent": 0.668178,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32151ede5456f6e879db261d1c838799",
		  
		  "name": "Ben",
		  "createdDate": "2014-07-23 08:40:38",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 1134,
		  "totalCountries": 37,
		  "totalStates": 84,
		  "totalEvents": 349,
		  "eventPercent": 0.94209,
		  "totalScheduleItems": 3862,
		  "schedulePercent": 0.905825,
		  "totalGuests": 1648,
		  "guestPercent": 0.923844,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3217c552ef23c11df9fa8a8253b39e95",
		  
		  "name": "Nastassia",
		  "createdDate": "2017-03-20 18:26:50",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 181,
		  "totalCountries": 7,
		  "totalStates": 31,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 958,
		  "schedulePercent": 0.478468,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "323b19183f3ddec033835b09d202464c",
		  
		  "name": "Martin",
		  "createdDate": "2017-11-27 12:34:30",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 512,
		  "totalCountries": 16,
		  "totalStates": 18,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1078,
		  "schedulePercent": 0.513146,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Maxwellâ€™s Concerts and Events",
		  "mostGuestCity": "Waterloo",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "324a3ab7b541131f60b0cdc1c059ab8f",
		  
		  "name": "Elvie",
		  "createdDate": "2013-07-10 14:39:27",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 831,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 2051,
		  "schedulePercent": 0.723595,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Mohegan Sun Arena",
		  "mostGuestCity": "Uncasville",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "324ab6bf75ad8c13a93f32d0b9babfa4",
		  
		  "name": "Jacob",
		  "createdDate": "2019-03-07 02:22:39",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 453,
		  "totalCountries": 18,
		  "totalStates": 58,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1052,
		  "schedulePercent": 0.505326,
		  "totalGuests": 414,
		  "guestPercent": 0.699343,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3253c78309dff3632b726487e4c110a1",
		  
		  "name": "Kara",
		  "createdDate": "2021-11-28 20:12:21",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 716,
		  "totalCountries": 2,
		  "totalStates": 39,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1128,
		  "schedulePercent": 0.527425,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Crystal Grand Music Theatre",
		  "mostGuestCity": "Wisconsin Dells",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3259080d00482366cea8def3682dedc4",
		  
		  "name": "Ryan",
		  "createdDate": "2023-11-29 00:35:15",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 39,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 273,
		  "schedulePercent": 0.201609,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Sandringham Estate",
		  "mostGuestCity": "Sandringham",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "325b3ceeed1aa23dfc313e7bddd463ae",
		  
		  "name": "Madison",
		  "createdDate": "2021-07-07 20:23:42",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1227,
		  "totalCountries": 12,
		  "totalStates": 51,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 2671,
		  "schedulePercent": 0.805417,
		  "totalGuests": 2044,
		  "guestPercent": 0.950023,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3266cd2a210f6c9087ca68cea679c932",
		  
		  "name": "Paul",
		  "createdDate": "2011-06-28 02:08:30",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 78,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 454,
		  "guestPercent": 0.714302,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "326bf3076e1ed9730ce5a8df75f17b04",
		  
		  "name": "Jenna",
		  "createdDate": "2017-03-24 21:13:00",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 817,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 2867,
		  "schedulePercent": 0.828989,
		  "totalGuests": 1600,
		  "guestPercent": 0.919991,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "326e514c6824b94352f839916ab58f22",
		  
		  "name": "Alison",
		  "createdDate": "2012-03-19 23:38:31",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 483,
		  "totalCountries": 9,
		  "totalStates": 68,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 3763,
		  "schedulePercent": 0.899819,
		  "totalGuests": 919,
		  "guestPercent": 0.834315,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Cadogan Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32756b49926bf6960b3fe5ce11662a61",
		  
		  "name": "Diana",
		  "createdDate": "2025-10-20 19:24:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 8,
		  "totalStates": 7,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 172,
		  "schedulePercent": 0.141772,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-11-20 00:00:00",
		  "mostGuestName": "St. Pancras Old Church",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "327e33b36aa1b1c6706b17a93064d9a2",
		  
		  "name": "Paul",
		  "createdDate": "2015-01-22 01:36:26",
		  "totalOrganizations": 30,
		  "totalTours": 41,
		  "totalDays": 732,
		  "totalCountries": 21,
		  "totalStates": 34,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 3123,
		  "schedulePercent": 0.853355,
		  "totalGuests": 318,
		  "guestPercent": 0.658772,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3280be06415b6a04b0f531e1db55a1d5",
		  
		  "name": "Soren",
		  "createdDate": "2012-12-26 22:08:29",
		  "totalOrganizations": 29,
		  "totalTours": 17,
		  "totalDays": 239,
		  "totalCountries": 6,
		  "totalStates": 2,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 1388,
		  "schedulePercent": 0.594402,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "Voxhall",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32902d3eafe5581a7fef7bdf60ffb58f",
		  
		  "name": "Luke",
		  "createdDate": "2023-12-15 15:58:23",
		  "totalOrganizations": 1,
		  "totalTours": 23,
		  "totalDays": 526,
		  "totalCountries": 21,
		  "totalStates": 20,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 3657,
		  "schedulePercent": 0.893132,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3298371a5070d92571e0202bdd4b52c7",
		  
		  "name": "Dale",
		  "createdDate": "2017-05-03 03:54:29",
		  "totalOrganizations": 31,
		  "totalTours": 22,
		  "totalDays": 301,
		  "totalCountries": 14,
		  "totalStates": 39,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 989,
		  "schedulePercent": 0.487874,
		  "totalGuests": 71,
		  "guestPercent": 0.486174,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Liberty Hall",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32998f1ee6f5bd3d1a0487e6750b50b7",
		  
		  "name": "Esteban",
		  "createdDate": "2023-11-08 12:35:49",
		  "totalOrganizations": 17,
		  "totalTours": 14,
		  "totalDays": 489,
		  "totalCountries": 25,
		  "totalStates": 32,
		  "totalEvents": 353,
		  "eventPercent": 0.94345,
		  "totalScheduleItems": 2858,
		  "schedulePercent": 0.828309,
		  "totalGuests": 778,
		  "guestPercent": 0.802131,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Store Vega",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3299cef3b18d23d9c4ef3ef04affc37b",
		  
		  "name": "Sydney",
		  "createdDate": "2022-05-27 10:26:01",
		  "totalOrganizations": 14,
		  "totalTours": 9,
		  "totalDays": 330,
		  "totalCountries": 26,
		  "totalStates": 38,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1968,
		  "schedulePercent": 0.707616,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "329d699c7a71f25e87fe039f7a8c53ba",
		  
		  "name": "Lucas",
		  "createdDate": "2017-07-19 18:03:15",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 195,
		  "totalCountries": 10,
		  "totalStates": 34,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1173,
		  "schedulePercent": 0.540685,
		  "totalGuests": 300,
		  "guestPercent": 0.649705,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Melkweg",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "329e38b7ee3f9eb165aa6d8e011558ce",
		  
		  "name": "Dave",
		  "createdDate": "2018-11-14 00:28:20",
		  "totalOrganizations": 27,
		  "totalTours": 6,
		  "totalDays": 260,
		  "totalCountries": 12,
		  "totalStates": 25,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 770,
		  "schedulePercent": 0.412285,
		  "totalGuests": 139,
		  "guestPercent": 0.551677,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32a229aba741ca57478c4b83e78c0dc4",
		  
		  "name": "Juan Pablo",
		  "createdDate": "2025-01-10 19:26:50",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 330,
		  "totalCountries": 8,
		  "totalStates": 47,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 705,
		  "schedulePercent": 0.388599,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32aa62062f0aacf6d570e2c9c42b54e4",
		  
		  "name": "Jared",
		  "createdDate": "2022-08-31 18:34:26",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 463,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 1644,
		  "schedulePercent": 0.648232,
		  "totalGuests": 88,
		  "guestPercent": 0.506686,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Thornton Winery",
		  "mostGuestCity": "Temecula",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32bacf08d2b22b4fd5411a35e38df90e",
		  
		  "name": "Seth",
		  "createdDate": "2025-01-06 19:34:27",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 600,
		  "totalCountries": 4,
		  "totalStates": 46,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 3211,
		  "schedulePercent": 0.860947,
		  "totalGuests": 1097,
		  "guestPercent": 0.863554,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32bb589b2962860009fb0a19cd686947",
		  
		  "name": "J.R",
		  "createdDate": "2025-04-01 22:00:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 270,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 798,
		  "schedulePercent": 0.421804,
		  "totalGuests": 136,
		  "guestPercent": 0.549524,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Buck's Backyard",
		  "mostGuestCity": "Buda",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32bdf49a32843d7625db484547fee397",
		  
		  "name": "Bales",
		  "createdDate": "2019-01-19 15:52:29",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 574,
		  "totalCountries": 16,
		  "totalStates": 55,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 2929,
		  "schedulePercent": 0.834202,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32cf3551fe148d898b0cf6388527a6b8",
		  
		  "name": "Tyler",
		  "createdDate": "2019-03-23 02:12:15",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 121,
		  "totalCountries": 10,
		  "totalStates": 24,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 673,
		  "schedulePercent": 0.37602,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32d318588b8198a58f6a130a1ca14850",
		  
		  "name": "Conor",
		  "createdDate": "2021-07-12 18:23:24",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 537,
		  "totalCountries": 14,
		  "totalStates": 40,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1496,
		  "schedulePercent": 0.616954,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Rawhide",
		  "mostGuestCity": "Chandler",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32f6797e06d747de6c8141fd2b0868f7",
		  
		  "name": "Montserrat",
		  "createdDate": "2023-03-12 14:45:09",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 100,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 559,
		  "schedulePercent": 0.336809,
		  "totalGuests": 420,
		  "guestPercent": 0.702289,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Palais Theatre",
		  "mostGuestCity": "St Kilda",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32fa1657d343b77314e4224c72e678f5",
		  
		  "name": "Sam",
		  "createdDate": "2019-02-13 00:22:19",
		  "totalOrganizations": 16,
		  "totalTours": 8,
		  "totalDays": 1263,
		  "totalCountries": 12,
		  "totalStates": 31,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 2143,
		  "schedulePercent": 0.738667,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "32fb56ca996d57a94fec57f996ff347a",
		  
		  "name": "Sydney",
		  "createdDate": "2021-06-03 20:11:32",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 479,
		  "totalCountries": 10,
		  "totalStates": 36,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1580,
		  "schedulePercent": 0.636673,
		  "totalGuests": 375,
		  "guestPercent": 0.683477,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Bethel Woods Center",
		  "mostGuestCity": "Bethel",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3311739417bf51896adabfe4a3568ceb",
		  
		  "name": "Anna",
		  "createdDate": "2022-04-14 16:05:31",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 271,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 386,
		  "schedulePercent": 0.261673,
		  "totalGuests": 501,
		  "guestPercent": 0.731074,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33161652ec249b6dee07d4c57402c8c0",
		  
		  "name": "Henry (TG)",
		  "createdDate": "2025-06-21 00:23:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 14,
		  "totalStates": 8,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 173,
		  "schedulePercent": 0.142452,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "The Lighthouse Theatre",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "331dd036bbb68200a6f937896fb976bd",
		  
		  "name": "Tom",
		  "createdDate": "2019-08-21 13:35:10",
		  "totalOrganizations": 12,
		  "totalTours": 18,
		  "totalDays": 514,
		  "totalCountries": 20,
		  "totalStates": 38,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2646,
		  "schedulePercent": 0.802584,
		  "totalGuests": 1073,
		  "guestPercent": 0.858681,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33309595945866fe85bad26410ec7389",
		  
		  "name": "Lou",
		  "createdDate": "2023-04-05 20:41:32",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 587,
		  "totalCountries": 20,
		  "totalStates": 68,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1901,
		  "schedulePercent": 0.69515,
		  "totalGuests": 1820,
		  "guestPercent": 0.93427,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3338526d12c1957f6499baaf9e50181b",
		  
		  "name": "Steven",
		  "createdDate": "2018-09-05 18:33:08",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 212,
		  "totalCountries": 9,
		  "totalStates": 44,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1144,
		  "schedulePercent": 0.532638,
		  "totalGuests": 728,
		  "guestPercent": 0.792498,
		  "mostGuestDate": "2025-08-04 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3347245b193210ca184eb09a950600f2",
		  
		  "name": "Andrew",
		  "createdDate": "2013-01-19 19:46:01",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 486,
		  "totalCountries": 5,
		  "totalStates": 30,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2119,
		  "schedulePercent": 0.735494,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Yakov's Theatre",
		  "mostGuestCity": "Branson",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "334d46ec34574a6027cc9a0410c8f5f3",
		  
		  "name": "Peter",
		  "createdDate": "2019-06-28 20:13:19",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 504,
		  "totalCountries": 9,
		  "totalStates": 31,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 772,
		  "schedulePercent": 0.413191,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-08-20 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "334e4095dbaa108d4d4ae540468991da",
		  
		  "name": "Luke",
		  "createdDate": "2010-04-20 01:21:14",
		  "totalOrganizations": 18,
		  "totalTours": 23,
		  "totalDays": 328,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1991,
		  "schedulePercent": 0.712262,
		  "totalGuests": 209,
		  "guestPercent": 0.601201,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Church In The Son",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3352c2296ec733fb08274d970ab8dc43",
		  
		  "name": "Elizabeth",
		  "createdDate": "2022-01-17 15:05:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 427,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 398,
		  "schedulePercent": 0.268586,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-11-30 00:00:00",
		  "mostGuestName": "Plymouth Pavilions",
		  "mostGuestCity": "Plymouth",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3353a27339c7b6a659df95130831b817",
		  
		  "name": "Britton",
		  "createdDate": "2010-12-15 18:34:56",
		  "totalOrganizations": 19,
		  "totalTours": 7,
		  "totalDays": 831,
		  "totalCountries": 34,
		  "totalStates": 43,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 3252,
		  "schedulePercent": 0.864234,
		  "totalGuests": 280,
		  "guestPercent": 0.639393,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Montauk Lighthouse",
		  "mostGuestCity": "Montauk",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "335403f6954b96ea30f30b19f2738ae6",
		  
		  "name": "Yasmine",
		  "createdDate": "2019-03-14 17:39:37",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 719,
		  "totalCountries": 4,
		  "totalStates": 44,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 2059,
		  "schedulePercent": 0.725861,
		  "totalGuests": 756,
		  "guestPercent": 0.797597,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3354aabe8eebc29c95a8fc4a52aaf775",
		  
		  "name": "Mei",
		  "createdDate": "2023-07-27 17:13:53",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 175,
		  "totalCountries": 8,
		  "totalStates": 43,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1062,
		  "schedulePercent": 0.5068,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-01-29 00:00:00",
		  "mostGuestName": "The Corner Hotel",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3357f55bc83c1d6d8650b3829e3c047f",
		  
		  "name": "Dermot",
		  "createdDate": "2011-08-22 19:37:20",
		  "totalOrganizations": 12,
		  "totalTours": 14,
		  "totalDays": 492,
		  "totalCountries": 24,
		  "totalStates": 64,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 2684,
		  "schedulePercent": 0.80723,
		  "totalGuests": 1317,
		  "guestPercent": 0.889053,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "336504b059ffe6b2f7444d0b27798f68",
		  
		  "name": "Patrick",
		  "createdDate": "2019-09-13 14:53:08",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 416,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 4846,
		  "schedulePercent": 0.948889,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33722c343d00576edbb95381578c0c67",
		  
		  "name": "J.D.",
		  "createdDate": "2019-05-23 04:30:21",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 93,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 282,
		  "schedulePercent": 0.206936,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Amerant Bank Arena",
		  "mostGuestCity": "Sunrise",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3373f912f3e0a52bcd28244638dbe4b1",
		  
		  "name": "Daniel",
		  "createdDate": "2019-05-29 19:40:47",
		  "totalOrganizations": 20,
		  "totalTours": 12,
		  "totalDays": 751,
		  "totalCountries": 23,
		  "totalStates": 55,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 3228,
		  "schedulePercent": 0.861967,
		  "totalGuests": 181,
		  "guestPercent": 0.580802,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "337ce9927dd6e19d1a3c6885c1e1c21c",
		  
		  "name": "AARON",
		  "createdDate": "2018-01-09 06:20:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 316,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 278,
		  "schedulePercent": 0.204216,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Tradex",
		  "mostGuestCity": "Abbotsford",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "337e2cd6d29892087fa0f9c3fd94a7a6",
		  
		  "name": "Lotte",
		  "createdDate": "2010-05-05 18:57:29",
		  "totalOrganizations": 21,
		  "totalTours": 14,
		  "totalDays": 855,
		  "totalCountries": 32,
		  "totalStates": 53,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2317,
		  "schedulePercent": 0.764279,
		  "totalGuests": 225,
		  "guestPercent": 0.610041,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Avant Gardner - The Brooklyn Mirage",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3389f94a70d1671174d1ff34585a8b2a",
		  
		  "name": "Noemie",
		  "createdDate": "2024-09-27 09:59:16",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 491,
		  "totalCountries": 4,
		  "totalStates": 14,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 831,
		  "schedulePercent": 0.43495,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Transbordeur",
		  "mostGuestCity": "Villeurbanne",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3398b7d03cf9cb28c9405a613d795e28",
		  
		  "name": "Brent",
		  "createdDate": "2018-09-13 03:53:52",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 352,
		  "totalCountries": 6,
		  "totalStates": 53,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 2752,
		  "schedulePercent": 0.816636,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33a498a2c6e02a669576606656a02adf",
		  
		  "name": "Renata ",
		  "createdDate": "2025-07-22 13:35:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 427,
		  "schedulePercent": 0.280938,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33a4d662e9661f060aca9d271ff51fb3",
		  
		  "name": "Claudine",
		  "createdDate": "2018-03-19 05:11:08",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 657,
		  "totalCountries": 37,
		  "totalStates": 91,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 4929,
		  "schedulePercent": 0.951949,
		  "totalGuests": 1113,
		  "guestPercent": 0.866274,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 160,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33b23e2117014c469705c45fa7439c5a",
		  
		  "name": "Julian",
		  "createdDate": "2019-09-18 13:50:53",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 356,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1022,
		  "schedulePercent": 0.497054,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Openluchttheater Caprera",
		  "mostGuestCity": "Bloemendaal",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33ba0ce9176b784d95dc0127969bb8d2",
		  
		  "name": "Jessy",
		  "createdDate": "2025-01-08 11:21:09",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 306,
		  "totalCountries": 35,
		  "totalStates": 67,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2502,
		  "schedulePercent": 0.787058,
		  "totalGuests": 879,
		  "guestPercent": 0.824569,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33c3fea94cc0d7c9cdc63ff66e631476",
		  
		  "name": "David",
		  "createdDate": "2011-09-21 16:19:45",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 242,
		  "totalCountries": 12,
		  "totalStates": 43,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1095,
		  "schedulePercent": 0.518699,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33d20714a87cbe7f2b1abdeb5c2c70a5",
		  
		  "name": "Luke",
		  "createdDate": "2014-07-11 19:12:40",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 473,
		  "totalCountries": 5,
		  "totalStates": 27,
		  "totalEvents": 278,
		  "eventPercent": 0.896872,
		  "totalScheduleItems": 1780,
		  "schedulePercent": 0.672597,
		  "totalGuests": 812,
		  "guestPercent": 0.811423,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Nissan Stadium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 195,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33ecc12a463d1248be2dbe84c131bfbe",
		  
		  "name": "Bryce",
		  "createdDate": "2024-02-20 15:22:13",
		  "totalOrganizations": 1,
		  "totalTours": 32,
		  "totalDays": 767,
		  "totalCountries": 23,
		  "totalStates": 25,
		  "totalEvents": 487,
		  "eventPercent": 0.976315,
		  "totalScheduleItems": 5374,
		  "schedulePercent": 0.964982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33f0e409a83ca6fd248173abe8c972fb",
		  
		  "name": "Lewis",
		  "createdDate": "2015-10-22 18:21:46",
		  "totalOrganizations": 12,
		  "totalTours": 20,
		  "totalDays": 1094,
		  "totalCountries": 30,
		  "totalStates": 74,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 2829,
		  "schedulePercent": 0.825589,
		  "totalGuests": 449,
		  "guestPercent": 0.712375,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Fox Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33fbc1b05060ee0cdc0c05d84a2a8e1a",
		  
		  "name": "Rudy",
		  "createdDate": "2019-06-27 00:11:22",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 432,
		  "totalCountries": 27,
		  "totalStates": 35,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1180,
		  "schedulePercent": 0.542384,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Olympia de ParÃ\u00ADs",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "33fcc9f501dcebe56e80c8d3979d5755",
		  
		  "name": "Tiago",
		  "createdDate": "2017-02-17 00:11:26",
		  "totalOrganizations": 19,
		  "totalTours": 7,
		  "totalDays": 147,
		  "totalCountries": 14,
		  "totalStates": 8,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 135,
		  "schedulePercent": 0.121827,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "340bd05fec4abc03f64bced70cfc5ffb",
		  
		  "name": "Maison",
		  "createdDate": "2025-06-24 13:43:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 77,
		  "totalCountries": 7,
		  "totalStates": 2,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 159,
		  "schedulePercent": 0.134519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34134d49c20df5471ef997701fc6b40b",
		  
		  "name": "Ryan",
		  "createdDate": "2014-09-21 21:13:05",
		  "totalOrganizations": 23,
		  "totalTours": 23,
		  "totalDays": 1187,
		  "totalCountries": 18,
		  "totalStates": 78,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 4058,
		  "schedulePercent": 0.916818,
		  "totalGuests": 1759,
		  "guestPercent": 0.930757,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3417d26cfeb9204bfccd5fd85d133df4",
		  
		  "name": "Yvan",
		  "createdDate": "2024-03-06 19:17:26",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 103,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 482,
		  "schedulePercent": 0.302811,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "341815a2641c9e0048e60ec205e4180c",
		  
		  "name": "Benjamin ",
		  "createdDate": "2023-11-16 00:23:22",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 663,
		  "totalCountries": 24,
		  "totalStates": 32,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1508,
		  "schedulePercent": 0.61956,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "House of Blues Houston",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34182e19d073aadb133daba26a1d6ab3",
		  
		  "name": "Marjorie",
		  "createdDate": "2019-06-07 21:51:58",
		  "totalOrganizations": 39,
		  "totalTours": 9,
		  "totalDays": 375,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 341,
		  "eventPercent": 0.936877,
		  "totalScheduleItems": 2350,
		  "schedulePercent": 0.768246,
		  "totalGuests": 5721,
		  "guestPercent": 0.998073,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 675,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "342810b17802e1a8a59cf38663c28bb5",
		  
		  "name": "Todd",
		  "createdDate": "2011-06-02 15:31:35",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 470,
		  "totalCountries": 10,
		  "totalStates": 38,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1409,
		  "schedulePercent": 0.599955,
		  "totalGuests": 108,
		  "guestPercent": 0.527199,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "AT&T Stadium",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "342dd44f5c107ccb7ec577cb422d61eb",
		  
		  "name": "Joakim",
		  "createdDate": "2023-12-31 21:14:41",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 147,
		  "schedulePercent": 0.128853,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "BÃ¥thuset Scene",
		  "mostGuestCity": "KrÃ¥kerÃ¸y",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3433b7fb2a5a4286a285cf2f074d91fe",
		  
		  "name": "Adam ",
		  "createdDate": "2023-05-31 15:32:58",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 155,
		  "totalCountries": 5,
		  "totalStates": 45,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 850,
		  "schedulePercent": 0.440163,
		  "totalGuests": 227,
		  "guestPercent": 0.611401,
		  "mostGuestDate": "2025-08-20 00:00:00",
		  "mostGuestName": "170 Russell",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3436827354757f033434356584836fe4",
		  
		  "name": "Karen",
		  "createdDate": "2014-04-10 19:39:35",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 463,
		  "totalCountries": 21,
		  "totalStates": 60,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2307,
		  "schedulePercent": 0.762579,
		  "totalGuests": 879,
		  "guestPercent": 0.824569,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "347bf240cbba43cd9bfa67198ae60b5c",
		  
		  "name": "Juliana",
		  "createdDate": "2020-04-12 19:57:29",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 9,
		  "totalStates": 28,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 1895,
		  "schedulePercent": 0.693336,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34874b3d825c40dfe9e8d527aceeb427",
		  
		  "name": "Garren",
		  "createdDate": "2019-10-30 21:31:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 912,
		  "schedulePercent": 0.462375,
		  "totalGuests": 673,
		  "guestPercent": 0.779238,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "Stern Grove Festival",
		  "mostGuestCity": "",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3489d2290f57100785720f1ed6af8188",
		  
		  "name": "John",
		  "createdDate": "2016-10-18 15:37:25",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 427,
		  "totalCountries": 19,
		  "totalStates": 59,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 1278,
		  "schedulePercent": 0.56709,
		  "totalGuests": 805,
		  "guestPercent": 0.80893,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 125,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "349a5c3152a5a2f4d9ec3927d6d8b39e",
		  
		  "name": "Abenteuerland Music ",
		  "createdDate": "2022-07-12 20:55:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 180,
		  "schedulePercent": 0.146419,
		  "totalGuests": 82,
		  "guestPercent": 0.499207,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "VELTINS-Arena",
		  "mostGuestCity": "Gelsenkirchen",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34a4b689300034ac713a6d4c09beb468",
		  
		  "name": "Stephen",
		  "createdDate": "2014-01-21 23:40:46",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 171,
		  "totalCountries": 16,
		  "totalStates": 25,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 944,
		  "schedulePercent": 0.473595,
		  "totalGuests": 353,
		  "guestPercent": 0.676337,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34a5175340f1e70dac9b811f65b83173",
		  
		  "name": "Sean",
		  "createdDate": "2023-10-19 19:42:04",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 969,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2055,
		  "schedulePercent": 0.724388,
		  "totalGuests": 829,
		  "guestPercent": 0.81505,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Levitate Music and Arts Festival",
		  "mostGuestCity": "Marshfield",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34a6c84d5b2efe3ef4a7b859cb1fdac6",
		  
		  "name": "Joe",
		  "createdDate": "2023-09-05 18:30:19",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 218,
		  "totalCountries": 6,
		  "totalStates": 40,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1006,
		  "schedulePercent": 0.49184,
		  "totalGuests": 251,
		  "guestPercent": 0.625567,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "O2 Academy Islington",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34a838908c8eee8863399128bedacd0e",
		  
		  "name": "Paul",
		  "createdDate": "2022-04-15 20:37:50",
		  "totalOrganizations": 10,
		  "totalTours": 22,
		  "totalDays": 485,
		  "totalCountries": 30,
		  "totalStates": 74,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 2210,
		  "schedulePercent": 0.749093,
		  "totalGuests": 680,
		  "guestPercent": 0.781165,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "BRIC",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34b504b8284c6d67a9cdd045da59259b",
		  
		  "name": "Ndieri",
		  "createdDate": "2022-04-29 13:57:30",
		  "totalOrganizations": 14,
		  "totalTours": 4,
		  "totalDays": 337,
		  "totalCountries": 10,
		  "totalStates": 25,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1384,
		  "schedulePercent": 0.593722,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34b8b0b771c15ac0bbc67c5a24511efb",
		  
		  "name": "Anh",
		  "createdDate": "2024-06-06 02:12:42",
		  "totalOrganizations": 6,
		  "totalTours": 21,
		  "totalDays": 532,
		  "totalCountries": 29,
		  "totalStates": 72,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2747,
		  "schedulePercent": 0.81607,
		  "totalGuests": 1991,
		  "guestPercent": 0.946623,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34c180f959afc33b26aa3fd0bf2cfea7",
		  
		  "name": "Jesse",
		  "createdDate": "2024-10-04 01:44:51",
		  "totalOrganizations": 3,
		  "totalTours": 19,
		  "totalDays": 471,
		  "totalCountries": 17,
		  "totalStates": 65,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 2383,
		  "schedulePercent": 0.773005,
		  "totalGuests": 1053,
		  "guestPercent": 0.855168,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34d41b11e43ae3563a82c6bb22545263",
		  
		  "name": "Marte Celina",
		  "createdDate": "2017-10-03 09:17:06",
		  "totalOrganizations": 15,
		  "totalTours": 1,
		  "totalDays": 47,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34d9facdc51d1377eba806e97b462c06",
		  
		  "name": "Evan",
		  "createdDate": "2012-07-19 18:38:09",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 386,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 714,
		  "schedulePercent": 0.391772,
		  "totalGuests": 373,
		  "guestPercent": 0.682457,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "The Intersection",
		  "mostGuestCity": "Grand Rapids",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34e6eca95ec0eb0be4f3604ea421314c",
		  
		  "name": "Steven",
		  "createdDate": "2014-08-25 23:16:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 207,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1210,
		  "schedulePercent": 0.549411,
		  "totalGuests": 803,
		  "guestPercent": 0.808137,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34ec97e77c50511c5b6ec60804b624fc",
		  
		  "name": "George",
		  "createdDate": "2015-06-18 09:58:34",
		  "totalOrganizations": 10,
		  "totalTours": 21,
		  "totalDays": 557,
		  "totalCountries": 22,
		  "totalStates": 68,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 2470,
		  "schedulePercent": 0.783772,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Belding Theater",
		  "mostGuestCity": "Hartford",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34ed80af1b35545d32fea467700531bb",
		  
		  "name": "Pantea",
		  "createdDate": "2016-12-13 12:20:50",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 205,
		  "totalCountries": 16,
		  "totalStates": 31,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 904,
		  "schedulePercent": 0.459882,
		  "totalGuests": 371,
		  "guestPercent": 0.68155,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Sofiero Slott och SlottstrÃ¤dgÃ¥rd",
		  "mostGuestCity": "Helsingborg",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "34ed9ff075c9c6f37902e540140cc314",
		  
		  "name": "John",
		  "createdDate": "2020-03-04 20:58:53",
		  "totalOrganizations": 9,
		  "totalTours": 32,
		  "totalDays": 380,
		  "totalCountries": 18,
		  "totalStates": 33,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1150,
		  "schedulePercent": 0.535018,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35079e4dd5d2c98f21f0ec6b1f7cc4c6",
		  
		  "name": "Chelsea",
		  "createdDate": "2024-10-03 10:55:10",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 37,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 158,
		  "schedulePercent": 0.134066,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3510861ec194ed776f52308c45664ddc",
		  
		  "name": "Adam",
		  "createdDate": "2019-10-09 14:27:41",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 221,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 822,
		  "schedulePercent": 0.43189,
		  "totalGuests": 290,
		  "guestPercent": 0.644266,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Centennial Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35114f7079f0c6e7d5ec22bf8fc4292e",
		  
		  "name": "Jarrod",
		  "createdDate": "2020-01-06 00:59:16",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 1146,
		  "totalCountries": 15,
		  "totalStates": 70,
		  "totalEvents": 248,
		  "eventPercent": 0.868654,
		  "totalScheduleItems": 4029,
		  "schedulePercent": 0.915231,
		  "totalGuests": 1019,
		  "guestPercent": 0.849955,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Majestic Ventura Theater",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3520030822f86b8af7991913b8267b23",
		  
		  "name": "Sierra",
		  "createdDate": "2025-03-17 14:11:44",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 197,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Lost Lake Lounge",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35228ef556a3e4ad36473fe730e63c0b",
		  
		  "name": "Josh",
		  "createdDate": "2015-11-11 05:32:19",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 18,
		  "totalStates": 45,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 434,
		  "schedulePercent": 0.283205,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35240d63b812768db02af9d334324789",
		  
		  "name": "Ryan",
		  "createdDate": "2015-05-25 17:58:23",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 95,
		  "totalCountries": 10,
		  "totalStates": 33,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3548397fe57e268ca49f644d5e6526cd",
		  
		  "name": "Katharine",
		  "createdDate": "2025-03-30 14:05:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 9,
		  "totalStates": 6,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 119,
		  "schedulePercent": 0.110041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "356c2eb4af5e0502dc32590914a35a4c",
		  
		  "name": "Carl",
		  "createdDate": "2015-01-21 23:56:29",
		  "totalOrganizations": 4,
		  "totalTours": 14,
		  "totalDays": 231,
		  "totalCountries": 12,
		  "totalStates": 21,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1272,
		  "schedulePercent": 0.565956,
		  "totalGuests": 612,
		  "guestPercent": 0.762239,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3579eebc65bd86d3d31e5133952a8be3",
		  
		  "name": "Jonathan",
		  "createdDate": "2014-04-21 23:43:01",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 433,
		  "totalCountries": 33,
		  "totalStates": 70,
		  "totalEvents": 250,
		  "eventPercent": 0.87092,
		  "totalScheduleItems": 2766,
		  "schedulePercent": 0.817656,
		  "totalGuests": 2294,
		  "guestPercent": 0.961695,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "357e574b67bb88672833531b259434c0",
		  
		  "name": "Ivone",
		  "createdDate": "2023-03-11 05:23:50",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 374,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3583305d678ed313c61447439e4a6856",
		  
		  "name": "Josefine",
		  "createdDate": "2025-02-11 10:17:58",
		  "totalOrganizations": 92,
		  "totalTours": 108,
		  "totalDays": 2015,
		  "totalCountries": 34,
		  "totalStates": 85,
		  "totalEvents": 1211,
		  "eventPercent": 0.997393,
		  "totalScheduleItems": 9698,
		  "schedulePercent": 0.99626,
		  "totalGuests": 2182,
		  "guestPercent": 0.957162,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3588a9bd0184b183ca2c0ff116458098",
		  
		  "name": "Jaymi",
		  "createdDate": "2022-07-07 01:48:38",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 102,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 212,
		  "schedulePercent": 0.166931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35969cf390688cc6e6ec6bda74a516fc",
		  
		  "name": "Mathilde",
		  "createdDate": "2021-11-01 17:34:07",
		  "totalOrganizations": 16,
		  "totalTours": 12,
		  "totalDays": 942,
		  "totalCountries": 11,
		  "totalStates": 27,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 3599,
		  "schedulePercent": 0.889279,
		  "totalGuests": 567,
		  "guestPercent": 0.748413,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Le Bikini",
		  "mostGuestCity": "Ramonville-Saint-Agne",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35ad1a60e1c9b35d7952e21af5e85243",
		  
		  "name": "Fielding",
		  "createdDate": "2009-12-22 20:42:56",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 1790,
		  "totalCountries": 7,
		  "totalStates": 53,
		  "totalEvents": 329,
		  "eventPercent": 0.932684,
		  "totalScheduleItems": 4139,
		  "schedulePercent": 0.921464,
		  "totalGuests": 1265,
		  "guestPercent": 0.882026,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35b158f6cc0800ef7787a031ab3e6622",
		  
		  "name": "Roman",
		  "createdDate": "2021-07-25 16:55:49",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 193,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 7,
		  "schedulePercent": 0.0172257,
		  "totalGuests": 641,
		  "guestPercent": 0.769379,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "City Winery New York City",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35b63a069d19a219ce267e2f07f56a40",
		  
		  "name": "Pablo",
		  "createdDate": "2025-04-30 19:30:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 153,
		  "totalCountries": 15,
		  "totalStates": 13,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 229,
		  "schedulePercent": 0.177131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35b9dd90bddd889e499cd678b8453f59",
		  
		  "name": "Claire",
		  "createdDate": "2022-04-13 22:06:16",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1242,
		  "totalCountries": 15,
		  "totalStates": 43,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2718,
		  "schedulePercent": 0.811537,
		  "totalGuests": 318,
		  "guestPercent": 0.658772,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Sphere",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35bb94b4787726ba5f99559f9643280f",
		  
		  "name": "Tara",
		  "createdDate": "2018-01-03 23:42:34",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 1294,
		  "totalCountries": 4,
		  "totalStates": 54,
		  "totalEvents": 471,
		  "eventPercent": 0.973935,
		  "totalScheduleItems": 5570,
		  "schedulePercent": 0.969062,
		  "totalGuests": 3052,
		  "guestPercent": 0.983001,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 157,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35be2af91cdbd64b671fc753fc24b530",
		  
		  "name": "Brian",
		  "createdDate": "2025-01-07 04:28:02",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 132,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 333,
		  "schedulePercent": 0.233454,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "PBR Baltimore: A Coors Banquet Bar",
		  "mostGuestCity": "Baltimore",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35c11af3e1440d9eee34fc77603d4c69",
		  
		  "name": "April ",
		  "createdDate": "2022-06-25 21:58:50",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 574,
		  "totalCountries": 29,
		  "totalStates": 46,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2060,
		  "schedulePercent": 0.726088,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Stern Grove Festival",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35c11f69614d9079579e77fbe10d65a6",
		  
		  "name": "Will",
		  "createdDate": "2011-08-09 21:52:13",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 677,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1402,
		  "schedulePercent": 0.598141,
		  "totalGuests": 269,
		  "guestPercent": 0.63418,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35d22fe45b821686ef61c56cd306cda8",
		  
		  "name": "Johnny ",
		  "createdDate": "2012-12-17 18:59:27",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 1127,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1840,
		  "schedulePercent": 0.683137,
		  "totalGuests": 1619,
		  "guestPercent": 0.921464,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35d51d329ab5ba6846a85bc4838e2a74",
		  
		  "name": "Laura Jean",
		  "createdDate": "2017-02-23 17:44:28",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 336,
		  "totalCountries": 25,
		  "totalStates": 46,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 1898,
		  "schedulePercent": 0.694016,
		  "totalGuests": 932,
		  "guestPercent": 0.836129,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "House of Blues Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35e68c35e41b731bd1eb9bd053a565d5",
		  
		  "name": "Steven",
		  "createdDate": "2022-10-25 19:31:28",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 161,
		  "schedulePercent": 0.136333,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Mahall's",
		  "mostGuestCity": "Lakewood",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35e7410cb0c3e5fb8ae347ef5ebd226c",
		  
		  "name": "Julian",
		  "createdDate": "2024-06-09 05:50:02",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 881,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 806,
		  "schedulePercent": 0.424751,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Dallas Bull",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "35fa7ccfd17914c23163a1b258fe8f5b",
		  
		  "name": "Alison",
		  "createdDate": "2023-05-14 16:14:33",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 423,
		  "totalCountries": 20,
		  "totalStates": 58,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 2049,
		  "schedulePercent": 0.723028,
		  "totalGuests": 520,
		  "guestPercent": 0.736061,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3606438e05da3f240162728d93205f64",
		  
		  "name": "Katy",
		  "createdDate": "2013-01-14 17:00:00",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 1472,
		  "totalCountries": 12,
		  "totalStates": 71,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 5323,
		  "schedulePercent": 0.963169,
		  "totalGuests": 1096,
		  "guestPercent": 0.863327,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 177,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3606bb8a8fb38ec6216c90f61aa7fa34",
		  
		  "name": "James",
		  "createdDate": "2018-08-25 15:49:29",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 427,
		  "totalCountries": 16,
		  "totalStates": 65,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2338,
		  "schedulePercent": 0.766546,
		  "totalGuests": 459,
		  "guestPercent": 0.715662,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3623b937520ba54b80d7d07662484371",
		  
		  "name": "Jessica",
		  "createdDate": "2018-02-20 20:10:19",
		  "totalOrganizations": 16,
		  "totalTours": 19,
		  "totalDays": 914,
		  "totalCountries": 35,
		  "totalStates": 109,
		  "totalEvents": 310,
		  "eventPercent": 0.919198,
		  "totalScheduleItems": 3820,
		  "schedulePercent": 0.903672,
		  "totalGuests": 1503,
		  "guestPercent": 0.909451,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36257eb2f11fce61805877ff9200d1b5",
		  
		  "name": "Ian",
		  "createdDate": "2017-11-07 05:36:23",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 133,
		  "totalCountries": 15,
		  "totalStates": 31,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 547,
		  "schedulePercent": 0.332956,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "3Ten Austin City Limits",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3627140e9048330f3508923ccfe66e6b",
		  
		  "name": "Salwa",
		  "createdDate": "2025-07-25 14:58:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 159,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 919,
		  "schedulePercent": 0.464415,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "362d59d59e3b7b6a1bc178d2a8ec2750",
		  
		  "name": "Justin",
		  "createdDate": "2016-09-29 16:32:09",
		  "totalOrganizations": 13,
		  "totalTours": 17,
		  "totalDays": 806,
		  "totalCountries": 8,
		  "totalStates": 63,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 4536,
		  "schedulePercent": 0.93903,
		  "totalGuests": 2220,
		  "guestPercent": 0.958749,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "364dc909133807020cc285ec763732ab",
		  
		  "name": "Kyle",
		  "createdDate": "2012-04-21 10:37:01",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 505,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2586,
		  "schedulePercent": 0.796464,
		  "totalGuests": 643,
		  "guestPercent": 0.769832,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "AT&T Stadium",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3656c34a27bcc2c5131e887f195151d4",
		  
		  "name": "Quinn",
		  "createdDate": "2025-07-01 12:22:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 46,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36636187dd8bd1d84655b0ddb2c66d9e",
		  
		  "name": "Fernando",
		  "createdDate": "2012-06-14 22:01:46",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 547,
		  "totalCountries": 4,
		  "totalStates": 53,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 3399,
		  "schedulePercent": 0.875227,
		  "totalGuests": 2418,
		  "guestPercent": 0.965549,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "366710054f27bc3e6650cf558fd01fdf",
		  
		  "name": "Zo&#235;",
		  "createdDate": "2024-07-27 22:59:09",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 222,
		  "totalCountries": 11,
		  "totalStates": 40,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1694,
		  "schedulePercent": 0.657525,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "366896db9ccef24960b8993baa7be894",
		  
		  "name": "Alicia",
		  "createdDate": "2017-10-26 01:24:53",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 275,
		  "schedulePercent": 0.202403,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3671e41a8bd7887b5730960d41074512",
		  
		  "name": "William",
		  "createdDate": "2022-03-01 19:48:13",
		  "totalOrganizations": 21,
		  "totalTours": 39,
		  "totalDays": 875,
		  "totalCountries": 17,
		  "totalStates": 58,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2499,
		  "schedulePercent": 0.786605,
		  "totalGuests": 89,
		  "guestPercent": 0.50714,
		  "mostGuestDate": "2025-11-12 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36789acf3a785a7281b4366fa622cef3",
		  
		  "name": "Elise",
		  "createdDate": "2022-11-25 21:40:42",
		  "totalOrganizations": 25,
		  "totalTours": 58,
		  "totalDays": 1357,
		  "totalCountries": 36,
		  "totalStates": 72,
		  "totalEvents": 446,
		  "eventPercent": 0.969968,
		  "totalScheduleItems": 4859,
		  "schedulePercent": 0.949683,
		  "totalGuests": 2156,
		  "guestPercent": 0.956029,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "367f32de1953f7bf994b0995aa7377c4",
		  
		  "name": "Sofie",
		  "createdDate": "2024-01-02 08:23:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 29,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 347,
		  "schedulePercent": 0.2415,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "368845647fb005bfecabf5bf6a8cafd0",
		  
		  "name": "Bree",
		  "createdDate": "2024-11-09 00:58:42",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 53,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3691535668e5d11b1bb3804e57bb3919",
		  
		  "name": "Max",
		  "createdDate": "2024-07-17 19:28:15",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36a2619544243b5a655a861053115587",
		  
		  "name": "Rebeka",
		  "createdDate": "2022-05-16 13:55:27",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 2084,
		  "totalCountries": 41,
		  "totalStates": 79,
		  "totalEvents": 327,
		  "eventPercent": 0.931324,
		  "totalScheduleItems": 6280,
		  "schedulePercent": 0.979148,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36a327a9b8001c218b41a62cbab2b763",
		  
		  "name": "Zack",
		  "createdDate": "2012-10-16 19:21:35",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 835,
		  "totalCountries": 13,
		  "totalStates": 58,
		  "totalEvents": 315,
		  "eventPercent": 0.922484,
		  "totalScheduleItems": 5104,
		  "schedulePercent": 0.957276,
		  "totalGuests": 2708,
		  "guestPercent": 0.976428,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36a5165da534c6e01ad42abae342d8de",
		  
		  "name": "Matt",
		  "createdDate": "2012-03-27 00:23:16",
		  "totalOrganizations": 24,
		  "totalTours": 16,
		  "totalDays": 1141,
		  "totalCountries": 34,
		  "totalStates": 76,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 4037,
		  "schedulePercent": 0.915571,
		  "totalGuests": 1253,
		  "guestPercent": 0.880553,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36a51f29621922c09b7b2e429e5958bb",
		  
		  "name": "Sebastien",
		  "createdDate": "2024-06-20 15:44:12",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 701,
		  "totalCountries": 15,
		  "totalStates": 34,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 960,
		  "schedulePercent": 0.479148,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-03-11 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36a5d0be8a31759f8444c3c88269a516",
		  
		  "name": "Randy",
		  "createdDate": "2024-09-10 17:37:45",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 237,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 1403,
		  "schedulePercent": 0.598368,
		  "totalGuests": 976,
		  "guestPercent": 0.842248,
		  "mostGuestDate": "2025-11-22 00:00:00",
		  "mostGuestName": "Simmons Bank Arena",
		  "mostGuestCity": "North Little Rock",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36af7fba20b067333504be77b555c647",
		  
		  "name": "Kaika",
		  "createdDate": "2022-09-26 08:12:22",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 80,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 533,
		  "schedulePercent": 0.328196,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Det Kongelige Teater",
		  "mostGuestCity": "KÃ¸benhavn K",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36b0e087652fb49b555811eb4adb5813",
		  
		  "name": "Frankie",
		  "createdDate": "2022-03-07 18:45:17",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 562,
		  "totalCountries": 15,
		  "totalStates": 44,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 2013,
		  "schedulePercent": 0.715662,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36cd7243a790b288af9d5ef7883eb322",
		  
		  "name": "ximena",
		  "createdDate": "2024-08-22 18:53:46",
		  "totalOrganizations": 1,
		  "totalTours": 12,
		  "totalDays": 329,
		  "totalCountries": 20,
		  "totalStates": 50,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 529,
		  "schedulePercent": 0.326609,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36ce07aec2f7b594329472c5785ee57b",
		  
		  "name": "Bryan",
		  "createdDate": "2013-09-12 02:59:47",
		  "totalOrganizations": 18,
		  "totalTours": 7,
		  "totalDays": 897,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 910,
		  "schedulePercent": 0.461695,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36cf4de4a2876b434d4b5daccfbaa060",
		  
		  "name": "Ashleigh",
		  "createdDate": "2023-09-05 19:39:22",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 124,
		  "schedulePercent": 0.114007,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "36f34d38d3c316b1592e9e172a725294",
		  
		  "name": "Leigh Ann",
		  "createdDate": "2024-07-29 17:27:41",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 391,
		  "totalCountries": 6,
		  "totalStates": 43,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1422,
		  "schedulePercent": 0.602561,
		  "totalGuests": 736,
		  "guestPercent": 0.793291,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3712e04c7ef88568f9609f18892296e3",
		  
		  "name": "Taj",
		  "createdDate": "2024-04-11 16:17:20",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 239,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1165,
		  "schedulePercent": 0.539098,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-05-05 00:00:00",
		  "mostGuestName": "The Echo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3713c262b5f5cb1dae1215b62f149349",
		  
		  "name": "Brian",
		  "createdDate": "2015-11-03 20:00:20",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 222,
		  "totalCountries": 19,
		  "totalStates": 28,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 576,
		  "schedulePercent": 0.342022,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3722de26d9638fa2b603a30082a3b0e8",
		  
		  "name": "Steven ",
		  "createdDate": "2011-07-12 11:37:38",
		  "totalOrganizations": 19,
		  "totalTours": 12,
		  "totalDays": 351,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 628,
		  "schedulePercent": 0.359927,
		  "totalGuests": 102,
		  "guestPercent": 0.522325,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Knuckleheads Saloon - Outdoor Stage",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "372d1a4f9945c3df0161a2fa026d3651",
		  
		  "name": "Matt ",
		  "createdDate": "2023-05-30 16:33:28",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 1008,
		  "totalCountries": 5,
		  "totalStates": 55,
		  "totalEvents": 357,
		  "eventPercent": 0.944696,
		  "totalScheduleItems": 4933,
		  "schedulePercent": 0.952063,
		  "totalGuests": 4643,
		  "guestPercent": 0.996374,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37351978869b0f24b6008cc36f922e6e",
		  
		  "name": "Ward",
		  "createdDate": "2015-06-04 21:58:19",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 709,
		  "totalCountries": 28,
		  "totalStates": 66,
		  "totalEvents": 277,
		  "eventPercent": 0.896079,
		  "totalScheduleItems": 2704,
		  "schedulePercent": 0.808704,
		  "totalGuests": 1289,
		  "guestPercent": 0.884293,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37406f35413968ce2cd35b6524c00a47",
		  
		  "name": "Eva ",
		  "createdDate": "2017-07-23 04:50:07",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 463,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2931,
		  "schedulePercent": 0.834769,
		  "totalGuests": 1639,
		  "guestPercent": 0.923617,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "374534042e005ae79fd4f84391b44978",
		  
		  "name": "Noah",
		  "createdDate": "2021-06-10 03:33:24",
		  "totalOrganizations": 10,
		  "totalTours": 14,
		  "totalDays": 1455,
		  "totalCountries": 22,
		  "totalStates": 73,
		  "totalEvents": 327,
		  "eventPercent": 0.931324,
		  "totalScheduleItems": 5406,
		  "schedulePercent": 0.966228,
		  "totalGuests": 1575,
		  "guestPercent": 0.917044,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3748e5792d2f6bac86c63c281d4c79a2",
		  
		  "name": "Robert",
		  "createdDate": "2023-01-19 15:44:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 363,
		  "totalCountries": 10,
		  "totalStates": 11,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 194,
		  "schedulePercent": 0.155712,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "376dac295ae72ac7010ad7842f40b6b4",
		  
		  "name": "Ethan",
		  "createdDate": "2023-09-21 21:01:04",
		  "totalOrganizations": 8,
		  "totalTours": 17,
		  "totalDays": 586,
		  "totalCountries": 17,
		  "totalStates": 55,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 1787,
		  "schedulePercent": 0.674071,
		  "totalGuests": 832,
		  "guestPercent": 0.81573,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "The Studio at Webster Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37728fc0adb51fea7dd69961da7ee178",
		  
		  "name": "Julinho",
		  "createdDate": "2025-04-05 21:46:30",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 223,
		  "schedulePercent": 0.173051,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3773a6dd08ffd676cfd8916e79aadcd3",
		  
		  "name": "Cindy",
		  "createdDate": "2024-06-05 16:23:06",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 222,
		  "totalCountries": 15,
		  "totalStates": 20,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 952,
		  "schedulePercent": 0.476541,
		  "totalGuests": 138,
		  "guestPercent": 0.550997,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Palau Sant Jordi",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "377d0ee09a589114f3f959864eecd743",
		  
		  "name": "Yves",
		  "createdDate": "2012-11-12 03:38:55",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 10,
		  "totalStates": 12,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 372,
		  "schedulePercent": 0.254193,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "377f2ac44e6318d9452c801b820b6d62",
		  
		  "name": "Joshua",
		  "createdDate": "2018-07-25 21:13:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1529,
		  "schedulePercent": 0.623527,
		  "totalGuests": 827,
		  "guestPercent": 0.81437,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3784fa3c1a75d4013793d3eca1dfd85a",
		  
		  "name": "Sarah",
		  "createdDate": "2023-10-11 02:37:46",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 812,
		  "totalCountries": 33,
		  "totalStates": 63,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2309,
		  "schedulePercent": 0.763033,
		  "totalGuests": 658,
		  "guestPercent": 0.773005,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "378618e7c12da271192d5be65a4bcc5e",
		  
		  "name": "Jerome",
		  "createdDate": "2010-08-06 20:23:31",
		  "totalOrganizations": 18,
		  "totalTours": 23,
		  "totalDays": 1038,
		  "totalCountries": 34,
		  "totalStates": 94,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 3119,
		  "schedulePercent": 0.853128,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Zenith Paris - La Villette",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "378c5fb08b78614d3c1e9a545831ce16",
		  
		  "name": "Rebecca",
		  "createdDate": "2009-09-28 21:22:52",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 79,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 507,
		  "schedulePercent": 0.314257,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Largo at the Coronet",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "378d99b6c7681c0923cef14da496a948",
		  
		  "name": "Super",
		  "createdDate": "2025-06-03 20:14:30",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 212,
		  "totalCountries": 6,
		  "totalStates": 11,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "MacKinnon Brothers Brewing Company",
		  "mostGuestCity": "Bath",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37939a8f16ed55a1ce58e8fef52a54db",
		  
		  "name": "Randi",
		  "createdDate": "2017-04-11 16:28:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 98,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 95,
		  "schedulePercent": 0.0933817,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3795615f1eb14ef2fedb8b74d26e7d64",
		  
		  "name": "David ",
		  "createdDate": "2021-08-09 16:31:24",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 605,
		  "totalCountries": 30,
		  "totalStates": 25,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 2277,
		  "schedulePercent": 0.75884,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37a5eef47a6bcd547603b3d6b0b12cbc",
		  
		  "name": "Paul",
		  "createdDate": "2017-07-06 17:00:52",
		  "totalOrganizations": 1,
		  "totalTours": 11,
		  "totalDays": 78,
		  "totalCountries": 4,
		  "totalStates": 27,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 331,
		  "schedulePercent": 0.231754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37b6cb7d782afc139f9b7a680bb0047b",
		  
		  "name": "Ulrich",
		  "createdDate": "2022-08-01 09:31:55",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 326,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 526,
		  "schedulePercent": 0.324683,
		  "totalGuests": 415,
		  "guestPercent": 0.699456,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Elbphilharmonie",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37b70f9ddfa918c30bca4a4b38c1f0bf",
		  
		  "name": "Kamron",
		  "createdDate": "2019-02-26 18:33:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 2224,
		  "schedulePercent": 0.7517,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37ba64580e854eb285412c0f2ea6bbbc",
		  
		  "name": "Jeff",
		  "createdDate": "2019-03-11 20:49:29",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 467,
		  "totalCountries": 9,
		  "totalStates": 40,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1050,
		  "schedulePercent": 0.50442,
		  "totalGuests": 143,
		  "guestPercent": 0.554057,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Archer Music Hall",
		  "mostGuestCity": "Allentown",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37c2fb2c21dc1552b5e3b6eb615dc454",
		  
		  "name": "Melissa",
		  "createdDate": "2025-01-08 19:05:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 108,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 335,
		  "schedulePercent": 0.234021,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37c60d57d73532d7068c6a66c9a099d8",
		  
		  "name": "Jason",
		  "createdDate": "2015-04-13 19:46:31",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 148,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 803,
		  "schedulePercent": 0.423617,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37c86e89d729c7b0e4ffe2f82100f2a1",
		  
		  "name": "Molly",
		  "createdDate": "2019-08-14 23:54:24",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "The Capitol Theatre",
		  "mostGuestCity": "Port Chester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37ccb95399cbb26eba041f3c76f8372b",
		  
		  "name": "Padraic",
		  "createdDate": "2014-05-28 20:45:26",
		  "totalOrganizations": 11,
		  "totalTours": 40,
		  "totalDays": 727,
		  "totalCountries": 8,
		  "totalStates": 61,
		  "totalEvents": 357,
		  "eventPercent": 0.944696,
		  "totalScheduleItems": 4800,
		  "schedulePercent": 0.947643,
		  "totalGuests": 1297,
		  "guestPercent": 0.885879,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37cd0ad81303a3ed22060e7fa9e046f5",
		  
		  "name": "Luz",
		  "createdDate": "2019-01-16 12:20:39",
		  "totalOrganizations": 41,
		  "totalTours": 9,
		  "totalDays": 515,
		  "totalCountries": 16,
		  "totalStates": 54,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 2353,
		  "schedulePercent": 0.768812,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37ceb3fdcb54403a43dc3697d72a1399",
		  
		  "name": "Tom",
		  "createdDate": "2018-12-23 23:37:12",
		  "totalOrganizations": 14,
		  "totalTours": 13,
		  "totalDays": 587,
		  "totalCountries": 11,
		  "totalStates": 45,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 2027,
		  "schedulePercent": 0.718722,
		  "totalGuests": 385,
		  "guestPercent": 0.68801,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37db487adb6df5a4ffae328cd5385d5c",
		  
		  "name": "Ray",
		  "createdDate": "2016-06-03 12:55:20",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 117,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 851,
		  "schedulePercent": 0.44039,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Substage",
		  "mostGuestCity": "Karlsruhe",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37e1a90969d1a6163a0fb4aa75034254",
		  
		  "name": "Dianaimh",
		  "createdDate": "2025-04-28 15:34:08",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 28,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 84,
		  "schedulePercent": 0.0851088,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Vicar Street",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37ebe12b8879c0e012bf556d489ddeb9",
		  
		  "name": "Regina",
		  "createdDate": "2025-03-26 23:10:18",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 162,
		  "totalCountries": 13,
		  "totalStates": 30,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1128,
		  "schedulePercent": 0.527425,
		  "totalGuests": 577,
		  "guestPercent": 0.751813,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37ec41941ac5a480429b3579e1578978",
		  
		  "name": "Dexter",
		  "createdDate": "2019-12-05 09:37:06",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 442,
		  "totalCountries": 12,
		  "totalStates": 34,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1369,
		  "schedulePercent": 0.589075,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-11-18 00:00:00",
		  "mostGuestName": "Barbican Centre",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37ff092dcb0cf19742d7f344b9c20c0f",
		  
		  "name": "Denny",
		  "createdDate": "2021-07-09 02:54:28",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 124,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 196,
		  "schedulePercent": 0.158772,
		  "totalGuests": 111,
		  "guestPercent": 0.529125,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "The Theater at Virgin Hotels",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "37ff264fbe89f1c670db23e541ba150e",
		  
		  "name": "Justin",
		  "createdDate": "2016-07-12 02:49:07",
		  "totalOrganizations": 59,
		  "totalTours": 21,
		  "totalDays": 1551,
		  "totalCountries": 18,
		  "totalStates": 52,
		  "totalEvents": 313,
		  "eventPercent": 0.921351,
		  "totalScheduleItems": 2706,
		  "schedulePercent": 0.809157,
		  "totalGuests": 739,
		  "guestPercent": 0.793858,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Barclays Center",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3802b6fdd82a127f4e59129650f74e4c",
		  
		  "name": "Jesse",
		  "createdDate": "2021-09-23 18:39:37",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 230,
		  "totalCountries": 14,
		  "totalStates": 49,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1090,
		  "schedulePercent": 0.518019,
		  "totalGuests": 488,
		  "guestPercent": 0.726995,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3806c4373b8b0218ce88fa9efad8f404",
		  
		  "name": "Matt",
		  "createdDate": "2012-05-14 19:42:12",
		  "totalOrganizations": 15,
		  "totalTours": 29,
		  "totalDays": 602,
		  "totalCountries": 19,
		  "totalStates": 56,
		  "totalEvents": 295,
		  "eventPercent": 0.909678,
		  "totalScheduleItems": 3629,
		  "schedulePercent": 0.891319,
		  "totalGuests": 1614,
		  "guestPercent": 0.920898,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Germania Insurance Amphitheater",
		  "mostGuestCity": "Del Valle",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "380d5bdaaaafa61dabb4042504eec271",
		  
		  "name": "Scott",
		  "createdDate": "2018-02-21 17:23:05",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 1970,
		  "totalCountries": 9,
		  "totalStates": 62,
		  "totalEvents": 354,
		  "eventPercent": 0.943903,
		  "totalScheduleItems": 5978,
		  "schedulePercent": 0.975635,
		  "totalGuests": 2709,
		  "guestPercent": 0.976655,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Cadence Bank Amphitheatre At Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "381b57e7c7b3b4d861abe28ffb918226",
		  
		  "name": "Guillaume",
		  "createdDate": "2022-12-04 09:25:57",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 203,
		  "schedulePercent": 0.162965,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "381e6052032d9a429142a11064c6ad73",
		  
		  "name": "Anthony",
		  "createdDate": "2017-03-16 22:16:11",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 968,
		  "totalCountries": 12,
		  "totalStates": 61,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2764,
		  "schedulePercent": 0.817543,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3825a543ceeb009fcafbc385a3e6f8b1",
		  
		  "name": "Ben",
		  "createdDate": "2016-08-24 22:34:15",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 1202,
		  "totalCountries": 6,
		  "totalStates": 50,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 2338,
		  "schedulePercent": 0.766546,
		  "totalGuests": 296,
		  "guestPercent": 0.647665,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Lincoln Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "382a10865ffb829bf7e2df3c029ef0d4",
		  
		  "name": "River",
		  "createdDate": "2024-08-12 17:55:00",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 435,
		  "totalCountries": 13,
		  "totalStates": 47,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1324,
		  "schedulePercent": 0.576609,
		  "totalGuests": 315,
		  "guestPercent": 0.656618,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Prospect Park Bandshell",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "382b436e29bfddef46ad7c3655083349",
		  
		  "name": "Thomas",
		  "createdDate": "2011-11-23 09:32:58",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 345,
		  "totalCountries": 21,
		  "totalStates": 25,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 1865,
		  "schedulePercent": 0.68835,
		  "totalGuests": 1098,
		  "guestPercent": 0.863781,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lyse Arena",
		  "mostGuestCity": "Stavanger",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "383cb6e36eca0afc9ef6f29b321607a2",
		  
		  "name": "Mark",
		  "createdDate": "2011-09-06 01:09:32",
		  "totalOrganizations": 51,
		  "totalTours": 28,
		  "totalDays": 567,
		  "totalCountries": 22,
		  "totalStates": 66,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 2838,
		  "schedulePercent": 0.826836,
		  "totalGuests": 1518,
		  "guestPercent": 0.911718,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38405e2f8eefeccde629a7da652926d5",
		  
		  "name": "Matthew",
		  "createdDate": "2012-08-06 12:14:03",
		  "totalOrganizations": 36,
		  "totalTours": 46,
		  "totalDays": 1268,
		  "totalCountries": 33,
		  "totalStates": 91,
		  "totalEvents": 479,
		  "eventPercent": 0.975068,
		  "totalScheduleItems": 8077,
		  "schedulePercent": 0.990934,
		  "totalGuests": 5359,
		  "guestPercent": 0.99796,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38584f4d5d69dbf01c31898816a68dbb",
		  
		  "name": "Josh",
		  "a_nickname": "John \"Shua\" Castle",
		  "createdDate": "2017-07-11 16:15:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 375,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1936,
		  "schedulePercent": 0.701043,
		  "totalGuests": 3249,
		  "guestPercent": 0.986174,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Ak-Chin Pavilion",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 173,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "385cf19c0ad5fef916e16a29efd3bb74",
		  
		  "name": "Janina",
		  "createdDate": "2024-09-16 08:41:31",
		  "totalOrganizations": 44,
		  "totalTours": 58,
		  "totalDays": 781,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 780,
		  "eventPercent": 0.992747,
		  "totalScheduleItems": 3226,
		  "schedulePercent": 0.861854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3865c27687da939eeb9ede40e9f51332",
		  
		  "name": "Henrik",
		  "createdDate": "2017-01-06 14:58:34",
		  "totalOrganizations": 30,
		  "totalTours": 9,
		  "totalDays": 119,
		  "totalCountries": 28,
		  "totalStates": 26,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 527,
		  "schedulePercent": 0.325136,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Wembley Stadium",
		  "mostGuestCity": "Wembley",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "386762078f447074dad8ce0842bb3608",
		  
		  "name": "Mickey",
		  "createdDate": "2013-12-05 16:41:24",
		  "totalOrganizations": 3,
		  "totalTours": 11,
		  "totalDays": 981,
		  "totalCountries": 4,
		  "totalStates": 58,
		  "totalEvents": 488,
		  "eventPercent": 0.977108,
		  "totalScheduleItems": 6524,
		  "schedulePercent": 0.982094,
		  "totalGuests": 803,
		  "guestPercent": 0.808137,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Balboa Theatre",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38680fbaa2f13746ae14d0a0a8b988fd",
		  
		  "name": "Nick",
		  "createdDate": "2023-10-14 18:02:34",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 689,
		  "totalCountries": 14,
		  "totalStates": 60,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 2608,
		  "schedulePercent": 0.798731,
		  "totalGuests": 2164,
		  "guestPercent": 0.956482,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Roadrunner",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "386dbdd1cd66866b1730e700a7e112bd",
		  
		  "name": "Jon",
		  "createdDate": "2025-02-04 15:28:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 35,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 186,
		  "schedulePercent": 0.151405,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38716979f365bde4386d2b00c9718b2f",
		  
		  "name": "Dawn",
		  "createdDate": "2016-09-18 11:09:54",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 1031,
		  "totalCountries": 24,
		  "totalStates": 83,
		  "totalEvents": 345,
		  "eventPercent": 0.939937,
		  "totalScheduleItems": 5266,
		  "schedulePercent": 0.961355,
		  "totalGuests": 2292,
		  "guestPercent": 0.961469,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "DCU Center",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38770d1e85b395f5721cafa14faa8d8a",
		  
		  "name": "Gustavo",
		  "createdDate": "2022-08-16 20:37:28",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 858,
		  "totalCountries": 19,
		  "totalStates": 62,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 3943,
		  "schedulePercent": 0.910811,
		  "totalGuests": 1994,
		  "guestPercent": 0.946963,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38773208f5cd3295d84e1f30ed2098d7",
		  
		  "name": "Truman",
		  "createdDate": "2023-08-29 14:49:11",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 588,
		  "totalCountries": 6,
		  "totalStates": 58,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2559,
		  "schedulePercent": 0.793971,
		  "totalGuests": 613,
		  "guestPercent": 0.762466,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 214,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38791aa0ccfab05e2b5c4c7aaf23a370",
		  
		  "name": "Karis",
		  "createdDate": "2022-01-17 13:16:37",
		  "totalOrganizations": 5,
		  "totalTours": 14,
		  "totalDays": 174,
		  "totalCountries": 17,
		  "totalStates": 29,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 860,
		  "schedulePercent": 0.44481,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "O2 Apollo Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "387ac5615e602ee0a75238f7ccadf992",
		  
		  "name": "Daniel",
		  "createdDate": "2022-07-14 07:14:28",
		  "totalOrganizations": 8,
		  "totalTours": 32,
		  "totalDays": 388,
		  "totalCountries": 13,
		  "totalStates": 44,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 1529,
		  "schedulePercent": 0.623527,
		  "totalGuests": 425,
		  "guestPercent": 0.704442,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Gage Roads Freo Brewery",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "388585811da3606ba431c78b5afecf35",
		  
		  "name": "Faith",
		  "createdDate": "2023-07-19 00:36:04",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 97,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 95,
		  "schedulePercent": 0.0933817,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Coors Light Birds Nest",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "389482ee95c9d4a2ea753e7e3a5b6e62",
		  
		  "name": "Tim",
		  "createdDate": "2025-03-31 14:43:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 47,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 152,
		  "schedulePercent": 0.131006,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "389af2a0b5a10af2e79a8449728b6c63",
		  
		  "name": "Mackenzie",
		  "createdDate": "2024-06-28 15:00:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 113,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 154,
		  "schedulePercent": 0.132026,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "A&R Music Bar",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "389bc80b30eb3ef2c2cb6bb430abcb8e",
		  
		  "name": "Frisbee",
		  "createdDate": "2024-12-01 21:01:59",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 114,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 57,
		  "schedulePercent": 0.0656165,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38b2c431c54e88a1211d96a80ffc81cc",
		  
		  "name": "Jake",
		  "createdDate": "2021-12-03 01:58:11",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 415,
		  "totalCountries": 16,
		  "totalStates": 31,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 528,
		  "schedulePercent": 0.326043,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38baf431d7aea793e25c41a352372a03",
		  
		  "name": "Eric",
		  "createdDate": "2023-12-29 08:45:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 72,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 989,
		  "schedulePercent": 0.487874,
		  "totalGuests": 1878,
		  "guestPercent": 0.938237,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "La Seine Musicale",
		  "mostGuestCity": "Boulogne-Billancourt",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38c7693990206838fad5ade3b66a39b4",
		  
		  "name": "Joni",
		  "createdDate": "2022-05-09 08:37:34",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 87,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 535,
		  "schedulePercent": 0.329102,
		  "totalGuests": 51,
		  "guestPercent": 0.454329,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "Backaksen kesÃ¤keikat",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38ce2107ef42e13a6afbfaa4b5e2ed6c",
		  
		  "name": "Stage",
		  "createdDate": "2023-09-08 20:06:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 133,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1416,
		  "schedulePercent": 0.601655,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38d9f81647892cd390c4cc49666fd465",
		  
		  "name": "Catriona",
		  "createdDate": "2020-08-19 06:56:41",
		  "totalOrganizations": 40,
		  "totalTours": 19,
		  "totalDays": 492,
		  "totalCountries": 8,
		  "totalStates": 17,
		  "totalEvents": 259,
		  "eventPercent": 0.881006,
		  "totalScheduleItems": 1301,
		  "schedulePercent": 0.571623,
		  "totalGuests": 120,
		  "guestPercent": 0.536945,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "38f7583da68a21ddb1c1845aa9ff3e90",
		  
		  "name": "Ali",
		  "createdDate": "2025-04-01 13:28:53",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 80,
		  "totalCountries": 14,
		  "totalStates": 15,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 445,
		  "schedulePercent": 0.288758,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "FÃ¥llan",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39083a0b5b5ec7f47d406cb44d719bd9",
		  
		  "name": "Gabi",
		  "createdDate": "2024-03-09 17:01:40",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 144,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "390a26f46b9722903a9302133411308f",
		  
		  "name": "Jennifer",
		  "createdDate": "2018-12-29 07:13:24",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 372,
		  "totalCountries": 6,
		  "totalStates": 46,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1796,
		  "schedulePercent": 0.675544,
		  "totalGuests": 482,
		  "guestPercent": 0.725181,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39100c751a3932273afe619fafd1db25",
		  
		  "name": "Trine",
		  "createdDate": "2015-10-22 07:22:16",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 54,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "391a72adc3420bd27a0d5ed26dd7acce",
		  
		  "name": "Kelsey",
		  "createdDate": "2022-05-04 19:53:48",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 2145,
		  "totalCountries": 39,
		  "totalStates": 71,
		  "totalEvents": 316,
		  "eventPercent": 0.923164,
		  "totalScheduleItems": 3086,
		  "schedulePercent": 0.850181,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "391cace097aa806ef3aef747843eaddf",
		  
		  "name": "Max",
		  "createdDate": "2013-09-01 21:44:53",
		  "totalOrganizations": 9,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 122,
		  "schedulePercent": 0.112534,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "391e98bb2e011bd1f80c5c86134c329d",
		  
		  "name": "Matthias",
		  "createdDate": "2019-01-20 19:44:54",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 141,
		  "totalCountries": 26,
		  "totalStates": 21,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 841,
		  "schedulePercent": 0.437557,
		  "totalGuests": 108,
		  "guestPercent": 0.527199,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Warfield",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3924fbcb61395f9ee9f101538188c20a",
		  
		  "name": "Peter",
		  "createdDate": "2023-11-27 21:22:14",
		  "totalOrganizations": 2,
		  "totalTours": 13,
		  "totalDays": 226,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 948,
		  "schedulePercent": 0.474728,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "392615592d23681019f1520b8a892010",
		  
		  "name": "Erik ",
		  "createdDate": "2018-08-27 13:38:01",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 80,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 398,
		  "schedulePercent": 0.268586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3926ce1f7d4b222e48fef1bd0d2717f3",
		  
		  "name": "Linda",
		  "createdDate": "2018-03-10 18:46:08",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 137,
		  "totalCountries": 14,
		  "totalStates": 44,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1021,
		  "schedulePercent": 0.496374,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Constellation Room",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3930769d133784bef0655ba397bb4cdf",
		  
		  "name": "John",
		  "createdDate": "2024-08-26 18:32:02",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 46,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 460,
		  "schedulePercent": 0.294764,
		  "totalGuests": 299,
		  "guestPercent": 0.649139,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "393315efe8703108386311bc8b171f81",
		  
		  "name": "Sarah",
		  "createdDate": "2019-10-13 16:30:20",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 374,
		  "totalCountries": 17,
		  "totalStates": 50,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1379,
		  "schedulePercent": 0.592362,
		  "totalGuests": 148,
		  "guestPercent": 0.556664,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39352147a2d13687f4e4f0ace89982ae",
		  
		  "name": "Katie",
		  "createdDate": "2024-12-17 16:35:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 174,
		  "schedulePercent": 0.143246,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3947840ccc85608c52c88e10b77aea80",
		  
		  "name": "Carlijne",
		  "createdDate": "2017-08-09 14:29:06",
		  "totalOrganizations": 11,
		  "totalTours": 27,
		  "totalDays": 3212,
		  "totalCountries": 42,
		  "totalStates": 95,
		  "totalEvents": 371,
		  "eventPercent": 0.950023,
		  "totalScheduleItems": 5783,
		  "schedulePercent": 0.972575,
		  "totalGuests": 1181,
		  "guestPercent": 0.874207,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "394d4fb9c0696ac22c88df3155a55e85",
		  
		  "name": "Carl",
		  "createdDate": "2024-05-26 04:31:58",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 463,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 375,
		  "schedulePercent": 0.25544,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "United Center",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "395cf306cb44bec03a18c284bf989abf",
		  
		  "name": "Al",
		  "createdDate": "2012-12-10 05:50:43",
		  "totalOrganizations": 48,
		  "totalTours": 34,
		  "totalDays": 552,
		  "totalCountries": 19,
		  "totalStates": 59,
		  "totalEvents": 250,
		  "eventPercent": 0.87092,
		  "totalScheduleItems": 2646,
		  "schedulePercent": 0.802584,
		  "totalGuests": 1975,
		  "guestPercent": 0.94583,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39608bc93600335886f3d6c9e6cfe4c9",
		  
		  "name": "Andreas",
		  "createdDate": "2024-04-24 09:35:06",
		  "totalOrganizations": 16,
		  "totalTours": 8,
		  "totalDays": 178,
		  "totalCountries": 7,
		  "totalStates": 12,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 724,
		  "schedulePercent": 0.395852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39665d61a637e37836fe0f444b80a80d",
		  
		  "name": "Ally",
		  "createdDate": "2023-03-07 02:08:39",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 136,
		  "totalCountries": 20,
		  "totalStates": 44,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 824,
		  "schedulePercent": 0.43223,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-11-05 00:00:00",
		  "mostGuestName": "Razzmatazz",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3969316cd0a9b3c8c20433438608dfe0",
		  
		  "name": "Sam",
		  "createdDate": "2013-12-26 20:00:24",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 33,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 151,
		  "schedulePercent": 0.130326,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Kravis Center",
		  "mostGuestCity": "West Palm Beach",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3973abe52599942f4196640fe5cd4f3f",
		  
		  "name": "Maike",
		  "createdDate": "2021-09-29 09:36:08",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 267,
		  "totalCountries": 5,
		  "totalStates": 21,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2964,
		  "schedulePercent": 0.838622,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "397e05b312261cfb6b08ec2f66f69684",
		  
		  "name": "Samantha",
		  "createdDate": "2016-01-26 17:16:19",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 710,
		  "totalCountries": 12,
		  "totalStates": 16,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1137,
		  "schedulePercent": 0.530825,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "Mighty Hoopla (Brockwell Park)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3989e0f5b2fc0c36c3c20048d8b072fe",
		  
		  "name": "Jenny",
		  "createdDate": "2021-08-09 17:00:23",
		  "totalOrganizations": 10,
		  "totalTours": 25,
		  "totalDays": 1515,
		  "totalCountries": 28,
		  "totalStates": 81,
		  "totalEvents": 503,
		  "eventPercent": 0.979601,
		  "totalScheduleItems": 8800,
		  "schedulePercent": 0.992974,
		  "totalGuests": 7912,
		  "guestPercent": 0.998867,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "398b88d07554c75ab6d6b9dda3aa4953",
		  
		  "name": "Alice",
		  "createdDate": "2023-03-17 14:39:56",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 659,
		  "totalCountries": 34,
		  "totalStates": 60,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 2001,
		  "schedulePercent": 0.713962,
		  "totalGuests": 186,
		  "guestPercent": 0.583862,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39996b63ddc53e416477ece6efac0f59",
		  
		  "name": "Kellye",
		  "createdDate": "2014-09-26 18:51:28",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 392,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 1878,
		  "schedulePercent": 0.690616,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Spartanburg School District 3 Community Auditorium",
		  "mostGuestCity": "Spartanburg",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "399c829060ca14cbc4251ef3b3f55627",
		  
		  "name": "Chris",
		  "createdDate": "2011-09-01 19:15:08",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 429,
		  "totalCountries": 6,
		  "totalStates": 28,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 878,
		  "schedulePercent": 0.450589,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39ab6527cf7b6e4fa1f21db3f0fffad5",
		  
		  "name": "Josh",
		  "createdDate": "2025-06-17 20:31:05",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 54,
		  "totalCountries": 11,
		  "totalStates": 20,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 428,
		  "schedulePercent": 0.281505,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Palladium",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39b6c22d8ee91a6d1481e4d9fbbb669a",
		  
		  "name": "Lemonheads",
		  "createdDate": "2025-07-09 23:24:46",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 102,
		  "totalCountries": 17,
		  "totalStates": 36,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 440,
		  "schedulePercent": 0.286491,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "O2 Ritz Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39b779670bdbdbad4cbc679e5f74a13d",
		  
		  "name": "Vincent",
		  "createdDate": "2024-03-15 15:23:53",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 578,
		  "totalCountries": 19,
		  "totalStates": 32,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 935,
		  "schedulePercent": 0.470988,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39b89826e8a2363480532bf41d03fd55",
		  
		  "name": "Jason",
		  "createdDate": "2018-06-15 21:23:51",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 540,
		  "totalCountries": 5,
		  "totalStates": 30,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 931,
		  "schedulePercent": 0.469402,
		  "totalGuests": 261,
		  "guestPercent": 0.6301,
		  "mostGuestDate": "2025-04-08 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39c61da9019d54a7f4ac08a670c2b200",
		  
		  "name": "Routing manager",
		  "createdDate": "2022-06-15 22:10:22",
		  "totalOrganizations": 1,
		  "totalTours": 12,
		  "totalDays": 88,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 67,
		  "schedulePercent": 0.0718495,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39cbdcfa1f4ae85e66193aafe922246c",
		  
		  "name": "Jeremy",
		  "createdDate": "2023-09-07 17:35:30",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 729,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 250,
		  "schedulePercent": 0.189937,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39cfd5516e8add4425ce27d6ec1c52c7",
		  
		  "name": "Jay",
		  "createdDate": "2025-04-25 18:13:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 167,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 403,
		  "schedulePercent": 0.271192,
		  "totalGuests": 236,
		  "guestPercent": 0.6165,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Call Home Music Festival",
		  "mostGuestCity": "Brantford",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39dd1ed83b36d13e3c7c93d23afb08dd",
		  
		  "name": "Whit",
		  "createdDate": "2014-07-11 17:25:57",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 169,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 709,
		  "schedulePercent": 0.389846,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39ddc399127cb579e304620f82213f72",
		  
		  "name": "Bryan",
		  "createdDate": "2010-04-04 03:04:40",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 162,
		  "totalCountries": 25,
		  "totalStates": 18,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1285,
		  "schedulePercent": 0.56879,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39e0dd6d8bc3f412061876e27832e9ff",
		  
		  "name": "Tyler",
		  "createdDate": "2022-07-11 17:55:52",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 375,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1066,
		  "schedulePercent": 0.508726,
		  "totalGuests": 105,
		  "guestPercent": 0.524932,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39eb2f208225c0cf5560e9d2ec5272a2",
		  
		  "name": "Etienne",
		  "createdDate": "2022-06-28 18:17:19",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 168,
		  "schedulePercent": 0.139279,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39eb384e515c2bfad9e3f224beab6faf",
		  
		  "name": "Jordan",
		  "createdDate": "2024-09-09 22:09:11",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 187,
		  "totalCountries": 6,
		  "totalStates": 11,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 434,
		  "schedulePercent": 0.283205,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39f2b10fc18ea4b93a925c6d2d3547b0",
		  
		  "name": "Mike",
		  "createdDate": "2018-07-09 02:09:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 333,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1138,
		  "schedulePercent": 0.531165,
		  "totalGuests": 1131,
		  "guestPercent": 0.868767,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Riverfront Park",
		  "mostGuestCity": "Charelston",
		  "mostGuestAmount": 189,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39f96d3c54e8d27fe99b54209827ad1a",
		  
		  "name": "Ross",
		  "createdDate": "2023-11-20 18:38:23",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 845,
		  "totalCountries": 19,
		  "totalStates": 23,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 702,
		  "schedulePercent": 0.387693,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-05-05 00:00:00",
		  "mostGuestName": "GRAMMY Museum at L.A. LIVE",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39fcc83fc3a9b22cc77d791a950fc0a3",
		  
		  "name": "Doug",
		  "createdDate": "2019-05-15 04:49:08",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 236,
		  "totalCountries": 13,
		  "totalStates": 41,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 2048,
		  "schedulePercent": 0.722801,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "39fff4317287250cb53dfbe16ee6e780",
		  
		  "name": "Henry",
		  "createdDate": "2021-09-28 17:55:27",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 394,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a10c2575f89d87a1ae6438c59dfc3e9",
		  
		  "name": "Ben",
		  "createdDate": "2013-10-15 10:09:36",
		  "totalOrganizations": 27,
		  "totalTours": 39,
		  "totalDays": 1166,
		  "totalCountries": 40,
		  "totalStates": 105,
		  "totalEvents": 544,
		  "eventPercent": 0.983794,
		  "totalScheduleItems": 7016,
		  "schedulePercent": 0.986401,
		  "totalGuests": 4511,
		  "guestPercent": 0.996034,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a114ad7e32bb8c7fbdb2983405a45b7",
		  
		  "name": "Ava",
		  "createdDate": "2024-06-25 16:57:08",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 123,
		  "totalCountries": 22,
		  "totalStates": 25,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 1205,
		  "schedulePercent": 0.548051,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a19e30d8c4a71ddd87b87bcd7ea4eff",
		  
		  "name": "Gabriel",
		  "createdDate": "2024-06-03 17:54:57",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 145,
		  "totalCountries": 27,
		  "totalStates": 37,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1117,
		  "schedulePercent": 0.523119,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a227ea352037204e1921c42f34a99ec",
		  
		  "name": "Dustin",
		  "createdDate": "2014-09-04 20:23:38",
		  "totalOrganizations": 14,
		  "totalTours": 3,
		  "totalDays": 211,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 628,
		  "schedulePercent": 0.359927,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a22f65bed020da24c2635e3006a0973",
		  
		  "name": "Chris",
		  "createdDate": "2017-09-26 19:30:27",
		  "totalOrganizations": 5,
		  "totalTours": 20,
		  "totalDays": 221,
		  "totalCountries": 12,
		  "totalStates": 52,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1745,
		  "schedulePercent": 0.667271,
		  "totalGuests": 643,
		  "guestPercent": 0.769832,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a36428a46fe3b927753b5bd5b40cd74",
		  
		  "name": "Nathan",
		  "createdDate": "2012-05-13 17:28:17",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 177,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 1868,
		  "schedulePercent": 0.688917,
		  "totalGuests": 1425,
		  "guestPercent": 0.902879,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a3a8086d9ceb9e8af577b86ad6163b5",
		  
		  "name": "Shantel",
		  "createdDate": "2021-06-22 20:42:47",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 924,
		  "totalCountries": 28,
		  "totalStates": 86,
		  "totalEvents": 325,
		  "eventPercent": 0.93053,
		  "totalScheduleItems": 4445,
		  "schedulePercent": 0.936197,
		  "totalGuests": 2304,
		  "guestPercent": 0.962489,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a601acd69b694388e6c3b39ba632a4a",
		  
		  "name": "Matthew",
		  "createdDate": "2025-02-11 13:55:21",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 225,
		  "totalCountries": 5,
		  "totalStates": 7,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1402,
		  "schedulePercent": 0.598141,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a696e0b516b90b384c5ae07072f7f9e",
		  
		  "name": "Robert",
		  "createdDate": "2023-08-09 04:02:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 151,
		  "schedulePercent": 0.130326,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a8547cc887a5ac3ded4aa2e33a86969",
		  
		  "name": "Drew",
		  "createdDate": "2022-06-20 22:32:41",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 242,
		  "totalCountries": 20,
		  "totalStates": 66,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2717,
		  "schedulePercent": 0.811423,
		  "totalGuests": 1682,
		  "guestPercent": 0.926904,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a86499f2389dd3066ccc08a0a0b805c",
		  
		  "name": "Shamika",
		  "createdDate": "2025-10-27 21:02:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 163,
		  "schedulePercent": 0.137579,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Ovens Auditorium",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3a91edd729564525316abe4dab350e49",
		  
		  "name": "David",
		  "createdDate": "2022-05-22 22:38:50",
		  "totalOrganizations": 8,
		  "totalTours": 20,
		  "totalDays": 1156,
		  "totalCountries": 22,
		  "totalStates": 59,
		  "totalEvents": 291,
		  "eventPercent": 0.906618,
		  "totalScheduleItems": 5643,
		  "schedulePercent": 0.970648,
		  "totalGuests": 2639,
		  "guestPercent": 0.973595,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3aa0a17a3b9f22407b474cd07dfa2b53",
		  
		  "name": "Jack",
		  "createdDate": "2014-03-22 21:53:38",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 689,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1773,
		  "schedulePercent": 0.671578,
		  "totalGuests": 270,
		  "guestPercent": 0.634746,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Red Hat Amphitheater",
		  "mostGuestCity": "Raleigh",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3aa9bc66c0de1f58dada718742dfc096",
		  
		  "name": "Wendy",
		  "createdDate": "2017-10-24 14:23:45",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 326,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 318,
		  "schedulePercent": 0.225748,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ab8f4db0c57e5bc8a026a38ff32d57b",
		  
		  "name": "Pat",
		  "createdDate": "2013-10-20 21:29:03",
		  "totalOrganizations": 17,
		  "totalTours": 10,
		  "totalDays": 266,
		  "totalCountries": 8,
		  "totalStates": 49,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1820,
		  "schedulePercent": 0.67951,
		  "totalGuests": 976,
		  "guestPercent": 0.842248,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ac3cfda4dabbefe45436c7f13172b14",
		  
		  "name": "Alexis",
		  "createdDate": "2022-10-09 01:54:25",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 455,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 845,
		  "schedulePercent": 0.438803,
		  "totalGuests": 179,
		  "guestPercent": 0.579556,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Constellation Room",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ac74a15477502a8a3c4806a92ee5b7b",
		  
		  "name": "Lara ",
		  "createdDate": "2021-09-15 14:16:53",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 150,
		  "totalCountries": 19,
		  "totalStates": 35,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 966,
		  "schedulePercent": 0.480054,
		  "totalGuests": 261,
		  "guestPercent": 0.6301,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Razzmatazz",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ac7a37a9d84a74c588b720099c62739",
		  
		  "name": "Blake",
		  "createdDate": "2015-01-05 20:54:26",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 658,
		  "totalCountries": 19,
		  "totalStates": 66,
		  "totalEvents": 307,
		  "eventPercent": 0.916818,
		  "totalScheduleItems": 3237,
		  "schedulePercent": 0.862874,
		  "totalGuests": 270,
		  "guestPercent": 0.634746,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "DR Koncerthuset",
		  "mostGuestCity": "Kobenhavn",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ace6f47eb9088a82f1bacfba0959ec1",
		  
		  "name": "Thomas",
		  "createdDate": "2017-05-24 09:43:23",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 175,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1475,
		  "schedulePercent": 0.611854,
		  "totalGuests": 2051,
		  "guestPercent": 0.950589,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ad63312728dba5d9042066d677ebb83",
		  
		  "name": "Gil",
		  "createdDate": "2023-01-25 23:50:41",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 156,
		  "totalCountries": 4,
		  "totalStates": 22,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 540,
		  "schedulePercent": 0.330349,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "Wolf Trap's Todo Sonido Festival 2025",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ad8edf502494d591ae511e3f7f04195",
		  
		  "name": "Julieta",
		  "createdDate": "2025-09-02 14:03:27",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 46,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 250,
		  "schedulePercent": 0.189937,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ae34f5c83a4b75a3c64e1dded91d802",
		  
		  "name": "James",
		  "createdDate": "2016-02-09 21:40:34",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 16,
		  "totalStates": 14,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 619,
		  "schedulePercent": 0.356528,
		  "totalGuests": 280,
		  "guestPercent": 0.639393,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Montauk Lighthouse",
		  "mostGuestCity": "Montauk",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3aef9b93060e5d65d2a2cf8ea694e76b",
		  
		  "name": "Keeks",
		  "createdDate": "2012-04-18 23:23:18",
		  "totalOrganizations": 38,
		  "totalTours": 19,
		  "totalDays": 1387,
		  "totalCountries": 16,
		  "totalStates": 58,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 2421,
		  "schedulePercent": 0.777539,
		  "totalGuests": 223,
		  "guestPercent": 0.608568,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Powerstation",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3af7dba3dbaa75670a6ca9d6679d628b",
		  
		  "name": "Robinette",
		  "createdDate": "2020-02-25 03:16:00",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 1830,
		  "totalCountries": 7,
		  "totalStates": 43,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 2322,
		  "schedulePercent": 0.765299,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b01652c580cd690f90c494fb65baeed",
		  
		  "name": "Maci",
		  "createdDate": "2020-02-15 13:45:55",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 578,
		  "totalCountries": 7,
		  "totalStates": 62,
		  "totalEvents": 349,
		  "eventPercent": 0.94209,
		  "totalScheduleItems": 5050,
		  "schedulePercent": 0.955576,
		  "totalGuests": 908,
		  "guestPercent": 0.831709,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b237cd8dac337e943c828ddb0ba3f6d",
		  
		  "name": "Rasmus",
		  "createdDate": "2014-01-22 15:09:46",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Cirkus Arena",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b277763cd0e07cf51dffbcf532ff568",
		  
		  "name": "Annalise",
		  "createdDate": "2023-04-03 01:41:20",
		  "totalOrganizations": 33,
		  "totalTours": 13,
		  "totalDays": 558,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1830,
		  "schedulePercent": 0.681437,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Hamer Hall",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b295e23278582fbe45a186040fe439b",
		  
		  "name": "Jan",
		  "createdDate": "2019-01-28 15:38:14",
		  "totalOrganizations": 10,
		  "totalTours": 18,
		  "totalDays": 990,
		  "totalCountries": 29,
		  "totalStates": 91,
		  "totalEvents": 345,
		  "eventPercent": 0.939937,
		  "totalScheduleItems": 4791,
		  "schedulePercent": 0.947303,
		  "totalGuests": 3170,
		  "guestPercent": 0.985041,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b29a93ca5a099a4cb45d89758feec09",
		  
		  "name": "JANN",
		  "createdDate": "2010-12-09 19:49:50",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 85,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 363,
		  "schedulePercent": 0.249433,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b29daa4104c157f71cd86759b35a9f4",
		  
		  "name": "Miles",
		  "createdDate": "2018-09-30 21:58:35",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 176,
		  "totalCountries": 19,
		  "totalStates": 37,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1324,
		  "schedulePercent": 0.576609,
		  "totalGuests": 359,
		  "guestPercent": 0.677924,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 180,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b2d845b47fabf0f0fb502a0f1f42e9c",
		  
		  "name": "Daniel",
		  "createdDate": "2024-04-24 10:48:13",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 171,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1847,
		  "schedulePercent": 0.685403,
		  "totalGuests": 2192,
		  "guestPercent": 0.957389,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b3e94f3958acd6c4132d5a24fc33b58",
		  
		  "name": "Brian",
		  "createdDate": "2014-09-09 22:27:38",
		  "totalOrganizations": 3,
		  "totalTours": 20,
		  "totalDays": 162,
		  "totalCountries": 2,
		  "totalStates": 33,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 847,
		  "schedulePercent": 0.439483,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Garden Amphitheatre",
		  "mostGuestCity": "Garden Grove",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b3eb19e6dcc1ce3a74087a934b248e0",
		  
		  "name": "Andi",
		  "createdDate": "2024-06-11 21:08:02",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 310,
		  "totalCountries": 19,
		  "totalStates": 30,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1466,
		  "schedulePercent": 0.610267,
		  "totalGuests": 108,
		  "guestPercent": 0.527199,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "TivoliVredenburg Pandora",
		  "mostGuestCity": "Utrecht",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b412337221c523be8b575709237d038",
		  
		  "name": "Brian ",
		  "createdDate": "2014-06-17 01:07:55",
		  "totalOrganizations": 16,
		  "totalTours": 3,
		  "totalDays": 700,
		  "totalCountries": 7,
		  "totalStates": 44,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 3373,
		  "schedulePercent": 0.8733,
		  "totalGuests": 3427,
		  "guestPercent": 0.989121,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 230,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b4449f87342271317970c6bf32e2cca",
		  
		  "name": "Geovanny",
		  "createdDate": "2022-12-06 14:37:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 105,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 373,
		  "schedulePercent": 0.254646,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b4aa1d20978b264d6e729ad4636ac13",
		  
		  "name": "Ben ",
		  "createdDate": "2011-02-10 22:27:57",
		  "totalOrganizations": 31,
		  "totalTours": 45,
		  "totalDays": 6123,
		  "totalCountries": 56,
		  "totalStates": 146,
		  "totalEvents": 1509,
		  "eventPercent": 0.99898,
		  "totalScheduleItems": 23184,
		  "schedulePercent": 0.999547,
		  "totalGuests": 5080,
		  "guestPercent": 0.997847,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "MGM Grand",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b4d5bd2df6e76801bcb9648737049f2",
		  
		  "name": "Lindsey",
		  "createdDate": "2023-01-05 17:49:28",
		  "totalOrganizations": 1,
		  "totalTours": 36,
		  "totalDays": 566,
		  "totalCountries": 18,
		  "totalStates": 37,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 2464,
		  "schedulePercent": 0.782865,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Ocean Resort Casino - Ovation Hall",
		  "mostGuestCity": "Atlantic City",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b5a74b59b29b67554068a105fe52d29",
		  
		  "name": "Sean",
		  "createdDate": "2023-05-05 18:28:08",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 108,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 485,
		  "schedulePercent": 0.30383,
		  "totalGuests": 505,
		  "guestPercent": 0.732434,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b707b66dc0e3f4594931ff889b3878c",
		  
		  "name": "eric",
		  "createdDate": "2020-02-20 19:32:11",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 1571,
		  "totalCountries": 15,
		  "totalStates": 54,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 3985,
		  "schedulePercent": 0.912511,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b715471e285ca30c667770bee806955",
		  
		  "name": "Benjamin",
		  "createdDate": "2023-10-02 22:55:12",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 160,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 336,
		  "schedulePercent": 0.234587,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "The Showbox",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b77fc61a4e9915ad2cc4ef70bca7f84",
		  
		  "name": "Michael",
		  "createdDate": "2018-02-20 02:36:04",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 110,
		  "totalCountries": 15,
		  "totalStates": 38,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 386,
		  "schedulePercent": 0.261673,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b7e3b40b72e120c4dec23902c042bc8",
		  
		  "name": "Judit",
		  "createdDate": "2017-02-27 17:10:53",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 695,
		  "totalCountries": 26,
		  "totalStates": 46,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 3345,
		  "schedulePercent": 0.87058,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "ICC Sydney Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b8f36447155d4b31d8d93427e39d1c2",
		  
		  "name": "Bea",
		  "createdDate": "2024-08-01 13:06:34",
		  "totalOrganizations": 13,
		  "totalTours": 26,
		  "totalDays": 1180,
		  "totalCountries": 24,
		  "totalStates": 64,
		  "totalEvents": 327,
		  "eventPercent": 0.931324,
		  "totalScheduleItems": 4283,
		  "schedulePercent": 0.930304,
		  "totalGuests": 108,
		  "guestPercent": 0.527199,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b9256f98eca96618fb10902a06c0c96",
		  
		  "name": "Jennifer",
		  "createdDate": "2024-10-30 17:45:12",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 714,
		  "totalCountries": 29,
		  "totalStates": 45,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 756,
		  "schedulePercent": 0.407978,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Creamfields Festival",
		  "mostGuestCity": "Daresbury",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3b9d2c051e927db8c01a272d810cd84a",
		  
		  "name": "Alec",
		  "createdDate": "2013-02-28 17:56:06",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 1096,
		  "totalCountries": 39,
		  "totalStates": 44,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 3749,
		  "schedulePercent": 0.898345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ba9c9e6e76e3a1c69031688e7fece76",
		  
		  "name": "Jed",
		  "createdDate": "2025-01-22 02:24:45",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 153,
		  "totalCountries": 11,
		  "totalStates": 32,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 424,
		  "schedulePercent": 0.279692,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bb21d1b9308d2d1548233db2b3695b6",
		  
		  "name": "Filip",
		  "createdDate": "2019-10-23 11:49:56",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 121,
		  "totalCountries": 15,
		  "totalStates": 26,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 849,
		  "schedulePercent": 0.439823,
		  "totalGuests": 328,
		  "guestPercent": 0.665231,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Crane",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bbbef0a133e20e0d4dc0189885c42a8",
		  
		  "name": "James",
		  "createdDate": "2022-12-18 00:37:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 591,
		  "totalCountries": 6,
		  "totalStates": 26,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 620,
		  "schedulePercent": 0.357208,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bc23af59476f6ed54fa3e8f4e304446",
		  
		  "name": "Chris",
		  "createdDate": "2010-07-31 21:49:01",
		  "totalOrganizations": 17,
		  "totalTours": 37,
		  "totalDays": 2386,
		  "totalCountries": 18,
		  "totalStates": 76,
		  "totalEvents": 566,
		  "eventPercent": 0.985607,
		  "totalScheduleItems": 6285,
		  "schedulePercent": 0.979261,
		  "totalGuests": 1451,
		  "guestPercent": 0.904692,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bc2a8aa52520409ff04b2e44dcb8709",
		  
		  "name": "Milly",
		  "createdDate": "2025-03-03 10:05:36",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 34,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 95,
		  "schedulePercent": 0.0933817,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "london",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bd288e9919fe697aff81cbe1a8cb17f",
		  
		  "name": "Dustin",
		  "createdDate": "2011-05-08 02:31:52",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 658,
		  "totalCountries": 7,
		  "totalStates": 43,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 3117,
		  "schedulePercent": 0.852901,
		  "totalGuests": 1415,
		  "guestPercent": 0.901519,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 227,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bd7048011c81e38d5895584c18653b2",
		  
		  "name": "Michael",
		  "createdDate": "2024-12-21 15:20:34",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 278,
		  "schedulePercent": 0.204216,
		  "totalGuests": 201,
		  "guestPercent": 0.595422,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bd738081949d320c0b99e7814779d45",
		  
		  "name": "Matty",
		  "createdDate": "2019-05-21 20:09:09",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 543,
		  "totalCountries": 19,
		  "totalStates": 45,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 982,
		  "schedulePercent": 0.485267,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Elsewhere",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bdff54ecc10007fe3988fd0262b9832",
		  
		  "name": "Greg",
		  "createdDate": "2023-12-06 22:26:34",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 80,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 372,
		  "schedulePercent": 0.254193,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3befc7b29ea022cb0cdcb0377025a05f",
		  
		  "name": "Richard",
		  "createdDate": "2019-03-31 14:53:50",
		  "totalOrganizations": 8,
		  "totalTours": 22,
		  "totalDays": 1180,
		  "totalCountries": 35,
		  "totalStates": 65,
		  "totalEvents": 392,
		  "eventPercent": 0.956822,
		  "totalScheduleItems": 7114,
		  "schedulePercent": 0.987421,
		  "totalGuests": 946,
		  "guestPercent": 0.838962,
		  "mostGuestDate": "2025-06-24 00:00:00",
		  "mostGuestName": "O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bf0efeaa86b2482311a894e91683daf",
		  
		  "name": "Phil",
		  "createdDate": "2017-02-04 09:56:16",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 116,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 718,
		  "schedulePercent": 0.393246,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Margaret Court Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3bf86d012c438008564a1946d8a4120b",
		  
		  "name": "John",
		  "createdDate": "2018-09-12 16:31:36",
		  "totalOrganizations": 1,
		  "totalTours": 39,
		  "totalDays": 206,
		  "totalCountries": 10,
		  "totalStates": 30,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1337,
		  "schedulePercent": 0.582729,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c076503493363c3716547776e3a2a29",
		  
		  "name": "Doug",
		  "createdDate": "2010-01-08 18:43:39",
		  "totalOrganizations": 19,
		  "totalTours": 12,
		  "totalDays": 591,
		  "totalCountries": 25,
		  "totalStates": 62,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 4166,
		  "schedulePercent": 0.923051,
		  "totalGuests": 1863,
		  "guestPercent": 0.93699,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c09445f55b75a39512b9fcef9aa7477",
		  
		  "name": "Richard",
		  "createdDate": "2022-03-29 20:47:10",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 266,
		  "totalCountries": 19,
		  "totalStates": 34,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 955,
		  "schedulePercent": 0.477901,
		  "totalGuests": 251,
		  "guestPercent": 0.625567,
		  "mostGuestDate": "2025-01-29 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c0e423b18082d7ab005b4b31bf799e5",
		  
		  "name": "Ekela",
		  "createdDate": "2024-04-15 12:15:17",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 58,
		  "totalCountries": 14,
		  "totalStates": 39,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 516,
		  "schedulePercent": 0.31947,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "O2 Institute",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c0ef4d80a68a9bb46b9b554661fe038",
		  
		  "name": "Maryjo",
		  "createdDate": "2017-02-16 21:14:12",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 318,
		  "totalCountries": 7,
		  "totalStates": 49,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 2091,
		  "schedulePercent": 0.730734,
		  "totalGuests": 144,
		  "guestPercent": 0.554624,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "O2 Academy Islington",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c115f4339d6cef70b6ca4a17624c7df",
		  
		  "name": "Judith",
		  "createdDate": "2013-01-10 16:49:19",
		  "totalOrganizations": 18,
		  "totalTours": 9,
		  "totalDays": 381,
		  "totalCountries": 14,
		  "totalStates": 22,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 1177,
		  "schedulePercent": 0.541364,
		  "totalGuests": 810,
		  "guestPercent": 0.81063,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Sadlon Arena",
		  "mostGuestCity": "Barrie",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c185aaf3cdb0d6aef9945920c4bc803",
		  
		  "name": "Forrest",
		  "createdDate": "2017-01-25 19:21:01",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 93,
		  "totalCountries": 12,
		  "totalStates": 24,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 358,
		  "schedulePercent": 0.247167,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Higginson Park",
		  "mostGuestCity": "Marlow",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c29b68f509efe0faaadfc90e6e27c75",
		  
		  "name": "Andrew",
		  "createdDate": "2022-02-21 12:31:34",
		  "totalOrganizations": 9,
		  "totalTours": 16,
		  "totalDays": 208,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1325,
		  "schedulePercent": 0.577516,
		  "totalGuests": 711,
		  "guestPercent": 0.788078,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The Fillmore Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c31106512fc479a0c7fbf086753d1fa",
		  
		  "name": "Peyman",
		  "createdDate": "2024-07-15 08:25:01",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 62,
		  "totalCountries": 8,
		  "totalStates": 8,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 159,
		  "schedulePercent": 0.134519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c42ce8fdfea9df95e1aa0749362cadb",
		  
		  "name": "Maegan",
		  "createdDate": "2024-07-26 18:32:23",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 683,
		  "totalCountries": 8,
		  "totalStates": 61,
		  "totalEvents": 317,
		  "eventPercent": 0.923617,
		  "totalScheduleItems": 4112,
		  "schedulePercent": 0.919538,
		  "totalGuests": 2017,
		  "guestPercent": 0.948436,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c48b11c26242201c47b22ff3d633e95",
		  
		  "name": "Smokeshow",
		  "createdDate": "2025-06-10 21:40:04",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 778,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 86,
		  "schedulePercent": 0.086582,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c48da9a54451e3a19f2372815ed3356",
		  
		  "name": "Gage",
		  "createdDate": "2021-10-11 14:47:51",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 1180,
		  "totalCountries": 12,
		  "totalStates": 56,
		  "totalEvents": 301,
		  "eventPercent": 0.913645,
		  "totalScheduleItems": 3955,
		  "schedulePercent": 0.911038,
		  "totalGuests": 1193,
		  "guestPercent": 0.875227,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c5010e1c29339f9144ac9644df0971d",
		  
		  "name": "Hana",
		  "createdDate": "2016-04-09 14:10:16",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 458,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 411,
		  "schedulePercent": 0.274365,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Fantasy Springs Casino",
		  "mostGuestCity": "Indio",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c5705639842ea3e956730eb2a9dc81f",
		  
		  "name": "Pauly",
		  "createdDate": "2023-04-30 19:08:24",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 1905,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1033,
		  "schedulePercent": 0.499547,
		  "totalGuests": 271,
		  "guestPercent": 0.635653,
		  "mostGuestDate": "2025-03-05 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c5b925d47cc5778b11d25f82b0da701",
		  
		  "name": "Anna Rose",
		  "createdDate": "2024-01-24 11:20:50",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 75,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 270,
		  "schedulePercent": 0.199569,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Tinderbox",
		  "mostGuestCity": "Odense",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c64fa99aba32873e19839fe0aadf47b",
		  
		  "name": "Ryan",
		  "createdDate": "2014-10-18 23:48:26",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 167,
		  "totalCountries": 7,
		  "totalStates": 31,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 531,
		  "schedulePercent": 0.327176,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-01-10 00:00:00",
		  "mostGuestName": "Thunder Valley Casino Resort",
		  "mostGuestCity": "Lincoln",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c69037ac976050f3e957c970c9e8b4d",
		  
		  "name": "Robert",
		  "createdDate": "2017-01-12 20:15:36",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 204,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 628,
		  "schedulePercent": 0.359927,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c69e3df386b4606bc37822352d3eaa3",
		  
		  "name": "Scott",
		  "createdDate": "2024-08-31 05:09:56",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 76,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 197,
		  "schedulePercent": 0.159225,
		  "totalGuests": 238,
		  "guestPercent": 0.617974,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Astor Theatre Perth",
		  "mostGuestCity": "Mount Lawley",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c6ac1b1d814792db54ba9819b410d77",
		  
		  "name": "Tim",
		  "createdDate": "2022-07-20 01:26:38",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 340,
		  "totalCountries": 6,
		  "totalStates": 13,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 634,
		  "schedulePercent": 0.361854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c72fcc64fa3c9f4827db78bae39e6b7",
		  
		  "name": "Eric",
		  "createdDate": "2019-05-15 20:13:01",
		  "totalOrganizations": 9,
		  "totalTours": 23,
		  "totalDays": 560,
		  "totalCountries": 26,
		  "totalStates": 71,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 4183,
		  "schedulePercent": 0.925317,
		  "totalGuests": 546,
		  "guestPercent": 0.742634,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c742c3b335297878cd0ec80982845f8",
		  
		  "name": "Imane",
		  "createdDate": "2020-01-31 08:43:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 282,
		  "totalCountries": 25,
		  "totalStates": 6,
		  "totalEvents": 1,
		  "eventPercent": 0.0074796,
		  "totalScheduleItems": 815,
		  "schedulePercent": 0.428944,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c8943245056a11c06bda6b8cc328b69",
		  
		  "name": "STRETCH",
		  "createdDate": "2024-06-06 00:30:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 147,
		  "schedulePercent": 0.128853,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3c8f5bf38d38a86e8890f812c28ac64c",
		  
		  "name": "Jovana",
		  "createdDate": "2018-10-07 23:58:19",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 507,
		  "totalCountries": 5,
		  "totalStates": 50,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 2224,
		  "schedulePercent": 0.7517,
		  "totalGuests": 567,
		  "guestPercent": 0.748413,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3cab63de0d571be54539d426b277c10b",
		  
		  "name": "Andrew",
		  "createdDate": "2023-11-28 16:38:16",
		  "totalOrganizations": 17,
		  "totalTours": 39,
		  "totalDays": 2327,
		  "totalCountries": 37,
		  "totalStates": 116,
		  "totalEvents": 735,
		  "eventPercent": 0.991954,
		  "totalScheduleItems": 14023,
		  "schedulePercent": 0.998753,
		  "totalGuests": 4311,
		  "guestPercent": 0.995127,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3cb19acd2d466ac40be766e77f2fea40",
		  
		  "name": "Alan",
		  "createdDate": "2025-04-14 09:04:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 44,
		  "totalCountries": 12,
		  "totalStates": 10,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3cce59c33c78a8a6a464544fd3b19c86",
		  
		  "name": "Michael",
		  "createdDate": "2023-07-12 15:01:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 106,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 416,
		  "schedulePercent": 0.276519,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Crystal Grand Music Theatre",
		  "mostGuestCity": "Wisconsin Dells",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3cd8eab1f5a888716b4f1892659c347c",
		  
		  "name": "Jussi",
		  "createdDate": "2021-08-27 00:57:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 79,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Tulisuudelma",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3cd9951f93f662b51d77af3803319fca",
		  
		  "name": "Jade",
		  "createdDate": "2018-08-18 04:35:55",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 344,
		  "schedulePercent": 0.240254,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Young Showground Camping",
		  "mostGuestCity": "Young",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3cdd3c8109df3104ca54a269e14b718c",
		  
		  "name": "Nicole",
		  "createdDate": "2022-08-02 02:52:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 411,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 630,
		  "schedulePercent": 0.360834,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Sweetland Amphitheatre at Boyd Park",
		  "mostGuestCity": "LaGrange",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ce247ec1202701e3cd892638a09effc",
		  
		  "name": "Maria",
		  "createdDate": "2025-08-04 10:44:19",
		  "totalOrganizations": 32,
		  "totalTours": 22,
		  "totalDays": 84,
		  "totalCountries": 9,
		  "totalStates": 9,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 312,
		  "schedulePercent": 0.223481,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3cec6e8943e099dcbc577aa6b6b1018f",
		  
		  "name": "Tal",
		  "createdDate": "2016-05-23 18:25:24",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 78,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 199,
		  "schedulePercent": 0.160245,
		  "totalGuests": 181,
		  "guestPercent": 0.580802,
		  "mostGuestDate": "2025-05-13 00:00:00",
		  "mostGuestName": "CMA Theater at the Country Music Hall of Fame and Museum",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3cef8b418f0cbec5c790dd758404fd30",
		  
		  "name": "Casey",
		  "createdDate": "2022-04-16 01:45:15",
		  "totalOrganizations": 26,
		  "totalTours": 33,
		  "totalDays": 1706,
		  "totalCountries": 27,
		  "totalStates": 90,
		  "totalEvents": 563,
		  "eventPercent": 0.985154,
		  "totalScheduleItems": 7556,
		  "schedulePercent": 0.988894,
		  "totalGuests": 3425,
		  "guestPercent": 0.988894,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d033620e1b2d5b40a6aa3daf33a79b5",
		  
		  "name": "Sofia",
		  "createdDate": "2023-09-25 14:16:24",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 1096,
		  "totalCountries": 39,
		  "totalStates": 44,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 3749,
		  "schedulePercent": 0.898345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d0b49c398e943da2b54a3fc42ea002c",
		  
		  "name": "Richard",
		  "createdDate": "2013-10-14 21:13:08",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 243,
		  "totalCountries": 7,
		  "totalStates": 16,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1607,
		  "schedulePercent": 0.641659,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Margaret Court Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d28c7c48165a6b126c71f46d61497f3",
		  
		  "name": "Joshua",
		  "createdDate": "2015-06-17 16:06:27",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 55,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Knitting Factory",
		  "mostGuestCity": "Spokane",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d2d5b69aeeef751691de79a35486675",
		  
		  "name": "Justin",
		  "createdDate": "2016-02-09 20:38:11",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 89,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d401b924135c5c23920ab175a0a13c7",
		  
		  "name": "Peter",
		  "createdDate": "2011-01-04 21:20:45",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 122,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 552,
		  "schedulePercent": 0.334769,
		  "totalGuests": 426,
		  "guestPercent": 0.705349,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Barbara B. Mann Performing Arts Hall",
		  "mostGuestCity": "Fort Myers",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d43ac53ae32a972af204716e7b698d4",
		  
		  "name": "Andy",
		  "createdDate": "2014-02-21 21:45:45",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 157,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1805,
		  "schedulePercent": 0.676791,
		  "totalGuests": 125,
		  "guestPercent": 0.541025,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d486a6aa3ca8168ac7214c6b443ffc4",
		  
		  "name": "Aaron",
		  "createdDate": "2016-02-05 21:27:04",
		  "totalOrganizations": 40,
		  "totalTours": 12,
		  "totalDays": 244,
		  "totalCountries": 11,
		  "totalStates": 24,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 2980,
		  "schedulePercent": 0.840662,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d4ac37862a4908848dd9580ce659680",
		  
		  "name": "Tessa",
		  "createdDate": "2015-03-06 16:17:28",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 772,
		  "totalCountries": 20,
		  "totalStates": 42,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1388,
		  "schedulePercent": 0.594402,
		  "totalGuests": 583,
		  "guestPercent": 0.75408,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 91,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d4b7fa324e39a34f80bcb69d6b8e080",
		  
		  "name": "Eleanor",
		  "createdDate": "2021-07-06 03:43:11",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 284,
		  "totalCountries": 18,
		  "totalStates": 47,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1543,
		  "schedulePercent": 0.625907,
		  "totalGuests": 860,
		  "guestPercent": 0.82117,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d6381c90cbc3a7ff406430eaadd9b60",
		  
		  "name": "Mika",
		  "createdDate": "2022-05-18 16:32:29",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 171,
		  "totalCountries": 22,
		  "totalStates": 26,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1463,
		  "schedulePercent": 0.609701,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d6771d3375bc75828ccc0346d824e0b",
		  
		  "name": "Leila",
		  "createdDate": "2019-01-30 03:42:42",
		  "totalOrganizations": 26,
		  "totalTours": 58,
		  "totalDays": 816,
		  "totalCountries": 16,
		  "totalStates": 23,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 2490,
		  "schedulePercent": 0.785925,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d78132cf796bb7acc72048b04ccfeb1",
		  
		  "name": "",
		  "createdDate": "2023-03-09 11:44:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 161,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 619,
		  "schedulePercent": 0.356528,
		  "totalGuests": 303,
		  "guestPercent": 0.651519,
		  "mostGuestDate": "2025-02-05 00:00:00",
		  "mostGuestName": "Kaufleuten",
		  "mostGuestCity": "ZÃ¼rich",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d7977529e2821e9f7bf117afb8006ed",
		  
		  "name": "Christopher",
		  "createdDate": "2024-05-07 16:21:57",
		  "totalOrganizations": 10,
		  "totalTours": 16,
		  "totalDays": 478,
		  "totalCountries": 14,
		  "totalStates": 70,
		  "totalEvents": 299,
		  "eventPercent": 0.912398,
		  "totalScheduleItems": 3403,
		  "schedulePercent": 0.875567,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Backstage Concerts GmbH",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d7cf14c0b8c9eb404547a06a12b8605",
		  
		  "name": "Cris",
		  "createdDate": "2024-10-10 14:15:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 188,
		  "schedulePercent": 0.152085,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d7da1d7349eb5f2fa11117f88f7b3ed",
		  
		  "name": "Hayden",
		  "createdDate": "2012-09-26 06:31:23",
		  "totalOrganizations": 57,
		  "totalTours": 44,
		  "totalDays": 1551,
		  "totalCountries": 45,
		  "totalStates": 82,
		  "totalEvents": 432,
		  "eventPercent": 0.966908,
		  "totalScheduleItems": 6855,
		  "schedulePercent": 0.985154,
		  "totalGuests": 1163,
		  "guestPercent": 0.872507,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3d7e1f7d5b1aa74df2e02b8988d5ab47",
		  
		  "name": "Evan ",
		  "createdDate": "2021-01-05 23:38:10",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 342,
		  "totalCountries": 17,
		  "totalStates": 73,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 1878,
		  "schedulePercent": 0.690616,
		  "totalGuests": 754,
		  "guestPercent": 0.796917,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Live At Five",
		  "mostGuestCity": "Fairhope",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3db636fdf59772bb0bda76e769ee04ac",
		  
		  "name": "Amit",
		  "createdDate": "2023-11-29 19:33:39",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 102,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 786,
		  "schedulePercent": 0.417838,
		  "totalGuests": 103,
		  "guestPercent": 0.522779,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Soho House Toronto",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3dc11b96a3003ebb5583157de0170d2a",
		  
		  "name": "Dave",
		  "createdDate": "2017-11-29 18:47:53",
		  "totalOrganizations": 17,
		  "totalTours": 5,
		  "totalDays": 252,
		  "totalCountries": 17,
		  "totalStates": 47,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 3263,
		  "schedulePercent": 0.865367,
		  "totalGuests": 3261,
		  "guestPercent": 0.986741,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 160,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3dd450fc3de9a526139f974e13ff2fc9",
		  
		  "name": "JB",
		  "createdDate": "2013-09-15 21:13:14",
		  "totalOrganizations": 32,
		  "totalTours": 16,
		  "totalDays": 3589,
		  "totalCountries": 34,
		  "totalStates": 66,
		  "totalEvents": 285,
		  "eventPercent": 0.901859,
		  "totalScheduleItems": 5385,
		  "schedulePercent": 0.965775,
		  "totalGuests": 1993,
		  "guestPercent": 0.946736,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Kaseya Arena",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ddb78f2cb7471d00aea74890d187630",
		  
		  "name": "Karley",
		  "createdDate": "2024-08-20 18:00:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 362,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 693,
		  "schedulePercent": 0.383613,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "United Center",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ddcd03bd1c44d6a7654762d0685a363",
		  
		  "name": "Sebastian",
		  "createdDate": "2018-06-04 12:04:50",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 99,
		  "totalCountries": 25,
		  "totalStates": 27,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 1289,
		  "schedulePercent": 0.569356,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3dde11ba41bf4b17133fef24dfec8773",
		  
		  "name": "Matthias",
		  "createdDate": "2019-04-06 20:00:12",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 226,
		  "schedulePercent": 0.174977,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3de25c422fd14667727a61a007fe530d",
		  
		  "name": "Nathan",
		  "createdDate": "2023-07-25 13:21:11",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3de2ee13980b93139777d1ac51cb2701",
		  
		  "name": "NELLY",
		  "createdDate": "2025-03-25 00:04:12",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 276,
		  "totalCountries": 6,
		  "totalStates": 19,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 1864,
		  "schedulePercent": 0.687783,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3deb075a5cd34a9da49afc9d85da36af",
		  
		  "name": "Adrian",
		  "createdDate": "2023-03-27 18:12:30",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 103,
		  "totalCountries": 7,
		  "totalStates": 17,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 296,
		  "schedulePercent": 0.215549,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3df851a0e19c127f8b41f69e29c89802",
		  
		  "name": "sam",
		  "createdDate": "2022-02-19 01:08:58",
		  "totalOrganizations": 13,
		  "totalTours": 21,
		  "totalDays": 811,
		  "totalCountries": 32,
		  "totalStates": 77,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 5121,
		  "schedulePercent": 0.957842,
		  "totalGuests": 1355,
		  "guestPercent": 0.893812,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e042a3940d348e4811e9c2979fa3f26",
		  
		  "name": "Teddy",
		  "createdDate": "2023-05-09 06:22:38",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 253,
		  "totalCountries": 24,
		  "totalStates": 70,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2073,
		  "schedulePercent": 0.727675,
		  "totalGuests": 218,
		  "guestPercent": 0.607208,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "O2 Academy Islington",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e046b709d3a9ab987496e311f53d27c",
		  
		  "name": "Sean",
		  "createdDate": "2019-07-03 17:47:30",
		  "totalOrganizations": 18,
		  "totalTours": 18,
		  "totalDays": 545,
		  "totalCountries": 17,
		  "totalStates": 101,
		  "totalEvents": 277,
		  "eventPercent": 0.896079,
		  "totalScheduleItems": 2538,
		  "schedulePercent": 0.790798,
		  "totalGuests": 248,
		  "guestPercent": 0.624207,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Fred Kavli Theater",
		  "mostGuestCity": "Thousand Oaks",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e0f0d883f467520e4144890324d0179",
		  
		  "name": "Tracey",
		  "createdDate": "2017-11-08 00:58:40",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 167,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 854,
		  "schedulePercent": 0.44141,
		  "totalGuests": 169,
		  "guestPercent": 0.573096,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "T-Mobile Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e1599df4f71100ddfa7f67c9e653bcb",
		  
		  "name": "Michael",
		  "createdDate": "2016-12-30 07:11:30",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 241,
		  "schedulePercent": 0.184723,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e24c88ead634f83bc843e5f943693ae",
		  
		  "name": "Chris",
		  "createdDate": "2015-02-20 05:29:36",
		  "totalOrganizations": 13,
		  "totalTours": 29,
		  "totalDays": 1300,
		  "totalCountries": 29,
		  "totalStates": 76,
		  "totalEvents": 410,
		  "eventPercent": 0.961242,
		  "totalScheduleItems": 6650,
		  "schedulePercent": 0.983794,
		  "totalGuests": 1573,
		  "guestPercent": 0.916704,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 160,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e332eb60b89d8ae791467dc222651e6",
		  
		  "name": "Ninoshka",
		  "createdDate": "2024-04-13 20:41:00",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 498,
		  "totalCountries": 18,
		  "totalStates": 58,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 2581,
		  "schedulePercent": 0.795784,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e359eb3782baa3786c61b751ff249f8",
		  
		  "name": "Matt ",
		  "createdDate": "2024-06-04 11:03:54",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 52,
		  "totalCountries": 14,
		  "totalStates": 13,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 350,
		  "schedulePercent": 0.242974,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-02-23 00:00:00",
		  "mostGuestName": "Rough Trade East",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e36b83c3fba47b55495b9579d8bb8a4",
		  
		  "name": " Kevin ",
		  "createdDate": "2025-03-24 17:09:04",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 189,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 572,
		  "schedulePercent": 0.340435,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e38859d846413f7b2917ad5fa805b55",
		  
		  "name": "Chip",
		  "createdDate": "2017-01-05 00:59:20",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 458,
		  "totalCountries": 34,
		  "totalStates": 60,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1966,
		  "schedulePercent": 0.707049,
		  "totalGuests": 2028,
		  "guestPercent": 0.948889,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 106,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e4ff42628caa12c2dc37aa6ce82d4db",
		  
		  "name": "Admin",
		  "createdDate": "2022-03-18 19:13:30",
		  "totalOrganizations": 1,
		  "totalTours": 12,
		  "totalDays": 65,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 475,
		  "schedulePercent": 0.300091,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e5198dd31618be1c4781a769fe041df",
		  
		  "name": "Sam",
		  "createdDate": "2022-07-30 01:28:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Drifters Wharf",
		  "mostGuestCity": "Gosford",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e67a76a1b2a11ebe575e1038a6b0643",
		  
		  "name": "Arie",
		  "createdDate": "2019-02-26 00:51:33",
		  "totalOrganizations": 41,
		  "totalTours": 61,
		  "totalDays": 709,
		  "totalCountries": 40,
		  "totalStates": 87,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 3346,
		  "schedulePercent": 0.87092,
		  "totalGuests": 665,
		  "guestPercent": 0.775725,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e7d9017525f9a46d6fe1b4e8b39e56c",
		  
		  "name": "Jordan",
		  "createdDate": "2021-10-27 21:46:21",
		  "totalOrganizations": 14,
		  "totalTours": 10,
		  "totalDays": 1727,
		  "totalCountries": 23,
		  "totalStates": 76,
		  "totalEvents": 269,
		  "eventPercent": 0.889393,
		  "totalScheduleItems": 4144,
		  "schedulePercent": 0.921691,
		  "totalGuests": 1546,
		  "guestPercent": 0.914325,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Fox Cabaret",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e8251c24e7ee2215b0c9ed903b28d35",
		  
		  "name": "Lauren",
		  "createdDate": "2025-02-02 21:22:43",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 1010,
		  "totalCountries": 16,
		  "totalStates": 34,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 344,
		  "schedulePercent": 0.240254,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e8c38a74e2c79e8bc8d2cabc7c64566",
		  
		  "name": "David",
		  "createdDate": "2015-12-03 05:44:40",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 1602,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 1840,
		  "schedulePercent": 0.683137,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Fantasy Springs Casino",
		  "mostGuestCity": "Indio",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e8f4b08016d0582a0ce2ab1fd6f9476",
		  
		  "name": "Jose",
		  "createdDate": "2019-06-19 19:29:52",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 806,
		  "totalCountries": 17,
		  "totalStates": 39,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 563,
		  "schedulePercent": 0.338282,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3e9267ca4c193172bc8f08ec56d4a208",
		  
		  "name": "Chloe",
		  "createdDate": "2019-09-27 15:46:43",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 362,
		  "totalCountries": 8,
		  "totalStates": 21,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 630,
		  "schedulePercent": 0.360834,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Coca-Cola Roxy",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3eaa400222c8c42db2c24c64d8e44ec8",
		  
		  "name": "Eric",
		  "createdDate": "2025-03-15 05:19:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 173,
		  "schedulePercent": 0.142452,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Capitol Theatre",
		  "mostGuestCity": "Port Chester",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3eada0ff3758742a684ad7aeac35cd8d",
		  
		  "name": "Daniel",
		  "createdDate": "2024-06-12 09:54:41",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Cirkus Arena",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3eb7ae01a92e734ff41ca22fe8b0bc27",
		  
		  "name": "Sesame Stage Manager",
		  "createdDate": "2024-03-11 15:58:07",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 219,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2072,
		  "schedulePercent": 0.727335,
		  "totalGuests": 471,
		  "guestPercent": 0.720762,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3eb88937bb3df3674f929df980a179bf",
		  
		  "name": "Lasse",
		  "createdDate": "2014-02-21 10:45:35",
		  "totalOrganizations": 36,
		  "totalTours": 8,
		  "totalDays": 549,
		  "totalCountries": 7,
		  "totalStates": 9,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 1442,
		  "schedulePercent": 0.606188,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "Burgsvik GrÃ¥ GÃ¥sen",
		  "mostGuestCity": "Burgsvik",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ebc21b2d9d692e30f7fb84ff04d4e70",
		  
		  "name": "Jonathan",
		  "createdDate": "2019-01-15 22:15:31",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 720,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 3761,
		  "schedulePercent": 0.899479,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ec1e66be4404f76899a898ed7d975a5",
		  
		  "name": "Imanol",
		  "createdDate": "2022-08-29 14:29:28",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 398,
		  "totalCountries": 4,
		  "totalStates": 24,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1187,
		  "schedulePercent": 0.543744,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Magnific Festival",
		  "mostGuestCity": "",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ecc5dae57f6cc20ff9e6fdb09d2a2c3",
		  
		  "name": "Aron",
		  "createdDate": "2023-09-05 23:52:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 369,
		  "totalCountries": 8,
		  "totalStates": 34,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1145,
		  "schedulePercent": 0.533092,
		  "totalGuests": 147,
		  "guestPercent": 0.556324,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "Patchogue Theatre for the Performing Arts",
		  "mostGuestCity": "Patchogue",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3eccb6d64a08d51af5e105e00e7f867f",
		  
		  "name": "Marilyn",
		  "createdDate": "2018-01-04 23:33:27",
		  "totalOrganizations": 15,
		  "totalTours": 2,
		  "totalDays": 97,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 396,
		  "schedulePercent": 0.267452,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ecdbe66727954ccf646ca790abb8ab5",
		  
		  "name": "Chris",
		  "createdDate": "2011-09-26 20:33:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 4,
		  "totalStates": 31,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 927,
		  "schedulePercent": 0.467362,
		  "totalGuests": 169,
		  "guestPercent": 0.573096,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Daily's Place",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ed1574070c7ec34b0b3eb0e675d8ac8",
		  
		  "name": "Christopher",
		  "createdDate": "2022-01-07 00:36:35",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 553,
		  "totalCountries": 24,
		  "totalStates": 72,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 2406,
		  "schedulePercent": 0.775725,
		  "totalGuests": 277,
		  "guestPercent": 0.638599,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Infinity Hall Hartford",
		  "mostGuestCity": "Hartford",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3edd1f8b17973546f5c71388f25e02cb",
		  
		  "name": "Ryan",
		  "createdDate": "2023-03-02 20:05:09",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 205,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1371,
		  "schedulePercent": 0.589529,
		  "totalGuests": 271,
		  "guestPercent": 0.635653,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3eeca38e7abccad5d005d91186efbc69",
		  
		  "name": "Jake",
		  "createdDate": "2017-04-10 20:14:03",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 982,
		  "totalCountries": 24,
		  "totalStates": 83,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 3535,
		  "schedulePercent": 0.884066,
		  "totalGuests": 957,
		  "guestPercent": 0.840209,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "TQL Stadium",
		  "mostGuestCity": "Cincinnati",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3efb88fcc633d5d6b75750e6efcdfd43",
		  
		  "name": "Jaden",
		  "createdDate": "2023-11-15 21:01:30",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 369,
		  "totalCountries": 18,
		  "totalStates": 56,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 2664,
		  "schedulePercent": 0.804057,
		  "totalGuests": 1867,
		  "guestPercent": 0.937217,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3eff9b602d77baf98b1f0b3eb83a5a31",
		  
		  "name": "Douglas",
		  "createdDate": "2011-02-18 17:42:26",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 490,
		  "totalCountries": 8,
		  "totalStates": 47,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 2758,
		  "schedulePercent": 0.817203,
		  "totalGuests": 1502,
		  "guestPercent": 0.908885,
		  "mostGuestDate": "2025-07-16 00:00:00",
		  "mostGuestName": "The Criterion",
		  "mostGuestCity": "Oklahoma City",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f008c78a141260956afd46f45ba4f8c",
		  
		  "name": "CLAUDINE",
		  "createdDate": "2024-05-21 09:26:47",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 842,
		  "totalCountries": 14,
		  "totalStates": 19,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 811,
		  "schedulePercent": 0.427357,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Grand ThÃ©Ã¢tre de QuÃ©bec",
		  "mostGuestCity": "QuÃ©bec",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f02859597feeb6210a5e40cd672e1f9",
		  
		  "name": "Katharina",
		  "createdDate": "2009-11-02 15:37:29",
		  "totalOrganizations": 8,
		  "totalTours": 22,
		  "totalDays": 1762,
		  "totalCountries": 39,
		  "totalStates": 85,
		  "totalEvents": 405,
		  "eventPercent": 0.959995,
		  "totalScheduleItems": 7548,
		  "schedulePercent": 0.988781,
		  "totalGuests": 1217,
		  "guestPercent": 0.87772,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f069d65967f64269bdab8fc53a5b353",
		  
		  "name": "Peyton",
		  "createdDate": "2016-06-02 00:34:41",
		  "totalOrganizations": 19,
		  "totalTours": 13,
		  "totalDays": 403,
		  "totalCountries": 22,
		  "totalStates": 56,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 3630,
		  "schedulePercent": 0.891432,
		  "totalGuests": 638,
		  "guestPercent": 0.768812,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f07ae060926e9fde26e974b02c2f064",
		  
		  "name": "Tyler",
		  "createdDate": "2022-02-12 05:00:43",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 625,
		  "schedulePercent": 0.359134,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f1be99b366c1a3159806e979575ebc6",
		  
		  "name": "Ahmed",
		  "createdDate": "2024-08-16 13:36:34",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 95,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 368,
		  "schedulePercent": 0.252153,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Bohemian National Cemetary",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f201e87c2f8fd88728136a1d701a723",
		  
		  "name": "Teisha",
		  "createdDate": "2016-04-05 15:31:57",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 877,
		  "totalCountries": 9,
		  "totalStates": 50,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 3064,
		  "schedulePercent": 0.848595,
		  "totalGuests": 1197,
		  "guestPercent": 0.875793,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f311d6a5337a8ca2ec91fd69f377eb1",
		  
		  "name": "Dillon",
		  "createdDate": "2016-04-12 21:51:36",
		  "totalOrganizations": 21,
		  "totalTours": 6,
		  "totalDays": 414,
		  "totalCountries": 14,
		  "totalStates": 49,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2531,
		  "schedulePercent": 0.790005,
		  "totalGuests": 1904,
		  "guestPercent": 0.94005,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f3aac07859208d78e13eae7b465bcc2",
		  
		  "name": "Lotta ",
		  "createdDate": "2025-08-30 20:35:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 109,
		  "schedulePercent": 0.105054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f4164f39a8e4558fd15d23439d1d810",
		  
		  "name": "Emil Sheriff ",
		  "createdDate": "2024-12-10 10:18:55",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 100,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 598,
		  "schedulePercent": 0.350521,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f42f69202fecba4e4800723ff8678e4",
		  
		  "name": "Duke",
		  "createdDate": "2013-01-10 17:48:25",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 115,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 440,
		  "schedulePercent": 0.286491,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Jackson-Triggs",
		  "mostGuestCity": "Niagara-on-the-Lake",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f49bee456dfb76298dcb8d866b6118b",
		  
		  "name": "Brendan",
		  "createdDate": "2017-03-28 21:43:38",
		  "totalOrganizations": 20,
		  "totalTours": 15,
		  "totalDays": 673,
		  "totalCountries": 21,
		  "totalStates": 70,
		  "totalEvents": 286,
		  "eventPercent": 0.902765,
		  "totalScheduleItems": 4589,
		  "schedulePercent": 0.94073,
		  "totalGuests": 1695,
		  "guestPercent": 0.928037,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f4a1efc56bdca5ea7e2be95ac3f4a74",
		  
		  "name": "Sten",
		  "createdDate": "2011-05-27 14:06:26",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 746,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 202,
		  "eventPercent": 0.804397,
		  "totalScheduleItems": 1990,
		  "schedulePercent": 0.711695,
		  "totalGuests": 763,
		  "guestPercent": 0.798957,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "San Antonio Stock Show & Rodeo",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f4dbe069868212bc0995bd4093a4e6d",
		  
		  "name": "Steven",
		  "createdDate": "2021-11-08 17:03:04",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 293,
		  "totalCountries": 27,
		  "totalStates": 50,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 3657,
		  "schedulePercent": 0.893132,
		  "totalGuests": 3112,
		  "guestPercent": 0.984134,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f656c3e019eca5d03e8708be5cbbea3",
		  
		  "name": "Marcus",
		  "createdDate": "2017-02-14 16:14:31",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 589,
		  "totalCountries": 19,
		  "totalStates": 74,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 2018,
		  "schedulePercent": 0.717022,
		  "totalGuests": 1108,
		  "guestPercent": 0.865594,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Fox Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f7d3493d2ce01ca4feeae194c6fae40",
		  
		  "name": "Alan",
		  "createdDate": "2024-09-19 00:33:57",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 85,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f7eed956814656bb39b81394d35ffe5",
		  
		  "name": "Juanita ",
		  "createdDate": "2023-09-18 19:24:12",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 514,
		  "totalCountries": 7,
		  "totalStates": 24,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 549,
		  "schedulePercent": 0.334089,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Gainbridge Fieldhouse",
		  "mostGuestCity": "Indianapolis",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f8368e7e9fcb96f7b3ff32cf6bc5d80",
		  
		  "name": "Hector",
		  "createdDate": "2024-11-19 17:11:54",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 566,
		  "totalCountries": 8,
		  "totalStates": 11,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 770,
		  "schedulePercent": 0.412285,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3f9a46e4bbf1ff6b42c5cd5b6c43b3dd",
		  
		  "name": "Gabriel",
		  "createdDate": "2012-05-10 15:06:16",
		  "totalOrganizations": 8,
		  "totalTours": 25,
		  "totalDays": 214,
		  "totalCountries": 9,
		  "totalStates": 46,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1808,
		  "schedulePercent": 0.677584,
		  "totalGuests": 688,
		  "guestPercent": 0.782978,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3fa49a735e620a837a092d558cd089f7",
		  
		  "name": "Lindsay",
		  "createdDate": "2017-12-09 20:20:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 135,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 366,
		  "schedulePercent": 0.25136,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3fb5cfc82958fab590a1328c18fb8999",
		  
		  "name": "Jacob",
		  "createdDate": "2025-01-27 20:38:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 338,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 493,
		  "schedulePercent": 0.30927,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3fcbb76c031a8a095feeb0475eda513c",
		  
		  "name": "Karin ",
		  "createdDate": "2017-12-06 10:50:22",
		  "totalOrganizations": 14,
		  "totalTours": 2,
		  "totalDays": 83,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 308,
		  "schedulePercent": 0.221782,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3fcdad8a03d424b9fb7967c9ada7cd5f",
		  
		  "name": "Kirsten",
		  "createdDate": "2021-07-30 15:38:22",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 648,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 924,
		  "schedulePercent": 0.466455,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Mahaiwe PAC",
		  "mostGuestCity": "Great Barrington",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3fd98f386d6ba37a060071fcbafa010e",
		  
		  "name": "Stew",
		  "createdDate": "2023-03-29 06:59:14",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 373,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1792,
		  "schedulePercent": 0.675317,
		  "totalGuests": 535,
		  "guestPercent": 0.738894,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Pine Creek Lodge",
		  "mostGuestCity": "Livingston",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3fde8533f25f1fcbb99e50c05f78ec0b",
		  
		  "name": "Stu",
		  "createdDate": "2016-01-15 17:51:04",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 9,
		  "totalStates": 13,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 469,
		  "schedulePercent": 0.297937,
		  "totalGuests": 490,
		  "guestPercent": 0.727561,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ff2d669b2c416f48dd366401b2db60a",
		  
		  "name": "CJ",
		  "createdDate": "2022-08-22 21:45:22",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 110,
		  "totalCountries": 11,
		  "totalStates": 27,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 377,
		  "schedulePercent": 0.256346,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "The Roxy Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ff65451ed293036d50f612eb753f688",
		  
		  "name": "Megan",
		  "createdDate": "2017-11-20 03:11:55",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 789,
		  "totalCountries": 17,
		  "totalStates": 66,
		  "totalEvents": 301,
		  "eventPercent": 0.913645,
		  "totalScheduleItems": 5222,
		  "schedulePercent": 0.960222,
		  "totalGuests": 1451,
		  "guestPercent": 0.904692,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Cardiff Utilita Arena",
		  "mostGuestCity": "Cardiff",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ff66abf9a8314a2158d43d7d39ed1c8",
		  
		  "name": "Christian",
		  "createdDate": "2021-09-20 17:49:04",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 745,
		  "totalCountries": 18,
		  "totalStates": 44,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1268,
		  "schedulePercent": 0.56539,
		  "totalGuests": 463,
		  "guestPercent": 0.716455,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Barclays Center",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ff976c55f9306e1dd139cd1d8aa46ac",
		  
		  "name": "Phil",
		  "createdDate": "2015-09-23 10:13:24",
		  "totalOrganizations": 72,
		  "totalTours": 33,
		  "totalDays": 597,
		  "totalCountries": 19,
		  "totalStates": 56,
		  "totalEvents": 248,
		  "eventPercent": 0.868654,
		  "totalScheduleItems": 3213,
		  "schedulePercent": 0.861174,
		  "totalGuests": 605,
		  "guestPercent": 0.759973,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ffa0f38b0f8cf4daad0824a71f2390d",
		  
		  "name": "Connor",
		  "createdDate": "2019-05-27 01:01:12",
		  "totalOrganizations": 16,
		  "totalTours": 15,
		  "totalDays": 735,
		  "totalCountries": 36,
		  "totalStates": 91,
		  "totalEvents": 360,
		  "eventPercent": 0.94617,
		  "totalScheduleItems": 5788,
		  "schedulePercent": 0.972688,
		  "totalGuests": 3119,
		  "guestPercent": 0.984361,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ffafe4a5c97eadbfa77409092b06e3f",
		  
		  "name": "Sophie",
		  "createdDate": "2023-12-03 23:07:28",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 443,
		  "totalCountries": 5,
		  "totalStates": 26,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 496,
		  "schedulePercent": 0.310403,
		  "totalGuests": 1212,
		  "guestPercent": 0.87704,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 171,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "3ffcde1cb38a0785a5e356bf5419a476",
		  
		  "name": "Amber",
		  "createdDate": "2014-02-25 00:23:28",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 847,
		  "totalCountries": 38,
		  "totalStates": 79,
		  "totalEvents": 230,
		  "eventPercent": 0.848595,
		  "totalScheduleItems": 3186,
		  "schedulePercent": 0.858454,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-03-03 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "400dc10405ef55faffa0075d897c5c84",
		  
		  "name": "Chelsea",
		  "createdDate": "2013-06-03 01:40:29",
		  "totalOrganizations": 8,
		  "totalTours": 20,
		  "totalDays": 364,
		  "totalCountries": 33,
		  "totalStates": 67,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2381,
		  "schedulePercent": 0.772892,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "400e2f3f9f8620faefccac43d96790f0",
		  
		  "name": "Zac",
		  "createdDate": "2024-06-11 20:34:14",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 211,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 604,
		  "schedulePercent": 0.352335,
		  "totalGuests": 93,
		  "guestPercent": 0.511786,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40105d67f8ce9edef82abfd3d7960ce3",
		  
		  "name": "MaryKirk",
		  "createdDate": "2019-08-22 14:53:55",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 169,
		  "totalCountries": 4,
		  "totalStates": 30,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 1017,
		  "schedulePercent": 0.495354,
		  "totalGuests": 544,
		  "guestPercent": 0.741727,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "402c3488f2df22b65bb694030ce207bb",
		  
		  "name": "Robert",
		  "createdDate": "2017-06-27 16:35:31",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 125,
		  "totalCountries": 4,
		  "totalStates": 31,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 479,
		  "schedulePercent": 0.302357,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Guernsey County Fairgrounds",
		  "mostGuestCity": "Old Washington",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4033a721807084a0590266cec4c20310",
		  
		  "name": "Kory",
		  "createdDate": "2023-02-28 23:07:22",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 171,
		  "totalCountries": 15,
		  "totalStates": 40,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 934,
		  "schedulePercent": 0.470648,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "403e0b443f7fee6bbfcfbdcd6663dc00",
		  
		  "name": "Jake",
		  "createdDate": "2019-09-10 21:47:43",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 982,
		  "totalCountries": 10,
		  "totalStates": 47,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 3027,
		  "schedulePercent": 0.844742,
		  "totalGuests": 156,
		  "guestPercent": 0.563577,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4040cec7788c7caf81173061f3184604",
		  
		  "name": "Jess",
		  "createdDate": "2022-03-03 18:52:10",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 814,
		  "totalCountries": 8,
		  "totalStates": 50,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1208,
		  "schedulePercent": 0.548844,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "404eec67014fc3ea4da83dba43f1a8a0",
		  
		  "name": "Keaton",
		  "createdDate": "2021-12-06 05:52:20",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 377,
		  "totalCountries": 11,
		  "totalStates": 44,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1290,
		  "schedulePercent": 0.569583,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "406294c397cd8a69d409a12639034e67",
		  
		  "name": "Kelly",
		  "createdDate": "2024-09-11 17:51:05",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 374,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1122,
		  "schedulePercent": 0.525499,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Cat's Cradle",
		  "mostGuestCity": "Carrboro",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "406e294a6cf6d2bbb75e6e148f1f815d",
		  
		  "name": "Lennox",
		  "createdDate": "2025-10-28 13:06:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40706fd8f343358a63acd32a75c1aaeb",
		  
		  "name": "Associate",
		  "createdDate": "2024-02-20 15:19:24",
		  "totalOrganizations": 1,
		  "totalTours": 32,
		  "totalDays": 767,
		  "totalCountries": 23,
		  "totalStates": 25,
		  "totalEvents": 487,
		  "eventPercent": 0.976315,
		  "totalScheduleItems": 5374,
		  "schedulePercent": 0.964982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "407f29c721f9c8bfc0af44a3f55c3099",
		  
		  "name": "Erin",
		  "createdDate": "2017-05-19 01:09:58",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 146,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1118,
		  "schedulePercent": 0.524025,
		  "totalGuests": 717,
		  "guestPercent": 0.789665,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40876a26dc9ece65b3cc20372388a0b1",
		  
		  "name": "Emily",
		  "createdDate": "2025-07-22 10:22:20",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 125,
		  "totalCountries": 9,
		  "totalStates": 8,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4089c1009f42ae6adc0ce60924d10a3a",
		  
		  "name": "Troy",
		  "createdDate": "2018-11-25 00:59:54",
		  "totalOrganizations": 33,
		  "totalTours": 24,
		  "totalDays": 1119,
		  "totalCountries": 17,
		  "totalStates": 62,
		  "totalEvents": 303,
		  "eventPercent": 0.914665,
		  "totalScheduleItems": 4025,
		  "schedulePercent": 0.914891,
		  "totalGuests": 488,
		  "guestPercent": 0.726995,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "408eeca2c7a11ce8f079d9ee3a9192ec",
		  
		  "name": "Derek",
		  "createdDate": "2014-11-10 11:13:53",
		  "totalOrganizations": 16,
		  "totalTours": 8,
		  "totalDays": 245,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1136,
		  "schedulePercent": 0.530485,
		  "totalGuests": 178,
		  "guestPercent": 0.579102,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Mercury Lounge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40a5c5ba250d7aa2ecc468a4e211b4c4",
		  
		  "name": "William",
		  "createdDate": "2024-06-22 19:55:17",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 37,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40aa6ddf6b7376b9eb57e61acb137649",
		  
		  "name": "Andri",
		  "createdDate": "2023-03-15 12:35:32",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 173,
		  "totalCountries": 6,
		  "totalStates": 21,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 700,
		  "schedulePercent": 0.386786,
		  "totalGuests": 312,
		  "guestPercent": 0.654918,
		  "mostGuestDate": "2025-02-05 00:00:00",
		  "mostGuestName": "Kaufleuten",
		  "mostGuestCity": "ZÃ¼rich",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40b09cf1a8da9d09a4d75a11d5415826",
		  
		  "name": "Alexis",
		  "createdDate": "2016-09-01 20:14:14",
		  "totalOrganizations": 22,
		  "totalTours": 27,
		  "totalDays": 545,
		  "totalCountries": 11,
		  "totalStates": 41,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 3713,
		  "schedulePercent": 0.896872,
		  "totalGuests": 197,
		  "guestPercent": 0.592362,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40b4ffd40a585c73d648cbe9749fd17c",
		  
		  "name": "Elessa",
		  "createdDate": "2022-02-25 12:48:37",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 461,
		  "totalCountries": 20,
		  "totalStates": 58,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2320,
		  "schedulePercent": 0.764959,
		  "totalGuests": 1265,
		  "guestPercent": 0.882026,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40b5cb54d1f113f48888867794a95571",
		  
		  "name": "Ollie",
		  "createdDate": "2016-10-15 03:02:38",
		  "totalOrganizations": 19,
		  "totalTours": 17,
		  "totalDays": 919,
		  "totalCountries": 13,
		  "totalStates": 48,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 3834,
		  "schedulePercent": 0.904692,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40bb332b0f7751d5836702b4c10e1d54",
		  
		  "name": "Heather ",
		  "createdDate": "2017-03-11 18:20:19",
		  "totalOrganizations": 5,
		  "totalTours": 27,
		  "totalDays": 1900,
		  "totalCountries": 13,
		  "totalStates": 46,
		  "totalEvents": 274,
		  "eventPercent": 0.894719,
		  "totalScheduleItems": 2741,
		  "schedulePercent": 0.81505,
		  "totalGuests": 223,
		  "guestPercent": 0.608568,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Jazz Cafe",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40be575453e64abd6fb67e491f16c75c",
		  
		  "name": "Nick",
		  "createdDate": "2010-03-05 19:32:45",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 285,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1666,
		  "schedulePercent": 0.652312,
		  "totalGuests": 1083,
		  "guestPercent": 0.861287,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40c21f6f735c79462bb13590b5484b83",
		  
		  "name": "Gavin",
		  "createdDate": "2024-07-03 00:45:24",
		  "totalOrganizations": 2,
		  "totalTours": 13,
		  "totalDays": 187,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 449,
		  "schedulePercent": 0.290345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40c237b083add8256b95e4a4a517a612",
		  
		  "name": "Tanya",
		  "createdDate": "2025-03-18 20:46:17",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 81,
		  "totalCountries": 24,
		  "totalStates": 20,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 937,
		  "schedulePercent": 0.471328,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "THE HALL",
		  "mostGuestCity": "DÃ¼bendorf",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40ca3914c0b4164e5177b0425a399f9f",
		  
		  "name": "Bianca",
		  "createdDate": "2019-07-23 02:06:08",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 899,
		  "totalCountries": 38,
		  "totalStates": 63,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 2695,
		  "schedulePercent": 0.80825,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Lollapalooza Festival Argentina",
		  "mostGuestCity": "San Isidro",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40ca5fdd7e9f3b96d414e99731d22e93",
		  
		  "name": "Drew",
		  "createdDate": "2019-07-25 18:56:48",
		  "totalOrganizations": 17,
		  "totalTours": 13,
		  "totalDays": 1084,
		  "totalCountries": 14,
		  "totalStates": 61,
		  "totalEvents": 316,
		  "eventPercent": 0.923164,
		  "totalScheduleItems": 4180,
		  "schedulePercent": 0.924637,
		  "totalGuests": 846,
		  "guestPercent": 0.818903,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40cd571b32c3246334e8bae6231a1a1d",
		  
		  "name": "Daniel",
		  "createdDate": "2022-01-17 16:35:14",
		  "totalOrganizations": 6,
		  "totalTours": 15,
		  "totalDays": 567,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2957,
		  "schedulePercent": 0.837715,
		  "totalGuests": 1048,
		  "guestPercent": 0.853694,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Levitate Music and Arts Festival",
		  "mostGuestCity": "Marshfield",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40d20f192683aa00b342d05124eb0ff4",
		  
		  "name": "Marika",
		  "createdDate": "2025-03-19 16:51:55",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 65,
		  "totalCountries": 16,
		  "totalStates": 12,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 364,
		  "schedulePercent": 0.25,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Leeds Irish Centre",
		  "mostGuestCity": "Leeds",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40d867583cd3b1ded6ad39c3b301bbb4",
		  
		  "name": "Selina",
		  "createdDate": "2022-10-18 08:24:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 79,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 180,
		  "schedulePercent": 0.146419,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40da358dbf81006edfbef43eaa68579d",
		  
		  "name": "Bill",
		  "createdDate": "2017-11-11 22:49:32",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 55,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40e313855d3131c9cc5b841eaaf74bf5",
		  
		  "name": "Sandra",
		  "createdDate": "2023-01-13 11:37:10",
		  "totalOrganizations": 43,
		  "totalTours": 43,
		  "totalDays": 655,
		  "totalCountries": 17,
		  "totalStates": 27,
		  "totalEvents": 430,
		  "eventPercent": 0.966002,
		  "totalScheduleItems": 3406,
		  "schedulePercent": 0.875907,
		  "totalGuests": 268,
		  "guestPercent": 0.6335,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Banan-Kompaniet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40e81d19bdabde7a54f6418d481460aa",
		  
		  "name": "Jake",
		  "createdDate": "2018-03-23 11:56:45",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 461,
		  "totalCountries": 21,
		  "totalStates": 36,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 5245,
		  "schedulePercent": 0.960675,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "40f8aae9e6eeb5c13a964be7526e25d4",
		  
		  "name": "Tamara",
		  "createdDate": "2019-06-18 14:16:15",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 198,
		  "totalCountries": 7,
		  "totalStates": 5,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41055ab7f4d32611eee799d8fbca41ba",
		  
		  "name": "Tom",
		  "createdDate": "2012-10-06 02:02:17",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 383,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2551,
		  "schedulePercent": 0.792838,
		  "totalGuests": 2345,
		  "guestPercent": 0.963509,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Northrop Auditorium",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "410ad29c396d5e68285be8218112b8b0",
		  
		  "name": "Don",
		  "createdDate": "2012-03-29 19:02:49",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 105,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 485,
		  "schedulePercent": 0.30383,
		  "totalGuests": 1604,
		  "guestPercent": 0.920331,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "410ed7bd4c0a5bee1dc6a54d91122bc4",
		  
		  "name": "Alyssa",
		  "createdDate": "2018-04-02 06:49:10",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 48,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 241,
		  "schedulePercent": 0.184723,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Hampton Pool",
		  "mostGuestCity": "Hampton",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "411e8e9323f7d6d6bc517bca376b9393",
		  
		  "name": "Jesus",
		  "createdDate": "2016-06-29 10:01:23",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 8,
		  "totalStates": 9,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 282,
		  "schedulePercent": 0.206936,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "PALACIO DE LA MÃšSICA",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "412138db5f366109bad05c0f77306721",
		  
		  "name": "Olivia",
		  "createdDate": "2025-05-15 17:36:28",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 338,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41220b50f6ea50c8563c5cb646653fe2",
		  
		  "name": "Jacob",
		  "createdDate": "2025-02-17 18:26:58",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 96,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 144,
		  "schedulePercent": 0.127267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41224557b268494889f932f95b9bd5b8",
		  
		  "name": "360x",
		  "createdDate": "2024-10-18 07:07:07",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 261,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "412a1a19bd445751fac172256d88c564",
		  
		  "name": "Christopher",
		  "createdDate": "2022-02-11 18:27:52",
		  "totalOrganizations": 18,
		  "totalTours": 25,
		  "totalDays": 1220,
		  "totalCountries": 19,
		  "totalStates": 45,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 1269,
		  "schedulePercent": 0.565503,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Auditorium Parco Della Musica - Sala Sinopoli",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "412ce25f6eaccd084463325267ac36c7",
		  
		  "name": "Mike",
		  "createdDate": "2023-09-05 20:36:50",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 121,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 743,
		  "schedulePercent": 0.402312,
		  "totalGuests": 405,
		  "guestPercent": 0.69617,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "412d38470aed3673ff0e4ba23059a9a8",
		  
		  "name": "Abbey",
		  "createdDate": "2025-03-25 04:00:02",
		  "totalOrganizations": 74,
		  "totalTours": 66,
		  "totalDays": 768,
		  "totalCountries": 7,
		  "totalStates": 20,
		  "totalEvents": 443,
		  "eventPercent": 0.969062,
		  "totalScheduleItems": 1599,
		  "schedulePercent": 0.640526,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "413a8fd063f20d93fc2ba3677aef5557",
		  
		  "name": "GARY",
		  "createdDate": "2013-07-21 11:21:57",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 353,
		  "totalCountries": 23,
		  "totalStates": 58,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2144,
		  "schedulePercent": 0.738781,
		  "totalGuests": 1073,
		  "guestPercent": 0.858681,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4143138f4f1760c1b4c13c057b11cc38",
		  
		  "name": "Maxime",
		  "createdDate": "2022-09-21 16:01:25",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 100,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 477,
		  "schedulePercent": 0.301677,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4149f440572c17c39f1079a285f394de",
		  
		  "name": "Nate",
		  "createdDate": "2025-04-15 03:11:32",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 135,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1594,
		  "schedulePercent": 0.639393,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "414ce640d823ba6a852f1efef5dbbc1f",
		  
		  "name": "Justin",
		  "createdDate": "2016-01-25 10:42:16",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 390,
		  "totalCountries": 17,
		  "totalStates": 67,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 2489,
		  "schedulePercent": 0.785811,
		  "totalGuests": 1363,
		  "guestPercent": 0.895286,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Salt Shed",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41618d5946f81532f5364d6a1cb1b915",
		  
		  "name": "Kirsty",
		  "createdDate": "2024-09-12 23:33:14",
		  "totalOrganizations": 3,
		  "totalTours": 18,
		  "totalDays": 569,
		  "totalCountries": 23,
		  "totalStates": 93,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 3016,
		  "schedulePercent": 0.843608,
		  "totalGuests": 899,
		  "guestPercent": 0.830122,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4162e6d0b05a0289b05aa3bc8b1911f4",
		  
		  "name": "Boyd",
		  "createdDate": "2025-03-11 21:44:11",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 849,
		  "totalCountries": 9,
		  "totalStates": 60,
		  "totalEvents": 256,
		  "eventPercent": 0.876927,
		  "totalScheduleItems": 4466,
		  "schedulePercent": 0.936763,
		  "totalGuests": 639,
		  "guestPercent": 0.769152,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "House of Blues Boston",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4170b7587ef849a08130b963f9cd7b86",
		  
		  "name": "Olivia",
		  "createdDate": "2024-08-20 11:31:01",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 627,
		  "totalCountries": 6,
		  "totalStates": 28,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 503,
		  "schedulePercent": 0.313123,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4170eb23e50859a9ae246f01c6d2f33d",
		  
		  "name": "Brittany",
		  "createdDate": "2024-07-12 21:52:16",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 411,
		  "totalCountries": 25,
		  "totalStates": 62,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 2768,
		  "schedulePercent": 0.817883,
		  "totalGuests": 1525,
		  "guestPercent": 0.912625,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "417b48ca75ca81f6c92557c30f2fdd4f",
		  
		  "name": "HervÃ©",
		  "createdDate": "2019-11-21 13:56:44",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 124,
		  "totalCountries": 10,
		  "totalStates": 14,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 550,
		  "schedulePercent": 0.334542,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4184132ff2544e87234b9eda2bb5c2a2",
		  
		  "name": "Nathan",
		  "createdDate": "2017-06-14 04:00:18",
		  "totalOrganizations": 22,
		  "totalTours": 25,
		  "totalDays": 777,
		  "totalCountries": 24,
		  "totalStates": 58,
		  "totalEvents": 259,
		  "eventPercent": 0.881006,
		  "totalScheduleItems": 3394,
		  "schedulePercent": 0.874773,
		  "totalGuests": 1069,
		  "guestPercent": 0.857774,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "PICA (Port Melbourne Industrial Centre for the Arts)",
		  "mostGuestCity": "Port Melbourne",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41843182f00f97dabfaee27bc8bcbb17",
		  
		  "name": "Teeks",
		  "createdDate": "2023-04-15 10:47:39",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 794,
		  "totalCountries": 12,
		  "totalStates": 11,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 1001,
		  "schedulePercent": 0.490594,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "418f277ea993466e3a422705b5f2ab2b",
		  
		  "name": "Beebe",
		  "createdDate": "2023-03-07 22:25:57",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 412,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1590,
		  "schedulePercent": 0.638373,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4199559b433b3bd36201854cceff4cbd",
		  
		  "name": "Maddie",
		  "createdDate": "2023-07-23 14:31:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 949,
		  "schedulePercent": 0.475181,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "419e29ec8a06f0b6fc5e68385c5c46ee",
		  
		  "name": "Harry",
		  "createdDate": "2016-04-19 04:27:43",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 401,
		  "totalCountries": 14,
		  "totalStates": 40,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 3388,
		  "schedulePercent": 0.874547,
		  "totalGuests": 1000,
		  "guestPercent": 0.845875,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41b25ef400e90c1ca6867f65594752b0",
		  
		  "name": "Ying",
		  "createdDate": "2017-08-16 12:06:57",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 354,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 2194,
		  "schedulePercent": 0.747167,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Margaret Court Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41b7161a5fdd285bfeac27b91cae73b2",
		  
		  "name": "Andre",
		  "createdDate": "2018-01-23 18:55:44",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 447,
		  "totalCountries": 19,
		  "totalStates": 8,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1918,
		  "schedulePercent": 0.697416,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41ba5ac7c1d7d88cb0c73f428d86aacd",
		  
		  "name": "Tahlia",
		  "createdDate": "2021-04-12 23:48:00",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 344,
		  "schedulePercent": 0.240254,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Young Showground Camping",
		  "mostGuestCity": "Young",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41c90055fb1660d27e5fa41ec3984dd9",
		  
		  "name": "Gary",
		  "createdDate": "2010-04-05 22:19:00",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 254,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1188,
		  "schedulePercent": 0.544084,
		  "totalGuests": 205,
		  "guestPercent": 0.598368,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "The Brighton Centre",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41d3c415065f9ec01fc625d084940705",
		  
		  "name": "Rota",
		  "createdDate": "2022-09-11 15:48:50",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 164,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 730,
		  "schedulePercent": 0.397892,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41e0d3b9dbe2f5687e1bf1dd03258b3d",
		  
		  "name": "Robert",
		  "createdDate": "2015-06-03 19:43:52",
		  "totalOrganizations": 14,
		  "totalTours": 7,
		  "totalDays": 586,
		  "totalCountries": 12,
		  "totalStates": 21,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1227,
		  "schedulePercent": 0.55383,
		  "totalGuests": 342,
		  "guestPercent": 0.671691,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41e1a54ff3a17611439bad2ec055f4da",
		  
		  "name": "Ben",
		  "createdDate": "2013-01-28 16:49:40",
		  "totalOrganizations": 21,
		  "totalTours": 10,
		  "totalDays": 751,
		  "totalCountries": 18,
		  "totalStates": 39,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 904,
		  "schedulePercent": 0.459882,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41f00e376f37f8208a8c40951f872656",
		  
		  "name": "Sprints",
		  "createdDate": "2024-01-31 14:35:18",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 296,
		  "totalCountries": 19,
		  "totalStates": 50,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 2040,
		  "schedulePercent": 0.720875,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Spandauer Zitadelle",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41f6e72486559e04f07654925f2e8b05",
		  
		  "name": "Ryan",
		  "createdDate": "2024-08-17 20:18:49",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 248,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 1990,
		  "schedulePercent": 0.711695,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "41ffd51dd3696d665e60895f109f3f90",
		  
		  "name": "Matt",
		  "createdDate": "2021-03-01 22:28:40",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 228,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1704,
		  "schedulePercent": 0.659111,
		  "totalGuests": 192,
		  "guestPercent": 0.587262,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Chicago Theatre",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4202d2061e729d3d3cd6e637cebb5556",
		  
		  "name": "Scott",
		  "createdDate": "2019-03-15 23:24:23",
		  "totalOrganizations": 12,
		  "totalTours": 23,
		  "totalDays": 713,
		  "totalCountries": 24,
		  "totalStates": 88,
		  "totalEvents": 360,
		  "eventPercent": 0.94617,
		  "totalScheduleItems": 5631,
		  "schedulePercent": 0.970195,
		  "totalGuests": 3644,
		  "guestPercent": 0.991047,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "OVO Arena Wembley",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 401,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4214a447dcaedabf1718730c287c0960",
		  
		  "name": "Gentry Touring",
		  "createdDate": "2023-09-10 03:18:01",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 1826,
		  "totalCountries": 18,
		  "totalStates": 40,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 3362,
		  "schedulePercent": 0.87262,
		  "totalGuests": 1290,
		  "guestPercent": 0.884406,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4215b875ce6ed0ea0f1925393fb09a0c",
		  
		  "name": "Hugues",
		  "createdDate": "2018-10-15 19:46:16",
		  "totalOrganizations": 25,
		  "totalTours": 19,
		  "totalDays": 221,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 899,
		  "schedulePercent": 0.457842,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "421a797fda9ecb735ef3f974e0262a34",
		  
		  "name": "Josh",
		  "createdDate": "2021-04-09 05:10:56",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 1026,
		  "totalCountries": 21,
		  "totalStates": 56,
		  "totalEvents": 448,
		  "eventPercent": 0.970762,
		  "totalScheduleItems": 5471,
		  "schedulePercent": 0.967022,
		  "totalGuests": 668,
		  "guestPercent": 0.777199,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "421cc39dd5890b59f61dc7837deb3d02",
		  
		  "name": "Kevin",
		  "createdDate": "2024-02-03 18:05:50",
		  "totalOrganizations": 6,
		  "totalTours": 16,
		  "totalDays": 492,
		  "totalCountries": 17,
		  "totalStates": 57,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 1022,
		  "schedulePercent": 0.497054,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Knockdown Center",
		  "mostGuestCity": "Maspeth",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "421ee980e030e8f25dff9a81cee71e7c",
		  
		  "name": "Brian",
		  "createdDate": "2012-08-20 14:42:47",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 331,
		  "totalCountries": 21,
		  "totalStates": 51,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1258,
		  "schedulePercent": 0.562557,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Fallsview Casino Resort",
		  "mostGuestCity": "Niagara Falls",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4223ebc65329d34c1251870c0113e632",
		  
		  "name": "Darrius",
		  "createdDate": "2022-09-26 13:49:11",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 687,
		  "totalCountries": 25,
		  "totalStates": 51,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1160,
		  "schedulePercent": 0.537511,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42286e93f421fdb1a8201d58aca60c58",
		  
		  "name": "Colin",
		  "createdDate": "2013-07-04 18:14:40",
		  "totalOrganizations": 35,
		  "totalTours": 48,
		  "totalDays": 1809,
		  "totalCountries": 36,
		  "totalStates": 108,
		  "totalEvents": 717,
		  "eventPercent": 0.9915,
		  "totalScheduleItems": 9311,
		  "schedulePercent": 0.99524,
		  "totalGuests": 3083,
		  "guestPercent": 0.983454,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42293a770c453409aba321218016974d",
		  
		  "name": "EGOR",
		  "createdDate": "2015-04-27 15:28:48",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 852,
		  "totalCountries": 41,
		  "totalStates": 50,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1867,
		  "schedulePercent": 0.688577,
		  "totalGuests": 493,
		  "guestPercent": 0.728355,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Gothenburg Studios",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "422b1fea0be3a3b35f03204759be607f",
		  
		  "name": "Regie",
		  "createdDate": "2024-04-04 12:08:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 54,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-12-13 00:00:00",
		  "mostGuestName": "Le Rex de Toulouse",
		  "mostGuestCity": "Toulouse",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "422d39e473048526e52a9c785ab31817",
		  
		  "name": "Delvon",
		  "createdDate": "2023-05-09 23:36:18",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 716,
		  "totalCountries": 14,
		  "totalStates": 32,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 329,
		  "schedulePercent": 0.230508,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4230d75757881fe609a48dbaf498c98f",
		  
		  "name": "Silvio",
		  "createdDate": "2015-10-29 13:17:30",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 783,
		  "totalCountries": 26,
		  "totalStates": 33,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1801,
		  "schedulePercent": 0.676451,
		  "totalGuests": 1031,
		  "guestPercent": 0.851088,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "ParkbÃ¼hne Wuhlheide",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 268,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4234cb0e55df40b814c7df13e43555a9",
		  
		  "name": "Blake",
		  "createdDate": "2023-10-31 21:54:33",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 182,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 296,
		  "schedulePercent": 0.215549,
		  "totalGuests": 244,
		  "guestPercent": 0.6216,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Toyota Music Factory",
		  "mostGuestCity": "Irving",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4247dc08769762aa4650d18d6c333040",
		  
		  "name": "Sandy",
		  "createdDate": "2024-06-04 15:57:58",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 858,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Heindl Center for Performing Arts",
		  "mostGuestCity": "Senatobia",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42498464429aa4b38d5ca182f16796d8",
		  
		  "name": "Julianne",
		  "createdDate": "2023-08-07 17:36:19",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 825,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "425c03855385b31c2a7823e179b53e68",
		  
		  "name": "Joshua ",
		  "createdDate": "2022-05-26 18:59:10",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 798,
		  "totalCountries": 11,
		  "totalStates": 36,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1563,
		  "schedulePercent": 0.63316,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Rawhide",
		  "mostGuestCity": "Chandler",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "426427d648fd1461a14ef71915065a8e",
		  
		  "name": "Vincent",
		  "createdDate": "2025-10-28 22:52:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 164,
		  "schedulePercent": 0.138146,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-11-19 00:00:00",
		  "mostGuestName": "Festival Hall",
		  "mostGuestCity": "West Melbourne",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42774c6def05019b9cca63dd4aea0324",
		  
		  "name": "Elizabeth",
		  "createdDate": "2018-01-22 19:08:37",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 683,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1615,
		  "schedulePercent": 0.643019,
		  "totalGuests": 751,
		  "guestPercent": 0.796464,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42776ee1d2e7a6524baa871e88acf551",
		  
		  "name": "Aaron",
		  "createdDate": "2013-09-19 00:27:00",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1200,
		  "totalCountries": 7,
		  "totalStates": 49,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 1999,
		  "schedulePercent": 0.713282,
		  "totalGuests": 1420,
		  "guestPercent": 0.902539,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "427d182a819301ad7368d6ca1cd8c6ac",
		  
		  "name": "Shirley",
		  "createdDate": "2010-06-30 16:21:57",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 559,
		  "totalCountries": 19,
		  "totalStates": 33,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 4181,
		  "schedulePercent": 0.924864,
		  "totalGuests": 243,
		  "guestPercent": 0.621147,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Lincoln Financial Field",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "427ec85cb1add2e3c07081eb7d441dbd",
		  
		  "name": "Ariel",
		  "createdDate": "2013-08-02 01:36:45",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 393,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 760,
		  "schedulePercent": 0.409225,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Eastside Bowl",
		  "mostGuestCity": "Madison",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42891008d0b7dd765a21547c866c04da",
		  
		  "name": "David",
		  "createdDate": "2017-02-23 02:22:27",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 10,
		  "totalStates": 43,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1701,
		  "schedulePercent": 0.658772,
		  "totalGuests": 1312,
		  "guestPercent": 0.887919,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "428cb8e9637a338b1fddcb0486a5ab5c",
		  
		  "name": "CAMILA",
		  "createdDate": "2022-08-16 02:01:07",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 126,
		  "totalCountries": 9,
		  "totalStates": 21,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42933fa78206120bd5ede717a37fb173",
		  
		  "name": "Colin",
		  "createdDate": "2022-09-09 15:53:54",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 71,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 565,
		  "schedulePercent": 0.338735,
		  "totalGuests": 605,
		  "guestPercent": 0.759973,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42962d5fb6809681dbb3a6d8df0b9784",
		  
		  "name": "Sarah",
		  "createdDate": "2012-05-04 23:24:42",
		  "totalOrganizations": 5,
		  "totalTours": 22,
		  "totalDays": 177,
		  "totalCountries": 6,
		  "totalStates": 24,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1029,
		  "schedulePercent": 0.49864,
		  "totalGuests": 1075,
		  "guestPercent": 0.859587,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "429988607b57b32185238831968cfbee",
		  
		  "name": "Liam",
		  "createdDate": "2022-04-05 01:49:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 148,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 288,
		  "schedulePercent": 0.211582,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "429db73755d0df397244b21a75250450",
		  
		  "name": "Rodrigo",
		  "createdDate": "2025-01-07 03:09:11",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 118,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 338,
		  "schedulePercent": 0.236967,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42a53b1c16ed627aa7ac4b6f3ebd7c9b",
		  
		  "name": "Lee",
		  "createdDate": "2018-05-30 03:25:41",
		  "totalOrganizations": 15,
		  "totalTours": 14,
		  "totalDays": 260,
		  "totalCountries": 12,
		  "totalStates": 29,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1032,
		  "schedulePercent": 0.49932,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "Riverstage",
		  "mostGuestCity": "Brisbane",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42a94bca13fa541ba7518cf30999b2a6",
		  
		  "name": "Luke",
		  "createdDate": "2024-01-09 22:26:17",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 561,
		  "totalCountries": 12,
		  "totalStates": 59,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2412,
		  "schedulePercent": 0.776179,
		  "totalGuests": 929,
		  "guestPercent": 0.835449,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42afe7730a2f2e0c2015fa3f70eae44e",
		  
		  "name": "Michelle",
		  "createdDate": "2025-03-20 17:52:43",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 58,
		  "totalCountries": 9,
		  "totalStates": 22,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 268,
		  "schedulePercent": 0.198209,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Our Black Heart",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42b02380bc9ca7fc264bbd21f2a1a1cb",
		  
		  "name": "Jennifer",
		  "createdDate": "2018-09-21 20:39:12",
		  "totalOrganizations": 4,
		  "totalTours": 20,
		  "totalDays": 704,
		  "totalCountries": 32,
		  "totalStates": 98,
		  "totalEvents": 331,
		  "eventPercent": 0.933364,
		  "totalScheduleItems": 3751,
		  "schedulePercent": 0.898799,
		  "totalGuests": 1527,
		  "guestPercent": 0.912851,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42bc702c4641bbbc7612799b2c62a5e5",
		  
		  "name": "Tom",
		  "createdDate": "2019-09-18 00:59:16",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 178,
		  "totalCountries": 17,
		  "totalStates": 37,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 987,
		  "schedulePercent": 0.486967,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Paradise Rock Club",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42bdf590242e08138bf4e8ef48cb8332",
		  
		  "name": "Rudy",
		  "createdDate": "2022-02-28 18:59:01",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 11,
		  "totalStates": 45,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1516,
		  "schedulePercent": 0.620807,
		  "totalGuests": 795,
		  "guestPercent": 0.80689,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42be4e8c68415e18a358d4e995317328",
		  
		  "name": "Tom",
		  "createdDate": "2022-05-31 23:41:20",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 401,
		  "totalCountries": 7,
		  "totalStates": 21,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1194,
		  "schedulePercent": 0.546124,
		  "totalGuests": 134,
		  "guestPercent": 0.548164,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "O2 Guildhall",
		  "mostGuestCity": "Southampton",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42c0921cf77fdaa0ebcac376753fbe96",
		  
		  "name": "Brandi",
		  "createdDate": "2013-05-17 08:30:40",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 128,
		  "totalCountries": 6,
		  "totalStates": 27,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 994,
		  "schedulePercent": 0.489121,
		  "totalGuests": 481,
		  "guestPercent": 0.724615,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42c5f31f967adefeb8d6bc7cc3a3487d",
		  
		  "name": "Cole",
		  "createdDate": "2014-04-02 20:42:50",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 646,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1950,
		  "schedulePercent": 0.703649,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42c835442c1670ff1d653fe38fd019fb",
		  
		  "name": "Patrick",
		  "createdDate": "2019-07-16 13:45:18",
		  "totalOrganizations": 11,
		  "totalTours": 19,
		  "totalDays": 571,
		  "totalCountries": 18,
		  "totalStates": 66,
		  "totalEvents": 308,
		  "eventPercent": 0.917271,
		  "totalScheduleItems": 4207,
		  "schedulePercent": 0.926224,
		  "totalGuests": 1880,
		  "guestPercent": 0.93869,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42c83f473ed27993720e0fb338f94a68",
		  
		  "name": "Katy",
		  "createdDate": "2025-09-16 22:30:14",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 143,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 424,
		  "schedulePercent": 0.279692,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42cc29b3b80af1585c840cd29e2188ad",
		  
		  "name": "Michael",
		  "createdDate": "2022-10-25 13:31:08",
		  "totalOrganizations": 15,
		  "totalTours": 19,
		  "totalDays": 976,
		  "totalCountries": 26,
		  "totalStates": 53,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1790,
		  "schedulePercent": 0.674864,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Hampton Pool",
		  "mostGuestCity": "Hampton",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42ccb0d560476d6c3b5452e0d8a75204",
		  
		  "name": "Kevin",
		  "createdDate": "2014-06-03 19:39:21",
		  "totalOrganizations": 21,
		  "totalTours": 22,
		  "totalDays": 1097,
		  "totalCountries": 27,
		  "totalStates": 73,
		  "totalEvents": 350,
		  "eventPercent": 0.942316,
		  "totalScheduleItems": 4611,
		  "schedulePercent": 0.940956,
		  "totalGuests": 2410,
		  "guestPercent": 0.965322,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Huntington Bank Pavilion at Northerly Island",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 272,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42d33281405b983ef763d70031f648a4",
		  
		  "name": "Julia",
		  "createdDate": "2020-01-30 14:58:12",
		  "totalOrganizations": 50,
		  "totalTours": 29,
		  "totalDays": 1066,
		  "totalCountries": 11,
		  "totalStates": 25,
		  "totalEvents": 469,
		  "eventPercent": 0.973595,
		  "totalScheduleItems": 3196,
		  "schedulePercent": 0.859248,
		  "totalGuests": 360,
		  "guestPercent": 0.67815,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rden Under Bron",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42d73abd5cb7e5edc402c8b325c9ccaf",
		  
		  "name": "Alex",
		  "createdDate": "2012-02-24 05:32:30",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 522,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1064,
		  "schedulePercent": 0.507593,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42e138dc863e26969711a76e3e990df8",
		  
		  "name": "Rafael",
		  "createdDate": "2025-04-04 11:33:07",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 353,
		  "totalCountries": 16,
		  "totalStates": 51,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 888,
		  "schedulePercent": 0.453083,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42e50b1ab81a99eca3ac53bb30365a2b",
		  
		  "name": "Parks Audio Productions",
		  "createdDate": "2025-02-17 00:53:08",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 175,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 185,
		  "schedulePercent": 0.150725,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42e8b94e367f85558617313eadb91978",
		  
		  "name": "Morgan",
		  "createdDate": "2023-05-18 22:54:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 51,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 766,
		  "schedulePercent": 0.410245,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42f12990e0c17bbbbccbbc95c607ab7d",
		  
		  "name": "Monte&#39;",
		  "createdDate": "2025-06-17 01:04:59",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42f2c156d0e56b1801c74428cf47e1b1",
		  
		  "name": "Lachlan",
		  "createdDate": "2023-09-22 14:56:04",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 671,
		  "totalCountries": 14,
		  "totalStates": 22,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 320,
		  "schedulePercent": 0.226995,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42f439b6de1b4f94a694ae9e0d3ded62",
		  
		  "name": "Alexis",
		  "createdDate": "2024-09-28 15:12:57",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 338,
		  "totalCountries": 5,
		  "totalStates": 14,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 341,
		  "schedulePercent": 0.239121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42fa2f5b5e717040b9c06abf9d88d3d6",
		  
		  "name": "James",
		  "createdDate": "2021-06-27 04:38:19",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 516,
		  "totalCountries": 11,
		  "totalStates": 54,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1833,
		  "schedulePercent": 0.68223,
		  "totalGuests": 1882,
		  "guestPercent": 0.938917,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42fd488f674e70d49ca4c5ffa155d146",
		  
		  "name": "Victor",
		  "createdDate": "2017-06-30 09:05:07",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 89,
		  "totalCountries": 20,
		  "totalStates": 34,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 659,
		  "schedulePercent": 0.37126,
		  "totalGuests": 282,
		  "guestPercent": 0.640413,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Huskvarna Folkets Park",
		  "mostGuestCity": "Huskvarna",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "42feed20c5a45274dc33e6f89093f74c",
		  
		  "name": "Kim",
		  "createdDate": "2014-12-09 14:32:02",
		  "totalOrganizations": 82,
		  "totalTours": 34,
		  "totalDays": 579,
		  "totalCountries": 11,
		  "totalStates": 7,
		  "totalEvents": 502,
		  "eventPercent": 0.979034,
		  "totalScheduleItems": 2645,
		  "schedulePercent": 0.802471,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Fredagsrock i Tivoli",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4304da72e31e0acc9afc922406aed783",
		  
		  "name": "Dominique",
		  "createdDate": "2021-09-24 15:19:45",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 892,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 377,
		  "schedulePercent": 0.256346,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "430f57cbdcda493da4fc9caf9aae5b27",
		  
		  "name": "Angel",
		  "createdDate": "2021-12-29 00:44:07",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 1146,
		  "totalCountries": 20,
		  "totalStates": 67,
		  "totalEvents": 357,
		  "eventPercent": 0.944696,
		  "totalScheduleItems": 4225,
		  "schedulePercent": 0.927924,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Movistar Arena Madrid",
		  "mostGuestCity": "Madrid",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "431013ab197c31ac1f88aff6a0145f89",
		  
		  "name": "Terry",
		  "createdDate": "2012-03-19 20:50:32",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 699,
		  "totalCountries": 21,
		  "totalStates": 56,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 4045,
		  "schedulePercent": 0.915685,
		  "totalGuests": 1223,
		  "guestPercent": 0.878286,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Alameda County Fairgrounds GATE #2 Attention Scott O'Leary",
		  "mostGuestCity": "Pleasanton",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "431bd6542a08552c03271fb082a079bd",
		  
		  "name": "Jess",
		  "createdDate": "2024-03-19 17:35:30",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 525,
		  "totalCountries": 12,
		  "totalStates": 37,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1727,
		  "schedulePercent": 0.663418,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4332ffcfd115a7f5726fbd9ff5afb503",
		  
		  "name": "adam",
		  "createdDate": "2019-09-03 19:55:05",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 178,
		  "totalCountries": 6,
		  "totalStates": 24,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "433316ab9f13495c6bbd51d0de961877",
		  
		  "name": "Thomas",
		  "createdDate": "2025-09-19 10:42:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 162,
		  "schedulePercent": 0.136786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-12-18 00:00:00",
		  "mostGuestName": "Olavshallen",
		  "mostGuestCity": "Trondheim",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "433b40e1e507603b71cf99bed2898f8b",
		  
		  "name": "Julien",
		  "createdDate": "2025-04-22 17:44:22",
		  "totalOrganizations": 1,
		  "totalTours": 12,
		  "totalDays": 119,
		  "totalCountries": 12,
		  "totalStates": 21,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 254,
		  "schedulePercent": 0.192883,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4347b22fc29275bc979c675607424026",
		  
		  "name": "Jennifer",
		  "createdDate": "2015-07-10 18:25:37",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 1645,
		  "totalCountries": 15,
		  "totalStates": 57,
		  "totalEvents": 293,
		  "eventPercent": 0.908092,
		  "totalScheduleItems": 4497,
		  "schedulePercent": 0.938237,
		  "totalGuests": 333,
		  "guestPercent": 0.666931,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Canada Life Place",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43530a44ac6b171ad3d6c38d58ced07e",
		  
		  "name": "Fabian",
		  "createdDate": "2015-07-24 00:42:27",
		  "totalOrganizations": 13,
		  "totalTours": 19,
		  "totalDays": 548,
		  "totalCountries": 21,
		  "totalStates": 63,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 1691,
		  "schedulePercent": 0.656958,
		  "totalGuests": 290,
		  "guestPercent": 0.644266,
		  "mostGuestDate": "2025-01-22 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "435b9c39e2f84a7e36a8bdf07ffb3fa3",
		  
		  "name": "Michael",
		  "createdDate": "2022-08-03 01:10:57",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 540,
		  "totalCountries": 11,
		  "totalStates": 34,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1587,
		  "schedulePercent": 0.637806,
		  "totalGuests": 535,
		  "guestPercent": 0.738894,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "436fa7249d5b63f71f3686dbb64ec9c2",
		  
		  "name": "NL",
		  "createdDate": "2017-05-13 20:03:11",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 342,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 367,
		  "schedulePercent": 0.251813,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4371f17c3de1ea24209ae5b3a18d83c9",
		  
		  "name": "Jayson",
		  "createdDate": "2021-10-07 02:06:50",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 365,
		  "totalCountries": 11,
		  "totalStates": 50,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 2377,
		  "schedulePercent": 0.772325,
		  "totalGuests": 1867,
		  "guestPercent": 0.937217,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4372692c69c6a50e435b9917cc88bdc5",
		  
		  "name": "Jane",
		  "createdDate": "2022-08-04 17:52:01",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 718,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 3910,
		  "schedulePercent": 0.909225,
		  "totalGuests": 310,
		  "guestPercent": 0.654352,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Park City Arena",
		  "mostGuestCity": "Park City",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43844cbdcdee5cfa8d22d8779ed671ca",
		  
		  "name": "Ingrid",
		  "createdDate": "2015-10-27 11:31:15",
		  "totalOrganizations": 48,
		  "totalTours": 29,
		  "totalDays": 976,
		  "totalCountries": 39,
		  "totalStates": 49,
		  "totalEvents": 437,
		  "eventPercent": 0.968155,
		  "totalScheduleItems": 3776,
		  "schedulePercent": 0.900839,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Rockefeller Music Hall",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4388b315e762f8c56d3001ec2ea4f667",
		  
		  "name": "Chad",
		  "createdDate": "2016-08-04 15:21:43",
		  "totalOrganizations": 7,
		  "totalTours": 18,
		  "totalDays": 836,
		  "totalCountries": 36,
		  "totalStates": 102,
		  "totalEvents": 392,
		  "eventPercent": 0.956822,
		  "totalScheduleItems": 6219,
		  "schedulePercent": 0.978694,
		  "totalGuests": 3810,
		  "guestPercent": 0.99218,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "438a58b605f572d3fc8ed21decb9d31c",
		  
		  "name": "Curt",
		  "createdDate": "2010-04-10 03:13:16",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 376,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1261,
		  "schedulePercent": 0.563123,
		  "totalGuests": 502,
		  "guestPercent": 0.731301,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Tarlelton Event Center",
		  "mostGuestCity": "Stephenville",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4394c407861d407b4e49cfc6fd761eda",
		  
		  "name": "Ron",
		  "createdDate": "2009-07-24 15:30:19",
		  "totalOrganizations": 18,
		  "totalTours": 13,
		  "totalDays": 1073,
		  "totalCountries": 47,
		  "totalStates": 100,
		  "totalEvents": 326,
		  "eventPercent": 0.931097,
		  "totalScheduleItems": 4428,
		  "schedulePercent": 0.935857,
		  "totalGuests": 2612,
		  "guestPercent": 0.972461,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "439ba5a15ad6d39edee2e4195f348f33",
		  
		  "name": "Florian",
		  "createdDate": "2025-11-03 13:33:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43a25264fea2b1179495d900b760ec74",
		  
		  "name": "Daniel",
		  "createdDate": "2023-09-30 13:31:23",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 47,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 339,
		  "schedulePercent": 0.237874,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Antone's Nightclub",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43af5db0507486fb245aaf67f47cd77a",
		  
		  "name": "Eric",
		  "createdDate": "2013-08-01 23:41:02",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 191,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 867,
		  "schedulePercent": 0.447643,
		  "totalGuests": 341,
		  "guestPercent": 0.671238,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Chief's Recording",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43b021b57be0a3a27b2aea348f875381",
		  
		  "name": "Eric ",
		  "createdDate": "2023-03-15 19:38:00",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 754,
		  "totalCountries": 2,
		  "totalStates": 44,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 3139,
		  "schedulePercent": 0.854601,
		  "totalGuests": 1141,
		  "guestPercent": 0.870694,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43c68b98e8f91a3fb1353b96b467def0",
		  
		  "name": "Mellina",
		  "createdDate": "2025-03-11 17:58:35",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 45,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 121,
		  "schedulePercent": 0.111627,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43d011a4380938aae38d13bf57b3b6f5",
		  
		  "name": "Jeff",
		  "createdDate": "2023-09-27 15:22:19",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 672,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1407,
		  "schedulePercent": 0.599841,
		  "totalGuests": 421,
		  "guestPercent": 0.702969,
		  "mostGuestDate": "2025-03-11 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43d02e7b423a9c5705f9aa70576eef6a",
		  
		  "name": "Simon",
		  "createdDate": "2010-06-01 11:21:02",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 71,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 384,
		  "schedulePercent": 0.260653,
		  "totalGuests": 279,
		  "guestPercent": 0.639166,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Skydeck on Broadway",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43d12b4b146acf2ff41c3a601d445e0a",
		  
		  "name": "Caleb",
		  "createdDate": "2022-06-29 18:55:22",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 221,
		  "totalCountries": 22,
		  "totalStates": 45,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1274,
		  "schedulePercent": 0.56641,
		  "totalGuests": 602,
		  "guestPercent": 0.75884,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Paramount",
		  "mostGuestCity": "Huntington",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43ddd58e9b07ebfada650a5785878080",
		  
		  "name": "Lindsay",
		  "createdDate": "2016-07-14 03:14:15",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 733,
		  "totalCountries": 20,
		  "totalStates": 54,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 2435,
		  "schedulePercent": 0.779012,
		  "totalGuests": 136,
		  "guestPercent": 0.549524,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "NRG Stadium",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43e571c9e92270f31fffcaef1497ec79",
		  
		  "name": "Dennis",
		  "createdDate": "2024-07-16 19:37:02",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 514,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1923,
		  "schedulePercent": 0.698436,
		  "totalGuests": 1308,
		  "guestPercent": 0.887579,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43ed44e7bb0a7cface8a4f87ea64ffde",
		  
		  "name": "Neal",
		  "createdDate": "2019-10-20 02:15:16",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 528,
		  "totalCountries": 6,
		  "totalStates": 58,
		  "totalEvents": 311,
		  "eventPercent": 0.919878,
		  "totalScheduleItems": 3897,
		  "schedulePercent": 0.908205,
		  "totalGuests": 779,
		  "guestPercent": 0.802244,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43f45c98087d5e8e11cb6d9c72641b4e",
		  
		  "name": "Will",
		  "createdDate": "2014-03-04 22:48:30",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 123,
		  "totalCountries": 14,
		  "totalStates": 33,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 645,
		  "schedulePercent": 0.365594,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "43fbddb150540c4dbc1c8578502daf06",
		  
		  "name": "Robert",
		  "createdDate": "2017-03-22 12:16:25",
		  "totalOrganizations": 9,
		  "totalTours": 2,
		  "totalDays": 384,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 1216,
		  "schedulePercent": 0.550657,
		  "totalGuests": 386,
		  "guestPercent": 0.688463,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Tempodrom",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44067603406ca98ee41ffa572406fbed",
		  
		  "name": "Fabian",
		  "createdDate": "2025-05-30 06:54:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 109,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 282,
		  "schedulePercent": 0.206936,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "440760187816cae039128b7e2b9823c9",
		  
		  "name": "Jamie",
		  "createdDate": "2024-06-20 16:11:07",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 371,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1374,
		  "schedulePercent": 0.590775,
		  "totalGuests": 311,
		  "guestPercent": 0.654692,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "440e9ac467a6c928260b1cbdedc2ba3b",
		  
		  "name": "Ronnie",
		  "createdDate": "2014-06-10 16:23:37",
		  "totalOrganizations": 3,
		  "totalTours": 11,
		  "totalDays": 502,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1076,
		  "schedulePercent": 0.512466,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44244d7784de08db16375d654fbd31a1",
		  
		  "name": "Yuran ",
		  "createdDate": "2025-04-08 16:41:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 223,
		  "schedulePercent": 0.173051,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "442882d1591eae29eb7978125bd48608",
		  
		  "name": "Antti",
		  "createdDate": "2019-05-08 10:05:54",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 122,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 124,
		  "schedulePercent": 0.114007,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "442cf253ae2721ad7d42c19a4227ac86",
		  
		  "name": "Michael",
		  "createdDate": "2024-02-23 01:56:30",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 70,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 190,
		  "schedulePercent": 0.153105,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Toad's Place",
		  "mostGuestCity": "New Haven",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "442e9fdc2db7b9a65a59033b8b31c30e",
		  
		  "name": "Jonah",
		  "createdDate": "2022-07-28 14:32:50",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 244,
		  "totalCountries": 17,
		  "totalStates": 49,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 1598,
		  "schedulePercent": 0.640299,
		  "totalGuests": 292,
		  "guestPercent": 0.645739,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4435b1307d3ebb1d06578277dc9a0eb3",
		  
		  "name": "Lemny",
		  "createdDate": "2019-09-05 14:53:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 309,
		  "totalCountries": 13,
		  "totalStates": 24,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 449,
		  "schedulePercent": 0.290345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "443a8f66d2fcadf5b6159f24d8ec1de7",
		  
		  "name": "Fabian",
		  "createdDate": "2025-10-24 19:24:57",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 55,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 174,
		  "schedulePercent": 0.143246,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-11-12 00:00:00",
		  "mostGuestName": "9:30 Club",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "443c327be488510849ec6e5df42a8316",
		  
		  "name": "Archers",
		  "createdDate": "2024-05-07 02:34:27",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 128,
		  "totalCountries": 13,
		  "totalStates": 51,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1194,
		  "schedulePercent": 0.546124,
		  "totalGuests": 215,
		  "guestPercent": 0.605281,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "O2 Academy Islington",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "443ee005336ec0ee412bd45cf74ac9b8",
		  
		  "name": "Matty",
		  "createdDate": "2011-02-19 01:45:37",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 345,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 365,
		  "schedulePercent": 0.250907,
		  "totalGuests": 325,
		  "guestPercent": 0.663531,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Hawaii Theatre",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 122,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "444817ee6a96fb8262c0fc2031a9abdc",
		  
		  "name": "Dennis",
		  "createdDate": "2024-09-10 00:38:29",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 356,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 103,
		  "schedulePercent": 0.0988214,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4452cacf636851a175c375c0599f4f03",
		  
		  "name": "Brian",
		  "createdDate": "2022-07-27 00:14:53",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 102,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 464,
		  "schedulePercent": 0.296351,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Venue at Horseshoe Hammond",
		  "mostGuestCity": "Hammond",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "445362ae5f65b7377dabca855ba189c5",
		  
		  "name": "William",
		  "createdDate": "2017-01-09 10:22:57",
		  "totalOrganizations": 21,
		  "totalTours": 12,
		  "totalDays": 243,
		  "totalCountries": 7,
		  "totalStates": 5,
		  "totalEvents": 242,
		  "eventPercent": 0.863667,
		  "totalScheduleItems": 844,
		  "schedulePercent": 0.438577,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4457aa1d6d1a21da31de87f5cfb46bd9",
		  
		  "name": "Taylor",
		  "createdDate": "2021-10-21 15:53:45",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 82,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 387,
		  "schedulePercent": 0.262579,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Luckman Fine Arts Complex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "445956e0a4a9363be6f96ada78c61ae1",
		  
		  "name": "One Step",
		  "createdDate": "2021-12-07 17:25:22",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 62,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 455,
		  "schedulePercent": 0.292611,
		  "totalGuests": 412,
		  "guestPercent": 0.698323,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "Chain Reaction",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "445bf9ec529c6c7d6a334f7896d7a324",
		  
		  "name": "Georgie",
		  "createdDate": "2019-06-13 13:14:55",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 746,
		  "totalCountries": 23,
		  "totalStates": 35,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2190,
		  "schedulePercent": 0.7466,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4464f961eeec6018526184a9afc0f0b1",
		  
		  "name": "Seth",
		  "createdDate": "2017-01-04 22:44:28",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 250,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1353,
		  "schedulePercent": 0.585902,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Arvada Center",
		  "mostGuestCity": "Arvada",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4472c78395a695fe86c1d02a1d98a1c5",
		  
		  "name": "Steven",
		  "createdDate": "2017-04-22 16:42:08",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 17,
		  "totalStates": 17,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 395,
		  "schedulePercent": 0.266772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44732ff23a05f42064ed92928aed520b",
		  
		  "name": "Hanna",
		  "createdDate": "2022-11-11 12:46:05",
		  "totalOrganizations": 30,
		  "totalTours": 6,
		  "totalDays": 582,
		  "totalCountries": 7,
		  "totalStates": 11,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 909,
		  "schedulePercent": 0.461242,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "Burgsvik GrÃ¥ GÃ¥sen",
		  "mostGuestCity": "Burgsvik",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "447a257ecc33cf8e4af78a6aa607fa46",
		  
		  "name": "Adam",
		  "createdDate": "2014-08-11 11:21:11",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 367,
		  "totalCountries": 10,
		  "totalStates": 21,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 297,
		  "schedulePercent": 0.216342,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "448057b887f1eda41273781ccadca966",
		  
		  "name": "Ariel",
		  "createdDate": "2021-10-03 18:24:01",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 124,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 931,
		  "schedulePercent": 0.469402,
		  "totalGuests": 209,
		  "guestPercent": 0.601201,
		  "mostGuestDate": "2025-04-29 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4487364b631f274e045710bde5a57e66",
		  
		  "name": "Mike",
		  "createdDate": "2019-01-17 10:56:25",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 97,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 95,
		  "schedulePercent": 0.0933817,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Coors Light Birds Nest",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4489e12812fdd4efaed3221f337d0c1a",
		  
		  "name": "Nigel",
		  "createdDate": "2024-04-16 14:54:24",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 1094,
		  "totalCountries": 27,
		  "totalStates": 21,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1380,
		  "schedulePercent": 0.592702,
		  "totalGuests": 403,
		  "guestPercent": 0.69583,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Brockwell Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4497739f1a06183f66f682793a7b3e0a",
		  
		  "name": "Anthony",
		  "createdDate": "2022-07-25 14:44:47",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 89,
		  "totalCountries": 13,
		  "totalStates": 46,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 872,
		  "schedulePercent": 0.449229,
		  "totalGuests": 189,
		  "guestPercent": 0.585222,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "Revolution Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44afef01f94ff4bd7e7afe4f7c967dc0",
		  
		  "name": "Venomous",
		  "createdDate": "2023-04-06 21:46:53",
		  "totalOrganizations": 3,
		  "totalTours": 11,
		  "totalDays": 246,
		  "totalCountries": 14,
		  "totalStates": 52,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 1390,
		  "schedulePercent": 0.594855,
		  "totalGuests": 71,
		  "guestPercent": 0.486174,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Rebel Lounge",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44cc922369c005e9704acd5cdcf5ba01",
		  
		  "name": "Sara",
		  "createdDate": "2015-04-13 14:23:11",
		  "totalOrganizations": 14,
		  "totalTours": 4,
		  "totalDays": 169,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 859,
		  "schedulePercent": 0.444243,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44dbf365c639da3cd7c3202a7da3170e",
		  
		  "name": "Adam",
		  "createdDate": "2025-02-19 06:30:59",
		  "totalOrganizations": 2,
		  "totalTours": 16,
		  "totalDays": 77,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 319,
		  "schedulePercent": 0.226541,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44dfbebe846786f45c8d2265e98939ba",
		  
		  "name": "Josh",
		  "createdDate": "2022-06-21 12:24:33",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 1272,
		  "totalCountries": 21,
		  "totalStates": 67,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 4163,
		  "schedulePercent": 0.922937,
		  "totalGuests": 1560,
		  "guestPercent": 0.915911,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44e6e7be96550adbefb406e551ab1362",
		  
		  "name": "Abby",
		  "createdDate": "2017-10-27 20:00:06",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 892,
		  "totalCountries": 10,
		  "totalStates": 51,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 3083,
		  "schedulePercent": 0.850068,
		  "totalGuests": 660,
		  "guestPercent": 0.774252,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44f07716c540d04130ce287051aa78b9",
		  
		  "name": "Roisin",
		  "createdDate": "2015-10-11 17:21:59",
		  "totalOrganizations": 37,
		  "totalTours": 36,
		  "totalDays": 1682,
		  "totalCountries": 47,
		  "totalStates": 106,
		  "totalEvents": 479,
		  "eventPercent": 0.975068,
		  "totalScheduleItems": 5903,
		  "schedulePercent": 0.974501,
		  "totalGuests": 301,
		  "guestPercent": 0.650385,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44f5260ff67dc682e225fb1906e8de58",
		  
		  "name": "Daniel",
		  "createdDate": "2020-01-06 15:41:11",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 277,
		  "totalCountries": 28,
		  "totalStates": 41,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 766,
		  "schedulePercent": 0.410245,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "The Observatory North Park",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44f733f9d882c0327b8c1a20f215bd12",
		  
		  "name": "Stewart",
		  "createdDate": "2015-05-04 17:21:24",
		  "totalOrganizations": 17,
		  "totalTours": 18,
		  "totalDays": 520,
		  "totalCountries": 25,
		  "totalStates": 46,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 3236,
		  "schedulePercent": 0.862761,
		  "totalGuests": 711,
		  "guestPercent": 0.788078,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "44fe96aa40ef1be504dbb92505b1a74c",
		  
		  "name": "Rebecca",
		  "createdDate": "2022-04-06 16:43:53",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 50,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Thalia Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "450cf22303960a89c14ff1c8e9ecce00",
		  
		  "name": "Christopher",
		  "createdDate": "2022-08-15 16:50:29",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 487,
		  "totalCountries": 6,
		  "totalStates": 47,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 3033,
		  "schedulePercent": 0.845422,
		  "totalGuests": 443,
		  "guestPercent": 0.710109,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "451d0d31f30efb1ed80989e02344461a",
		  
		  "name": "Julien",
		  "createdDate": "2019-10-17 14:22:47",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 96,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 279,
		  "schedulePercent": 0.205009,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4521836272e9299bdc60a88d80f0dd05",
		  
		  "name": "Sari",
		  "createdDate": "2012-11-24 03:32:28",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 640,
		  "totalCountries": 23,
		  "totalStates": 41,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 3587,
		  "schedulePercent": 0.888373,
		  "totalGuests": 2521,
		  "guestPercent": 0.968722,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "452688b58df2a4aa2277033075664695",
		  
		  "name": "James",
		  "createdDate": "2025-07-03 01:56:28",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 22,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 138,
		  "schedulePercent": 0.123527,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "The Timber Yard",
		  "mostGuestCity": "Port Melbourne",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "452ebde8bb62ada68d233ab312adeb2f",
		  
		  "name": "Dawson",
		  "createdDate": "2024-07-16 20:22:46",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 90,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 742,
		  "schedulePercent": 0.401972,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Dolly Parton's Celebrity Theater",
		  "mostGuestCity": "Pigeon Forge",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "454a9b8f967542d4c4b8177efd330c19",
		  
		  "name": "Valerie",
		  "createdDate": "2019-07-01 18:07:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 133,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 667,
		  "schedulePercent": 0.373867,
		  "totalGuests": 606,
		  "guestPercent": 0.760539,
		  "mostGuestDate": "2025-08-25 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4552ca322905543979a7feb280a0a43c",
		  
		  "name": "Larry ",
		  "createdDate": "2018-03-12 23:05:45",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4565dd4efb0be8729859bb441ea46e35",
		  
		  "name": "Brian ",
		  "createdDate": "2021-08-18 03:08:01",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 585,
		  "totalCountries": 14,
		  "totalStates": 35,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 2716,
		  "schedulePercent": 0.811197,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Arvest Bank Theatre @ The Midland",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "456a60a8317932cd8d239970d08be518",
		  
		  "name": "Saint",
		  "createdDate": "2023-07-17 19:00:16",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 154,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 902,
		  "schedulePercent": 0.458862,
		  "totalGuests": 467,
		  "guestPercent": 0.719288,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "457140d4f3369da1211c51847687c6c7",
		  
		  "name": "Phil",
		  "createdDate": "2018-04-09 22:37:48",
		  "totalOrganizations": 13,
		  "totalTours": 20,
		  "totalDays": 1812,
		  "totalCountries": 25,
		  "totalStates": 90,
		  "totalEvents": 351,
		  "eventPercent": 0.942883,
		  "totalScheduleItems": 7084,
		  "schedulePercent": 0.987081,
		  "totalGuests": 1282,
		  "guestPercent": 0.8835,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4577e622ac34fde3f2c340b2d8a94a27",
		  
		  "name": "Ashley",
		  "createdDate": "2017-08-15 20:01:54",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 2227,
		  "totalCountries": 39,
		  "totalStates": 72,
		  "totalEvents": 328,
		  "eventPercent": 0.932004,
		  "totalScheduleItems": 3167,
		  "schedulePercent": 0.856868,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "457982731de5ceac00ec9fd84cdafab5",
		  
		  "name": "Tom",
		  "createdDate": "2011-08-27 20:32:03",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 93,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 282,
		  "schedulePercent": 0.206936,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Amerant Bank Arena",
		  "mostGuestCity": "Sunrise",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "458a2f42dbbcbe45afe7b32dfd25cde0",
		  
		  "name": "Rawk",
		  "createdDate": "2023-06-20 05:45:22",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 740,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 816,
		  "schedulePercent": 0.42951,
		  "totalGuests": 534,
		  "guestPercent": 0.738441,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Historic Scoot Inn",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "459df8134973e8b6a0e84d0f8b0a533f",
		  
		  "name": "Production",
		  "createdDate": "2024-05-03 17:27:39",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 246,
		  "totalCountries": 3,
		  "totalStates": 47,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2342,
		  "schedulePercent": 0.767226,
		  "totalGuests": 437,
		  "guestPercent": 0.708522,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Terrace Theatre",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "459fb1149cce672ccbd98169c06dc181",
		  
		  "name": "Alexander",
		  "createdDate": "2017-02-10 02:36:23",
		  "totalOrganizations": 15,
		  "totalTours": 8,
		  "totalDays": 726,
		  "totalCountries": 13,
		  "totalStates": 61,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 2606,
		  "schedulePercent": 0.798617,
		  "totalGuests": 577,
		  "guestPercent": 0.751813,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45a73db761730379007808b0e48e4299",
		  
		  "name": "Sunny",
		  "createdDate": "2017-04-27 20:42:12",
		  "totalOrganizations": 16,
		  "totalTours": 14,
		  "totalDays": 654,
		  "totalCountries": 33,
		  "totalStates": 53,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 3325,
		  "schedulePercent": 0.86922,
		  "totalGuests": 476,
		  "guestPercent": 0.722688,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "MOA Arena",
		  "mostGuestCity": "Pasay",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45adb2e0f310768f9bf23cadfbcfa6ca",
		  
		  "name": "Melanie",
		  "createdDate": "2024-08-29 23:14:11",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 102,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1074,
		  "schedulePercent": 0.511786,
		  "totalGuests": 472,
		  "guestPercent": 0.721328,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Cobb Energy Centre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45b05bf857b7ebb7512259f0eb42ae1c",
		  
		  "name": "Tom",
		  "createdDate": "2022-02-15 16:05:19",
		  "totalOrganizations": 18,
		  "totalTours": 15,
		  "totalDays": 3199,
		  "totalCountries": 44,
		  "totalStates": 125,
		  "totalEvents": 541,
		  "eventPercent": 0.983228,
		  "totalScheduleItems": 5649,
		  "schedulePercent": 0.970875,
		  "totalGuests": 183,
		  "guestPercent": 0.581482,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45b446ae53eaecf9bca3f2fea4c43b96",
		  
		  "name": "Kylie",
		  "createdDate": "2022-08-17 04:34:59",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 852,
		  "totalCountries": 15,
		  "totalStates": 24,
		  "totalEvents": 302,
		  "eventPercent": 0.914211,
		  "totalScheduleItems": 1050,
		  "schedulePercent": 0.50442,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stand Comedy Club Newcastle",
		  "mostGuestCity": "Newcastle upon Tyne",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45b462365432847c5405b295245f9943",
		  
		  "name": "FENIA",
		  "createdDate": "2025-02-11 13:26:44",
		  "totalOrganizations": 3,
		  "totalTours": 13,
		  "totalDays": 271,
		  "totalCountries": 8,
		  "totalStates": 37,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 726,
		  "schedulePercent": 0.396646,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45c69732043adaf86b7d07992791511c",
		  
		  "name": "Melanie",
		  "createdDate": "2019-03-19 23:51:09",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 38,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 3,
		  "eventPercent": 0.0250453,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45db209798683c7353f73eee9b960bf2",
		  
		  "name": "Adam",
		  "createdDate": "2013-02-19 00:30:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 397,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 2128,
		  "schedulePercent": 0.736287,
		  "totalGuests": 3425,
		  "guestPercent": 0.988894,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Ak-Chin Pavilion",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 173,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45de2992c4cf955987f85a277870e5bb",
		  
		  "name": "Amy",
		  "createdDate": "2025-07-15 01:05:17",
		  "totalOrganizations": 7,
		  "totalTours": 42,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Wonderland",
		  "mostGuestCity": "Bloomington",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "45e3bf5fbccfc1ca8c954ba737bd283a",
		  
		  "name": "Highway",
		  "createdDate": "2018-07-24 09:42:08",
		  "totalOrganizations": 37,
		  "totalTours": 49,
		  "totalDays": 1390,
		  "totalCountries": 34,
		  "totalStates": 118,
		  "totalEvents": 536,
		  "eventPercent": 0.982434,
		  "totalScheduleItems": 6108,
		  "schedulePercent": 0.977335,
		  "totalGuests": 2113,
		  "guestPercent": 0.954442,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4603d6c1ffaf9e88597a8e9c5c738652",
		  
		  "name": "Timothy",
		  "createdDate": "2012-06-14 16:56:12",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 234,
		  "totalCountries": 15,
		  "totalStates": 29,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1039,
		  "schedulePercent": 0.50102,
		  "totalGuests": 198,
		  "guestPercent": 0.593155,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "460478bec7e368cdc62df7b3fa30eff0",
		  
		  "name": "Kathleen",
		  "createdDate": "2023-08-11 15:38:12",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 153,
		  "totalCountries": 4,
		  "totalStates": 24,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 898,
		  "schedulePercent": 0.457502,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4608470b2da75473c009a05e80b35a0d",
		  
		  "name": "JT",
		  "createdDate": "2023-07-21 17:20:46",
		  "totalOrganizations": 3,
		  "totalTours": 12,
		  "totalDays": 313,
		  "totalCountries": 20,
		  "totalStates": 57,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1548,
		  "schedulePercent": 0.626587,
		  "totalGuests": 1109,
		  "guestPercent": 0.865707,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46084cd5c44bddadcfa7c6bbb1a077f8",
		  
		  "name": "Tamma",
		  "createdDate": "2024-05-08 16:47:12",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 64,
		  "totalCountries": 19,
		  "totalStates": 19,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 466,
		  "schedulePercent": 0.296804,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Palacio Vistalegre",
		  "mostGuestCity": "Madrid",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46098327cb6075de95ea941971ac7354",
		  
		  "name": "Kerry",
		  "createdDate": "2013-04-15 17:16:17",
		  "totalOrganizations": 16,
		  "totalTours": 11,
		  "totalDays": 514,
		  "totalCountries": 21,
		  "totalStates": 33,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1958,
		  "schedulePercent": 0.705122,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Decca Live",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "460b278f0f916f5328ef5fe1f25ee32e",
		  
		  "name": "Zac",
		  "createdDate": "2018-11-14 13:33:01",
		  "totalOrganizations": 8,
		  "totalTours": 32,
		  "totalDays": 858,
		  "totalCountries": 24,
		  "totalStates": 71,
		  "totalEvents": 331,
		  "eventPercent": 0.933364,
		  "totalScheduleItems": 6196,
		  "schedulePercent": 0.978241,
		  "totalGuests": 2590,
		  "guestPercent": 0.971668,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4614cc7f18b751f2ccc5556d3a7b89fa",
		  
		  "name": "Juan",
		  "createdDate": "2024-07-20 04:17:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 217,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 3,
		  "eventPercent": 0.0250453,
		  "totalScheduleItems": 105,
		  "schedulePercent": 0.101315,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "461804f4cb56d83e25d7155dce64d231",
		  
		  "name": "Kalle",
		  "createdDate": "2022-04-23 07:16:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 220,
		  "schedulePercent": 0.171578,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "462a6e06d2c985526f76fae121e9bbcf",
		  
		  "name": "James",
		  "createdDate": "2025-07-01 15:39:57",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 53,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 535,
		  "schedulePercent": 0.329102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "462cdb4811b95d75b35989d9b9110f0c",
		  
		  "name": "Dre",
		  "createdDate": "2022-05-04 22:08:01",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 104,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 649,
		  "schedulePercent": 0.366954,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "462f62d62aa20b9bc9535ec9de3c89a2",
		  
		  "name": "Justin",
		  "createdDate": "2009-07-06 22:18:51",
		  "totalOrganizations": 19,
		  "totalTours": 15,
		  "totalDays": 1014,
		  "totalCountries": 26,
		  "totalStates": 43,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1825,
		  "schedulePercent": 0.680417,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "NOS Alive",
		  "mostGuestCity": "Alges",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "463c116c04a12a9a7fc744c545435c97",
		  
		  "name": "Fabian",
		  "createdDate": "2025-03-03 23:22:19",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 37,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 122,
		  "schedulePercent": 0.112534,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "london",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4644f299079b10f0342dca486b2201b6",
		  
		  "name": "Levi",
		  "createdDate": "2023-07-20 17:14:02",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 313,
		  "totalCountries": 20,
		  "totalStates": 57,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1548,
		  "schedulePercent": 0.626587,
		  "totalGuests": 1109,
		  "guestPercent": 0.865707,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4649ad22bf8625a2803dbfcb21c6e5b6",
		  
		  "name": "Austin",
		  "createdDate": "2025-04-28 19:07:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 94,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 452,
		  "schedulePercent": 0.291364,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Harrah's Lake Tahoe",
		  "mostGuestCity": "Stateline",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "464e3cc6cd1de49aa1a086a58afd5512",
		  
		  "name": "Randall",
		  "createdDate": "2017-04-12 21:47:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 231,
		  "totalCountries": 2,
		  "totalStates": 37,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 1960,
		  "schedulePercent": 0.705576,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "465075e02e3ca72dae5c611dde127488",
		  
		  "name": "Whitey ",
		  "createdDate": "2016-07-14 22:55:30",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 386,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 391,
		  "schedulePercent": 0.265073,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "The Dirty Drummer",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4654bd553d26546dcf5101ceac523c34",
		  
		  "name": "Mats",
		  "createdDate": "2016-11-22 12:35:21",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 88,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 185,
		  "schedulePercent": 0.150725,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4672bf1b8a3fa591320fd50c6d8315b7",
		  
		  "name": "Eric",
		  "createdDate": "2019-06-15 05:32:25",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 179,
		  "totalCountries": 15,
		  "totalStates": 57,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1361,
		  "schedulePercent": 0.587715,
		  "totalGuests": 471,
		  "guestPercent": 0.720762,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4675e56258f5055c1eeb365eb36ef100",
		  
		  "name": "Abigail",
		  "createdDate": "2024-03-25 18:48:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 287,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 599,
		  "schedulePercent": 0.350975,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46778f2940bdc2777209da0f9a1c3e2a",
		  
		  "name": "Sherry",
		  "createdDate": "2024-07-23 14:15:42",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 43,
		  "totalCountries": 7,
		  "totalStates": 17,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 201,
		  "schedulePercent": 0.161491,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "467991d6edca0a5e0cf52c08154a183d",
		  
		  "name": "Brian",
		  "createdDate": "2012-03-20 03:18:20",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 51,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 373,
		  "guestPercent": 0.682457,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Moody Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "467caca3b925db5035df4e453cc3066b",
		  
		  "name": "Sally",
		  "createdDate": "2011-08-09 07:03:01",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 86,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 222,
		  "schedulePercent": 0.172597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4682595cbb7db323d3c1268036b3ce81",
		  
		  "name": "John",
		  "createdDate": "2019-08-29 08:01:59",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 101,
		  "totalCountries": 9,
		  "totalStates": 24,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 865,
		  "schedulePercent": 0.446623,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Royale",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4687485f8a8be0757dddeb7c3a17df4f",
		  
		  "name": "Colton",
		  "createdDate": "2025-08-26 14:49:09",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 128,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 74,
		  "schedulePercent": 0.0775159,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "469036dd0a74fff70d887bd9a9691547",
		  
		  "name": "Sean",
		  "createdDate": "2018-10-06 02:26:36",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 144,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1046,
		  "schedulePercent": 0.503173,
		  "totalGuests": 1060,
		  "guestPercent": 0.856301,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4691165425991e4116f08db207b78045",
		  
		  "name": "Taylor",
		  "createdDate": "2018-06-27 22:53:03",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 373,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1586,
		  "schedulePercent": 0.637579,
		  "totalGuests": 1510,
		  "guestPercent": 0.910358,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46992db91473eabb21b811abe5637a39",
		  
		  "name": "Benjamin",
		  "createdDate": "2022-01-29 11:07:23",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 68,
		  "totalCountries": 6,
		  "totalStates": 11,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 276,
		  "schedulePercent": 0.202969,
		  "totalGuests": 216,
		  "guestPercent": 0.605961,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "469f0e11c049ea5b25f35ff1599526f4",
		  
		  "name": "Mitchell",
		  "createdDate": "2021-01-15 22:05:54",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 806,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 263,
		  "schedulePercent": 0.196056,
		  "totalGuests": 273,
		  "guestPercent": 0.636899,
		  "mostGuestDate": "2025-05-13 00:00:00",
		  "mostGuestName": "CMA Theater at the Country Music Hall of Fame and Museum",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46a8ced62da625ac679d4cb14dcb5fcf",
		  
		  "name": "Mickey",
		  "createdDate": "2024-08-14 00:59:54",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 148,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 7,
		  "schedulePercent": 0.0172257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46b5c026c490eca698eeb131295d1358",
		  
		  "name": "Antti",
		  "createdDate": "2022-02-24 07:41:32",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 86,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 271,
		  "schedulePercent": 0.200023,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Espoon Viinijuhlat",
		  "mostGuestCity": "Espoo",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46c1853bfdb3cfc1345b97a5167a5e83",
		  
		  "name": "Benjamin",
		  "createdDate": "2021-11-09 11:00:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 399,
		  "totalCountries": 12,
		  "totalStates": 12,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 362,
		  "schedulePercent": 0.249093,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46cbfe6a872c13078aa9c2c674d6bd15",
		  
		  "name": "Guillaume",
		  "createdDate": "2017-10-13 15:42:54",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 214,
		  "totalCountries": 19,
		  "totalStates": 40,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1030,
		  "schedulePercent": 0.498753,
		  "totalGuests": 325,
		  "guestPercent": 0.663531,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Station SC",
		  "mostGuestCity": "Birtinya",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46cd36429c3503de5688694480e8423b",
		  
		  "name": "Carl",
		  "createdDate": "2025-01-14 17:53:34",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 477,
		  "totalCountries": 14,
		  "totalStates": 38,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1076,
		  "schedulePercent": 0.512466,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46d31d5ad752a7e53a2230aa6ed711dc",
		  
		  "name": "Connie ",
		  "createdDate": "2019-02-20 04:10:18",
		  "totalOrganizations": 11,
		  "totalTours": 2,
		  "totalDays": 97,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 781,
		  "schedulePercent": 0.416251,
		  "totalGuests": 41,
		  "guestPercent": 0.439937,
		  "mostGuestDate": "2025-01-10 00:00:00",
		  "mostGuestName": "Taffeta Music Hall",
		  "mostGuestCity": "Lowell",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46d4f0526b00929d1696cc9af6f83ea8",
		  
		  "name": "Kim",
		  "createdDate": "2013-07-11 21:05:16",
		  "totalOrganizations": 28,
		  "totalTours": 28,
		  "totalDays": 1923,
		  "totalCountries": 30,
		  "totalStates": 76,
		  "totalEvents": 559,
		  "eventPercent": 0.984701,
		  "totalScheduleItems": 9274,
		  "schedulePercent": 0.995014,
		  "totalGuests": 915,
		  "guestPercent": 0.833296,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "iTHINK Financial Amphitheatre",
		  "mostGuestCity": "West Palm Beach",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46da324a1180db48dd9ea56fd0f8f680",
		  
		  "name": "Ren&#233;",
		  "createdDate": "2022-02-10 16:27:28",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 323,
		  "totalCountries": 30,
		  "totalStates": 34,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 3215,
		  "schedulePercent": 0.861401,
		  "totalGuests": 1014,
		  "guestPercent": 0.849161,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "ParkbÃ¼hne Wuhlheide",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 268,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46dc12f32e514b355e69fb89b8ac701b",
		  
		  "name": "Neville",
		  "createdDate": "2021-09-17 01:59:42",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 524,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 1115,
		  "schedulePercent": 0.522439,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46e0ec3774bf665235c3239ee6420eff",
		  
		  "name": "Lynden",
		  "createdDate": "2013-12-20 07:11:58",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 433,
		  "totalCountries": 16,
		  "totalStates": 39,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 2168,
		  "schedulePercent": 0.74218,
		  "totalGuests": 400,
		  "guestPercent": 0.694583,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46ea833cee831e07846f8efbdc1a530d",
		  
		  "name": "Armando",
		  "createdDate": "2015-09-04 23:03:12",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 102,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "46ef51f4625df33d204fffba333e749c",
		  
		  "name": "Austin",
		  "createdDate": "2023-11-21 17:28:06",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 157,
		  "totalCountries": 14,
		  "totalStates": 46,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 129,
		  "schedulePercent": 0.11718,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-05-26 00:00:00",
		  "mostGuestName": "Esplanade Annexe Studio",
		  "mostGuestCity": "",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "470180cc9ee254e449a5e220d0656b73",
		  
		  "name": "Jay",
		  "createdDate": "2013-07-30 19:07:39",
		  "totalOrganizations": 23,
		  "totalTours": 25,
		  "totalDays": 1495,
		  "totalCountries": 7,
		  "totalStates": 56,
		  "totalEvents": 441,
		  "eventPercent": 0.968835,
		  "totalScheduleItems": 7817,
		  "schedulePercent": 0.989914,
		  "totalGuests": 3094,
		  "guestPercent": 0.983908,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47022092f8c9d9ae9e52aadd993b6385",
		  
		  "name": "Tom",
		  "createdDate": "2016-12-03 01:24:07",
		  "totalOrganizations": 177,
		  "totalTours": 47,
		  "totalDays": 1177,
		  "totalCountries": 16,
		  "totalStates": 33,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 2968,
		  "schedulePercent": 0.839189,
		  "totalGuests": 34,
		  "guestPercent": 0.426677,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "Auditorio Ibirapuera - Oscar Niemeyer",
		  "mostGuestCity": "Sao Paulo",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "470dcd73c22946c918c75704da1497d2",
		  
		  "name": "Erika",
		  "createdDate": "2024-03-05 12:51:24",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 197,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1324,
		  "schedulePercent": 0.576609,
		  "totalGuests": 431,
		  "guestPercent": 0.706709,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "471160afc117fc680c4c4b3891dec3fd",
		  
		  "name": "Laura",
		  "createdDate": "2017-03-23 15:38:55",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 358,
		  "totalCountries": 12,
		  "totalStates": 36,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 2630,
		  "schedulePercent": 0.801111,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Motorco Music Hall",
		  "mostGuestCity": "Durham",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "471bd1918ba7b0afe955d3255ed780b2",
		  
		  "name": "Dallas",
		  "createdDate": "2023-08-15 15:09:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 93,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 352,
		  "schedulePercent": 0.243994,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4729a8b22429fce29c55e4850dca5846",
		  
		  "name": "Adam",
		  "createdDate": "2021-06-29 15:56:40",
		  "totalOrganizations": 16,
		  "totalTours": 30,
		  "totalDays": 2611,
		  "totalCountries": 37,
		  "totalStates": 93,
		  "totalEvents": 491,
		  "eventPercent": 0.977561,
		  "totalScheduleItems": 8067,
		  "schedulePercent": 0.99082,
		  "totalGuests": 2547,
		  "guestPercent": 0.970308,
		  "mostGuestDate": "2025-04-28 00:00:00",
		  "mostGuestName": "Arena CDMX",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "472ad18908353ddc38d1462ec6ea9116",
		  
		  "name": "Steven",
		  "createdDate": "2024-05-12 16:46:25",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 536,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1591,
		  "schedulePercent": 0.639053,
		  "totalGuests": 1938,
		  "guestPercent": 0.941636,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "472ceae08097063a0919ce1ffe01542c",
		  
		  "name": "Henri",
		  "createdDate": "2016-06-25 10:22:26",
		  "totalOrganizations": 36,
		  "totalTours": 65,
		  "totalDays": 1682,
		  "totalCountries": 9,
		  "totalStates": 14,
		  "totalEvents": 1201,
		  "eventPercent": 0.997167,
		  "totalScheduleItems": 5849,
		  "schedulePercent": 0.973595,
		  "totalGuests": 1146,
		  "guestPercent": 0.871034,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47364ec659a11fe740295474b816f5be",
		  
		  "name": "Mike",
		  "createdDate": "2023-12-05 02:08:25",
		  "totalOrganizations": 4,
		  "totalTours": 22,
		  "totalDays": 551,
		  "totalCountries": 6,
		  "totalStates": 34,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1867,
		  "schedulePercent": 0.688577,
		  "totalGuests": 736,
		  "guestPercent": 0.793291,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4739af828050e87175e2c8e66ed73e49",
		  
		  "name": "Luis",
		  "createdDate": "2022-05-11 20:42:08",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 20,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 345,
		  "schedulePercent": 0.24116,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "473c8eb3b453b3c6c18b5acc4fb55d90",
		  
		  "name": "THE",
		  "createdDate": "2018-11-10 18:32:03",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 145,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1054,
		  "schedulePercent": 0.50612,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Knitting Factory",
		  "mostGuestCity": "Boise",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4744df111fd242195898f927a434826e",
		  
		  "name": "Joshua",
		  "createdDate": "2025-04-01 00:42:55",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 71,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 565,
		  "schedulePercent": 0.338735,
		  "totalGuests": 514,
		  "guestPercent": 0.733908,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Webster Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "475a78a788fac25b9f3c4c8d64e37782",
		  
		  "name": "Joe",
		  "createdDate": "2019-07-30 20:58:58",
		  "totalOrganizations": 14,
		  "totalTours": 7,
		  "totalDays": 562,
		  "totalCountries": 11,
		  "totalStates": 30,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1160,
		  "schedulePercent": 0.537511,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4767e6f7cd809e544cf32bbae00cbc47",
		  
		  "name": "Duane",
		  "createdDate": "2021-08-01 16:41:27",
		  "totalOrganizations": 6,
		  "totalTours": 18,
		  "totalDays": 425,
		  "totalCountries": 15,
		  "totalStates": 44,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 2253,
		  "schedulePercent": 0.755213,
		  "totalGuests": 722,
		  "guestPercent": 0.790798,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "OC Fair & Event Center",
		  "mostGuestCity": "Costa Mesa",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "476952b1d71b1e16a6cd279315dda781",
		  
		  "name": "Waynne",
		  "createdDate": "2014-05-23 21:07:57",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 103,
		  "totalCountries": 14,
		  "totalStates": 44,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 734,
		  "schedulePercent": 0.399705,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "476a5d19a69142e32b91d83fba340aa7",
		  
		  "name": "Alex",
		  "createdDate": "2019-05-09 17:10:23",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 571,
		  "totalCountries": 23,
		  "totalStates": 30,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1939,
		  "schedulePercent": 0.702063,
		  "totalGuests": 494,
		  "guestPercent": 0.728694,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "476bb11c91c92e20566f23567afefff7",
		  
		  "name": "Megan",
		  "createdDate": "2023-05-05 03:57:26",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 359,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 799,
		  "schedulePercent": 0.422257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47728e49ba871a6d51e8136d8c3daf68",
		  
		  "name": "",
		  "createdDate": "2022-01-12 16:23:50",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 29,
		  "totalCountries": 1,
		  "totalStates": 3,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 286,
		  "schedulePercent": 0.210335,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4773d0b18f22d9b4cf2dd1a60a11d4f0",
		  
		  "name": "matthew ",
		  "createdDate": "2025-03-17 17:25:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 64,
		  "totalCountries": 15,
		  "totalStates": 18,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 511,
		  "schedulePercent": 0.316296,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "477fb0503e864eb4605ef48ece210a31",
		  
		  "name": "Office",
		  "createdDate": "2023-11-14 07:51:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 142,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 314,
		  "guestPercent": 0.656052,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Klagenfurt Ostbucht",
		  "mostGuestCity": "Klagenfurt am WÃ¶rthersee",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4788a6aed84139d0057645d2f5a14d63",
		  
		  "name": "Monica",
		  "createdDate": "2015-08-24 17:19:46",
		  "totalOrganizations": 3,
		  "totalTours": 17,
		  "totalDays": 299,
		  "totalCountries": 13,
		  "totalStates": 58,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 2935,
		  "schedulePercent": 0.835449,
		  "totalGuests": 1053,
		  "guestPercent": 0.855168,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "479274eaced407f82ddbf1d3b0eacc5a",
		  
		  "name": "Jason",
		  "createdDate": "2017-08-11 18:20:37",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 1588,
		  "totalCountries": 4,
		  "totalStates": 46,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 1638,
		  "schedulePercent": 0.647325,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4795e19a38248c991058a661e7f4c47e",
		  
		  "name": "Poppy",
		  "createdDate": "2025-08-19 08:13:57",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 492,
		  "totalCountries": 21,
		  "totalStates": 33,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 501,
		  "schedulePercent": 0.312443,
		  "totalGuests": 294,
		  "guestPercent": 0.646532,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4796cec33fa1700f2124ec0e6c3706bd",
		  
		  "name": "Tim",
		  "createdDate": "2014-09-15 19:34:13",
		  "totalOrganizations": 230,
		  "totalTours": 34,
		  "totalDays": 1999,
		  "totalCountries": 43,
		  "totalStates": 74,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 4264,
		  "schedulePercent": 0.929737,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "479e19e0dd7288866875d5eeb2a80d98",
		  
		  "name": "Emily ",
		  "createdDate": "2022-01-08 20:13:51",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 729,
		  "totalCountries": 4,
		  "totalStates": 49,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2633,
		  "schedulePercent": 0.801224,
		  "totalGuests": 1502,
		  "guestPercent": 0.908885,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47a698f19a7c707e6130a231d84845de",
		  
		  "name": "WavyLand",
		  "createdDate": "2025-05-06 00:51:53",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 83,
		  "totalCountries": 5,
		  "totalStates": 9,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 310,
		  "schedulePercent": 0.222688,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47b0f99ab15309d4f8870dcac36ef33a",
		  
		  "name": "Carly ",
		  "createdDate": "2019-01-04 12:46:00",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 305,
		  "totalCountries": 12,
		  "totalStates": 8,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 290,
		  "schedulePercent": 0.212149,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Shacklewell Arms",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47ba2e5747d6b1aa135ab1c934a52410",
		  
		  "name": "Toby",
		  "createdDate": "2024-08-28 23:31:24",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 1516,
		  "totalCountries": 22,
		  "totalStates": 60,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2134,
		  "schedulePercent": 0.737307,
		  "totalGuests": 793,
		  "guestPercent": 0.806324,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Footprint Center",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47cdd385e91410994995642147d42888",
		  
		  "name": "Ollie",
		  "createdDate": "2017-06-03 10:29:26",
		  "totalOrganizations": 26,
		  "totalTours": 29,
		  "totalDays": 783,
		  "totalCountries": 36,
		  "totalStates": 75,
		  "totalEvents": 376,
		  "eventPercent": 0.952629,
		  "totalScheduleItems": 6104,
		  "schedulePercent": 0.977221,
		  "totalGuests": 905,
		  "guestPercent": 0.831482,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47d18a97fbb9f18504e4c65da4d98fe1",
		  
		  "name": "Justin",
		  "createdDate": "2013-03-11 12:56:01",
		  "totalOrganizations": 24,
		  "totalTours": 27,
		  "totalDays": 1732,
		  "totalCountries": 27,
		  "totalStates": 91,
		  "totalEvents": 412,
		  "eventPercent": 0.961582,
		  "totalScheduleItems": 4588,
		  "schedulePercent": 0.940503,
		  "totalGuests": 1459,
		  "guestPercent": 0.906505,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "OVO Arena, Wembley",
		  "mostGuestCity": "Wembley",
		  "mostGuestAmount": 128,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47db147093c451ac39bdd7cd55963358",
		  
		  "name": "Ilkka",
		  "createdDate": "2024-09-27 12:10:44",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 200,
		  "totalCountries": 16,
		  "totalStates": 13,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 794,
		  "schedulePercent": 0.420331,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Huvila-teltta",
		  "mostGuestCity": "Hakaniemi",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47e3492b5a11568bafea137d5b28cf49",
		  
		  "name": "Ari",
		  "createdDate": "2025-03-18 21:33:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 151,
		  "schedulePercent": 0.130326,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Elsewhere",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47e52a209f8e0628b76e5fba52744e30",
		  
		  "name": "Timothy",
		  "createdDate": "2023-04-23 18:06:11",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 174,
		  "totalCountries": 23,
		  "totalStates": 26,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 778,
		  "schedulePercent": 0.415458,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Pomona Fox Theater",
		  "mostGuestCity": "Pomona",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47e9bdb3093bc58e73fb9996bc6a1ebd",
		  
		  "name": "Jon ",
		  "createdDate": "2014-02-12 17:41:49",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 70,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 456,
		  "schedulePercent": 0.293178,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Travis County Exposition Center- Leudecke Arena",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "47eccd4bf93ebd39770dab7c244081a1",
		  
		  "name": "FERNANDO ",
		  "createdDate": "2022-07-05 02:55:12",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 51,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 229,
		  "schedulePercent": 0.177131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "480268de6d10171f53ac8c4bbbc448b6",
		  
		  "name": "Tom",
		  "createdDate": "2015-04-23 23:14:56",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 321,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 877,
		  "schedulePercent": 0.450136,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Rock City",
		  "mostGuestCity": "Nottingham",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "480f1ff5a6cad211a2fbf67a9a3101f0",
		  
		  "name": "Tim",
		  "createdDate": "2023-10-11 00:34:15",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 351,
		  "totalCountries": 20,
		  "totalStates": 43,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1282,
		  "schedulePercent": 0.567996,
		  "totalGuests": 172,
		  "guestPercent": 0.575136,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4816bc331166a414771ef3529bb283fd",
		  
		  "name": "Elisa",
		  "createdDate": "2022-04-27 22:18:22",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 822,
		  "totalCountries": 12,
		  "totalStates": 29,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 1137,
		  "schedulePercent": 0.530825,
		  "totalGuests": 143,
		  "guestPercent": 0.554057,
		  "mostGuestDate": "2025-06-10 00:00:00",
		  "mostGuestName": "Empower Field at Mile High",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4819e1f0a0bd582eb0babd26b6733549",
		  
		  "name": "Becki",
		  "createdDate": "2025-04-08 09:38:42",
		  "totalOrganizations": 1,
		  "totalTours": 16,
		  "totalDays": 162,
		  "totalCountries": 6,
		  "totalStates": 31,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1240,
		  "schedulePercent": 0.557344,
		  "totalGuests": 384,
		  "guestPercent": 0.68767,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4844a62e12c7ed4a20d6ba57cda9c63d",
		  
		  "name": "Travis",
		  "createdDate": "2022-05-21 12:37:51",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 517,
		  "totalCountries": 19,
		  "totalStates": 37,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1187,
		  "schedulePercent": 0.543744,
		  "totalGuests": 610,
		  "guestPercent": 0.761786,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 150,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4848678db2e4651d4c29ab339c8c0f45",
		  
		  "name": "Ben",
		  "createdDate": "2019-01-30 16:45:31",
		  "totalOrganizations": 16,
		  "totalTours": 19,
		  "totalDays": 1146,
		  "totalCountries": 34,
		  "totalStates": 70,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 4209,
		  "schedulePercent": 0.926337,
		  "totalGuests": 1295,
		  "guestPercent": 0.885653,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "484d8dd8276c9411f86f04189225d2d2",
		  
		  "name": "Crispin",
		  "createdDate": "2022-10-20 13:49:18",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 803,
		  "totalCountries": 12,
		  "totalStates": 60,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 1550,
		  "schedulePercent": 0.62704,
		  "totalGuests": 643,
		  "guestPercent": 0.769832,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Danforth Music Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "487d613398e88c3685328eee33a91386",
		  
		  "name": "Filip",
		  "createdDate": "2023-09-24 20:40:54",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 497,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 348,
		  "schedulePercent": 0.241954,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Parkbiografen",
		  "mostGuestCity": "Skien",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4882408e914eb3805919c36f1a528d41",
		  
		  "name": "Jacki",
		  "createdDate": "2023-09-03 20:36:29",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 643,
		  "totalCountries": 14,
		  "totalStates": 63,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 1903,
		  "schedulePercent": 0.69549,
		  "totalGuests": 540,
		  "guestPercent": 0.740594,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Salt Shed",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48a7fbd47e60ce1f5a84ea5ed50f9933",
		  
		  "name": "John",
		  "createdDate": "2022-10-04 03:35:47",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 244,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 398,
		  "schedulePercent": 0.268586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48a8913306590dcd8881557adfcaf562",
		  
		  "name": "Dayne",
		  "createdDate": "2011-05-27 00:57:04",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 935,
		  "totalCountries": 6,
		  "totalStates": 46,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 2986,
		  "schedulePercent": 0.841455,
		  "totalGuests": 1034,
		  "guestPercent": 0.851995,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48bbcfbc66c18987bbdda41e7b2b7b80",
		  
		  "name": "David",
		  "createdDate": "2017-08-04 04:05:24",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 69,
		  "totalCountries": 8,
		  "totalStates": 20,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 457,
		  "schedulePercent": 0.293404,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48c88f2ffd479826f84565e417044af0",
		  
		  "name": "Andrea",
		  "createdDate": "2023-09-21 04:12:00",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 228,
		  "totalCountries": 4,
		  "totalStates": 31,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 253,
		  "schedulePercent": 0.191976,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-02-10 00:00:00",
		  "mostGuestName": "Foce",
		  "mostGuestCity": "Lugano",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48ca2582fd5ba8f2b20a8b6138030219",
		  
		  "name": "Alex",
		  "createdDate": "2018-09-10 14:59:02",
		  "totalOrganizations": 10,
		  "totalTours": 22,
		  "totalDays": 288,
		  "totalCountries": 9,
		  "totalStates": 32,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1779,
		  "schedulePercent": 0.672371,
		  "totalGuests": 1890,
		  "guestPercent": 0.939597,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48d2f2c8fd2d152cba35982bd9315e81",
		  
		  "name": "Karen ",
		  "createdDate": "2015-03-18 23:00:10",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 1195,
		  "totalCountries": 11,
		  "totalStates": 42,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 579,
		  "schedulePercent": 0.343155,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48d704548042540a141db5d0b153a497",
		  
		  "name": "Dustin",
		  "createdDate": "2019-03-19 16:44:55",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 569,
		  "totalCountries": 11,
		  "totalStates": 57,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2516,
		  "schedulePercent": 0.788078,
		  "totalGuests": 1243,
		  "guestPercent": 0.879986,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48dd68a3e173c02499d860e32cc42e61",
		  
		  "name": "Geoff",
		  "createdDate": "2012-07-09 15:19:39",
		  "totalOrganizations": 12,
		  "totalTours": 4,
		  "totalDays": 204,
		  "totalCountries": 19,
		  "totalStates": 40,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 836,
		  "schedulePercent": 0.436197,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48e688588b70dce5d4c6e3c9686ec6b4",
		  
		  "name": "Peter",
		  "createdDate": "2024-07-09 21:41:04",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 55,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 559,
		  "schedulePercent": 0.336809,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Rochaus",
		  "mostGuestCity": "West Dundee",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48ebee7174f167b0dba0152ebb4cfe30",
		  
		  "name": "Steve",
		  "createdDate": "2015-09-17 19:28:06",
		  "totalOrganizations": 13,
		  "totalTours": 12,
		  "totalDays": 1316,
		  "totalCountries": 8,
		  "totalStates": 59,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 2540,
		  "schedulePercent": 0.790911,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Santa Barbara Bowl",
		  "mostGuestCity": "Santa Barbara",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48f34734d5adb1319babcde0c3467af9",
		  
		  "name": "Noelle",
		  "createdDate": "2016-09-14 21:29:30",
		  "totalOrganizations": 20,
		  "totalTours": 35,
		  "totalDays": 1743,
		  "totalCountries": 29,
		  "totalStates": 79,
		  "totalEvents": 571,
		  "eventPercent": 0.985947,
		  "totalScheduleItems": 6591,
		  "schedulePercent": 0.983001,
		  "totalGuests": 1832,
		  "guestPercent": 0.93495,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Cal Coast Credit Union Amphitheater",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "48f7f893a8298efc589549e86ac8e69b",
		  
		  "name": "Brian",
		  "createdDate": "2021-09-24 21:11:41",
		  "totalOrganizations": 9,
		  "totalTours": 21,
		  "totalDays": 525,
		  "totalCountries": 15,
		  "totalStates": 58,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 2850,
		  "schedulePercent": 0.827743,
		  "totalGuests": 965,
		  "guestPercent": 0.840435,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Echo-Plex",
		  "mostGuestCity": "Echo Park",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49044412cce179ef6d8790bd565688ad",
		  
		  "name": "Foreign ",
		  "createdDate": "2024-12-16 23:35:23",
		  "totalOrganizations": 1,
		  "totalTours": 14,
		  "totalDays": 106,
		  "totalCountries": 9,
		  "totalStates": 25,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 173,
		  "schedulePercent": 0.142452,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "490989c59b90f583886649f1d99eb754",
		  
		  "name": "Christopher",
		  "createdDate": "2019-05-15 10:35:49",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 679,
		  "totalCountries": 36,
		  "totalStates": 52,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 2264,
		  "schedulePercent": 0.757366,
		  "totalGuests": 634,
		  "guestPercent": 0.766659,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4925b8c335052167457a896adee54832",
		  
		  "name": "Erin",
		  "createdDate": "2016-09-01 17:36:02",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 612,
		  "totalCountries": 16,
		  "totalStates": 58,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 4123,
		  "schedulePercent": 0.920444,
		  "totalGuests": 1886,
		  "guestPercent": 0.93937,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49267d4cb90842a3b895064d9bc14fa1",
		  
		  "name": "Ibrahim",
		  "createdDate": "2023-01-05 18:02:32",
		  "totalOrganizations": 2,
		  "totalTours": 36,
		  "totalDays": 566,
		  "totalCountries": 18,
		  "totalStates": 37,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 2464,
		  "schedulePercent": 0.782865,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Ocean Resort Casino - Ovation Hall",
		  "mostGuestCity": "Atlantic City",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "492a1754b6fa324fa72217b34615a29d",
		  
		  "name": "Julia",
		  "createdDate": "2025-05-19 16:27:15",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 223,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 471,
		  "schedulePercent": 0.298731,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "492ddb2585aecfa90d9b30fca9cb8af9",
		  
		  "name": "Pedro",
		  "createdDate": "2024-09-24 18:09:28",
		  "totalOrganizations": 16,
		  "totalTours": 16,
		  "totalDays": 526,
		  "totalCountries": 18,
		  "totalStates": 16,
		  "totalEvents": 437,
		  "eventPercent": 0.968155,
		  "totalScheduleItems": 4233,
		  "schedulePercent": 0.928264,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "492e345662925ae7b5df52eb7e107abc",
		  
		  "name": "Alex",
		  "createdDate": "2022-06-07 21:55:41",
		  "totalOrganizations": 8,
		  "totalTours": 15,
		  "totalDays": 431,
		  "totalCountries": 19,
		  "totalStates": 62,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2859,
		  "schedulePercent": 0.828422,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "Admiralspalast",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "492f1cc524c132283b26863423836dbb",
		  
		  "name": "Megan",
		  "createdDate": "2022-07-27 17:55:02",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 420,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 730,
		  "schedulePercent": 0.397892,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4930736ce7a45df69c890ae3a2ca0da5",
		  
		  "name": "Emily",
		  "createdDate": "2021-12-03 13:55:48",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 390,
		  "totalCountries": 26,
		  "totalStates": 77,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 3178,
		  "schedulePercent": 0.857774,
		  "totalGuests": 1287,
		  "guestPercent": 0.884066,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4937737a04753a70b83bd21219493f78",
		  
		  "name": "Remko",
		  "createdDate": "2018-09-07 12:47:48",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 12,
		  "totalStates": 16,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 264,
		  "schedulePercent": 0.196396,
		  "totalGuests": 200,
		  "guestPercent": 0.594855,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49381b252983016e52c5949c2aa6c4a1",
		  
		  "name": "Joel",
		  "createdDate": "2025-03-27 07:04:58",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 72,
		  "schedulePercent": 0.0759293,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "494ef28b8887a9db15be59f3310377ab",
		  
		  "name": "Terence",
		  "createdDate": "2020-01-23 00:45:44",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 93,
		  "totalCountries": 13,
		  "totalStates": 19,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 784,
		  "schedulePercent": 0.417044,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Decca Live",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "495b95789343722b34e44507fe2d1bf8",
		  
		  "name": "Anissa",
		  "createdDate": "2021-05-31 14:59:16",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 727,
		  "totalCountries": 5,
		  "totalStates": 18,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1916,
		  "schedulePercent": 0.697303,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "495ba29ab8ab15ef9be9a8bcd28488bf",
		  
		  "name": "Antonia",
		  "createdDate": "2022-07-06 10:40:19",
		  "totalOrganizations": 64,
		  "totalTours": 77,
		  "totalDays": 5662,
		  "totalCountries": 26,
		  "totalStates": 44,
		  "totalEvents": 1477,
		  "eventPercent": 0.998527,
		  "totalScheduleItems": 9622,
		  "schedulePercent": 0.996147,
		  "totalGuests": 192,
		  "guestPercent": 0.587262,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "The Marlowe",
		  "mostGuestCity": "Canterbury",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "496cc3ff892ef8aaf3f4afba568759ab",
		  
		  "name": "Tiffany",
		  "createdDate": "2024-06-21 03:36:05",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 1639,
		  "totalCountries": 21,
		  "totalStates": 42,
		  "totalEvents": 246,
		  "eventPercent": 0.866954,
		  "totalScheduleItems": 4102,
		  "schedulePercent": 0.918858,
		  "totalGuests": 1290,
		  "guestPercent": 0.884406,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "496eab42072007a90dcb03ec27f352c6",
		  
		  "name": "John",
		  "createdDate": "2017-04-01 10:56:03",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 243,
		  "totalCountries": 15,
		  "totalStates": 26,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 690,
		  "schedulePercent": 0.382593,
		  "totalGuests": 269,
		  "guestPercent": 0.63418,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Salle Pleyel",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "498214b5fd830895a0a4320649ec3014",
		  
		  "name": "Gary",
		  "createdDate": "2018-04-04 14:00:10",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 268,
		  "totalCountries": 11,
		  "totalStates": 15,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 418,
		  "schedulePercent": 0.277765,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Fox Theater",
		  "mostGuestCity": "Oakland",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "498895b1f7627c480e14440761c339a7",
		  
		  "name": "JAVIER",
		  "createdDate": "2024-04-04 04:19:34",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 130,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 733,
		  "schedulePercent": 0.399592,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "498b2810aaf69057497c4932073b7f94",
		  
		  "name": "Kevin",
		  "createdDate": "2025-03-02 18:06:00",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 66,
		  "totalCountries": 7,
		  "totalStates": 19,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 564,
		  "schedulePercent": 0.338509,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49970a57cc3e99a93a3e8488b2225f4e",
		  
		  "name": "James",
		  "createdDate": "2019-04-20 19:52:49",
		  "totalOrganizations": 9,
		  "totalTours": 22,
		  "totalDays": 707,
		  "totalCountries": 25,
		  "totalStates": 67,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 3201,
		  "schedulePercent": 0.859927,
		  "totalGuests": 1042,
		  "guestPercent": 0.853015,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "NRG Stadium",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49a06360c6235b9d4fdbfbd729d4c28d",
		  
		  "name": "Allen",
		  "createdDate": "2017-11-08 19:27:37",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 430,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 444,
		  "schedulePercent": 0.288078,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Win River Casino",
		  "mostGuestCity": "Redding",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49a2f062b2029811e3cefdaaac15cdd8",
		  
		  "name": "Matias ",
		  "createdDate": "2016-02-02 20:12:34",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 8,
		  "totalStates": 13,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 194,
		  "schedulePercent": 0.155712,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49a397dd229fc47c1f32261c13252616",
		  
		  "name": "Devyn",
		  "createdDate": "2020-01-31 00:17:21",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 381,
		  "totalCountries": 23,
		  "totalStates": 52,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 3659,
		  "schedulePercent": 0.893812,
		  "totalGuests": 1291,
		  "guestPercent": 0.884973,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49a91041f4fe61d4d232779ebbd14e17",
		  
		  "name": "Aaron",
		  "createdDate": "2022-05-15 18:43:15",
		  "totalOrganizations": 7,
		  "totalTours": 20,
		  "totalDays": 209,
		  "totalCountries": 21,
		  "totalStates": 41,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1749,
		  "schedulePercent": 0.668404,
		  "totalGuests": 394,
		  "guestPercent": 0.691976,
		  "mostGuestDate": "2025-01-15 00:00:00",
		  "mostGuestName": "Lodge Room",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49abd6b4da5e83db57aebc8638f8ec0a",
		  
		  "name": "Adam ",
		  "createdDate": "2025-04-02 04:28:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 204,
		  "schedulePercent": 0.163531,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Ballroom @ Spiderhouse",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49b680a03f01154780ef4749478af689",
		  
		  "name": "Shae",
		  "createdDate": "2024-07-07 13:52:18",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 909,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1335,
		  "schedulePercent": 0.581936,
		  "totalGuests": 1596,
		  "guestPercent": 0.919311,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Ravinia",
		  "mostGuestCity": "Highland Park",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49ccc32a12b57dda833f99f9102c3dd1",
		  
		  "name": "Gray",
		  "createdDate": "2025-08-12 23:11:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 228,
		  "schedulePercent": 0.176451,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "McMenamins Mission Theater",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49d1f96868ba7783bb709c4ee1321d56",
		  
		  "name": "Adam",
		  "createdDate": "2025-08-17 22:04:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 139,
		  "schedulePercent": 0.123867,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Stockyard",
		  "mostGuestCity": "Holiday",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49db5eb36cda4def7fd4ec2dff78c357",
		  
		  "name": "Rex",
		  "createdDate": "2014-11-04 17:08:35",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 939,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 159,
		  "schedulePercent": 0.134519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49dcfb0e883b24301ce7c97a967bceb5",
		  
		  "name": "Otto",
		  "createdDate": "2023-06-29 20:36:49",
		  "totalOrganizations": 11,
		  "totalTours": 52,
		  "totalDays": 798,
		  "totalCountries": 22,
		  "totalStates": 67,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 1727,
		  "schedulePercent": 0.663418,
		  "totalGuests": 496,
		  "guestPercent": 0.729148,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49e48dec568e47b20fb36383fa774c93",
		  
		  "name": "Carlos",
		  "createdDate": "2017-12-05 11:10:42",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 156,
		  "totalCountries": 9,
		  "totalStates": 37,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 327,
		  "schedulePercent": 0.230054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49f09bfccb8299dabbd2cddbb3705b31",
		  
		  "name": "Theau ",
		  "createdDate": "2022-07-04 05:48:45",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 377,
		  "totalCountries": 10,
		  "totalStates": 15,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 238,
		  "schedulePercent": 0.183704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "49f8977573d3191015ce1c899f69ea67",
		  
		  "name": "Areli",
		  "createdDate": "2022-04-08 23:48:11",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 78,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 324,
		  "schedulePercent": 0.228354,
		  "totalGuests": 475,
		  "guestPercent": 0.722348,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "HISTORY",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a067c1ac1a7432b2a9909ad8f9367fc",
		  
		  "name": "Alex",
		  "createdDate": "2021-07-16 02:03:53",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 412,
		  "totalCountries": 12,
		  "totalStates": 56,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 2374,
		  "schedulePercent": 0.771985,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "100 Club",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a0d56f3c3c832075a279ee60cdfff37",
		  
		  "name": "Matthias",
		  "createdDate": "2022-05-29 07:54:23",
		  "totalOrganizations": 26,
		  "totalTours": 20,
		  "totalDays": 360,
		  "totalCountries": 26,
		  "totalStates": 67,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1368,
		  "schedulePercent": 0.588622,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-01-28 00:00:00",
		  "mostGuestName": "L'Olympia Bruno Coquatrix",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a0d7ce69e25b3262943021c0ec37835",
		  
		  "name": "Bethany",
		  "createdDate": "2009-11-18 19:17:13",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 1425,
		  "schedulePercent": 0.603581,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a18f0864a07384becee73239c059b64",
		  
		  "name": "Shwayze",
		  "createdDate": "2023-03-06 21:27:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 851,
		  "schedulePercent": 0.44039,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a194c3ecb65fda56bab1475573bf91a",
		  
		  "name": "Troy",
		  "createdDate": "2022-05-19 20:30:21",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 598,
		  "totalCountries": 6,
		  "totalStates": 44,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 1909,
		  "schedulePercent": 0.696283,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a19ea1916cb5a1670f3249cb16517fd",
		  
		  "name": "Loren",
		  "createdDate": "2025-05-08 20:19:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 104,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 414,
		  "schedulePercent": 0.275612,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a20a7ad5075f48d119f35e1a9519c09",
		  
		  "name": "Jeff",
		  "createdDate": "2022-03-06 18:28:39",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 474,
		  "totalCountries": 6,
		  "totalStates": 34,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1015,
		  "schedulePercent": 0.494674,
		  "totalGuests": 1307,
		  "guestPercent": 0.887239,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a223f2aba55f28a0cb5d744ceab1a74",
		  
		  "name": "Thomas",
		  "createdDate": "2023-07-25 07:09:49",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 140,
		  "totalCountries": 20,
		  "totalStates": 35,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1053,
		  "schedulePercent": 0.505893,
		  "totalGuests": 282,
		  "guestPercent": 0.640413,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Huskvarna Folkets Park",
		  "mostGuestCity": "Huskvarna",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a2a98ba3b554068c1f1494a6628031d",
		  
		  "name": "Mark",
		  "createdDate": "2025-01-17 16:49:19",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 345,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 720,
		  "schedulePercent": 0.394266,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Mars Music Hall",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a3189439b9add744f61768fab7bcfcc",
		  
		  "name": "William",
		  "createdDate": "2016-10-31 21:27:35",
		  "totalOrganizations": 18,
		  "totalTours": 22,
		  "totalDays": 1760,
		  "totalCountries": 25,
		  "totalStates": 78,
		  "totalEvents": 611,
		  "eventPercent": 0.987761,
		  "totalScheduleItems": 8991,
		  "schedulePercent": 0.99354,
		  "totalGuests": 3017,
		  "guestPercent": 0.982208,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a36041d83637912b780b0b291ca41b5",
		  
		  "name": "Harri",
		  "createdDate": "2023-01-30 06:49:43",
		  "totalOrganizations": 43,
		  "totalTours": 72,
		  "totalDays": 2531,
		  "totalCountries": 8,
		  "totalStates": 91,
		  "totalEvents": 1384,
		  "eventPercent": 0.998073,
		  "totalScheduleItems": 6470,
		  "schedulePercent": 0.981641,
		  "totalGuests": 659,
		  "guestPercent": 0.773572,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a4130b1614df1ed6a228a9855977162",
		  
		  "name": "Phil",
		  "createdDate": "2021-08-25 06:53:28",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 815,
		  "totalCountries": 8,
		  "totalStates": 54,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 2428,
		  "schedulePercent": 0.778332,
		  "totalGuests": 938,
		  "guestPercent": 0.837035,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a4c96e14f383bc0497713bc1343b1e0",
		  
		  "name": "Tobias",
		  "createdDate": "2025-04-07 22:27:23",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 43,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a50a7a53e86a045992724584aba436e",
		  
		  "name": "Xavier",
		  "createdDate": "2024-05-23 22:40:21",
		  "totalOrganizations": 9,
		  "totalTours": 20,
		  "totalDays": 391,
		  "totalCountries": 16,
		  "totalStates": 57,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 2187,
		  "schedulePercent": 0.746147,
		  "totalGuests": 1227,
		  "guestPercent": 0.878626,
		  "mostGuestDate": "2025-01-22 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a589b1ec4b265944983d0d682ed5368",
		  
		  "name": "Jacob Aarosiin",
		  "createdDate": "2024-12-19 11:22:47",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 238,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 1196,
		  "schedulePercent": 0.546691,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a5fb9c9440b971a209176bf1056ae6e",
		  
		  "name": "Nate ",
		  "createdDate": "2015-02-03 18:58:23",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 1609,
		  "totalCountries": 3,
		  "totalStates": 52,
		  "totalEvents": 310,
		  "eventPercent": 0.919198,
		  "totalScheduleItems": 2593,
		  "schedulePercent": 0.796578,
		  "totalGuests": 704,
		  "guestPercent": 0.786605,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a618366424f60fde6abc67aeda368f7",
		  
		  "name": "Tanja",
		  "createdDate": "2022-08-22 13:07:22",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 345,
		  "totalCountries": 15,
		  "totalStates": 15,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "DBTL, Turku",
		  "mostGuestCity": "",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a6a59676c5a653ecb61197260ea953e",
		  
		  "name": "Erin",
		  "createdDate": "2022-09-20 03:31:45",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 238,
		  "totalCountries": 18,
		  "totalStates": 54,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2052,
		  "schedulePercent": 0.723708,
		  "totalGuests": 326,
		  "guestPercent": 0.664211,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Moody Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a6ecc2b8399e65b795f7d0d796b774a",
		  
		  "name": "Michael",
		  "createdDate": "2024-05-02 23:37:00",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 376,
		  "totalCountries": 4,
		  "totalStates": 44,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1644,
		  "schedulePercent": 0.648232,
		  "totalGuests": 2414,
		  "guestPercent": 0.965435,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a710ca838417b48b733e5a482010948",
		  
		  "name": "Matthew",
		  "createdDate": "2017-03-31 05:28:53",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 240,
		  "totalCountries": 18,
		  "totalStates": 55,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1631,
		  "schedulePercent": 0.646079,
		  "totalGuests": 1040,
		  "guestPercent": 0.852788,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a789d89cea59be795e0c8df9766be8b",
		  
		  "name": "John ",
		  "createdDate": "2024-09-02 14:25:31",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 59,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 511,
		  "schedulePercent": 0.316296,
		  "totalGuests": 779,
		  "guestPercent": 0.802244,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a7ee32597a2fa7c18eaf8816b036166",
		  
		  "name": "TOBE",
		  "createdDate": "2024-05-27 23:37:56",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 68,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a85938dd55a7e4f923935301341ca99",
		  
		  "name": "Mindy",
		  "createdDate": "2023-10-31 18:07:38",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 887,
		  "totalCountries": 33,
		  "totalStates": 74,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 4314,
		  "schedulePercent": 0.931664,
		  "totalGuests": 2672,
		  "guestPercent": 0.974728,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a8aaaac6a5ce5b4de759ed600a9f9d9",
		  
		  "name": "Austin",
		  "createdDate": "2015-10-02 00:39:09",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 114,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 951,
		  "schedulePercent": 0.475861,
		  "totalGuests": 987,
		  "guestPercent": 0.843608,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Signal",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 176,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4a8cd798dc5ebef47dbf212cb8e42155",
		  
		  "name": "Lance",
		  "createdDate": "2011-10-12 14:34:53",
		  "totalOrganizations": 13,
		  "totalTours": 11,
		  "totalDays": 559,
		  "totalCountries": 21,
		  "totalStates": 73,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2170,
		  "schedulePercent": 0.742974,
		  "totalGuests": 410,
		  "guestPercent": 0.697303,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4aa3657237d05543bd14f4c24a6903e0",
		  
		  "name": "Megan",
		  "createdDate": "2013-12-10 19:39:22",
		  "totalOrganizations": 13,
		  "totalTours": 34,
		  "totalDays": 1288,
		  "totalCountries": 28,
		  "totalStates": 68,
		  "totalEvents": 343,
		  "eventPercent": 0.938463,
		  "totalScheduleItems": 4872,
		  "schedulePercent": 0.950589,
		  "totalGuests": 1452,
		  "guestPercent": 0.905032,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Cal Coast Credit Union Amphitheater",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4aa77e21a66876db9d7ed8659ce6b92d",
		  
		  "name": "Vincent",
		  "createdDate": "2016-09-13 10:44:10",
		  "totalOrganizations": 6,
		  "totalTours": 26,
		  "totalDays": 607,
		  "totalCountries": 27,
		  "totalStates": 75,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 1569,
		  "schedulePercent": 0.634746,
		  "totalGuests": 253,
		  "guestPercent": 0.626927,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "Sanders Theatre",
		  "mostGuestCity": "Cambridge",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ab52d66fec29292599a2ce24ab86c65",
		  
		  "name": "Jorge",
		  "createdDate": "2025-01-28 21:18:51",
		  "totalOrganizations": 27,
		  "totalTours": 26,
		  "totalDays": 351,
		  "totalCountries": 30,
		  "totalStates": 37,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 1558,
		  "schedulePercent": 0.632026,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Folketeateret",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4acb3d2de035ce8ab285933a11352a83",
		  
		  "name": "Sharon ",
		  "createdDate": "2014-05-01 18:55:48",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 79,
		  "totalCountries": 8,
		  "totalStates": 27,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 574,
		  "schedulePercent": 0.341228,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Old Town School of Folk Music",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4acc0e15e3961cc2af574c6c4396443b",
		  
		  "name": "Matthew",
		  "createdDate": "2023-10-30 17:28:02",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 732,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 387,
		  "schedulePercent": 0.262579,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4acee78957c2a09bdf64df1ffd58697f",
		  
		  "name": "Travis",
		  "createdDate": "2016-09-29 06:33:30",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 622,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 271,
		  "eventPercent": 0.891092,
		  "totalScheduleItems": 3144,
		  "schedulePercent": 0.855168,
		  "totalGuests": 1854,
		  "guestPercent": 0.936537,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Boone Pickens Stadium",
		  "mostGuestCity": "Stillwater",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ad4ea3d597b051f81b1f5b5476fab30",
		  
		  "name": "Aaron",
		  "createdDate": "2016-09-19 18:30:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 30,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 779,
		  "schedulePercent": 0.415798,
		  "totalGuests": 407,
		  "guestPercent": 0.696623,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4adad113e852f660457f7429392e72a6",
		  
		  "name": "Brian",
		  "createdDate": "2020-01-07 15:14:25",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 164,
		  "totalCountries": 2,
		  "totalStates": 37,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1644,
		  "schedulePercent": 0.648232,
		  "totalGuests": 582,
		  "guestPercent": 0.753626,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "The Get Down Music Venue",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4adfd71e6da624e9fa66ee55b57c6d25",
		  
		  "name": "Michael",
		  "createdDate": "2012-01-28 20:47:23",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 81,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 578,
		  "schedulePercent": 0.342702,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4aec9eeb9beb505f787140e53fd52437",
		  
		  "name": "Holly",
		  "createdDate": "2025-08-19 20:18:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 168,
		  "schedulePercent": 0.139279,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4aeee7935981e55fe44f1a457fc192ca",
		  
		  "name": "Mikaela",
		  "createdDate": "2025-04-04 12:45:56",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 55,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 324,
		  "schedulePercent": 0.228354,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Liseberg Polketten",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4af155c8496b577a80ee294d8bb62650",
		  
		  "name": "Dennis",
		  "createdDate": "2025-08-03 18:15:17",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 116,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 166,
		  "schedulePercent": 0.138599,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4afd9411dd7f629e09e5448620f66957",
		  
		  "name": "Paul",
		  "createdDate": "2018-01-10 17:49:48",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 110,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 812,
		  "schedulePercent": 0.427697,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4afdfd0418c5c3ff70aaf97ab04a2743",
		  
		  "name": "George ",
		  "createdDate": "2016-07-18 07:28:21",
		  "totalOrganizations": 14,
		  "totalTours": 4,
		  "totalDays": 214,
		  "totalCountries": 20,
		  "totalStates": 11,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1196,
		  "schedulePercent": 0.546691,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b022d1c50015ac4018b3c02122afffd",
		  
		  "name": "Nicole",
		  "createdDate": "2021-11-04 21:38:38",
		  "totalOrganizations": 27,
		  "totalTours": 27,
		  "totalDays": 1005,
		  "totalCountries": 33,
		  "totalStates": 57,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 4461,
		  "schedulePercent": 0.936423,
		  "totalGuests": 95,
		  "guestPercent": 0.513826,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "SunBet Arena at Time Square Casino",
		  "mostGuestCity": "Pretoria",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b371b048467c086a1f17135ffeafae1",
		  
		  "name": "Ash",
		  "createdDate": "2019-10-14 16:18:56",
		  "totalOrganizations": 34,
		  "totalTours": 29,
		  "totalDays": 697,
		  "totalCountries": 24,
		  "totalStates": 72,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 3704,
		  "schedulePercent": 0.896532,
		  "totalGuests": 1489,
		  "guestPercent": 0.908545,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b43e149e2c511cc65e02f081a3c3ea4",
		  
		  "name": "Marco",
		  "createdDate": "2011-12-03 16:57:57",
		  "totalOrganizations": 1,
		  "totalTours": 24,
		  "totalDays": 139,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 368,
		  "schedulePercent": 0.252153,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b4ffbb6a6a8f77ec4ed258eb0641347",
		  
		  "name": "Bj&#248;rn Terje",
		  "createdDate": "2024-11-01 12:49:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 330,
		  "schedulePercent": 0.230961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b5b811292bb1e04c2d67839881ece64",
		  
		  "name": "Jan",
		  "createdDate": "2022-02-05 21:01:26",
		  "totalOrganizations": 15,
		  "totalTours": 15,
		  "totalDays": 816,
		  "totalCountries": 24,
		  "totalStates": 62,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 2923,
		  "schedulePercent": 0.833182,
		  "totalGuests": 562,
		  "guestPercent": 0.746827,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b5f8ad2f3950fa8c63830898c096bf6",
		  
		  "name": "Filip Blystad ",
		  "createdDate": "2024-07-22 19:37:50",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 388,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 32,
		  "schedulePercent": 0.042951,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b67552ef97658fa29d1c96118a7ee24",
		  
		  "name": "Matthys ",
		  "createdDate": "2016-11-02 23:45:48",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 62,
		  "totalCountries": 9,
		  "totalStates": 5,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 271,
		  "schedulePercent": 0.200023,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b73191a3b9db1dfc7ccd71db9f60421",
		  
		  "name": "JT",
		  "createdDate": "2022-10-12 15:54:17",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 274,
		  "totalCountries": 9,
		  "totalStates": 34,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1397,
		  "schedulePercent": 0.597235,
		  "totalGuests": 2079,
		  "guestPercent": 0.952743,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b76ab3a52243f1ce751dba77ceed81c",
		  
		  "name": "MasterTour3",
		  "createdDate": "2017-10-19 14:26:09",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 319,
		  "totalCountries": 5,
		  "totalStates": 7,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 455,
		  "schedulePercent": 0.292611,
		  "totalGuests": 201,
		  "guestPercent": 0.595422,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Paleo Festival Nyon",
		  "mostGuestCity": "Nyon",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b76d7d8591c3e0acfffa538a394b885",
		  
		  "name": "Sean",
		  "createdDate": "2022-07-19 16:15:00",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b7c73d4fa7769d235785f43dd541e00",
		  
		  "name": "Omar ",
		  "createdDate": "2013-05-05 03:20:54",
		  "totalOrganizations": 18,
		  "totalTours": 13,
		  "totalDays": 827,
		  "totalCountries": 9,
		  "totalStates": 88,
		  "totalEvents": 300,
		  "eventPercent": 0.913078,
		  "totalScheduleItems": 2910,
		  "schedulePercent": 0.832616,
		  "totalGuests": 313,
		  "guestPercent": 0.655372,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Fred Kavli Theater",
		  "mostGuestCity": "Thousand Oaks",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b7e16508eff097b9684cec3dc62b92e",
		  
		  "name": "nikki",
		  "createdDate": "2025-08-19 04:10:15",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 60,
		  "totalCountries": 5,
		  "totalStates": 23,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 268,
		  "schedulePercent": 0.198209,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b80a2ddf152ab9056d3bcde08cdf1d4",
		  
		  "name": "Julie-Blanche",
		  "createdDate": "2020-02-10 14:53:14",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 186,
		  "totalCountries": 13,
		  "totalStates": 29,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 666,
		  "schedulePercent": 0.373413,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4b8b48ac4038b3a96ef60e8d3a05d6ca",
		  
		  "name": "Adam",
		  "createdDate": "2018-10-11 16:26:38",
		  "totalOrganizations": 73,
		  "totalTours": 66,
		  "totalDays": 8720,
		  "totalCountries": 55,
		  "totalStates": 145,
		  "totalEvents": 1091,
		  "eventPercent": 0.996487,
		  "totalScheduleItems": 16658,
		  "schedulePercent": 0.999207,
		  "totalGuests": 4341,
		  "guestPercent": 0.99524,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ba461fbb41046a2a0b9eb7919dc6909",
		  
		  "name": "Tyler",
		  "createdDate": "2017-07-04 01:18:45",
		  "totalOrganizations": 14,
		  "totalTours": 4,
		  "totalDays": 354,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 709,
		  "schedulePercent": 0.389846,
		  "totalGuests": 419,
		  "guestPercent": 0.701496,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ba5fd6d1f6cccfc69ac51e74d025bc5",
		  
		  "name": "Don",
		  "createdDate": "2023-05-02 16:43:21",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 654,
		  "schedulePercent": 0.368994,
		  "totalGuests": 765,
		  "guestPercent": 0.799637,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bac5ea5e55ba2e74a408f69b7cf7abe",
		  
		  "name": "Meg",
		  "createdDate": "2016-01-29 21:47:29",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 543,
		  "totalCountries": 21,
		  "totalStates": 60,
		  "totalEvents": 230,
		  "eventPercent": 0.848595,
		  "totalScheduleItems": 3130,
		  "schedulePercent": 0.853694,
		  "totalGuests": 408,
		  "guestPercent": 0.69685,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bb113632d7f5d47a9380d63cefb48cb",
		  
		  "name": "Olivia",
		  "createdDate": "2016-07-05 13:45:49",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 244,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 439,
		  "schedulePercent": 0.285811,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Sand Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bbd43ef060aab85f49b16b4971c723e",
		  
		  "name": "Maxance",
		  "createdDate": "2023-05-15 10:14:24",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 260,
		  "totalCountries": 10,
		  "totalStates": 26,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1403,
		  "schedulePercent": 0.598368,
		  "totalGuests": 268,
		  "guestPercent": 0.6335,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Arena Montpellier",
		  "mostGuestCity": "PÃ©rols",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bbfd16d38e43310d269527470d0bebc",
		  
		  "name": "Carlee",
		  "createdDate": "2023-07-13 18:13:32",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 749,
		  "totalCountries": 4,
		  "totalStates": 58,
		  "totalEvents": 333,
		  "eventPercent": 0.934044,
		  "totalScheduleItems": 4986,
		  "schedulePercent": 0.953762,
		  "totalGuests": 388,
		  "guestPercent": 0.68903,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bc2cf12e06f39f131e4129a2531bf2f",
		  
		  "name": "Mark",
		  "createdDate": "2017-07-11 01:19:39",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 193,
		  "totalCountries": 5,
		  "totalStates": 27,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1002,
		  "schedulePercent": 0.49082,
		  "totalGuests": 293,
		  "guestPercent": 0.646306,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "Hopewell",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bcd073be1b354bba219e8a37a82c5af",
		  
		  "name": "Callum",
		  "createdDate": "2021-09-03 05:04:38",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 45,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 242,
		  "schedulePercent": 0.18529,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bdd65e9b4029e8dcdc27ee65d8928a8",
		  
		  "name": "Rob",
		  "createdDate": "2022-05-07 23:46:48",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 120,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 807,
		  "schedulePercent": 0.425657,
		  "totalGuests": 272,
		  "guestPercent": 0.636333,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bed4d5d8135dd12904aeeace14ed5e7",
		  
		  "name": "Everette",
		  "createdDate": "2018-04-25 19:03:11",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 102,
		  "totalCountries": 4,
		  "totalStates": 19,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 471,
		  "schedulePercent": 0.298731,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Stockbridge Amphitheater",
		  "mostGuestCity": "Stockbridge",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bf6d04679e01840048827fd9948c1d2",
		  
		  "name": "Layla",
		  "createdDate": "2024-05-23 22:08:11",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 90,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4bf752c21a338ccf1f96dac48ab3a0ac",
		  
		  "name": "Chris",
		  "createdDate": "2015-03-15 17:24:49",
		  "totalOrganizations": 15,
		  "totalTours": 12,
		  "totalDays": 2223,
		  "totalCountries": 21,
		  "totalStates": 89,
		  "totalEvents": 423,
		  "eventPercent": 0.964189,
		  "totalScheduleItems": 8744,
		  "schedulePercent": 0.992747,
		  "totalGuests": 2259,
		  "guestPercent": 0.960335,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c0a1c5970c3b2af9fbf3090c455875b",
		  
		  "name": "Crook",
		  "createdDate": "2016-02-10 18:58:17",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 445,
		  "totalCountries": 26,
		  "totalStates": 75,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 3043,
		  "schedulePercent": 0.846328,
		  "totalGuests": 1531,
		  "guestPercent": 0.913418,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c0b7b23125fbf7cd19dbd563b8bfd08",
		  
		  "name": "Jim",
		  "createdDate": "2024-07-25 13:26:13",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 207,
		  "totalCountries": 19,
		  "totalStates": 35,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1161,
		  "schedulePercent": 0.537965,
		  "totalGuests": 966,
		  "guestPercent": 0.840662,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c13487e9f442e8a788c48caae569d5f",
		  
		  "name": "Keith Everette",
		  "createdDate": "2015-08-20 20:22:30",
		  "totalOrganizations": 11,
		  "totalTours": 15,
		  "totalDays": 662,
		  "totalCountries": 6,
		  "totalStates": 48,
		  "totalEvents": 386,
		  "eventPercent": 0.955236,
		  "totalScheduleItems": 4051,
		  "schedulePercent": 0.916025,
		  "totalGuests": 2896,
		  "guestPercent": 0.979941,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c25e0e36dcf8389ae4f3b935d2e8cb1",
		  
		  "name": "Dan ",
		  "createdDate": "2015-07-06 03:45:15",
		  "totalOrganizations": 13,
		  "totalTours": 30,
		  "totalDays": 956,
		  "totalCountries": 32,
		  "totalStates": 86,
		  "totalEvents": 353,
		  "eventPercent": 0.94345,
		  "totalScheduleItems": 5078,
		  "schedulePercent": 0.956822,
		  "totalGuests": 1997,
		  "guestPercent": 0.94719,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Exit/In",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c28d70d548888a444c761d0d0b3f264",
		  
		  "name": "Christina",
		  "createdDate": "2022-01-19 19:59:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 202,
		  "schedulePercent": 0.162058,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c2a2c237c0b82739e97e051cb0528b2",
		  
		  "name": "A",
		  "createdDate": "2022-05-21 16:15:48",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 48,
		  "totalCountries": 17,
		  "totalStates": 3,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 361,
		  "schedulePercent": 0.248753,
		  "totalGuests": 521,
		  "guestPercent": 0.736514,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Islington Assembly Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c2f7fd9e0ad548d2069d98f328f45c0",
		  
		  "name": "Matt",
		  "createdDate": "2025-09-11 19:57:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 112,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 269,
		  "schedulePercent": 0.198889,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "St. Augustine Amphitheatre",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c2fa156d5f22c7883be77757d764403",
		  
		  "name": "Katja",
		  "createdDate": "2024-03-05 11:38:56",
		  "totalOrganizations": 41,
		  "totalTours": 40,
		  "totalDays": 849,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 738,
		  "eventPercent": 0.99218,
		  "totalScheduleItems": 4147,
		  "schedulePercent": 0.922144,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Tulisuudelma",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c4b5e58bebf7cff2a3c394898091de0",
		  
		  "name": "Kyle",
		  "createdDate": "2023-08-28 21:50:50",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 368,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1724,
		  "schedulePercent": 0.662738,
		  "totalGuests": 468,
		  "guestPercent": 0.719515,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "40 Watt Club",
		  "mostGuestCity": "Athens",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c4c47b8eb2d74c37f79391e410247d3",
		  
		  "name": "Jack",
		  "createdDate": "2023-01-09 06:26:37",
		  "totalOrganizations": 1,
		  "totalTours": 12,
		  "totalDays": 1177,
		  "totalCountries": 22,
		  "totalStates": 33,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 135,
		  "schedulePercent": 0.121827,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c543f544de92e05662aa1e42dc2f1b7",
		  
		  "name": "David",
		  "createdDate": "2022-04-22 01:02:10",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 923,
		  "totalCountries": 13,
		  "totalStates": 56,
		  "totalEvents": 310,
		  "eventPercent": 0.919198,
		  "totalScheduleItems": 3405,
		  "schedulePercent": 0.87568,
		  "totalGuests": 1065,
		  "guestPercent": 0.857208,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "The Nile Theater",
		  "mostGuestCity": "Bakersfield",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c637d41fca48501c2f537d0b1cdb33d",
		  
		  "name": "Anna",
		  "createdDate": "2014-01-07 17:02:44",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 452,
		  "totalCountries": 9,
		  "totalStates": 30,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 681,
		  "schedulePercent": 0.379646,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c6d3fcb7c7a141454fdc06af2ddc370",
		  
		  "name": "Paul",
		  "createdDate": "2024-02-13 10:53:52",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 104,
		  "totalCountries": 12,
		  "totalStates": 14,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 320,
		  "schedulePercent": 0.226995,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c7a6c8585b7043400c6378f6236fb89",
		  
		  "name": "Clint",
		  "createdDate": "2011-05-28 01:19:40",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 778,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 3021,
		  "schedulePercent": 0.844175,
		  "totalGuests": 323,
		  "guestPercent": 0.662511,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Credit Union 1 Amphitheatre",
		  "mostGuestCity": "Tinley Park",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c8305fe4d6d23e5ba3e4ed51f7dfe9d",
		  
		  "name": "Julian",
		  "createdDate": "2025-01-29 17:05:30",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c852d1f711e6577ac40e698d2184f6b",
		  
		  "name": "Andrew",
		  "createdDate": "2013-03-15 02:35:22",
		  "totalOrganizations": 31,
		  "totalTours": 24,
		  "totalDays": 1898,
		  "totalCountries": 25,
		  "totalStates": 75,
		  "totalEvents": 287,
		  "eventPercent": 0.903672,
		  "totalScheduleItems": 3995,
		  "schedulePercent": 0.913191,
		  "totalGuests": 1229,
		  "guestPercent": 0.87874,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Majestic Ventura Theater",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c85aaf561e3de438d3f96bf5b0b8a76",
		  
		  "name": "Chris",
		  "createdDate": "2023-06-29 20:39:08",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 58,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 434,
		  "schedulePercent": 0.283205,
		  "totalGuests": 601,
		  "guestPercent": 0.758273,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c8956cc2829d0bff397352a9fed1bd0",
		  
		  "name": "Justin",
		  "createdDate": "2016-02-19 03:37:49",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 220,
		  "schedulePercent": 0.171578,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Intuition Ale Works",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c8ea93e0f59a86bcfef2707a5dd62e0",
		  
		  "name": "Keren",
		  "createdDate": "2025-05-22 20:59:00",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 177,
		  "totalCountries": 20,
		  "totalStates": 23,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 815,
		  "schedulePercent": 0.428944,
		  "totalGuests": 118,
		  "guestPercent": 0.535698,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c94809f3c4edc05122ca0bba197fd76",
		  
		  "name": "Jeffery",
		  "createdDate": "2025-01-27 00:17:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 135,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 886,
		  "schedulePercent": 0.452516,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Billy Bob's Texas",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c97a7f58f1ea6b6827e51a2a8bea650",
		  
		  "name": "Alex",
		  "createdDate": "2022-12-19 05:23:47",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 735,
		  "totalCountries": 35,
		  "totalStates": 60,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 2924,
		  "schedulePercent": 0.833522,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c98b51e77a491d0abca769203524727",
		  
		  "name": "Yanira",
		  "createdDate": "2022-04-29 01:30:13",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 424,
		  "totalCountries": 20,
		  "totalStates": 57,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 1919,
		  "schedulePercent": 0.697643,
		  "totalGuests": 553,
		  "guestPercent": 0.7449,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4c9f57b37c395c9ab9d555dbd66f5e19",
		  
		  "name": "Alexander",
		  "createdDate": "2024-07-04 08:49:19",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 49,
		  "totalCountries": 5,
		  "totalStates": 4,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 313,
		  "schedulePercent": 0.223935,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Kollektivet Livet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ca100ed6c8f88a8e68f1ceb8a10b6d4",
		  
		  "name": "Mark ",
		  "createdDate": "2014-04-15 14:26:43",
		  "totalOrganizations": 22,
		  "totalTours": 12,
		  "totalDays": 618,
		  "totalCountries": 25,
		  "totalStates": 62,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 4679,
		  "schedulePercent": 0.943336,
		  "totalGuests": 678,
		  "guestPercent": 0.780372,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "The Torch",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ca9aa89db45b51685225dffe741991f",
		  
		  "name": "AMOS",
		  "createdDate": "2025-03-04 13:40:28",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 8,
		  "totalStates": 33,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 436,
		  "schedulePercent": 0.284338,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4cb7eda40f5ba4f22b520f5c6512c196",
		  
		  "name": "Garrett",
		  "createdDate": "2024-01-09 20:38:58",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 124,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 854,
		  "schedulePercent": 0.44141,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "American Music Theatre",
		  "mostGuestCity": "Lancaster",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4cc478be272255b713d791b5960a0626",
		  
		  "name": "Brian",
		  "createdDate": "2017-01-18 03:49:30",
		  "totalOrganizations": 4,
		  "totalTours": 15,
		  "totalDays": 281,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2404,
		  "schedulePercent": 0.775499,
		  "totalGuests": 705,
		  "guestPercent": 0.786945,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4cc92c9deb61635d3e3cbf1300c9a65a",
		  
		  "name": "Alexander",
		  "createdDate": "2022-06-17 12:32:36",
		  "totalOrganizations": 11,
		  "totalTours": 16,
		  "totalDays": 161,
		  "totalCountries": 24,
		  "totalStates": 30,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1355,
		  "schedulePercent": 0.586582,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "SO 36",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4cc99f290663837e9b177f81ceaa1ab7",
		  
		  "name": "Jennifer",
		  "createdDate": "2022-06-16 10:40:01",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 384,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 573,
		  "schedulePercent": 0.340888,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Kiri Te Kanawa Theatre, Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4cd31712c1c2720ee20b8b937186ed8a",
		  
		  "name": "Morgan",
		  "createdDate": "2014-05-28 22:31:17",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 367,
		  "totalCountries": 19,
		  "totalStates": 28,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 679,
		  "schedulePercent": 0.378626,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "The Wellmont Theater",
		  "mostGuestCity": "Montclair",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4cfafaf3d3116586b27d508578235944",
		  
		  "name": "Eddison",
		  "createdDate": "2014-11-28 22:20:51",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 143,
		  "totalCountries": 14,
		  "totalStates": 11,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 540,
		  "schedulePercent": 0.330349,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Queen's Royal College",
		  "mostGuestCity": "Port of Spain",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d0b8812d0be18ec03a61aa9208eb8de",
		  
		  "name": "mark",
		  "createdDate": "2010-06-18 01:12:49",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 146,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 992,
		  "schedulePercent": 0.488781,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d1212d33937725cc5f6c20f335a56ec",
		  
		  "name": "Solene ",
		  "createdDate": "2022-03-11 11:41:51",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 437,
		  "totalCountries": 21,
		  "totalStates": 38,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1170,
		  "schedulePercent": 0.540231,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d188c50c19789d797997eecfce43bb2",
		  
		  "name": "Matias",
		  "createdDate": "2024-10-08 16:40:22",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 68,
		  "totalCountries": 9,
		  "totalStates": 14,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 669,
		  "schedulePercent": 0.374433,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d1e1c9a9ed197432900c8bf2cf57d1c",
		  
		  "name": "Virginie",
		  "createdDate": "2025-01-21 15:52:54",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 241,
		  "totalCountries": 5,
		  "totalStates": 47,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1895,
		  "schedulePercent": 0.693336,
		  "totalGuests": 95,
		  "guestPercent": 0.513826,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "ArÃ¨nes de NÃ®mes",
		  "mostGuestCity": "NÃ®mes",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d26fdf565e5c7cf9c76b49da565b34f",
		  
		  "name": "Chris",
		  "createdDate": "2020-11-07 23:46:09",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 466,
		  "totalCountries": 2,
		  "totalStates": 44,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 1844,
		  "schedulePercent": 0.68461,
		  "totalGuests": 1851,
		  "guestPercent": 0.936423,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 157,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d2f60540727b424746cfff6070d942f",
		  
		  "name": "William",
		  "createdDate": "2024-07-16 18:02:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 86,
		  "totalCountries": 9,
		  "totalStates": 20,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 140,
		  "schedulePercent": 0.12432,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d415ee65d26ed3bc336983afed7d41c",
		  
		  "name": "Josh",
		  "createdDate": "2023-08-10 16:18:00",
		  "totalOrganizations": 1,
		  "totalTours": 26,
		  "totalDays": 876,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 411,
		  "eventPercent": 0.961355,
		  "totalScheduleItems": 2623,
		  "schedulePercent": 0.799864,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Dunstan Playhouse",
		  "mostGuestCity": "Adelaide",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d42493f3189caa8ff0a263c7e8d053b",
		  
		  "name": "Chris",
		  "createdDate": "2011-12-08 06:08:52",
		  "totalOrganizations": 58,
		  "totalTours": 18,
		  "totalDays": 384,
		  "totalCountries": 34,
		  "totalStates": 54,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 3180,
		  "schedulePercent": 0.857888,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d4297cff6957afc561394b723a5f0bb",
		  
		  "name": "Stacey",
		  "createdDate": "2012-09-11 12:32:11",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 525,
		  "totalCountries": 8,
		  "totalStates": 55,
		  "totalEvents": 268,
		  "eventPercent": 0.888599,
		  "totalScheduleItems": 3203,
		  "schedulePercent": 0.860381,
		  "totalGuests": 2299,
		  "guestPercent": 0.962035,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d47a6a9309bd075fe244a53c9ce1724",
		  
		  "name": "Lisa",
		  "createdDate": "2018-10-01 16:31:23",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 73,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 448,
		  "schedulePercent": 0.289778,
		  "totalGuests": 213,
		  "guestPercent": 0.604261,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Elysee Montmartre",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d4cc24cbb16bba7ce77f7fa0b7fe6b4",
		  
		  "name": "Kyra",
		  "createdDate": "2025-05-28 02:20:32",
		  "totalOrganizations": 72,
		  "totalTours": 76,
		  "totalDays": 883,
		  "totalCountries": 18,
		  "totalStates": 39,
		  "totalEvents": 496,
		  "eventPercent": 0.978355,
		  "totalScheduleItems": 2016,
		  "schedulePercent": 0.716795,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Huntington State Beach",
		  "mostGuestCity": "Huntington Beach",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d52b2f464d147160881fcefedc6bfeb",
		  
		  "name": "Thomas",
		  "createdDate": "2016-06-25 17:38:46",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 320,
		  "totalCountries": 20,
		  "totalStates": 13,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1842,
		  "schedulePercent": 0.68393,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d56844d41aa41c83baa2a8277fb78bc",
		  
		  "name": "Teri",
		  "createdDate": "2011-06-23 04:48:31",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 684,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 926,
		  "schedulePercent": 0.467022,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Shenzhen Universiade Sports Centre",
		  "mostGuestCity": "Shen Zhen Shi",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d634ee0617481cac6dca9f0bfe5e90a",
		  
		  "name": "LIFE",
		  "createdDate": "2022-12-09 18:07:43",
		  "totalOrganizations": 2,
		  "totalTours": 29,
		  "totalDays": 117,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 3881,
		  "schedulePercent": 0.906958,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d64cb1a6ae9af72683af0cb4ff61cf6",
		  
		  "name": "KATY",
		  "createdDate": "2022-10-04 11:16:30",
		  "totalOrganizations": 70,
		  "totalTours": 72,
		  "totalDays": 5423,
		  "totalCountries": 23,
		  "totalStates": 40,
		  "totalEvents": 1418,
		  "eventPercent": 0.9983,
		  "totalScheduleItems": 9257,
		  "schedulePercent": 0.994787,
		  "totalGuests": 192,
		  "guestPercent": 0.587262,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "The Marlowe",
		  "mostGuestCity": "Canterbury",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d65811216a7d9e51197f71e39bc3409",
		  
		  "name": "Sammie",
		  "createdDate": "2025-06-24 01:01:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 173,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 202,
		  "schedulePercent": 0.162058,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d67b4a041ef81d16a3256e267762b85",
		  
		  "name": "Gary ",
		  "createdDate": "2014-10-03 23:04:40",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 688,
		  "totalCountries": 17,
		  "totalStates": 57,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 2288,
		  "schedulePercent": 0.760086,
		  "totalGuests": 904,
		  "guestPercent": 0.831142,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d69969ac9e55233648c6dc6db7e2a27",
		  
		  "name": "Luis",
		  "createdDate": "2024-06-22 17:03:07",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 155,
		  "totalCountries": 12,
		  "totalStates": 12,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 72,
		  "schedulePercent": 0.0759293,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d757c3b10c35d80a4a403baf5f54834",
		  
		  "name": "Luke",
		  "createdDate": "2020-11-02 09:10:32",
		  "totalOrganizations": 1,
		  "totalTours": 21,
		  "totalDays": 504,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 2736,
		  "schedulePercent": 0.813803,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d7670f6114f98eb881c5313d092e749",
		  
		  "name": "Jared",
		  "createdDate": "2023-06-20 20:37:18",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 420,
		  "totalCountries": 13,
		  "totalStates": 39,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2455,
		  "schedulePercent": 0.781618,
		  "totalGuests": 493,
		  "guestPercent": 0.728355,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d76c5d5466ecf3d83bb52b1035686d5",
		  
		  "name": "Howard",
		  "createdDate": "2019-02-12 04:00:13",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 1613,
		  "totalCountries": 4,
		  "totalStates": 56,
		  "totalEvents": 317,
		  "eventPercent": 0.923617,
		  "totalScheduleItems": 3818,
		  "schedulePercent": 0.903558,
		  "totalGuests": 579,
		  "guestPercent": 0.752493,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "The Caverns",
		  "mostGuestCity": "Pelham",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d804174374cd4f9e0ec6a57a2e30645",
		  
		  "name": "keith",
		  "createdDate": "2015-05-11 07:55:37",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 63,
		  "totalCountries": 20,
		  "totalStates": 26,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 521,
		  "schedulePercent": 0.321736,
		  "totalGuests": 247,
		  "guestPercent": 0.623753,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Watford Colosseum",
		  "mostGuestCity": "Watford",
		  "mostGuestAmount": 150,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d8d06c94c83b1f7e3bc1ae3f4ccf8fb",
		  
		  "name": "John",
		  "createdDate": "2010-04-02 17:58:15",
		  "totalOrganizations": 23,
		  "totalTours": 8,
		  "totalDays": 449,
		  "totalCountries": 8,
		  "totalStates": 83,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 2421,
		  "schedulePercent": 0.777539,
		  "totalGuests": 302,
		  "guestPercent": 0.650839,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Fred Kavli Theater",
		  "mostGuestCity": "Thousand Oaks",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4d9206541d34079d9a9658a9cb37b2c0",
		  
		  "name": "Courtney",
		  "createdDate": "2018-11-14 01:39:22",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 169,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 788,
		  "schedulePercent": 0.418178,
		  "totalGuests": 186,
		  "guestPercent": 0.583862,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4da684445f264f84d363d54696f47821",
		  
		  "name": "Robin",
		  "createdDate": "2022-12-07 17:52:02",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 250,
		  "totalCountries": 10,
		  "totalStates": 16,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1493,
		  "schedulePercent": 0.615934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4db6a17d00a111d5a384bb503f7623bf",
		  
		  "name": "Mario",
		  "createdDate": "2015-02-03 14:43:32",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 429,
		  "totalCountries": 31,
		  "totalStates": 66,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1773,
		  "schedulePercent": 0.671578,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Klub Studio",
		  "mostGuestCity": "KrakÃ³w",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4dc35f4eeba5a25145a411ac78805e14",
		  
		  "name": "Bryan",
		  "createdDate": "2014-03-06 22:47:06",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 841,
		  "totalCountries": 20,
		  "totalStates": 58,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 2300,
		  "schedulePercent": 0.762013,
		  "totalGuests": 240,
		  "guestPercent": 0.61922,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "Revolution Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4dc5e648ecc7d7628b2c14a965689d35",
		  
		  "name": "Steve",
		  "createdDate": "2019-09-03 10:33:55",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 936,
		  "totalCountries": 8,
		  "totalStates": 24,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2438,
		  "schedulePercent": 0.779352,
		  "totalGuests": 505,
		  "guestPercent": 0.732434,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Zenith de Toulouse",
		  "mostGuestCity": "Toulouse",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4dc785e34afea75a6150f10ebddfb296",
		  
		  "name": "Linn",
		  "createdDate": "2023-10-10 08:44:31",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 130,
		  "totalCountries": 8,
		  "totalStates": 11,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 736,
		  "schedulePercent": 0.399932,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Sofiero Slott och SlottstrÃ¤dgÃ¥rd",
		  "mostGuestCity": "Helsingborg",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4dd4d632ad6918c986d1cd3038a34f92",
		  
		  "name": "Dean",
		  "createdDate": "2015-06-03 02:54:05",
		  "totalOrganizations": 134,
		  "totalTours": 26,
		  "totalDays": 315,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1339,
		  "schedulePercent": 0.583409,
		  "totalGuests": 160,
		  "guestPercent": 0.565956,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Tulsa Performing Arts Center",
		  "mostGuestCity": "Tulsa",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4de565de26daa2cc3464f2f8f8ac8694",
		  
		  "name": "Lani",
		  "createdDate": "2020-12-27 04:27:56",
		  "totalOrganizations": 49,
		  "totalTours": 54,
		  "totalDays": 953,
		  "totalCountries": 19,
		  "totalStates": 35,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 2609,
		  "schedulePercent": 0.798844,
		  "totalGuests": 245,
		  "guestPercent": 0.622167,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4de92db089b916952d920a25bbdc7424",
		  
		  "name": "Edward",
		  "createdDate": "2017-07-19 20:28:16",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 56,
		  "totalCountries": 10,
		  "totalStates": 18,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 397,
		  "schedulePercent": 0.268019,
		  "totalGuests": 346,
		  "guestPercent": 0.673277,
		  "mostGuestDate": "2025-03-12 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4df2f5be878632c8a21b14cee7fec566",
		  
		  "name": "Sasha",
		  "createdDate": "2019-03-13 15:08:39",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 554,
		  "totalCountries": 41,
		  "totalStates": 48,
		  "totalEvents": 243,
		  "eventPercent": 0.864347,
		  "totalScheduleItems": 3161,
		  "schedulePercent": 0.856414,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4dfdf0576ad6a54b010de2fab261e75d",
		  
		  "name": "Sebastian",
		  "createdDate": "2022-07-25 21:26:00",
		  "totalOrganizations": 12,
		  "totalTours": 14,
		  "totalDays": 118,
		  "totalCountries": 20,
		  "totalStates": 22,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1021,
		  "schedulePercent": 0.496374,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "SO 36",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e127fe755475e765a1acd7ee716dc7c",
		  
		  "name": "Sara",
		  "createdDate": "2015-09-01 00:36:52",
		  "totalOrganizations": 16,
		  "totalTours": 22,
		  "totalDays": 1429,
		  "totalCountries": 44,
		  "totalStates": 87,
		  "totalEvents": 411,
		  "eventPercent": 0.961355,
		  "totalScheduleItems": 6092,
		  "schedulePercent": 0.976995,
		  "totalGuests": 884,
		  "guestPercent": 0.826723,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e2067d9f98dd35b227f5d5af81cd912",
		  
		  "name": "GwÃ©naÃ«l",
		  "createdDate": "2024-08-16 09:47:40",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 242,
		  "totalCountries": 17,
		  "totalStates": 7,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1898,
		  "schedulePercent": 0.694016,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e2a59f1d547bfae5f453b46560247da",
		  
		  "name": "Jeff",
		  "createdDate": "2016-03-19 21:13:44",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 245,
		  "totalCountries": 29,
		  "totalStates": 53,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2074,
		  "schedulePercent": 0.727901,
		  "totalGuests": 902,
		  "guestPercent": 0.830462,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "013 Poppodium",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e2c23ff777dc784a1e818ba4be71705",
		  
		  "name": "Benjamin",
		  "createdDate": "2010-03-01 18:32:39",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 418,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1676,
		  "schedulePercent": 0.654125,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e2faa365c0e730e8763c5163260d692",
		  
		  "name": "Joe",
		  "createdDate": "2019-11-13 06:50:16",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 337,
		  "totalCountries": 28,
		  "totalStates": 79,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2376,
		  "schedulePercent": 0.772212,
		  "totalGuests": 758,
		  "guestPercent": 0.797937,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "X-tra",
		  "mostGuestCity": "Zurich",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e3337f27a08f05f81bdc0b07bfe5f34",
		  
		  "name": "Chris ",
		  "createdDate": "2011-04-11 15:32:19",
		  "totalOrganizations": 9,
		  "totalTours": 13,
		  "totalDays": 984,
		  "totalCountries": 18,
		  "totalStates": 51,
		  "totalEvents": 271,
		  "eventPercent": 0.891092,
		  "totalScheduleItems": 2430,
		  "schedulePercent": 0.778785,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Golden Gate Park",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e3cc928043b33a91f6ae51650a4d1d7",
		  
		  "name": "Alyssa",
		  "createdDate": "2024-08-20 19:31:04",
		  "totalOrganizations": 3,
		  "totalTours": 11,
		  "totalDays": 410,
		  "totalCountries": 18,
		  "totalStates": 58,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 2141,
		  "schedulePercent": 0.738441,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e40c6dbadac262dd477d353fbe1fd0d",
		  
		  "name": "Alexandra",
		  "createdDate": "2024-01-30 23:58:47",
		  "totalOrganizations": 10,
		  "totalTours": 23,
		  "totalDays": 445,
		  "totalCountries": 21,
		  "totalStates": 55,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 1783,
		  "schedulePercent": 0.673164,
		  "totalGuests": 752,
		  "guestPercent": 0.796804,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "The Corner Hotel",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e45914230b093de4330c927e8943d1a",
		  
		  "name": "Zonia",
		  "createdDate": "2024-08-30 14:35:49",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 1268,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1098,
		  "schedulePercent": 0.519379,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e48008475e2f86e7bf4b2e1bcec5b3e",
		  
		  "name": "Camila",
		  "createdDate": "2014-09-08 19:39:11",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 581,
		  "totalCountries": 15,
		  "totalStates": 47,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1511,
		  "schedulePercent": 0.620127,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e484f5dc799dd15ff270bedbc6b8f70",
		  
		  "name": "Jen",
		  "createdDate": "2016-11-16 00:21:01",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 83,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 208,
		  "schedulePercent": 0.165005,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e499a72ebd680e3a58cd4a2fd668700",
		  
		  "name": "Lorraine ",
		  "createdDate": "2022-11-14 00:01:35",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 638,
		  "totalCountries": 7,
		  "totalStates": 24,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 458,
		  "schedulePercent": 0.293858,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "Kelowna Community Theatre",
		  "mostGuestCity": "Kelowna",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e63e3ede884bedfd5d3a5065a916a7c",
		  
		  "name": "Sean",
		  "createdDate": "2018-05-24 22:04:18",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 9,
		  "totalStates": 30,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 702,
		  "schedulePercent": 0.387693,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-08-20 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e645af2d070b615f4732187420978e5",
		  
		  "name": "Chase",
		  "createdDate": "2013-03-04 18:11:21",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 675,
		  "totalCountries": 11,
		  "totalStates": 31,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1330,
		  "schedulePercent": 0.579896,
		  "totalGuests": 216,
		  "guestPercent": 0.605961,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e6cc42246f64f0a4228c80ebe39fa77",
		  
		  "name": "Nick",
		  "createdDate": "2018-01-02 20:10:19",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 530,
		  "totalCountries": 36,
		  "totalStates": 54,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 1999,
		  "schedulePercent": 0.713282,
		  "totalGuests": 748,
		  "guestPercent": 0.795784,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e6eb66f5a1f905dbd4ab4e288cdec74",
		  
		  "name": "Cormac",
		  "createdDate": "2022-09-28 19:26:48",
		  "totalOrganizations": 8,
		  "totalTours": 27,
		  "totalDays": 834,
		  "totalCountries": 20,
		  "totalStates": 61,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 1890,
		  "schedulePercent": 0.692883,
		  "totalGuests": 838,
		  "guestPercent": 0.81743,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e82e7aef594a5a9095fd9ec9ae54951",
		  
		  "name": "Kevin",
		  "createdDate": "2022-02-17 14:10:19",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 220,
		  "totalCountries": 7,
		  "totalStates": 36,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 438,
		  "schedulePercent": 0.285131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e88bb8f62b759d37453ee8bd8fdfc6a",
		  
		  "name": "James",
		  "createdDate": "2024-01-10 19:50:49",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 99,
		  "totalCountries": 14,
		  "totalStates": 34,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Lemon Grove",
		  "mostGuestCity": "Exeter",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e8b0d57d9a1fe073dde5df34e4084b3",
		  
		  "name": "Lisa",
		  "createdDate": "2023-10-27 14:46:16",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 189,
		  "totalCountries": 8,
		  "totalStates": 18,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1084,
		  "schedulePercent": 0.515299,
		  "totalGuests": 179,
		  "guestPercent": 0.579556,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Dalhalla",
		  "mostGuestCity": "RÃ¤ttvik",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4e8b151daa93c28698963690fe58348b",
		  
		  "name": "James",
		  "createdDate": "2015-10-28 19:43:46",
		  "totalOrganizations": 8,
		  "totalTours": 19,
		  "totalDays": 1448,
		  "totalCountries": 27,
		  "totalStates": 93,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 4951,
		  "schedulePercent": 0.952629,
		  "totalGuests": 930,
		  "guestPercent": 0.835675,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ea0d07706c8dc2ee37ecda741e875ec",
		  
		  "name": "Christian",
		  "createdDate": "2019-04-01 23:09:42",
		  "totalOrganizations": 13,
		  "totalTours": 15,
		  "totalDays": 1257,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2605,
		  "schedulePercent": 0.798277,
		  "totalGuests": 3513,
		  "guestPercent": 0.989801,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 128,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ea59ec2e9582e36f50ee654a7beec20",
		  
		  "name": "Izabella",
		  "createdDate": "2025-02-11 10:19:05",
		  "totalOrganizations": 21,
		  "totalTours": 14,
		  "totalDays": 240,
		  "totalCountries": 6,
		  "totalStates": 10,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 825,
		  "schedulePercent": 0.43257,
		  "totalGuests": 122,
		  "guestPercent": 0.538985,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "SÃ¶dra Teatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ea9e1e330723fd665c2a5dcbae3aa4b",
		  
		  "name": "Christopher",
		  "createdDate": "2017-05-28 15:21:20",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 128,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 705,
		  "schedulePercent": 0.388599,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ec67d61dddbf04e03c08789b031c831",
		  
		  "name": "Raymond",
		  "createdDate": "2016-11-22 10:45:10",
		  "totalOrganizations": 16,
		  "totalTours": 12,
		  "totalDays": 1155,
		  "totalCountries": 33,
		  "totalStates": 50,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 4666,
		  "schedulePercent": 0.942656,
		  "totalGuests": 745,
		  "guestPercent": 0.795218,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 241,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ef97417aa58178d8a67d8d6a8ba8b72",
		  
		  "name": "Rob",
		  "createdDate": "2020-01-03 06:40:33",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 63,
		  "totalCountries": 8,
		  "totalStates": 7,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 180,
		  "schedulePercent": 0.146419,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "San Fran",
		  "mostGuestCity": "Te Aro",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4efe36bbcef3525a0efab8fb36f44abd",
		  
		  "name": "David",
		  "createdDate": "2023-08-10 05:51:52",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 140,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 892,
		  "schedulePercent": 0.455462,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f1fc040c1aead0fd2519ec560696ecf",
		  
		  "name": "Chiara",
		  "createdDate": "2025-04-05 22:55:44",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 205,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1404,
		  "schedulePercent": 0.599161,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Berkeley",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f2b12d2c6923c4381ec2464d8f784c8",
		  
		  "name": "Lauren",
		  "createdDate": "2015-01-18 19:08:21",
		  "totalOrganizations": 15,
		  "totalTours": 20,
		  "totalDays": 1057,
		  "totalCountries": 22,
		  "totalStates": 27,
		  "totalEvents": 352,
		  "eventPercent": 0.94311,
		  "totalScheduleItems": 5048,
		  "schedulePercent": 0.955349,
		  "totalGuests": 165,
		  "guestPercent": 0.56947,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f336bac7cf2fdb93627a72f5944cf2b",
		  
		  "name": "Clay",
		  "createdDate": "2017-07-22 15:23:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 116,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 909,
		  "schedulePercent": 0.461242,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Mississippi Coliseum",
		  "mostGuestCity": "Jackson",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f35777e8f1b793e0c688bebba6d59dd",
		  
		  "name": "Callum",
		  "createdDate": "2017-10-12 09:56:50",
		  "totalOrganizations": 10,
		  "totalTours": 24,
		  "totalDays": 500,
		  "totalCountries": 21,
		  "totalStates": 59,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 2700,
		  "schedulePercent": 0.808477,
		  "totalGuests": 1410,
		  "guestPercent": 0.901065,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f36a3fe7b2d014dbbdf9ffde2dbbdde",
		  
		  "name": "Aaron",
		  "createdDate": "2018-09-18 15:39:07",
		  "totalOrganizations": 24,
		  "totalTours": 18,
		  "totalDays": 759,
		  "totalCountries": 18,
		  "totalStates": 49,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 2338,
		  "schedulePercent": 0.766546,
		  "totalGuests": 475,
		  "guestPercent": 0.722348,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f4def232265416a9e313a720b07835f",
		  
		  "name": "Joel",
		  "createdDate": "2019-07-28 16:22:31",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 21,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 140,
		  "schedulePercent": 0.12432,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Tioga-Sequoia Brewing Company Beer Garden",
		  "mostGuestCity": "Fresno",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f50615eb3e0256f74bd340124b165b7",
		  
		  "name": "Filipe",
		  "createdDate": "2017-01-25 02:49:42",
		  "totalOrganizations": 19,
		  "totalTours": 23,
		  "totalDays": 534,
		  "totalCountries": 34,
		  "totalStates": 92,
		  "totalEvents": 327,
		  "eventPercent": 0.931324,
		  "totalScheduleItems": 4611,
		  "schedulePercent": 0.940956,
		  "totalGuests": 2069,
		  "guestPercent": 0.951723,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f50ab9823e323293fff333104afa122",
		  
		  "name": "QCM SFM",
		  "createdDate": "2024-08-19 20:08:29",
		  "totalOrganizations": 16,
		  "totalTours": 15,
		  "totalDays": 4473,
		  "totalCountries": 24,
		  "totalStates": 50,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 472,
		  "schedulePercent": 0.299071,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f50e1728579b5e2c697069078265b91",
		  
		  "name": "Isaac",
		  "createdDate": "2020-07-27 00:26:12",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 268,
		  "totalCountries": 10,
		  "totalStates": 28,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 941,
		  "schedulePercent": 0.472575,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f59194da0ccb06ed0ac0c31a779749c",
		  
		  "name": "tyler",
		  "createdDate": "2025-04-27 05:21:29",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 130,
		  "totalCountries": 8,
		  "totalStates": 47,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1013,
		  "schedulePercent": 0.49422,
		  "totalGuests": 277,
		  "guestPercent": 0.638599,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Brooklyn Meadows",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f5be1ed4f070ea10880445b7fc46e5d",
		  
		  "name": "Miguel",
		  "createdDate": "2021-08-11 04:40:49",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 597,
		  "totalCountries": 28,
		  "totalStates": 73,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 2030,
		  "schedulePercent": 0.719062,
		  "totalGuests": 224,
		  "guestPercent": 0.609474,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "The O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f6e41fabe41d9ff9f6ff69aca4d5bd9",
		  
		  "name": "Marcus",
		  "createdDate": "2021-05-04 04:17:05",
		  "totalOrganizations": 18,
		  "totalTours": 26,
		  "totalDays": 917,
		  "totalCountries": 41,
		  "totalStates": 108,
		  "totalEvents": 439,
		  "eventPercent": 0.968608,
		  "totalScheduleItems": 6620,
		  "schedulePercent": 0.983568,
		  "totalGuests": 1872,
		  "guestPercent": 0.937443,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f70be95ab76010e1059cde055505724",
		  
		  "name": "Jack",
		  "createdDate": "2025-03-19 13:45:30",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 183,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 680,
		  "schedulePercent": 0.379306,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f808fce948d8774df1743a8ae292165",
		  
		  "name": "Timothy",
		  "createdDate": "2019-03-06 04:49:37",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 72,
		  "totalCountries": 5,
		  "totalStates": 9,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-11-12 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f816efe2f4e23dcf1be365d0afbdd0b",
		  
		  "name": "Kierra",
		  "createdDate": "2021-01-05 20:07:40",
		  "totalOrganizations": 16,
		  "totalTours": 19,
		  "totalDays": 2564,
		  "totalCountries": 10,
		  "totalStates": 55,
		  "totalEvents": 363,
		  "eventPercent": 0.947529,
		  "totalScheduleItems": 5514,
		  "schedulePercent": 0.967702,
		  "totalGuests": 2580,
		  "guestPercent": 0.971215,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f820ba3c08a0725585cf48be68991ac",
		  
		  "name": "Ost",
		  "createdDate": "2018-07-02 12:57:17",
		  "totalOrganizations": 21,
		  "totalTours": 26,
		  "totalDays": 1082,
		  "totalCountries": 32,
		  "totalStates": 61,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 1927,
		  "schedulePercent": 0.699569,
		  "totalGuests": 156,
		  "guestPercent": 0.563577,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Fabric",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f83c0a80e3290d3b7301df0430214cf",
		  
		  "name": "Allison",
		  "createdDate": "2022-04-28 15:33:30",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 422,
		  "totalCountries": 6,
		  "totalStates": 32,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1071,
		  "schedulePercent": 0.511106,
		  "totalGuests": 114,
		  "guestPercent": 0.531505,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Neighborhood Theatre",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f8d02d9a931c80ac95326b220f979b2",
		  
		  "name": "Lydia",
		  "createdDate": "2019-10-16 02:09:09",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 94,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 442,
		  "schedulePercent": 0.287738,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Sandstone Point Hotel",
		  "mostGuestCity": "Sandstone Point",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f8d71a42b2ecff0ed26f3d3d6f861c8",
		  
		  "name": "Zach",
		  "createdDate": "2023-11-28 19:44:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 12,
		  "totalStates": 13,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 448,
		  "schedulePercent": 0.289778,
		  "totalGuests": 136,
		  "guestPercent": 0.549524,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Ancienne Belgique",
		  "mostGuestCity": "Brussel",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f92541a2604b98ce9412c8dd6b1c094",
		  
		  "name": "Jani",
		  "createdDate": "2022-05-04 09:00:29",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 313,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 311,
		  "eventPercent": 0.919878,
		  "totalScheduleItems": 969,
		  "schedulePercent": 0.481074,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "Vauhti Kiihtyy",
		  "mostGuestCity": "Tampere",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f9d248ee618bcb17cc2c1b6628f4fb9",
		  
		  "name": "Mary",
		  "createdDate": "2021-10-02 14:36:15",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 494,
		  "totalCountries": 11,
		  "totalStates": 37,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 720,
		  "schedulePercent": 0.394266,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4f9d650a205832c508850f4903f8a591",
		  
		  "name": "Maribeth",
		  "createdDate": "2019-05-31 19:20:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 114,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 307,
		  "schedulePercent": 0.221102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fa6077ce856d5032c7a5bc62a619f0d",
		  
		  "name": "Shamus",
		  "createdDate": "2011-11-29 19:00:48",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 753,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 549,
		  "schedulePercent": 0.334089,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fb46faf3b728ad33e459ff540f1cd77",
		  
		  "name": "Alex",
		  "createdDate": "2023-09-16 20:41:33",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 81,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 248,
		  "schedulePercent": 0.188917,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Zoellner Arts Center",
		  "mostGuestCity": "Bethlehem",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fb53a39bf7dbc6acdb084122220c212",
		  
		  "name": "David",
		  "createdDate": "2016-11-14 05:26:12",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 763,
		  "totalCountries": 24,
		  "totalStates": 64,
		  "totalEvents": 202,
		  "eventPercent": 0.804397,
		  "totalScheduleItems": 3275,
		  "schedulePercent": 0.8665,
		  "totalGuests": 328,
		  "guestPercent": 0.665231,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fb9f8e94114b02704f8fbc953f9b541",
		  
		  "name": "Raymond",
		  "createdDate": "2019-06-25 18:27:01",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 287,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1712,
		  "schedulePercent": 0.660811,
		  "totalGuests": 302,
		  "guestPercent": 0.650839,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "The Walmart AMP",
		  "mostGuestCity": "Rogers",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fc835747503ba8b2eb52c53da047719",
		  
		  "name": "Graeme",
		  "createdDate": "2010-10-14 00:00:21",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 404,
		  "totalCountries": 11,
		  "totalStates": 38,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 797,
		  "schedulePercent": 0.421464,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fd1ebb4e394c8a9ab6698927fce1a42",
		  
		  "name": "Lachie",
		  "createdDate": "2023-11-23 09:03:29",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 344,
		  "schedulePercent": 0.240254,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Young Showground Camping",
		  "mostGuestCity": "Young",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fdb0002bc7d683badc543d9f251559a",
		  
		  "name": "VSQ Live",
		  "createdDate": "2025-09-12 03:10:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 106,
		  "totalCountries": 8,
		  "totalStates": 25,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 452,
		  "schedulePercent": 0.291364,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "Patchogue Theatre for the Performing Arts",
		  "mostGuestCity": "Patchogue",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fdd28a99b206345ed3414a4f1bfdfd7",
		  
		  "name": "Jon",
		  "createdDate": "2009-07-09 21:43:59",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 4,
		  "totalStates": 47,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 2307,
		  "schedulePercent": 0.762579,
		  "totalGuests": 885,
		  "guestPercent": 0.826836,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Amica Mutual Pavilion",
		  "mostGuestCity": "Providence",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ff75149279dce153743ecfa03e7e0a5",
		  
		  "name": "Q",
		  "createdDate": "2024-02-26 19:31:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 259,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 50,
		  "schedulePercent": 0.0601768,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ff8060a03024c08267d8aef2eaa9578",
		  
		  "name": "Halle",
		  "createdDate": "2022-08-16 22:49:07",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 418,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 819,
		  "schedulePercent": 0.430304,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-04-16 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4ffc9fa6249492ad2d8b7c7a50155998",
		  
		  "name": "Richard",
		  "createdDate": "2022-03-30 17:26:41",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 738,
		  "totalCountries": 19,
		  "totalStates": 37,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 626,
		  "schedulePercent": 0.359474,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "4fff76ab193265dcc423f4dfccddca99",
		  
		  "name": "Justin ",
		  "createdDate": "2013-11-07 21:10:22",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 1075,
		  "totalCountries": 9,
		  "totalStates": 40,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1359,
		  "schedulePercent": 0.587489,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Fantasy Springs Casino",
		  "mostGuestCity": "Indio",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5000cf2223b21be4975020bbe2734576",
		  
		  "name": "Michelle",
		  "createdDate": "2025-07-14 15:07:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 77,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 854,
		  "schedulePercent": 0.44141,
		  "totalGuests": 395,
		  "guestPercent": 0.692203,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Dolby Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50034ac00e3d50a36236e439a90ffe39",
		  
		  "name": "Cory",
		  "createdDate": "2019-07-29 19:47:38",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 350,
		  "totalCountries": 20,
		  "totalStates": 34,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1120,
		  "schedulePercent": 0.524932,
		  "totalGuests": 229,
		  "guestPercent": 0.612194,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 180,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5005528664d0c20c5d1ca2d997420918",
		  
		  "name": "Dennis",
		  "createdDate": "2013-09-25 00:10:08",
		  "totalOrganizations": 16,
		  "totalTours": 7,
		  "totalDays": 264,
		  "totalCountries": 8,
		  "totalStates": 28,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1485,
		  "schedulePercent": 0.614687,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Jones Beach Bandshell",
		  "mostGuestCity": "Wantagh",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5007c2a403a4e71f9a5d3494e269e951",
		  
		  "name": "Julius",
		  "createdDate": "2022-02-22 11:13:08",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 513,
		  "totalCountries": 24,
		  "totalStates": 28,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 1838,
		  "schedulePercent": 0.68257,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Stars am Strand",
		  "mostGuestCity": "Timmendorfer Strand",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5007ec0ad5f09b9abfbf789ad6000f2d",
		  
		  "name": "Marcus",
		  "createdDate": "2018-08-16 12:15:52",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 778,
		  "totalCountries": 34,
		  "totalStates": 76,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2970,
		  "schedulePercent": 0.839529,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5024525dfc3bc58318fd2db243f9dc32",
		  
		  "name": "Gillian",
		  "createdDate": "2017-11-06 04:20:26",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 381,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2775,
		  "schedulePercent": 0.818676,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "502996a3fa042d68ee2a2195496dacc5",
		  
		  "name": "Lisette ",
		  "createdDate": "2022-12-20 17:09:16",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 715,
		  "totalCountries": 18,
		  "totalStates": 29,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2053,
		  "schedulePercent": 0.723935,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50332c555428ab08f056fb0925d92c8c",
		  
		  "name": "Sam",
		  "createdDate": "2024-01-02 21:14:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 333,
		  "totalCountries": 10,
		  "totalStates": 46,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1064,
		  "schedulePercent": 0.507593,
		  "totalGuests": 880,
		  "guestPercent": 0.825363,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Roadrunner",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5043d930768acbaf8ad09467e88c21dc",
		  
		  "name": "Mo",
		  "createdDate": "2021-05-05 00:21:41",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 115,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 396,
		  "schedulePercent": 0.267452,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Capitol Theatre",
		  "mostGuestCity": "Port Chester",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "504438fe3f09e674097553cba5df9962",
		  
		  "name": "Tasha",
		  "createdDate": "2018-08-18 23:44:36",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 348,
		  "schedulePercent": 0.241954,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Soaring Eagle Casino",
		  "mostGuestCity": "Mt Pleasant",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5068a2139297c05ff4c3d5c3dc08f2c4",
		  
		  "name": "RANDY",
		  "createdDate": "2019-01-04 16:49:55",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 346,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 620,
		  "schedulePercent": 0.357208,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "507c343291d051757b706922e95f3afe",
		  
		  "name": "Leah ",
		  "createdDate": "2022-09-19 20:02:22",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 989,
		  "totalCountries": 21,
		  "totalStates": 67,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 3900,
		  "schedulePercent": 0.908318,
		  "totalGuests": 596,
		  "guestPercent": 0.757026,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "The Fillmore Silver Spring",
		  "mostGuestCity": "Silver Spring",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50832a2a648aa7a6bb6c040d3beff85d",
		  
		  "name": "Alexander",
		  "createdDate": "2025-02-10 06:08:02",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 171,
		  "totalCountries": 10,
		  "totalStates": 22,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 392,
		  "schedulePercent": 0.265866,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "FÃ¥llan",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50833680af00b6c1b724b7ba47d9c675",
		  
		  "name": "Melantha",
		  "createdDate": "2024-06-17 17:07:39",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 145,
		  "totalCountries": 5,
		  "totalStates": 27,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 799,
		  "schedulePercent": 0.422257,
		  "totalGuests": 88,
		  "guestPercent": 0.506686,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5083408a0200251fb8bc955e78f0932b",
		  
		  "name": "Douglas",
		  "createdDate": "2011-04-19 22:25:10",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 726,
		  "totalCountries": 11,
		  "totalStates": 54,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 2762,
		  "schedulePercent": 0.81743,
		  "totalGuests": 1239,
		  "guestPercent": 0.879306,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Daily's Place Amphitheater",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50888d3a2e90ca85c8ea4a8b3a4c975c",
		  
		  "name": "Olivia",
		  "createdDate": "2022-08-31 06:03:31",
		  "totalOrganizations": 45,
		  "totalTours": 54,
		  "totalDays": 967,
		  "totalCountries": 11,
		  "totalStates": 16,
		  "totalEvents": 647,
		  "eventPercent": 0.989687,
		  "totalScheduleItems": 3888,
		  "schedulePercent": 0.907638,
		  "totalGuests": 145,
		  "guestPercent": 0.555077,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Ulriksdals slott",
		  "mostGuestCity": "Solna",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "508bd1dceabc0f831d31b4f9e7819891",
		  
		  "name": "James",
		  "createdDate": "2022-08-03 09:56:26",
		  "totalOrganizations": 14,
		  "totalTours": 21,
		  "totalDays": 2093,
		  "totalCountries": 42,
		  "totalStates": 105,
		  "totalEvents": 589,
		  "eventPercent": 0.987194,
		  "totalScheduleItems": 10405,
		  "schedulePercent": 0.99728,
		  "totalGuests": 3592,
		  "guestPercent": 0.990707,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50906e0c3943933281ae9e71f60cd382",
		  
		  "name": "Jenny",
		  "createdDate": "2022-07-08 22:29:30",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 884,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 793,
		  "eventPercent": 0.993087,
		  "totalScheduleItems": 7082,
		  "schedulePercent": 0.986967,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "509abd8a01f13fcca5006bac08dff1f1",
		  
		  "name": "Cameron",
		  "createdDate": "2025-05-03 20:56:04",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 261,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1717,
		  "schedulePercent": 0.661605,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "509e299d0f54a4a398f63340fe6ec81b",
		  
		  "name": "Bailey",
		  "createdDate": "2025-10-10 15:42:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 55,
		  "totalCountries": 8,
		  "totalStates": 15,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 281,
		  "schedulePercent": 0.206256,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50a418b82321b59948e71b736f040f4f",
		  
		  "name": "Vanessa",
		  "createdDate": "2014-04-24 18:15:35",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 147,
		  "totalCountries": 11,
		  "totalStates": 35,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 613,
		  "schedulePercent": 0.355168,
		  "totalGuests": 321,
		  "guestPercent": 0.660471,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50a59cdba4be40884097cfcb70d8b061",
		  
		  "name": "Chuck",
		  "createdDate": "2017-11-20 01:38:18",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 338,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 103,
		  "schedulePercent": 0.0988214,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "House of Blues Chicago",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50a66297e28825e06a73357e20148423",
		  
		  "name": "Eric",
		  "createdDate": "2019-10-22 14:53:35",
		  "totalOrganizations": 1,
		  "totalTours": 17,
		  "totalDays": 247,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 244,
		  "schedulePercent": 0.186763,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50b7eed1beb9515bbdb1f140d3f77a71",
		  
		  "name": "Kristin",
		  "createdDate": "2016-01-21 18:20:49",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 83,
		  "totalCountries": 6,
		  "totalStates": 1,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 198,
		  "schedulePercent": 0.159451,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Budapest Park",
		  "mostGuestCity": "Budapest",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50bb52dc3e2c32a90bc2c841c5e30509",
		  
		  "name": "Nikolaus",
		  "createdDate": "2025-08-01 21:16:08",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 271,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1178,
		  "schedulePercent": 0.541704,
		  "totalGuests": 158,
		  "guestPercent": 0.565277,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "1720",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50bc815b2e2ee7b2e11e1bfaf1e14b00",
		  
		  "name": "Eric",
		  "createdDate": "2016-04-06 08:20:01",
		  "totalOrganizations": 26,
		  "totalTours": 10,
		  "totalDays": 483,
		  "totalCountries": 36,
		  "totalStates": 90,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 2500,
		  "schedulePercent": 0.786831,
		  "totalGuests": 1173,
		  "guestPercent": 0.87364,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 280,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50bdb4b1c5a38bd3d3318992f0704ae0",
		  
		  "name": "Mathias",
		  "createdDate": "2019-05-10 22:28:42",
		  "totalOrganizations": 68,
		  "totalTours": 43,
		  "totalDays": 1373,
		  "totalCountries": 50,
		  "totalStates": 106,
		  "totalEvents": 383,
		  "eventPercent": 0.954216,
		  "totalScheduleItems": 5280,
		  "schedulePercent": 0.961695,
		  "totalGuests": 301,
		  "guestPercent": 0.650385,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Lincoln Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50bdd5cc24403f0f47242f6ff6051bd5",
		  
		  "name": "Michael",
		  "createdDate": "2023-09-18 02:11:46",
		  "totalOrganizations": 30,
		  "totalTours": 52,
		  "totalDays": 3516,
		  "totalCountries": 20,
		  "totalStates": 105,
		  "totalEvents": 944,
		  "eventPercent": 0.995354,
		  "totalScheduleItems": 9109,
		  "schedulePercent": 0.993767,
		  "totalGuests": 2782,
		  "guestPercent": 0.977561,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "BRIC",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50c43dc7af55a1f2c4deafbbb2d44879",
		  
		  "name": "Nicholas",
		  "createdDate": "2022-01-31 23:51:18",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 724,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 960,
		  "schedulePercent": 0.479148,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50c4cb9249d45105c1f984ab916bd8f0",
		  
		  "name": "Sharice",
		  "createdDate": "2024-10-24 19:14:37",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 50,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 487,
		  "schedulePercent": 0.30485,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Coca-Cola Roxy",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50ca9f36dcb5d586a692692942597295",
		  
		  "name": "Benjamin",
		  "createdDate": "2015-06-05 23:58:24",
		  "totalOrganizations": 15,
		  "totalTours": 8,
		  "totalDays": 268,
		  "totalCountries": 17,
		  "totalStates": 39,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1339,
		  "schedulePercent": 0.583409,
		  "totalGuests": 226,
		  "guestPercent": 0.610607,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Lincoln Theatre",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50d401f6ec8fc54e712ab19dc6b7ca60",
		  
		  "name": "Matt",
		  "createdDate": "2025-06-06 12:37:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 88,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50d4834d19271797ed2e6322051b067b",
		  
		  "name": "Matt",
		  "createdDate": "2019-10-08 01:18:29",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 1329,
		  "totalCountries": 11,
		  "totalStates": 41,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1165,
		  "schedulePercent": 0.539098,
		  "totalGuests": 185,
		  "guestPercent": 0.583069,
		  "mostGuestDate": "2025-12-05 00:00:00",
		  "mostGuestName": "Sphere",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50da385037ee662d96ee9a3dfc3e7c74",
		  
		  "name": "Bobby",
		  "createdDate": "2023-01-17 17:20:51",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 156,
		  "totalCountries": 4,
		  "totalStates": 25,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1670,
		  "schedulePercent": 0.653219,
		  "totalGuests": 208,
		  "guestPercent": 0.600521,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Historic Scoot Inn",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50dce22c3c0d957bdac0f5d09fcc3b67",
		  
		  "name": "Tim",
		  "createdDate": "2018-10-17 16:50:53",
		  "totalOrganizations": 12,
		  "totalTours": 23,
		  "totalDays": 271,
		  "totalCountries": 16,
		  "totalStates": 60,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2027,
		  "schedulePercent": 0.718722,
		  "totalGuests": 497,
		  "guestPercent": 0.729488,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50e2b181ad2d7edfc630d058290b331f",
		  
		  "name": "Kerrie",
		  "createdDate": "2013-08-10 04:25:24",
		  "totalOrganizations": 78,
		  "totalTours": 14,
		  "totalDays": 329,
		  "totalCountries": 6,
		  "totalStates": 13,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 1565,
		  "schedulePercent": 0.633613,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Twin Towns Services Club",
		  "mostGuestCity": "Tweed Heads",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50e3c4e996c97c8e4eccdb823fa6f9a2",
		  
		  "name": "Moritz",
		  "createdDate": "2021-12-01 20:20:23",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 931,
		  "totalCountries": 27,
		  "totalStates": 42,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1969,
		  "schedulePercent": 0.708069,
		  "totalGuests": 763,
		  "guestPercent": 0.798957,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Gothenburg Studios",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50ec27c087bc31aadda1035b07c7cc1c",
		  
		  "name": "Shaun",
		  "createdDate": "2013-10-04 11:35:19",
		  "totalOrganizations": 50,
		  "totalTours": 20,
		  "totalDays": 528,
		  "totalCountries": 31,
		  "totalStates": 51,
		  "totalEvents": 202,
		  "eventPercent": 0.804397,
		  "totalScheduleItems": 1910,
		  "schedulePercent": 0.696623,
		  "totalGuests": 324,
		  "guestPercent": 0.663191,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50ed1b5805614fc9263e1410c9e7ae36",
		  
		  "name": "Chris",
		  "createdDate": "2020-01-23 01:04:25",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 491,
		  "totalCountries": 32,
		  "totalStates": 32,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1451,
		  "schedulePercent": 0.607548,
		  "totalGuests": 499,
		  "guestPercent": 0.730168,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Nissan Stadium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50f193f63c1be113c6820aca84d206af",
		  
		  "name": "ELIJAH",
		  "createdDate": "2022-04-16 04:45:10",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 236,
		  "totalCountries": 5,
		  "totalStates": 29,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1188,
		  "schedulePercent": 0.544084,
		  "totalGuests": 675,
		  "guestPercent": 0.779805,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Waikiki Shell",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50f6d98ad582cb575c17674fa360bfbf",
		  
		  "name": "Paul",
		  "createdDate": "2010-12-22 21:57:15",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 975,
		  "totalCountries": 12,
		  "totalStates": 48,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1634,
		  "schedulePercent": 0.646306,
		  "totalGuests": 432,
		  "guestPercent": 0.706936,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Kia Center",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50f8288043de0e7731191f2364c632d3",
		  
		  "name": "Mary",
		  "createdDate": "2024-09-23 03:40:21",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 424,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 280,
		  "eventPercent": 0.898345,
		  "totalScheduleItems": 504,
		  "schedulePercent": 0.313463,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "50fd422110ea9329a83b5b2f4d2833ba",
		  
		  "name": "Patrick",
		  "createdDate": "2019-07-02 06:57:56",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 1556,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 2805,
		  "schedulePercent": 0.822869,
		  "totalGuests": 468,
		  "guestPercent": 0.719515,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Armada Agricultural Society (Armada Fair)",
		  "mostGuestCity": "Armada",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51278b078ed17dbe3258ece61c11bad6",
		  
		  "name": "Ronald",
		  "createdDate": "2022-10-14 23:30:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 358,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 177,
		  "schedulePercent": 0.144266,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Moonshine Beach",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "512fe26378f051738549fe2dd8bc13fe",
		  
		  "name": "Jake ",
		  "createdDate": "2023-03-28 16:17:05",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 585,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 982,
		  "schedulePercent": 0.485267,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Ford Amphitheater",
		  "mostGuestCity": "Colorado Springs",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5135182ac1790e10d097fe09f0521e2c",
		  
		  "name": "Boyd",
		  "createdDate": "2017-01-08 16:49:39",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 403,
		  "totalCountries": 8,
		  "totalStates": 45,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 2323,
		  "schedulePercent": 0.765526,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51401b929c5c3ffeed4a6ff7c67becef",
		  
		  "name": "Mike",
		  "createdDate": "2014-05-10 18:26:26",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 209,
		  "totalCountries": 9,
		  "totalStates": 19,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 588,
		  "schedulePercent": 0.346895,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "514b2a1aa03595226fb0308e51c1680e",
		  
		  "name": "Brian",
		  "createdDate": "2022-04-26 16:08:02",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 795,
		  "totalCountries": 24,
		  "totalStates": 49,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1405,
		  "schedulePercent": 0.599388,
		  "totalGuests": 422,
		  "guestPercent": 0.703536,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "515fc16b71c888cd4e1752d383bcb879",
		  
		  "name": "Melanie",
		  "createdDate": "2018-01-26 18:41:02",
		  "totalOrganizations": 16,
		  "totalTours": 17,
		  "totalDays": 604,
		  "totalCountries": 8,
		  "totalStates": 56,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 3681,
		  "schedulePercent": 0.894946,
		  "totalGuests": 348,
		  "guestPercent": 0.674184,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51758fb1dbc29d2c541e08dc5ff3d869",
		  
		  "name": "Mara ",
		  "createdDate": "2015-08-04 07:41:33",
		  "totalOrganizations": 4,
		  "totalTours": 30,
		  "totalDays": 346,
		  "totalCountries": 25,
		  "totalStates": 56,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 2624,
		  "schedulePercent": 0.800091,
		  "totalGuests": 1384,
		  "guestPercent": 0.898232,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51798e918d2a112f330f316f2e3b0734",
		  
		  "name": "Adam",
		  "createdDate": "2018-09-18 03:18:07",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 228,
		  "totalCountries": 8,
		  "totalStates": 32,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1096,
		  "schedulePercent": 0.518926,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Thornton Winery",
		  "mostGuestCity": "Temecula",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "517c4060702fcfd7dea4d9239bc69280",
		  
		  "name": "Maggie",
		  "createdDate": "2017-01-09 18:14:37",
		  "totalOrganizations": 16,
		  "totalTours": 24,
		  "totalDays": 1876,
		  "totalCountries": 22,
		  "totalStates": 88,
		  "totalEvents": 424,
		  "eventPercent": 0.964302,
		  "totalScheduleItems": 4845,
		  "schedulePercent": 0.948776,
		  "totalGuests": 941,
		  "guestPercent": 0.837942,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Agora Theatre",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "517cbf62f1b44bc119cd5fae1b96644f",
		  
		  "name": "Isaac",
		  "createdDate": "2017-05-26 23:44:29",
		  "totalOrganizations": 7,
		  "totalTours": 18,
		  "totalDays": 494,
		  "totalCountries": 32,
		  "totalStates": 81,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 2902,
		  "schedulePercent": 0.832049,
		  "totalGuests": 1363,
		  "guestPercent": 0.895286,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Marquee Theatre",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5185431bed3bda1ecbe4e3d3733a9bc4",
		  
		  "name": "Keith",
		  "createdDate": "2017-05-03 23:18:13",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 248,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 635,
		  "schedulePercent": 0.362647,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "519886575da225234fc33faa9a77ad34",
		  
		  "name": "Morgan",
		  "createdDate": "2024-10-24 02:30:15",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 816,
		  "totalCountries": 28,
		  "totalStates": 55,
		  "totalEvents": 244,
		  "eventPercent": 0.86514,
		  "totalScheduleItems": 4566,
		  "schedulePercent": 0.940277,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Dreamland Margate - Scenic Stage",
		  "mostGuestCity": "Margate",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51ab4d99c7c3d3fbb30f50f18730bf47",
		  
		  "name": "Aja",
		  "createdDate": "2017-03-21 23:38:41",
		  "totalOrganizations": 14,
		  "totalTours": 4,
		  "totalDays": 44,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 220,
		  "schedulePercent": 0.171578,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Climate Pledge Arena",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51bfbe56f898bf2546b4faa93b33225e",
		  
		  "name": "Eric",
		  "createdDate": "2016-09-03 11:36:04",
		  "totalOrganizations": 29,
		  "totalTours": 24,
		  "totalDays": 1314,
		  "totalCountries": 31,
		  "totalStates": 67,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 2736,
		  "schedulePercent": 0.813803,
		  "totalGuests": 982,
		  "guestPercent": 0.843042,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51d1d9bc29ce7715f1734d59a779c855",
		  
		  "name": "Mario",
		  "createdDate": "2025-10-28 14:03:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 308,
		  "schedulePercent": 0.221782,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Observatory North Park",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51efe9ea5e391df6701bc38f4617d999",
		  
		  "name": "Toni",
		  "createdDate": "2023-03-24 15:25:09",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 119,
		  "totalCountries": 21,
		  "totalStates": 7,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 649,
		  "schedulePercent": 0.366954,
		  "totalGuests": 280,
		  "guestPercent": 0.639393,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "QUARTERBACK Immobilien ARENA",
		  "mostGuestCity": "Leipzig",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51f75d235af85ef838e15e5ca1aa342c",
		  
		  "name": "Albany",
		  "createdDate": "2018-10-22 21:09:40",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 571,
		  "totalCountries": 6,
		  "totalStates": 33,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1327,
		  "schedulePercent": 0.578309,
		  "totalGuests": 428,
		  "guestPercent": 0.706029,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "51f98a05045eafe3ee0e5a893d3b62bb",
		  
		  "name": "John",
		  "createdDate": "2019-06-05 20:19:41",
		  "totalOrganizations": 28,
		  "totalTours": 22,
		  "totalDays": 1362,
		  "totalCountries": 16,
		  "totalStates": 70,
		  "totalEvents": 460,
		  "eventPercent": 0.972575,
		  "totalScheduleItems": 6799,
		  "schedulePercent": 0.984927,
		  "totalGuests": 3390,
		  "guestPercent": 0.988554,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52194337d5ac62fb6936edf80fc5d535",
		  
		  "name": "Mitchell",
		  "createdDate": "2024-10-11 17:52:14",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 358,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 548,
		  "schedulePercent": 0.333522,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Cowboys and Cadillacs",
		  "mostGuestCity": "New Braunfels",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "522199ede3ec6f410f53d7b5e67e5e5e",
		  
		  "name": "Alan",
		  "createdDate": "2014-01-22 23:10:19",
		  "totalOrganizations": 8,
		  "totalTours": 27,
		  "totalDays": 531,
		  "totalCountries": 28,
		  "totalStates": 93,
		  "totalEvents": 304,
		  "eventPercent": 0.915231,
		  "totalScheduleItems": 3702,
		  "schedulePercent": 0.895966,
		  "totalGuests": 3764,
		  "guestPercent": 0.991727,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52263dafd6a66b4776a78064e6582a2c",
		  
		  "name": "Mindi",
		  "createdDate": "2011-05-23 15:58:48",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 610,
		  "totalCountries": 27,
		  "totalStates": 59,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 2336,
		  "schedulePercent": 0.766432,
		  "totalGuests": 690,
		  "guestPercent": 0.783545,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "522c01dc9e4515ef20b92947da76d790",
		  
		  "name": "Alternate",
		  "createdDate": "2020-02-10 19:13:16",
		  "totalOrganizations": 26,
		  "totalTours": 9,
		  "totalDays": 866,
		  "totalCountries": 21,
		  "totalStates": 66,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 3783,
		  "schedulePercent": 0.901292,
		  "totalGuests": 628,
		  "guestPercent": 0.764733,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "523786921afababbebd304a2904c963b",
		  
		  "name": "Jack",
		  "createdDate": "2024-02-10 03:11:54",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 3078,
		  "totalCountries": 19,
		  "totalStates": 10,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 280,
		  "schedulePercent": 0.205576,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "523923e31ca651cb4999995527757460",
		  
		  "name": "Marissa",
		  "createdDate": "2019-09-26 17:42:50",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 707,
		  "totalCountries": 15,
		  "totalStates": 64,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 2598,
		  "schedulePercent": 0.797144,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5244a6413f65066af5771be422a6fcbf",
		  
		  "name": "Samia",
		  "createdDate": "2015-08-03 17:20:00",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 718,
		  "totalCountries": 6,
		  "totalStates": 51,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 3195,
		  "schedulePercent": 0.859134,
		  "totalGuests": 332,
		  "guestPercent": 0.666704,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "524d45e926f90108e17f445351f20019",
		  
		  "name": "Caleb",
		  "createdDate": "2024-07-29 19:24:31",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 370,
		  "totalCountries": 9,
		  "totalStates": 42,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 2214,
		  "schedulePercent": 0.750567,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Yuengling Center",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52595ab8ffa721a33afded95597bf323",
		  
		  "name": "Liam",
		  "createdDate": "2012-12-20 01:38:42",
		  "totalOrganizations": 35,
		  "totalTours": 22,
		  "totalDays": 3158,
		  "totalCountries": 21,
		  "totalStates": 61,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 4145,
		  "schedulePercent": 0.921917,
		  "totalGuests": 864,
		  "guestPercent": 0.82185,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Zenith Paris - La Villette",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "525ab1ab835241725c5a0235b0cdeebf",
		  
		  "name": "Danny",
		  "createdDate": "2023-05-11 20:18:50",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 738,
		  "totalCountries": 16,
		  "totalStates": 51,
		  "totalEvents": 244,
		  "eventPercent": 0.86514,
		  "totalScheduleItems": 2719,
		  "schedulePercent": 0.811877,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "McMenamins Mission Theater",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "525b19f703b255a3a4de77f61bfb1083",
		  
		  "name": "Thomas",
		  "createdDate": "2017-11-07 12:31:54",
		  "totalOrganizations": 20,
		  "totalTours": 25,
		  "totalDays": 379,
		  "totalCountries": 20,
		  "totalStates": 61,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 2279,
		  "schedulePercent": 0.75918,
		  "totalGuests": 1321,
		  "guestPercent": 0.890186,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "525bb1752a1e2aca544cf2b2d060bc5a",
		  
		  "name": "zachary",
		  "createdDate": "2015-05-11 18:06:26",
		  "totalOrganizations": 35,
		  "totalTours": 45,
		  "totalDays": 1946,
		  "totalCountries": 12,
		  "totalStates": 72,
		  "totalEvents": 451,
		  "eventPercent": 0.971215,
		  "totalScheduleItems": 4092,
		  "schedulePercent": 0.918178,
		  "totalGuests": 928,
		  "guestPercent": 0.835335,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "The Van Buren",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5262f57171fa5d01f0599767e908ee48",
		  
		  "name": "oakridgeboys",
		  "createdDate": "2016-01-08 21:46:09",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 700,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 425,
		  "schedulePercent": 0.280032,
		  "totalGuests": 202,
		  "guestPercent": 0.596328,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "The Caverns",
		  "mostGuestCity": "Pelham",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "526b21a77323509ea53dcba39d0a46da",
		  
		  "name": "Caleb",
		  "createdDate": "2021-12-04 23:16:51",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 556,
		  "totalCountries": 30,
		  "totalStates": 55,
		  "totalEvents": 240,
		  "eventPercent": 0.861854,
		  "totalScheduleItems": 3141,
		  "schedulePercent": 0.854714,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "529be7f43826a178d2cadbe686477b46",
		  
		  "name": "Nick",
		  "createdDate": "2018-10-15 01:24:46",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 682,
		  "totalCountries": 23,
		  "totalStates": 61,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 3971,
		  "schedulePercent": 0.911605,
		  "totalGuests": 2045,
		  "guestPercent": 0.950136,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52a7807f043cd091cb0037d9a7eeb78c",
		  
		  "name": "Alex",
		  "createdDate": "2019-01-24 19:42:43",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 877,
		  "totalCountries": 26,
		  "totalStates": 61,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 1438,
		  "schedulePercent": 0.605734,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "The Barns At Wolf Trap",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52a87634cecdda9e45a2a8218260d09c",
		  
		  "name": "ALEJANDRO",
		  "createdDate": "2025-05-24 02:59:42",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 425,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 234,
		  "schedulePercent": 0.18053,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52bdf20bebfc0f6ce1941115e640a86c",
		  
		  "name": "Stephen",
		  "createdDate": "2024-04-22 21:21:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 50,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 83,
		  "schedulePercent": 0.0847688,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Barstool Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52be875a7ba113d2cd816e0d767dac48",
		  
		  "name": "Trap",
		  "createdDate": "2024-04-03 16:20:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 71,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 678,
		  "schedulePercent": 0.377946,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52bed0282c14bd9bda5733ea5ac95b0a",
		  
		  "name": "Henry-Francois",
		  "createdDate": "2019-10-05 20:56:39",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 933,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 949,
		  "schedulePercent": 0.475181,
		  "totalGuests": 164,
		  "guestPercent": 0.569016,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "MTELUS",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52c9211fc68d2c87816ba70e37dc1fa3",
		  
		  "name": "Gage",
		  "createdDate": "2019-05-16 19:12:48",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1078,
		  "schedulePercent": 0.513146,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52cb1d2b6d3067fedca3eec7ef736da1",
		  
		  "name": "Milton",
		  "createdDate": "2024-01-13 12:14:51",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 138,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 399,
		  "schedulePercent": 0.269152,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52cba8d1fb43718de98c23f6a3721056",
		  
		  "name": "Alanna",
		  "createdDate": "2023-05-05 21:27:59",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 772,
		  "totalCountries": 3,
		  "totalStates": 47,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 1881,
		  "schedulePercent": 0.691636,
		  "totalGuests": 289,
		  "guestPercent": 0.643699,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Branded Theater",
		  "mostGuestCity": "Richmond",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52d1e0ebb437071b1979a5819058e937",
		  
		  "name": "Sean",
		  "createdDate": "2010-07-08 03:17:02",
		  "totalOrganizations": 35,
		  "totalTours": 28,
		  "totalDays": 606,
		  "totalCountries": 11,
		  "totalStates": 32,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 2534,
		  "schedulePercent": 0.790118,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Taronga Zoo Sydney",
		  "mostGuestCity": "Mosman",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52d3668a5d481d2e415960854b1775e7",
		  
		  "name": "jonathan",
		  "createdDate": "2012-04-24 04:15:21",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 753,
		  "totalCountries": 14,
		  "totalStates": 31,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 3345,
		  "schedulePercent": 0.87058,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Bell Centre",
		  "mostGuestCity": "Montreal",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52de03e6217694e590fcdc216c19fd78",
		  
		  "name": "Scott",
		  "createdDate": "2019-10-22 00:25:55",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 423,
		  "totalCountries": 21,
		  "totalStates": 68,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 3652,
		  "schedulePercent": 0.892906,
		  "totalGuests": 1840,
		  "guestPercent": 0.93529,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "MGM Music Hall at Fenway",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52de13b93e9a786db235a39e728c58be",
		  
		  "name": "Chuck",
		  "createdDate": "2010-11-07 00:52:41",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 139,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 727,
		  "schedulePercent": 0.397099,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52df0b03218fc120f9837997ada39642",
		  
		  "name": "Luke",
		  "createdDate": "2012-09-24 16:33:20",
		  "totalOrganizations": 61,
		  "totalTours": 39,
		  "totalDays": 728,
		  "totalCountries": 15,
		  "totalStates": 29,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 2220,
		  "schedulePercent": 0.75102,
		  "totalGuests": 670,
		  "guestPercent": 0.777879,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Roma Street Parkland Amphitheatre",
		  "mostGuestCity": "Brisbane City",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52e8eaf55cf0d8fead5fb3938b43de53",
		  
		  "name": "David",
		  "createdDate": "2025-09-16 19:14:54",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 20,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 157,
		  "schedulePercent": 0.13316,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "City Winery",
		  "mostGuestCity": "Pittsburgh",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52ec78f410fb33c82586a96203241cf3",
		  
		  "name": "Hailey",
		  "createdDate": "2022-05-24 15:33:29",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1336,
		  "totalCountries": 16,
		  "totalStates": 69,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 5191,
		  "schedulePercent": 0.959429,
		  "totalGuests": 2846,
		  "guestPercent": 0.978921,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "52f398fd568f115bb94db41a06e8cf7d",
		  
		  "name": "Dennis",
		  "createdDate": "2025-04-01 14:59:14",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 358,
		  "totalCountries": 12,
		  "totalStates": 26,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 1136,
		  "schedulePercent": 0.530485,
		  "totalGuests": 597,
		  "guestPercent": 0.757253,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53092a9cd42cbb8e3057359031d36ffe",
		  
		  "name": "Madison",
		  "createdDate": "2025-03-24 20:14:33",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 644,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1015,
		  "schedulePercent": 0.494674,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "530f73bb0a586a17f6e669d8a1a36228",
		  
		  "name": "Genevieve",
		  "createdDate": "2023-02-03 20:26:50",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 128,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 468,
		  "schedulePercent": 0.297484,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-08 00:00:00",
		  "mostGuestName": "El Club",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5315a8d492b3835b7673f536135e160c",
		  
		  "name": "Rebecca",
		  "createdDate": "2012-09-14 00:12:47",
		  "totalOrganizations": 29,
		  "totalTours": 12,
		  "totalDays": 86,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 596,
		  "schedulePercent": 0.349841,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Palmer Events Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "532e709fc6005d1f4e71c42ee3aa54da",
		  
		  "name": "Filip",
		  "createdDate": "2025-03-03 10:06:01",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 32,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 88,
		  "schedulePercent": 0.088282,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53366b18301951405a4334d5b79e8bff",
		  
		  "name": "Marco",
		  "createdDate": "2018-05-25 00:24:13",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 708,
		  "totalCountries": 17,
		  "totalStates": 61,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 3250,
		  "schedulePercent": 0.863894,
		  "totalGuests": 239,
		  "guestPercent": 0.618314,
		  "mostGuestDate": "2025-05-20 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53370f571ffaae9bfe2934e140e2f1da",
		  
		  "name": "Lori",
		  "createdDate": "2021-07-21 13:53:33",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 85,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 783,
		  "schedulePercent": 0.416704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "533785a93e4323e69e030986718a9c52",
		  
		  "name": "Cardiff",
		  "createdDate": "2019-10-21 13:45:46",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 354,
		  "totalCountries": 12,
		  "totalStates": 48,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1373,
		  "schedulePercent": 0.590549,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53477b3fdff6e5afb4eabb4275dee593",
		  
		  "name": "Lucas",
		  "createdDate": "2025-01-10 20:18:57",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 188,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 677,
		  "schedulePercent": 0.377493,
		  "totalGuests": 295,
		  "guestPercent": 0.647212,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53480cdb0bb3caacb76e0984fa4d7a5f",
		  
		  "name": "Glynn",
		  "createdDate": "2022-03-09 17:49:18",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "534ac4c01e377d80962f5e20cfb9986c",
		  
		  "name": "Pete",
		  "createdDate": "2013-07-02 20:10:10",
		  "totalOrganizations": 22,
		  "totalTours": 40,
		  "totalDays": 376,
		  "totalCountries": 27,
		  "totalStates": 38,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 2746,
		  "schedulePercent": 0.815843,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-04-20 00:00:00",
		  "mostGuestName": "Etihad Park",
		  "mostGuestCity": "Abu Dhabi",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5353b5fda59f72599568d103c4efddf1",
		  
		  "name": "Hoon",
		  "createdDate": "2024-09-02 22:44:40",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 66,
		  "totalCountries": 14,
		  "totalStates": 16,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 384,
		  "schedulePercent": 0.260653,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "535db275c4912ab80102d4e4f97d5082",
		  
		  "name": "Kinder",
		  "createdDate": "2025-05-26 10:54:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 29,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5367dff119b144d9605d353cf02b14f5",
		  
		  "name": "Bastien ",
		  "createdDate": "2024-01-16 10:26:07",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 44,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 560,
		  "schedulePercent": 0.337375,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Caribana Festival Nyon",
		  "mostGuestCity": "Crans-pres-Celigny",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5370206c9967d2792eeac27df1326263",
		  
		  "name": "Calvin",
		  "createdDate": "2023-12-26 17:27:08",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 170,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 186,
		  "schedulePercent": 0.151405,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Mississippi Studios and Bar Bar",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53782833996e0c5b838d7ed5dddf7846",
		  
		  "name": "Lee-Anne",
		  "createdDate": "2013-09-09 04:30:25",
		  "totalOrganizations": 11,
		  "totalTours": 4,
		  "totalDays": 126,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 972,
		  "schedulePercent": 0.481981,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5388ac63888c623d77156c498936ca8d",
		  
		  "name": "Warren",
		  "createdDate": "2024-09-15 20:21:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 78,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 444,
		  "schedulePercent": 0.288078,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "538a2a42d1bc25f82c13233440c1d626",
		  
		  "name": "Trap",
		  "createdDate": "2025-09-11 17:39:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 15,
		  "totalStates": 16,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 293,
		  "schedulePercent": 0.213849,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "538b6c7d59502b0c5c5e9640c9142bd4",
		  
		  "name": "Matthew",
		  "createdDate": "2016-05-23 19:05:55",
		  "totalOrganizations": 3,
		  "totalTours": 16,
		  "totalDays": 461,
		  "totalCountries": 23,
		  "totalStates": 51,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1899,
		  "schedulePercent": 0.694583,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53cd40870c73b4c029adec522092ff21",
		  
		  "name": "Kasey",
		  "createdDate": "2016-06-20 19:20:12",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 352,
		  "totalCountries": 4,
		  "totalStates": 31,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 829,
		  "schedulePercent": 0.434157,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Jubilee Auditorium",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53d4eccdd9ad7d80050da75655a9f75c",
		  
		  "name": "Jonathan",
		  "createdDate": "2013-09-24 21:13:14",
		  "totalOrganizations": 18,
		  "totalTours": 25,
		  "totalDays": 380,
		  "totalCountries": 21,
		  "totalStates": 64,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 2810,
		  "schedulePercent": 0.823776,
		  "totalGuests": 1044,
		  "guestPercent": 0.853355,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53d7fec75eb7d293159c5a16123028b5",
		  
		  "name": "Earl",
		  "createdDate": "2018-01-24 21:26:56",
		  "totalOrganizations": 6,
		  "totalTours": 17,
		  "totalDays": 287,
		  "totalCountries": 19,
		  "totalStates": 50,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 2231,
		  "schedulePercent": 0.752946,
		  "totalGuests": 694,
		  "guestPercent": 0.784111,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53daab949ef37f48e89f18f7be5830cf",
		  
		  "name": "Jacob",
		  "createdDate": "2021-10-08 14:48:03",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 365,
		  "totalCountries": 12,
		  "totalStates": 31,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 660,
		  "schedulePercent": 0.371714,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53de50cd08ae68a32cbe598f8bb39e30",
		  
		  "name": "Sonny",
		  "createdDate": "2015-09-16 15:56:59",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 114,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 391,
		  "schedulePercent": 0.265073,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-04-08 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53e0156a692cb3aaef5e83ee1647af90",
		  
		  "name": "Cierra",
		  "createdDate": "2025-10-27 15:36:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-29 00:00:00",
		  "mostGuestName": "Kulturwerk Herford",
		  "mostGuestCity": "Herford",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53e942f4a4ca14c20f6e4fbe4d82be76",
		  
		  "name": "Sammy",
		  "createdDate": "2025-03-27 17:38:08",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 377,
		  "totalCountries": 12,
		  "totalStates": 41,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 2211,
		  "schedulePercent": 0.749433,
		  "totalGuests": 1321,
		  "guestPercent": 0.890186,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Gas South Arena",
		  "mostGuestCity": "Duluth",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53e96cd4002e680de676a0b2ff5a3557",
		  
		  "name": "Dave",
		  "createdDate": "2012-02-23 17:18:26",
		  "totalOrganizations": 15,
		  "totalTours": 27,
		  "totalDays": 453,
		  "totalCountries": 27,
		  "totalStates": 64,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 3354,
		  "schedulePercent": 0.871374,
		  "totalGuests": 308,
		  "guestPercent": 0.653105,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53f503f603db5acf73cf865bbae8e5a9",
		  
		  "name": "Mike",
		  "createdDate": "2013-08-22 23:28:34",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 283,
		  "totalCountries": 3,
		  "totalStates": 46,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 698,
		  "schedulePercent": 0.385993,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Winspear Opera House",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "53fcb0f87c166d4a67db215598bd6428",
		  
		  "name": "Russell",
		  "createdDate": "2016-05-20 10:09:33",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5401c9268f76aaf3817dbd9b04af471c",
		  
		  "name": "Laurie",
		  "createdDate": "2023-10-30 14:15:26",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 164,
		  "totalCountries": 26,
		  "totalStates": 39,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1009,
		  "schedulePercent": 0.493087,
		  "totalGuests": 233,
		  "guestPercent": 0.614234,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Rex Club",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54022c40ee2b33cd1754259c6398e25e",
		  
		  "name": "Kevin",
		  "createdDate": "2019-06-14 09:12:38",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 106,
		  "totalCountries": 6,
		  "totalStates": 18,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 941,
		  "schedulePercent": 0.472575,
		  "totalGuests": 974,
		  "guestPercent": 0.841568,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Klassik am Dom",
		  "mostGuestCity": "Linz",
		  "mostGuestAmount": 185,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5410904a79fa78d6e1fa1fd460585c95",
		  
		  "name": "Erik",
		  "createdDate": "2023-01-07 20:57:57",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 89,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 79,
		  "schedulePercent": 0.081029,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Effenaar",
		  "mostGuestCity": "Eindhoven",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54220e8b1e71e6b49c359a8a0ccbdff5",
		  
		  "name": "Gaius",
		  "createdDate": "2010-09-01 01:05:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 189,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 214,
		  "schedulePercent": 0.168631,
		  "totalGuests": 134,
		  "guestPercent": 0.548164,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "YouTube Theater",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "542c4fefa0615894ff492e173f168f28",
		  
		  "name": "Jeremy",
		  "createdDate": "2018-02-13 20:33:17",
		  "totalOrganizations": 8,
		  "totalTours": 18,
		  "totalDays": 287,
		  "totalCountries": 27,
		  "totalStates": 58,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 1497,
		  "schedulePercent": 0.617407,
		  "totalGuests": 1069,
		  "guestPercent": 0.857774,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5436adeb8c74c81b755f5801eabd9ea9",
		  
		  "name": "ProducciÃ³n",
		  "createdDate": "2018-03-29 19:10:48",
		  "totalOrganizations": 29,
		  "totalTours": 13,
		  "totalDays": 285,
		  "totalCountries": 6,
		  "totalStates": 42,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 1929,
		  "schedulePercent": 0.699909,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "543e97080eaa22f53e615862649c3d0e",
		  
		  "name": "Chris",
		  "createdDate": "2019-10-02 18:28:30",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 146,
		  "totalCountries": 20,
		  "totalStates": 48,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 998,
		  "schedulePercent": 0.489687,
		  "totalGuests": 452,
		  "guestPercent": 0.713622,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Scala",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54463e3243f90bcc11fa96ff1fd98f40",
		  
		  "name": "Jacco",
		  "createdDate": "2024-05-22 19:39:43",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 144,
		  "totalCountries": 15,
		  "totalStates": 24,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 838,
		  "schedulePercent": 0.43665,
		  "totalGuests": 273,
		  "guestPercent": 0.636899,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Cannery Hall",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "544cbcf0b96854f1f1fdfbe5adff8716",
		  
		  "name": "Evan",
		  "createdDate": "2012-04-01 05:20:14",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 426,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 669,
		  "schedulePercent": 0.374433,
		  "totalGuests": 562,
		  "guestPercent": 0.746827,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5450e75df13f010582edd13003faa8e2",
		  
		  "name": "Ellen ",
		  "createdDate": "2023-08-30 23:46:07",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 267,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2364,
		  "schedulePercent": 0.770399,
		  "totalGuests": 867,
		  "guestPercent": 0.822529,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54574be251b3c68a3373f8e47a17177e",
		  
		  "name": "Anna",
		  "createdDate": "2022-06-06 18:09:30",
		  "totalOrganizations": 16,
		  "totalTours": 11,
		  "totalDays": 488,
		  "totalCountries": 25,
		  "totalStates": 42,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 3345,
		  "schedulePercent": 0.87058,
		  "totalGuests": 2076,
		  "guestPercent": 0.952176,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54613820365916ae7c739a349cf568c1",
		  
		  "name": "Jason",
		  "createdDate": "2013-10-08 18:27:54",
		  "totalOrganizations": 16,
		  "totalTours": 32,
		  "totalDays": 925,
		  "totalCountries": 39,
		  "totalStates": 84,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 3568,
		  "schedulePercent": 0.886673,
		  "totalGuests": 1206,
		  "guestPercent": 0.87636,
		  "mostGuestDate": "2025-09-16 00:00:00",
		  "mostGuestName": "The Regency Ballroom",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5476adb58a73444cbd291955b0df9cf2",
		  
		  "name": "Britta",
		  "createdDate": "2021-11-22 09:56:29",
		  "totalOrganizations": 30,
		  "totalTours": 32,
		  "totalDays": 1583,
		  "totalCountries": 12,
		  "totalStates": 35,
		  "totalEvents": 267,
		  "eventPercent": 0.888033,
		  "totalScheduleItems": 2442,
		  "schedulePercent": 0.780032,
		  "totalGuests": 996,
		  "guestPercent": 0.845422,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Koelnarena",
		  "mostGuestCity": "Cologne",
		  "mostGuestAmount": 256,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54774b09548674d215b30c29562a603e",
		  
		  "name": "Philippe",
		  "createdDate": "2022-01-28 12:02:54",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 368,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1817,
		  "schedulePercent": 0.678944,
		  "totalGuests": 202,
		  "guestPercent": 0.596328,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "L'Espace Aumaillerie",
		  "mostGuestCity": "La Selle-en-LuitrÃ©",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54860cf9b0252d08b1d1ae9f4954ac42",
		  
		  "name": "Eline",
		  "createdDate": "2019-09-03 17:42:20",
		  "totalOrganizations": 8,
		  "totalTours": 15,
		  "totalDays": 532,
		  "totalCountries": 24,
		  "totalStates": 63,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1898,
		  "schedulePercent": 0.694016,
		  "totalGuests": 726,
		  "guestPercent": 0.792044,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Tollwood Music Festival",
		  "mostGuestCity": "Munich",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5491d1cbc741c9d472a5c7096af31679",
		  
		  "name": "Christian",
		  "createdDate": "2022-01-13 14:51:34",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 190,
		  "totalCountries": 6,
		  "totalStates": 50,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 1617,
		  "schedulePercent": 0.643472,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "549acf2d2bf85b16cf655a8d46c027f8",
		  
		  "name": "Kurt",
		  "createdDate": "2019-11-19 02:36:00",
		  "totalOrganizations": 3,
		  "totalTours": 23,
		  "totalDays": 154,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 754,
		  "schedulePercent": 0.407298,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54a92747f366cb00ce5584c592c3ad00",
		  
		  "name": "Graham",
		  "createdDate": "2023-02-09 15:59:56",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 119,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 267,
		  "schedulePercent": 0.197756,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Aviva Studios, home of Factory International",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54a93d68604a5dcdd25c6d5f91bcc8ff",
		  
		  "name": "Matt",
		  "createdDate": "2012-05-30 01:14:42",
		  "totalOrganizations": 20,
		  "totalTours": 6,
		  "totalDays": 485,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1263,
		  "schedulePercent": 0.563803,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54add98462971867fb21f464ca6e0eb2",
		  
		  "name": "James",
		  "createdDate": "2022-06-18 16:03:53",
		  "totalOrganizations": 23,
		  "totalTours": 13,
		  "totalDays": 789,
		  "totalCountries": 22,
		  "totalStates": 57,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 4229,
		  "schedulePercent": 0.928037,
		  "totalGuests": 2231,
		  "guestPercent": 0.959202,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54b843e91934758ed50b0d1513dc0cd2",
		  
		  "name": "Erich",
		  "createdDate": "2015-02-02 18:29:27",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 838,
		  "totalCountries": 29,
		  "totalStates": 72,
		  "totalEvents": 268,
		  "eventPercent": 0.888599,
		  "totalScheduleItems": 3885,
		  "schedulePercent": 0.907412,
		  "totalGuests": 747,
		  "guestPercent": 0.795558,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54baef7cbc7a9b1baab6b6d81df43e0e",
		  
		  "name": "Ashley",
		  "createdDate": "2025-03-09 16:23:53",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 132,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 927,
		  "schedulePercent": 0.467362,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54d1e7ec46250b4bff6e17d980b5f28e",
		  
		  "name": "Laura",
		  "createdDate": "2024-05-17 15:08:29",
		  "totalOrganizations": 25,
		  "totalTours": 28,
		  "totalDays": 918,
		  "totalCountries": 7,
		  "totalStates": 6,
		  "totalEvents": 895,
		  "eventPercent": 0.994447,
		  "totalScheduleItems": 3618,
		  "schedulePercent": 0.890639,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54d64894b53b6ce9492a3508700e4b97",
		  
		  "name": "Michele",
		  "createdDate": "2018-09-22 20:13:56",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 118,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 142,
		  "schedulePercent": 0.126587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54d7c8e6cad7663df9ff11adf03f1936",
		  
		  "name": "Joshua",
		  "createdDate": "2015-07-25 15:49:23",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 704,
		  "totalCountries": 9,
		  "totalStates": 38,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 932,
		  "schedulePercent": 0.470082,
		  "totalGuests": 638,
		  "guestPercent": 0.768812,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Fenway Park",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54e05b8082ff1bf05f2576c4b5e83d21",
		  
		  "name": "Dom",
		  "createdDate": "2023-07-25 16:14:42",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 245,
		  "totalCountries": 12,
		  "totalStates": 34,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 888,
		  "schedulePercent": 0.453083,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Banpaku Memorial Park (East Plaza)",
		  "mostGuestCity": "Osaka",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54e763416a61f7e5b06c1e18ee68d997",
		  
		  "name": "Michael",
		  "createdDate": "2016-08-24 21:48:56",
		  "totalOrganizations": 23,
		  "totalTours": 24,
		  "totalDays": 456,
		  "totalCountries": 17,
		  "totalStates": 62,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 2711,
		  "schedulePercent": 0.81029,
		  "totalGuests": 1243,
		  "guestPercent": 0.879986,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Echo-Plex",
		  "mostGuestCity": "Echo Park",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "54f3bc794c1786a133d615631da4e342",
		  
		  "name": "Joey",
		  "createdDate": "2020-02-04 22:21:21",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 652,
		  "totalCountries": 10,
		  "totalStates": 55,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2594,
		  "schedulePercent": 0.796691,
		  "totalGuests": 284,
		  "guestPercent": 0.641206,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "The Mystic Theatre",
		  "mostGuestCity": "Petaluma",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5504769b42cfc51657b7c3c3a38b399f",
		  
		  "name": "Juliette",
		  "createdDate": "2019-06-13 17:23:12",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 374,
		  "totalCountries": 19,
		  "totalStates": 22,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 2158,
		  "schedulePercent": 0.740934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5506897121a4c3c903a20ec4e5e357e2",
		  
		  "name": "Leah",
		  "createdDate": "2024-12-22 00:59:04",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 324,
		  "totalCountries": 3,
		  "totalStates": 46,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 2238,
		  "schedulePercent": 0.753853,
		  "totalGuests": 1348,
		  "guestPercent": 0.892792,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Germania Insurance Amphitheater",
		  "mostGuestCity": "Del Valle",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5518e2ec5525483763902f5ac15e374d",
		  
		  "name": "Charlie",
		  "createdDate": "2019-01-30 04:01:09",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 469,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1230,
		  "schedulePercent": 0.554964,
		  "totalGuests": 1553,
		  "guestPercent": 0.915345,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "551e91f815e74dc58b8de55bf3538ca8",
		  
		  "name": "Mills",
		  "createdDate": "2016-06-01 18:54:30",
		  "totalOrganizations": 53,
		  "totalTours": 8,
		  "totalDays": 299,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1242,
		  "schedulePercent": 0.558364,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5523da6eb59df88055887838ab2cc613",
		  
		  "name": "stefania",
		  "createdDate": "2022-11-07 16:05:43",
		  "totalOrganizations": 30,
		  "totalTours": 36,
		  "totalDays": 1714,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 317,
		  "eventPercent": 0.923617,
		  "totalScheduleItems": 2778,
		  "schedulePercent": 0.819243,
		  "totalGuests": 996,
		  "guestPercent": 0.845422,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Koelnarena",
		  "mostGuestCity": "Cologne",
		  "mostGuestAmount": 256,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5528e5c931520d5fc62b0a88ab6990ed",
		  
		  "name": "Olivia",
		  "createdDate": "2023-01-08 01:56:07",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 2490,
		  "totalCountries": 23,
		  "totalStates": 72,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 1947,
		  "schedulePercent": 0.703196,
		  "totalGuests": 190,
		  "guestPercent": 0.585902,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Republic NOLA",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5534ac0b2912e53f2e30210920c5d278",
		  
		  "name": "Ceyla",
		  "createdDate": "2023-05-17 21:31:09",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5540f1ed2390c54aef6b015f580190ed",
		  
		  "name": "Bengt \"Elak\"",
		  "createdDate": "2013-09-23 13:29:46",
		  "totalOrganizations": 20,
		  "totalTours": 4,
		  "totalDays": 210,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 591,
		  "schedulePercent": 0.347915,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "554376517bc7baab577aa215e22193df",
		  
		  "name": "Larkin",
		  "createdDate": "2018-09-30 14:41:16",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 365,
		  "totalCountries": 18,
		  "totalStates": 37,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1292,
		  "schedulePercent": 0.569923,
		  "totalGuests": 851,
		  "guestPercent": 0.819923,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55454a1b2c7ea5fd05d7930c7f1177e8",
		  
		  "name": "Christian",
		  "createdDate": "2014-06-08 23:09:24",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 1454,
		  "totalCountries": 22,
		  "totalStates": 45,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2076,
		  "schedulePercent": 0.728468,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "SunBet Arena at Time Square Casino",
		  "mostGuestCity": "Pretoria",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5548629d31bb538be43cc22252c1df6e",
		  
		  "name": "Holger",
		  "createdDate": "2025-10-28 12:25:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "554dcf0a3fcfe2202e8a4bfbd120f9dd",
		  
		  "name": "Aiden",
		  "createdDate": "2024-03-02 01:29:19",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1251,
		  "schedulePercent": 0.56097,
		  "totalGuests": 372,
		  "guestPercent": 0.68189,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Beaver Dam Amphitheater",
		  "mostGuestCity": "Beaver Dam",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5566b7709a7c18bc21fb63c3d144ae6e",
		  
		  "name": "Chris",
		  "createdDate": "2021-10-30 16:58:23",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 319,
		  "totalCountries": 29,
		  "totalStates": 35,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 1864,
		  "schedulePercent": 0.687783,
		  "totalGuests": 164,
		  "guestPercent": 0.569016,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Islington Assembly Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "556a59c12c6faee44dd29223d99f57a8",
		  
		  "name": "SAM",
		  "createdDate": "2016-10-04 09:55:51",
		  "totalOrganizations": 19,
		  "totalTours": 11,
		  "totalDays": 242,
		  "totalCountries": 21,
		  "totalStates": 53,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1788,
		  "schedulePercent": 0.674411,
		  "totalGuests": 827,
		  "guestPercent": 0.81437,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55732eebc47fcd2846586e16e04e0e48",
		  
		  "name": "Luke",
		  "createdDate": "2020-03-04 12:28:30",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 218,
		  "totalCountries": 30,
		  "totalStates": 32,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1368,
		  "schedulePercent": 0.588622,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Lollapalooza Festival Argentina",
		  "mostGuestCity": "San Isidro",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5574100c03d5e34ffbf2424cf5dba439",
		  
		  "name": "Jonathan",
		  "createdDate": "2024-03-20 14:29:23",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 365,
		  "totalCountries": 22,
		  "totalStates": 48,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 766,
		  "schedulePercent": 0.410245,
		  "totalGuests": 612,
		  "guestPercent": 0.762239,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5578d7285d4361a8554d3004f60f1977",
		  
		  "name": "Francesco",
		  "createdDate": "2018-12-08 22:03:20",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 136,
		  "totalCountries": 22,
		  "totalStates": 46,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 767,
		  "schedulePercent": 0.410925,
		  "totalGuests": 388,
		  "guestPercent": 0.68903,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Alcatraz",
		  "mostGuestCity": "Milano",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55991f11e815459c921442e63840c133",
		  
		  "name": "Javan",
		  "createdDate": "2023-01-22 22:15:11",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 69,
		  "totalCountries": 6,
		  "totalStates": 11,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 455,
		  "schedulePercent": 0.292611,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Leicester Square Theatre",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55a21b367728025b190a580bb6882e2f",
		  
		  "name": "Alexa",
		  "createdDate": "2025-06-13 00:24:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 152,
		  "schedulePercent": 0.131006,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55acc0e50a54bc4e9ab866f929bdb9b2",
		  
		  "name": "Clotilde",
		  "createdDate": "2025-03-27 21:55:44",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 84,
		  "totalCountries": 11,
		  "totalStates": 12,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 447,
		  "schedulePercent": 0.289438,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Festival Mythos",
		  "mostGuestCity": "Saint-Jacques-de-la-Lande",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55bc0064ef5a348f7930c03c9f8dc43d",
		  
		  "name": "Ales",
		  "createdDate": "2014-11-08 17:39:52",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 134,
		  "totalCountries": 11,
		  "totalStates": 40,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 833,
		  "schedulePercent": 0.435517,
		  "totalGuests": 641,
		  "guestPercent": 0.769379,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "BRIC",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55c5c872077a498b2b077f637620fe4d",
		  
		  "name": "Jez",
		  "createdDate": "2015-10-20 15:37:25",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 9,
		  "totalStates": 13,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 203,
		  "schedulePercent": 0.162965,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-06-16 00:00:00",
		  "mostGuestName": "Downstairs At The Dome",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55d7e5846e9234ae11da36acbab07f88",
		  
		  "name": "Nadia",
		  "createdDate": "2025-08-19 14:16:08",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 548,
		  "schedulePercent": 0.333522,
		  "totalGuests": 580,
		  "guestPercent": 0.752607,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Pavilion at Montage Mountain",
		  "mostGuestCity": "Moosic",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "55e1c7e241c10677579079949908f626",
		  
		  "name": "Sam",
		  "createdDate": "2025-01-27 10:59:28",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 550,
		  "totalCountries": 23,
		  "totalStates": 24,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 690,
		  "schedulePercent": 0.382593,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Dreamland Margate - Scenic Stage",
		  "mostGuestCity": "Margate",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5601865615b1364d28be1db2f32e3c84",
		  
		  "name": "Giovannie",
		  "createdDate": "2025-01-29 15:04:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 233,
		  "totalCountries": 2,
		  "totalStates": 39,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 624,
		  "schedulePercent": 0.358908,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Cain's Ballroom",
		  "mostGuestCity": "Tulsa",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "561c5922579302b6723f2c0bd94b072a",
		  
		  "name": "Kelly",
		  "createdDate": "2023-08-25 10:06:24",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 349,
		  "totalCountries": 7,
		  "totalStates": 9,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 977,
		  "schedulePercent": 0.483568,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5621b361c657bac9d810ba5136c5ffb5",
		  
		  "name": "Paul",
		  "createdDate": "2024-11-18 16:37:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 436,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 10,
		  "schedulePercent": 0.0207389,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5632016b083998abae5726e31a41e57a",
		  
		  "name": "Lucy Marie",
		  "createdDate": "2016-12-13 18:04:14",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 369,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1206,
		  "schedulePercent": 0.548504,
		  "totalGuests": 292,
		  "guestPercent": 0.645739,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5633b5a0220c42d098d6ab9e42816212",
		  
		  "name": "John",
		  "createdDate": "2016-03-22 15:44:15",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 597,
		  "schedulePercent": 0.350068,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Sonoma County Fairgrounds",
		  "mostGuestCity": "Santa Rosa",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5638efa7fd8122f184908704232cb92f",
		  
		  "name": "Gunnar",
		  "createdDate": "2024-10-14 21:04:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 136,
		  "schedulePercent": 0.122507,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Mo's Place",
		  "mostGuestCity": "Katy",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "565a8b30cb4453a1fb44795c32326e7a",
		  
		  "name": "Marc",
		  "createdDate": "2012-02-28 08:58:42",
		  "totalOrganizations": 20,
		  "totalTours": 13,
		  "totalDays": 638,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1676,
		  "schedulePercent": 0.654125,
		  "totalGuests": 189,
		  "guestPercent": 0.585222,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "Walt Disney Concert Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "566d76651fa624c61228e9c6bb578297",
		  
		  "name": "Mychal",
		  "createdDate": "2023-04-27 14:50:17",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 180,
		  "totalCountries": 6,
		  "totalStates": 57,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 1421,
		  "schedulePercent": 0.602335,
		  "totalGuests": 1355,
		  "guestPercent": 0.893812,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5671f176199f4aa0f1133ef80fd814da",
		  
		  "name": "Michael",
		  "createdDate": "2018-12-12 19:36:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 36,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 203,
		  "schedulePercent": 0.162965,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5679e2d596d0212213bb5fb2174c4aed",
		  
		  "name": "TOUR BOSS",
		  "createdDate": "2024-09-14 04:02:49",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 85,
		  "totalCountries": 14,
		  "totalStates": 34,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 285,
		  "schedulePercent": 0.209542,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-03-12 00:00:00",
		  "mostGuestName": "Club Citta'",
		  "mostGuestCity": "Kawasaki-shi",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56813e4f33d65fbcc1f515ae07872123",
		  
		  "name": "Charlie",
		  "createdDate": "2018-11-01 14:13:32",
		  "totalOrganizations": 35,
		  "totalTours": 19,
		  "totalDays": 1017,
		  "totalCountries": 26,
		  "totalStates": 62,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 3228,
		  "schedulePercent": 0.861967,
		  "totalGuests": 1709,
		  "guestPercent": 0.92849,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Thompson's Point",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5682f60b0519baff92542a78e6323a62",
		  
		  "name": "Cyril",
		  "createdDate": "2016-11-14 15:19:20",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 277,
		  "totalCountries": 15,
		  "totalStates": 18,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 383,
		  "schedulePercent": 0.259859,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5689cf65c55eddbf5adc838098c3087e",
		  
		  "name": "Lolita",
		  "createdDate": "2025-02-18 09:35:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 301,
		  "totalCountries": 6,
		  "totalStates": 3,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 122,
		  "schedulePercent": 0.112534,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56947d25327f274842de3837869d8895",
		  
		  "name": "Samuel",
		  "createdDate": "2014-08-09 05:24:02",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 752,
		  "totalCountries": 22,
		  "totalStates": 61,
		  "totalEvents": 302,
		  "eventPercent": 0.914211,
		  "totalScheduleItems": 5836,
		  "schedulePercent": 0.973368,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "569b9d582ef14d197cc41216248a6051",
		  
		  "name": "Derek",
		  "createdDate": "2013-01-29 01:56:31",
		  "totalOrganizations": 34,
		  "totalTours": 11,
		  "totalDays": 540,
		  "totalCountries": 6,
		  "totalStates": 16,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 4780,
		  "schedulePercent": 0.947076,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Stade de France",
		  "mostGuestCity": "Saint-Denis",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56aa5b4f252914d68c82633da0241518",
		  
		  "name": "Karine",
		  "createdDate": "2024-09-30 20:07:45",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 245,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 793,
		  "schedulePercent": 0.419991,
		  "totalGuests": 284,
		  "guestPercent": 0.641206,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Place des Festivals â€“ ScÃ¨ne Bell",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56b396b23812002164a900a7c2b23683",
		  
		  "name": "Leah",
		  "createdDate": "2025-10-20 17:38:29",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 39,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 128,
		  "schedulePercent": 0.116614,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56b4c685b28cd02413e6eb7f8d84a097",
		  
		  "name": "Joel",
		  "createdDate": "2024-10-22 21:10:15",
		  "totalOrganizations": 19,
		  "totalTours": 17,
		  "totalDays": 525,
		  "totalCountries": 18,
		  "totalStates": 11,
		  "totalEvents": 441,
		  "eventPercent": 0.968835,
		  "totalScheduleItems": 4172,
		  "schedulePercent": 0.924071,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56beccbb1210d20e466f6cbe09d57a68",
		  
		  "name": "STARSET",
		  "createdDate": "2019-03-21 00:00:41",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 320,
		  "totalCountries": 6,
		  "totalStates": 42,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1177,
		  "schedulePercent": 0.541364,
		  "totalGuests": 658,
		  "guestPercent": 0.773005,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56c07f7b7573b186ee363c0efe6d2620",
		  
		  "name": "PrÃ©Pro",
		  "createdDate": "2024-08-09 21:14:09",
		  "totalOrganizations": 5,
		  "totalTours": 14,
		  "totalDays": 127,
		  "totalCountries": 12,
		  "totalStates": 14,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 655,
		  "schedulePercent": 0.3699,
		  "totalGuests": 974,
		  "guestPercent": 0.841568,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "THT/Paradiso Noord",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 373,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56c13bcabfd6295fc2f757f4c2727bf8",
		  
		  "name": "Brandon",
		  "createdDate": "2024-08-16 22:32:03",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 113,
		  "schedulePercent": 0.106754,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-11-26 00:00:00",
		  "mostGuestName": "Terminal West",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56d2ff29f088eabe34cd8597d23fba4e",
		  
		  "name": "Aaron ",
		  "createdDate": "2013-05-21 20:04:23",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 77,
		  "totalCountries": 5,
		  "totalStates": 29,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 404,
		  "schedulePercent": 0.271532,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Fogg Street Lawn Club - Rooftop Series",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56da7ffe7008cf6c514fedcd1f529ea6",
		  
		  "name": "Christie ",
		  "createdDate": "2017-04-28 18:34:14",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 308,
		  "totalCountries": 12,
		  "totalStates": 47,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 3439,
		  "schedulePercent": 0.877946,
		  "totalGuests": 1317,
		  "guestPercent": 0.889053,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56e0b238dc2e6480744eadc8e14b4844",
		  
		  "name": "Genevi&#232;ve",
		  "createdDate": "2024-12-18 15:34:40",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 108,
		  "totalCountries": 4,
		  "totalStates": 11,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 400,
		  "schedulePercent": 0.269379,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Horseshoe Tavern",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56e6d30ffe75411b77d1b143dba7cd98",
		  
		  "name": "Fratellis",
		  "createdDate": "2022-10-17 10:35:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 63,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 98,
		  "schedulePercent": 0.0951949,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Glasgow Green",
		  "mostGuestCity": "",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56ed22620dfda012e26e6a4a5d437808",
		  
		  "name": "Christopher",
		  "createdDate": "2022-03-10 16:18:45",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 288,
		  "totalCountries": 9,
		  "totalStates": 33,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1537,
		  "schedulePercent": 0.624773,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "56f5bc3c83f8f4e0da058a4d4857f9da",
		  
		  "name": "GlÃ²ria",
		  "createdDate": "2019-11-22 14:31:11",
		  "totalOrganizations": 7,
		  "totalTours": 1,
		  "totalDays": 52,
		  "totalCountries": 9,
		  "totalStates": 14,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 311,
		  "schedulePercent": 0.222801,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "BeachLife Festival",
		  "mostGuestCity": "Redondo Beach",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5703bd21b3b2ff6c052d482112ff635c",
		  
		  "name": "Christine",
		  "createdDate": "2022-10-03 18:54:10",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 268,
		  "totalCountries": 8,
		  "totalStates": 33,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1933,
		  "schedulePercent": 0.700476,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5705a987d4199cf535fa3d96d3e42f52",
		  
		  "name": "Brenna",
		  "createdDate": "2025-01-31 18:38:23",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 220,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1789,
		  "schedulePercent": 0.674637,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "570ef70d60cb405820d0480b351d37d1",
		  
		  "name": "Lillian",
		  "createdDate": "2025-09-25 21:18:02",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 121,
		  "totalCountries": 7,
		  "totalStates": 20,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 124,
		  "schedulePercent": 0.114007,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Supersonic",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "572203b61540fad6ce1e604a44d1a097",
		  
		  "name": "Gerard",
		  "createdDate": "2019-04-05 22:39:40",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 269,
		  "totalCountries": 14,
		  "totalStates": 20,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5731f6e247c2c967deed922a4fecd044",
		  
		  "name": "PhilaÃ©",
		  "createdDate": "2023-08-28 15:16:30",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 224,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 439,
		  "schedulePercent": 0.285811,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Le Virtuoz Club",
		  "mostGuestCity": "Villeneuve-la-Garenne",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "575471dfe999130b35e9f2c3b563d1b2",
		  
		  "name": "Amiel",
		  "createdDate": "2019-12-20 02:11:23",
		  "totalOrganizations": 12,
		  "totalTours": 16,
		  "totalDays": 1302,
		  "totalCountries": 25,
		  "totalStates": 69,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 2733,
		  "schedulePercent": 0.81335,
		  "totalGuests": 984,
		  "guestPercent": 0.843268,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "575eead8e905c0d4cd56a5b7ee954b64",
		  
		  "name": "Chris",
		  "createdDate": "2020-02-24 16:13:23",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 845,
		  "totalCountries": 4,
		  "totalStates": 46,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2085,
		  "schedulePercent": 0.729941,
		  "totalGuests": 1170,
		  "guestPercent": 0.873187,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 190,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5765dac17d1d97e1a7189412feea0dad",
		  
		  "name": "John",
		  "createdDate": "2025-06-30 17:45:31",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 179,
		  "totalCountries": 7,
		  "totalStates": 29,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1010,
		  "schedulePercent": 0.493314,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "GLC Live at 20 Monroe",
		  "mostGuestCity": "Grand Rapids",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "576b6fe90458cef8618aa5b94ed550e4",
		  
		  "name": "Brendan",
		  "createdDate": "2012-01-16 16:09:03",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 65,
		  "totalCountries": 8,
		  "totalStates": 18,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 387,
		  "schedulePercent": 0.262579,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Tuning Fork",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "576ed37e407902bd39b34e6c736bd390",
		  
		  "name": "Celina",
		  "createdDate": "2017-04-20 16:36:18",
		  "totalOrganizations": 17,
		  "totalTours": 6,
		  "totalDays": 387,
		  "totalCountries": 17,
		  "totalStates": 21,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 878,
		  "schedulePercent": 0.450589,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "O2 Ritz Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "577424197cca4cc6a777f975a93a56d2",
		  
		  "name": "Jeff",
		  "createdDate": "2023-08-19 12:43:56",
		  "totalOrganizations": 15,
		  "totalTours": 29,
		  "totalDays": 737,
		  "totalCountries": 26,
		  "totalStates": 104,
		  "totalEvents": 413,
		  "eventPercent": 0.961695,
		  "totalScheduleItems": 3644,
		  "schedulePercent": 0.891886,
		  "totalGuests": 1203,
		  "guestPercent": 0.876133,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Powerstation",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "577ea7bc8de0cd6e9e4e5ed8d43e9f21",
		  
		  "name": "Rick",
		  "createdDate": "2012-05-26 07:57:12",
		  "totalOrganizations": 17,
		  "totalTours": 10,
		  "totalDays": 787,
		  "totalCountries": 12,
		  "totalStates": 59,
		  "totalEvents": 271,
		  "eventPercent": 0.891092,
		  "totalScheduleItems": 4365,
		  "schedulePercent": 0.93359,
		  "totalGuests": 910,
		  "guestPercent": 0.832616,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Palais Theatre",
		  "mostGuestCity": "St Kilda",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57833742c14e9c3f9b9924f081cd2690",
		  
		  "name": "Markus GiÃ¦ver",
		  "createdDate": "2025-09-30 22:32:42",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 24,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 201,
		  "schedulePercent": 0.161491,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "578709a073121781b794571724a2b979",
		  
		  "name": "Michael",
		  "createdDate": "2014-03-07 20:46:35",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 610,
		  "totalCountries": 20,
		  "totalStates": 66,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 3377,
		  "schedulePercent": 0.873527,
		  "totalGuests": 2076,
		  "guestPercent": 0.952176,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5791221095129baa19752abe9ad47260",
		  
		  "name": "Joslyn",
		  "createdDate": "2019-09-04 22:07:23",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 1887,
		  "totalCountries": 20,
		  "totalStates": 65,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 2897,
		  "schedulePercent": 0.831596,
		  "totalGuests": 325,
		  "guestPercent": 0.663531,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Mayfair Austin",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "579250be08ba6732f1d0b08b6c2558fb",
		  
		  "name": "Derek",
		  "createdDate": "2012-03-06 14:06:24",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 1482,
		  "totalCountries": 20,
		  "totalStates": 75,
		  "totalEvents": 317,
		  "eventPercent": 0.923617,
		  "totalScheduleItems": 5666,
		  "schedulePercent": 0.971102,
		  "totalGuests": 1854,
		  "guestPercent": 0.936537,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "UBS Arena",
		  "mostGuestCity": "Elmont",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57a59ef45570dea5fd499246738fa47d",
		  
		  "name": "TNP",
		  "createdDate": "2022-04-21 16:49:15",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 429,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 580,
		  "schedulePercent": 0.343608,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Tuacahn Center For the Arts",
		  "mostGuestCity": "Ivins",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57a81b3f691173bf1a53858fb0b873ca",
		  
		  "name": "John",
		  "createdDate": "2013-05-14 03:49:07",
		  "totalOrganizations": 50,
		  "totalTours": 20,
		  "totalDays": 2127,
		  "totalCountries": 37,
		  "totalStates": 75,
		  "totalEvents": 405,
		  "eventPercent": 0.959995,
		  "totalScheduleItems": 5557,
		  "schedulePercent": 0.968722,
		  "totalGuests": 228,
		  "guestPercent": 0.611514,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Palau Sant Jordi",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57adf0512fc3eb66e39b34b31b982131",
		  
		  "name": "Dean",
		  "createdDate": "2019-07-09 14:53:47",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 248,
		  "totalCountries": 21,
		  "totalStates": 50,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1391,
		  "schedulePercent": 0.595195,
		  "totalGuests": 661,
		  "guestPercent": 0.774932,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Bramall Lane",
		  "mostGuestCity": "Sheffield",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57b88b725c1b37b46c03a41992662a5d",
		  
		  "name": "Tommy ",
		  "createdDate": "2015-04-06 17:13:57",
		  "totalOrganizations": 13,
		  "totalTours": 3,
		  "totalDays": 105,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 412,
		  "schedulePercent": 0.275272,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "The Bottleneck",
		  "mostGuestCity": "Lawrence",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57b9dfca3b7feb04bc18fe5a2c26c81e",
		  
		  "name": "Jada",
		  "createdDate": "2023-05-16 20:37:14",
		  "totalOrganizations": 4,
		  "totalTours": 35,
		  "totalDays": 953,
		  "totalCountries": 25,
		  "totalStates": 55,
		  "totalEvents": 313,
		  "eventPercent": 0.921351,
		  "totalScheduleItems": 3600,
		  "schedulePercent": 0.889393,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57c4bb0355f88b06475d029af2a1fd8f",
		  
		  "name": "Dave",
		  "createdDate": "2012-05-28 03:57:42",
		  "totalOrganizations": 26,
		  "totalTours": 36,
		  "totalDays": 788,
		  "totalCountries": 17,
		  "totalStates": 50,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 2544,
		  "schedulePercent": 0.791251,
		  "totalGuests": 629,
		  "guestPercent": 0.764959,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Margaret Court Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57c7ed2518b2cf78dbc4f5bbbcfb6150",
		  
		  "name": "Grant",
		  "createdDate": "2014-11-06 11:33:16",
		  "totalOrganizations": 20,
		  "totalTours": 43,
		  "totalDays": 732,
		  "totalCountries": 27,
		  "totalStates": 77,
		  "totalEvents": 311,
		  "eventPercent": 0.919878,
		  "totalScheduleItems": 3369,
		  "schedulePercent": 0.873073,
		  "totalGuests": 2076,
		  "guestPercent": 0.952176,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57cf651f35623f0d92adc8a6bc19a026",
		  
		  "name": "Igor",
		  "createdDate": "2024-04-26 08:19:28",
		  "totalOrganizations": 37,
		  "totalTours": 41,
		  "totalDays": 918,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 807,
		  "eventPercent": 0.993314,
		  "totalScheduleItems": 4580,
		  "schedulePercent": 0.94039,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Tulisuudelma",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57d096d0ccf7d5dadc7fd67cb4f7b98e",
		  
		  "name": "Event ",
		  "createdDate": "2023-04-18 17:51:16",
		  "totalOrganizations": 53,
		  "totalTours": 17,
		  "totalDays": 664,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 283,
		  "eventPercent": 0.900499,
		  "totalScheduleItems": 207,
		  "schedulePercent": 0.164438,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57d2cc46046e7adf3c1c783806331e29",
		  
		  "name": "Kim",
		  "createdDate": "2024-07-17 04:35:54",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 113,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 617,
		  "schedulePercent": 0.356301,
		  "totalGuests": 617,
		  "guestPercent": 0.763033,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "Brooklyn paramount",
		  "mostGuestCity": "",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57e114801d65c54d05ef337b3476fbf5",
		  
		  "name": "Robertson",
		  "createdDate": "2012-08-16 20:39:01",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 291,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 864,
		  "schedulePercent": 0.446056,
		  "totalGuests": 546,
		  "guestPercent": 0.742634,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Wilshire Ebell Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57e19322aa07610002b507127039e295",
		  
		  "name": "Craig",
		  "createdDate": "2017-12-01 04:20:19",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 20,
		  "totalCountries": 1,
		  "totalStates": 4,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 117,
		  "schedulePercent": 0.108794,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Church Pub",
		  "mostGuestCity": "Christchurch",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57e217876cf9700cbf0f3ff28d5e7085",
		  
		  "name": "Cooper ",
		  "createdDate": "2021-11-24 20:09:30",
		  "totalOrganizations": 11,
		  "totalTours": 15,
		  "totalDays": 959,
		  "totalCountries": 12,
		  "totalStates": 63,
		  "totalEvents": 286,
		  "eventPercent": 0.902765,
		  "totalScheduleItems": 4011,
		  "schedulePercent": 0.913645,
		  "totalGuests": 1951,
		  "guestPercent": 0.94277,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "57fb61f9968fa3d7694ccb62a373e670",
		  
		  "name": "Veronica",
		  "createdDate": "2024-03-03 04:40:03",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 50,
		  "totalCountries": 13,
		  "totalStates": 12,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 454,
		  "schedulePercent": 0.292384,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58014d6ba1570d44f5b2b07a59d648a9",
		  
		  "name": "Benjamin",
		  "createdDate": "2023-01-09 14:06:04",
		  "totalOrganizations": 9,
		  "totalTours": 22,
		  "totalDays": 377,
		  "totalCountries": 25,
		  "totalStates": 45,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 2064,
		  "schedulePercent": 0.726768,
		  "totalGuests": 585,
		  "guestPercent": 0.7551,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Dalhalla",
		  "mostGuestCity": "RÃ¤ttvik",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5806ae974f00096584a5adbc4da2a866",
		  
		  "name": "Jacob",
		  "createdDate": "2021-10-22 17:29:10",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 409,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 987,
		  "schedulePercent": 0.486967,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "580db8390f5d78daa379c896f639eb1c",
		  
		  "name": "Helmi",
		  "createdDate": "2018-12-11 01:10:57",
		  "totalOrganizations": 20,
		  "totalTours": 32,
		  "totalDays": 553,
		  "totalCountries": 4,
		  "totalStates": 177,
		  "totalEvents": 498,
		  "eventPercent": 0.978581,
		  "totalScheduleItems": 1329,
		  "schedulePercent": 0.579442,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Lomakeskus Sieravuori",
		  "mostGuestCity": "Honkilahti",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5812aa4e169428dbfd8fe06ead73d741",
		  
		  "name": "Sean",
		  "createdDate": "2015-01-08 04:14:26",
		  "totalOrganizations": 5,
		  "totalTours": 22,
		  "totalDays": 496,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2546,
		  "schedulePercent": 0.791478,
		  "totalGuests": 251,
		  "guestPercent": 0.625567,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Bayfront Festival Park",
		  "mostGuestCity": "Duluth",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5821df5d0848d4e23ba58043616eb1a0",
		  
		  "name": "Marlon",
		  "createdDate": "2011-08-16 11:34:57",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 690,
		  "totalCountries": 18,
		  "totalStates": 46,
		  "totalEvents": 275,
		  "eventPercent": 0.895059,
		  "totalScheduleItems": 5639,
		  "schedulePercent": 0.970422,
		  "totalGuests": 402,
		  "guestPercent": 0.695376,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Smart Financial Centre at Sugar Land",
		  "mostGuestCity": "Sugar Land",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "582b67f920bcff553da38483abf35bd1",
		  
		  "name": "Jamison",
		  "createdDate": "2022-07-22 20:36:54",
		  "totalOrganizations": 12,
		  "totalTours": 14,
		  "totalDays": 572,
		  "totalCountries": 17,
		  "totalStates": 69,
		  "totalEvents": 232,
		  "eventPercent": 0.850408,
		  "totalScheduleItems": 2926,
		  "schedulePercent": 0.833749,
		  "totalGuests": 927,
		  "guestPercent": 0.835222,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Utah First Credit Union Amphitheatre",
		  "mostGuestCity": "West Valley City",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "584ba25cef11a6aae6a7e3b3ee2869b8",
		  
		  "name": "Vander",
		  "createdDate": "2020-01-22 22:02:38",
		  "totalOrganizations": 10,
		  "totalTours": 19,
		  "totalDays": 930,
		  "totalCountries": 40,
		  "totalStates": 66,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2889,
		  "schedulePercent": 0.831029,
		  "totalGuests": 171,
		  "guestPercent": 0.574683,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Arena Opus",
		  "mostGuestCity": "SÃ£o JosÃ©",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "584c8bf376bdf9dc77d1deeab47ee412",
		  
		  "name": "Joseph",
		  "createdDate": "2013-04-10 13:12:33",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 133,
		  "totalCountries": 16,
		  "totalStates": 19,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 499,
		  "schedulePercent": 0.311763,
		  "totalGuests": 836,
		  "guestPercent": 0.816863,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 106,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "585b63494c0c3f6151d08a489eb3edee",
		  
		  "name": "Chris",
		  "createdDate": "2024-01-18 17:58:05",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 23,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 125,
		  "schedulePercent": 0.114914,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "585cb6e92f56f4e32049dd3f704aa24b",
		  
		  "name": "Jackson",
		  "createdDate": "2019-05-13 15:46:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 205,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1161,
		  "schedulePercent": 0.537965,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Sons of Hermann Hall",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "586dd50de2a02578efa55e6e7e37f294",
		  
		  "name": "Marc",
		  "createdDate": "2013-07-16 20:32:07",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 371,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1374,
		  "schedulePercent": 0.590775,
		  "totalGuests": 311,
		  "guestPercent": 0.654692,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58723dead8669f40bd3ee8b03bc3a2fd",
		  
		  "name": "Brylee",
		  "createdDate": "2022-12-04 04:07:04",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 40,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58795a9ec2f98bbb24ed5228134d8a3c",
		  
		  "name": "Chad",
		  "createdDate": "2018-09-03 03:41:37",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 1111,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1667,
		  "schedulePercent": 0.652652,
		  "totalGuests": 179,
		  "guestPercent": 0.579556,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Wang Theater",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "587ed2a543afbde524f0167e43fbd9a3",
		  
		  "name": "Kyle",
		  "createdDate": "2024-01-13 21:00:12",
		  "totalOrganizations": 12,
		  "totalTours": 17,
		  "totalDays": 2577,
		  "totalCountries": 14,
		  "totalStates": 75,
		  "totalEvents": 521,
		  "eventPercent": 0.980961,
		  "totalScheduleItems": 4135,
		  "schedulePercent": 0.921238,
		  "totalGuests": 882,
		  "guestPercent": 0.825703,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Roadrunner",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5891da87975f6347a8182aaeac574578",
		  
		  "name": "Ben",
		  "createdDate": "2019-04-18 16:47:10",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 94,
		  "totalCountries": 8,
		  "totalStates": 23,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 233,
		  "schedulePercent": 0.179964,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Islington Assembly Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "589ae0825e3e81124c55fc4b0c3f90a3",
		  
		  "name": "Steven",
		  "createdDate": "2015-05-31 02:57:01",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1097,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1393,
		  "schedulePercent": 0.596102,
		  "totalGuests": 198,
		  "guestPercent": 0.593155,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Goldfield Trading Post",
		  "mostGuestCity": "Roseville",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "589cb0693c3987c833753811db472734",
		  
		  "name": "Cyril",
		  "createdDate": "2019-01-09 12:39:01",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 62,
		  "totalCountries": 11,
		  "totalStates": 27,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 922,
		  "schedulePercent": 0.465888,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-01-10 00:00:00",
		  "mostGuestName": "013 Poppodium",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58a42eff2b0d41cf0394f62fb52d37c1",
		  
		  "name": "Charlotte",
		  "createdDate": "2025-08-25 07:58:09",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 35,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 215,
		  "schedulePercent": 0.169198,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58a5c96025fc719d8d2cfb43f8d8f845",
		  
		  "name": "stu",
		  "createdDate": "2011-07-15 11:03:34",
		  "totalOrganizations": 3,
		  "totalTours": 11,
		  "totalDays": 93,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 266,
		  "schedulePercent": 0.197076,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Broadwater Parklands",
		  "mostGuestCity": "Southport",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58a97da842e967e89dafaa5f58b4bae0",
		  
		  "name": "Marcus",
		  "createdDate": "2021-09-01 02:11:10",
		  "totalOrganizations": 11,
		  "totalTours": 26,
		  "totalDays": 683,
		  "totalCountries": 22,
		  "totalStates": 79,
		  "totalEvents": 387,
		  "eventPercent": 0.955349,
		  "totalScheduleItems": 4171,
		  "schedulePercent": 0.923731,
		  "totalGuests": 1354,
		  "guestPercent": 0.893472,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Pearl Concert Theater",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58abc57bf7628f25474a9bf5cc741de9",
		  
		  "name": "Keith",
		  "createdDate": "2018-06-08 09:22:03",
		  "totalOrganizations": 6,
		  "totalTours": 17,
		  "totalDays": 76,
		  "totalCountries": 10,
		  "totalStates": 19,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 296,
		  "schedulePercent": 0.215549,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58ae4ae41e205a8aade179c949b2b8b7",
		  
		  "name": "Seikan",
		  "createdDate": "2017-10-18 16:28:20",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 195,
		  "totalCountries": 27,
		  "totalStates": 50,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 718,
		  "schedulePercent": 0.393246,
		  "totalGuests": 142,
		  "guestPercent": 0.553604,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58b3cb2e04dc16b4d81862d9c0c6ccb9",
		  
		  "name": "Charles",
		  "createdDate": "2013-01-21 03:26:17",
		  "totalOrganizations": 18,
		  "totalTours": 10,
		  "totalDays": 916,
		  "totalCountries": 22,
		  "totalStates": 83,
		  "totalEvents": 324,
		  "eventPercent": 0.929964,
		  "totalScheduleItems": 6366,
		  "schedulePercent": 0.980168,
		  "totalGuests": 1130,
		  "guestPercent": 0.868314,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58bd4f4e3ff25d965fe5ea0b9bb9c51f",
		  
		  "name": "Nicole",
		  "createdDate": "2025-03-24 20:42:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 259,
		  "schedulePercent": 0.194356,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "713 Music Hall",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58c33d6692674c863c43d776a6275ce2",
		  
		  "name": "Rikk",
		  "createdDate": "2017-05-26 17:35:04",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 435,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1826,
		  "schedulePercent": 0.680984,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "Levon Helm Studios",
		  "mostGuestCity": "Woodstock",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58c77721ab259075290a708dfb73e129",
		  
		  "name": "Shireen",
		  "createdDate": "2024-08-29 17:23:07",
		  "totalOrganizations": 5,
		  "totalTours": 15,
		  "totalDays": 293,
		  "totalCountries": 22,
		  "totalStates": 63,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1684,
		  "schedulePercent": 0.655825,
		  "totalGuests": 598,
		  "guestPercent": 0.75748,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58c9082faf8a94ae690ba088aadb74a0",
		  
		  "name": "Eleanor",
		  "createdDate": "2021-08-25 16:03:08",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 1313,
		  "totalCountries": 10,
		  "totalStates": 53,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 2116,
		  "schedulePercent": 0.734814,
		  "totalGuests": 574,
		  "guestPercent": 0.750567,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Fogg Street Lawn Club - Rooftop Series",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58d059680f9556977314ed4baf66c3c4",
		  
		  "name": "Timothy",
		  "createdDate": "2016-07-19 20:44:59",
		  "totalOrganizations": 18,
		  "totalTours": 12,
		  "totalDays": 1311,
		  "totalCountries": 6,
		  "totalStates": 60,
		  "totalEvents": 324,
		  "eventPercent": 0.929964,
		  "totalScheduleItems": 3039,
		  "schedulePercent": 0.845988,
		  "totalGuests": 534,
		  "guestPercent": 0.738441,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Signal",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58d55073b0b4514951e7fcb106a9eefb",
		  
		  "name": "Betty",
		  "createdDate": "2022-05-30 05:10:07",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 258,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 697,
		  "schedulePercent": 0.385766,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58d5e0b31501bffdfade8ae8e94ed4fa",
		  
		  "name": "Ryan",
		  "createdDate": "2017-10-16 20:08:12",
		  "totalOrganizations": 16,
		  "totalTours": 12,
		  "totalDays": 1441,
		  "totalCountries": 13,
		  "totalStates": 52,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 5226,
		  "schedulePercent": 0.960335,
		  "totalGuests": 2493,
		  "guestPercent": 0.967928,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58d60cfc2601dbdab4ad9f66896aae90",
		  
		  "name": "Stefan",
		  "createdDate": "2016-08-17 08:47:32",
		  "totalOrganizations": 20,
		  "totalTours": 2,
		  "totalDays": 329,
		  "totalCountries": 27,
		  "totalStates": 7,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 1050,
		  "schedulePercent": 0.50442,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58dda81f171ee02e8070d7d23e9d9253",
		  
		  "name": "Jack",
		  "createdDate": "2019-06-19 13:29:20",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 492,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 789,
		  "schedulePercent": 0.418631,
		  "totalGuests": 1001,
		  "guestPercent": 0.846102,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58e1a010f3ee38a5582619caf161c7b8",
		  
		  "name": "William",
		  "createdDate": "2015-04-17 00:26:35",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 970,
		  "totalCountries": 20,
		  "totalStates": 68,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 4401,
		  "schedulePercent": 0.93495,
		  "totalGuests": 3063,
		  "guestPercent": 0.983228,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58e3f3f3eaeb420ff4052a4c8e492e95",
		  
		  "name": "MATT",
		  "createdDate": "2024-03-06 23:15:17",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 176,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 976,
		  "schedulePercent": 0.483114,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Explanada del Estadio Azteca",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58e5ec160ef39345a0f23371bab92425",
		  
		  "name": "Tyler",
		  "createdDate": "2020-01-13 17:43:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 48,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1310,
		  "schedulePercent": 0.574116,
		  "totalGuests": 89,
		  "guestPercent": 0.50714,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Humboldt County Fair",
		  "mostGuestCity": "Humboldt",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58e6001207022bda050481c4b9c9bab8",
		  
		  "name": "Derrick",
		  "createdDate": "2014-05-12 21:09:01",
		  "totalOrganizations": 4,
		  "totalTours": 27,
		  "totalDays": 558,
		  "totalCountries": 16,
		  "totalStates": 60,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2975,
		  "schedulePercent": 0.840209,
		  "totalGuests": 1929,
		  "guestPercent": 0.94107,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "OC Fair & Event Center",
		  "mostGuestCity": "Costa Mesa",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58eab47299f4cc4534679bbbc223f8a8",
		  
		  "name": "Aino",
		  "createdDate": "2025-05-17 23:17:09",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 196,
		  "totalCountries": 11,
		  "totalStates": 32,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 589,
		  "schedulePercent": 0.347235,
		  "totalGuests": 389,
		  "guestPercent": 0.68971,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "58f84684f6ef013ac518d732075c2792",
		  
		  "name": "Assistant",
		  "createdDate": "2024-12-17 17:37:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 133,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1416,
		  "schedulePercent": 0.601655,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5901ba7452319c96b5cf73e872fc550c",
		  
		  "name": "Addie",
		  "createdDate": "2023-05-25 11:38:31",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 11,
		  "totalStates": 28,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 608,
		  "schedulePercent": 0.353808,
		  "totalGuests": 349,
		  "guestPercent": 0.674637,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Beacham",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59025bf38ccd497056ef62e4de55b032",
		  
		  "name": "Ryan",
		  "createdDate": "2022-02-02 18:21:28",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 91,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 415,
		  "schedulePercent": 0.276292,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5904d5b9ca95a807146f6047b39e780e",
		  
		  "name": "Jeff",
		  "createdDate": "2018-01-13 16:56:30",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 2379,
		  "schedulePercent": 0.772552,
		  "totalGuests": 1761,
		  "guestPercent": 0.93087,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59067551af837c2720396452c39026c5",
		  
		  "name": "Steve",
		  "createdDate": "2020-09-25 19:35:07",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 195,
		  "totalCountries": 20,
		  "totalStates": 45,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 926,
		  "schedulePercent": 0.467022,
		  "totalGuests": 422,
		  "guestPercent": 0.703536,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Wang Theater",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "590d5bab28640cc466027b7376e29e44",
		  
		  "name": "Jonathan",
		  "createdDate": "2013-12-18 08:41:30",
		  "totalOrganizations": 14,
		  "totalTours": 14,
		  "totalDays": 216,
		  "totalCountries": 17,
		  "totalStates": 53,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2108,
		  "schedulePercent": 0.734134,
		  "totalGuests": 853,
		  "guestPercent": 0.820263,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Zenith Paris - La Villette",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 303,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "591f54c9bb5dbce6f426e7952d07e09d",
		  
		  "name": "Daryl",
		  "createdDate": "2014-04-22 15:07:49",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 6,
		  "totalStates": 23,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "592142dab5fb18d8382db0ee158904e2",
		  
		  "name": "Joerg",
		  "createdDate": "2024-05-08 07:12:42",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 295,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1691,
		  "schedulePercent": 0.656958,
		  "totalGuests": 1106,
		  "guestPercent": 0.865027,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Galopprennbahn KÃ¶ln-Weidenpesch",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5933c9d317e4f215769bde7e87b59e6a",
		  
		  "name": "Andrew",
		  "createdDate": "2015-11-05 04:44:36",
		  "totalOrganizations": 4,
		  "totalTours": 21,
		  "totalDays": 240,
		  "totalCountries": 6,
		  "totalStates": 40,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1907,
		  "schedulePercent": 0.695943,
		  "totalGuests": 1214,
		  "guestPercent": 0.87738,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "593d52a1d6c1d54420e08512acf56f46",
		  
		  "name": "Johanna",
		  "createdDate": "2016-10-21 10:13:07",
		  "totalOrganizations": 11,
		  "totalTours": 2,
		  "totalDays": 168,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 899,
		  "schedulePercent": 0.457842,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5944621c0e0cb02c9904b55732901e08",
		  
		  "name": "Klara",
		  "createdDate": "2022-11-21 14:09:58",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 276,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1478,
		  "schedulePercent": 0.612307,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59460f6e38d06a16cca8ed31810c0280",
		  
		  "name": "Blake",
		  "createdDate": "2021-10-29 23:33:12",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 1279,
		  "totalCountries": 6,
		  "totalStates": 48,
		  "totalEvents": 345,
		  "eventPercent": 0.939937,
		  "totalScheduleItems": 4303,
		  "schedulePercent": 0.93087,
		  "totalGuests": 2834,
		  "guestPercent": 0.978694,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "594ae3f7d9f3b3a0873769df5bfa924b",
		  
		  "name": "Trinity",
		  "createdDate": "2018-07-03 18:25:13",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 544,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1335,
		  "schedulePercent": 0.581936,
		  "totalGuests": 1596,
		  "guestPercent": 0.919311,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Ravinia",
		  "mostGuestCity": "Highland Park",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "594c59b8d25b0d88bcddeb60857df60c",
		  
		  "name": "Paul",
		  "createdDate": "2012-05-10 01:20:35",
		  "totalOrganizations": 11,
		  "totalTours": 16,
		  "totalDays": 403,
		  "totalCountries": 17,
		  "totalStates": 58,
		  "totalEvents": 283,
		  "eventPercent": 0.900499,
		  "totalScheduleItems": 2837,
		  "schedulePercent": 0.826496,
		  "totalGuests": 1384,
		  "guestPercent": 0.898232,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5958adb6842b61389a986cecd6b179ec",
		  
		  "name": "David",
		  "createdDate": "2025-10-28 13:41:03",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 24,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 248,
		  "schedulePercent": 0.188917,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5958ca090751f873743249882a2d3bc9",
		  
		  "name": "Joseph",
		  "createdDate": "2019-10-30 20:42:14",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 799,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 171,
		  "guestPercent": 0.574683,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Arvest Bank Theatre @ The Midland",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "595f8de0490bd5635c65388181432f08",
		  
		  "name": "Greg",
		  "createdDate": "2022-03-14 15:00:24",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 153,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 772,
		  "schedulePercent": 0.413191,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5961b38b3c711225eac90ae795427a8f",
		  
		  "name": "Christoph",
		  "createdDate": "2025-02-06 20:57:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 289,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 415,
		  "guestPercent": 0.699456,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Elbphilharmonie",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5965f683e1f345489cf844546a4977d3",
		  
		  "name": "Evan ",
		  "createdDate": "2014-09-17 16:48:15",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 10,
		  "totalStates": 43,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1701,
		  "schedulePercent": 0.658772,
		  "totalGuests": 1312,
		  "guestPercent": 0.887919,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "596d4bfae210a48446c526790a207741",
		  
		  "name": "Chase",
		  "createdDate": "2016-11-04 03:02:51",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 71,
		  "totalCountries": 15,
		  "totalStates": 30,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 625,
		  "schedulePercent": 0.359134,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5976098abbd623496136b096d4113c50",
		  
		  "name": "Sarah Jane",
		  "createdDate": "2018-10-19 23:06:53",
		  "totalOrganizations": 13,
		  "totalTours": 18,
		  "totalDays": 1169,
		  "totalCountries": 41,
		  "totalStates": 77,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 3430,
		  "schedulePercent": 0.87772,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59781ae72d09c5cecb9e592e9bb74af4",
		  
		  "name": "Slam ",
		  "createdDate": "2022-09-13 18:35:56",
		  "totalOrganizations": 29,
		  "totalTours": 20,
		  "totalDays": 547,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 773,
		  "schedulePercent": 0.413758,
		  "totalGuests": 34,
		  "guestPercent": 0.426677,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Le MinistÃ¨re",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5987fbdf4b6df3653489b3022e108980",
		  
		  "name": "Jacob",
		  "createdDate": "2025-08-20 15:25:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 85,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 191,
		  "schedulePercent": 0.153672,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59977268ac7fa0bfd930646af1a1b4c6",
		  
		  "name": "Jarett",
		  "createdDate": "2014-01-21 22:17:48",
		  "totalOrganizations": 10,
		  "totalTours": 23,
		  "totalDays": 316,
		  "totalCountries": 25,
		  "totalStates": 41,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2567,
		  "schedulePercent": 0.794651,
		  "totalGuests": 2086,
		  "guestPercent": 0.953309,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Dolby Live",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59a23ae1a34e35858bc3dc8eb9033c58",
		  
		  "name": "Erin",
		  "createdDate": "2023-08-21 18:13:33",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 111,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 422,
		  "schedulePercent": 0.278898,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Cannery Ballroom",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59a5339e8797bf7104ef416ab1481155",
		  
		  "name": "Janet",
		  "createdDate": "2009-09-09 18:03:48",
		  "totalOrganizations": 47,
		  "totalTours": 16,
		  "totalDays": 741,
		  "totalCountries": 15,
		  "totalStates": 50,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 3202,
		  "schedulePercent": 0.860267,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59a782e62219771c3b82a081ef5e2c1c",
		  
		  "name": "Bill",
		  "createdDate": "2016-06-11 00:13:19",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 334,
		  "totalCountries": 10,
		  "totalStates": 21,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 440,
		  "schedulePercent": 0.286491,
		  "totalGuests": 126,
		  "guestPercent": 0.541364,
		  "mostGuestDate": "2025-02-04 00:00:00",
		  "mostGuestName": "Festsaal Kreuzberg",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59be6f39262faca58c07e939f1277e93",
		  
		  "name": "J.R. ",
		  "createdDate": "2016-08-13 21:57:05",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 780,
		  "totalCountries": 6,
		  "totalStates": 50,
		  "totalEvents": 300,
		  "eventPercent": 0.913078,
		  "totalScheduleItems": 2868,
		  "schedulePercent": 0.829216,
		  "totalGuests": 867,
		  "guestPercent": 0.822529,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59c9a8198c9abc82dd436a8b6ce3c3d0",
		  
		  "name": "Brennan",
		  "createdDate": "2016-02-28 19:46:08",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 448,
		  "totalCountries": 11,
		  "totalStates": 55,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1744,
		  "schedulePercent": 0.667044,
		  "totalGuests": 411,
		  "guestPercent": 0.697869,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Tipitina's Uptown",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59ca8a5734e732ab245db141faed6e45",
		  
		  "name": "Leah",
		  "createdDate": "2023-08-18 00:49:22",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 60,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 267,
		  "schedulePercent": 0.197756,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "The Rebel Lounge",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59d1b1a5f468bdab49a1a1f9f1c22242",
		  
		  "name": "Landon",
		  "createdDate": "2015-05-01 01:30:55",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 739,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 1928,
		  "schedulePercent": 0.699796,
		  "totalGuests": 848,
		  "guestPercent": 0.81947,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59dd555950014c65f194722140bb9f7b",
		  
		  "name": "Dom",
		  "createdDate": "2021-06-10 11:30:28",
		  "totalOrganizations": 30,
		  "totalTours": 30,
		  "totalDays": 505,
		  "totalCountries": 29,
		  "totalStates": 68,
		  "totalEvents": 302,
		  "eventPercent": 0.914211,
		  "totalScheduleItems": 2367,
		  "schedulePercent": 0.771079,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Electric Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59e45ad4ea4c4189f41350f7efb66cde",
		  
		  "name": "Greg",
		  "createdDate": "2016-09-30 19:49:28",
		  "totalOrganizations": 4,
		  "totalTours": 22,
		  "totalDays": 184,
		  "totalCountries": 12,
		  "totalStates": 44,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2013,
		  "schedulePercent": 0.715662,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59e5b65a2eb3048f20ee430c16cf46ed",
		  
		  "name": "Alexandros",
		  "createdDate": "2011-04-08 06:44:57",
		  "totalOrganizations": 12,
		  "totalTours": 20,
		  "totalDays": 890,
		  "totalCountries": 25,
		  "totalStates": 87,
		  "totalEvents": 395,
		  "eventPercent": 0.957729,
		  "totalScheduleItems": 6538,
		  "schedulePercent": 0.982321,
		  "totalGuests": 3929,
		  "guestPercent": 0.99286,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59f15df7551f9b4250a50c1d9b393917",
		  
		  "name": "Shane",
		  "createdDate": "2010-10-08 21:31:35",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 366,
		  "totalCountries": 13,
		  "totalStates": 45,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1267,
		  "schedulePercent": 0.56505,
		  "totalGuests": 393,
		  "guestPercent": 0.691296,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Thomas Wolfe Auditorium",
		  "mostGuestCity": "Asheville",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59f5df3b192f2e6a7fc05b6eb46ad6ae",
		  
		  "name": "Najwa",
		  "createdDate": "2019-06-03 18:21:59",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 59,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 923,
		  "schedulePercent": 0.466228,
		  "totalGuests": 178,
		  "guestPercent": 0.579102,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Kauffman Center for the Performing Arts",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59f9e6cae65849baeb7bc2661a0a4505",
		  
		  "name": "Heather",
		  "createdDate": "2019-01-20 16:45:56",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 750,
		  "totalCountries": 4,
		  "totalStates": 56,
		  "totalEvents": 337,
		  "eventPercent": 0.93597,
		  "totalScheduleItems": 4739,
		  "schedulePercent": 0.945943,
		  "totalGuests": 519,
		  "guestPercent": 0.735494,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "59fc9542f8a53ef70ba6fd6aeb89b61d",
		  
		  "name": "Zach",
		  "createdDate": "2022-09-19 01:16:32",
		  "totalOrganizations": 10,
		  "totalTours": 14,
		  "totalDays": 1264,
		  "totalCountries": 20,
		  "totalStates": 73,
		  "totalEvents": 299,
		  "eventPercent": 0.912398,
		  "totalScheduleItems": 3839,
		  "schedulePercent": 0.905145,
		  "totalGuests": 1212,
		  "guestPercent": 0.87704,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a01bef27470ad62d1b04e963164c430",
		  
		  "name": "Cecilia",
		  "createdDate": "2022-02-17 14:06:21",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 232,
		  "totalCountries": 14,
		  "totalStates": 39,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 485,
		  "schedulePercent": 0.30383,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a05b8dca466171a74396c2ddcc452e7",
		  
		  "name": "Ernie",
		  "createdDate": "2021-08-03 16:55:19",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 410,
		  "totalCountries": 20,
		  "totalStates": 73,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 3216,
		  "schedulePercent": 0.861514,
		  "totalGuests": 745,
		  "guestPercent": 0.795218,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Empower FCU Amphitheater at Lakeview",
		  "mostGuestCity": "Syracuse",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a09f1746bb2a398a2f956b254e4eb55",
		  
		  "name": "Anton",
		  "createdDate": "2016-06-02 10:42:02",
		  "totalOrganizations": 13,
		  "totalTours": 17,
		  "totalDays": 520,
		  "totalCountries": 42,
		  "totalStates": 91,
		  "totalEvents": 240,
		  "eventPercent": 0.861854,
		  "totalScheduleItems": 3750,
		  "schedulePercent": 0.898685,
		  "totalGuests": 991,
		  "guestPercent": 0.844288,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "013 Poppodium",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a1071c1e078d70fd4fdf1d00d2f72fb",
		  
		  "name": "Tim",
		  "createdDate": "2012-07-31 05:00:46",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 353,
		  "totalCountries": 13,
		  "totalStates": 58,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 2024,
		  "schedulePercent": 0.718268,
		  "totalGuests": 839,
		  "guestPercent": 0.817656,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a13942e54cb2c2e3f26b7531bc59e9d",
		  
		  "name": "Gabrielle ",
		  "createdDate": "2018-10-15 02:20:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 129,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1507,
		  "schedulePercent": 0.618994,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a1a13c01a0e6494855c20ec6dad4d62",
		  
		  "name": "Jason ",
		  "createdDate": "2015-05-02 04:09:36",
		  "totalOrganizations": 11,
		  "totalTours": 20,
		  "totalDays": 1131,
		  "totalCountries": 8,
		  "totalStates": 42,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2967,
		  "schedulePercent": 0.839075,
		  "totalGuests": 466,
		  "guestPercent": 0.718948,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a1abcbad7b2ddb2ced2f4b428b7b083",
		  
		  "name": "SEAN",
		  "createdDate": "2011-06-17 16:31:45",
		  "totalOrganizations": 10,
		  "totalTours": 14,
		  "totalDays": 135,
		  "totalCountries": 19,
		  "totalStates": 35,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 739,
		  "schedulePercent": 0.401179,
		  "totalGuests": 385,
		  "guestPercent": 0.68801,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a2138b7fbb1e6b97edcd7ce39c30bd6",
		  
		  "name": "Thomas",
		  "createdDate": "2022-02-12 20:51:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 20,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Columbiahalle",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a2848d56b6f621b0c39096dc6b24a8c",
		  
		  "name": "Scott",
		  "createdDate": "2014-09-07 16:03:21",
		  "totalOrganizations": 19,
		  "totalTours": 22,
		  "totalDays": 363,
		  "totalCountries": 18,
		  "totalStates": 36,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 2150,
		  "schedulePercent": 0.739914,
		  "totalGuests": 1134,
		  "guestPercent": 0.86956,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 150,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a2f15c997c3aaec6d85b32ef8a73d03",
		  
		  "name": "Jenna",
		  "createdDate": "2024-10-30 00:57:40",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 524,
		  "totalCountries": 22,
		  "totalStates": 64,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 4856,
		  "schedulePercent": 0.949456,
		  "totalGuests": 2864,
		  "guestPercent": 0.979374,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Cardiff Utilita Arena",
		  "mostGuestCity": "Cardiff",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a3c8274ee235d4711ce3aba541f68a2",
		  
		  "name": "Monique ",
		  "createdDate": "2025-05-12 17:30:43",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 147,
		  "totalCountries": 9,
		  "totalStates": 22,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 349,
		  "schedulePercent": 0.24252,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Sunshine Theater",
		  "mostGuestCity": "Albuquerque",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a3fcfbe0a3fe06508870e51cbefec1d",
		  
		  "name": "Tristan",
		  "createdDate": "2016-10-05 10:19:33",
		  "totalOrganizations": 14,
		  "totalTours": 31,
		  "totalDays": 704,
		  "totalCountries": 41,
		  "totalStates": 76,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2700,
		  "schedulePercent": 0.808477,
		  "totalGuests": 1804,
		  "guestPercent": 0.933477,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Royal Highland Centre",
		  "mostGuestCity": "Ingliston",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a4278f566abf1e77820ba78cff58e93",
		  
		  "name": "Alice",
		  "createdDate": "2015-08-27 04:10:45",
		  "totalOrganizations": 26,
		  "totalTours": 12,
		  "totalDays": 549,
		  "totalCountries": 11,
		  "totalStates": 19,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1541,
		  "schedulePercent": 0.625567,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Crystal Palace Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a4836019be4fe3034baa557db7f1b70",
		  
		  "name": "Samantha",
		  "createdDate": "2022-04-03 16:29:13",
		  "totalOrganizations": 13,
		  "totalTours": 21,
		  "totalDays": 1516,
		  "totalCountries": 30,
		  "totalStates": 60,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 2926,
		  "schedulePercent": 0.833749,
		  "totalGuests": 95,
		  "guestPercent": 0.513826,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a6936c1ec070ab0241232fcbd25c02e",
		  
		  "name": "Yvette",
		  "createdDate": "2013-03-09 14:46:01",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 374,
		  "totalCountries": 26,
		  "totalStates": 73,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 3663,
		  "schedulePercent": 0.894039,
		  "totalGuests": 1879,
		  "guestPercent": 0.938463,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a7ccbcdad9d7dfde7a70422482874e9",
		  
		  "name": "Nick",
		  "createdDate": "2018-01-19 22:27:46",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 85,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 831,
		  "schedulePercent": 0.43495,
		  "totalGuests": 397,
		  "guestPercent": 0.69277,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Abba's House",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a81a3eac73fb0f7a0ab9af5671acf6c",
		  
		  "name": "Helen",
		  "createdDate": "2024-09-20 19:10:19",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 455,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1860,
		  "schedulePercent": 0.686877,
		  "totalGuests": 883,
		  "guestPercent": 0.826269,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a866ba86d2c8599c273991412ea8489",
		  
		  "name": "Eva",
		  "createdDate": "2023-05-05 20:04:59",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 404,
		  "schedulePercent": 0.271532,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a89526d79e08eef344572e4e0d704da",
		  
		  "name": "Mario",
		  "createdDate": "2018-12-19 23:34:12",
		  "totalOrganizations": 4,
		  "totalTours": 17,
		  "totalDays": 514,
		  "totalCountries": 24,
		  "totalStates": 44,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1499,
		  "schedulePercent": 0.618087,
		  "totalGuests": 496,
		  "guestPercent": 0.729148,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Commodore Ballroom",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a8a8f2d73a85a90070103c3c7e64b9e",
		  
		  "name": "Simon",
		  "createdDate": "2016-02-08 21:41:43",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a8cf1c58c095b954913851a7f67b795",
		  
		  "name": "Eran",
		  "createdDate": "2021-09-17 20:16:37",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 986,
		  "totalCountries": 6,
		  "totalStates": 45,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2451,
		  "schedulePercent": 0.781165,
		  "totalGuests": 1097,
		  "guestPercent": 0.863554,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a935656ca27391344a3907e027db63a",
		  
		  "name": "Walter",
		  "createdDate": "2023-11-08 01:46:15",
		  "totalOrganizations": 1,
		  "totalTours": 21,
		  "totalDays": 504,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 2736,
		  "schedulePercent": 0.813803,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5a96c5ef7ff775b5ddd5960d70b3c1c5",
		  
		  "name": "Nemanja",
		  "createdDate": "2011-07-27 19:07:44",
		  "totalOrganizations": 10,
		  "totalTours": 1,
		  "totalDays": 202,
		  "totalCountries": 21,
		  "totalStates": 32,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1330,
		  "schedulePercent": 0.579896,
		  "totalGuests": 1969,
		  "guestPercent": 0.944923,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Red Bull Arena",
		  "mostGuestCity": "Harrison",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5aaa9cc30595c0df10cf050f482cdfd5",
		  
		  "name": "Tom",
		  "createdDate": "2024-04-11 14:16:48",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 124,
		  "totalCountries": 19,
		  "totalStates": 29,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 807,
		  "schedulePercent": 0.425657,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Strange Brew",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ab5994283125b615e19112db98e4bc9",
		  
		  "name": "Mark",
		  "createdDate": "2016-03-11 00:08:22",
		  "totalOrganizations": 21,
		  "totalTours": 4,
		  "totalDays": 52,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 122,
		  "schedulePercent": 0.112534,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ac1f2c1c938e0e2d67e137568d2f116",
		  
		  "name": "Sylvie",
		  "createdDate": "2021-12-14 16:54:14",
		  "totalOrganizations": 34,
		  "totalTours": 14,
		  "totalDays": 433,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 403,
		  "eventPercent": 0.959429,
		  "totalScheduleItems": 2426,
		  "schedulePercent": 0.778105,
		  "totalGuests": 3577,
		  "guestPercent": 0.99048,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 391,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ac23b08c2a71711ddb54c53703559da",
		  
		  "name": "Tour",
		  "createdDate": "2024-02-06 05:43:03",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 604,
		  "schedulePercent": 0.352335,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ac4595154843b508fff7cafc160d7df",
		  
		  "name": "Michelle",
		  "createdDate": "2011-07-07 22:28:59",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 16,
		  "totalStates": 14,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 619,
		  "schedulePercent": 0.356528,
		  "totalGuests": 280,
		  "guestPercent": 0.639393,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Montauk Lighthouse",
		  "mostGuestCity": "Montauk",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ac6994d7801d0ef72f9485a93cc09c5",
		  
		  "name": "Alfredo",
		  "createdDate": "2015-07-18 04:21:17",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 1507,
		  "totalCountries": 19,
		  "totalStates": 52,
		  "totalEvents": 281,
		  "eventPercent": 0.898912,
		  "totalScheduleItems": 3911,
		  "schedulePercent": 0.909338,
		  "totalGuests": 2006,
		  "guestPercent": 0.947869,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ad0bd45de06dcf588fffa1c6f35e33c",
		  
		  "name": "Lewis",
		  "createdDate": "2025-04-17 13:32:42",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 30,
		  "totalCountries": 7,
		  "totalStates": 6,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 151,
		  "schedulePercent": 0.130326,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ae919c0265115ac0afef16eab915464",
		  
		  "name": "Thomas",
		  "createdDate": "2023-06-30 09:54:50",
		  "totalOrganizations": 124,
		  "totalTours": 52,
		  "totalDays": 274,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 270,
		  "eventPercent": 0.890299,
		  "totalScheduleItems": 1297,
		  "schedulePercent": 0.57083,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-01-05 00:00:00",
		  "mostGuestName": "On The Rocks",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5af7663d7f3b7c745d43018001743ee1",
		  
		  "name": "Zack",
		  "createdDate": "2019-03-02 01:16:17",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 515,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 1086,
		  "schedulePercent": 0.516319,
		  "totalGuests": 9103,
		  "guestPercent": 0.99898,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 523,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5aff0b8e13ccc53804808d5a8beba1f7",
		  
		  "name": "Aaron",
		  "createdDate": "2013-07-09 06:35:28",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 261,
		  "totalCountries": 26,
		  "totalStates": 50,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 1390,
		  "schedulePercent": 0.594855,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b0ed1be97684b00d452873938b939b5",
		  
		  "name": "Christina",
		  "createdDate": "2023-09-29 04:04:26",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 373,
		  "totalCountries": 4,
		  "totalStates": 31,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1833,
		  "schedulePercent": 0.68223,
		  "totalGuests": 192,
		  "guestPercent": 0.587262,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Chicago Theatre",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b155cdfcfb4907122594ed9b244dc7b",
		  
		  "name": "Anna",
		  "createdDate": "2022-10-13 16:21:54",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 191,
		  "totalCountries": 11,
		  "totalStates": 21,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 300,
		  "schedulePercent": 0.217475,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Tolhuistuin",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b1eddaf3c961644dfff463ddbb05894",
		  
		  "name": "Joel",
		  "createdDate": "2017-04-28 05:31:28",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 772,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1227,
		  "schedulePercent": 0.55383,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b208a5bbd2a8d7a07257f79e57d5606",
		  
		  "name": "Cole",
		  "a_nickname": "\"Coleslaw\"",
		  "createdDate": "2020-03-09 17:01:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 252,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 700,
		  "schedulePercent": 0.386786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b21dc1de0f3ee1212f539c0578c63d6",
		  
		  "name": "Ajailon",
		  "createdDate": "2024-09-04 17:41:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 376,
		  "totalCountries": 11,
		  "totalStates": 45,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1561,
		  "schedulePercent": 0.63282,
		  "totalGuests": 418,
		  "guestPercent": 0.701043,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Kia Center",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b27fc465f0b5f637f2efc3f44d9cd8c",
		  
		  "name": "Manny",
		  "createdDate": "2022-12-02 17:37:00",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 253,
		  "totalCountries": 16,
		  "totalStates": 60,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1745,
		  "schedulePercent": 0.667271,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b31377fa497d303bac128b31c1abe27",
		  
		  "name": "Stacy",
		  "createdDate": "2022-12-18 00:30:34",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 447,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 105,
		  "schedulePercent": 0.101315,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b395c60e34b4d8cc9e32078304192a7",
		  
		  "name": "GP",
		  "createdDate": "2021-09-23 22:25:14",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 733,
		  "totalCountries": 7,
		  "totalStates": 25,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 102,
		  "schedulePercent": 0.0980281,
		  "totalGuests": 163,
		  "guestPercent": 0.568223,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Baltimore City Hall",
		  "mostGuestCity": "Baltimore",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b4094f55af314a2fc6ce5af6e82b278",
		  
		  "name": "Susan",
		  "createdDate": "2019-10-04 03:47:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 297,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 547,
		  "schedulePercent": 0.332956,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "3TEN Austin City Limits Live",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b5a80ab77db7e9a34125b775dce37b2",
		  
		  "name": "Zebb",
		  "createdDate": "2024-06-24 21:59:24",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 765,
		  "totalCountries": 3,
		  "totalStates": 52,
		  "totalEvents": 310,
		  "eventPercent": 0.919198,
		  "totalScheduleItems": 3102,
		  "schedulePercent": 0.851541,
		  "totalGuests": 1514,
		  "guestPercent": 0.911378,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Tarlelton Event Center",
		  "mostGuestCity": "Stephenville",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b750e8cc2530e06f575abf4b2502a58",
		  
		  "name": "Keith ",
		  "createdDate": "2013-03-05 07:31:25",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 156,
		  "totalCountries": 11,
		  "totalStates": 30,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 620,
		  "schedulePercent": 0.357208,
		  "totalGuests": 486,
		  "guestPercent": 0.726428,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b796a6c0c43781def86bd2d04626a22",
		  
		  "name": "Tim",
		  "createdDate": "2011-09-16 19:21:32",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 304,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 435,
		  "schedulePercent": 0.284111,
		  "totalGuests": 201,
		  "guestPercent": 0.595422,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Fred Kavli Theater",
		  "mostGuestCity": "Thousand Oaks",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b7af8dbcccab4a226cd0744725e7741",
		  
		  "name": "Kathleen",
		  "createdDate": "2016-03-11 00:12:23",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 571,
		  "totalCountries": 5,
		  "totalStates": 21,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 2273,
		  "schedulePercent": 0.7585,
		  "totalGuests": 523,
		  "guestPercent": 0.736967,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b7ba67b4264cfb7de5188ab13b05e9e",
		  
		  "name": "Kyle",
		  "createdDate": "2022-03-01 00:02:50",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 67,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 476,
		  "schedulePercent": 0.300884,
		  "totalGuests": 548,
		  "guestPercent": 0.74354,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The Fillmore Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b80824bb174efbf121846f5975582de",
		  
		  "name": "Carsten",
		  "createdDate": "2022-05-21 10:55:10",
		  "totalOrganizations": 58,
		  "totalTours": 37,
		  "totalDays": 1026,
		  "totalCountries": 13,
		  "totalStates": 23,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 1365,
		  "schedulePercent": 0.588509,
		  "totalGuests": 106,
		  "guestPercent": 0.525385,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "FZW",
		  "mostGuestCity": "Dortmund",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b84ad2752541051d8edb873850d465c",
		  
		  "name": "Diego",
		  "createdDate": "2017-02-02 23:34:01",
		  "totalOrganizations": 10,
		  "totalTours": 1,
		  "totalDays": 112,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b87cd1d674aca7ebc1a67be4d8bf961",
		  
		  "name": "Linn",
		  "createdDate": "2025-07-30 09:03:44",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 92,
		  "totalCountries": 10,
		  "totalStates": 14,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-11-14 00:00:00",
		  "mostGuestName": "Gretchen",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b886fbd8e4dac1201cd380179936c27",
		  
		  "name": "Rikk",
		  "createdDate": "2025-01-25 15:19:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 89,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1120,
		  "schedulePercent": 0.524932,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b8dbceab7d05c7b1d8ba9fd7d1d7123",
		  
		  "name": "Kester ",
		  "createdDate": "2011-06-03 07:12:17",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 184,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 642,
		  "schedulePercent": 0.364914,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Freo Social",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5b8e804458a67ea726b1b052f5bc3411",
		  
		  "name": "Dilara",
		  "createdDate": "2024-05-31 11:39:55",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 375,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 429,
		  "schedulePercent": 0.281845,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ba2cbe875540bc6e41645360b8df1a9",
		  
		  "name": "Willy",
		  "createdDate": "2018-01-31 13:31:18",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 643,
		  "totalCountries": 6,
		  "totalStates": 53,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 2722,
		  "schedulePercent": 0.81233,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bafe32b75bb0a66e06c9bb6d9f637a5",
		  
		  "name": "Solana",
		  "createdDate": "2010-05-26 22:10:50",
		  "totalOrganizations": 23,
		  "totalTours": 6,
		  "totalDays": 134,
		  "totalCountries": 13,
		  "totalStates": 26,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 594,
		  "schedulePercent": 0.349275,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Outlands Music Festival",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bc32f3125a96d59ccfce89ec18b5af4",
		  
		  "name": "Sam",
		  "createdDate": "2025-09-10 18:57:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 73,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 97,
		  "schedulePercent": 0.0947416,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bc41c843ff8fc995e0e29bcf6b74c9e",
		  
		  "name": "Andy",
		  "createdDate": "2024-01-16 19:12:08",
		  "totalOrganizations": 5,
		  "totalTours": 16,
		  "totalDays": 847,
		  "totalCountries": 6,
		  "totalStates": 48,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 2175,
		  "schedulePercent": 0.744107,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "The Mishawaka",
		  "mostGuestCity": "Bellvue",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bc7fb7c719e3673ada49819e1872e94",
		  
		  "name": "Sylvia",
		  "createdDate": "2019-05-06 01:51:31",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 471,
		  "totalCountries": 30,
		  "totalStates": 15,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 2144,
		  "schedulePercent": 0.738781,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bd30d6f53626ec20413864c71e73353",
		  
		  "name": "Charles",
		  "createdDate": "2011-04-07 23:29:49",
		  "totalOrganizations": 24,
		  "totalTours": 7,
		  "totalDays": 1046,
		  "totalCountries": 17,
		  "totalStates": 35,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1815,
		  "schedulePercent": 0.678604,
		  "totalGuests": 328,
		  "guestPercent": 0.665231,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bd91654d75116afcfed476a2c134ed5",
		  
		  "name": "Anna",
		  "createdDate": "2021-08-03 15:12:46",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 648,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 924,
		  "schedulePercent": 0.466455,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Mahaiwe PAC",
		  "mostGuestCity": "Great Barrington",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bd927d7a23aceff9e17580b400462a6",
		  
		  "name": "Tim",
		  "createdDate": "2021-07-16 12:40:56",
		  "totalOrganizations": 10,
		  "totalTours": 26,
		  "totalDays": 391,
		  "totalCountries": 18,
		  "totalStates": 34,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1262,
		  "schedulePercent": 0.56335,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bf1746f66562bd9ca4313e115355693",
		  
		  "name": "Ian",
		  "createdDate": "2014-11-10 20:35:42",
		  "totalOrganizations": 12,
		  "totalTours": 15,
		  "totalDays": 859,
		  "totalCountries": 9,
		  "totalStates": 57,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 2492,
		  "schedulePercent": 0.786151,
		  "totalGuests": 1146,
		  "guestPercent": 0.871034,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Canada Life Place",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bf1cbd9a9d734e57cfe3841c83f8dab",
		  
		  "name": "Guy",
		  "createdDate": "2019-05-08 07:32:08",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 141,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 231,
		  "schedulePercent": 0.178377,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Hotel Brunswick",
		  "mostGuestCity": "Brunswick Heads",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bf384fecb5ca357d034716bc5e5b9ef",
		  
		  "name": "Adam",
		  "createdDate": "2023-08-28 17:22:41",
		  "totalOrganizations": 13,
		  "totalTours": 42,
		  "totalDays": 1703,
		  "totalCountries": 27,
		  "totalStates": 78,
		  "totalEvents": 499,
		  "eventPercent": 0.978694,
		  "totalScheduleItems": 4738,
		  "schedulePercent": 0.94583,
		  "totalGuests": 1096,
		  "guestPercent": 0.863327,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Million Dollar Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5bf83df24b1cfe9814ef5d4d92f98d9b",
		  
		  "name": "Philip",
		  "createdDate": "2017-12-27 20:46:15",
		  "totalOrganizations": 13,
		  "totalTours": 11,
		  "totalDays": 1634,
		  "totalCountries": 10,
		  "totalStates": 59,
		  "totalEvents": 275,
		  "eventPercent": 0.895059,
		  "totalScheduleItems": 4831,
		  "schedulePercent": 0.948323,
		  "totalGuests": 1855,
		  "guestPercent": 0.936763,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c071a3d0c5512189da88c9601fa0890",
		  
		  "name": "Lennart",
		  "createdDate": "2024-01-10 12:03:09",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 22,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 228,
		  "schedulePercent": 0.176451,
		  "totalGuests": 221,
		  "guestPercent": 0.607774,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "O2 Guildhall",
		  "mostGuestCity": "Southampton",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c0adfda30576339cca046b9427c229a",
		  
		  "name": "Perttu",
		  "createdDate": "2022-06-17 13:03:33",
		  "totalOrganizations": 12,
		  "totalTours": 15,
		  "totalDays": 379,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 354,
		  "eventPercent": 0.943903,
		  "totalScheduleItems": 2095,
		  "schedulePercent": 0.732094,
		  "totalGuests": 220,
		  "guestPercent": 0.607434,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Nordis Live",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c193366565cd399bf0ed64fedbc16cd",
		  
		  "name": "Luc",
		  "createdDate": "2019-08-18 17:00:39",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 314,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 287,
		  "eventPercent": 0.903672,
		  "totalScheduleItems": 2969,
		  "schedulePercent": 0.839415,
		  "totalGuests": 704,
		  "guestPercent": 0.786605,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Shanghai Culture Square Theatre",
		  "mostGuestCity": "Huang Pu Qu",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c19ce5b798933485e9429e3f311474e",
		  
		  "name": "Jeff",
		  "createdDate": "2022-04-13 17:03:03",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c1f9c67764bcdf9cec90ffefc4314ee",
		  
		  "name": "James",
		  "createdDate": "2021-09-25 14:01:08",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 534,
		  "totalCountries": 23,
		  "totalStates": 64,
		  "totalEvents": 246,
		  "eventPercent": 0.866954,
		  "totalScheduleItems": 2953,
		  "schedulePercent": 0.837149,
		  "totalGuests": 391,
		  "guestPercent": 0.690277,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c21e04f74172ea67bda6ea6ee4fdaa4",
		  
		  "name": "Mark",
		  "createdDate": "2019-05-28 09:04:18",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 105,
		  "totalCountries": 14,
		  "totalStates": 21,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 637,
		  "schedulePercent": 0.363327,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "BeachLife Festival",
		  "mostGuestCity": "Redondo Beach",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c2296cd628cc13a98b15b5ea3bb526b",
		  
		  "name": "Goldie",
		  "createdDate": "2024-09-03 18:57:56",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 159,
		  "totalCountries": 11,
		  "totalStates": 29,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 732,
		  "schedulePercent": 0.399139,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Horseshoe Tavern",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c37422451c4af86f676178582ecb9f6",
		  
		  "name": "Warren",
		  "createdDate": "2023-02-12 22:50:17",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 2038,
		  "totalCountries": 35,
		  "totalStates": 75,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 3522,
		  "schedulePercent": 0.88316,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Industry City",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c37d3c02f923443a97024c3c0d0e5b8",
		  
		  "name": "Che",
		  "createdDate": "2016-05-12 15:23:00",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 147,
		  "totalCountries": 15,
		  "totalStates": 45,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1179,
		  "schedulePercent": 0.541931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c3fbce60c130976ba4670fbe3584563",
		  
		  "name": "Joel",
		  "createdDate": "2024-08-09 12:05:41",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 155,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 294,
		  "schedulePercent": 0.214415,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c44f5d67e6c492453abed6b99ee039d",
		  
		  "name": "Tyson",
		  "createdDate": "2024-04-13 00:47:43",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 52,
		  "totalCountries": 14,
		  "totalStates": 12,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Prince Bandroom",
		  "mostGuestCity": "St Kilda",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c51fcd7975b46551bf1bddd1fc24cb1",
		  
		  "name": "William ",
		  "createdDate": "2014-09-16 13:37:48",
		  "totalOrganizations": 21,
		  "totalTours": 28,
		  "totalDays": 1967,
		  "totalCountries": 38,
		  "totalStates": 91,
		  "totalEvents": 618,
		  "eventPercent": 0.988554,
		  "totalScheduleItems": 9241,
		  "schedulePercent": 0.994674,
		  "totalGuests": 1376,
		  "guestPercent": 0.896872,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c5364528b53a43a452157c4c7f80bb8",
		  
		  "name": "Stu",
		  "createdDate": "2017-04-08 01:00:54",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 147,
		  "totalCountries": 14,
		  "totalStates": 23,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 916,
		  "schedulePercent": 0.463735,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-03-11 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c62e5cdf813f0c079917fb289c68170",
		  
		  "name": "Eivind",
		  "createdDate": "2017-06-20 11:29:10",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 557,
		  "totalCountries": 9,
		  "totalStates": 17,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1374,
		  "schedulePercent": 0.590775,
		  "totalGuests": 805,
		  "guestPercent": 0.80893,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lyse Arena",
		  "mostGuestCity": "Stavanger",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c69d89d6ca182b5f9ab2496f254e2e4",
		  
		  "name": "Josh",
		  "createdDate": "2019-01-24 15:56:17",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 676,
		  "totalCountries": 12,
		  "totalStates": 63,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 2260,
		  "schedulePercent": 0.756686,
		  "totalGuests": 80,
		  "guestPercent": 0.49728,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Velvet Underground",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c7076a968871568494af9e145d38d52",
		  
		  "name": "Colin",
		  "createdDate": "2010-06-07 16:48:21",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 307,
		  "totalCountries": 28,
		  "totalStates": 27,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 2060,
		  "schedulePercent": 0.726088,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "ICC Sydney Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c78a56272ac1b28f4d28eb37279cbc4",
		  
		  "name": "Bradley",
		  "createdDate": "2019-09-26 13:39:01",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 1178,
		  "totalCountries": 11,
		  "totalStates": 54,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 4956,
		  "schedulePercent": 0.952969,
		  "totalGuests": 891,
		  "guestPercent": 0.827743,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c82d7faa9af334e8785db9c88f57c18",
		  
		  "name": "Suzie",
		  "createdDate": "2021-09-16 12:59:29",
		  "totalOrganizations": 5,
		  "totalTours": 11,
		  "totalDays": 117,
		  "totalCountries": 14,
		  "totalStates": 28,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1238,
		  "schedulePercent": 0.556664,
		  "totalGuests": 344,
		  "guestPercent": 0.672144,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Walt Disney Concert Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c911dcd36eaf671a681a3a17087626f",
		  
		  "name": "Stephen",
		  "createdDate": "2017-05-15 19:21:20",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 649,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 2422,
		  "schedulePercent": 0.777879,
		  "totalGuests": 863,
		  "guestPercent": 0.821736,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c97cbbe092c8f38f4478881e73de79f",
		  
		  "name": "Lyn",
		  "createdDate": "2018-10-01 12:16:02",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 215,
		  "totalCountries": 24,
		  "totalStates": 63,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 1994,
		  "schedulePercent": 0.712602,
		  "totalGuests": 351,
		  "guestPercent": 0.675317,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "1720",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5c9b031f415a951feaf517906640951e",
		  
		  "name": "Todd",
		  "createdDate": "2013-10-28 20:23:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 2633,
		  "schedulePercent": 0.801224,
		  "totalGuests": 580,
		  "guestPercent": 0.752607,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "House of Blues Myrtle Beach",
		  "mostGuestCity": "North Myrtle Beach",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ca1383dfe9f02c6feaf8de70ba4cd11",
		  
		  "name": "Cory",
		  "createdDate": "2021-12-29 04:24:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 128,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 708,
		  "schedulePercent": 0.389506,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "The Mod Club",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ca87c81445bad2539a17737e584cae7",
		  
		  "name": "James",
		  "createdDate": "2015-11-10 00:39:57",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 162,
		  "totalCountries": 17,
		  "totalStates": 41,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1427,
		  "schedulePercent": 0.604261,
		  "totalGuests": 239,
		  "guestPercent": 0.618314,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "Xfinity Center",
		  "mostGuestCity": "Mansfield",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5cb53c950629cf7b67608e19694a7207",
		  
		  "name": "James",
		  "createdDate": "2022-07-28 12:41:18",
		  "totalOrganizations": 4,
		  "totalTours": 21,
		  "totalDays": 215,
		  "totalCountries": 6,
		  "totalStates": 33,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1588,
		  "schedulePercent": 0.638259,
		  "totalGuests": 784,
		  "guestPercent": 0.80417,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5cc8ea0fcf41fa6e08be22141aa06aec",
		  
		  "name": "James",
		  "createdDate": "2022-06-19 22:36:54",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 66,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 1039,
		  "schedulePercent": 0.50102,
		  "totalGuests": 1306,
		  "guestPercent": 0.886899,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5cca5a88f690d96fcbdfdcc1c788011c",
		  
		  "name": "Cameron",
		  "createdDate": "2016-05-22 17:28:40",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 246,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 3079,
		  "schedulePercent": 0.849615,
		  "totalGuests": 1332,
		  "guestPercent": 0.891432,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ccade15a9ba86c1d1e283e1a448c364",
		  
		  "name": "Cory",
		  "createdDate": "2013-06-21 03:00:15",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 641,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 1838,
		  "schedulePercent": 0.68257,
		  "totalGuests": 341,
		  "guestPercent": 0.671238,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Miller Theater",
		  "mostGuestCity": "Augusta",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ccc4dfaf0d55006327e4b3f6752dc49",
		  
		  "name": "Kalee",
		  "createdDate": "2025-07-06 21:17:00",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 59,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 216,
		  "schedulePercent": 0.169538,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5cd0b6d8096720bacb15889dcf3f76e1",
		  
		  "name": "Yasmin ",
		  "createdDate": "2020-02-09 21:59:19",
		  "totalOrganizations": 33,
		  "totalTours": 16,
		  "totalDays": 841,
		  "totalCountries": 25,
		  "totalStates": 53,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 1895,
		  "schedulePercent": 0.693336,
		  "totalGuests": 120,
		  "guestPercent": 0.536945,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "The Green Room Byron",
		  "mostGuestCity": "Tyagarah",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5cdbbe4dc9423e63cf8162c62b5e6fa4",
		  
		  "name": "Simon",
		  "createdDate": "2010-01-11 16:47:38",
		  "totalOrganizations": 63,
		  "totalTours": 37,
		  "totalDays": 1431,
		  "totalCountries": 44,
		  "totalStates": 92,
		  "totalEvents": 531,
		  "eventPercent": 0.981868,
		  "totalScheduleItems": 7669,
		  "schedulePercent": 0.989121,
		  "totalGuests": 3455,
		  "guestPercent": 0.989347,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5cde52d5ef7d17452f9d91b0977d2361",
		  
		  "name": "Bryan",
		  "createdDate": "2012-08-24 01:44:00",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 260,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 2004,
		  "schedulePercent": 0.714415,
		  "totalGuests": 3729,
		  "guestPercent": 0.9915,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ce51f9f782363af2d05218cd0c533a9",
		  
		  "name": "Jeremy",
		  "createdDate": "2024-03-01 00:22:40",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 1123,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 682,
		  "schedulePercent": 0.379873,
		  "totalGuests": 106,
		  "guestPercent": 0.525385,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Republic NOLA",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ce57a3cecdf765662fdcd5c5363cfe5",
		  
		  "name": "Fiona",
		  "createdDate": "2025-03-22 21:12:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 129,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 687,
		  "schedulePercent": 0.381573,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Red Hat Amphitheater",
		  "mostGuestCity": "Raleigh",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ce726a8a8977583c29e0245fd220671",
		  
		  "name": "Bertram",
		  "createdDate": "2018-04-16 13:06:43",
		  "totalOrganizations": 34,
		  "totalTours": 22,
		  "totalDays": 483,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 387,
		  "eventPercent": 0.955349,
		  "totalScheduleItems": 3872,
		  "schedulePercent": 0.906505,
		  "totalGuests": 2037,
		  "guestPercent": 0.949343,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Klassik am Dom",
		  "mostGuestCity": "Linz",
		  "mostGuestAmount": 185,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5cfb8bb6d478cc41ead374cce8ff9c60",
		  
		  "name": "Jennifer",
		  "createdDate": "2013-10-21 19:55:37",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 325,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2162,
		  "schedulePercent": 0.741387,
		  "totalGuests": 2833,
		  "guestPercent": 0.978581,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d01523a324dc831839f1a721ee2ca59",
		  
		  "name": "Gorka",
		  "createdDate": "2022-09-01 13:20:38",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 595,
		  "totalCountries": 18,
		  "totalStates": 58,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1674,
		  "schedulePercent": 0.653785,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Prospect Park Bandshell",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d0c52939a1572a6978b2e8c65119c3b",
		  
		  "name": "Matthew",
		  "createdDate": "2025-01-27 21:12:00",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 112,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 815,
		  "schedulePercent": 0.428944,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "29th Street Ballroom",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d0facde9b942e8761134a54328f5c17",
		  
		  "name": "Peter",
		  "createdDate": "2014-10-20 19:15:48",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 176,
		  "totalCountries": 28,
		  "totalStates": 35,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1195,
		  "schedulePercent": 0.546578,
		  "totalGuests": 197,
		  "guestPercent": 0.592362,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "EE Wembley Stadium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d102977fb7cfc452b68ada1d8c0b2d7",
		  
		  "name": "Daniel",
		  "createdDate": "2015-05-03 21:56:43",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 268,
		  "totalCountries": 18,
		  "totalStates": 28,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 937,
		  "schedulePercent": 0.471328,
		  "totalGuests": 550,
		  "guestPercent": 0.743994,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "Liseberg (Stora scenen)",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d1148733fd447e09310800274b68616",
		  
		  "name": "Jacob",
		  "createdDate": "2018-10-29 15:10:36",
		  "totalOrganizations": 11,
		  "totalTours": 22,
		  "totalDays": 400,
		  "totalCountries": 27,
		  "totalStates": 64,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 2286,
		  "schedulePercent": 0.759746,
		  "totalGuests": 1079,
		  "guestPercent": 0.860381,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d149e4bd3f49a36f4296c929e81800d",
		  
		  "name": "Jerm",
		  "createdDate": "2018-06-28 00:19:24",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 196,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 32,
		  "schedulePercent": 0.042951,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d1acfffce32f91a028d9108e3385685",
		  
		  "name": "Lola",
		  "createdDate": "2022-02-12 18:29:42",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 54,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d36617b55efb9ad524862b334177e80",
		  
		  "name": "Sierra",
		  "createdDate": "2022-10-20 18:22:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 154,
		  "schedulePercent": 0.132026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d3753009dba4bf113ba19a1a8bb0568",
		  
		  "name": "Chiaki",
		  "createdDate": "2024-03-08 13:09:04",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 224,
		  "totalCountries": 21,
		  "totalStates": 33,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1369,
		  "schedulePercent": 0.589075,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d38fab55aaa9f535d994c2c6bd20c96",
		  
		  "name": "ARELY",
		  "createdDate": "2024-02-26 22:55:34",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 84,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 162,
		  "schedulePercent": 0.136786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d46e2c6e528ad1641d52a4cdbaac526",
		  
		  "name": "Erik",
		  "createdDate": "2025-10-27 17:57:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-29 00:00:00",
		  "mostGuestName": "Kulturwerk Herford",
		  "mostGuestCity": "Herford",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d4c5c6c98ace8cba5ffe75ac05cb417",
		  
		  "name": "Carly",
		  "createdDate": "2023-07-03 16:02:18",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 313,
		  "totalCountries": 14,
		  "totalStates": 33,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 849,
		  "schedulePercent": 0.439823,
		  "totalGuests": 535,
		  "guestPercent": 0.738894,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 125,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d66f1a512de9bb1aca66514148be0fe",
		  
		  "name": "Alisha",
		  "createdDate": "2022-03-02 01:38:27",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 873,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 3187,
		  "schedulePercent": 0.858568,
		  "totalGuests": 292,
		  "guestPercent": 0.645739,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Capital One Arena",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d6b70a79abc7fd8dbadcfcfdcee81b7",
		  
		  "name": "Ivy",
		  "createdDate": "2022-10-05 19:39:55",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 702,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 1374,
		  "schedulePercent": 0.590775,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d6c2a3e39ffa7fff210dc5990636c1b",
		  
		  "name": "Kristy",
		  "createdDate": "2020-03-11 04:01:58",
		  "totalOrganizations": 14,
		  "totalTours": 25,
		  "totalDays": 307,
		  "totalCountries": 11,
		  "totalStates": 41,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1379,
		  "schedulePercent": 0.592362,
		  "totalGuests": 34,
		  "guestPercent": 0.426677,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "The Empty Bottle",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d79e5bb0df27561e49bc7802725ca43",
		  
		  "name": "Kosta",
		  "createdDate": "2013-08-22 13:36:49",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 44,
		  "totalCountries": 17,
		  "totalStates": 9,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d8dff3fb27d401b584cfc056b691910",
		  
		  "name": "Blotas",
		  "createdDate": "2018-01-04 14:13:41",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 654,
		  "totalCountries": 5,
		  "totalStates": 17,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1561,
		  "schedulePercent": 0.63282,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5d975c2e189db4ad94eba872182ce98e",
		  
		  "name": "Lolade",
		  "createdDate": "2023-10-19 19:58:28",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 160,
		  "totalCountries": 13,
		  "totalStates": 25,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 545,
		  "schedulePercent": 0.332162,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5da80fa698bdd8551362880b669146ae",
		  
		  "name": "Feirin",
		  "createdDate": "2019-06-20 02:56:06",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 129,
		  "totalCountries": 12,
		  "totalStates": 34,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 671,
		  "schedulePercent": 0.375227,
		  "totalGuests": 644,
		  "guestPercent": 0.770172,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "The Torch",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5daa31c1ab05a91238495a9ea0742249",
		  
		  "name": "Mike",
		  "createdDate": "2025-08-19 16:28:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 371,
		  "schedulePercent": 0.253853,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5db92578e9d0bd48eb87dbc7f7fa80bc",
		  
		  "name": "Autumn",
		  "createdDate": "2024-03-24 22:33:18",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 274,
		  "totalCountries": 7,
		  "totalStates": 36,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 945,
		  "schedulePercent": 0.473821,
		  "totalGuests": 722,
		  "guestPercent": 0.790798,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5dbe30ad0190fa5f42281e14faf334bd",
		  
		  "name": "Isabella",
		  "createdDate": "2022-03-09 17:42:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5dc371f3aa4664d3bf642aab7380cf99",
		  
		  "name": "Wayne",
		  "createdDate": "2023-01-03 17:15:43",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 936,
		  "totalCountries": 10,
		  "totalStates": 48,
		  "totalEvents": 221,
		  "eventPercent": 0.835449,
		  "totalScheduleItems": 2408,
		  "schedulePercent": 0.775839,
		  "totalGuests": 347,
		  "guestPercent": 0.673844,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Buck's Backyard",
		  "mostGuestCity": "Buda",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5dc78d9855647a040c0e6e902691c4ae",
		  
		  "name": "Mitch",
		  "createdDate": "2020-12-29 19:05:47",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 403,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 407,
		  "schedulePercent": 0.272665,
		  "totalGuests": 349,
		  "guestPercent": 0.674637,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Majestic Ventura Theater",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5dd18cf947f50b39556349419844aacc",
		  
		  "name": "Connor",
		  "createdDate": "2018-10-16 18:06:48",
		  "totalOrganizations": 7,
		  "totalTours": 24,
		  "totalDays": 563,
		  "totalCountries": 18,
		  "totalStates": 76,
		  "totalEvents": 319,
		  "eventPercent": 0.925204,
		  "totalScheduleItems": 3571,
		  "schedulePercent": 0.887013,
		  "totalGuests": 458,
		  "guestPercent": 0.715549,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5dd520a9f1284c2baea1ae50eb9ea402",
		  
		  "name": "Zach",
		  "createdDate": "2024-08-26 20:31:34",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 278,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1799,
		  "schedulePercent": 0.675884,
		  "totalGuests": 328,
		  "guestPercent": 0.665231,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "40 Watt Club",
		  "mostGuestCity": "Athens",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5de156bac57ae04c2c96e55ca82ded9f",
		  
		  "name": "Ashley",
		  "createdDate": "2014-04-08 20:37:18",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 399,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2733,
		  "schedulePercent": 0.81335,
		  "totalGuests": 1351,
		  "guestPercent": 0.893132,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5de6fcadac08b3999bd48e369c1d983b",
		  
		  "name": "Russell",
		  "createdDate": "2022-09-07 05:34:57",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 105,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Fogartyville Community Media and Arts Center",
		  "mostGuestCity": "Sarasota",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5df0371117e002b3f41df106feb754d5",
		  
		  "name": "Kristoffer",
		  "createdDate": "2022-06-08 10:57:54",
		  "totalOrganizations": 17,
		  "totalTours": 13,
		  "totalDays": 266,
		  "totalCountries": 12,
		  "totalStates": 9,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 1374,
		  "schedulePercent": 0.590775,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Astra Kulturhaus",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e03c984945d14f5009dc01390081241",
		  
		  "name": "Michael",
		  "createdDate": "2015-08-12 08:21:07",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 78,
		  "totalCountries": 8,
		  "totalStates": 28,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 427,
		  "schedulePercent": 0.280938,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-03 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e084217c4d40d2b4de992630797c359",
		  
		  "name": "John",
		  "createdDate": "2024-08-06 20:22:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 202,
		  "schedulePercent": 0.162058,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e095c3d934ada215f22451c575613e4",
		  
		  "name": "matthias",
		  "createdDate": "2024-09-03 15:05:09",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 47,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 377,
		  "schedulePercent": 0.256346,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e26bae433bc6234edf339698dd25ef3",
		  
		  "name": "Jordan",
		  "createdDate": "2025-07-15 16:36:05",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 507,
		  "totalCountries": 9,
		  "totalStates": 20,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 234,
		  "schedulePercent": 0.18053,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e53f6321b1665a9b0d5782844e1d83d",
		  
		  "name": "Lex",
		  "createdDate": "2015-05-09 09:39:26",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 206,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 386,
		  "schedulePercent": 0.261673,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e5c69cc45eee2699bd81aa316eca793",
		  
		  "name": "Matthew",
		  "createdDate": "2013-07-09 01:21:17",
		  "totalOrganizations": 19,
		  "totalTours": 7,
		  "totalDays": 75,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 492,
		  "schedulePercent": 0.30893,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Marcus Pointe Baptist Church",
		  "mostGuestCity": "Pensacola",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e5cde259e93026731cb38f58c8912b7",
		  
		  "name": "James",
		  "createdDate": "2012-03-19 21:03:35",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 288,
		  "totalCountries": 22,
		  "totalStates": 12,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 903,
		  "schedulePercent": 0.459089,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e67376ac0e505069ec4eb1179321a87",
		  
		  "name": "Clinton",
		  "createdDate": "2025-10-28 08:21:28",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 37,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 279,
		  "schedulePercent": 0.205009,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e6ce4bd3c8c6d9543df8a13dd23f5ed",
		  
		  "name": "christopher",
		  "createdDate": "2022-09-10 21:12:22",
		  "totalOrganizations": 2,
		  "totalTours": 15,
		  "totalDays": 251,
		  "totalCountries": 12,
		  "totalStates": 41,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1501,
		  "schedulePercent": 0.61854,
		  "totalGuests": 107,
		  "guestPercent": 0.526292,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Plenary Theatre",
		  "mostGuestCity": "South Wharf",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e74d76b5f8f0b827711172fcf61bae5",
		  
		  "name": "Cassandra",
		  "createdDate": "2022-03-02 13:22:19",
		  "totalOrganizations": 121,
		  "totalTours": 98,
		  "totalDays": 2308,
		  "totalCountries": 24,
		  "totalStates": 69,
		  "totalEvents": 1147,
		  "eventPercent": 0.996714,
		  "totalScheduleItems": 9238,
		  "schedulePercent": 0.99456,
		  "totalGuests": 2301,
		  "guestPercent": 0.962262,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Banan-Kompaniet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e78463bcc53d199cf8d1141df622dd7",
		  
		  "name": "Max",
		  "createdDate": "2021-08-16 19:24:03",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 117,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1644,
		  "schedulePercent": 0.648232,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e7b4f69d52cdf39ab50b78a76c40e69",
		  
		  "name": "Kris",
		  "createdDate": "2010-09-14 19:21:57",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 430,
		  "totalCountries": 19,
		  "totalStates": 63,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1825,
		  "schedulePercent": 0.680417,
		  "totalGuests": 499,
		  "guestPercent": 0.730168,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e7d778acad5885fc0f3d31d73b5061b",
		  
		  "name": "Nicole",
		  "createdDate": "2023-02-06 21:12:32",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 229,
		  "totalCountries": 11,
		  "totalStates": 49,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1574,
		  "schedulePercent": 0.635766,
		  "totalGuests": 344,
		  "guestPercent": 0.672144,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "TV Eye",
		  "mostGuestCity": "Ridgewood",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e84c8dc13be42663a62c975aab82589",
		  
		  "name": "Marjo",
		  "createdDate": "2022-03-10 11:41:13",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 137,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 870,
		  "schedulePercent": 0.448663,
		  "totalGuests": 1106,
		  "guestPercent": 0.865027,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Galopprennbahn KÃ¶ln-Weidenpesch",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e8d6cc34e30f4176bbbab0f62ba5d9c",
		  
		  "name": "Karel",
		  "createdDate": "2019-10-04 18:37:21",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 178,
		  "totalCountries": 16,
		  "totalStates": 38,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1169,
		  "schedulePercent": 0.539778,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e90281f97c0beb121afcb863a41f53b",
		  
		  "name": "Dion",
		  "createdDate": "2015-09-24 04:27:51",
		  "totalOrganizations": 30,
		  "totalTours": 24,
		  "totalDays": 710,
		  "totalCountries": 27,
		  "totalStates": 71,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 3154,
		  "schedulePercent": 0.855848,
		  "totalGuests": 727,
		  "guestPercent": 0.792384,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Somerset House",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e91dc161139747c7e4b08025acc00b9",
		  
		  "name": "Manny",
		  "createdDate": "2021-09-09 03:19:26",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 760,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 841,
		  "schedulePercent": 0.437557,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5e9d8cfca8e47182b9d93e60271afe62",
		  
		  "name": "Scott",
		  "createdDate": "2017-07-24 20:39:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 114,
		  "totalCountries": 14,
		  "totalStates": 30,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 806,
		  "schedulePercent": 0.424751,
		  "totalGuests": 948,
		  "guestPercent": 0.839189,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5eaac5b1574d657e81e9ad0777e59119",
		  
		  "name": "Pietari",
		  "createdDate": "2023-01-10 12:37:46",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 206,
		  "totalCountries": 17,
		  "totalStates": 22,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 1545,
		  "schedulePercent": 0.62636,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Huvila-teltta",
		  "mostGuestCity": "Hakaniemi",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5eac976d08e7a86e91cfe18102890a78",
		  
		  "name": "Samantha",
		  "createdDate": "2024-02-12 15:42:13",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 286,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2174,
		  "schedulePercent": 0.743767,
		  "totalGuests": 254,
		  "guestPercent": 0.627153,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5eb11235f3eef1de37139b0285d0de6e",
		  
		  "name": "cote",
		  "createdDate": "2025-04-23 20:24:29",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 94,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5eb1e863b8d10c8f5258960221fedf89",
		  
		  "name": "Freddie",
		  "createdDate": "2012-03-06 15:17:01",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 384,
		  "totalCountries": 19,
		  "totalStates": 61,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 2978,
		  "schedulePercent": 0.840435,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "Albert Hall",
		  "mostGuestCity": "City Centre",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ec8af744010b63c14aa317c97329f7e",
		  
		  "name": "Selina",
		  "createdDate": "2025-06-17 19:04:20",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 150,
		  "totalCountries": 7,
		  "totalStates": 17,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 721,
		  "schedulePercent": 0.394832,
		  "totalGuests": 894,
		  "guestPercent": 0.828309,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Columbiahalle",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 165,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ecea169976f49c5c5472568e888488c",
		  
		  "name": "Tyrone",
		  "createdDate": "2013-10-14 20:22:42",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 607,
		  "totalCountries": 14,
		  "totalStates": 45,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 2935,
		  "schedulePercent": 0.835449,
		  "totalGuests": 417,
		  "guestPercent": 0.700363,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "MGM Grand",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ed5d2a123480a81e2c5c886f02fcc00",
		  
		  "name": "Linda",
		  "createdDate": "2018-06-12 01:16:09",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 794,
		  "totalCountries": 15,
		  "totalStates": 47,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 2083,
		  "schedulePercent": 0.729828,
		  "totalGuests": 904,
		  "guestPercent": 0.831142,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ee0bdcc52eb7a6ea5aa896cd4cf3455",
		  
		  "name": "Camilla",
		  "createdDate": "2025-03-29 16:54:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 202,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1084,
		  "schedulePercent": 0.515299,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ee3d9ab6fe32131489869019321ea40",
		  
		  "name": "Jeff",
		  "createdDate": "2013-07-19 21:46:47",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 526,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 2032,
		  "schedulePercent": 0.719515,
		  "totalGuests": 1510,
		  "guestPercent": 0.910358,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ee7b75a13593322942abe4dda56a91a",
		  
		  "name": "Danielle",
		  "createdDate": "2014-12-15 11:38:41",
		  "totalOrganizations": 2,
		  "totalTours": 32,
		  "totalDays": 767,
		  "totalCountries": 23,
		  "totalStates": 25,
		  "totalEvents": 487,
		  "eventPercent": 0.976315,
		  "totalScheduleItems": 5374,
		  "schedulePercent": 0.964982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ef0a5231aceaee2149173fecb626911",
		  
		  "name": "Dan",
		  "createdDate": "2024-04-30 17:19:07",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 159,
		  "totalCountries": 11,
		  "totalStates": 27,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 411,
		  "schedulePercent": 0.274365,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Griffin House Inc",
		  "mostGuestCity": "Palenville",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ef2a66ec6aafc92bf7abbb36f130fc7",
		  
		  "name": "Layton",
		  "createdDate": "2025-02-17 21:00:37",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 141,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 769,
		  "schedulePercent": 0.411945,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ef5d8785421cecef109ae6617251da2",
		  
		  "name": "ERIC",
		  "createdDate": "2024-01-31 00:35:54",
		  "totalOrganizations": 3,
		  "totalTours": 54,
		  "totalDays": 328,
		  "totalCountries": 9,
		  "totalStates": 43,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 982,
		  "schedulePercent": 0.485267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ef6ba1a4cf2fce6c4d872d7499978c7",
		  
		  "name": "Chris",
		  "createdDate": "2014-04-06 22:34:16",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 70,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 242,
		  "schedulePercent": 0.18529,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Niverville Old Tyme Fair",
		  "mostGuestCity": "Niverville ",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ef87758d2a3086f644ab3265f627af0",
		  
		  "name": "Raul",
		  "createdDate": "2023-04-04 17:39:18",
		  "totalOrganizations": 9,
		  "totalTours": 20,
		  "totalDays": 359,
		  "totalCountries": 13,
		  "totalStates": 69,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 1925,
		  "schedulePercent": 0.699116,
		  "totalGuests": 302,
		  "guestPercent": 0.650839,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "O2 Guildhall",
		  "mostGuestCity": "Southampton",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5efe03746511502221f143e8c678126f",
		  
		  "name": "Justin",
		  "createdDate": "2019-01-24 22:09:30",
		  "totalOrganizations": 21,
		  "totalTours": 22,
		  "totalDays": 906,
		  "totalCountries": 22,
		  "totalStates": 87,
		  "totalEvents": 488,
		  "eventPercent": 0.977108,
		  "totalScheduleItems": 5767,
		  "schedulePercent": 0.972121,
		  "totalGuests": 3421,
		  "guestPercent": 0.988781,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Fox Theater",
		  "mostGuestCity": "Oakland",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f024ff582277788fdf46cefbe6f85b9",
		  
		  "name": "Allison",
		  "createdDate": "2022-06-22 02:35:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 2224,
		  "schedulePercent": 0.7517,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f065f3b6196cdbd1318cfc64486c177",
		  
		  "name": "Nikkita",
		  "createdDate": "2021-09-20 19:50:13",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 82,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 280,
		  "schedulePercent": 0.205576,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f1029a0b5a2b2781746fd6fe4d7eac0",
		  
		  "name": "Sandra ",
		  "createdDate": "2024-03-15 16:19:40",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 76,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 297,
		  "schedulePercent": 0.216342,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "The Kessler Theater",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f292159abbf767d08cb7e8bb0de8e83",
		  
		  "name": "Ben",
		  "createdDate": "2016-08-03 23:10:34",
		  "totalOrganizations": 21,
		  "totalTours": 11,
		  "totalDays": 397,
		  "totalCountries": 23,
		  "totalStates": 22,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1338,
		  "schedulePercent": 0.583182,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f3c664593e841a1a0280701dcec4d15",
		  
		  "name": "Daniella",
		  "createdDate": "2023-05-23 17:38:35",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 402,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1032,
		  "schedulePercent": 0.49932,
		  "totalGuests": 233,
		  "guestPercent": 0.614234,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "The Pacific Amphitheatre",
		  "mostGuestCity": "Costa Mesa",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f3d2157de789647a6b87782a18061ee",
		  
		  "name": "Ali",
		  "createdDate": "2023-11-06 03:49:47",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 91,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 1511,
		  "schedulePercent": 0.620127,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f46eb9f00cb2187a9b76626f9440bba",
		  
		  "name": "GFour",
		  "createdDate": "2024-05-28 13:24:41",
		  "totalOrganizations": 1,
		  "totalTours": 25,
		  "totalDays": 247,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1347,
		  "schedulePercent": 0.584655,
		  "totalGuests": 77,
		  "guestPercent": 0.49456,
		  "mostGuestDate": "2025-01-12 00:00:00",
		  "mostGuestName": "Youkey Theater",
		  "mostGuestCity": "Lakeland",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f4a037ca106676a78944d9742fecd5d",
		  
		  "name": "Tim",
		  "createdDate": "2019-01-11 13:26:08",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 232,
		  "totalCountries": 13,
		  "totalStates": 27,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 603,
		  "schedulePercent": 0.351881,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f512bde53f2366304c5725cb7fafb14",
		  
		  "name": "ARC Nashville ",
		  "createdDate": "2025-09-10 18:57:02",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f56ab196d26520662a1b1f24c03ef94",
		  
		  "name": "Kilian",
		  "createdDate": "2018-11-04 21:00:27",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 278,
		  "totalCountries": 28,
		  "totalStates": 51,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1607,
		  "schedulePercent": 0.641659,
		  "totalGuests": 1366,
		  "guestPercent": 0.895852,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f58315d788cc09e6a6e628ff104c661",
		  
		  "name": "Richard",
		  "createdDate": "2009-08-28 05:08:54",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 257,
		  "totalCountries": 12,
		  "totalStates": 41,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1083,
		  "schedulePercent": 0.515186,
		  "totalGuests": 341,
		  "guestPercent": 0.671238,
		  "mostGuestDate": "2025-08-25 00:00:00",
		  "mostGuestName": "The Ford",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f60ea93c2d53cefb43aa591fe1aaf12",
		  
		  "name": "George",
		  "createdDate": "2017-03-07 10:21:02",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 289,
		  "totalCountries": 21,
		  "totalStates": 35,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 2055,
		  "schedulePercent": 0.724388,
		  "totalGuests": 1318,
		  "guestPercent": 0.889733,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Blackpool Opera House",
		  "mostGuestCity": "Blackpool",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f7281442bef43cbd15a97ef31e74f20",
		  
		  "name": "Sarah ",
		  "createdDate": "2019-04-26 19:56:00",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 97,
		  "totalCountries": 6,
		  "totalStates": 13,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 519,
		  "schedulePercent": 0.32117,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f7ccb41d70f7cf9ff2491e593ca34de",
		  
		  "name": "Diego",
		  "createdDate": "2022-10-06 23:44:54",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 347,
		  "totalCountries": 14,
		  "totalStates": 25,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1017,
		  "schedulePercent": 0.495354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f8c9695a62e0a0ee09255625cc170ab",
		  
		  "name": "Steve",
		  "createdDate": "2025-10-28 17:29:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 49,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f9bd39750fb6498e01b286ed7c3826a",
		  
		  "name": "Trond",
		  "createdDate": "2017-08-21 10:35:21",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 96,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 670,
		  "schedulePercent": 0.374773,
		  "totalGuests": 193,
		  "guestPercent": 0.588169,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Arendal Kulturhus",
		  "mostGuestCity": "Arendal",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5f9fe75d9fd004d352221221144245ec",
		  
		  "name": "Noe",
		  "createdDate": "2017-07-04 10:47:10",
		  "totalOrganizations": 19,
		  "totalTours": 30,
		  "totalDays": 816,
		  "totalCountries": 23,
		  "totalStates": 74,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 2857,
		  "schedulePercent": 0.827969,
		  "totalGuests": 821,
		  "guestPercent": 0.813463,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fa0c8edd2092eef65d12a94ece36260",
		  
		  "name": "Cody",
		  "createdDate": "2022-11-15 17:56:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 14,
		  "totalStates": 51,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1927,
		  "schedulePercent": 0.699569,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fab7e1b78a428121aa5fe189cad5e26",
		  
		  "name": "Michael",
		  "createdDate": "2013-07-01 18:26:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 11,
		  "totalStates": 39,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1464,
		  "schedulePercent": 0.609927,
		  "totalGuests": 842,
		  "guestPercent": 0.818336,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fadcaa445db134fb00971000efd77e7",
		  
		  "name": "Christopher",
		  "createdDate": "2012-11-08 16:33:20",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 147,
		  "totalCountries": 18,
		  "totalStates": 41,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1156,
		  "schedulePercent": 0.536151,
		  "totalGuests": 520,
		  "guestPercent": 0.736061,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5faf4ebcbe3fe6b7f8afee36d666c4b1",
		  
		  "name": "David",
		  "createdDate": "2024-07-02 21:24:06",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 94,
		  "totalCountries": 5,
		  "totalStates": 27,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 211,
		  "schedulePercent": 0.166704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fb16472a1cf6f9f8b3b9df3be793a0b",
		  
		  "name": "Steven",
		  "createdDate": "2022-04-26 22:03:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 363,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 266,
		  "schedulePercent": 0.197076,
		  "totalGuests": 197,
		  "guestPercent": 0.592362,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fbb9955a5d73ae550d58865614bbaa5",
		  
		  "name": "Adrian",
		  "createdDate": "2025-03-11 18:05:42",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 45,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 121,
		  "schedulePercent": 0.111627,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fbfaa783f865078296ad2de96859339",
		  
		  "name": "Candace",
		  "createdDate": "2022-09-13 05:45:39",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 285,
		  "totalCountries": 16,
		  "totalStates": 27,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1858,
		  "schedulePercent": 0.686763,
		  "totalGuests": 795,
		  "guestPercent": 0.80689,
		  "mostGuestDate": "2025-08-20 00:00:00",
		  "mostGuestName": "170 Russell",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fcdcc0e170a2d0706e67fca49092bcc",
		  
		  "name": "Alva",
		  "createdDate": "2024-03-20 10:15:01",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 328,
		  "totalCountries": 23,
		  "totalStates": 32,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1327,
		  "schedulePercent": 0.578309,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "SÃ¶dra Teatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fd0fef14d65de15248557b0769a8408",
		  
		  "name": "Andres",
		  "createdDate": "2014-02-14 13:49:18",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 337,
		  "totalCountries": 20,
		  "totalStates": 40,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1851,
		  "schedulePercent": 0.686197,
		  "totalGuests": 257,
		  "guestPercent": 0.628286,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Roy Thomson Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fd8aa5d149e0ca414b2454434214509",
		  
		  "name": "elin",
		  "createdDate": "2019-01-14 09:06:03",
		  "totalOrganizations": 22,
		  "totalTours": 7,
		  "totalDays": 290,
		  "totalCountries": 6,
		  "totalStates": 18,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 775,
		  "schedulePercent": 0.414551,
		  "totalGuests": 270,
		  "guestPercent": 0.634746,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "GrÃ¶na Lund",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fdd3a3937f7bbd911616f5bcf648f0f",
		  
		  "name": "Shannon ",
		  "createdDate": "2022-09-06 14:53:36",
		  "totalOrganizations": 9,
		  "totalTours": 13,
		  "totalDays": 283,
		  "totalCountries": 27,
		  "totalStates": 53,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1716,
		  "schedulePercent": 0.661265,
		  "totalGuests": 1185,
		  "guestPercent": 0.874433,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fdf74fd9b2e966172de04aab18623cb",
		  
		  "name": "Lorenzo",
		  "createdDate": "2025-05-21 22:26:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 219,
		  "totalCountries": 8,
		  "totalStates": 2,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 158,
		  "schedulePercent": 0.134066,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Rail Park Tilburg",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5fe01d9906257a5c5cb8751f8c9dacdd",
		  
		  "name": "Abby",
		  "createdDate": "2023-09-01 11:56:55",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 760,
		  "totalCountries": 17,
		  "totalStates": 25,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1615,
		  "schedulePercent": 0.643019,
		  "totalGuests": 446,
		  "guestPercent": 0.711355,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "BST Hyde Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ff8bd045a5b2750ef60ba1b366f3ca8",
		  
		  "name": "Rob",
		  "createdDate": "2017-11-15 06:51:48",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 121,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 753,
		  "schedulePercent": 0.406505,
		  "totalGuests": 71,
		  "guestPercent": 0.486174,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "The Gov",
		  "mostGuestCity": "Hindmarsh",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "5ffaeea08e126f43491dc7b422f1c889",
		  
		  "name": "Nicolas",
		  "createdDate": "2019-08-22 21:52:12",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 386,
		  "totalCountries": 21,
		  "totalStates": 82,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 2998,
		  "schedulePercent": 0.842022,
		  "totalGuests": 340,
		  "guestPercent": 0.671011,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "600214a965a90fa8d6eb3790ad0804a4",
		  
		  "name": "Will",
		  "createdDate": "2013-07-04 12:20:11",
		  "totalOrganizations": 9,
		  "totalTours": 36,
		  "totalDays": 825,
		  "totalCountries": 29,
		  "totalStates": 62,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 3401,
		  "schedulePercent": 0.87534,
		  "totalGuests": 351,
		  "guestPercent": 0.675317,
		  "mostGuestDate": "2025-06-03 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "600242bee088d71d5404b1d5a6b6c7f5",
		  
		  "name": "Alex",
		  "createdDate": "2017-07-26 07:03:39",
		  "totalOrganizations": 41,
		  "totalTours": 39,
		  "totalDays": 496,
		  "totalCountries": 6,
		  "totalStates": 18,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2220,
		  "schedulePercent": 0.75102,
		  "totalGuests": 1101,
		  "guestPercent": 0.864121,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Singing Bird Studio",
		  "mostGuestCity": "Frankston",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "600258d01c54ab18c74830deedeb04f3",
		  
		  "name": "Raymie",
		  "createdDate": "2015-09-05 16:08:04",
		  "totalOrganizations": 6,
		  "totalTours": 24,
		  "totalDays": 533,
		  "totalCountries": 19,
		  "totalStates": 61,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 5017,
		  "schedulePercent": 0.954782,
		  "totalGuests": 1053,
		  "guestPercent": 0.855168,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "600895232035c8374bf083322803cbd0",
		  
		  "name": "Michelle",
		  "createdDate": "2025-10-31 17:13:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 351,
		  "schedulePercent": 0.24354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60143ae8c8689274d950f53d59a22b76",
		  
		  "name": "Sara",
		  "createdDate": "2015-06-26 23:24:05",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 216,
		  "schedulePercent": 0.169538,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "High Limit Room",
		  "mostGuestCity": "",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6014551de0cc2e264d84ded4180a7c6b",
		  
		  "name": "Gerard",
		  "createdDate": "2022-06-18 20:56:50",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 665,
		  "totalCountries": 9,
		  "totalStates": 42,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1383,
		  "schedulePercent": 0.593382,
		  "totalGuests": 428,
		  "guestPercent": 0.706029,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "601e66a8f44640c7c1aaa2e022c10258",
		  
		  "name": "Valerie",
		  "createdDate": "2025-06-06 17:32:05",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 819,
		  "schedulePercent": 0.430304,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Meridian Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60238e8116ccf6a458bf596e7103e6f9",
		  
		  "name": "Robert",
		  "createdDate": "2013-09-23 20:10:57",
		  "totalOrganizations": 13,
		  "totalTours": 2,
		  "totalDays": 356,
		  "totalCountries": 24,
		  "totalStates": 26,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 958,
		  "schedulePercent": 0.478468,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Dreamland Margate - Scenic Stage",
		  "mostGuestCity": "Margate",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "602679efa5b512a1f1841e6f63ddf4bc",
		  
		  "name": "James",
		  "createdDate": "2022-07-01 17:38:11",
		  "totalOrganizations": 1,
		  "totalTours": 11,
		  "totalDays": 1694,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 1630,
		  "schedulePercent": 0.645852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6028819a4582d18726d3848db6bbb49e",
		  
		  "name": "Andy",
		  "createdDate": "2018-11-13 05:56:08",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 199,
		  "totalCountries": 18,
		  "totalStates": 57,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1326,
		  "schedulePercent": 0.577743,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "The SSE Arena, Wembley",
		  "mostGuestCity": "Wembley",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "602da3a2f4348ed2b1b2048598a45ed3",
		  
		  "name": "Imanol",
		  "createdDate": "2024-09-08 13:14:03",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 51,
		  "totalCountries": 17,
		  "totalStates": 18,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 309,
		  "schedulePercent": 0.222235,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6030117f48c128f2c845323a4559018b",
		  
		  "name": "Maddy",
		  "createdDate": "2021-06-09 00:17:23",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1074,
		  "totalCountries": 13,
		  "totalStates": 24,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 791,
		  "schedulePercent": 0.419311,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "603730eb48e886fd163fa486a9ec54d1",
		  
		  "name": "Max",
		  "createdDate": "2025-04-03 13:36:50",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 125,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 338,
		  "schedulePercent": 0.236967,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Gamma Ray Bar",
		  "mostGuestCity": "Madison",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6041ea44128bd9ed2d6f300c8871a34c",
		  
		  "name": "Sara",
		  "createdDate": "2021-09-24 16:28:12",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 350,
		  "totalCountries": 12,
		  "totalStates": 50,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1947,
		  "schedulePercent": 0.703196,
		  "totalGuests": 248,
		  "guestPercent": 0.624207,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "San Antonio Stock Show & Rodeo",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6046d6365fae62ade988b235d188fcc4",
		  
		  "name": "TRACEY",
		  "createdDate": "2024-09-13 14:30:35",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 229,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 268,
		  "schedulePercent": 0.198209,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6053738ca631ec0354f63ebf12889030",
		  
		  "name": "Megan",
		  "createdDate": "2021-10-25 19:23:59",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 63,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 411,
		  "schedulePercent": 0.274365,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Madame Louâ€™s",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6067c7ef57f97c3da8e59d8caacd13b4",
		  
		  "name": "Andrew",
		  "createdDate": "2011-04-24 08:19:38",
		  "totalOrganizations": 47,
		  "totalTours": 12,
		  "totalDays": 521,
		  "totalCountries": 29,
		  "totalStates": 51,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2468,
		  "schedulePercent": 0.783545,
		  "totalGuests": 768,
		  "guestPercent": 0.800431,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6067d6dacb995a4e5b3af45b7d6c40d6",
		  
		  "name": "Anika",
		  "createdDate": "2013-08-05 18:29:11",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 667,
		  "totalCountries": 28,
		  "totalStates": 59,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 3228,
		  "schedulePercent": 0.861967,
		  "totalGuests": 940,
		  "guestPercent": 0.837262,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "Canadian Tire Centre",
		  "mostGuestCity": "Ottawa",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6068086e0da1a4f989ba73b09aec1cf3",
		  
		  "name": "Christoffer",
		  "createdDate": "2019-07-03 22:02:24",
		  "totalOrganizations": 15,
		  "totalTours": 22,
		  "totalDays": 452,
		  "totalCountries": 20,
		  "totalStates": 70,
		  "totalEvents": 266,
		  "eventPercent": 0.887579,
		  "totalScheduleItems": 3639,
		  "schedulePercent": 0.891659,
		  "totalGuests": 721,
		  "guestPercent": 0.790571,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Electric Ballroom",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "606d0fff904c7384833943e7dd8c949d",
		  
		  "name": "Michael",
		  "createdDate": "2018-11-07 12:04:57",
		  "totalOrganizations": 13,
		  "totalTours": 22,
		  "totalDays": 590,
		  "totalCountries": 15,
		  "totalStates": 68,
		  "totalEvents": 343,
		  "eventPercent": 0.938463,
		  "totalScheduleItems": 4529,
		  "schedulePercent": 0.938803,
		  "totalGuests": 1920,
		  "guestPercent": 0.940956,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6071e0f64f6a7d0c1a624eb53de8a5f6",
		  
		  "name": "Patrick",
		  "createdDate": "2011-04-28 02:48:34",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 573,
		  "totalCountries": 10,
		  "totalStates": 28,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 2165,
		  "schedulePercent": 0.74184,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Soldiers and Sailors Memorial Auditorium",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6071f70c13359a9433a5a9fc79cecafb",
		  
		  "name": "Dom",
		  "createdDate": "2023-11-27 14:26:24",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 437,
		  "totalCountries": 28,
		  "totalStates": 51,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1646,
		  "schedulePercent": 0.649479,
		  "totalGuests": 756,
		  "guestPercent": 0.797597,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60722b77c6479ff09090ce9e217fc3b1",
		  
		  "name": "Salt",
		  "createdDate": "2023-11-20 03:37:32",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 145,
		  "totalCountries": 13,
		  "totalStates": 22,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 607,
		  "schedulePercent": 0.353581,
		  "totalGuests": 127,
		  "guestPercent": 0.542044,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "The River Hotel",
		  "mostGuestCity": "Margaret River",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60808dc8c0019cc98bb91315ae020c96",
		  
		  "name": "Lisa",
		  "createdDate": "2018-07-09 21:50:16",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 448,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 681,
		  "schedulePercent": 0.379646,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Hard Rock Rocksino Northfield Park",
		  "mostGuestCity": "Northfield",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60844093d425bfbc0a5c4d71c08cc906",
		  
		  "name": "Ben",
		  "createdDate": "2017-03-18 12:58:45",
		  "totalOrganizations": 40,
		  "totalTours": 13,
		  "totalDays": 569,
		  "totalCountries": 27,
		  "totalStates": 30,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 3102,
		  "schedulePercent": 0.851541,
		  "totalGuests": 327,
		  "guestPercent": 0.664665,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Uber arena (Formerly Mercedes Benz Arena)",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "609cc8a51300495e9c47efee959b22d0",
		  
		  "name": "Steinar",
		  "createdDate": "2018-04-11 11:00:26",
		  "totalOrganizations": 10,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 119,
		  "schedulePercent": 0.110041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60a399b7852191a3116434f1a456731c",
		  
		  "name": "Zack",
		  "createdDate": "2024-07-21 23:53:22",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 480,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 793,
		  "schedulePercent": 0.419991,
		  "totalGuests": 187,
		  "guestPercent": 0.584202,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Whitby Ribfest",
		  "mostGuestCity": "Whitby",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60ba4887df78a14889ec3d8bc25f44f2",
		  
		  "name": "Robert",
		  "createdDate": "2022-04-21 20:17:28",
		  "totalOrganizations": 10,
		  "totalTours": 40,
		  "totalDays": 1921,
		  "totalCountries": 21,
		  "totalStates": 76,
		  "totalEvents": 618,
		  "eventPercent": 0.988554,
		  "totalScheduleItems": 6158,
		  "schedulePercent": 0.977788,
		  "totalGuests": 1388,
		  "guestPercent": 0.899252,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Dolby Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60c8635dc4d82713d67fa4a0285104ad",
		  
		  "name": "Johann ",
		  "createdDate": "2015-11-23 19:00:55",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 46,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 328,
		  "schedulePercent": 0.230394,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60cf76a2aaf78ee82365812a9da0f508",
		  
		  "name": "Ric",
		  "createdDate": "2022-04-12 03:40:16",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 443,
		  "totalCountries": 9,
		  "totalStates": 51,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 950,
		  "schedulePercent": 0.475635,
		  "totalGuests": 883,
		  "guestPercent": 0.826269,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Fox Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60da678189b98a3c93151018916934d8",
		  
		  "name": "Trevor",
		  "createdDate": "2023-04-16 10:10:19",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 414,
		  "totalCountries": 6,
		  "totalStates": 20,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 251,
		  "schedulePercent": 0.190843,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Button Factory",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60e4e2fe4d8d925ed55262a20367a012",
		  
		  "name": "Julie",
		  "createdDate": "2024-12-02 22:01:44",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 37,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "60fd0afde69a5d191585184ed85eed53",
		  
		  "name": "Darrell",
		  "createdDate": "2012-02-06 00:23:14",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 398,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1630,
		  "schedulePercent": 0.645852,
		  "totalGuests": 285,
		  "guestPercent": 0.641999,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "610079789aa5866fedf337624bbddfc5",
		  
		  "name": "Glen",
		  "createdDate": "2021-10-31 09:51:19",
		  "totalOrganizations": 9,
		  "totalTours": 16,
		  "totalDays": 866,
		  "totalCountries": 38,
		  "totalStates": 91,
		  "totalEvents": 371,
		  "eventPercent": 0.950023,
		  "totalScheduleItems": 5037,
		  "schedulePercent": 0.955122,
		  "totalGuests": 1765,
		  "guestPercent": 0.931437,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61007e07dbca39b99cb73fc87122273d",
		  
		  "name": "Angela",
		  "createdDate": "2023-07-18 17:02:17",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 564,
		  "totalCountries": 3,
		  "totalStates": 46,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1690,
		  "schedulePercent": 0.656732,
		  "totalGuests": 436,
		  "guestPercent": 0.707842,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6100a8a3d3049954681bd749f6d2fd59",
		  
		  "name": "Charene",
		  "createdDate": "2023-11-16 01:47:51",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 49,
		  "totalCountries": 6,
		  "totalStates": 6,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6109c96c85387664e2cc6f4cc290fb7d",
		  
		  "name": "Sophia ",
		  "createdDate": "2021-11-30 21:51:55",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 337,
		  "totalCountries": 23,
		  "totalStates": 31,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1682,
		  "schedulePercent": 0.655032,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "610a3256200aa448b9d0ac73ba478764",
		  
		  "name": "Harvey",
		  "createdDate": "2022-11-03 18:58:26",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 567,
		  "totalCountries": 34,
		  "totalStates": 100,
		  "totalEvents": 296,
		  "eventPercent": 0.910131,
		  "totalScheduleItems": 3705,
		  "schedulePercent": 0.896645,
		  "totalGuests": 1521,
		  "guestPercent": 0.912058,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "610dd33220bac3ca3cf7b48bccb6346a",
		  
		  "name": "Janine",
		  "createdDate": "2018-03-20 18:35:30",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 227,
		  "totalCountries": 24,
		  "totalStates": 31,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1110,
		  "schedulePercent": 0.520852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "610fd8cebe70f4f36df0c70a9058ded9",
		  
		  "name": "Peter",
		  "createdDate": "2022-11-02 18:38:27",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 139,
		  "totalCountries": 8,
		  "totalStates": 7,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 978,
		  "schedulePercent": 0.484021,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Grieghallen",
		  "mostGuestCity": "Bergen",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61151a6430a72f4c8fe83ed5f1832c77",
		  
		  "name": "Rick",
		  "createdDate": "2017-09-13 18:24:34",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 386,
		  "totalCountries": 12,
		  "totalStates": 39,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 2293,
		  "schedulePercent": 0.760879,
		  "totalGuests": 1020,
		  "guestPercent": 0.850068,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "611b8a202f68db8ee773ade2726c2dca",
		  
		  "name": "Emma",
		  "createdDate": "2018-03-19 05:15:33",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 275,
		  "totalCountries": 3,
		  "totalStates": 48,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 2518,
		  "schedulePercent": 0.788418,
		  "totalGuests": 487,
		  "guestPercent": 0.726768,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Balboa Theatre",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6121c8eca6d027ee1551bb72d8820b0a",
		  
		  "name": "Quentin",
		  "createdDate": "2011-09-11 21:20:45",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 799,
		  "totalCountries": 17,
		  "totalStates": 49,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 1468,
		  "schedulePercent": 0.610721,
		  "totalGuests": 723,
		  "guestPercent": 0.791138,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 171,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6125f42030bf757e2b95c3db85b8c7c6",
		  
		  "name": "Efuwa",
		  "createdDate": "2022-10-12 20:42:00",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 139,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1317,
		  "schedulePercent": 0.575476,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6135054e8071b18fc973ee62b4dce000",
		  
		  "name": "Nick",
		  "createdDate": "2013-08-22 14:06:52",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 1015,
		  "totalCountries": 6,
		  "totalStates": 44,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2069,
		  "schedulePercent": 0.727108,
		  "totalGuests": 646,
		  "guestPercent": 0.770512,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6142d14b1b2b43bacf4f11a6bea91164",
		  
		  "name": "Samuel",
		  "createdDate": "2025-03-22 17:57:17",
		  "totalOrganizations": 4,
		  "totalTours": 18,
		  "totalDays": 406,
		  "totalCountries": 21,
		  "totalStates": 71,
		  "totalEvents": 268,
		  "eventPercent": 0.888599,
		  "totalScheduleItems": 2329,
		  "schedulePercent": 0.765979,
		  "totalGuests": 897,
		  "guestPercent": 0.829329,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "614652143974baa4bba52abcedb4f92c",
		  
		  "name": "Judd",
		  "createdDate": "2014-02-27 22:59:41",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 580,
		  "totalCountries": 36,
		  "totalStates": 58,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1644,
		  "schedulePercent": 0.648232,
		  "totalGuests": 200,
		  "guestPercent": 0.594855,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "NRG Stadium",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6148f11a0c13acf54bb93e0d0732d50a",
		  
		  "name": "Chris",
		  "createdDate": "2014-08-07 19:16:59",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 1169,
		  "totalCountries": 13,
		  "totalStates": 13,
		  "totalEvents": 861,
		  "eventPercent": 0.994334,
		  "totalScheduleItems": 979,
		  "schedulePercent": 0.484361,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61497af809b0b782918f1fda0fb24f21",
		  
		  "name": "Nicholas ",
		  "createdDate": "2012-10-11 14:06:20",
		  "totalOrganizations": 52,
		  "totalTours": 18,
		  "totalDays": 369,
		  "totalCountries": 16,
		  "totalStates": 48,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 1583,
		  "schedulePercent": 0.637126,
		  "totalGuests": 419,
		  "guestPercent": 0.701496,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "614b89ff2c50f030dffa6f3eb809b266",
		  
		  "name": "Bill",
		  "createdDate": "2011-05-30 03:19:21",
		  "totalOrganizations": 26,
		  "totalTours": 20,
		  "totalDays": 301,
		  "totalCountries": 21,
		  "totalStates": 31,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1658,
		  "schedulePercent": 0.651292,
		  "totalGuests": 808,
		  "guestPercent": 0.809723,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6151bef9be413025363e055cbae4b425",
		  
		  "name": "Gellman",
		  "createdDate": "2013-12-13 04:17:39",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 408,
		  "totalCountries": 7,
		  "totalStates": 34,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1049,
		  "schedulePercent": 0.504193,
		  "totalGuests": 572,
		  "guestPercent": 0.75034,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Wilshire Ebell Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "616a5b105c7a3db9334e405756ca5ce8",
		  
		  "name": "Rebecca",
		  "createdDate": "2016-09-10 21:31:51",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 710,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 2192,
		  "schedulePercent": 0.746827,
		  "totalGuests": 608,
		  "guestPercent": 0.761219,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "616b2a91aef7f4cdc9e90fb307c4dee5",
		  
		  "name": "Lara",
		  "createdDate": "2016-07-20 00:35:14",
		  "totalOrganizations": 13,
		  "totalTours": 63,
		  "totalDays": 974,
		  "totalCountries": 25,
		  "totalStates": 81,
		  "totalEvents": 360,
		  "eventPercent": 0.94617,
		  "totalScheduleItems": 4938,
		  "schedulePercent": 0.952289,
		  "totalGuests": 1942,
		  "guestPercent": 0.942203,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61782fc692a95c0150a39a6ce97a8ca2",
		  
		  "name": "Andrew",
		  "createdDate": "2018-06-27 16:26:58",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 76,
		  "totalCountries": 9,
		  "totalStates": 7,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 242,
		  "schedulePercent": 0.18529,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "617f1d59976431f5788c266a513fb253",
		  
		  "name": "JR",
		  "createdDate": "2023-04-04 17:05:08",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 128,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 586,
		  "schedulePercent": 0.346442,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "618061ed84adf52cee0c1e58167e22ed",
		  
		  "name": "Sergio",
		  "createdDate": "2024-03-26 22:46:10",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 8,
		  "totalStates": 14,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 247,
		  "schedulePercent": 0.18835,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6189de26409cc78d91d3633eb5cfce28",
		  
		  "name": "Tim",
		  "createdDate": "2014-07-29 03:28:01",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 754,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 253,
		  "schedulePercent": 0.191976,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Hamer Hall",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "618e7a92f5cf2da4b10d425316715c3e",
		  
		  "name": "Sylvain",
		  "createdDate": "2024-12-13 15:41:40",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 223,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 524,
		  "schedulePercent": 0.324003,
		  "totalGuests": 2612,
		  "guestPercent": 0.972461,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 675,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61921347c8becae272c39dd8634c6f20",
		  
		  "name": "Arturo",
		  "createdDate": "2023-04-26 17:30:48",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 433,
		  "totalCountries": 12,
		  "totalStates": 25,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1043,
		  "schedulePercent": 0.501927,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Samyan Mitrtown",
		  "mostGuestCity": "Pathum Wan",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "619673417bbf36aa44f3cde1e8d35a5f",
		  
		  "name": "Oli",
		  "createdDate": "2011-12-05 12:18:40",
		  "totalOrganizations": 18,
		  "totalTours": 16,
		  "totalDays": 488,
		  "totalCountries": 15,
		  "totalStates": 41,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 1956,
		  "schedulePercent": 0.704442,
		  "totalGuests": 1262,
		  "guestPercent": 0.881913,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wythenshawe Park and Gardens",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "619bcd5ee7673befc09e2ed4d0a2ee6f",
		  
		  "name": "Matthias",
		  "createdDate": "2018-04-16 12:25:56",
		  "totalOrganizations": 30,
		  "totalTours": 22,
		  "totalDays": 462,
		  "totalCountries": 7,
		  "totalStates": 36,
		  "totalEvents": 365,
		  "eventPercent": 0.948096,
		  "totalScheduleItems": 3607,
		  "schedulePercent": 0.889959,
		  "totalGuests": 2037,
		  "guestPercent": 0.949343,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Klassik am Dom",
		  "mostGuestCity": "Linz",
		  "mostGuestAmount": 185,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61a2ec243c4a7261ccc0ebc14d850ba0",
		  
		  "name": "Shauna",
		  "createdDate": "2022-03-01 21:00:03",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 74,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 370,
		  "schedulePercent": 0.253173,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61a34059ba454602e71e834d1bdbbbdb",
		  
		  "name": "Yeshua ",
		  "createdDate": "2022-07-16 18:06:58",
		  "totalOrganizations": 14,
		  "totalTours": 16,
		  "totalDays": 659,
		  "totalCountries": 21,
		  "totalStates": 91,
		  "totalEvents": 306,
		  "eventPercent": 0.916251,
		  "totalScheduleItems": 4747,
		  "schedulePercent": 0.946283,
		  "totalGuests": 1254,
		  "guestPercent": 0.88078,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Pavilion at Montage Mountain",
		  "mostGuestCity": "Moosic",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61b58acc7efe4687cb72a45030aed096",
		  
		  "name": "James",
		  "createdDate": "2019-10-21 20:14:33",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 1228,
		  "totalCountries": 13,
		  "totalStates": 63,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 3517,
		  "schedulePercent": 0.882933,
		  "totalGuests": 2559,
		  "guestPercent": 0.970762,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61bd3c318bf0f0027a03033e5a0466c8",
		  
		  "name": "Otto",
		  "createdDate": "2022-02-14 21:27:25",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 107,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 309,
		  "schedulePercent": 0.222235,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Piazza",
		  "mostGuestCity": "Tahkovuori",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61c55c9e88b00b103f91e80e36c1f230",
		  
		  "name": "Drayton",
		  "createdDate": "2022-11-04 17:50:09",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 1638,
		  "schedulePercent": 0.647325,
		  "totalGuests": 795,
		  "guestPercent": 0.80689,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61ce4750720058d6eb31f22643ca1c0f",
		  
		  "name": "Victoria",
		  "createdDate": "2015-09-25 16:45:38",
		  "totalOrganizations": 15,
		  "totalTours": 29,
		  "totalDays": 380,
		  "totalCountries": 19,
		  "totalStates": 47,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 1146,
		  "schedulePercent": 0.533432,
		  "totalGuests": 188,
		  "guestPercent": 0.584882,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Racket NYC",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61d46d0945f3d4c4eecca48959a9f83f",
		  
		  "name": "Team",
		  "createdDate": "2024-03-11 23:32:50",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 232,
		  "totalCountries": 7,
		  "totalStates": 27,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 214,
		  "schedulePercent": 0.168631,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Tico Time River Resort RV Park",
		  "mostGuestCity": "Aztec",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61d5bfea53eb159cc1b9f0b7b68699c7",
		  
		  "name": "Sandro",
		  "createdDate": "2025-10-28 13:11:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61efa08238f7b0c6363c79f3787ba942",
		  
		  "name": "Tanya",
		  "createdDate": "2013-05-28 22:26:34",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 363,
		  "totalCountries": 23,
		  "totalStates": 57,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 3361,
		  "schedulePercent": 0.871827,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61f3ad2a33317c2582750b4ff7fce2ad",
		  
		  "name": "Aaron",
		  "createdDate": "2021-11-12 18:05:40",
		  "totalOrganizations": 6,
		  "totalTours": 31,
		  "totalDays": 690,
		  "totalCountries": 18,
		  "totalStates": 62,
		  "totalEvents": 374,
		  "eventPercent": 0.951609,
		  "totalScheduleItems": 2949,
		  "schedulePercent": 0.836695,
		  "totalGuests": 714,
		  "guestPercent": 0.788985,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "61f7fd0d2a7d5b92b093b471bc46ce19",
		  
		  "name": "Tom",
		  "createdDate": "2024-05-22 20:59:49",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 265,
		  "totalCountries": 12,
		  "totalStates": 9,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 50,
		  "schedulePercent": 0.0601768,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6203aad555637e48e04366250ccdb350",
		  
		  "name": "Trinidad",
		  "createdDate": "2018-03-26 17:03:34",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 679,
		  "totalCountries": 42,
		  "totalStates": 61,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 2394,
		  "schedulePercent": 0.774252,
		  "totalGuests": 1966,
		  "guestPercent": 0.944696,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Kaseya Arena",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "620950a0bd6b00593973f716473138b9",
		  
		  "name": "Evan",
		  "createdDate": "2022-02-25 23:04:56",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 392,
		  "totalCountries": 24,
		  "totalStates": 25,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 1015,
		  "schedulePercent": 0.494674,
		  "totalGuests": 499,
		  "guestPercent": 0.730168,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Nissan Stadium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62134d41259ce1a1a19d04ded09217e7",
		  
		  "name": "Jeremy",
		  "createdDate": "2022-04-07 00:17:02",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 184,
		  "totalCountries": 5,
		  "totalStates": 29,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 982,
		  "schedulePercent": 0.485267,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Soboba Casino Resort",
		  "mostGuestCity": "San Jacinto",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "621428012349038f58cbcb8898634c30",
		  
		  "name": "Billy",
		  "createdDate": "2011-08-30 16:06:40",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 870,
		  "totalCountries": 16,
		  "totalStates": 54,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 5930,
		  "schedulePercent": 0.974841,
		  "totalGuests": 2325,
		  "guestPercent": 0.963282,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62233b8bf9087b1c784b4b8415ec8ebb",
		  
		  "name": "Alix",
		  "createdDate": "2025-03-10 16:13:15",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 438,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 419,
		  "schedulePercent": 0.278105,
		  "totalGuests": 141,
		  "guestPercent": 0.55315,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "The Windjammer",
		  "mostGuestCity": "Isle of Palms",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "622fd68fd436d25585f5b72e0d2d13c6",
		  
		  "name": "Dave",
		  "createdDate": "2017-01-01 22:45:37",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 372,
		  "totalCountries": 29,
		  "totalStates": 58,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1392,
		  "schedulePercent": 0.595648,
		  "totalGuests": 217,
		  "guestPercent": 0.606528,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Pepsi Center WTC",
		  "mostGuestCity": "Benito Juarez",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "623c92be88fc92906c00a3e0b3a09a7b",
		  
		  "name": "Deanna",
		  "createdDate": "2024-02-08 19:42:31",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 134,
		  "totalCountries": 10,
		  "totalStates": 17,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 703,
		  "schedulePercent": 0.388146,
		  "totalGuests": 88,
		  "guestPercent": 0.506686,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Spotlight 29 Casino",
		  "mostGuestCity": "Coachella",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "624590cfa0b10c24e8b7dec413dd0435",
		  
		  "name": "Wilma",
		  "createdDate": "2025-03-27 11:26:39",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 50,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 161,
		  "schedulePercent": 0.136333,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "624989f0dac3a5eb93bdb29084bfc103",
		  
		  "name": "JULIETA",
		  "createdDate": "2025-07-22 13:55:53",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 23,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 186,
		  "schedulePercent": 0.151405,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "624c57680534867bbef52702a96a8293",
		  
		  "name": "Samuli",
		  "createdDate": "2023-01-10 12:38:31",
		  "totalOrganizations": 5,
		  "totalTours": 11,
		  "totalDays": 230,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 1347,
		  "schedulePercent": 0.584655,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Backstage Concerts GmbH",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "625908146757c4843d967425929a41ba",
		  
		  "name": "Lutz",
		  "createdDate": "2019-12-21 00:22:37",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 1040,
		  "totalCountries": 36,
		  "totalStates": 49,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 2677,
		  "schedulePercent": 0.80655,
		  "totalGuests": 350,
		  "guestPercent": 0.675091,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Columbiahalle",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62593079b51c53fb5d179868fbd73efa",
		  
		  "name": "Ash",
		  "createdDate": "2014-09-01 05:23:59",
		  "totalOrganizations": 146,
		  "totalTours": 96,
		  "totalDays": 1515,
		  "totalCountries": 25,
		  "totalStates": 105,
		  "totalEvents": 745,
		  "eventPercent": 0.992294,
		  "totalScheduleItems": 9266,
		  "schedulePercent": 0.9949,
		  "totalGuests": 2421,
		  "guestPercent": 0.965889,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "627103c4d2e4e69ffa02cc2bbbc742b6",
		  
		  "name": "Juan",
		  "createdDate": "2024-02-05 19:27:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 122,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 606,
		  "schedulePercent": 0.353014,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6288ae7bc43f163bfb1536b4ef9a57e8",
		  
		  "name": "Sean",
		  "createdDate": "2013-03-02 18:04:17",
		  "totalOrganizations": 12,
		  "totalTours": 1,
		  "totalDays": 361,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 1079,
		  "schedulePercent": 0.513826,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6296ffad5515d70337935af0ac0daf73",
		  
		  "name": "Dan",
		  "createdDate": "2022-08-25 23:50:13",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 758,
		  "totalCountries": 4,
		  "totalStates": 44,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 2218,
		  "schedulePercent": 0.750907,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62a537c16b462cf868792a0f15830079",
		  
		  "name": "Neal ",
		  "createdDate": "2013-06-12 03:30:06",
		  "totalOrganizations": 20,
		  "totalTours": 7,
		  "totalDays": 694,
		  "totalCountries": 11,
		  "totalStates": 47,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 2171,
		  "schedulePercent": 0.743087,
		  "totalGuests": 367,
		  "guestPercent": 0.679964,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62ac4ade4f0cdfbf735118cee4d01198",
		  
		  "name": "Dave",
		  "createdDate": "2016-03-20 21:52:34",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 420,
		  "totalCountries": 20,
		  "totalStates": 48,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2475,
		  "schedulePercent": 0.784111,
		  "totalGuests": 735,
		  "guestPercent": 0.793178,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Roy Thomson Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62b41867d4cf50b8c429ca490e79725a",
		  
		  "name": "Blippi",
		  "createdDate": "2025-02-14 14:24:09",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 240,
		  "totalCountries": 3,
		  "totalStates": 47,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 2298,
		  "schedulePercent": 0.761559,
		  "totalGuests": 437,
		  "guestPercent": 0.708522,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Terrace Theatre",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62c4a044c376d79340401b9ef3226d65",
		  
		  "name": "Tom",
		  "createdDate": "2024-05-28 10:44:33",
		  "totalOrganizations": 5,
		  "totalTours": 26,
		  "totalDays": 947,
		  "totalCountries": 30,
		  "totalStates": 108,
		  "totalEvents": 282,
		  "eventPercent": 0.899819,
		  "totalScheduleItems": 3628,
		  "schedulePercent": 0.891206,
		  "totalGuests": 1301,
		  "guestPercent": 0.886106,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62d98362ef9a322d86635c71cb135955",
		  
		  "name": "Riley",
		  "createdDate": "2025-03-25 02:45:43",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 121,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1340,
		  "schedulePercent": 0.583749,
		  "totalGuests": 192,
		  "guestPercent": 0.587262,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Historic Scoot Inn",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62dba7ffe229aa9a023cc10a5dcaf29b",
		  
		  "name": "Tommy",
		  "createdDate": "2012-06-08 15:51:02",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 88,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 623,
		  "schedulePercent": 0.358454,
		  "totalGuests": 615,
		  "guestPercent": 0.762693,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lyse Arena",
		  "mostGuestCity": "Stavanger",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62e1315d9d8b397c381eec250e555dc2",
		  
		  "name": "Patrick",
		  "createdDate": "2011-05-17 15:51:53",
		  "totalOrganizations": 21,
		  "totalTours": 45,
		  "totalDays": 2698,
		  "totalCountries": 42,
		  "totalStates": 126,
		  "totalEvents": 781,
		  "eventPercent": 0.99286,
		  "totalScheduleItems": 9895,
		  "schedulePercent": 0.996714,
		  "totalGuests": 4401,
		  "guestPercent": 0.99558,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Cadence Bank Amphitheatre At Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62e6136a0bb34ed0617d572c4341e06e",
		  
		  "name": "Joey",
		  "createdDate": "2023-08-10 20:53:53",
		  "totalOrganizations": 8,
		  "totalTours": 23,
		  "totalDays": 558,
		  "totalCountries": 23,
		  "totalStates": 64,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 2797,
		  "schedulePercent": 0.821623,
		  "totalGuests": 1090,
		  "guestPercent": 0.862307,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62f14151785a8b55cd3fb2d419f0f42a",
		  
		  "name": "Magnus",
		  "createdDate": "2014-06-10 08:58:52",
		  "totalOrganizations": 49,
		  "totalTours": 4,
		  "totalDays": 175,
		  "totalCountries": 5,
		  "totalStates": 4,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 156,
		  "schedulePercent": 0.132706,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Logomo",
		  "mostGuestCity": "Ã…bo",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62f63196384bff89780f90e26f684dd1",
		  
		  "name": "Jakob",
		  "createdDate": "2013-10-03 07:13:20",
		  "totalOrganizations": 47,
		  "totalTours": 25,
		  "totalDays": 840,
		  "totalCountries": 28,
		  "totalStates": 34,
		  "totalEvents": 696,
		  "eventPercent": 0.99116,
		  "totalScheduleItems": 4833,
		  "schedulePercent": 0.948549,
		  "totalGuests": 1604,
		  "guestPercent": 0.920331,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62f733bc26ca187f79b49d890546b693",
		  
		  "name": "ian",
		  "createdDate": "2024-09-18 13:35:13",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 190,
		  "totalCountries": 25,
		  "totalStates": 53,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 686,
		  "schedulePercent": 0.38146,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "62f8d15a2628689d19b5df5020683db4",
		  
		  "name": "Gabriella",
		  "createdDate": "2024-04-02 15:46:10",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 605,
		  "totalCountries": 14,
		  "totalStates": 38,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 722,
		  "schedulePercent": 0.395172,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6301c02a61b708adf83fb6adac32bafa",
		  
		  "name": "Dan",
		  "createdDate": "2013-07-23 05:24:15",
		  "totalOrganizations": 67,
		  "totalTours": 66,
		  "totalDays": 2173,
		  "totalCountries": 29,
		  "totalStates": 103,
		  "totalEvents": 517,
		  "eventPercent": 0.980848,
		  "totalScheduleItems": 6903,
		  "schedulePercent": 0.985721,
		  "totalGuests": 1165,
		  "guestPercent": 0.87296,
		  "mostGuestDate": "2025-08-26 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "630c9ad1a5d0f3e1f81c9962f6af46fd",
		  
		  "name": "Ethan",
		  "createdDate": "2015-01-19 16:21:38",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 736,
		  "totalCountries": 6,
		  "totalStates": 49,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1862,
		  "schedulePercent": 0.687557,
		  "totalGuests": 421,
		  "guestPercent": 0.702969,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63144d8fcd53bf498b06daea04755526",
		  
		  "name": "Ben",
		  "createdDate": "2016-09-14 20:52:23",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 139,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1063,
		  "schedulePercent": 0.507253,
		  "totalGuests": 952,
		  "guestPercent": 0.839755,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Northside Hospital-Cherokee Amphitheater",
		  "mostGuestCity": "Woodstock",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "631f9884e8a0081ca6c2268cd25eb35c",
		  
		  "name": "Ourness",
		  "createdDate": "2025-07-02 04:34:15",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 735,
		  "totalCountries": 21,
		  "totalStates": 47,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1735,
		  "schedulePercent": 0.664778,
		  "totalGuests": 391,
		  "guestPercent": 0.690277,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6326c7ba254009095ae5b9c608f7b94c",
		  
		  "name": "Chris ",
		  "createdDate": "2019-10-21 20:41:24",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 198,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1006,
		  "schedulePercent": 0.49184,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Brentwood Emporium",
		  "mostGuestCity": "Brentwood",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "632ee7e4422832405fc492e4414edf26",
		  
		  "name": "Hossein",
		  "createdDate": "2012-07-20 17:51:58",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "TempleLive at the Columbus Athenaeum",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "632f357bb0cf5fee3eefd8549217f65f",
		  
		  "name": "Chyanne",
		  "createdDate": "2022-03-16 21:07:36",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 329,
		  "totalCountries": 17,
		  "totalStates": 54,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2102,
		  "schedulePercent": 0.733114,
		  "totalGuests": 990,
		  "guestPercent": 0.844062,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Climate Pledge Arena",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "633c7efabe7d94fad1111768cc8a5910",
		  
		  "name": "Sean",
		  "createdDate": "2018-07-26 01:20:01",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 48,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 245,
		  "schedulePercent": 0.186877,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6342cf91a2981aed818377d4d5096e12",
		  
		  "name": "James",
		  "createdDate": "2017-06-30 13:49:24",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 34,
		  "totalCountries": 15,
		  "totalStates": 10,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 470,
		  "schedulePercent": 0.298277,
		  "totalGuests": 93,
		  "guestPercent": 0.511786,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63434d1e6097354952b52118b5df769e",
		  
		  "name": "Tony",
		  "createdDate": "2023-01-08 12:42:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 31,
		  "totalCountries": 9,
		  "totalStates": 13,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 250,
		  "guestPercent": 0.625113,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Heimathafen NeukÃ¶lln",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63473ab1b6f0a9ae94e386b9000af152",
		  
		  "name": "David",
		  "createdDate": "2023-04-20 09:41:59",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 175,
		  "totalCountries": 20,
		  "totalStates": 7,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 922,
		  "schedulePercent": 0.465888,
		  "totalGuests": 214,
		  "guestPercent": 0.604828,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "X-tra",
		  "mostGuestCity": "Zurich",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "634cd3cfb5bab2b0eab26c5cc6e46da1",
		  
		  "name": "Keely ",
		  "createdDate": "2018-10-05 19:43:03",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 276,
		  "totalCountries": 18,
		  "totalStates": 22,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2081,
		  "schedulePercent": 0.729374,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6352555fe8f2dc31b27f62a22a4cfd14",
		  
		  "name": "Regan",
		  "createdDate": "2024-02-14 19:38:24",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 939,
		  "totalCountries": 11,
		  "totalStates": 61,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 2745,
		  "schedulePercent": 0.81573,
		  "totalGuests": 629,
		  "guestPercent": 0.764959,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "636abc1f426cda46e8a562dd2adb9529",
		  
		  "name": "Graham",
		  "createdDate": "2019-07-02 19:36:10",
		  "totalOrganizations": 16,
		  "totalTours": 14,
		  "totalDays": 947,
		  "totalCountries": 10,
		  "totalStates": 48,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 3395,
		  "schedulePercent": 0.874887,
		  "totalGuests": 541,
		  "guestPercent": 0.741047,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Sidney Myer Music Bowl",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6372d79a5b00d130560bf1c6bb57776a",
		  
		  "name": "Dave",
		  "createdDate": "2015-10-14 23:05:39",
		  "totalOrganizations": 11,
		  "totalTours": 2,
		  "totalDays": 194,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 63,
		  "schedulePercent": 0.069243,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Mockingbird Theater & Bar",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "637609de0898a6e92149fb463dfc9def",
		  
		  "name": "Mark",
		  "createdDate": "2025-04-10 01:42:50",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 97,
		  "totalCountries": 20,
		  "totalStates": 37,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 315,
		  "schedulePercent": 0.224841,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63871409a90389f341724f0b8620b380",
		  
		  "name": "Kody",
		  "createdDate": "2015-04-17 17:29:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 91,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6388556f4e8891c1a013036152483422",
		  
		  "name": "COMPANY",
		  "createdDate": "2024-11-26 20:17:38",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 688,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 502,
		  "eventPercent": 0.979034,
		  "totalScheduleItems": 4020,
		  "schedulePercent": 0.914551,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6396b670e143743ff5ee2db600032dd2",
		  
		  "name": "Justin",
		  "createdDate": "2015-07-03 23:50:20",
		  "totalOrganizations": 15,
		  "totalTours": 14,
		  "totalDays": 595,
		  "totalCountries": 24,
		  "totalStates": 75,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2133,
		  "schedulePercent": 0.737194,
		  "totalGuests": 420,
		  "guestPercent": 0.702289,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Michigan Lottery Amphitheatre at Freedom Hill",
		  "mostGuestCity": "Sterling Heights",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6397d511baa336500b59fca94a41168b",
		  
		  "name": "Melody",
		  "createdDate": "2016-02-16 06:43:34",
		  "totalOrganizations": 8,
		  "totalTours": 15,
		  "totalDays": 247,
		  "totalCountries": 12,
		  "totalStates": 34,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 907,
		  "schedulePercent": 0.460789,
		  "totalGuests": 266,
		  "guestPercent": 0.632026,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Croxton Bandroom",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "639e36da9e02248bd24dd0f57b8fedd6",
		  
		  "name": "Aaron",
		  "createdDate": "2017-01-24 06:22:18",
		  "totalOrganizations": 15,
		  "totalTours": 33,
		  "totalDays": 706,
		  "totalCountries": 13,
		  "totalStates": 47,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1413,
		  "schedulePercent": 0.600748,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Paradiso",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63a1d1d8e9d2973eee5f80a3d5d004c4",
		  
		  "name": "Evgenia",
		  "createdDate": "2022-11-15 18:04:35",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 104,
		  "totalCountries": 5,
		  "totalStates": 27,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 812,
		  "schedulePercent": 0.427697,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63a437a914efb92a139d5db580c8e334",
		  
		  "name": "David",
		  "createdDate": "2024-02-12 18:18:32",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 150,
		  "totalCountries": 10,
		  "totalStates": 30,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 698,
		  "schedulePercent": 0.385993,
		  "totalGuests": 108,
		  "guestPercent": 0.527199,
		  "mostGuestDate": "2025-05-12 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63aa8c3ebfeb6c2a5f67a326490e236b",
		  
		  "name": "Tillie",
		  "createdDate": "2025-03-08 11:03:00",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 1451,
		  "totalCountries": 29,
		  "totalStates": 70,
		  "totalEvents": 240,
		  "eventPercent": 0.861854,
		  "totalScheduleItems": 2875,
		  "schedulePercent": 0.829556,
		  "totalGuests": 650,
		  "guestPercent": 0.771872,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63acc1333626c479c0f8401e0bb8fdb3",
		  
		  "name": "Giovambattista",
		  "createdDate": "2024-05-09 14:18:52",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 781,
		  "totalCountries": 2,
		  "totalStates": 39,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 402,
		  "schedulePercent": 0.270739,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63beb3d5075882815592eb321d277b0e",
		  
		  "name": "Cory",
		  "createdDate": "2015-01-06 23:48:58",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 477,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 2134,
		  "schedulePercent": 0.737307,
		  "totalGuests": 1627,
		  "guestPercent": 0.922257,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63c34121d4c3d40b603eede7ef82176e",
		  
		  "name": "Matthew",
		  "createdDate": "2011-02-16 18:33:35",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 1203,
		  "totalCountries": 6,
		  "totalStates": 54,
		  "totalEvents": 244,
		  "eventPercent": 0.86514,
		  "totalScheduleItems": 4112,
		  "schedulePercent": 0.919538,
		  "totalGuests": 763,
		  "guestPercent": 0.798957,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Kresge Auditorium",
		  "mostGuestCity": "Interlochen",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63c341ba04bed438e498f89550bb6d11",
		  
		  "name": "Daniel",
		  "createdDate": "2023-11-21 23:55:11",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 919,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1564,
		  "schedulePercent": 0.6335,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Electric City",
		  "mostGuestCity": "Buffalo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63cdc4a981a329bcbdf6f821783f3403",
		  
		  "name": "NETworks",
		  "createdDate": "2022-07-26 16:21:15",
		  "totalOrganizations": 16,
		  "totalTours": 6,
		  "totalDays": 1166,
		  "totalCountries": 4,
		  "totalStates": 49,
		  "totalEvents": 960,
		  "eventPercent": 0.995467,
		  "totalScheduleItems": 9848,
		  "schedulePercent": 0.996487,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63d07f75cc1771138c6e8e328f479c03",
		  
		  "name": "Natalie",
		  "createdDate": "2025-01-21 17:36:51",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 3076,
		  "totalCountries": 47,
		  "totalStates": 128,
		  "totalEvents": 549,
		  "eventPercent": 0.984134,
		  "totalScheduleItems": 5656,
		  "schedulePercent": 0.970988,
		  "totalGuests": 110,
		  "guestPercent": 0.528105,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "la citadelle",
		  "mostGuestCity": "Marseille",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63d0a5ecd821658f1d85329fa2810db6",
		  
		  "name": "George",
		  "createdDate": "2016-12-19 21:09:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 269,
		  "schedulePercent": 0.198889,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "The Grand Theatre",
		  "mostGuestCity": "Kingston",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63d84c3c919bbf6d69b636004cf9a205",
		  
		  "name": "Nick",
		  "createdDate": "2025-05-12 21:58:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 312,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 490,
		  "schedulePercent": 0.307344,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63dc9897170975a6f7c8c6836d07392b",
		  
		  "name": "Maja",
		  "createdDate": "2023-02-06 10:16:15",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 99,
		  "totalCountries": 12,
		  "totalStates": 16,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 839,
		  "schedulePercent": 0.43699,
		  "totalGuests": 62,
		  "guestPercent": 0.473368,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "OverOslo",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63de77491c1546f7bc2adb272c6414ff",
		  
		  "name": "Heikki",
		  "createdDate": "2011-03-01 15:00:51",
		  "totalOrganizations": 143,
		  "totalTours": 87,
		  "totalDays": 1213,
		  "totalCountries": 6,
		  "totalStates": 3,
		  "totalEvents": 1210,
		  "eventPercent": 0.99728,
		  "totalScheduleItems": 4305,
		  "schedulePercent": 0.931097,
		  "totalGuests": 126,
		  "guestPercent": 0.541364,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63e9da328f3a58add49900b1f0a2a778",
		  
		  "name": "Eric",
		  "createdDate": "2021-08-28 23:19:47",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 953,
		  "totalCountries": 31,
		  "totalStates": 100,
		  "totalEvents": 340,
		  "eventPercent": 0.93665,
		  "totalScheduleItems": 6410,
		  "schedulePercent": 0.981074,
		  "totalGuests": 475,
		  "guestPercent": 0.722348,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63ebf51dadc606283580ab6022e6a230",
		  
		  "name": "Haley",
		  "createdDate": "2021-06-22 21:29:53",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1261,
		  "totalCountries": 11,
		  "totalStates": 47,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 4056,
		  "schedulePercent": 0.916591,
		  "totalGuests": 1781,
		  "guestPercent": 0.93223,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63f30d6df6cee707054a1f058b7d2c8a",
		  
		  "name": "Paul",
		  "createdDate": "2019-11-03 10:15:45",
		  "totalOrganizations": 9,
		  "totalTours": 18,
		  "totalDays": 463,
		  "totalCountries": 16,
		  "totalStates": 49,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 2047,
		  "schedulePercent": 0.722688,
		  "totalGuests": 719,
		  "guestPercent": 0.790345,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "63fcf7da51cfc06337f44f3218ec7bd6",
		  
		  "name": "Chris",
		  "createdDate": "2016-01-09 11:09:43",
		  "totalOrganizations": 10,
		  "totalTours": 32,
		  "totalDays": 238,
		  "totalCountries": 5,
		  "totalStates": 39,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 2173,
		  "schedulePercent": 0.743427,
		  "totalGuests": 846,
		  "guestPercent": 0.818903,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Germania Insurance Amphitheater",
		  "mostGuestCity": "Del Valle",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "640049c07411bb66a9a11a171965456a",
		  
		  "name": "Mary",
		  "createdDate": "2025-03-18 13:57:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 173,
		  "schedulePercent": 0.142452,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Capitol Theatre",
		  "mostGuestCity": "Port Chester",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "640823ff2d6b715b844a142b58071462",
		  
		  "name": "Lewis",
		  "createdDate": "2012-12-28 15:53:38",
		  "totalOrganizations": 17,
		  "totalTours": 8,
		  "totalDays": 101,
		  "totalCountries": 11,
		  "totalStates": 15,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 324,
		  "schedulePercent": 0.228354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6417c98363d8a9ba00c2756d25f47544",
		  
		  "name": "David",
		  "createdDate": "2017-07-02 13:09:45",
		  "totalOrganizations": 24,
		  "totalTours": 20,
		  "totalDays": 1763,
		  "totalCountries": 44,
		  "totalStates": 96,
		  "totalEvents": 403,
		  "eventPercent": 0.959429,
		  "totalScheduleItems": 3889,
		  "schedulePercent": 0.907865,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The Axis Club Theatre",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6419fe30e2f5c2037e0a24da8a0143ba",
		  
		  "name": "Tristan",
		  "createdDate": "2019-04-25 00:15:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 14,
		  "totalStates": 37,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 866,
		  "schedulePercent": 0.447303,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "DR Koncerthuset",
		  "mostGuestCity": "Kobenhavn",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "641a2549512addffa6aa63d165ea1560",
		  
		  "name": "Grady",
		  "createdDate": "2018-12-21 06:52:05",
		  "totalOrganizations": 42,
		  "totalTours": 48,
		  "totalDays": 2766,
		  "totalCountries": 23,
		  "totalStates": 69,
		  "totalEvents": 390,
		  "eventPercent": 0.956029,
		  "totalScheduleItems": 4885,
		  "schedulePercent": 0.950816,
		  "totalGuests": 1004,
		  "guestPercent": 0.847008,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "The Night Cat",
		  "mostGuestCity": "Fitzroy",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "641bbd6351950aa5c277acf01c353d0c",
		  
		  "name": "Nicholas",
		  "createdDate": "2023-10-30 23:07:31",
		  "totalOrganizations": 9,
		  "totalTours": 2,
		  "totalDays": 62,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 436,
		  "schedulePercent": 0.284338,
		  "totalGuests": 331,
		  "guestPercent": 0.666364,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Velvet Underground",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6422b785389e1636fb70fe1a93dd3d69",
		  
		  "name": "David",
		  "createdDate": "2017-09-19 17:12:00",
		  "totalOrganizations": 19,
		  "totalTours": 9,
		  "totalDays": 146,
		  "totalCountries": 10,
		  "totalStates": 28,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 762,
		  "schedulePercent": 0.409565,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64245093d1a156cca4b4e018b2e43b05",
		  
		  "name": "Carlos",
		  "createdDate": "2019-11-26 00:15:04",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 765,
		  "totalCountries": 10,
		  "totalStates": 36,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64257a2a4e285ed1bdf6a6c17777e30d",
		  
		  "name": "FLAVE",
		  "createdDate": "2016-02-27 18:13:04",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 247,
		  "totalCountries": 13,
		  "totalStates": 21,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1516,
		  "schedulePercent": 0.620807,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "The Fillmore New Orleans",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "642a5ddaaaa46ac85d8c1e1aba172ed9",
		  
		  "name": "Marjan",
		  "createdDate": "2025-03-17 20:16:56",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 47,
		  "totalCountries": 14,
		  "totalStates": 19,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 438,
		  "schedulePercent": 0.285131,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Shepherd's Bush Empire",
		  "mostGuestCity": "Shepherd's Bush",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64371c5415eb749f1c4a93ec262e3a41",
		  
		  "name": "Jay",
		  "createdDate": "2010-02-12 18:52:02",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 588,
		  "totalCountries": 8,
		  "totalStates": 49,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 2175,
		  "schedulePercent": 0.744107,
		  "totalGuests": 1529,
		  "guestPercent": 0.913191,
		  "mostGuestDate": "2025-07-16 00:00:00",
		  "mostGuestName": "The Criterion",
		  "mostGuestCity": "Oklahoma City",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6460ed34f5721b142e622548f3bca919",
		  
		  "name": "Email",
		  "createdDate": "2016-10-05 04:03:30",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 616,
		  "totalCountries": 7,
		  "totalStates": 42,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1177,
		  "schedulePercent": 0.541364,
		  "totalGuests": 1583,
		  "guestPercent": 0.917951,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Radio City Music Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 191,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6474003b315b4231ace0db7e480f9e7c",
		  
		  "name": "Liam",
		  "createdDate": "2023-05-02 15:47:54",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 174,
		  "totalCountries": 5,
		  "totalStates": 9,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 1243,
		  "schedulePercent": 0.558704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6474942e6fca4b9bce7939884956e2fd",
		  
		  "name": "Sarah",
		  "createdDate": "2023-10-17 02:36:09",
		  "totalOrganizations": 13,
		  "totalTours": 22,
		  "totalDays": 573,
		  "totalCountries": 14,
		  "totalStates": 68,
		  "totalEvents": 261,
		  "eventPercent": 0.88248,
		  "totalScheduleItems": 3773,
		  "schedulePercent": 0.900385,
		  "totalGuests": 1482,
		  "guestPercent": 0.907752,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64761624621ddb3cbadd11ae20c82f91",
		  
		  "name": "Neal",
		  "createdDate": "2018-10-10 19:44:20",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 1350,
		  "totalCountries": 7,
		  "totalStates": 46,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1371,
		  "schedulePercent": 0.589529,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "647c6d0499879b07887cb8e5271444fe",
		  
		  "name": "Jim",
		  "createdDate": "2014-09-22 18:26:27",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 496,
		  "schedulePercent": 0.310403,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "Lori's Roadhouse",
		  "mostGuestCity": "West Chester Township",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6480d690b49ef9e40d05158616a6c825",
		  
		  "name": "Dan",
		  "createdDate": "2013-01-11 22:58:57",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 133,
		  "schedulePercent": 0.120467,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6488a75818b4de6e8fc7bed3a7915f33",
		  
		  "name": "Tobi",
		  "createdDate": "2023-04-01 17:45:55",
		  "totalOrganizations": 8,
		  "totalTours": 17,
		  "totalDays": 352,
		  "totalCountries": 25,
		  "totalStates": 63,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 2094,
		  "schedulePercent": 0.731754,
		  "totalGuests": 816,
		  "guestPercent": 0.812557,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "648b5fa7ad85145801ce849f0efda90e",
		  
		  "name": "Jimi",
		  "createdDate": "2019-02-15 10:50:53",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 230,
		  "totalCountries": 20,
		  "totalStates": 28,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 294,
		  "guestPercent": 0.646532,
		  "mostGuestDate": "2025-05-06 00:00:00",
		  "mostGuestName": "ZAG Arena",
		  "mostGuestCity": "Hannover",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6492db6d6a2e84b6bfa7e615711ee123",
		  
		  "name": "Michael",
		  "createdDate": "2024-11-24 15:59:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 2,
		  "totalStates": 42,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1088,
		  "schedulePercent": 0.517452,
		  "totalGuests": 763,
		  "guestPercent": 0.798957,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "John T. Floore's Country Store",
		  "mostGuestCity": "Helotes",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64952a4b42f63d3b33f77aa643e76890",
		  
		  "name": "Hasse",
		  "createdDate": "2022-02-17 21:04:07",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 49,
		  "totalCountries": 6,
		  "totalStates": 5,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 253,
		  "schedulePercent": 0.191976,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "MalmÃ¶ Arena",
		  "mostGuestCity": "MalmÃ¶",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "649ac27498c1ad06bec5564f8014296b",
		  
		  "name": "PATINA",
		  "createdDate": "2022-01-24 17:38:02",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 714,
		  "schedulePercent": 0.391772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "649c437c57a934c789edce8b4f86d300",
		  
		  "name": "Shannon",
		  "createdDate": "2021-10-13 17:13:03",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 510,
		  "totalCountries": 12,
		  "totalStates": 60,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 3594,
		  "schedulePercent": 0.888599,
		  "totalGuests": 804,
		  "guestPercent": 0.80859,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64b0d4dc6f66d6e6380a4e2fc5347eef",
		  
		  "name": "Robin",
		  "createdDate": "2016-01-24 18:39:23",
		  "totalOrganizations": 22,
		  "totalTours": 36,
		  "totalDays": 1012,
		  "totalCountries": 30,
		  "totalStates": 99,
		  "totalEvents": 451,
		  "eventPercent": 0.971215,
		  "totalScheduleItems": 6929,
		  "schedulePercent": 0.986061,
		  "totalGuests": 3536,
		  "guestPercent": 0.990027,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64bf06bdfa5449345c588d3e020ade1f",
		  
		  "name": "Edward",
		  "createdDate": "2024-01-17 13:50:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 122,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 342,
		  "schedulePercent": 0.239914,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64ca54d8702dc991ed35653b882e5c96",
		  
		  "name": "Rob",
		  "createdDate": "2023-10-27 20:59:21",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 375,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 740,
		  "schedulePercent": 0.401519,
		  "totalGuests": 651,
		  "guestPercent": 0.771985,
		  "mostGuestDate": "2025-11-07 00:00:00",
		  "mostGuestName": "KAOS",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64d11306f57074822c02a9f1b9de1018",
		  
		  "name": "Brent",
		  "createdDate": "2022-04-13 00:36:57",
		  "totalOrganizations": 20,
		  "totalTours": 19,
		  "totalDays": 341,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1202,
		  "schedulePercent": 0.547597,
		  "totalGuests": 569,
		  "guestPercent": 0.749773,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The Fillmore Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64d5eaf387a5449a3f497a477b74c6d3",
		  
		  "name": "Jake",
		  "createdDate": "2019-08-17 17:22:25",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 376,
		  "totalCountries": 4,
		  "totalStates": 11,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 143,
		  "schedulePercent": 0.12704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64e02e96928cd5546f8416f9d7739372",
		  
		  "name": "Jonathan",
		  "createdDate": "2023-05-11 12:47:22",
		  "totalOrganizations": 13,
		  "totalTours": 14,
		  "totalDays": 1827,
		  "totalCountries": 22,
		  "totalStates": 33,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 2729,
		  "schedulePercent": 0.81301,
		  "totalGuests": 540,
		  "guestPercent": 0.740594,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Camp Bestival",
		  "mostGuestCity": "East Lulworth",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64e24c6cf3604de7cf8db1520c7093b3",
		  
		  "name": "Lee",
		  "createdDate": "2012-02-22 14:35:17",
		  "totalOrganizations": 25,
		  "totalTours": 23,
		  "totalDays": 1245,
		  "totalCountries": 53,
		  "totalStates": 100,
		  "totalEvents": 346,
		  "eventPercent": 0.940503,
		  "totalScheduleItems": 5308,
		  "schedulePercent": 0.962489,
		  "totalGuests": 575,
		  "guestPercent": 0.75102,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "SSE Arena Belfast",
		  "mostGuestCity": "Belfast",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64e3792b4c8f24c15329a5febe88eff7",
		  
		  "name": "Mafer",
		  "createdDate": "2025-07-24 20:40:47",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 67,
		  "totalCountries": 13,
		  "totalStates": 15,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64e9c30575fd12a3b2277e9d7c1e5513",
		  
		  "name": "Shelley",
		  "createdDate": "2013-06-16 20:11:00",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 670,
		  "totalCountries": 6,
		  "totalStates": 35,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1450,
		  "schedulePercent": 0.607321,
		  "totalGuests": 221,
		  "guestPercent": 0.607774,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64ea5175654c4e07cc1e001f8d71c153",
		  
		  "name": "Jason",
		  "createdDate": "2014-10-04 00:25:55",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 857,
		  "totalCountries": 19,
		  "totalStates": 47,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 2163,
		  "schedulePercent": 0.7415,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "64eb94dabaf82a26a846a3e67da7630d",
		  
		  "name": "Jackie",
		  "createdDate": "2012-11-23 02:47:40",
		  "totalOrganizations": 6,
		  "totalTours": 26,
		  "totalDays": 477,
		  "totalCountries": 11,
		  "totalStates": 51,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 1308,
		  "schedulePercent": 0.573323,
		  "totalGuests": 381,
		  "guestPercent": 0.686197,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "650778f4c38468749e85c0e3cbf99959",
		  
		  "name": "Eddie ",
		  "createdDate": "2019-03-08 06:37:35",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 361,
		  "totalCountries": 11,
		  "totalStates": 32,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 2096,
		  "schedulePercent": 0.732208,
		  "totalGuests": 766,
		  "guestPercent": 0.800091,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "653d00e56c8af4c0ad057d843334c408",
		  
		  "name": "Brady",
		  "createdDate": "2024-03-26 00:44:35",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 185,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 821,
		  "schedulePercent": 0.431324,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "The Foundry",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65655cd18d933fc62895ddb2bd6fcece",
		  
		  "name": "Olli",
		  "createdDate": "2018-03-06 19:08:16",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 110,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 527,
		  "schedulePercent": 0.325136,
		  "totalGuests": 408,
		  "guestPercent": 0.69685,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "656c0a534affdff194fcea1c51323f9f",
		  
		  "name": "Thibault",
		  "createdDate": "2019-11-28 14:31:20",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 388,
		  "totalCountries": 15,
		  "totalStates": 35,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1328,
		  "schedulePercent": 0.578989,
		  "totalGuests": 219,
		  "guestPercent": 0.607321,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "656d495d9a2dbc2724e086c4a5e4976f",
		  
		  "name": "John",
		  "createdDate": "2013-01-16 14:30:32",
		  "totalOrganizations": 24,
		  "totalTours": 34,
		  "totalDays": 724,
		  "totalCountries": 22,
		  "totalStates": 96,
		  "totalEvents": 325,
		  "eventPercent": 0.93053,
		  "totalScheduleItems": 4973,
		  "schedulePercent": 0.953309,
		  "totalGuests": 1051,
		  "guestPercent": 0.854374,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6571efd956563dbe1b43a048bf12498c",
		  
		  "name": "Arne",
		  "createdDate": "2021-11-17 13:11:33",
		  "totalOrganizations": 6,
		  "totalTours": 34,
		  "totalDays": 1088,
		  "totalCountries": 19,
		  "totalStates": 39,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 1756,
		  "schedulePercent": 0.669538,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Lille Grand Palais",
		  "mostGuestCity": "Lille",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "657b0ca098df8441a9760925a18181e4",
		  
		  "name": "Randy",
		  "createdDate": "2019-03-04 23:48:56",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 1038,
		  "totalCountries": 3,
		  "totalStates": 52,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 2203,
		  "schedulePercent": 0.748187,
		  "totalGuests": 287,
		  "guestPercent": 0.642906,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Ford Amphitheater",
		  "mostGuestCity": "Colorado Springs",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "657caaeb6ebd33b95445879344fb24d4",
		  
		  "name": "Kevin",
		  "a_nickname": "\"Tom\"",
		  "createdDate": "2010-10-17 08:38:34",
		  "totalOrganizations": 32,
		  "totalTours": 22,
		  "totalDays": 962,
		  "totalCountries": 21,
		  "totalStates": 79,
		  "totalEvents": 368,
		  "eventPercent": 0.949116,
		  "totalScheduleItems": 5969,
		  "schedulePercent": 0.975408,
		  "totalGuests": 4814,
		  "guestPercent": 0.997167,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "657d609ab8333019ab95975a44ded415",
		  
		  "name": "Jonas",
		  "createdDate": "2025-10-24 07:24:41",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 46,
		  "totalCountries": 1,
		  "totalStates": 11,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 189,
		  "schedulePercent": 0.152539,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "657e170d050f0aa5d966bc9406301258",
		  
		  "name": "Aroha",
		  "createdDate": "2021-11-04 19:35:35",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 199,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "658487dc10de60b244a4b66c0bd04558",
		  
		  "name": "Brigit",
		  "createdDate": "2021-12-08 14:29:00",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 650,
		  "totalCountries": 20,
		  "totalStates": 51,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 2445,
		  "schedulePercent": 0.780372,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Amaze Festival",
		  "mostGuestCity": "SmÃ¶gen",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6586d638cb0f803aef40a99f9c467a9c",
		  
		  "name": "John",
		  "createdDate": "2022-09-09 13:51:45",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 506,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1799,
		  "schedulePercent": 0.675884,
		  "totalGuests": 1295,
		  "guestPercent": 0.885653,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Daily's Place Amphitheater",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6595d75b786bb15f4ab1808bfd8f98d5",
		  
		  "name": "Brian",
		  "createdDate": "2013-06-29 04:58:21",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 814,
		  "totalCountries": 32,
		  "totalStates": 57,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 4776,
		  "schedulePercent": 0.946963,
		  "totalGuests": 1409,
		  "guestPercent": 0.900952,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "659c46cc48c23b3b5485a1866cbd7c71",
		  
		  "name": "Austin",
		  "createdDate": "2021-08-25 18:56:11",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 297,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 811,
		  "schedulePercent": 0.427357,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "659e80b1b3762bba9964527dbd1810b3",
		  
		  "name": "max",
		  "createdDate": "2025-02-19 23:34:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 204,
		  "totalCountries": 11,
		  "totalStates": 20,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 230,
		  "schedulePercent": 0.177697,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65a21c509e1afe7cf6b4a1c8862804e5",
		  
		  "name": "Carl",
		  "createdDate": "2022-04-26 21:28:35",
		  "totalOrganizations": 16,
		  "totalTours": 12,
		  "totalDays": 1859,
		  "totalCountries": 39,
		  "totalStates": 62,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 4084,
		  "schedulePercent": 0.917724,
		  "totalGuests": 584,
		  "guestPercent": 0.75442,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Dreamland Margate - Scenic Stage",
		  "mostGuestCity": "Margate",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65a87b68ce73737b2c6418c3022b110c",
		  
		  "name": "Matthieu",
		  "createdDate": "2015-03-31 16:18:38",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 105,
		  "totalCountries": 4,
		  "totalStates": 31,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 420,
		  "schedulePercent": 0.278332,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65ad2234aa9fa600499bbe378f788701",
		  
		  "name": "Braden",
		  "createdDate": "2025-02-21 00:53:14",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 48,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65bccf7881c170eb8a0684d35375def2",
		  
		  "name": "Anders",
		  "createdDate": "2015-06-23 08:12:07",
		  "totalOrganizations": 48,
		  "totalTours": 40,
		  "totalDays": 500,
		  "totalCountries": 20,
		  "totalStates": 32,
		  "totalEvents": 400,
		  "eventPercent": 0.958409,
		  "totalScheduleItems": 2790,
		  "schedulePercent": 0.820943,
		  "totalGuests": 129,
		  "guestPercent": 0.543518,
		  "mostGuestDate": "2025-02-05 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65be5acbf2704c59f5e6ee7eee225dc7",
		  
		  "name": "Drew",
		  "createdDate": "2011-06-14 13:52:40",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 850,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 3025,
		  "schedulePercent": 0.844402,
		  "totalGuests": 1689,
		  "guestPercent": 0.927697,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65c44fd62330fab231b00c86c07275e9",
		  
		  "name": "Eli",
		  "createdDate": "2023-07-28 14:30:53",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 260,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 865,
		  "schedulePercent": 0.446623,
		  "totalGuests": 487,
		  "guestPercent": 0.726768,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "The Factory",
		  "mostGuestCity": "Chesterfield",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65c53df3b1aa1ffdfda1e12490696ed8",
		  
		  "name": "Jake",
		  "createdDate": "2018-02-13 18:44:09",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 420,
		  "totalCountries": 5,
		  "totalStates": 59,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 2277,
		  "schedulePercent": 0.75884,
		  "totalGuests": 329,
		  "guestPercent": 0.665685,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Seminole Hard Rock Hotel & Casino Hollywood",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65cb095349e539b4b51536e4439adfbd",
		  
		  "name": "Hayley",
		  "createdDate": "2016-12-23 20:12:29",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 769,
		  "totalCountries": 15,
		  "totalStates": 42,
		  "totalEvents": 285,
		  "eventPercent": 0.901859,
		  "totalScheduleItems": 4990,
		  "schedulePercent": 0.954102,
		  "totalGuests": 1579,
		  "guestPercent": 0.917498,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65e2e4f4dd80ee1fa1f633000d2f4ada",
		  
		  "name": "Clare",
		  "createdDate": "2020-01-25 01:02:22",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 189,
		  "schedulePercent": 0.152539,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65f23fb75a87948f8e3080201d3c6294",
		  
		  "name": "Lindsey",
		  "createdDate": "2013-08-12 20:27:57",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 1215,
		  "totalCountries": 8,
		  "totalStates": 55,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 3181,
		  "schedulePercent": 0.858001,
		  "totalGuests": 854,
		  "guestPercent": 0.82049,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "65fdc9b00b2f9ea0327c246b3b5f0001",
		  
		  "name": "Laurie ",
		  "createdDate": "2023-02-28 13:59:01",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 252,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66072cea2c71941b5c35124de48ec1d7",
		  
		  "name": "Piya",
		  "createdDate": "2023-01-21 23:01:59",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 97,
		  "totalCountries": 11,
		  "totalStates": 25,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 302,
		  "schedulePercent": 0.218268,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Griffin House Inc",
		  "mostGuestCity": "Palenville",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "661000f7e743030592b7325e1c92a168",
		  
		  "name": "Miguel",
		  "createdDate": "2015-01-15 01:13:50",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 98,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 972,
		  "schedulePercent": 0.481981,
		  "totalGuests": 1051,
		  "guestPercent": 0.854374,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Byline Bank Aragon Ballroom",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6618510bbc7e23a117af289628b16934",
		  
		  "name": "LARRY",
		  "createdDate": "2024-03-31 22:27:44",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 59,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 303,
		  "schedulePercent": 0.218608,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "Levon Helm Studios",
		  "mostGuestCity": "Woodstock",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "661d534d911e634df3c42bfbd0d50a1c",
		  
		  "name": "Lucy",
		  "createdDate": "2023-08-22 21:20:44",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 455,
		  "totalCountries": 25,
		  "totalStates": 25,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1911,
		  "schedulePercent": 0.696736,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66219cd29492d55116df380a47de1e54",
		  
		  "name": "Gavin",
		  "createdDate": "2014-10-31 19:39:59",
		  "totalOrganizations": 18,
		  "totalTours": 8,
		  "totalDays": 226,
		  "totalCountries": 18,
		  "totalStates": 32,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 790,
		  "schedulePercent": 0.418971,
		  "totalGuests": 129,
		  "guestPercent": 0.543518,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Glass House",
		  "mostGuestCity": "Pomona",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6626c141322e694ce4f670fcac6d079e",
		  
		  "name": "Kamryn ",
		  "createdDate": "2022-03-08 17:14:15",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 808,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 2181,
		  "schedulePercent": 0.745127,
		  "totalGuests": 534,
		  "guestPercent": 0.738441,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "662729d64aaf0471e476d10ea0b7b1bd",
		  
		  "name": "Niles",
		  "createdDate": "2012-02-01 01:31:01",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 587,
		  "totalCountries": 25,
		  "totalStates": 52,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 3293,
		  "schedulePercent": 0.867634,
		  "totalGuests": 389,
		  "guestPercent": 0.68971,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66320851a6f6a051b102583c0a57d251",
		  
		  "name": "John",
		  "createdDate": "2011-01-31 07:48:04",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 188,
		  "totalCountries": 16,
		  "totalStates": 38,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 730,
		  "schedulePercent": 0.397892,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "3Ten Austin City Limits",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66323f0bbf1a5b38c568716f8e857cbe",
		  
		  "name": "Joey",
		  "createdDate": "2018-02-13 19:50:25",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 1573,
		  "totalCountries": 17,
		  "totalStates": 52,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 1941,
		  "schedulePercent": 0.702403,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Los Angeles State Historic Park",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6634ea5c98d1022da68d76bc9024ff9b",
		  
		  "name": "Sonya",
		  "createdDate": "2021-10-27 18:58:49",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 398,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1204,
		  "schedulePercent": 0.547824,
		  "totalGuests": 435,
		  "guestPercent": 0.707616,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Cadence Bank Amphitheatre At Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6637d79111f824f1488fb82730aa9bd9",
		  
		  "name": "Camilo",
		  "createdDate": "2023-01-17 18:19:40",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 133,
		  "totalCountries": 9,
		  "totalStates": 21,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6643d0c14f59236264d7454e9fdd6dcf",
		  
		  "name": "Adam",
		  "createdDate": "2014-12-05 00:02:34",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 310,
		  "totalCountries": 8,
		  "totalStates": 25,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2169,
		  "schedulePercent": 0.742634,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "664fc56f2b35d5aba9b7dfde138f754c",
		  
		  "name": "Luke",
		  "createdDate": "2009-12-29 23:10:01",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 666,
		  "totalCountries": 22,
		  "totalStates": 79,
		  "totalEvents": 312,
		  "eventPercent": 0.920671,
		  "totalScheduleItems": 6443,
		  "schedulePercent": 0.981188,
		  "totalGuests": 1941,
		  "guestPercent": 0.94209,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Cardiff Utilita Arena",
		  "mostGuestCity": "Cardiff",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66568550cca51cdc76a06c6e1504181f",
		  
		  "name": "Steven",
		  "createdDate": "2009-07-03 17:01:42",
		  "totalOrganizations": 2,
		  "totalTours": 18,
		  "totalDays": 327,
		  "totalCountries": 13,
		  "totalStates": 58,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 2935,
		  "schedulePercent": 0.835449,
		  "totalGuests": 1053,
		  "guestPercent": 0.855168,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "665dace984fc067eb0a2c8db4d5a457d",
		  
		  "name": "Yori",
		  "createdDate": "2018-11-02 15:08:23",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 77,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-11-04 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "665dc124e67071257dda28f9b5782c07",
		  
		  "name": "Zeke",
		  "createdDate": "2014-01-15 20:57:35",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 4,
		  "totalStates": 31,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 927,
		  "schedulePercent": 0.467362,
		  "totalGuests": 169,
		  "guestPercent": 0.573096,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Daily's Place",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66658f3f97481a5fe99c805c299283ce",
		  
		  "name": "Shannon ",
		  "createdDate": "2023-11-01 22:35:20",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 160,
		  "totalCountries": 13,
		  "totalStates": 25,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 545,
		  "schedulePercent": 0.332162,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "666b13c4470ebbe61648b952ec4af0f9",
		  
		  "name": "Alex",
		  "createdDate": "2024-07-23 14:20:50",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 77,
		  "totalCountries": 8,
		  "totalStates": 14,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 220,
		  "schedulePercent": 0.171578,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "666b9d56e68dda2c08b67a3fcf53f03d",
		  
		  "name": "Renan",
		  "createdDate": "2018-12-04 21:49:18",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 82,
		  "totalCountries": 10,
		  "totalStates": 18,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 225,
		  "schedulePercent": 0.174524,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "The Cluny 2",
		  "mostGuestCity": "Ouseburn",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "666cc2c25e3897698d0639c17e82c349",
		  
		  "name": "Kay ",
		  "createdDate": "2022-06-21 13:33:25",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 21,
		  "totalStates": 37,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1245,
		  "schedulePercent": 0.55927,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "douglass park",
		  "mostGuestCity": "",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66838c13e793eeb5be53569c92f05018",
		  
		  "name": "Alan",
		  "createdDate": "2024-06-18 23:25:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 98,
		  "totalCountries": 16,
		  "totalStates": 29,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 748,
		  "schedulePercent": 0.404125,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Treasure Island Amphitheater",
		  "mostGuestCity": "Welch",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "668e0f715b07b667e6df5aeddd759e8d",
		  
		  "name": "Nick",
		  "createdDate": "2017-08-11 08:12:11",
		  "totalOrganizations": 8,
		  "totalTours": 15,
		  "totalDays": 456,
		  "totalCountries": 10,
		  "totalStates": 11,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1010,
		  "schedulePercent": 0.493314,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "668e471cc95d2b27de74fd98ce332cfd",
		  
		  "name": "Rob",
		  "createdDate": "2018-07-20 16:35:46",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 868,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 989,
		  "schedulePercent": 0.487874,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Jubilee Auditorium",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66949e78025e7f0701c1625ca1caf8ac",
		  
		  "name": "Larissa",
		  "createdDate": "2016-09-15 18:56:48",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 456,
		  "totalCountries": 30,
		  "totalStates": 63,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 4644,
		  "schedulePercent": 0.94243,
		  "totalGuests": 3553,
		  "guestPercent": 0.990254,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "669b4a3708a5acf45fb32fcf1cbac9dd",
		  
		  "name": "Clay",
		  "createdDate": "2017-06-03 14:41:54",
		  "totalOrganizations": 14,
		  "totalTours": 16,
		  "totalDays": 892,
		  "totalCountries": 30,
		  "totalStates": 66,
		  "totalEvents": 293,
		  "eventPercent": 0.908092,
		  "totalScheduleItems": 6607,
		  "schedulePercent": 0.983341,
		  "totalGuests": 1354,
		  "guestPercent": 0.893472,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66a394120e7793a9aeea890881e9ee7e",
		  
		  "name": "Marci",
		  "createdDate": "2021-06-02 01:59:59",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 806,
		  "totalCountries": 11,
		  "totalStates": 49,
		  "totalEvents": 202,
		  "eventPercent": 0.804397,
		  "totalScheduleItems": 2626,
		  "schedulePercent": 0.800544,
		  "totalGuests": 1909,
		  "guestPercent": 0.940503,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66ac6632c6dde276741976aeb2a7eb2c",
		  
		  "name": "Richard",
		  "createdDate": "2011-10-09 18:37:02",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 389,
		  "totalCountries": 20,
		  "totalStates": 20,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66b2e130a01f5e3b35571970127f2c4f",
		  
		  "name": "Larry",
		  "createdDate": "2024-01-10 18:56:02",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 1159,
		  "totalCountries": 34,
		  "totalStates": 50,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 4068,
		  "schedulePercent": 0.917271,
		  "totalGuests": 1261,
		  "guestPercent": 0.8818,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 263,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66b3fa822d3b5629486a787d7a4290b6",
		  
		  "name": "Kelly",
		  "createdDate": "2019-03-31 18:31:38",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 699,
		  "totalCountries": 4,
		  "totalStates": 47,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2985,
		  "schedulePercent": 0.841342,
		  "totalGuests": 228,
		  "guestPercent": 0.611514,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "House of Blues Boston",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66d3b79e519636ad917548f96d1e2dcd",
		  
		  "name": "Rob",
		  "createdDate": "2023-02-21 19:56:12",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 226,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 685,
		  "schedulePercent": 0.381006,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66dfcd575d65ea6e371bd6a0633cc4d5",
		  
		  "name": "Hayden",
		  "createdDate": "2015-11-10 11:40:00",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 6,
		  "totalStates": 26,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 323,
		  "schedulePercent": 0.228014,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66e88c5b8673b97e5b78e6697db3b74c",
		  
		  "name": "Tasha",
		  "createdDate": "2017-05-15 19:30:36",
		  "totalOrganizations": 3,
		  "totalTours": 11,
		  "totalDays": 502,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1076,
		  "schedulePercent": 0.512466,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66f1c8eed591f024583ac2a989ddb3f4",
		  
		  "name": "Eddie",
		  "createdDate": "2013-06-09 00:32:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 957,
		  "schedulePercent": 0.478014,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Harbison Theatre at Midlands Technical College",
		  "mostGuestCity": "Irmo",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66f2d695e97f92584ed519be25aa58da",
		  
		  "name": "Gwen",
		  "createdDate": "2023-06-16 15:21:08",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 338,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 109,
		  "schedulePercent": 0.105054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "66f751f379eae13e74e236752f9db490",
		  
		  "name": "David",
		  "createdDate": "2016-10-18 22:32:45",
		  "totalOrganizations": 18,
		  "totalTours": 12,
		  "totalDays": 1502,
		  "totalCountries": 27,
		  "totalStates": 53,
		  "totalEvents": 285,
		  "eventPercent": 0.901859,
		  "totalScheduleItems": 3703,
		  "schedulePercent": 0.896192,
		  "totalGuests": 818,
		  "guestPercent": 0.81267,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Carnegie Hall - Stern Auditorium | Perelman Stage",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "671b7b45626742d4769878683a171587",
		  
		  "name": "Christina",
		  "createdDate": "2023-05-22 21:05:04",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 371,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 393,
		  "schedulePercent": 0.266432,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Soaring Eagle Casino",
		  "mostGuestCity": "Mt Pleasant",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "671ce5d35d4b51cb9f0a83e384163f5c",
		  
		  "name": " Damien",
		  "createdDate": "2023-04-01 13:33:39",
		  "totalOrganizations": 10,
		  "totalTours": 16,
		  "totalDays": 311,
		  "totalCountries": 6,
		  "totalStates": 21,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1126,
		  "schedulePercent": 0.526859,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "671d4ddc10dc5d17967367b94a3411f8",
		  
		  "name": "Frank",
		  "createdDate": "2016-01-13 15:26:42",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 34,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "672110531e3354e12faa1b85b394dd11",
		  
		  "name": "Torill",
		  "createdDate": "2018-04-11 10:00:57",
		  "totalOrganizations": 9,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 119,
		  "schedulePercent": 0.110041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67295253ec2cfe0490d1358da7369db7",
		  
		  "name": "Todd",
		  "createdDate": "2016-06-01 19:13:12",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 502,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 1885,
		  "schedulePercent": 0.692203,
		  "totalGuests": 1510,
		  "guestPercent": 0.910358,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 157,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "676bea6906b13f0e702010cbe22fce46",
		  
		  "name": "Titti",
		  "createdDate": "2018-01-29 16:43:18",
		  "totalOrganizations": 70,
		  "totalTours": 10,
		  "totalDays": 253,
		  "totalCountries": 26,
		  "totalStates": 62,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2015,
		  "schedulePercent": 0.716455,
		  "totalGuests": 1375,
		  "guestPercent": 0.896645,
		  "mostGuestDate": "2025-06-16 00:00:00",
		  "mostGuestName": "Cavea Auditorium",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6775ec30dfdc8fdb2f2f58ac3eca1864",
		  
		  "name": "YANN",
		  "createdDate": "2025-02-19 17:11:44",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 101,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 615,
		  "schedulePercent": 0.355734,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "677a1b750a3e8549e8880b48ddafd5a8",
		  
		  "name": "Casey",
		  "createdDate": "2022-06-30 01:35:18",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 113,
		  "schedulePercent": 0.106754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "677cf62c4967037870504d8111754927",
		  
		  "name": "The",
		  "createdDate": "2022-09-29 11:30:00",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 80,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 383,
		  "schedulePercent": 0.259859,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "FIRST UNITARIAN CHURCH OF PHILADELPHIA",
		  "mostGuestCity": "PHILADELPHIA",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "677d7bb51f36307a2f55f5744e1e060a",
		  
		  "name": "Sam",
		  "createdDate": "2025-06-02 21:12:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 211,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 467,
		  "schedulePercent": 0.297031,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6782d3f4d332c85ac94e064dcbf9f53f",
		  
		  "name": "Madi",
		  "createdDate": "2012-06-13 02:59:26",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 107,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 189,
		  "schedulePercent": 0.152539,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "678e8d6c18d79ffa6a1ee3f0cb055c06",
		  
		  "name": "Ian",
		  "createdDate": "2022-06-16 20:33:01",
		  "totalOrganizations": 4,
		  "totalTours": 16,
		  "totalDays": 1852,
		  "totalCountries": 15,
		  "totalStates": 37,
		  "totalEvents": 243,
		  "eventPercent": 0.864347,
		  "totalScheduleItems": 2728,
		  "schedulePercent": 0.812897,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Decca Live",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "679197786219a0e99c131684e4710744",
		  
		  "name": "Tom",
		  "createdDate": "2014-11-19 12:26:43",
		  "totalOrganizations": 102,
		  "totalTours": 68,
		  "totalDays": 1278,
		  "totalCountries": 18,
		  "totalStates": 56,
		  "totalEvents": 477,
		  "eventPercent": 0.974728,
		  "totalScheduleItems": 6123,
		  "schedulePercent": 0.977448,
		  "totalGuests": 545,
		  "guestPercent": 0.74218,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67a4a152e61251abc0e42e47f454ea74",
		  
		  "name": "Braden Dies",
		  "createdDate": "2024-04-02 15:22:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 330,
		  "totalCountries": 13,
		  "totalStates": 42,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 2272,
		  "schedulePercent": 0.758386,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67a6edcfeccf45c4fd5d6225f772c1dd",
		  
		  "name": "Darren",
		  "createdDate": "2019-10-02 18:40:44",
		  "totalOrganizations": 6,
		  "totalTours": 29,
		  "totalDays": 203,
		  "totalCountries": 20,
		  "totalStates": 17,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1973,
		  "schedulePercent": 0.708409,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-04-20 00:00:00",
		  "mostGuestName": "Etihad Park",
		  "mostGuestCity": "Abu Dhabi",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67b61bbda416d53b7862568e2782c540",
		  
		  "name": "Johnny",
		  "createdDate": "2018-09-28 22:25:51",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 628,
		  "totalCountries": 9,
		  "totalStates": 15,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 920,
		  "schedulePercent": 0.464982,
		  "totalGuests": 478,
		  "guestPercent": 0.723255,
		  "mostGuestDate": "2025-03-09 00:00:00",
		  "mostGuestName": "Bord Gais Energy Theatre",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67bb18927c53f49401089fdc9f638531",
		  
		  "name": "Emily",
		  "createdDate": "2019-02-01 10:13:07",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 225,
		  "totalCountries": 21,
		  "totalStates": 34,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1423,
		  "schedulePercent": 0.602788,
		  "totalGuests": 832,
		  "guestPercent": 0.81573,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Turbinenhalle",
		  "mostGuestCity": "Oberhausen",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67c5697d1452f1cdd8af586d669182ad",
		  
		  "name": "Becca",
		  "createdDate": "2018-04-26 13:08:51",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 723,
		  "totalCountries": 10,
		  "totalStates": 64,
		  "totalEvents": 428,
		  "eventPercent": 0.964982,
		  "totalScheduleItems": 5344,
		  "schedulePercent": 0.963962,
		  "totalGuests": 908,
		  "guestPercent": 0.831709,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67cc34a08d738070a604abc72d586429",
		  
		  "name": "James",
		  "createdDate": "2019-01-04 21:21:54",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 359,
		  "totalCountries": 9,
		  "totalStates": 49,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 452,
		  "schedulePercent": 0.291364,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67cd8982146d41b2cff089228138aef4",
		  
		  "name": "Anthony",
		  "createdDate": "2013-10-23 21:48:02",
		  "totalOrganizations": 30,
		  "totalTours": 10,
		  "totalDays": 1298,
		  "totalCountries": 26,
		  "totalStates": 61,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 5581,
		  "schedulePercent": 0.969402,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "Governor's Ball Music Festival",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "67e1b86135e2eda0097d6f643f202ceb",
		  
		  "name": "Luis",
		  "createdDate": "2025-04-08 11:54:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 223,
		  "schedulePercent": 0.173051,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6802adee1d79b913bf58e6f732764256",
		  
		  "name": "Rob",
		  "createdDate": "2022-09-02 11:06:33",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 229,
		  "totalCountries": 21,
		  "totalStates": 54,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 862,
		  "schedulePercent": 0.445603,
		  "totalGuests": 607,
		  "guestPercent": 0.760879,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Powerstation",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "681da11f0dbac21eea77dcc679c1f442",
		  
		  "name": "Neil",
		  "createdDate": "2010-11-08 09:56:32",
		  "totalOrganizations": 35,
		  "totalTours": 13,
		  "totalDays": 1072,
		  "totalCountries": 27,
		  "totalStates": 31,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2203,
		  "schedulePercent": 0.748187,
		  "totalGuests": 393,
		  "guestPercent": 0.691296,
		  "mostGuestDate": "2025-01-16 00:00:00",
		  "mostGuestName": "Fremantle Prison",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "682834d472c0643bb90c6cfe45f4acb2",
		  
		  "name": "Ronald ",
		  "createdDate": "2025-04-10 20:38:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 229,
		  "guestPercent": 0.612194,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "682d65f68fb96d481be2801c51497f4d",
		  
		  "name": "Raheem",
		  "createdDate": "2019-10-16 23:02:46",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 498,
		  "totalCountries": 6,
		  "totalStates": 41,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 1528,
		  "schedulePercent": 0.622733,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Maymont Park",
		  "mostGuestCity": "Richmond",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6835fe9ac7c6b792fa5916df0cf7f57f",
		  
		  "name": "Patch",
		  "createdDate": "2023-06-26 05:59:09",
		  "totalOrganizations": 2,
		  "totalTours": 13,
		  "totalDays": 213,
		  "totalCountries": 6,
		  "totalStates": 14,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 795,
		  "schedulePercent": 0.420784,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "683e912d35ee3767e1c5c77d0434b387",
		  
		  "name": "Tobias",
		  "createdDate": "2015-06-19 11:15:21",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 79,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 822,
		  "schedulePercent": 0.43189,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "684a8e72540381563d59aff4288fca6b",
		  
		  "name": "Moira",
		  "createdDate": "2024-05-11 12:42:31",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 200,
		  "totalCountries": 12,
		  "totalStates": 7,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 803,
		  "schedulePercent": 0.423617,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6853387ec1bc81212f44563cbfd92414",
		  
		  "name": "Leo",
		  "createdDate": "2025-04-01 22:38:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 66,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 774,
		  "schedulePercent": 0.414211,
		  "totalGuests": 672,
		  "guestPercent": 0.778785,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "OUTLOUD Festival",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "685607f07b85a7911b588a1f5ec80507",
		  
		  "name": "Ben ",
		  "createdDate": "2023-03-14 16:42:20",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 167,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 434,
		  "schedulePercent": 0.283205,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6863473d50dd4fdaf4c09627f911c883",
		  
		  "name": "Christopher",
		  "createdDate": "2023-08-02 21:27:25",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 340,
		  "totalCountries": 7,
		  "totalStates": 43,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2821,
		  "schedulePercent": 0.824909,
		  "totalGuests": 940,
		  "guestPercent": 0.837262,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "686fe89348bf91d518710cc76d25a76f",
		  
		  "name": "Jordin",
		  "createdDate": "2022-12-06 18:44:53",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 900,
		  "totalCountries": 2,
		  "totalStates": 46,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1329,
		  "schedulePercent": 0.579442,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Crystal Grand Music Theatre",
		  "mostGuestCity": "Wisconsin Dells",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "687513e449d6acfbc567d9d78fbea5d1",
		  
		  "name": "Liz ",
		  "createdDate": "2025-02-04 13:30:18",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 668,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1122,
		  "schedulePercent": 0.525499,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "687e492e947ce16c4891c14a7b4207ff",
		  
		  "name": "Stu ",
		  "createdDate": "2015-03-02 19:23:56",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 357,
		  "totalCountries": 24,
		  "totalStates": 53,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 3974,
		  "schedulePercent": 0.911831,
		  "totalGuests": 2824,
		  "guestPercent": 0.978128,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68846e4088c3cbbddadcb73936d3a228",
		  
		  "name": "jordan",
		  "createdDate": "2023-10-16 08:37:11",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 85,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 459,
		  "schedulePercent": 0.294311,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "House of Blues Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6885ca4ed175902a289877cad129a336",
		  
		  "name": "Hunter",
		  "createdDate": "2024-03-14 17:32:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 364,
		  "schedulePercent": 0.25,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6887084ced0c9e66c55ee5a3824a0785",
		  
		  "name": "Tony",
		  "createdDate": "2025-06-26 03:15:03",
		  "totalOrganizations": 1,
		  "totalTours": 12,
		  "totalDays": 38,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 99,
		  "schedulePercent": 0.0962149,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6887db088b905b5deed42351c2b30e16",
		  
		  "name": "Glen",
		  "createdDate": "2017-06-16 08:14:29",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 222,
		  "totalCountries": 20,
		  "totalStates": 38,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 787,
		  "schedulePercent": 0.418064,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Queenâ€™s Park",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6888a73a0e1a929c8a20fe2f9cd93f57",
		  
		  "name": "MacKenzie",
		  "createdDate": "2022-01-07 22:48:35",
		  "totalOrganizations": 25,
		  "totalTours": 23,
		  "totalDays": 3538,
		  "totalCountries": 24,
		  "totalStates": 98,
		  "totalEvents": 761,
		  "eventPercent": 0.99252,
		  "totalScheduleItems": 15741,
		  "schedulePercent": 0.999093,
		  "totalGuests": 4776,
		  "guestPercent": 0.99694,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 190,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "688912ba7e6e43419feefbde9877fc4f",
		  
		  "name": "Brian",
		  "createdDate": "2023-10-04 15:50:50",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 125,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "PBR Baltimore: A Coors Banquet Bar",
		  "mostGuestCity": "Baltimore",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "688d786a8ba97f2f6ab7562587f28796",
		  
		  "name": "Kimberly",
		  "createdDate": "2024-03-28 18:56:01",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 728,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 215,
		  "schedulePercent": 0.169198,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "The Grove",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "689317b7156d1b803b542e7056ea9339",
		  
		  "name": "Alison",
		  "createdDate": "2013-12-11 11:17:59",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 178,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1373,
		  "schedulePercent": 0.590549,
		  "totalGuests": 659,
		  "guestPercent": 0.773572,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68936d0faeaaaa1284208c73755eb8b1",
		  
		  "name": "Kylie",
		  "createdDate": "2018-04-18 16:05:05",
		  "totalOrganizations": 2,
		  "totalTours": 16,
		  "totalDays": 256,
		  "totalCountries": 16,
		  "totalStates": 43,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2347,
		  "schedulePercent": 0.767906,
		  "totalGuests": 1625,
		  "guestPercent": 0.921917,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "689ec820fe337c7ed5bb42efa910ddb9",
		  
		  "name": "Produktionsleder",
		  "createdDate": "2021-09-28 13:02:29",
		  "totalOrganizations": 16,
		  "totalTours": 6,
		  "totalDays": 76,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 512,
		  "schedulePercent": 0.316636,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68a8ffa3130222d7747f88d3a7dfb441",
		  
		  "name": "ADM Tiago",
		  "createdDate": "2025-02-11 18:14:54",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 121,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 350,
		  "schedulePercent": 0.242974,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68b43371d3211cf6961a57cf7a324206",
		  
		  "name": "Micheal",
		  "createdDate": "2013-05-13 06:41:42",
		  "totalOrganizations": 10,
		  "totalTours": 32,
		  "totalDays": 512,
		  "totalCountries": 9,
		  "totalStates": 20,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1604,
		  "schedulePercent": 0.641206,
		  "totalGuests": 326,
		  "guestPercent": 0.664211,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68b4ee1e146ad2178fdec96d628be552",
		  
		  "name": "Lori",
		  "createdDate": "2025-10-28 19:01:55",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 47,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 281,
		  "schedulePercent": 0.206256,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68b542f854b4be60e0a248a7b40a4bc6",
		  
		  "name": "Eric",
		  "createdDate": "2019-02-15 04:12:13",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 372,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 580,
		  "schedulePercent": 0.343608,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Lab11",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68c32dff90d8c9b6b248fe2f151c58c2",
		  
		  "name": "Mark",
		  "createdDate": "2017-11-06 20:47:27",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 731,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 652,
		  "schedulePercent": 0.3682,
		  "totalGuests": 677,
		  "guestPercent": 0.780145,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Ovens Auditorium",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68c3d85c2e745c6f073279cdf9f819e4",
		  
		  "name": "Marc",
		  "createdDate": "2024-05-28 19:22:14",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 679,
		  "totalCountries": 20,
		  "totalStates": 50,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1600,
		  "schedulePercent": 0.640639,
		  "totalGuests": 270,
		  "guestPercent": 0.634746,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68ca400fcce78c39ac49cdf6ec591997",
		  
		  "name": "Katy",
		  "createdDate": "2025-01-04 15:10:55",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 917,
		  "totalCountries": 14,
		  "totalStates": 63,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 3444,
		  "schedulePercent": 0.878513,
		  "totalGuests": 1879,
		  "guestPercent": 0.938463,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68d40bc94f07e19fcf05860cd55aa3f0",
		  
		  "name": "Alex",
		  "createdDate": "2020-04-27 22:32:58",
		  "totalOrganizations": 22,
		  "totalTours": 16,
		  "totalDays": 1202,
		  "totalCountries": 24,
		  "totalStates": 73,
		  "totalEvents": 292,
		  "eventPercent": 0.907185,
		  "totalScheduleItems": 3962,
		  "schedulePercent": 0.911265,
		  "totalGuests": 1512,
		  "guestPercent": 0.910925,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68dddd066dee809cebfb004b59a8f0f2",
		  
		  "name": "Owen",
		  "createdDate": "2022-02-24 23:55:04",
		  "totalOrganizations": 13,
		  "totalTours": 14,
		  "totalDays": 273,
		  "totalCountries": 18,
		  "totalStates": 60,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 1344,
		  "schedulePercent": 0.584315,
		  "totalGuests": 652,
		  "guestPercent": 0.772099,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68e2b05cffce6da02139f554c7d2e5b0",
		  
		  "name": "Jason",
		  "createdDate": "2012-03-09 01:22:55",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 111,
		  "totalCountries": 5,
		  "totalStates": 34,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1217,
		  "schedulePercent": 0.550997,
		  "totalGuests": 445,
		  "guestPercent": 0.710675,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "The Xfinity Center",
		  "mostGuestCity": "Mansfield",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68e4ea57601a6d671325ace6d0a3c633",
		  
		  "name": "Sheridan",
		  "createdDate": "2021-08-07 18:06:00",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 159,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 272,
		  "guestPercent": 0.636333,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Ogden Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68e9176d098ef0c117453fc80ab31c0e",
		  
		  "name": "Theo",
		  "createdDate": "2025-01-30 21:24:45",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 171,
		  "totalCountries": 18,
		  "totalStates": 35,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 798,
		  "schedulePercent": 0.421804,
		  "totalGuests": 137,
		  "guestPercent": 0.550204,
		  "mostGuestDate": "2025-05-12 00:00:00",
		  "mostGuestName": "Stubb's Bar-B-Q",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "68fcae8a217b43c19bb9ad1c73ec9fdb",
		  
		  "name": "Niklas ",
		  "createdDate": "2019-12-12 11:05:54",
		  "totalOrganizations": 40,
		  "totalTours": 28,
		  "totalDays": 349,
		  "totalCountries": 8,
		  "totalStates": 5,
		  "totalEvents": 299,
		  "eventPercent": 0.912398,
		  "totalScheduleItems": 2074,
		  "schedulePercent": 0.727901,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6903d95427075ce9ae5bba0fdea89f61",
		  
		  "name": "Joao",
		  "createdDate": "2025-10-27 12:29:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 37,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 313,
		  "schedulePercent": 0.223935,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "690ba4efac6b724d0684a1687ee2599c",
		  
		  "name": "James",
		  "createdDate": "2016-03-23 22:44:00",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 286,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1413,
		  "schedulePercent": 0.600748,
		  "totalGuests": 1397,
		  "guestPercent": 0.900045,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6911c4bc6f7cf1f85e8245da6099d34a",
		  
		  "name": "Geoff",
		  "createdDate": "2014-01-08 12:06:14",
		  "totalOrganizations": 41,
		  "totalTours": 20,
		  "totalDays": 819,
		  "totalCountries": 24,
		  "totalStates": 76,
		  "totalEvents": 232,
		  "eventPercent": 0.850408,
		  "totalScheduleItems": 3836,
		  "schedulePercent": 0.905032,
		  "totalGuests": 1650,
		  "guestPercent": 0.924071,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "691eeba9a487f7d2f5b718f12580831a",
		  
		  "name": "Bryan",
		  "createdDate": "2012-10-23 20:39:25",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 109,
		  "totalCountries": 19,
		  "totalStates": 42,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 370,
		  "schedulePercent": 0.253173,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-03-12 00:00:00",
		  "mostGuestName": "Club Citta'",
		  "mostGuestCity": "Kawasaki-shi",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6937dfa47d615cee66fc608005991bb6",
		  
		  "name": "John",
		  "createdDate": "2019-08-06 03:38:07",
		  "totalOrganizations": 11,
		  "totalTours": 4,
		  "totalDays": 194,
		  "totalCountries": 15,
		  "totalStates": 49,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1974,
		  "schedulePercent": 0.708522,
		  "totalGuests": 339,
		  "guestPercent": 0.670558,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6940e23c194f5603b834568d06f00efe",
		  
		  "name": "Morgan",
		  "createdDate": "2025-02-08 07:31:13",
		  "totalOrganizations": 4,
		  "totalTours": 19,
		  "totalDays": 372,
		  "totalCountries": 20,
		  "totalStates": 44,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 2338,
		  "schedulePercent": 0.766546,
		  "totalGuests": 1167,
		  "guestPercent": 0.873073,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "694bca8b860da7b18a3fdc89bc43b2b7",
		  
		  "name": "Henriette",
		  "createdDate": "2018-09-05 09:04:43",
		  "totalOrganizations": 22,
		  "totalTours": 10,
		  "totalDays": 158,
		  "totalCountries": 22,
		  "totalStates": 27,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1325,
		  "schedulePercent": 0.577516,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Byscenen in Trondheim",
		  "mostGuestCity": "Trondheim",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6962363d413ef266fa3eecfdb4b565db",
		  
		  "name": "Mark",
		  "createdDate": "2018-04-22 20:33:21",
		  "totalOrganizations": 22,
		  "totalTours": 37,
		  "totalDays": 1307,
		  "totalCountries": 25,
		  "totalStates": 89,
		  "totalEvents": 570,
		  "eventPercent": 0.985834,
		  "totalScheduleItems": 7805,
		  "schedulePercent": 0.989801,
		  "totalGuests": 1953,
		  "guestPercent": 0.94345,
		  "mostGuestDate": "2025-05-11 00:00:00",
		  "mostGuestName": "",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "696624573778017793ec9e298b83280f",
		  
		  "name": "Luca Ruggiero",
		  "createdDate": "2022-04-16 11:46:45",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 185,
		  "totalCountries": 13,
		  "totalStates": 47,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 896,
		  "schedulePercent": 0.456596,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-04-08 00:00:00",
		  "mostGuestName": "Hoxton Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "696929eac33683be766f59cba0c59a56",
		  
		  "name": "Kyle",
		  "createdDate": "2012-05-31 15:40:37",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 21,
		  "totalStates": 37,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1245,
		  "schedulePercent": 0.55927,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "douglass park",
		  "mostGuestCity": "",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "696d070f409fd72408b5b718ed00c92a",
		  
		  "name": "Emir",
		  "createdDate": "2022-07-07 08:13:30",
		  "totalOrganizations": 24,
		  "totalTours": 11,
		  "totalDays": 268,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 1247,
		  "schedulePercent": 0.55995,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Skalldyrfestivalen",
		  "mostGuestCity": "Mandal",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69730d3efe66035235e957957a1d574e",
		  
		  "name": "Kelly",
		  "createdDate": "2025-06-02 18:37:27",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 93,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69781b719991236b17420586e2272d3b",
		  
		  "name": "Primary",
		  "createdDate": "2025-06-02 21:11:23",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 359,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1231,
		  "schedulePercent": 0.555304,
		  "totalGuests": 142,
		  "guestPercent": 0.553604,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Whitewater Amphitheater",
		  "mostGuestCity": "New Braunfels",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "697ace66e2acbe32872eea678d288352",
		  
		  "name": "Gabriel",
		  "createdDate": "2022-05-17 11:50:26",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 184,
		  "totalCountries": 10,
		  "totalStates": 50,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1011,
		  "schedulePercent": 0.493654,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Luckman Fine Arts Complex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "697c2e86f20e4a3bf6e3ee22bb78b260",
		  
		  "name": "Susantha",
		  "createdDate": "2013-08-21 03:04:39",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 138,
		  "totalCountries": 10,
		  "totalStates": 26,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 723,
		  "schedulePercent": 0.395512,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "697ce8bf61531c0ad8d3b7416d88fea2",
		  
		  "name": "Emma",
		  "createdDate": "2024-09-03 18:23:20",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 102,
		  "totalCountries": 11,
		  "totalStates": 25,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 709,
		  "schedulePercent": 0.389846,
		  "totalGuests": 217,
		  "guestPercent": 0.606528,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "697e08926ebb2155568f3e7116c57b51",
		  
		  "name": "Sam",
		  "createdDate": "2021-04-23 14:27:05",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 1076,
		  "totalCountries": 11,
		  "totalStates": 66,
		  "totalEvents": 292,
		  "eventPercent": 0.907185,
		  "totalScheduleItems": 3567,
		  "schedulePercent": 0.886559,
		  "totalGuests": 2049,
		  "guestPercent": 0.950476,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "697f01cd1e58530a1b7c51d8317c0c14",
		  
		  "name": "Natalie",
		  "createdDate": "2014-08-02 19:48:28",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 323,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 977,
		  "schedulePercent": 0.483568,
		  "totalGuests": 381,
		  "guestPercent": 0.686197,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "The Fillmore Silver Spring",
		  "mostGuestCity": "Silver Spring",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "698352f9a4422e1b296b197062ba1c02",
		  
		  "name": "Tyler",
		  "createdDate": "2025-03-26 07:12:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 280,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 764,
		  "schedulePercent": 0.409905,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-04-07 00:00:00",
		  "mostGuestName": "The Complex",
		  "mostGuestCity": "Salt Lake City",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69847ed9aa7466e4ddaa34b95f4f9048",
		  
		  "name": "Michael",
		  "createdDate": "2010-01-27 05:03:58",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 562,
		  "totalCountries": 5,
		  "totalStates": 54,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 4549,
		  "schedulePercent": 0.93937,
		  "totalGuests": 2201,
		  "guestPercent": 0.957956,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6986eff28e82f910f12fe5d5bce1aa98",
		  
		  "name": "Eli",
		  "createdDate": "2025-04-11 06:45:31",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 176,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 932,
		  "schedulePercent": 0.470082,
		  "totalGuests": 500,
		  "guestPercent": 0.730734,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6990d26709ec0b94ee8aed636ad76c3f",
		  
		  "name": "Georgina",
		  "createdDate": "2022-01-20 01:02:43",
		  "totalOrganizations": 11,
		  "totalTours": 35,
		  "totalDays": 695,
		  "totalCountries": 18,
		  "totalStates": 61,
		  "totalEvents": 347,
		  "eventPercent": 0.941183,
		  "totalScheduleItems": 2958,
		  "schedulePercent": 0.837942,
		  "totalGuests": 703,
		  "guestPercent": 0.786378,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "699c1f81315adde9ce035f46880f78bc",
		  
		  "name": "Andrew",
		  "createdDate": "2022-09-16 15:19:17",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 345,
		  "totalCountries": 14,
		  "totalStates": 53,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 1624,
		  "schedulePercent": 0.645059,
		  "totalGuests": 390,
		  "guestPercent": 0.69005,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69a33ae4d8837c5caad39debc84487eb",
		  
		  "name": "Ivan",
		  "createdDate": "2009-09-17 21:23:49",
		  "totalOrganizations": 15,
		  "totalTours": 21,
		  "totalDays": 770,
		  "totalCountries": 21,
		  "totalStates": 60,
		  "totalEvents": 261,
		  "eventPercent": 0.88248,
		  "totalScheduleItems": 5452,
		  "schedulePercent": 0.966795,
		  "totalGuests": 4102,
		  "guestPercent": 0.993994,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 263,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69a6425a70a3cdb8d3761bcb0bcdec76",
		  
		  "name": "Helga",
		  "createdDate": "2019-04-15 03:43:29",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 686,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 336,
		  "schedulePercent": 0.234587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69a8f8c38faca19d29ba2f97b8e50579",
		  
		  "name": "Graham",
		  "createdDate": "2017-06-17 02:38:09",
		  "totalOrganizations": 4,
		  "totalTours": 16,
		  "totalDays": 192,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 2058,
		  "schedulePercent": 0.725635,
		  "totalGuests": 740,
		  "guestPercent": 0.794198,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "John Anson Ford Amphitheatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69a9fe1895237b494f1ce85daf2610d2",
		  
		  "name": "Marisa",
		  "createdDate": "2023-02-07 21:03:59",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 873,
		  "totalCountries": 24,
		  "totalStates": 40,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1224,
		  "schedulePercent": 0.553717,
		  "totalGuests": 189,
		  "guestPercent": 0.585222,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "The Torch At The LA Memorial Coliseum",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69ab451ede540d89c90a32d3b753d09f",
		  
		  "name": "Marina",
		  "createdDate": "2020-01-13 16:52:06",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 146,
		  "totalCountries": 17,
		  "totalStates": 36,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 679,
		  "schedulePercent": 0.378626,
		  "totalGuests": 377,
		  "guestPercent": 0.68461,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69ae9456fa5744f888a705a2670d648a",
		  
		  "name": " ",
		  "createdDate": "2024-04-01 15:01:08",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 56,
		  "totalCountries": 6,
		  "totalStates": 24,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69b6a7ddcb7dd2e6343bc2214d6fd72e",
		  
		  "name": "Marc",
		  "createdDate": "2013-07-23 11:34:18",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 779,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1161,
		  "schedulePercent": 0.537965,
		  "totalGuests": 287,
		  "guestPercent": 0.642906,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Glasgow Royal Concert Hall",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69c1a4550c49cfedc21f7e52affd116f",
		  
		  "name": "Emily",
		  "createdDate": "2024-10-10 14:54:16",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 705,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 9134,
		  "schedulePercent": 0.993994,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69c73c3cf4f48c34f114e6c629b953e2",
		  
		  "name": "Ana",
		  "createdDate": "2024-09-30 06:10:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 99,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69c9258afdd9be5ad0a959812292cc2f",
		  
		  "name": "Marcus",
		  "createdDate": "2025-04-26 14:57:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 171,
		  "totalCountries": 11,
		  "totalStates": 11,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 1148,
		  "schedulePercent": 0.533885,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69d1a69524a657fcd6ffdbd30d09ae1e",
		  
		  "name": "Mamie",
		  "createdDate": "2023-01-09 15:35:03",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 372,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 580,
		  "schedulePercent": 0.343608,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Lab11",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69d351320cbbc14d0b2fc7a617192f63",
		  
		  "name": "Tanner",
		  "createdDate": "2021-09-22 00:30:12",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 348,
		  "schedulePercent": 0.241954,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "69e2b009a847c04bbc14d8c9f6c252bc",
		  
		  "name": "Avinesh",
		  "createdDate": "2023-03-07 15:12:28",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 1025,
		  "totalCountries": 20,
		  "totalStates": 54,
		  "totalEvents": 264,
		  "eventPercent": 0.885766,
		  "totalScheduleItems": 3142,
		  "schedulePercent": 0.854828,
		  "totalGuests": 993,
		  "guestPercent": 0.844855,
		  "mostGuestDate": "2025-09-02 00:00:00",
		  "mostGuestName": "Unipol Forum",
		  "mostGuestCity": "Assago",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a05dc924a269cf25a1b614546fccab4",
		  
		  "name": "Production",
		  "createdDate": "2025-06-13 00:28:21",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 109,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 1084,
		  "schedulePercent": 0.515299,
		  "totalGuests": 416,
		  "guestPercent": 0.699909,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "John Anson Ford Amphitheatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a17cff071d79bd029df11c50b1a393c",
		  
		  "name": "Chris",
		  "createdDate": "2016-12-15 21:22:47",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 592,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 2102,
		  "schedulePercent": 0.733114,
		  "totalGuests": 774,
		  "guestPercent": 0.801224,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a2caa4e0f173dec9199a39cee4fd5e4",
		  
		  "name": "Rennie",
		  "createdDate": "2024-10-03 16:10:19",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 298,
		  "totalCountries": 13,
		  "totalStates": 30,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 410,
		  "schedulePercent": 0.273799,
		  "totalGuests": 348,
		  "guestPercent": 0.674184,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a2d3e48a377355392c161bfb35f1c81",
		  
		  "name": "Christopher",
		  "createdDate": "2013-03-26 00:27:23",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 286,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 224,
		  "schedulePercent": 0.173844,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a2fb3d61fde7aa8e54ea46f7cf795cb",
		  
		  "name": "Live",
		  "createdDate": "2023-04-19 20:10:17",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 1984,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 1117,
		  "schedulePercent": 0.523119,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a32c6055c76d6f3977ae764809c0d0e",
		  
		  "name": "Jonathan",
		  "createdDate": "2025-08-20 17:57:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 69,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 190,
		  "schedulePercent": 0.153105,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "The Birchmere",
		  "mostGuestCity": "Alexandria",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a3682dfc564eef78f5497a95d7acfcd",
		  
		  "name": "Lindsay ",
		  "createdDate": "2015-09-16 00:35:08",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 291,
		  "totalCountries": 15,
		  "totalStates": 20,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 952,
		  "schedulePercent": 0.476541,
		  "totalGuests": 138,
		  "guestPercent": 0.550997,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Palau Sant Jordi",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a466ba2a07216f58d72d1a97c9caf89",
		  
		  "name": "Neville",
		  "createdDate": "2023-03-17 01:38:49",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 203,
		  "totalCountries": 21,
		  "totalStates": 34,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 894,
		  "schedulePercent": 0.455802,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "Sun Splash Festival",
		  "mostGuestCity": "Vreeswijkstraat",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a4ee92f9073df73fce666f14101943d",
		  
		  "name": "Allan",
		  "createdDate": "2023-09-13 18:31:27",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 548,
		  "totalCountries": 18,
		  "totalStates": 38,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 939,
		  "schedulePercent": 0.472121,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-06-03 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a626aed7ce3ea9efeee0c607ae1c058",
		  
		  "name": "Cameron",
		  "createdDate": "2017-02-04 19:11:33",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 321,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 974,
		  "schedulePercent": 0.482434,
		  "totalGuests": 244,
		  "guestPercent": 0.6216,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a633fee2348acdbeff9d63376716853",
		  
		  "name": "Allie",
		  "createdDate": "2022-11-16 16:16:13",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 5,
		  "totalStates": 56,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2527,
		  "schedulePercent": 0.789325,
		  "totalGuests": 4231,
		  "guestPercent": 0.994334,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a705530d3e44acd84d4a71322081b28",
		  
		  "name": "Kayla",
		  "createdDate": "2021-07-11 23:23:09",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 321,
		  "totalCountries": 19,
		  "totalStates": 70,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 4667,
		  "schedulePercent": 0.94277,
		  "totalGuests": 709,
		  "guestPercent": 0.787511,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Jyske Bank BOXEN",
		  "mostGuestCity": "Herning",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a7175b39e208bcc086bfcaf5904e70f",
		  
		  "name": "Lauren",
		  "createdDate": "2019-01-07 20:52:41",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 339,
		  "totalCountries": 19,
		  "totalStates": 47,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 2625,
		  "schedulePercent": 0.800317,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a73cb3ac318da1f5eb32680ec71e8d4",
		  
		  "name": "Bryan",
		  "createdDate": "2021-01-22 00:48:11",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 542,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 3658,
		  "schedulePercent": 0.893472,
		  "totalGuests": 878,
		  "guestPercent": 0.824456,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a7415aaa11acadbe6aaeddae4566d30",
		  
		  "name": "Bill",
		  "createdDate": "2016-02-01 17:32:55",
		  "totalOrganizations": 10,
		  "totalTours": 17,
		  "totalDays": 371,
		  "totalCountries": 6,
		  "totalStates": 17,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1173,
		  "schedulePercent": 0.540685,
		  "totalGuests": 367,
		  "guestPercent": 0.679964,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a81b0c754e19740222b51300f3038bc",
		  
		  "name": "Dan",
		  "createdDate": "2013-10-09 14:21:00",
		  "totalOrganizations": 15,
		  "totalTours": 27,
		  "totalDays": 385,
		  "totalCountries": 26,
		  "totalStates": 80,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2710,
		  "schedulePercent": 0.810063,
		  "totalGuests": 834,
		  "guestPercent": 0.81607,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6a8d680e5efe73dd63371bdff258bd8c",
		  
		  "name": "Karina",
		  "createdDate": "2024-03-12 01:03:42",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 193,
		  "totalCountries": 17,
		  "totalStates": 42,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1182,
		  "schedulePercent": 0.542838,
		  "totalGuests": 895,
		  "guestPercent": 0.828536,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "House of Blues Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6aa6c70b44dda6d3e53e8e8a31650b29",
		  
		  "name": "Pablo",
		  "createdDate": "2022-06-20 13:31:01",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 813,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1258,
		  "schedulePercent": 0.562557,
		  "totalGuests": 917,
		  "guestPercent": 0.833975,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "House of Blues Boston",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6aa8c48cac823ba0872f025095efe65a",
		  
		  "name": "Zoe",
		  "createdDate": "2022-12-12 10:27:32",
		  "totalOrganizations": 129,
		  "totalTours": 48,
		  "totalDays": 647,
		  "totalCountries": 33,
		  "totalStates": 51,
		  "totalEvents": 338,
		  "eventPercent": 0.93631,
		  "totalScheduleItems": 3033,
		  "schedulePercent": 0.845422,
		  "totalGuests": 327,
		  "guestPercent": 0.664665,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Folketeateret",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ab57d618c0744fc1c366429a6551b37",
		  
		  "name": "Chris ",
		  "createdDate": "2022-04-22 11:37:06",
		  "totalOrganizations": 16,
		  "totalTours": 14,
		  "totalDays": 628,
		  "totalCountries": 19,
		  "totalStates": 52,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1686,
		  "schedulePercent": 0.656052,
		  "totalGuests": 896,
		  "guestPercent": 0.828989,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6abffc73d4cc614020c7ea85d6a943f0",
		  
		  "name": "Lauren",
		  "createdDate": "2016-09-15 18:50:24",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 964,
		  "totalCountries": 26,
		  "totalStates": 65,
		  "totalEvents": 244,
		  "eventPercent": 0.86514,
		  "totalScheduleItems": 4704,
		  "schedulePercent": 0.944356,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ad41415c153c7a20707d47f17cdd36b",
		  
		  "name": "Matt",
		  "createdDate": "2022-01-19 20:05:10",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 2305,
		  "totalCountries": 10,
		  "totalStates": 42,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1612,
		  "schedulePercent": 0.642679,
		  "totalGuests": 480,
		  "guestPercent": 0.724161,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ad8100dde7993a8c7f1f122805cc768",
		  
		  "name": "Bradley",
		  "createdDate": "2019-08-14 19:13:15",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 530,
		  "totalCountries": 6,
		  "totalStates": 36,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 957,
		  "schedulePercent": 0.478014,
		  "totalGuests": 1659,
		  "guestPercent": 0.924637,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 183,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6adbe5706df41cc389cb39c89b37c47a",
		  
		  "name": "emilia",
		  "createdDate": "2024-05-09 23:31:35",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 730,
		  "totalCountries": 17,
		  "totalStates": 26,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 3323,
		  "schedulePercent": 0.868994,
		  "totalGuests": 1406,
		  "guestPercent": 0.900725,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6add381d170f08e229affd7c883f0053",
		  
		  "name": "Stephen",
		  "createdDate": "2017-07-23 14:46:48",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 168,
		  "totalCountries": 9,
		  "totalStates": 22,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 921,
		  "schedulePercent": 0.465095,
		  "totalGuests": 250,
		  "guestPercent": 0.625113,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Scotiabank Centre",
		  "mostGuestCity": "Halifax",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6aeea2243277349f630c166f3c1eeaf9",
		  
		  "name": "DDE-",
		  "createdDate": "2017-08-19 10:09:31",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 54,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 316,
		  "schedulePercent": 0.225295,
		  "totalGuests": 420,
		  "guestPercent": 0.702289,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Rockefeller Music Hall",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 147,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6af4f283761812dcbe797c60e9465dee",
		  
		  "name": "Sophia",
		  "createdDate": "2022-08-10 15:22:57",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 226,
		  "schedulePercent": 0.174977,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b0b6850724e7d78f8d423f33c74cbf0",
		  
		  "name": "Jacob",
		  "createdDate": "2023-02-14 09:26:10",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 160,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 285,
		  "schedulePercent": 0.209542,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b0cadf4a20d67460c9ad664b58185c5",
		  
		  "name": "Andries",
		  "createdDate": "2022-03-15 15:08:51",
		  "totalOrganizations": 56,
		  "totalTours": 35,
		  "totalDays": 596,
		  "totalCountries": 25,
		  "totalStates": 88,
		  "totalEvents": 379,
		  "eventPercent": 0.953422,
		  "totalScheduleItems": 2801,
		  "schedulePercent": 0.822076,
		  "totalGuests": 517,
		  "guestPercent": 0.735041,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Ancienne Belgique",
		  "mostGuestCity": "Brussel",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b266b9f077913552aecf9c243c57752",
		  
		  "name": "Chelsea",
		  "createdDate": "2021-01-12 06:49:51",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 595,
		  "totalCountries": 13,
		  "totalStates": 20,
		  "totalEvents": 289,
		  "eventPercent": 0.904918,
		  "totalScheduleItems": 2291,
		  "schedulePercent": 0.760653,
		  "totalGuests": 120,
		  "guestPercent": 0.536945,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b26d575e6f33ca1b9a69cdf34441080",
		  
		  "name": "Gino",
		  "createdDate": "2013-12-12 19:32:20",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 137,
		  "totalCountries": 12,
		  "totalStates": 27,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 756,
		  "schedulePercent": 0.407978,
		  "totalGuests": 605,
		  "guestPercent": 0.759973,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b51bb62de1a789de53c0f205234a86b",
		  
		  "name": "Julie",
		  "createdDate": "2024-10-18 05:37:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 117,
		  "schedulePercent": 0.108794,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b51cd51c001d7069ceaa3ed945aaa36",
		  
		  "name": "Michael",
		  "createdDate": "2019-06-19 00:28:50",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 394,
		  "totalCountries": 5,
		  "totalStates": 23,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 602,
		  "schedulePercent": 0.351768,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Heaton Park",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b528de19d9dca57e541c342e8093a76",
		  
		  "name": "Sergio",
		  "createdDate": "2012-07-05 16:25:26",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 556,
		  "totalCountries": 7,
		  "totalStates": 13,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 299,
		  "schedulePercent": 0.217135,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b5e82066a03f21ecff0f0a88c62b8aa",
		  
		  "name": "Mary",
		  "createdDate": "2025-04-10 09:05:57",
		  "totalOrganizations": 1,
		  "totalTours": 30,
		  "totalDays": 110,
		  "totalCountries": 16,
		  "totalStates": 21,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 593,
		  "schedulePercent": 0.348595,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b60c7c148a5a4ebae9abd717326118b",
		  
		  "name": "Jason",
		  "createdDate": "2022-05-14 17:48:40",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 1366,
		  "totalCountries": 25,
		  "totalStates": 57,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 3192,
		  "schedulePercent": 0.859021,
		  "totalGuests": 375,
		  "guestPercent": 0.683477,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Bethel Woods Center",
		  "mostGuestCity": "Bethel",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b6654da3f463c6e49592651d5b731b1",
		  
		  "name": "Jackson",
		  "createdDate": "2024-08-07 16:05:52",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 172,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1130,
		  "schedulePercent": 0.528105,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b69fcd424b35ae6c12a15af7638b1ef",
		  
		  "name": "Illiana",
		  "createdDate": "2019-10-08 16:28:56",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 203,
		  "totalCountries": 13,
		  "totalStates": 31,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 992,
		  "schedulePercent": 0.488781,
		  "totalGuests": 201,
		  "guestPercent": 0.595422,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b727a9de732a8a138f9f859bd2505b7",
		  
		  "name": "Kelsea",
		  "createdDate": "2024-11-14 18:25:46",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 732,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 387,
		  "schedulePercent": 0.262579,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b7365b930a9f38c6ecf0ad8c7cf503f",
		  
		  "name": "Olen",
		  "createdDate": "2023-03-28 20:42:23",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 124,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 545,
		  "schedulePercent": 0.332162,
		  "totalGuests": 147,
		  "guestPercent": 0.556324,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Warehouse Live",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b73844c104f9fb806e280cd9ce55125",
		  
		  "name": "Arnie",
		  "createdDate": "2014-11-10 06:06:29",
		  "totalOrganizations": 15,
		  "totalTours": 18,
		  "totalDays": 328,
		  "totalCountries": 6,
		  "totalStates": 49,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1612,
		  "schedulePercent": 0.642679,
		  "totalGuests": 1776,
		  "guestPercent": 0.932117,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Boettcher Concert Hall",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b7c3ac7fa967f437476206ddf056283",
		  
		  "name": "Carmen",
		  "createdDate": "2015-08-11 20:29:30",
		  "totalOrganizations": 20,
		  "totalTours": 22,
		  "totalDays": 837,
		  "totalCountries": 12,
		  "totalStates": 62,
		  "totalEvents": 341,
		  "eventPercent": 0.936877,
		  "totalScheduleItems": 4454,
		  "schedulePercent": 0.93631,
		  "totalGuests": 956,
		  "guestPercent": 0.840095,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b8083cdfd1795e2e4baeb563006928b",
		  
		  "name": "Philippe",
		  "createdDate": "2021-11-11 17:02:49",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 825,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b830c6b84ce0bc4dc5ca009b023c302",
		  
		  "name": "Callie",
		  "createdDate": "2021-08-24 19:10:46",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 363,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 3,
		  "eventPercent": 0.0250453,
		  "totalScheduleItems": 56,
		  "schedulePercent": 0.0648232,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b8c9f2d59e4ffc1f88e4031ac921e12",
		  
		  "name": "Sarah ",
		  "createdDate": "2023-05-08 19:40:00",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 20,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b917777df6200ba00cc25ee81699cac",
		  
		  "name": "Yvette",
		  "createdDate": "2025-08-07 11:23:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 240,
		  "totalCountries": 15,
		  "totalStates": 34,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1503,
		  "schedulePercent": 0.61888,
		  "totalGuests": 285,
		  "guestPercent": 0.641999,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Allianz Amphitheater at Riverfront",
		  "mostGuestCity": "Richmond",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6b9cebd6f484bc182e5eb0f39eb7fe63",
		  
		  "name": "Zach",
		  "createdDate": "2017-09-20 19:55:07",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 732,
		  "totalCountries": 7,
		  "totalStates": 68,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 5639,
		  "schedulePercent": 0.970422,
		  "totalGuests": 4231,
		  "guestPercent": 0.994334,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ba29533257868682da98dd32ed1b8d7",
		  
		  "name": "Tom",
		  "createdDate": "2014-05-09 14:09:01",
		  "totalOrganizations": 16,
		  "totalTours": 16,
		  "totalDays": 517,
		  "totalCountries": 8,
		  "totalStates": 57,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 5525,
		  "schedulePercent": 0.967928,
		  "totalGuests": 975,
		  "guestPercent": 0.842022,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ba3f40013430e97004e57e6cf50098f",
		  
		  "name": "Craig",
		  "createdDate": "2023-10-11 23:16:28",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 202,
		  "totalCountries": 11,
		  "totalStates": 42,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1085,
		  "schedulePercent": 0.515979,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Busch Gardens",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6bde5348c0b0472a2332daf7beebf742",
		  
		  "name": "Roland",
		  "createdDate": "2022-05-04 16:17:27",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 593,
		  "totalCountries": 9,
		  "totalStates": 70,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 3280,
		  "schedulePercent": 0.86684,
		  "totalGuests": 1066,
		  "guestPercent": 0.857321,
		  "mostGuestDate": "2025-07-14 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6beaa19e39ab14cc4850d6ab4fd512c6",
		  
		  "name": "Nicholas",
		  "createdDate": "2021-05-12 23:08:25",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 403,
		  "totalCountries": 8,
		  "totalStates": 35,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 2880,
		  "schedulePercent": 0.830236,
		  "totalGuests": 2424,
		  "guestPercent": 0.966002,
		  "mostGuestDate": "2025-07-21 00:00:00",
		  "mostGuestName": "Desert 5 Spot",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6beb25d6681b9db1d4c4fdd769150ccc",
		  
		  "name": "Alex",
		  "createdDate": "2024-08-13 21:38:04",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 750,
		  "totalCountries": 23,
		  "totalStates": 65,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 2452,
		  "schedulePercent": 0.781392,
		  "totalGuests": 782,
		  "guestPercent": 0.80349,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Paramount",
		  "mostGuestCity": "Huntington",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6bff05e6c72746111068c6c0f4517fe7",
		  
		  "name": "Sofie",
		  "createdDate": "2021-06-16 08:02:43",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 373,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 350,
		  "eventPercent": 0.942316,
		  "totalScheduleItems": 1181,
		  "schedulePercent": 0.542611,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c042c0a18dcba14223fb721c9a056cf",
		  
		  "name": "RUBEN ",
		  "createdDate": "2023-07-01 16:20:03",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 714,
		  "totalCountries": 16,
		  "totalStates": 41,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1558,
		  "schedulePercent": 0.632026,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Astra Kulturhaus",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c0e131fb71cc79fc299c665f1f25b32",
		  
		  "name": "Eric",
		  "createdDate": "2017-11-23 17:19:43",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 654,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2287,
		  "schedulePercent": 0.759973,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c1465d8b1f8ff2a38b76dd89342e029",
		  
		  "name": "Julie",
		  "createdDate": "2014-02-04 18:30:54",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 587,
		  "totalCountries": 9,
		  "totalStates": 34,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1206,
		  "schedulePercent": 0.548504,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Golden Gate Park",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c1a2d84d3b9a3e9b022e57980da17f3",
		  
		  "name": "Sarah",
		  "createdDate": "2017-09-29 22:18:20",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 338,
		  "totalCountries": 22,
		  "totalStates": 56,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1790,
		  "schedulePercent": 0.674864,
		  "totalGuests": 252,
		  "guestPercent": 0.626247,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c289b4705d16677e2135e2bf18105b4",
		  
		  "name": "Katie ",
		  "createdDate": "2024-04-10 05:10:18",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 252,
		  "totalCountries": 8,
		  "totalStates": 30,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1819,
		  "schedulePercent": 0.67917,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c2c6a92f9e56e2c3693ebabbd4ba4c0",
		  
		  "name": "David",
		  "createdDate": "2023-04-24 20:14:32",
		  "totalOrganizations": 15,
		  "totalTours": 17,
		  "totalDays": 666,
		  "totalCountries": 18,
		  "totalStates": 63,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 3256,
		  "schedulePercent": 0.864914,
		  "totalGuests": 1480,
		  "guestPercent": 0.907412,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c3629a8340c93059876a60ccaf82d8d",
		  
		  "name": "Demetrius ",
		  "createdDate": "2013-03-01 23:10:12",
		  "totalOrganizations": 19,
		  "totalTours": 12,
		  "totalDays": 665,
		  "totalCountries": 16,
		  "totalStates": 49,
		  "totalEvents": 319,
		  "eventPercent": 0.925204,
		  "totalScheduleItems": 2598,
		  "schedulePercent": 0.797144,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c3abadca8484372e2d6dd9839bc852b",
		  
		  "name": "Przemyslaw",
		  "createdDate": "2025-05-31 14:59:09",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 775,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 127,
		  "schedulePercent": 0.116387,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c3d672a343b469f3ab7b8d0a9b74127",
		  
		  "name": "Chase",
		  "createdDate": "2022-10-14 00:54:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 296,
		  "schedulePercent": 0.215549,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Chesterfield Amphitheater",
		  "mostGuestCity": "Chesterfield",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c452c1e5ca5631e53414ba7d33e40de",
		  
		  "name": "Jesse",
		  "createdDate": "2025-03-19 05:22:24",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 140,
		  "totalCountries": 11,
		  "totalStates": 39,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 841,
		  "schedulePercent": 0.437557,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Palladium",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c48f11581bbae29ee8c8306062c2cc3",
		  
		  "name": "Elizabeth",
		  "createdDate": "2023-05-07 04:11:53",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 105,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1039,
		  "schedulePercent": 0.50102,
		  "totalGuests": 679,
		  "guestPercent": 0.780825,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c4dcfb55ff6075cb6d3e87eb2fcc241",
		  
		  "name": "Spilling",
		  "createdDate": "2022-04-25 16:02:36",
		  "totalOrganizations": 147,
		  "totalTours": 62,
		  "totalDays": 1117,
		  "totalCountries": 36,
		  "totalStates": 62,
		  "totalEvents": 450,
		  "eventPercent": 0.970875,
		  "totalScheduleItems": 3702,
		  "schedulePercent": 0.895966,
		  "totalGuests": 632,
		  "guestPercent": 0.765979,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c4f5ce982ee4c689150fb08878e2091",
		  
		  "name": "Katie",
		  "createdDate": "2021-09-20 17:55:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 139,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1481,
		  "schedulePercent": 0.612987,
		  "totalGuests": 2526,
		  "guestPercent": 0.969402,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c50bd78a8ee225e1ab8bb6a02487a54",
		  
		  "name": "Irela",
		  "createdDate": "2014-10-21 22:00:39",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 245,
		  "totalCountries": 16,
		  "totalStates": 13,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 118,
		  "schedulePercent": 0.109587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c5b634cdabe63404db6bdf33077e7a1",
		  
		  "name": "Phil",
		  "createdDate": "2010-07-22 17:14:43",
		  "totalOrganizations": 21,
		  "totalTours": 9,
		  "totalDays": 372,
		  "totalCountries": 15,
		  "totalStates": 33,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2662,
		  "schedulePercent": 0.80383,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c5eef1be6f452e2ea8af931b1b4f1f5",
		  
		  "name": "Jason",
		  "createdDate": "2019-12-01 20:01:30",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 46,
		  "totalCountries": 9,
		  "totalStates": 9,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 22,
		  "schedulePercent": 0.0330916,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c622d1fada4c4ea685b7f38ab0daab2",
		  
		  "name": "London",
		  "createdDate": "2021-12-05 23:11:32",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 66,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 396,
		  "schedulePercent": 0.267452,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c6a457b321766fa91720f61e569a9fb",
		  
		  "name": "Jared",
		  "createdDate": "2013-01-07 21:59:02",
		  "totalOrganizations": 25,
		  "totalTours": 31,
		  "totalDays": 1800,
		  "totalCountries": 18,
		  "totalStates": 55,
		  "totalEvents": 330,
		  "eventPercent": 0.93291,
		  "totalScheduleItems": 4373,
		  "schedulePercent": 0.934044,
		  "totalGuests": 1702,
		  "guestPercent": 0.928264,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Thompson's Point",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c6c563aff080a4bd41618f61f8009cf",
		  
		  "name": "Aaron",
		  "createdDate": "2021-10-05 22:46:03",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 194,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 1081,
		  "schedulePercent": 0.514619,
		  "totalGuests": 274,
		  "guestPercent": 0.637353,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c6cc30793337b966628205a6c586408",
		  
		  "name": "Luke",
		  "createdDate": "2025-03-29 11:39:31",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 32,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 206,
		  "schedulePercent": 0.163871,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-11 00:00:00",
		  "mostGuestName": "Tivoli",
		  "mostGuestCity": "Brisbane",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c6eb116b724d28b984ae81e01721332",
		  
		  "name": "James",
		  "createdDate": "2017-06-04 11:04:26",
		  "totalOrganizations": 15,
		  "totalTours": 35,
		  "totalDays": 517,
		  "totalCountries": 18,
		  "totalStates": 50,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1797,
		  "schedulePercent": 0.675657,
		  "totalGuests": 950,
		  "guestPercent": 0.839529,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c7041a8e9e8eea6e7f555ce50b67b48",
		  
		  "name": "Rey",
		  "createdDate": "2024-04-15 10:47:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 727,
		  "schedulePercent": 0.397099,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c7329195f2976e60444ef26b7430e2a",
		  
		  "name": "Ira",
		  "createdDate": "2019-09-30 23:16:37",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 71,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 752,
		  "schedulePercent": 0.406052,
		  "totalGuests": 490,
		  "guestPercent": 0.727561,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c743f529bb3e84930fcb1d63ba9e77f",
		  
		  "name": "Chris",
		  "createdDate": "2013-03-11 08:49:51",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 149,
		  "totalCountries": 6,
		  "totalStates": 13,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 248,
		  "schedulePercent": 0.188917,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c77cd94b0a3b93def66fbcce51d6437",
		  
		  "name": "Meegan",
		  "createdDate": "2025-04-04 23:49:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 61,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "The ELM",
		  "mostGuestCity": "Bozeman",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c84254e12045b7d5560a82ee670f23a",
		  
		  "name": "David",
		  "createdDate": "2015-02-07 04:44:54",
		  "totalOrganizations": 24,
		  "totalTours": 13,
		  "totalDays": 681,
		  "totalCountries": 17,
		  "totalStates": 53,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 1999,
		  "schedulePercent": 0.713282,
		  "totalGuests": 755,
		  "guestPercent": 0.797371,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Banan-Kompaniet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c91e59718e12a4681c15022eb240893",
		  
		  "name": "Andreu",
		  "createdDate": "2020-02-21 14:14:43",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 214,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 789,
		  "schedulePercent": 0.418631,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c9398de9fcb2756a0c5142075779da9",
		  
		  "name": "Suzie",
		  "createdDate": "2023-01-18 15:33:08",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 389,
		  "totalCountries": 20,
		  "totalStates": 20,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6c9d31bb8d1e323274df4cf833aff151",
		  
		  "name": "Hanna",
		  "createdDate": "2025-03-30 16:27:44",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 47,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 173,
		  "schedulePercent": 0.142452,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ca46c8404b97f3a6e7377c3c2d71979",
		  
		  "name": "Harrison",
		  "createdDate": "2021-03-18 16:41:44",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 135,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1254,
		  "schedulePercent": 0.561763,
		  "totalGuests": 258,
		  "guestPercent": 0.628513,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Lake Martin Amphitheater",
		  "mostGuestCity": "Eclectic",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ca8497e32a5f4b9b47388b443979066",
		  
		  "name": "George",
		  "createdDate": "2017-09-13 00:57:57",
		  "totalOrganizations": 12,
		  "totalTours": 25,
		  "totalDays": 487,
		  "totalCountries": 8,
		  "totalStates": 60,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2736,
		  "schedulePercent": 0.813803,
		  "totalGuests": 1671,
		  "guestPercent": 0.925997,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "The Glass House",
		  "mostGuestCity": "Pomona",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cb489d8d7f4b7de9abc22b015eb0935",
		  
		  "name": "Ellie",
		  "createdDate": "2024-04-16 20:08:57",
		  "totalOrganizations": 15,
		  "totalTours": 33,
		  "totalDays": 618,
		  "totalCountries": 26,
		  "totalStates": 64,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 2877,
		  "schedulePercent": 0.829896,
		  "totalGuests": 1516,
		  "guestPercent": 0.911605,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cbb1750ae4a978e0793f6cba40d4732",
		  
		  "name": "Jason",
		  "createdDate": "2013-03-21 02:00:23",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 133,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 804,
		  "schedulePercent": 0.424071,
		  "totalGuests": 1074,
		  "guestPercent": 0.859134,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cbc35a5760621f36e79275d232a6eca",
		  
		  "name": "NIcole",
		  "createdDate": "2022-04-22 17:14:02",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 446,
		  "totalCountries": 10,
		  "totalStates": 35,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1688,
		  "schedulePercent": 0.656505,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Hoedown Hill",
		  "mostGuestCity": "Windsor",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cc2ea5b20216f75819e5ee23941b03e",
		  
		  "name": "Julian",
		  "createdDate": "2025-09-01 13:10:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 70,
		  "totalCountries": 19,
		  "totalStates": 2,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 280,
		  "guestPercent": 0.639393,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "QUARTERBACK Immobilien ARENA",
		  "mostGuestCity": "Leipzig",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ccf9149703a42e9d345bbd55442a457",
		  
		  "name": "LTM",
		  "createdDate": "2018-11-27 04:57:52",
		  "totalOrganizations": 19,
		  "totalTours": 25,
		  "totalDays": 1259,
		  "totalCountries": 27,
		  "totalStates": 70,
		  "totalEvents": 288,
		  "eventPercent": 0.904465,
		  "totalScheduleItems": 3533,
		  "schedulePercent": 0.883953,
		  "totalGuests": 1415,
		  "guestPercent": 0.901519,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cd5d285f42c9f192903e9a5311c6195",
		  
		  "name": "Ollie",
		  "createdDate": "2023-08-07 10:13:50",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 138,
		  "totalCountries": 24,
		  "totalStates": 42,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 967,
		  "schedulePercent": 0.480394,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "The Garage",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cd6ea72f7f0e33ba300c12d8464621a",
		  
		  "name": "PC",
		  "createdDate": "2025-06-03 20:04:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 202,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 524,
		  "schedulePercent": 0.324003,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "The Kessler Theater",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cda7a97cbb7685ec08eda6dab922203",
		  
		  "name": "Ryder",
		  "createdDate": "2023-04-19 17:21:01",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 79,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 585,
		  "schedulePercent": 0.345648,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Historic Scoot Inn",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cdb5a61ed81d40c9782b6e8af6f26d6",
		  
		  "name": "Tanner",
		  "createdDate": "2022-07-20 20:51:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1051,
		  "schedulePercent": 0.504873,
		  "totalGuests": 97,
		  "guestPercent": 0.516092,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Mercury Lounge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cf338fab2af06933a68238819c83927",
		  
		  "name": "Ezra",
		  "createdDate": "2023-11-21 02:00:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 323,
		  "totalCountries": 20,
		  "totalStates": 11,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 820,
		  "schedulePercent": 0.430984,
		  "totalGuests": 268,
		  "guestPercent": 0.6335,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Brockwell Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cfa6cbd5828055dfe03b56827adf96a",
		  
		  "name": "Brian",
		  "createdDate": "2012-01-20 02:58:35",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 247,
		  "totalCountries": 17,
		  "totalStates": 58,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1125,
		  "schedulePercent": 0.526632,
		  "totalGuests": 368,
		  "guestPercent": 0.680417,
		  "mostGuestDate": "2025-07-08 00:00:00",
		  "mostGuestName": "Jannus Live",
		  "mostGuestCity": "St. Petersburg",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cfbeb2915b71ed71ce5408f20558dd9",
		  
		  "name": "Sinead",
		  "createdDate": "2018-09-28 06:23:02",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 987,
		  "totalCountries": 15,
		  "totalStates": 49,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 2936,
		  "schedulePercent": 0.835789,
		  "totalGuests": 417,
		  "guestPercent": 0.700363,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "MGM Grand",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6cfc910431e4b459fec9064e84037208",
		  
		  "name": "Edward",
		  "createdDate": "2009-08-24 17:08:14",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 493,
		  "schedulePercent": 0.30927,
		  "totalGuests": 666,
		  "guestPercent": 0.776292,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d03271673e3d25fe1ca050e0974f119",
		  
		  "name": "Steven",
		  "createdDate": "2014-03-01 02:10:27",
		  "totalOrganizations": 15,
		  "totalTours": 27,
		  "totalDays": 1796,
		  "totalCountries": 38,
		  "totalStates": 76,
		  "totalEvents": 375,
		  "eventPercent": 0.952403,
		  "totalScheduleItems": 6751,
		  "schedulePercent": 0.984474,
		  "totalGuests": 4013,
		  "guestPercent": 0.9932,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "OVO Arena Wembley",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 401,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d07e7555b2bf14d66022071603fb791",
		  
		  "name": "Tom",
		  "createdDate": "2024-01-07 03:11:56",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 593,
		  "totalCountries": 8,
		  "totalStates": 60,
		  "totalEvents": 367,
		  "eventPercent": 0.948663,
		  "totalScheduleItems": 4221,
		  "schedulePercent": 0.927697,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Theatre Royal Glasgow",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d119b9a36c41d0c5b5cd3429cfba375",
		  
		  "name": "Maria Alejandra",
		  "createdDate": "2021-06-28 20:28:23",
		  "totalOrganizations": 69,
		  "totalTours": 15,
		  "totalDays": 739,
		  "totalCountries": 7,
		  "totalStates": 41,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 2195,
		  "schedulePercent": 0.747393,
		  "totalGuests": 903,
		  "guestPercent": 0.830689,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d235cb52e62d285619451138c743ebb",
		  
		  "name": "Reid",
		  "createdDate": "2024-09-10 17:51:15",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 160,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Third Room",
		  "mostGuestCity": "Asheville",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d2c749b8003b00b2cb69c05761476f9",
		  
		  "name": "Lindsay",
		  "createdDate": "2023-06-09 02:55:07",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 439,
		  "totalCountries": 24,
		  "totalStates": 62,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 2289,
		  "schedulePercent": 0.760313,
		  "totalGuests": 2115,
		  "guestPercent": 0.954556,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d39be488e5c5ee6e691a8488eb78966",
		  
		  "name": "Gustav",
		  "createdDate": "2018-05-18 12:17:09",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 86,
		  "totalCountries": 16,
		  "totalStates": 14,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 434,
		  "schedulePercent": 0.283205,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d3a97917d1473c8e238b02a8b083d00",
		  
		  "name": "Andrew",
		  "createdDate": "2023-12-30 23:25:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 21,
		  "totalCountries": 1,
		  "totalStates": 7,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 121,
		  "schedulePercent": 0.111627,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d467acdc8bdf5ae05db95d3d0c38574",
		  
		  "name": "Kadin",
		  "createdDate": "2025-10-27 21:45:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-29 00:00:00",
		  "mostGuestName": "Kulturwerk Herford",
		  "mostGuestCity": "Herford",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d4e9a619b169d849f0929affda0fdc0",
		  
		  "name": "Alison",
		  "createdDate": "2022-09-03 04:21:50",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 116,
		  "schedulePercent": 0.108228,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d4f51b9861a70f395ded83e37a7f27b",
		  
		  "name": "Hannah",
		  "createdDate": "2025-03-18 16:07:42",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 694,
		  "totalCountries": 13,
		  "totalStates": 22,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1115,
		  "schedulePercent": 0.522439,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-06-04 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d4ffbf0740075eaa23dbfe739c99a2d",
		  
		  "name": "Kelsey",
		  "createdDate": "2022-05-11 21:21:36",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 745,
		  "totalCountries": 2,
		  "totalStates": 33,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 597,
		  "schedulePercent": 0.350068,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "Daryl's House Club",
		  "mostGuestCity": "Pawling",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d5975ac9659338ee582c6c86c05e6d3",
		  
		  "name": "Kevin Alexander",
		  "createdDate": "2025-08-12 19:05:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 141,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 89,
		  "schedulePercent": 0.0889619,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d6231d56e19dd1952a9a0b37f362759",
		  
		  "name": "Morgan",
		  "createdDate": "2022-07-06 16:04:50",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 280,
		  "totalCountries": 9,
		  "totalStates": 21,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1172,
		  "schedulePercent": 0.540571,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d647d6b60f8aede7b7f0a651412a822",
		  
		  "name": "Tora Terese",
		  "createdDate": "2021-08-19 06:26:10",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 349,
		  "totalCountries": 4,
		  "totalStates": 14,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 1568,
		  "schedulePercent": 0.634406,
		  "totalGuests": 228,
		  "guestPercent": 0.611514,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Lille VEGA, KÃ¸benhavn (Musikkens Hus)",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d6a81ea990f2e50d6e253793df08891",
		  
		  "name": "Justin",
		  "createdDate": "2023-09-10 16:17:19",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 169,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1394,
		  "schedulePercent": 0.596555,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-04-22 00:00:00",
		  "mostGuestName": "Nile Theater",
		  "mostGuestCity": "Mesa",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d72454a41617b1ace1ae91c16497c26",
		  
		  "name": "Sarah",
		  "createdDate": "2022-08-13 00:02:50",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 142,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 186,
		  "schedulePercent": 0.151405,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d8ced23e01f08434a57f6af533f5755",
		  
		  "name": "Jon",
		  "createdDate": "2023-05-12 17:37:44",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 404,
		  "totalCountries": 3,
		  "totalStates": 49,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1481,
		  "schedulePercent": 0.612987,
		  "totalGuests": 460,
		  "guestPercent": 0.715775,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d8f064bf69563ef1fccfa6422b2ac51",
		  
		  "name": "Lindsay",
		  "createdDate": "2016-02-05 23:09:34",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 410,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 314,
		  "schedulePercent": 0.224388,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Country Thunder Alberta",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d93a8bcbbd5967503115a2b59992f0e",
		  
		  "name": "Mark",
		  "createdDate": "2022-04-11 16:26:53",
		  "totalOrganizations": 3,
		  "totalTours": 12,
		  "totalDays": 144,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 794,
		  "schedulePercent": 0.420331,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d9676b09e9e237a128783554721ff02",
		  
		  "name": "Mark",
		  "createdDate": "2017-02-21 18:31:10",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 325,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1814,
		  "schedulePercent": 0.678377,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6d9e927abb49dc3d617028f54f4e133c",
		  
		  "name": "Freddie",
		  "createdDate": "2012-06-01 20:34:10",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 517,
		  "totalCountries": 5,
		  "totalStates": 52,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1483,
		  "schedulePercent": 0.613894,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Voodoo Lounge",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6da0624f222c1cdf7d87c2fe36615947",
		  
		  "name": "Gustavo ",
		  "createdDate": "2025-10-27 17:35:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 22,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 135,
		  "schedulePercent": 0.121827,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-11-14 00:00:00",
		  "mostGuestName": "OpÃ©ra de Rouen Normandie",
		  "mostGuestCity": "Rouen",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6da08baf073cd564ee2d52959e9b4404",
		  
		  "name": "Alonso",
		  "createdDate": "2024-02-28 21:29:02",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 303,
		  "totalCountries": 5,
		  "totalStates": 30,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 420,
		  "schedulePercent": 0.278332,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6dae36f0226e2b597a7b40f76d214c65",
		  
		  "name": "AJ",
		  "createdDate": "2018-05-16 14:02:21",
		  "totalOrganizations": 23,
		  "totalTours": 22,
		  "totalDays": 1483,
		  "totalCountries": 30,
		  "totalStates": 67,
		  "totalEvents": 572,
		  "eventPercent": 0.986061,
		  "totalScheduleItems": 9292,
		  "schedulePercent": 0.995127,
		  "totalGuests": 2002,
		  "guestPercent": 0.947303,
		  "mostGuestDate": "2025-03-12 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6daf7940194ee044d1371be430b66f0f",
		  
		  "name": "Archie",
		  "createdDate": "2025-04-20 04:02:18",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 755,
		  "totalCountries": 23,
		  "totalStates": 49,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 3262,
		  "schedulePercent": 0.86514,
		  "totalGuests": 1457,
		  "guestPercent": 0.906278,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Roadrunner",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6db89d20c9c9c1381ddc918fa9534d6d",
		  
		  "name": "John",
		  "createdDate": "2012-10-17 16:15:37",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 542,
		  "totalCountries": 10,
		  "totalStates": 35,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1205,
		  "schedulePercent": 0.548051,
		  "totalGuests": 221,
		  "guestPercent": 0.607774,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Capital One Arena",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6dbc89658896714018fe25d97dd0f976",
		  
		  "name": "Sue",
		  "createdDate": "2023-03-28 12:48:21",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 46,
		  "totalCountries": 11,
		  "totalStates": 13,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 167,
		  "schedulePercent": 0.138939,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "La Cigale",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6dc91ade1aae69309c2f3da810728c9b",
		  
		  "name": "Eileen ",
		  "createdDate": "2014-09-08 10:44:04",
		  "totalOrganizations": 20,
		  "totalTours": 8,
		  "totalDays": 337,
		  "totalCountries": 19,
		  "totalStates": 29,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2936,
		  "schedulePercent": 0.835789,
		  "totalGuests": 3463,
		  "guestPercent": 0.989461,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Lanxess Arena",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 195,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6dc9a18a539320258b6e6879e4f0ae8f",
		  
		  "name": "Nick",
		  "createdDate": "2022-05-30 07:15:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 246,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 142,
		  "schedulePercent": 0.126587,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Jergel's Rhythm Grille",
		  "mostGuestCity": "Warrendale",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6dcdb89550a3dea644b95e06db70fb40",
		  
		  "name": "Agustin ",
		  "createdDate": "2019-01-17 09:26:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 55,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 273,
		  "schedulePercent": 0.201609,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6dedf0a644688dfaad655b1e1e105f95",
		  
		  "name": "Caroline",
		  "createdDate": "2024-02-14 21:51:23",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 352,
		  "totalCountries": 6,
		  "totalStates": 53,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 2752,
		  "schedulePercent": 0.816636,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6dfad07b0286afabe800a5300377ef6c",
		  
		  "name": "Elliott",
		  "createdDate": "2017-05-22 12:20:23",
		  "totalOrganizations": 13,
		  "totalTours": 8,
		  "totalDays": 248,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 395,
		  "schedulePercent": 0.266772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6dfebec443180cedfcdcd37aba8bb48d",
		  
		  "name": "Colie",
		  "createdDate": "2013-07-30 15:45:36",
		  "totalOrganizations": 16,
		  "totalTours": 8,
		  "totalDays": 596,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1768,
		  "schedulePercent": 0.671011,
		  "totalGuests": 213,
		  "guestPercent": 0.604261,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Hernando's Hideaway",
		  "mostGuestCity": "Memphis",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e0024f49590330f664d154d207d182a",
		  
		  "name": "William",
		  "createdDate": "2018-10-03 22:46:17",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 686,
		  "totalCountries": 22,
		  "totalStates": 80,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 4739,
		  "schedulePercent": 0.945943,
		  "totalGuests": 95,
		  "guestPercent": 0.513826,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "ArÃ¨nes de NÃ®mes",
		  "mostGuestCity": "NÃ®mes",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e0d3df90aba27f46bd9906b76568adb",
		  
		  "name": "Emily",
		  "createdDate": "2022-09-02 01:26:09",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 1756,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2640,
		  "schedulePercent": 0.802017,
		  "totalGuests": 318,
		  "guestPercent": 0.658772,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Sphere",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e17ce37e8fe83d7c9f852d590fd5dec",
		  
		  "name": "Tec",
		  "createdDate": "2013-08-25 17:39:13",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 655,
		  "totalCountries": 33,
		  "totalStates": 64,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 2804,
		  "schedulePercent": 0.822643,
		  "totalGuests": 1121,
		  "guestPercent": 0.867067,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e192f1909660df492f49124ac2800f4",
		  
		  "name": "Alex",
		  "createdDate": "2024-07-22 20:13:22",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 107,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 817,
		  "schedulePercent": 0.429737,
		  "totalGuests": 393,
		  "guestPercent": 0.691296,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e1d8960cd351abc0a065247a9443ba0",
		  
		  "name": "Lloyd",
		  "createdDate": "2018-11-26 18:22:28",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 196,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 990,
		  "schedulePercent": 0.488554,
		  "totalGuests": 180,
		  "guestPercent": 0.580009,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Tiki Bar",
		  "mostGuestCity": "Costa Mesa",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e1e728f359421596701ff763e6b1e57",
		  
		  "name": "Kira",
		  "createdDate": "2023-01-06 18:18:20",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 337,
		  "totalCountries": 22,
		  "totalStates": 60,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 1699,
		  "schedulePercent": 0.658432,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e27ad6f2182e34f8cc4297ced937627",
		  
		  "name": "Colin",
		  "createdDate": "2023-02-01 20:00:30",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 1080,
		  "totalCountries": 5,
		  "totalStates": 58,
		  "totalEvents": 334,
		  "eventPercent": 0.934497,
		  "totalScheduleItems": 4661,
		  "schedulePercent": 0.942543,
		  "totalGuests": 3666,
		  "guestPercent": 0.991274,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e27d6ed2f8584d089f3fb732e1c8667",
		  
		  "name": "Rob",
		  "createdDate": "2022-06-27 11:22:57",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 480,
		  "totalCountries": 33,
		  "totalStates": 20,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1188,
		  "schedulePercent": 0.544084,
		  "totalGuests": 176,
		  "guestPercent": 0.577743,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Troxy",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e29e02f833f9a8fc4331122507f0640",
		  
		  "name": "Chris",
		  "createdDate": "2016-05-16 19:27:23",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 82,
		  "totalCountries": 15,
		  "totalStates": 22,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 280,
		  "schedulePercent": 0.205576,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "GARDEN AMP",
		  "mostGuestCity": "Garden Grove",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e338933b84e61a6189dbf0fb5101400",
		  
		  "name": "Dustin ",
		  "createdDate": "2014-03-17 22:11:56",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 390,
		  "totalCountries": 31,
		  "totalStates": 57,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 2028,
		  "schedulePercent": 0.718948,
		  "totalGuests": 872,
		  "guestPercent": 0.823436,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e38980f41ceb188968e18c0c9e3ab75",
		  
		  "name": "Quinn",
		  "createdDate": "2022-04-29 22:58:32",
		  "totalOrganizations": 19,
		  "totalTours": 15,
		  "totalDays": 683,
		  "totalCountries": 15,
		  "totalStates": 33,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 2829,
		  "schedulePercent": 0.825589,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e3b5a7b465aa612fbda3703bd5bca2f",
		  
		  "name": "Abigail",
		  "createdDate": "2016-03-02 01:28:54",
		  "totalOrganizations": 13,
		  "totalTours": 2,
		  "totalDays": 224,
		  "totalCountries": 10,
		  "totalStates": 19,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 1216,
		  "schedulePercent": 0.550657,
		  "totalGuests": 223,
		  "guestPercent": 0.608568,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e414ea5bcc014f88c5551b087f3b697",
		  
		  "name": "Kirk",
		  "createdDate": "2010-03-05 21:20:38",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 383,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 646,
		  "schedulePercent": 0.36582,
		  "totalGuests": 668,
		  "guestPercent": 0.777199,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Orion Amphitheater",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 121,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e4872956ea4b1b333dbd08793d79b3d",
		  
		  "name": "Cody",
		  "createdDate": "2021-08-23 19:38:52",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 181,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 700,
		  "schedulePercent": 0.386786,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "Arlington Music Hall",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e4bfc16a3bfa15ea5a5595051f7cc7b",
		  
		  "name": "Leonie",
		  "createdDate": "2023-09-25 15:21:38",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 645,
		  "totalCountries": 6,
		  "totalStates": 18,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 2705,
		  "schedulePercent": 0.80893,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e59416111495b5ba4cade7270fa7965",
		  
		  "name": " Hannah",
		  "createdDate": "2025-03-27 17:49:11",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 20,
		  "totalCountries": 9,
		  "totalStates": 13,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 132,
		  "schedulePercent": 0.119674,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e5fe3e4cb5d98c80da4b3f6df3a51db",
		  
		  "name": "Naomi ",
		  "createdDate": "2024-01-03 03:03:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 90,
		  "totalCountries": 15,
		  "totalStates": 29,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 621,
		  "schedulePercent": 0.357548,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e7502ad176923210ceca477665e9cb7",
		  
		  "name": "Chancey",
		  "createdDate": "2019-05-15 17:49:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 138,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 557,
		  "schedulePercent": 0.336355,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e7dd1fd2c4f6871740f8e6ab0172177",
		  
		  "name": "Vivian",
		  "createdDate": "2018-06-06 18:24:59",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 342,
		  "totalCountries": 8,
		  "totalStates": 38,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1323,
		  "schedulePercent": 0.576496,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e7e1303cf724bead4c8744542f13d8d",
		  
		  "name": "Atalanta",
		  "createdDate": "2024-01-19 17:17:14",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 1227,
		  "totalCountries": 34,
		  "totalStates": 54,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 4104,
		  "schedulePercent": 0.919198,
		  "totalGuests": 460,
		  "guestPercent": 0.715775,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e82513cd63d3fec4a0765d4069a4a60",
		  
		  "name": "Andreas",
		  "createdDate": "2022-12-28 12:30:22",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 97,
		  "totalCountries": 18,
		  "totalStates": 19,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 568,
		  "guestPercent": 0.749207,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Festung Kufstein",
		  "mostGuestCity": "Kufstein",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e83a1276cd4331048baff68adcd1018",
		  
		  "name": "Nick",
		  "createdDate": "2017-05-02 18:48:47",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 566,
		  "totalCountries": 33,
		  "totalStates": 50,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 103,
		  "guestPercent": 0.522779,
		  "mostGuestDate": "2025-09-01 00:00:00",
		  "mostGuestName": "Nippon Budokan",
		  "mostGuestCity": "Chiyoda-ku",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e863c7b993a4d4b51e45c82af715d97",
		  
		  "name": "Alexa",
		  "createdDate": "2023-07-09 15:34:54",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 605,
		  "totalCountries": 8,
		  "totalStates": 53,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2712,
		  "schedulePercent": 0.810517,
		  "totalGuests": 2005,
		  "guestPercent": 0.947756,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "UBS Arena",
		  "mostGuestCity": "Elmont",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6e909ef19fccf81f9b51f94f26d5fde3",
		  
		  "name": "Gift",
		  "createdDate": "2022-07-26 19:46:45",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 476,
		  "totalCountries": 7,
		  "totalStates": 34,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 864,
		  "schedulePercent": 0.446056,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ea0dc85fadd03e6acbd6abb8ec57b76",
		  
		  "name": "Stuart",
		  "createdDate": "2012-03-09 14:59:31",
		  "totalOrganizations": 9,
		  "totalTours": 19,
		  "totalDays": 1455,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 278,
		  "eventPercent": 0.896872,
		  "totalScheduleItems": 4718,
		  "schedulePercent": 0.94515,
		  "totalGuests": 2649,
		  "guestPercent": 0.974161,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6eb33b72688e18e648b7c786d5c2e56a",
		  
		  "name": "Hector",
		  "createdDate": "2022-09-08 16:14:54",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 83,
		  "totalCountries": 10,
		  "totalStates": 21,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 553,
		  "schedulePercent": 0.334995,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Die Kantine",
		  "mostGuestCity": "Koln",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ed0b6099dd2ead6e6ac17d7c8191b54",
		  
		  "name": "DeGira",
		  "createdDate": "2024-02-14 00:35:36",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 130,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 749,
		  "schedulePercent": 0.404805,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ed433c01f3aded15f5ac7fa56630bee",
		  
		  "name": "Robert",
		  "createdDate": "2014-03-27 05:33:01",
		  "totalOrganizations": 20,
		  "totalTours": 15,
		  "totalDays": 815,
		  "totalCountries": 14,
		  "totalStates": 65,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 1990,
		  "schedulePercent": 0.711695,
		  "totalGuests": 1213,
		  "guestPercent": 0.877267,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ee1577dc1de9177f8a962820838db6c",
		  
		  "name": "Henry",
		  "createdDate": "2014-08-07 01:25:23",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 361,
		  "totalCountries": 3,
		  "totalStates": 48,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1324,
		  "schedulePercent": 0.576609,
		  "totalGuests": 200,
		  "guestPercent": 0.594855,
		  "mostGuestDate": "2025-09-22 00:00:00",
		  "mostGuestName": "Avenir Centre",
		  "mostGuestCity": "Moncton",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6eef3a5d2e572e13a39fd92b366585a8",
		  
		  "name": "John",
		  "createdDate": "2023-03-16 10:30:35",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 477,
		  "totalCountries": 22,
		  "totalStates": 43,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 623,
		  "schedulePercent": 0.358454,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "MK11 Live Music Venue & Sports Bar",
		  "mostGuestCity": "Milton Keynes",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6eefe6724de101d9f5dd5027b354474f",
		  
		  "name": "Jacob",
		  "createdDate": "2022-10-17 23:56:25",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 1042,
		  "totalCountries": 12,
		  "totalStates": 67,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 4246,
		  "schedulePercent": 0.928944,
		  "totalGuests": 2856,
		  "guestPercent": 0.979261,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ef334c5e341269057aad7f7559a8aa8",
		  
		  "name": "Tanner",
		  "createdDate": "2023-04-13 16:09:16",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 155,
		  "totalCountries": 8,
		  "totalStates": 43,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-06-03 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ef61b155f0ed11c2a2c951a89718ed3",
		  
		  "name": "Sara",
		  "createdDate": "2025-02-04 15:35:42",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 801,
		  "totalCountries": 6,
		  "totalStates": 46,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1976,
		  "schedulePercent": 0.708975,
		  "totalGuests": 306,
		  "guestPercent": 0.652539,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f1a1412ae060cb85c967848ea348a50",
		  
		  "name": "Mike ",
		  "createdDate": "2017-06-02 21:25:11",
		  "totalOrganizations": 1,
		  "totalTours": 11,
		  "totalDays": 65,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 791,
		  "schedulePercent": 0.419311,
		  "totalGuests": 1237,
		  "guestPercent": 0.878966,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f1bb7b2b0e120b6c61ba24cb373dc67",
		  
		  "name": "Allie",
		  "createdDate": "2025-03-25 14:45:56",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 440,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1212,
		  "schedulePercent": 0.549637,
		  "totalGuests": 266,
		  "guestPercent": 0.632026,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f2a3012ac1f3af00b63562205ed63d9",
		  
		  "name": "Greg",
		  "createdDate": "2012-07-02 11:58:42",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 378,
		  "totalCountries": 7,
		  "totalStates": 19,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 662,
		  "schedulePercent": 0.372393,
		  "totalGuests": 312,
		  "guestPercent": 0.654918,
		  "mostGuestDate": "2025-04-16 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f2bcdd2949476281f229691054bbf19",
		  
		  "name": "Erika",
		  "createdDate": "2022-06-11 18:48:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 947,
		  "schedulePercent": 0.474388,
		  "totalGuests": 1307,
		  "guestPercent": 0.887239,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f2bdf27720180546d70c00d73a3807b",
		  
		  "name": "Sara",
		  "createdDate": "2025-09-02 19:03:01",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 83,
		  "totalCountries": 9,
		  "totalStates": 32,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 598,
		  "schedulePercent": 0.350521,
		  "totalGuests": 249,
		  "guestPercent": 0.624887,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f2cb88dc96d45d5d1f2ef174f121392",
		  
		  "name": "NATALIE",
		  "createdDate": "2019-08-20 14:20:53",
		  "totalOrganizations": 3,
		  "totalTours": 13,
		  "totalDays": 379,
		  "totalCountries": 17,
		  "totalStates": 40,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1587,
		  "schedulePercent": 0.637806,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-22 00:00:00",
		  "mostGuestName": "Kupferschmiede",
		  "mostGuestCity": "Langnau im Emmental",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f3049bebae773785130f24694212bcd",
		  
		  "name": "Zach",
		  "createdDate": "2019-11-27 04:41:34",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 731,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1447,
		  "schedulePercent": 0.606754,
		  "totalGuests": 820,
		  "guestPercent": 0.81301,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f345f35c30b75caa1b8c9f13a362cf2",
		  
		  "name": "Jurgen",
		  "createdDate": "2022-05-04 11:16:11",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 579,
		  "totalCountries": 21,
		  "totalStates": 68,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 2005,
		  "schedulePercent": 0.714642,
		  "totalGuests": 1436,
		  "guestPercent": 0.903558,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "House of Blues Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f3ae574911d01565620f741cbdbb8f3",
		  
		  "name": "Zackiri",
		  "createdDate": "2021-11-23 12:53:58",
		  "totalOrganizations": 8,
		  "totalTours": 30,
		  "totalDays": 625,
		  "totalCountries": 29,
		  "totalStates": 71,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 3620,
		  "schedulePercent": 0.890979,
		  "totalGuests": 1105,
		  "guestPercent": 0.864914,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f3c8a8e9de59e528d81ed43cd2a286f",
		  
		  "name": "Tommy",
		  "createdDate": "2017-07-12 17:43:23",
		  "totalOrganizations": 26,
		  "totalTours": 17,
		  "totalDays": 435,
		  "totalCountries": 21,
		  "totalStates": 50,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 1742,
		  "schedulePercent": 0.665911,
		  "totalGuests": 125,
		  "guestPercent": 0.541025,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Lincoln Theatre",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f3d8288e9cea5773e4b9884f58fba19",
		  
		  "name": "Patrick",
		  "createdDate": "2016-08-01 02:15:44",
		  "totalOrganizations": 31,
		  "totalTours": 36,
		  "totalDays": 1367,
		  "totalCountries": 13,
		  "totalStates": 24,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 2280,
		  "schedulePercent": 0.759293,
		  "totalGuests": 1726,
		  "guestPercent": 0.92917,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f3ea255371a7c97575e57c747dc84b5",
		  
		  "name": "Joe",
		  "createdDate": "2018-10-24 16:49:21",
		  "totalOrganizations": 15,
		  "totalTours": 12,
		  "totalDays": 712,
		  "totalCountries": 20,
		  "totalStates": 42,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1573,
		  "schedulePercent": 0.635539,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Cabaret Sauvage",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f4784f1f2adf72ec22d485923ab46cb",
		  
		  "name": "Aaron ",
		  "createdDate": "2024-12-30 21:16:33",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 165,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1663,
		  "schedulePercent": 0.651745,
		  "totalGuests": 575,
		  "guestPercent": 0.75102,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f53772430798198e4989799bd2f5747",
		  
		  "name": "Jeffery",
		  "createdDate": "2022-04-27 14:17:31",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 692,
		  "totalCountries": 19,
		  "totalStates": 56,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2308,
		  "schedulePercent": 0.762806,
		  "totalGuests": 694,
		  "guestPercent": 0.784111,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f6563f9877a8f1452e193479c3ecade",
		  
		  "name": "Winners",
		  "createdDate": "2024-07-26 13:46:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 111,
		  "schedulePercent": 0.106074,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f6b077b5a125fac412a4d03da588796",
		  
		  "name": "Sebastian",
		  "createdDate": "2021-06-07 15:35:58",
		  "totalOrganizations": 5,
		  "totalTours": 17,
		  "totalDays": 351,
		  "totalCountries": 12,
		  "totalStates": 54,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 3449,
		  "schedulePercent": 0.878626,
		  "totalGuests": 419,
		  "guestPercent": 0.701496,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "BOK Center",
		  "mostGuestCity": "Tulsa",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f6c4976d591c39adf7988e7ccce79c9",
		  
		  "name": "Casandra",
		  "createdDate": "2024-03-21 23:52:16",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 359,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 971,
		  "schedulePercent": 0.481641,
		  "totalGuests": 684,
		  "guestPercent": 0.782072,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f7d9be3c59168c05e790cb3ac0a0384",
		  
		  "name": "Abbie",
		  "createdDate": "2019-10-14 01:22:54",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 167,
		  "totalCountries": 18,
		  "totalStates": 36,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 2883,
		  "schedulePercent": 0.830576,
		  "totalGuests": 2451,
		  "guestPercent": 0.966455,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f82111471424ccab1e9ce84f49ff004",
		  
		  "name": "Justin",
		  "createdDate": "2022-06-17 09:29:39",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 829,
		  "totalCountries": 14,
		  "totalStates": 55,
		  "totalEvents": 346,
		  "eventPercent": 0.940503,
		  "totalScheduleItems": 4712,
		  "schedulePercent": 0.944583,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "House of Blues Restaurant & Bar",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f8a25d44e86065ed489eb0cef713f75",
		  
		  "name": "Gulya",
		  "createdDate": "2022-08-28 16:20:24",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 358,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 291,
		  "eventPercent": 0.906618,
		  "totalScheduleItems": 3759,
		  "schedulePercent": 0.899365,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f9034d561e456eed57e36c839b3d588",
		  
		  "name": "Christian",
		  "createdDate": "2023-11-10 17:59:03",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 682,
		  "totalCountries": 15,
		  "totalStates": 21,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1304,
		  "schedulePercent": 0.57219,
		  "totalGuests": 477,
		  "guestPercent": 0.722915,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Le Bikini",
		  "mostGuestCity": "Ramonville-Saint-Agne",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f94d003009601d0fda942f2799410fa",
		  
		  "name": "MATTHEW",
		  "createdDate": "2025-07-21 03:49:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 8,
		  "totalStates": 9,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 40,
		  "schedulePercent": 0.0504306,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6f9dccfd7389b3fb7846c1586754e443",
		  
		  "name": "Nicholas ",
		  "createdDate": "2015-05-22 07:20:04",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 204,
		  "totalCountries": 22,
		  "totalStates": 33,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1276,
		  "schedulePercent": 0.566636,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Auditorium Parco Della Musica - Sala Sinopoli",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6fbbfff94430a09ca24a421b6849b432",
		  
		  "name": "Laretta ",
		  "createdDate": "2022-03-15 07:59:26",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 1166,
		  "totalCountries": 26,
		  "totalStates": 67,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 4209,
		  "schedulePercent": 0.926337,
		  "totalGuests": 1120,
		  "guestPercent": 0.86684,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6fe1dbc029fbfd808c59c565149e3ea4",
		  
		  "name": "Cheryl",
		  "createdDate": "2014-11-02 18:45:57",
		  "totalOrganizations": 20,
		  "totalTours": 14,
		  "totalDays": 2227,
		  "totalCountries": 12,
		  "totalStates": 48,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 3598,
		  "schedulePercent": 0.889053,
		  "totalGuests": 410,
		  "guestPercent": 0.697303,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Wang Theater",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "6ff9472772d4fdaab2dc738e1a1b40e7",
		  
		  "name": "Svein Egil",
		  "createdDate": "2024-07-05 14:27:02",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 34,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 162,
		  "schedulePercent": 0.136786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-12-18 00:00:00",
		  "mostGuestName": "Olavshallen",
		  "mostGuestCity": "Trondheim",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7002c20d66ebe74e1a3983673e7b1962",
		  
		  "name": "james",
		  "createdDate": "2013-08-13 10:02:07",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 23,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 176,
		  "schedulePercent": 0.143699,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "700fb73245b74bf3be92778b3ec06ab1",
		  
		  "name": "Harry",
		  "createdDate": "2022-04-01 11:42:20",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 519,
		  "totalCountries": 18,
		  "totalStates": 16,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2212,
		  "schedulePercent": 0.750113,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Studebaker Theater",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "701ce392e4918fbfa67f3a45bbf193ae",
		  
		  "name": "Marco",
		  "createdDate": "2021-11-30 16:29:28",
		  "totalOrganizations": 6,
		  "totalTours": 32,
		  "totalDays": 1197,
		  "totalCountries": 38,
		  "totalStates": 73,
		  "totalEvents": 390,
		  "eventPercent": 0.956029,
		  "totalScheduleItems": 4486,
		  "schedulePercent": 0.937783,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "701f45df5e8a2a03729f1bb756a0e774",
		  
		  "name": "Nina ",
		  "createdDate": "2019-12-02 03:05:27",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 40,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 108,
		  "schedulePercent": 0.103921,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "702409e4119fab919741f53a88620bb1",
		  
		  "name": "Johannes",
		  "createdDate": "2017-05-17 07:34:19",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 266,
		  "totalCountries": 5,
		  "totalStates": 4,
		  "totalEvents": 256,
		  "eventPercent": 0.876927,
		  "totalScheduleItems": 1274,
		  "schedulePercent": 0.56641,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "702a128f136275c77663fa3875102f45",
		  
		  "name": "Tyler",
		  "createdDate": "2023-04-14 15:40:40",
		  "totalOrganizations": 19,
		  "totalTours": 24,
		  "totalDays": 717,
		  "totalCountries": 25,
		  "totalStates": 82,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 3366,
		  "schedulePercent": 0.872847,
		  "totalGuests": 754,
		  "guestPercent": 0.796917,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "703070cd840d5ca0532726f7a1db53d1",
		  
		  "name": "Paul",
		  "createdDate": "2022-12-03 03:54:05",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 319,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 871,
		  "schedulePercent": 0.448776,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-03-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70307f194414800fd64328798a1316fc",
		  
		  "name": "Peter",
		  "createdDate": "2013-07-01 03:59:04",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 1580,
		  "schedulePercent": 0.636673,
		  "totalGuests": 1377,
		  "guestPercent": 0.896985,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "703cc42cdc41e8d77e4d7482c4b4e34e",
		  
		  "name": "Megumi",
		  "createdDate": "2024-08-10 07:07:14",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 88,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 220,
		  "schedulePercent": 0.171578,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "703d2d5f49e895c5f8cda9f9a0625d50",
		  
		  "name": "Alex ",
		  "createdDate": "2019-03-22 18:11:47",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 369,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Pensacola Interstate Fair",
		  "mostGuestCity": "Pensacola",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "704423da3c2333cd0018202314a9da79",
		  
		  "name": "Jamie",
		  "createdDate": "2019-11-29 21:16:44",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 863,
		  "totalCountries": 10,
		  "totalStates": 43,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 2321,
		  "schedulePercent": 0.765186,
		  "totalGuests": 1292,
		  "guestPercent": 0.885199,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7046de1c18b182a0841d41a00ed0d954",
		  
		  "name": "Steve",
		  "createdDate": "2010-03-08 16:09:12",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 216,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1376,
		  "schedulePercent": 0.591682,
		  "totalGuests": 568,
		  "guestPercent": 0.749207,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "L'Olympia Bruno Coquatrix",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "704bea4009ea577074f15250bc0f9640",
		  
		  "name": "Ollie",
		  "createdDate": "2024-02-19 10:44:12",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 1146,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 321,
		  "eventPercent": 0.926904,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "704d28b2bdc473f1b892fd2a569e3c83",
		  
		  "name": "Jimmy",
		  "createdDate": "2016-11-25 12:36:25",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 387,
		  "totalCountries": 24,
		  "totalStates": 72,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 3412,
		  "schedulePercent": 0.876473,
		  "totalGuests": 1682,
		  "guestPercent": 0.926904,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Cardiff Utilita Arena",
		  "mostGuestCity": "Cardiff",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70511627744c42ba183ba0ea2dc0c1ce",
		  
		  "name": "Jeremy",
		  "createdDate": "2018-12-08 22:45:25",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 44,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 282,
		  "schedulePercent": 0.206936,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "706fed58dbaae6bce66bd737592d8a73",
		  
		  "name": "Lauren",
		  "createdDate": "2024-03-12 16:28:23",
		  "totalOrganizations": 22,
		  "totalTours": 34,
		  "totalDays": 1417,
		  "totalCountries": 16,
		  "totalStates": 78,
		  "totalEvents": 575,
		  "eventPercent": 0.986287,
		  "totalScheduleItems": 7019,
		  "schedulePercent": 0.986514,
		  "totalGuests": 1139,
		  "guestPercent": 0.87024,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7071754f83ff5e19105f1a82d5df004c",
		  
		  "name": "Abraham",
		  "createdDate": "2024-02-16 18:47:38",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 37,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 126,
		  "schedulePercent": 0.115707,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7071a0b8cddfbc57863617514b464a24",
		  
		  "name": "Miranda",
		  "createdDate": "2025-03-18 19:11:53",
		  "totalOrganizations": 1,
		  "totalTours": 32,
		  "totalDays": 143,
		  "totalCountries": 13,
		  "totalStates": 31,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 876,
		  "schedulePercent": 0.449683,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7074461eb188cf60f7adda0ed11c5158",
		  
		  "name": "Deidre",
		  "createdDate": "2023-07-13 05:06:40",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 654,
		  "totalCountries": 6,
		  "totalStates": 36,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 2991,
		  "schedulePercent": 0.841795,
		  "totalGuests": 1740,
		  "guestPercent": 0.92985,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Boone Pickens Stadium",
		  "mostGuestCity": "Stillwater",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "707b7b80c74d41b332bfa24b9e3afe15",
		  
		  "name": "GUY",
		  "createdDate": "2019-11-08 23:34:58",
		  "totalOrganizations": 5,
		  "totalTours": 18,
		  "totalDays": 485,
		  "totalCountries": 19,
		  "totalStates": 67,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2548,
		  "schedulePercent": 0.792044,
		  "totalGuests": 885,
		  "guestPercent": 0.826836,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "707c503fd2470e8befcb8949676a6680",
		  
		  "name": "Howard",
		  "createdDate": "2009-06-05 03:17:22",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 485,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1676,
		  "schedulePercent": 0.654125,
		  "totalGuests": 1510,
		  "guestPercent": 0.910358,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 157,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7086215f596d4385fb673609a2adcfac",
		  
		  "name": "Chris ",
		  "createdDate": "2017-06-22 22:50:12",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 395,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 657,
		  "schedulePercent": 0.370354,
		  "totalGuests": 205,
		  "guestPercent": 0.598368,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "NOLA Funk Fest",
		  "mostGuestCity": "New Orleans ",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "709011d63e7fe509f76a7807ededfeb3",
		  
		  "name": "Sandrine",
		  "createdDate": "2019-04-23 19:44:39",
		  "totalOrganizations": 35,
		  "totalTours": 17,
		  "totalDays": 583,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 1188,
		  "schedulePercent": 0.544084,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Horseshoe Tavern",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "709ee8d2679cdf6606310b477a8163ee",
		  
		  "name": "Jeffrey",
		  "createdDate": "2013-03-21 16:54:45",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 629,
		  "totalCountries": 32,
		  "totalStates": 96,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 3835,
		  "schedulePercent": 0.904918,
		  "totalGuests": 287,
		  "guestPercent": 0.642906,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70a028c19aa91ec1ffc9a105e7342052",
		  
		  "name": "Andres",
		  "createdDate": "2023-10-14 09:45:21",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 102,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 203,
		  "schedulePercent": 0.162965,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "The Pullo Center",
		  "mostGuestCity": "York",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70a32bb3fa4e7b21acefa714bffc4fd0",
		  
		  "name": "Nadia",
		  "createdDate": "2025-06-10 16:12:56",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 29,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 140,
		  "schedulePercent": 0.12432,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70ac52fbff0e9d7c04d193c5b57a1349",
		  
		  "name": "Jesus ",
		  "createdDate": "2016-01-26 22:14:34",
		  "totalOrganizations": 19,
		  "totalTours": 37,
		  "totalDays": 151,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 837,
		  "schedulePercent": 0.436423,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70aef2be73ee59106979fc0e233bcd74",
		  
		  "name": "Christopher",
		  "createdDate": "2015-06-23 17:52:01",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 640,
		  "totalCountries": 21,
		  "totalStates": 50,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 2600,
		  "schedulePercent": 0.797484,
		  "totalGuests": 2911,
		  "guestPercent": 0.980281,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70ca50c5d83bc69c350f68ec6c916943",
		  
		  "name": "Grace",
		  "createdDate": "2024-04-29 06:11:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 68,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 367,
		  "schedulePercent": 0.251813,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70d17d0ec97b8b0ff20b2116de4f56eb",
		  
		  "name": "Kieren ",
		  "createdDate": "2020-02-18 18:35:43",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 171,
		  "totalCountries": 21,
		  "totalStates": 45,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1170,
		  "schedulePercent": 0.540231,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70f076a7af395530db64763a52520d6b",
		  
		  "name": "IAN",
		  "createdDate": "2025-05-22 01:01:19",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 353,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 446,
		  "schedulePercent": 0.289098,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The Brooklyn Monarch",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70f25d0b233d05f6016c923bdfb68ae7",
		  
		  "name": "Ron",
		  "createdDate": "2013-03-27 22:36:22",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 148,
		  "totalCountries": 7,
		  "totalStates": 43,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 945,
		  "schedulePercent": 0.473821,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Scala",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "70fd4ba84b18568947742f63bb0473e6",
		  
		  "name": "Jamie Kurtz (HC)",
		  "createdDate": "2023-09-21 22:21:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 334,
		  "eventPercent": 0.934497,
		  "totalScheduleItems": 3167,
		  "schedulePercent": 0.856868,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "710005f0dcd86a197d0305b9da9592b8",
		  
		  "name": "Rachael",
		  "createdDate": "2018-01-23 19:14:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1509,
		  "schedulePercent": 0.620014,
		  "totalGuests": 1133,
		  "guestPercent": 0.869447,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "711737b4f1a97781866fb6f3fce5b0f1",
		  
		  "name": "Karima",
		  "createdDate": "2018-04-24 06:18:07",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 506,
		  "totalCountries": 21,
		  "totalStates": 61,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 2925,
		  "schedulePercent": 0.833636,
		  "totalGuests": 1477,
		  "guestPercent": 0.907185,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7117388ec3f83335f497ca7b0c2db49b",
		  
		  "name": "Jaimee",
		  "createdDate": "2017-10-04 08:58:35",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 375,
		  "totalCountries": 11,
		  "totalStates": 28,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 867,
		  "schedulePercent": 0.447643,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Kings Place Music Foundation",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7128ae6599966b90b73feedd9e7249c2",
		  
		  "name": "Tommy",
		  "createdDate": "2023-01-30 14:32:35",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 59,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 408,
		  "schedulePercent": 0.272892,
		  "totalGuests": 233,
		  "guestPercent": 0.614234,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "GrÃ¶na Lund",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7133ee5c6224817680ccf2da12bdffd1",
		  
		  "name": "Alexander",
		  "createdDate": "2010-09-18 19:05:33",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 1147,
		  "totalCountries": 36,
		  "totalStates": 64,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 3554,
		  "schedulePercent": 0.885199,
		  "totalGuests": 649,
		  "guestPercent": 0.771306,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "714049935cca4f4e3726d8b878a8277e",
		  
		  "name": "Mark",
		  "createdDate": "2022-09-07 12:10:11",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 80,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 422,
		  "schedulePercent": 0.278898,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Union Chapel",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "714365a4cc804ecc0961ef8e892ab711",
		  
		  "name": "Paulina",
		  "createdDate": "2025-02-26 14:39:54",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 136,
		  "totalCountries": 18,
		  "totalStates": 38,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1352,
		  "schedulePercent": 0.585449,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7150836bb1d32b10b1a5da84fba286a5",
		  
		  "name": "Isabell",
		  "createdDate": "2021-09-01 09:28:19",
		  "totalOrganizations": 93,
		  "totalTours": 50,
		  "totalDays": 1316,
		  "totalCountries": 23,
		  "totalStates": 26,
		  "totalEvents": 1220,
		  "eventPercent": 0.99762,
		  "totalScheduleItems": 5260,
		  "schedulePercent": 0.961242,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "715863572fa4e6cb9906cf3939b10dee",
		  
		  "name": "Derek",
		  "createdDate": "2022-01-20 16:43:13",
		  "totalOrganizations": 10,
		  "totalTours": 19,
		  "totalDays": 2252,
		  "totalCountries": 20,
		  "totalStates": 65,
		  "totalEvents": 415,
		  "eventPercent": 0.962149,
		  "totalScheduleItems": 6580,
		  "schedulePercent": 0.982661,
		  "totalGuests": 4300,
		  "guestPercent": 0.995014,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "716e7c824a0f3ea52322c064fde0f25d",
		  
		  "name": "Mark",
		  "createdDate": "2018-08-29 04:48:44",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 142,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 487,
		  "schedulePercent": 0.30485,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Whitewater Amphitheater",
		  "mostGuestCity": "New Braunfels",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7170cd6078f768bce70d1c86bfe2fdd7",
		  
		  "name": "Matthew",
		  "createdDate": "2017-03-02 22:37:53",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 868,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1395,
		  "schedulePercent": 0.596668,
		  "totalGuests": 420,
		  "guestPercent": 0.702289,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Orpheum Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7188737a3d1e502e2d27c94cf88bde5f",
		  
		  "name": "JOSE LUIS",
		  "createdDate": "2025-03-30 18:43:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 270,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 144,
		  "schedulePercent": 0.127267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "718ae7a2b60933a0e066efb874640381",
		  
		  "name": "Jillian",
		  "createdDate": "2013-04-12 16:05:45",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 570,
		  "totalCountries": 5,
		  "totalStates": 24,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1317,
		  "schedulePercent": 0.575476,
		  "totalGuests": 263,
		  "guestPercent": 0.63078,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "718bc43655fa0464964dc38f2a8cd23c",
		  
		  "name": "David",
		  "createdDate": "2021-06-17 21:07:55",
		  "totalOrganizations": 1,
		  "totalTours": 96,
		  "totalDays": 487,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 296,
		  "eventPercent": 0.910131,
		  "totalScheduleItems": 1362,
		  "schedulePercent": 0.587942,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71997b80b474474248fa39aacac2b33c",
		  
		  "name": "Rob",
		  "createdDate": "2023-01-18 17:55:28",
		  "totalOrganizations": 23,
		  "totalTours": 9,
		  "totalDays": 723,
		  "totalCountries": 10,
		  "totalStates": 64,
		  "totalEvents": 428,
		  "eventPercent": 0.964982,
		  "totalScheduleItems": 5344,
		  "schedulePercent": 0.963962,
		  "totalGuests": 908,
		  "guestPercent": 0.831709,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71a12a7e19e0894d7b3c69de9db724ee",
		  
		  "name": "Max",
		  "createdDate": "2019-09-11 23:04:31",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 647,
		  "totalCountries": 15,
		  "totalStates": 51,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 2163,
		  "schedulePercent": 0.7415,
		  "totalGuests": 1302,
		  "guestPercent": 0.886333,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71bda1904075fc78bc87ba1b145946fd",
		  
		  "name": "Shaun",
		  "createdDate": "2017-09-08 19:28:15",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 71,
		  "totalCountries": 16,
		  "totalStates": 9,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 374,
		  "schedulePercent": 0.2551,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71d3ba3df02874247923c74d5bc546f6",
		  
		  "name": "Adrian ",
		  "createdDate": "2013-09-15 23:11:59",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 531,
		  "totalCountries": 30,
		  "totalStates": 29,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 779,
		  "schedulePercent": 0.415798,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71d4defad608e155417c19683678df02",
		  
		  "name": "Dayah",
		  "createdDate": "2018-05-13 04:43:39",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 903,
		  "totalCountries": 12,
		  "totalStates": 32,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1983,
		  "schedulePercent": 0.710222,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71deddf4122585b79c91ec58d45f3b0e",
		  
		  "name": "Jesse",
		  "createdDate": "2017-03-13 20:38:00",
		  "totalOrganizations": 23,
		  "totalTours": 32,
		  "totalDays": 1591,
		  "totalCountries": 38,
		  "totalStates": 108,
		  "totalEvents": 633,
		  "eventPercent": 0.989347,
		  "totalScheduleItems": 8979,
		  "schedulePercent": 0.993427,
		  "totalGuests": 3233,
		  "guestPercent": 0.985947,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "The Dome",
		  "mostGuestCity": "Virginia Beach",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71e15d3f82047b1d1689f6681444d506",
		  
		  "name": "Admin",
		  "createdDate": "2023-09-18 15:30:08",
		  "totalOrganizations": 31,
		  "totalTours": 46,
		  "totalDays": 1618,
		  "totalCountries": 17,
		  "totalStates": 83,
		  "totalEvents": 625,
		  "eventPercent": 0.989121,
		  "totalScheduleItems": 7781,
		  "schedulePercent": 0.989574,
		  "totalGuests": 3222,
		  "guestPercent": 0.985721,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71e1c1ed47ed7edfdb21933850734ad7",
		  
		  "name": "Isabelle",
		  "createdDate": "2023-11-07 12:14:42",
		  "totalOrganizations": 29,
		  "totalTours": 23,
		  "totalDays": 392,
		  "totalCountries": 7,
		  "totalStates": 26,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 1552,
		  "schedulePercent": 0.62738,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Parken sÃ¶der",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71e2625a9d6af0a5f35b282b259f13a2",
		  
		  "name": "Jonathan",
		  "createdDate": "2021-09-29 15:44:38",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 319,
		  "schedulePercent": 0.226541,
		  "totalGuests": 468,
		  "guestPercent": 0.719515,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Salle Albert-Rousseau",
		  "mostGuestCity": "Ville de QuÃ©bec",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71ea63a8574e63314759b3bf02aa5507",
		  
		  "name": "Ryan",
		  "createdDate": "2010-04-13 23:50:29",
		  "totalOrganizations": 101,
		  "totalTours": 78,
		  "totalDays": 14101,
		  "totalCountries": 22,
		  "totalStates": 117,
		  "totalEvents": 2504,
		  "eventPercent": 0.999773,
		  "totalScheduleItems": 32246,
		  "schedulePercent": 0.999773,
		  "totalGuests": 7017,
		  "guestPercent": 0.99864,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 190,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71eabd4050a65545d658f7306f200b9e",
		  
		  "name": "Edith",
		  "createdDate": "2020-11-11 05:46:48",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 69,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 157,
		  "schedulePercent": 0.13316,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71ed7f7d957bb22880d1a69914720bee",
		  
		  "name": "Adam",
		  "createdDate": "2014-05-16 17:56:28",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 4,
		  "totalStates": 20,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1237,
		  "schedulePercent": 0.556324,
		  "totalGuests": 263,
		  "guestPercent": 0.63078,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71efadd9e530bc6d2718cba3c1f7caf7",
		  
		  "name": "Johan",
		  "createdDate": "2018-04-10 13:32:37",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 52,
		  "totalCountries": 6,
		  "totalStates": 3,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 358,
		  "schedulePercent": 0.247167,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Hugo Park Festival",
		  "mostGuestCity": "NorrkÃ¶ping",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "71f9b1946ee26658eabc19026a0683a4",
		  
		  "name": "Taylor",
		  "createdDate": "2017-07-14 17:58:41",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 561,
		  "totalCountries": 20,
		  "totalStates": 64,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 3558,
		  "schedulePercent": 0.885313,
		  "totalGuests": 1187,
		  "guestPercent": 0.874773,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "DCU Center",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72284fc920cf8855fb1952024fbbca9b",
		  
		  "name": "Jacob ",
		  "createdDate": "2019-03-21 13:26:59",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 194,
		  "totalCountries": 14,
		  "totalStates": 8,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 986,
		  "schedulePercent": 0.486854,
		  "totalGuests": 131,
		  "guestPercent": 0.545444,
		  "mostGuestDate": "2025-04-07 00:00:00",
		  "mostGuestName": "Baby's All Right",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "723b6afcba10a4bca758b4f6357ea49c",
		  
		  "name": "Jus.",
		  "createdDate": "2019-11-21 22:39:22",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 116,
		  "totalCountries": 9,
		  "totalStates": 30,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 634,
		  "schedulePercent": 0.361854,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-01-29 00:00:00",
		  "mostGuestName": "1720",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "723bc37cfc12932e4db85257434d416b",
		  
		  "name": "Trevor",
		  "createdDate": "2010-06-17 12:20:07",
		  "totalOrganizations": 15,
		  "totalTours": 37,
		  "totalDays": 956,
		  "totalCountries": 34,
		  "totalStates": 84,
		  "totalEvents": 330,
		  "eventPercent": 0.93291,
		  "totalScheduleItems": 5226,
		  "schedulePercent": 0.960335,
		  "totalGuests": 1960,
		  "guestPercent": 0.944016,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "723dd85a96a8d05ddc203b74fbe55c47",
		  
		  "name": "Dusty",
		  "createdDate": "2018-10-07 03:37:43",
		  "totalOrganizations": 18,
		  "totalTours": 21,
		  "totalDays": 767,
		  "totalCountries": 22,
		  "totalStates": 76,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 3432,
		  "schedulePercent": 0.877833,
		  "totalGuests": 1268,
		  "guestPercent": 0.882366,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "724136b4bdb828dc93677a608b135d72",
		  
		  "name": "Christian",
		  "createdDate": "2016-12-30 18:19:46",
		  "totalOrganizations": 20,
		  "totalTours": 24,
		  "totalDays": 1385,
		  "totalCountries": 15,
		  "totalStates": 52,
		  "totalEvents": 270,
		  "eventPercent": 0.890299,
		  "totalScheduleItems": 4050,
		  "schedulePercent": 0.915798,
		  "totalGuests": 1965,
		  "guestPercent": 0.944583,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72580de9625b0b66067215787e177068",
		  
		  "name": "Martin",
		  "createdDate": "2018-09-24 20:46:45",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 175,
		  "totalCountries": 16,
		  "totalStates": 17,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 900,
		  "schedulePercent": 0.458409,
		  "totalGuests": 810,
		  "guestPercent": 0.81063,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Turbinenhalle",
		  "mostGuestCity": "Oberhausen",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7268fabe37e1c38af45708518cbfedb1",
		  
		  "name": "Alex",
		  "createdDate": "2014-05-21 03:26:26",
		  "totalOrganizations": 18,
		  "totalTours": 9,
		  "totalDays": 358,
		  "totalCountries": 9,
		  "totalStates": 17,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 284,
		  "schedulePercent": 0.208862,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72819ff809f462b1788cc5e08029c372",
		  
		  "name": "Tim",
		  "createdDate": "2013-06-28 19:17:28",
		  "totalOrganizations": 27,
		  "totalTours": 50,
		  "totalDays": 1097,
		  "totalCountries": 20,
		  "totalStates": 69,
		  "totalEvents": 414,
		  "eventPercent": 0.961922,
		  "totalScheduleItems": 4690,
		  "schedulePercent": 0.943676,
		  "totalGuests": 1805,
		  "guestPercent": 0.93359,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "728a52a12538fc9c48f264aeed19baf3",
		  
		  "name": "Ann",
		  "createdDate": "2017-10-02 14:29:49",
		  "totalOrganizations": 32,
		  "totalTours": 24,
		  "totalDays": 834,
		  "totalCountries": 29,
		  "totalStates": 59,
		  "totalEvents": 292,
		  "eventPercent": 0.907185,
		  "totalScheduleItems": 5293,
		  "schedulePercent": 0.961809,
		  "totalGuests": 879,
		  "guestPercent": 0.824569,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "729a0b9ef83bb30f595544d70b8956c1",
		  
		  "name": "Zach",
		  "createdDate": "2021-09-27 20:59:19",
		  "totalOrganizations": 19,
		  "totalTours": 23,
		  "totalDays": 989,
		  "totalCountries": 18,
		  "totalStates": 78,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 3881,
		  "schedulePercent": 0.906958,
		  "totalGuests": 1171,
		  "guestPercent": 0.8733,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "729e82ccaa54094c02d4ee4cbed7ed0d",
		  
		  "name": "Philip",
		  "createdDate": "2015-12-07 19:06:20",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 418,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1830,
		  "schedulePercent": 0.681437,
		  "totalGuests": 744,
		  "guestPercent": 0.794991,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72a5f42325eff27d3dccb17354d3237f",
		  
		  "name": "Nando",
		  "createdDate": "2021-09-27 14:59:59",
		  "totalOrganizations": 8,
		  "totalTours": 46,
		  "totalDays": 1225,
		  "totalCountries": 14,
		  "totalStates": 55,
		  "totalEvents": 343,
		  "eventPercent": 0.938463,
		  "totalScheduleItems": 5059,
		  "schedulePercent": 0.955916,
		  "totalGuests": 627,
		  "guestPercent": 0.764619,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72a863f18f01ad42e92a6d30ca4b7a3e",
		  
		  "name": "Jesse",
		  "createdDate": "2024-04-01 12:31:49",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 383,
		  "totalCountries": 19,
		  "totalStates": 28,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1066,
		  "schedulePercent": 0.508726,
		  "totalGuests": 486,
		  "guestPercent": 0.726428,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Grand Sierra Theater",
		  "mostGuestCity": "Reno",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72af678364172b9e69daa4a4d0e426c0",
		  
		  "name": "Matt",
		  "createdDate": "2025-09-14 17:57:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 73,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 219,
		  "schedulePercent": 0.171238,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72b1d0cc6f285ab23a024356e86d0f95",
		  
		  "name": "Alex",
		  "createdDate": "2024-07-14 03:50:57",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 708,
		  "totalCountries": 19,
		  "totalStates": 76,
		  "totalEvents": 276,
		  "eventPercent": 0.895626,
		  "totalScheduleItems": 2819,
		  "schedulePercent": 0.824683,
		  "totalGuests": 1147,
		  "guestPercent": 0.87126,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72be18f06fed01ee73a0aae55d8da4e0",
		  
		  "name": "Harry ",
		  "createdDate": "2018-05-11 01:22:37",
		  "totalOrganizations": 15,
		  "totalTours": 12,
		  "totalDays": 892,
		  "totalCountries": 11,
		  "totalStates": 50,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1922,
		  "schedulePercent": 0.698096,
		  "totalGuests": 370,
		  "guestPercent": 0.68121,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72c458f1fa510de106719ad7d923221f",
		  
		  "name": "Jaime",
		  "createdDate": "2021-08-09 15:21:34",
		  "totalOrganizations": 22,
		  "totalTours": 25,
		  "totalDays": 952,
		  "totalCountries": 24,
		  "totalStates": 62,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 3717,
		  "schedulePercent": 0.897212,
		  "totalGuests": 1960,
		  "guestPercent": 0.944016,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72cbd0b2bbb73cba21312ae93ca9792d",
		  
		  "name": "Duncan ",
		  "createdDate": "2016-12-15 22:49:40",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 860,
		  "totalCountries": 6,
		  "totalStates": 36,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 3421,
		  "schedulePercent": 0.877153,
		  "totalGuests": 2664,
		  "guestPercent": 0.974501,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72d444bad1fd1ed95f2e69b4cbccb722",
		  
		  "name": "Adam",
		  "createdDate": "2015-07-10 00:07:55",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 249,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 2022,
		  "schedulePercent": 0.717588,
		  "totalGuests": 510,
		  "guestPercent": 0.733001,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Country Music Hall of Fame and Museum",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72d6b56896aa3d7425f3b81b0b621041",
		  
		  "name": "John",
		  "createdDate": "2014-08-06 22:11:55",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 170,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 529,
		  "schedulePercent": 0.326609,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72d87d3d9b12d5ca7af7c7014ca1bf6e",
		  
		  "name": "Samantha",
		  "createdDate": "2015-08-17 23:26:02",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 386,
		  "totalCountries": 10,
		  "totalStates": 36,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1260,
		  "schedulePercent": 0.562897,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "72ffcaa297a3cb744208b98d902af161",
		  
		  "name": "Simon",
		  "createdDate": "2013-04-08 20:46:05",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 124,
		  "totalCountries": 18,
		  "totalStates": 11,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 921,
		  "schedulePercent": 0.465095,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Arena Riga",
		  "mostGuestCity": "Riga",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "730a7b00e8dfcc11c3c6f19913885d6d",
		  
		  "name": "John-Peter",
		  "createdDate": "2015-12-02 03:08:11",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 61,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 582,
		  "schedulePercent": 0.344515,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "730f6be026346c9b33916b412b733593",
		  
		  "name": "Sahir",
		  "createdDate": "2012-10-08 23:04:31",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 2012,
		  "totalCountries": 19,
		  "totalStates": 42,
		  "totalEvents": 362,
		  "eventPercent": 0.94719,
		  "totalScheduleItems": 5124,
		  "schedulePercent": 0.957956,
		  "totalGuests": 2540,
		  "guestPercent": 0.969968,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7311d96ce55dc2cca65bd530f8135153",
		  
		  "name": "Brande",
		  "createdDate": "2014-03-04 20:32:06",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 969,
		  "totalCountries": 8,
		  "totalStates": 37,
		  "totalEvents": 445,
		  "eventPercent": 0.969288,
		  "totalScheduleItems": 3051,
		  "schedulePercent": 0.847801,
		  "totalGuests": 9939,
		  "guestPercent": 0.99966,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 523,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "731397cfe73eb295c8a573342275d4ae",
		  
		  "name": "Abby",
		  "createdDate": "2023-09-12 10:28:47",
		  "totalOrganizations": 18,
		  "totalTours": 12,
		  "totalDays": 1628,
		  "totalCountries": 22,
		  "totalStates": 55,
		  "totalEvents": 287,
		  "eventPercent": 0.903672,
		  "totalScheduleItems": 2490,
		  "schedulePercent": 0.785925,
		  "totalGuests": 170,
		  "guestPercent": 0.574003,
		  "mostGuestDate": "2025-01-27 00:00:00",
		  "mostGuestName": "Hoxton Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73154ee28edd2b887aad2ca744b53879",
		  
		  "name": "Henrik",
		  "createdDate": "2020-08-14 19:51:13",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 167,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 404,
		  "schedulePercent": 0.271532,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "Bio Skandia",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73240d362e3da00a6769f4f8b6bf4377",
		  
		  "name": "Cuillin",
		  "createdDate": "2025-02-21 04:22:25",
		  "totalOrganizations": 76,
		  "totalTours": 38,
		  "totalDays": 716,
		  "totalCountries": 27,
		  "totalStates": 70,
		  "totalEvents": 248,
		  "eventPercent": 0.868654,
		  "totalScheduleItems": 2669,
		  "schedulePercent": 0.805077,
		  "totalGuests": 1357,
		  "guestPercent": 0.894492,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7334559b560d1677a92bd9cada88abbb",
		  
		  "name": "Becky",
		  "createdDate": "2014-11-13 04:45:05",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 129,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 753,
		  "schedulePercent": 0.406505,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Club Regent Casino",
		  "mostGuestCity": "Winnipeg",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "733d36c6cc9b7a1adbaf2bc709f7ca8d",
		  
		  "name": "Rachel",
		  "createdDate": "2022-06-04 15:29:12",
		  "totalOrganizations": 6,
		  "totalTours": 16,
		  "totalDays": 856,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 1385,
		  "schedulePercent": 0.593835,
		  "totalGuests": 425,
		  "guestPercent": 0.704442,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7350197f66a542bdbdad6188d83a2324",
		  
		  "name": "Y. Osman",
		  "createdDate": "2025-03-14 18:02:49",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 702,
		  "totalCountries": 6,
		  "totalStates": 19,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 773,
		  "schedulePercent": 0.413758,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Cermodern",
		  "mostGuestCity": "SÄ±hhÄ±ye / AltÄ±ndaÄŸ/AltÄ±ndaÄŸ",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "735ee7026704209ee1101d825cc9ee3a",
		  
		  "name": "Lior",
		  "createdDate": "2024-06-07 13:03:26",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 154,
		  "totalCountries": 14,
		  "totalStates": 30,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 917,
		  "schedulePercent": 0.464075,
		  "totalGuests": 199,
		  "guestPercent": 0.594062,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Verti Music Hall",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73676b6c7ef6bcc2e86df5de28e0786a",
		  
		  "name": "Nicholas",
		  "createdDate": "2013-02-16 19:20:29",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 626,
		  "totalCountries": 8,
		  "totalStates": 35,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 1484,
		  "schedulePercent": 0.614121,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "736c1cf2f01232489588f487a824e781",
		  
		  "name": "Michael Jr. ",
		  "createdDate": "2017-02-22 02:42:02",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 359,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 770,
		  "schedulePercent": 0.412285,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "736eb40e395d8bbe99a653634a3c18f3",
		  
		  "name": "Rebecca",
		  "createdDate": "2019-08-17 15:07:11",
		  "totalOrganizations": 14,
		  "totalTours": 44,
		  "totalDays": 732,
		  "totalCountries": 32,
		  "totalStates": 43,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 3422,
		  "schedulePercent": 0.87738,
		  "totalGuests": 228,
		  "guestPercent": 0.611514,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "736fd14ebefe273d78c307cff4d65347",
		  
		  "name": "Paulo",
		  "createdDate": "2018-08-08 21:20:41",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 245,
		  "totalCountries": 23,
		  "totalStates": 33,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1047,
		  "schedulePercent": 0.503626,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "Turbinenhalle",
		  "mostGuestCity": "Oberhausen",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73780ff6177bea962412b9ae5da702ad",
		  
		  "name": "Frazer",
		  "createdDate": "2023-09-26 08:07:12",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 200,
		  "totalCountries": 12,
		  "totalStates": 49,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1127,
		  "schedulePercent": 0.527085,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "The Wooly",
		  "mostGuestCity": "Gainesville",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7383f98501542744b932ec73f9d6b669",
		  
		  "name": "Represent",
		  "createdDate": "2025-02-28 12:56:06",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 24,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 59,
		  "schedulePercent": 0.0672031,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73879c8277955253a83356ccef98bd47",
		  
		  "name": "Alex",
		  "createdDate": "2022-04-01 16:01:53",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 988,
		  "totalCountries": 6,
		  "totalStates": 46,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1262,
		  "schedulePercent": 0.56335,
		  "totalGuests": 180,
		  "guestPercent": 0.580009,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Mayfair Austin",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "738e9493741bbd46737cabc4b3b5c073",
		  
		  "name": "Marie-Sandrine",
		  "createdDate": "2024-12-18 11:29:53",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 2076,
		  "totalCountries": 16,
		  "totalStates": 35,
		  "totalEvents": 281,
		  "eventPercent": 0.898912,
		  "totalScheduleItems": 3479,
		  "schedulePercent": 0.880893,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73975c240851a569dab9a1a36c0f7736",
		  
		  "name": "Marco",
		  "createdDate": "2025-06-04 21:21:32",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 25,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 151,
		  "schedulePercent": 0.130326,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-11-14 00:00:00",
		  "mostGuestName": "OpÃ©ra de Rouen Normandie",
		  "mostGuestCity": "Rouen",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "739ed7448b74ee072d93226630f9973b",
		  
		  "name": "Deniz",
		  "createdDate": "2019-01-21 11:54:27",
		  "totalOrganizations": 68,
		  "totalTours": 33,
		  "totalDays": 1194,
		  "totalCountries": 10,
		  "totalStates": 7,
		  "totalEvents": 1163,
		  "eventPercent": 0.996827,
		  "totalScheduleItems": 4499,
		  "schedulePercent": 0.938463,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73a530b71125b10a23bedb7d3b670c34",
		  
		  "name": "Stoney",
		  "createdDate": "2015-05-16 19:20:29",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 122,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 719,
		  "schedulePercent": 0.393586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73b1f47a60f08ddc4bb6f21ed70e7c46",
		  
		  "name": "Miska",
		  "createdDate": "2023-11-02 09:00:54",
		  "totalOrganizations": 21,
		  "totalTours": 18,
		  "totalDays": 283,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 278,
		  "eventPercent": 0.896872,
		  "totalScheduleItems": 1303,
		  "schedulePercent": 0.571963,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Tulisuudelma",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73c239b9673298d7df9a14d3d3f26f08",
		  
		  "name": "Lijne",
		  "createdDate": "2018-05-02 14:12:33",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 176,
		  "totalCountries": 10,
		  "totalStates": 9,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73c4591d7756a6c05888e6b91ae6a3fe",
		  
		  "name": "Sven",
		  "createdDate": "2024-12-13 09:44:35",
		  "totalOrganizations": 2,
		  "totalTours": 23,
		  "totalDays": 185,
		  "totalCountries": 30,
		  "totalStates": 26,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1961,
		  "schedulePercent": 0.706029,
		  "totalGuests": 785,
		  "guestPercent": 0.804964,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Turbinenhalle",
		  "mostGuestCity": "Oberhausen",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73ccbf20f65fe9006c8cf9d1da663d58",
		  
		  "name": "sidewalk",
		  "createdDate": "2022-10-04 18:33:36",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 517,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1635,
		  "schedulePercent": 0.646532,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73d134a787f8fa400fdc6400b9955b1c",
		  
		  "name": "Ted",
		  "createdDate": "2024-06-17 21:26:49",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 100,
		  "totalCountries": 15,
		  "totalStates": 27,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1038,
		  "schedulePercent": 0.500793,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Backstage Concerts GmbH",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73d6572f42ac53d434f2a0dc789e90e5",
		  
		  "name": "Mika",
		  "createdDate": "2016-09-27 21:28:25",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 164,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 590,
		  "schedulePercent": 0.347575,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Tulisuudelma",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73dbb7a16f46118c2c1184e76cb94b2d",
		  
		  "name": "Alicia",
		  "createdDate": "2021-03-29 16:30:30",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 17,
		  "totalStates": 17,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 395,
		  "schedulePercent": 0.266772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73e47b3a22f241df24dbf56437110fbb",
		  
		  "name": "Gray",
		  "createdDate": "2021-09-22 14:35:41",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 99,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73ee62ed521bb2793f7a3eccd7a9c43a",
		  
		  "name": "Angelica",
		  "createdDate": "2023-07-19 16:24:52",
		  "totalOrganizations": 9,
		  "totalTours": 17,
		  "totalDays": 568,
		  "totalCountries": 29,
		  "totalStates": 50,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2387,
		  "schedulePercent": 0.773345,
		  "totalGuests": 1666,
		  "guestPercent": 0.925657,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "73fe464f2cd8995c631c994e2a7456ea",
		  
		  "name": "Christopher",
		  "createdDate": "2023-05-23 12:11:57",
		  "totalOrganizations": 63,
		  "totalTours": 38,
		  "totalDays": 1301,
		  "totalCountries": 30,
		  "totalStates": 68,
		  "totalEvents": 606,
		  "eventPercent": 0.987647,
		  "totalScheduleItems": 4552,
		  "schedulePercent": 0.939597,
		  "totalGuests": 147,
		  "guestPercent": 0.556324,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Knockdown Center",
		  "mostGuestCity": "Maspeth",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "740da6907af5f513fc4925cfd61b9d9b",
		  
		  "name": "Ruth",
		  "createdDate": "2023-09-26 15:35:07",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 101,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 637,
		  "schedulePercent": 0.363327,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Arlene Schnitzer Concert Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "740e8d0bebb316771c4863ea19c5056f",
		  
		  "name": "Hannah",
		  "createdDate": "2018-10-22 20:14:20",
		  "totalOrganizations": 11,
		  "totalTours": 20,
		  "totalDays": 981,
		  "totalCountries": 13,
		  "totalStates": 60,
		  "totalEvents": 287,
		  "eventPercent": 0.903672,
		  "totalScheduleItems": 4326,
		  "schedulePercent": 0.932344,
		  "totalGuests": 2730,
		  "guestPercent": 0.977108,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "741ceded2180aae09058d8bc4c512f9f",
		  
		  "name": "Hannah",
		  "createdDate": "2025-02-10 21:18:33",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 230,
		  "totalCountries": 13,
		  "totalStates": 23,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 2405,
		  "schedulePercent": 0.775612,
		  "totalGuests": 1577,
		  "guestPercent": 0.917271,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7427a08f5c9750592981bf53c832194e",
		  
		  "name": "Harri",
		  "createdDate": "2021-07-21 10:03:52",
		  "totalOrganizations": 45,
		  "totalTours": 26,
		  "totalDays": 3463,
		  "totalCountries": 45,
		  "totalStates": 93,
		  "totalEvents": 445,
		  "eventPercent": 0.969288,
		  "totalScheduleItems": 8170,
		  "schedulePercent": 0.99116,
		  "totalGuests": 1367,
		  "guestPercent": 0.896192,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "742ba764d4ea7e78e7e0b19d6fab6068",
		  
		  "name": "Carolyn ",
		  "createdDate": "2010-03-11 23:25:04",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 1409,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1556,
		  "schedulePercent": 0.631686,
		  "totalGuests": 917,
		  "guestPercent": 0.833975,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "743c13272648b32ae73116c782bd8e82",
		  
		  "name": "Caroline",
		  "createdDate": "2022-02-16 05:12:31",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 523,
		  "totalCountries": 25,
		  "totalStates": 58,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 4635,
		  "schedulePercent": 0.941863,
		  "totalGuests": 2800,
		  "guestPercent": 0.977901,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "743e2329bbdd705f4f99c78cea470aad",
		  
		  "name": "Maude",
		  "createdDate": "2022-06-02 15:11:47",
		  "totalOrganizations": 42,
		  "totalTours": 14,
		  "totalDays": 519,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 477,
		  "eventPercent": 0.974728,
		  "totalScheduleItems": 2412,
		  "schedulePercent": 0.776179,
		  "totalGuests": 5721,
		  "guestPercent": 0.998073,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 675,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74479f5c1bb4f3793d11059f80a5aea4",
		  
		  "name": "Maria",
		  "createdDate": "2015-06-22 07:12:24",
		  "totalOrganizations": 32,
		  "totalTours": 15,
		  "totalDays": 361,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 355,
		  "eventPercent": 0.94413,
		  "totalScheduleItems": 2316,
		  "schedulePercent": 0.764166,
		  "totalGuests": 230,
		  "guestPercent": 0.612534,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "Det Kongelige Teater",
		  "mostGuestCity": "KÃ¸benhavn K",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "744d9197fab04ca9c30e2c094149090e",
		  
		  "name": "Chris",
		  "createdDate": "2022-07-25 15:02:12",
		  "totalOrganizations": 21,
		  "totalTours": 46,
		  "totalDays": 1501,
		  "totalCountries": 28,
		  "totalStates": 100,
		  "totalEvents": 548,
		  "eventPercent": 0.984021,
		  "totalScheduleItems": 7690,
		  "schedulePercent": 0.989234,
		  "totalGuests": 1538,
		  "guestPercent": 0.913645,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7452d92ca7f058a55489639e90966963",
		  
		  "name": "Candelaria",
		  "createdDate": "2022-10-14 14:56:23",
		  "totalOrganizations": 20,
		  "totalTours": 15,
		  "totalDays": 3256,
		  "totalCountries": 47,
		  "totalStates": 128,
		  "totalEvents": 561,
		  "eventPercent": 0.984927,
		  "totalScheduleItems": 5713,
		  "schedulePercent": 0.971781,
		  "totalGuests": 110,
		  "guestPercent": 0.528105,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "la citadelle",
		  "mostGuestCity": "Marseille",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "745c135d100c216b313cb97337e30f10",
		  
		  "name": "Jeb",
		  "createdDate": "2023-12-13 15:55:26",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 317,
		  "totalCountries": 4,
		  "totalStates": 52,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 1758,
		  "schedulePercent": 0.670218,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "San Antonio Stock Show & Rodeo",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7472e62d2777ce1fa70040416caee424",
		  
		  "name": "Harold",
		  "createdDate": "2015-02-12 20:01:20",
		  "totalOrganizations": 14,
		  "totalTours": 19,
		  "totalDays": 1264,
		  "totalCountries": 23,
		  "totalStates": 78,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 4205,
		  "schedulePercent": 0.925997,
		  "totalGuests": 2056,
		  "guestPercent": 0.950929,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "747c8e4f81e615bde9cd345d2d795900",
		  
		  "name": "Hannah",
		  "createdDate": "2019-10-15 23:50:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 139,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 903,
		  "schedulePercent": 0.459089,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Billy Bob's Texas",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7482186e33db4af35ab6d38f8715ad87",
		  
		  "name": "Michael",
		  "createdDate": "2016-01-21 20:55:05",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 131,
		  "totalCountries": 7,
		  "totalStates": 12,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 512,
		  "schedulePercent": 0.316636,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Reggies Chicago",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "748318fe062e1af878ca71b96413e7e3",
		  
		  "name": "Zane",
		  "createdDate": "2017-06-29 05:40:51",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 2008,
		  "totalCountries": 25,
		  "totalStates": 60,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 3032,
		  "schedulePercent": 0.845308,
		  "totalGuests": 391,
		  "guestPercent": 0.690277,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "748e15e335c4288d01969117e23a9233",
		  
		  "name": "Jason",
		  "createdDate": "2022-06-27 22:23:01",
		  "totalOrganizations": 11,
		  "totalTours": 23,
		  "totalDays": 784,
		  "totalCountries": 8,
		  "totalStates": 53,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 2373,
		  "schedulePercent": 0.771759,
		  "totalGuests": 785,
		  "guestPercent": 0.804964,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Barstool Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7493b4b54fc1b1b8cb6060bc2397392b",
		  
		  "name": "Lisa",
		  "createdDate": "2017-12-29 09:39:22",
		  "totalOrganizations": 18,
		  "totalTours": 10,
		  "totalDays": 460,
		  "totalCountries": 26,
		  "totalStates": 43,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1329,
		  "schedulePercent": 0.579442,
		  "totalGuests": 666,
		  "guestPercent": 0.776292,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Annexet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7494c93fc312efb000a0510a10620b6c",
		  
		  "name": "Zuszsanna",
		  "createdDate": "2018-11-07 22:19:18",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 220,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 508,
		  "schedulePercent": 0.31471,
		  "totalGuests": 204,
		  "guestPercent": 0.597915,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Hernando's Hideaway",
		  "mostGuestCity": "Memphis",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "749cc2de3e2b40c56557de22702733ba",
		  
		  "name": "Sara",
		  "createdDate": "2023-08-29 13:47:55",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 215,
		  "totalCountries": 14,
		  "totalStates": 35,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1507,
		  "schedulePercent": 0.618994,
		  "totalGuests": 209,
		  "guestPercent": 0.601201,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "749eaabacef0a77a9f06b8be39b6b322",
		  
		  "name": "Ed",
		  "createdDate": "2012-06-02 05:08:48",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 228,
		  "totalCountries": 34,
		  "totalStates": 65,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1530,
		  "schedulePercent": 0.623867,
		  "totalGuests": 830,
		  "guestPercent": 0.815277,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "The Orpheum Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74b15c36a19086cd6419c6a3445258de",
		  
		  "name": "Daniel",
		  "createdDate": "2014-05-09 17:54:26",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 394,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 164,
		  "schedulePercent": 0.138146,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "The Midway",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74b2542284c4fd1a06e31ec0fd899de1",
		  
		  "name": "Natalie",
		  "createdDate": "2016-03-24 19:43:49",
		  "totalOrganizations": 10,
		  "totalTours": 2,
		  "totalDays": 37,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 177,
		  "schedulePercent": 0.144266,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74c791bc29b80f087bf0e0e7250f1aba",
		  
		  "name": "James",
		  "createdDate": "2022-03-12 05:53:14",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 310,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1712,
		  "schedulePercent": 0.660811,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Bell Centre",
		  "mostGuestCity": "Montreal",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74ce2711717f72c661a419457ed8cd58",
		  
		  "name": "Mark",
		  "createdDate": "2023-12-15 15:57:58",
		  "totalOrganizations": 1,
		  "totalTours": 32,
		  "totalDays": 767,
		  "totalCountries": 23,
		  "totalStates": 25,
		  "totalEvents": 487,
		  "eventPercent": 0.976315,
		  "totalScheduleItems": 5374,
		  "schedulePercent": 0.964982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74dd0fb4ed32846a8f2cb7e9af0c7227",
		  
		  "name": "Jawsh",
		  "createdDate": "2011-03-05 15:58:23",
		  "totalOrganizations": 38,
		  "totalTours": 17,
		  "totalDays": 1057,
		  "totalCountries": 9,
		  "totalStates": 65,
		  "totalEvents": 401,
		  "eventPercent": 0.958636,
		  "totalScheduleItems": 4558,
		  "schedulePercent": 0.939823,
		  "totalGuests": 1466,
		  "guestPercent": 0.906618,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74e1f10df801371adf43322a2a380489",
		  
		  "name": "Eric",
		  "createdDate": "2021-08-03 14:42:33",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 202,
		  "totalCountries": 17,
		  "totalStates": 45,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 2223,
		  "schedulePercent": 0.751587,
		  "totalGuests": 1053,
		  "guestPercent": 0.855168,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Germania Insurance Amphitheater",
		  "mostGuestCity": "Del Valle",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74eed0341111b9071a7565326852d990",
		  
		  "name": "Frank",
		  "createdDate": "2022-06-09 09:53:09",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 54,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 477,
		  "schedulePercent": 0.301677,
		  "totalGuests": 1026,
		  "guestPercent": 0.850748,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 220,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "74feddf82aec68bb55bdc66665dcf633",
		  
		  "name": "Sami",
		  "createdDate": "2022-10-12 12:57:51",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 1099,
		  "totalCountries": 9,
		  "totalStates": 46,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1879,
		  "schedulePercent": 0.691183,
		  "totalGuests": 483,
		  "guestPercent": 0.725635,
		  "mostGuestDate": "2025-02-04 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "750c3f2aedea9582a5fdab6b4c52a08d",
		  
		  "name": "Cady",
		  "createdDate": "2021-09-25 21:39:33",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 1088,
		  "totalCountries": 6,
		  "totalStates": 54,
		  "totalEvents": 277,
		  "eventPercent": 0.896079,
		  "totalScheduleItems": 5386,
		  "schedulePercent": 0.965889,
		  "totalGuests": 4718,
		  "guestPercent": 0.996714,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "750e0a0b68d85e60436a0760c48a3055",
		  
		  "name": "Jordan",
		  "createdDate": "2021-10-26 03:39:08",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 531,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1149,
		  "schedulePercent": 0.534338,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75101309600896c0655c0a7f54c1a0fb",
		  
		  "name": "Christopher",
		  "createdDate": "2011-11-04 16:22:33",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 69,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 190,
		  "schedulePercent": 0.153105,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "The Birchmere",
		  "mostGuestCity": "Alexandria",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7512f949dc3415585265e21cfb1123a3",
		  
		  "name": "Stephan",
		  "createdDate": "2018-11-01 04:20:27",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 653,
		  "totalCountries": 8,
		  "totalStates": 34,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 984,
		  "schedulePercent": 0.486401,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "751a791cd3278db9070937d81afd0717",
		  
		  "name": "Alec",
		  "createdDate": "2025-10-24 19:49:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 126,
		  "schedulePercent": 0.115707,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "752c9c5bb10daa8381d5e5831641c88f",
		  
		  "name": "Zachary",
		  "createdDate": "2023-12-20 15:46:21",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 615,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1989,
		  "schedulePercent": 0.711355,
		  "totalGuests": 1220,
		  "guestPercent": 0.877833,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Akins Ford Arena",
		  "mostGuestCity": "Athens",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "753b94b9021737557fd65d8a18ab8584",
		  
		  "name": "Jonathan",
		  "createdDate": "2012-03-12 00:00:05",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 451,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 123,
		  "schedulePercent": 0.113327,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7544c5e4ad90c02987b78c46c98f4043",
		  
		  "name": "The",
		  "createdDate": "2024-06-27 17:08:42",
		  "totalOrganizations": 1,
		  "totalTours": 13,
		  "totalDays": 177,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 861,
		  "schedulePercent": 0.44515,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Ogden Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "754b0bd4e2759fc0ce19498ae219e57b",
		  
		  "name": "Lisa",
		  "createdDate": "2023-08-14 17:14:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 45,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 417,
		  "schedulePercent": 0.276972,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "754bf4573b242c5bfb2f82fe4d8ff1f1",
		  
		  "name": "Jess",
		  "createdDate": "2022-04-24 17:23:17",
		  "totalOrganizations": 21,
		  "totalTours": 16,
		  "totalDays": 1174,
		  "totalCountries": 17,
		  "totalStates": 58,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 2803,
		  "schedulePercent": 0.822303,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The Regency Ballroom",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7551cb9d29a745be53aa10b86bae2a1e",
		  
		  "name": "Carlos",
		  "createdDate": "2009-10-25 19:47:39",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 107,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 198,
		  "schedulePercent": 0.159451,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75531c476985de4ca1503a217eeac743",
		  
		  "name": "Eleven",
		  "createdDate": "2012-05-22 02:31:13",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 192,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 445,
		  "schedulePercent": 0.288758,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Anita's Theatre Thirroul",
		  "mostGuestCity": "Thirroul",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75641b5605a68e07333208641a0e2d7b",
		  
		  "name": "Mimi",
		  "createdDate": "2024-11-04 19:52:22",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 76,
		  "totalCountries": 14,
		  "totalStates": 22,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 532,
		  "schedulePercent": 0.327969,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "756e1e6abe4ba6475aee47c2723e80da",
		  
		  "name": "Catrin ",
		  "createdDate": "2023-11-01 08:11:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 441,
		  "schedulePercent": 0.287285,
		  "totalGuests": 335,
		  "guestPercent": 0.668064,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 241,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75752769d73e1e30ffb1d5cea8baa652",
		  
		  "name": "Gavin",
		  "createdDate": "2025-03-28 21:42:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 76,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 325,
		  "schedulePercent": 0.229034,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Public Works",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7576177ccb355626c94d8f82907bc33d",
		  
		  "name": "Devon",
		  "createdDate": "2021-04-28 19:18:55",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 455,
		  "totalCountries": 23,
		  "totalStates": 76,
		  "totalEvents": 285,
		  "eventPercent": 0.901859,
		  "totalScheduleItems": 4462,
		  "schedulePercent": 0.93665,
		  "totalGuests": 4036,
		  "guestPercent": 0.99354,
		  "mostGuestDate": "2025-07-21 00:00:00",
		  "mostGuestName": "Desert 5 Spot",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7577925965302323591b252b70d1d837",
		  
		  "name": "Mack",
		  "createdDate": "2013-09-17 17:49:21",
		  "totalOrganizations": 15,
		  "totalTours": 19,
		  "totalDays": 1220,
		  "totalCountries": 16,
		  "totalStates": 81,
		  "totalEvents": 336,
		  "eventPercent": 0.93563,
		  "totalScheduleItems": 2917,
		  "schedulePercent": 0.832956,
		  "totalGuests": 1431,
		  "guestPercent": 0.903332,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 263,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "757b9f8ecb1933d8b8b3e5b1217a3c43",
		  
		  "name": "Zoe",
		  "createdDate": "2023-05-10 13:55:59",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 123,
		  "totalCountries": 6,
		  "totalStates": 17,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1019,
		  "schedulePercent": 0.496147,
		  "totalGuests": 146,
		  "guestPercent": 0.555984,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Trabendo",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7599aaf9031b3aadbf68f1b560d918ac",
		  
		  "name": "Garrett",
		  "createdDate": "2024-01-31 09:31:35",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 579,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1891,
		  "schedulePercent": 0.692996,
		  "totalGuests": 379,
		  "guestPercent": 0.685403,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "The Roxy Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "759e9755d5e570117b5bdd9d73694951",
		  
		  "name": "Stephen ",
		  "createdDate": "2020-11-12 19:49:59",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 422,
		  "totalCountries": 2,
		  "totalStates": 37,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 1620,
		  "schedulePercent": 0.644152,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Emo's",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75a149b671ee6b520f6fb5b0fc445bfe",
		  
		  "name": "Lee",
		  "createdDate": "2023-02-11 16:25:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 52,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 699,
		  "schedulePercent": 0.386333,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75a8d89c1876eb92cd22492fcc0caeca",
		  
		  "name": "Robert",
		  "createdDate": "2019-09-12 02:30:15",
		  "totalOrganizations": 14,
		  "totalTours": 16,
		  "totalDays": 1543,
		  "totalCountries": 31,
		  "totalStates": 62,
		  "totalEvents": 315,
		  "eventPercent": 0.922484,
		  "totalScheduleItems": 4933,
		  "schedulePercent": 0.952063,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75ab13ef5d1674b96f01c4135adbc8bc",
		  
		  "name": "Bill",
		  "createdDate": "2018-01-05 03:57:31",
		  "totalOrganizations": 3,
		  "totalTours": 21,
		  "totalDays": 397,
		  "totalCountries": 11,
		  "totalStates": 41,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 4118,
		  "schedulePercent": 0.920218,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-09-01 00:00:00",
		  "mostGuestName": "Nippon Budokan",
		  "mostGuestCity": "Chiyoda-ku",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75bfcffc507038862ba175369a3973ae",
		  
		  "name": "Kaan",
		  "createdDate": "2024-08-30 08:25:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 85,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 669,
		  "schedulePercent": 0.374433,
		  "totalGuests": 107,
		  "guestPercent": 0.526292,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "E-Werk",
		  "mostGuestCity": "Koln",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75cc4037216caa0f97bfe6958e54ae95",
		  
		  "name": "Jamie",
		  "createdDate": "2025-06-03 18:14:28",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 737,
		  "totalCountries": 7,
		  "totalStates": 39,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 880,
		  "schedulePercent": 0.451269,
		  "totalGuests": 264,
		  "guestPercent": 0.631573,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Bluebird Theater",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75cd6d8ff9e364e577a0d9e0865af6b5",
		  
		  "name": "Ryan",
		  "createdDate": "2013-08-22 22:55:09",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 111,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 477,
		  "schedulePercent": 0.301677,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "Scotiabank Centre",
		  "mostGuestCity": "Halifax",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "75ec425f66ae4ff20be7f82afd5bc7eb",
		  
		  "name": "Stephen",
		  "createdDate": "2015-01-12 20:20:44",
		  "totalOrganizations": 21,
		  "totalTours": 14,
		  "totalDays": 1338,
		  "totalCountries": 3,
		  "totalStates": 48,
		  "totalEvents": 446,
		  "eventPercent": 0.969968,
		  "totalScheduleItems": 6469,
		  "schedulePercent": 0.981414,
		  "totalGuests": 1549,
		  "guestPercent": 0.914665,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76000c33ac1aeb0b87dd404572353360",
		  
		  "name": "Jane",
		  "createdDate": "2016-02-15 17:45:30",
		  "totalOrganizations": 9,
		  "totalTours": 18,
		  "totalDays": 139,
		  "totalCountries": 11,
		  "totalStates": 13,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 678,
		  "schedulePercent": 0.377946,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7600319bd5186b8c6e6d7ece21269892",
		  
		  "name": "Roser",
		  "createdDate": "2025-05-22 06:13:00",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 101,
		  "totalCountries": 16,
		  "totalStates": 26,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 839,
		  "schedulePercent": 0.43699,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "Torres Park Auditorium",
		  "mostGuestCity": "Cartagena",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7602466ac5796cede6ec865de3070810",
		  
		  "name": "Todd",
		  "createdDate": "2016-01-26 19:05:30",
		  "totalOrganizations": 28,
		  "totalTours": 65,
		  "totalDays": 479,
		  "totalCountries": 6,
		  "totalStates": 35,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 1961,
		  "schedulePercent": 0.706029,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "The Capitol Theatre",
		  "mostGuestCity": "Port Chester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "760625f7b13a0be5f51fe22a49ba5f89",
		  
		  "name": "Iain",
		  "createdDate": "2017-02-10 11:37:22",
		  "totalOrganizations": 26,
		  "totalTours": 4,
		  "totalDays": 366,
		  "totalCountries": 8,
		  "totalStates": 23,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 2068,
		  "schedulePercent": 0.726995,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "761807baeb01706cf7e166ff99af6484",
		  
		  "name": "Alex",
		  "createdDate": "2023-05-22 21:44:13",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 119,
		  "totalCountries": 13,
		  "totalStates": 33,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 313,
		  "schedulePercent": 0.223935,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "762b3f730ef1985a7472312baca59451",
		  
		  "name": "Judy",
		  "createdDate": "2016-01-04 21:06:35",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "762e5f5ecdbe21afdd43c5e6fa76820b",
		  
		  "name": "George",
		  "createdDate": "2019-04-10 03:52:32",
		  "totalOrganizations": 13,
		  "totalTours": 29,
		  "totalDays": 526,
		  "totalCountries": 12,
		  "totalStates": 41,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 3134,
		  "schedulePercent": 0.854261,
		  "totalGuests": 435,
		  "guestPercent": 0.707616,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "762fa25758c24c17959f2fbc484db4b8",
		  
		  "name": "Steve",
		  "createdDate": "2009-07-06 20:34:26",
		  "totalOrganizations": 15,
		  "totalTours": 18,
		  "totalDays": 227,
		  "totalCountries": 5,
		  "totalStates": 23,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1425,
		  "schedulePercent": 0.603581,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "Sidney Myer Music Bowl",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "763a9441554213c5702fcc57d4dfaafb",
		  
		  "name": "Katya",
		  "createdDate": "2024-11-07 01:00:06",
		  "totalOrganizations": 7,
		  "totalTours": 18,
		  "totalDays": 1503,
		  "totalCountries": 13,
		  "totalStates": 69,
		  "totalEvents": 307,
		  "eventPercent": 0.916818,
		  "totalScheduleItems": 3147,
		  "schedulePercent": 0.855281,
		  "totalGuests": 1660,
		  "guestPercent": 0.924977,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "BRIC",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76518a1745ab70a642a422e3d2a5670c",
		  
		  "name": "Brian",
		  "createdDate": "2024-04-10 18:09:22",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 62,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 247,
		  "schedulePercent": 0.18835,
		  "totalGuests": 51,
		  "guestPercent": 0.454329,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Pappy & Harriet's",
		  "mostGuestCity": "Pioneertown",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76701f49f328f442983901a06a816ed7",
		  
		  "name": "Mary",
		  "createdDate": "2024-01-24 18:11:36",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 12,
		  "totalStates": 55,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 1933,
		  "schedulePercent": 0.700476,
		  "totalGuests": 795,
		  "guestPercent": 0.80689,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "767d9fb38d5fd3868a43e477e1f7ed06",
		  
		  "name": "eva",
		  "createdDate": "2023-05-22 12:51:54",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 439,
		  "totalCountries": 23,
		  "totalStates": 65,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1221,
		  "schedulePercent": 0.552924,
		  "totalGuests": 550,
		  "guestPercent": 0.743994,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "767e42c63dd50d6093454787617819f8",
		  
		  "name": "Pablo",
		  "createdDate": "2025-01-08 01:23:36",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 182,
		  "totalCountries": 17,
		  "totalStates": 54,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 605,
		  "schedulePercent": 0.352675,
		  "totalGuests": 352,
		  "guestPercent": 0.675884,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "The Fillmore Miami Beach",
		  "mostGuestCity": "Miami Beach",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76842387b86022baa017452c3726399c",
		  
		  "name": "Heather",
		  "createdDate": "2025-07-11 20:01:14",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 69,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7695e6db9ac7fa5fc7fe93b9182e3e33",
		  
		  "name": "Jessica",
		  "createdDate": "2017-07-08 17:17:53",
		  "totalOrganizations": 15,
		  "totalTours": 13,
		  "totalDays": 432,
		  "totalCountries": 20,
		  "totalStates": 52,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 3088,
		  "schedulePercent": 0.850408,
		  "totalGuests": 559,
		  "guestPercent": 0.7466,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "769a18021e0919ea95f3ba85a4f3d5de",
		  
		  "name": "Sofia",
		  "createdDate": "2022-06-21 18:26:54",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 302,
		  "totalCountries": 19,
		  "totalStates": 32,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1437,
		  "schedulePercent": 0.605508,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-02-23 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "769ace36c5962fec09135c80a0ec6e7e",
		  
		  "name": "Josiah ",
		  "createdDate": "2018-06-26 12:36:08",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 1171,
		  "totalCountries": 9,
		  "totalStates": 36,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 475,
		  "schedulePercent": 0.300091,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "PBR Baltimore: A Coors Banquet Bar",
		  "mostGuestCity": "Baltimore",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "769c20ea276eac22e29f3f1daacda437",
		  
		  "name": "Sebastian",
		  "createdDate": "2025-03-19 13:44:04",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 79,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 302,
		  "schedulePercent": 0.218268,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76a6b07649ef27f3124dfac730bebb43",
		  
		  "name": "Jessica",
		  "createdDate": "2022-09-27 10:07:13",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 133,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 776,
		  "schedulePercent": 0.415005,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Princess Theatre",
		  "mostGuestCity": "Launceston",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76a6bd81d94d4c1bcce4f8d0056a769f",
		  
		  "name": "Oscar",
		  "createdDate": "2018-01-19 05:01:49",
		  "totalOrganizations": 9,
		  "totalTours": 20,
		  "totalDays": 193,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1362,
		  "schedulePercent": 0.587942,
		  "totalGuests": 621,
		  "guestPercent": 0.763486,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Waikiki Shell",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76ad88fc0e61939da68f79c630b36490",
		  
		  "name": "Zoe",
		  "createdDate": "2025-07-31 18:28:25",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 522,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 795,
		  "schedulePercent": 0.420784,
		  "totalGuests": 715,
		  "guestPercent": 0.789325,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Thompson's Point",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76b3235e9205db19da3ad0848ce5f9f9",
		  
		  "name": "Diony",
		  "createdDate": "2017-01-15 15:50:18",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 570,
		  "totalCountries": 3,
		  "totalStates": 51,
		  "totalEvents": 256,
		  "eventPercent": 0.876927,
		  "totalScheduleItems": 3548,
		  "schedulePercent": 0.884746,
		  "totalGuests": 3087,
		  "guestPercent": 0.983568,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76ba213d06357e6306c4f4dfa91540b1",
		  
		  "name": "Maria ",
		  "createdDate": "2022-03-09 18:11:41",
		  "totalOrganizations": 18,
		  "totalTours": 18,
		  "totalDays": 2547,
		  "totalCountries": 28,
		  "totalStates": 60,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 2239,
		  "schedulePercent": 0.75408,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-05-08 00:00:00",
		  "mostGuestName": "St. Ann & the Holy Trinity Church",
		  "mostGuestCity": "Brooklyn, NYC",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76d5c2171e702098b552da44b0b24cab",
		  
		  "name": "Paul",
		  "createdDate": "2016-09-05 09:45:17",
		  "totalOrganizations": 34,
		  "totalTours": 65,
		  "totalDays": 1213,
		  "totalCountries": 37,
		  "totalStates": 80,
		  "totalEvents": 274,
		  "eventPercent": 0.894719,
		  "totalScheduleItems": 3764,
		  "schedulePercent": 0.899932,
		  "totalGuests": 310,
		  "guestPercent": 0.654352,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Liberty Hall",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76d87ab9d3d6489b6e93d0a9d62e6f2d",
		  
		  "name": "Maya",
		  "createdDate": "2019-01-21 15:15:49",
		  "totalOrganizations": 15,
		  "totalTours": 6,
		  "totalDays": 149,
		  "totalCountries": 20,
		  "totalStates": 34,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1336,
		  "schedulePercent": 0.582389,
		  "totalGuests": 974,
		  "guestPercent": 0.841568,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76e168fb7c02709c9b539f43749bfa77",
		  
		  "name": "Helena",
		  "createdDate": "2024-02-28 15:33:40",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 948,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76e5bcd63b2931fbc1bbf78eb98ffaa2",
		  
		  "name": "Jared",
		  "createdDate": "2023-07-11 15:47:53",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 51,
		  "totalCountries": 4,
		  "totalStates": 24,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 285,
		  "schedulePercent": 0.209542,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76f0d4daaf1e0990170e8fc6e5e9705e",
		  
		  "name": "Stephanie ",
		  "createdDate": "2018-05-02 18:56:01",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 224,
		  "totalCountries": 6,
		  "totalStates": 11,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 430,
		  "schedulePercent": 0.281958,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76f1b8fe747be7a52420e2c9a1b3d60c",
		  
		  "name": "Ouafi",
		  "createdDate": "2018-04-08 11:46:13",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 127,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 307,
		  "schedulePercent": 0.221102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76f5e6f2cb7b60c690ee860e37c6005d",
		  
		  "name": "Sienna ",
		  "createdDate": "2022-10-21 17:06:50",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 1074,
		  "totalCountries": 26,
		  "totalStates": 52,
		  "totalEvents": 474,
		  "eventPercent": 0.974388,
		  "totalScheduleItems": 7092,
		  "schedulePercent": 0.987307,
		  "totalGuests": 1595,
		  "guestPercent": 0.919084,
		  "mostGuestDate": "2025-06-24 00:00:00",
		  "mostGuestName": "O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "76fb5f4842da61aafe84cc42f0d0ea7e",
		  
		  "name": "Jerry",
		  "createdDate": "2016-03-29 21:48:59",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 932,
		  "totalCountries": 7,
		  "totalStates": 42,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 3361,
		  "schedulePercent": 0.871827,
		  "totalGuests": 1334,
		  "guestPercent": 0.891659,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7702e8790fda6ba21f3dee68c996fd0f",
		  
		  "name": "A Comic Soul",
		  "createdDate": "2023-02-09 13:38:55",
		  "totalOrganizations": 145,
		  "totalTours": 59,
		  "totalDays": 749,
		  "totalCountries": 33,
		  "totalStates": 55,
		  "totalEvents": 416,
		  "eventPercent": 0.962489,
		  "totalScheduleItems": 3586,
		  "schedulePercent": 0.888146,
		  "totalGuests": 368,
		  "guestPercent": 0.680417,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Folketeateret",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77042bc42d6f031bcff435878f555a4a",
		  
		  "name": "Tyler",
		  "createdDate": "2015-02-23 17:07:56",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 653,
		  "totalCountries": 12,
		  "totalStates": 40,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 3579,
		  "schedulePercent": 0.887466,
		  "totalGuests": 2715,
		  "guestPercent": 0.976768,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "770e0101c7ca90be9cb2230d21d4d7d0",
		  
		  "name": "Melody",
		  "createdDate": "2023-10-25 21:37:18",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 354,
		  "totalCountries": 13,
		  "totalStates": 30,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1376,
		  "schedulePercent": 0.591682,
		  "totalGuests": 1408,
		  "guestPercent": 0.900839,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7712b3a6fb36663b26dc9ad6e99bea0c",
		  
		  "name": "Melissa",
		  "createdDate": "2024-01-17 22:03:42",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 576,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 855,
		  "schedulePercent": 0.442203,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7719bbf2914267ee201d6ff598e8affa",
		  
		  "name": "Anthony",
		  "createdDate": "2012-08-25 20:07:29",
		  "totalOrganizations": 31,
		  "totalTours": 13,
		  "totalDays": 1070,
		  "totalCountries": 15,
		  "totalStates": 49,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 2281,
		  "schedulePercent": 0.75952,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "United Center",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "771d7db8afae8854c019ee54e2d019a7",
		  
		  "name": "Sarah",
		  "createdDate": "2019-11-05 00:39:09",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 104,
		  "totalCountries": 13,
		  "totalStates": 27,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 353,
		  "schedulePercent": 0.24422,
		  "totalGuests": 93,
		  "guestPercent": 0.511786,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "771e4468cc05d5f293966bb7332f588b",
		  
		  "name": "Kristopher",
		  "createdDate": "2019-06-19 11:15:31",
		  "totalOrganizations": 5,
		  "totalTours": 23,
		  "totalDays": 415,
		  "totalCountries": 21,
		  "totalStates": 60,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 1692,
		  "schedulePercent": 0.657298,
		  "totalGuests": 1114,
		  "guestPercent": 0.866387,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "771f60b6ae668e0251a829d28a0e2667",
		  
		  "name": "Riley ",
		  "createdDate": "2021-07-22 02:13:41",
		  "totalOrganizations": 17,
		  "totalTours": 28,
		  "totalDays": 1629,
		  "totalCountries": 37,
		  "totalStates": 98,
		  "totalEvents": 433,
		  "eventPercent": 0.967248,
		  "totalScheduleItems": 6686,
		  "schedulePercent": 0.984134,
		  "totalGuests": 986,
		  "guestPercent": 0.843495,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7727b98f8ff8bf8e910e16f40e75e836",
		  
		  "name": "Stefan",
		  "createdDate": "2019-07-31 12:24:13",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 233,
		  "totalCountries": 26,
		  "totalStates": 37,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1094,
		  "schedulePercent": 0.518586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "772b9dfdbaa1950fc7079f7f95c3f86e",
		  
		  "name": "Matt",
		  "createdDate": "2022-01-23 16:24:47",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 441,
		  "totalCountries": 12,
		  "totalStates": 51,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 905,
		  "schedulePercent": 0.460335,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7739ffc5c122e523b21e301ea9c2b6f8",
		  
		  "name": "Sarah",
		  "createdDate": "2025-03-23 01:24:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 24,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 146,
		  "schedulePercent": 0.128173,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Elsewhere",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "773a2a8399f8f8a61e9f0a14687355ad",
		  
		  "name": "Cecilie",
		  "createdDate": "2015-01-27 14:04:08",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 67,
		  "totalCountries": 11,
		  "totalStates": 13,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 468,
		  "schedulePercent": 0.297484,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "773efd353fb19814ca739abeb6d963de",
		  
		  "name": "Sandra",
		  "createdDate": "2024-06-01 17:29:39",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 79,
		  "totalCountries": 8,
		  "totalStates": 18,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Tuning Fork",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77417e61ed8d93a60ec035504ca5448b",
		  
		  "name": "Ty",
		  "createdDate": "2024-05-27 02:04:18",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 573,
		  "totalCountries": 6,
		  "totalStates": 48,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 2364,
		  "schedulePercent": 0.770399,
		  "totalGuests": 611,
		  "guestPercent": 0.761899,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Beaver Dam Amphitheater",
		  "mostGuestCity": "Beaver Dam",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "775615c38fb562947e3a4a16e8899849",
		  
		  "name": "Lanny",
		  "createdDate": "2022-03-16 01:23:44",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 363,
		  "totalCountries": 13,
		  "totalStates": 45,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1332,
		  "schedulePercent": 0.580916,
		  "totalGuests": 1366,
		  "guestPercent": 0.895852,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Climate Pledge Arena",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "775d2f17569e01f7c05b2912bbeae95e",
		  
		  "name": "Frank",
		  "createdDate": "2019-05-04 12:29:57",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 97,
		  "totalCountries": 18,
		  "totalStates": 19,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 568,
		  "guestPercent": 0.749207,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Festung Kufstein",
		  "mostGuestCity": "Kufstein",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "775dec7cd5ce05b090cc9f2b77e80bfb",
		  
		  "name": "Quinn",
		  "createdDate": "2015-09-19 21:37:24",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 1066,
		  "totalCountries": 18,
		  "totalStates": 80,
		  "totalEvents": 337,
		  "eventPercent": 0.93597,
		  "totalScheduleItems": 4869,
		  "schedulePercent": 0.950476,
		  "totalGuests": 1087,
		  "guestPercent": 0.861514,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "775f7aed838a11161b0defcb5bb0f9db",
		  
		  "name": "James",
		  "createdDate": "2023-07-21 14:49:15",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 899,
		  "totalCountries": 5,
		  "totalStates": 33,
		  "totalEvents": 685,
		  "eventPercent": 0.990934,
		  "totalScheduleItems": 1878,
		  "schedulePercent": 0.690616,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Manchester Cathedral",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7763bc353374e6e9fb86ba23e1b8f4ac",
		  
		  "name": "Rachel",
		  "createdDate": "2024-05-08 14:19:23",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 43,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 286,
		  "schedulePercent": 0.210335,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "776bed736abc956af661142a3f71a341",
		  
		  "name": "Christopher",
		  "createdDate": "2024-11-15 17:48:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 350,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 448,
		  "schedulePercent": 0.289778,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Val Air Ballroom",
		  "mostGuestCity": "West Des Moines",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7781354abc1d348c69b584c1bebc3355",
		  
		  "name": "Gerardo",
		  "createdDate": "2021-07-08 00:35:39",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 540,
		  "totalCountries": 18,
		  "totalStates": 35,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1742,
		  "schedulePercent": 0.665911,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7785cae477a398dcecfeeb7327f0d559",
		  
		  "name": "Casey ",
		  "createdDate": "2019-06-18 20:59:34",
		  "totalOrganizations": 19,
		  "totalTours": 23,
		  "totalDays": 975,
		  "totalCountries": 31,
		  "totalStates": 42,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 3289,
		  "schedulePercent": 0.86718,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "SunBet Arena at Time Square Casino",
		  "mostGuestCity": "Pretoria",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "778fcccc4cb17c6ae72aed7babd21dd7",
		  
		  "name": "Christoph",
		  "createdDate": "2018-05-10 19:08:59",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 148,
		  "totalCountries": 24,
		  "totalStates": 35,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 701,
		  "schedulePercent": 0.387466,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "KiFF",
		  "mostGuestCity": "Aarau",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "779c74e4a9c5a32f914723626e391bbb",
		  
		  "name": "Aysha",
		  "createdDate": "2024-03-13 20:10:54",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 367,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 1212,
		  "schedulePercent": 0.549637,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Centro de Eventos Pedregal in Heredia",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77a3dbc8bd42b8c8e845880fc0bf9ba8",
		  
		  "name": "Ryan",
		  "createdDate": "2023-11-10 06:08:00",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 88,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 606,
		  "schedulePercent": 0.353014,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77bf9d1b347c9e85b02ee889ab638782",
		  
		  "name": "Gabby",
		  "createdDate": "2025-06-23 03:25:29",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 140,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77c2750146d6076319a9fefcb3921199",
		  
		  "name": "Shea",
		  "createdDate": "2022-08-04 04:37:54",
		  "totalOrganizations": 6,
		  "totalTours": 31,
		  "totalDays": 367,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 2543,
		  "schedulePercent": 0.791138,
		  "totalGuests": 334,
		  "guestPercent": 0.667384,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77e02a6947b0bdc57be7e2b1a16271e1",
		  
		  "name": "Wade",
		  "createdDate": "2018-02-14 02:58:03",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 134,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 614,
		  "schedulePercent": 0.355394,
		  "totalGuests": 358,
		  "guestPercent": 0.677471,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77e6451dab26c7cffaea8a6fce5996f0",
		  
		  "name": "Brent",
		  "createdDate": "2022-11-23 21:06:03",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 78,
		  "totalCountries": 10,
		  "totalStates": 13,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 554,
		  "schedulePercent": 0.335109,
		  "totalGuests": 546,
		  "guestPercent": 0.742634,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77f4ee6a903e128a67fbf9184cdb2ed5",
		  
		  "name": "Amanda",
		  "createdDate": "2015-01-20 06:42:11",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 133,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 849,
		  "schedulePercent": 0.439823,
		  "totalGuests": 1482,
		  "guestPercent": 0.907752,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Boettcher Concert Hall",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77f51365ce9d960b97ecddc6c2046fd8",
		  
		  "name": "Jason",
		  "createdDate": "2012-07-08 02:05:04",
		  "totalOrganizations": 15,
		  "totalTours": 8,
		  "totalDays": 820,
		  "totalCountries": 32,
		  "totalStates": 67,
		  "totalEvents": 310,
		  "eventPercent": 0.919198,
		  "totalScheduleItems": 4532,
		  "schedulePercent": 0.938917,
		  "totalGuests": 1546,
		  "guestPercent": 0.914325,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Exchange LA",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77f6fd67663eac90a2fcc13be3b3d492",
		  
		  "name": "Trevor",
		  "createdDate": "2012-08-04 18:44:45",
		  "totalOrganizations": 9,
		  "totalTours": 19,
		  "totalDays": 687,
		  "totalCountries": 21,
		  "totalStates": 60,
		  "totalEvents": 260,
		  "eventPercent": 0.881573,
		  "totalScheduleItems": 4987,
		  "schedulePercent": 0.953876,
		  "totalGuests": 664,
		  "guestPercent": 0.775612,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77f731fa541ef916f1b2195b31d3a610",
		  
		  "name": "Robbie",
		  "createdDate": "2017-05-30 19:48:34",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 127,
		  "totalCountries": 4,
		  "totalStates": 37,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 888,
		  "schedulePercent": 0.453083,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "77fe4854884c2d3da2862ca4320ebe8e",
		  
		  "name": "Bronwyn",
		  "createdDate": "2025-09-09 02:41:54",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 138,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 800,
		  "schedulePercent": 0.422597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7800fd86b644a86baa57d1b5aa0e126e",
		  
		  "name": "ANDY",
		  "createdDate": "2023-02-01 08:51:43",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 774,
		  "totalCountries": 23,
		  "totalStates": 26,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 2755,
		  "schedulePercent": 0.816976,
		  "totalGuests": 629,
		  "guestPercent": 0.764959,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "780ab1ab37e29927a68e0284cd2b5c7b",
		  
		  "name": "Daniel",
		  "createdDate": "2022-02-09 13:02:31",
		  "totalOrganizations": 23,
		  "totalTours": 13,
		  "totalDays": 249,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1155,
		  "schedulePercent": 0.535585,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Playa Festival",
		  "mostGuestCity": "Sundsvall",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "781fc8e09c2cef283fa088bb6e0d2030",
		  
		  "name": "Niklas",
		  "createdDate": "2024-04-09 09:02:38",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 472,
		  "schedulePercent": 0.299071,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Arena Wien",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "783859c59254b021074945f58b3ebda7",
		  
		  "name": "Eddie",
		  "createdDate": "2011-06-05 18:51:36",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 15,
		  "totalStates": 39,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 844,
		  "schedulePercent": 0.438577,
		  "totalGuests": 672,
		  "guestPercent": 0.778785,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Footprint Center",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "78459f747560e0c4e180957111a5a9b8",
		  
		  "name": "Welshie",
		  "createdDate": "2012-01-05 18:35:40",
		  "totalOrganizations": 9,
		  "totalTours": 24,
		  "totalDays": 783,
		  "totalCountries": 28,
		  "totalStates": 75,
		  "totalEvents": 337,
		  "eventPercent": 0.93597,
		  "totalScheduleItems": 6590,
		  "schedulePercent": 0.982888,
		  "totalGuests": 3262,
		  "guestPercent": 0.986967,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Cardiff Utilita Arena",
		  "mostGuestCity": "Cardiff",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7856c61e942388edb7417d559f680b0d",
		  
		  "name": "Luis ",
		  "createdDate": "2019-01-18 17:44:56",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 301,
		  "totalCountries": 6,
		  "totalStates": 31,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 449,
		  "schedulePercent": 0.290345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "785eaa3a6e7528f90c17bf8c6d4a7cc1",
		  
		  "name": "Benn",
		  "createdDate": "2013-05-21 21:55:42",
		  "totalOrganizations": 37,
		  "totalTours": 91,
		  "totalDays": 2734,
		  "totalCountries": 36,
		  "totalStates": 123,
		  "totalEvents": 776,
		  "eventPercent": 0.992634,
		  "totalScheduleItems": 12554,
		  "schedulePercent": 0.998413,
		  "totalGuests": 4386,
		  "guestPercent": 0.995467,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "786954bd3f90d4b66461e5d20568ad03",
		  
		  "name": "Holly",
		  "createdDate": "2025-05-12 16:16:56",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 86,
		  "totalCountries": 13,
		  "totalStates": 18,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 413,
		  "schedulePercent": 0.275499,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-09-15 00:00:00",
		  "mostGuestName": "Les Etoiles",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "786cc13198a166d4ccbd0533a8098fc6",
		  
		  "name": "Old",
		  "createdDate": "2021-10-18 15:49:45",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 378,
		  "totalCountries": 5,
		  "totalStates": 33,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1070,
		  "schedulePercent": 0.510426,
		  "totalGuests": 631,
		  "guestPercent": 0.765639,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "78737f6aab647f719b1a45a359ff973d",
		  
		  "name": "Lucas",
		  "createdDate": "2024-10-24 21:11:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 179,
		  "schedulePercent": 0.145852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7875b982baad60678e463e98e201e1a4",
		  
		  "name": "Matt",
		  "createdDate": "2018-10-02 12:21:04",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 299,
		  "totalCountries": 12,
		  "totalStates": 14,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1313,
		  "schedulePercent": 0.574569,
		  "totalGuests": 803,
		  "guestPercent": 0.808137,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Metropolis",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "787bfe95bfeaf876f55daf61eaf50982",
		  
		  "name": "Kari",
		  "createdDate": "2017-05-11 17:55:15",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 75,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 374,
		  "schedulePercent": 0.2551,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Helsinki City Festivaali",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7885d40bd15b1593ce5a7f49df95444f",
		  
		  "name": "Kevin",
		  "createdDate": "2023-04-03 14:56:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 71,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 806,
		  "schedulePercent": 0.424751,
		  "totalGuests": 1106,
		  "guestPercent": 0.865027,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Galopprennbahn KÃ¶ln-Weidenpesch",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7890fcc48a01a080a535778bf9b6114f",
		  
		  "name": "Frozen",
		  "createdDate": "2023-02-01 07:03:55",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 115,
		  "totalCountries": 6,
		  "totalStates": 45,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 834,
		  "schedulePercent": 0.435743,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Franklin Music Hall",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "789fe83450f600b529d48ae435c69f34",
		  
		  "name": "Astou",
		  "createdDate": "2024-01-26 14:42:47",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 281,
		  "totalCountries": 15,
		  "totalStates": 23,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 994,
		  "schedulePercent": 0.489121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "78b9e193801feb3ff3e7a5ac7c33588b",
		  
		  "name": "MIchela",
		  "createdDate": "2025-04-10 13:54:57",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 530,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 320,
		  "schedulePercent": 0.226995,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "78d4adcb6a00476f3d2cdff7cc95a7d6",
		  
		  "name": "Hilary",
		  "createdDate": "2019-02-07 19:01:09",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 930,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1720,
		  "schedulePercent": 0.662058,
		  "totalGuests": 615,
		  "guestPercent": 0.762693,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "The Paramount",
		  "mostGuestCity": "Huntington",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "78e869eaa7fe0b29f1d2b2e3c9fb40e9",
		  
		  "name": "Charles",
		  "createdDate": "2020-02-01 20:52:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 1,
		  "totalStates": 22,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 1354,
		  "schedulePercent": 0.586129,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "78ef720dd19f25f666a32a15deb6a63f",
		  
		  "name": "Richard",
		  "createdDate": "2022-04-20 09:57:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 367,
		  "totalCountries": 9,
		  "totalStates": 6,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 121,
		  "schedulePercent": 0.111627,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "78f06b8fa4b0290ed9421bb3aca49066",
		  
		  "name": "Brad",
		  "createdDate": "2024-01-23 16:58:09",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 87,
		  "totalCountries": 14,
		  "totalStates": 33,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 34,
		  "schedulePercent": 0.0452176,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "78f5e368bdd9acc98a7712ba251be0a5",
		  
		  "name": "Nick",
		  "createdDate": "2022-11-17 20:21:47",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 79,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 509,
		  "schedulePercent": 0.31505,
		  "totalGuests": 131,
		  "guestPercent": 0.545444,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Township Auditorium",
		  "mostGuestCity": "Columbia",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7907732e28f50e436645c7fc60895c4f",
		  
		  "name": "Jason",
		  "createdDate": "2017-08-07 04:30:43",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 352,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 199,
		  "schedulePercent": 0.160245,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Miss Kitty's",
		  "mostGuestCity": "Clive",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79089652237991dd4361dd0551e03b53",
		  
		  "name": "Mia",
		  "createdDate": "2019-11-21 19:57:00",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 86,
		  "totalCountries": 7,
		  "totalStates": 20,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 671,
		  "schedulePercent": 0.375227,
		  "totalGuests": 329,
		  "guestPercent": 0.665685,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "790921b2ee7ad37a67aa0e2100c03f97",
		  
		  "name": "Avery",
		  "createdDate": "2023-01-17 21:15:35",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 199,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 855,
		  "schedulePercent": 0.442203,
		  "totalGuests": 106,
		  "guestPercent": 0.525385,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "790bf9f002e540b347e717630b43ecc3",
		  
		  "name": "Ross",
		  "createdDate": "2015-09-11 22:51:57",
		  "totalOrganizations": 13,
		  "totalTours": 11,
		  "totalDays": 1049,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1114,
		  "schedulePercent": 0.521872,
		  "totalGuests": 457,
		  "guestPercent": 0.714982,
		  "mostGuestDate": "2025-12-16 00:00:00",
		  "mostGuestName": "Grand Ole Opry",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "790ce02aed222867cebf87d64fc5f756",
		  
		  "name": "Madeline",
		  "createdDate": "2023-10-25 16:42:52",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 597,
		  "totalCountries": 9,
		  "totalStates": 61,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 1800,
		  "schedulePercent": 0.676224,
		  "totalGuests": 226,
		  "guestPercent": 0.610607,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Palladium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79177cc03e0fa44da0a275b47676225f",
		  
		  "name": "Yuri",
		  "createdDate": "2025-04-04 12:32:33",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 202,
		  "totalCountries": 12,
		  "totalStates": 32,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1722,
		  "schedulePercent": 0.662398,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7918c4109a81a98f2b4aa24dbb26977a",
		  
		  "name": "Sarah",
		  "createdDate": "2018-03-28 09:45:14",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 76,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 546,
		  "schedulePercent": 0.332616,
		  "totalGuests": 338,
		  "guestPercent": 0.670104,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Studenternas Arena",
		  "mostGuestCity": "Uppsala",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "791b5ecebb0fd83f4a0433b9568f3655",
		  
		  "name": "Travis",
		  "createdDate": "2017-04-15 01:12:44",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 425,
		  "totalCountries": 8,
		  "totalStates": 43,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 597,
		  "schedulePercent": 0.350068,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7923a79d04b5d8f206829cf7ab006094",
		  
		  "name": "Alexandra",
		  "createdDate": "2021-11-25 22:57:34",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 175,
		  "totalCountries": 20,
		  "totalStates": 29,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1957,
		  "schedulePercent": 0.704669,
		  "totalGuests": 380,
		  "guestPercent": 0.685857,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Uber arena (Formerly Mercedes Benz Arena)",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7924564927a597d86938ae866fd08305",
		  
		  "name": "Daniel",
		  "createdDate": "2022-01-26 22:58:02",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 118,
		  "totalCountries": 16,
		  "totalStates": 20,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Racket NYC",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "792c5b1f2d709cae54a96c2d201b4801",
		  
		  "name": "Randy",
		  "createdDate": "2013-12-22 17:56:58",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 526,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 2346,
		  "schedulePercent": 0.767452,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "793d7cc2a120da17114392e0cf4b2b06",
		  
		  "name": "Megan",
		  "createdDate": "2015-04-20 05:09:13",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 899,
		  "totalCountries": 7,
		  "totalStates": 17,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 1009,
		  "schedulePercent": 0.493087,
		  "totalGuests": 108,
		  "guestPercent": 0.527199,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Innings Festival - Tempe Beach Park Ampitheatre",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "794828e7a3896b975a963d24d8d4b536",
		  
		  "name": "Emily ",
		  "createdDate": "2022-06-03 11:01:00",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 557,
		  "totalCountries": 10,
		  "totalStates": 24,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2659,
		  "schedulePercent": 0.803717,
		  "totalGuests": 697,
		  "guestPercent": 0.784905,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The SSE Hydro",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7963a895319482bbbcde3d2763f187fa",
		  
		  "name": "Richie",
		  "createdDate": "2014-02-11 11:02:50",
		  "totalOrganizations": 35,
		  "totalTours": 19,
		  "totalDays": 1900,
		  "totalCountries": 27,
		  "totalStates": 73,
		  "totalEvents": 344,
		  "eventPercent": 0.93937,
		  "totalScheduleItems": 4694,
		  "schedulePercent": 0.943903,
		  "totalGuests": 345,
		  "guestPercent": 0.672711,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Watford Colosseum",
		  "mostGuestCity": "Watford",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "796c3407f181e5a8ed27be82b29c131f",
		  
		  "name": "Jack",
		  "createdDate": "2025-09-04 21:58:43",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 87,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 437,
		  "guestPercent": 0.708522,
		  "mostGuestDate": "2025-09-16 00:00:00",
		  "mostGuestName": "The Regency Ballroom",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "796ca7cfb748691c1667184eaec687ed",
		  
		  "name": "Henry",
		  "createdDate": "2024-03-22 06:34:27",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 130,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Des Plaines Theatre",
		  "mostGuestCity": "Des Plaines",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "797089e34fa068ba556e21da9f191106",
		  
		  "name": "Scott",
		  "createdDate": "2011-10-05 21:15:56",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 567,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1405,
		  "schedulePercent": 0.599388,
		  "totalGuests": 649,
		  "guestPercent": 0.771306,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7974d88c195ffb7e22b1caa4f338ffea",
		  
		  "name": "Luc",
		  "createdDate": "2016-01-07 15:10:51",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 570,
		  "totalCountries": 7,
		  "totalStates": 26,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 2673,
		  "schedulePercent": 0.80587,
		  "totalGuests": 541,
		  "guestPercent": 0.741047,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Salle Wilfrid-Pelletier",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "797d287af0571a0a5c76abb3a0396bc8",
		  
		  "name": "Harry",
		  "createdDate": "2019-01-08 13:55:48",
		  "totalOrganizations": 41,
		  "totalTours": 32,
		  "totalDays": 6832,
		  "totalCountries": 43,
		  "totalStates": 105,
		  "totalEvents": 669,
		  "eventPercent": 0.990254,
		  "totalScheduleItems": 9359,
		  "schedulePercent": 0.995467,
		  "totalGuests": 2705,
		  "guestPercent": 0.976201,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "798c590b10062c00601fe7bbcd26c2ed",
		  
		  "name": "Adrian",
		  "createdDate": "2024-08-30 04:11:12",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 1404,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 1363,
		  "schedulePercent": 0.588282,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7991ceb2e7ba59f4dbd36a49785f8831",
		  
		  "name": "Iceland ",
		  "createdDate": "2023-07-24 13:07:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 126,
		  "schedulePercent": 0.115707,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "799817c6c74cf778c766575034aee118",
		  
		  "name": "Jordan",
		  "createdDate": "2023-05-14 12:27:26",
		  "totalOrganizations": 14,
		  "totalTours": 39,
		  "totalDays": 628,
		  "totalCountries": 9,
		  "totalStates": 50,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2537,
		  "schedulePercent": 0.790345,
		  "totalGuests": 711,
		  "guestPercent": 0.788078,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "799a3e098d193521c4743684dbe94434",
		  
		  "name": "Georg",
		  "createdDate": "2022-04-09 07:25:16",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 289,
		  "totalCountries": 17,
		  "totalStates": 39,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 1803,
		  "schedulePercent": 0.676677,
		  "totalGuests": 462,
		  "guestPercent": 0.716342,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Arena Wien",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79a5234571da853dc11fc0b0c97dd05d",
		  
		  "name": "Trent",
		  "createdDate": "2019-01-14 21:18:33",
		  "totalOrganizations": 13,
		  "totalTours": 30,
		  "totalDays": 1348,
		  "totalCountries": 4,
		  "totalStates": 57,
		  "totalEvents": 682,
		  "eventPercent": 0.990707,
		  "totalScheduleItems": 7511,
		  "schedulePercent": 0.988441,
		  "totalGuests": 4442,
		  "guestPercent": 0.995694,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79a87f4ad26d5c60d76e06be2de4e775",
		  
		  "name": "Dev",
		  "createdDate": "2018-07-11 23:45:17",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 60,
		  "totalCountries": 6,
		  "totalStates": 15,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 290,
		  "schedulePercent": 0.212149,
		  "totalGuests": 34,
		  "guestPercent": 0.426677,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Vancouver Playhouse",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79aa3ffb8611b9c206727779323141f3",
		  
		  "name": "Domino",
		  "createdDate": "2013-09-06 16:27:25",
		  "totalOrganizations": 11,
		  "totalTours": 2,
		  "totalDays": 477,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 280,
		  "schedulePercent": 0.205576,
		  "totalGuests": 346,
		  "guestPercent": 0.673277,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79b2516fc0313b9cf5625302ecd373ab",
		  
		  "name": "Zoux",
		  "createdDate": "2016-02-02 00:48:23",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 461,
		  "totalCountries": 12,
		  "totalStates": 16,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 341,
		  "schedulePercent": 0.239121,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79c7c6de0886187fecf883be495ac8da",
		  
		  "name": "Nick",
		  "createdDate": "2023-09-13 17:35:31",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 839,
		  "totalCountries": 36,
		  "totalStates": 51,
		  "totalEvents": 246,
		  "eventPercent": 0.866954,
		  "totalScheduleItems": 3244,
		  "schedulePercent": 0.863214,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79c844095dc92a3a3e835a08d09e3700",
		  
		  "name": "Liam",
		  "createdDate": "2024-09-16 02:08:12",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 333,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 954,
		  "schedulePercent": 0.477335,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79cbe81e2b36f6f1f097285ccc72fbaa",
		  
		  "name": "Declan",
		  "createdDate": "2022-03-17 18:21:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 81,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 260,
		  "schedulePercent": 0.194923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79d0eb62a95fb22849b26e5d53bd31f1",
		  
		  "name": "TYSON",
		  "createdDate": "2014-09-26 03:25:44",
		  "totalOrganizations": 59,
		  "totalTours": 22,
		  "totalDays": 1106,
		  "totalCountries": 34,
		  "totalStates": 84,
		  "totalEvents": 303,
		  "eventPercent": 0.914665,
		  "totalScheduleItems": 4322,
		  "schedulePercent": 0.932004,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79dcbf79585d646f63c7fdf80a9a9031",
		  
		  "name": "Antonella",
		  "createdDate": "2019-07-15 17:08:58",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79e5a7d8ac836d77910cca4ac7d30365",
		  
		  "name": "Eric",
		  "createdDate": "2022-01-24 17:59:37",
		  "totalOrganizations": 16,
		  "totalTours": 18,
		  "totalDays": 389,
		  "totalCountries": 26,
		  "totalStates": 51,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 1299,
		  "schedulePercent": 0.57117,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Cigale",
		  "mostGuestCity": "Quebec",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79f38fe1a4421f448e366a9df70faa5d",
		  
		  "name": "Samantha",
		  "createdDate": "2014-06-04 19:49:18",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 1103,
		  "totalCountries": 14,
		  "totalStates": 53,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 5703,
		  "schedulePercent": 0.971555,
		  "totalGuests": 660,
		  "guestPercent": 0.774252,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "79fafc1c774f5ddeef7f0ad85c2afdc0",
		  
		  "name": "John ",
		  "createdDate": "2022-10-13 00:23:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1787,
		  "schedulePercent": 0.674071,
		  "totalGuests": 1079,
		  "guestPercent": 0.860381,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a01bddba80961a2589e5ecee24545c3",
		  
		  "name": "Mike",
		  "createdDate": "2019-05-31 21:41:04",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 698,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2537,
		  "schedulePercent": 0.790345,
		  "totalGuests": 1882,
		  "guestPercent": 0.938917,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a023ae6e9b1bd497367c68b59c8862a",
		  
		  "name": "Austin",
		  "createdDate": "2023-10-20 03:37:47",
		  "totalOrganizations": 13,
		  "totalTours": 20,
		  "totalDays": 1079,
		  "totalCountries": 25,
		  "totalStates": 95,
		  "totalEvents": 297,
		  "eventPercent": 0.910811,
		  "totalScheduleItems": 4182,
		  "schedulePercent": 0.925091,
		  "totalGuests": 1130,
		  "guestPercent": 0.868314,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a0ff2dfa543b9f8e2496c3615114366",
		  
		  "name": "Sarah",
		  "createdDate": "2023-06-13 02:57:03",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 44,
		  "totalCountries": 7,
		  "totalStates": 18,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 575,
		  "schedulePercent": 0.341455,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Banpaku Memorial Park (East Plaza)",
		  "mostGuestCity": "Osaka",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a1ec250629ec04d3566e976464d4985",
		  
		  "name": "Tanner",
		  "createdDate": "2015-11-11 18:20:19",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 659,
		  "totalCountries": 10,
		  "totalStates": 51,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1971,
		  "schedulePercent": 0.708182,
		  "totalGuests": 1193,
		  "guestPercent": 0.875227,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a261cb37b9764944c98da1ab7f3deb2",
		  
		  "name": "Jake",
		  "createdDate": "2023-12-09 18:16:53",
		  "totalOrganizations": 1,
		  "totalTours": 32,
		  "totalDays": 767,
		  "totalCountries": 23,
		  "totalStates": 25,
		  "totalEvents": 487,
		  "eventPercent": 0.976315,
		  "totalScheduleItems": 5374,
		  "schedulePercent": 0.964982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a27c891fa3e66f503d1bae684dfcd40",
		  
		  "name": "Adam",
		  "createdDate": "2016-10-14 15:32:55",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 622,
		  "totalCountries": 9,
		  "totalStates": 42,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1468,
		  "schedulePercent": 0.610721,
		  "totalGuests": 470,
		  "guestPercent": 0.720422,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a2e4aff3fa7884af17753d976b383b0",
		  
		  "name": "Markus",
		  "createdDate": "2025-02-06 04:41:23",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 47,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 526,
		  "schedulePercent": 0.324683,
		  "totalGuests": 839,
		  "guestPercent": 0.817656,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Wiener Stadthalle",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a3142fe47e6b18fade6b6a3105b6b6e",
		  
		  "name": "Dwight",
		  "createdDate": "2023-09-10 14:12:48",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 1476,
		  "totalCountries": 12,
		  "totalStates": 52,
		  "totalEvents": 315,
		  "eventPercent": 0.922484,
		  "totalScheduleItems": 5624,
		  "schedulePercent": 0.969968,
		  "totalGuests": 1057,
		  "guestPercent": 0.856188,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a37391e6fad8ba0df438b8d1caea281",
		  
		  "name": "Will",
		  "createdDate": "2015-03-19 19:05:44",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 1099,
		  "totalCountries": 9,
		  "totalStates": 46,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1879,
		  "schedulePercent": 0.691183,
		  "totalGuests": 483,
		  "guestPercent": 0.725635,
		  "mostGuestDate": "2025-02-04 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a4ec34635db95a728034f7870318b27",
		  
		  "name": "Dan",
		  "createdDate": "2013-09-06 21:42:59",
		  "totalOrganizations": 14,
		  "totalTours": 10,
		  "totalDays": 711,
		  "totalCountries": 21,
		  "totalStates": 60,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2105,
		  "schedulePercent": 0.733794,
		  "totalGuests": 641,
		  "guestPercent": 0.769379,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Channel 24",
		  "mostGuestCity": "Sacramento",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a537b3e347e63d1ec103b5824893434",
		  
		  "name": "Mackenzie",
		  "createdDate": "2022-09-05 15:36:31",
		  "totalOrganizations": 8,
		  "totalTours": 20,
		  "totalDays": 789,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 2003,
		  "schedulePercent": 0.714302,
		  "totalGuests": 569,
		  "guestPercent": 0.749773,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a537bb6e6108d0ef19a1f5b19a5333d",
		  
		  "name": "Richard",
		  "createdDate": "2011-09-14 14:29:59",
		  "totalOrganizations": 17,
		  "totalTours": 21,
		  "totalDays": 386,
		  "totalCountries": 30,
		  "totalStates": 60,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 3210,
		  "schedulePercent": 0.860834,
		  "totalGuests": 1357,
		  "guestPercent": 0.894492,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Old Royal Naval College",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a545cdfd83557e25390328671b6ea5c",
		  
		  "name": "Chris",
		  "createdDate": "2018-04-21 08:08:31",
		  "totalOrganizations": 17,
		  "totalTours": 8,
		  "totalDays": 206,
		  "totalCountries": 31,
		  "totalStates": 57,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1724,
		  "schedulePercent": 0.662738,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Manning Bar",
		  "mostGuestCity": "Camperdown",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a596c66127a4c83488af3bf92ef26ce",
		  
		  "name": "Corey",
		  "createdDate": "2016-08-17 18:26:26",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 208,
		  "totalCountries": 11,
		  "totalStates": 27,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 938,
		  "schedulePercent": 0.471895,
		  "totalGuests": 509,
		  "guestPercent": 0.732888,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a61690b5ae4e487fc2e2080ddbe7d80",
		  
		  "name": "Antonia",
		  "createdDate": "2023-07-05 01:00:10",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 387,
		  "totalCountries": 39,
		  "totalStates": 39,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1391,
		  "schedulePercent": 0.595195,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a634537f9a636aed3e617a22645bbb1",
		  
		  "name": "Jason",
		  "createdDate": "2022-04-29 17:14:50",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 308,
		  "totalCountries": 21,
		  "totalStates": 57,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1124,
		  "schedulePercent": 0.526179,
		  "totalGuests": 709,
		  "guestPercent": 0.787511,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Santa Barbara Bowl",
		  "mostGuestCity": "Santa Barbara",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a6c22c4650c2d3e2433c72228499f61",
		  
		  "name": "Emmy",
		  "createdDate": "2015-09-11 18:49:00",
		  "totalOrganizations": 21,
		  "totalTours": 16,
		  "totalDays": 1005,
		  "totalCountries": 28,
		  "totalStates": 103,
		  "totalEvents": 357,
		  "eventPercent": 0.944696,
		  "totalScheduleItems": 5295,
		  "schedulePercent": 0.961922,
		  "totalGuests": 1771,
		  "guestPercent": 0.931777,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a71c47a5db7019a1b278e03340d1728",
		  
		  "name": "Amanda",
		  "createdDate": "2018-04-15 17:40:54",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 42,
		  "totalCountries": 1,
		  "totalStates": 11,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 279,
		  "schedulePercent": 0.205009,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Tampa Theatre",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a772d89dad5f63346ed022232820f56",
		  
		  "name": "Charles",
		  "createdDate": "2022-11-02 21:57:48",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 9,
		  "totalStates": 24,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 761,
		  "schedulePercent": 0.409338,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Royale",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a892fa5948419029b76ee63a3d55d7e",
		  
		  "name": "Aaron",
		  "createdDate": "2010-07-21 21:42:20",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 266,
		  "totalCountries": 6,
		  "totalStates": 45,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 993,
		  "schedulePercent": 0.489007,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a937e60ab83a743e28f705e410e3d3f",
		  
		  "name": "Heather",
		  "createdDate": "2019-08-26 21:25:34",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 106,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1127,
		  "schedulePercent": 0.527085,
		  "totalGuests": 239,
		  "guestPercent": 0.618314,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "New Jersey Performing Arts Center (NJPAC)",
		  "mostGuestCity": "Newark",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a97a0643ff1c0cef6a8df8621080607",
		  
		  "name": "Greg",
		  "createdDate": "2025-08-27 11:24:19",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 23,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 122,
		  "schedulePercent": 0.112534,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Manoir Pub",
		  "mostGuestCity": "Saint-Maurice",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7a9afb4a2ae09196b1f86edb600dcf8c",
		  
		  "name": "kevin",
		  "createdDate": "2025-01-12 23:11:18",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 78,
		  "totalCountries": 13,
		  "totalStates": 15,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 512,
		  "schedulePercent": 0.316636,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-01-29 00:00:00",
		  "mostGuestName": "The Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7aae1ae8f94c8c9217fcf3d79ca4a497",
		  
		  "name": "Scott",
		  "createdDate": "2011-03-06 12:37:19",
		  "totalOrganizations": 20,
		  "totalTours": 1,
		  "totalDays": 237,
		  "totalCountries": 20,
		  "totalStates": 29,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 601,
		  "schedulePercent": 0.351315,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ac8713db48478b051153688d3b2d50e",
		  
		  "name": "Caitlin",
		  "createdDate": "2021-06-01 05:13:47",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 89,
		  "schedulePercent": 0.0889619,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7acdd8b78fe80918841203abd6a9d771",
		  
		  "name": "Ariel",
		  "createdDate": "2023-07-07 20:27:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 183,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 168,
		  "schedulePercent": 0.139279,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ae80e7f60eb1bf1b1a98366388f6ce3",
		  
		  "name": "Jessica ",
		  "createdDate": "2021-11-11 16:59:19",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 605,
		  "totalCountries": 22,
		  "totalStates": 33,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1113,
		  "schedulePercent": 0.521645,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ae9b4662b68907977965998c0d4f54a",
		  
		  "name": "Cath",
		  "createdDate": "2023-05-07 17:17:13",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 276,
		  "totalCountries": 10,
		  "totalStates": 8,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 493,
		  "schedulePercent": 0.30927,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Somerset House",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7aeddde22158481bde39d701472281af",
		  
		  "name": "Jon",
		  "createdDate": "2025-01-10 16:02:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 46,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 334,
		  "schedulePercent": 0.233908,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7af3f4f2960808776757a3aa2a84d412",
		  
		  "name": "Ryan",
		  "createdDate": "2011-07-27 17:29:01",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 327,
		  "totalCountries": 9,
		  "totalStates": 42,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1608,
		  "schedulePercent": 0.641886,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "Great Stage Park",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7af82ccb5326cdb89b63e9cc872e82ba",
		  
		  "name": "Dionne",
		  "createdDate": "2025-06-08 03:52:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 206,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1095,
		  "schedulePercent": 0.518699,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "TOKYU THEATRE Orb",
		  "mostGuestCity": "Shibuya-ku",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7afc420853706a9248a8446c4115b373",
		  
		  "name": "Michael",
		  "createdDate": "2019-08-29 00:24:21",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 150,
		  "totalCountries": 5,
		  "totalStates": 30,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1578,
		  "schedulePercent": 0.636219,
		  "totalGuests": 1528,
		  "guestPercent": 0.912965,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Globe Life Park in Arlington",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b0410a3fe383389d333ffda71a1ab03",
		  
		  "name": "Frank",
		  "createdDate": "2025-02-21 11:13:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 285,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 820,
		  "schedulePercent": 0.430984,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b0514d4b9eb95774672e13c8e1ed3a8",
		  
		  "name": "Thomas",
		  "createdDate": "2023-04-30 08:35:19",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 140,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 791,
		  "schedulePercent": 0.419311,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b1281ff802ed439f13c8f397b465cfd",
		  
		  "name": "Eric ",
		  "createdDate": "2022-05-11 04:17:10",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 1160,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 4673,
		  "schedulePercent": 0.94311,
		  "totalGuests": 3053,
		  "guestPercent": 0.983114,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b1b1453168ca46732b7cdfc052f558d",
		  
		  "name": "Louise",
		  "createdDate": "2024-09-03 10:44:00",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 392,
		  "totalCountries": 6,
		  "totalStates": 5,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 751,
		  "schedulePercent": 0.405598,
		  "totalGuests": 146,
		  "guestPercent": 0.555984,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "La Rampe, ScÃ¨ne conventionnÃ©e danse et musiques",
		  "mostGuestCity": "Ã‰chirolles",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b20586babb595042632ffca27baef8d",
		  
		  "name": "Jeff",
		  "createdDate": "2013-04-18 22:17:40",
		  "totalOrganizations": 15,
		  "totalTours": 3,
		  "totalDays": 837,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 1923,
		  "schedulePercent": 0.698436,
		  "totalGuests": 1973,
		  "guestPercent": 0.94549,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b20e05c75c1aa03cfc6221f373c561a",
		  
		  "name": "Morgan",
		  "createdDate": "2025-04-11 17:15:55",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 322,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 259,
		  "schedulePercent": 0.194356,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b2fb94ece86d359d655966bb6f4b803",
		  
		  "name": "Steve",
		  "createdDate": "2015-07-29 10:04:22",
		  "totalOrganizations": 10,
		  "totalTours": 2,
		  "totalDays": 314,
		  "totalCountries": 17,
		  "totalStates": 33,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1649,
		  "schedulePercent": 0.649932,
		  "totalGuests": 1437,
		  "guestPercent": 0.903672,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b6019b8a9c0e27a49b2d5d6cc2e5eb9",
		  
		  "name": "Peter",
		  "createdDate": "2018-07-31 13:11:19",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 100,
		  "totalCountries": 15,
		  "totalStates": 16,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 301,
		  "schedulePercent": 0.217815,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b62e4272294fc2330d533565688fdcf",
		  
		  "name": "Rosie",
		  "createdDate": "2021-11-18 12:31:43",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 983,
		  "totalCountries": 16,
		  "totalStates": 24,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 966,
		  "schedulePercent": 0.480054,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Le Hasard Ludique",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b6847439d6456866f9b7cb3c7f66f78",
		  
		  "name": "Paul",
		  "createdDate": "2024-02-09 20:30:05",
		  "totalOrganizations": 32,
		  "totalTours": 6,
		  "totalDays": 1254,
		  "totalCountries": 16,
		  "totalStates": 43,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 2179,
		  "schedulePercent": 0.7449,
		  "totalGuests": 1676,
		  "guestPercent": 0.926564,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b73b10ca0c497df2854fb4a4511abce",
		  
		  "name": "Illiana",
		  "createdDate": "2018-03-31 19:44:35",
		  "totalOrganizations": 19,
		  "totalTours": 7,
		  "totalDays": 474,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 2417,
		  "schedulePercent": 0.776972,
		  "totalGuests": 991,
		  "guestPercent": 0.844288,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b748112854130b6066b9e21bd377e57",
		  
		  "name": "Kelli",
		  "createdDate": "2015-10-09 14:41:40",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 327,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 411,
		  "schedulePercent": 0.274365,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Fort Adams State Park",
		  "mostGuestCity": "Newport",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b7c59f22d6cb588d3e7c1a843b9cabd",
		  
		  "name": "Brother Hassan ",
		  "createdDate": "2016-08-28 19:00:07",
		  "totalOrganizations": 16,
		  "totalTours": 12,
		  "totalDays": 846,
		  "totalCountries": 21,
		  "totalStates": 62,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2770,
		  "schedulePercent": 0.818223,
		  "totalGuests": 1872,
		  "guestPercent": 0.937443,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b8a915f7c7e3e42d1fda95fa3f084c4",
		  
		  "name": "Paul",
		  "createdDate": "2016-04-14 18:02:00",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 179,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 32,
		  "schedulePercent": 0.042951,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b9121a60a01a0c7cb09abf1f16e0f65",
		  
		  "name": "Michael",
		  "createdDate": "2023-05-23 01:12:05",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 109,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 336,
		  "schedulePercent": 0.234587,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b91defe91e2c7aa31b9389dc0a6bdb1",
		  
		  "name": "Lily Belle",
		  "createdDate": "2023-03-15 22:39:39",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 131,
		  "totalCountries": 7,
		  "totalStates": 14,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 255,
		  "schedulePercent": 0.19311,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-02-23 00:00:00",
		  "mostGuestName": "Northcote Social Club",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7b9690ccfbbfb1dbcb99dada33fd81cb",
		  
		  "name": "Andrew",
		  "createdDate": "2012-03-13 07:20:20",
		  "totalOrganizations": 36,
		  "totalTours": 19,
		  "totalDays": 2335,
		  "totalCountries": 36,
		  "totalStates": 82,
		  "totalEvents": 447,
		  "eventPercent": 0.970422,
		  "totalScheduleItems": 9118,
		  "schedulePercent": 0.99388,
		  "totalGuests": 1015,
		  "guestPercent": 0.849501,
		  "mostGuestDate": "2025-06-24 00:00:00",
		  "mostGuestName": "O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7baf59857bf03e6c3eb1d9ac63ed300b",
		  
		  "name": "Mark",
		  "createdDate": "2025-06-13 17:54:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 81,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7bb2818eb37e36a174e42bd6e1ca5482",
		  
		  "name": "Dylan",
		  "createdDate": "2019-08-05 18:58:30",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 1026,
		  "totalCountries": 2,
		  "totalStates": 39,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 3104,
		  "schedulePercent": 0.851995,
		  "totalGuests": 1714,
		  "guestPercent": 0.928717,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7bb2d030fe9ff7e6f2b54453652eee7d",
		  
		  "name": "Sally",
		  "createdDate": "2022-03-23 20:51:06",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 357,
		  "totalCountries": 20,
		  "totalStates": 20,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 2830,
		  "schedulePercent": 0.825816,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7bb6114c32218ab3f360cdc923f93510",
		  
		  "name": "Ruben",
		  "createdDate": "2017-07-13 20:42:14",
		  "totalOrganizations": 26,
		  "totalTours": 21,
		  "totalDays": 1237,
		  "totalCountries": 25,
		  "totalStates": 70,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2749,
		  "schedulePercent": 0.81641,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Astra Kulturhaus",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7bbdc160ec8116b043187077541ba8c6",
		  
		  "name": "Carlos ",
		  "createdDate": "2018-04-10 22:32:35",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 196,
		  "totalCountries": 9,
		  "totalStates": 24,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 632,
		  "schedulePercent": 0.361514,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "PALACIO DE LA MÃšSICA",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7bcd0a50a79675dd790857e9ca21b109",
		  
		  "name": "ShaggyPup",
		  "createdDate": "2018-10-16 16:09:03",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 51,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 546,
		  "schedulePercent": 0.332616,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7bd01ba66e8d1d7ddd707d6c3007f9a3",
		  
		  "name": "George",
		  "createdDate": "2019-08-13 17:10:24",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 281,
		  "totalCountries": 20,
		  "totalStates": 30,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 652,
		  "schedulePercent": 0.3682,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7be84174af1dbc13312423004a348ea6",
		  
		  "name": "Jonny",
		  "createdDate": "2022-07-05 14:10:51",
		  "totalOrganizations": 17,
		  "totalTours": 32,
		  "totalDays": 1138,
		  "totalCountries": 29,
		  "totalStates": 67,
		  "totalEvents": 250,
		  "eventPercent": 0.87092,
		  "totalScheduleItems": 2788,
		  "schedulePercent": 0.820716,
		  "totalGuests": 295,
		  "guestPercent": 0.647212,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Portman Road Stadium",
		  "mostGuestCity": "Ipswich",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7befddde293ca68cef71a0aa4b1c6dd3",
		  
		  "name": "Amy",
		  "createdDate": "2015-12-28 12:46:15",
		  "totalOrganizations": 46,
		  "totalTours": 29,
		  "totalDays": 1107,
		  "totalCountries": 20,
		  "totalStates": 78,
		  "totalEvents": 363,
		  "eventPercent": 0.947529,
		  "totalScheduleItems": 6771,
		  "schedulePercent": 0.984701,
		  "totalGuests": 2731,
		  "guestPercent": 0.977221,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7bfc42ba70ebdeaf2a9d4396afe5b1e7",
		  
		  "name": "Aliya",
		  "createdDate": "2023-06-18 21:50:13",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 87,
		  "totalCountries": 5,
		  "totalStates": 25,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 106,
		  "schedulePercent": 0.102108,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c154888981af2ee867520acebe46114",
		  
		  "name": "David C",
		  "createdDate": "2023-06-06 17:49:17",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 76,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 713,
		  "schedulePercent": 0.391432,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Grace Community Church",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c2a14f8183dfd86e806d8eb753ca7d4",
		  
		  "name": "Jake",
		  "createdDate": "2018-02-26 20:55:22",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 288,
		  "totalCountries": 21,
		  "totalStates": 53,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2290,
		  "schedulePercent": 0.760539,
		  "totalGuests": 602,
		  "guestPercent": 0.75884,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c3aba8ee6ef986e49b396719fe741c1",
		  
		  "name": "Mitchel",
		  "createdDate": "2025-03-26 22:31:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 280,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1282,
		  "schedulePercent": 0.567996,
		  "totalGuests": 2057,
		  "guestPercent": 0.951043,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c494fcf75e4866db53d14154ccaa357",
		  
		  "name": "David-Etienne",
		  "createdDate": "2016-06-29 09:17:39",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 498,
		  "totalCountries": 13,
		  "totalStates": 20,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 630,
		  "schedulePercent": 0.360834,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Horseshoe Tavern",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c49829de6c0a7db4c01220d810e758f",
		  
		  "name": "Reginald",
		  "createdDate": "2022-05-11 22:36:57",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 223,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 373,
		  "schedulePercent": 0.254646,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "713 Music Hall",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c51cc41424dd941f5741c7f2d559cff",
		  
		  "name": "Elliot",
		  "createdDate": "2015-08-18 00:21:47",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 710,
		  "totalCountries": 4,
		  "totalStates": 47,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 2726,
		  "schedulePercent": 0.81267,
		  "totalGuests": 775,
		  "guestPercent": 0.801451,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c544d516a3a4a133ebf6a77b619ab31",
		  
		  "name": "Brian ",
		  "createdDate": "2011-03-05 21:56:11",
		  "totalOrganizations": 15,
		  "totalTours": 13,
		  "totalDays": 788,
		  "totalCountries": 10,
		  "totalStates": 55,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2989,
		  "schedulePercent": 0.841682,
		  "totalGuests": 1135,
		  "guestPercent": 0.869787,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c5847e5ee178202623434fdf31ee9b0",
		  
		  "name": "Garrett",
		  "createdDate": "2024-05-27 19:43:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 349,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 162,
		  "schedulePercent": 0.136786,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Gruene Hall",
		  "mostGuestCity": "New Braunfels",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c5bd612011e745c18ab64cc51bd517c",
		  
		  "name": "Blaire",
		  "createdDate": "2015-11-11 23:15:46",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 275,
		  "totalCountries": 6,
		  "totalStates": 47,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2097,
		  "schedulePercent": 0.732434,
		  "totalGuests": 1341,
		  "guestPercent": 0.892112,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c64805e5e426ef9e1775a77f907cecd",
		  
		  "name": "Timothy",
		  "createdDate": "2015-07-26 18:25:59",
		  "totalOrganizations": 22,
		  "totalTours": 19,
		  "totalDays": 982,
		  "totalCountries": 33,
		  "totalStates": 46,
		  "totalEvents": 314,
		  "eventPercent": 0.921917,
		  "totalScheduleItems": 5039,
		  "schedulePercent": 0.955236,
		  "totalGuests": 407,
		  "guestPercent": 0.696623,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c669b6edde3ff9a6958aa166d147c13",
		  
		  "name": "Pat ",
		  "createdDate": "2015-02-27 19:33:17",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 755,
		  "totalCountries": 21,
		  "totalStates": 32,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 2446,
		  "schedulePercent": 0.780712,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c69a4dd4be234e059dd130170317bb8",
		  
		  "name": "Matt",
		  "createdDate": "2014-03-17 15:39:44",
		  "totalOrganizations": 16,
		  "totalTours": 4,
		  "totalDays": 916,
		  "totalCountries": 14,
		  "totalStates": 23,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 1620,
		  "schedulePercent": 0.644152,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c6e0e8f8a1d83f9dc7e095f13423b0f",
		  
		  "name": "Admin",
		  "createdDate": "2025-04-10 21:46:24",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 356,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 103,
		  "schedulePercent": 0.0988214,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c7acf9efd610e39eb681653e5a62188",
		  
		  "name": "Jared",
		  "createdDate": "2021-06-29 00:27:42",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 266,
		  "totalCountries": 23,
		  "totalStates": 42,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 2768,
		  "schedulePercent": 0.817883,
		  "totalGuests": 774,
		  "guestPercent": 0.801224,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c865073acae56d78c919dc2851a5a5c",
		  
		  "name": "Hanjun ",
		  "createdDate": "2024-10-22 08:20:59",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 76,
		  "totalCountries": 9,
		  "totalStates": 12,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 137,
		  "schedulePercent": 0.123187,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c88e1c43911c4ac18f640c463feabc4",
		  
		  "name": "Charlie",
		  "createdDate": "2022-02-09 14:57:37",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 387,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 245,
		  "schedulePercent": 0.186877,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c8d0c98c722606e014939d221851dcc",
		  
		  "name": "Sophie ",
		  "createdDate": "2013-01-15 09:37:07",
		  "totalOrganizations": 15,
		  "totalTours": 46,
		  "totalDays": 698,
		  "totalCountries": 40,
		  "totalStates": 102,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 3926,
		  "schedulePercent": 0.910131,
		  "totalGuests": 1937,
		  "guestPercent": 0.94141,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c913301d2ab6fe94f671cfc60cf8567",
		  
		  "name": "Andrew",
		  "createdDate": "2017-01-30 15:42:59",
		  "totalOrganizations": 13,
		  "totalTours": 2,
		  "totalDays": 417,
		  "totalCountries": 16,
		  "totalStates": 37,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 339,
		  "schedulePercent": 0.237874,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Le Poisson Rouge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c9314a29567f002cc5f19c9c4880b24",
		  
		  "name": "Mariko",
		  "createdDate": "2015-11-05 13:28:11",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 379,
		  "totalCountries": 23,
		  "totalStates": 27,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 2317,
		  "schedulePercent": 0.764279,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c953d4f08d31b2f27c25548aaa55eaa",
		  
		  "name": "Paul",
		  "createdDate": "2017-08-23 21:53:58",
		  "totalOrganizations": 26,
		  "totalTours": 19,
		  "totalDays": 1895,
		  "totalCountries": 8,
		  "totalStates": 62,
		  "totalEvents": 286,
		  "eventPercent": 0.902765,
		  "totalScheduleItems": 3879,
		  "schedulePercent": 0.906845,
		  "totalGuests": 1048,
		  "guestPercent": 0.853694,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c9585d62598f0417ac4a46176bc9a96",
		  
		  "name": "Christopher",
		  "createdDate": "2024-01-05 00:54:35",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 267,
		  "totalCountries": 24,
		  "totalStates": 69,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2074,
		  "schedulePercent": 0.727901,
		  "totalGuests": 385,
		  "guestPercent": 0.68801,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Salt Shed",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7c9fae0cc7a581532edbfc8005221f60",
		  
		  "name": "Melissa",
		  "createdDate": "2024-02-10 13:48:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 24,
		  "totalCountries": 1,
		  "totalStates": 8,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 242,
		  "schedulePercent": 0.18529,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ca02affd38d98c2ff9f9adced2aeb1a",
		  
		  "name": "James",
		  "createdDate": "2011-08-18 21:12:22",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 598,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 2238,
		  "schedulePercent": 0.753853,
		  "totalGuests": 1727,
		  "guestPercent": 0.929284,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cb0eeac6e10ee1bd912f88b40c8bec3",
		  
		  "name": "Mat",
		  "createdDate": "2023-03-05 17:49:07",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 732,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1806,
		  "schedulePercent": 0.677017,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Coors Light Birds Nest",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cb18e155cd6cec7dab9f386186de299",
		  
		  "name": "Jeff",
		  "createdDate": "2012-02-21 16:08:11",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 369,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 2080,
		  "schedulePercent": 0.729034,
		  "totalGuests": 2521,
		  "guestPercent": 0.968722,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cb3f202cf28e71cd2ee1dd64dbc0963",
		  
		  "name": "William",
		  "createdDate": "2019-10-15 21:44:15",
		  "totalOrganizations": 9,
		  "totalTours": 45,
		  "totalDays": 125,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 740,
		  "schedulePercent": 0.401519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cb6084b1465b1e2d6045c509829f6cf",
		  
		  "name": "Cameron",
		  "createdDate": "2012-04-24 04:40:54",
		  "totalOrganizations": 24,
		  "totalTours": 10,
		  "totalDays": 981,
		  "totalCountries": 33,
		  "totalStates": 60,
		  "totalEvents": 312,
		  "eventPercent": 0.920671,
		  "totalScheduleItems": 3775,
		  "schedulePercent": 0.900612,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cc47a9c8631eab404bafc2f8b876822",
		  
		  "name": "Harrison",
		  "createdDate": "2025-03-20 15:03:05",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 252,
		  "totalCountries": 15,
		  "totalStates": 47,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1651,
		  "schedulePercent": 0.650499,
		  "totalGuests": 1070,
		  "guestPercent": 0.858341,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cc755bbb9820a708eac51b982ca95d4",
		  
		  "name": "Brandon",
		  "createdDate": "2021-06-04 11:29:56",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 367,
		  "totalCountries": 8,
		  "totalStates": 18,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 340,
		  "schedulePercent": 0.238441,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "XS Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cde55c2d76d9c90f89b8527d308ec0c",
		  
		  "name": "Brisselli",
		  "createdDate": "2017-05-30 22:29:04",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 685,
		  "totalCountries": 20,
		  "totalStates": 61,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 2725,
		  "schedulePercent": 0.812557,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ce31938fb694a886dc6897c8eb1d3d8",
		  
		  "name": "Patrick",
		  "createdDate": "2022-10-05 03:45:12",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 38,
		  "totalCountries": 8,
		  "totalStates": 13,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Port Beach Brewery",
		  "mostGuestCity": "North Fremantle",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cea1067e346d91f6259f252b83a8ec3",
		  
		  "name": "Ben",
		  "createdDate": "2009-11-04 08:45:34",
		  "totalOrganizations": 18,
		  "totalTours": 10,
		  "totalDays": 1073,
		  "totalCountries": 10,
		  "totalStates": 52,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 4069,
		  "schedulePercent": 0.917384,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cece73cf874072f5f3657c6520c6850",
		  
		  "name": "Simon",
		  "createdDate": "2023-04-14 09:25:31",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 69,
		  "totalCountries": 8,
		  "totalStates": 6,
		  "totalEvents": 1,
		  "eventPercent": 0.0074796,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7cfdfe2dec020a82f6396e868b88826e",
		  
		  "name": "Paul",
		  "createdDate": "2022-10-11 16:46:31",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 262,
		  "totalCountries": 11,
		  "totalStates": 44,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 919,
		  "schedulePercent": 0.464415,
		  "totalGuests": 356,
		  "guestPercent": 0.677131,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d0f67c9135a46b0882cd92d965dcab5",
		  
		  "name": "Bailey",
		  "createdDate": "2023-03-14 20:55:16",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 290,
		  "totalCountries": 19,
		  "totalStates": 48,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1451,
		  "schedulePercent": 0.607548,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d11d0f04b220bffb33457f35372ef17",
		  
		  "name": "Sacha",
		  "createdDate": "2014-03-21 19:12:41",
		  "totalOrganizations": 14,
		  "totalTours": 17,
		  "totalDays": 1022,
		  "totalCountries": 41,
		  "totalStates": 78,
		  "totalEvents": 333,
		  "eventPercent": 0.934044,
		  "totalScheduleItems": 5062,
		  "schedulePercent": 0.956142,
		  "totalGuests": 473,
		  "guestPercent": 0.721668,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d1c6125ef1cea0246b938c323ee12aa",
		  
		  "name": "Tim",
		  "createdDate": "2023-09-13 14:55:26",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 76,
		  "totalCountries": 11,
		  "totalStates": 34,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 702,
		  "schedulePercent": 0.387693,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d1d9472d602c954e0ab2b6458426ec8",
		  
		  "name": "Alison",
		  "createdDate": "2021-09-21 10:17:22",
		  "totalOrganizations": 51,
		  "totalTours": 9,
		  "totalDays": 404,
		  "totalCountries": 24,
		  "totalStates": 41,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1629,
		  "schedulePercent": 0.645739,
		  "totalGuests": 320,
		  "guestPercent": 0.659791,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d2ab22d1dd96c1d51d3917697b7d8de",
		  
		  "name": "Kat",
		  "createdDate": "2018-08-06 21:46:37",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 191,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 1067,
		  "schedulePercent": 0.509406,
		  "totalGuests": 106,
		  "guestPercent": 0.525385,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d33e26483ffebad873072fa8e23ed45",
		  
		  "name": "Andy",
		  "createdDate": "2010-01-28 14:11:00",
		  "totalOrganizations": 14,
		  "totalTours": 18,
		  "totalDays": 231,
		  "totalCountries": 25,
		  "totalStates": 34,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 966,
		  "schedulePercent": 0.480054,
		  "totalGuests": 137,
		  "guestPercent": 0.550204,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d39caf8063b05fc7c2e4177e170192d",
		  
		  "name": "Joseph",
		  "createdDate": "2022-05-06 21:50:16",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 430,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 364,
		  "schedulePercent": 0.25,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d39f05b0748733ef1fb10f308821b73",
		  
		  "name": "Cl&#233;ment",
		  "createdDate": "2021-10-25 08:45:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 27,
		  "totalStates": 5,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 582,
		  "schedulePercent": 0.344515,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d3a3641316973ac8b4f9df489996850",
		  
		  "name": "Matt",
		  "createdDate": "2018-10-09 00:33:46",
		  "totalOrganizations": 1,
		  "totalTours": 11,
		  "totalDays": 134,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 663,
		  "schedulePercent": 0.372507,
		  "totalGuests": 1083,
		  "guestPercent": 0.861287,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d41c2d82d3423d946b507f338068f35",
		  
		  "name": "Haley",
		  "createdDate": "2021-04-16 22:23:13",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 555,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1425,
		  "schedulePercent": 0.603581,
		  "totalGuests": 383,
		  "guestPercent": 0.68699,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d5496effe08d1c9b49f590361a5eca2",
		  
		  "name": "Sam",
		  "createdDate": "2025-03-18 19:26:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 38,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 108,
		  "schedulePercent": 0.103921,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d607f13ff242acb7eae9682929fd451",
		  
		  "name": "Parker",
		  "createdDate": "2018-02-16 19:25:15",
		  "totalOrganizations": 13,
		  "totalTours": 15,
		  "totalDays": 1106,
		  "totalCountries": 17,
		  "totalStates": 63,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 4887,
		  "schedulePercent": 0.950929,
		  "totalGuests": 1972,
		  "guestPercent": 0.945376,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d6d0930a0c2389b1f018c9fcfbde1d1",
		  
		  "name": "Kristin",
		  "createdDate": "2023-08-16 11:42:06",
		  "totalOrganizations": 14,
		  "totalTours": 6,
		  "totalDays": 330,
		  "totalCountries": 7,
		  "totalStates": 12,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1119,
		  "schedulePercent": 0.524592,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "Burgsvik GrÃ¥ GÃ¥sen",
		  "mostGuestCity": "Burgsvik",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d7b4ae13dec3dfded99f4f1fb93d21a",
		  
		  "name": "Daniel",
		  "createdDate": "2017-02-14 07:21:35",
		  "totalOrganizations": 13,
		  "totalTours": 60,
		  "totalDays": 431,
		  "totalCountries": 14,
		  "totalStates": 56,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 1288,
		  "schedulePercent": 0.568903,
		  "totalGuests": 335,
		  "guestPercent": 0.668064,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d8bff49df6c2b6ff3f508971f7a9016",
		  
		  "name": "Taika",
		  "createdDate": "2019-04-08 10:59:01",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 401,
		  "totalCountries": 18,
		  "totalStates": 30,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1872,
		  "schedulePercent": 0.689823,
		  "totalGuests": 132,
		  "guestPercent": 0.546124,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "ParkbÃ¼hne GeyserHaus e.V.",
		  "mostGuestCity": "Leipzig",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d8ea65fa3f72ff7df09b247612030bc",
		  
		  "name": "David",
		  "createdDate": "2017-03-14 23:33:56",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 2009,
		  "totalCountries": 8,
		  "totalStates": 66,
		  "totalEvents": 401,
		  "eventPercent": 0.958636,
		  "totalScheduleItems": 5601,
		  "schedulePercent": 0.969628,
		  "totalGuests": 2431,
		  "guestPercent": 0.966115,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d986475d13b734e158e3b523360ae6e",
		  
		  "name": "Shane",
		  "createdDate": "2019-03-22 22:17:22",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 606,
		  "totalCountries": 20,
		  "totalStates": 69,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 5360,
		  "schedulePercent": 0.964302,
		  "totalGuests": 419,
		  "guestPercent": 0.701496,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Hammerstein Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7d9f734a0beb4697fb0444db27bd58e7",
		  
		  "name": "Adriana ",
		  "createdDate": "2022-06-06 16:24:46",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 422,
		  "totalCountries": 16,
		  "totalStates": 31,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 749,
		  "schedulePercent": 0.404805,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7da0e747e5de7980d2ca5c7205d0f4a2",
		  
		  "name": "Dominic",
		  "createdDate": "2021-03-23 18:53:02",
		  "totalOrganizations": 8,
		  "totalTours": 46,
		  "totalDays": 672,
		  "totalCountries": 27,
		  "totalStates": 46,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 3738,
		  "schedulePercent": 0.898119,
		  "totalGuests": 683,
		  "guestPercent": 0.781845,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7da5dd250901bffe9e859948d729cd24",
		  
		  "name": "Nuno",
		  "createdDate": "2025-05-24 18:40:53",
		  "totalOrganizations": 17,
		  "totalTours": 15,
		  "totalDays": 376,
		  "totalCountries": 14,
		  "totalStates": 5,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 3182,
		  "schedulePercent": 0.858228,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7db30d775396a74abed6c0b0ab247be1",
		  
		  "name": "ANDRES",
		  "createdDate": "2023-01-17 10:35:15",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 647,
		  "totalCountries": 21,
		  "totalStates": 31,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1155,
		  "schedulePercent": 0.535585,
		  "totalGuests": 375,
		  "guestPercent": 0.683477,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "North Beach Bandshell",
		  "mostGuestCity": "Miami Beach",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7dbadc0b3be630f692470f7623d442f1",
		  
		  "name": "Ollie",
		  "createdDate": "2019-02-18 04:12:20",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 1019,
		  "totalCountries": 40,
		  "totalStates": 65,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 2964,
		  "schedulePercent": 0.838622,
		  "totalGuests": 582,
		  "guestPercent": 0.753626,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Diamante de BÃ©isbol - Sede de los Living Conciertos",
		  "mostGuestCity": "Cali",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7dbb2517d0c826a33286820d9a925957",
		  
		  "name": "Naomi",
		  "createdDate": "2018-05-29 06:01:44",
		  "totalOrganizations": 14,
		  "totalTours": 10,
		  "totalDays": 821,
		  "totalCountries": 29,
		  "totalStates": 52,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 3509,
		  "schedulePercent": 0.882593,
		  "totalGuests": 783,
		  "guestPercent": 0.80383,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7dbc7187d4a0d68a512e0690c5b075c6",
		  
		  "name": "Lauren",
		  "createdDate": "2022-08-26 07:54:53",
		  "totalOrganizations": 11,
		  "totalTours": 21,
		  "totalDays": 401,
		  "totalCountries": 26,
		  "totalStates": 69,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2558,
		  "schedulePercent": 0.793744,
		  "totalGuests": 430,
		  "guestPercent": 0.706482,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7dc51968ee1360ec70c7a69f8170f2f5",
		  
		  "name": "Benjamin",
		  "createdDate": "2022-04-27 20:41:54",
		  "totalOrganizations": 17,
		  "totalTours": 5,
		  "totalDays": 267,
		  "totalCountries": 26,
		  "totalStates": 34,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1834,
		  "schedulePercent": 0.682457,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "O2 Academy Islington",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7dd069cafa6099d4d771e20ec241c38f",
		  
		  "name": "Hugo",
		  "createdDate": "2021-10-28 01:25:06",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 208,
		  "totalCountries": 15,
		  "totalStates": 42,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 2564,
		  "schedulePercent": 0.794311,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7dd95beb16ab30d0eba91769e63a6d3d",
		  
		  "name": "Davis",
		  "createdDate": "2022-07-19 19:11:04",
		  "totalOrganizations": 10,
		  "totalTours": 16,
		  "totalDays": 533,
		  "totalCountries": 27,
		  "totalStates": 60,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 1797,
		  "schedulePercent": 0.675657,
		  "totalGuests": 1292,
		  "guestPercent": 0.885199,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7de01e6e8411c037d9400e4974637ec0",
		  
		  "name": "RJ",
		  "createdDate": "2022-06-11 01:59:45",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 932,
		  "totalCountries": 7,
		  "totalStates": 42,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 3361,
		  "schedulePercent": 0.871827,
		  "totalGuests": 1334,
		  "guestPercent": 0.891659,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7de5e7d6f32631c0406e8852deba78c0",
		  
		  "name": "Pernilla ",
		  "createdDate": "2017-02-06 10:14:29",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 1111,
		  "totalCountries": 7,
		  "totalStates": 22,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 695,
		  "schedulePercent": 0.384406,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "DR Koncerthuset",
		  "mostGuestCity": "Kobenhavn",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7de7bcc199f62780714ca59aa63b80b9",
		  
		  "name": "matthew",
		  "createdDate": "2022-04-19 19:05:59",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 719,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2499,
		  "schedulePercent": 0.786605,
		  "totalGuests": 323,
		  "guestPercent": 0.662511,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Credit Union 1 Amphitheatre",
		  "mostGuestCity": "Tinley Park",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7deaa5954c0fd77860950643f98f1a62",
		  
		  "name": "Danette",
		  "createdDate": "2022-02-09 18:17:46",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 90,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 742,
		  "schedulePercent": 0.401972,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Dolly Parton's Celebrity Theater",
		  "mostGuestCity": "Pigeon Forge",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7deab6a68f75ab4e9b461348c83f4aa9",
		  
		  "name": "Otto H&#248;gh",
		  "createdDate": "2025-02-28 10:20:25",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 62,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Glassalen",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e0934f3a6408beb9040327ebd8f8ffd",
		  
		  "name": "Sofie",
		  "createdDate": "2025-02-27 21:44:21",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 216,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "CRSSD",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e19ec25e56c9a58d8a0cac546c86322",
		  
		  "name": "Phillip",
		  "createdDate": "2023-09-24 15:53:27",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 172,
		  "totalCountries": 35,
		  "totalStates": 37,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 980,
		  "schedulePercent": 0.484587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e1b2d5786b1ea26a88f8d707f4f5c75",
		  
		  "name": "maitrat",
		  "createdDate": "2018-10-16 11:47:10",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 119,
		  "totalCountries": 11,
		  "totalStates": 22,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Le Radiant",
		  "mostGuestCity": "Caluire-et-Cuire",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e2049d67793a0f9ea0418600a462ff6",
		  
		  "name": "Danielle",
		  "createdDate": "2022-05-29 15:59:05",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 54,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-03-04 00:00:00",
		  "mostGuestName": "The Eastern",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e23ffba384b040a5130d2b72ee9e4b9",
		  
		  "name": "CJ",
		  "createdDate": "2010-08-31 19:08:45",
		  "totalOrganizations": 29,
		  "totalTours": 8,
		  "totalDays": 363,
		  "totalCountries": 22,
		  "totalStates": 55,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 3247,
		  "schedulePercent": 0.863667,
		  "totalGuests": 1635,
		  "guestPercent": 0.922824,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Cardiff Utilita Arena",
		  "mostGuestCity": "Cardiff",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e24892319fd41d2137b71d13a7b6f92",
		  
		  "name": "William",
		  "createdDate": "2024-01-31 21:42:18",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 476,
		  "totalCountries": 21,
		  "totalStates": 62,
		  "totalEvents": 281,
		  "eventPercent": 0.898912,
		  "totalScheduleItems": 2257,
		  "schedulePercent": 0.75612,
		  "totalGuests": 784,
		  "guestPercent": 0.80417,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "CCH - Congress Center Hamburg - Saal 1",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 135,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e252d8fcae9fe00e4c2e7caad1da009",
		  
		  "name": "Taylor",
		  "createdDate": "2025-10-22 14:24:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 88,
		  "schedulePercent": 0.088282,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Cafe du Nord",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e2dfd61afad5b7160903798c02777ad",
		  
		  "name": "Toby ",
		  "createdDate": "2017-08-01 16:47:16",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 135,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1594,
		  "schedulePercent": 0.639393,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e2eecd9178f06d1689385409d51f29d",
		  
		  "name": "Cindy",
		  "createdDate": "2011-12-20 17:27:02",
		  "totalOrganizations": 5,
		  "totalTours": 17,
		  "totalDays": 827,
		  "totalCountries": 21,
		  "totalStates": 59,
		  "totalEvents": 245,
		  "eventPercent": 0.866047,
		  "totalScheduleItems": 2039,
		  "schedulePercent": 0.720648,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Coors Light Birds Nest",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e2f8a8d4aa9eca43905594f48a77cad",
		  
		  "name": "Aaryn",
		  "createdDate": "2021-09-01 03:03:15",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 200,
		  "totalCountries": 16,
		  "totalStates": 43,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1263,
		  "schedulePercent": 0.563803,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "Admiralspalast",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e339ad2377d50eaff88ab50075aed67",
		  
		  "name": "Ali",
		  "createdDate": "2022-09-02 08:23:37",
		  "totalOrganizations": 3,
		  "totalTours": 16,
		  "totalDays": 505,
		  "totalCountries": 18,
		  "totalStates": 64,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 2391,
		  "schedulePercent": 0.773912,
		  "totalGuests": 879,
		  "guestPercent": 0.824569,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e3b42e62f81d9827b40604a90059ac5",
		  
		  "name": "Michael",
		  "createdDate": "2015-06-14 19:51:53",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 62,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 209,
		  "schedulePercent": 0.165798,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e4ad6035a27e5c15667f0e4127d39d4",
		  
		  "name": "ADELA",
		  "createdDate": "2024-03-15 21:39:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 72,
		  "totalCountries": 10,
		  "totalStates": 22,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 275,
		  "schedulePercent": 0.202403,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e4fc1222a617429281e29b2b166da10",
		  
		  "name": "Christopher",
		  "createdDate": "2019-10-17 14:09:37",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 764,
		  "totalCountries": 12,
		  "totalStates": 62,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 2957,
		  "schedulePercent": 0.837715,
		  "totalGuests": 1292,
		  "guestPercent": 0.885199,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e562b85218ca564b6b200af396b73f5",
		  
		  "name": "Josh",
		  "createdDate": "2023-01-02 23:53:07",
		  "totalOrganizations": 5,
		  "totalTours": 14,
		  "totalDays": 1086,
		  "totalCountries": 16,
		  "totalStates": 64,
		  "totalEvents": 434,
		  "eventPercent": 0.967362,
		  "totalScheduleItems": 3342,
		  "schedulePercent": 0.87024,
		  "totalGuests": 602,
		  "guestPercent": 0.75884,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e6dfb34fa524ed86aff08005cdb8754",
		  
		  "name": "Charlie",
		  "createdDate": "2019-08-09 15:02:06",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 351,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1162,
		  "schedulePercent": 0.538531,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Baby's All Right",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e6ef5129b730201eee376abf330a701",
		  
		  "name": "Annick",
		  "createdDate": "2021-03-17 13:41:14",
		  "totalOrganizations": 22,
		  "totalTours": 52,
		  "totalDays": 489,
		  "totalCountries": 23,
		  "totalStates": 34,
		  "totalEvents": 248,
		  "eventPercent": 0.868654,
		  "totalScheduleItems": 2658,
		  "schedulePercent": 0.803377,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-03-16 00:00:00",
		  "mostGuestName": "ImpÃ©rial Bell",
		  "mostGuestCity": "QuÃ©bec",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e76c21dab84941d91c1977b269c584c",
		  
		  "name": "Ben",
		  "createdDate": "2023-08-27 20:34:39",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 113,
		  "totalCountries": 6,
		  "totalStates": 32,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1849,
		  "schedulePercent": 0.685743,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e9a64e6d19fbc20d31d45514b4001ca",
		  
		  "name": "Clayton",
		  "createdDate": "2025-01-16 04:46:54",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 65,
		  "totalCountries": 25,
		  "totalStates": 29,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 474,
		  "schedulePercent": 0.299977,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7e9ae4dcbb953251d89e72fc9add2c73",
		  
		  "name": "Derek",
		  "createdDate": "2024-03-04 20:54:13",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 6,
		  "totalStates": 23,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ebc8e8e2dbe581c1f0f1a435764c495",
		  
		  "name": "Sofia",
		  "createdDate": "2025-04-01 15:58:23",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 61,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 104,
		  "schedulePercent": 0.0999547,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Shoreline Waterfront",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ebf63905822b5b3a12fd989726c37fa",
		  
		  "name": "Produktion",
		  "createdDate": "2022-03-03 13:50:48",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 244,
		  "totalCountries": 8,
		  "totalStates": 19,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1899,
		  "schedulePercent": 0.694583,
		  "totalGuests": 2029,
		  "guestPercent": 0.949116,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Galopprennbahn KÃ¶ln-Weidenpesch",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ec5fc8801301bd3dc18ef52d4fb08ca",
		  
		  "name": "Thomas",
		  "createdDate": "2021-07-21 14:00:43",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 98,
		  "totalCountries": 6,
		  "totalStates": 14,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 624,
		  "schedulePercent": 0.358908,
		  "totalGuests": 478,
		  "guestPercent": 0.723255,
		  "mostGuestDate": "2025-03-09 00:00:00",
		  "mostGuestName": "Bord Gais Energy Theatre",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ee79c311db220ec9575a47dad737a7c",
		  
		  "name": "Nakia",
		  "createdDate": "2023-01-20 01:11:56",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 806,
		  "totalCountries": 19,
		  "totalStates": 71,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 3373,
		  "schedulePercent": 0.8733,
		  "totalGuests": 406,
		  "guestPercent": 0.69651,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Arena 8888 Sofia",
		  "mostGuestCity": "Sofia",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7eea04615447ee131d2e16675c0ae5b4",
		  
		  "name": "Scott",
		  "createdDate": "2022-03-06 00:43:23",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 277,
		  "totalCountries": 14,
		  "totalStates": 52,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1981,
		  "schedulePercent": 0.709769,
		  "totalGuests": 1357,
		  "guestPercent": 0.894492,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7eeda38acb05d488facc0f903717ae93",
		  
		  "name": "Maren",
		  "createdDate": "2024-06-10 14:48:50",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 129,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 1023,
		  "schedulePercent": 0.497393,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ef18d2eba2d3c7c053de5f89e90dfde",
		  
		  "name": "Christian",
		  "createdDate": "2021-11-11 02:30:11",
		  "totalOrganizations": 9,
		  "totalTours": 17,
		  "totalDays": 646,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1611,
		  "schedulePercent": 0.642339,
		  "totalGuests": 498,
		  "guestPercent": 0.729828,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f027eb5999be95d8856a20244406772",
		  
		  "name": "Sophie",
		  "createdDate": "2025-08-26 19:28:28",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 179,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 595,
		  "schedulePercent": 0.349501,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f05469817f2436e77f525321fedd1f8",
		  
		  "name": "Kolohe",
		  "createdDate": "2021-10-30 15:30:16",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 39,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 290,
		  "schedulePercent": 0.212149,
		  "totalGuests": 163,
		  "guestPercent": 0.568223,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Ventura Music Hall",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f09aace697da81934fc04e37690676f",
		  
		  "name": "Jenna",
		  "createdDate": "2010-02-05 23:00:34",
		  "totalOrganizations": 29,
		  "totalTours": 45,
		  "totalDays": 500,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 1625,
		  "schedulePercent": 0.645286,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Asheville Yards",
		  "mostGuestCity": "Asheville",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f16682fd3b6869f3321dfc677a93c84",
		  
		  "name": "Heiner",
		  "createdDate": "2025-03-25 01:16:30",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 281,
		  "totalCountries": 21,
		  "totalStates": 19,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 1096,
		  "schedulePercent": 0.518926,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f1d06f37a65e397b300e5c8a89ca3be",
		  
		  "name": "Now",
		  "createdDate": "2018-01-10 19:49:57",
		  "totalOrganizations": 12,
		  "totalTours": 2,
		  "totalDays": 379,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 1,
		  "eventPercent": 0.0074796,
		  "totalScheduleItems": 1484,
		  "schedulePercent": 0.614121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f34aed7cdce5119ac3ae8f2d3c8c753",
		  
		  "name": "Matthew",
		  "createdDate": "2016-09-03 04:00:06",
		  "totalOrganizations": 3,
		  "totalTours": 16,
		  "totalDays": 2197,
		  "totalCountries": 6,
		  "totalStates": 52,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 2824,
		  "schedulePercent": 0.825023,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Voodoo Lounge",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f4070c3e5c85a549e1913c2f789eb2a",
		  
		  "name": "Olie",
		  "createdDate": "2023-02-27 18:54:36",
		  "totalOrganizations": 24,
		  "totalTours": 27,
		  "totalDays": 5653,
		  "totalCountries": 43,
		  "totalStates": 96,
		  "totalEvents": 644,
		  "eventPercent": 0.989461,
		  "totalScheduleItems": 10955,
		  "schedulePercent": 0.99762,
		  "totalGuests": 2214,
		  "guestPercent": 0.958409,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f40bfd369a48e7185d14dc609a66f6c",
		  
		  "name": "Vi",
		  "createdDate": "2018-05-09 05:09:02",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 151,
		  "totalCountries": 19,
		  "totalStates": 42,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 720,
		  "schedulePercent": 0.394266,
		  "totalGuests": 183,
		  "guestPercent": 0.581482,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f4b9d8e73f7ca6468aa51e077c4c91f",
		  
		  "name": "Gabreanna",
		  "createdDate": "2022-09-07 20:20:14",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 686,
		  "totalCountries": 9,
		  "totalStates": 63,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 4758,
		  "schedulePercent": 0.94651,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-03-17 00:00:00",
		  "mostGuestName": "Houston Livestock Show and Rodeo",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f4d230f87ffca3021a29a268eeb09f9",
		  
		  "name": "Berkley",
		  "createdDate": "2015-03-12 18:06:00",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 904,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 4116,
		  "schedulePercent": 0.920104,
		  "totalGuests": 2472,
		  "guestPercent": 0.966795,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thompson Boling Arena",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f66bf2911cfe3fbf36392cb89a69225",
		  
		  "name": "Katie ",
		  "createdDate": "2024-04-09 16:43:12",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 245,
		  "totalCountries": 6,
		  "totalStates": 27,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1324,
		  "schedulePercent": 0.576609,
		  "totalGuests": 591,
		  "guestPercent": 0.755893,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f6c276f3c16614c14acc8f1f2542c79",
		  
		  "name": "Kara",
		  "createdDate": "2013-04-15 11:20:36",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 738,
		  "totalCountries": 25,
		  "totalStates": 71,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 3674,
		  "schedulePercent": 0.894492,
		  "totalGuests": 134,
		  "guestPercent": 0.548164,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "NOS Alive",
		  "mostGuestCity": "Alges",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f6ce1a17c3d67cafc3f116c514b3458",
		  
		  "name": "The Murder",
		  "createdDate": "2024-07-23 15:54:14",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 269,
		  "totalCountries": 22,
		  "totalStates": 31,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 675,
		  "schedulePercent": 0.376473,
		  "totalGuests": 225,
		  "guestPercent": 0.610041,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Iveagh Gardens",
		  "mostGuestCity": "Dublin 2",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f80e9930cdabe81b638656df7c49b4f",
		  
		  "name": "Kareem",
		  "createdDate": "2024-07-07 19:05:19",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 100,
		  "totalCountries": 12,
		  "totalStates": 26,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 72,
		  "schedulePercent": 0.0759293,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7f8d57015db6563a136401ce5e730f88",
		  
		  "name": "Bo ",
		  "createdDate": "2015-05-07 11:38:58",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 260,
		  "schedulePercent": 0.194923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fa1cf0c1c3336cf52b46a0edb6c0b7a",
		  
		  "name": "Kelly",
		  "createdDate": "2018-10-01 20:09:32",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 178,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 700,
		  "schedulePercent": 0.386786,
		  "totalGuests": 300,
		  "guestPercent": 0.649705,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wolf Trap National Park for the Performing Arts",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fb0aab7173ae3aeb1dd291a20bbf325",
		  
		  "name": "Keith",
		  "createdDate": "2009-09-04 07:58:03",
		  "totalOrganizations": 7,
		  "totalTours": 30,
		  "totalDays": 425,
		  "totalCountries": 32,
		  "totalStates": 56,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2604,
		  "schedulePercent": 0.797824,
		  "totalGuests": 789,
		  "guestPercent": 0.805417,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fb729f721a024d1d12da7b8d0b3eeaf",
		  
		  "name": "Phil",
		  "createdDate": "2024-06-22 22:51:39",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 388,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 582,
		  "schedulePercent": 0.344515,
		  "totalGuests": 528,
		  "guestPercent": 0.737987,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Hawaii Theatre",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 122,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fbfc3cb937f4476835495470628aa6b",
		  
		  "name": "Dean",
		  "createdDate": "2018-02-07 19:49:28",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 78,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fd0857f1d9ddb7628e6a4b92c8f65c9",
		  
		  "name": "Luis",
		  "createdDate": "2012-05-03 19:49:09",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 1413,
		  "totalCountries": 30,
		  "totalStates": 50,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2117,
		  "schedulePercent": 0.735041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fd4b7bfdad593d1db7eed7bff09ce8a",
		  
		  "name": "Franca",
		  "createdDate": "2022-01-20 14:12:07",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 668,
		  "totalCountries": 28,
		  "totalStates": 57,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 2046,
		  "schedulePercent": 0.722575,
		  "totalGuests": 135,
		  "guestPercent": 0.548844,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Movistar Arena",
		  "mostGuestCity": "BogotÃ¡",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fe227761990da20e1f163fe05f1d46e",
		  
		  "name": "Cath",
		  "createdDate": "2018-10-29 09:41:32",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 215,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1133,
		  "schedulePercent": 0.529238,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "The Palms",
		  "mostGuestCity": "Southbank",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fe42d06c64f44accf865d4ba1361bab",
		  
		  "name": "David",
		  "createdDate": "2025-03-19 20:18:44",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 346,
		  "totalCountries": 18,
		  "totalStates": 35,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1447,
		  "schedulePercent": 0.606754,
		  "totalGuests": 607,
		  "guestPercent": 0.760879,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Cal Coast Credit Union Amphitheater",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fe62b5507564d5f4c62195c56c23601",
		  
		  "name": "Pauline",
		  "createdDate": "2023-12-29 10:19:05",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 157,
		  "totalCountries": 6,
		  "totalStates": 19,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1045,
		  "schedulePercent": 0.502493,
		  "totalGuests": 887,
		  "guestPercent": 0.827176,
		  "mostGuestDate": "2025-03-12 00:00:00",
		  "mostGuestName": "Halle Tony Garnier",
		  "mostGuestCity": "Lyon",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ff86ada0b556c1f7a6da5e2f80440fe",
		  
		  "name": "Lizzie",
		  "createdDate": "2016-03-11 00:18:15",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 357,
		  "totalCountries": 25,
		  "totalStates": 15,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 370,
		  "schedulePercent": 0.253173,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ffba0d4d3e328bff38652aa3fb1611f",
		  
		  "name": "Rebecca ",
		  "createdDate": "2024-04-10 16:16:36",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 148,
		  "totalCountries": 12,
		  "totalStates": 9,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 375,
		  "schedulePercent": 0.25544,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7ffbc8861566ba8a4e940e9c072a3f78",
		  
		  "name": "Miredys",
		  "createdDate": "2017-09-21 23:25:49",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 219,
		  "totalCountries": 14,
		  "totalStates": 25,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 75,
		  "schedulePercent": 0.0784225,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "7fff47a8ac0ef8a06a39cc6b6ac3f075",
		  
		  "name": "Anna-Liisa",
		  "createdDate": "2023-12-12 13:45:02",
		  "totalOrganizations": 34,
		  "totalTours": 60,
		  "totalDays": 1171,
		  "totalCountries": 4,
		  "totalStates": 137,
		  "totalEvents": 1086,
		  "eventPercent": 0.996374,
		  "totalScheduleItems": 4727,
		  "schedulePercent": 0.945603,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "Backaksen kesÃ¤keikat",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8000732990061e427fe2c0806118dc2e",
		  
		  "name": "Jon",
		  "createdDate": "2014-08-19 21:18:30",
		  "totalOrganizations": 9,
		  "totalTours": 16,
		  "totalDays": 648,
		  "totalCountries": 26,
		  "totalStates": 61,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 3159,
		  "schedulePercent": 0.856301,
		  "totalGuests": 1774,
		  "guestPercent": 0.93189,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "801f9262ad36cda7d5199bf937641926",
		  
		  "name": "HUGH",
		  "createdDate": "2011-06-23 10:22:15",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 110,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 339,
		  "schedulePercent": 0.237874,
		  "totalGuests": 34,
		  "guestPercent": 0.426677,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "HOTA, Home of the Arts",
		  "mostGuestCity": "Surfers Paradise",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80201cb5b8e771dd1bcb273a1265426a",
		  
		  "name": "Dennis",
		  "createdDate": "2015-05-27 13:53:30",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 1085,
		  "totalCountries": 16,
		  "totalStates": 63,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 3977,
		  "schedulePercent": 0.912058,
		  "totalGuests": 939,
		  "guestPercent": 0.837149,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Grand Sierra Theater",
		  "mostGuestCity": "Reno",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80231f28f227b553a44bdcdd4764e3b7",
		  
		  "name": "Dominick",
		  "createdDate": "2015-10-11 03:11:03",
		  "totalOrganizations": 5,
		  "totalTours": 20,
		  "totalDays": 142,
		  "totalCountries": 9,
		  "totalStates": 41,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 1303,
		  "schedulePercent": 0.571963,
		  "totalGuests": 600,
		  "guestPercent": 0.757933,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "802394d17d7f176ae0ca8ad13b1032c7",
		  
		  "name": "James",
		  "createdDate": "2021-05-20 14:19:02",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 1053,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 3540,
		  "schedulePercent": 0.884293,
		  "totalGuests": 1875,
		  "guestPercent": 0.937897,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "802fc7cc397bd2ca21d396f158931ce6",
		  
		  "name": "Brent",
		  "createdDate": "2013-09-13 16:16:08",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 313,
		  "totalCountries": 9,
		  "totalStates": 55,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1615,
		  "schedulePercent": 0.643019,
		  "totalGuests": 1632,
		  "guestPercent": 0.922484,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 280,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "803292e23ca481103d4692f196010834",
		  
		  "name": "Chrystal",
		  "createdDate": "2025-04-11 01:25:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 228,
		  "totalCountries": 12,
		  "totalStates": 27,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 146,
		  "schedulePercent": 0.128173,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80333b7bb9dcf4189373c854bd0d551c",
		  
		  "name": "Kurt",
		  "createdDate": "2016-05-22 23:01:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 509,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1218,
		  "schedulePercent": 0.551224,
		  "totalGuests": 223,
		  "guestPercent": 0.608568,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "First Horizon Coliseum",
		  "mostGuestCity": "Greensboro",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "805201629888bc1636bfda83203cb78b",
		  
		  "name": "Florian",
		  "createdDate": "2023-09-06 13:35:08",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 94,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 809,
		  "schedulePercent": 0.426337,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "805680e854695639f4dacbf548cd7a3f",
		  
		  "name": "Adit ",
		  "createdDate": "2021-03-21 23:17:39",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 86,
		  "totalCountries": 7,
		  "totalStates": 10,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 224,
		  "schedulePercent": 0.173844,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80584bd6de56a961cd0113e60c5020a6",
		  
		  "name": "Lisa",
		  "createdDate": "2022-06-28 19:18:54",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 243,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1861,
		  "schedulePercent": 0.687103,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80597c9a2ce48c1728e6e5c9c81952cd",
		  
		  "name": "Emily",
		  "createdDate": "2022-01-06 23:44:41",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 592,
		  "totalCountries": 11,
		  "totalStates": 53,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 3644,
		  "schedulePercent": 0.891886,
		  "totalGuests": 1597,
		  "guestPercent": 0.919878,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Grand Sierra Theater",
		  "mostGuestCity": "Reno",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "805fa1f5963f6f29d94f0bcfc83fe370",
		  
		  "name": "marie",
		  "createdDate": "2022-02-28 21:47:40",
		  "totalOrganizations": 34,
		  "totalTours": 18,
		  "totalDays": 588,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 1221,
		  "schedulePercent": 0.552924,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Horseshoe Tavern",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8062b25d9b820e21ca458077fe90a112",
		  
		  "name": "Modern",
		  "createdDate": "2021-12-07 16:40:42",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 119,
		  "totalCountries": 10,
		  "totalStates": 45,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 941,
		  "schedulePercent": 0.472575,
		  "totalGuests": 354,
		  "guestPercent": 0.676451,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "The Observatory North Park",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8069b2d466e687bde1efb513a4c8e11d",
		  
		  "name": "Florencia ",
		  "createdDate": "2025-03-18 00:18:05",
		  "totalOrganizations": 1,
		  "totalTours": 32,
		  "totalDays": 143,
		  "totalCountries": 13,
		  "totalStates": 31,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 876,
		  "schedulePercent": 0.449683,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8097bb60ca4c8ae9c6c14be88dcaee16",
		  
		  "name": "Craig",
		  "createdDate": "2023-07-18 19:00:39",
		  "totalOrganizations": 46,
		  "totalTours": 37,
		  "totalDays": 1083,
		  "totalCountries": 46,
		  "totalStates": 101,
		  "totalEvents": 489,
		  "eventPercent": 0.977448,
		  "totalScheduleItems": 6205,
		  "schedulePercent": 0.978355,
		  "totalGuests": 2178,
		  "guestPercent": 0.956936,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "809eab66981bb6d496f02205185d9add",
		  
		  "name": "Bridget",
		  "createdDate": "2025-04-08 11:04:47",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 28,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 375,
		  "schedulePercent": 0.25544,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80a006070bcfaf3d98d83c028d55cd74",
		  
		  "name": "Marco",
		  "createdDate": "2024-03-18 11:48:48",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 187,
		  "totalCountries": 23,
		  "totalStates": 59,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1161,
		  "schedulePercent": 0.537965,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "X-tra",
		  "mostGuestCity": "Zurich",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80ad80b0163cd9929e055ad6502afbc2",
		  
		  "name": "Celine",
		  "createdDate": "2022-09-19 14:07:05",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 77,
		  "totalCountries": 21,
		  "totalStates": 11,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 400,
		  "schedulePercent": 0.269379,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80b5bc862d2862e5a49a6197fe303b4a",
		  
		  "name": "Jay",
		  "createdDate": "2014-04-03 19:51:24",
		  "totalOrganizations": 13,
		  "totalTours": 17,
		  "totalDays": 2095,
		  "totalCountries": 36,
		  "totalStates": 91,
		  "totalEvents": 292,
		  "eventPercent": 0.907185,
		  "totalScheduleItems": 4372,
		  "schedulePercent": 0.933817,
		  "totalGuests": 803,
		  "guestPercent": 0.808137,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80c5a66033090de29649f996fe1fac8f",
		  
		  "name": "Ronald ",
		  "createdDate": "2016-06-15 04:04:05",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 4,
		  "totalStates": 22,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 578,
		  "schedulePercent": 0.342702,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "State Farm Arena",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80c654eab7ca717deab9b9be064b3f09",
		  
		  "name": "Andy",
		  "createdDate": "2023-05-10 12:14:22",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 1389,
		  "totalCountries": 22,
		  "totalStates": 65,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 2772,
		  "schedulePercent": 0.818563,
		  "totalGuests": 217,
		  "guestPercent": 0.606528,
		  "mostGuestDate": "2025-06-02 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80d6b72aeaafbec88f12183185a9f68a",
		  
		  "name": "Nate",
		  "createdDate": "2014-01-30 17:17:14",
		  "totalOrganizations": 4,
		  "totalTours": 15,
		  "totalDays": 452,
		  "totalCountries": 21,
		  "totalStates": 51,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2709,
		  "schedulePercent": 0.80995,
		  "totalGuests": 1575,
		  "guestPercent": 0.917044,
		  "mostGuestDate": "2025-07-16 00:00:00",
		  "mostGuestName": "The Criterion",
		  "mostGuestCity": "Oklahoma City",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80e1507af17f0c3e90acb75f5a80d6f1",
		  
		  "name": "Toshiko",
		  "createdDate": "2016-09-30 15:05:08",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 606,
		  "totalCountries": 11,
		  "totalStates": 42,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 2021,
		  "schedulePercent": 0.717475,
		  "totalGuests": 1596,
		  "guestPercent": 0.919311,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Ravinia",
		  "mostGuestCity": "Highland Park",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80f5c75a481e48da5f31f0fcbca5666e",
		  
		  "name": "Kelly",
		  "createdDate": "2013-09-26 16:18:30",
		  "totalOrganizations": 22,
		  "totalTours": 22,
		  "totalDays": 876,
		  "totalCountries": 24,
		  "totalStates": 63,
		  "totalEvents": 328,
		  "eventPercent": 0.932004,
		  "totalScheduleItems": 4130,
		  "schedulePercent": 0.920898,
		  "totalGuests": 1220,
		  "guestPercent": 0.877833,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Magazine London",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80f8d3e9af45ab6ab481160ee01506e0",
		  
		  "name": "Jonie",
		  "createdDate": "2013-03-20 18:32:34",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 76,
		  "totalCountries": 13,
		  "totalStates": 30,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 730,
		  "schedulePercent": 0.397892,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "80f90507b1d6a8693bf527c2e45c2109",
		  
		  "name": "Tom",
		  "createdDate": "2013-10-09 18:51:19",
		  "totalOrganizations": 18,
		  "totalTours": 7,
		  "totalDays": 666,
		  "totalCountries": 12,
		  "totalStates": 33,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1122,
		  "schedulePercent": 0.525499,
		  "totalGuests": 894,
		  "guestPercent": 0.828309,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Movistar Arena Madrid",
		  "mostGuestCity": "Madrid",
		  "mostGuestAmount": 148,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8101b1c2f8c9d2fc56eedaf0d064643e",
		  
		  "name": "Nick",
		  "createdDate": "2018-07-13 08:04:46",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 449,
		  "totalCountries": 28,
		  "totalStates": 30,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1453,
		  "schedulePercent": 0.608114,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81027e2c12978b036387081beee9f046",
		  
		  "name": "James",
		  "createdDate": "2018-05-31 14:46:49",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 189,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1498,
		  "schedulePercent": 0.617747,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Chandler Center For The Arts",
		  "mostGuestCity": "Chandler",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8102f47d9b7d3c5d97d05ae514a284d4",
		  
		  "name": "Elena",
		  "createdDate": "2022-03-26 15:47:43",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 504,
		  "totalCountries": 13,
		  "totalStates": 40,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1997,
		  "schedulePercent": 0.713169,
		  "totalGuests": 1140,
		  "guestPercent": 0.87058,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "810ae7dde60390c78072525351286d7a",
		  
		  "name": "Narelle ",
		  "createdDate": "2024-06-20 05:52:57",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 344,
		  "schedulePercent": 0.240254,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Young Showground Camping",
		  "mostGuestCity": "Young",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "810c081af301401250541370b0c90bf8",
		  
		  "name": "Mary",
		  "createdDate": "2017-04-15 19:38:19",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 94,
		  "totalCountries": 5,
		  "totalStates": 29,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 548,
		  "schedulePercent": 0.333522,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81247b0b5520c3411ffed52e9775f3b1",
		  
		  "name": "True Artist",
		  "createdDate": "2015-04-22 22:15:23",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 692,
		  "totalCountries": 12,
		  "totalStates": 51,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 2933,
		  "schedulePercent": 0.834995,
		  "totalGuests": 2917,
		  "guestPercent": 0.980394,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "813485729e289c517957b5cd4e2a6c5c",
		  
		  "name": "Zack",
		  "createdDate": "2024-07-02 02:51:24",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 329,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1121,
		  "schedulePercent": 0.525385,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "The Windjammer",
		  "mostGuestCity": "Isle of Palms",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8138f87aacb0044dbe45049635371266",
		  
		  "name": "Ia",
		  "createdDate": "2014-04-08 18:23:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 10,
		  "totalStates": 25,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 761,
		  "schedulePercent": 0.409338,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Lehman Center for the Performing Arts",
		  "mostGuestCity": "Bronx",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8152588561d245bfbe0e75ac5fbcab0a",
		  
		  "name": "Jenny",
		  "createdDate": "2025-03-17 17:35:42",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 84,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 497,
		  "schedulePercent": 0.310857,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Arts Garage",
		  "mostGuestCity": "Delray Beach",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8157ba12d4222c913adb4578b34be10e",
		  
		  "name": "Hannah",
		  "createdDate": "2022-05-11 13:58:49",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 927,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 2806,
		  "schedulePercent": 0.823209,
		  "totalGuests": 958,
		  "guestPercent": 0.840322,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "815b9ccd47ab7ff1195a04693768915b",
		  
		  "name": "Aaron",
		  "createdDate": "2016-07-08 13:29:36",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 743,
		  "totalCountries": 15,
		  "totalStates": 51,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2738,
		  "schedulePercent": 0.814597,
		  "totalGuests": 1006,
		  "guestPercent": 0.847688,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "816ba7d2f08d5d99b1e16a506f2ff3b2",
		  
		  "name": "Graham",
		  "createdDate": "2024-11-20 05:41:49",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 204,
		  "totalCountries": 13,
		  "totalStates": 17,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 837,
		  "schedulePercent": 0.436423,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8177c57c397c76aabae2d59008934776",
		  
		  "name": "atorina",
		  "createdDate": "2024-09-06 21:37:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 135,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 366,
		  "schedulePercent": 0.25136,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "817a58702a1cfa53e7f25fcb3ec621ff",
		  
		  "name": "Anders",
		  "createdDate": "2012-03-26 12:17:50",
		  "totalOrganizations": 19,
		  "totalTours": 11,
		  "totalDays": 393,
		  "totalCountries": 22,
		  "totalStates": 26,
		  "totalEvents": 269,
		  "eventPercent": 0.889393,
		  "totalScheduleItems": 2426,
		  "schedulePercent": 0.778105,
		  "totalGuests": 834,
		  "guestPercent": 0.81607,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Store Vega",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81812921c1e212bff6f51ffc2c35357e",
		  
		  "name": "Jadon",
		  "createdDate": "2021-10-05 20:25:10",
		  "totalOrganizations": 18,
		  "totalTours": 77,
		  "totalDays": 2545,
		  "totalCountries": 9,
		  "totalStates": 64,
		  "totalEvents": 346,
		  "eventPercent": 0.940503,
		  "totalScheduleItems": 5896,
		  "schedulePercent": 0.974388,
		  "totalGuests": 689,
		  "guestPercent": 0.783432,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Yuengling Center",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8186e013b7c44e3091263c9378634582",
		  
		  "name": "Tristan",
		  "createdDate": "2022-06-24 20:10:21",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 819,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1545,
		  "schedulePercent": 0.62636,
		  "totalGuests": 2226,
		  "guestPercent": 0.958975,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81885ae81534a549681530acb21f74c7",
		  
		  "name": "Jess",
		  "createdDate": "2017-07-15 16:16:27",
		  "totalOrganizations": 17,
		  "totalTours": 12,
		  "totalDays": 588,
		  "totalCountries": 17,
		  "totalStates": 59,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2551,
		  "schedulePercent": 0.792838,
		  "totalGuests": 698,
		  "guestPercent": 0.785018,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "818d432e412833c98f7a4622ce4f00ec",
		  
		  "name": "Mikko",
		  "createdDate": "2010-10-14 06:33:43",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 135,
		  "totalCountries": 24,
		  "totalStates": 20,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 908,
		  "schedulePercent": 0.461015,
		  "totalGuests": 308,
		  "guestPercent": 0.653105,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Tavastia Club",
		  "mostGuestCity": "Helsingfors",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81b018274eb24c8b681fb5f5563026bb",
		  
		  "name": "Elle",
		  "createdDate": "2017-06-09 17:39:38",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 632,
		  "totalCountries": 14,
		  "totalStates": 40,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1539,
		  "schedulePercent": 0.625113,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Rawhide",
		  "mostGuestCity": "Chandler",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81b48bcefba663b2cc732ee81973bab8",
		  
		  "name": "Chris",
		  "createdDate": "2025-01-22 19:52:25",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 210,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1621,
		  "schedulePercent": 0.644719,
		  "totalGuests": 836,
		  "guestPercent": 0.816863,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Hard Rock Live at Etess Arena",
		  "mostGuestCity": "Atlantic City",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81bb100eb5367fe8e58bbfa6ecc16f0e",
		  
		  "name": "Derek",
		  "createdDate": "2025-04-07 13:18:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 267,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 207,
		  "schedulePercent": 0.164438,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81bc4c7026b899226fda6cc47fb61822",
		  
		  "name": "KSA",
		  "createdDate": "2024-08-15 11:25:03",
		  "totalOrganizations": 15,
		  "totalTours": 46,
		  "totalDays": 763,
		  "totalCountries": 10,
		  "totalStates": 2,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 114,
		  "schedulePercent": 0.107774,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81bfd0cbb0a9f0f35b8b8b6142e42b1e",
		  
		  "name": "Max",
		  "createdDate": "2022-08-10 18:04:48",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 393,
		  "totalCountries": 25,
		  "totalStates": 50,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 2603,
		  "schedulePercent": 0.797711,
		  "totalGuests": 1158,
		  "guestPercent": 0.871827,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81c3bc8704af1ce105e9f20a2ec57e87",
		  
		  "name": "Will",
		  "createdDate": "2023-08-08 18:25:33",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 65,
		  "totalCountries": 5,
		  "totalStates": 26,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 463,
		  "schedulePercent": 0.296124,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre Beanfield",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81e3905d7914417db85a3f399831010a",
		  
		  "name": "TRACI",
		  "createdDate": "2020-01-20 23:43:54",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 502,
		  "schedulePercent": 0.312783,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "81ef3daf1362739923bac1c1d5a60f11",
		  
		  "name": "Kris",
		  "createdDate": "2013-08-15 18:00:31",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 576,
		  "totalCountries": 19,
		  "totalStates": 70,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 2175,
		  "schedulePercent": 0.744107,
		  "totalGuests": 460,
		  "guestPercent": 0.715775,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Bruce Mason Centre",
		  "mostGuestCity": "Takapuna Beach",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8202efd7f9f1118df5976506afafeb1e",
		  
		  "name": "Matt",
		  "createdDate": "2023-10-27 13:32:57",
		  "totalOrganizations": 1,
		  "totalTours": 27,
		  "totalDays": 129,
		  "totalCountries": 1,
		  "totalStates": 18,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 753,
		  "schedulePercent": 0.406505,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82038608b0e779142277f4e8702da8c9",
		  
		  "name": "Joshua ",
		  "createdDate": "2017-01-06 14:13:22",
		  "totalOrganizations": 18,
		  "totalTours": 16,
		  "totalDays": 1011,
		  "totalCountries": 52,
		  "totalStates": 68,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 3801,
		  "schedulePercent": 0.902879,
		  "totalGuests": 450,
		  "guestPercent": 0.712489,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "820458f0bb285901b7fa306763e8bea2",
		  
		  "name": "Siobhan",
		  "createdDate": "2025-04-28 03:33:40",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 51,
		  "totalCountries": 13,
		  "totalStates": 12,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 216,
		  "schedulePercent": 0.169538,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8208fa0956fe6b5a3718a586b044935a",
		  
		  "name": "Aaron",
		  "createdDate": "2021-07-20 18:33:28",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 493,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 2094,
		  "schedulePercent": 0.731754,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Decca Live",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82130ce3b3fb12e6a9af3153c74b4812",
		  
		  "name": "Sven",
		  "createdDate": "2024-01-24 15:20:48",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 330,
		  "totalCountries": 14,
		  "totalStates": 20,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1239,
		  "schedulePercent": 0.557004,
		  "totalGuests": 93,
		  "guestPercent": 0.511786,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Hurricane Festival",
		  "mostGuestCity": "ScheeÃŸel",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "821c392726955647611f9a408aa66e08",
		  
		  "name": "David",
		  "createdDate": "2023-01-05 02:27:46",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 424,
		  "totalCountries": 20,
		  "totalStates": 38,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1953,
		  "schedulePercent": 0.703876,
		  "totalGuests": 1141,
		  "guestPercent": 0.870694,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Cal Coast Credit Union Amphitheater",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "821d2f5678cf3bc204b702000c27cbb9",
		  
		  "name": "Lee",
		  "createdDate": "2016-12-27 02:32:52",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 1101,
		  "totalCountries": 6,
		  "totalStates": 56,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 5310,
		  "schedulePercent": 0.962602,
		  "totalGuests": 1423,
		  "guestPercent": 0.902765,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82208117b00f7a3e68deede738d2d884",
		  
		  "name": "Nick",
		  "createdDate": "2019-10-24 16:22:18",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 269,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 544,
		  "schedulePercent": 0.331709,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "The District",
		  "mostGuestCity": "Sioux Falls",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8220cae838e6ddf42838a5d71c4b3491",
		  
		  "name": "Jack",
		  "createdDate": "2010-03-01 23:03:23",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 915,
		  "totalCountries": 26,
		  "totalStates": 83,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 3911,
		  "schedulePercent": 0.909338,
		  "totalGuests": 870,
		  "guestPercent": 0.822983,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "822206dbef5831bbabf2fe33990e0360",
		  
		  "name": "Tim",
		  "createdDate": "2023-02-20 18:32:12",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 120,
		  "totalCountries": 7,
		  "totalStates": 26,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 591,
		  "schedulePercent": 0.347915,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Sam's Town Point",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "823c99a816329916dd2d7cfc9fce6806",
		  
		  "name": "Chloe",
		  "createdDate": "2025-09-04 09:22:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 118,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 2,
		  "schedulePercent": 0.0105394,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82622aad66bc375b21f842d4e21c4c3b",
		  
		  "name": "Kristin",
		  "createdDate": "2016-06-04 03:02:16",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 936,
		  "totalCountries": 27,
		  "totalStates": 45,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 4718,
		  "schedulePercent": 0.94515,
		  "totalGuests": 648,
		  "guestPercent": 0.771079,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Bethel Woods Center",
		  "mostGuestCity": "Bethel",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8269b7a14fed8e6deeb1bbda32656d5e",
		  
		  "name": "Tim",
		  "createdDate": "2023-07-10 19:26:44",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 714,
		  "totalCountries": 7,
		  "totalStates": 30,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 171,
		  "schedulePercent": 0.141319,
		  "totalGuests": 236,
		  "guestPercent": 0.6165,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8297b3bcaf374c9cacd1ea3367247011",
		  
		  "name": "Jason",
		  "createdDate": "2011-08-10 17:45:50",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 85,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 107,
		  "schedulePercent": 0.102675,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Coppell Arts Center",
		  "mostGuestCity": "Coppell",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82a290c0325871ab2259b62308e77017",
		  
		  "name": "Karen",
		  "createdDate": "2021-09-19 15:11:31",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 171,
		  "totalCountries": 17,
		  "totalStates": 19,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 325,
		  "schedulePercent": 0.229034,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "The Cosmopolitan of Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82ae9cdff3c81de9adfa80e28e8b3f13",
		  
		  "name": "Calvin",
		  "createdDate": "2024-08-10 16:59:02",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 445,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 3449,
		  "schedulePercent": 0.878626,
		  "totalGuests": 825,
		  "guestPercent": 0.813803,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Credit Union 1 Amphitheatre",
		  "mostGuestCity": "Tinley Park",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82baf9801328c146f5c6102915ab4fcf",
		  
		  "name": "Hanna",
		  "createdDate": "2013-06-11 09:30:18",
		  "totalOrganizations": 10,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 5,
		  "totalStates": 14,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 208,
		  "schedulePercent": 0.165005,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82cb696736a42527923368397baf4bb6",
		  
		  "name": "Lina",
		  "createdDate": "2024-08-13 11:55:41",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 128,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 335,
		  "schedulePercent": 0.234021,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82d5ffc73e56d849c06d94e4ae79eaae",
		  
		  "name": "Emma",
		  "createdDate": "2025-05-24 00:34:01",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 128,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 859,
		  "schedulePercent": 0.444243,
		  "totalGuests": 261,
		  "guestPercent": 0.6301,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Royale",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82d756a64b0def0f1826a669d88266c2",
		  
		  "name": "Stephen",
		  "createdDate": "2021-09-22 04:34:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 134,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82d75a8e9495fdb5b49fca694ab1728e",
		  
		  "name": "Royal",
		  "createdDate": "2019-08-29 22:51:24",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 393,
		  "totalCountries": 24,
		  "totalStates": 26,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 1015,
		  "schedulePercent": 0.494674,
		  "totalGuests": 499,
		  "guestPercent": 0.730168,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Nissan Stadium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82dd2cdaec8c8f20a7e626159d9de985",
		  
		  "name": "Meredith",
		  "createdDate": "2022-04-22 17:33:13",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 294,
		  "totalCountries": 11,
		  "totalStates": 45,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1035,
		  "schedulePercent": 0.500227,
		  "totalGuests": 113,
		  "guestPercent": 0.530598,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "The Dome",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82e27f0f6bc92ce1cffdc2dd51c1bb3f",
		  
		  "name": "Raymond",
		  "createdDate": "2017-07-12 15:34:19",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 544,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1335,
		  "schedulePercent": 0.581936,
		  "totalGuests": 1596,
		  "guestPercent": 0.919311,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Ravinia",
		  "mostGuestCity": "Highland Park",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "82e740d93ced3a700fbae822dc68cb1c",
		  
		  "name": "Rivers",
		  "createdDate": "2022-06-26 13:03:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 21,
		  "totalStates": 37,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1245,
		  "schedulePercent": 0.55927,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "douglass park",
		  "mostGuestCity": "",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "830fada7bf1c86c9748766885cb9ba7f",
		  
		  "name": "Scott ",
		  "createdDate": "2024-07-02 05:18:20",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 107,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 417,
		  "schedulePercent": 0.276972,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Pearl Concert Theater",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8311f782f5ed169fa2d37348c1fe7c96",
		  
		  "name": "LESA",
		  "createdDate": "2024-07-15 22:02:14",
		  "totalOrganizations": 2,
		  "totalTours": 13,
		  "totalDays": 276,
		  "totalCountries": 11,
		  "totalStates": 29,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1265,
		  "schedulePercent": 0.564597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8313f44320f89fa14b98249144972060",
		  
		  "name": "Maureen",
		  "createdDate": "2024-02-10 18:58:58",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 6,
		  "totalStates": 26,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 360,
		  "schedulePercent": 0.248187,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83190fe8965b33c03093223522e88f3e",
		  
		  "name": "Ylva",
		  "createdDate": "2024-10-17 08:36:11",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 176,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 607,
		  "schedulePercent": 0.353581,
		  "totalGuests": 180,
		  "guestPercent": 0.580009,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Cosmopolite Scene",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "832f087b95900666298a33bbf9cd51cc",
		  
		  "name": "Keith",
		  "createdDate": "2019-01-14 19:45:44",
		  "totalOrganizations": 16,
		  "totalTours": 8,
		  "totalDays": 344,
		  "totalCountries": 17,
		  "totalStates": 42,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 908,
		  "schedulePercent": 0.461015,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "United Center",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83335b38187400306f17d05d53ec63c9",
		  
		  "name": "Chantal",
		  "createdDate": "2025-02-05 04:15:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 181,
		  "schedulePercent": 0.147212,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8334aae6ac6975085262033454be1861",
		  
		  "name": "Joey",
		  "createdDate": "2014-09-02 06:35:56",
		  "totalOrganizations": 21,
		  "totalTours": 3,
		  "totalDays": 866,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1229,
		  "schedulePercent": 0.554284,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Irvine Barclay Theater",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "833ce228ae03cfd6058aef6ab9532290",
		  
		  "name": "Julius",
		  "createdDate": "2017-04-27 02:09:31",
		  "totalOrganizations": 15,
		  "totalTours": 12,
		  "totalDays": 413,
		  "totalCountries": 24,
		  "totalStates": 52,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 3107,
		  "schedulePercent": 0.852335,
		  "totalGuests": 874,
		  "guestPercent": 0.823776,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Colosseum Theater at Caesars Palace",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "833f453d2ebdcb00feb7fda0d641d1b5",
		  
		  "name": "Hayley",
		  "createdDate": "2022-09-15 15:23:27",
		  "totalOrganizations": 31,
		  "totalTours": 37,
		  "totalDays": 5536,
		  "totalCountries": 24,
		  "totalStates": 91,
		  "totalEvents": 1079,
		  "eventPercent": 0.996147,
		  "totalScheduleItems": 21866,
		  "schedulePercent": 0.999433,
		  "totalGuests": 9335,
		  "guestPercent": 0.99932,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 190,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "833fed8aeefaac2203518cace799abf1",
		  
		  "name": "Dayne",
		  "createdDate": "2023-09-26 00:02:19",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 332,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 395,
		  "schedulePercent": 0.266772,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "The Paramount",
		  "mostGuestCity": "Huntington",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8343ed88cec12c121a2a3d9544b30de8",
		  
		  "name": "Doug",
		  "createdDate": "2025-02-20 18:17:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 388,
		  "schedulePercent": 0.263486,
		  "totalGuests": 326,
		  "guestPercent": 0.664211,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Beacham",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "834704ddc84cccfdd596c8a485aa433a",
		  
		  "name": "Paul ",
		  "createdDate": "2016-05-29 13:30:15",
		  "totalOrganizations": 39,
		  "totalTours": 18,
		  "totalDays": 1772,
		  "totalCountries": 17,
		  "totalStates": 30,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 1655,
		  "schedulePercent": 0.651065,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Albert Hall",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8348d4116f044e34b042b484e0c18ee7",
		  
		  "name": "William",
		  "createdDate": "2019-04-22 17:28:26",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 381,
		  "totalCountries": 23,
		  "totalStates": 29,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1424,
		  "schedulePercent": 0.603355,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "834ac17a276b256c83bf33898799846a",
		  
		  "name": "Mark",
		  "createdDate": "2015-12-07 17:37:22",
		  "totalOrganizations": 14,
		  "totalTours": 10,
		  "totalDays": 899,
		  "totalCountries": 24,
		  "totalStates": 60,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 3416,
		  "schedulePercent": 0.876927,
		  "totalGuests": 636,
		  "guestPercent": 0.767226,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83549460f572f1231ef2257721375ec7",
		  
		  "name": "James",
		  "createdDate": "2016-03-22 19:26:37",
		  "totalOrganizations": 22,
		  "totalTours": 8,
		  "totalDays": 469,
		  "totalCountries": 24,
		  "totalStates": 98,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 2741,
		  "schedulePercent": 0.81505,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Desert Diamond Arena",
		  "mostGuestCity": "Glendale",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8366829d532c3601f91b3f56f1891cfb",
		  
		  "name": "Alan",
		  "createdDate": "2011-11-01 21:33:41",
		  "totalOrganizations": 42,
		  "totalTours": 38,
		  "totalDays": 1021,
		  "totalCountries": 54,
		  "totalStates": 113,
		  "totalEvents": 447,
		  "eventPercent": 0.970422,
		  "totalScheduleItems": 4860,
		  "schedulePercent": 0.949796,
		  "totalGuests": 1580,
		  "guestPercent": 0.917724,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83694bdd62ba523654ee4c2406d801d7",
		  
		  "name": "Chris",
		  "createdDate": "2023-02-01 22:47:54",
		  "totalOrganizations": 14,
		  "totalTours": 21,
		  "totalDays": 732,
		  "totalCountries": 20,
		  "totalStates": 52,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 1806,
		  "schedulePercent": 0.677017,
		  "totalGuests": 682,
		  "guestPercent": 0.781505,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 136,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "836ce7e7839c9e658350e435ab8ef2fe",
		  
		  "name": "Nate",
		  "createdDate": "2014-10-17 03:19:53",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 703,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 2309,
		  "schedulePercent": 0.763033,
		  "totalGuests": 1355,
		  "guestPercent": 0.893812,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Surly Brewing Co.",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83727c57ecae1739fe7f959bdaa561b5",
		  
		  "name": "Paul",
		  "createdDate": "2018-02-28 22:14:21",
		  "totalOrganizations": 6,
		  "totalTours": 15,
		  "totalDays": 304,
		  "totalCountries": 12,
		  "totalStates": 38,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 729,
		  "schedulePercent": 0.397665,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Salt Shed",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "837ae614dd6937924f751a8b93c643bf",
		  
		  "name": "JT",
		  "createdDate": "2019-08-15 18:48:06",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 418,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2136,
		  "schedulePercent": 0.737761,
		  "totalGuests": 221,
		  "guestPercent": 0.607774,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "837f25e73d14003421b4e19c2a126e57",
		  
		  "name": "Alex",
		  "createdDate": "2025-09-18 16:52:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 123,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 664,
		  "schedulePercent": 0.373073,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "838b46326f0fe54e8d4073c0ab97604d",
		  
		  "name": "Tobias",
		  "createdDate": "2016-01-23 14:53:23",
		  "totalOrganizations": 25,
		  "totalTours": 11,
		  "totalDays": 335,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 1480,
		  "schedulePercent": 0.612647,
		  "totalGuests": 233,
		  "guestPercent": 0.614234,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "GrÃ¶na Lund",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "838d581ce011e74ad70279f1303b89cd",
		  
		  "name": "Michael",
		  "createdDate": "2021-06-05 20:57:15",
		  "totalOrganizations": 24,
		  "totalTours": 48,
		  "totalDays": 1299,
		  "totalCountries": 29,
		  "totalStates": 86,
		  "totalEvents": 587,
		  "eventPercent": 0.986854,
		  "totalScheduleItems": 6604,
		  "schedulePercent": 0.983228,
		  "totalGuests": 2052,
		  "guestPercent": 0.950703,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "839fa62b3fdb84ab57a127dae36df0b1",
		  
		  "name": "D-A-D",
		  "createdDate": "2021-05-04 13:25:29",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 108,
		  "totalCountries": 13,
		  "totalStates": 18,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 647,
		  "schedulePercent": 0.366387,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Barba Negra Music Club",
		  "mostGuestCity": "Budapest",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83a06f27d16572002676866ed51d2473",
		  
		  "name": "Carlos",
		  "createdDate": "2017-06-06 23:28:59",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 714,
		  "totalCountries": 18,
		  "totalStates": 19,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 981,
		  "schedulePercent": 0.484814,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83a0fb1a647e2647e8a63b5c519ac398",
		  
		  "name": "Matt",
		  "createdDate": "2024-07-26 02:56:07",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 364,
		  "schedulePercent": 0.25,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83a359277b779e08a5db1ab223284a24",
		  
		  "name": "AMAIA PRODUCCIÃ’N",
		  "createdDate": "2025-01-27 17:41:15",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 339,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83b106f1d065c98cafb195eeeede8d99",
		  
		  "name": "Chelsea",
		  "createdDate": "2020-12-03 18:45:33",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 2823,
		  "totalCountries": 5,
		  "totalStates": 26,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83b6c0817ddffc841f98fd3fce88a253",
		  
		  "name": "Pete",
		  "createdDate": "2014-07-09 14:12:02",
		  "totalOrganizations": 18,
		  "totalTours": 19,
		  "totalDays": 427,
		  "totalCountries": 35,
		  "totalStates": 56,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 2397,
		  "schedulePercent": 0.774819,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "First Direct Arena",
		  "mostGuestCity": "Leeds",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83c2f0f7bf35f3ed97730992f81568cc",
		  
		  "name": "Liam",
		  "createdDate": "2025-02-12 22:04:59",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 328,
		  "totalCountries": 7,
		  "totalStates": 50,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1052,
		  "schedulePercent": 0.505326,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Hernando's Hideaway",
		  "mostGuestCity": "Memphis",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83d917e9c11c8ea51a717ec55454e1e8",
		  
		  "name": "Camryn",
		  "createdDate": "2023-09-18 23:25:58",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 235,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1299,
		  "schedulePercent": 0.57117,
		  "totalGuests": 770,
		  "guestPercent": 0.800544,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83e042389b0731647b1d89fbb6e61d71",
		  
		  "name": "Matthew",
		  "createdDate": "2025-03-26 14:36:21",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 196,
		  "totalCountries": 20,
		  "totalStates": 50,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 901,
		  "schedulePercent": 0.458749,
		  "totalGuests": 611,
		  "guestPercent": 0.761899,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Myth Live",
		  "mostGuestCity": "Maplewood",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83ebce61c1d2116905dd6db5176aca57",
		  
		  "name": "Ron",
		  "createdDate": "2017-06-14 15:45:55",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 181,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1054,
		  "schedulePercent": 0.50612,
		  "totalGuests": 658,
		  "guestPercent": 0.773005,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83f8a383ca9d6b5fc46b92bb9140deb8",
		  
		  "name": "Paul ",
		  "createdDate": "2009-09-10 18:34:06",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 213,
		  "totalCountries": 6,
		  "totalStates": 28,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1745,
		  "schedulePercent": 0.667271,
		  "totalGuests": 2354,
		  "guestPercent": 0.963622,
		  "mostGuestDate": "2025-07-21 00:00:00",
		  "mostGuestName": "Desert 5 Spot",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83f8ac5d08a1464b4a4b8e3ede656247",
		  
		  "name": "Joey",
		  "createdDate": "2018-09-07 20:18:00",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 229,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1313,
		  "schedulePercent": 0.574569,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83fb194a71487f76211a6b6167ba593a",
		  
		  "name": "Kyle",
		  "createdDate": "2022-08-01 20:19:10",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 102,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 464,
		  "schedulePercent": 0.296351,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Venue at Horseshoe Hammond",
		  "mostGuestCity": "Hammond",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "83fb3b56f14ed3667d0bd7569309aac8",
		  
		  "name": "Philipp",
		  "createdDate": "2017-11-27 12:58:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 97,
		  "totalCountries": 18,
		  "totalStates": 19,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 568,
		  "guestPercent": 0.749207,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Festung Kufstein",
		  "mostGuestCity": "Kufstein",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "840047458d777d41f81bb1bced4ba829",
		  
		  "name": "MoWorks",
		  "createdDate": "2025-05-20 00:19:04",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 35,
		  "totalCountries": 6,
		  "totalStates": 13,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Abilene Christian University",
		  "mostGuestCity": "Abilene",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8405689d5c780c180281ef56a5c023e1",
		  
		  "name": "Sara",
		  "createdDate": "2022-01-18 18:45:44",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 321,
		  "totalCountries": 18,
		  "totalStates": 12,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1049,
		  "schedulePercent": 0.504193,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8413ed65532cbb7ce01fc8105b90fc11",
		  
		  "name": "Paulina",
		  "createdDate": "2025-05-27 13:44:56",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 272,
		  "totalCountries": 18,
		  "totalStates": 35,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 473,
		  "schedulePercent": 0.299637,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8422bf82e61b23f739abf069fbf54d1f",
		  
		  "name": "Jacob",
		  "createdDate": "2025-08-01 16:21:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8427b3e49fe27b5acc7c0b0b2d4c12ba",
		  
		  "name": "Martin",
		  "createdDate": "2012-07-30 17:45:40",
		  "totalOrganizations": 8,
		  "totalTours": 17,
		  "totalDays": 403,
		  "totalCountries": 18,
		  "totalStates": 56,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 1308,
		  "schedulePercent": 0.573323,
		  "totalGuests": 517,
		  "guestPercent": 0.735041,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Cadogan Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8439765ba47453944c3f753901fa91c9",
		  
		  "name": "Dennis ",
		  "createdDate": "2015-12-30 18:35:29",
		  "totalOrganizations": 43,
		  "totalTours": 45,
		  "totalDays": 2474,
		  "totalCountries": 42,
		  "totalStates": 124,
		  "totalEvents": 835,
		  "eventPercent": 0.993767,
		  "totalScheduleItems": 14711,
		  "schedulePercent": 0.99898,
		  "totalGuests": 4989,
		  "guestPercent": 0.997507,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "843cb19a5f14a0ba9143425f407458a7",
		  
		  "name": "Rienk",
		  "createdDate": "2016-02-22 01:56:21",
		  "totalOrganizations": 7,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 11,
		  "totalStates": 6,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 157,
		  "schedulePercent": 0.13316,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "SaSaZu",
		  "mostGuestCity": "Prague",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "843df39d1c8f4308f6124e9622164c3d",
		  
		  "name": "Mark",
		  "createdDate": "2013-09-26 18:01:51",
		  "totalOrganizations": 24,
		  "totalTours": 52,
		  "totalDays": 308,
		  "totalCountries": 22,
		  "totalStates": 33,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 1461,
		  "schedulePercent": 0.609248,
		  "totalGuests": 1061,
		  "guestPercent": 0.856528,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84422e2da6b373ef75719212e9a00082",
		  
		  "name": "Logan Dean",
		  "createdDate": "2019-06-16 15:27:56",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 88,
		  "totalCountries": 8,
		  "totalStates": 33,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 416,
		  "schedulePercent": 0.276519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84473be9a3fa7bb8c5afea0459ba284c",
		  
		  "name": "Alexis",
		  "createdDate": "2025-02-04 23:19:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 117,
		  "schedulePercent": 0.108794,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "844bff1d9e6ca0e668e637d90da722e4",
		  
		  "name": "Sun",
		  "createdDate": "2023-08-15 16:55:20",
		  "totalOrganizations": 25,
		  "totalTours": 27,
		  "totalDays": 5266,
		  "totalCountries": 46,
		  "totalStates": 87,
		  "totalEvents": 529,
		  "eventPercent": 0.981754,
		  "totalScheduleItems": 8462,
		  "schedulePercent": 0.9915,
		  "totalGuests": 2216,
		  "guestPercent": 0.958522,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "845886de2e354f37c7cbbedb871640e5",
		  
		  "name": "Iacopo",
		  "createdDate": "2023-04-29 00:43:23",
		  "totalOrganizations": 12,
		  "totalTours": 16,
		  "totalDays": 557,
		  "totalCountries": 36,
		  "totalStates": 62,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 2040,
		  "schedulePercent": 0.720875,
		  "totalGuests": 479,
		  "guestPercent": 0.723935,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8459c207ae4191e8391500d5c29e3f7d",
		  
		  "name": "Stephanie",
		  "createdDate": "2022-08-22 19:59:17",
		  "totalOrganizations": 2,
		  "totalTours": 72,
		  "totalDays": 202,
		  "totalCountries": 11,
		  "totalStates": 31,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1026,
		  "schedulePercent": 0.498073,
		  "totalGuests": 168,
		  "guestPercent": 0.572303,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "City Winery",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "845a37c6cfd42a7287ab9f424def700e",
		  
		  "name": "Gerald",
		  "createdDate": "2013-08-22 20:22:44",
		  "totalOrganizations": 10,
		  "totalTours": 17,
		  "totalDays": 488,
		  "totalCountries": 32,
		  "totalStates": 67,
		  "totalEvents": 232,
		  "eventPercent": 0.850408,
		  "totalScheduleItems": 1892,
		  "schedulePercent": 0.69311,
		  "totalGuests": 372,
		  "guestPercent": 0.68189,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "846c998fcb1425d8af0a4cbe1d46dfde",
		  
		  "name": "Kristina",
		  "createdDate": "2025-02-18 11:25:43",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 106,
		  "totalCountries": 19,
		  "totalStates": 9,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 877,
		  "schedulePercent": 0.450136,
		  "totalGuests": 182,
		  "guestPercent": 0.581142,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "X-tra",
		  "mostGuestCity": "Zurich",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "846c9fcc33db8a73116089bb587964c5",
		  
		  "name": "Wesley",
		  "createdDate": "2017-02-27 18:12:09",
		  "totalOrganizations": 17,
		  "totalTours": 17,
		  "totalDays": 1855,
		  "totalCountries": 20,
		  "totalStates": 67,
		  "totalEvents": 360,
		  "eventPercent": 0.94617,
		  "totalScheduleItems": 5976,
		  "schedulePercent": 0.975521,
		  "totalGuests": 780,
		  "guestPercent": 0.80315,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "847a3e025f9b4b9511bc3cf8448ee95f",
		  
		  "name": "Holly",
		  "createdDate": "2022-03-08 22:51:25",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 405,
		  "totalCountries": 15,
		  "totalStates": 59,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1904,
		  "schedulePercent": 0.695603,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Crescent Ballroom",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8487cca64020e16da52393c2d4d4ea26",
		  
		  "name": "Mitchell",
		  "createdDate": "2015-01-06 18:40:22",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 1216,
		  "totalCountries": 31,
		  "totalStates": 67,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 3491,
		  "schedulePercent": 0.881573,
		  "totalGuests": 882,
		  "guestPercent": 0.825703,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "848d654a8eaf0004dbc4f9796d005605",
		  
		  "name": "Caroll",
		  "createdDate": "2012-04-13 17:05:32",
		  "totalOrganizations": 16,
		  "totalTours": 5,
		  "totalDays": 312,
		  "totalCountries": 4,
		  "totalStates": 19,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1021,
		  "schedulePercent": 0.496374,
		  "totalGuests": 594,
		  "guestPercent": 0.756346,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "849772b22709908e35a3465858d9a162",
		  
		  "name": "Isaiah",
		  "createdDate": "2021-11-07 20:54:18",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 320,
		  "totalCountries": 10,
		  "totalStates": 55,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1750,
		  "schedulePercent": 0.668631,
		  "totalGuests": 601,
		  "guestPercent": 0.758273,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84ac0fdb12913386dd2232f908071804",
		  
		  "name": "Abbey",
		  "createdDate": "2023-09-22 14:43:52",
		  "totalOrganizations": 7,
		  "totalTours": 31,
		  "totalDays": 174,
		  "totalCountries": 7,
		  "totalStates": 23,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1664,
		  "schedulePercent": 0.652085,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Bryce Jordan Center",
		  "mostGuestCity": "University Park",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84aff8cdc91b1e839871893ef3d60aaa",
		  
		  "name": "Ben",
		  "createdDate": "2025-03-18 16:23:18",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 80,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 358,
		  "schedulePercent": 0.247167,
		  "totalGuests": 171,
		  "guestPercent": 0.574683,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Immersive Media Performing Arts Center (iMPAC)",
		  "mostGuestCity": "Gulfport",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84b66c978fb047b3dd34786201dad17b",
		  
		  "name": "Tara",
		  "createdDate": "2013-10-09 22:51:59",
		  "totalOrganizations": 14,
		  "totalTours": 2,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 101,
		  "schedulePercent": 0.0970082,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "9:30 Club",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84bf0f441b34108b926d121170d395d3",
		  
		  "name": "Hunter",
		  "createdDate": "2024-12-21 10:01:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 342,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 26,
		  "schedulePercent": 0.0371713,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84d0b3728d8e4bf406f05c2c9b1366b3",
		  
		  "name": "Al",
		  "createdDate": "2013-02-13 15:50:04",
		  "totalOrganizations": 15,
		  "totalTours": 4,
		  "totalDays": 296,
		  "totalCountries": 8,
		  "totalStates": 30,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1639,
		  "schedulePercent": 0.647892,
		  "totalGuests": 1075,
		  "guestPercent": 0.859587,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84de19271b473d87f3df8e28edbf46db",
		  
		  "name": "KB",
		  "createdDate": "2024-01-15 01:09:15",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 264,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84dea0faec4f48ad65af0a8542de8f10",
		  
		  "name": "Chris",
		  "createdDate": "2023-06-25 02:44:57",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 175,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 737,
		  "schedulePercent": 0.400272,
		  "totalGuests": 206,
		  "guestPercent": 0.598821,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84ea45d321c82eb33e3c55062573750a",
		  
		  "name": "Marion",
		  "createdDate": "2023-02-17 21:35:49",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 152,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1117,
		  "schedulePercent": 0.523119,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84f34a34f62c1fe931c9bdd558608116",
		  
		  "name": "Johnny",
		  "createdDate": "2021-11-09 02:15:48",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 183,
		  "totalCountries": 12,
		  "totalStates": 55,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1075,
		  "schedulePercent": 0.512239,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84f4b0a2d97c8219b2ac1fda82351b97",
		  
		  "name": "Lisa",
		  "createdDate": "2018-03-04 00:39:42",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 97,
		  "totalCountries": 14,
		  "totalStates": 20,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 623,
		  "schedulePercent": 0.358454,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Tupelo Music Hall",
		  "mostGuestCity": "Derry",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "84f5516dfb5ea7f16d9345fdbf933091",
		  
		  "name": "Taylor",
		  "createdDate": "2018-12-31 22:15:45",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 516,
		  "totalCountries": 4,
		  "totalStates": 19,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 776,
		  "schedulePercent": 0.415005,
		  "totalGuests": 843,
		  "guestPercent": 0.818563,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8501069666a03398f2e4700fc580d8ef",
		  
		  "name": "Ben",
		  "createdDate": "2013-04-24 12:44:00",
		  "totalOrganizations": 21,
		  "totalTours": 37,
		  "totalDays": 1112,
		  "totalCountries": 36,
		  "totalStates": 75,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 4170,
		  "schedulePercent": 0.923504,
		  "totalGuests": 1761,
		  "guestPercent": 0.93087,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8503b7460643d58aa773b293aeeba781",
		  
		  "name": "Claire",
		  "createdDate": "2023-05-18 09:24:41",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 729,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 360,
		  "schedulePercent": 0.248187,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85052199663f9cd6b26edf671f885910",
		  
		  "name": "Andy",
		  "createdDate": "2023-02-08 16:11:25",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 60,
		  "totalCountries": 10,
		  "totalStates": 21,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 266,
		  "schedulePercent": 0.197076,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "The Opera House",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85164b21f00018645b58ba28606c082c",
		  
		  "name": "Cody",
		  "createdDate": "2018-02-18 22:41:56",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 597,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2042,
		  "schedulePercent": 0.721668,
		  "totalGuests": 111,
		  "guestPercent": 0.529125,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Soboba Casino Resort",
		  "mostGuestCity": "San Jacinto",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8518d9b50914803c376436d61afba2c0",
		  
		  "name": "Hunter ",
		  "createdDate": "2024-10-29 21:06:26",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 415,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 764,
		  "schedulePercent": 0.409905,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "Crafthouse",
		  "mostGuestCity": "Pittsburgh",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8527aab3e75f87b4b96862260f8cac8f",
		  
		  "name": "Brent",
		  "createdDate": "2021-12-01 14:38:22",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 428,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1219,
		  "schedulePercent": 0.551677,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Under The Big Sky",
		  "mostGuestCity": "Whitefish",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "852864e9bfcb6cc4c8f0cc269330adbb",
		  
		  "name": "Joey",
		  "createdDate": "2020-01-28 18:05:10",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 1493,
		  "totalCountries": 6,
		  "totalStates": 56,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 1847,
		  "schedulePercent": 0.685403,
		  "totalGuests": 199,
		  "guestPercent": 0.594062,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "852fa187d2b67f39f59afb053ffcaa30",
		  
		  "name": "Jay",
		  "createdDate": "2021-10-15 03:49:59",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 476,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1008,
		  "schedulePercent": 0.492747,
		  "totalGuests": 1343,
		  "guestPercent": 0.892339,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8537881d92f1e006dd66d8f94902abe0",
		  
		  "name": "Chanelle",
		  "createdDate": "2025-08-13 10:06:42",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 107,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1222,
		  "schedulePercent": 0.553264,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "853d7ed770b07a59c31b9262e4ed9cfe",
		  
		  "name": "Shawn",
		  "createdDate": "2017-01-09 20:22:37",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 440,
		  "totalCountries": 7,
		  "totalStates": 46,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 2475,
		  "schedulePercent": 0.784111,
		  "totalGuests": 733,
		  "guestPercent": 0.792951,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85418b4e629f025ceb0ad4e793732f0e",
		  
		  "name": "Connor",
		  "createdDate": "2021-11-27 21:27:04",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 173,
		  "totalCountries": 6,
		  "totalStates": 44,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 970,
		  "schedulePercent": 0.481188,
		  "totalGuests": 514,
		  "guestPercent": 0.733908,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85492173efd086441ed9fd86cbf29abf",
		  
		  "name": "Brianna",
		  "createdDate": "2022-10-14 00:14:34",
		  "totalOrganizations": 4,
		  "totalTours": 16,
		  "totalDays": 231,
		  "totalCountries": 9,
		  "totalStates": 28,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1068,
		  "schedulePercent": 0.509633,
		  "totalGuests": 1077,
		  "guestPercent": 0.860267,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "854deb33f3cd10bff3513766baba9dda",
		  
		  "name": "Chad",
		  "createdDate": "2017-09-19 13:56:39",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 294,
		  "totalCountries": 3,
		  "totalStates": 48,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1745,
		  "schedulePercent": 0.667271,
		  "totalGuests": 1240,
		  "guestPercent": 0.87942,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85546ed3678ac3cc61a49a05714979eb",
		  
		  "name": "John",
		  "createdDate": "2013-01-17 09:50:16",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 597,
		  "totalCountries": 20,
		  "totalStates": 50,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 988,
		  "schedulePercent": 0.487421,
		  "totalGuests": 113,
		  "guestPercent": 0.530598,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Crescent Ballroom",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8555c46e6d605c7ecf58c4c1626eb5fa",
		  
		  "name": "Anthony",
		  "createdDate": "2013-03-15 19:37:05",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 101,
		  "totalCountries": 11,
		  "totalStates": 17,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 439,
		  "schedulePercent": 0.285811,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "855afdb3fac07fedfcaa598776c8e328",
		  
		  "name": "Dominik ",
		  "createdDate": "2023-08-16 06:19:59",
		  "totalOrganizations": 1,
		  "totalTours": 24,
		  "totalDays": 141,
		  "totalCountries": 19,
		  "totalStates": 32,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 1378,
		  "guestPercent": 0.897325,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "858389679c0dbcc7de9ab101ecca4688",
		  
		  "name": "Irvin ",
		  "createdDate": "2015-06-12 08:39:32",
		  "totalOrganizations": 28,
		  "totalTours": 16,
		  "totalDays": 1705,
		  "totalCountries": 20,
		  "totalStates": 75,
		  "totalEvents": 409,
		  "eventPercent": 0.961015,
		  "totalScheduleItems": 3703,
		  "schedulePercent": 0.896192,
		  "totalGuests": 2160,
		  "guestPercent": 0.956369,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85842637905ae6b7600cf8bb7c77e45c",
		  
		  "name": "John",
		  "createdDate": "2013-01-15 22:05:22",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 823,
		  "totalCountries": 14,
		  "totalStates": 55,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 3933,
		  "schedulePercent": 0.910585,
		  "totalGuests": 2482,
		  "guestPercent": 0.967022,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8585323bb1af0cea1e0a6665690869ed",
		  
		  "name": "Jamar",
		  "createdDate": "2025-05-20 03:34:15",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 171,
		  "totalCountries": 11,
		  "totalStates": 11,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 1148,
		  "schedulePercent": 0.533885,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85893874d67e30de8c9c887b0ba8f83a",
		  
		  "name": "Sanna",
		  "createdDate": "2025-08-21 21:06:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 137,
		  "totalCountries": 9,
		  "totalStates": 14,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 197,
		  "schedulePercent": 0.159225,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8590cd12a1508af9c92cfd5d9dc08337",
		  
		  "name": "Jamal",
		  "createdDate": "2021-07-09 16:14:13",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 334,
		  "totalCountries": 25,
		  "totalStates": 34,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1683,
		  "schedulePercent": 0.655598,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Berkeley",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "859cfdfec093315673990b0b2ae70d9e",
		  
		  "name": "Pete",
		  "createdDate": "2015-09-13 19:24:34",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 372,
		  "totalCountries": 8,
		  "totalStates": 21,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 744,
		  "schedulePercent": 0.403105,
		  "totalGuests": 288,
		  "guestPercent": 0.643246,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "859d85a05569220531d0c24403d28c4f",
		  
		  "name": "Philip",
		  "createdDate": "2021-08-16 06:34:34",
		  "totalOrganizations": 20,
		  "totalTours": 28,
		  "totalDays": 1326,
		  "totalCountries": 27,
		  "totalStates": 72,
		  "totalEvents": 456,
		  "eventPercent": 0.972235,
		  "totalScheduleItems": 4690,
		  "schedulePercent": 0.943676,
		  "totalGuests": 1785,
		  "guestPercent": 0.93257,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Cal Coast Credit Union Amphitheater",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "859fae9c7ed28278cf66d5f21a8bd2c5",
		  
		  "name": "Vix",
		  "createdDate": "2017-07-15 17:56:51",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 142,
		  "totalCountries": 14,
		  "totalStates": 33,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1080,
		  "schedulePercent": 0.514279,
		  "totalGuests": 842,
		  "guestPercent": 0.818336,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 91,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "859fbe39f0c42b8227b8605869b07384",
		  
		  "name": "Brandon",
		  "createdDate": "2019-12-02 19:33:24",
		  "totalOrganizations": 17,
		  "totalTours": 12,
		  "totalDays": 584,
		  "totalCountries": 14,
		  "totalStates": 65,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 3201,
		  "schedulePercent": 0.859927,
		  "totalGuests": 2059,
		  "guestPercent": 0.951383,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 280,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85a0f267445e2b0cc490c48a9bfb2841",
		  
		  "name": "Adam",
		  "createdDate": "2019-01-05 23:57:40",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 137,
		  "totalCountries": 18,
		  "totalStates": 14,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 1068,
		  "schedulePercent": 0.509633,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85ab4e8da34ae684b25bc723c167e716",
		  
		  "name": "Luke",
		  "createdDate": "2015-06-17 13:02:47",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 135,
		  "totalCountries": 13,
		  "totalStates": 28,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 585,
		  "schedulePercent": 0.345648,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-09-09 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85b03fac30f944256493df59db69d1b4",
		  
		  "name": "Grant",
		  "createdDate": "2017-09-17 02:47:11",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 100,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 606,
		  "schedulePercent": 0.353014,
		  "totalGuests": 452,
		  "guestPercent": 0.713622,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85bd5a82a3dfbe15e5533c8190c1ef13",
		  
		  "name": "Jayona",
		  "createdDate": "2025-07-11 02:34:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 173,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 202,
		  "schedulePercent": 0.162058,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85bdb50403d9d53eb4a1ca6eec94dc78",
		  
		  "name": "Nick",
		  "createdDate": "2018-10-01 11:14:38",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 500,
		  "totalCountries": 16,
		  "totalStates": 38,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1820,
		  "schedulePercent": 0.67951,
		  "totalGuests": 184,
		  "guestPercent": 0.582276,
		  "mostGuestDate": "2025-06-02 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85c40ad7c919854f5de5988ff7b69a8a",
		  
		  "name": "Purpose",
		  "createdDate": "2025-03-31 17:01:25",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 170,
		  "totalCountries": 10,
		  "totalStates": 38,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85c56707de8abb3440042c18297d8046",
		  
		  "name": "Jesse",
		  "createdDate": "2022-10-10 21:40:50",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 208,
		  "totalCountries": 14,
		  "totalStates": 46,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 774,
		  "schedulePercent": 0.414211,
		  "totalGuests": 825,
		  "guestPercent": 0.813803,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "South Side Ballroom",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85d64a6a07f82ae44c05052cac78c354",
		  
		  "name": "Hulvey ",
		  "createdDate": "2024-10-09 22:28:40",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 464,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 949,
		  "schedulePercent": 0.475181,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85d9af74f9d2297f9b4698512ce98bad",
		  
		  "name": "Paul",
		  "createdDate": "2012-02-17 19:29:57",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 190,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1155,
		  "schedulePercent": 0.535585,
		  "totalGuests": 252,
		  "guestPercent": 0.626247,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85ecc53c71aca70dc52dadde15383764",
		  
		  "name": "Amaechi",
		  "createdDate": "2025-06-02 16:19:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 59,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Nationwide Arena",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85f0d0a03b762020d156fa92ddfd1401",
		  
		  "name": "Lindsey",
		  "createdDate": "2013-03-19 22:35:37",
		  "totalOrganizations": 65,
		  "totalTours": 65,
		  "totalDays": 13474,
		  "totalCountries": 33,
		  "totalStates": 145,
		  "totalEvents": 2906,
		  "eventPercent": 0.999887,
		  "totalScheduleItems": 39400,
		  "schedulePercent": 0.999887,
		  "totalGuests": 14768,
		  "guestPercent": 0.999887,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "85f6baa3056811e9b839d07d0ecba824",
		  
		  "name": "John Daniel",
		  "createdDate": "2013-10-16 03:37:00",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 148,
		  "totalCountries": 8,
		  "totalStates": 20,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 611,
		  "schedulePercent": 0.354374,
		  "totalGuests": 188,
		  "guestPercent": 0.584882,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Budweiser Gardens",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86018bb89435f5ce844cc232979d0ed7",
		  
		  "name": "Brynn",
		  "createdDate": "2023-10-09 22:18:53",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 488,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1560,
		  "schedulePercent": 0.632706,
		  "totalGuests": 450,
		  "guestPercent": 0.712489,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86074547f190a5112fcc1dd01861b110",
		  
		  "name": "Chris",
		  "createdDate": "2014-06-05 03:50:46",
		  "totalOrganizations": 13,
		  "totalTours": 13,
		  "totalDays": 671,
		  "totalCountries": 17,
		  "totalStates": 54,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 3727,
		  "schedulePercent": 0.897779,
		  "totalGuests": 3020,
		  "guestPercent": 0.982321,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86104340dfee467cc11b352429ffacc6",
		  
		  "name": "Flo",
		  "createdDate": "2022-10-25 12:02:35",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 96,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 615,
		  "schedulePercent": 0.355734,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8611c3c9892a80f10d04ddb06dfed782",
		  
		  "name": "Nathan",
		  "createdDate": "2023-02-08 16:13:00",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 69,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 74,
		  "schedulePercent": 0.0775159,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "O2 Academy Islington",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8614b3fe10b2cd9124f4c4db0d8615c3",
		  
		  "name": "Kyana",
		  "createdDate": "2018-09-27 19:14:31",
		  "totalOrganizations": 19,
		  "totalTours": 15,
		  "totalDays": 624,
		  "totalCountries": 12,
		  "totalStates": 51,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 2486,
		  "schedulePercent": 0.785018,
		  "totalGuests": 1070,
		  "guestPercent": 0.858341,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Saenger Theatre",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 145,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "861d39af8a51a86b05b7526f7e5efe00",
		  
		  "name": "Gabe",
		  "createdDate": "2015-05-14 17:49:42",
		  "totalOrganizations": 11,
		  "totalTours": 15,
		  "totalDays": 622,
		  "totalCountries": 15,
		  "totalStates": 59,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1646,
		  "schedulePercent": 0.649479,
		  "totalGuests": 864,
		  "guestPercent": 0.82185,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "DCU Center",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "861f4d806f8a91276cd5d74c98f8fa13",
		  
		  "name": "Nicholas",
		  "createdDate": "2022-11-05 15:44:44",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 993,
		  "totalCountries": 8,
		  "totalStates": 37,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1205,
		  "schedulePercent": 0.548051,
		  "totalGuests": 539,
		  "guestPercent": 0.740367,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "862ae9405037ce347dfb1e3723ba7279",
		  
		  "name": "Kyra",
		  "createdDate": "2024-07-22 00:06:47",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 180,
		  "totalCountries": 8,
		  "totalStates": 37,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 828,
		  "schedulePercent": 0.433477,
		  "totalGuests": 189,
		  "guestPercent": 0.585222,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "Revolution Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "862e0ffca005b9c1b23488c3f9e4fb49",
		  
		  "name": "Kira",
		  "createdDate": "2023-07-20 03:02:34",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 433,
		  "totalCountries": 12,
		  "totalStates": 6,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 623,
		  "schedulePercent": 0.358454,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8638fdec215526d1349f3b0df923b54f",
		  
		  "name": "Detroit",
		  "createdDate": "2013-03-10 20:15:58",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 552,
		  "totalCountries": 7,
		  "totalStates": 31,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 2494,
		  "schedulePercent": 0.786265,
		  "totalGuests": 1781,
		  "guestPercent": 0.93223,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8642b7b6ed784628d6731a6d5e775f7a",
		  
		  "name": "Steven",
		  "createdDate": "2021-08-03 11:12:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 227,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1317,
		  "schedulePercent": 0.575476,
		  "totalGuests": 652,
		  "guestPercent": 0.772099,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "United Supermarkets Arena",
		  "mostGuestCity": "Lubbock",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "864bc5f6300400626b7780b99761b641",
		  
		  "name": "Rick",
		  "createdDate": "2021-06-23 22:18:55",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 1061,
		  "totalCountries": 7,
		  "totalStates": 54,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 3295,
		  "schedulePercent": 0.86786,
		  "totalGuests": 804,
		  "guestPercent": 0.80859,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8659dab857cee54f05c86d28c404e36f",
		  
		  "name": "Benito ",
		  "createdDate": "2013-09-12 16:02:37",
		  "totalOrganizations": 17,
		  "totalTours": 7,
		  "totalDays": 518,
		  "totalCountries": 9,
		  "totalStates": 55,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 818,
		  "guestPercent": 0.81267,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8661e9b481e54077a3d4b22fedbe6a7d",
		  
		  "name": "Ole",
		  "createdDate": "2022-06-16 08:54:44",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 326,
		  "totalCountries": 18,
		  "totalStates": 24,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 747,
		  "schedulePercent": 0.403785,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Rockefeller Music Hall",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8669860ece3480bd18331b0b584cffac",
		  
		  "name": "Century",
		  "createdDate": "2023-12-08 03:29:28",
		  "totalOrganizations": 57,
		  "totalTours": 31,
		  "totalDays": 866,
		  "totalCountries": 6,
		  "totalStates": 14,
		  "totalEvents": 693,
		  "eventPercent": 0.991047,
		  "totalScheduleItems": 1576,
		  "schedulePercent": 0.636106,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "866b19d179bda5b2fe59adf4ba6ce4f9",
		  
		  "name": "David",
		  "createdDate": "2011-10-01 04:21:51",
		  "totalOrganizations": 20,
		  "totalTours": 36,
		  "totalDays": 987,
		  "totalCountries": 22,
		  "totalStates": 53,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 3291,
		  "schedulePercent": 0.867407,
		  "totalGuests": 814,
		  "guestPercent": 0.812103,
		  "mostGuestDate": "2025-02-10 00:00:00",
		  "mostGuestName": "Tokyo Garden Theater",
		  "mostGuestCity": "",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "867390a61cf99ae29e4bdff23f4a3b30",
		  
		  "name": "Michele",
		  "createdDate": "2013-09-29 20:07:34",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 1779,
		  "totalCountries": 5,
		  "totalStates": 61,
		  "totalEvents": 342,
		  "eventPercent": 0.93767,
		  "totalScheduleItems": 6267,
		  "schedulePercent": 0.979034,
		  "totalGuests": 2153,
		  "guestPercent": 0.955916,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Boone Pickens Stadium",
		  "mostGuestCity": "Stillwater",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "867ed5c733e4afa686c7b744bacb1e27",
		  
		  "name": "Niall",
		  "createdDate": "2024-12-08 11:45:10",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 60,
		  "totalCountries": 18,
		  "totalStates": 21,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 560,
		  "schedulePercent": 0.337375,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Quad Theatre",
		  "mostGuestCity": "Plymouth",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "868544793a9b4cbc76a73f86b2fe3d01",
		  
		  "name": "Matt",
		  "createdDate": "2022-06-17 04:50:00",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 683,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 690,
		  "schedulePercent": 0.382593,
		  "totalGuests": 372,
		  "guestPercent": 0.68189,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "The Amphitheater at Canyons",
		  "mostGuestCity": "Park City",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86921e8514a4b03667cb34e372bf27c4",
		  
		  "name": "Chris ",
		  "createdDate": "2025-03-05 22:52:50",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 74,
		  "totalCountries": 12,
		  "totalStates": 15,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 518,
		  "schedulePercent": 0.320603,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Arena 8888 Sofia",
		  "mostGuestCity": "Sofia",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86a140719ead3036b954cfd157be6336",
		  
		  "name": "Production Stage",
		  "createdDate": "2024-09-24 02:22:07",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 402,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 279,
		  "eventPercent": 0.897439,
		  "totalScheduleItems": 2013,
		  "schedulePercent": 0.715662,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86a31bdd20e4e1bdec783ddd0ae8c29e",
		  
		  "name": "Desiree",
		  "createdDate": "2013-02-19 17:33:24",
		  "totalOrganizations": 5,
		  "totalTours": 15,
		  "totalDays": 634,
		  "totalCountries": 26,
		  "totalStates": 44,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 2054,
		  "schedulePercent": 0.724275,
		  "totalGuests": 912,
		  "guestPercent": 0.832729,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86a446eb23ea5d210cd0292784fd1153",
		  
		  "name": "Yoyo",
		  "createdDate": "2023-06-27 06:22:50",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 715,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2568,
		  "schedulePercent": 0.795104,
		  "totalGuests": 2769,
		  "guestPercent": 0.977335,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86ab44152539c43e4e9cfdbbdb21081f",
		  
		  "name": "Andrea",
		  "createdDate": "2017-07-24 13:28:54",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 150,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1722,
		  "schedulePercent": 0.662398,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86b3f20e942877f52b85e7b17a23a1cc",
		  
		  "name": "Cheilon",
		  "createdDate": "2016-05-16 17:39:32",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 235,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 987,
		  "schedulePercent": 0.486967,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Ponoka Stampede",
		  "mostGuestCity": "Ponoka",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86c7254f045d64ed5d4151677378a163",
		  
		  "name": "Heikki",
		  "createdDate": "2022-09-23 08:13:28",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 165,
		  "totalCountries": 20,
		  "totalStates": 44,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1783,
		  "schedulePercent": 0.673164,
		  "totalGuests": 1073,
		  "guestPercent": 0.858681,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "013 Poppodium",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86cb390dc5cfed3f018cd32c91f82de8",
		  
		  "name": "Nicholas",
		  "createdDate": "2019-11-25 22:32:18",
		  "totalOrganizations": 12,
		  "totalTours": 18,
		  "totalDays": 772,
		  "totalCountries": 25,
		  "totalStates": 79,
		  "totalEvents": 286,
		  "eventPercent": 0.902765,
		  "totalScheduleItems": 2972,
		  "schedulePercent": 0.839869,
		  "totalGuests": 1543,
		  "guestPercent": 0.913871,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86db9e0dad6665feb5b2079b73d06da0",
		  
		  "name": "Dylan",
		  "createdDate": "2021-12-05 21:12:26",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 1003,
		  "totalCountries": 38,
		  "totalStates": 81,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 2302,
		  "schedulePercent": 0.762126,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Klub Studio",
		  "mostGuestCity": "KrakÃ³w",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86e301bbc09e8cb4affc686b48908541",
		  
		  "name": "James",
		  "createdDate": "2017-09-04 15:25:46",
		  "totalOrganizations": 6,
		  "totalTours": 16,
		  "totalDays": 335,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1386,
		  "schedulePercent": 0.594062,
		  "totalGuests": 581,
		  "guestPercent": 0.753286,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Electric Ballroom",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86e56586f0dae8f2ce42e04f078320d4",
		  
		  "name": "Laura",
		  "createdDate": "2015-11-10 21:56:12",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 735,
		  "totalCountries": 13,
		  "totalStates": 42,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2419,
		  "schedulePercent": 0.777425,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86ea81a9f61e865cdfe6a736f88325cd",
		  
		  "name": "Anthony",
		  "createdDate": "2024-07-11 18:01:03",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 617,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 989,
		  "schedulePercent": 0.487874,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86ee3d71bd4aad180aef5cf17b3fd7e9",
		  
		  "name": "Maddy",
		  "createdDate": "2022-12-07 01:00:40",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 233,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 6,
		  "eventPercent": 0.0499773,
		  "totalScheduleItems": 447,
		  "schedulePercent": 0.289438,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86f212c5a5b75ad08092e1f12c4e3f2d",
		  
		  "name": "Nick",
		  "createdDate": "2012-05-07 16:15:54",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 535,
		  "totalCountries": 36,
		  "totalStates": 31,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1930,
		  "schedulePercent": 0.700023,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "86fa61773861b9be12a4cbcc805c2353",
		  
		  "name": "Piergiorgio",
		  "createdDate": "2025-10-17 15:02:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 147,
		  "schedulePercent": 0.128853,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87082c651e1297f48bd1cd0bacdda3df",
		  
		  "name": "Rodney",
		  "createdDate": "2020-01-21 15:41:00",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 369,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Pensacola Interstate Fair",
		  "mostGuestCity": "Pensacola",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "871143654900f58efc097255b3f26f28",
		  
		  "name": "Ted",
		  "createdDate": "2016-07-30 19:55:29",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 1531,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 2102,
		  "schedulePercent": 0.733114,
		  "totalGuests": 145,
		  "guestPercent": 0.555077,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Buck's Backyard",
		  "mostGuestCity": "Buda",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8714bdc3803eb729fe8723db0f9a5840",
		  
		  "name": "Matthew",
		  "createdDate": "2017-01-04 20:31:00",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 320,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1829,
		  "schedulePercent": 0.681324,
		  "totalGuests": 206,
		  "guestPercent": 0.598821,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Chicago Theatre",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "871dcb35cd96d16f166995ee19d2e86f",
		  
		  "name": "Espen",
		  "createdDate": "2025-01-23 15:27:40",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 230,
		  "schedulePercent": 0.177697,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "OverOslo",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8728fe0ca6d0498fdb94b4ac3f9c92a7",
		  
		  "name": "Lisa",
		  "createdDate": "2010-07-29 18:52:40",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 309,
		  "totalCountries": 17,
		  "totalStates": 24,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 995,
		  "schedulePercent": 0.489461,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Zenith Paris - La Villette",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87320a141bcfa279d8cba8bd0339211a",
		  
		  "name": "Daniel Kolstad",
		  "createdDate": "2017-09-19 12:07:35",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 106,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 863,
		  "schedulePercent": 0.445943,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Byscenen in Trondheim",
		  "mostGuestCity": "Trondheim",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "873e00e2a9b463a5ddde342eaa98c083",
		  
		  "name": "Jacquelyn",
		  "createdDate": "2024-01-26 00:16:06",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 943,
		  "totalCountries": 21,
		  "totalStates": 36,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 2041,
		  "schedulePercent": 0.721442,
		  "totalGuests": 1966,
		  "guestPercent": 0.944696,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Kaseya Arena",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8745b0520b3683452bae18fddf779cd8",
		  
		  "name": "Matt",
		  "createdDate": "2024-01-04 18:53:22",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 593,
		  "totalCountries": 1,
		  "totalStates": 23,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87547eaaea2b8a2c037dbe7c8e2e12e2",
		  
		  "name": "Ruby",
		  "createdDate": "2022-05-25 12:54:17",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 753,
		  "totalCountries": 21,
		  "totalStates": 48,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2802,
		  "schedulePercent": 0.82219,
		  "totalGuests": 1014,
		  "guestPercent": 0.849161,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8756adfaa8d5f702b8ab38190b417a5e",
		  
		  "name": "Martin",
		  "createdDate": "2014-02-21 08:54:58",
		  "totalOrganizations": 6,
		  "totalTours": 29,
		  "totalDays": 322,
		  "totalCountries": 26,
		  "totalStates": 42,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 1736,
		  "schedulePercent": 0.665118,
		  "totalGuests": 1523,
		  "guestPercent": 0.912398,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8757dc05bf9f76c72dc36a92a3e40cf5",
		  
		  "name": "Paul",
		  "createdDate": "2021-08-08 18:05:16",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 505,
		  "totalCountries": 11,
		  "totalStates": 16,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 2377,
		  "schedulePercent": 0.772325,
		  "totalGuests": 2521,
		  "guestPercent": 0.968722,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87761f18337f24cb06b1add02cc611af",
		  
		  "name": "Gary",
		  "createdDate": "2013-04-05 18:00:43",
		  "totalOrganizations": 12,
		  "totalTours": 17,
		  "totalDays": 452,
		  "totalCountries": 24,
		  "totalStates": 38,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1580,
		  "schedulePercent": 0.636673,
		  "totalGuests": 483,
		  "guestPercent": 0.725635,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87827c51ffab3ce5f38bfd21b5ef13b7",
		  
		  "name": "Jimmy",
		  "createdDate": "2016-11-29 12:37:27",
		  "totalOrganizations": 17,
		  "totalTours": 15,
		  "totalDays": 287,
		  "totalCountries": 15,
		  "totalStates": 35,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 1473,
		  "schedulePercent": 0.611514,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8794fec690d8dfaa2778ff4ad762be4c",
		  
		  "name": "Mike",
		  "createdDate": "2009-11-18 03:53:56",
		  "totalOrganizations": 14,
		  "totalTours": 21,
		  "totalDays": 1344,
		  "totalCountries": 28,
		  "totalStates": 75,
		  "totalEvents": 344,
		  "eventPercent": 0.93937,
		  "totalScheduleItems": 5771,
		  "schedulePercent": 0.972348,
		  "totalGuests": 2090,
		  "guestPercent": 0.953536,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Magazine London",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "879955a82baf4bf0fcc7420b5da197af",
		  
		  "name": "Rus",
		  "createdDate": "2015-10-20 18:06:37",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 63,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "THE PARAMOUNT THEATRE",
		  "mostGuestCity": "ANDERSON",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "879b22934a90a65eaefbcfcba218fcda",
		  
		  "name": "Armand",
		  "createdDate": "2025-01-17 15:33:51",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 143,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 493,
		  "schedulePercent": 0.30927,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87a3460f7ae9e1e76834f34c27897f9b",
		  
		  "name": "APGoldIntl",
		  "createdDate": "2023-08-24 23:16:37",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 1866,
		  "totalCountries": 18,
		  "totalStates": 56,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 2168,
		  "schedulePercent": 0.74218,
		  "totalGuests": 231,
		  "guestPercent": 0.613327,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Downtown Las Vegas Events Center",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87a5ad384c41f4af3c7725389f3501b6",
		  
		  "name": "Andreas",
		  "createdDate": "2017-01-11 10:27:22",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 80,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 175,
		  "schedulePercent": 0.143586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87ac17b808dc81c14c3295604a13a916",
		  
		  "name": "Adam",
		  "createdDate": "2022-08-25 21:00:39",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 261,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1292,
		  "schedulePercent": 0.569923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87c8c00394c3e1cd8be6cf85077c3c8f",
		  
		  "name": "Carlina",
		  "createdDate": "2019-01-24 22:47:51",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 538,
		  "totalCountries": 16,
		  "totalStates": 54,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2748,
		  "schedulePercent": 0.816183,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87cc64aad9ef5a23a7cc9cfa64650e80",
		  
		  "name": "Maria",
		  "createdDate": "2023-12-05 08:51:44",
		  "totalOrganizations": 19,
		  "totalTours": 12,
		  "totalDays": 962,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 296,
		  "eventPercent": 0.910131,
		  "totalScheduleItems": 2198,
		  "schedulePercent": 0.747733,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "Burgsvik GrÃ¥ GÃ¥sen",
		  "mostGuestCity": "Burgsvik",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87db5ab363d8a51bf7751535bc48f4a2",
		  
		  "name": "Chris",
		  "createdDate": "2024-08-23 16:52:27",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 63,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 651,
		  "schedulePercent": 0.36786,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "James H. Clark Auditorium",
		  "mostGuestCity": "Conway",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87e9e55f6b5722e11ac1ede0b300a33f",
		  
		  "name": "Justine",
		  "createdDate": "2022-12-30 15:20:52",
		  "totalOrganizations": 21,
		  "totalTours": 24,
		  "totalDays": 3808,
		  "totalCountries": 37,
		  "totalStates": 89,
		  "totalEvents": 343,
		  "eventPercent": 0.938463,
		  "totalScheduleItems": 4800,
		  "schedulePercent": 0.947643,
		  "totalGuests": 545,
		  "guestPercent": 0.74218,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Dreamland Margate - Scenic Stage",
		  "mostGuestCity": "Margate",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "87f00b6bf7c6a6f670164cbee98369c4",
		  
		  "name": "Anna",
		  "createdDate": "2022-09-13 14:34:15",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 1377,
		  "totalCountries": 15,
		  "totalStates": 55,
		  "totalEvents": 308,
		  "eventPercent": 0.917271,
		  "totalScheduleItems": 4397,
		  "schedulePercent": 0.934837,
		  "totalGuests": 2059,
		  "guestPercent": 0.951383,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8817f587ce4253bb065b9beef9ad05fd",
		  
		  "name": "Rafael",
		  "createdDate": "2018-05-31 11:25:10",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 765,
		  "totalCountries": 27,
		  "totalStates": 53,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 1912,
		  "schedulePercent": 0.696963,
		  "totalGuests": 480,
		  "guestPercent": 0.724161,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Channel 24",
		  "mostGuestCity": "Sacramento",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "881c5df864ca1d255fc89a2f80d0a7b6",
		  
		  "name": "Lauren",
		  "createdDate": "2011-01-29 20:36:07",
		  "totalOrganizations": 16,
		  "totalTours": 4,
		  "totalDays": 320,
		  "totalCountries": 6,
		  "totalStates": 11,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 2022,
		  "schedulePercent": 0.717588,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "882152a96429d2145049a3b89fb11f2d",
		  
		  "name": "Brian",
		  "createdDate": "2014-03-08 18:18:09",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 624,
		  "totalCountries": 26,
		  "totalStates": 69,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 2646,
		  "schedulePercent": 0.802584,
		  "totalGuests": 751,
		  "guestPercent": 0.796464,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "882403aee23ead245b50fad34df633c0",
		  
		  "name": "Nick",
		  "createdDate": "2022-06-20 15:11:06",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 502,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 3070,
		  "schedulePercent": 0.849161,
		  "totalGuests": 1004,
		  "guestPercent": 0.847008,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 177,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88299512064ab1fec18623558862632c",
		  
		  "name": "Roy",
		  "createdDate": "2023-05-20 23:10:02",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 701,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 3198,
		  "schedulePercent": 0.859474,
		  "totalGuests": 991,
		  "guestPercent": 0.844288,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8829e640930cf3c2e1d79e36c5566769",
		  
		  "name": "Nancy",
		  "createdDate": "2014-06-03 10:03:00",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 105,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 407,
		  "schedulePercent": 0.272665,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Moody Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8839b1b2ea4e55fb112adfd484050a7e",
		  
		  "name": "Lauren",
		  "createdDate": "2023-10-06 02:34:24",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 592,
		  "totalCountries": 24,
		  "totalStates": 51,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 3823,
		  "schedulePercent": 0.904012,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "884c3f53a91a107486ba85d6ce8ac68c",
		  
		  "name": "Jackie",
		  "createdDate": "2022-06-06 14:43:59",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 1186,
		  "totalCountries": 10,
		  "totalStates": 49,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 3913,
		  "schedulePercent": 0.909565,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Ford Amphitheater",
		  "mostGuestCity": "Colorado Springs",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88550f2405f2ad7cdc000576c359631e",
		  
		  "name": "Alan",
		  "createdDate": "2010-08-20 20:05:13",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 120,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 570,
		  "schedulePercent": 0.339982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8857ad389bd243e7e7b36c753ccce994",
		  
		  "name": "Klaus",
		  "createdDate": "2014-05-14 20:00:17",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 77,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 675,
		  "schedulePercent": 0.376473,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "885b229d2c79eabb682d7b2db319ecc7",
		  
		  "name": "Brittany",
		  "createdDate": "2019-04-12 13:30:17",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 111,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 1158,
		  "schedulePercent": 0.536718,
		  "totalGuests": 590,
		  "guestPercent": 0.755666,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88619812ecaf0732b39eac38a4919f3e",
		  
		  "name": "Facetta",
		  "createdDate": "2025-04-19 08:04:16",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 63,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 649,
		  "schedulePercent": 0.366954,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Capital One Arena",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88661b32874c10507655b107ef405e1b",
		  
		  "name": "Mishenka ",
		  "createdDate": "2019-02-02 06:57:24",
		  "totalOrganizations": 9,
		  "totalTours": 19,
		  "totalDays": 385,
		  "totalCountries": 11,
		  "totalStates": 18,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1307,
		  "schedulePercent": 0.573209,
		  "totalGuests": 558,
		  "guestPercent": 0.74626,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88661be30d23f5df2f4efc0f05be6d4e",
		  
		  "name": "Andy",
		  "createdDate": "2018-04-11 16:27:21",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 138,
		  "totalCountries": 10,
		  "totalStates": 40,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 896,
		  "schedulePercent": 0.456596,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88668f632644ae41c7722ccb9ad14ff1",
		  
		  "name": "John",
		  "createdDate": "2018-06-18 21:55:00",
		  "totalOrganizations": 18,
		  "totalTours": 18,
		  "totalDays": 729,
		  "totalCountries": 19,
		  "totalStates": 58,
		  "totalEvents": 289,
		  "eventPercent": 0.904918,
		  "totalScheduleItems": 5115,
		  "schedulePercent": 0.957616,
		  "totalGuests": 2532,
		  "guestPercent": 0.969855,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "886b30033e5cc3b1f1a83dccea4ae7ca",
		  
		  "name": "Lexi",
		  "createdDate": "2021-09-09 15:34:12",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 135,
		  "totalCountries": 2,
		  "totalStates": 68,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1047,
		  "schedulePercent": 0.503626,
		  "totalGuests": 272,
		  "guestPercent": 0.636333,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Fred Kavli Theater",
		  "mostGuestCity": "Thousand Oaks",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "887af694c636d4d5fc0cfd82710a3043",
		  
		  "name": "Stephen",
		  "createdDate": "2012-07-09 05:36:02",
		  "totalOrganizations": 77,
		  "totalTours": 14,
		  "totalDays": 532,
		  "totalCountries": 8,
		  "totalStates": 24,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1830,
		  "schedulePercent": 0.681437,
		  "totalGuests": 197,
		  "guestPercent": 0.592362,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "888b6edefb50b25a031a29997562185e",
		  
		  "name": "Nicolai",
		  "createdDate": "2014-05-18 14:17:33",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 80,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 422,
		  "schedulePercent": 0.278898,
		  "totalGuests": 174,
		  "guestPercent": 0.576156,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Lido",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "888c05c2c609770399453550d5896d05",
		  
		  "name": "Filippa",
		  "createdDate": "2025-03-03 10:08:50",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 34,
		  "totalCountries": 4,
		  "totalStates": 1,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8892477b5ff67e7af3b7e6bc36faf9e8",
		  
		  "name": "Lucy",
		  "createdDate": "2017-06-15 22:08:38",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 850,
		  "totalCountries": 21,
		  "totalStates": 30,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 1819,
		  "schedulePercent": 0.67917,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-01-27 00:00:00",
		  "mostGuestName": "Hoxton Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8899bbf5986d5bbdf6a615d8d3e38ada",
		  
		  "name": "Steph",
		  "createdDate": "2015-03-18 15:32:59",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 313,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 708,
		  "schedulePercent": 0.389506,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88ca2a2ccdba4ce5a899da843efe2ae3",
		  
		  "name": "Julie",
		  "createdDate": "2012-08-21 17:33:57",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 102,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 994,
		  "schedulePercent": 0.489121,
		  "totalGuests": 594,
		  "guestPercent": 0.756346,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88cb79ad57af5633d27017c1e13012b5",
		  
		  "name": "Kevin ",
		  "createdDate": "2023-06-05 15:03:35",
		  "totalOrganizations": 6,
		  "totalTours": 20,
		  "totalDays": 776,
		  "totalCountries": 9,
		  "totalStates": 45,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 1785,
		  "schedulePercent": 0.673731,
		  "totalGuests": 309,
		  "guestPercent": 0.654012,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88cc1c35288719309c79381bd8a907a8",
		  
		  "name": "Bianca ",
		  "createdDate": "2017-10-22 17:23:55",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 374,
		  "totalCountries": 8,
		  "totalStates": 19,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 716,
		  "schedulePercent": 0.392339,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Brisbane Convention & Exhibition Centre",
		  "mostGuestCity": "South Brisbane",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88dbf45cfc7258cb3198e387b4788dd7",
		  
		  "name": "Ferg",
		  "createdDate": "2025-03-29 12:27:47",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 73,
		  "totalCountries": 11,
		  "totalStates": 13,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 274,
		  "schedulePercent": 0.202063,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88e286f0010bda361f2f628c5b7d4b07",
		  
		  "name": "Steve",
		  "createdDate": "2021-09-22 11:11:45",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 228,
		  "totalCountries": 10,
		  "totalStates": 45,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1232,
		  "schedulePercent": 0.555417,
		  "totalGuests": 660,
		  "guestPercent": 0.774252,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88eec2aa6703a0e7e4d241de613d8ee6",
		  
		  "name": "Patrick",
		  "createdDate": "2020-02-20 12:54:45",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 204,
		  "totalCountries": 22,
		  "totalStates": 31,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 881,
		  "schedulePercent": 0.451723,
		  "totalGuests": 345,
		  "guestPercent": 0.672711,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Paramount",
		  "mostGuestCity": "Huntington",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88eed9ade31b537d378a5a5af91a5912",
		  
		  "name": "Joe ",
		  "createdDate": "2017-01-20 03:01:19",
		  "totalOrganizations": 10,
		  "totalTours": 21,
		  "totalDays": 939,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 3813,
		  "schedulePercent": 0.903332,
		  "totalGuests": 2200,
		  "guestPercent": 0.957842,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "88f53d32d69cb1a07def7c708318c6ff",
		  
		  "name": "Matt",
		  "createdDate": "2020-01-27 21:41:42",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 731,
		  "totalCountries": 28,
		  "totalStates": 78,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 3039,
		  "schedulePercent": 0.845988,
		  "totalGuests": 1275,
		  "guestPercent": 0.883046,
		  "mostGuestDate": "2025-01-29 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "891091cfe6433ffc78346905538da6ca",
		  
		  "name": "Lucas",
		  "createdDate": "2017-09-14 19:05:58",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 208,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 889,
		  "schedulePercent": 0.453649,
		  "totalGuests": 301,
		  "guestPercent": 0.650385,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "891312b0441acbe79022de4657395575",
		  
		  "name": "Martina",
		  "createdDate": "2017-07-03 22:27:51",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 930,
		  "totalCountries": 15,
		  "totalStates": 49,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 1977,
		  "schedulePercent": 0.709429,
		  "totalGuests": 638,
		  "guestPercent": 0.768812,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89208f77eb7180784fe7758950790931",
		  
		  "name": "Misty",
		  "createdDate": "2009-12-18 08:41:40",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 655,
		  "totalCountries": 12,
		  "totalStates": 38,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 3026,
		  "schedulePercent": 0.844628,
		  "totalGuests": 2099,
		  "guestPercent": 0.953989,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "892d7d17acbeaafd4afcdee7fe5bde7b",
		  
		  "name": "Jacobsen",
		  "createdDate": "2023-04-10 18:54:12",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 339,
		  "totalCountries": 24,
		  "totalStates": 83,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 2355,
		  "schedulePercent": 0.769379,
		  "totalGuests": 174,
		  "guestPercent": 0.576156,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "893470905cc96a91b5ff2d1a9559cf0f",
		  
		  "name": "Tim",
		  "createdDate": "2016-10-07 17:44:46",
		  "totalOrganizations": 9,
		  "totalTours": 28,
		  "totalDays": 525,
		  "totalCountries": 23,
		  "totalStates": 77,
		  "totalEvents": 277,
		  "eventPercent": 0.896079,
		  "totalScheduleItems": 4172,
		  "schedulePercent": 0.924071,
		  "totalGuests": 2052,
		  "guestPercent": 0.950703,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8936e89492f83e8711b8177dd2fe7792",
		  
		  "name": "Drew",
		  "createdDate": "2025-03-17 21:03:33",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 372,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1202,
		  "schedulePercent": 0.547597,
		  "totalGuests": 660,
		  "guestPercent": 0.774252,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "First Bank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89392f270305536111e8b425efce5d90",
		  
		  "name": "Rowan",
		  "createdDate": "2022-08-30 02:09:09",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 75,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 248,
		  "schedulePercent": 0.188917,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Kings Beach Tavern",
		  "mostGuestCity": "Kings Beach",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "894aaf995b0083d0ad78a1c408ade675",
		  
		  "name": "jochen",
		  "createdDate": "2025-10-28 14:34:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "895ffda78f8f5fd04b08b127fc748b0b",
		  
		  "name": "Ellen",
		  "createdDate": "2025-03-30 15:48:11",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 49,
		  "totalCountries": 5,
		  "totalStates": 1,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 198,
		  "schedulePercent": 0.159451,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "896789f0e48560142548f44e1386d86c",
		  
		  "name": "Email",
		  "createdDate": "2019-01-13 23:11:57",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 693,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 772,
		  "schedulePercent": 0.413191,
		  "totalGuests": 466,
		  "guestPercent": 0.718948,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "The Shed",
		  "mostGuestCity": "Maryville",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8972d195aa6a76477e6a1c36bd696957",
		  
		  "name": "Chris",
		  "createdDate": "2018-07-05 18:37:03",
		  "totalOrganizations": 14,
		  "totalTours": 7,
		  "totalDays": 537,
		  "totalCountries": 20,
		  "totalStates": 40,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 974,
		  "schedulePercent": 0.482434,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Islington Assembly Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "897b16ce7407d7d1e66e4d0cd5d75cc5",
		  
		  "name": "Production",
		  "createdDate": "2023-01-12 03:45:10",
		  "totalOrganizations": 654,
		  "totalTours": 142,
		  "totalDays": 3243,
		  "totalCountries": 16,
		  "totalStates": 37,
		  "totalEvents": 1083,
		  "eventPercent": 0.99626,
		  "totalScheduleItems": 9587,
		  "schedulePercent": 0.99592,
		  "totalGuests": 776,
		  "guestPercent": 0.801564,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Sidney Myer Music Bowl",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "898461d2f4878a8ef3c94e2ac311a239",
		  
		  "name": "Jai Dev",
		  "createdDate": "2014-06-09 10:14:03",
		  "totalOrganizations": 28,
		  "totalTours": 49,
		  "totalDays": 3040,
		  "totalCountries": 27,
		  "totalStates": 113,
		  "totalEvents": 937,
		  "eventPercent": 0.995014,
		  "totalScheduleItems": 12537,
		  "schedulePercent": 0.9983,
		  "totalGuests": 3311,
		  "guestPercent": 0.987761,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8988d25be849f2664fdab26f2006846f",
		  
		  "name": "Drew",
		  "createdDate": "2019-07-08 00:27:21",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 182,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1763,
		  "schedulePercent": 0.670558,
		  "totalGuests": 436,
		  "guestPercent": 0.707842,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Moody Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "898ced19f0cf809b6c4ceda52d8f7a07",
		  
		  "name": "Zachary",
		  "createdDate": "2016-07-13 18:24:20",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 729,
		  "totalCountries": 25,
		  "totalStates": 49,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 3969,
		  "schedulePercent": 0.911491,
		  "totalGuests": 699,
		  "guestPercent": 0.785358,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8993e81702011a7ff0bcc3c7502c1d76",
		  
		  "name": "William",
		  "createdDate": "2022-05-16 11:32:14",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 298,
		  "schedulePercent": 0.216795,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8997b2381d81c2e1a9f7d9ec3b8a2691",
		  
		  "name": "Dom",
		  "createdDate": "2024-05-03 12:39:09",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 300,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 239,
		  "schedulePercent": 0.184157,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89a06cd93d4225c11c1ab791dcbd20af",
		  
		  "name": "Gareth",
		  "createdDate": "2021-09-07 09:22:56",
		  "totalOrganizations": 14,
		  "totalTours": 18,
		  "totalDays": 309,
		  "totalCountries": 12,
		  "totalStates": 50,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1147,
		  "schedulePercent": 0.533545,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-09-16 00:00:00",
		  "mostGuestName": "Stanley Arts",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89a25f0160c79a06f453975c2e34c340",
		  
		  "name": "Dani",
		  "createdDate": "2015-12-15 19:54:32",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 406,
		  "totalCountries": 13,
		  "totalStates": 16,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 838,
		  "schedulePercent": 0.43665,
		  "totalGuests": 243,
		  "guestPercent": 0.621147,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "Revolution Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89bd7c4c3878795053a3b16d0b4d6c5b",
		  
		  "name": "Joy",
		  "createdDate": "2023-11-07 18:34:54",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 123,
		  "totalCountries": 21,
		  "totalStates": 34,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1081,
		  "schedulePercent": 0.514619,
		  "totalGuests": 1160,
		  "guestPercent": 0.87194,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89c4a0efee0818d09e5fd27273b239b5",
		  
		  "name": "Austen",
		  "createdDate": "2018-09-10 20:30:15",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 1533,
		  "totalCountries": 32,
		  "totalStates": 48,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 2222,
		  "schedulePercent": 0.751473,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "The Ground Miami",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89d790d3aca3f42e91e6dda2a6a30e71",
		  
		  "name": "Ian",
		  "createdDate": "2025-05-28 01:52:11",
		  "totalOrganizations": 1,
		  "totalTours": 13,
		  "totalDays": 82,
		  "totalCountries": 5,
		  "totalStates": 18,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 362,
		  "schedulePercent": 0.249093,
		  "totalGuests": 51,
		  "guestPercent": 0.454329,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Night at the Barracks",
		  "mostGuestCity": "Manly",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89e13eac58b80148ed97ef4b61e946ac",
		  
		  "name": "Ryan",
		  "createdDate": "2022-03-08 23:01:21",
		  "totalOrganizations": 67,
		  "totalTours": 54,
		  "totalDays": 1080,
		  "totalCountries": 31,
		  "totalStates": 89,
		  "totalEvents": 314,
		  "eventPercent": 0.921917,
		  "totalScheduleItems": 4562,
		  "schedulePercent": 0.940163,
		  "totalGuests": 132,
		  "guestPercent": 0.546124,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Northcote Social Club",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89ea8aa5c11f60e6f388a6213e0369c1",
		  
		  "name": "Kyo",
		  "createdDate": "2022-07-16 03:40:03",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 184,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 952,
		  "schedulePercent": 0.476541,
		  "totalGuests": 83,
		  "guestPercent": 0.499773,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "The Brighton Centre",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89f8f47e4f55667c4e51ad1d02ce40f0",
		  
		  "name": "Roy",
		  "createdDate": "2024-11-18 20:09:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 838,
		  "schedulePercent": 0.43665,
		  "totalGuests": 2357,
		  "guestPercent": 0.964189,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 391,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "89fad5341155689e23afe4f4493b69fc",
		  
		  "name": "Gemma",
		  "createdDate": "2017-05-26 01:15:00",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 204,
		  "totalCountries": 12,
		  "totalStates": 29,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1122,
		  "schedulePercent": 0.525499,
		  "totalGuests": 358,
		  "guestPercent": 0.677471,
		  "mostGuestDate": "2025-06-24 00:00:00",
		  "mostGuestName": "Radio City Music Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a0cc4d2a7c0456cd5e52f30e2b4013f",
		  
		  "name": "David",
		  "createdDate": "2017-09-26 09:08:31",
		  "totalOrganizations": 19,
		  "totalTours": 4,
		  "totalDays": 1057,
		  "totalCountries": 23,
		  "totalStates": 58,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 3044,
		  "schedulePercent": 0.846668,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a0d2788ce3b57831138ab78f7a6787e",
		  
		  "name": "Vanessa",
		  "createdDate": "2022-01-04 23:08:55",
		  "totalOrganizations": 4,
		  "totalTours": 20,
		  "totalDays": 779,
		  "totalCountries": 20,
		  "totalStates": 69,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 4158,
		  "schedulePercent": 0.922597,
		  "totalGuests": 1824,
		  "guestPercent": 0.934497,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a196625d911f158bb48e624e103e566",
		  
		  "name": "corey",
		  "createdDate": "2015-07-20 16:39:33",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 204,
		  "totalCountries": 13,
		  "totalStates": 27,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 591,
		  "schedulePercent": 0.347915,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a199bdb32e7b16daa848bb69c4fde34",
		  
		  "name": "Basak",
		  "createdDate": "2021-06-08 15:08:27",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 269,
		  "totalCountries": 7,
		  "totalStates": 38,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 924,
		  "schedulePercent": 0.466455,
		  "totalGuests": 224,
		  "guestPercent": 0.609474,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Fiddler's Green Amphitheatre",
		  "mostGuestCity": "Englewood",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a1b8f4806cf004f7810fdd21e97df2f",
		  
		  "name": "Charles",
		  "createdDate": "2017-08-25 19:32:05",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 83,
		  "totalCountries": 5,
		  "totalStates": 34,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 647,
		  "schedulePercent": 0.366387,
		  "totalGuests": 126,
		  "guestPercent": 0.541364,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Zenith Pau",
		  "mostGuestCity": "Pau",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a1e7438582a67521a96deccd70b92b3",
		  
		  "name": "Amelia",
		  "createdDate": "2021-10-20 20:30:13",
		  "totalOrganizations": 8,
		  "totalTours": 15,
		  "totalDays": 939,
		  "totalCountries": 32,
		  "totalStates": 79,
		  "totalEvents": 376,
		  "eventPercent": 0.952629,
		  "totalScheduleItems": 5307,
		  "schedulePercent": 0.962375,
		  "totalGuests": 2998,
		  "guestPercent": 0.981754,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a22c1edf07839aba77bbe7bc2cfc2ef",
		  
		  "name": "Mimosa",
		  "createdDate": "2024-02-26 11:15:43",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 937,
		  "totalCountries": 26,
		  "totalStates": 40,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1690,
		  "schedulePercent": 0.656732,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-02-09 00:00:00",
		  "mostGuestName": "Palais de Congres",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a3f900d4e2946098438640b1d752709",
		  
		  "name": "Perchik",
		  "createdDate": "2019-03-28 16:49:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 84,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 142,
		  "schedulePercent": 0.126587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a4652f739a25a9cd592c45ca33adf9f",
		  
		  "name": "Mattias",
		  "createdDate": "2015-09-08 17:40:01",
		  "totalOrganizations": 25,
		  "totalTours": 8,
		  "totalDays": 870,
		  "totalCountries": 12,
		  "totalStates": 48,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 2299,
		  "schedulePercent": 0.761673,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a49ecc6e4569ceec72d3605f5ab6c41",
		  
		  "name": "Jens",
		  "createdDate": "2022-07-24 09:27:16",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 96,
		  "totalCountries": 13,
		  "totalStates": 15,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Club Vaudeville",
		  "mostGuestCity": "Lindau (Bodensee)",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a576b0d74abe8fe0385503491147a59",
		  
		  "name": "Cade",
		  "createdDate": "2020-03-07 01:02:49",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 562,
		  "totalCountries": 5,
		  "totalStates": 50,
		  "totalEvents": 347,
		  "eventPercent": 0.941183,
		  "totalScheduleItems": 3017,
		  "schedulePercent": 0.843835,
		  "totalGuests": 144,
		  "guestPercent": 0.554624,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "The Junction Center",
		  "mostGuestCity": "Manheim",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a61c3c6a5ba06404d1744903c772aaa",
		  
		  "name": "LUIS ",
		  "createdDate": "2018-01-26 23:34:11",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 282,
		  "totalCountries": 12,
		  "totalStates": 18,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 136,
		  "schedulePercent": 0.122507,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Paper Tiger",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a6754a10c4f944a47ed0141d67f148f",
		  
		  "name": "Harrison",
		  "createdDate": "2025-06-23 21:35:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 53,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 340,
		  "schedulePercent": 0.238441,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Brewster Street Ice House",
		  "mostGuestCity": "Corpus Christi",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a6b1ce5705b9bf437bb348e34663e37",
		  
		  "name": "Jona",
		  "createdDate": "2025-03-03 10:07:52",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 34,
		  "totalCountries": 4,
		  "totalStates": 1,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a753809f569b00fd9357f01dc642af1",
		  
		  "name": "Marc",
		  "createdDate": "2018-10-08 16:23:23",
		  "totalOrganizations": 6,
		  "totalTours": 40,
		  "totalDays": 229,
		  "totalCountries": 10,
		  "totalStates": 30,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1567,
		  "schedulePercent": 0.63384,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a7c361f45bdbccbda8811cfaafc21fe",
		  
		  "name": "Jasmin",
		  "createdDate": "2024-12-11 01:59:20",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 191,
		  "totalCountries": 10,
		  "totalStates": 17,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 593,
		  "schedulePercent": 0.348595,
		  "totalGuests": 314,
		  "guestPercent": 0.656052,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a7c69f70a2596b07c8931bd128e1a49",
		  
		  "name": "Brittany",
		  "createdDate": "2018-07-04 01:50:15",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 601,
		  "totalCountries": 13,
		  "totalStates": 59,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2710,
		  "schedulePercent": 0.810063,
		  "totalGuests": 1601,
		  "guestPercent": 0.920104,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a7e745876d451f5218e27d076d84167",
		  
		  "name": "Brett",
		  "createdDate": "2019-08-04 21:52:41",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 4,
		  "totalStates": 20,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1237,
		  "schedulePercent": 0.556324,
		  "totalGuests": 263,
		  "guestPercent": 0.63078,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a813e99e0977bd9a3962bcc93586576",
		  
		  "name": "Gillian",
		  "createdDate": "2012-09-28 04:24:25",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 979,
		  "totalCountries": 9,
		  "totalStates": 30,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1458,
		  "schedulePercent": 0.608908,
		  "totalGuests": 656,
		  "guestPercent": 0.772665,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a8bad8d691ca4567bca66e19ad638d0",
		  
		  "name": "Aaron",
		  "createdDate": "2024-03-24 17:46:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 124,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Bergen Performing Arts Center",
		  "mostGuestCity": "Englewood",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a955a69d4cfea83396d0070b5f320ae",
		  
		  "name": "Chris",
		  "createdDate": "2016-12-04 10:18:19",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 80,
		  "totalCountries": 10,
		  "totalStates": 40,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 654,
		  "schedulePercent": 0.368994,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "HISTORY",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8a9e41965988e0bef1e917eb858b1d45",
		  
		  "name": "Chris",
		  "createdDate": "2023-08-18 23:05:22",
		  "totalOrganizations": 1,
		  "totalTours": 12,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 162,
		  "schedulePercent": 0.136786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8aaa461e01eb1b165815c62ba41e5ef6",
		  
		  "name": "Kevin",
		  "createdDate": "2023-08-29 21:41:50",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 603,
		  "schedulePercent": 0.351881,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8aab2f85680188eb6c6f109695c0f92e",
		  
		  "name": "Kids on tour",
		  "createdDate": "2022-11-08 16:56:04",
		  "totalOrganizations": 62,
		  "totalTours": 36,
		  "totalDays": 737,
		  "totalCountries": 24,
		  "totalStates": 58,
		  "totalEvents": 325,
		  "eventPercent": 0.93053,
		  "totalScheduleItems": 4216,
		  "schedulePercent": 0.927017,
		  "totalGuests": 749,
		  "guestPercent": 0.796011,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Event Style Festival",
		  "mostGuestCity": "Mont-Tremblant",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ab0e2017efe6e1f3e18c1131ad0a59b",
		  
		  "name": "Joana",
		  "createdDate": "2023-03-17 10:15:56",
		  "totalOrganizations": 151,
		  "totalTours": 65,
		  "totalDays": 950,
		  "totalCountries": 36,
		  "totalStates": 89,
		  "totalEvents": 511,
		  "eventPercent": 0.980394,
		  "totalScheduleItems": 4864,
		  "schedulePercent": 0.950136,
		  "totalGuests": 373,
		  "guestPercent": 0.682457,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Folketeateret",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ab255e55c906e7277c54da3107da05f",
		  
		  "name": "Justin ",
		  "createdDate": "2011-12-26 23:43:12",
		  "totalOrganizations": 13,
		  "totalTours": 22,
		  "totalDays": 642,
		  "totalCountries": 38,
		  "totalStates": 105,
		  "totalEvents": 377,
		  "eventPercent": 0.952969,
		  "totalScheduleItems": 5861,
		  "schedulePercent": 0.973935,
		  "totalGuests": 2672,
		  "guestPercent": 0.974728,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Hala Stulecia",
		  "mostGuestCity": "WrocÅ‚aw",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8abe077aa134f7d78b9b5f3700c50220",
		  
		  "name": "Vic",
		  "createdDate": "2023-05-12 09:34:29",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 908,
		  "totalCountries": 16,
		  "totalStates": 34,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 784,
		  "schedulePercent": 0.417044,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "CRSSD",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8abe9c4acee71bfedc754c01e12c105e",
		  
		  "name": "Corrie",
		  "createdDate": "2025-03-25 19:07:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 281,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1821,
		  "schedulePercent": 0.67985,
		  "totalGuests": 1306,
		  "guestPercent": 0.886899,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ad859cd973e2fcf68e64d55dc63fd7b",
		  
		  "name": "Patrick",
		  "createdDate": "2024-01-26 22:42:40",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 319,
		  "totalCountries": 11,
		  "totalStates": 47,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1118,
		  "schedulePercent": 0.524025,
		  "totalGuests": 688,
		  "guestPercent": 0.782978,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Radio City Music Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 191,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ad8c9a442b432b706f04dbf71e658d2",
		  
		  "name": "Mahalia",
		  "createdDate": "2016-10-06 19:01:07",
		  "totalOrganizations": 7,
		  "totalTours": 20,
		  "totalDays": 388,
		  "totalCountries": 9,
		  "totalStates": 46,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 882,
		  "schedulePercent": 0.451949,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ae18c74883c54e469408ff15818cb84",
		  
		  "name": "Haley",
		  "createdDate": "2018-10-01 03:29:18",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 201,
		  "totalCountries": 4,
		  "totalStates": 47,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 939,
		  "schedulePercent": 0.472121,
		  "totalGuests": 103,
		  "guestPercent": 0.522779,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Luckman Fine Arts Complex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ae971624b29d2b6a328f7c2c42fccb8",
		  
		  "name": "Paul",
		  "createdDate": "2014-02-18 01:36:33",
		  "totalOrganizations": 5,
		  "totalTours": 11,
		  "totalDays": 52,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 338,
		  "schedulePercent": 0.236967,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Tampa Theatre",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8aeef8b5677122f4da7568e985fda9a8",
		  
		  "name": "Locon",
		  "createdDate": "2025-03-05 13:57:22",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 182,
		  "totalCountries": 9,
		  "totalStates": 6,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 361,
		  "schedulePercent": 0.248753,
		  "totalGuests": 34,
		  "guestPercent": 0.426677,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Gasometer Hotel",
		  "mostGuestCity": "Collingwood",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8af0b5c1918c753b7862edb08a6c4468",
		  
		  "name": "Ethan",
		  "createdDate": "2025-03-19 22:06:21",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 283,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 12,
		  "schedulePercent": 0.0226655,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8af1b27cf410373b47960b29ebc06722",
		  
		  "name": "Libby",
		  "createdDate": "2010-06-25 23:59:31",
		  "totalOrganizations": 16,
		  "totalTours": 8,
		  "totalDays": 339,
		  "totalCountries": 16,
		  "totalStates": 24,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 1636,
		  "schedulePercent": 0.646759,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8af229dabdcb65daf4a465fd914f9c83",
		  
		  "name": "Max",
		  "createdDate": "2024-04-30 00:27:16",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 36,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 164,
		  "schedulePercent": 0.138146,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "The Chapel",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8af4835c2baefb800881858a90800da5",
		  
		  "name": "John",
		  "createdDate": "2024-02-13 23:31:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 133,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "OWA Parks & Resort",
		  "mostGuestCity": "Foley",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8af5bb5c70c1d831fca933bab57920be",
		  
		  "name": "Ryan",
		  "createdDate": "2017-12-05 20:55:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 324,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 180,
		  "schedulePercent": 0.146419,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Lumberyard",
		  "mostGuestCity": "canyon",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8afe9ea942d17638a7bb63a84971baf4",
		  
		  "name": "Charney",
		  "createdDate": "2012-05-07 06:45:40",
		  "totalOrganizations": 87,
		  "totalTours": 27,
		  "totalDays": 1144,
		  "totalCountries": 29,
		  "totalStates": 39,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 4135,
		  "schedulePercent": 0.921238,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Sydney Opera House",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b028b1c37e94b89fcb9ec1b0fafdc7d",
		  
		  "name": "Andy",
		  "createdDate": "2014-08-14 15:16:43",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 342,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1957,
		  "schedulePercent": 0.704669,
		  "totalGuests": 605,
		  "guestPercent": 0.759973,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Fallsview Casino Resort",
		  "mostGuestCity": "Niagara Falls",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b0dd5e6363f76c551094de435930915",
		  
		  "name": "Joshua",
		  "createdDate": "2022-04-10 05:40:24",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 118,
		  "totalCountries": 10,
		  "totalStates": 34,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 376,
		  "schedulePercent": 0.25612,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b134e2428dec87b20d5af8cde387bee",
		  
		  "name": "Jad",
		  "createdDate": "2019-08-26 05:37:57",
		  "totalOrganizations": 28,
		  "totalTours": 22,
		  "totalDays": 1220,
		  "totalCountries": 36,
		  "totalStates": 70,
		  "totalEvents": 355,
		  "eventPercent": 0.94413,
		  "totalScheduleItems": 5298,
		  "schedulePercent": 0.962035,
		  "totalGuests": 1478,
		  "guestPercent": 0.907298,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b177828e99f33c347bf388f3f40221f",
		  
		  "name": "Eddie",
		  "createdDate": "2016-08-11 12:24:11",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 261,
		  "totalCountries": 35,
		  "totalStates": 61,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1436,
		  "schedulePercent": 0.605281,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Pepsi Center WTC",
		  "mostGuestCity": "Benito Juarez",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b1fe28e7bee9fe8122ba228ca4d6516",
		  
		  "name": "Veronica",
		  "createdDate": "2023-01-10 12:13:14",
		  "totalOrganizations": 47,
		  "totalTours": 51,
		  "totalDays": 812,
		  "totalCountries": 29,
		  "totalStates": 42,
		  "totalEvents": 551,
		  "eventPercent": 0.984248,
		  "totalScheduleItems": 4417,
		  "schedulePercent": 0.935403,
		  "totalGuests": 726,
		  "guestPercent": 0.792044,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b2c309c1d59bc931295fec67ff3a561",
		  
		  "name": "Allen",
		  "createdDate": "2017-05-11 22:51:26",
		  "totalOrganizations": 7,
		  "totalTours": 27,
		  "totalDays": 227,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 951,
		  "schedulePercent": 0.475861,
		  "totalGuests": 401,
		  "guestPercent": 0.69481,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Commodore Ballroom",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b3305c6fde684774388b702e4110bea",
		  
		  "name": "Steve",
		  "createdDate": "2021-07-07 01:20:39",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 70,
		  "totalCountries": 9,
		  "totalStates": 13,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 383,
		  "schedulePercent": 0.259859,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Scotiabank Centre",
		  "mostGuestCity": "Halifax",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b334a882f4312a03ac93501277d53b1",
		  
		  "name": "Todd",
		  "createdDate": "2025-03-31 01:28:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 273,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 242,
		  "schedulePercent": 0.18529,
		  "totalGuests": 140,
		  "guestPercent": 0.552357,
		  "mostGuestDate": "2025-06-24 00:00:00",
		  "mostGuestName": "Iceberg Alley Performance Tent",
		  "mostGuestCity": "St. John's",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b4a937ade0b5be9cf605e3beebe308b",
		  
		  "name": "Griffin",
		  "createdDate": "2024-04-19 16:24:52",
		  "totalOrganizations": 4,
		  "totalTours": 16,
		  "totalDays": 940,
		  "totalCountries": 27,
		  "totalStates": 83,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 3048,
		  "schedulePercent": 0.847348,
		  "totalGuests": 1321,
		  "guestPercent": 0.890186,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b5dd9ecf53f97bc2a17383fd9d5def7",
		  
		  "name": "Kristian",
		  "createdDate": "2018-04-24 17:49:44",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 582,
		  "totalCountries": 34,
		  "totalStates": 49,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1732,
		  "schedulePercent": 0.664211,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Kulttuuritalo",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b5ee6c451b8a2b3511af506b0ae3e05",
		  
		  "name": "Markus",
		  "createdDate": "2015-09-15 02:07:03",
		  "totalOrganizations": 14,
		  "totalTours": 2,
		  "totalDays": 137,
		  "totalCountries": 13,
		  "totalStates": 17,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 673,
		  "schedulePercent": 0.37602,
		  "totalGuests": 581,
		  "guestPercent": 0.753286,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Turbinenhalle",
		  "mostGuestCity": "Oberhausen",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b60dc1847a87e8d871399ef1a43afcc",
		  
		  "name": "Emily ",
		  "createdDate": "2023-07-25 14:19:15",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 25,
		  "totalCountries": 4,
		  "totalStates": 4,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 198,
		  "schedulePercent": 0.159451,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b64c6c822e4e04fc75953043f6b168f",
		  
		  "name": "Greg",
		  "createdDate": "2017-02-06 19:36:43",
		  "totalOrganizations": 9,
		  "totalTours": 13,
		  "totalDays": 1366,
		  "totalCountries": 11,
		  "totalStates": 58,
		  "totalEvents": 341,
		  "eventPercent": 0.936877,
		  "totalScheduleItems": 5102,
		  "schedulePercent": 0.957162,
		  "totalGuests": 2460,
		  "guestPercent": 0.966568,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b6b4004e300ba5d6ad71819bbf2fe33",
		  
		  "name": "Jonathan",
		  "createdDate": "2024-01-28 21:40:48",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 461,
		  "totalCountries": 4,
		  "totalStates": 51,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 2113,
		  "schedulePercent": 0.734248,
		  "totalGuests": 728,
		  "guestPercent": 0.792498,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b7428eb06acd924c9f21dd50ae2f3a7",
		  
		  "name": "Daniel",
		  "createdDate": "2019-04-23 11:20:09",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 105,
		  "totalCountries": 14,
		  "totalStates": 15,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 406,
		  "schedulePercent": 0.272099,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b7702ad88f7473a848d09e4ca998958",
		  
		  "name": "Patrick",
		  "createdDate": "2015-05-14 21:01:34",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 812,
		  "totalCountries": 7,
		  "totalStates": 33,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 790,
		  "schedulePercent": 0.418971,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Dallas Bull",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b7d1dfa5efece7f549aa5dec0fc05ab",
		  
		  "name": "Dea",
		  "createdDate": "2022-09-27 17:31:42",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 218,
		  "totalCountries": 30,
		  "totalStates": 32,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1368,
		  "schedulePercent": 0.588622,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Lollapalooza Festival Argentina",
		  "mostGuestCity": "San Isidro",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b8414c8fac8bc9fdfe9515929904c34",
		  
		  "name": "Jason",
		  "createdDate": "2024-09-12 18:24:49",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 205,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 161,
		  "schedulePercent": 0.136333,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b885af28524c23025637004568e0cba",
		  
		  "name": "Dylan",
		  "createdDate": "2025-07-11 14:20:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 59,
		  "totalCountries": 11,
		  "totalStates": 15,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 172,
		  "schedulePercent": 0.141772,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "City Recital Hall",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8b889ee83827d25d52aa20339c5622ca",
		  
		  "name": "Jackie",
		  "createdDate": "2023-10-07 16:02:20",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 255,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 1039,
		  "schedulePercent": 0.50102,
		  "totalGuests": 544,
		  "guestPercent": 0.741727,
		  "mostGuestDate": "2025-09-09 00:00:00",
		  "mostGuestName": "The Rooftop at Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ba24785e6c18b22462bfeaa7459d51e",
		  
		  "name": "Sheep",
		  "a_nickname": null,
		  "createdDate": "2010-07-29 21:12:05",
		  "totalOrganizations": 19,
		  "totalTours": 21,
		  "totalDays": 1258,
		  "totalCountries": 21,
		  "totalStates": 70,
		  "totalEvents": 400,
		  "eventPercent": 0.958409,
		  "totalScheduleItems": 7914,
		  "schedulePercent": 0.990367,
		  "totalGuests": 4279,
		  "guestPercent": 0.9949,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ba8079489fd257120291826efcddbd1",
		  
		  "name": "Ross",
		  "createdDate": "2024-04-24 19:01:45",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 738,
		  "totalCountries": 17,
		  "totalStates": 52,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2857,
		  "schedulePercent": 0.827969,
		  "totalGuests": 945,
		  "guestPercent": 0.838735,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8badb179c62ad3bc37182f32252284df",
		  
		  "name": "Monica",
		  "createdDate": "2018-03-17 01:28:37",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 37,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 294,
		  "schedulePercent": 0.214415,
		  "totalGuests": 659,
		  "guestPercent": 0.773572,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8bbaa46aaa8ac5974258be2afa8d28cf",
		  
		  "name": "Amanda",
		  "createdDate": "2021-12-01 21:57:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 103,
		  "totalCountries": 21,
		  "totalStates": 15,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 341,
		  "schedulePercent": 0.239121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8bc55d265f8f5db40367d31f3159bc42",
		  
		  "name": "Callum",
		  "createdDate": "2024-01-08 21:30:48",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 127,
		  "totalCountries": 18,
		  "totalStates": 17,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1305,
		  "schedulePercent": 0.572756,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-01-03 00:00:00",
		  "mostGuestName": "The Fleece",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8bcd9f415f12c990396e2e92afd276ba",
		  
		  "name": "Elijah",
		  "createdDate": "2024-03-31 17:34:29",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 62,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 363,
		  "schedulePercent": 0.249433,
		  "totalGuests": 89,
		  "guestPercent": 0.50714,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Jacksonville Symphony",
		  "mostGuestCity": "Jacksonville",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8bd76478900dd45592829149cf33f966",
		  
		  "name": "Harry",
		  "createdDate": "2015-10-28 22:59:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 2224,
		  "schedulePercent": 0.7517,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8bde52009b26f86f0976f3a9516705cc",
		  
		  "name": "Courtney Kiara",
		  "createdDate": "2018-03-17 22:41:48",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 565,
		  "totalCountries": 15,
		  "totalStates": 39,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1759,
		  "schedulePercent": 0.670331,
		  "totalGuests": 405,
		  "guestPercent": 0.69617,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Viejas Arena",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8be1494ecec256f18aa9483897f31643",
		  
		  "name": "Joshua",
		  "createdDate": "2022-05-03 21:09:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 378,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 825,
		  "schedulePercent": 0.43257,
		  "totalGuests": 1549,
		  "guestPercent": 0.914665,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8beabffb0fd4353dc8682e9c2d160227",
		  
		  "name": "Dwight",
		  "createdDate": "2022-07-17 02:25:53",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 474,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 3644,
		  "schedulePercent": 0.891886,
		  "totalGuests": 2793,
		  "guestPercent": 0.977788,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8bed34cfb22a48f6600ae56e855ac61a",
		  
		  "name": "Marissa",
		  "createdDate": "2025-06-11 16:30:56",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 102,
		  "totalCountries": 20,
		  "totalStates": 20,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 350,
		  "schedulePercent": 0.242974,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c0d40cc9360d6d3fd5f0cc4f1c13afa",
		  
		  "name": "Steve",
		  "createdDate": "2024-06-25 16:32:34",
		  "totalOrganizations": 17,
		  "totalTours": 55,
		  "totalDays": 1284,
		  "totalCountries": 42,
		  "totalStates": 71,
		  "totalEvents": 355,
		  "eventPercent": 0.94413,
		  "totalScheduleItems": 4556,
		  "schedulePercent": 0.93971,
		  "totalGuests": 510,
		  "guestPercent": 0.733001,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Hitchin Priory",
		  "mostGuestCity": "Hitchin",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c116b5ae5bf6ae7813afbc82c485523",
		  
		  "name": "Josh",
		  "createdDate": "2012-11-16 23:06:11",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 873,
		  "totalCountries": 7,
		  "totalStates": 34,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 2415,
		  "schedulePercent": 0.776745,
		  "totalGuests": 895,
		  "guestPercent": 0.828536,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 214,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c17a34524e1a39202037ff68140d8a2",
		  
		  "name": "Jordan ",
		  "createdDate": "2025-07-05 23:33:59",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 261,
		  "schedulePercent": 0.195603,
		  "totalGuests": 165,
		  "guestPercent": 0.56947,
		  "mostGuestDate": "2025-09-01 00:00:00",
		  "mostGuestName": "John T. Floore's Country Store",
		  "mostGuestCity": "Helotes",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c27cfca9b2c050c75dc3ded1d2c6cff",
		  
		  "name": "Jeremy",
		  "createdDate": "2017-05-16 14:11:44",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 1059,
		  "totalCountries": 8,
		  "totalStates": 26,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 658,
		  "schedulePercent": 0.370807,
		  "totalGuests": 198,
		  "guestPercent": 0.593155,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c2ad0c7010d2f2bd0a1ef329c60a725",
		  
		  "name": "Davon",
		  "createdDate": "2023-01-07 06:56:18",
		  "totalOrganizations": 9,
		  "totalTours": 13,
		  "totalDays": 2284,
		  "totalCountries": 8,
		  "totalStates": 57,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 1404,
		  "schedulePercent": 0.599161,
		  "totalGuests": 193,
		  "guestPercent": 0.588169,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Republic NOLA",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c382bfb5fc8b5e3e902adf3ca0171f3",
		  
		  "name": "Mark",
		  "createdDate": "2022-05-20 09:01:13",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 96,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 383,
		  "schedulePercent": 0.259859,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-07 00:00:00",
		  "mostGuestName": "O2 Guildhall",
		  "mostGuestCity": "Southampton",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c39699575d4d8dfbe50f9f8fdcb3e2b",
		  
		  "name": "Scott",
		  "createdDate": "2019-06-22 09:11:27",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 416,
		  "totalCountries": 12,
		  "totalStates": 36,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1825,
		  "schedulePercent": 0.680417,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Arena 8888 Sofia",
		  "mostGuestCity": "Sofia",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c3f2dbd01f8216a0abad13e626f6d77",
		  
		  "name": "AVA",
		  "createdDate": "2024-06-07 19:58:58",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 349,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1508,
		  "schedulePercent": 0.61956,
		  "totalGuests": 827,
		  "guestPercent": 0.81437,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c55a930d244043a3ef188799ffd716b",
		  
		  "name": "McKinley",
		  "createdDate": "2024-01-27 01:20:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 11,
		  "totalStates": 21,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 96,
		  "schedulePercent": 0.094175,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c6298b15027534895d6a224a4706813",
		  
		  "name": "Kelley",
		  "createdDate": "2018-05-14 18:20:33",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 578,
		  "totalCountries": 5,
		  "totalStates": 49,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 2549,
		  "schedulePercent": 0.792384,
		  "totalGuests": 908,
		  "guestPercent": 0.831709,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c662d7aaed3f12e06459a9704a402e9",
		  
		  "name": "Mackenzie",
		  "createdDate": "2018-08-24 00:34:34",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 214,
		  "totalCountries": 25,
		  "totalStates": 32,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 3166,
		  "schedulePercent": 0.856641,
		  "totalGuests": 2076,
		  "guestPercent": 0.952176,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c67d7e0c24f54b1c1a0da87aaf8337e",
		  
		  "name": "Jeromy",
		  "createdDate": "2014-09-08 02:33:44",
		  "totalOrganizations": 14,
		  "totalTours": 23,
		  "totalDays": 1130,
		  "totalCountries": 28,
		  "totalStates": 89,
		  "totalEvents": 409,
		  "eventPercent": 0.961015,
		  "totalScheduleItems": 5413,
		  "schedulePercent": 0.966342,
		  "totalGuests": 2510,
		  "guestPercent": 0.968382,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c6b221acaeaa506f6c76ff9b1791d77",
		  
		  "name": "Tiffany",
		  "createdDate": "2016-12-14 09:16:17",
		  "totalOrganizations": 14,
		  "totalTours": 13,
		  "totalDays": 437,
		  "totalCountries": 15,
		  "totalStates": 57,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 2429,
		  "schedulePercent": 0.778672,
		  "totalGuests": 575,
		  "guestPercent": 0.75102,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 91,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c6f0a2cb2b26083519804055fbcd078",
		  
		  "name": "Maddison",
		  "createdDate": "2025-03-05 11:11:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 323,
		  "schedulePercent": 0.228014,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c74b72f87ed71ec694eaf8ce2989558",
		  
		  "name": "Chad",
		  "createdDate": "2016-06-02 16:50:28",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 79,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 710,
		  "schedulePercent": 0.390639,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c76d1a2dc1b39d4c252529852227cb9",
		  
		  "name": "Doug",
		  "createdDate": "2025-02-28 19:38:40",
		  "totalOrganizations": 8,
		  "totalTours": 33,
		  "totalDays": 1211,
		  "totalCountries": 20,
		  "totalStates": 75,
		  "totalEvents": 465,
		  "eventPercent": 0.973141,
		  "totalScheduleItems": 4536,
		  "schedulePercent": 0.93903,
		  "totalGuests": 761,
		  "guestPercent": 0.798617,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Million Dollar Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c79821119a2f6f01a827d88c0784955",
		  
		  "name": "Peter",
		  "createdDate": "2017-08-23 07:42:27",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 117,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1051,
		  "schedulePercent": 0.504873,
		  "totalGuests": 763,
		  "guestPercent": 0.798957,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c83c1aa091683284dda22c245567f62",
		  
		  "name": "Antoine",
		  "createdDate": "2016-06-21 12:15:35",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 432,
		  "totalCountries": 19,
		  "totalStates": 44,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1383,
		  "schedulePercent": 0.593382,
		  "totalGuests": 123,
		  "guestPercent": 0.539211,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "Koerner Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c881c57e73f3c5e9b189ab73dd71793",
		  
		  "name": "Woody",
		  "createdDate": "2017-03-23 02:27:41",
		  "totalOrganizations": 17,
		  "totalTours": 15,
		  "totalDays": 318,
		  "totalCountries": 9,
		  "totalStates": 10,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 970,
		  "schedulePercent": 0.481188,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c97dc400bc73fb28d7b68958c7d1400",
		  
		  "name": "Trevor",
		  "createdDate": "2022-01-11 20:42:27",
		  "totalOrganizations": 16,
		  "totalTours": 21,
		  "totalDays": 3070,
		  "totalCountries": 28,
		  "totalStates": 76,
		  "totalEvents": 402,
		  "eventPercent": 0.958862,
		  "totalScheduleItems": 6405,
		  "schedulePercent": 0.980734,
		  "totalGuests": 1317,
		  "guestPercent": 0.889053,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c9f9cdc3092e1d9ae6bde3d56b306ce",
		  
		  "name": "Erin",
		  "createdDate": "2025-04-23 21:08:17",
		  "totalOrganizations": 3,
		  "totalTours": 11,
		  "totalDays": 94,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8c9faea49a9ebe91d92bfc0203533f0e",
		  
		  "name": "Rose",
		  "createdDate": "2018-02-07 13:06:45",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 685,
		  "totalCountries": 24,
		  "totalStates": 39,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 3487,
		  "schedulePercent": 0.881346,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cb878b7840a90c4623d053500f5ace4",
		  
		  "name": "Jay",
		  "createdDate": "2013-03-26 16:37:13",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 546,
		  "totalCountries": 14,
		  "totalStates": 43,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1596,
		  "schedulePercent": 0.640073,
		  "totalGuests": 1938,
		  "guestPercent": 0.941636,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cb8f1977f79097f3d3c250779e43231",
		  
		  "name": "Royale",
		  "createdDate": "2024-05-03 16:10:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 38,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 301,
		  "schedulePercent": 0.217815,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cc202331f621674f62b7885002daf46",
		  
		  "name": "William",
		  "createdDate": "2018-04-05 19:08:20",
		  "totalOrganizations": 20,
		  "totalTours": 31,
		  "totalDays": 420,
		  "totalCountries": 24,
		  "totalStates": 63,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 3387,
		  "schedulePercent": 0.87432,
		  "totalGuests": 1547,
		  "guestPercent": 0.914551,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cc213a3ff3ac7ee1558a3ce0017b3a7",
		  
		  "name": "Jared",
		  "createdDate": "2023-10-26 18:09:42",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 264,
		  "totalCountries": 24,
		  "totalStates": 29,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1317,
		  "schedulePercent": 0.575476,
		  "totalGuests": 364,
		  "guestPercent": 0.67951,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "QUARTERBACK Immobilien ARENA",
		  "mostGuestCity": "Leipzig",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cc26b633e7b4c9424b06ab3b678676d",
		  
		  "name": "Mookie",
		  "createdDate": "2015-04-03 03:09:41",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 61,
		  "totalCountries": 4,
		  "totalStates": 4,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cc3b0d805f56abe6cf514d753c70210",
		  
		  "name": "Lino",
		  "createdDate": "2019-11-24 19:29:47",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 231,
		  "totalCountries": 22,
		  "totalStates": 54,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1946,
		  "schedulePercent": 0.702969,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cc6cacb8877a1631da94461c57c7f30",
		  
		  "name": "Mia",
		  "createdDate": "2022-09-21 23:42:26",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 639,
		  "totalCountries": 16,
		  "totalStates": 52,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2670,
		  "schedulePercent": 0.80519,
		  "totalGuests": 137,
		  "guestPercent": 0.550204,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Ancienne Belgique",
		  "mostGuestCity": "Brussel",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cce6834a7df55f266084f4dcbc06fe1",
		  
		  "name": "Zianna",
		  "createdDate": "2025-06-10 14:03:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 287,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1376,
		  "schedulePercent": 0.591682,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cd8011bee43e555657e5b9168e2e5de",
		  
		  "name": "Makene",
		  "createdDate": "2023-10-05 19:46:45",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 214,
		  "totalCountries": 12,
		  "totalStates": 34,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 570,
		  "schedulePercent": 0.339982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ce08ea464072bc72407f3e66b825782",
		  
		  "name": "Amanda",
		  "createdDate": "2014-04-15 14:19:45",
		  "totalOrganizations": 20,
		  "totalTours": 10,
		  "totalDays": 561,
		  "totalCountries": 31,
		  "totalStates": 52,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 3003,
		  "schedulePercent": 0.842362,
		  "totalGuests": 684,
		  "guestPercent": 0.782072,
		  "mostGuestDate": "2025-06-24 00:00:00",
		  "mostGuestName": "Radio City Music Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ce78c2205b58ed634a83c866e5524d4",
		  
		  "name": "Chris",
		  "createdDate": "2022-09-14 11:27:18",
		  "totalOrganizations": 8,
		  "totalTours": 39,
		  "totalDays": 433,
		  "totalCountries": 26,
		  "totalStates": 49,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 2168,
		  "schedulePercent": 0.74218,
		  "totalGuests": 686,
		  "guestPercent": 0.782298,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Bramall Lane",
		  "mostGuestCity": "Sheffield",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cec80a1a3c152b4c8bd082c25e1ad63",
		  
		  "name": "Alice",
		  "createdDate": "2024-01-13 15:44:53",
		  "totalOrganizations": 7,
		  "totalTours": 38,
		  "totalDays": 432,
		  "totalCountries": 39,
		  "totalStates": 81,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2906,
		  "schedulePercent": 0.832389,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-06-04 00:00:00",
		  "mostGuestName": "Zepp Shinjuku (TOKYO)",
		  "mostGuestCity": "",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cf2f1d56f11e9814b16ba2d45a21e9c",
		  
		  "name": "Shelby",
		  "createdDate": "2019-05-30 15:30:35",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 821,
		  "totalCountries": 5,
		  "totalStates": 33,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1267,
		  "schedulePercent": 0.56505,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Princess Theatre",
		  "mostGuestCity": "Decatur",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8cfa9a9c34c0e24eabe273effa6408b1",
		  
		  "name": "Maria",
		  "createdDate": "2018-12-03 13:21:36",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 276,
		  "totalCountries": 6,
		  "totalStates": 26,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1319,
		  "schedulePercent": 0.576043,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d08f6dea601e9c545a5e134220de249",
		  
		  "name": "Adam",
		  "createdDate": "2016-07-13 05:59:50",
		  "totalOrganizations": 16,
		  "totalTours": 7,
		  "totalDays": 129,
		  "totalCountries": 10,
		  "totalStates": 11,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 540,
		  "schedulePercent": 0.330349,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Freo.Social",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d0ead938b85d74331ce30776bb1b666",
		  
		  "name": "Dennis",
		  "createdDate": "2025-01-10 15:26:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 336,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 301,
		  "schedulePercent": 0.217815,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rn",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d18529b307fc74f19bc354274227ee0",
		  
		  "name": "Peter",
		  "createdDate": "2015-02-21 00:34:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 262,
		  "schedulePercent": 0.19583,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "Varsity Theater",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d2836dbee863a654602e3f8a2f589fb",
		  
		  "name": "Eva",
		  "createdDate": "2022-02-21 23:39:47",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 150,
		  "totalCountries": 26,
		  "totalStates": 49,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 2043,
		  "schedulePercent": 0.721781,
		  "totalGuests": 230,
		  "guestPercent": 0.612534,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Escenario GNP Seguros",
		  "mostGuestCity": "Monterrey",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d35e4d4928c32310ba4f258b9f61561",
		  
		  "name": "Jonathan",
		  "createdDate": "2025-04-02 19:12:45",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 132,
		  "totalCountries": 4,
		  "totalStates": 28,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 520,
		  "schedulePercent": 0.32151,
		  "totalGuests": 425,
		  "guestPercent": 0.704442,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Surly Brewing Co.",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d3724042784c3206dbf24ab4a77126f",
		  
		  "name": "Paul",
		  "createdDate": "2018-10-11 20:46:34",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 248,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2092,
		  "schedulePercent": 0.730961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d4137b6b9a0c6318d6049da6ce4b992",
		  
		  "name": "Ethan",
		  "createdDate": "2022-01-06 18:14:14",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 328,
		  "totalCountries": 31,
		  "totalStates": 78,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2140,
		  "schedulePercent": 0.738327,
		  "totalGuests": 551,
		  "guestPercent": 0.74456,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Chelsea Heights Hotel",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d4806cfc096e5a7f539764a7bd7910b",
		  
		  "name": "Danielle",
		  "createdDate": "2022-08-31 16:45:57",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 146,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1011,
		  "schedulePercent": 0.493654,
		  "totalGuests": 135,
		  "guestPercent": 0.548844,
		  "mostGuestDate": "2025-05-08 00:00:00",
		  "mostGuestName": "The Croxton Bandroom",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d492d079ba8cc30882aede1354ac33d",
		  
		  "name": "Kelsey",
		  "createdDate": "2023-07-07 19:56:17",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 1023,
		  "totalCountries": 7,
		  "totalStates": 55,
		  "totalEvents": 324,
		  "eventPercent": 0.929964,
		  "totalScheduleItems": 4298,
		  "schedulePercent": 0.93053,
		  "totalGuests": 2642,
		  "guestPercent": 0.973708,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d4aaaaf8f097da5a2336a37e8e718d5",
		  
		  "name": "Matyas",
		  "createdDate": "2014-04-23 19:32:12",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 46,
		  "totalCountries": 12,
		  "totalStates": 16,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "SO36",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d55bdf93eefeceb6adae583088d7687",
		  
		  "name": "Andy",
		  "createdDate": "2016-06-29 10:42:14",
		  "totalOrganizations": 21,
		  "totalTours": 15,
		  "totalDays": 2198,
		  "totalCountries": 29,
		  "totalStates": 60,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 3900,
		  "schedulePercent": 0.908318,
		  "totalGuests": 1316,
		  "guestPercent": 0.888939,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d5631a5dfa1bdb68bbc3939a0fd8b6a",
		  
		  "name": "Judi",
		  "createdDate": "2018-06-05 13:45:36",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 717,
		  "totalCountries": 11,
		  "totalStates": 42,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1672,
		  "schedulePercent": 0.653672,
		  "totalGuests": 608,
		  "guestPercent": 0.761219,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d601d8ff6bc7397b173887583b7c988",
		  
		  "name": "Todd",
		  "createdDate": "2016-08-07 21:30:42",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 410,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1374,
		  "schedulePercent": 0.590775,
		  "totalGuests": 692,
		  "guestPercent": 0.783772,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d6712e7cd63808544da02d916b2f44c",
		  
		  "name": "Angeline ",
		  "createdDate": "2024-10-05 23:46:55",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 566,
		  "totalCountries": 10,
		  "totalStates": 31,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 3289,
		  "schedulePercent": 0.86718,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d6b3531662f2efb9debc058872cb446",
		  
		  "name": "Mary",
		  "createdDate": "2012-07-20 07:13:06",
		  "totalOrganizations": 22,
		  "totalTours": 31,
		  "totalDays": 872,
		  "totalCountries": 7,
		  "totalStates": 53,
		  "totalEvents": 284,
		  "eventPercent": 0.901292,
		  "totalScheduleItems": 3576,
		  "schedulePercent": 0.887353,
		  "totalGuests": 1859,
		  "guestPercent": 0.936877,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d7075af5c4c200166de0705504c4573",
		  
		  "name": "Rosemary",
		  "createdDate": "2017-04-26 18:33:32",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d74fe21386c978fb7d43c15acf2d24c",
		  
		  "name": "Kristian",
		  "createdDate": "2015-11-09 08:01:16",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 282,
		  "totalCountries": 33,
		  "totalStates": 64,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1738,
		  "schedulePercent": 0.665458,
		  "totalGuests": 1526,
		  "guestPercent": 0.912738,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d75b13586b45cc16c9e8b3d644d44a5",
		  
		  "name": "Adam",
		  "createdDate": "2020-01-14 21:59:50",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 259,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1326,
		  "schedulePercent": 0.577743,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Watson Lake Park",
		  "mostGuestCity": "Prescott",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d774d4dff8a6ccb54efff786f547856",
		  
		  "name": "Jamie",
		  "createdDate": "2024-01-23 17:39:05",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 378,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d77881434ed0b7e96d34ecc374e1486",
		  
		  "name": "Felix",
		  "createdDate": "2021-10-26 02:49:52",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 369,
		  "totalCountries": 6,
		  "totalStates": 27,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 744,
		  "schedulePercent": 0.403105,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Higher Ground",
		  "mostGuestCity": "South Burlington",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d7e67a47da1fdb1460eafb792d07607",
		  
		  "name": "Daniel ",
		  "createdDate": "2016-09-19 20:45:42",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 314,
		  "totalCountries": 13,
		  "totalStates": 24,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 839,
		  "schedulePercent": 0.43699,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d8036c77a5a929ed2256fbc866aae82",
		  
		  "name": "Carine",
		  "createdDate": "2021-11-06 01:20:32",
		  "totalOrganizations": 14,
		  "totalTours": 21,
		  "totalDays": 900,
		  "totalCountries": 26,
		  "totalStates": 98,
		  "totalEvents": 480,
		  "eventPercent": 0.975408,
		  "totalScheduleItems": 5768,
		  "schedulePercent": 0.972235,
		  "totalGuests": 2239,
		  "guestPercent": 0.959542,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d940ddbd671099c40b45501c3290153",
		  
		  "name": "Klarissa",
		  "createdDate": "2014-06-09 20:38:47",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 126,
		  "schedulePercent": 0.115707,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d9c027fde1175f5b122bb540778a665",
		  
		  "name": "Simone",
		  "createdDate": "2018-05-11 09:57:13",
		  "totalOrganizations": 3,
		  "totalTours": 14,
		  "totalDays": 429,
		  "totalCountries": 16,
		  "totalStates": 60,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 2149,
		  "schedulePercent": 0.739461,
		  "totalGuests": 879,
		  "guestPercent": 0.824569,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8d9c5d8772f53c521b8c64ff5036ba91",
		  
		  "name": "Marshall",
		  "createdDate": "2014-03-18 03:54:41",
		  "totalOrganizations": 12,
		  "totalTours": 4,
		  "totalDays": 560,
		  "totalCountries": 5,
		  "totalStates": 48,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 2803,
		  "schedulePercent": 0.822303,
		  "totalGuests": 742,
		  "guestPercent": 0.794651,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Kresge Auditorium",
		  "mostGuestCity": "Interlochen",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8da95de12f257b4eb8effcf4d12a7f9d",
		  
		  "name": "C&#233;line",
		  "createdDate": "2023-05-25 11:55:53",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 266,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 737,
		  "schedulePercent": 0.400272,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "Riverstage",
		  "mostGuestCity": "Brisbane",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8daf8950ae3a0607c3ad7a46f3d5cba0",
		  
		  "name": "STEVE",
		  "createdDate": "2024-02-28 02:53:48",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 55,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 568,
		  "schedulePercent": 0.339755,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Capital One Arena",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8db1c8a31b05001d4462d2b081bdae84",
		  
		  "name": "Ricardo",
		  "createdDate": "2022-09-06 18:24:15",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 654,
		  "totalCountries": 10,
		  "totalStates": 48,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1218,
		  "schedulePercent": 0.551224,
		  "totalGuests": 262,
		  "guestPercent": 0.630553,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Infinity Hall Hartford",
		  "mostGuestCity": "Hartford",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8dbb4e7dc16118b97cd99c9a74fd1e32",
		  
		  "name": "Simon",
		  "createdDate": "2017-11-30 03:53:34",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 724,
		  "totalCountries": 18,
		  "totalStates": 57,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 3612,
		  "schedulePercent": 0.890299,
		  "totalGuests": 1769,
		  "guestPercent": 0.93155,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8dbe892ee04caaeaf5de493a67525dad",
		  
		  "name": "Andrew",
		  "createdDate": "2018-12-21 20:01:45",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 453,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 490,
		  "schedulePercent": 0.307344,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8dbf428ef3897c26f8f856c9b39d21e8",
		  
		  "name": "Forrest",
		  "createdDate": "2025-04-27 01:05:44",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 173,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 630,
		  "schedulePercent": 0.360834,
		  "totalGuests": 209,
		  "guestPercent": 0.601201,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The Regency Ballroom",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8dc49323518f62ea1efb40f14e7c0235",
		  
		  "name": "Michelle",
		  "createdDate": "2023-08-29 07:18:14",
		  "totalOrganizations": 26,
		  "totalTours": 27,
		  "totalDays": 470,
		  "totalCountries": 21,
		  "totalStates": 40,
		  "totalEvents": 328,
		  "eventPercent": 0.932004,
		  "totalScheduleItems": 2174,
		  "schedulePercent": 0.743767,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-07-16 00:00:00",
		  "mostGuestName": "Wine Mechanics",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8dcb53cde03b90b72c2c0a2e82c0f668",
		  
		  "name": "Dillon",
		  "createdDate": "2024-03-04 20:44:59",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 2049,
		  "totalCountries": 14,
		  "totalStates": 85,
		  "totalEvents": 343,
		  "eventPercent": 0.938463,
		  "totalScheduleItems": 4151,
		  "schedulePercent": 0.922257,
		  "totalGuests": 233,
		  "guestPercent": 0.614234,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e096e39ccb91f10eb69c9b41cc3195f",
		  
		  "name": "Kristin",
		  "createdDate": "2019-02-18 18:55:01",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 252,
		  "totalCountries": 17,
		  "totalStates": 48,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 3251,
		  "schedulePercent": 0.864007,
		  "totalGuests": 3261,
		  "guestPercent": 0.986741,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 160,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e0de7b52893b09b95743eca9c351e5b",
		  
		  "name": "Briget",
		  "createdDate": "2022-07-04 15:14:37",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 364,
		  "totalCountries": 11,
		  "totalStates": 55,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 2623,
		  "schedulePercent": 0.799864,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Freideck Open Air",
		  "mostGuestCity": "Cologne",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e11273c20a970af10b6a4ebc7e88c48",
		  
		  "name": "Karl",
		  "createdDate": "2021-06-17 13:51:45",
		  "totalOrganizations": 8,
		  "totalTours": 33,
		  "totalDays": 497,
		  "totalCountries": 26,
		  "totalStates": 56,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2050,
		  "schedulePercent": 0.723141,
		  "totalGuests": 602,
		  "guestPercent": 0.75884,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e13e8518dea4a3fb0ef98e74a01ba0a",
		  
		  "name": "Anders",
		  "createdDate": "2013-07-23 09:38:15",
		  "totalOrganizations": 14,
		  "totalTours": 6,
		  "totalDays": 142,
		  "totalCountries": 15,
		  "totalStates": 23,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 674,
		  "guestPercent": 0.779465,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "Vasateatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e1677c1782354d03086265e775f3fc1",
		  
		  "name": "Brian",
		  "createdDate": "2019-09-11 06:02:34",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 58,
		  "totalCountries": 5,
		  "totalStates": 24,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 385,
		  "schedulePercent": 0.260993,
		  "totalGuests": 88,
		  "guestPercent": 0.506686,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "29th Street Ballroom",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e342e8e1f175289b1af8876effd8ff2",
		  
		  "name": "Mikael",
		  "createdDate": "2017-10-18 13:25:30",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 1044,
		  "totalCountries": 5,
		  "totalStates": 18,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1614,
		  "schedulePercent": 0.642906,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Interference",
		  "mostGuestCity": "Balma",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e34c84b417261ede8b6eba107c4639e",
		  
		  "name": "Brett",
		  "createdDate": "2023-06-13 17:19:38",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 130,
		  "totalCountries": 22,
		  "totalStates": 42,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1130,
		  "schedulePercent": 0.528105,
		  "totalGuests": 567,
		  "guestPercent": 0.748413,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Electric Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e35679e2954e15be27747a5487930d0",
		  
		  "name": "Blair",
		  "createdDate": "2013-01-21 20:33:43",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 109,
		  "totalCountries": 6,
		  "totalStates": 26,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 678,
		  "schedulePercent": 0.377946,
		  "totalGuests": 478,
		  "guestPercent": 0.723255,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "London Palladium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e3bffd705e0d3e704e1d466d2bca380",
		  
		  "name": "Lisa",
		  "createdDate": "2021-11-02 18:18:07",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 100,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 137,
		  "schedulePercent": 0.123187,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Moroccan Lounge",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e3e342219a7bc97c7f9e6c7732aad13",
		  
		  "name": "Hillary",
		  "createdDate": "2021-02-04 16:29:25",
		  "totalOrganizations": 11,
		  "totalTours": 31,
		  "totalDays": 1947,
		  "totalCountries": 27,
		  "totalStates": 93,
		  "totalEvents": 417,
		  "eventPercent": 0.962715,
		  "totalScheduleItems": 6195,
		  "schedulePercent": 0.978128,
		  "totalGuests": 2249,
		  "guestPercent": 0.959882,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e40151fc50f9635eba84611a94470f5",
		  
		  "name": "Reuben",
		  "createdDate": "2022-07-18 15:33:26",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 1316,
		  "totalCountries": 15,
		  "totalStates": 28,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 1986,
		  "schedulePercent": 0.710675,
		  "totalGuests": 686,
		  "guestPercent": 0.782298,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Rama Casino",
		  "mostGuestCity": "Orillia",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e4f787eb5c3aba036270526fa279d37",
		  
		  "name": "Daniel",
		  "createdDate": "2024-04-23 22:40:33",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 556,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "The Mohawk",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e567665ed98531f0273983df927d73f",
		  
		  "name": "Annie",
		  "createdDate": "2023-05-04 00:43:03",
		  "totalOrganizations": 17,
		  "totalTours": 29,
		  "totalDays": 645,
		  "totalCountries": 20,
		  "totalStates": 68,
		  "totalEvents": 296,
		  "eventPercent": 0.910131,
		  "totalScheduleItems": 3606,
		  "schedulePercent": 0.889733,
		  "totalGuests": 1521,
		  "guestPercent": 0.912058,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e5e0ccc6dfdaf928b318e0ab07d9784",
		  
		  "name": "CONSTANTINE ",
		  "createdDate": "2023-08-14 01:57:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 493,
		  "totalCountries": 6,
		  "totalStates": 24,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 193,
		  "schedulePercent": 0.155485,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e68cda5cbb669646e3c1f4a487d883b",
		  
		  "name": "Priscilla",
		  "createdDate": "2017-03-24 22:55:20",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 138,
		  "totalCountries": 13,
		  "totalStates": 27,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 695,
		  "schedulePercent": 0.384406,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Verti Music Hall",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e6ff16cab1b1e1535ff24664d218315",
		  
		  "name": "Team",
		  "createdDate": "2022-03-15 18:06:26",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 227,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 632,
		  "schedulePercent": 0.361514,
		  "totalGuests": 192,
		  "guestPercent": 0.587262,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Chicago Theatre",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e700514162c9a6bb9225b5ed29b9190",
		  
		  "name": "Ben",
		  "createdDate": "2018-07-31 21:45:50",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 34,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e82efe4a34fd25fcd39b1253181550d",
		  
		  "name": "Wesley",
		  "createdDate": "2013-05-05 03:19:37",
		  "totalOrganizations": 24,
		  "totalTours": 31,
		  "totalDays": 1328,
		  "totalCountries": 31,
		  "totalStates": 79,
		  "totalEvents": 321,
		  "eventPercent": 0.926904,
		  "totalScheduleItems": 5166,
		  "schedulePercent": 0.958862,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8e993c60d211cc457cbb772ed8fa1a23",
		  
		  "name": "Ryland",
		  "createdDate": "2023-09-05 20:01:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 124,
		  "schedulePercent": 0.114007,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8eb290d473dd09fb45f940ce06801ca2",
		  
		  "name": "Jennifer",
		  "createdDate": "2013-09-05 16:36:16",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 772,
		  "schedulePercent": 0.413191,
		  "totalGuests": 1001,
		  "guestPercent": 0.846102,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8eb39fcdd82b4c3e829f8c39048edb84",
		  
		  "name": "Theodore",
		  "createdDate": "2010-08-20 17:27:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 2224,
		  "schedulePercent": 0.7517,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ebcc074787984007cc036c7bcf8ebe7",
		  
		  "name": "Simon",
		  "createdDate": "2018-05-22 11:19:45",
		  "totalOrganizations": 9,
		  "totalTours": 30,
		  "totalDays": 413,
		  "totalCountries": 16,
		  "totalStates": 52,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 1907,
		  "schedulePercent": 0.695943,
		  "totalGuests": 714,
		  "guestPercent": 0.788985,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ec086501f4da775acdc19720b19370b",
		  
		  "name": "Laura",
		  "createdDate": "2023-04-28 02:39:10",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 265,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1229,
		  "schedulePercent": 0.554284,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ec0c023def49bc863440b414eeb5866",
		  
		  "name": "Daniel",
		  "createdDate": "2025-01-16 15:58:42",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 250,
		  "totalCountries": 11,
		  "totalStates": 20,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 390,
		  "schedulePercent": 0.264733,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Nirwana Tuinfeest",
		  "mostGuestCity": "Lierop",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ecd29cf169ab155d9e781e31c522a7e",
		  
		  "name": "Rich",
		  "createdDate": "2020-01-06 10:11:32",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 1866,
		  "totalCountries": 17,
		  "totalStates": 50,
		  "totalEvents": 242,
		  "eventPercent": 0.863667,
		  "totalScheduleItems": 3233,
		  "schedulePercent": 0.862421,
		  "totalGuests": 140,
		  "guestPercent": 0.552357,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Chiddfest",
		  "mostGuestCity": "Chiddingly",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ecd77817b10a2406e1e338dda2b3fa2",
		  
		  "name": "Basty ",
		  "createdDate": "2017-09-28 14:03:17",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 865,
		  "totalCountries": 26,
		  "totalStates": 45,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 3901,
		  "schedulePercent": 0.908658,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ed31ee8727edc21fdccbb75c69417ae",
		  
		  "name": "Jeff",
		  "createdDate": "2020-01-08 22:20:47",
		  "totalOrganizations": 49,
		  "totalTours": 18,
		  "totalDays": 670,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 289,
		  "eventPercent": 0.904918,
		  "totalScheduleItems": 207,
		  "schedulePercent": 0.164438,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ed667c02752456f35e9335a1e9bb75f",
		  
		  "name": "HÃ©ctor Alejandro ",
		  "createdDate": "2025-04-02 15:17:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 29,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 132,
		  "schedulePercent": 0.119674,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8edad96d45fc20ea4db511cd12b9f8a6",
		  
		  "name": "Michael",
		  "createdDate": "2013-03-06 17:45:54",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 381,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2775,
		  "schedulePercent": 0.818676,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ee2468c59bd13b1f690a73e1d50fc82",
		  
		  "name": "Jayda",
		  "createdDate": "2022-07-11 18:19:14",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 143,
		  "totalCountries": 9,
		  "totalStates": 25,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 639,
		  "schedulePercent": 0.364234,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ef6864352889b827412a3f4ce97bcbf",
		  
		  "name": "Josh",
		  "createdDate": "2021-11-09 03:51:26",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 104,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8efa981fb6c5ecc1fbd8b11ec7d2f52d",
		  
		  "name": "Timothy",
		  "createdDate": "2015-12-12 05:45:32",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 78,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f1183205e72515b1a753a651f6eee03",
		  
		  "name": "Alan",
		  "createdDate": "2018-02-09 12:35:11",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 918,
		  "totalCountries": 16,
		  "totalStates": 41,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2900,
		  "schedulePercent": 0.831709,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Amaze Festival",
		  "mostGuestCity": "SmÃ¶gen",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f14a49fbd0a1d2d586415b4a12e6669",
		  
		  "name": "Highland",
		  "createdDate": "2025-04-11 02:24:53",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 33,
		  "totalCountries": 11,
		  "totalStates": 9,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 243,
		  "schedulePercent": 0.186083,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f1f5c23aba3d8447d8c54fbe6409959",
		  
		  "name": "Gabriela",
		  "createdDate": "2021-05-10 18:23:51",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 360,
		  "totalCountries": 17,
		  "totalStates": 41,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 799,
		  "schedulePercent": 0.422257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f2b77e2a392f29680926c098dd7bd6c",
		  
		  "name": "Victoire",
		  "createdDate": "2025-03-05 14:21:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 248,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f31252c98e1406d0fff655fb3659027",
		  
		  "name": "ER",
		  "createdDate": "2024-09-03 13:29:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 109,
		  "schedulePercent": 0.105054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f31f47820685d3f3c59f3a399107b4f",
		  
		  "name": "Georgie",
		  "createdDate": "2018-03-02 17:01:54",
		  "totalOrganizations": 14,
		  "totalTours": 6,
		  "totalDays": 1368,
		  "totalCountries": 20,
		  "totalStates": 47,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1252,
		  "schedulePercent": 0.561083,
		  "totalGuests": 141,
		  "guestPercent": 0.55315,
		  "mostGuestDate": "2025-01-27 00:00:00",
		  "mostGuestName": "Hoxton Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f3b8174ae5dda443b0f95d1253e6655",
		  
		  "name": "Ben Fuller",
		  "createdDate": "2024-01-05 20:27:54",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1084,
		  "totalCountries": 6,
		  "totalStates": 51,
		  "totalEvents": 315,
		  "eventPercent": 0.922484,
		  "totalScheduleItems": 4382,
		  "schedulePercent": 0.93461,
		  "totalGuests": 663,
		  "guestPercent": 0.775499,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f3bd9dec684b3e649b74caf2c6fe3fa",
		  
		  "name": "Philippe",
		  "createdDate": "2021-06-29 11:22:34",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 152,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1117,
		  "schedulePercent": 0.523119,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f5393606780aa84412c122ca3515d9b",
		  
		  "name": "Tyler",
		  "createdDate": "2022-02-04 17:55:08",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 468,
		  "totalCountries": 17,
		  "totalStates": 37,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1282,
		  "schedulePercent": 0.567996,
		  "totalGuests": 658,
		  "guestPercent": 0.773005,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f53a78e1c9318fb46517cedf1ef7f54",
		  
		  "name": "Chris",
		  "createdDate": "2023-11-23 00:12:00",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 21,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 98,
		  "schedulePercent": 0.0951949,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Neptune Theatre",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f60ac1603c2fa9d4582662b5cd9156d",
		  
		  "name": "Janelle",
		  "createdDate": "2024-09-10 07:19:18",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 144,
		  "totalCountries": 10,
		  "totalStates": 33,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 593,
		  "schedulePercent": 0.348595,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f6500251c8352bca4f9df99dfed7ae6",
		  
		  "name": "Paul",
		  "createdDate": "2010-01-14 16:48:24",
		  "totalOrganizations": 15,
		  "totalTours": 17,
		  "totalDays": 1422,
		  "totalCountries": 20,
		  "totalStates": 58,
		  "totalEvents": 369,
		  "eventPercent": 0.949229,
		  "totalScheduleItems": 3665,
		  "schedulePercent": 0.894266,
		  "totalGuests": 1556,
		  "guestPercent": 0.915798,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Sadlon Arena",
		  "mostGuestCity": "Barrie",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f67cbf022b13f7a183e4fc161918d26",
		  
		  "name": "Pamela",
		  "createdDate": "2024-09-16 03:16:56",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 280,
		  "totalCountries": 26,
		  "totalStates": 47,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 661,
		  "schedulePercent": 0.372054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f681c34ec20499dc1bd1bc6e0e8a0be",
		  
		  "name": "Chosen",
		  "createdDate": "2025-04-06 04:26:27",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 368,
		  "totalCountries": 12,
		  "totalStates": 44,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1393,
		  "schedulePercent": 0.596102,
		  "totalGuests": 740,
		  "guestPercent": 0.794198,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f6b87b137d4fbff64a78a523f636216",
		  
		  "name": "Tayler",
		  "createdDate": "2018-06-29 16:41:32",
		  "totalOrganizations": 24,
		  "totalTours": 18,
		  "totalDays": 2586,
		  "totalCountries": 9,
		  "totalStates": 56,
		  "totalEvents": 471,
		  "eventPercent": 0.973935,
		  "totalScheduleItems": 3310,
		  "schedulePercent": 0.8682,
		  "totalGuests": 488,
		  "guestPercent": 0.726995,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f6e16f9587baea65fb8a2b801e1a24a",
		  
		  "name": "Justin",
		  "createdDate": "2019-06-14 00:30:26",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 94,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 652,
		  "schedulePercent": 0.3682,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Toad's Place",
		  "mostGuestCity": "New Haven",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f6f90aff4f847179816ee531d1ac96a",
		  
		  "name": "Belinda",
		  "createdDate": "2018-06-27 18:13:23",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 563,
		  "totalCountries": 24,
		  "totalStates": 40,
		  "totalEvents": 280,
		  "eventPercent": 0.898345,
		  "totalScheduleItems": 2184,
		  "schedulePercent": 0.745467,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f710ad78772bf6c0522cdd1ae8929ea",
		  
		  "name": "Logan",
		  "createdDate": "2023-04-12 14:22:40",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 270,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1327,
		  "schedulePercent": 0.578309,
		  "totalGuests": 387,
		  "guestPercent": 0.688803,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Rupp Arena",
		  "mostGuestCity": "Lexington",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f71b244d746a57635f589b74c070b8e",
		  
		  "name": "Maxime",
		  "createdDate": "2024-04-02 20:05:53",
		  "totalOrganizations": 1,
		  "totalTours": 23,
		  "totalDays": 423,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 218,
		  "schedulePercent": 0.170558,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "La Place, centre culturel Hip-Hop",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f76c1c52577e1fbab980969e3e6a014",
		  
		  "name": "Rob",
		  "createdDate": "2017-10-01 01:14:08",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 422,
		  "totalCountries": 23,
		  "totalStates": 57,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 3361,
		  "schedulePercent": 0.871827,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f79911a4ae95e688cc42e4d090b68d3",
		  
		  "name": "Megan",
		  "createdDate": "2023-03-13 17:31:37",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 2063,
		  "schedulePercent": 0.726655,
		  "totalGuests": 421,
		  "guestPercent": 0.702969,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Buckhead Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f7f2bc8d27cfd7d8597c39144fceedf",
		  
		  "name": "Nathan",
		  "createdDate": "2014-07-15 22:06:33",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 155,
		  "totalCountries": 2,
		  "totalStates": 37,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1507,
		  "schedulePercent": 0.618994,
		  "totalGuests": 1835,
		  "guestPercent": 0.935177,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 203,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f808a236f924a043fc27fedc02b9da7",
		  
		  "name": "Laura",
		  "createdDate": "2020-01-27 14:48:18",
		  "totalOrganizations": 10,
		  "totalTours": 23,
		  "totalDays": 1251,
		  "totalCountries": 34,
		  "totalStates": 61,
		  "totalEvents": 403,
		  "eventPercent": 0.959429,
		  "totalScheduleItems": 6029,
		  "schedulePercent": 0.975861,
		  "totalGuests": 847,
		  "guestPercent": 0.819243,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wythenshawe Park and Gardens",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f83cac45b800a635538b7ac177c5e28",
		  
		  "name": "Lee ",
		  "createdDate": "2021-04-29 05:12:18",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 118,
		  "totalCountries": 1,
		  "totalStates": 8,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 751,
		  "schedulePercent": 0.405598,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "The Palms",
		  "mostGuestCity": "Southbank",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f96994a6431a7777e4a22a83571a0f8",
		  
		  "name": "Dave",
		  "createdDate": "2012-05-07 23:37:58",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 362,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8f9df5e3ddc815971bee504306eaf6c0",
		  
		  "name": "Mark",
		  "createdDate": "2017-04-22 14:20:58",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 67,
		  "totalCountries": 10,
		  "totalStates": 26,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 506,
		  "schedulePercent": 0.31403,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fa243eea1975ddac8bc9b7b467a47ba",
		  
		  "name": "Mischa",
		  "createdDate": "2024-03-29 07:39:27",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 149,
		  "totalCountries": 31,
		  "totalStates": 33,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1264,
		  "schedulePercent": 0.564483,
		  "totalGuests": 524,
		  "guestPercent": 0.737194,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "Voxhall",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fa6c80e2c532fd775be2edc935a3116",
		  
		  "name": "Stefan",
		  "createdDate": "2015-05-04 14:59:44",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 510,
		  "schedulePercent": 0.315503,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Festwiese",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8faee8681209559e8ef84cc9dea91f9d",
		  
		  "name": "Robert",
		  "createdDate": "2024-10-12 17:13:46",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 43,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 179,
		  "schedulePercent": 0.145852,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "The Grizzly Rose",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fb176d8499deffdf9e348f32b97f33f",
		  
		  "name": "Nina",
		  "createdDate": "2020-02-24 11:37:38",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 190,
		  "guestPercent": 0.585902,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fb5207575940761977cbc8341fb9b13",
		  
		  "name": "VARMAH",
		  "createdDate": "2018-10-15 05:35:49",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 226,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fb8854aed609e1dd1bdcb984e41529f",
		  
		  "name": "Walter",
		  "createdDate": "2017-11-04 19:55:46",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 1371,
		  "totalCountries": 14,
		  "totalStates": 33,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 1033,
		  "schedulePercent": 0.499547,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fc712b5297d88139101ddf6c7e89f2f",
		  
		  "name": "thomas",
		  "createdDate": "2022-06-27 17:37:26",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 601,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 1065,
		  "schedulePercent": 0.50816,
		  "totalGuests": 372,
		  "guestPercent": 0.68189,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 106,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fcaf0784656d08c47799904fb27cfc5",
		  
		  "name": "NEICEE ",
		  "createdDate": "2016-06-08 17:19:33",
		  "totalOrganizations": 19,
		  "totalTours": 28,
		  "totalDays": 910,
		  "totalCountries": 28,
		  "totalStates": 39,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 2308,
		  "schedulePercent": 0.762806,
		  "totalGuests": 212,
		  "guestPercent": 0.603921,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "SunBet Arena at Time Square Casino",
		  "mostGuestCity": "Pretoria",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fd3916c24fc844ab1b9b4ed43578a50",
		  
		  "name": "Ben",
		  "createdDate": "2013-01-28 16:14:01",
		  "totalOrganizations": 19,
		  "totalTours": 25,
		  "totalDays": 1423,
		  "totalCountries": 24,
		  "totalStates": 85,
		  "totalEvents": 506,
		  "eventPercent": 0.980054,
		  "totalScheduleItems": 6614,
		  "schedulePercent": 0.983454,
		  "totalGuests": 1413,
		  "guestPercent": 0.901405,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "MGM Grand",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fd5eecb038b015a8888bb8a64b719c5",
		  
		  "name": "Jonas",
		  "createdDate": "2022-05-12 19:16:41",
		  "totalOrganizations": 28,
		  "totalTours": 24,
		  "totalDays": 277,
		  "totalCountries": 23,
		  "totalStates": 29,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 1512,
		  "schedulePercent": 0.620467,
		  "totalGuests": 456,
		  "guestPercent": 0.714869,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Tivoli",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fde68a331d016882741c512596ba597",
		  
		  "name": "Benjamin",
		  "createdDate": "2023-08-03 22:44:31",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 449,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2978,
		  "schedulePercent": 0.840435,
		  "totalGuests": 609,
		  "guestPercent": 0.761559,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8fea29c51ae64fbe830892fcb2701828",
		  
		  "name": "Greg",
		  "createdDate": "2018-07-23 15:20:44",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 98,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 915,
		  "schedulePercent": 0.463055,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "The Caverns",
		  "mostGuestCity": "Pelham",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "8ff3123d978065de7cbe82d58873e3b0",
		  
		  "name": "Dan",
		  "createdDate": "2023-02-02 01:34:37",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 698,
		  "totalCountries": 22,
		  "totalStates": 34,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2216,
		  "schedulePercent": 0.75068,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Brisbane Entertainment Centre",
		  "mostGuestCity": "Boondall",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90003e6cd698e4762b2df699998437ca",
		  
		  "name": "Kenn",
		  "createdDate": "2013-10-28 21:12:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 2633,
		  "schedulePercent": 0.801224,
		  "totalGuests": 580,
		  "guestPercent": 0.752607,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "House of Blues Myrtle Beach",
		  "mostGuestCity": "North Myrtle Beach",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "900f15283339ab4c6f656800d784ebe0",
		  
		  "name": "Alison",
		  "createdDate": "2023-06-10 16:09:13",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 265,
		  "totalCountries": 22,
		  "totalStates": 26,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1538,
		  "schedulePercent": 0.624887,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9013e41e40f7abce9940d72fb50c5c55",
		  
		  "name": "Kevin",
		  "createdDate": "2019-10-31 22:53:07",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 733,
		  "totalCountries": 7,
		  "totalStates": 25,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 102,
		  "schedulePercent": 0.0980281,
		  "totalGuests": 163,
		  "guestPercent": 0.568223,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Baltimore City Hall",
		  "mostGuestCity": "Baltimore",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "901888d2488f85e7089718970196dc74",
		  
		  "name": "Carsten",
		  "createdDate": "2019-05-13 20:24:29",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 51,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 271,
		  "schedulePercent": 0.200023,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "901b47aec862c425f2bf279ee7434356",
		  
		  "name": "Frank",
		  "createdDate": "2014-05-27 12:28:47",
		  "totalOrganizations": 13,
		  "totalTours": 8,
		  "totalDays": 324,
		  "totalCountries": 20,
		  "totalStates": 16,
		  "totalEvents": 268,
		  "eventPercent": 0.888599,
		  "totalScheduleItems": 2159,
		  "schedulePercent": 0.741047,
		  "totalGuests": 667,
		  "guestPercent": 0.776745,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Tivoli",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "901e4695e013d50a8e7e12b20b160ab1",
		  
		  "name": "Florencia",
		  "createdDate": "2023-12-05 14:51:50",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 305,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1481,
		  "schedulePercent": 0.612987,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90243dadd71e38f06a34fe0ff681d90e",
		  
		  "name": "Robyn",
		  "createdDate": "2012-05-02 08:14:25",
		  "totalOrganizations": 77,
		  "totalTours": 37,
		  "totalDays": 766,
		  "totalCountries": 24,
		  "totalStates": 70,
		  "totalEvents": 351,
		  "eventPercent": 0.942883,
		  "totalScheduleItems": 5334,
		  "schedulePercent": 0.963735,
		  "totalGuests": 279,
		  "guestPercent": 0.639166,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Qudos Bank Arena",
		  "mostGuestCity": "Sydney Olympic Park",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "902858253be68719e40bb113981db183",
		  
		  "name": "Airyn",
		  "createdDate": "2013-02-19 21:14:48",
		  "totalOrganizations": 18,
		  "totalTours": 13,
		  "totalDays": 884,
		  "totalCountries": 6,
		  "totalStates": 56,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 2358,
		  "schedulePercent": 0.769606,
		  "totalGuests": 853,
		  "guestPercent": 0.820263,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "The Empire Theatre",
		  "mostGuestCity": "Belleville",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90430077010b3d6e764bfd9048cb3d61",
		  
		  "name": "Heidi",
		  "createdDate": "2012-01-05 18:40:02",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 292,
		  "totalCountries": 17,
		  "totalStates": 49,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 1871,
		  "schedulePercent": 0.689597,
		  "totalGuests": 1687,
		  "guestPercent": 0.927584,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90434aac1bb3cebba5126d649f2b63e2",
		  
		  "name": "Soren",
		  "createdDate": "2013-05-13 13:53:57",
		  "totalOrganizations": 36,
		  "totalTours": 13,
		  "totalDays": 191,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 1072,
		  "schedulePercent": 0.511559,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "904dc635eea9c3d86cdcb80fee6a3aa8",
		  
		  "name": "Vavoom",
		  "createdDate": "2022-04-19 10:35:01",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 1209,
		  "totalCountries": 29,
		  "totalStates": 42,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 937,
		  "schedulePercent": 0.471328,
		  "totalGuests": 107,
		  "guestPercent": 0.526292,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "The Green Room Byron",
		  "mostGuestCity": "Tyagarah",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "904ec279693c28f1eab42f1a63bc7482",
		  
		  "name": "Liam ",
		  "createdDate": "2014-10-14 11:36:56",
		  "totalOrganizations": 16,
		  "totalTours": 25,
		  "totalDays": 128,
		  "totalCountries": 11,
		  "totalStates": 17,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 595,
		  "schedulePercent": 0.349501,
		  "totalGuests": 330,
		  "guestPercent": 0.666138,
		  "mostGuestDate": "2025-01-22 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "904f479538db521f8336621b08a3edaf",
		  
		  "name": "Scott",
		  "createdDate": "2019-09-19 07:15:42",
		  "totalOrganizations": 74,
		  "totalTours": 43,
		  "totalDays": 2072,
		  "totalCountries": 37,
		  "totalStates": 108,
		  "totalEvents": 515,
		  "eventPercent": 0.980621,
		  "totalScheduleItems": 7189,
		  "schedulePercent": 0.987647,
		  "totalGuests": 1545,
		  "guestPercent": 0.914098,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "904f772e2cd6fb8dc8308d683e37ec67",
		  
		  "name": "Ava",
		  "createdDate": "2022-02-14 10:08:12",
		  "totalOrganizations": 18,
		  "totalTours": 15,
		  "totalDays": 4051,
		  "totalCountries": 10,
		  "totalStates": 24,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 1776,
		  "schedulePercent": 0.671917,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Atabal",
		  "mostGuestCity": "Biarritz",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9055c0b12f5b80bc0c07023a27e572ab",
		  
		  "name": "Maxime ",
		  "createdDate": "2016-05-23 20:25:16",
		  "totalOrganizations": 25,
		  "totalTours": 6,
		  "totalDays": 598,
		  "totalCountries": 14,
		  "totalStates": 33,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1021,
		  "schedulePercent": 0.496374,
		  "totalGuests": 574,
		  "guestPercent": 0.750567,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Seattle Woodland Park Zoo",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90662e56113358b91bdb08ed9f9fbde0",
		  
		  "name": "Bintou-Elise",
		  "createdDate": "2018-09-25 11:49:01",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 63,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 469,
		  "schedulePercent": 0.297937,
		  "totalGuests": 204,
		  "guestPercent": 0.597915,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Banan-Kompaniet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9068b969cc4efa92fb86a2e2c5205360",
		  
		  "name": "Caitlin",
		  "createdDate": "2018-04-27 05:21:43",
		  "totalOrganizations": 20,
		  "totalTours": 6,
		  "totalDays": 609,
		  "totalCountries": 14,
		  "totalStates": 56,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1554,
		  "schedulePercent": 0.631233,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-09-01 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9074e38b56a618143bfcc1cef8e0da09",
		  
		  "name": "Noah",
		  "createdDate": "2019-11-22 22:40:40",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 139,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1106,
		  "schedulePercent": 0.520286,
		  "totalGuests": 614,
		  "guestPercent": 0.762579,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Canada Life Place",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90761b2f9f235e91b04ac4d0d7f99305",
		  
		  "name": "Erik",
		  "createdDate": "2020-01-26 23:35:11",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9078c88104682a92a11fb5266dfa152c",
		  
		  "name": "Liryca",
		  "createdDate": "2025-09-18 23:47:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 47,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "909a33c59c7f26dd9c323c9d3efc618c",
		  
		  "name": "Gordon",
		  "createdDate": "2022-06-24 10:41:35",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 1012,
		  "totalCountries": 26,
		  "totalStates": 41,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 3312,
		  "schedulePercent": 0.868314,
		  "totalGuests": 172,
		  "guestPercent": 0.575136,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90a67e55883488ae0038eaea01a858ce",
		  
		  "name": "Riley",
		  "createdDate": "2024-12-23 16:53:06",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 83,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 935,
		  "schedulePercent": 0.470988,
		  "totalGuests": 2696,
		  "guestPercent": 0.975635,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90d33eec61e5e8f27ab3173ed49d8c22",
		  
		  "name": "Cameron",
		  "createdDate": "2016-08-23 16:17:36",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 497,
		  "totalCountries": 21,
		  "totalStates": 63,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 4473,
		  "schedulePercent": 0.93733,
		  "totalGuests": 2377,
		  "guestPercent": 0.964755,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90d4b83fb88e3754713468b0ff4ca2f6",
		  
		  "name": "Matt",
		  "createdDate": "2023-06-28 01:45:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 77,
		  "totalCountries": 4,
		  "totalStates": 14,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 271,
		  "schedulePercent": 0.200023,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-02-04 00:00:00",
		  "mostGuestName": "SWG3 Studio Warehouse",
		  "mostGuestCity": "",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90dc3ef00bff41a87a00f862f443bb02",
		  
		  "name": "Danny",
		  "createdDate": "2023-07-10 18:42:05",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 331,
		  "totalCountries": 18,
		  "totalStates": 23,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 1442,
		  "schedulePercent": 0.606188,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Centro de Eventos El Pedregal ",
		  "mostGuestCity": "",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90dd9cfef86cfa831a7e4af71a26d567",
		  
		  "name": "Tess",
		  "createdDate": "2021-05-24 23:40:56",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 50,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 510,
		  "schedulePercent": 0.315503,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90f00d1f463a2a2d535947ae0d795a21",
		  
		  "name": "Jake",
		  "createdDate": "2022-04-09 13:44:03",
		  "totalOrganizations": 13,
		  "totalTours": 15,
		  "totalDays": 1887,
		  "totalCountries": 8,
		  "totalStates": 58,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 3553,
		  "schedulePercent": 0.884973,
		  "totalGuests": 1736,
		  "guestPercent": 0.929624,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "90fe6a035564519d0919e9869e8fca63",
		  
		  "name": "Phillip",
		  "createdDate": "2017-02-23 01:30:49",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 278,
		  "schedulePercent": 0.204216,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "910679bbab6b6c1e3f1bdafb28cc7658",
		  
		  "name": "Taylor",
		  "createdDate": "2016-05-14 10:23:27",
		  "totalOrganizations": 7,
		  "totalTours": 1,
		  "totalDays": 146,
		  "totalCountries": 8,
		  "totalStates": 25,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1156,
		  "schedulePercent": 0.536151,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9109ef3be3a2305f193830553e79383f",
		  
		  "name": "Koan",
		  "createdDate": "2025-04-03 19:20:00",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 125,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 338,
		  "schedulePercent": 0.236967,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Gamma Ray Bar",
		  "mostGuestCity": "Madison",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91138cd120787781f6b9c39f86cb6a32",
		  
		  "name": "Michael",
		  "createdDate": "2024-11-04 20:27:31",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 812,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1176,
		  "schedulePercent": 0.541251,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "911a9af1daa9647d147d8b70fc040f64",
		  
		  "name": "Hugh Chad",
		  "createdDate": "2025-01-08 13:47:16",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 476,
		  "totalCountries": 13,
		  "totalStates": 36,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1523,
		  "schedulePercent": 0.622393,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Kaufleuten Klub",
		  "mostGuestCity": "ZÃ¼rich",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "911b69e4394085d3ca8a63837c83dde4",
		  
		  "name": "Mathilde",
		  "createdDate": "2018-08-07 16:19:55",
		  "totalOrganizations": 21,
		  "totalTours": 53,
		  "totalDays": 484,
		  "totalCountries": 29,
		  "totalStates": 44,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 2637,
		  "schedulePercent": 0.801677,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-03-16 00:00:00",
		  "mostGuestName": "ImpÃ©rial Bell",
		  "mostGuestCity": "QuÃ©bec",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91218175089ff9b86270214bddbe58e1",
		  
		  "name": "Letisha",
		  "createdDate": "2023-03-20 04:32:38",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 103,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 580,
		  "schedulePercent": 0.343608,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "912248f288c177f050f699f65ddcdcca",
		  
		  "name": "Shannon ",
		  "createdDate": "2018-05-06 22:10:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 348,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 629,
		  "schedulePercent": 0.360381,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "912adb22e43478bc043e47d1eabf06ad",
		  
		  "name": "MMG",
		  "createdDate": "2021-09-28 23:45:17",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 772,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 890,
		  "schedulePercent": 0.453989,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "City Vineyard",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "912e8f4d92f5ab8b778ff9a3cb0b097c",
		  
		  "name": "Travis",
		  "createdDate": "2023-06-20 11:17:00",
		  "totalOrganizations": 16,
		  "totalTours": 17,
		  "totalDays": 1106,
		  "totalCountries": 28,
		  "totalStates": 71,
		  "totalEvents": 384,
		  "eventPercent": 0.954782,
		  "totalScheduleItems": 5777,
		  "schedulePercent": 0.972461,
		  "totalGuests": 270,
		  "guestPercent": 0.634746,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "The Night Cat",
		  "mostGuestCity": "Fitzroy",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91359ad0fdbc29e264a1f17b7724ab78",
		  
		  "name": "Seth",
		  "createdDate": "2010-04-15 18:25:24",
		  "totalOrganizations": 19,
		  "totalTours": 3,
		  "totalDays": 76,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 644,
		  "schedulePercent": 0.365367,
		  "totalGuests": 333,
		  "guestPercent": 0.666931,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9140305a318ceaa581ec6436905853f7",
		  
		  "name": "James",
		  "createdDate": "2022-07-19 18:03:31",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 1085,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 1520,
		  "schedulePercent": 0.621827,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Musikfest Cafe",
		  "mostGuestCity": "Bethlehem",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "915c23ab79534e535de8d514c223b3d3",
		  
		  "name": "Asa",
		  "createdDate": "2017-04-18 13:58:22",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 133,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1743,
		  "schedulePercent": 0.666591,
		  "totalGuests": 1311,
		  "guestPercent": 0.887693,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9163c76702f51d3d5cbf012fc24ce152",
		  
		  "name": "Jonathan",
		  "createdDate": "2023-03-13 23:19:06",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 260,
		  "totalCountries": 8,
		  "totalStates": 32,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 1606,
		  "schedulePercent": 0.641319,
		  "totalGuests": 373,
		  "guestPercent": 0.682457,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Smart Financial Centre at Sugar Land",
		  "mostGuestCity": "Sugar Land",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9163f667d353fdd6c9bbc758577d3ab0",
		  
		  "name": "Bluey",
		  "createdDate": "2023-06-11 16:39:35",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 336,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 1018,
		  "schedulePercent": 0.49592,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "918411ba2ca76826fba304d27333b0f3",
		  
		  "name": "Scooter",
		  "createdDate": "2020-01-08 00:27:54",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 524,
		  "totalCountries": 6,
		  "totalStates": 47,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1496,
		  "schedulePercent": 0.616954,
		  "totalGuests": 374,
		  "guestPercent": 0.683137,
		  "mostGuestDate": "2025-03-18 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91847910faef274a4d858ef32fe90eda",
		  
		  "name": "Trish",
		  "createdDate": "2021-10-12 21:37:03",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 168,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 501,
		  "schedulePercent": 0.312443,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "918aeaff2583e21b54ea64c5d34f1ca0",
		  
		  "name": "Stephanie",
		  "createdDate": "2015-01-20 22:19:32",
		  "totalOrganizations": 23,
		  "totalTours": 8,
		  "totalDays": 328,
		  "totalCountries": 36,
		  "totalStates": 44,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 2263,
		  "schedulePercent": 0.757253,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Teatro MetropÃ³litan",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "918bedf2e349c570231fef3242ea62a0",
		  
		  "name": "Marjorie",
		  "createdDate": "2023-05-08 05:52:46",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 732,
		  "totalCountries": 23,
		  "totalStates": 34,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2582,
		  "schedulePercent": 0.795898,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Brisbane Entertainment Centre",
		  "mostGuestCity": "Boondall",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "919c7c91b015b0a8262cda4d4355224f",
		  
		  "name": "Daniel",
		  "createdDate": "2023-09-13 20:11:17",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 814,
		  "totalCountries": 5,
		  "totalStates": 23,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 672,
		  "schedulePercent": 0.375793,
		  "totalGuests": 204,
		  "guestPercent": 0.597915,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Licorice Pizza Records",
		  "mostGuestCity": "Studio City",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91a6bf55712faa6f49f2cd4267bba434",
		  
		  "name": "Corey ",
		  "createdDate": "2022-03-05 20:51:42",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 311,
		  "totalCountries": 20,
		  "totalStates": 63,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1474,
		  "schedulePercent": 0.611741,
		  "totalGuests": 208,
		  "guestPercent": 0.600521,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "O2 Academy Islington",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91aabf208af34b5e0e07d5b45e97fe34",
		  
		  "name": "CÃ©cilia",
		  "createdDate": "2025-08-29 10:03:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 111,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 556,
		  "schedulePercent": 0.335789,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91ad83382c84116fa17cdde89555be53",
		  
		  "name": "Little Daggers Touring AS",
		  "createdDate": "2023-05-22 18:10:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 10,
		  "totalStates": 9,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 303,
		  "schedulePercent": 0.218608,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91b301a3c97d1a4c1dde4f39f847456e",
		  
		  "name": "Kaylee",
		  "createdDate": "2018-09-17 08:43:23",
		  "totalOrganizations": 25,
		  "totalTours": 21,
		  "totalDays": 302,
		  "totalCountries": 21,
		  "totalStates": 24,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 1898,
		  "schedulePercent": 0.694016,
		  "totalGuests": 51,
		  "guestPercent": 0.454329,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Store Vega",
		  "mostGuestCity": "Copenhagen",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91b8652f89d483fe07d595ed437bdc1c",
		  
		  "name": "Jeffrey",
		  "createdDate": "2009-10-20 21:17:24",
		  "totalOrganizations": 10,
		  "totalTours": 14,
		  "totalDays": 331,
		  "totalCountries": 7,
		  "totalStates": 29,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 821,
		  "schedulePercent": 0.431324,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Lucas Oil Live at WinStar World Casino",
		  "mostGuestCity": "Thackerville",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91bc4a98adf67bfd5781cba6b3e7f823",
		  
		  "name": "Jax",
		  "createdDate": "2025-07-16 22:02:48",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 148,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1273,
		  "schedulePercent": 0.56607,
		  "totalGuests": 46,
		  "guestPercent": 0.446623,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The Hall",
		  "mostGuestCity": "Little Rock",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91d48d838081e8abc896ae68359da514",
		  
		  "name": "Melissa",
		  "createdDate": "2019-09-09 22:57:56",
		  "totalOrganizations": 4,
		  "totalTours": 14,
		  "totalDays": 522,
		  "totalCountries": 6,
		  "totalStates": 29,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 899,
		  "schedulePercent": 0.457842,
		  "totalGuests": 285,
		  "guestPercent": 0.641999,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Lincoln Financial Field",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91e3b7c9dea6da8dcb31b585de102612",
		  
		  "name": "Dominique",
		  "createdDate": "2015-10-29 16:05:48",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 81,
		  "totalCountries": 17,
		  "totalStates": 14,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 376,
		  "guestPercent": 0.68427,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Salle Wilfrid-Pelletier",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91eeb15c294837fcbb22228c5ea4bbbe",
		  
		  "name": "Bittersweethearts",
		  "createdDate": "2022-12-22 22:12:18",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 43,
		  "totalCountries": 10,
		  "totalStates": 8,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 139,
		  "schedulePercent": 0.123867,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91ef71a13ccef37efa8154447f351957",
		  
		  "name": "Hayden",
		  "createdDate": "2022-08-30 22:51:08",
		  "totalOrganizations": 5,
		  "totalTours": 15,
		  "totalDays": 748,
		  "totalCountries": 8,
		  "totalStates": 58,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2254,
		  "schedulePercent": 0.755553,
		  "totalGuests": 933,
		  "guestPercent": 0.836355,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91f398ddfdaf44d85aa24912c0fb3429",
		  
		  "name": "Max",
		  "createdDate": "2018-07-13 20:31:25",
		  "totalOrganizations": 14,
		  "totalTours": 21,
		  "totalDays": 412,
		  "totalCountries": 30,
		  "totalStates": 59,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 1484,
		  "schedulePercent": 0.614121,
		  "totalGuests": 417,
		  "guestPercent": 0.700363,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91f3eaf0b13e39124d351f3ff3ae291d",
		  
		  "name": "Tom",
		  "createdDate": "2019-12-20 01:16:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 333,
		  "schedulePercent": 0.233454,
		  "totalGuests": 228,
		  "guestPercent": 0.611514,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Wind Creek Bethlehem",
		  "mostGuestCity": "Bethlehem",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "91f7ca02de8d9d28fefa51acdcc8961f",
		  
		  "name": "Michel",
		  "createdDate": "2025-11-01 01:45:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 5,
		  "schedulePercent": 0.0151859,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "920494a02bddb139164092a99ddf6851",
		  
		  "name": "Vasco",
		  "createdDate": "2023-01-24 18:44:17",
		  "totalOrganizations": 18,
		  "totalTours": 18,
		  "totalDays": 535,
		  "totalCountries": 18,
		  "totalStates": 11,
		  "totalEvents": 452,
		  "eventPercent": 0.971781,
		  "totalScheduleItems": 4345,
		  "schedulePercent": 0.93291,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92076257181df148eebe5f8ed6e4bce7",
		  
		  "name": "David",
		  "createdDate": "2015-12-23 00:24:17",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 68,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 312,
		  "schedulePercent": 0.223481,
		  "totalGuests": 299,
		  "guestPercent": 0.649139,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Intuit Dome",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9223a48799c8dc0c2c465b07a7c4832f",
		  
		  "name": "IBRAHIM",
		  "createdDate": "2023-11-10 19:22:21",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 482,
		  "totalCountries": 17,
		  "totalStates": 56,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1548,
		  "schedulePercent": 0.626587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "922640e9d4b8de68c383185b72ee9c5c",
		  
		  "name": "Michael",
		  "createdDate": "2024-04-08 12:02:20",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 192,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "922a4a514cac50c5c31ff2bbe807cb3c",
		  
		  "name": "Jobi",
		  "createdDate": "2024-11-18 19:33:49",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 82,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 800,
		  "schedulePercent": 0.422597,
		  "totalGuests": 163,
		  "guestPercent": 0.568223,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "922cffb3d4a006113a028c26dc814354",
		  
		  "name": "Eddie",
		  "createdDate": "2020-01-17 22:58:05",
		  "totalOrganizations": 33,
		  "totalTours": 22,
		  "totalDays": 444,
		  "totalCountries": 17,
		  "totalStates": 41,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1979,
		  "schedulePercent": 0.709542,
		  "totalGuests": 1579,
		  "guestPercent": 0.917498,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92348bbe78b2aaf384513044b28ed1c5",
		  
		  "name": "Joe",
		  "createdDate": "2022-09-10 17:20:58",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 1049,
		  "totalCountries": 4,
		  "totalStates": 62,
		  "totalEvents": 484,
		  "eventPercent": 0.976088,
		  "totalScheduleItems": 7020,
		  "schedulePercent": 0.986627,
		  "totalGuests": 792,
		  "guestPercent": 0.805984,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9237cefbb78459924b85352c49ce6520",
		  
		  "name": "Taahira",
		  "createdDate": "2024-09-02 22:45:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 231,
		  "schedulePercent": 0.178377,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Majestic Theatre",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "923fbe5bb17b3f177ba4eed1acff28dc",
		  
		  "name": "Doug",
		  "createdDate": "2017-12-07 23:11:23",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 164,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 296,
		  "schedulePercent": 0.215549,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9241259041b3f0343126f44edea84e51",
		  
		  "name": "Owen",
		  "createdDate": "2014-02-08 16:54:59",
		  "totalOrganizations": 102,
		  "totalTours": 50,
		  "totalDays": 1056,
		  "totalCountries": 22,
		  "totalStates": 39,
		  "totalEvents": 285,
		  "eventPercent": 0.901859,
		  "totalScheduleItems": 3713,
		  "schedulePercent": 0.896872,
		  "totalGuests": 1117,
		  "guestPercent": 0.866614,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "The Factory",
		  "mostGuestCity": "Hamilton",
		  "mostGuestAmount": 121,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "924313c368561640a5efab3076d434b3",
		  
		  "name": "Marya",
		  "createdDate": "2011-12-06 21:19:56",
		  "totalOrganizations": 22,
		  "totalTours": 13,
		  "totalDays": 1034,
		  "totalCountries": 10,
		  "totalStates": 52,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 2078,
		  "schedulePercent": 0.728921,
		  "totalGuests": 942,
		  "guestPercent": 0.838395,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Wilshire Ebell Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "924dc5a4fd188998be4f535aa9f589df",
		  
		  "name": "Tim",
		  "createdDate": "2016-07-20 00:46:03",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 1272,
		  "totalCountries": 26,
		  "totalStates": 41,
		  "totalEvents": 455,
		  "eventPercent": 0.972008,
		  "totalScheduleItems": 5195,
		  "schedulePercent": 0.959542,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92502ac84dc7b6788e00cd57be4fdae7",
		  
		  "name": "Tanya",
		  "createdDate": "2024-11-23 07:43:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 47,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 185,
		  "schedulePercent": 0.150725,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9275a4464a14551ce937ca84af54a552",
		  
		  "name": "Anthony",
		  "createdDate": "2015-09-09 18:32:14",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 102,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "927829d24047f1fd291ad0e28f4ca9e4",
		  
		  "name": "Nolan",
		  "createdDate": "2019-02-16 02:05:18",
		  "totalOrganizations": 14,
		  "totalTours": 32,
		  "totalDays": 675,
		  "totalCountries": 20,
		  "totalStates": 87,
		  "totalEvents": 399,
		  "eventPercent": 0.958296,
		  "totalScheduleItems": 5364,
		  "schedulePercent": 0.964529,
		  "totalGuests": 2251,
		  "guestPercent": 0.959995,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 122,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "927fe6c2c5fc82942e4aac9c43bb05f8",
		  
		  "name": "Peter",
		  "createdDate": "2022-01-12 06:36:53",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 684,
		  "schedulePercent": 0.380893,
		  "totalGuests": 401,
		  "guestPercent": 0.69481,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "928d4ca1710a9c52dc610341446d22cb",
		  
		  "name": "Stephanie",
		  "createdDate": "2023-05-30 03:59:13",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 494,
		  "totalCountries": 15,
		  "totalStates": 60,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 1730,
		  "schedulePercent": 0.663758,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Mahall's",
		  "mostGuestCity": "Lakewood",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "928fec8d4c567fbdf6113d8269fb8794",
		  
		  "name": "Faith",
		  "createdDate": "2017-03-16 06:15:05",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 167,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 873,
		  "schedulePercent": 0.449456,
		  "totalGuests": 369,
		  "guestPercent": 0.68087,
		  "mostGuestDate": "2025-05-13 00:00:00",
		  "mostGuestName": "Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "929131c0e86cc8d27718f21cc16d4177",
		  
		  "name": "George",
		  "createdDate": "2022-06-16 21:51:15",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 377,
		  "totalCountries": 31,
		  "totalStates": 69,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 2018,
		  "schedulePercent": 0.717022,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Koka Booth Amphitheatre",
		  "mostGuestCity": "Cary",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9292c365ada16804349817c6f28ae3e7",
		  
		  "name": "Parker",
		  "createdDate": "2016-04-04 12:38:44",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 402,
		  "totalCountries": 12,
		  "totalStates": 24,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1062,
		  "schedulePercent": 0.5068,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Mississippi Valley Fairgrounds",
		  "mostGuestCity": "Davenport",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "929c211e283668310e2225b37b06a9c6",
		  
		  "name": "Tom",
		  "createdDate": "2016-04-10 17:48:28",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 117,
		  "totalCountries": 6,
		  "totalStates": 33,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 771,
		  "schedulePercent": 0.412625,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Motorco Music Hall",
		  "mostGuestCity": "Durham",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92a03e661426d45ec009324fcaac0087",
		  
		  "name": "Mallory",
		  "createdDate": "2025-01-29 15:53:40",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 232,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92a70d1f6dc93a88815dadf74f8bd836",
		  
		  "name": "Elizabeth",
		  "createdDate": "2022-02-20 20:44:37",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 771,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1485,
		  "schedulePercent": 0.614687,
		  "totalGuests": 211,
		  "guestPercent": 0.603128,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "Buckhead Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92a87369126332ce972819a302cd8dae",
		  
		  "name": "Dawson",
		  "createdDate": "2025-05-05 17:56:04",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 479,
		  "totalCountries": 6,
		  "totalStates": 33,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 637,
		  "schedulePercent": 0.363327,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92aeff70c730d8b9b1fdf2d4316e47f6",
		  
		  "name": "Bobby",
		  "createdDate": "2025-01-28 19:04:37",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 2812,
		  "totalCountries": 8,
		  "totalStates": 44,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 1315,
		  "schedulePercent": 0.575023,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Coca-Cola Roxy",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92bd87ef1e5bb7e6fdcfac6489e850b1",
		  
		  "name": "Angie",
		  "createdDate": "2009-10-06 21:42:55",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 732,
		  "totalCountries": 17,
		  "totalStates": 24,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 1516,
		  "schedulePercent": 0.620807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92bda1802dc1d2ca4a3030adcdc2d0d8",
		  
		  "name": "Dustin ",
		  "createdDate": "2012-09-12 19:21:55",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 502,
		  "totalCountries": 6,
		  "totalStates": 39,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 1126,
		  "schedulePercent": 0.526859,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Harbison Theatre at Midlands Technical College",
		  "mostGuestCity": "Irmo",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92bff13fb21fcd42d795e815d5ee6c11",
		  
		  "name": "Nico",
		  "createdDate": "2016-03-16 17:46:11",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 83,
		  "totalCountries": 4,
		  "totalStates": 30,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 750,
		  "schedulePercent": 0.405032,
		  "totalGuests": 503,
		  "guestPercent": 0.731528,
		  "mostGuestDate": "2025-11-13 00:00:00",
		  "mostGuestName": "YouTube Theater",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92c80c98816c46d694d13edca47a3dd4",
		  
		  "name": "James",
		  "createdDate": "2015-08-16 02:06:54",
		  "totalOrganizations": 16,
		  "totalTours": 21,
		  "totalDays": 458,
		  "totalCountries": 34,
		  "totalStates": 52,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 3132,
		  "schedulePercent": 0.854034,
		  "totalGuests": 646,
		  "guestPercent": 0.770512,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92d80db5438377ec17083b58c027777e",
		  
		  "name": "Cassandra",
		  "createdDate": "2023-03-24 13:40:35",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 21,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 103,
		  "schedulePercent": 0.0988214,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Le !POC! (PÃ´le Culturel)",
		  "mostGuestCity": "Alfortville",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92e947ab405ef1688bf6a9c5ee8ea052",
		  
		  "name": "Justus",
		  "createdDate": "2023-11-20 10:42:38",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 894,
		  "schedulePercent": 0.455802,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "92fea6e060c84941cbf5aaf840f47c67",
		  
		  "name": "Kieren",
		  "createdDate": "2015-06-29 16:26:51",
		  "totalOrganizations": 26,
		  "totalTours": 40,
		  "totalDays": 1984,
		  "totalCountries": 35,
		  "totalStates": 111,
		  "totalEvents": 672,
		  "eventPercent": 0.990594,
		  "totalScheduleItems": 12831,
		  "schedulePercent": 0.998527,
		  "totalGuests": 4696,
		  "guestPercent": 0.996487,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "930087152de6169874b88d96ab32359e",
		  
		  "name": "Jon",
		  "createdDate": "2016-08-26 16:06:58",
		  "totalOrganizations": 24,
		  "totalTours": 21,
		  "totalDays": 690,
		  "totalCountries": 18,
		  "totalStates": 48,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 3585,
		  "schedulePercent": 0.887919,
		  "totalGuests": 3920,
		  "guestPercent": 0.992747,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "OVO Arena Wembley",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 401,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93128ff4b5a5f41df987f262887cef6f",
		  
		  "name": "Matthew",
		  "createdDate": "2013-09-13 20:59:23",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 1171,
		  "totalCountries": 11,
		  "totalStates": 52,
		  "totalEvents": 378,
		  "eventPercent": 0.953309,
		  "totalScheduleItems": 4152,
		  "schedulePercent": 0.922371,
		  "totalGuests": 574,
		  "guestPercent": 0.750567,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Palladium",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93156432fff37829b7a106265fa55c56",
		  
		  "name": "Abe",
		  "createdDate": "2015-03-15 20:31:27",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 351,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 918,
		  "schedulePercent": 0.464302,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Tennessee Theatre",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93161592bea02aa6acdf6df88990684d",
		  
		  "name": "Chris",
		  "createdDate": "2024-05-22 17:23:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 163,
		  "schedulePercent": 0.137579,
		  "totalGuests": 113,
		  "guestPercent": 0.530598,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "The Roxy Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9317dd7ddf82f7411e4c980ddd4e9466",
		  
		  "name": "FrÃ\u00ADÃ°a",
		  "createdDate": "2022-10-20 12:00:49",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 99,
		  "totalCountries": 12,
		  "totalStates": 18,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 573,
		  "schedulePercent": 0.340888,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "932e0eee1656cf7ef23634829b295a50",
		  
		  "name": "Dougie",
		  "createdDate": "2017-06-30 12:43:27",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 1469,
		  "totalCountries": 6,
		  "totalStates": 6,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1334,
		  "schedulePercent": 0.581369,
		  "totalGuests": 362,
		  "guestPercent": 0.67883,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Glasgow Royal Concert Hall",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93305caa369b40e90bc75bba6ae2969a",
		  
		  "name": "Craig",
		  "createdDate": "2025-06-30 15:46:55",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 80,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9336290d6ec4515dd33bf4c0d9e568e5",
		  
		  "name": "CARYL ",
		  "createdDate": "2012-08-14 14:43:08",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 66,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9342aed4db5f7b43b4e64c40766c1a93",
		  
		  "name": "Maria",
		  "createdDate": "2022-05-07 11:48:17",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 95,
		  "totalCountries": 20,
		  "totalStates": 24,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 288,
		  "schedulePercent": 0.211582,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93456d36cc076fb80e3ef4991a51d74f",
		  
		  "name": "LAPTOP 1",
		  "createdDate": "2025-08-12 16:54:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 69,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 104,
		  "schedulePercent": 0.0999547,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "The Daisy Jones Bar",
		  "mostGuestCity": "Stellenbosch",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "934f93f77dc05c6224a3b52028404824",
		  
		  "name": "Scott",
		  "createdDate": "2013-09-26 15:15:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 266,
		  "totalCountries": 5,
		  "totalStates": 47,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 2211,
		  "schedulePercent": 0.749433,
		  "totalGuests": 776,
		  "guestPercent": 0.801564,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "935b33d4091099f10a32ee48b0769cc2",
		  
		  "name": "Jen",
		  "createdDate": "2018-12-11 14:18:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 149,
		  "totalCountries": 19,
		  "totalStates": 30,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 852,
		  "schedulePercent": 0.440843,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Auditorium Parco Della Musica - Sala Sinopoli",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "935e0fa06c7a22cff7f0d15bfcc3f9d0",
		  
		  "name": "Kurro",
		  "createdDate": "2024-04-25 16:35:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 533,
		  "schedulePercent": 0.328196,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "935f1ff4638598d0977f9309aa71c35a",
		  
		  "name": "Bryan",
		  "createdDate": "2024-12-10 14:41:48",
		  "totalOrganizations": 1,
		  "totalTours": 13,
		  "totalDays": 341,
		  "totalCountries": 37,
		  "totalStates": 46,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 699,
		  "schedulePercent": 0.386333,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Sound Nightclub",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93646520d54bb06160b1ccbe74fe8d96",
		  
		  "name": "Cedric",
		  "createdDate": "2019-11-02 19:41:50",
		  "totalOrganizations": 3,
		  "totalTours": 17,
		  "totalDays": 194,
		  "totalCountries": 15,
		  "totalStates": 37,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1290,
		  "schedulePercent": 0.569583,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "936c462ec2c6fcedc5b05beedffcad7e",
		  
		  "name": "Stefanie",
		  "createdDate": "2021-11-02 12:17:11",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 175,
		  "totalCountries": 20,
		  "totalStates": 29,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1957,
		  "schedulePercent": 0.704669,
		  "totalGuests": 380,
		  "guestPercent": 0.685857,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Uber arena (Formerly Mercedes Benz Arena)",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93711c815dc92b7f2b6b9a16e40c48a8",
		  
		  "name": "Madeline",
		  "createdDate": "2022-01-20 20:07:57",
		  "totalOrganizations": 9,
		  "totalTours": 13,
		  "totalDays": 2033,
		  "totalCountries": 20,
		  "totalStates": 63,
		  "totalEvents": 332,
		  "eventPercent": 0.933817,
		  "totalScheduleItems": 5490,
		  "schedulePercent": 0.967135,
		  "totalGuests": 1476,
		  "guestPercent": 0.906958,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Champion Forest Baptist Church - Champions Campus",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9381d1d26995ecb42fb366405594bf5a",
		  
		  "name": "Johan",
		  "createdDate": "2014-05-13 22:33:40",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 15,
		  "totalStates": 17,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 417,
		  "schedulePercent": 0.276972,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "The Wellmont Theater",
		  "mostGuestCity": "Montclair",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9388fd38e2e6c498178577be267ecc10",
		  
		  "name": "Luke",
		  "createdDate": "2013-06-03 01:37:32",
		  "totalOrganizations": 7,
		  "totalTours": 19,
		  "totalDays": 732,
		  "totalCountries": 22,
		  "totalStates": 43,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 1618,
		  "schedulePercent": 0.643586,
		  "totalGuests": 767,
		  "guestPercent": 0.800204,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93913a05b281950a98c9a8c4d5c19369",
		  
		  "name": "Andy",
		  "createdDate": "2023-05-03 14:04:02",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 588,
		  "totalCountries": 23,
		  "totalStates": 26,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1324,
		  "schedulePercent": 0.576609,
		  "totalGuests": 334,
		  "guestPercent": 0.667384,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Glasgow Royal Concert Hall",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93913d07af4de78e3f790b2b4c348a9e",
		  
		  "name": "Caroline",
		  "createdDate": "2012-06-01 17:28:16",
		  "totalOrganizations": 43,
		  "totalTours": 22,
		  "totalDays": 749,
		  "totalCountries": 8,
		  "totalStates": 47,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 1986,
		  "schedulePercent": 0.710675,
		  "totalGuests": 437,
		  "guestPercent": 0.708522,
		  "mostGuestDate": "2025-11-30 00:00:00",
		  "mostGuestName": "Plymouth Pavilions",
		  "mostGuestCity": "Plymouth",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "939518c41ff1dcbc0859fc3e3ed648cf",
		  
		  "name": "Jodi",
		  "createdDate": "2019-05-29 14:38:39",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 459,
		  "totalCountries": 32,
		  "totalStates": 49,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 1846,
		  "schedulePercent": 0.685063,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Palau Sant Jordi",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9399f4aba8d0496881478906f38a283a",
		  
		  "name": "Michelle",
		  "createdDate": "2024-12-29 20:28:40",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 1366,
		  "totalCountries": 20,
		  "totalStates": 45,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 1926,
		  "schedulePercent": 0.699456,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "SunBet Arena at Time Square Casino",
		  "mostGuestCity": "Pretoria",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93a5afc85f10363b8d2ab05d01260aa7",
		  
		  "name": "Jannika",
		  "createdDate": "2022-04-26 09:13:19",
		  "totalOrganizations": 31,
		  "totalTours": 34,
		  "totalDays": 541,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 538,
		  "eventPercent": 0.982774,
		  "totalScheduleItems": 2123,
		  "schedulePercent": 0.735834,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93a696ed8297fb49aaf38fd0c69da564",
		  
		  "name": "Aoife",
		  "createdDate": "2025-03-18 17:45:08",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 48,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93ac445bcdcb8c1b0b069e766eaefdb3",
		  
		  "name": "Samuel",
		  "createdDate": "2025-06-15 01:51:07",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 1166,
		  "totalCountries": 13,
		  "totalStates": 8,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 295,
		  "schedulePercent": 0.215095,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Openair Frauenfeld",
		  "mostGuestCity": "Frauenfeld",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93ce22b25cdb9bcd9dda728b7a4d72df",
		  
		  "name": "Jeremy",
		  "createdDate": "2020-02-14 16:08:53",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 785,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 3798,
		  "schedulePercent": 0.902652,
		  "totalGuests": 1947,
		  "guestPercent": 0.942543,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 150,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93e9a746a07e743142b9b639bf7d83e7",
		  
		  "name": "Daniel",
		  "createdDate": "2017-01-26 18:35:34",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 2148,
		  "totalCountries": 21,
		  "totalStates": 56,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 4099,
		  "schedulePercent": 0.918631,
		  "totalGuests": 493,
		  "guestPercent": 0.728355,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Rogers Arena",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93ea90b3dd39b11c2273b4d3059794f3",
		  
		  "name": "Richard",
		  "createdDate": "2016-06-15 19:34:54",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 30,
		  "totalCountries": 4,
		  "totalStates": 14,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 233,
		  "schedulePercent": 0.179964,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Rose Bowl Stadium",
		  "mostGuestCity": "Pasadena",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93eaa762b174160927759942b0e33f27",
		  
		  "name": "Rose",
		  "createdDate": "2023-08-17 14:25:53",
		  "totalOrganizations": 1,
		  "totalTours": 13,
		  "totalDays": 100,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 338,
		  "schedulePercent": 0.236967,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93f310f47f0ee7bce6ca3740db50f6f4",
		  
		  "name": "Evan",
		  "createdDate": "2025-02-13 14:34:43",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 727,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 2055,
		  "schedulePercent": 0.724388,
		  "totalGuests": 242,
		  "guestPercent": 0.62092,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "James H. Clark Auditorium",
		  "mostGuestCity": "Conway",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "93f8a28fd17e1c33f8facb90f4ab0934",
		  
		  "name": "Dave",
		  "createdDate": "2014-02-27 21:01:08",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 149,
		  "totalCountries": 13,
		  "totalStates": 43,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 1139,
		  "guestPercent": 0.87024,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 122,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9400cc63b05a082bce2c6ad1da73bf2d",
		  
		  "name": "Josh",
		  "createdDate": "2021-07-03 16:19:40",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 458,
		  "totalCountries": 6,
		  "totalStates": 32,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 444,
		  "schedulePercent": 0.288078,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9401360268915ec7eaeea2bce8112178",
		  
		  "name": "Matt",
		  "createdDate": "2016-05-16 15:00:26",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 64,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 129,
		  "guestPercent": 0.543518,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Electric Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9402c79482108166c81ca73859abaed1",
		  
		  "name": "Samuel",
		  "createdDate": "2023-07-27 11:03:24",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 316,
		  "totalCountries": 14,
		  "totalStates": 26,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 675,
		  "schedulePercent": 0.376473,
		  "totalGuests": 275,
		  "guestPercent": 0.637579,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "940575859908ec95898b69920bd988b0",
		  
		  "name": "Simo",
		  "createdDate": "2015-04-08 12:53:57",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 245,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 1006,
		  "schedulePercent": 0.49184,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Espoon Viinijuhlat",
		  "mostGuestCity": "Espoo",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94105e08fa0e2901aaf1388a778e961d",
		  
		  "name": "Mark",
		  "createdDate": "2009-12-30 23:41:54",
		  "totalOrganizations": 16,
		  "totalTours": 49,
		  "totalDays": 1110,
		  "totalCountries": 28,
		  "totalStates": 98,
		  "totalEvents": 402,
		  "eventPercent": 0.958862,
		  "totalScheduleItems": 5206,
		  "schedulePercent": 0.959655,
		  "totalGuests": 1545,
		  "guestPercent": 0.914098,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "941fc7c65eb4239bf33db344e71d6990",
		  
		  "name": "Ward",
		  "createdDate": "2018-01-16 23:42:00",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 428,
		  "totalCountries": 22,
		  "totalStates": 56,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2038,
		  "schedulePercent": 0.720422,
		  "totalGuests": 321,
		  "guestPercent": 0.660471,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Viejas Arena",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "942e458516747a3df1244b1a752216f1",
		  
		  "name": "Thomas",
		  "createdDate": "2014-04-09 11:49:43",
		  "totalOrganizations": 28,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 218,
		  "schedulePercent": 0.170558,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "SnÃ¶sÃ¤tragrÃ¤nd Wall Of Fame",
		  "mostGuestCity": "Bandhagen",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9431a35790c9ed6aad9453d1764bf2fb",
		  
		  "name": "Cody J",
		  "createdDate": "2016-07-08 00:49:19",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 255,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 867,
		  "schedulePercent": 0.447643,
		  "totalGuests": 187,
		  "guestPercent": 0.584202,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Travis County Exposition Center- Leudecke Arena",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9435b8b3d205a95e1ef1b205f4be0429",
		  
		  "name": "Matthew",
		  "createdDate": "2024-06-20 14:56:26",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 343,
		  "totalCountries": 19,
		  "totalStates": 72,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 3439,
		  "schedulePercent": 0.877946,
		  "totalGuests": 1073,
		  "guestPercent": 0.858681,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9437c062605ee480f443151f1e8e8f02",
		  
		  "name": "Callie",
		  "createdDate": "2018-02-22 00:26:58",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 6,
		  "totalStates": 47,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 3112,
		  "schedulePercent": 0.852448,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "943f15f8410cb5536f72daa92a0e2770",
		  
		  "name": "Jonny",
		  "createdDate": "2014-11-20 13:16:33",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 33,
		  "totalCountries": 9,
		  "totalStates": 10,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 221,
		  "schedulePercent": 0.172257,
		  "totalGuests": 208,
		  "guestPercent": 0.600521,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "London Palladium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 128,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94417b0e56f6699e4588d3767dcacfe3",
		  
		  "name": "Steve",
		  "createdDate": "2018-10-29 15:21:27",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 247,
		  "totalCountries": 9,
		  "totalStates": 42,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1403,
		  "schedulePercent": 0.598368,
		  "totalGuests": 594,
		  "guestPercent": 0.756346,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "945e1868563005652ff2b4bfe673ef5b",
		  
		  "name": "Doug",
		  "createdDate": "2014-07-10 16:16:29",
		  "totalOrganizations": 29,
		  "totalTours": 14,
		  "totalDays": 693,
		  "totalCountries": 18,
		  "totalStates": 42,
		  "totalEvents": 261,
		  "eventPercent": 0.88248,
		  "totalScheduleItems": 3025,
		  "schedulePercent": 0.844402,
		  "totalGuests": 779,
		  "guestPercent": 0.802244,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9462da2a1e376da8451835791a43fb61",
		  
		  "name": "Katie ",
		  "createdDate": "2016-04-05 19:40:37",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 1088,
		  "totalCountries": 13,
		  "totalStates": 38,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 2750,
		  "schedulePercent": 0.816523,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Coors Light Birds Nest",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9469abd34900d3b995d9957122c63544",
		  
		  "name": "Carter",
		  "createdDate": "2022-07-26 01:44:13",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 574,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 2359,
		  "schedulePercent": 0.769832,
		  "totalGuests": 1528,
		  "guestPercent": 0.912965,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Levitate Music and Arts Festival",
		  "mostGuestCity": "Marshfield",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "946a19c0332518b1b225db487eb635ae",
		  
		  "name": "Lina",
		  "createdDate": "2022-09-12 19:32:30",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 118,
		  "totalCountries": 7,
		  "totalStates": 14,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 386,
		  "schedulePercent": 0.261673,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "SÃ¶dra Teatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9476dd3057d7c0348f2a092432b43874",
		  
		  "name": "Jasmine",
		  "createdDate": "2025-03-26 18:42:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 253,
		  "schedulePercent": 0.191976,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "713 Music Hall",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "947b97fba59053df6a018269ca89f9d3",
		  
		  "name": "Eric",
		  "createdDate": "2023-10-11 22:21:54",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 457,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1667,
		  "schedulePercent": 0.652652,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "947cfaeaf193a87b55dfa63c787838fe",
		  
		  "name": "Amber ",
		  "createdDate": "2024-01-11 03:27:46",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 92,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 439,
		  "schedulePercent": 0.285811,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "947e2032ad318ff39d1c405f591d1dd5",
		  
		  "name": "Marc",
		  "createdDate": "2023-06-22 13:50:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1003,
		  "schedulePercent": 0.490934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "948ad5e210e1c8443acb073546023af7",
		  
		  "name": "Jenni",
		  "createdDate": "2023-01-26 16:09:02",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 565,
		  "totalCountries": 4,
		  "totalStates": 51,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1296,
		  "schedulePercent": 0.57049,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "949a9374a00cef8facf44e09bb9bed13",
		  
		  "name": "Chelsea",
		  "createdDate": "2021-10-09 18:23:40",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 420,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1566,
		  "schedulePercent": 0.633726,
		  "totalGuests": 339,
		  "guestPercent": 0.670558,
		  "mostGuestDate": "2025-03-17 00:00:00",
		  "mostGuestName": "Bradley Mountain",
		  "mostGuestCity": "Columbia",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "949b07eda749a22e6631c52896cffe3d",
		  
		  "name": "Siobhain",
		  "createdDate": "2018-12-22 11:54:51",
		  "totalOrganizations": 23,
		  "totalTours": 13,
		  "totalDays": 758,
		  "totalCountries": 21,
		  "totalStates": 54,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 3014,
		  "schedulePercent": 0.843382,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "House of Blues Chicago",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94a02c4d761fc467a33f5603d3c141ef",
		  
		  "name": "Chris",
		  "createdDate": "2024-06-27 17:38:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 347,
		  "schedulePercent": 0.2415,
		  "totalGuests": 808,
		  "guestPercent": 0.809723,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94a18271cda57bf64e56bdb72c2671ec",
		  
		  "name": "Michael",
		  "createdDate": "2011-01-07 19:51:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 95,
		  "totalCountries": 7,
		  "totalStates": 16,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 556,
		  "schedulePercent": 0.335789,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-12-18 00:00:00",
		  "mostGuestName": "Granada Theatre",
		  "mostGuestCity": "Sherbrooke",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94a98e4278de9505425c0eb3193e3156",
		  
		  "name": "Jennifer",
		  "createdDate": "2019-04-15 20:04:14",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 372,
		  "totalCountries": 26,
		  "totalStates": 22,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94aa10e6cf9482401382fb02e9ef5e48",
		  
		  "name": "Windwaker",
		  "createdDate": "2019-07-10 03:21:53",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 214,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1315,
		  "schedulePercent": 0.575023,
		  "totalGuests": 419,
		  "guestPercent": 0.701496,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94acae72b9a931f86675737513190d95",
		  
		  "name": "Ryan",
		  "createdDate": "2017-06-05 22:40:21",
		  "totalOrganizations": 17,
		  "totalTours": 9,
		  "totalDays": 772,
		  "totalCountries": 8,
		  "totalStates": 53,
		  "totalEvents": 232,
		  "eventPercent": 0.850408,
		  "totalScheduleItems": 3834,
		  "schedulePercent": 0.904692,
		  "totalGuests": 318,
		  "guestPercent": 0.658772,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Warner Theatre",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94c12f7b89bd2aceebbc351348b144dc",
		  
		  "name": "Jen",
		  "createdDate": "2021-06-16 14:17:16",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 729,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1403,
		  "schedulePercent": 0.598368,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Interference",
		  "mostGuestCity": "Balma",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94cc82491917368cf2a387aefba998ce",
		  
		  "name": "Sam Huge",
		  "createdDate": "2016-01-06 19:20:08",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 227,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1057,
		  "schedulePercent": 0.506346,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Tempe Beach Park Surface Lot",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94cceaaa2b432b22d93027c7f4ee5a06",
		  
		  "name": "Jamey",
		  "createdDate": "2015-02-12 01:57:02",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 139,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 903,
		  "schedulePercent": 0.459089,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Billy Bob's Texas",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94cd37dcec1e80dffd3c3021824778cf",
		  
		  "name": "Andrew",
		  "createdDate": "2015-03-31 23:24:57",
		  "totalOrganizations": 18,
		  "totalTours": 6,
		  "totalDays": 212,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 114,
		  "schedulePercent": 0.107774,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94e682098b27e80152efc201c3a4421b",
		  
		  "name": "marco",
		  "createdDate": "2019-07-22 16:24:30",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 511,
		  "totalCountries": 27,
		  "totalStates": 33,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1141,
		  "schedulePercent": 0.532185,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94e97b27f88e0ce61cfeb1384d449312",
		  
		  "name": "Jenna",
		  "createdDate": "2022-03-09 19:26:13",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 200,
		  "totalCountries": 8,
		  "totalStates": 15,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 272,
		  "schedulePercent": 0.200929,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "94fde08aa7b407d574c158012a811e52",
		  
		  "name": "Ron",
		  "createdDate": "2023-04-14 18:18:12",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 139,
		  "totalCountries": 22,
		  "totalStates": 53,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1070,
		  "schedulePercent": 0.510426,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "X-tra",
		  "mostGuestCity": "Zurich",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9510444432ea54e5c966c30f92dadfea",
		  
		  "name": "Autumn ",
		  "createdDate": "2019-09-17 18:55:15",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 918,
		  "totalCountries": 6,
		  "totalStates": 30,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 472,
		  "schedulePercent": 0.299071,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "951ee92b0f4c25c3b06559540cdb46be",
		  
		  "name": "Juan",
		  "createdDate": "2024-02-12 17:54:47",
		  "totalOrganizations": 13,
		  "totalTours": 8,
		  "totalDays": 568,
		  "totalCountries": 31,
		  "totalStates": 52,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1334,
		  "schedulePercent": 0.581369,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Wolf Barcelona",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "951f711ee84839c0cf7d2dc945bf6c8b",
		  
		  "name": "Mike",
		  "createdDate": "2018-11-13 22:06:47",
		  "totalOrganizations": 4,
		  "totalTours": 31,
		  "totalDays": 694,
		  "totalCountries": 18,
		  "totalStates": 64,
		  "totalEvents": 363,
		  "eventPercent": 0.947529,
		  "totalScheduleItems": 3545,
		  "schedulePercent": 0.88452,
		  "totalGuests": 395,
		  "guestPercent": 0.692203,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Dolby Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95214c14c7c815931a6f342e842da311",
		  
		  "name": "Josh",
		  "createdDate": "2022-09-15 22:05:43",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 342,
		  "totalCountries": 10,
		  "totalStates": 8,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 531,
		  "schedulePercent": 0.327176,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "952640836e8a7dbdc4001e71e46cff54",
		  
		  "name": "Hannah",
		  "createdDate": "2024-10-22 15:10:42",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 489,
		  "totalCountries": 13,
		  "totalStates": 60,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 1975,
		  "schedulePercent": 0.708862,
		  "totalGuests": 577,
		  "guestPercent": 0.751813,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "952850b80348b2697f3afa7750dc54e4",
		  
		  "name": "Gateways",
		  "createdDate": "2023-11-22 15:48:36",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 38,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 556,
		  "schedulePercent": 0.335789,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "952d44d3f7f01d3f48b4d89fd71ee908",
		  
		  "name": "Claire",
		  "createdDate": "2025-03-17 15:33:14",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 52,
		  "totalCountries": 9,
		  "totalStates": 17,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 299,
		  "schedulePercent": 0.217135,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Madame Louâ€™s",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "953413854be4efd66e995faea00ec5a9",
		  
		  "name": "Chris",
		  "createdDate": "2023-05-31 17:26:01",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 99,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 459,
		  "schedulePercent": 0.294311,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "953527d9036cc3f65faa18a9b255916f",
		  
		  "name": "Miguel ",
		  "createdDate": "2025-03-21 12:29:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 28,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 223,
		  "schedulePercent": 0.173051,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95403736413fe49f535d2d3c8aa33f16",
		  
		  "name": "Jonathan",
		  "createdDate": "2022-03-01 15:13:14",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 405,
		  "totalCountries": 15,
		  "totalStates": 45,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1679,
		  "schedulePercent": 0.654578,
		  "totalGuests": 617,
		  "guestPercent": 0.763033,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Theatre Antique de Vienne",
		  "mostGuestCity": "Vienne",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9548ba68bd24bdff0d017f6c0104093c",
		  
		  "name": "Kat",
		  "createdDate": "2016-05-04 21:03:14",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 1021,
		  "totalCountries": 25,
		  "totalStates": 83,
		  "totalEvents": 266,
		  "eventPercent": 0.887579,
		  "totalScheduleItems": 4864,
		  "schedulePercent": 0.950136,
		  "totalGuests": 1195,
		  "guestPercent": 0.87568,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "955d0b450a30e750e64f8c7da73a938b",
		  
		  "name": "Georgia",
		  "createdDate": "2022-09-12 19:16:31",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 146,
		  "totalCountries": 14,
		  "totalStates": 16,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 690,
		  "schedulePercent": 0.382593,
		  "totalGuests": 284,
		  "guestPercent": 0.641206,
		  "mostGuestDate": "2025-03-10 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "955e3ac5747c3fa8f56426b6c915f6ab",
		  
		  "name": "Kyle",
		  "createdDate": "2023-02-03 21:32:42",
		  "totalOrganizations": 8,
		  "totalTours": 18,
		  "totalDays": 636,
		  "totalCountries": 19,
		  "totalStates": 80,
		  "totalEvents": 245,
		  "eventPercent": 0.866047,
		  "totalScheduleItems": 3291,
		  "schedulePercent": 0.867407,
		  "totalGuests": 546,
		  "guestPercent": 0.742634,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Arena 8888 Sofia",
		  "mostGuestCity": "Sofia",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95734145eec0f7ca260e7417e00bdf9c",
		  
		  "name": "Shannon",
		  "createdDate": "2018-10-01 17:10:40",
		  "totalOrganizations": 76,
		  "totalTours": 34,
		  "totalDays": 881,
		  "totalCountries": 26,
		  "totalStates": 52,
		  "totalEvents": 284,
		  "eventPercent": 0.901292,
		  "totalScheduleItems": 3917,
		  "schedulePercent": 0.909678,
		  "totalGuests": 2037,
		  "guestPercent": 0.949343,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "958b1724dc58a6c63da1c4b6c5ca8932",
		  
		  "name": "Bryan ",
		  "createdDate": "2023-05-18 20:14:12",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 590,
		  "totalCountries": 13,
		  "totalStates": 52,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1757,
		  "schedulePercent": 0.669878,
		  "totalGuests": 602,
		  "guestPercent": 0.75884,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "958c967454252f50d3f79a80ec975aa5",
		  
		  "name": "Luis Alfonso",
		  "createdDate": "2025-02-05 20:26:45",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 624,
		  "totalCountries": 21,
		  "totalStates": 68,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 1571,
		  "schedulePercent": 0.634973,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9591abaeab125027938dedd59477fddc",
		  
		  "name": "Gino",
		  "createdDate": "2018-11-04 21:43:58",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 120,
		  "totalCountries": 20,
		  "totalStates": 24,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 1045,
		  "schedulePercent": 0.502493,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9597ca0cad2cab7d50aa96e5d61026b8",
		  
		  "name": "William",
		  "createdDate": "2025-02-04 18:56:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 110,
		  "schedulePercent": 0.105734,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "Meow Wolf Denver | Convergence Station",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95ae3c369e784b5231536aeac7470387",
		  
		  "name": "Jesse",
		  "createdDate": "2009-12-23 14:38:42",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 916,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 3169,
		  "schedulePercent": 0.857208,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Coors Light Birds Nest",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95bfe10709bd78bf91fb66348e7d3354",
		  
		  "name": "Lizzie",
		  "createdDate": "2023-03-21 14:57:44",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 51,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 157,
		  "schedulePercent": 0.13316,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95c4696f18ffe16e9951e14b1625fba1",
		  
		  "name": "Eddie",
		  "createdDate": "2009-12-09 17:43:26",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 878,
		  "totalCountries": 6,
		  "totalStates": 55,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 4420,
		  "schedulePercent": 0.93563,
		  "totalGuests": 151,
		  "guestPercent": 0.558817,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95c81bced355f2fbba78d25c79897b04",
		  
		  "name": "Ian",
		  "createdDate": "2021-07-26 23:03:50",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 154,
		  "totalCountries": 13,
		  "totalStates": 36,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1301,
		  "schedulePercent": 0.571623,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95dd2e04ecd45de7d6fef15186784b6e",
		  
		  "name": "LinnÃ©a",
		  "createdDate": "2024-03-12 00:25:02",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 334,
		  "totalCountries": 20,
		  "totalStates": 41,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1223,
		  "schedulePercent": 0.55349,
		  "totalGuests": 172,
		  "guestPercent": 0.575136,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95e9e32344b7b33f613e9f50af4ab6c5",
		  
		  "name": "Mike",
		  "createdDate": "2025-10-25 00:37:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 51,
		  "totalCountries": 1,
		  "totalStates": 18,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 88,
		  "schedulePercent": 0.088282,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95ed2d44d68e799a714b729a5dde829f",
		  
		  "name": "Barry",
		  "createdDate": "2015-07-03 18:59:19",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 729,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1207,
		  "schedulePercent": 0.548731,
		  "totalGuests": 546,
		  "guestPercent": 0.742634,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "95fdbbf980460cc41ba2482523d69ba7",
		  
		  "name": "Steve",
		  "createdDate": "2024-04-17 22:54:52",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 226,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 830,
		  "schedulePercent": 0.43461,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Sagebrush",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "960616f7bd74557a4ef993140db86832",
		  
		  "name": "Caroline",
		  "createdDate": "2019-07-16 00:06:05",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 84,
		  "totalCountries": 6,
		  "totalStates": 16,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9631cf84a4e1e02f6b40efa4fb2e63c6",
		  
		  "name": "Nikolaj",
		  "createdDate": "2021-09-09 10:49:15",
		  "totalOrganizations": 53,
		  "totalTours": 33,
		  "totalDays": 584,
		  "totalCountries": 10,
		  "totalStates": 4,
		  "totalEvents": 564,
		  "eventPercent": 0.985494,
		  "totalScheduleItems": 2792,
		  "schedulePercent": 0.821056,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Hotel Cecil",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96381c08363d26a6c7b3e35743d90216",
		  
		  "name": "Henrik",
		  "createdDate": "2024-07-23 09:02:33",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 27,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 124,
		  "schedulePercent": 0.114007,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "963be3d2afc142ac2f191df069a53a94",
		  
		  "name": "George",
		  "createdDate": "2018-04-26 03:12:30",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 113,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 274,
		  "schedulePercent": 0.202063,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Adelaide Entertainment Centre Theatre",
		  "mostGuestCity": "Hindmarsh",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "963c032b3e4ad068da36f07681029516",
		  
		  "name": "Dustin",
		  "createdDate": "2022-02-25 21:10:25",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 137,
		  "totalCountries": 8,
		  "totalStates": 24,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 857,
		  "schedulePercent": 0.442656,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96453db7d62a832d3a32159839a6cf46",
		  
		  "name": "Andy",
		  "createdDate": "2014-06-30 08:06:41",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 34,
		  "totalCountries": 9,
		  "totalStates": 5,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 126,
		  "schedulePercent": 0.115707,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "964b9ddd8602418a7bb123244a3dea84",
		  
		  "name": "Sara",
		  "createdDate": "2025-10-11 14:05:43",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 36,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 503,
		  "schedulePercent": 0.313123,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Crawford Auditorium at Grove City College",
		  "mostGuestCity": "Grove City",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9658f5a533acb4d4a4f81c6ff38755a7",
		  
		  "name": "Luke",
		  "createdDate": "2019-07-22 23:25:08",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 732,
		  "totalCountries": 18,
		  "totalStates": 39,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 957,
		  "schedulePercent": 0.478014,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9665cf10dd3655b331a8d61f3da47b35",
		  
		  "name": "david",
		  "createdDate": "2022-04-08 17:49:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 14,
		  "totalStates": 29,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1,
		  "schedulePercent": 0.00804624,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9671961c6da3ab3ee6bfc273c6827157",
		  
		  "name": "Eli",
		  "createdDate": "2019-04-06 14:57:12",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 54,
		  "totalCountries": 14,
		  "totalStates": 28,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "Vogue Theatre",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "967a075c812291aa3a77a62b9bd6f71e",
		  
		  "name": "Lulu",
		  "createdDate": "2023-10-22 02:17:20",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 88,
		  "totalCountries": 24,
		  "totalStates": 32,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 145,
		  "guestPercent": 0.555077,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "967b5aadafad0d70ad100762491f3754",
		  
		  "name": "Omar",
		  "createdDate": "2020-08-11 18:21:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1178,
		  "schedulePercent": 0.541704,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-01-10 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "967e670228da33d4fc53559fbfd0e23a",
		  
		  "name": "Timothy",
		  "createdDate": "2017-08-08 20:30:02",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 494,
		  "totalCountries": 4,
		  "totalStates": 53,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1218,
		  "schedulePercent": 0.551224,
		  "totalGuests": 220,
		  "guestPercent": 0.607434,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9685ff317155e08f824e65aeae572d6e",
		  
		  "name": "Rheanne",
		  "createdDate": "2024-01-05 04:19:05",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 511,
		  "totalCountries": 26,
		  "totalStates": 42,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1741,
		  "schedulePercent": 0.665798,
		  "totalGuests": 1977,
		  "guestPercent": 0.946056,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Red Bull Arena",
		  "mostGuestCity": "Harrison",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9693ac225c86fe061b3e1a06206bf48b",
		  
		  "name": "Tia",
		  "createdDate": "2013-08-28 18:24:45",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 936,
		  "totalCountries": 19,
		  "totalStates": 51,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2548,
		  "schedulePercent": 0.792044,
		  "totalGuests": 1843,
		  "guestPercent": 0.93563,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "969a3e6c41a8bb8df89448b79a8ec645",
		  
		  "name": "Kim",
		  "createdDate": "2015-04-25 15:01:57",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 61,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 435,
		  "schedulePercent": 0.284111,
		  "totalGuests": 201,
		  "guestPercent": 0.595422,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Fredagsrock i Tivoli",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "969e412827db32e361110efa6511fa1d",
		  
		  "name": "Markus",
		  "createdDate": "2023-06-05 12:21:22",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 259,
		  "totalCountries": 24,
		  "totalStates": 44,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1877,
		  "schedulePercent": 0.69039,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-03-09 00:00:00",
		  "mostGuestName": "L'Olympia",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96a3b671295c30f53cf9ee4b152d9777",
		  
		  "name": "Michael",
		  "createdDate": "2021-12-01 05:49:46",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 1105,
		  "totalCountries": 11,
		  "totalStates": 40,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 1124,
		  "schedulePercent": 0.526179,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Los Angeles State Historic Park",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96a82a62182cb3eec2fe7f8ee5e9233c",
		  
		  "name": "Steve",
		  "createdDate": "2013-08-28 00:15:41",
		  "totalOrganizations": 4,
		  "totalTours": 15,
		  "totalDays": 305,
		  "totalCountries": 27,
		  "totalStates": 60,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 2905,
		  "schedulePercent": 0.832162,
		  "totalGuests": 649,
		  "guestPercent": 0.771306,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Colosseum Theater at Caesars Palace",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96d2d3868241d62df4e7adf37c0a08ed",
		  
		  "name": "Erik",
		  "createdDate": "2016-07-29 07:54:17",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 808,
		  "totalCountries": 25,
		  "totalStates": 53,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 5209,
		  "schedulePercent": 0.959882,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96e56a82f98817f5342e2fe471522f25",
		  
		  "name": "Tobias",
		  "createdDate": "2022-05-07 23:24:43",
		  "totalOrganizations": 23,
		  "totalTours": 12,
		  "totalDays": 857,
		  "totalCountries": 25,
		  "totalStates": 29,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1749,
		  "schedulePercent": 0.668404,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96e74a1d29c1ff6ec11d96c2e7ba1547",
		  
		  "name": "Corey",
		  "createdDate": "2019-08-21 16:59:51",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 939,
		  "schedulePercent": 0.472121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96ec5ca50e29559feecc49dd8d2a3ec8",
		  
		  "name": "Annie",
		  "createdDate": "2023-11-01 07:41:04",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 70,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 205,
		  "schedulePercent": 0.163758,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96ef5d28c4c90f2b1f0b142c69170d43",
		  
		  "name": "Ben",
		  "createdDate": "2024-09-05 15:18:58",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 370,
		  "totalCountries": 11,
		  "totalStates": 28,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 381,
		  "schedulePercent": 0.25918,
		  "totalGuests": 319,
		  "guestPercent": 0.659565,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96f0ab8687f85cb80935fa64f258db46",
		  
		  "name": "Oscar",
		  "createdDate": "2022-03-24 19:11:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 417,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 1,
		  "eventPercent": 0.0074796,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "96fcc27bf5acfce95fb6f7488dec2329",
		  
		  "name": "Emma",
		  "createdDate": "2023-05-13 10:20:37",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 39,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 172,
		  "schedulePercent": 0.141772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97152ff49d7071a1292ab183bacf2297",
		  
		  "name": "Brianna",
		  "createdDate": "2014-05-22 21:18:31",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 170,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 2044,
		  "schedulePercent": 0.722235,
		  "totalGuests": 548,
		  "guestPercent": 0.74354,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Buell Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "971a479366688d93cc3904ce18fbb258",
		  
		  "name": "simon",
		  "createdDate": "2017-08-14 00:58:52",
		  "totalOrganizations": 102,
		  "totalTours": 74,
		  "totalDays": 2855,
		  "totalCountries": 33,
		  "totalStates": 121,
		  "totalEvents": 823,
		  "eventPercent": 0.99354,
		  "totalScheduleItems": 12230,
		  "schedulePercent": 0.998187,
		  "totalGuests": 2313,
		  "guestPercent": 0.962942,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "971bae608d40bc19596c6faeeb4c8f8a",
		  
		  "name": "Jan",
		  "createdDate": "2021-10-12 19:29:30",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 116,
		  "totalCountries": 19,
		  "totalStates": 17,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 865,
		  "schedulePercent": 0.446623,
		  "totalGuests": 288,
		  "guestPercent": 0.643246,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "GieÃŸener Kultursommer",
		  "mostGuestCity": "GieÃŸen",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9720af56051a3f53abd59aa78b58593c",
		  
		  "name": "Steve",
		  "createdDate": "2010-08-24 21:06:51",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 235,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2248,
		  "schedulePercent": 0.75476,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9722b6e4ce52fb4b211b9aca3de94d40",
		  
		  "name": "Dennis",
		  "createdDate": "2016-01-04 20:35:53",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 913,
		  "totalCountries": 18,
		  "totalStates": 38,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 3829,
		  "schedulePercent": 0.904465,
		  "totalGuests": 151,
		  "guestPercent": 0.558817,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Royal Arena",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9725d870196803ab7c65b1ae6762f2ee",
		  
		  "name": "SABELA",
		  "createdDate": "2019-01-10 11:16:02",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 105,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "972808f49903729e3bb4ab409e05eaf2",
		  
		  "name": "Justin",
		  "createdDate": "2022-01-20 08:31:14",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 716,
		  "totalCountries": 19,
		  "totalStates": 56,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1542,
		  "schedulePercent": 0.62568,
		  "totalGuests": 187,
		  "guestPercent": 0.584202,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97360782f4c074cb88c0a4c102000b8e",
		  
		  "name": "Nicolai",
		  "createdDate": "2019-02-14 18:10:17",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 63,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 709,
		  "schedulePercent": 0.389846,
		  "totalGuests": 307,
		  "guestPercent": 0.652879,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9744e3fdd49a68bf30396f49aedb4e5e",
		  
		  "name": "Travis",
		  "createdDate": "2022-05-16 17:59:17",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 836,
		  "totalCountries": 29,
		  "totalStates": 70,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 2933,
		  "schedulePercent": 0.834995,
		  "totalGuests": 1012,
		  "guestPercent": 0.848708,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "974ec1dbe17679a2e5f65eb1de5761c1",
		  
		  "name": "Joe",
		  "createdDate": "2012-11-12 08:07:36",
		  "totalOrganizations": 56,
		  "totalTours": 54,
		  "totalDays": 2133,
		  "totalCountries": 21,
		  "totalStates": 88,
		  "totalEvents": 682,
		  "eventPercent": 0.990707,
		  "totalScheduleItems": 8615,
		  "schedulePercent": 0.992407,
		  "totalGuests": 3673,
		  "guestPercent": 0.991387,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "975dc9b62cb05ca0a6b19976bf15fb8e",
		  
		  "name": "Nadya ",
		  "createdDate": "2023-07-07 10:00:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 619,
		  "schedulePercent": 0.356528,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Movistar Arena Madrid",
		  "mostGuestCity": "Madrid",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97635dab790d7aba62d0cd1b496677b5",
		  
		  "name": "Tommy",
		  "createdDate": "2022-08-09 22:27:57",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 456,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 773,
		  "schedulePercent": 0.413758,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "976d8717662b9a5d02e5378021362f40",
		  
		  "name": "Jake",
		  "createdDate": "2020-09-29 22:27:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 89,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 209,
		  "schedulePercent": 0.165798,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "977513caeb75b1da6918dd12a550ed27",
		  
		  "name": "Dina",
		  "createdDate": "2024-12-02 14:16:04",
		  "totalOrganizations": 30,
		  "totalTours": 5,
		  "totalDays": 183,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 585,
		  "schedulePercent": 0.345648,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9775955e61e8cd4a8d98ea53826391d5",
		  
		  "name": "Lewis",
		  "createdDate": "2023-10-31 14:15:18",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 539,
		  "totalCountries": 24,
		  "totalStates": 78,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 2248,
		  "schedulePercent": 0.75476,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "in the meadows",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "977a4d5b5c930deb54cca0910b2de594",
		  
		  "name": "IAN",
		  "createdDate": "2011-11-07 15:54:00",
		  "totalOrganizations": 23,
		  "totalTours": 30,
		  "totalDays": 708,
		  "totalCountries": 22,
		  "totalStates": 67,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 2320,
		  "schedulePercent": 0.764959,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9793e11281f72b55c067822a4309632c",
		  
		  "name": "Tony",
		  "createdDate": "2016-07-03 16:09:05",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 560,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1250,
		  "schedulePercent": 0.560743,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-01-10 00:00:00",
		  "mostGuestName": "Gallagher Square",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "979c3850d63b7c84a53f5b7d52e22519",
		  
		  "name": "Ilona",
		  "createdDate": "2022-06-29 07:52:32",
		  "totalOrganizations": 22,
		  "totalTours": 34,
		  "totalDays": 727,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 616,
		  "eventPercent": 0.988327,
		  "totalScheduleItems": 2482,
		  "schedulePercent": 0.784791,
		  "totalGuests": 243,
		  "guestPercent": 0.621147,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "979e4af07f4028b3ce1139f987e7b0b3",
		  
		  "name": "Paulie",
		  "createdDate": "2016-06-15 02:59:42",
		  "totalOrganizations": 69,
		  "totalTours": 23,
		  "totalDays": 440,
		  "totalCountries": 21,
		  "totalStates": 41,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 2786,
		  "schedulePercent": 0.820376,
		  "totalGuests": 363,
		  "guestPercent": 0.67917,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97a2bd60fa6fd21e8c8de4156cbc57de",
		  
		  "name": "Sean",
		  "createdDate": "2023-02-19 01:22:58",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 790,
		  "totalCountries": 9,
		  "totalStates": 47,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 2962,
		  "schedulePercent": 0.838282,
		  "totalGuests": 688,
		  "guestPercent": 0.782978,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "Fox Theater",
		  "mostGuestCity": "Oakland",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97a60036f557385d32fac2643ecdbde9",
		  
		  "name": "Gabe",
		  "createdDate": "2012-06-06 17:00:56",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 164,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 731,
		  "schedulePercent": 0.398572,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-01-29 00:00:00",
		  "mostGuestName": "The Corner Hotel",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97a7e0a4725acabd8a4dda21af3d6a26",
		  
		  "name": "Oliver",
		  "createdDate": "2018-02-12 20:37:55",
		  "totalOrganizations": 17,
		  "totalTours": 7,
		  "totalDays": 733,
		  "totalCountries": 26,
		  "totalStates": 33,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1764,
		  "schedulePercent": 0.670784,
		  "totalGuests": 1031,
		  "guestPercent": 0.851088,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "ParkbÃ¼hne Wuhlheide",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 268,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97a970c5332d35ee7b5f02b4887865cd",
		  
		  "name": "Bianca ",
		  "createdDate": "2017-06-06 13:51:59",
		  "totalOrganizations": 13,
		  "totalTours": 12,
		  "totalDays": 1405,
		  "totalCountries": 19,
		  "totalStates": 61,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 5067,
		  "schedulePercent": 0.956596,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Golden Gate Park",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97af751dc5fa6da749f9925867d90d4c",
		  
		  "name": "Jimmy",
		  "createdDate": "2019-03-23 09:53:46",
		  "totalOrganizations": 16,
		  "totalTours": 15,
		  "totalDays": 1051,
		  "totalCountries": 23,
		  "totalStates": 64,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 4101,
		  "schedulePercent": 0.918744,
		  "totalGuests": 972,
		  "guestPercent": 0.841455,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97b0a3b4c63f58f0cc0266a914675369",
		  
		  "name": "Abby",
		  "createdDate": "2012-03-16 13:00:54",
		  "totalOrganizations": 24,
		  "totalTours": 5,
		  "totalDays": 145,
		  "totalCountries": 4,
		  "totalStates": 25,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1550,
		  "schedulePercent": 0.62704,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97b7676fafe1c666f285b7c6f17b8295",
		  
		  "name": "Sarah",
		  "createdDate": "2024-10-10 22:27:51",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 57,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 366,
		  "schedulePercent": 0.25136,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hammerstein Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97c7d15c3df9095e7681d49bdd5fe84a",
		  
		  "name": "Mike",
		  "createdDate": "2024-02-20 17:14:42",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 711,
		  "totalCountries": 6,
		  "totalStates": 51,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 1988,
		  "schedulePercent": 0.711129,
		  "totalGuests": 790,
		  "guestPercent": 0.805644,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97c7f916d082c8333300a969a418e9e4",
		  
		  "name": "Paul",
		  "createdDate": "2014-05-15 13:33:42",
		  "totalOrganizations": 8,
		  "totalTours": 21,
		  "totalDays": 613,
		  "totalCountries": 18,
		  "totalStates": 67,
		  "totalEvents": 284,
		  "eventPercent": 0.901292,
		  "totalScheduleItems": 4496,
		  "schedulePercent": 0.93801,
		  "totalGuests": 2676,
		  "guestPercent": 0.974955,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97cec8360376f8d79363410f173c631c",
		  
		  "name": "TECKOFF",
		  "createdDate": "2021-09-14 19:11:13",
		  "totalOrganizations": 16,
		  "totalTours": 14,
		  "totalDays": 1203,
		  "totalCountries": 11,
		  "totalStates": 37,
		  "totalEvents": 360,
		  "eventPercent": 0.94617,
		  "totalScheduleItems": 5054,
		  "schedulePercent": 0.955802,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97d6a1656c7b18af0db968ed020f7ecc",
		  
		  "name": "Dale",
		  "createdDate": "2025-10-07 20:01:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 406,
		  "schedulePercent": 0.272099,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Estadio Pascual Guerrero",
		  "mostGuestCity": "Cali",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97e1790b3d17f485e27b85dbcf584d90",
		  
		  "name": "bryan",
		  "createdDate": "2016-02-15 21:59:30",
		  "totalOrganizations": 10,
		  "totalTours": 22,
		  "totalDays": 680,
		  "totalCountries": 24,
		  "totalStates": 95,
		  "totalEvents": 384,
		  "eventPercent": 0.954782,
		  "totalScheduleItems": 4748,
		  "schedulePercent": 0.946396,
		  "totalGuests": 1101,
		  "guestPercent": 0.864121,
		  "mostGuestDate": "2025-04-08 00:00:00",
		  "mostGuestName": "College Street Music Hall",
		  "mostGuestCity": "New Haven",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97e6719846afe6173af07f3f2062bd47",
		  
		  "name": "DeAnna",
		  "createdDate": "2010-02-09 20:14:11",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 464,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 2090,
		  "schedulePercent": 0.730621,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97f4e375f62e07e6adfad581708752f0",
		  
		  "name": "Toni",
		  "createdDate": "2014-07-21 20:12:06",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 440,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 3015,
		  "schedulePercent": 0.843495,
		  "totalGuests": 3109,
		  "guestPercent": 0.984021,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "97fde0514a67871b550aa8e813b957bb",
		  
		  "name": "Claire",
		  "createdDate": "2017-10-25 23:04:53",
		  "totalOrganizations": 7,
		  "totalTours": 36,
		  "totalDays": 321,
		  "totalCountries": 11,
		  "totalStates": 36,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1052,
		  "schedulePercent": 0.505326,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-04-07 00:00:00",
		  "mostGuestName": "Tipitina's Uptown",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9804784c18a1d6a61bca892604a0ece5",
		  
		  "name": "Abigail",
		  "createdDate": "2017-09-27 10:46:21",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 367,
		  "totalCountries": 12,
		  "totalStates": 39,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 1481,
		  "schedulePercent": 0.612987,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9804d39eb074afeb78844b0d06d8d347",
		  
		  "name": "Danielle",
		  "createdDate": "2021-01-26 21:49:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 20,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 199,
		  "schedulePercent": 0.160245,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "980ad3894c0ebdc9e336d33eed6e991e",
		  
		  "name": "Molly",
		  "createdDate": "2020-01-15 00:01:24",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 202,
		  "totalCountries": 7,
		  "totalStates": 29,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 981,
		  "schedulePercent": 0.484814,
		  "totalGuests": 967,
		  "guestPercent": 0.840889,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "PNC Bank Arts Center",
		  "mostGuestCity": "Holmdel",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "980b92b41e928cad2b9a95ba20f0ce18",
		  
		  "name": "Amanda",
		  "createdDate": "2019-05-10 04:45:47",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 390,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 3063,
		  "schedulePercent": 0.848481,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9828433c87eae5881c91dbdbdae02a18",
		  
		  "name": "Mark",
		  "createdDate": "2013-06-27 06:46:13",
		  "totalOrganizations": 70,
		  "totalTours": 66,
		  "totalDays": 899,
		  "totalCountries": 20,
		  "totalStates": 60,
		  "totalEvents": 281,
		  "eventPercent": 0.898912,
		  "totalScheduleItems": 3703,
		  "schedulePercent": 0.896192,
		  "totalGuests": 282,
		  "guestPercent": 0.640413,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9835459c995758c98601e1ebb5e089d5",
		  
		  "name": "Jeanna",
		  "createdDate": "2022-07-21 16:26:56",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "983c3441dd05301eebcc67bbf509ff7e",
		  
		  "name": "Angela",
		  "createdDate": "2023-01-25 04:20:44",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 484,
		  "schedulePercent": 0.303604,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "983e4a048450d5d5d37049fc3ec09c9d",
		  
		  "name": "Juli&#225;n",
		  "createdDate": "2024-04-10 20:44:38",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 19,
		  "totalStates": 32,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "983e6ad8680d4073cc548b3f1dc5cae5",
		  
		  "name": "Lexi",
		  "createdDate": "2024-03-25 17:35:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 114,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 951,
		  "schedulePercent": 0.475861,
		  "totalGuests": 987,
		  "guestPercent": 0.843608,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Signal",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 176,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9841acba49f855ed118ad3424939b0f8",
		  
		  "name": "Teresa",
		  "createdDate": "2024-03-13 05:25:09",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 107,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 715,
		  "schedulePercent": 0.392112,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "984d3e9a9ec9f40ad109fff347af2d00",
		  
		  "name": "Eben",
		  "createdDate": "2024-04-09 18:51:03",
		  "totalOrganizations": 1,
		  "totalTours": 21,
		  "totalDays": 162,
		  "totalCountries": 15,
		  "totalStates": 30,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 871,
		  "schedulePercent": 0.448776,
		  "totalGuests": 272,
		  "guestPercent": 0.636333,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Warner Theatre",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "984fd75f352bdf7b562bb160e86dedcd",
		  
		  "name": "Austin",
		  "createdDate": "2016-09-13 22:43:15",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 240,
		  "totalCountries": 19,
		  "totalStates": 35,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 709,
		  "schedulePercent": 0.389846,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "The Workman's Club",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "984fe0916cb161376dc73cc51df70dad",
		  
		  "name": "Chloe",
		  "createdDate": "2024-03-15 12:59:55",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 161,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 668,
		  "schedulePercent": 0.374207,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "Mercury Lounge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9850b7992c523ff55fb61f996061d466",
		  
		  "name": "Lalo",
		  "createdDate": "2009-12-03 00:02:15",
		  "totalOrganizations": 14,
		  "totalTours": 7,
		  "totalDays": 34,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 202,
		  "schedulePercent": 0.162058,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Hoedown Hill",
		  "mostGuestCity": "Windsor",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "985766ed3e7abb255a42bf5714799a62",
		  
		  "name": "Jonathan",
		  "createdDate": "2018-03-06 03:17:31",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 479,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 771,
		  "schedulePercent": 0.412625,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98585a27d1c609807a41669240a4c69d",
		  
		  "name": "Gabriel",
		  "createdDate": "2009-06-03 21:55:17",
		  "totalOrganizations": 13,
		  "totalTours": 1,
		  "totalDays": 105,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 485,
		  "schedulePercent": 0.30383,
		  "totalGuests": 1604,
		  "guestPercent": 0.920331,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9871efb85a12986baf07b531aa8977e2",
		  
		  "name": "Jenna",
		  "createdDate": "2022-09-01 17:00:04",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 359,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 2349,
		  "schedulePercent": 0.768019,
		  "totalGuests": 847,
		  "guestPercent": 0.819243,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9877d999e2f8fe34f992c24162fc0e9c",
		  
		  "name": "Peyton",
		  "createdDate": "2023-10-21 18:55:31",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 548,
		  "totalCountries": 10,
		  "totalStates": 52,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 2306,
		  "schedulePercent": 0.762353,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Terminal West",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "988241956b5c9df7f6576ad6335cc8c2",
		  
		  "name": "Brian",
		  "createdDate": "2019-10-29 23:31:44",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 451,
		  "totalCountries": 23,
		  "totalStates": 46,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1391,
		  "schedulePercent": 0.595195,
		  "totalGuests": 244,
		  "guestPercent": 0.6216,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Razzmatazz",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98ad470dc31928d96a09df63b3de3cec",
		  
		  "name": "Colin",
		  "createdDate": "2025-03-03 07:03:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 336,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Eastside Bowl",
		  "mostGuestCity": "Madison",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98bc063c225d381330331ec7c1452f92",
		  
		  "name": "William",
		  "createdDate": "2019-01-22 22:51:49",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 943,
		  "totalCountries": 15,
		  "totalStates": 69,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 2350,
		  "schedulePercent": 0.768246,
		  "totalGuests": 812,
		  "guestPercent": 0.811423,
		  "mostGuestDate": "2025-12-05 00:00:00",
		  "mostGuestName": "Sphere",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98bc77093dd1191a32bdb41f5270365d",
		  
		  "name": "Fabien",
		  "createdDate": "2015-01-16 17:13:12",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 252,
		  "totalCountries": 5,
		  "totalStates": 14,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 785,
		  "schedulePercent": 0.417384,
		  "totalGuests": 172,
		  "guestPercent": 0.575136,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Cepac Silo",
		  "mostGuestCity": "Marseille",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98c36e0095d91abff4af5b0ca13b0709",
		  
		  "name": "Kyle",
		  "createdDate": "2022-07-08 17:44:53",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 437,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2552,
		  "schedulePercent": 0.793178,
		  "totalGuests": 2244,
		  "guestPercent": 0.959769,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98c7f72a46908ac1156c54378778e316",
		  
		  "name": "Nicole",
		  "createdDate": "2021-09-07 22:18:15",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 108,
		  "totalCountries": 18,
		  "totalStates": 40,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 450,
		  "schedulePercent": 0.290911,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-08 00:00:00",
		  "mostGuestName": "The Atlantis",
		  "mostGuestCity": "Washington DC",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98d5221477b75ce3d7355b7ddf8bd9bf",
		  
		  "name": "Jordan",
		  "createdDate": "2018-07-10 18:00:14",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 521,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1486,
		  "schedulePercent": 0.615027,
		  "totalGuests": 335,
		  "guestPercent": 0.668064,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98da259f4cf20e44adbec14a47d08c62",
		  
		  "name": "Dylan",
		  "createdDate": "2021-03-27 17:50:31",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 657,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1636,
		  "schedulePercent": 0.646759,
		  "totalGuests": 473,
		  "guestPercent": 0.721668,
		  "mostGuestDate": "2025-01-15 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98e68af88991889733e623d6bd124669",
		  
		  "name": "Graham ",
		  "createdDate": "2021-06-22 04:29:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 663,
		  "schedulePercent": 0.372507,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98f462ca0f507bd097bc0ec1ce89fc07",
		  
		  "name": "Patrick",
		  "createdDate": "2015-08-12 21:22:59",
		  "totalOrganizations": 22,
		  "totalTours": 22,
		  "totalDays": 1516,
		  "totalCountries": 32,
		  "totalStates": 84,
		  "totalEvents": 402,
		  "eventPercent": 0.958862,
		  "totalScheduleItems": 8610,
		  "schedulePercent": 0.992294,
		  "totalGuests": 371,
		  "guestPercent": 0.68155,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "98fe95791a71b05df946bc0661d97ed8",
		  
		  "name": "KENYA ",
		  "createdDate": "2025-08-13 18:22:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 140,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 1292,
		  "schedulePercent": 0.569923,
		  "totalGuests": 1079,
		  "guestPercent": 0.860381,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "990c0a559917481a4ec0e311f6dcfa43",
		  
		  "name": "Zayne",
		  "createdDate": "2024-10-03 22:57:31",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 635,
		  "totalCountries": 6,
		  "totalStates": 45,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1670,
		  "schedulePercent": 0.653219,
		  "totalGuests": 1483,
		  "guestPercent": 0.907978,
		  "mostGuestDate": "2025-01-15 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "990ecb1f766b2ceb3ee6394f6a80ca3b",
		  
		  "name": "Matty",
		  "createdDate": "2019-08-21 10:16:22",
		  "totalOrganizations": 18,
		  "totalTours": 28,
		  "totalDays": 461,
		  "totalCountries": 19,
		  "totalStates": 73,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 2529,
		  "schedulePercent": 0.789778,
		  "totalGuests": 309,
		  "guestPercent": 0.654012,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99166614616cc7bca3954f693cd79d95",
		  
		  "name": "Brant",
		  "createdDate": "2012-11-20 20:10:35",
		  "totalOrganizations": 10,
		  "totalTours": 20,
		  "totalDays": 1374,
		  "totalCountries": 35,
		  "totalStates": 92,
		  "totalEvents": 422,
		  "eventPercent": 0.963962,
		  "totalScheduleItems": 7756,
		  "schedulePercent": 0.989461,
		  "totalGuests": 2515,
		  "guestPercent": 0.968495,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "991865dbce29a620c9a31518db6823ca",
		  
		  "name": "Daniel",
		  "createdDate": "2013-07-09 05:35:46",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 247,
		  "totalCountries": 27,
		  "totalStates": 40,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1311,
		  "schedulePercent": 0.574343,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Lollapalooza Festival Argentina",
		  "mostGuestCity": "San Isidro",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "992868fbaf2af5dd2536d6729a9fcb22",
		  
		  "name": "Risa",
		  "createdDate": "2022-08-16 06:50:18",
		  "totalOrganizations": 18,
		  "totalTours": 11,
		  "totalDays": 204,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1145,
		  "schedulePercent": 0.533092,
		  "totalGuests": 374,
		  "guestPercent": 0.683137,
		  "mostGuestDate": "2025-05-20 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "992989dbb3ed745c3371d8c247a1a072",
		  
		  "name": "Michael",
		  "createdDate": "2024-11-04 17:53:41",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 598,
		  "totalCountries": 6,
		  "totalStates": 44,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 1909,
		  "schedulePercent": 0.696283,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "993fb0dac8292eccf347f657ca434737",
		  
		  "name": "Jake",
		  "createdDate": "2011-04-20 10:41:08",
		  "totalOrganizations": 9,
		  "totalTours": 38,
		  "totalDays": 363,
		  "totalCountries": 8,
		  "totalStates": 100,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 1972,
		  "schedulePercent": 0.708296,
		  "totalGuests": 415,
		  "guestPercent": 0.699456,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "994031eccf317a07aa29bdf5fd532d4a",
		  
		  "name": "Carl",
		  "createdDate": "2022-08-03 15:44:40",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 205,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 1842,
		  "schedulePercent": 0.68393,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Fort Mose Historic State Park",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "995b1904dc26f7f945a7701ed7a34109",
		  
		  "name": "Chelsea",
		  "createdDate": "2019-06-19 23:39:12",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 179,
		  "totalCountries": 18,
		  "totalStates": 46,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 2786,
		  "schedulePercent": 0.820376,
		  "totalGuests": 709,
		  "guestPercent": 0.787511,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Jyske Bank BOXEN",
		  "mostGuestCity": "Herning",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9960e95fd9160e1f6e4b926992460840",
		  
		  "name": "John",
		  "createdDate": "2011-04-07 03:15:11",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 125,
		  "schedulePercent": 0.114914,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9966af8080877118dba28228e26bb99f",
		  
		  "name": "Clarence",
		  "createdDate": "2018-01-10 15:20:04",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 774,
		  "totalCountries": 26,
		  "totalStates": 40,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2861,
		  "schedulePercent": 0.828649,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9980157399d576f33edc2caec34bae2c",
		  
		  "name": "Kirkland",
		  "createdDate": "2023-09-07 16:51:40",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 321,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 31,
		  "schedulePercent": 0.0420444,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Tipitina's Uptown",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99869ca7b84592a97a189f2431fe7ad7",
		  
		  "name": "Danny ",
		  "createdDate": "2013-10-17 19:53:46",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 473,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1781,
		  "schedulePercent": 0.672711,
		  "totalGuests": 569,
		  "guestPercent": 0.749773,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9994703a95d56ac96fe22904e9226aa9",
		  
		  "name": "Aaron",
		  "createdDate": "2023-09-26 15:23:59",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 639,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1462,
		  "schedulePercent": 0.609474,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99a2bc45c546f9ea264fc9e03ed2331c",
		  
		  "name": "Carolyn",
		  "createdDate": "2024-03-14 20:22:18",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 152,
		  "totalCountries": 8,
		  "totalStates": 41,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 868,
		  "schedulePercent": 0.448096,
		  "totalGuests": 97,
		  "guestPercent": 0.516092,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Columbia Theater",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99a4b7a446c9c7f36f60552c65b68c01",
		  
		  "name": "MM Production",
		  "createdDate": "2024-06-14 23:28:00",
		  "totalOrganizations": 5,
		  "totalTours": 16,
		  "totalDays": 1078,
		  "totalCountries": 8,
		  "totalStates": 52,
		  "totalEvents": 279,
		  "eventPercent": 0.897439,
		  "totalScheduleItems": 3686,
		  "schedulePercent": 0.895059,
		  "totalGuests": 772,
		  "guestPercent": 0.800771,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99aa7beda3d1f3977e391078f3c483e6",
		  
		  "name": "Abby",
		  "createdDate": "2015-10-05 17:58:50",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 255,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 2687,
		  "schedulePercent": 0.80757,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99cc16a2f749741af5d48f182c11e2b2",
		  
		  "name": "CFA",
		  "createdDate": "2024-11-04 17:19:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 133,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1416,
		  "schedulePercent": 0.601655,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99ce86b8eb6fb8157b08649089b8206d",
		  
		  "name": "Kyle",
		  "createdDate": "2022-04-18 00:38:58",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 127,
		  "totalCountries": 6,
		  "totalStates": 40,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1222,
		  "schedulePercent": 0.553264,
		  "totalGuests": 185,
		  "guestPercent": 0.583069,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Marquee Theatre",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99d11489991cab2ec096d5ca153ab55a",
		  
		  "name": "Zoey",
		  "createdDate": "2024-03-27 05:20:31",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 462,
		  "totalCountries": 17,
		  "totalStates": 44,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1263,
		  "schedulePercent": 0.563803,
		  "totalGuests": 309,
		  "guestPercent": 0.654012,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99d1904c17793a356dedb07734ee3a46",
		  
		  "name": "laura",
		  "createdDate": "2025-05-02 00:53:46",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 75,
		  "totalCountries": 11,
		  "totalStates": 16,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 307,
		  "schedulePercent": 0.221102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99df6defac5d7365b87b9b6cb4e6e5b3",
		  
		  "name": "Gerard",
		  "createdDate": "2025-10-20 11:42:11",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 152,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 1400,
		  "schedulePercent": 0.597801,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99e8e73856cd35951430e641ec13c0c4",
		  
		  "name": "Zach",
		  "createdDate": "2025-02-15 23:39:23",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 470,
		  "totalCountries": 11,
		  "totalStates": 46,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 2511,
		  "schedulePercent": 0.787851,
		  "totalGuests": 1798,
		  "guestPercent": 0.933137,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99fa49ca857315059d0465f0dd1139e4",
		  
		  "name": "Emmanuel",
		  "createdDate": "2018-01-12 18:00:28",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 92,
		  "totalCountries": 5,
		  "totalStates": 14,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 472,
		  "schedulePercent": 0.299071,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "ZÃ‰NITH DE TOULON",
		  "mostGuestCity": "Toulon",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "99fbf6d31b810e2e359253e630e666e6",
		  
		  "name": "Paul",
		  "createdDate": "2018-07-17 19:47:31",
		  "totalOrganizations": 35,
		  "totalTours": 22,
		  "totalDays": 893,
		  "totalCountries": 16,
		  "totalStates": 73,
		  "totalEvents": 313,
		  "eventPercent": 0.921351,
		  "totalScheduleItems": 4288,
		  "schedulePercent": 0.930417,
		  "totalGuests": 993,
		  "guestPercent": 0.844855,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a02e5fbb03dfa0b4959f1e856ad4b66",
		  
		  "name": "Alejandro",
		  "createdDate": "2012-02-07 23:03:32",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 768,
		  "totalCountries": 11,
		  "totalStates": 39,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1240,
		  "schedulePercent": 0.557344,
		  "totalGuests": 584,
		  "guestPercent": 0.75442,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Saenger Theatre",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 145,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a16c126d2c3c4b903b6f6d33e75be60",
		  
		  "name": "David",
		  "createdDate": "2021-09-14 15:33:50",
		  "totalOrganizations": 17,
		  "totalTours": 17,
		  "totalDays": 467,
		  "totalCountries": 29,
		  "totalStates": 68,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2712,
		  "schedulePercent": 0.810517,
		  "totalGuests": 389,
		  "guestPercent": 0.68971,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a1851d5602be6b125a875fd4888dbbf",
		  
		  "name": "Glenn",
		  "createdDate": "2012-11-09 19:23:08",
		  "totalOrganizations": 14,
		  "totalTours": 9,
		  "totalDays": 385,
		  "totalCountries": 21,
		  "totalStates": 38,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1380,
		  "schedulePercent": 0.592702,
		  "totalGuests": 216,
		  "guestPercent": 0.605961,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Royal Festival Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a1af7d819daef282ddbc47829477a46",
		  
		  "name": "Dani",
		  "createdDate": "2025-05-23 23:44:22",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 71,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 271,
		  "schedulePercent": 0.200023,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Lincoln Center for the Performing Arts",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a1ed6a764197c122274570f869e639c",
		  
		  "name": "Patrick",
		  "createdDate": "2015-09-12 18:11:23",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 950,
		  "totalCountries": 5,
		  "totalStates": 47,
		  "totalEvents": 319,
		  "eventPercent": 0.925204,
		  "totalScheduleItems": 4781,
		  "schedulePercent": 0.94719,
		  "totalGuests": 3542,
		  "guestPercent": 0.99014,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a32bc3ac352db0914790e30c9b9caef",
		  
		  "name": "Joe",
		  "createdDate": "2020-02-04 16:46:59",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 583,
		  "totalCountries": 4,
		  "totalStates": 44,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1716,
		  "schedulePercent": 0.661265,
		  "totalGuests": 882,
		  "guestPercent": 0.825703,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a3f9de3c720fbcceb5aec151c4933ee",
		  
		  "name": "Charles ",
		  "createdDate": "2025-03-19 22:03:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 283,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 12,
		  "schedulePercent": 0.0226655,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a3fc6c207d9c973d7480d6e31310b7b",
		  
		  "name": "David",
		  "createdDate": "2019-08-07 01:42:06",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 123,
		  "totalCountries": 9,
		  "totalStates": 29,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 229,
		  "schedulePercent": 0.177131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a45a021a595c5dabc2b71d8b0eac1a9",
		  
		  "name": "harrison",
		  "createdDate": "2024-08-23 12:23:03",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 360,
		  "totalCountries": 17,
		  "totalStates": 36,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 657,
		  "schedulePercent": 0.370354,
		  "totalGuests": 236,
		  "guestPercent": 0.6165,
		  "mostGuestDate": "2025-02-11 00:00:00",
		  "mostGuestName": "Exit/In",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a4c843e106c82e415cbd04c1e8f5f91",
		  
		  "name": "Kyle",
		  "createdDate": "2025-03-15 01:48:50",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 228,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 208,
		  "schedulePercent": 0.165005,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a531ab230f0ca139740f8ac8e6b9634",
		  
		  "name": "Tommy ",
		  "createdDate": "2023-04-26 09:46:50",
		  "totalOrganizations": 14,
		  "totalTours": 14,
		  "totalDays": 921,
		  "totalCountries": 37,
		  "totalStates": 58,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 3992,
		  "schedulePercent": 0.913078,
		  "totalGuests": 669,
		  "guestPercent": 0.777652,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a5b04841f4db967318f327a211caf3d",
		  
		  "name": "Harrison",
		  "createdDate": "2018-09-04 04:37:32",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 46,
		  "totalCountries": 11,
		  "totalStates": 19,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Prince Bandroom",
		  "mostGuestCity": "St Kilda",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a618540c1d1fcd8d46d50263990c28e",
		  
		  "name": "Louise",
		  "createdDate": "2022-10-04 11:33:06",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 24,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 260,
		  "schedulePercent": 0.194923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a72110601a29b4a9451c005a4c7deb2",
		  
		  "name": "Johnny",
		  "createdDate": "2025-01-10 22:12:34",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 226,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1990,
		  "schedulePercent": 0.711695,
		  "totalGuests": 308,
		  "guestPercent": 0.653105,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Church In The Son",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a76f36f6ea66b2cb92cf9f1a0a74fc7",
		  
		  "name": "Bailey ",
		  "createdDate": "2023-03-13 15:56:32",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 245,
		  "totalCountries": 18,
		  "totalStates": 48,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1501,
		  "schedulePercent": 0.61854,
		  "totalGuests": 417,
		  "guestPercent": 0.700363,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a864944329830f24946834e6935531a",
		  
		  "name": "Neil",
		  "createdDate": "2011-02-15 14:51:48",
		  "totalOrganizations": 12,
		  "totalTours": 1,
		  "totalDays": 218,
		  "totalCountries": 12,
		  "totalStates": 29,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 562,
		  "schedulePercent": 0.337942,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a911650bc8bb67dd365ec3fbfd58912",
		  
		  "name": "Kae",
		  "createdDate": "2024-05-07 19:39:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 37,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 181,
		  "schedulePercent": 0.147212,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9a99dcaf1c0fae4a75a19ae363c3ac41",
		  
		  "name": "Early",
		  "createdDate": "2014-12-02 07:21:05",
		  "totalOrganizations": 20,
		  "totalTours": 19,
		  "totalDays": 391,
		  "totalCountries": 33,
		  "totalStates": 39,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 2106,
		  "schedulePercent": 0.733908,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9aa1344a9b428906d339dd056d30218f",
		  
		  "name": "Adrian",
		  "createdDate": "2022-02-10 01:37:02",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 136,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 147,
		  "schedulePercent": 0.128853,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Altar Bar",
		  "mostGuestCity": "Hobart",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9aad856e46a2f6ea881dd1a7a33cf190",
		  
		  "name": "Robert",
		  "createdDate": "2017-07-25 13:46:24",
		  "totalOrganizations": 6,
		  "totalTours": 20,
		  "totalDays": 171,
		  "totalCountries": 29,
		  "totalStates": 47,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1475,
		  "schedulePercent": 0.611854,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Darling Harbour Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ab3db494f3a9296d22de9f3402f46bd",
		  
		  "name": "Zachary",
		  "createdDate": "2025-04-01 20:24:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 236,
		  "schedulePercent": 0.182344,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9abbeeb58d60a1e1ddfbffd30f314a26",
		  
		  "name": "Jason",
		  "createdDate": "2023-08-25 15:24:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 314,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1143,
		  "schedulePercent": 0.532298,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "Fox Theater",
		  "mostGuestCity": "Oakland",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ac6fba0801d55fc14cd7055e29e2d1e",
		  
		  "name": "Connor",
		  "createdDate": "2018-10-04 19:13:42",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 593,
		  "totalCountries": 10,
		  "totalStates": 50,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 797,
		  "schedulePercent": 0.421464,
		  "totalGuests": 607,
		  "guestPercent": 0.760879,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Michigan Lottery Amphitheatre at Freedom Hill",
		  "mostGuestCity": "Sterling Heights",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9acda188a983374e11202a26cd0f05ef",
		  
		  "name": "Roger",
		  "createdDate": "2022-03-17 17:04:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 97,
		  "totalCountries": 16,
		  "totalStates": 18,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9acfb7978a54d272c4850d771ba7fc5e",
		  
		  "name": "Andreas",
		  "createdDate": "2023-09-20 09:32:45",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 165,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 2,
		  "eventPercent": 0.0163191,
		  "totalScheduleItems": 767,
		  "schedulePercent": 0.410925,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9adafa9e7f84863314b1a9abe7eedf3e",
		  
		  "name": "Molly",
		  "createdDate": "2022-04-25 23:19:16",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 202,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1716,
		  "schedulePercent": 0.661265,
		  "totalGuests": 212,
		  "guestPercent": 0.603921,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ae086a222a7a85dbc7738db8dc9a02b",
		  
		  "name": "Yannick",
		  "createdDate": "2025-02-03 15:37:59",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 106,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 459,
		  "schedulePercent": 0.294311,
		  "totalGuests": 468,
		  "guestPercent": 0.719515,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Salle Albert-Rousseau",
		  "mostGuestCity": "Ville de QuÃ©bec",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ae5ec6df2b07a1bc64aaaa60478b404",
		  
		  "name": "Markeisha ",
		  "createdDate": "2025-09-05 18:45:05",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 323,
		  "totalCountries": 11,
		  "totalStates": 37,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1284,
		  "schedulePercent": 0.568676,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Foundry",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ae60a2ab8c38a305f838154d1e86fb1",
		  
		  "name": "N",
		  "createdDate": "2023-09-23 08:56:45",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 452,
		  "totalCountries": 20,
		  "totalStates": 31,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 851,
		  "schedulePercent": 0.44039,
		  "totalGuests": 185,
		  "guestPercent": 0.583069,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ae76f9c2dcc6af951f2ee1f37b02eb2",
		  
		  "name": "Dave",
		  "createdDate": "2018-12-23 04:24:49",
		  "totalOrganizations": 73,
		  "totalTours": 63,
		  "totalDays": 1259,
		  "totalCountries": 13,
		  "totalStates": 44,
		  "totalEvents": 528,
		  "eventPercent": 0.981528,
		  "totalScheduleItems": 5533,
		  "schedulePercent": 0.968042,
		  "totalGuests": 1416,
		  "guestPercent": 0.901859,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9aeaff49b3503be4955f34b5b5a944db",
		  
		  "name": "Frank",
		  "createdDate": "2012-03-25 02:37:14",
		  "totalOrganizations": 27,
		  "totalTours": 26,
		  "totalDays": 1446,
		  "totalCountries": 27,
		  "totalStates": 77,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 3612,
		  "schedulePercent": 0.890299,
		  "totalGuests": 1873,
		  "guestPercent": 0.937783,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b10012d8683e3cf78b1ef6ec60b0dd9",
		  
		  "name": "Sarah",
		  "createdDate": "2021-08-02 12:06:43",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 534,
		  "totalCountries": 15,
		  "totalStates": 35,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 1636,
		  "schedulePercent": 0.646759,
		  "totalGuests": 888,
		  "guestPercent": 0.827516,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wythenshawe Park and Gardens",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b20526f63b4773433e77ea6a6ca1ad3",
		  
		  "name": "Aaron",
		  "createdDate": "2025-07-10 15:34:46",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 124,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 369,
		  "schedulePercent": 0.252946,
		  "totalGuests": 62,
		  "guestPercent": 0.473368,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Vogue Theatre",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b2a714376990f2003798eac55a55925",
		  
		  "name": "Jonathan",
		  "createdDate": "2024-10-03 02:08:03",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 1340,
		  "totalCountries": 22,
		  "totalStates": 63,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 2478,
		  "schedulePercent": 0.784451,
		  "totalGuests": 1104,
		  "guestPercent": 0.864801,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Footprint Center",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b2f1594ac98b499f94f21795a0319ab",
		  
		  "name": "Mellen",
		  "createdDate": "2025-10-02 08:27:00",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 30,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 267,
		  "schedulePercent": 0.197756,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b31f1c3b7b5a103705499fd37474d79",
		  
		  "name": "Martin",
		  "createdDate": "2023-01-27 12:22:23",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 101,
		  "totalCountries": 11,
		  "totalStates": 16,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b33ae58eed5ce504491d25d89487e0e",
		  
		  "name": "Megan",
		  "createdDate": "2023-04-29 08:39:49",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 465,
		  "totalCountries": 24,
		  "totalStates": 23,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1667,
		  "schedulePercent": 0.652652,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b3abb264f894fc29d35de4325e1879c",
		  
		  "name": "Jenny",
		  "createdDate": "2014-03-13 05:38:27",
		  "totalOrganizations": 19,
		  "totalTours": 14,
		  "totalDays": 491,
		  "totalCountries": 39,
		  "totalStates": 97,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 4298,
		  "schedulePercent": 0.93053,
		  "totalGuests": 1807,
		  "guestPercent": 0.933704,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Hala Stulecia",
		  "mostGuestCity": "WrocÅ‚aw",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b430ec4aea894a4f14beef3bc98c639",
		  
		  "name": "Cory",
		  "createdDate": "2015-06-15 20:26:59",
		  "totalOrganizations": 54,
		  "totalTours": 36,
		  "totalDays": 544,
		  "totalCountries": 18,
		  "totalStates": 55,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 1953,
		  "schedulePercent": 0.703876,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b44b2f7d1b2c25f18b1df22952d3c7a",
		  
		  "name": "Michael ",
		  "createdDate": "2023-08-23 14:34:06",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 34,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 200,
		  "guestPercent": 0.594855,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Light House Arts Centre",
		  "mostGuestCity": "Halifax",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b4bb28dd7751128affe3c58de753be3",
		  
		  "name": "Erin",
		  "createdDate": "2016-06-17 02:24:09",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 341,
		  "totalCountries": 12,
		  "totalStates": 32,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2998,
		  "schedulePercent": 0.842022,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b4fd16be28dd5f8d11e64a164b8860d",
		  
		  "name": "Dale",
		  "createdDate": "2009-09-23 17:57:10",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 74,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 363,
		  "schedulePercent": 0.249433,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "River Rock Casino Resort",
		  "mostGuestCity": "Richmond",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b5a92a27b36b2b878857aea079518bd",
		  
		  "name": "Madison",
		  "createdDate": "2022-09-07 16:56:30",
		  "totalOrganizations": 10,
		  "totalTours": 22,
		  "totalDays": 782,
		  "totalCountries": 29,
		  "totalStates": 88,
		  "totalEvents": 342,
		  "eventPercent": 0.93767,
		  "totalScheduleItems": 4604,
		  "schedulePercent": 0.940843,
		  "totalGuests": 1163,
		  "guestPercent": 0.872507,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "The Torch At The LA Memorial Coliseum",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b6b1ebbb725b17d9f264c1503673189",
		  
		  "name": "Victoria",
		  "createdDate": "2025-03-03 10:09:43",
		  "totalOrganizations": 13,
		  "totalTours": 14,
		  "totalDays": 69,
		  "totalCountries": 5,
		  "totalStates": 1,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 294,
		  "schedulePercent": 0.214415,
		  "totalGuests": 82,
		  "guestPercent": 0.499207,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b70c1208cc781be1df03443d6442df5",
		  
		  "name": "David",
		  "createdDate": "2024-03-03 18:27:42",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 216,
		  "totalCountries": 5,
		  "totalStates": 20,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 428,
		  "schedulePercent": 0.281505,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b819db46a685f907df8090b7f18f8a1",
		  
		  "name": "Christopher ",
		  "createdDate": "2017-03-21 04:04:06",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 192,
		  "totalCountries": 16,
		  "totalStates": 34,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 801,
		  "schedulePercent": 0.423277,
		  "totalGuests": 273,
		  "guestPercent": 0.636899,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b84a4dbdf7d2cb2d4cb3b85b76d7bdb",
		  
		  "name": "Nora",
		  "createdDate": "2020-01-24 05:09:07",
		  "totalOrganizations": 6,
		  "totalTours": 16,
		  "totalDays": 340,
		  "totalCountries": 42,
		  "totalStates": 71,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 2676,
		  "schedulePercent": 0.806437,
		  "totalGuests": 835,
		  "guestPercent": 0.816296,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9b9c61d60eb51bbdf6609bef160f4a46",
		  
		  "name": "Ryland",
		  "createdDate": "2012-09-02 03:37:39",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 687,
		  "totalCountries": 25,
		  "totalStates": 90,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 3246,
		  "schedulePercent": 0.863554,
		  "totalGuests": 1131,
		  "guestPercent": 0.868767,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 280,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bad690da8224afc58acf16dc815c6a1",
		  
		  "name": "Bjornar",
		  "createdDate": "2024-04-15 09:24:24",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 257,
		  "totalCountries": 8,
		  "totalStates": 14,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1046,
		  "schedulePercent": 0.503173,
		  "totalGuests": 782,
		  "guestPercent": 0.80349,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lyse Arena",
		  "mostGuestCity": "Stavanger",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bb80d24c7b809acd6f09116614ea0d3",
		  
		  "name": "Jan",
		  "createdDate": "2022-02-10 19:46:15",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 399,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 867,
		  "schedulePercent": 0.447643,
		  "totalGuests": 1549,
		  "guestPercent": 0.914665,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bc5390e1e7511acedd433f0401eda15",
		  
		  "name": "Dean",
		  "createdDate": "2025-09-26 17:12:11",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 51,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 340,
		  "schedulePercent": 0.238441,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Prudential Hall",
		  "mostGuestCity": "Newark",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bc7a7101288d2cc1df6f2c25570c649",
		  
		  "name": "Sean",
		  "createdDate": "2012-01-09 03:42:06",
		  "totalOrganizations": 13,
		  "totalTours": 3,
		  "totalDays": 74,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 318,
		  "schedulePercent": 0.225748,
		  "totalGuests": 285,
		  "guestPercent": 0.641999,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bc8df8c4f505d66c988975fa7b0ca66",
		  
		  "name": "Timothy",
		  "createdDate": "2014-04-01 20:52:35",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 427,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 312,
		  "eventPercent": 0.920671,
		  "totalScheduleItems": 1649,
		  "schedulePercent": 0.649932,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Yakov's Theatre",
		  "mostGuestCity": "Branson",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bd436f4315fdf6a207d243e956e7451",
		  
		  "name": "David",
		  "createdDate": "2025-05-09 21:27:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 104,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 414,
		  "schedulePercent": 0.275612,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9be83632ecd3fdbac1d3cf7c76562ed6",
		  
		  "name": "Peadar",
		  "createdDate": "2024-05-26 10:12:17",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 331,
		  "totalCountries": 20,
		  "totalStates": 21,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 826,
		  "schedulePercent": 0.433024,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Glass House",
		  "mostGuestCity": "Pomona",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bea90a3d3c76e669ddfe5c038cb35b8",
		  
		  "name": "Allison",
		  "createdDate": "2021-08-23 16:33:35",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 21,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 126,
		  "schedulePercent": 0.115707,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Dada Dallas",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bee50ee3cf77230d029b770f798888e",
		  
		  "name": "Jason",
		  "createdDate": "2023-06-15 23:35:32",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 545,
		  "totalCountries": 5,
		  "totalStates": 50,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 3152,
		  "schedulePercent": 0.855621,
		  "totalGuests": 1311,
		  "guestPercent": 0.887693,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bf34c078de45d1fb75c0bab4e467bc7",
		  
		  "name": "Brennan",
		  "createdDate": "2023-05-03 02:11:11",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 694,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1078,
		  "schedulePercent": 0.513146,
		  "totalGuests": 379,
		  "guestPercent": 0.685403,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Canada Life Place",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bf56e08baed326d8edbf37786486a48",
		  
		  "name": "James",
		  "createdDate": "2025-04-10 07:13:50",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 47,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bfde0c849ceb06fb209cdde311ac8be",
		  
		  "name": "Jamie",
		  "createdDate": "2015-01-28 17:11:22",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 739,
		  "totalCountries": 32,
		  "totalStates": 39,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2784,
		  "schedulePercent": 0.819923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9bfe6e2d8d07afc4ca91b21b5a59ea1b",
		  
		  "name": "Victor",
		  "createdDate": "2025-02-15 02:19:33",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 155,
		  "totalCountries": 10,
		  "totalStates": 53,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 740,
		  "schedulePercent": 0.401519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c037d3ab3d9da68444b1d82b66be7b8",
		  
		  "name": "Katie",
		  "createdDate": "2014-06-10 16:25:19",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 1169,
		  "totalCountries": 13,
		  "totalStates": 54,
		  "totalEvents": 406,
		  "eventPercent": 0.960335,
		  "totalScheduleItems": 4909,
		  "schedulePercent": 0.951609,
		  "totalGuests": 1007,
		  "guestPercent": 0.847801,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Mark C. Smith Concert Hall",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c04315cd2162836bd366767b8100cd9",
		  
		  "name": "Pansy",
		  "createdDate": "2023-07-10 22:36:58",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 479,
		  "schedulePercent": 0.302357,
		  "totalGuests": 83,
		  "guestPercent": 0.499773,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Bluebird Theater",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c05a9429ae7ac8b12da10d8fbffc459",
		  
		  "name": "Keanu",
		  "createdDate": "2021-11-08 07:38:34",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 39,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c230f727b20d749527f5afccad7dbcc",
		  
		  "name": "Julia",
		  "createdDate": "2023-01-20 10:10:05",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 781,
		  "totalCountries": 21,
		  "totalStates": 46,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 3091,
		  "schedulePercent": 0.850861,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "SÃ¶dra Teatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c2362c068c45fdefb0ac546c77ce895",
		  
		  "name": "Helen",
		  "createdDate": "2015-09-04 04:26:05",
		  "totalOrganizations": 17,
		  "totalTours": 12,
		  "totalDays": 441,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 758,
		  "schedulePercent": 0.408885,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c2386c594fd41f432dc7e4f5e9d7061",
		  
		  "name": "Cherish",
		  "createdDate": "2023-08-10 20:22:07",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 154,
		  "totalCountries": 9,
		  "totalStates": 29,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1257,
		  "schedulePercent": 0.562103,
		  "totalGuests": 1884,
		  "guestPercent": 0.939143,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c2c3b52a71f96a21fcf9a917194c4ba",
		  
		  "name": "GIOVANNI",
		  "createdDate": "2023-05-23 20:53:11",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 842,
		  "totalCountries": 17,
		  "totalStates": 47,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 1257,
		  "schedulePercent": 0.562103,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c2db3771e440cb75a73a4c432656229",
		  
		  "name": "Nikki",
		  "createdDate": "2011-01-25 02:55:08",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 165,
		  "totalCountries": 8,
		  "totalStates": 35,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1074,
		  "schedulePercent": 0.511786,
		  "totalGuests": 382,
		  "guestPercent": 0.686537,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Massey Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c2ef2521fb0f2ab8b356d365d3818e1",
		  
		  "name": "Dave",
		  "createdDate": "2022-06-14 20:25:56",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 732,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-03-03 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c3bb0e400e274524d64903e79e2b5aa",
		  
		  "name": "Dave",
		  "createdDate": "2012-01-12 17:53:59",
		  "totalOrganizations": 24,
		  "totalTours": 29,
		  "totalDays": 1387,
		  "totalCountries": 31,
		  "totalStates": 102,
		  "totalEvents": 426,
		  "eventPercent": 0.964755,
		  "totalScheduleItems": 4670,
		  "schedulePercent": 0.942996,
		  "totalGuests": 1850,
		  "guestPercent": 0.93631,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c3e2b29d988c87293d4d42111f06ff7",
		  
		  "name": "Murray",
		  "createdDate": "2022-01-28 10:02:27",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 153,
		  "totalCountries": 14,
		  "totalStates": 49,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1048,
		  "schedulePercent": 0.503853,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c47922e17691155834d1446455cef3e",
		  
		  "name": "Sean",
		  "createdDate": "2016-01-08 23:56:06",
		  "totalOrganizations": 18,
		  "totalTours": 7,
		  "totalDays": 908,
		  "totalCountries": 10,
		  "totalStates": 43,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1528,
		  "schedulePercent": 0.622733,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c5415684f7144259751ed78a3fc7aad",
		  
		  "name": "Alex",
		  "createdDate": "2022-05-19 03:37:29",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 89,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 887,
		  "schedulePercent": 0.452856,
		  "totalGuests": 936,
		  "guestPercent": 0.836582,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "1720",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c607d442326b25ff1ce2eb8c7b7fa1b",
		  
		  "name": "Zippy",
		  "createdDate": "2013-04-24 12:51:15",
		  "totalOrganizations": 13,
		  "totalTours": 8,
		  "totalDays": 557,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 516,
		  "schedulePercent": 0.31947,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "Hackney Church (St John at Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c6e1bf87b42655d6dbc304d42ffa1f6",
		  
		  "name": "Paul",
		  "createdDate": "2022-02-21 21:26:48",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 157,
		  "totalCountries": 22,
		  "totalStates": 45,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1034,
		  "schedulePercent": 0.499887,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c7b58bcf24012cc7040aa54220d586a",
		  
		  "name": "Ricky",
		  "createdDate": "2018-01-29 21:10:25",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 177,
		  "totalCountries": 20,
		  "totalStates": 54,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 2216,
		  "schedulePercent": 0.75068,
		  "totalGuests": 172,
		  "guestPercent": 0.575136,
		  "mostGuestDate": "2025-01-10 00:00:00",
		  "mostGuestName": "Taffeta Music Hall",
		  "mostGuestCity": "Lowell",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c80338ea01d3b2104964a0defcea22c",
		  
		  "name": "Beau",
		  "createdDate": "2012-06-05 18:00:02",
		  "totalOrganizations": 16,
		  "totalTours": 18,
		  "totalDays": 418,
		  "totalCountries": 12,
		  "totalStates": 55,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 4258,
		  "schedulePercent": 0.92951,
		  "totalGuests": 3290,
		  "guestPercent": 0.987534,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c8374be5ab3de33e8e8191fafd0c5e7",
		  
		  "name": "Ted",
		  "createdDate": "2018-04-09 02:33:19",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 344,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 335,
		  "schedulePercent": 0.234021,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9c9ba6f9b203240f60d98cc02f4d1562",
		  
		  "name": "Ted",
		  "createdDate": "2016-03-22 01:22:25",
		  "totalOrganizations": 19,
		  "totalTours": 14,
		  "totalDays": 453,
		  "totalCountries": 13,
		  "totalStates": 34,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 975,
		  "schedulePercent": 0.483001,
		  "totalGuests": 95,
		  "guestPercent": 0.513826,
		  "mostGuestDate": "2025-05-08 00:00:00",
		  "mostGuestName": "Dada Dallas",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ca175c983496169a787d563d09b2d0c",
		  
		  "name": "Dirk",
		  "createdDate": "2022-05-24 18:07:36",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 78,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 319,
		  "schedulePercent": 0.226541,
		  "totalGuests": 351,
		  "guestPercent": 0.675317,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Burg Eisenhardt",
		  "mostGuestCity": "Bad Belzig",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ca22f83f8ac95eda6a84c611e9a88fa",
		  
		  "name": "Andrew",
		  "createdDate": "2022-06-20 15:32:02",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 942,
		  "totalCountries": 18,
		  "totalStates": 63,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 2563,
		  "schedulePercent": 0.794198,
		  "totalGuests": 1004,
		  "guestPercent": 0.847008,
		  "mostGuestDate": "2025-03-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cb03a46d5cb4d66d64ce7798cd29c8c",
		  
		  "name": "Eva",
		  "createdDate": "2023-12-18 10:51:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 49,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 603,
		  "schedulePercent": 0.351881,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cb1749cddfa4a072fb362f3bc2364d8",
		  
		  "name": "Ashley",
		  "createdDate": "2013-09-26 20:25:49",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 386,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 2827,
		  "schedulePercent": 0.825249,
		  "totalGuests": 1788,
		  "guestPercent": 0.932684,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cb26990441121ff788c2a2a38c1c211",
		  
		  "name": "Taylor",
		  "createdDate": "2025-05-05 00:18:25",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 35,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 351,
		  "schedulePercent": 0.24354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cc0c4fa50cbaac2f8f2e8b0d5f7c1cf",
		  
		  "name": "Alexander",
		  "createdDate": "2013-12-05 02:32:43",
		  "totalOrganizations": 21,
		  "totalTours": 25,
		  "totalDays": 756,
		  "totalCountries": 23,
		  "totalStates": 54,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 3542,
		  "schedulePercent": 0.884406,
		  "totalGuests": 294,
		  "guestPercent": 0.646532,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "The Barracks Precinct",
		  "mostGuestCity": "Manly",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cc8589d31dced6d36539be81f86f008",
		  
		  "name": "Chris",
		  "createdDate": "2010-03-09 22:49:27",
		  "totalOrganizations": 14,
		  "totalTours": 4,
		  "totalDays": 250,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1357,
		  "schedulePercent": 0.586809,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-12-02 00:00:00",
		  "mostGuestName": "Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cd4b32fa699b6834129458cce322b26",
		  
		  "name": "Jorrit",
		  "createdDate": "2025-09-28 21:04:31",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 188,
		  "totalCountries": 10,
		  "totalStates": 16,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 168,
		  "schedulePercent": 0.139279,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "[UNVRS] IBIZA",
		  "mostGuestCity": "Sant Rafel",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cd4fc18448d217c1790ac8c95011e05",
		  
		  "name": "Camden",
		  "createdDate": "2024-08-07 21:06:47",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 278,
		  "totalCountries": 20,
		  "totalStates": 42,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1053,
		  "schedulePercent": 0.505893,
		  "totalGuests": 237,
		  "guestPercent": 0.617294,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Carlswerk Victoria",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cea2ade03ef83172186486121e84474",
		  
		  "name": "Tour",
		  "createdDate": "2024-07-10 11:04:45",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 313,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1281,
		  "schedulePercent": 0.567656,
		  "totalGuests": 352,
		  "guestPercent": 0.675884,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ceeeac53b4ed57639429d346adfea96",
		  
		  "name": "Niklas",
		  "createdDate": "2018-11-01 17:12:17",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 49,
		  "totalCountries": 9,
		  "totalStates": 17,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 267,
		  "schedulePercent": 0.197756,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9cf373df2a181e60ae5d207cb1cfc89c",
		  
		  "name": "John",
		  "createdDate": "2019-01-05 04:12:08",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 296,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 748,
		  "schedulePercent": 0.404125,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d04c0c444abb4853bd24da74af6ff59",
		  
		  "name": "Casey",
		  "createdDate": "2019-03-28 18:18:24",
		  "totalOrganizations": 13,
		  "totalTours": 15,
		  "totalDays": 969,
		  "totalCountries": 12,
		  "totalStates": 59,
		  "totalEvents": 313,
		  "eventPercent": 0.921351,
		  "totalScheduleItems": 5312,
		  "schedulePercent": 0.962715,
		  "totalGuests": 1437,
		  "guestPercent": 0.903672,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d16e7f6f6e48651cfbbafa6b07be9c4",
		  
		  "name": "Lewis",
		  "createdDate": "2014-10-15 15:00:03",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 749,
		  "totalCountries": 17,
		  "totalStates": 46,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1967,
		  "schedulePercent": 0.707389,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d20645b2deb43df5d38cf356163fd20",
		  
		  "name": "Steve",
		  "createdDate": "2018-09-08 21:06:36",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 217,
		  "totalCountries": 12,
		  "totalStates": 28,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1012,
		  "schedulePercent": 0.493994,
		  "totalGuests": 199,
		  "guestPercent": 0.594062,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Jazz Cafe",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d2c49c9233936d39c13782a31f24bf5",
		  
		  "name": "tyler",
		  "createdDate": "2023-08-21 18:10:16",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 435,
		  "totalCountries": 2,
		  "totalStates": 46,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 3723,
		  "schedulePercent": 0.897439,
		  "totalGuests": 801,
		  "guestPercent": 0.807684,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "The Walmart AMP",
		  "mostGuestCity": "Rogers",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d3505056ee2ab862eb2f07c245fcf3a",
		  
		  "name": "Sam",
		  "createdDate": "2025-04-01 14:55:44",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 348,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 958,
		  "schedulePercent": 0.478468,
		  "totalGuests": 191,
		  "guestPercent": 0.586582,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Hill Country Barbecue Market",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d44acd3dfaaa319e35b9f604066aa46",
		  
		  "name": "Erik",
		  "createdDate": "2013-09-03 22:23:51",
		  "totalOrganizations": 17,
		  "totalTours": 9,
		  "totalDays": 406,
		  "totalCountries": 16,
		  "totalStates": 44,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 2247,
		  "schedulePercent": 0.754646,
		  "totalGuests": 230,
		  "guestPercent": 0.612534,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d565e7dbb2583335a4667c7a6ed3216",
		  
		  "name": "Willie",
		  "createdDate": "2020-03-06 04:53:00",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 1292,
		  "totalCountries": 5,
		  "totalStates": 30,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 4408,
		  "schedulePercent": 0.935063,
		  "totalGuests": 212,
		  "guestPercent": 0.603921,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Resorts World Theatre",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d5a479c9fb93fbef65a16054ed0d613",
		  
		  "name": "Deven ",
		  "createdDate": "2017-05-09 00:14:58",
		  "totalOrganizations": 15,
		  "totalTours": 36,
		  "totalDays": 1028,
		  "totalCountries": 19,
		  "totalStates": 71,
		  "totalEvents": 434,
		  "eventPercent": 0.967362,
		  "totalScheduleItems": 5136,
		  "schedulePercent": 0.958409,
		  "totalGuests": 2621,
		  "guestPercent": 0.973141,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "The Met Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d6b064e1659f34050ced60584695ddf",
		  
		  "name": "Dominic",
		  "createdDate": "2021-12-28 18:21:00",
		  "totalOrganizations": 9,
		  "totalTours": 65,
		  "totalDays": 398,
		  "totalCountries": 7,
		  "totalStates": 43,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 3170,
		  "schedulePercent": 0.857321,
		  "totalGuests": 966,
		  "guestPercent": 0.840662,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Exit/In",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d6f4e8b63394636785a0ec9af16ebd3",
		  
		  "name": "Margaux",
		  "createdDate": "2019-08-16 15:09:03",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 517,
		  "totalCountries": 14,
		  "totalStates": 45,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 880,
		  "schedulePercent": 0.451269,
		  "totalGuests": 297,
		  "guestPercent": 0.648119,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Festival d'ete de Quebec",
		  "mostGuestCity": "Ville de Quebec",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d7d65ef2a355ed751c9821a09d28b0c",
		  
		  "name": "Anders",
		  "createdDate": "2019-10-22 19:59:54",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 4,
		  "totalStates": 4,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 273,
		  "schedulePercent": 0.201609,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d81b7cc5e09a969c611b23db65da55f",
		  
		  "name": "sebastien",
		  "createdDate": "2022-01-12 09:59:23",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 1255,
		  "totalCountries": 5,
		  "totalStates": 46,
		  "totalEvents": 391,
		  "eventPercent": 0.956482,
		  "totalScheduleItems": 5712,
		  "schedulePercent": 0.971668,
		  "totalGuests": 739,
		  "guestPercent": 0.793858,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "LDLC Arena",
		  "mostGuestCity": "DÃ©cines-Charpieu",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d83411a1d0aa6890d525e952ec3509a",
		  
		  "name": "Robert",
		  "createdDate": "2023-03-03 00:50:23",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 210,
		  "totalCountries": 22,
		  "totalStates": 56,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 282,
		  "schedulePercent": 0.206936,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d85232d490b45b4df58f38f12e00299",
		  
		  "name": "Patrick",
		  "createdDate": "2024-01-23 21:19:16",
		  "totalOrganizations": 24,
		  "totalTours": 14,
		  "totalDays": 497,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 460,
		  "eventPercent": 0.972575,
		  "totalScheduleItems": 2579,
		  "schedulePercent": 0.795671,
		  "totalGuests": 3913,
		  "guestPercent": 0.992634,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 391,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d87ebb7a254ce9a2a4d7375d04b67c2",
		  
		  "name": "Mark",
		  "createdDate": "2012-04-23 21:07:31",
		  "totalOrganizations": 21,
		  "totalTours": 7,
		  "totalDays": 760,
		  "totalCountries": 22,
		  "totalStates": 40,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2506,
		  "schedulePercent": 0.787398,
		  "totalGuests": 380,
		  "guestPercent": 0.685857,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Uber arena (Formerly Mercedes Benz Arena)",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d923dbf3289795aaaa3e1e760ef67d7",
		  
		  "name": "Sam",
		  "createdDate": "2025-01-09 17:41:19",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 94,
		  "totalCountries": 12,
		  "totalStates": 39,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 702,
		  "schedulePercent": 0.387693,
		  "totalGuests": 388,
		  "guestPercent": 0.68903,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d95c59e3d6d362a45b05774bb6d586c",
		  
		  "name": "Moon",
		  "createdDate": "2022-03-11 23:02:41",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 79,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 709,
		  "schedulePercent": 0.389846,
		  "totalGuests": 215,
		  "guestPercent": 0.605281,
		  "mostGuestDate": "2025-01-28 00:00:00",
		  "mostGuestName": "Tipitina's Uptown",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9d9eeee30f225176eb93496a38f9b432",
		  
		  "name": "Borja",
		  "createdDate": "2019-12-02 16:24:38",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 21,
		  "totalCountries": 7,
		  "totalStates": 2,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 125,
		  "schedulePercent": 0.114914,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-07 00:00:00",
		  "mostGuestName": "Redoutensaal",
		  "mostGuestCity": "Erlangen",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9da9aa6d72e14162de2f560a84151cc9",
		  
		  "name": "Daniel",
		  "createdDate": "2015-12-16 17:41:51",
		  "totalOrganizations": 8,
		  "totalTours": 19,
		  "totalDays": 866,
		  "totalCountries": 14,
		  "totalStates": 62,
		  "totalEvents": 408,
		  "eventPercent": 0.960902,
		  "totalScheduleItems": 4113,
		  "schedulePercent": 0.919764,
		  "totalGuests": 619,
		  "guestPercent": 0.763373,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "SSE Arena Belfast",
		  "mostGuestCity": "Belfast",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dabcee2e8a6d52062a1da5c5e7a2268",
		  
		  "name": "David",
		  "createdDate": "2025-01-06 18:51:23",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 277,
		  "totalCountries": 28,
		  "totalStates": 41,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 766,
		  "schedulePercent": 0.410245,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "The Observatory North Park",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dad82e8c9857d5c805e19cc2af1328b",
		  
		  "name": "Santiago ",
		  "createdDate": "2022-05-17 17:29:33",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 105,
		  "totalCountries": 7,
		  "totalStates": 33,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Roxy Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dc00bfda6e1bc4ea3abac7d2db53790",
		  
		  "name": "The Chandy",
		  "createdDate": "2018-01-02 19:40:28",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 80,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 593,
		  "schedulePercent": 0.348595,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dc034475815819f203c95a1aef62283",
		  
		  "name": "Sue",
		  "createdDate": "2017-09-05 23:54:01",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 214,
		  "totalCountries": 15,
		  "totalStates": 42,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1300,
		  "schedulePercent": 0.57151,
		  "totalGuests": 427,
		  "guestPercent": 0.705576,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dc641382133c4310027d19226947a90",
		  
		  "name": "TM",
		  "createdDate": "2021-09-15 00:12:00",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 122,
		  "guestPercent": 0.538985,
		  "mostGuestDate": "2025-07-22 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dcb3a4614a62db173e1e2857ccab8c6",
		  
		  "name": "John",
		  "createdDate": "2022-08-03 15:46:35",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 205,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 1842,
		  "schedulePercent": 0.68393,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Fort Mose Historic State Park",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dcd9f387c7e06b9ea28359edc77d4e6",
		  
		  "name": "Roxana",
		  "createdDate": "2019-05-21 16:32:34",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 349,
		  "totalCountries": 15,
		  "totalStates": 42,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 547,
		  "schedulePercent": 0.332956,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dcef5adf4a6d4a2399d1c802b0d71da",
		  
		  "name": "Charlotte",
		  "createdDate": "2022-02-24 03:59:58",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 295,
		  "totalCountries": 7,
		  "totalStates": 22,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 970,
		  "schedulePercent": 0.481188,
		  "totalGuests": 297,
		  "guestPercent": 0.648119,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "The Green Room Byron",
		  "mostGuestCity": "Tyagarah",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dd1228134b202329ef6553ecfb61ec0",
		  
		  "name": "ARIANNA",
		  "createdDate": "2023-07-25 01:51:25",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 374,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 498,
		  "schedulePercent": 0.31131,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Avalon Hollywood",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9dee171b932a2f713cdc1a0dbe872172",
		  
		  "name": "Jens",
		  "createdDate": "2022-06-20 17:05:22",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 24,
		  "totalCountries": 7,
		  "totalStates": 6,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 194,
		  "schedulePercent": 0.155712,
		  "totalGuests": 183,
		  "guestPercent": 0.581482,
		  "mostGuestDate": "2025-04-16 00:00:00",
		  "mostGuestName": "turock",
		  "mostGuestCity": "Essen",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9df06d509f0f1331c5cd5612bd69c7b6",
		  
		  "name": "Andrew",
		  "createdDate": "2012-07-09 06:05:35",
		  "totalOrganizations": 43,
		  "totalTours": 27,
		  "totalDays": 739,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2001,
		  "schedulePercent": 0.713962,
		  "totalGuests": 515,
		  "guestPercent": 0.734361,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Liberty Hall",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9df58a28b4da2f766931be4a34ce8b90",
		  
		  "name": "Production ",
		  "createdDate": "2018-05-09 01:01:07",
		  "totalOrganizations": 647,
		  "totalTours": 162,
		  "totalDays": 3332,
		  "totalCountries": 12,
		  "totalStates": 29,
		  "totalEvents": 1064,
		  "eventPercent": 0.99592,
		  "totalScheduleItems": 9978,
		  "schedulePercent": 0.996827,
		  "totalGuests": 1260,
		  "guestPercent": 0.881573,
		  "mostGuestDate": "2025-11-21 00:00:00",
		  "mostGuestName": "Perth HPC",
		  "mostGuestCity": "Mount Claremont",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e095cf8756c0afaa8580c7938c393ef",
		  
		  "name": "Tom",
		  "createdDate": "2015-06-30 02:15:02",
		  "totalOrganizations": 109,
		  "totalTours": 41,
		  "totalDays": 944,
		  "totalCountries": 22,
		  "totalStates": 54,
		  "totalEvents": 243,
		  "eventPercent": 0.864347,
		  "totalScheduleItems": 2694,
		  "schedulePercent": 0.808137,
		  "totalGuests": 654,
		  "guestPercent": 0.772439,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Sidney Myer Music Bowl",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e1395e88ebf1df473faa6015fecb7ca",
		  
		  "name": "Damian",
		  "createdDate": "2013-05-21 07:10:35",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 113,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 824,
		  "schedulePercent": 0.43223,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Hamer Hall",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e13f6626a45eb7c22d07fc9d59feaa5",
		  
		  "name": "Carin",
		  "createdDate": "2025-06-02 01:13:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 137,
		  "totalCountries": 17,
		  "totalStates": 16,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 194,
		  "schedulePercent": 0.155712,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e1421659fa8ba4ed1f8325ffa58d620",
		  
		  "name": "Talena ",
		  "createdDate": "2018-06-14 15:49:26",
		  "totalOrganizations": 9,
		  "totalTours": 16,
		  "totalDays": 711,
		  "totalCountries": 24,
		  "totalStates": 68,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 3956,
		  "schedulePercent": 0.911151,
		  "totalGuests": 486,
		  "guestPercent": 0.726428,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Finsbury Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e153bfe06baa40f0dcb879946c6bc23",
		  
		  "name": "Audrey",
		  "createdDate": "2019-07-24 23:40:28",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 200,
		  "totalCountries": 16,
		  "totalStates": 43,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1263,
		  "schedulePercent": 0.563803,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "Admiralspalast",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e1a8036930a5b361f909ee9cd224b55",
		  
		  "name": "Nicolas",
		  "createdDate": "2023-11-25 14:14:35",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 313,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1338,
		  "schedulePercent": 0.583182,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e1eefc191fc276b155dcb6a15c280c0",
		  
		  "name": "Stephen",
		  "createdDate": "2018-05-14 17:29:38",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 853,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1754,
		  "schedulePercent": 0.669198,
		  "totalGuests": 666,
		  "guestPercent": 0.776292,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e227d442361ec1b2da15aeae8e146fa",
		  
		  "name": "Hannah",
		  "createdDate": "2023-07-26 23:23:16",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 411,
		  "totalCountries": 19,
		  "totalStates": 62,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 1731,
		  "schedulePercent": 0.663985,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "House of Blues San Diego",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e232df8d0ffffbbcf1b98acaa1eb9dc",
		  
		  "name": "Hildamar",
		  "createdDate": "2024-04-03 03:19:04",
		  "totalOrganizations": 2,
		  "totalTours": 13,
		  "totalDays": 114,
		  "totalCountries": 11,
		  "totalStates": 16,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 378,
		  "schedulePercent": 0.256913,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e4a1e3ac1a676e0d2365b39e9500705",
		  
		  "name": "Adrien",
		  "createdDate": "2019-09-17 12:55:56",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 201,
		  "totalCountries": 18,
		  "totalStates": 52,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1026,
		  "schedulePercent": 0.498073,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Tote",
		  "mostGuestCity": "Collingwood",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e4b4c51b2c3a07b85be6c1675497881",
		  
		  "name": "Justin",
		  "createdDate": "2013-07-12 00:29:11",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 714,
		  "totalCountries": 17,
		  "totalStates": 69,
		  "totalEvents": 268,
		  "eventPercent": 0.888599,
		  "totalScheduleItems": 4496,
		  "schedulePercent": 0.93801,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e4e5c24368a225ce57d779aad5612ca",
		  
		  "name": "Kea ",
		  "createdDate": "2016-05-03 02:34:26",
		  "totalOrganizations": 15,
		  "totalTours": 15,
		  "totalDays": 375,
		  "totalCountries": 16,
		  "totalStates": 58,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2117,
		  "schedulePercent": 0.735041,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Santa Barbara Bowl",
		  "mostGuestCity": "Santa Barbara",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e51885b7f695617af86c87ad19783b4",
		  
		  "name": "Corinna",
		  "createdDate": "2025-10-06 10:01:53",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 48,
		  "totalCountries": 1,
		  "totalStates": 11,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 190,
		  "schedulePercent": 0.153105,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Spectrum Club",
		  "mostGuestCity": "Augsburg",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e588a5e9f99e89951cb1c891bae38bd",
		  
		  "name": "Stephan",
		  "createdDate": "2024-08-07 21:08:30",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 764,
		  "totalCountries": 32,
		  "totalStates": 69,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2010,
		  "schedulePercent": 0.715095,
		  "totalGuests": 632,
		  "guestPercent": 0.765979,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Whisky a Go Go",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e623ee79cea4e6256a49d173b3f8f1e",
		  
		  "name": "Jayden",
		  "createdDate": "2019-08-28 06:58:25",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 178,
		  "totalCountries": 8,
		  "totalStates": 10,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 700,
		  "schedulePercent": 0.386786,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e65b5b335e64b6ad7c22a9c20ee481d",
		  
		  "name": "Aaron",
		  "createdDate": "2012-08-28 21:23:54",
		  "totalOrganizations": 20,
		  "totalTours": 15,
		  "totalDays": 767,
		  "totalCountries": 15,
		  "totalStates": 73,
		  "totalEvents": 261,
		  "eventPercent": 0.88248,
		  "totalScheduleItems": 3566,
		  "schedulePercent": 0.886333,
		  "totalGuests": 860,
		  "guestPercent": 0.82117,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e679af5c82d5127609601c31c30505f",
		  
		  "name": "Abigail",
		  "createdDate": "2018-02-10 19:10:46",
		  "totalOrganizations": 22,
		  "totalTours": 7,
		  "totalDays": 402,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 101,
		  "schedulePercent": 0.0970082,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e694dd8b6fc8acdd8843f69b5e54184",
		  
		  "name": "Fran&#231;ois ",
		  "createdDate": "2022-03-30 19:24:52",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 570,
		  "totalCountries": 9,
		  "totalStates": 23,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2548,
		  "schedulePercent": 0.792044,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Festival Euphoria",
		  "mostGuestCity": "Nantes",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e8d59381bcc9929baaefbf9426970d9",
		  
		  "name": "Justin",
		  "createdDate": "2010-05-03 22:17:32",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 664,
		  "totalCountries": 9,
		  "totalStates": 36,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 1991,
		  "schedulePercent": 0.712262,
		  "totalGuests": 814,
		  "guestPercent": 0.812103,
		  "mostGuestDate": "2025-08-25 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9e9f6b4e0503fbb4442987dc1cde86e2",
		  
		  "name": "Wild",
		  "createdDate": "2022-04-18 18:05:33",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 733,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 224,
		  "schedulePercent": 0.173844,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ea225a8689e4b018a12244beaa33d8e",
		  
		  "name": "Jesse",
		  "createdDate": "2012-09-23 00:37:01",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 371,
		  "totalCountries": 16,
		  "totalStates": 74,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2668,
		  "schedulePercent": 0.80485,
		  "totalGuests": 976,
		  "guestPercent": 0.842248,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Intuit Dome",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ea2acbab12924b829f7f41f080059d6",
		  
		  "name": "Tom",
		  "createdDate": "2023-10-27 09:04:01",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 94,
		  "totalCountries": 19,
		  "totalStates": 34,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 683,
		  "schedulePercent": 0.380326,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Saint Andrewâ€™s Hall",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ea68bd0dab95adb3bb16c82beffb447",
		  
		  "name": "Vanessa",
		  "createdDate": "2023-09-19 00:58:30",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 526,
		  "totalCountries": 10,
		  "totalStates": 46,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1717,
		  "schedulePercent": 0.661605,
		  "totalGuests": 916,
		  "guestPercent": 0.833522,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ea739447db45e9ef40c88b3e50b22be",
		  
		  "name": "Alicia",
		  "createdDate": "2011-08-27 02:10:37",
		  "totalOrganizations": 25,
		  "totalTours": 13,
		  "totalDays": 949,
		  "totalCountries": 23,
		  "totalStates": 60,
		  "totalEvents": 316,
		  "eventPercent": 0.923164,
		  "totalScheduleItems": 5387,
		  "schedulePercent": 0.966002,
		  "totalGuests": 1876,
		  "guestPercent": 0.93801,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9eacbd22b8a2886173c3f7722688aad1",
		  
		  "name": "Edgar",
		  "createdDate": "2019-06-12 20:52:44",
		  "totalOrganizations": 70,
		  "totalTours": 13,
		  "totalDays": 669,
		  "totalCountries": 6,
		  "totalStates": 34,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1840,
		  "schedulePercent": 0.683137,
		  "totalGuests": 698,
		  "guestPercent": 0.785018,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9eb932fc509dd8f6e3e37c354f65cda9",
		  
		  "name": "Vanessa ",
		  "createdDate": "2024-02-19 16:58:35",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 297,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 2277,
		  "schedulePercent": 0.75884,
		  "totalGuests": 1728,
		  "guestPercent": 0.929397,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ebd6efc50eb5c07ea7c6566bf56cae1",
		  
		  "name": "Gala",
		  "createdDate": "2017-05-24 13:16:25",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 140,
		  "totalCountries": 10,
		  "totalStates": 18,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 743,
		  "schedulePercent": 0.402312,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Estadio Pascual Guerrero",
		  "mostGuestCity": "Cali",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ec554e810d8452a8d114194f9e375ad",
		  
		  "name": "Alejandra",
		  "createdDate": "2022-08-09 16:00:16",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 525,
		  "totalCountries": 13,
		  "totalStates": 42,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1887,
		  "schedulePercent": 0.692543,
		  "totalGuests": 825,
		  "guestPercent": 0.813803,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ed5f1bfaeddcb64fc5fc2ec621c788a",
		  
		  "name": "Jay ",
		  "createdDate": "2017-09-12 20:43:25",
		  "totalOrganizations": 9,
		  "totalTours": 19,
		  "totalDays": 100,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 483,
		  "schedulePercent": 0.302924,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-06-22 00:00:00",
		  "mostGuestName": "Garcia's",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ee00ee63fc6b4c7b4d0198191c3b3c7",
		  
		  "name": "Matt",
		  "createdDate": "2014-09-30 23:35:43",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 1099,
		  "totalCountries": 9,
		  "totalStates": 46,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1879,
		  "schedulePercent": 0.691183,
		  "totalGuests": 483,
		  "guestPercent": 0.725635,
		  "mostGuestDate": "2025-02-04 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9eead06a09f42e6a7098368e0b37f680",
		  
		  "name": "Iain",
		  "createdDate": "2022-02-07 16:28:12",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 619,
		  "totalCountries": 11,
		  "totalStates": 54,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 2236,
		  "schedulePercent": 0.753286,
		  "totalGuests": 867,
		  "guestPercent": 0.822529,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ef33cd9117c8a013c4976acc49b7cf9",
		  
		  "name": "Titia",
		  "createdDate": "2022-11-28 15:22:19",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 243,
		  "totalCountries": 19,
		  "totalStates": 29,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 2075,
		  "schedulePercent": 0.728241,
		  "totalGuests": 1577,
		  "guestPercent": 0.917271,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Zenith Nantes Metropole",
		  "mostGuestCity": "St Herblain",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ef33d363c6fb25b02419fd2c4e82c50",
		  
		  "name": "Russell ",
		  "createdDate": "2023-04-10 14:48:52",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 845,
		  "totalCountries": 10,
		  "totalStates": 40,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1870,
		  "schedulePercent": 0.689257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ef9774738fd5e9d77804a2ee9396065",
		  
		  "name": "James",
		  "createdDate": "2024-09-11 13:41:39",
		  "totalOrganizations": 9,
		  "totalTours": 16,
		  "totalDays": 1331,
		  "totalCountries": 26,
		  "totalStates": 48,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 3527,
		  "schedulePercent": 0.883726,
		  "totalGuests": 841,
		  "guestPercent": 0.818223,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9efb39eca2c18fb83f029cfc1885d98e",
		  
		  "name": "Baba",
		  "createdDate": "2024-12-04 19:01:48",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 65,
		  "totalCountries": 6,
		  "totalStates": 9,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f01ad33a8dd56d4749f38b258387cba",
		  
		  "name": "Brandon",
		  "createdDate": "2023-10-02 18:52:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 443,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1374,
		  "schedulePercent": 0.590775,
		  "totalGuests": 444,
		  "guestPercent": 0.710449,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Canada Life Place",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f043c07270aab190edf415b37916405",
		  
		  "name": "Justin",
		  "createdDate": "2024-07-29 15:21:16",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 98,
		  "totalCountries": 9,
		  "totalStates": 37,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 578,
		  "schedulePercent": 0.342702,
		  "totalGuests": 107,
		  "guestPercent": 0.526292,
		  "mostGuestDate": "2025-07-30 00:00:00",
		  "mostGuestName": "Denver Botanic Gardens Amphitheatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f133050bb24321ca9d9853c11382681",
		  
		  "name": "Scott",
		  "createdDate": "2025-04-02 20:02:19",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 420,
		  "totalCountries": 11,
		  "totalStates": 39,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 1645,
		  "schedulePercent": 0.649139,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f1631574e31f5e33b9cf7ad1e7fa156",
		  
		  "name": "Fairfield",
		  "createdDate": "2025-03-20 21:08:36",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 202,
		  "totalCountries": 12,
		  "totalStates": 32,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1722,
		  "schedulePercent": 0.662398,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f1a2c71d20129239e44ed1c1fa67cdf",
		  
		  "name": "Nick",
		  "createdDate": "2017-05-30 02:23:09",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 581,
		  "totalCountries": 26,
		  "totalStates": 66,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 3088,
		  "schedulePercent": 0.850408,
		  "totalGuests": 1589,
		  "guestPercent": 0.918404,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f1c6b02e6ae67fa460b0e8552a58874",
		  
		  "name": "Courtney",
		  "createdDate": "2017-12-14 19:32:10",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 356,
		  "totalCountries": 27,
		  "totalStates": 58,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2523,
		  "schedulePercent": 0.788645,
		  "totalGuests": 1827,
		  "guestPercent": 0.934837,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f2f74aea775c1a25004c61a1a7baaa9",
		  
		  "name": "Dean",
		  "createdDate": "2022-09-14 15:48:55",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 349,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 404,
		  "schedulePercent": 0.271532,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Six String Grill & Stage",
		  "mostGuestCity": "Foxborough",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f357eb75aa5b6cd058403f61fdc05df",
		  
		  "name": "Edgar",
		  "createdDate": "2013-06-17 21:26:14",
		  "totalOrganizations": 11,
		  "totalTours": 2,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 62,
		  "schedulePercent": 0.0686763,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Lollapalooza",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f3677c37edd3ae8ba709e63817a65f9",
		  
		  "name": "Cyril",
		  "createdDate": "2024-07-15 09:43:48",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 155,
		  "totalCountries": 9,
		  "totalStates": 16,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 416,
		  "schedulePercent": 0.276519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f378e025593f4810a441b8210897c80",
		  
		  "name": "Dan",
		  "createdDate": "2017-04-18 09:36:56",
		  "totalOrganizations": 20,
		  "totalTours": 11,
		  "totalDays": 1464,
		  "totalCountries": 22,
		  "totalStates": 57,
		  "totalEvents": 267,
		  "eventPercent": 0.888033,
		  "totalScheduleItems": 3783,
		  "schedulePercent": 0.901292,
		  "totalGuests": 3275,
		  "guestPercent": 0.987194,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f3908e99f117712233cebd17cb549f7",
		  
		  "name": "Iowa",
		  "createdDate": "2016-11-13 23:47:35",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 976,
		  "totalCountries": 19,
		  "totalStates": 54,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2673,
		  "schedulePercent": 0.80587,
		  "totalGuests": 143,
		  "guestPercent": 0.554057,
		  "mostGuestDate": "2025-06-10 00:00:00",
		  "mostGuestName": "Empower Field at Mile High",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f3c68053a67f894d203a4ff4a52e5dd",
		  
		  "name": "Hanford",
		  "createdDate": "2023-05-19 03:22:59",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 969,
		  "totalCountries": 7,
		  "totalStates": 54,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 2221,
		  "schedulePercent": 0.751247,
		  "totalGuests": 3796,
		  "guestPercent": 0.991954,
		  "mostGuestDate": "2025-05-13 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 176,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f40db2d328b980112cc6c8c7e73b518",
		  
		  "name": "Brooke",
		  "createdDate": "2025-08-05 18:56:24",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 322,
		  "totalCountries": 6,
		  "totalStates": 42,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 921,
		  "schedulePercent": 0.465095,
		  "totalGuests": 383,
		  "guestPercent": 0.68699,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f4d7e6d10954a1dca08faefa5fe8837",
		  
		  "name": "Jessica",
		  "createdDate": "2018-03-20 15:43:16",
		  "totalOrganizations": 4,
		  "totalTours": 10,
		  "totalDays": 224,
		  "totalCountries": 10,
		  "totalStates": 42,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1204,
		  "schedulePercent": 0.547824,
		  "totalGuests": 202,
		  "guestPercent": 0.596328,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "The Regent Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f4dde3332c8a08c060fe678b818c24d",
		  
		  "name": "Les",
		  "createdDate": "2016-08-05 22:49:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1246,
		  "schedulePercent": 0.559837,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f50c97eaa7a4d661886c1a1f7a1d769",
		  
		  "name": "James",
		  "createdDate": "2025-06-02 20:54:11",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 212,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 360,
		  "schedulePercent": 0.248187,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Avila Beach Bowl",
		  "mostGuestCity": "Avila Beach",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f555c5a68f70241ac08e8d8fbef628b",
		  
		  "name": "WILL",
		  "createdDate": "2023-09-19 14:28:50",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 119,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 21,
		  "schedulePercent": 0.0319583,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f595379c319d3af7426311efb6500a5",
		  
		  "name": "Merrie",
		  "createdDate": "2016-07-10 22:01:41",
		  "totalOrganizations": 3,
		  "totalTours": 15,
		  "totalDays": 324,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2708,
		  "schedulePercent": 0.80961,
		  "totalGuests": 1454,
		  "guestPercent": 0.905825,
		  "mostGuestDate": "2025-04-28 00:00:00",
		  "mostGuestName": "Arena CDMX",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f62b9f421562e7a4ea651c465dd44fa",
		  
		  "name": "Mia ",
		  "createdDate": "2025-09-16 21:23:18",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 168,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 391,
		  "schedulePercent": 0.265073,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f65e5375900adfb7e03a3d1232cadc3",
		  
		  "name": "Sammy",
		  "createdDate": "2019-08-25 10:42:06",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 117,
		  "totalCountries": 13,
		  "totalStates": 22,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 857,
		  "schedulePercent": 0.442656,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-01-08 00:00:00",
		  "mostGuestName": "House of Blues San Diego",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f65e7fc9c063dfb586d5b7547092fae",
		  
		  "name": "Ance",
		  "createdDate": "2022-12-29 13:04:46",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 1761,
		  "totalCountries": 29,
		  "totalStates": 70,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 4638,
		  "schedulePercent": 0.942203,
		  "totalGuests": 494,
		  "guestPercent": 0.728694,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Coors Light Birds Nest",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f65f564f8a8252b21a882653d8a9c23",
		  
		  "name": "Carlo",
		  "createdDate": "2016-03-15 17:57:51",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 445,
		  "totalCountries": 11,
		  "totalStates": 17,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 509,
		  "schedulePercent": 0.31505,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f710f77a302165fac690a1e0905956b",
		  
		  "name": "Eden",
		  "createdDate": "2018-02-27 23:34:24",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 809,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 3359,
		  "schedulePercent": 0.8716,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f740e9e22aedb244813bdc7cc0d7e12",
		  
		  "name": "Anthony",
		  "createdDate": "2012-02-13 00:28:25",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 397,
		  "totalCountries": 27,
		  "totalStates": 86,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 3203,
		  "schedulePercent": 0.860381,
		  "totalGuests": 1540,
		  "guestPercent": 0.913758,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f77752783cf10e333259ca99c57bb8e",
		  
		  "name": "MICHAL",
		  "createdDate": "2015-11-30 09:39:22",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 124,
		  "totalCountries": 8,
		  "totalStates": 23,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 610,
		  "schedulePercent": 0.354148,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Wakefield Exchange Shed",
		  "mostGuestCity": "Wakefield",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f79633e4774d755595ee7de52b9784f",
		  
		  "name": "Thomas",
		  "createdDate": "2019-08-23 10:17:49",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 651,
		  "totalCountries": 32,
		  "totalStates": 64,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2688,
		  "schedulePercent": 0.807797,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "The Mohawk",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f86342e7847cf0a17eff95950460636",
		  
		  "name": "Dean",
		  "createdDate": "2023-04-19 18:54:03",
		  "totalOrganizations": 12,
		  "totalTours": 16,
		  "totalDays": 801,
		  "totalCountries": 33,
		  "totalStates": 88,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 3482,
		  "schedulePercent": 0.881006,
		  "totalGuests": 1748,
		  "guestPercent": 0.930417,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f8cc6c95541b58c6a212e4222a4ada4",
		  
		  "name": "Brett",
		  "createdDate": "2013-09-21 23:41:55",
		  "totalOrganizations": 11,
		  "totalTours": 16,
		  "totalDays": 996,
		  "totalCountries": 28,
		  "totalStates": 84,
		  "totalEvents": 241,
		  "eventPercent": 0.862647,
		  "totalScheduleItems": 3794,
		  "schedulePercent": 0.902312,
		  "totalGuests": 1064,
		  "guestPercent": 0.856981,
		  "mostGuestDate": "2025-08-11 00:00:00",
		  "mostGuestName": "Exchange LA",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9f91907ac260b97d9c214692127b8052",
		  
		  "name": "Dirk",
		  "createdDate": "2024-11-06 13:48:11",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 80,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 905,
		  "schedulePercent": 0.460335,
		  "totalGuests": 567,
		  "guestPercent": 0.748413,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Electric Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fa9a39bed40f231943a0c6ac5e20126",
		  
		  "name": "Zack",
		  "createdDate": "2014-01-21 11:27:01",
		  "totalOrganizations": 18,
		  "totalTours": 27,
		  "totalDays": 531,
		  "totalCountries": 22,
		  "totalStates": 66,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 4095,
		  "schedulePercent": 0.918404,
		  "totalGuests": 749,
		  "guestPercent": 0.796011,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fa9dc3d7e77993590af51e52a4efa80",
		  
		  "name": "Eric",
		  "createdDate": "2019-07-26 19:46:13",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 453,
		  "totalCountries": 11,
		  "totalStates": 49,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 2043,
		  "schedulePercent": 0.721781,
		  "totalGuests": 577,
		  "guestPercent": 0.751813,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fa9f1a651e3960f2c9282fc2a758e0d",
		  
		  "name": "Federico ",
		  "createdDate": "2017-02-15 00:26:32",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 219,
		  "totalCountries": 7,
		  "totalStates": 22,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 676,
		  "schedulePercent": 0.37704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fae419469994b6f00c363c99aeb66cd",
		  
		  "name": "George",
		  "createdDate": "2025-04-01 13:31:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 35,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 181,
		  "schedulePercent": 0.147212,
		  "totalGuests": 131,
		  "guestPercent": 0.545444,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Electric Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fb163f3827220cf079fc2a7d2ab62a1",
		  
		  "name": "Far Land",
		  "createdDate": "2020-12-19 03:57:00",
		  "totalOrganizations": 13,
		  "totalTours": 25,
		  "totalDays": 217,
		  "totalCountries": 12,
		  "totalStates": 35,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 718,
		  "schedulePercent": 0.393246,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fb6fa80e7f521d9e3870b1545f80466",
		  
		  "name": "Joel",
		  "createdDate": "2009-12-09 21:36:04",
		  "totalOrganizations": 26,
		  "totalTours": 8,
		  "totalDays": 167,
		  "totalCountries": 6,
		  "totalStates": 9,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 748,
		  "schedulePercent": 0.404125,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fc4e20d29b2bd2c27972bc5c0f2e11a",
		  
		  "name": "Karen",
		  "createdDate": "2016-04-18 15:49:42",
		  "totalOrganizations": 38,
		  "totalTours": 24,
		  "totalDays": 2111,
		  "totalCountries": 22,
		  "totalStates": 26,
		  "totalEvents": 1389,
		  "eventPercent": 0.998187,
		  "totalScheduleItems": 4892,
		  "schedulePercent": 0.951156,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stand Comedy Club Newcastle",
		  "mostGuestCity": "Newcastle upon Tyne",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fd5e66b4e4f3825520fbb9ceb0e4bb1",
		  
		  "name": "Kevin",
		  "createdDate": "2015-10-13 21:16:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 921,
		  "schedulePercent": 0.465095,
		  "totalGuests": 1125,
		  "guestPercent": 0.867407,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fde7d72830084e578e0873e0cdfa919",
		  
		  "name": "Viktoria",
		  "createdDate": "2022-08-16 13:04:49",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 467,
		  "totalCountries": 36,
		  "totalStates": 83,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 2098,
		  "schedulePercent": 0.732548,
		  "totalGuests": 120,
		  "guestPercent": 0.536945,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Borgholms Slott",
		  "mostGuestCity": "Borgholm",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fe0b7b38d0e104943da718acf400296",
		  
		  "name": "Patrick",
		  "createdDate": "2015-11-04 02:16:07",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 165,
		  "totalCountries": 6,
		  "totalStates": 10,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 738,
		  "schedulePercent": 0.400952,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Young Showground Camping",
		  "mostGuestCity": "Young",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fe2a30a009c38a18fae32f32c092c2b",
		  
		  "name": "Brett",
		  "createdDate": "2017-10-19 16:11:47",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 1041,
		  "totalCountries": 8,
		  "totalStates": 63,
		  "totalEvents": 539,
		  "eventPercent": 0.983114,
		  "totalScheduleItems": 5060,
		  "schedulePercent": 0.956029,
		  "totalGuests": 1191,
		  "guestPercent": 0.875113,
		  "mostGuestDate": "2025-09-01 00:00:00",
		  "mostGuestName": "John T. Floore's Country Store",
		  "mostGuestCity": "Helotes",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9fee53ff4350c336123a0bab49724615",
		  
		  "name": "Matt",
		  "createdDate": "2018-01-16 18:33:36",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 965,
		  "schedulePercent": 0.479714,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "The Kessler Theater",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ff1980075e31c9462b959dc02bc1403",
		  
		  "name": "Aled ",
		  "createdDate": "2019-04-27 12:25:16",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 171,
		  "totalCountries": 10,
		  "totalStates": 22,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 1145,
		  "schedulePercent": 0.533092,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "The Low Green",
		  "mostGuestCity": "",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "9ffe5d2ea0c8e64b78d835fe34fb2e2b",
		  
		  "name": "Adam",
		  "createdDate": "2018-06-03 01:31:13",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 282,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 958,
		  "schedulePercent": 0.478468,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Northcote Social Club",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a00788cac7ff6f2a3115d9c9aca9f083",
		  
		  "name": "teyler",
		  "createdDate": "2023-07-31 20:05:33",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 433,
		  "totalCountries": 24,
		  "totalStates": 31,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 2282,
		  "schedulePercent": 0.759633,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a012585c9170d055d1992b882b008cad",
		  
		  "name": "Malcolm",
		  "createdDate": "2019-10-14 17:56:25",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 63,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 251,
		  "guestPercent": 0.625567,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a01349ea08c4eaa9cb09a3b9bf48bd9a",
		  
		  "name": "Philippe",
		  "createdDate": "2021-07-31 20:01:30",
		  "totalOrganizations": 20,
		  "totalTours": 16,
		  "totalDays": 245,
		  "totalCountries": 21,
		  "totalStates": 47,
		  "totalEvents": 245,
		  "eventPercent": 0.866047,
		  "totalScheduleItems": 1068,
		  "schedulePercent": 0.509633,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Cobra Lounge",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0200add064362ab973ec5f34a934c86",
		  
		  "name": "Brandon",
		  "createdDate": "2016-01-16 08:57:12",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 1104,
		  "totalCountries": 11,
		  "totalStates": 81,
		  "totalEvents": 330,
		  "eventPercent": 0.93291,
		  "totalScheduleItems": 3729,
		  "schedulePercent": 0.897892,
		  "totalGuests": 626,
		  "guestPercent": 0.764279,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Seminole Hard Rock Hotel & Casino Hollywood",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a02643f91c6378b1c0cec494c4526ff4",
		  
		  "name": "Seth",
		  "createdDate": "2023-02-08 14:25:40",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 286,
		  "totalCountries": 28,
		  "totalStates": 37,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1166,
		  "schedulePercent": 0.539325,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a029f492564c60f1533b32b0df2c4006",
		  
		  "name": "Andrew",
		  "createdDate": "2014-05-08 04:49:34",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 248,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2092,
		  "schedulePercent": 0.730961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0318fa0ccb84c90d7b6cb144cf280c9",
		  
		  "name": "Andr&#233;",
		  "createdDate": "2023-07-03 15:21:01",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 60,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 519,
		  "schedulePercent": 0.32117,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Parkteatret Scene",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a04a6af35ea4d88c53a1ec8ff4826a56",
		  
		  "name": "Santeri",
		  "createdDate": "2018-06-13 20:13:32",
		  "totalOrganizations": 35,
		  "totalTours": 50,
		  "totalDays": 1438,
		  "totalCountries": 12,
		  "totalStates": 30,
		  "totalEvents": 906,
		  "eventPercent": 0.994674,
		  "totalScheduleItems": 3790,
		  "schedulePercent": 0.902085,
		  "totalGuests": 600,
		  "guestPercent": 0.757933,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Allas Sea Pool",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a05ee64124071285a09ab2e0ec603c43",
		  
		  "name": "Jillian",
		  "createdDate": "2024-05-03 18:25:14",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 337,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 228,
		  "schedulePercent": 0.176451,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Lion's Park",
		  "mostGuestCity": "Brantford ",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a060ef2d1426148417acf5931e2bea57",
		  
		  "name": "Josh",
		  "createdDate": "2023-10-24 16:39:13",
		  "totalOrganizations": 13,
		  "totalTours": 14,
		  "totalDays": 782,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2086,
		  "schedulePercent": 0.730054,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-04-29 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a075949b52829b12316c10763e5c1353",
		  
		  "name": "Luis",
		  "createdDate": "2016-04-25 21:47:31",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 245,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1008,
		  "schedulePercent": 0.492747,
		  "totalGuests": 936,
		  "guestPercent": 0.836582,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a07a0527fae1d16829969bacb85def4e",
		  
		  "name": "Jason",
		  "createdDate": "2023-05-14 15:03:29",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 1146,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 321,
		  "eventPercent": 0.926904,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a07a3f88a68baf89ac798c97f28c0075",
		  
		  "name": "Reggie",
		  "createdDate": "2015-01-06 15:26:13",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 620,
		  "totalCountries": 6,
		  "totalStates": 21,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 1351,
		  "schedulePercent": 0.585222,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Muckleshoot Casino Resort",
		  "mostGuestCity": "Auburn",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a07af592e9e60ebc508ffd3472714629",
		  
		  "name": "Vanessa",
		  "createdDate": "2018-06-02 02:16:36",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 700,
		  "totalCountries": 9,
		  "totalStates": 43,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 1783,
		  "schedulePercent": 0.673164,
		  "totalGuests": 547,
		  "guestPercent": 0.743314,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a08dcc698364c2ff50452216e4ed0c32",
		  
		  "name": "Ferdinand",
		  "createdDate": "2025-10-28 12:52:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0910b748c87c598f7f9f5c7675bdbd0",
		  
		  "name": "Hannah",
		  "createdDate": "2019-04-26 03:20:31",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a091ff13f454ff2dc2b465eaf53afd5c",
		  
		  "name": "Marie-Claire",
		  "createdDate": "2011-04-12 17:56:21",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 484,
		  "totalCountries": 10,
		  "totalStates": 35,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1864,
		  "schedulePercent": 0.687783,
		  "totalGuests": 703,
		  "guestPercent": 0.786378,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Alameda County Fairgrounds GATE #2 Attention Scott O'Leary",
		  "mostGuestCity": "Pleasanton",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a09ec8f23ab8ff7351cf69333ca2096a",
		  
		  "name": "Niilo",
		  "createdDate": "2022-03-12 22:00:57",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 74,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "Vauhti Kiihtyy",
		  "mostGuestCity": "Tampere",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0a2a92eeb95cc7b76f7bb1ece39f003",
		  
		  "name": "Sam ",
		  "createdDate": "2022-07-21 19:30:38",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 1891,
		  "totalCountries": 30,
		  "totalStates": 56,
		  "totalEvents": 287,
		  "eventPercent": 0.903672,
		  "totalScheduleItems": 2073,
		  "schedulePercent": 0.727675,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-05-05 00:00:00",
		  "mostGuestName": "GRAMMY Museum at L.A. LIVE",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0a37b2318a6598a5a1f0fa60dc2867c",
		  
		  "name": "Andy",
		  "createdDate": "2024-03-15 12:56:46",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 2396,
		  "totalCountries": 34,
		  "totalStates": 68,
		  "totalEvents": 300,
		  "eventPercent": 0.913078,
		  "totalScheduleItems": 835,
		  "schedulePercent": 0.436083,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0a5dd028d56976184b6aa74d476662b",
		  
		  "name": "Brett",
		  "createdDate": "2013-11-29 03:26:46",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 440,
		  "totalCountries": 11,
		  "totalStates": 27,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 593,
		  "schedulePercent": 0.348595,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Tacoma Dome",
		  "mostGuestCity": "Tacoma",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0a9522f1e2f26033b312ebff5af8a17",
		  
		  "name": "Katherine",
		  "createdDate": "2018-01-04 17:26:45",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 1045,
		  "totalCountries": 6,
		  "totalStates": 57,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 4467,
		  "schedulePercent": 0.93699,
		  "totalGuests": 1943,
		  "guestPercent": 0.94243,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0b69d9ae56076ce482d69225b5a092e",
		  
		  "name": "Jodie",
		  "createdDate": "2012-02-25 04:44:06",
		  "totalOrganizations": 144,
		  "totalTours": 3,
		  "totalDays": 32,
		  "totalCountries": 6,
		  "totalStates": 10,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 158,
		  "guestPercent": 0.565277,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Qudos Bank Arena",
		  "mostGuestCity": "Sydney Olympic Park",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0bd18b526513e6f68bf9ebb2bfaa865",
		  
		  "name": "Chris",
		  "createdDate": "2019-01-15 03:18:38",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 63,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 243,
		  "schedulePercent": 0.186083,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0cc7f58fbf7fa7b519bda74ada302b6",
		  
		  "name": "SummerStage",
		  "createdDate": "2018-06-05 16:47:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0cfd09d3f4118ae877f23f2fee3f7ba",
		  
		  "name": "Kimberly ",
		  "createdDate": "2025-04-07 21:38:19",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 235,
		  "totalCountries": 18,
		  "totalStates": 22,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 847,
		  "schedulePercent": 0.439483,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "SALA APOLO",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a0e6428df817963a828a0b45fa28133f",
		  
		  "name": "Marc",
		  "createdDate": "2016-10-22 00:10:55",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 916,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 533,
		  "schedulePercent": 0.328196,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "Schermerhorn Symphony Hall",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a11100d4217d5eb1f1c9c75d7b75080d",
		  
		  "name": "Justin",
		  "createdDate": "2015-08-27 14:45:22",
		  "totalOrganizations": 21,
		  "totalTours": 15,
		  "totalDays": 1172,
		  "totalCountries": 6,
		  "totalStates": 53,
		  "totalEvents": 479,
		  "eventPercent": 0.975068,
		  "totalScheduleItems": 6082,
		  "schedulePercent": 0.976881,
		  "totalGuests": 3768,
		  "guestPercent": 0.99184,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a11185faa5df8a243373fa0d2dab84f1",
		  
		  "name": "Sofie",
		  "createdDate": "2024-10-19 11:06:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 80,
		  "totalCountries": 20,
		  "totalStates": 2,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 335,
		  "schedulePercent": 0.234021,
		  "totalGuests": 280,
		  "guestPercent": 0.639393,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "QUARTERBACK Immobilien ARENA",
		  "mostGuestCity": "Leipzig",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a11cb9b04864a794eb4e207209796fc3",
		  
		  "name": "Sal ",
		  "createdDate": "2011-05-04 17:21:17",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 159,
		  "totalCountries": 13,
		  "totalStates": 34,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 654,
		  "schedulePercent": 0.368994,
		  "totalGuests": 275,
		  "guestPercent": 0.637579,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Cadogan Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a125fcf61e58857443f2499a6ac089a0",
		  
		  "name": "Connor",
		  "createdDate": "2016-11-13 02:26:59",
		  "totalOrganizations": 2,
		  "totalTours": 16,
		  "totalDays": 168,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a13c7372e368482b477e66e7eee29fa2",
		  
		  "name": "Markus",
		  "createdDate": "2022-11-04 14:05:13",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 238,
		  "totalCountries": 15,
		  "totalStates": 24,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 1791,
		  "schedulePercent": 0.675204,
		  "totalGuests": 635,
		  "guestPercent": 0.766999,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "CCH - Congress Center Hamburg - Saal 1",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 135,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a13fe594bbf4c11954ff988c08fb9b3c",
		  
		  "name": "Trinity",
		  "createdDate": "2025-03-16 11:29:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 55,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 752,
		  "schedulePercent": 0.406052,
		  "totalGuests": 559,
		  "guestPercent": 0.7466,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a14d57230daac215d6e6a4f81de272ad",
		  
		  "name": "Caleb",
		  "createdDate": "2022-08-11 23:19:42",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 658,
		  "totalCountries": 6,
		  "totalStates": 29,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 652,
		  "schedulePercent": 0.3682,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Golden Gate Park",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a15f6214d1f57b43647dcbbe961cfa95",
		  
		  "name": "Jonas",
		  "createdDate": "2018-02-06 07:17:31",
		  "totalOrganizations": 18,
		  "totalTours": 14,
		  "totalDays": 234,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1396,
		  "schedulePercent": 0.597008,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Lillehammer live",
		  "mostGuestCity": "Lillehammer",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a164ea184f54a9ba047216268faf3ae1",
		  
		  "name": "Georgina",
		  "createdDate": "2024-12-03 22:46:57",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 775,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 268,
		  "schedulePercent": 0.198209,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a167303cd0de42b77dddaa0b90d32e13",
		  
		  "name": "Servan",
		  "createdDate": "2020-02-05 14:20:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 171,
		  "schedulePercent": 0.141319,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a16aad4580541306f26f80b93985d6c9",
		  
		  "name": "Etta",
		  "createdDate": "2025-01-14 10:33:58",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 71,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 531,
		  "schedulePercent": 0.327176,
		  "totalGuests": 236,
		  "guestPercent": 0.6165,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Banan-Kompaniet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a17594bcb189600932b444821f4eaafd",
		  
		  "name": "Louisa",
		  "createdDate": "2024-01-05 19:10:29",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 126,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 972,
		  "schedulePercent": 0.481981,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a17870f41eb3e66d193f45cfeacfbc70",
		  
		  "name": "Johan",
		  "createdDate": "2024-05-20 22:40:01",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 2701,
		  "totalCountries": 38,
		  "totalStates": 59,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 1144,
		  "schedulePercent": 0.532638,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1790369cc738cbb2a002a56beadd4cd",
		  
		  "name": "Eileen",
		  "createdDate": "2013-07-15 15:33:03",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 131,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 187,
		  "schedulePercent": 0.151859,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a181d079bff12b734b3e584666ed0b78",
		  
		  "name": "Eruna",
		  "createdDate": "2025-03-24 19:31:58",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 109,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1066,
		  "schedulePercent": 0.508726,
		  "totalGuests": 770,
		  "guestPercent": 0.800544,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a182934ab03879bf8488e7fa768b96e9",
		  
		  "name": "Kelly",
		  "createdDate": "2023-05-07 17:10:20",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 127,
		  "totalCountries": 6,
		  "totalStates": 24,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1884,
		  "schedulePercent": 0.691976,
		  "totalGuests": 1587,
		  "guestPercent": 0.918178,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a18530c23fea089ce239c1a1fc0caba3",
		  
		  "name": "Trafton",
		  "createdDate": "2022-09-23 20:15:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 894,
		  "schedulePercent": 0.455802,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "The Windjammer",
		  "mostGuestCity": "Isle of Palms",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a18f17a38e7a899e650a0e989c59b12f",
		  
		  "name": "Jason",
		  "createdDate": "2024-05-16 15:12:01",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 1928,
		  "totalCountries": 33,
		  "totalStates": 69,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 2999,
		  "schedulePercent": 0.842248,
		  "totalGuests": 745,
		  "guestPercent": 0.795218,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "Backstage Kulturzentrum",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1972f1cc81fb5d622d2286068a513c1",
		  
		  "name": "Jonathan",
		  "createdDate": "2022-03-11 19:42:03",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 618,
		  "totalCountries": 4,
		  "totalStates": 46,
		  "totalEvents": 334,
		  "eventPercent": 0.934497,
		  "totalScheduleItems": 3565,
		  "schedulePercent": 0.886219,
		  "totalGuests": 623,
		  "guestPercent": 0.763826,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Mark C. Smith Concert Hall",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a197319aa05d3cecd33ecefc6d2a8aa0",
		  
		  "name": "Danny",
		  "createdDate": "2020-02-27 21:33:59",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 363,
		  "totalCountries": 5,
		  "totalStates": 34,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1480,
		  "schedulePercent": 0.612647,
		  "totalGuests": 132,
		  "guestPercent": 0.546124,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1a9893f037dbfba5730aef38ea25531",
		  
		  "name": "Nathan",
		  "createdDate": "2017-05-08 23:54:11",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 61,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 203,
		  "schedulePercent": 0.162965,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1ae54997574fedff886165d987fc8da",
		  
		  "name": "Francisco",
		  "createdDate": "2021-09-04 14:42:04",
		  "totalOrganizations": 25,
		  "totalTours": 7,
		  "totalDays": 237,
		  "totalCountries": 18,
		  "totalStates": 23,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 910,
		  "schedulePercent": 0.461695,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1ba1d6a41355837de36f9cf5f25af54",
		  
		  "name": "Bram",
		  "createdDate": "2017-10-22 13:05:27",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 156,
		  "totalCountries": 17,
		  "totalStates": 35,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 736,
		  "schedulePercent": 0.399932,
		  "totalGuests": 148,
		  "guestPercent": 0.556664,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "The Burl",
		  "mostGuestCity": "Lexington",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1c9788ca305b0449b3f75029a02507b",
		  
		  "name": "Sune Stab",
		  "createdDate": "2024-01-05 13:50:26",
		  "totalOrganizations": 47,
		  "totalTours": 34,
		  "totalDays": 596,
		  "totalCountries": 12,
		  "totalStates": 8,
		  "totalEvents": 535,
		  "eventPercent": 0.982208,
		  "totalScheduleItems": 2843,
		  "schedulePercent": 0.827176,
		  "totalGuests": 375,
		  "guestPercent": 0.683477,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Fredagsrock i Tivoli",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1d2a1bbcbd84cec1142b7123cc8cdd6",
		  
		  "name": "Alex",
		  "createdDate": "2017-05-01 11:39:13",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 276,
		  "totalCountries": 14,
		  "totalStates": 54,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 1924,
		  "schedulePercent": 0.699003,
		  "totalGuests": 137,
		  "guestPercent": 0.550204,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1dcf248ad5399274e270174be3cb1ac",
		  
		  "name": "John",
		  "createdDate": "2018-07-26 22:34:57",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 408,
		  "totalCountries": 13,
		  "totalStates": 60,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 1731,
		  "schedulePercent": 0.663985,
		  "totalGuests": 2172,
		  "guestPercent": 0.956596,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1dd425fed60f8ff704e29a03602b92a",
		  
		  "name": "Jon",
		  "createdDate": "2015-11-18 10:49:43",
		  "totalOrganizations": 30,
		  "totalTours": 14,
		  "totalDays": 2064,
		  "totalCountries": 28,
		  "totalStates": 78,
		  "totalEvents": 430,
		  "eventPercent": 0.966002,
		  "totalScheduleItems": 4469,
		  "schedulePercent": 0.937217,
		  "totalGuests": 1948,
		  "guestPercent": 0.942656,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 125,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1e86f3c21d5216ab88ea86e63f7c87a",
		  
		  "name": "Bridge",
		  "createdDate": "2023-04-28 23:14:19",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 364,
		  "totalCountries": 8,
		  "totalStates": 41,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1348,
		  "schedulePercent": 0.585109,
		  "totalGuests": 103,
		  "guestPercent": 0.522779,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Club Soda",
		  "mostGuestCity": "Montreal",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1ec3c3bcd6857cbff0ca643d1956a61",
		  
		  "name": "Producci&#243;n ",
		  "createdDate": "2022-10-11 00:41:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 121,
		  "totalCountries": 11,
		  "totalStates": 16,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 397,
		  "schedulePercent": 0.268019,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1ed787e3b740e4b5e45d7e637e63380",
		  
		  "name": "Michael",
		  "createdDate": "2015-04-02 09:59:51",
		  "totalOrganizations": 10,
		  "totalTours": 17,
		  "totalDays": 422,
		  "totalCountries": 20,
		  "totalStates": 46,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2189,
		  "schedulePercent": 0.746487,
		  "totalGuests": 302,
		  "guestPercent": 0.650839,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 91,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a1ef41d891c00a9a9c6a513c727ea73d",
		  
		  "name": "Jesse",
		  "createdDate": "2022-09-10 21:43:01",
		  "totalOrganizations": 19,
		  "totalTours": 10,
		  "totalDays": 789,
		  "totalCountries": 28,
		  "totalStates": 72,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2707,
		  "schedulePercent": 0.809497,
		  "totalGuests": 718,
		  "guestPercent": 0.790005,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2091c7b067d7107053b5f05a66a37b1",
		  
		  "name": "MACC",
		  "createdDate": "2022-02-28 10:03:10",
		  "totalOrganizations": 15,
		  "totalTours": 17,
		  "totalDays": 276,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 954,
		  "schedulePercent": 0.477335,
		  "totalGuests": 412,
		  "guestPercent": 0.698323,
		  "mostGuestDate": "2025-01-29 00:00:00",
		  "mostGuestName": "Martin Luther Kirche",
		  "mostGuestCity": "Dresden",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a22872cffb4d0a7319c630d5d4f2e57e",
		  
		  "name": "Elodie",
		  "createdDate": "2018-06-03 14:19:48",
		  "totalOrganizations": 14,
		  "totalTours": 56,
		  "totalDays": 1100,
		  "totalCountries": 34,
		  "totalStates": 56,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 3583,
		  "schedulePercent": 0.887693,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-04-20 00:00:00",
		  "mostGuestName": "Etihad Park",
		  "mostGuestCity": "Abu Dhabi",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2341ca8d00d9e832830d51c420f21e0",
		  
		  "name": "Mick",
		  "createdDate": "2009-08-21 19:33:24",
		  "totalOrganizations": 61,
		  "totalTours": 16,
		  "totalDays": 190,
		  "totalCountries": 17,
		  "totalStates": 28,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 471,
		  "schedulePercent": 0.298731,
		  "totalGuests": 67,
		  "guestPercent": 0.480734,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Der Hirsch",
		  "mostGuestCity": "NÃ¼rnberg",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a23d67f7b29c1ab82bc9c5f75a45ece1",
		  
		  "name": "Hieronymus",
		  "createdDate": "2013-10-02 00:50:50",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 919,
		  "totalCountries": 6,
		  "totalStates": 21,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a240ce74c2b83ccbad1b93343dcea5bd",
		  
		  "name": "Andy",
		  "createdDate": "2014-05-17 14:55:04",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 1190,
		  "totalCountries": 21,
		  "totalStates": 67,
		  "totalEvents": 415,
		  "eventPercent": 0.962149,
		  "totalScheduleItems": 5689,
		  "schedulePercent": 0.971328,
		  "totalGuests": 1363,
		  "guestPercent": 0.895286,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "MGM Grand",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2426df47c04c3030572b68202b4cd4c",
		  
		  "name": "Rebecca",
		  "createdDate": "2024-12-19 11:50:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 52,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 382,
		  "schedulePercent": 0.259406,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a24422545d1982eaa3a4a0a036a61da9",
		  
		  "name": "Flavia ",
		  "createdDate": "2012-09-05 00:57:15",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 752,
		  "totalCountries": 18,
		  "totalStates": 38,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1899,
		  "schedulePercent": 0.694583,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Heaton Park",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a24b017e9e7ad36b8e3401622da3894f",
		  
		  "name": "Cami",
		  "createdDate": "2023-04-28 18:30:57",
		  "totalOrganizations": 6,
		  "totalTours": 15,
		  "totalDays": 271,
		  "totalCountries": 29,
		  "totalStates": 65,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 2428,
		  "schedulePercent": 0.778332,
		  "totalGuests": 835,
		  "guestPercent": 0.816296,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a25233c58b92ba1d28ded0de6df36252",
		  
		  "name": "Evie",
		  "createdDate": "2025-02-24 04:23:32",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 142,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 700,
		  "schedulePercent": 0.386786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2533f6854c177fcbdeb61d30506e106",
		  
		  "name": "Maythe",
		  "createdDate": "2022-03-02 00:44:11",
		  "totalOrganizations": 9,
		  "totalTours": 21,
		  "totalDays": 620,
		  "totalCountries": 14,
		  "totalStates": 48,
		  "totalEvents": 304,
		  "eventPercent": 0.915231,
		  "totalScheduleItems": 3068,
		  "schedulePercent": 0.848935,
		  "totalGuests": 1847,
		  "guestPercent": 0.93597,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a259b8c96d527a896f20993c9611a8a7",
		  
		  "name": "M&#233;lanie",
		  "createdDate": "2019-10-30 15:54:06",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 208,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 905,
		  "schedulePercent": 0.460335,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a26c94df2b1c1882070d574338527877",
		  
		  "name": "Michael",
		  "createdDate": "2015-03-28 09:23:12",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1965,
		  "schedulePercent": 0.706482,
		  "totalGuests": 2502,
		  "guestPercent": 0.968155,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a26db916a8c218ede3efbbc53ea062f6",
		  
		  "name": "Shane",
		  "createdDate": "2025-01-15 11:37:04",
		  "totalOrganizations": 8,
		  "totalTours": 18,
		  "totalDays": 380,
		  "totalCountries": 27,
		  "totalStates": 35,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 791,
		  "schedulePercent": 0.419311,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a27af640009b2880b02ce566728aaacf",
		  
		  "name": "Mike",
		  "createdDate": "2025-06-04 00:04:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 208,
		  "totalCountries": 8,
		  "totalStates": 35,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 777,
		  "schedulePercent": 0.415231,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a27ee2a7f787560b1676a3e3ae232362",
		  
		  "name": "Donnie",
		  "createdDate": "2014-08-24 00:50:53",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 217,
		  "totalCountries": 8,
		  "totalStates": 29,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1149,
		  "schedulePercent": 0.534338,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "The Espee",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2834311a524eafef3bb8d963a333523",
		  
		  "name": "Cameron",
		  "createdDate": "2018-04-10 20:43:36",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 907,
		  "totalCountries": 4,
		  "totalStates": 56,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 2666,
		  "schedulePercent": 0.80451,
		  "totalGuests": 1008,
		  "guestPercent": 0.848028,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "RADIO/EAST",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a29e861a3ce267484e965b4ba0e3aa46",
		  
		  "name": "Dustin",
		  "createdDate": "2024-09-13 17:08:23",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 153,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 670,
		  "schedulePercent": 0.374773,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "BeachLife Festival",
		  "mostGuestCity": "Redondo Beach",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2a295c4aa6bfd33a3f111060d19f36b",
		  
		  "name": "Jerry",
		  "createdDate": "2009-07-16 18:31:27",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 459,
		  "totalCountries": 3,
		  "totalStates": 47,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 2395,
		  "schedulePercent": 0.774365,
		  "totalGuests": 1661,
		  "guestPercent": 0.925091,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2b5d14a5f224b99194f2b10a68eac0f",
		  
		  "name": "Lena",
		  "createdDate": "2025-11-02 14:45:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2c022ff304d02b0c72c5e7a43494341",
		  
		  "name": "Gretchen",
		  "createdDate": "2014-12-12 08:43:13",
		  "totalOrganizations": 52,
		  "totalTours": 8,
		  "totalDays": 532,
		  "totalCountries": 3,
		  "totalStates": 55,
		  "totalEvents": 348,
		  "eventPercent": 0.941523,
		  "totalScheduleItems": 3888,
		  "schedulePercent": 0.907638,
		  "totalGuests": 1095,
		  "guestPercent": 0.862874,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "Cobb Energy Centre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2c2965345b7574fd652caca94a4f1b2",
		  
		  "name": "David",
		  "createdDate": "2016-11-17 16:58:35",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 340,
		  "totalCountries": 26,
		  "totalStates": 39,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1492,
		  "schedulePercent": 0.61582,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2c399704eb219489815bdc6b64e13e4",
		  
		  "name": "Timothy",
		  "createdDate": "2024-01-07 00:47:28",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 166,
		  "totalCountries": 15,
		  "totalStates": 43,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 854,
		  "schedulePercent": 0.44141,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Rebel Lounge",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2c40d5cccc5a1033d5310464e1fa012",
		  
		  "name": "MAINDRON",
		  "createdDate": "2024-01-26 17:36:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 110,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 556,
		  "schedulePercent": 0.335789,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2d5ff79c4acdebb865f09537a5fb2bd",
		  
		  "name": "Sarah",
		  "createdDate": "2025-02-26 22:09:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 7,
		  "totalStates": 3,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 164,
		  "schedulePercent": 0.138146,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2de15287ede856e2bed2e200fc829ce",
		  
		  "name": "Band",
		  "createdDate": "2024-01-16 19:02:12",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 192,
		  "totalCountries": 7,
		  "totalStates": 34,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 530,
		  "schedulePercent": 0.326949,
		  "totalGuests": 285,
		  "guestPercent": 0.641999,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Buckhead Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2de1ea227c179edec56803f72f327ed",
		  
		  "name": "Matt",
		  "createdDate": "2011-09-08 19:11:45",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 464,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1024,
		  "schedulePercent": 0.49762,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2dfe93dffbe3768d6ce145ce5a1c757",
		  
		  "name": "DOMINIQUE",
		  "createdDate": "2018-03-30 22:15:07",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 872,
		  "totalCountries": 18,
		  "totalStates": 30,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1414,
		  "schedulePercent": 0.601201,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2e3222769d2545ce73e70365b45d528",
		  
		  "name": "Buddy",
		  "createdDate": "2019-11-03 20:23:45",
		  "totalOrganizations": 13,
		  "totalTours": 19,
		  "totalDays": 396,
		  "totalCountries": 20,
		  "totalStates": 66,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 2213,
		  "schedulePercent": 0.75034,
		  "totalGuests": 879,
		  "guestPercent": 0.824569,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "  5004 National Western Drive   ",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2e4991eb04ba01ef66d6705e1e32a56",
		  
		  "name": "Larry",
		  "createdDate": "2019-03-10 15:54:26",
		  "totalOrganizations": 12,
		  "totalTours": 19,
		  "totalDays": 1154,
		  "totalCountries": 16,
		  "totalStates": 50,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 5178,
		  "schedulePercent": 0.959089,
		  "totalGuests": 2830,
		  "guestPercent": 0.978468,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2f986080edab9db88733ebea2ac966f",
		  
		  "name": "Chris",
		  "createdDate": "2019-07-04 02:11:55",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 1250,
		  "totalCountries": 14,
		  "totalStates": 64,
		  "totalEvents": 344,
		  "eventPercent": 0.93937,
		  "totalScheduleItems": 5596,
		  "schedulePercent": 0.969515,
		  "totalGuests": 2228,
		  "guestPercent": 0.959089,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a2f9c7431661a947c0ac2c25fdc0d369",
		  
		  "name": "Nicholas",
		  "createdDate": "2025-04-28 04:59:58",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 38,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 212,
		  "schedulePercent": 0.166931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a309267d8a67d0cb88aebe1f0156faa9",
		  
		  "name": "David",
		  "createdDate": "2012-06-19 05:28:13",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 407,
		  "totalCountries": 7,
		  "totalStates": 44,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 898,
		  "schedulePercent": 0.457502,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a309ba7b92e06cc2a1325d415f311d2e",
		  
		  "name": "Neale",
		  "createdDate": "2013-01-05 00:29:45",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 315,
		  "totalCountries": 24,
		  "totalStates": 57,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 2258,
		  "schedulePercent": 0.75646,
		  "totalGuests": 184,
		  "guestPercent": 0.582276,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a310b5a631e71b28c805d6e4d5472a94",
		  
		  "name": "Ronald",
		  "createdDate": "2009-09-09 17:13:03",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 1571,
		  "totalCountries": 15,
		  "totalStates": 54,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 3985,
		  "schedulePercent": 0.912511,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a31bf49d6e41db581429ad5a7027c4d4",
		  
		  "name": "Sean",
		  "createdDate": "2024-01-16 20:43:03",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 148,
		  "totalCountries": 24,
		  "totalStates": 42,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 563,
		  "schedulePercent": 0.338282,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a321d02ebcddc29e4f75bcbcdecbcd2c",
		  
		  "name": "Jaimee",
		  "createdDate": "2018-07-10 18:45:40",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 51,
		  "totalCountries": 10,
		  "totalStates": 10,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 400,
		  "schedulePercent": 0.269379,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Arena 8888 Sofia",
		  "mostGuestCity": "Sofia",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a323f82967d4606c4e61f1a6d4141ffc",
		  
		  "name": "Jan Ole",
		  "createdDate": "2019-01-16 15:09:44",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 344,
		  "totalCountries": 32,
		  "totalStates": 69,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 3234,
		  "schedulePercent": 0.862647,
		  "totalGuests": 785,
		  "guestPercent": 0.804964,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a32e5ee9f781f7f4000f69721afd6da7",
		  
		  "name": "Daria",
		  "createdDate": "2024-10-15 14:50:57",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 89,
		  "totalCountries": 16,
		  "totalStates": 24,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a339fad02fddb904743e82d16e5b815c",
		  
		  "name": "Walter",
		  "createdDate": "2023-10-02 19:53:34",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 415,
		  "totalCountries": 7,
		  "totalStates": 24,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 541,
		  "schedulePercent": 0.331142,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a3469826c5865b52d5f013b6ee404d95",
		  
		  "name": "Scott",
		  "createdDate": "2017-02-04 01:45:00",
		  "totalOrganizations": 19,
		  "totalTours": 5,
		  "totalDays": 565,
		  "totalCountries": 20,
		  "totalStates": 44,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1200,
		  "schedulePercent": 0.547484,
		  "totalGuests": 186,
		  "guestPercent": 0.583862,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a36e4a9ca091d6d8e9d3787eb7090b35",
		  
		  "name": "Alyssa",
		  "createdDate": "2023-05-30 17:41:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 168,
		  "totalCountries": 4,
		  "totalStates": 44,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 931,
		  "schedulePercent": 0.469402,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Royale",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a37879fbf075dd65053101b107189dd7",
		  
		  "name": "Rosie",
		  "createdDate": "2024-09-04 04:19:10",
		  "totalOrganizations": 17,
		  "totalTours": 32,
		  "totalDays": 1162,
		  "totalCountries": 33,
		  "totalStates": 78,
		  "totalEvents": 514,
		  "eventPercent": 0.980508,
		  "totalScheduleItems": 6029,
		  "schedulePercent": 0.975861,
		  "totalGuests": 2962,
		  "guestPercent": 0.981074,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a38aab1466f1c459e7c522e6fccb6873",
		  
		  "name": "Morgan",
		  "createdDate": "2022-05-21 23:31:47",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 119,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a38adcb1a66dbb1a4e9b428e7de3539b",
		  
		  "name": "Jack",
		  "createdDate": "2017-06-28 23:24:09",
		  "totalOrganizations": 45,
		  "totalTours": 21,
		  "totalDays": 349,
		  "totalCountries": 12,
		  "totalStates": 25,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1410,
		  "schedulePercent": 0.600295,
		  "totalGuests": 77,
		  "guestPercent": 0.49456,
		  "mostGuestDate": "2025-05-05 00:00:00",
		  "mostGuestName": "GRAMMY Museum at L.A. LIVE",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a39787a38636d311cc4f753118f962a4",
		  
		  "name": "Katharina",
		  "createdDate": "2025-10-30 08:15:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a39eec08ac35531d0bdabdf22b20876a",
		  
		  "name": "Lisa",
		  "createdDate": "2018-06-19 09:00:02",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 125,
		  "totalCountries": 7,
		  "totalStates": 28,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 587,
		  "schedulePercent": 0.346668,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-12-16 00:00:00",
		  "mostGuestName": "Sheffield City Hall",
		  "mostGuestCity": "Sheffield",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a3a52d3ebbe08b84dca41a484d2aa75b",
		  
		  "name": "Brittany",
		  "createdDate": "2019-01-31 23:31:05",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 283,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 719,
		  "schedulePercent": 0.393586,
		  "totalGuests": 46,
		  "guestPercent": 0.446623,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a3b3dd6be099f3992c8897d3805b6dc0",
		  
		  "name": "Melanie",
		  "createdDate": "2023-08-18 22:58:55",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 732,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 387,
		  "schedulePercent": 0.262579,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a3b41756d8f3c3c50629e932f0b43d53",
		  
		  "name": "Ana Georgina",
		  "createdDate": "2017-08-07 18:52:40",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 103,
		  "totalCountries": 10,
		  "totalStates": 12,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Sant Jordi Club",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a3b63d3992904cb7e7a4306a9c4ff539",
		  
		  "name": "Alistair",
		  "createdDate": "2016-06-21 10:35:08",
		  "totalOrganizations": 28,
		  "totalTours": 11,
		  "totalDays": 817,
		  "totalCountries": 25,
		  "totalStates": 44,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 1962,
		  "schedulePercent": 0.706256,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a3be6ced3f1ff0d519e3ddb61e8a9568",
		  
		  "name": "Sean",
		  "createdDate": "2022-10-26 20:55:21",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 144,
		  "totalCountries": 4,
		  "totalStates": 37,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 778,
		  "schedulePercent": 0.415458,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Foro Indierocks!",
		  "mostGuestCity": "MÃ©xico D.F.",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a3cc7a2ed81b0960cb10b0333049a391",
		  
		  "name": "Isha",
		  "createdDate": "2023-04-01 03:26:15",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 61,
		  "totalCountries": 9,
		  "totalStates": 23,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a3e264b9871a1812148b1c1bd7cc9bb1",
		  
		  "name": "Rusty",
		  "createdDate": "2015-10-03 17:59:10",
		  "totalOrganizations": 24,
		  "totalTours": 37,
		  "totalDays": 787,
		  "totalCountries": 21,
		  "totalStates": 72,
		  "totalEvents": 359,
		  "eventPercent": 0.94583,
		  "totalScheduleItems": 3810,
		  "schedulePercent": 0.903105,
		  "totalGuests": 1509,
		  "guestPercent": 0.910131,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Surly Brewing Co.",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a40349d5a797b5f489d98d7a298a3ca2",
		  
		  "name": "Anna-Tiina",
		  "createdDate": "2017-05-18 09:34:15",
		  "totalOrganizations": 22,
		  "totalTours": 32,
		  "totalDays": 698,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 580,
		  "eventPercent": 0.986401,
		  "totalScheduleItems": 2679,
		  "schedulePercent": 0.80689,
		  "totalGuests": 809,
		  "guestPercent": 0.810403,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Nordis Live",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a405922a640e15eeba59204809568451",
		  
		  "name": "Steve",
		  "createdDate": "2023-09-11 02:34:13",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 6,
		  "totalStates": 14,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 212,
		  "schedulePercent": 0.166931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a408ca6b760cfeaa28c8d72dee76c283",
		  
		  "name": "C&#233;line",
		  "createdDate": "2022-07-08 09:16:25",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 337,
		  "totalCountries": 18,
		  "totalStates": 32,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 544,
		  "schedulePercent": 0.331709,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4098133ee877aa9f00aea8ac71b0b46",
		  
		  "name": "Steven",
		  "createdDate": "2019-01-04 13:18:39",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 1161,
		  "totalCountries": 36,
		  "totalStates": 66,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 3442,
		  "schedulePercent": 0.8784,
		  "totalGuests": 298,
		  "guestPercent": 0.648685,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a419a50426fc335bb4daa648c3fe37bf",
		  
		  "name": "Meera",
		  "createdDate": "2023-03-28 18:53:07",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 40,
		  "totalCountries": 13,
		  "totalStates": 10,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 260,
		  "schedulePercent": 0.194923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a419a5fb0af12dfa998ba261d5eb1474",
		  
		  "name": "Bevan ",
		  "createdDate": "2017-09-20 05:44:35",
		  "totalOrganizations": 25,
		  "totalTours": 5,
		  "totalDays": 102,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 439,
		  "schedulePercent": 0.285811,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a41bd6bb32e9cffdb0ed901f9a473e49",
		  
		  "name": "Lara",
		  "createdDate": "2024-08-01 01:00:54",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 121,
		  "schedulePercent": 0.111627,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Whammy Bar",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4257f7231d94fc53b6a1d1543e366db",
		  
		  "name": "Emma",
		  "createdDate": "2018-07-19 05:41:52",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 192,
		  "totalCountries": 8,
		  "totalStates": 17,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1143,
		  "schedulePercent": 0.532298,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a42a32b6749940cfeaa5a66b25d9a3c4",
		  
		  "name": "Charmaine",
		  "createdDate": "2024-11-07 22:24:35",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 264,
		  "totalCountries": 37,
		  "totalStates": 37,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 830,
		  "schedulePercent": 0.43461,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Doka",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a44b4c4fdc318b16cdea18b91ce370b7",
		  
		  "name": "Roshad",
		  "createdDate": "2009-09-01 00:45:55",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 586,
		  "totalCountries": 17,
		  "totalStates": 38,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 2346,
		  "schedulePercent": 0.767452,
		  "totalGuests": 111,
		  "guestPercent": 0.529125,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a457c0f146bca5d7ef57d71d576484c6",
		  
		  "name": "Kasper ",
		  "createdDate": "2025-06-10 09:42:57",
		  "totalOrganizations": 38,
		  "totalTours": 31,
		  "totalDays": 355,
		  "totalCountries": 10,
		  "totalStates": 6,
		  "totalEvents": 333,
		  "eventPercent": 0.934044,
		  "totalScheduleItems": 1682,
		  "schedulePercent": 0.655032,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-07-24 00:00:00",
		  "mostGuestName": "GÃ¦sten",
		  "mostGuestCity": "",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a45a5a42594af896f9b81dbf89c19814",
		  
		  "name": "Ryan",
		  "createdDate": "2018-03-31 15:53:26",
		  "totalOrganizations": 18,
		  "totalTours": 30,
		  "totalDays": 1021,
		  "totalCountries": 31,
		  "totalStates": 88,
		  "totalEvents": 330,
		  "eventPercent": 0.93291,
		  "totalScheduleItems": 3825,
		  "schedulePercent": 0.904238,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Bruce Mason Centre",
		  "mostGuestCity": "Takapuna Beach",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4645f8d8faaa661426e208e232c9499",
		  
		  "name": "Josh",
		  "createdDate": "2011-03-04 03:15:32",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 123,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 902,
		  "schedulePercent": 0.458862,
		  "totalGuests": 1075,
		  "guestPercent": 0.859587,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a468e8cb4f719f28e8274193a73a6d36",
		  
		  "name": "Admin",
		  "createdDate": "2021-09-08 11:25:28",
		  "totalOrganizations": 23,
		  "totalTours": 7,
		  "totalDays": 842,
		  "totalCountries": 9,
		  "totalStates": 17,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 557,
		  "schedulePercent": 0.336355,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Klagenfurt Ostbucht",
		  "mostGuestCity": "Klagenfurt am WÃ¶rthersee",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a46c18ed0a8b72a46ebc363bd76db0e9",
		  
		  "name": "Taylor",
		  "createdDate": "2018-03-07 03:33:19",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1289,
		  "schedulePercent": 0.569356,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Fantasy Springs Casino",
		  "mostGuestCity": "Indio",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a46d85f3d66e75b54359d72ea1b8bbe3",
		  
		  "name": "Michael",
		  "createdDate": "2019-08-19 16:54:24",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 210,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2221,
		  "schedulePercent": 0.751247,
		  "totalGuests": 2002,
		  "guestPercent": 0.947303,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Globe Life Park in Arlington",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a480cc7044d77afc347b20c6d37be3c4",
		  
		  "name": "Michael",
		  "createdDate": "2016-03-27 20:52:54",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 550,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 2518,
		  "schedulePercent": 0.788418,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a483e744449afb6c63d3068ff7ca4da4",
		  
		  "name": "Gretchen",
		  "createdDate": "2016-01-03 20:14:07",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 368,
		  "totalCountries": 15,
		  "totalStates": 54,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 2740,
		  "schedulePercent": 0.814823,
		  "totalGuests": 2587,
		  "guestPercent": 0.971442,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a48559064d02b940ea580e5b3ebb40ed",
		  
		  "name": "Simon",
		  "createdDate": "2011-11-08 19:52:24",
		  "totalOrganizations": 27,
		  "totalTours": 9,
		  "totalDays": 560,
		  "totalCountries": 16,
		  "totalStates": 41,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1711,
		  "schedulePercent": 0.660585,
		  "totalGuests": 590,
		  "guestPercent": 0.755666,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a488ec3cf7e60172f925ec110ea420da",
		  
		  "name": "Bryce",
		  "createdDate": "2022-01-16 12:32:02",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 323,
		  "totalCountries": 34,
		  "totalStates": 83,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2706,
		  "schedulePercent": 0.809157,
		  "totalGuests": 1063,
		  "guestPercent": 0.856868,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a496d3cacae7459a90ce719ecf8efa7e",
		  
		  "name": "Mau",
		  "createdDate": "2023-09-14 13:38:55",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 29,
		  "totalCountries": 11,
		  "totalStates": 1,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 315,
		  "schedulePercent": 0.224841,
		  "totalGuests": 123,
		  "guestPercent": 0.539211,
		  "mostGuestDate": "2025-03-17 00:00:00",
		  "mostGuestName": "Islington Assembly Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4a49816d68c64dcf40e6d09dad4459a",
		  
		  "name": "Sherwin ",
		  "createdDate": "2017-09-14 17:59:19",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 153,
		  "totalCountries": 24,
		  "totalStates": 47,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 737,
		  "schedulePercent": 0.400272,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "Stay Gold",
		  "mostGuestCity": "Brunswick",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4a6962d70fefc832d264f8cc40b0ed6",
		  
		  "name": "Mike ",
		  "createdDate": "2014-04-15 19:08:29",
		  "totalOrganizations": 33,
		  "totalTours": 94,
		  "totalDays": 2342,
		  "totalCountries": 24,
		  "totalStates": 84,
		  "totalEvents": 747,
		  "eventPercent": 0.992407,
		  "totalScheduleItems": 6795,
		  "schedulePercent": 0.984814,
		  "totalGuests": 1060,
		  "guestPercent": 0.856301,
		  "mostGuestDate": "2025-03-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4aecf1513ab5f0e370e1a600eba1156",
		  
		  "name": "Anthony",
		  "createdDate": "2014-09-20 20:49:10",
		  "totalOrganizations": 131,
		  "totalTours": 4,
		  "totalDays": 107,
		  "totalCountries": 13,
		  "totalStates": 7,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 655,
		  "schedulePercent": 0.3699,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4b57dccc587dc70ef1977c137fc1f05",
		  
		  "name": "Jillian",
		  "createdDate": "2023-11-21 02:40:19",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 512,
		  "totalCountries": 11,
		  "totalStates": 44,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1381,
		  "schedulePercent": 0.593155,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Electric City",
		  "mostGuestCity": "Buffalo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4b98382c7a56f34c9a031f23e4b9dc4",
		  
		  "name": "Amos",
		  "createdDate": "2015-05-06 19:59:29",
		  "totalOrganizations": 26,
		  "totalTours": 9,
		  "totalDays": 166,
		  "totalCountries": 18,
		  "totalStates": 32,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1130,
		  "schedulePercent": 0.528105,
		  "totalGuests": 198,
		  "guestPercent": 0.593155,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4bc435ba4aae083eaaf049d4c2c4bd6",
		  
		  "name": "Suzy",
		  "createdDate": "2023-08-16 16:31:38",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 195,
		  "totalCountries": 24,
		  "totalStates": 27,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 639,
		  "schedulePercent": 0.364234,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "MVM Dome",
		  "mostGuestCity": "Budapest",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4c134746e96391dc953650f7a428700",
		  
		  "name": "Jared",
		  "createdDate": "2022-08-02 02:58:17",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 176,
		  "schedulePercent": 0.143699,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4cd3e877c04dc96a69d4226d23aace5",
		  
		  "name": "Andy",
		  "createdDate": "2012-06-23 21:38:09",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 651,
		  "totalCountries": 11,
		  "totalStates": 54,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1850,
		  "schedulePercent": 0.68597,
		  "totalGuests": 485,
		  "guestPercent": 0.726315,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Utah First Credit Union Amphitheatre",
		  "mostGuestCity": "West Valley City",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4d0a3009ae087b31354444a5f68fdc4",
		  
		  "name": "Anne",
		  "createdDate": "2018-04-03 23:52:10",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 65,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 408,
		  "schedulePercent": 0.272892,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4d1b71d4f7dcdc7c8ce8dff43bd37a1",
		  
		  "name": "Dustin",
		  "createdDate": "2025-06-18 16:04:50",
		  "totalOrganizations": 5,
		  "totalTours": 27,
		  "totalDays": 517,
		  "totalCountries": 13,
		  "totalStates": 53,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 3038,
		  "schedulePercent": 0.845762,
		  "totalGuests": 975,
		  "guestPercent": 0.842022,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Dolby Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4e0056378da1f113ed8a3a4720cdba7",
		  
		  "name": "Tony",
		  "createdDate": "2016-07-07 20:23:15",
		  "totalOrganizations": 14,
		  "totalTours": 9,
		  "totalDays": 628,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 2408,
		  "schedulePercent": 0.775839,
		  "totalGuests": 214,
		  "guestPercent": 0.604828,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "James H. Clark Auditorium",
		  "mostGuestCity": "Conway",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4e4e03120c925c13611029234ac8ad2",
		  
		  "name": "Alanna",
		  "createdDate": "2025-07-28 20:34:39",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 357,
		  "schedulePercent": 0.246714,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4eb519ef161246c24f574732ee87e2e",
		  
		  "name": "Logistics",
		  "createdDate": "2025-01-20 07:01:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 121,
		  "totalCountries": 16,
		  "totalStates": 17,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 104,
		  "schedulePercent": 0.0999547,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4ee7511edc7f61af832b4417764db32",
		  
		  "name": "Willow ",
		  "createdDate": "2023-04-17 02:46:17",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 26,
		  "totalCountries": 7,
		  "totalStates": 10,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 33,
		  "schedulePercent": 0.0441976,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4ee8f948bf0ca23235c301740a6e014",
		  
		  "name": "Alex",
		  "createdDate": "2019-08-26 19:57:17",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 829,
		  "totalCountries": 15,
		  "totalStates": 62,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 2877,
		  "schedulePercent": 0.829896,
		  "totalGuests": 1405,
		  "guestPercent": 0.900499,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Mission Ballroom",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a4f92571d5e474996d50de4a627d3043",
		  
		  "name": "William",
		  "createdDate": "2017-03-27 18:53:54",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 756,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1595,
		  "schedulePercent": 0.639733,
		  "totalGuests": 243,
		  "guestPercent": 0.621147,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a511f7bf658fa7d273aa06fa712ba03d",
		  
		  "name": "Mark",
		  "createdDate": "2024-04-02 17:33:29",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 172,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 2001,
		  "schedulePercent": 0.713962,
		  "totalGuests": 371,
		  "guestPercent": 0.68155,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lincoln Theatre",
		  "mostGuestCity": "Raleigh",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a513bcf48d5e1a5cf2853c94f71eb673",
		  
		  "name": "Alison",
		  "createdDate": "2022-01-20 01:01:30",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 213,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1328,
		  "schedulePercent": 0.578989,
		  "totalGuests": 667,
		  "guestPercent": 0.776745,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5291540a4aac5fb81e253168d7225be",
		  
		  "name": "Mattis",
		  "createdDate": "2016-10-12 15:07:16",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 123,
		  "totalCountries": 10,
		  "totalStates": 7,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 719,
		  "schedulePercent": 0.393586,
		  "totalGuests": 238,
		  "guestPercent": 0.617974,
		  "mostGuestDate": "2025-02-04 00:00:00",
		  "mostGuestName": "Gloria",
		  "mostGuestCity": "Koln",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a52aadd9485658d0c244713233e29554",
		  
		  "name": "Mike",
		  "createdDate": "2024-08-26 17:22:51",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 134,
		  "totalCountries": 13,
		  "totalStates": 37,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 731,
		  "schedulePercent": 0.398572,
		  "totalGuests": 388,
		  "guestPercent": 0.68903,
		  "mostGuestDate": "2025-06-10 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a52c8326a0f1453df9533ccc76f675de",
		  
		  "name": "Malin",
		  "createdDate": "2024-02-02 13:19:43",
		  "totalOrganizations": 31,
		  "totalTours": 8,
		  "totalDays": 554,
		  "totalCountries": 7,
		  "totalStates": 9,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 1390,
		  "schedulePercent": 0.594855,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "Burgsvik GrÃ¥ GÃ¥sen",
		  "mostGuestCity": "Burgsvik",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a52e5120f8afb9d33f10d3525ab579dc",
		  
		  "name": " Kaonashi",
		  "createdDate": "2021-09-13 01:19:54",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 138,
		  "totalCountries": 9,
		  "totalStates": 45,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 295,
		  "guestPercent": 0.647212,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "Brick By Brick",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a532b37bc7bfcd41462a2bf27d44dd36",
		  
		  "name": "Ivanna",
		  "createdDate": "2025-03-19 23:03:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 47,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 172,
		  "schedulePercent": 0.141772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5390423194256960e28589eab5e0f25",
		  
		  "name": "Daniel",
		  "createdDate": "2013-02-17 21:41:03",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 376,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 580,
		  "schedulePercent": 0.343608,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Lab11",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a539504bb456f6bcd366a1d2d1b23594",
		  
		  "name": "Elspeth",
		  "createdDate": "2022-04-26 09:44:05",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 59,
		  "totalCountries": 7,
		  "totalStates": 19,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a541bf47588644b966dbbe1d1f07606a",
		  
		  "name": "Kevin",
		  "createdDate": "2011-09-29 20:47:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 129,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 753,
		  "schedulePercent": 0.406505,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Club Regent Casino",
		  "mostGuestCity": "Winnipeg",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5433a974a928987f620e99c00a1ce44",
		  
		  "name": "Cyrus ",
		  "createdDate": "2025-04-01 20:08:00",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 75,
		  "totalCountries": 20,
		  "totalStates": 9,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 611,
		  "schedulePercent": 0.354374,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a548c2bf6287c9cfc56ef8e0cbf1c7e7",
		  
		  "name": "Ana Paula",
		  "createdDate": "2016-10-25 16:46:43",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 903,
		  "totalCountries": 21,
		  "totalStates": 42,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 2275,
		  "schedulePercent": 0.758726,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Movistar Arena Madrid",
		  "mostGuestCity": "Madrid",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a54a4a4405dd26c9c1cec424d77265e1",
		  
		  "name": "Missi",
		  "createdDate": "2012-01-12 07:42:08",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 446,
		  "totalCountries": 18,
		  "totalStates": 47,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1840,
		  "schedulePercent": 0.683137,
		  "totalGuests": 209,
		  "guestPercent": 0.601201,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a54cf2861308b20ba84b20816cd60033",
		  
		  "name": "Sarah",
		  "createdDate": "2022-02-11 18:21:04",
		  "totalOrganizations": 29,
		  "totalTours": 26,
		  "totalDays": 1153,
		  "totalCountries": 22,
		  "totalStates": 65,
		  "totalEvents": 270,
		  "eventPercent": 0.890299,
		  "totalScheduleItems": 3201,
		  "schedulePercent": 0.859927,
		  "totalGuests": 2203,
		  "guestPercent": 0.958069,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a57416460cd1d4a506e0ffca37c68e5d",
		  
		  "name": "Production",
		  "createdDate": "2021-10-26 00:55:06",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 617,
		  "totalCountries": 8,
		  "totalStates": 36,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 1120,
		  "schedulePercent": 0.524932,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Foufounes Ã‰lectriques",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a576da97d271a8cb39a40a06f7d2b011",
		  
		  "name": "Ida",
		  "createdDate": "2019-07-08 00:09:30",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 198,
		  "totalCountries": 14,
		  "totalStates": 12,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 298,
		  "schedulePercent": 0.216795,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "ECI Cultuurfabriek",
		  "mostGuestCity": "Roermond",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5831c47cb725a2240990009f1a47f73",
		  
		  "name": "Maja",
		  "createdDate": "2022-02-25 17:03:09",
		  "totalOrganizations": 39,
		  "totalTours": 7,
		  "totalDays": 158,
		  "totalCountries": 6,
		  "totalStates": 23,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 766,
		  "schedulePercent": 0.410245,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Bayside Festival",
		  "mostGuestCity": "Helsingborg",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a58379d0417bfcebdf541b7b5f9da6c5",
		  
		  "name": "Martin",
		  "createdDate": "2021-08-18 13:45:28",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 639,
		  "totalCountries": 24,
		  "totalStates": 38,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 2396,
		  "schedulePercent": 0.774592,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5879afa6118c3c8a4db069fe0f51088",
		  
		  "name": "Christina ",
		  "createdDate": "2018-02-12 03:32:03",
		  "totalOrganizations": 13,
		  "totalTours": 3,
		  "totalDays": 346,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1346,
		  "schedulePercent": 0.584542,
		  "totalGuests": 1638,
		  "guestPercent": 0.923504,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5a0704c919b2f549a4faf8d3b0c6e93",
		  
		  "name": "Mike",
		  "createdDate": "2012-04-18 02:52:25",
		  "totalOrganizations": 7,
		  "totalTours": 24,
		  "totalDays": 603,
		  "totalCountries": 32,
		  "totalStates": 84,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 4248,
		  "schedulePercent": 0.929057,
		  "totalGuests": 2187,
		  "guestPercent": 0.957276,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5a2620047aaccb2d533a4f7ee0bce0b",
		  
		  "name": "Assistant",
		  "createdDate": "2024-09-24 02:22:49",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 404,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 280,
		  "eventPercent": 0.898345,
		  "totalScheduleItems": 2013,
		  "schedulePercent": 0.715662,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5a910fae27c02f061927157d69a6add",
		  
		  "name": "Tara",
		  "createdDate": "2023-04-11 15:56:48",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 113,
		  "totalCountries": 7,
		  "totalStates": 28,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1243,
		  "schedulePercent": 0.558704,
		  "totalGuests": 1884,
		  "guestPercent": 0.939143,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5bd831f1cb7fbc24f345ed0963300e9",
		  
		  "name": "Randy",
		  "createdDate": "2019-01-17 18:02:57",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1399,
		  "schedulePercent": 0.597575,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5c4690ab8994b8c97e77d2034d168b3",
		  
		  "name": "Hoodie",
		  "createdDate": "2022-03-28 19:42:46",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 552,
		  "totalCountries": 26,
		  "totalStates": 33,
		  "totalEvents": 292,
		  "eventPercent": 0.907185,
		  "totalScheduleItems": 5447,
		  "schedulePercent": 0.966568,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Estadio Pascual Guerrero",
		  "mostGuestCity": "Cali",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5c6f1edbb5a79256cf71285b288f270",
		  
		  "name": "Anival",
		  "createdDate": "2024-04-19 18:35:54",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 132,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 696,
		  "schedulePercent": 0.385313,
		  "totalGuests": 248,
		  "guestPercent": 0.624207,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "San Antonio Stock Show & Rodeo",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5cf36df8664f3cabdd4420de33d219e",
		  
		  "name": "Denny",
		  "createdDate": "2015-01-16 21:58:36",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 339,
		  "totalCountries": 16,
		  "totalStates": 24,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 1636,
		  "schedulePercent": 0.646759,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5d9880ee9496f2d06d20cba516ef9dd",
		  
		  "name": "Maria",
		  "createdDate": "2018-03-23 15:06:24",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 143,
		  "totalCountries": 7,
		  "totalStates": 26,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 679,
		  "schedulePercent": 0.378626,
		  "totalGuests": 250,
		  "guestPercent": 0.625113,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5e6b261e0ce8fff25236b1683b5bbb2",
		  
		  "name": "Jordan",
		  "createdDate": "2022-03-07 18:37:39",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 419,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2343,
		  "schedulePercent": 0.767339,
		  "totalGuests": 662,
		  "guestPercent": 0.775159,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a5f3b2767f715baf8e262c4f9249ea2b",
		  
		  "name": "Keesha",
		  "createdDate": "2024-06-18 13:22:47",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 160,
		  "totalCountries": 15,
		  "totalStates": 25,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 675,
		  "schedulePercent": 0.376473,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Lighthouse Theatre",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a603a66a9a653f81e47c63d3f6b41218",
		  
		  "name": "Kyle",
		  "createdDate": "2023-05-01 20:54:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 91,
		  "totalCountries": 5,
		  "totalStates": 4,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 198,
		  "schedulePercent": 0.159451,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a60af6b4c2aefcea9f47d6668fd52222",
		  
		  "name": "Martin",
		  "createdDate": "2024-01-15 16:40:27",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 124,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 343,
		  "schedulePercent": 0.240141,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a60b17c4fd5dae80a2b55c238a8bb7f0",
		  
		  "name": "Diana",
		  "createdDate": "2023-07-13 08:11:33",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 201,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 743,
		  "schedulePercent": 0.402312,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a615edaf4834e015419a80bbb3b3b0f3",
		  
		  "name": "Sari",
		  "createdDate": "2022-06-22 10:01:43",
		  "totalOrganizations": 29,
		  "totalTours": 34,
		  "totalDays": 1555,
		  "totalCountries": 13,
		  "totalStates": 35,
		  "totalEvents": 281,
		  "eventPercent": 0.898912,
		  "totalScheduleItems": 2514,
		  "schedulePercent": 0.787965,
		  "totalGuests": 996,
		  "guestPercent": 0.845422,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Koelnarena",
		  "mostGuestCity": "Cologne",
		  "mostGuestAmount": 256,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a617219f740f786c1033f968772088b3",
		  
		  "name": "JOHN",
		  "createdDate": "2022-09-07 18:49:50",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 191,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 318,
		  "schedulePercent": 0.225748,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a61e2422592cb10997ac77a294df8a4b",
		  
		  "name": "Craig",
		  "createdDate": "2024-07-09 21:52:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 95,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 105,
		  "schedulePercent": 0.101315,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6232d8c0eee817091b7dbb8cabe5e65",
		  
		  "name": "Wayne",
		  "createdDate": "2020-09-02 11:38:05",
		  "totalOrganizations": 27,
		  "totalTours": 18,
		  "totalDays": 813,
		  "totalCountries": 7,
		  "totalStates": 39,
		  "totalEvents": 308,
		  "eventPercent": 0.917271,
		  "totalScheduleItems": 1339,
		  "schedulePercent": 0.583409,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "PEI Brewing Company",
		  "mostGuestCity": "Charlottetown",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a62b299caafccf460c8327b2393ef96d",
		  
		  "name": "Dominik ",
		  "createdDate": "2022-05-25 21:29:47",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 98,
		  "totalCountries": 21,
		  "totalStates": 22,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 588,
		  "schedulePercent": 0.346895,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6349782e3e5f06fd2145b55a5b282b0",
		  
		  "name": "Jess",
		  "createdDate": "2017-12-30 01:22:10",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 378,
		  "totalCountries": 10,
		  "totalStates": 16,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 1906,
		  "schedulePercent": 0.69583,
		  "totalGuests": 813,
		  "guestPercent": 0.811763,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a64fc8abca591d6b18a780d5148b2a61",
		  
		  "name": "Marlow",
		  "createdDate": "2025-04-21 18:42:34",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 260,
		  "totalCountries": 2,
		  "totalStates": 39,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 784,
		  "guestPercent": 0.80417,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a65db0bbea51ec3051e41f0f662f2bc9",
		  
		  "name": "Henry",
		  "createdDate": "2016-05-05 16:00:10",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 679,
		  "totalCountries": 14,
		  "totalStates": 40,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 4050,
		  "schedulePercent": 0.915798,
		  "totalGuests": 1283,
		  "guestPercent": 0.883613,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a665e543bf9fdd6aad2652f92c99a827",
		  
		  "name": "Rachel",
		  "createdDate": "2022-03-11 14:59:14",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 707,
		  "totalCountries": 20,
		  "totalStates": 86,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 3368,
		  "schedulePercent": 0.87296,
		  "totalGuests": 1143,
		  "guestPercent": 0.87092,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a669372f7dcda3e90b6c4da51098d4cf",
		  
		  "name": "Mike",
		  "createdDate": "2011-08-16 22:39:00",
		  "totalOrganizations": 25,
		  "totalTours": 14,
		  "totalDays": 1557,
		  "totalCountries": 24,
		  "totalStates": 62,
		  "totalEvents": 250,
		  "eventPercent": 0.87092,
		  "totalScheduleItems": 3455,
		  "schedulePercent": 0.879533,
		  "totalGuests": 1878,
		  "guestPercent": 0.938237,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a670773e44d5b02ec7fc621dc6f845a2",
		  
		  "name": "Morgan",
		  "createdDate": "2019-02-26 21:15:41",
		  "totalOrganizations": 4,
		  "totalTours": 10,
		  "totalDays": 374,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 2007,
		  "schedulePercent": 0.714869,
		  "totalGuests": 1502,
		  "guestPercent": 0.908885,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6718f85f3738d2e72ec3003edcb4e9d",
		  
		  "name": "Joshua",
		  "createdDate": "2018-08-18 02:09:03",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 57,
		  "totalCountries": 7,
		  "totalStates": 18,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 338,
		  "schedulePercent": 0.236967,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paradiso",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6838b51d9ae9e6289f17f73be8eee02",
		  
		  "name": "Lola",
		  "createdDate": "2024-05-17 15:29:25",
		  "totalOrganizations": 8,
		  "totalTours": 28,
		  "totalDays": 805,
		  "totalCountries": 7,
		  "totalStates": 22,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1337,
		  "schedulePercent": 0.582729,
		  "totalGuests": 192,
		  "guestPercent": 0.587262,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Les Nuits de FourviÃ¨re",
		  "mostGuestCity": "Lyon",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a687612c0530cc7e534e4c47b5850b41",
		  
		  "name": "Todd",
		  "createdDate": "2023-04-22 06:52:21",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 103,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 552,
		  "schedulePercent": 0.334769,
		  "totalGuests": 154,
		  "guestPercent": 0.561537,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Social",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a68dc7aabb02eedac6a5059ce3ed420b",
		  
		  "name": "Simeon",
		  "createdDate": "2020-01-15 16:03:10",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 78,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 771,
		  "schedulePercent": 0.412625,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a68dd7063c1ad9061bdc260478acf295",
		  
		  "name": "Freddy",
		  "createdDate": "2018-05-31 15:31:32",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 274,
		  "totalCountries": 18,
		  "totalStates": 23,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 2352,
		  "schedulePercent": 0.768472,
		  "totalGuests": 2611,
		  "guestPercent": 0.972235,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a695b72a4de8f00b0376176bd987be47",
		  
		  "name": "Rob",
		  "createdDate": "2012-08-03 21:40:51",
		  "totalOrganizations": 14,
		  "totalTours": 24,
		  "totalDays": 454,
		  "totalCountries": 37,
		  "totalStates": 94,
		  "totalEvents": 248,
		  "eventPercent": 0.868654,
		  "totalScheduleItems": 3846,
		  "schedulePercent": 0.905372,
		  "totalGuests": 1362,
		  "guestPercent": 0.895172,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Bramall Lane",
		  "mostGuestCity": "Sheffield",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6974996024c6d386124a4da68013109",
		  
		  "name": "Ethan ",
		  "createdDate": "2021-06-01 17:42:57",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 66,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 592,
		  "schedulePercent": 0.348481,
		  "totalGuests": 331,
		  "guestPercent": 0.666364,
		  "mostGuestDate": "2025-06-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6979a51d6cf687f4e767c428383c286",
		  
		  "name": "Zac",
		  "createdDate": "2015-07-07 07:01:34",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 368,
		  "totalCountries": 2,
		  "totalStates": 37,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1870,
		  "schedulePercent": 0.689257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a69e412cd2637c6474e095799da8af42",
		  
		  "name": "Rebecca",
		  "createdDate": "2020-03-03 08:33:56",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 174,
		  "totalCountries": 17,
		  "totalStates": 29,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1364,
		  "schedulePercent": 0.588395,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6c9cd18931f782f34e99308113de4ee",
		  
		  "name": "Chloe",
		  "createdDate": "2025-05-06 22:36:52",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 94,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 233,
		  "schedulePercent": 0.179964,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6cc7a4404ea9c570128146743cd049c",
		  
		  "name": "Shannon",
		  "createdDate": "2019-08-19 23:38:28",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 183,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 680,
		  "schedulePercent": 0.379306,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6daf91d81d0c5f66529923db5c2f7bd",
		  
		  "name": "Paul",
		  "createdDate": "2016-08-28 21:12:42",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 89,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 441,
		  "schedulePercent": 0.287285,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Chippewa Valley Rock Fest",
		  "mostGuestCity": "Cadott",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6db45caa4defaf9fb8f5e7fbb754b02",
		  
		  "name": "will",
		  "createdDate": "2023-04-11 08:46:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 139,
		  "schedulePercent": 0.123867,
		  "totalGuests": 67,
		  "guestPercent": 0.480734,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6df5730107853d4487d15e6a5f45207",
		  
		  "name": "Jochen",
		  "createdDate": "2017-07-08 16:50:43",
		  "totalOrganizations": 2,
		  "totalTours": 14,
		  "totalDays": 277,
		  "totalCountries": 33,
		  "totalStates": 54,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 2456,
		  "schedulePercent": 0.781732,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6ebeaedd34a3ed43a62cc77f91a3e1b",
		  
		  "name": "Tim",
		  "createdDate": "2018-02-06 19:11:41",
		  "totalOrganizations": 15,
		  "totalTours": 49,
		  "totalDays": 662,
		  "totalCountries": 10,
		  "totalStates": 38,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 1405,
		  "schedulePercent": 0.599388,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "MacKinnon Brothers Brewing Company",
		  "mostGuestCity": "Bath",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6f49053e65aa41fd0f7e187c5f5a170",
		  
		  "name": "Kane",
		  "createdDate": "2014-05-23 03:23:29",
		  "totalOrganizations": 11,
		  "totalTours": 23,
		  "totalDays": 605,
		  "totalCountries": 20,
		  "totalStates": 70,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2847,
		  "schedulePercent": 0.827516,
		  "totalGuests": 1177,
		  "guestPercent": 0.87398,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Metropolis",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6fd003d006cceb6c90f936dfa26ffb3",
		  
		  "name": "Jackson",
		  "createdDate": "2015-07-06 20:58:00",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 598,
		  "totalCountries": 6,
		  "totalStates": 44,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 1909,
		  "schedulePercent": 0.696283,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a6fe228ef232ec8455afbb9353db6b47",
		  
		  "name": "Tim",
		  "createdDate": "2025-06-07 01:00:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 115,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 386,
		  "schedulePercent": 0.261673,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Cervantes' Masterpiece Ballroom & Cervantes' Other Side",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a71272c18164d2657157fe272d16268c",
		  
		  "name": "Joni",
		  "createdDate": "2019-04-11 09:42:00",
		  "totalOrganizations": 51,
		  "totalTours": 33,
		  "totalDays": 392,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 390,
		  "eventPercent": 0.956029,
		  "totalScheduleItems": 1966,
		  "schedulePercent": 0.707049,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7151e61b8ed392a84c370351f3609bc",
		  
		  "name": "Alton",
		  "createdDate": "2015-11-18 22:14:55",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 14,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a721569690cc95ccce4f8a8f45af2966",
		  
		  "name": "Raymond",
		  "createdDate": "2021-09-27 17:23:28",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 200,
		  "totalCountries": 16,
		  "totalStates": 43,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1263,
		  "schedulePercent": 0.563803,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "Admiralspalast",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a730c51a78bf651f270446fc944ca7c7",
		  
		  "name": "Sean",
		  "createdDate": "2019-04-03 00:32:09",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 428,
		  "totalCountries": 20,
		  "totalStates": 58,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 2558,
		  "schedulePercent": 0.793744,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Yaamava' Resort & Casino",
		  "mostGuestCity": "Highland",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a737d75cd2fc472c700f39bc3704710e",
		  
		  "name": "Les ",
		  "createdDate": "2025-03-04 07:22:59",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 761,
		  "totalCountries": 12,
		  "totalStates": 55,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 5132,
		  "schedulePercent": 0.958182,
		  "totalGuests": 343,
		  "guestPercent": 0.671804,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "State Farm Arena",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a742261029ac063642cdbcd46fcdca87",
		  
		  "name": "Ian",
		  "createdDate": "2021-11-18 23:18:59",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 2120,
		  "totalCountries": 13,
		  "totalStates": 70,
		  "totalEvents": 429,
		  "eventPercent": 0.965889,
		  "totalScheduleItems": 5828,
		  "schedulePercent": 0.973141,
		  "totalGuests": 1025,
		  "guestPercent": 0.850521,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7442a0768686653a5e63eae3e0aa2d3",
		  
		  "name": "Ruth",
		  "createdDate": "2022-10-03 13:57:48",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 426,
		  "totalCountries": 13,
		  "totalStates": 18,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 1425,
		  "schedulePercent": 0.603581,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a74b2683295d769bc9c5504813ace120",
		  
		  "name": "Fiona",
		  "createdDate": "2013-02-25 19:23:49",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 50,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7508d23eec4ddd72b0ead1c0cd6a612",
		  
		  "name": "Paul",
		  "createdDate": "2013-11-04 12:01:09",
		  "totalOrganizations": 15,
		  "totalTours": 1,
		  "totalDays": 20,
		  "totalCountries": 10,
		  "totalStates": 10,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 105,
		  "schedulePercent": 0.101315,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a766f7564eb774cc83d4b6ff86ca5cd5",
		  
		  "name": "Johan",
		  "createdDate": "2009-11-16 18:50:04",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 77,
		  "totalCountries": 6,
		  "totalStates": 11,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 500,
		  "schedulePercent": 0.31199,
		  "totalGuests": 335,
		  "guestPercent": 0.668064,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 241,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a76ad5baffed9aa1783fae0b8c185907",
		  
		  "name": "Jake",
		  "createdDate": "2013-01-12 19:35:31",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 557,
		  "totalCountries": 19,
		  "totalStates": 45,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2026,
		  "schedulePercent": 0.718608,
		  "totalGuests": 906,
		  "guestPercent": 0.831596,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 180,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7726115048f24c4cc6c1a8d385c9f42",
		  
		  "name": "Mackenzie",
		  "createdDate": "2023-10-03 23:09:43",
		  "totalOrganizations": 13,
		  "totalTours": 17,
		  "totalDays": 769,
		  "totalCountries": 6,
		  "totalStates": 58,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 3396,
		  "schedulePercent": 0.875,
		  "totalGuests": 1386,
		  "guestPercent": 0.898912,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7797aff34c62df45c87f6480e7d8732",
		  
		  "name": "Harrison",
		  "createdDate": "2024-03-15 15:45:44",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 173,
		  "totalCountries": 28,
		  "totalStates": 65,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1721,
		  "schedulePercent": 0.662171,
		  "totalGuests": 360,
		  "guestPercent": 0.67815,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a78396526144eac1d202cc605d4547f0",
		  
		  "name": "Hannah",
		  "createdDate": "2024-12-19 05:17:11",
		  "totalOrganizations": 7,
		  "totalTours": 20,
		  "totalDays": 318,
		  "totalCountries": 15,
		  "totalStates": 49,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2022,
		  "schedulePercent": 0.717588,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Barbican Centre",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a783b8db89b8bfe8aa491407a3ee95e0",
		  
		  "name": "Chad",
		  "createdDate": "2016-08-26 17:44:37",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 139,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 903,
		  "schedulePercent": 0.459089,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Billy Bob's Texas",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a78e2bbb785c262a8598f1c3b56b5350",
		  
		  "name": "Seth ",
		  "createdDate": "2019-09-10 17:10:32",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 85,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 240,
		  "schedulePercent": 0.184497,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7a3af49392d5c09c4d633ecc474e2f4",
		  
		  "name": "Trevor",
		  "createdDate": "2024-04-23 17:53:26",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 326,
		  "totalCountries": 11,
		  "totalStates": 67,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2387,
		  "schedulePercent": 0.773345,
		  "totalGuests": 1075,
		  "guestPercent": 0.859587,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "The Dome",
		  "mostGuestCity": "Virginia Beach",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7b2e0b7f3b56f64a354535e5cdf924d",
		  
		  "name": "Luis",
		  "createdDate": "2023-04-18 08:47:48",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 394,
		  "totalCountries": 18,
		  "totalStates": 32,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 818,
		  "schedulePercent": 0.430077,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7b9673e4e7a5ca49786adbf5166bfee",
		  
		  "name": "Thomas",
		  "createdDate": "2018-05-26 20:53:14",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 388,
		  "totalCountries": 14,
		  "totalStates": 4,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 963,
		  "schedulePercent": 0.479601,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7ba6bad9d5d40a3f3614b2aace73525",
		  
		  "name": "MARGARITA",
		  "createdDate": "2025-07-11 15:14:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 1,
		  "eventPercent": 0.0074796,
		  "totalScheduleItems": 360,
		  "schedulePercent": 0.248187,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7bb2d666a47b9e78442de7222ae2123",
		  
		  "name": "Keith",
		  "createdDate": "2015-04-29 21:21:59",
		  "totalOrganizations": 15,
		  "totalTours": 20,
		  "totalDays": 540,
		  "totalCountries": 15,
		  "totalStates": 61,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 2293,
		  "schedulePercent": 0.760879,
		  "totalGuests": 806,
		  "guestPercent": 0.809384,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7c02fddfecdea3b274c8b037747ab14",
		  
		  "name": "Colin",
		  "createdDate": "2023-02-08 12:29:10",
		  "totalOrganizations": 8,
		  "totalTours": 19,
		  "totalDays": 664,
		  "totalCountries": 24,
		  "totalStates": 60,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 4335,
		  "schedulePercent": 0.932684,
		  "totalGuests": 1306,
		  "guestPercent": 0.886899,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Pitt Street Uniting Church",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7c171bd656e8b2db665f04d7ff1a713",
		  
		  "name": "Floz",
		  "createdDate": "2018-04-16 05:00:58",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 114,
		  "totalCountries": 11,
		  "totalStates": 26,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 554,
		  "schedulePercent": 0.335109,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Mountain Winery",
		  "mostGuestCity": "Saratoga",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7c2a41ac05560ea6851d27c02c9ff21",
		  
		  "name": "Charlie",
		  "createdDate": "2024-06-01 17:13:25",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 431,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1192,
		  "schedulePercent": 0.545444,
		  "totalGuests": 401,
		  "guestPercent": 0.69481,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7c4c1d035698548cab4ca1f592af1bf",
		  
		  "name": "Steve",
		  "createdDate": "2020-01-30 10:41:21",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 524,
		  "schedulePercent": 0.324003,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7e5faaab4c1ef17360e94eb9c168b73",
		  
		  "name": "Kyla ",
		  "createdDate": "2024-07-03 23:07:41",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 444,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 2259,
		  "schedulePercent": 0.756573,
		  "totalGuests": 2564,
		  "guestPercent": 0.970988,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7e731b64af06b4f3e3a3d3083676e21",
		  
		  "name": "Greg",
		  "createdDate": "2014-01-13 17:23:25",
		  "totalOrganizations": 19,
		  "totalTours": 15,
		  "totalDays": 863,
		  "totalCountries": 37,
		  "totalStates": 63,
		  "totalEvents": 266,
		  "eventPercent": 0.887579,
		  "totalScheduleItems": 3650,
		  "schedulePercent": 0.892452,
		  "totalGuests": 2124,
		  "guestPercent": 0.955122,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7f0c5bb7b57f956474fa137d688d7bc",
		  
		  "name": "Jacob",
		  "createdDate": "2023-02-08 22:05:16",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 257,
		  "totalCountries": 5,
		  "totalStates": 29,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 410,
		  "schedulePercent": 0.273799,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "The Caverns",
		  "mostGuestCity": "Pelham",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7fab704998a7f7ad3720975aeb5dd9d",
		  
		  "name": "Alex",
		  "createdDate": "2025-03-19 19:00:54",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 199,
		  "totalCountries": 23,
		  "totalStates": 22,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 479,
		  "schedulePercent": 0.302357,
		  "totalGuests": 211,
		  "guestPercent": 0.603128,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a7ff749a80ca8b81db552be9660acdc2",
		  
		  "name": "Yaroslav",
		  "createdDate": "2024-02-18 16:45:31",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 93,
		  "totalCountries": 10,
		  "totalStates": 8,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 341,
		  "schedulePercent": 0.239121,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-06-30 00:00:00",
		  "mostGuestName": "Batschkapp",
		  "mostGuestCity": "Frankfurt am Main",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8086eea9317015b2289403d78d03bda",
		  
		  "name": "Kjell Morten",
		  "createdDate": "2023-11-07 12:05:10",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 542,
		  "totalCountries": 12,
		  "totalStates": 20,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1457,
		  "schedulePercent": 0.608568,
		  "totalGuests": 876,
		  "guestPercent": 0.823889,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 241,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a80a51179842d4d037ca148fed34ff74",
		  
		  "name": "Toshi",
		  "createdDate": "2013-11-29 18:33:07",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 70,
		  "totalCountries": 15,
		  "totalStates": 13,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 260,
		  "schedulePercent": 0.194923,
		  "totalGuests": 120,
		  "guestPercent": 0.536945,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a80b7e25ac4066dc661c1ff99b0ba89a",
		  
		  "name": "Kristin",
		  "createdDate": "2020-01-21 22:34:47",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 74,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 293,
		  "schedulePercent": 0.213849,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a81f9b6dba7295f3725477648c0e3046",
		  
		  "name": "Carlos",
		  "createdDate": "2019-11-09 01:33:11",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 94,
		  "totalCountries": 15,
		  "totalStates": 23,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a822bdaa8c096d690503ee7057364ff3",
		  
		  "name": "Jordan",
		  "createdDate": "2025-05-01 11:21:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 64,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 1319,
		  "schedulePercent": 0.576043,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a83b025770146890b5bc1e156daed8e5",
		  
		  "name": "Makaya",
		  "createdDate": "2018-05-24 19:59:01",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 112,
		  "totalCountries": 17,
		  "totalStates": 18,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 470,
		  "schedulePercent": 0.298277,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Auditorium Parco Della Musica - Sala Sinopoli",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a83c219bf9cdae5803b87e6d9d483865",
		  
		  "name": "Dhruv",
		  "createdDate": "2025-01-02 22:37:18",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 5,
		  "totalStates": 21,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 242,
		  "schedulePercent": 0.18529,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-01-28 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8544542b2a9391cf96fda8625b98307",
		  
		  "name": "Adriana",
		  "createdDate": "2025-04-28 02:27:15",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 93,
		  "totalCountries": 9,
		  "totalStates": 23,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 543,
		  "schedulePercent": 0.331369,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a85851e21f8d8e81cab8bfe6edcb6a3f",
		  
		  "name": "Matthew ",
		  "createdDate": "2025-03-24 20:36:28",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 505,
		  "totalCountries": 7,
		  "totalStates": 40,
		  "totalEvents": 230,
		  "eventPercent": 0.848595,
		  "totalScheduleItems": 3832,
		  "schedulePercent": 0.904578,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a861537c958aabfad70434c3fd662a2b",
		  
		  "name": "CORRIDOS",
		  "createdDate": "2024-06-08 00:25:46",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 343,
		  "totalCountries": 7,
		  "totalStates": 16,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a864a22ac1b408c0d595f86941264257",
		  
		  "name": "Ellie",
		  "createdDate": "2022-06-10 18:18:18",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 189,
		  "totalCountries": 7,
		  "totalStates": 11,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1171,
		  "schedulePercent": 0.540458,
		  "totalGuests": 450,
		  "guestPercent": 0.712489,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Event Style Festival",
		  "mostGuestCity": "Mont-Tremblant",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a866ab3450d85009660b995a6d0ebac2",
		  
		  "name": "Marco",
		  "createdDate": "2025-07-22 21:16:19",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 8,
		  "totalStates": 9,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 40,
		  "schedulePercent": 0.0504306,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a86e6a4e99daf16f3fb0a5f5ef5a28e0",
		  
		  "name": "Carly",
		  "createdDate": "2021-11-30 20:02:39",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 112,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 666,
		  "schedulePercent": 0.373413,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Meow Wolf Denver",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a876f37703effa0626be0bfd443ff952",
		  
		  "name": "Daniel",
		  "createdDate": "2017-01-07 17:42:04",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1169,
		  "totalCountries": 10,
		  "totalStates": 53,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 3647,
		  "schedulePercent": 0.892339,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-02-03 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a883215e348bb349e18081bd32a9a7f0",
		  
		  "name": "Ilta",
		  "createdDate": "2025-09-29 11:07:40",
		  "totalOrganizations": 24,
		  "totalTours": 21,
		  "totalDays": 192,
		  "totalCountries": 14,
		  "totalStates": 15,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 697,
		  "schedulePercent": 0.385766,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a88e5325268cf0a7b6edde955a58e75c",
		  
		  "name": "Adam",
		  "createdDate": "2012-02-21 16:47:16",
		  "totalOrganizations": 24,
		  "totalTours": 9,
		  "totalDays": 303,
		  "totalCountries": 26,
		  "totalStates": 55,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1572,
		  "schedulePercent": 0.635199,
		  "totalGuests": 457,
		  "guestPercent": 0.714982,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a89131f77e614c043fc9b8ee92dc51df",
		  
		  "name": "Stefan",
		  "createdDate": "2022-04-18 08:42:19",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 532,
		  "totalCountries": 11,
		  "totalStates": 22,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1257,
		  "schedulePercent": 0.562103,
		  "totalGuests": 492,
		  "guestPercent": 0.728015,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a89c521a4cb927903929140a4e476a6e",
		  
		  "name": "Adam",
		  "createdDate": "2022-10-17 17:18:59",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 194,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 673,
		  "schedulePercent": 0.37602,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8ac898da48a9dd533ac6dd2c8689bdf",
		  
		  "name": "Mark ",
		  "createdDate": "2013-11-21 20:53:36",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 438,
		  "totalCountries": 11,
		  "totalStates": 32,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1001,
		  "schedulePercent": 0.490594,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8aee5ca6b5effd1afa9af4406f2a392",
		  
		  "name": "Arnaud",
		  "createdDate": "2024-02-13 16:14:10",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 165,
		  "totalCountries": 17,
		  "totalStates": 48,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1457,
		  "schedulePercent": 0.608568,
		  "totalGuests": 382,
		  "guestPercent": 0.686537,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Meadows",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8b009aea19d62dd4b7fd72ca651e51e",
		  
		  "name": "Karen",
		  "createdDate": "2022-06-22 21:08:36",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 101,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 410,
		  "schedulePercent": 0.273799,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Liberty Hall",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8b2479c8114349fba0955c7037ec6de",
		  
		  "name": "Chris",
		  "createdDate": "2014-11-23 13:59:40",
		  "totalOrganizations": 19,
		  "totalTours": 5,
		  "totalDays": 170,
		  "totalCountries": 17,
		  "totalStates": 18,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 631,
		  "schedulePercent": 0.361287,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8b855e19499372d12e739439becdf07",
		  
		  "name": "Basile",
		  "createdDate": "2019-04-01 12:57:30",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 283,
		  "totalCountries": 5,
		  "totalStates": 9,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 493,
		  "schedulePercent": 0.30927,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Sakifo Musik Festival",
		  "mostGuestCity": "Saint-Pierre",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8c0ddbf5bef1628ecef4709c326ae76",
		  
		  "name": "Ines",
		  "createdDate": "2025-04-10 14:22:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 13,
		  "totalStates": 1,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 326,
		  "schedulePercent": 0.229601,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-04-22 00:00:00",
		  "mostGuestName": "B72",
		  "mostGuestCity": "Wien",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8c39b8a0452c0301dac84cbbf04414d",
		  
		  "name": "Kamal",
		  "createdDate": "2019-09-02 21:05:17",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 209,
		  "totalCountries": 18,
		  "totalStates": 19,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 987,
		  "schedulePercent": 0.486967,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "On The Beach Festival Site",
		  "mostGuestCity": "",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8c42e397dc4a428347bdcc51c493879",
		  
		  "name": "Adrian",
		  "createdDate": "2013-07-30 04:40:40",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 761,
		  "totalCountries": 13,
		  "totalStates": 50,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1554,
		  "schedulePercent": 0.631233,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Horseshoe Tavern",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8c88de30d44eee5e167ee39943d000b",
		  
		  "name": "Felicity",
		  "createdDate": "2018-01-19 17:42:11",
		  "totalOrganizations": 55,
		  "totalTours": 29,
		  "totalDays": 626,
		  "totalCountries": 36,
		  "totalStates": 91,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 3341,
		  "schedulePercent": 0.870127,
		  "totalGuests": 896,
		  "guestPercent": 0.828989,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8c99880e081e90683a67ae8366b3062",
		  
		  "name": "Jean",
		  "createdDate": "2017-10-04 11:26:23",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 141,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 627,
		  "schedulePercent": 0.359701,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Luckman Fine Arts Complex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8d5afea3a57790d353a3bde14e2ff64",
		  
		  "name": "DANIEL",
		  "createdDate": "2023-09-07 17:41:42",
		  "totalOrganizations": 3,
		  "totalTours": 13,
		  "totalDays": 105,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 311,
		  "schedulePercent": 0.222801,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8de91ac08acbb49714fd022d69c0e53",
		  
		  "name": "Andrew",
		  "createdDate": "2017-10-03 11:59:22",
		  "totalOrganizations": 23,
		  "totalTours": 13,
		  "totalDays": 2137,
		  "totalCountries": 27,
		  "totalStates": 60,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 5258,
		  "schedulePercent": 0.961015,
		  "totalGuests": 578,
		  "guestPercent": 0.75238,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8e43dc4fb0a94d8da3f5e886dcd0137",
		  
		  "name": "Ryan",
		  "createdDate": "2025-06-26 13:06:59",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8f03863ab05c5e531c5fa731e5d6d25",
		  
		  "name": "Boyd",
		  "createdDate": "2020-12-02 23:33:47",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 530,
		  "totalCountries": 23,
		  "totalStates": 52,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 3379,
		  "schedulePercent": 0.873753,
		  "totalGuests": 1798,
		  "guestPercent": 0.933137,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Revolution Concert House",
		  "mostGuestCity": "Garden City",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8f2db45ec2d05ee4b3609a2c6827222",
		  
		  "name": "Francis",
		  "createdDate": "2025-09-18 17:40:18",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 173,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 87,
		  "schedulePercent": 0.0878287,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "House of Blues Myrtle Beach",
		  "mostGuestCity": "North Myrtle Beach",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8fa9f609bfb9fe5b10101e5f9b0cd06",
		  
		  "name": "Jacob",
		  "createdDate": "2023-09-08 15:07:22",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 271,
		  "totalCountries": 12,
		  "totalStates": 37,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "McMenamins Crystal Ballroom",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a8fd18bf754301b4167e7f93419fecbe",
		  
		  "name": "Raven",
		  "createdDate": "2023-05-15 05:29:59",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 502,
		  "totalCountries": 16,
		  "totalStates": 60,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2319,
		  "schedulePercent": 0.764846,
		  "totalGuests": 1266,
		  "guestPercent": 0.882253,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a90907cce745d9b3820ab2db81603869",
		  
		  "name": "Xavier",
		  "createdDate": "2024-01-03 10:57:12",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 309,
		  "totalCountries": 5,
		  "totalStates": 20,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1395,
		  "schedulePercent": 0.596668,
		  "totalGuests": 1273,
		  "guestPercent": 0.88282,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "La Seine Musicale",
		  "mostGuestCity": "Boulogne-Billancourt",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a90ca2571e04bd523661dc346b08fa8c",
		  
		  "name": "Isabella \"Morot\"",
		  "createdDate": "2016-11-18 12:19:13",
		  "totalOrganizations": 85,
		  "totalTours": 42,
		  "totalDays": 486,
		  "totalCountries": 14,
		  "totalStates": 45,
		  "totalEvents": 374,
		  "eventPercent": 0.951609,
		  "totalScheduleItems": 3105,
		  "schedulePercent": 0.852108,
		  "totalGuests": 355,
		  "guestPercent": 0.676564,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 241,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a90fea4d2206536f3eb0685ba006d51f",
		  
		  "name": "Brian ",
		  "createdDate": "2025-09-15 09:18:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 37,
		  "totalCountries": 8,
		  "totalStates": 11,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 111,
		  "schedulePercent": 0.106074,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Nochtspeicher",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a91e466b52734d628b69f93fff72a414",
		  
		  "name": "Nicholas",
		  "createdDate": "2023-08-14 18:12:08",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 661,
		  "totalCountries": 6,
		  "totalStates": 41,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1712,
		  "schedulePercent": 0.660811,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-08-25 00:00:00",
		  "mostGuestName": "Margaret Court Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a91eb4e70e7e5c54bc8ab414e61b4818",
		  
		  "name": "Jovana",
		  "createdDate": "2019-01-10 16:38:49",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 145,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 833,
		  "schedulePercent": 0.435517,
		  "totalGuests": 106,
		  "guestPercent": 0.525385,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a931af14e5f4ad3d612c539dc1209b58",
		  
		  "name": "Amanda",
		  "createdDate": "2019-07-22 17:09:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 64,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 272,
		  "schedulePercent": 0.200929,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a931f681fc417d8f16bb9004ac9a84df",
		  
		  "name": "Alexander",
		  "createdDate": "2019-03-29 06:20:29",
		  "totalOrganizations": 5,
		  "totalTours": 19,
		  "totalDays": 233,
		  "totalCountries": 2,
		  "totalStates": 40,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1899,
		  "schedulePercent": 0.694583,
		  "totalGuests": 565,
		  "guestPercent": 0.747847,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a932f97d2125318d0ede2800ea9b4102",
		  
		  "name": "Carlette",
		  "createdDate": "2017-07-24 21:18:37",
		  "totalOrganizations": 3,
		  "totalTours": 19,
		  "totalDays": 151,
		  "totalCountries": 27,
		  "totalStates": 37,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1343,
		  "schedulePercent": 0.584089,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Darien Lake Performing Arts Center",
		  "mostGuestCity": "Darien Center",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a93f185ce91cdeaa249cabf66a493fa7",
		  
		  "name": "Sebastien",
		  "createdDate": "2023-01-11 21:03:28",
		  "totalOrganizations": 3,
		  "totalTours": 17,
		  "totalDays": 62,
		  "totalCountries": 11,
		  "totalStates": 18,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 406,
		  "schedulePercent": 0.272099,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Chevalier Theatre",
		  "mostGuestCity": "Medford",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a93f9be505c7924f268008e38f42cf2d",
		  
		  "name": "CP",
		  "createdDate": "2023-10-10 22:43:34",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 75,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 114,
		  "schedulePercent": 0.107774,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a942aa3730a7d29a49c272f0f24a719d",
		  
		  "name": "Sascha",
		  "createdDate": "2023-02-01 19:20:02",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 325,
		  "totalCountries": 17,
		  "totalStates": 37,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1017,
		  "schedulePercent": 0.495354,
		  "totalGuests": 512,
		  "guestPercent": 0.733568,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Santa Barbara Bowl",
		  "mostGuestCity": "Santa Barbara",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a94c6ff3f2e71c417035ba52cc9da424",
		  
		  "name": "Bodo",
		  "createdDate": "2024-09-12 14:16:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 49,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 603,
		  "schedulePercent": 0.351881,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a959365aaeb6be03cce9e924d26a036c",
		  
		  "name": "Angelica ",
		  "createdDate": "2025-10-24 15:50:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 4,
		  "totalStates": 19,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 289,
		  "schedulePercent": 0.211809,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a95ab147010fc727efadaed466d62720",
		  
		  "name": "Sofie",
		  "createdDate": "2022-08-31 15:30:41",
		  "totalOrganizations": 17,
		  "totalTours": 13,
		  "totalDays": 782,
		  "totalCountries": 14,
		  "totalStates": 22,
		  "totalEvents": 314,
		  "eventPercent": 0.921917,
		  "totalScheduleItems": 2006,
		  "schedulePercent": 0.714755,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Lunds Allhelgonakyrka",
		  "mostGuestCity": "Lund",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a95efc490d7d2bd0d3f1b09a15aa0507",
		  
		  "name": "Kylie",
		  "createdDate": "2018-09-24 06:57:33",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 524,
		  "totalCountries": 18,
		  "totalStates": 47,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 792,
		  "schedulePercent": 0.419878,
		  "totalGuests": 271,
		  "guestPercent": 0.635653,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Scala",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a964ca3d7214bb9ffa581a7c7965f6d6",
		  
		  "name": "Stephen",
		  "createdDate": "2022-04-14 21:34:46",
		  "totalOrganizations": 9,
		  "totalTours": 19,
		  "totalDays": 590,
		  "totalCountries": 21,
		  "totalStates": 88,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 4093,
		  "schedulePercent": 0.918291,
		  "totalGuests": 500,
		  "guestPercent": 0.730734,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a96d20b38adbb5667345e37c17079f55",
		  
		  "name": "Tobias",
		  "createdDate": "2025-02-19 10:08:12",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a96ed07efdb461aad669b5921686be3a",
		  
		  "name": "Daniel",
		  "createdDate": "2013-12-05 21:06:10",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 504,
		  "totalCountries": 18,
		  "totalStates": 58,
		  "totalEvents": 269,
		  "eventPercent": 0.889393,
		  "totalScheduleItems": 3008,
		  "schedulePercent": 0.842815,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a97208f3174a6e65dec4702f380c84fd",
		  
		  "name": "Ray",
		  "createdDate": "2011-03-22 20:33:14",
		  "totalOrganizations": 12,
		  "totalTours": 2,
		  "totalDays": 252,
		  "totalCountries": 17,
		  "totalStates": 36,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1280,
		  "schedulePercent": 0.567316,
		  "totalGuests": 237,
		  "guestPercent": 0.617294,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Roy Thomson Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a984448f06ec2c082b9b386608b418c1",
		  
		  "name": "Tim",
		  "createdDate": "2019-11-30 12:10:04",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 328,
		  "totalCountries": 19,
		  "totalStates": 42,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 836,
		  "schedulePercent": 0.436197,
		  "totalGuests": 294,
		  "guestPercent": 0.646532,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a98c9d77535e9dc8ff9302d44c9a11d8",
		  
		  "name": "Michael",
		  "createdDate": "2018-06-19 01:50:29",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 80,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 634,
		  "schedulePercent": 0.361854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a98ec92d9e9091ebe579e8c3e9399791",
		  
		  "name": "Henry",
		  "createdDate": "2022-10-06 00:11:37",
		  "totalOrganizations": 12,
		  "totalTours": 20,
		  "totalDays": 1018,
		  "totalCountries": 19,
		  "totalStates": 78,
		  "totalEvents": 314,
		  "eventPercent": 0.921917,
		  "totalScheduleItems": 4317,
		  "schedulePercent": 0.931777,
		  "totalGuests": 473,
		  "guestPercent": 0.721668,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Roadrunner",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9953b635b69925750e4c6606984e25d",
		  
		  "name": "Amanda Kate",
		  "createdDate": "2025-01-14 19:30:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 297,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 547,
		  "schedulePercent": 0.332956,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "3TEN Austin City Limits Live",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a997fe5007258e5184f341e354d1d9c5",
		  
		  "name": "Lisa",
		  "createdDate": "2018-09-08 12:37:28",
		  "totalOrganizations": 26,
		  "totalTours": 28,
		  "totalDays": 689,
		  "totalCountries": 7,
		  "totalStates": 46,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 2945,
		  "schedulePercent": 0.836242,
		  "totalGuests": 718,
		  "guestPercent": 0.790005,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a99f20560df071ff793a2c031acaba72",
		  
		  "name": "Tinku",
		  "createdDate": "2022-07-27 18:14:51",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 534,
		  "totalCountries": 20,
		  "totalStates": 38,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1043,
		  "schedulePercent": 0.501927,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "The Sun Rose",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9a3abfda0b8a09643e782e76f0cd88e",
		  
		  "name": "Ivan",
		  "createdDate": "2017-09-11 02:23:45",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 93,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 626,
		  "schedulePercent": 0.359474,
		  "totalGuests": 41,
		  "guestPercent": 0.439937,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Chain Reaction",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9a5b7415cb662522325069911d2a5c7",
		  
		  "name": "Simon",
		  "createdDate": "2023-09-21 12:33:29",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 1007,
		  "totalCountries": 18,
		  "totalStates": 37,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 1189,
		  "schedulePercent": 0.544878,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-02-09 00:00:00",
		  "mostGuestName": "Palais de Congres",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9ac9d9fe5fa4711d46176cc7beb0bc2",
		  
		  "name": "Fletcher",
		  "createdDate": "2022-04-13 21:30:48",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 1567,
		  "totalCountries": 9,
		  "totalStates": 57,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2136,
		  "schedulePercent": 0.737761,
		  "totalGuests": 426,
		  "guestPercent": 0.705349,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Buckhead Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9b608c98f764cc7427d81babe0c802f",
		  
		  "name": "Brett",
		  "createdDate": "2025-02-14 22:06:18",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 148,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 1,
		  "schedulePercent": 0.00804624,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9b6b157d7e7a82934313dd5e3f3ba48",
		  
		  "name": "Jamila",
		  "createdDate": "2023-06-20 13:38:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 176,
		  "totalCountries": 30,
		  "totalStates": 21,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 1116,
		  "schedulePercent": 0.522892,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9b74b392ae37dcee66cd61ec1cbee7e",
		  
		  "name": "Anna",
		  "createdDate": "2015-10-21 03:18:05",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 164,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 218,
		  "schedulePercent": 0.170558,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9bd0b788d4b3a8253b2ee6fcc126433",
		  
		  "name": "Michael",
		  "createdDate": "2013-02-15 16:28:32",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 371,
		  "totalCountries": 23,
		  "totalStates": 72,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 3686,
		  "schedulePercent": 0.895059,
		  "totalGuests": 779,
		  "guestPercent": 0.802244,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9c2062cb743e7a7e5b06356a056dd19",
		  
		  "name": "James",
		  "createdDate": "2015-11-11 03:33:55",
		  "totalOrganizations": 30,
		  "totalTours": 39,
		  "totalDays": 805,
		  "totalCountries": 18,
		  "totalStates": 77,
		  "totalEvents": 374,
		  "eventPercent": 0.951609,
		  "totalScheduleItems": 5139,
		  "schedulePercent": 0.958636,
		  "totalGuests": 3009,
		  "guestPercent": 0.981981,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Metropolis",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9d14a81293ac104c47f71584065614f",
		  
		  "name": "Thomas",
		  "createdDate": "2016-01-26 15:47:39",
		  "totalOrganizations": 13,
		  "totalTours": 8,
		  "totalDays": 78,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 476,
		  "schedulePercent": 0.300884,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9d17613988084139d0f06639bacdd3d",
		  
		  "name": "Mike",
		  "createdDate": "2010-10-01 21:23:48",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 119,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 408,
		  "schedulePercent": 0.272892,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "McMenamins Crystal Ballroom",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9d99db4a680a0b894d117a012111dd7",
		  
		  "name": "Christopher",
		  "createdDate": "2014-07-22 21:09:27",
		  "totalOrganizations": 30,
		  "totalTours": 21,
		  "totalDays": 1045,
		  "totalCountries": 19,
		  "totalStates": 60,
		  "totalEvents": 315,
		  "eventPercent": 0.922484,
		  "totalScheduleItems": 5315,
		  "schedulePercent": 0.962829,
		  "totalGuests": 2081,
		  "guestPercent": 0.952969,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Freo.Social",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9dc637dd5399d075f95bce4f33186b5",
		  
		  "name": "Isaac",
		  "createdDate": "2025-03-24 18:20:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Brighton Music Hall",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9dceb7b44f4884a08dad8bab29acf8f",
		  
		  "name": "James ",
		  "createdDate": "2012-02-20 20:41:27",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 608,
		  "totalCountries": 37,
		  "totalStates": 77,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1708,
		  "schedulePercent": 0.660131,
		  "totalGuests": 123,
		  "guestPercent": 0.539211,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "masive music club",
		  "mostGuestCity": "bratislava",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9eae268262f2e6777546671d969a005",
		  
		  "name": "Thomas",
		  "createdDate": "2022-05-27 00:11:21",
		  "totalOrganizations": 15,
		  "totalTours": 19,
		  "totalDays": 669,
		  "totalCountries": 24,
		  "totalStates": 75,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 2869,
		  "schedulePercent": 0.829329,
		  "totalGuests": 416,
		  "guestPercent": 0.699909,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Cannery Ballroom",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9f3322b9e2b98948521c94b56302428",
		  
		  "name": "Kenny",
		  "createdDate": "2015-06-15 16:04:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 392,
		  "schedulePercent": 0.265866,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9f36b3ca70017c60ec48c8b77732f48",
		  
		  "name": "Elise",
		  "createdDate": "2024-03-31 20:00:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 264,
		  "schedulePercent": 0.196396,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "The Foundry",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9f7714c9dba41735edf298a73f8b047",
		  
		  "name": "",
		  "createdDate": "2024-02-17 11:39:23",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 98,
		  "totalCountries": 14,
		  "totalStates": 18,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 311,
		  "schedulePercent": 0.222801,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-10-06 00:00:00",
		  "mostGuestName": "Huxleys Neue Welt",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9f8adda513fcdc21c67172e486b8bee",
		  
		  "name": "Stefan",
		  "createdDate": "2018-12-12 08:09:57",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 296,
		  "totalCountries": 7,
		  "totalStates": 18,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 1568,
		  "schedulePercent": 0.634406,
		  "totalGuests": 62,
		  "guestPercent": 0.473368,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Circus Krone",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "a9fdb8c559d1266cff9cd328ce620713",
		  
		  "name": "Lee",
		  "createdDate": "2019-12-06 23:35:42",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 466,
		  "totalCountries": 21,
		  "totalStates": 53,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 2861,
		  "schedulePercent": 0.828649,
		  "totalGuests": 1253,
		  "guestPercent": 0.880553,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa1735b3dc7dcee1cfd61b08a6f21349",
		  
		  "name": "Jordan",
		  "createdDate": "2015-02-10 17:35:20",
		  "totalOrganizations": 18,
		  "totalTours": 9,
		  "totalDays": 1388,
		  "totalCountries": 9,
		  "totalStates": 61,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 6393,
		  "schedulePercent": 0.980394,
		  "totalGuests": 1626,
		  "guestPercent": 0.922144,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 177,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa1a844d0dad0ccb4a97c0a43fe76606",
		  
		  "name": "Pierre Alexandre",
		  "createdDate": "2014-06-04 11:36:47",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 236,
		  "totalCountries": 23,
		  "totalStates": 44,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1590,
		  "schedulePercent": 0.638373,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa1facc168551e66a5dc1f4fe483df2a",
		  
		  "name": "Lucie",
		  "createdDate": "2022-01-07 19:16:36",
		  "totalOrganizations": 41,
		  "totalTours": 15,
		  "totalDays": 487,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 457,
		  "eventPercent": 0.972348,
		  "totalScheduleItems": 2043,
		  "schedulePercent": 0.721781,
		  "totalGuests": 3584,
		  "guestPercent": 0.990594,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 391,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa2a88d15cf59a280d825a784a9e958e",
		  
		  "name": "Abi",
		  "createdDate": "2024-06-21 19:53:27",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 884,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 670,
		  "eventPercent": 0.990367,
		  "totalScheduleItems": 1861,
		  "schedulePercent": 0.687103,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa4c605cb85a512244d2439b7b39da0b",
		  
		  "name": "Costanza",
		  "createdDate": "2022-01-05 18:45:03",
		  "totalOrganizations": 9,
		  "totalTours": 26,
		  "totalDays": 707,
		  "totalCountries": 34,
		  "totalStates": 79,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 3828,
		  "schedulePercent": 0.904352,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa57c2a5f6d1abba93d69543cf9b24c5",
		  
		  "name": "Gail",
		  "createdDate": "2019-09-28 04:26:37",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 137,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 911,
		  "schedulePercent": 0.462149,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa63a7e5fde4d16ef05312458542d75f",
		  
		  "name": "Tim",
		  "createdDate": "2025-03-18 19:10:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 35,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 374,
		  "schedulePercent": 0.2551,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa72860d4a791fa334f3cf9b9e4d96a0",
		  
		  "name": "Allen",
		  "createdDate": "2017-08-01 06:24:58",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 213,
		  "totalCountries": 36,
		  "totalStates": 71,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1135,
		  "schedulePercent": 0.529805,
		  "totalGuests": 248,
		  "guestPercent": 0.624207,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa7aee1b96447da395f07cf8400745fa",
		  
		  "name": "Philip",
		  "createdDate": "2025-07-22 18:06:56",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 111,
		  "totalCountries": 6,
		  "totalStates": 24,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 910,
		  "schedulePercent": 0.461695,
		  "totalGuests": 1076,
		  "guestPercent": 0.860154,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "Gas South Arena",
		  "mostGuestCity": "Duluth",
		  "mostGuestAmount": 150,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa84ddcc619705d2c2ce24a77b886ba4",
		  
		  "name": "James",
		  "createdDate": "2022-05-19 16:10:19",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 163,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 575,
		  "schedulePercent": 0.341455,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa8638fc51056981fd919ccc942aa4ad",
		  
		  "name": "Justine",
		  "createdDate": "2025-06-11 13:18:55",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 172,
		  "totalCountries": 9,
		  "totalStates": 2,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 185,
		  "schedulePercent": 0.150725,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Oran Mor",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa8a7c6aa68e95b3c70bd8670de31f7e",
		  
		  "name": "Georgios",
		  "createdDate": "2019-08-28 06:40:46",
		  "totalOrganizations": 83,
		  "totalTours": 44,
		  "totalDays": 976,
		  "totalCountries": 31,
		  "totalStates": 66,
		  "totalEvents": 623,
		  "eventPercent": 0.989007,
		  "totalScheduleItems": 5496,
		  "schedulePercent": 0.967475,
		  "totalGuests": 1895,
		  "guestPercent": 0.939823,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa8ba730aadb86ca2c5e0e0135fc0e79",
		  
		  "name": "Matt",
		  "createdDate": "2019-07-12 15:09:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 178,
		  "totalCountries": 18,
		  "totalStates": 34,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aa99048d5c500b85d0f19b92bc9280ed",
		  
		  "name": "Chris",
		  "createdDate": "2024-05-17 16:55:57",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 225,
		  "schedulePercent": 0.174524,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aaa3a05db7cde7c9ad153725b0d41b23",
		  
		  "name": "Christina",
		  "createdDate": "2021-10-08 12:01:11",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 1000,
		  "totalCountries": 18,
		  "totalStates": 64,
		  "totalEvents": 286,
		  "eventPercent": 0.902765,
		  "totalScheduleItems": 4866,
		  "schedulePercent": 0.950363,
		  "totalGuests": 2676,
		  "guestPercent": 0.974955,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aaab0b0a5aa739e0c19c6eec79f4c82f",
		  
		  "name": "Alicia",
		  "createdDate": "2011-07-27 04:57:33",
		  "totalOrganizations": 31,
		  "totalTours": 38,
		  "totalDays": 995,
		  "totalCountries": 24,
		  "totalStates": 81,
		  "totalEvents": 406,
		  "eventPercent": 0.960335,
		  "totalScheduleItems": 4689,
		  "schedulePercent": 0.943563,
		  "totalGuests": 2062,
		  "guestPercent": 0.951609,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aaab32cbf1fd2c86d1bdecd74090c82f",
		  
		  "name": "Janelle",
		  "createdDate": "2019-04-04 15:06:53",
		  "totalOrganizations": 23,
		  "totalTours": 17,
		  "totalDays": 216,
		  "totalCountries": 20,
		  "totalStates": 26,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 932,
		  "schedulePercent": 0.470082,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "FNB Stadium",
		  "mostGuestCity": "Johannesburg",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aaac6fbac7060a158ee84695a1c7c0b5",
		  
		  "name": "Gabriele",
		  "createdDate": "2011-06-07 21:50:17",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 915,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 1000,
		  "schedulePercent": 0.490141,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aab5be5f862d759f5b4ff166ae3c3215",
		  
		  "name": "Javier",
		  "createdDate": "2023-01-10 16:40:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 304,
		  "totalCountries": 9,
		  "totalStates": 9,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 453,
		  "schedulePercent": 0.291931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aac15f5377ddb8db70668b6c6b8497bf",
		  
		  "name": "Jonathan",
		  "createdDate": "2018-07-03 21:21:34",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 308,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2288,
		  "schedulePercent": 0.760086,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aac93e4aca79503eb85e66495432e348",
		  
		  "name": "Joseph",
		  "createdDate": "2016-07-19 12:13:16",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 224,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1558,
		  "schedulePercent": 0.632026,
		  "totalGuests": 211,
		  "guestPercent": 0.603128,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "Hopewell",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aacabecd8154bc5ae0c51017c6be1c62",
		  
		  "name": "Jonas",
		  "createdDate": "2014-10-27 05:05:10",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 495,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 2052,
		  "schedulePercent": 0.723708,
		  "totalGuests": 1254,
		  "guestPercent": 0.88078,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Nissan Stadium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 195,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aacf7489538be606d1e1ab9f5fd3a7ba",
		  
		  "name": "Matt",
		  "createdDate": "2018-10-23 05:51:51",
		  "totalOrganizations": 15,
		  "totalTours": 21,
		  "totalDays": 218,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 385,
		  "schedulePercent": 0.260993,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aad64ca1ff143a1d4aefa836d5051d9b",
		  
		  "name": "Quentin",
		  "createdDate": "2023-07-17 22:37:11",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 369,
		  "totalCountries": 22,
		  "totalStates": 26,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 636,
		  "schedulePercent": 0.363101,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aaf22f4ad923666ec801674f95e2ce5e",
		  
		  "name": "Dean",
		  "createdDate": "2018-06-26 06:45:51",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 590,
		  "totalCountries": 16,
		  "totalStates": 29,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1149,
		  "schedulePercent": 0.534338,
		  "totalGuests": 145,
		  "guestPercent": 0.555077,
		  "mostGuestDate": "2025-02-23 00:00:00",
		  "mostGuestName": "Annexet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab0a75508d45da43ba0ed7f3c9cd735a",
		  
		  "name": "Brad",
		  "createdDate": "2025-06-04 21:19:35",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 267,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 916,
		  "schedulePercent": 0.463735,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab0c200f4135f82fedeefe471e7dd131",
		  
		  "name": "Kendall",
		  "createdDate": "2025-10-08 18:57:06",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 233,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab1cbb4995aeac4337c51c432005cb6c",
		  
		  "name": "Shawn",
		  "createdDate": "2024-12-19 19:27:37",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 481,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 279,
		  "eventPercent": 0.897439,
		  "totalScheduleItems": 2583,
		  "schedulePercent": 0.796011,
		  "totalGuests": 1962,
		  "guestPercent": 0.944356,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Palace Theater",
		  "mostGuestCity": "Waterbury",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab24c4a1560e4d66bfc1c2ba8c872217",
		  
		  "name": "Ilaria",
		  "createdDate": "2024-05-23 08:45:52",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 103,
		  "totalCountries": 11,
		  "totalStates": 19,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 333,
		  "schedulePercent": 0.233454,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab24db26ec626ed719ecc30564788c54",
		  
		  "name": "Jess",
		  "createdDate": "2022-06-05 10:01:28",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 175,
		  "totalCountries": 16,
		  "totalStates": 17,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 900,
		  "schedulePercent": 0.458409,
		  "totalGuests": 810,
		  "guestPercent": 0.81063,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Turbinenhalle",
		  "mostGuestCity": "Oberhausen",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab25c9edd723430501d928cfadef43f2",
		  
		  "name": "Jeremy",
		  "createdDate": "2022-02-14 15:47:45",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 33,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 330,
		  "schedulePercent": 0.230961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab29471ddb356863d2b414ce5d2c21fb",
		  
		  "name": "Dan",
		  "createdDate": "2015-01-07 17:19:05",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 136,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 338,
		  "schedulePercent": 0.236967,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stand Comedy Club Newcastle",
		  "mostGuestCity": "Newcastle upon Tyne",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab3116aeb2f7ab4f059cc6e3c7744d7a",
		  
		  "name": "Dion",
		  "createdDate": "2020-01-20 14:22:19",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 108,
		  "totalCountries": 10,
		  "totalStates": 35,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 517,
		  "schedulePercent": 0.32015,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab346a3052f89207410006ec11283ae2",
		  
		  "name": "JÃ¸rn",
		  "createdDate": "2022-12-18 11:02:15",
		  "totalOrganizations": 22,
		  "totalTours": 19,
		  "totalDays": 450,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 432,
		  "eventPercent": 0.966908,
		  "totalScheduleItems": 2057,
		  "schedulePercent": 0.725181,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab42219e6df20200f3a5e9f689e88f02",
		  
		  "name": "Sydney",
		  "createdDate": "2024-06-03 22:13:46",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 258,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 806,
		  "schedulePercent": 0.424751,
		  "totalGuests": 436,
		  "guestPercent": 0.707842,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab4299ddd40d8a4aa64da9e18d27b60a",
		  
		  "name": "MARK",
		  "createdDate": "2025-06-16 00:04:07",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 294,
		  "totalCountries": 16,
		  "totalStates": 27,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1305,
		  "schedulePercent": 0.572756,
		  "totalGuests": 541,
		  "guestPercent": 0.741047,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab45be28926315c2a94ecf9728111af2",
		  
		  "name": "Woodrow",
		  "createdDate": "2015-01-24 16:04:50",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 367,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 719,
		  "schedulePercent": 0.393586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab57ba94636aa7484dc63fd2a8e547d7",
		  
		  "name": "Scott",
		  "createdDate": "2023-07-13 16:30:32",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 96,
		  "totalCountries": 11,
		  "totalStates": 37,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 402,
		  "schedulePercent": 0.270739,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab5d7e9f87ac65425c7b06f80f455fc9",
		  
		  "name": "Dana",
		  "createdDate": "2017-01-14 01:32:24",
		  "totalOrganizations": 1,
		  "totalTours": 72,
		  "totalDays": 202,
		  "totalCountries": 11,
		  "totalStates": 31,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1026,
		  "schedulePercent": 0.498073,
		  "totalGuests": 168,
		  "guestPercent": 0.572303,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "City Winery",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab61e1fb91520bd269436a271128350d",
		  
		  "name": "Gez",
		  "createdDate": "2013-11-11 14:05:13",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 935,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2178,
		  "schedulePercent": 0.744787,
		  "totalGuests": 209,
		  "guestPercent": 0.601201,
		  "mostGuestDate": "2025-01-26 00:00:00",
		  "mostGuestName": "Regent Theatre ",
		  "mostGuestCity": "Ipswich",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab63389da215c8441249be356c2131ff",
		  
		  "name": "Ali",
		  "createdDate": "2019-04-23 11:50:27",
		  "totalOrganizations": 10,
		  "totalTours": 16,
		  "totalDays": 601,
		  "totalCountries": 27,
		  "totalStates": 72,
		  "totalEvents": 246,
		  "eventPercent": 0.866954,
		  "totalScheduleItems": 3586,
		  "schedulePercent": 0.888146,
		  "totalGuests": 887,
		  "guestPercent": 0.827176,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Rooftop at Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab76a70aa29c9fa58c2bf8be9cddaf75",
		  
		  "name": "Anders",
		  "createdDate": "2014-03-14 20:43:43",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 488,
		  "totalCountries": 19,
		  "totalStates": 44,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 3984,
		  "schedulePercent": 0.912171,
		  "totalGuests": 237,
		  "guestPercent": 0.617294,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Chicago Theatre",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab7888ca05b61e8139889a7a1cddfcdb",
		  
		  "name": "Oeyvind",
		  "createdDate": "2021-08-16 07:55:52",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 187,
		  "totalCountries": 21,
		  "totalStates": 16,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 1311,
		  "schedulePercent": 0.574343,
		  "totalGuests": 303,
		  "guestPercent": 0.651519,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Arena 8888 Sofia",
		  "mostGuestCity": "Sofia",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab8684ce96bb3c2e67563a3d009373a6",
		  
		  "name": "Angel",
		  "createdDate": "2023-06-05 20:48:50",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 739,
		  "totalCountries": 38,
		  "totalStates": 87,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 3091,
		  "schedulePercent": 0.850861,
		  "totalGuests": 535,
		  "guestPercent": 0.738894,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ab906435aaa87424134bb49deefe3861",
		  
		  "name": "Sarah",
		  "createdDate": "2021-08-24 07:43:45",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 391,
		  "totalCountries": 26,
		  "totalStates": 48,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 2971,
		  "schedulePercent": 0.839642,
		  "totalGuests": 1718,
		  "guestPercent": 0.928944,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "MGM Music Hall at Fenway",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abaf892dc4ea465d74da34241957c574",
		  
		  "name": "Cameron",
		  "createdDate": "2016-10-11 16:04:45",
		  "totalOrganizations": 4,
		  "totalTours": 14,
		  "totalDays": 305,
		  "totalCountries": 11,
		  "totalStates": 50,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1779,
		  "schedulePercent": 0.672371,
		  "totalGuests": 348,
		  "guestPercent": 0.674184,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abafe85ac14a2d8ace7ab442655b5a26",
		  
		  "name": "Janik",
		  "createdDate": "2022-05-10 18:02:53",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 282,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1080,
		  "schedulePercent": 0.514279,
		  "totalGuests": 284,
		  "guestPercent": 0.641206,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Place des Festivals â€“ ScÃ¨ne Bell",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abb3aa943f3e13b7f1d4af132d14be27",
		  
		  "name": "Joe",
		  "createdDate": "2016-11-04 00:38:13",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 653,
		  "totalCountries": 25,
		  "totalStates": 59,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2232,
		  "schedulePercent": 0.75306,
		  "totalGuests": 1087,
		  "guestPercent": 0.861514,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Colosseum Theater at Caesars Palace",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abb91ba5bb1b6b17dffcc45e2d972e31",
		  
		  "name": "Jacinta",
		  "createdDate": "2024-01-31 15:02:57",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 48,
		  "totalCountries": 10,
		  "totalStates": 11,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abbe35054ad6fc1d4681926b015eddd4",
		  
		  "name": "Christina",
		  "createdDate": "2017-08-28 21:07:27",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 566,
		  "totalCountries": 7,
		  "totalStates": 40,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 2152,
		  "schedulePercent": 0.740254,
		  "totalGuests": 2316,
		  "guestPercent": 0.963055,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abcdf9fa8febc4f3c11634ff82a43464",
		  
		  "name": "Lisa",
		  "createdDate": "2022-03-09 16:45:50",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 290,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 433,
		  "schedulePercent": 0.282978,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abd4cd7ed207231d9da1fd8e68c34b54",
		  
		  "name": "Maxime",
		  "createdDate": "2022-05-25 01:29:45",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 253,
		  "totalCountries": 14,
		  "totalStates": 38,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 506,
		  "schedulePercent": 0.31403,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "FÃªte de l'humanitÃ©",
		  "mostGuestCity": "Bretigny sur orge",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abd804f7c6b9e9fa722da5b3a22adcad",
		  
		  "name": "Jared",
		  "createdDate": "2019-06-20 04:13:19",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 485,
		  "schedulePercent": 0.30383,
		  "totalGuests": 413,
		  "guestPercent": 0.698663,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Intuit Dome",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abdc518bc0505894fc87f42bbf8a1d15",
		  
		  "name": "Jason",
		  "createdDate": "2020-02-13 16:06:04",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 403,
		  "totalCountries": 15,
		  "totalStates": 50,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1578,
		  "schedulePercent": 0.636219,
		  "totalGuests": 787,
		  "guestPercent": 0.805304,
		  "mostGuestDate": "2025-05-11 00:00:00",
		  "mostGuestName": "",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abe449e3174483c54343317deaf56629",
		  
		  "name": "Mathew",
		  "createdDate": "2024-07-30 18:51:45",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 170,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 1388,
		  "schedulePercent": 0.594402,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abe63d9fb9b1bc0ffb7125bfba9aa1e7",
		  
		  "name": "Ben",
		  "createdDate": "2017-08-19 19:28:28",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 221,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 974,
		  "schedulePercent": 0.482434,
		  "totalGuests": 193,
		  "guestPercent": 0.588169,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Immersive Media Performing Arts Center (iMPAC)",
		  "mostGuestCity": "Gulfport",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abe94e45dce392be8bf7ec2bc18f4550",
		  
		  "name": "Hey",
		  "createdDate": "2025-01-28 00:47:47",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 160,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 500,
		  "schedulePercent": 0.31199,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-02-24 00:00:00",
		  "mostGuestName": "Herald Theatre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abf2a82ad9180f48c4765aebf5a65c32",
		  
		  "name": "Bobby",
		  "createdDate": "2019-01-25 20:10:22",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 108,
		  "schedulePercent": 0.103921,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abfc602708eafea5cdf1df76b080b242",
		  
		  "name": "Dan ",
		  "createdDate": "2016-04-27 18:47:56",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 151,
		  "totalCountries": 25,
		  "totalStates": 51,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 803,
		  "schedulePercent": 0.423617,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "The Mohawk",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "abfdd093576925acbbdbf18e9e2f2119",
		  
		  "name": "Neea",
		  "createdDate": "2023-05-10 12:58:32",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 106,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 505,
		  "schedulePercent": 0.31369,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac05721f02f27f1fef7810f9b9814839",
		  
		  "name": "Jez",
		  "createdDate": "2009-11-23 23:26:31",
		  "totalOrganizations": 21,
		  "totalTours": 8,
		  "totalDays": 267,
		  "totalCountries": 14,
		  "totalStates": 22,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 843,
		  "schedulePercent": 0.438237,
		  "totalGuests": 566,
		  "guestPercent": 0.74796,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac069835730bea58ead3fedce64e0664",
		  
		  "name": "Chris",
		  "a_nickname": "\"Hey You\" ",
		  "createdDate": "2019-10-29 22:57:44",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 670,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 331,
		  "schedulePercent": 0.231754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac0c6ed7c1c52b8572414a262466d042",
		  
		  "name": "Jasper",
		  "createdDate": "2025-03-06 02:08:52",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 176,
		  "schedulePercent": 0.143699,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac15993396352ae42c2ef4c82ba4e36b",
		  
		  "name": "Chris",
		  "createdDate": "2018-09-25 04:17:33",
		  "totalOrganizations": 15,
		  "totalTours": 17,
		  "totalDays": 613,
		  "totalCountries": 15,
		  "totalStates": 57,
		  "totalEvents": 240,
		  "eventPercent": 0.861854,
		  "totalScheduleItems": 3337,
		  "schedulePercent": 0.869787,
		  "totalGuests": 1137,
		  "guestPercent": 0.870014,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac2039d5ca473dbe5002cc61a1cc7bb3",
		  
		  "name": "Yaw",
		  "createdDate": "2022-05-30 22:32:41",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac3a05317877e280d789701188d98f73",
		  
		  "name": "Matthew",
		  "createdDate": "2025-07-13 03:49:25",
		  "totalOrganizations": 1,
		  "totalTours": 23,
		  "totalDays": 51,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 327,
		  "schedulePercent": 0.230054,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Wonderland",
		  "mostGuestCity": "Bloomington",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac3a4405adec4810e1e9d5624e1c57d3",
		  
		  "name": "Spencer",
		  "createdDate": "2014-11-17 18:29:59",
		  "totalOrganizations": 14,
		  "totalTours": 16,
		  "totalDays": 1042,
		  "totalCountries": 27,
		  "totalStates": 43,
		  "totalEvents": 358,
		  "eventPercent": 0.945376,
		  "totalScheduleItems": 3469,
		  "schedulePercent": 0.880553,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac5520ef78b90be2e12fbfe6f8cd9623",
		  
		  "name": "Oscar",
		  "createdDate": "2025-07-18 10:21:41",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 68,
		  "totalCountries": 12,
		  "totalStates": 27,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 753,
		  "schedulePercent": 0.406505,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-08-20 00:00:00",
		  "mostGuestName": "Marquis Theater",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac57dbae2fe1d5b210aba95cd46c37c7",
		  
		  "name": "Bridger",
		  "createdDate": "2023-03-15 15:59:07",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 869,
		  "totalCountries": 17,
		  "totalStates": 71,
		  "totalEvents": 315,
		  "eventPercent": 0.922484,
		  "totalScheduleItems": 2664,
		  "schedulePercent": 0.804057,
		  "totalGuests": 454,
		  "guestPercent": 0.714302,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "The Fillmore Silver Spring",
		  "mostGuestCity": "Silver Spring",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac5fc0caa9f66cbf9419ceca67876088",
		  
		  "name": "Jane",
		  "createdDate": "2024-10-24 18:21:37",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 381,
		  "totalCountries": 9,
		  "totalStates": 10,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 2469,
		  "schedulePercent": 0.783658,
		  "totalGuests": 628,
		  "guestPercent": 0.764733,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac706172db5d8f6c8bcab9b6bf9e8f75",
		  
		  "name": "Marlo",
		  "createdDate": "2021-12-07 22:38:34",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 576,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 1329,
		  "schedulePercent": 0.579442,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac713c5d44bf924290c647320a140f9b",
		  
		  "name": "Henrik ",
		  "createdDate": "2023-03-06 12:17:55",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 101,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 582,
		  "schedulePercent": 0.344515,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac71887226da139e4068b32f42dddc4e",
		  
		  "name": "RachÃªl",
		  "createdDate": "2019-05-21 22:54:46",
		  "totalOrganizations": 15,
		  "totalTours": 5,
		  "totalDays": 54,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 181,
		  "schedulePercent": 0.147212,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac7cbd6ea59ae20bc76b86bb3ca53f7b",
		  
		  "name": "Daniel",
		  "createdDate": "2015-09-24 15:26:49",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 545,
		  "totalCountries": 24,
		  "totalStates": 27,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 685,
		  "schedulePercent": 0.381006,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac847b07f362c96a929422dfe825cd87",
		  
		  "name": "Ty",
		  "createdDate": "2024-05-27 02:05:25",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 490,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 699,
		  "schedulePercent": 0.386333,
		  "totalGuests": 260,
		  "guestPercent": 0.629873,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Fillmore Charlotte",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac8b54e7e7a896aca47a6f4f2f83783a",
		  
		  "name": "Asha",
		  "createdDate": "2022-04-05 01:40:47",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 52,
		  "totalCountries": 13,
		  "totalStates": 16,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 315,
		  "schedulePercent": 0.224841,
		  "totalGuests": 140,
		  "guestPercent": 0.552357,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac8bfcdfd49390f023b974f977491986",
		  
		  "name": "Christopher",
		  "createdDate": "2022-02-14 08:57:14",
		  "totalOrganizations": 10,
		  "totalTours": 26,
		  "totalDays": 342,
		  "totalCountries": 34,
		  "totalStates": 48,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2082,
		  "schedulePercent": 0.729488,
		  "totalGuests": 137,
		  "guestPercent": 0.550204,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac964050ab72dbc5ea307c3256f7100c",
		  
		  "name": "Stijn",
		  "createdDate": "2022-04-11 13:33:05",
		  "totalOrganizations": 14,
		  "totalTours": 19,
		  "totalDays": 780,
		  "totalCountries": 29,
		  "totalStates": 95,
		  "totalEvents": 287,
		  "eventPercent": 0.903672,
		  "totalScheduleItems": 2192,
		  "schedulePercent": 0.746827,
		  "totalGuests": 794,
		  "guestPercent": 0.806437,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Powerstation",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ac9f65b3720fb330eb95d9a51826e7a5",
		  
		  "name": "Jose",
		  "createdDate": "2019-05-16 23:10:26",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 402,
		  "totalCountries": 24,
		  "totalStates": 37,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1427,
		  "schedulePercent": 0.604261,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Sant Jordi Club",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "acb1d010522d2ec294099d24ffb4a486",
		  
		  "name": "Hanna",
		  "createdDate": "2022-08-16 09:38:34",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 427,
		  "totalCountries": 29,
		  "totalStates": 93,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 3464,
		  "schedulePercent": 0.880213,
		  "totalGuests": 1904,
		  "guestPercent": 0.94005,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Tempodrom",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "acb269608b35b9b8830463b68e735e5d",
		  
		  "name": "Email",
		  "createdDate": "2016-03-28 15:06:05",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 43,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 294,
		  "schedulePercent": 0.214415,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Nelson Ledges Quarry Park",
		  "mostGuestCity": "Garrettsville",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "acbb737cd179a9910817bd02cb0ca255",
		  
		  "name": "Seth",
		  "createdDate": "2025-01-13 19:20:05",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 360,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 781,
		  "schedulePercent": 0.416251,
		  "totalGuests": 256,
		  "guestPercent": 0.62806,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "House of Blues Dallas",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "acc73f73382f09215cb63c05ee586a7c",
		  
		  "name": "Yura",
		  "createdDate": "2022-01-27 04:54:07",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 101,
		  "totalCountries": 16,
		  "totalStates": 19,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 234,
		  "schedulePercent": 0.18053,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Racket NYC",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "acc8255938022c48ccd29b853020a324",
		  
		  "name": "Tomas",
		  "createdDate": "2013-10-14 12:05:54",
		  "totalOrganizations": 20,
		  "totalTours": 32,
		  "totalDays": 493,
		  "totalCountries": 27,
		  "totalStates": 74,
		  "totalEvents": 242,
		  "eventPercent": 0.863667,
		  "totalScheduleItems": 3401,
		  "schedulePercent": 0.87534,
		  "totalGuests": 1447,
		  "guestPercent": 0.904352,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "BRIC",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "accc2dd1c925bccb3e77074f2d1cb905",
		  
		  "name": "Kajsa",
		  "createdDate": "2025-01-27 09:55:07",
		  "totalOrganizations": 20,
		  "totalTours": 19,
		  "totalDays": 296,
		  "totalCountries": 7,
		  "totalStates": 23,
		  "totalEvents": 271,
		  "eventPercent": 0.891092,
		  "totalScheduleItems": 1694,
		  "schedulePercent": 0.657525,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Studenternas Arena",
		  "mostGuestCity": "Uppsala",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "acd3c2778c6b1c5de288c17c9039eaae",
		  
		  "name": "Parker",
		  "createdDate": "2020-01-07 23:39:49",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 1030,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 281,
		  "eventPercent": 0.898912,
		  "totalScheduleItems": 3421,
		  "schedulePercent": 0.877153,
		  "totalGuests": 2589,
		  "guestPercent": 0.971555,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 203,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "acf84165ceb51a0a21dda843b69b5165",
		  
		  "name": "Bex",
		  "createdDate": "2015-07-28 18:40:23",
		  "totalOrganizations": 14,
		  "totalTours": 25,
		  "totalDays": 515,
		  "totalCountries": 25,
		  "totalStates": 54,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 3657,
		  "schedulePercent": 0.893132,
		  "totalGuests": 1634,
		  "guestPercent": 0.922711,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad01a839dadda5b3cf564f2bd6c80e19",
		  
		  "name": "Tour",
		  "createdDate": "2016-10-10 13:21:46",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 534,
		  "schedulePercent": 0.328762,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad0fd0551cbb7933b8e47afa3cf7ac21",
		  
		  "name": "Morgan",
		  "createdDate": "2022-01-17 20:28:07",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 567,
		  "totalCountries": 19,
		  "totalStates": 48,
		  "totalEvents": 248,
		  "eventPercent": 0.868654,
		  "totalScheduleItems": 2266,
		  "schedulePercent": 0.757593,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad1917bc5e3c63826c92414f0bf24783",
		  
		  "name": "Fredrik",
		  "createdDate": "2013-11-08 17:16:49",
		  "totalOrganizations": 13,
		  "totalTours": 3,
		  "totalDays": 193,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 247,
		  "schedulePercent": 0.18835,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "Burgsvik GrÃ¥ GÃ¥sen",
		  "mostGuestCity": "Burgsvik",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad1b12697a768de58abc97c5ee6f16ec",
		  
		  "name": "Thando",
		  "createdDate": "2022-04-22 10:05:54",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 66,
		  "totalCountries": 7,
		  "totalStates": 14,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 250,
		  "schedulePercent": 0.189937,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad28bd3387a83c65c5269b8190ce23d9",
		  
		  "name": "Boris",
		  "createdDate": "2017-10-30 13:37:29",
		  "totalOrganizations": 20,
		  "totalTours": 21,
		  "totalDays": 1341,
		  "totalCountries": 20,
		  "totalStates": 81,
		  "totalEvents": 325,
		  "eventPercent": 0.93053,
		  "totalScheduleItems": 4102,
		  "schedulePercent": 0.918858,
		  "totalGuests": 1594,
		  "guestPercent": 0.918971,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad28d606c3ef0ffdd2887475d0493402",
		  
		  "name": "Lauren",
		  "createdDate": "2021-11-05 19:05:41",
		  "totalOrganizations": 5,
		  "totalTours": 24,
		  "totalDays": 144,
		  "totalCountries": 23,
		  "totalStates": 32,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 899,
		  "schedulePercent": 0.457842,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad422d0967fdcb42a2afb4afd4212129",
		  
		  "name": "Conor",
		  "createdDate": "2023-10-31 23:46:46",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 168,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1413,
		  "schedulePercent": 0.600748,
		  "totalGuests": 1003,
		  "guestPercent": 0.846668,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "The Roxy",
		  "mostGuestCity": "Lakewood",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad46039606445a0d23a6809e4feee37b",
		  
		  "name": "Misty",
		  "createdDate": "2025-02-23 13:34:50",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 235,
		  "totalCountries": 14,
		  "totalStates": 9,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 495,
		  "schedulePercent": 0.310177,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad4a1487403e7201d763ecbbfef39605",
		  
		  "name": "Danielle",
		  "createdDate": "2024-04-23 20:05:03",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 726,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 162,
		  "schedulePercent": 0.136786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad4fcd74ac4118b428338d96f498a633",
		  
		  "name": "Doug",
		  "createdDate": "2017-01-13 15:13:44",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 728,
		  "schedulePercent": 0.397439,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad551c006477bf4d40ad24b3c01b9e73",
		  
		  "name": "Gareth Ed",
		  "createdDate": "2015-01-20 01:56:21",
		  "totalOrganizations": 64,
		  "totalTours": 19,
		  "totalDays": 373,
		  "totalCountries": 15,
		  "totalStates": 24,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1006,
		  "schedulePercent": 0.49184,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad5790438cbfdcebe263697c318c5bc6",
		  
		  "name": "Steven",
		  "createdDate": "2024-08-26 15:52:09",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 180,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 947,
		  "schedulePercent": 0.474388,
		  "totalGuests": 193,
		  "guestPercent": 0.588169,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad67acd2703e09bc4d904a0acae3c42c",
		  
		  "name": "Drew",
		  "createdDate": "2023-08-13 18:08:28",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 81,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 738,
		  "schedulePercent": 0.400952,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad69f7f672f7538910f2382fc9038022",
		  
		  "name": "Sam",
		  "createdDate": "2013-06-04 07:42:12",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 199,
		  "totalCountries": 12,
		  "totalStates": 33,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 984,
		  "schedulePercent": 0.486401,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad6a8d8ecdae0be78984ab37f9b3e1f3",
		  
		  "name": "Tristan",
		  "createdDate": "2018-08-14 22:19:39",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 528,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 3152,
		  "schedulePercent": 0.855621,
		  "totalGuests": 593,
		  "guestPercent": 0.75612,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Yuengling Center",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad6c1c59418133416090a0c4782d0e86",
		  
		  "name": "Kei",
		  "createdDate": "2023-03-22 20:40:12",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 93,
		  "totalCountries": 10,
		  "totalStates": 22,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 255,
		  "schedulePercent": 0.19311,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-11-20 00:00:00",
		  "mostGuestName": "St. Pancras Old Church",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad6ca8081c8308e5fc6eee938e1fd42d",
		  
		  "name": "Natasha",
		  "createdDate": "2021-12-10 20:34:44",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 164,
		  "totalCountries": 19,
		  "totalStates": 49,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1035,
		  "schedulePercent": 0.500227,
		  "totalGuests": 498,
		  "guestPercent": 0.729828,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "OVO Arena, Wembley",
		  "mostGuestCity": "Wembley",
		  "mostGuestAmount": 128,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad9a1d7e0ce703bd695fb15004c3b8d5",
		  
		  "name": "Holger",
		  "createdDate": "2022-11-10 22:21:12",
		  "totalOrganizations": 19,
		  "totalTours": 14,
		  "totalDays": 253,
		  "totalCountries": 18,
		  "totalStates": 27,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1528,
		  "schedulePercent": 0.622733,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ad9c0c2f5969399ccf413fa87b2eb57d",
		  
		  "name": "Cara",
		  "createdDate": "2014-03-08 16:42:01",
		  "totalOrganizations": 5,
		  "totalTours": 11,
		  "totalDays": 663,
		  "totalCountries": 23,
		  "totalStates": 27,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 3364,
		  "schedulePercent": 0.872733,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ada40db6dd36b2aaad99bcfd37d98560",
		  
		  "name": "Arachn&#233;e",
		  "createdDate": "2025-05-15 10:16:39",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 806,
		  "schedulePercent": 0.424751,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-12-05 00:00:00",
		  "mostGuestName": "Sud de France Arena",
		  "mostGuestCity": "PÃ©rols",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ada85f6f882656e178dbc10e1ff003f9",
		  
		  "name": "Tyler",
		  "createdDate": "2017-10-04 14:57:05",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 184,
		  "totalCountries": 17,
		  "totalStates": 51,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1034,
		  "schedulePercent": 0.499887,
		  "totalGuests": 762,
		  "guestPercent": 0.798731,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Marquee Theatre",
		  "mostGuestCity": "Tempe",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "adaf052df606f1a39a7704f9f1dfe355",
		  
		  "name": "Ottomatti",
		  "createdDate": "2018-09-18 12:46:10",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 146,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Espoon Viinijuhlat",
		  "mostGuestCity": "Espoo",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "adb7bdda5f9507328a1c12970c653ddc",
		  
		  "name": "Jason",
		  "createdDate": "2025-10-28 04:34:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 64,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 188,
		  "schedulePercent": 0.152085,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "KCRW",
		  "mostGuestCity": "Santa Monica",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "adc2fc978d480a573da233b5c38666e3",
		  
		  "name": "Marcia",
		  "createdDate": "2022-07-24 14:28:09",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 67,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 266,
		  "schedulePercent": 0.197076,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "adc354bdad38102f6645b7b2534b2bf8",
		  
		  "name": "Rachel",
		  "createdDate": "2011-06-15 16:15:52",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 425,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 871,
		  "schedulePercent": 0.448776,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Anita's Theatre Thirroul",
		  "mostGuestCity": "Thirroul",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "adc4fc861da89df96a4009c2cd6479cb",
		  
		  "name": "Ivan",
		  "createdDate": "2014-06-04 10:21:54",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 275,
		  "totalCountries": 14,
		  "totalStates": 10,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 548,
		  "schedulePercent": 0.333522,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "add0bcb41108e987eefbc808178d8963",
		  
		  "name": "Andrew",
		  "createdDate": "2018-03-14 14:22:49",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 734,
		  "totalCountries": 21,
		  "totalStates": 47,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 3413,
		  "schedulePercent": 0.876587,
		  "totalGuests": 2142,
		  "guestPercent": 0.955236,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ade12247a5f0620cbd217d695beecd59",
		  
		  "name": "Danielle",
		  "createdDate": "2015-04-06 19:32:12",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 605,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2364,
		  "schedulePercent": 0.770399,
		  "totalGuests": 352,
		  "guestPercent": 0.675884,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "The Waiting Room Lounge",
		  "mostGuestCity": "Omaha",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae074afd49eb36cccea2c02699f840a8",
		  
		  "name": "Emma",
		  "createdDate": "2025-01-09 09:12:59",
		  "totalOrganizations": 32,
		  "totalTours": 8,
		  "totalDays": 718,
		  "totalCountries": 7,
		  "totalStates": 14,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 1250,
		  "schedulePercent": 0.560743,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "Burgsvik GrÃ¥ GÃ¥sen",
		  "mostGuestCity": "Burgsvik",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae163bb57cd507af208d4a62d2061f4a",
		  
		  "name": "Joel",
		  "createdDate": "2017-06-05 12:39:28",
		  "totalOrganizations": 9,
		  "totalTours": 16,
		  "totalDays": 364,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1624,
		  "schedulePercent": 0.645059,
		  "totalGuests": 1245,
		  "guestPercent": 0.880213,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "UBS Arena",
		  "mostGuestCity": "Elmont",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae227a69c9782f0a39fead0041451ddb",
		  
		  "name": "Rebecca",
		  "createdDate": "2016-11-08 00:19:41",
		  "totalOrganizations": 17,
		  "totalTours": 17,
		  "totalDays": 1837,
		  "totalCountries": 29,
		  "totalStates": 55,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 2638,
		  "schedulePercent": 0.801791,
		  "totalGuests": 201,
		  "guestPercent": 0.595422,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "SunBet Arena at Time Square Casino",
		  "mostGuestCity": "Pretoria",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae31e0a8d701ee5fa7ee4b8040902be6",
		  
		  "name": "Bray ",
		  "createdDate": "2025-05-29 16:57:12",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 674,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 931,
		  "schedulePercent": 0.469402,
		  "totalGuests": 129,
		  "guestPercent": 0.543518,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Central Park SummerStage",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae4339c81ba14abfab2bbff59b859bd0",
		  
		  "name": "Anthony",
		  "createdDate": "2014-06-25 16:44:56",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 209,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 285,
		  "schedulePercent": 0.209542,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae47cc615799abc1faf294527e5c693a",
		  
		  "name": "Emily",
		  "createdDate": "2023-12-09 00:00:55",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 86,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 388,
		  "schedulePercent": 0.263486,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae61d7b395a37f45beaaf63bba5a2961",
		  
		  "name": "Louis",
		  "createdDate": "2022-08-15 11:07:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 263,
		  "totalCountries": 8,
		  "totalStates": 11,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 325,
		  "schedulePercent": 0.229034,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-04-29 00:00:00",
		  "mostGuestName": "La Boule Noire",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae85f7b2ff06c959aa0f73fb5b20b738",
		  
		  "name": "Tyler",
		  "createdDate": "2020-12-04 11:07:05",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 130,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 693,
		  "schedulePercent": 0.383613,
		  "totalGuests": 760,
		  "guestPercent": 0.798277,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ae8dc5e425931666c2912a5121c4b670",
		  
		  "name": "Blair",
		  "createdDate": "2022-03-02 06:05:50",
		  "totalOrganizations": 17,
		  "totalTours": 9,
		  "totalDays": 162,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 893,
		  "schedulePercent": 0.455576,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Twin Towns Services Club",
		  "mostGuestCity": "Tweed Heads",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aea50d2a36dc3c2a23b031c29b64b2bb",
		  
		  "name": "Pat ",
		  "createdDate": "2021-12-17 02:08:21",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 271,
		  "totalCountries": 14,
		  "totalStates": 38,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 710,
		  "schedulePercent": 0.390639,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Veld Music Festival",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aea53ab23b2dfa9b9f6e8584c07d22d8",
		  
		  "name": "Mark",
		  "createdDate": "2016-07-17 08:11:41",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 620,
		  "totalCountries": 17,
		  "totalStates": 18,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 583,
		  "schedulePercent": 0.345308,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-11-16 00:00:00",
		  "mostGuestName": "Wiener Stadthalle",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aea82730aef6de2de1825b8c8790134d",
		  
		  "name": "William",
		  "createdDate": "2018-01-29 23:57:25",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 1099,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 3049,
		  "schedulePercent": 0.847461,
		  "totalGuests": 2593,
		  "guestPercent": 0.971781,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aeb3be0d6be7d173f14930008f1d118c",
		  
		  "name": "Michael",
		  "createdDate": "2021-07-26 14:48:54",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 373,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 580,
		  "schedulePercent": 0.343608,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Lab11",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aeb83a7081de80bbaabe2ffdf9fbd660",
		  
		  "name": "Jakob",
		  "createdDate": "2024-09-24 08:29:28",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 116,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 237,
		  "schedulePercent": 0.182684,
		  "totalGuests": 80,
		  "guestPercent": 0.49728,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "FZW",
		  "mostGuestCity": "Dortmund",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aecaab46d4c21ccd57885b807f9478c0",
		  
		  "name": "Anne",
		  "createdDate": "2010-03-22 15:17:04",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 424,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 2211,
		  "schedulePercent": 0.749433,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aecc8ffb7c20c3dc4fdd17ffc040ac8f",
		  
		  "name": "CAS",
		  "createdDate": "2024-07-16 07:36:32",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 95,
		  "totalCountries": 12,
		  "totalStates": 34,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 512,
		  "schedulePercent": 0.316636,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "The Globe",
		  "mostGuestCity": "Cardiff",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aed04316c3291dd7db30877d6c844f44",
		  
		  "name": "AdÃ¡n",
		  "createdDate": "2016-08-15 19:26:49",
		  "totalOrganizations": 23,
		  "totalTours": 39,
		  "totalDays": 2018,
		  "totalCountries": 35,
		  "totalStates": 104,
		  "totalEvents": 561,
		  "eventPercent": 0.984927,
		  "totalScheduleItems": 9875,
		  "schedulePercent": 0.9966,
		  "totalGuests": 3600,
		  "guestPercent": 0.99082,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aed4d88c9afd48a00e9faa208e8be4cf",
		  
		  "name": "Jacob",
		  "createdDate": "2021-08-30 08:20:16",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 187,
		  "totalCountries": 5,
		  "totalStates": 4,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 1133,
		  "schedulePercent": 0.529238,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aef304659a76b229bc5e967e8c133606",
		  
		  "name": "Raelynn",
		  "createdDate": "2022-05-10 14:39:09",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 527,
		  "schedulePercent": 0.325136,
		  "totalGuests": 312,
		  "guestPercent": 0.654918,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Murat Theatre @ Old National Centre",
		  "mostGuestCity": "Indianapolis",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aef6b9494414964ff7ae1e4eb96f94cf",
		  
		  "name": "Anne-Marie",
		  "createdDate": "2025-03-30 13:13:50",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 43,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aef80c43937433565948400c0cbcb4af",
		  
		  "name": "Nayara",
		  "createdDate": "2022-01-07 00:57:57",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 423,
		  "totalCountries": 14,
		  "totalStates": 36,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 2647,
		  "schedulePercent": 0.803037,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aeff102c11ed52c8d8276a6fb2105990",
		  
		  "name": "Renee",
		  "createdDate": "2023-03-10 19:02:59",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 247,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1810,
		  "schedulePercent": 0.678037,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-02-23 00:00:00",
		  "mostGuestName": "Orpheum Theatre",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af097f7f92614cd1bb7c70726aec43a2",
		  
		  "name": "Josh",
		  "createdDate": "2017-06-27 14:10:49",
		  "totalOrganizations": 18,
		  "totalTours": 25,
		  "totalDays": 490,
		  "totalCountries": 28,
		  "totalStates": 79,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 2541,
		  "schedulePercent": 0.791025,
		  "totalGuests": 187,
		  "guestPercent": 0.584202,
		  "mostGuestDate": "2025-07-22 00:00:00",
		  "mostGuestName": "Zebulon",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af0d9d2421e4faecc9a6b38fe2fa7e4a",
		  
		  "name": "Mikko",
		  "createdDate": "2016-06-11 13:34:31",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 209,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 796,
		  "schedulePercent": 0.421238,
		  "totalGuests": 327,
		  "guestPercent": 0.664665,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Tavastia Club",
		  "mostGuestCity": "Helsingfors",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af0fb209b0da5899da54bc135fb157ff",
		  
		  "name": "Toby",
		  "createdDate": "2025-03-19 02:33:58",
		  "totalOrganizations": 5,
		  "totalTours": 24,
		  "totalDays": 358,
		  "totalCountries": 12,
		  "totalStates": 12,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 830,
		  "schedulePercent": 0.43461,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Oxford Art Factory",
		  "mostGuestCity": "Darlinghurst",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af1b2bd57182940bad07a078e7521b9b",
		  
		  "name": "Travis",
		  "createdDate": "2022-02-02 18:37:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 304,
		  "totalCountries": 8,
		  "totalStates": 42,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 3047,
		  "schedulePercent": 0.846895,
		  "totalGuests": 1952,
		  "guestPercent": 0.942883,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af1c536609958db1e6ea75ec8c2ef206",
		  
		  "name": "Ben",
		  "createdDate": "2013-12-04 19:00:28",
		  "totalOrganizations": 26,
		  "totalTours": 35,
		  "totalDays": 1490,
		  "totalCountries": 59,
		  "totalStates": 97,
		  "totalEvents": 622,
		  "eventPercent": 0.988894,
		  "totalScheduleItems": 9150,
		  "schedulePercent": 0.994334,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af3406c2d1fcfaedda5dabdc0bb219c1",
		  
		  "name": "Mason",
		  "createdDate": "2022-08-16 21:52:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 95,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1092,
		  "schedulePercent": 0.518359,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af508d6d167a8acd0c148b5d85160135",
		  
		  "name": "Michael",
		  "createdDate": "2010-03-18 02:40:52",
		  "totalOrganizations": 9,
		  "totalTours": 32,
		  "totalDays": 539,
		  "totalCountries": 13,
		  "totalStates": 40,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 3081,
		  "schedulePercent": 0.849728,
		  "totalGuests": 929,
		  "guestPercent": 0.835449,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af57f2b925194eaebf4cc78b275319d9",
		  
		  "name": "Leesa",
		  "createdDate": "2010-11-09 11:38:43",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 364,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2040,
		  "schedulePercent": 0.720875,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af5f957b2d53b4da3c89d09592590330",
		  
		  "name": "Marshay ",
		  "createdDate": "2019-01-04 21:30:50",
		  "totalOrganizations": 18,
		  "totalTours": 6,
		  "totalDays": 256,
		  "totalCountries": 5,
		  "totalStates": 23,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af63ac5a7bf71ed05b1421befc34658e",
		  
		  "name": "Stefan",
		  "createdDate": "2024-07-05 21:25:51",
		  "totalOrganizations": 8,
		  "totalTours": 21,
		  "totalDays": 721,
		  "totalCountries": 4,
		  "totalStates": 54,
		  "totalEvents": 301,
		  "eventPercent": 0.913645,
		  "totalScheduleItems": 3611,
		  "schedulePercent": 0.890186,
		  "totalGuests": 1015,
		  "guestPercent": 0.849501,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Pavilion at Montage Mountain",
		  "mostGuestCity": "Moosic",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af669b7961f80468680a987600f44a15",
		  
		  "name": "Harry",
		  "createdDate": "2024-08-26 08:13:04",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 256,
		  "totalCountries": 22,
		  "totalStates": 55,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1428,
		  "schedulePercent": 0.604488,
		  "totalGuests": 1112,
		  "guestPercent": 0.86616,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af7b964601fc394b7a38fbbd8c0b1fdd",
		  
		  "name": "Logistics",
		  "createdDate": "2024-02-12 12:49:44",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 1146,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 321,
		  "eventPercent": 0.926904,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af85444f46956f1e52d0867f2324955b",
		  
		  "name": "Justin",
		  "createdDate": "2012-06-08 15:45:33",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 385,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1199,
		  "schedulePercent": 0.547257,
		  "totalGuests": 369,
		  "guestPercent": 0.68087,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Pensacola Interstate Fair",
		  "mostGuestCity": "Pensacola",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af8556bdd9516f9c3f893e423b06c61c",
		  
		  "name": "Zelda",
		  "createdDate": "2023-06-20 15:49:16",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 174,
		  "totalCountries": 2,
		  "totalStates": 33,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 965,
		  "schedulePercent": 0.479714,
		  "totalGuests": 294,
		  "guestPercent": 0.646532,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Mahaffey Theater",
		  "mostGuestCity": "St. Petersburg",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af96038d4e90efa680f3f84e20e20b29",
		  
		  "name": "Stacy",
		  "createdDate": "2022-12-28 00:50:05",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 408,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 478,
		  "schedulePercent": 0.302244,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Chevalier Theatre",
		  "mostGuestCity": "Medford",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "af9eef743404f86393cb9011d4fa057e",
		  
		  "name": "Taylor",
		  "createdDate": "2025-01-29 07:33:31",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 365,
		  "totalCountries": 11,
		  "totalStates": 32,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1457,
		  "schedulePercent": 0.608568,
		  "totalGuests": 535,
		  "guestPercent": 0.738894,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afab8628213bfade6bda9ee8ff9db61b",
		  
		  "name": "Aren",
		  "createdDate": "2018-04-14 21:40:07",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 2045,
		  "totalCountries": 21,
		  "totalStates": 59,
		  "totalEvents": 282,
		  "eventPercent": 0.899819,
		  "totalScheduleItems": 2617,
		  "schedulePercent": 0.799524,
		  "totalGuests": 231,
		  "guestPercent": 0.613327,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Downtown Las Vegas Events Center",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afb523c6a017443e6bf0565c6ec9c02b",
		  
		  "name": "Nicholas",
		  "createdDate": "2017-04-22 03:03:46",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 720,
		  "totalCountries": 12,
		  "totalStates": 61,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 4237,
		  "schedulePercent": 0.92849,
		  "totalGuests": 2848,
		  "guestPercent": 0.979034,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afbf351b9c178a318bf4c50498b6227c",
		  
		  "name": "Kim",
		  "createdDate": "2012-11-05 22:16:37",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 191,
		  "totalCountries": 2,
		  "totalStates": 37,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 2117,
		  "schedulePercent": 0.735041,
		  "totalGuests": 516,
		  "guestPercent": 0.734927,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afbf8cff78bc155f9887b9106ce57c45",
		  
		  "name": "Drew",
		  "createdDate": "2021-04-17 01:17:11",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 1351,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 493,
		  "eventPercent": 0.978015,
		  "totalScheduleItems": 2387,
		  "schedulePercent": 0.773345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afc25dc038fb7a7cdfa77fa68727b516",
		  
		  "name": "Evens",
		  "createdDate": "2022-04-20 11:53:51",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 407,
		  "totalCountries": 11,
		  "totalStates": 22,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 585,
		  "schedulePercent": 0.345648,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Fort Adams State Park",
		  "mostGuestCity": "Newport",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afc49c785a162bdf9ca9e12293d91a9b",
		  
		  "name": "Kate",
		  "createdDate": "2025-01-30 22:29:50",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 106,
		  "schedulePercent": 0.102108,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Lehman Center for the Performing Arts",
		  "mostGuestCity": "Bronx",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afca2fa5e37ad72fb37f3a5c79cf743d",
		  
		  "name": "Dante",
		  "createdDate": "2017-01-19 16:00:17",
		  "totalOrganizations": 23,
		  "totalTours": 16,
		  "totalDays": 663,
		  "totalCountries": 19,
		  "totalStates": 120,
		  "totalEvents": 361,
		  "eventPercent": 0.946963,
		  "totalScheduleItems": 5129,
		  "schedulePercent": 0.958069,
		  "totalGuests": 2368,
		  "guestPercent": 0.964302,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afddcc1d2a51492d1671891e6be258bf",
		  
		  "name": "John",
		  "createdDate": "2009-11-18 20:38:30",
		  "totalOrganizations": 44,
		  "totalTours": 86,
		  "totalDays": 2500,
		  "totalCountries": 21,
		  "totalStates": 101,
		  "totalEvents": 505,
		  "eventPercent": 0.979828,
		  "totalScheduleItems": 4722,
		  "schedulePercent": 0.94549,
		  "totalGuests": 1668,
		  "guestPercent": 0.925771,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Thomas Wolfe Auditorium",
		  "mostGuestCity": "Asheville",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "afed16a056562e317ee789dbce5abacb",
		  
		  "name": "Julia",
		  "createdDate": "2024-04-15 06:13:47",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 1146,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 321,
		  "eventPercent": 0.926904,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "aff9f85744959c3c7226ce21297c354c",
		  
		  "name": "Curnita",
		  "createdDate": "2023-09-25 15:24:33",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 253,
		  "schedulePercent": 0.191976,
		  "totalGuests": 307,
		  "guestPercent": 0.652879,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "The Masquerade",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "affac768f5f896d449631ac18850543d",
		  
		  "name": "Emilia",
		  "createdDate": "2024-12-23 14:30:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 13,
		  "totalStates": 19,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 1369,
		  "schedulePercent": 0.589075,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b001e9b429c7e1e7a1215b6008a7739f",
		  
		  "name": "Bob ",
		  "createdDate": "2016-01-28 18:41:31",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 765,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 255,
		  "schedulePercent": 0.19311,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "The Moroccan Lounge",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b00bdc957a33b13439db63c0da042c47",
		  
		  "name": "Bryan",
		  "createdDate": "2011-08-24 00:11:31",
		  "totalOrganizations": 21,
		  "totalTours": 36,
		  "totalDays": 480,
		  "totalCountries": 31,
		  "totalStates": 62,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 1718,
		  "schedulePercent": 0.661831,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Newman Center",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b00f0504150f7663c76270b437fba91e",
		  
		  "name": "MATTHEW",
		  "createdDate": "2021-11-28 03:18:32",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 79,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 583,
		  "schedulePercent": 0.345308,
		  "totalGuests": 327,
		  "guestPercent": 0.664665,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b012c1f28df4db2569464d88af8f93e0",
		  
		  "name": "Eli",
		  "createdDate": "2024-02-01 04:01:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 283,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 676,
		  "schedulePercent": 0.37704,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Middle Tennessee District Fair- Rotary Park",
		  "mostGuestCity": "Lawrenceburg",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b014b5a2e829ccefc6b12d72052de0d2",
		  
		  "name": "Angel",
		  "createdDate": "2017-04-20 15:17:01",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 1341,
		  "totalCountries": 9,
		  "totalStates": 41,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1230,
		  "schedulePercent": 0.554964,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b01dab6c0d7d908588fc01409e351246",
		  
		  "name": "Carlos ",
		  "createdDate": "2018-03-29 19:12:37",
		  "totalOrganizations": 29,
		  "totalTours": 19,
		  "totalDays": 387,
		  "totalCountries": 6,
		  "totalStates": 43,
		  "totalEvents": 329,
		  "eventPercent": 0.932684,
		  "totalScheduleItems": 2292,
		  "schedulePercent": 0.760766,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b049b9c1e0bec33aeec1b1942d57c5c4",
		  
		  "name": "Mike",
		  "createdDate": "2011-06-09 22:30:07",
		  "totalOrganizations": 17,
		  "totalTours": 21,
		  "totalDays": 780,
		  "totalCountries": 17,
		  "totalStates": 50,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 2585,
		  "schedulePercent": 0.796238,
		  "totalGuests": 1162,
		  "guestPercent": 0.87228,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Studio Instrument Rentals",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b04a51a14c57dcaff7d5b3d8ce51901d",
		  
		  "name": "Scarlett",
		  "createdDate": "2023-07-03 15:05:21",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 462,
		  "totalCountries": 10,
		  "totalStates": 8,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 259,
		  "schedulePercent": 0.194356,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b04b732a3139b6f5cbd5a57bd61bad77",
		  
		  "name": "GÃ©raldine",
		  "createdDate": "2023-02-02 10:22:37",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 409,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 566,
		  "schedulePercent": 0.339302,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b04be120c453720f23ad8baf0d265107",
		  
		  "name": "Scott",
		  "createdDate": "2014-07-14 13:17:27",
		  "totalOrganizations": 11,
		  "totalTours": 43,
		  "totalDays": 1095,
		  "totalCountries": 46,
		  "totalStates": 98,
		  "totalEvents": 404,
		  "eventPercent": 0.959882,
		  "totalScheduleItems": 5298,
		  "schedulePercent": 0.962035,
		  "totalGuests": 2092,
		  "guestPercent": 0.953762,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b04d8456fa55441e02e4323b9cda3d56",
		  
		  "name": "Kevin",
		  "createdDate": "2009-10-19 21:30:38",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 76,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b05288769d2ff5618832a897dc4a25c6",
		  
		  "name": "Reed",
		  "createdDate": "2022-11-05 16:57:50",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 100,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 848,
		  "schedulePercent": 0.43971,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Public Records",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b05f1d9167a288fb173f6baf678bd4d1",
		  
		  "name": "Zach",
		  "createdDate": "2018-04-14 18:49:10",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 1003,
		  "totalCountries": 14,
		  "totalStates": 61,
		  "totalEvents": 260,
		  "eventPercent": 0.881573,
		  "totalScheduleItems": 3932,
		  "schedulePercent": 0.910471,
		  "totalGuests": 3854,
		  "guestPercent": 0.992294,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b06a8f31288dc7603bbd1d151663b03e",
		  
		  "name": "Jenny",
		  "createdDate": "2015-11-11 14:06:51",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 71,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 162,
		  "schedulePercent": 0.136786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b06bd46fd8311745293c40fb53a6e558",
		  
		  "name": "Pia",
		  "createdDate": "2023-06-03 03:25:14",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 491,
		  "totalCountries": 29,
		  "totalStates": 47,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 658,
		  "schedulePercent": 0.370807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b06bdf392677036642d62757f241992e",
		  
		  "name": "adam",
		  "createdDate": "2019-07-10 22:58:25",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 558,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1681,
		  "schedulePercent": 0.654805,
		  "totalGuests": 216,
		  "guestPercent": 0.605961,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0848585567a0c0d623561dbfd65d4b0",
		  
		  "name": "Amira",
		  "createdDate": "2018-10-30 19:52:13",
		  "totalOrganizations": 19,
		  "totalTours": 17,
		  "totalDays": 560,
		  "totalCountries": 17,
		  "totalStates": 47,
		  "totalEvents": 293,
		  "eventPercent": 0.908092,
		  "totalScheduleItems": 1551,
		  "schedulePercent": 0.627267,
		  "totalGuests": 239,
		  "guestPercent": 0.618314,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Knockdown Center",
		  "mostGuestCity": "Maspeth",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b087dbdb208861e8e63d892774abe465",
		  
		  "name": "Chad",
		  "createdDate": "2018-07-05 04:02:19",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 108,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 507,
		  "schedulePercent": 0.314257,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0896105e6abf17ba69610741995d334",
		  
		  "name": "Jimmy",
		  "createdDate": "2016-12-28 21:49:31",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 1607,
		  "totalCountries": 13,
		  "totalStates": 67,
		  "totalEvents": 415,
		  "eventPercent": 0.962149,
		  "totalScheduleItems": 7315,
		  "schedulePercent": 0.988214,
		  "totalGuests": 2892,
		  "guestPercent": 0.979828,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Choctaw Grand Theater",
		  "mostGuestCity": "Durant",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0a4a09a5a2a691c034546571b6aa183",
		  
		  "name": "Tiago ",
		  "createdDate": "2025-03-19 12:47:27",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 61,
		  "totalCountries": 11,
		  "totalStates": 6,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 432,
		  "schedulePercent": 0.282638,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0bbcceb375c330c587bae58a99da78f",
		  
		  "name": "Rick",
		  "createdDate": "2021-12-12 21:03:16",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 925,
		  "totalCountries": 15,
		  "totalStates": 47,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1750,
		  "schedulePercent": 0.668631,
		  "totalGuests": 772,
		  "guestPercent": 0.800771,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "The Masonic",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0c81687342297e85415b88c76183f7c",
		  
		  "name": "Anders",
		  "createdDate": "2016-06-10 11:04:29",
		  "totalOrganizations": 20,
		  "totalTours": 16,
		  "totalDays": 384,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 348,
		  "eventPercent": 0.941523,
		  "totalScheduleItems": 2053,
		  "schedulePercent": 0.723935,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0d48162edc3626135f9e5bfef9b3e1d",
		  
		  "name": "Temi",
		  "createdDate": "2022-06-17 13:04:28",
		  "totalOrganizations": 30,
		  "totalTours": 41,
		  "totalDays": 979,
		  "totalCountries": 8,
		  "totalStates": 11,
		  "totalEvents": 922,
		  "eventPercent": 0.9949,
		  "totalScheduleItems": 4342,
		  "schedulePercent": 0.932797,
		  "totalGuests": 498,
		  "guestPercent": 0.729828,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Nordis Live",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0dc788c9c90ccb77cc614af939aa088",
		  
		  "name": "Chris",
		  "createdDate": "2018-03-06 15:44:17",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 618,
		  "totalCountries": 10,
		  "totalStates": 48,
		  "totalEvents": 276,
		  "eventPercent": 0.895626,
		  "totalScheduleItems": 2635,
		  "schedulePercent": 0.801564,
		  "totalGuests": 160,
		  "guestPercent": 0.565956,
		  "mostGuestDate": "2025-12-04 00:00:00",
		  "mostGuestName": "Fishers Event Center",
		  "mostGuestCity": "Fishers",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0dfb5d9c4e780fe82678f8c14f6450c",
		  
		  "name": "Devin",
		  "createdDate": "2015-11-15 01:40:26",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 1146,
		  "totalCountries": 11,
		  "totalStates": 56,
		  "totalEvents": 260,
		  "eventPercent": 0.881573,
		  "totalScheduleItems": 3815,
		  "schedulePercent": 0.903445,
		  "totalGuests": 2041,
		  "guestPercent": 0.949683,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "ICON Festival stage at small park",
		  "mostGuestCity": "Cincinnati",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0ed40b2c924cecd4b3f510372a37a48",
		  
		  "name": "Richard ",
		  "createdDate": "2016-11-09 16:12:18",
		  "totalOrganizations": 22,
		  "totalTours": 29,
		  "totalDays": 514,
		  "totalCountries": 19,
		  "totalStates": 72,
		  "totalEvents": 326,
		  "eventPercent": 0.931097,
		  "totalScheduleItems": 3569,
		  "schedulePercent": 0.886899,
		  "totalGuests": 754,
		  "guestPercent": 0.796917,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b0fdc82574633c16204e88bf8823e6bf",
		  
		  "name": "Michael",
		  "createdDate": "2021-08-18 22:42:03",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 576,
		  "totalCountries": 25,
		  "totalStates": 59,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2595,
		  "schedulePercent": 0.796804,
		  "totalGuests": 548,
		  "guestPercent": 0.74354,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1004e1062f6923ed5df7d5dcc273536",
		  
		  "name": "Patrick",
		  "createdDate": "2022-08-10 18:11:18",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 368,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 2080,
		  "schedulePercent": 0.729034,
		  "totalGuests": 2521,
		  "guestPercent": 0.968722,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1010ef3333b75b319838450b31d71b2",
		  
		  "name": "Anton",
		  "createdDate": "2022-11-08 09:09:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 11,
		  "totalStates": 6,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 157,
		  "schedulePercent": 0.13316,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "SaSaZu",
		  "mostGuestCity": "Prague",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1019dbf37281688ed9c26aab4d0a33b",
		  
		  "name": "Desiree",
		  "createdDate": "2024-06-03 16:18:17",
		  "totalOrganizations": 20,
		  "totalTours": 23,
		  "totalDays": 4110,
		  "totalCountries": 11,
		  "totalStates": 74,
		  "totalEvents": 847,
		  "eventPercent": 0.99422,
		  "totalScheduleItems": 18900,
		  "schedulePercent": 0.99932,
		  "totalGuests": 7698,
		  "guestPercent": 0.998753,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 190,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b102fe306d59d8b0a553930d46fe16e1",
		  
		  "name": "Fred",
		  "createdDate": "2019-04-25 19:48:08",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 44,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 118,
		  "schedulePercent": 0.109587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b10328f656adc5e011f29466349c1d78",
		  
		  "name": "Andrea",
		  "createdDate": "2015-05-20 15:21:59",
		  "totalOrganizations": 7,
		  "totalTours": 1,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 689,
		  "schedulePercent": 0.38214,
		  "totalGuests": 1103,
		  "guestPercent": 0.864687,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b10ae8fe09e5585232b36386f2768731",
		  
		  "name": "Lydell",
		  "createdDate": "2023-01-05 16:49:10",
		  "totalOrganizations": 3,
		  "totalTours": 36,
		  "totalDays": 566,
		  "totalCountries": 18,
		  "totalStates": 37,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 2464,
		  "schedulePercent": 0.782865,
		  "totalGuests": 96,
		  "guestPercent": 0.514733,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Ocean Resort Casino - Ovation Hall",
		  "mostGuestCity": "Atlantic City",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1222477019e9470acc8c0be1ba80cd0",
		  
		  "name": "Scott",
		  "createdDate": "2014-12-17 22:46:56",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 593,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1179,
		  "schedulePercent": 0.541931,
		  "totalGuests": 1175,
		  "guestPercent": 0.873867,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b13da562e71d5c52d75a62c1e9b1e835",
		  
		  "name": "Joe",
		  "createdDate": "2018-05-03 06:01:54",
		  "totalOrganizations": 27,
		  "totalTours": 51,
		  "totalDays": 1539,
		  "totalCountries": 24,
		  "totalStates": 84,
		  "totalEvents": 611,
		  "eventPercent": 0.987761,
		  "totalScheduleItems": 4332,
		  "schedulePercent": 0.932457,
		  "totalGuests": 777,
		  "guestPercent": 0.801904,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Miami Beach Bandshell",
		  "mostGuestCity": "Miami Beach",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1436e2763dd2dc17d813f36ddd76da6",
		  
		  "name": "Luke",
		  "createdDate": "2024-04-24 13:59:42",
		  "totalOrganizations": 14,
		  "totalTours": 22,
		  "totalDays": 708,
		  "totalCountries": 31,
		  "totalStates": 89,
		  "totalEvents": 285,
		  "eventPercent": 0.901859,
		  "totalScheduleItems": 3726,
		  "schedulePercent": 0.897665,
		  "totalGuests": 952,
		  "guestPercent": 0.839755,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b14f4f53b8faea932b7b39d9f04f3aef",
		  
		  "name": "Phil",
		  "createdDate": "2017-10-12 15:03:26",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 333,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1138,
		  "schedulePercent": 0.531165,
		  "totalGuests": 1131,
		  "guestPercent": 0.868767,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Riverfront Park",
		  "mostGuestCity": "Charelston",
		  "mostGuestAmount": 189,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1517c0e698157f55c0a9ee698fff9ec",
		  
		  "name": "Kris",
		  "createdDate": "2022-10-21 20:56:42",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 79,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 509,
		  "schedulePercent": 0.31505,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b161d86c45b4813419a9fcae62db8cb2",
		  
		  "name": "Sesame",
		  "createdDate": "2024-08-20 12:15:41",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 219,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2072,
		  "schedulePercent": 0.727335,
		  "totalGuests": 471,
		  "guestPercent": 0.720762,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b163313a834f576c0406575c90584b83",
		  
		  "name": "",
		  "createdDate": "2017-06-02 07:59:26",
		  "totalOrganizations": 21,
		  "totalTours": 12,
		  "totalDays": 137,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1157,
		  "schedulePercent": 0.536605,
		  "totalGuests": 378,
		  "guestPercent": 0.685063,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b167ace9c3985a4fe0795651b08623ee",
		  
		  "name": "Jonny",
		  "createdDate": "2023-08-14 21:39:26",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 505,
		  "totalCountries": 27,
		  "totalStates": 67,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2570,
		  "schedulePercent": 0.795444,
		  "totalGuests": 1507,
		  "guestPercent": 0.910018,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "Pearl Concert Theater",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b16ddce73a5f66fa1bb1ebc4d29609b9",
		  
		  "name": "Tim",
		  "createdDate": "2025-04-24 07:24:18",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 377,
		  "guestPercent": 0.68461,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "District 14",
		  "mostGuestCity": "Narre Warren",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b170e560cf2969ba2d35fa8ec97d04f0",
		  
		  "name": "James",
		  "createdDate": "2025-02-19 05:27:32",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 328,
		  "totalCountries": 7,
		  "totalStates": 31,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 978,
		  "schedulePercent": 0.484021,
		  "totalGuests": 412,
		  "guestPercent": 0.698323,
		  "mostGuestDate": "2025-11-21 00:00:00",
		  "mostGuestName": "Perth HPC",
		  "mostGuestCity": "Mount Claremont",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b182f0d908918ccb1efae2e0fbb22263",
		  
		  "name": "Shoshie",
		  "createdDate": "2021-07-26 16:18:18",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b183743a643d333193ceed4981ff8090",
		  
		  "name": "Terrian",
		  "createdDate": "2024-06-08 14:18:22",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 83,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 828,
		  "schedulePercent": 0.433477,
		  "totalGuests": 2693,
		  "guestPercent": 0.975521,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b185f96220839ce38652b510d31cdb89",
		  
		  "name": "Rory",
		  "createdDate": "2015-07-06 17:52:12",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 261,
		  "totalCountries": 15,
		  "totalStates": 61,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1883,
		  "schedulePercent": 0.691863,
		  "totalGuests": 301,
		  "guestPercent": 0.650385,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1915f407e888a67f1ab4d0bccdbdf94",
		  
		  "name": "Mathieu",
		  "createdDate": "2019-04-13 17:20:31",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 112,
		  "totalCountries": 12,
		  "totalStates": 27,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1185,
		  "schedulePercent": 0.543291,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-01-28 00:00:00",
		  "mostGuestName": "L'Olympia Bruno Coquatrix",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1a13b083c16b363a60b5e8517673f16",
		  
		  "name": "Jacob",
		  "createdDate": "2011-05-18 17:20:58",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 883,
		  "totalCountries": 22,
		  "totalStates": 71,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 5257,
		  "schedulePercent": 0.960902,
		  "totalGuests": 1382,
		  "guestPercent": 0.898005,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Climate Pledge Arena",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1a5cb42ed04a530b460f0e3f94c0ae1",
		  
		  "name": "Melissa",
		  "createdDate": "2023-08-24 14:58:18",
		  "totalOrganizations": 15,
		  "totalTours": 19,
		  "totalDays": 77,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 99,
		  "schedulePercent": 0.0962149,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1aa310c5a320723f68fd5373eda48ea",
		  
		  "name": "Brian",
		  "createdDate": "2011-02-09 00:32:29",
		  "totalOrganizations": 19,
		  "totalTours": 33,
		  "totalDays": 420,
		  "totalCountries": 16,
		  "totalStates": 63,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2122,
		  "schedulePercent": 0.735721,
		  "totalGuests": 450,
		  "guestPercent": 0.712489,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1b72957058c799ae1f633322a75d945",
		  
		  "name": "Leanne",
		  "createdDate": "2023-11-05 19:15:05",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 921,
		  "totalCountries": 13,
		  "totalStates": 26,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 597,
		  "schedulePercent": 0.350068,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1b90845ca4a6a28f1a44eb9ffdf67c9",
		  
		  "name": "Jackie",
		  "createdDate": "2022-05-17 17:42:57",
		  "totalOrganizations": 1,
		  "totalTours": 14,
		  "totalDays": 234,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 306,
		  "schedulePercent": 0.220875,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1bd94e4d87d23b8fa3036617e0d3cfa",
		  
		  "name": "Mel",
		  "createdDate": "2022-02-08 01:36:35",
		  "totalOrganizations": 7,
		  "totalTours": 21,
		  "totalDays": 399,
		  "totalCountries": 16,
		  "totalStates": 32,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 2169,
		  "schedulePercent": 0.742634,
		  "totalGuests": 790,
		  "guestPercent": 0.805644,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Metropolis",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1be87e1b63f765b0861f234ffeb8698",
		  
		  "name": "Lucille",
		  "createdDate": "2016-10-09 08:09:00",
		  "totalOrganizations": 35,
		  "totalTours": 39,
		  "totalDays": 1338,
		  "totalCountries": 28,
		  "totalStates": 100,
		  "totalEvents": 445,
		  "eventPercent": 0.969288,
		  "totalScheduleItems": 6532,
		  "schedulePercent": 0.982208,
		  "totalGuests": 2726,
		  "guestPercent": 0.976995,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1c22cda218336bde8ad4fc708c04ee6",
		  
		  "name": "Zach",
		  "createdDate": "2022-08-11 21:31:03",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 200,
		  "totalCountries": 9,
		  "totalStates": 42,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1155,
		  "schedulePercent": 0.535585,
		  "totalGuests": 111,
		  "guestPercent": 0.529125,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Velvet Underground",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1d0869d4e3e9e2494926a7c99905e96",
		  
		  "name": "Kyle",
		  "createdDate": "2021-08-18 22:11:55",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 162,
		  "totalCountries": 11,
		  "totalStates": 59,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1241,
		  "schedulePercent": 0.558024,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1d31a9bd63eeb97351e164b0f3c03cf",
		  
		  "name": "Ally",
		  "createdDate": "2021-09-03 03:53:21",
		  "totalOrganizations": 22,
		  "totalTours": 11,
		  "totalDays": 417,
		  "totalCountries": 11,
		  "totalStates": 62,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2070,
		  "schedulePercent": 0.727221,
		  "totalGuests": 303,
		  "guestPercent": 0.651519,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Baby's All Right",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1d507d534a6d6ef222080cfc7e0f624",
		  
		  "name": "Ben",
		  "createdDate": "2024-09-25 03:05:01",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 391,
		  "totalCountries": 27,
		  "totalStates": 86,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 3065,
		  "schedulePercent": 0.848708,
		  "totalGuests": 1385,
		  "guestPercent": 0.898572,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1d6dff7f3416111e53669f72f78208d",
		  
		  "name": "Jane",
		  "createdDate": "2012-06-05 11:20:05",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 599,
		  "totalCountries": 19,
		  "totalStates": 45,
		  "totalEvents": 279,
		  "eventPercent": 0.897439,
		  "totalScheduleItems": 3050,
		  "schedulePercent": 0.847688,
		  "totalGuests": 812,
		  "guestPercent": 0.811423,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Nissan Stadium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 195,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1e685fbcb80cf101e586d0cfe12dcb8",
		  
		  "name": "Mark",
		  "createdDate": "2012-01-06 14:33:45",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 66,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 324,
		  "schedulePercent": 0.228354,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "The Capitol Theatre",
		  "mostGuestCity": "Port Chester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1f00dc011cfdb18974da16534c23d42",
		  
		  "name": "Nora",
		  "createdDate": "2025-10-31 11:16:43",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 30,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 47,
		  "schedulePercent": 0.057117,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1f409ebf07f5419108b125cdb0e7a4e",
		  
		  "name": "Lauren",
		  "createdDate": "2024-01-18 20:50:04",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 61,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 140,
		  "schedulePercent": 0.12432,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "The Echo Lounge & Music Hall",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b1f8ca93fadb14fbaf9f9571b09e9d76",
		  
		  "name": "Francois",
		  "createdDate": "2018-03-17 14:33:16",
		  "totalOrganizations": 7,
		  "totalTours": 21,
		  "totalDays": 549,
		  "totalCountries": 41,
		  "totalStates": 95,
		  "totalEvents": 271,
		  "eventPercent": 0.891092,
		  "totalScheduleItems": 4019,
		  "schedulePercent": 0.914438,
		  "totalGuests": 1365,
		  "guestPercent": 0.895626,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2002db4cc4d4f33521704fa8f631780",
		  
		  "name": "Anders",
		  "createdDate": "2013-03-18 08:39:51",
		  "totalOrganizations": 147,
		  "totalTours": 97,
		  "totalDays": 2491,
		  "totalCountries": 25,
		  "totalStates": 72,
		  "totalEvents": 1222,
		  "eventPercent": 0.997733,
		  "totalScheduleItems": 9613,
		  "schedulePercent": 0.996034,
		  "totalGuests": 2196,
		  "guestPercent": 0.957616,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rden Under Bron",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2111e860450ca31029dd54791cba116",
		  
		  "name": "Randall",
		  "createdDate": "2014-05-08 21:19:44",
		  "totalOrganizations": 9,
		  "totalTours": 40,
		  "totalDays": 948,
		  "totalCountries": 21,
		  "totalStates": 66,
		  "totalEvents": 343,
		  "eventPercent": 0.938463,
		  "totalScheduleItems": 4353,
		  "schedulePercent": 0.933024,
		  "totalGuests": 1307,
		  "guestPercent": 0.887239,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "MN STATE FAIRGROUNDS ",
		  "mostGuestCity": "St Paul",
		  "mostGuestAmount": 248,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b213890a2bb7ae1969b5692425fa028d",
		  
		  "name": "Sara",
		  "createdDate": "2024-05-29 09:19:22",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 609,
		  "totalCountries": 12,
		  "totalStates": 22,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1357,
		  "schedulePercent": 0.586809,
		  "totalGuests": 503,
		  "guestPercent": 0.731528,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b213ddbb934007d64ccc7b79b4da06d9",
		  
		  "name": "Dory",
		  "createdDate": "2022-06-01 21:03:45",
		  "totalOrganizations": 8,
		  "totalTours": 17,
		  "totalDays": 772,
		  "totalCountries": 15,
		  "totalStates": 57,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 4079,
		  "schedulePercent": 0.917611,
		  "totalGuests": 1770,
		  "guestPercent": 0.931664,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2187e0013cd1b4a44f0c2e4cbf851d9",
		  
		  "name": "Daniel",
		  "createdDate": "2019-06-08 19:09:27",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 1259,
		  "totalCountries": 9,
		  "totalStates": 58,
		  "totalEvents": 355,
		  "eventPercent": 0.94413,
		  "totalScheduleItems": 4857,
		  "schedulePercent": 0.949569,
		  "totalGuests": 1713,
		  "guestPercent": 0.928604,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Boone Pickens Stadium",
		  "mostGuestCity": "Stillwater",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2195aa57aa14c1dc05841c2fe5cbebc",
		  
		  "name": "Omar",
		  "createdDate": "2015-06-12 20:59:19",
		  "totalOrganizations": 10,
		  "totalTours": 21,
		  "totalDays": 723,
		  "totalCountries": 15,
		  "totalStates": 54,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 2496,
		  "schedulePercent": 0.786491,
		  "totalGuests": 1160,
		  "guestPercent": 0.87194,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2198f4f266349b83f7651f982fb0b3a",
		  
		  "name": "Emily",
		  "createdDate": "2016-02-22 16:16:42",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 267,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 110,
		  "guestPercent": 0.528105,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Fallsview Casino Resort",
		  "mostGuestCity": "Niagara Falls",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b21b09f0f580904212933dbcfc59de3a",
		  
		  "name": "Lindsay",
		  "createdDate": "2019-10-15 21:46:07",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 335,
		  "totalCountries": 22,
		  "totalStates": 69,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2437,
		  "schedulePercent": 0.779238,
		  "totalGuests": 2057,
		  "guestPercent": 0.951043,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b21b9d80b754e52d33759cde8ed47ba3",
		  
		  "name": "Cylvanna",
		  "createdDate": "2023-02-06 18:39:42",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 783,
		  "totalCountries": 6,
		  "totalStates": 29,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 1475,
		  "schedulePercent": 0.611854,
		  "totalGuests": 9103,
		  "guestPercent": 0.99898,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 523,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b22385ba357b4e028efff7e96d1c94ec",
		  
		  "name": "Abby",
		  "createdDate": "2025-04-01 15:11:30",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 78,
		  "schedulePercent": 0.0804624,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Shoreline Waterfront",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b22b5336e30960dc28abad3f536521eb",
		  
		  "name": "K&K ",
		  "createdDate": "2024-01-16 09:25:03",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 89,
		  "totalCountries": 7,
		  "totalStates": 10,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 575,
		  "schedulePercent": 0.341455,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b22c420bda00c2ae1dc928da5badc23d",
		  
		  "name": "Todd",
		  "createdDate": "2012-02-01 15:20:44",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 829,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1686,
		  "schedulePercent": 0.656052,
		  "totalGuests": 674,
		  "guestPercent": 0.779465,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "The Paramount",
		  "mostGuestCity": "Huntington",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b22c705dda3de3f091d96fdf042c65f2",
		  
		  "name": "Jay",
		  "createdDate": "2016-06-16 20:44:43",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 52,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 94,
		  "schedulePercent": 0.0923617,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b22f6d560c23125e4b428e0cb18083e4",
		  
		  "name": "Brad",
		  "createdDate": "2016-05-02 01:21:44",
		  "totalOrganizations": 27,
		  "totalTours": 36,
		  "totalDays": 711,
		  "totalCountries": 14,
		  "totalStates": 29,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1159,
		  "schedulePercent": 0.537171,
		  "totalGuests": 303,
		  "guestPercent": 0.651519,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Margaret Court Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b235c663d87b99fe473fcb188130963e",
		  
		  "name": "Camila",
		  "createdDate": "2022-03-26 20:29:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 7,
		  "totalStates": 4,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 406,
		  "schedulePercent": 0.272099,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Estadio Pascual Guerrero",
		  "mostGuestCity": "Cali",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b24064536fc74980b4be4f5ac44dd325",
		  
		  "name": "Erik ",
		  "createdDate": "2022-10-06 06:51:18",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 94,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 580,
		  "schedulePercent": 0.343608,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2450256b1b23596f03fed370b075a37",
		  
		  "name": "Lisa",
		  "createdDate": "2023-07-26 16:19:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 4,
		  "totalStates": 27,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 845,
		  "schedulePercent": 0.438803,
		  "totalGuests": 102,
		  "guestPercent": 0.522325,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b248a3ca5bf429a1f9f6dabb98bfabc5",
		  
		  "name": "Melissa",
		  "createdDate": "2017-06-02 02:02:13",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 636,
		  "totalCountries": 14,
		  "totalStates": 45,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1800,
		  "schedulePercent": 0.676224,
		  "totalGuests": 699,
		  "guestPercent": 0.785358,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b24e584862870f63ad71eda52e3a1a23",
		  
		  "name": "Kevin",
		  "createdDate": "2016-09-27 17:42:06",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 529,
		  "totalCountries": 28,
		  "totalStates": 64,
		  "totalEvents": 221,
		  "eventPercent": 0.835449,
		  "totalScheduleItems": 3115,
		  "schedulePercent": 0.852675,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b251e28c73a57633527f64db55d3633b",
		  
		  "name": "Chris",
		  "createdDate": "2015-03-30 17:25:28",
		  "totalOrganizations": 10,
		  "totalTours": 29,
		  "totalDays": 860,
		  "totalCountries": 30,
		  "totalStates": 78,
		  "totalEvents": 310,
		  "eventPercent": 0.919198,
		  "totalScheduleItems": 4056,
		  "schedulePercent": 0.916591,
		  "totalGuests": 864,
		  "guestPercent": 0.82185,
		  "mostGuestDate": "2025-01-15 00:00:00",
		  "mostGuestName": "Lodge Room",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b25ac1980b375446482fbb6dbd2ec04d",
		  
		  "name": "Joshua",
		  "createdDate": "2025-03-25 14:57:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 259,
		  "schedulePercent": 0.194356,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "713 Music Hall",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2629baa38526cd2668dee53511ae367",
		  
		  "name": "Naomi ",
		  "createdDate": "2023-03-23 23:22:22",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 1019,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 413,
		  "eventPercent": 0.961695,
		  "totalScheduleItems": 2387,
		  "schedulePercent": 0.773345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b27807a84ac00d5b6603c594089418c2",
		  
		  "name": "Emil",
		  "createdDate": "2017-08-10 18:41:01",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 24,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 271,
		  "schedulePercent": 0.200023,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b27f464aa494688b3e8d8d23a75e37ce",
		  
		  "name": "Todd",
		  "createdDate": "2024-09-05 21:14:41",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 132,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 572,
		  "schedulePercent": 0.340435,
		  "totalGuests": 265,
		  "guestPercent": 0.631686,
		  "mostGuestDate": "2025-07-22 00:00:00",
		  "mostGuestName": "Commodore Ballroom",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b27fa943ff5c2c9a32910705443f4856",
		  
		  "name": "Tim",
		  "createdDate": "2012-08-24 18:41:52",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 102,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 717,
		  "schedulePercent": 0.393019,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b28908c6ad2f0530c6a54624f9913793",
		  
		  "name": "Esprit",
		  "createdDate": "2023-12-13 17:38:11",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 41,
		  "totalCountries": 11,
		  "totalStates": 11,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Academy 2",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2951cc7f13789db089644a6e9791467",
		  
		  "name": "Gemma",
		  "createdDate": "2021-06-22 04:45:19",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 192,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 486,
		  "schedulePercent": 0.304397,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2aa51e04330c807e4cb700106ef5ec2",
		  
		  "name": "Duncan",
		  "createdDate": "2012-06-04 14:59:04",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 623,
		  "totalCountries": 30,
		  "totalStates": 59,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 3627,
		  "schedulePercent": 0.891092,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2abc3798808959645d3e5dd46240947",
		  
		  "name": "Pam",
		  "createdDate": "2012-05-26 08:13:18",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 748,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 2077,
		  "schedulePercent": 0.728694,
		  "totalGuests": 102,
		  "guestPercent": 0.522325,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2b30f050c6f0d6b261274ee4c49b5d4",
		  
		  "name": "Cassandra",
		  "createdDate": "2021-10-26 20:01:46",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 26,
		  "totalCountries": 8,
		  "totalStates": 5,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 168,
		  "schedulePercent": 0.139279,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-06-10 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2bcaca92dd15297bed7e598f85bdd4f",
		  
		  "name": "Alex",
		  "createdDate": "2023-06-20 22:26:04",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 261,
		  "totalCountries": 22,
		  "totalStates": 37,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 1598,
		  "schedulePercent": 0.640299,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2c178f39b595950fe3210a9c29f8f7d",
		  
		  "name": "Vin",
		  "createdDate": "2025-03-18 23:24:42",
		  "totalOrganizations": 1,
		  "totalTours": 16,
		  "totalDays": 162,
		  "totalCountries": 6,
		  "totalStates": 31,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1240,
		  "schedulePercent": 0.557344,
		  "totalGuests": 384,
		  "guestPercent": 0.68767,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2c5b5d9ef7bfb5346d09e8eb513521d",
		  
		  "name": "Matthew",
		  "createdDate": "2024-06-05 22:07:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 304,
		  "totalCountries": 9,
		  "totalStates": 35,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 1666,
		  "schedulePercent": 0.652312,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2e608b9111d9fe1f21f3e5f6714dc4d",
		  
		  "name": "Rachel",
		  "createdDate": "2010-11-29 20:16:49",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 293,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1375,
		  "schedulePercent": 0.591568,
		  "totalGuests": 184,
		  "guestPercent": 0.582276,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Tottenham Hotspur Stadium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2ec28982172a0f58512cbcd60989cb3",
		  
		  "name": "Cory",
		  "createdDate": "2024-03-29 17:24:54",
		  "totalOrganizations": 8,
		  "totalTours": 21,
		  "totalDays": 546,
		  "totalCountries": 19,
		  "totalStates": 74,
		  "totalEvents": 312,
		  "eventPercent": 0.920671,
		  "totalScheduleItems": 3516,
		  "schedulePercent": 0.88282,
		  "totalGuests": 687,
		  "guestPercent": 0.782865,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "Northwell Health at Jones Beach Theater",
		  "mostGuestCity": "Wantagh",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2ed19a248482b8f1543b3da118b98da",
		  
		  "name": "Rebecca",
		  "createdDate": "2020-01-12 18:53:31",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 391,
		  "totalCountries": 22,
		  "totalStates": 66,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 2175,
		  "schedulePercent": 0.744107,
		  "totalGuests": 1327,
		  "guestPercent": 0.891092,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b2f0fd632b4584e58e0f6f06e6854741",
		  
		  "name": "Joel",
		  "createdDate": "2016-08-10 23:10:39",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 264,
		  "totalCountries": 8,
		  "totalStates": 78,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1733,
		  "schedulePercent": 0.664325,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Fred Kavli Theater",
		  "mostGuestCity": "Thousand Oaks",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3053a3b41f0c563363ac4e781134be6",
		  
		  "name": "Ann Kathrin",
		  "createdDate": "2022-12-17 14:07:14",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 746,
		  "totalCountries": 14,
		  "totalStates": 31,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b305c8f94f5fee39f80dc9d866656e08",
		  
		  "name": "Corey",
		  "createdDate": "2019-01-31 20:47:40",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 1629,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 3278,
		  "schedulePercent": 0.866614,
		  "totalGuests": 1415,
		  "guestPercent": 0.901519,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Akins Ford Arena",
		  "mostGuestCity": "Athens",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b313df3b65b5540c28b87a7c3273f995",
		  
		  "name": "JOHN ",
		  "createdDate": "2019-01-13 23:57:19",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 609,
		  "totalCountries": 6,
		  "totalStates": 32,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1552,
		  "schedulePercent": 0.62738,
		  "totalGuests": 977,
		  "guestPercent": 0.842588,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Cadence Bank Amphitheatre At Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b32e94643b410e7b15ec91bf4b39fcf3",
		  
		  "name": "Erin",
		  "createdDate": "2017-07-13 19:38:33",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 155,
		  "totalCountries": 14,
		  "totalStates": 44,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 800,
		  "schedulePercent": 0.422597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b330c9c1a5d8c4d44a78416945e0a079",
		  
		  "name": "Perusi",
		  "createdDate": "2020-10-24 10:19:48",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 403,
		  "totalCountries": 13,
		  "totalStates": 21,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 642,
		  "schedulePercent": 0.364914,
		  "totalGuests": 346,
		  "guestPercent": 0.673277,
		  "mostGuestDate": "2025-03-12 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3334c0bf18914fb3d381a0f0dc4c656",
		  
		  "name": "Lachlan",
		  "createdDate": "2018-07-26 14:12:05",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 563,
		  "totalCountries": 24,
		  "totalStates": 40,
		  "totalEvents": 280,
		  "eventPercent": 0.898345,
		  "totalScheduleItems": 2184,
		  "schedulePercent": 0.745467,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b33b2b480eb21c627ecaf2d62d0e935f",
		  
		  "name": "Elin",
		  "createdDate": "2022-02-01 12:07:16",
		  "totalOrganizations": 85,
		  "totalTours": 82,
		  "totalDays": 1685,
		  "totalCountries": 25,
		  "totalStates": 77,
		  "totalEvents": 941,
		  "eventPercent": 0.99524,
		  "totalScheduleItems": 7547,
		  "schedulePercent": 0.988667,
		  "totalGuests": 1918,
		  "guestPercent": 0.940843,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Banan-Kompaniet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b33c8169f805676a4b48ef9b64f3509d",
		  
		  "name": "Robert",
		  "createdDate": "2021-12-03 14:50:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 141,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 410,
		  "schedulePercent": 0.273799,
		  "totalGuests": 215,
		  "guestPercent": 0.605281,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Clay Cooper Theatre",
		  "mostGuestCity": "Branson",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3481eaba3587520d55168f328b01187",
		  
		  "name": "Helena",
		  "createdDate": "2017-08-14 13:02:37",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 108,
		  "totalCountries": 21,
		  "totalStates": 11,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 815,
		  "schedulePercent": 0.428944,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b349c0482f7dcffc676676fdf79d881d",
		  
		  "name": "Mastertour",
		  "createdDate": "2023-04-04 13:22:17",
		  "totalOrganizations": 9,
		  "totalTours": 23,
		  "totalDays": 417,
		  "totalCountries": 25,
		  "totalStates": 46,
		  "totalEvents": 256,
		  "eventPercent": 0.876927,
		  "totalScheduleItems": 2398,
		  "schedulePercent": 0.775045,
		  "totalGuests": 837,
		  "guestPercent": 0.817203,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Dalhalla",
		  "mostGuestCity": "RÃ¤ttvik",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b35215b5628f885cf4b2e29ba5b1081a",
		  
		  "name": "Jason",
		  "createdDate": "2017-05-01 21:10:16",
		  "totalOrganizations": 11,
		  "totalTours": 23,
		  "totalDays": 624,
		  "totalCountries": 7,
		  "totalStates": 49,
		  "totalEvents": 256,
		  "eventPercent": 0.876927,
		  "totalScheduleItems": 4257,
		  "schedulePercent": 0.929397,
		  "totalGuests": 940,
		  "guestPercent": 0.837262,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b35615cf01241cfad8c1dad7039ed13d",
		  
		  "name": "Harley",
		  "createdDate": "2025-04-05 21:59:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 223,
		  "schedulePercent": 0.173051,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3626139717f4bf0ff423ccb38f1f835",
		  
		  "name": "LaDonna ",
		  "createdDate": "2017-06-29 21:23:40",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 641,
		  "schedulePercent": 0.364687,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "3rd & Lindsley Bar & Grill",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b36bc63bf33c2f5df1a8532a97d1fa1f",
		  
		  "name": "Steve",
		  "createdDate": "2018-07-31 23:39:24",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 659,
		  "totalCountries": 5,
		  "totalStates": 39,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1743,
		  "schedulePercent": 0.666591,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "San Jose Civic Auditorium",
		  "mostGuestCity": "San Jose",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b375c4d4baceb42cbf02255ca1c1be1b",
		  
		  "name": "Valeria ",
		  "createdDate": "2019-02-20 00:36:00",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 140,
		  "schedulePercent": 0.12432,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b37e398143d4c094f9b6fb1ac48407de",
		  
		  "name": "Manoel",
		  "createdDate": "2012-05-29 00:53:58",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 141,
		  "totalCountries": 14,
		  "totalStates": 16,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 1496,
		  "schedulePercent": 0.616954,
		  "totalGuests": 1216,
		  "guestPercent": 0.877607,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "SAP Arena",
		  "mostGuestCity": "MA",
		  "mostGuestAmount": 154,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b38bd027a9126750841f7f18a323a074",
		  
		  "name": "Abigail",
		  "createdDate": "2025-04-08 05:44:37",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 174,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 127,
		  "guestPercent": 0.542044,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Ford Amphitheater",
		  "mostGuestCity": "Colorado Springs",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3941d4eeea10a80893498f3249d94c1",
		  
		  "name": "Larry",
		  "createdDate": "2024-10-23 01:41:10",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 97,
		  "totalCountries": 22,
		  "totalStates": 36,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 943,
		  "schedulePercent": 0.473368,
		  "totalGuests": 865,
		  "guestPercent": 0.82219,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b395b6ba274fcb8366b320bc59fd2dfb",
		  
		  "name": "Chris",
		  "createdDate": "2022-02-14 22:38:21",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b398efd61e6a47fc665a2465317ed7d7",
		  
		  "name": "Glenn",
		  "createdDate": "2022-11-21 20:47:06",
		  "totalOrganizations": 5,
		  "totalTours": 27,
		  "totalDays": 424,
		  "totalCountries": 8,
		  "totalStates": 44,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1183,
		  "schedulePercent": 0.543064,
		  "totalGuests": 169,
		  "guestPercent": 0.573096,
		  "mostGuestDate": "2025-01-22 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3a5b63291342222b41786d389e95f43",
		  
		  "name": "Paris",
		  "createdDate": "2024-04-14 17:50:07",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 776,
		  "totalCountries": 18,
		  "totalStates": 63,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2807,
		  "schedulePercent": 0.823436,
		  "totalGuests": 2081,
		  "guestPercent": 0.952969,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3aba3783d02109e7108be9632caed9d",
		  
		  "name": "James",
		  "createdDate": "2022-03-08 16:39:39",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 65,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 318,
		  "schedulePercent": 0.225748,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3c36da48e9ea1e61d1bc6008bf55206",
		  
		  "name": "Zach",
		  "createdDate": "2022-10-12 22:29:50",
		  "totalOrganizations": 16,
		  "totalTours": 22,
		  "totalDays": 1524,
		  "totalCountries": 9,
		  "totalStates": 66,
		  "totalEvents": 373,
		  "eventPercent": 0.951383,
		  "totalScheduleItems": 4699,
		  "schedulePercent": 0.944243,
		  "totalGuests": 2475,
		  "guestPercent": 0.966908,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3e1cfa2a2c7cab51b66154b78baff04",
		  
		  "name": "Adam",
		  "createdDate": "2016-07-02 02:39:06",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 661,
		  "totalCountries": 11,
		  "totalStates": 46,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 2460,
		  "schedulePercent": 0.782298,
		  "totalGuests": 806,
		  "guestPercent": 0.809384,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3ec1c96fa22d61360715fa1c93438bd",
		  
		  "name": "Martina",
		  "createdDate": "2024-04-05 20:03:16",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 235,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 375,
		  "schedulePercent": 0.25544,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b3ff6d18e07fdc950ed7d121e4d5d318",
		  
		  "name": "Norwood",
		  "createdDate": "2015-11-08 04:22:30",
		  "totalOrganizations": 14,
		  "totalTours": 14,
		  "totalDays": 1717,
		  "totalCountries": 27,
		  "totalStates": 69,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 3148,
		  "schedulePercent": 0.855394,
		  "totalGuests": 830,
		  "guestPercent": 0.815277,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Colosseum Theater at Caesars Palace",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b407d453e55d4de495dca8ab083edd36",
		  
		  "name": "Liam",
		  "createdDate": "2018-09-19 18:20:07",
		  "totalOrganizations": 14,
		  "totalTours": 12,
		  "totalDays": 865,
		  "totalCountries": 32,
		  "totalStates": 81,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 5068,
		  "schedulePercent": 0.956709,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Fryshuset Klubben",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4168c6f45a1021c63c09314c901436d",
		  
		  "name": "Steven",
		  "createdDate": "2022-10-27 17:21:44",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 881,
		  "totalCountries": 15,
		  "totalStates": 47,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 3007,
		  "schedulePercent": 0.842702,
		  "totalGuests": 1069,
		  "guestPercent": 0.857774,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b423d94c0eac0482169e0e8718ca96a9",
		  
		  "name": "Paula",
		  "createdDate": "2017-02-27 20:01:10",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 367,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 719,
		  "schedulePercent": 0.393586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b42bc06ae436aea71d4a5312bfb9ffce",
		  
		  "name": "Sierra",
		  "createdDate": "2024-11-19 13:15:34",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 129,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 886,
		  "schedulePercent": 0.452516,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "Voxhall",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b43016d8a6d227dd73935751a2904524",
		  
		  "name": "Brian",
		  "createdDate": "2016-11-10 20:51:32",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 76,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 19,
		  "schedulePercent": 0.0296917,
		  "totalGuests": 103,
		  "guestPercent": 0.522779,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Chief's on Broadway",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b43339e21cceb5e8d6a5ff9fcf1115ff",
		  
		  "name": "Rachel",
		  "createdDate": "2023-05-03 04:20:18",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 229,
		  "totalCountries": 13,
		  "totalStates": 49,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 1497,
		  "schedulePercent": 0.617407,
		  "totalGuests": 791,
		  "guestPercent": 0.80587,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Echo-Plex",
		  "mostGuestCity": "Echo Park",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b43824c81a471ea3777998566117b7ad",
		  
		  "name": "Martijn",
		  "createdDate": "2014-10-31 10:26:24",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 43,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 129,
		  "schedulePercent": 0.11718,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b43937e67912f6d98dfe65802159c91e",
		  
		  "name": "Andrea",
		  "createdDate": "2025-03-26 01:17:37",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 177,
		  "totalCountries": 17,
		  "totalStates": 51,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 725,
		  "schedulePercent": 0.396306,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Crystal Bay Casino",
		  "mostGuestCity": "Crystal Bay",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4508eec9ba5d20b6fb6084dee28090e",
		  
		  "name": "Wiz",
		  "createdDate": "2025-10-04 12:35:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 86,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 399,
		  "schedulePercent": 0.269152,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b451702e2410c3e1cc38490cdbc5bd40",
		  
		  "name": "Bragg",
		  "createdDate": "2019-01-13 20:52:34",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 350,
		  "totalCountries": 4,
		  "totalStates": 44,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 1590,
		  "schedulePercent": 0.638373,
		  "totalGuests": 332,
		  "guestPercent": 0.666704,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b45a52a5a0a0bce30f7d42431188d57c",
		  
		  "name": "Olympe",
		  "createdDate": "2016-10-11 15:22:55",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 62,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 367,
		  "schedulePercent": 0.251813,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b45b15b4da0e128349cd361c38f2cb69",
		  
		  "name": "Mike ",
		  "createdDate": "2011-09-05 15:44:16",
		  "totalOrganizations": 15,
		  "totalTours": 21,
		  "totalDays": 369,
		  "totalCountries": 9,
		  "totalStates": 49,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 1925,
		  "schedulePercent": 0.699116,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-03-16 00:00:00",
		  "mostGuestName": "Kaufleuten",
		  "mostGuestCity": "ZÃ¼rich",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b46246a7892c482fb90e3aaf9cb0e2fe",
		  
		  "name": "Alexis",
		  "createdDate": "2021-07-23 20:41:31",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 193,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1134,
		  "schedulePercent": 0.529578,
		  "totalGuests": 399,
		  "guestPercent": 0.694016,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Event Style Festival",
		  "mostGuestCity": "Mont-Tremblant",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b464683ccbcb55211bace51b1583bb53",
		  
		  "name": "Erica",
		  "createdDate": "2015-11-25 20:25:10",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 772,
		  "totalCountries": 3,
		  "totalStates": 47,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2369,
		  "schedulePercent": 0.771419,
		  "totalGuests": 2703,
		  "guestPercent": 0.976088,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4817d5643f3d1804c7b8e8187a26c5b",
		  
		  "name": "Chris",
		  "createdDate": "2023-04-25 17:46:18",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 29,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 107,
		  "schedulePercent": 0.102675,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Louder Than Life Music Festival",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b486983daacbb68fc63faa21812bc730",
		  
		  "name": "Kirk",
		  "createdDate": "2016-05-12 20:06:56",
		  "totalOrganizations": 10,
		  "totalTours": 16,
		  "totalDays": 725,
		  "totalCountries": 9,
		  "totalStates": 58,
		  "totalEvents": 306,
		  "eventPercent": 0.916251,
		  "totalScheduleItems": 4167,
		  "schedulePercent": 0.923164,
		  "totalGuests": 3427,
		  "guestPercent": 0.989121,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Rocket Mortgage FieldHouse",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b48b4ace9583c79612bea09592e04158",
		  
		  "name": "Jenny",
		  "createdDate": "2024-07-30 09:15:41",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 335,
		  "totalCountries": 19,
		  "totalStates": 29,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 3043,
		  "schedulePercent": 0.846328,
		  "totalGuests": 4811,
		  "guestPercent": 0.997054,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Uber Eats Music Hall",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 405,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b492ccc64cc95e885616d10d431d788e",
		  
		  "name": "Daniel ",
		  "createdDate": "2009-10-03 02:27:58",
		  "totalOrganizations": 22,
		  "totalTours": 17,
		  "totalDays": 2084,
		  "totalCountries": 37,
		  "totalStates": 60,
		  "totalEvents": 283,
		  "eventPercent": 0.900499,
		  "totalScheduleItems": 4466,
		  "schedulePercent": 0.936763,
		  "totalGuests": 672,
		  "guestPercent": 0.778785,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4975ab5862a29720ec449477fd57969",
		  
		  "name": "Gunnar",
		  "createdDate": "2020-10-13 17:49:31",
		  "totalOrganizations": 19,
		  "totalTours": 9,
		  "totalDays": 199,
		  "totalCountries": 8,
		  "totalStates": 18,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 910,
		  "schedulePercent": 0.461695,
		  "totalGuests": 263,
		  "guestPercent": 0.63078,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Arendal Kulturhus",
		  "mostGuestCity": "Arendal",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b499fac42b7083e6ae207cd2258108e2",
		  
		  "name": "Tiger",
		  "createdDate": "2025-10-14 08:32:29",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 127,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 934,
		  "schedulePercent": 0.470648,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b49c6ae1a37775d8175374eeb192d0e0",
		  
		  "name": "Keiran",
		  "createdDate": "2024-02-19 20:01:26",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 2362,
		  "totalCountries": 38,
		  "totalStates": 83,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 1898,
		  "schedulePercent": 0.694016,
		  "totalGuests": 82,
		  "guestPercent": 0.499207,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Old Park Farm",
		  "mostGuestCity": "",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b49dca2d3163772f1e1b022c627de506",
		  
		  "name": "Everett",
		  "createdDate": "2018-10-10 18:15:39",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 143,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 809,
		  "schedulePercent": 0.426337,
		  "totalGuests": 575,
		  "guestPercent": 0.75102,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4a17862ea82bddf3367f2d2ab6ade32",
		  
		  "name": "Chris",
		  "createdDate": "2019-05-15 07:40:10",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 44,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 403,
		  "schedulePercent": 0.271192,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Granada Theater",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4a94f0ed3f4dc681ca421122b3eb9d2",
		  
		  "name": "Sophie ",
		  "createdDate": "2020-02-09 22:01:44",
		  "totalOrganizations": 38,
		  "totalTours": 29,
		  "totalDays": 1468,
		  "totalCountries": 37,
		  "totalStates": 90,
		  "totalEvents": 421,
		  "eventPercent": 0.963849,
		  "totalScheduleItems": 5688,
		  "schedulePercent": 0.971215,
		  "totalGuests": 2070,
		  "guestPercent": 0.951836,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4bfdd618681daf833c0e8d7842fa8f8",
		  
		  "name": "David",
		  "createdDate": "2018-03-14 04:39:12",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 297,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 1852,
		  "schedulePercent": 0.68631,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4c02a601e06bbca9dc8544828b85255",
		  
		  "name": "Steve",
		  "createdDate": "2017-08-11 15:47:03",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 225,
		  "totalCountries": 11,
		  "totalStates": 44,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 930,
		  "schedulePercent": 0.468835,
		  "totalGuests": 830,
		  "guestPercent": 0.815277,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4c9d68a42efcabd39d5aa969127e535",
		  
		  "name": "Shannon ",
		  "createdDate": "2023-01-09 02:00:16",
		  "totalOrganizations": 24,
		  "totalTours": 10,
		  "totalDays": 189,
		  "totalCountries": 12,
		  "totalStates": 21,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 704,
		  "schedulePercent": 0.388259,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Parking at Julian B. Lane Riverfront Park",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4cab1a926de850dfe28fd868af4814a",
		  
		  "name": "Steve",
		  "createdDate": "2021-08-20 01:44:14",
		  "totalOrganizations": 16,
		  "totalTours": 16,
		  "totalDays": 1438,
		  "totalCountries": 13,
		  "totalStates": 62,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 3919,
		  "schedulePercent": 0.909905,
		  "totalGuests": 2115,
		  "guestPercent": 0.954556,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4d147a46d0e856e2efa9bf1e56a23c2",
		  
		  "name": "Romance",
		  "createdDate": "2018-03-05 14:10:58",
		  "totalOrganizations": 16,
		  "totalTours": 6,
		  "totalDays": 1106,
		  "totalCountries": 7,
		  "totalStates": 25,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 1240,
		  "schedulePercent": 0.557344,
		  "totalGuests": 168,
		  "guestPercent": 0.572303,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "LDLC Arena",
		  "mostGuestCity": "DÃ©cines-Charpieu",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4d41382b5cbe368c0442e454306b36f",
		  
		  "name": "NSR",
		  "createdDate": "2024-05-20 15:37:56",
		  "totalOrganizations": 4,
		  "totalTours": 65,
		  "totalDays": 191,
		  "totalCountries": 18,
		  "totalStates": 23,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4d65186cc424fefd8458f7bb875e91b",
		  
		  "name": "Sam",
		  "createdDate": "2022-11-05 00:15:13",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 1034,
		  "totalCountries": 26,
		  "totalStates": 74,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 2887,
		  "schedulePercent": 0.830802,
		  "totalGuests": 822,
		  "guestPercent": 0.81369,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4d74d61665661a805c4d3a23e666ca3",
		  
		  "name": "Gabriel",
		  "createdDate": "2017-08-30 05:24:55",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 830,
		  "totalCountries": 33,
		  "totalStates": 56,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 2461,
		  "schedulePercent": 0.782412,
		  "totalGuests": 146,
		  "guestPercent": 0.555984,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "San Jose Civic Auditorium",
		  "mostGuestCity": "San Jose",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4d9da302254325321eebcae1e5bc986",
		  
		  "name": "Brielle",
		  "createdDate": "2023-09-26 18:16:12",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 148,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1697,
		  "schedulePercent": 0.658092,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "DNA Lounge",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4dee020cf21792e32fc11102ce7bdfe",
		  
		  "name": "Jarrid ",
		  "createdDate": "2024-11-14 19:13:04",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 713,
		  "totalCountries": 8,
		  "totalStates": 56,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 2038,
		  "schedulePercent": 0.720422,
		  "totalGuests": 1794,
		  "guestPercent": 0.932797,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 157,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4eacf97bdf8aacc48f54793384b72f1",
		  
		  "name": "Katie",
		  "createdDate": "2014-02-27 22:47:30",
		  "totalOrganizations": 14,
		  "totalTours": 13,
		  "totalDays": 1831,
		  "totalCountries": 24,
		  "totalStates": 70,
		  "totalEvents": 283,
		  "eventPercent": 0.900499,
		  "totalScheduleItems": 6493,
		  "schedulePercent": 0.981981,
		  "totalGuests": 1102,
		  "guestPercent": 0.864461,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4f3d424aceb3755faf44697ee2f22b9",
		  
		  "name": "Alizium",
		  "createdDate": "2025-03-13 19:25:11",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 46,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 460,
		  "schedulePercent": 0.294764,
		  "totalGuests": 299,
		  "guestPercent": 0.649139,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Teragram Ballroom",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b4ff720459b02b0d7408a00f38f4e354",
		  
		  "name": "Daniel",
		  "createdDate": "2021-09-10 14:36:09",
		  "totalOrganizations": 13,
		  "totalTours": 13,
		  "totalDays": 337,
		  "totalCountries": 20,
		  "totalStates": 60,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2297,
		  "schedulePercent": 0.761446,
		  "totalGuests": 1012,
		  "guestPercent": 0.848708,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b517eb2bd6c5a434bac7a87cc40c6a35",
		  
		  "name": "Laura",
		  "createdDate": "2012-02-15 20:53:33",
		  "totalOrganizations": 19,
		  "totalTours": 7,
		  "totalDays": 175,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 856,
		  "schedulePercent": 0.442543,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5218f27fc1adf3d3a388ce34af91622",
		  
		  "name": "Pamela",
		  "createdDate": "2016-04-29 15:35:19",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 206,
		  "totalCountries": 12,
		  "totalStates": 25,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 2082,
		  "schedulePercent": 0.729488,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5230186675ab610e47057bc9b47b6d1",
		  
		  "name": "Ben",
		  "createdDate": "2011-09-08 11:48:25",
		  "totalOrganizations": 15,
		  "totalTours": 8,
		  "totalDays": 560,
		  "totalCountries": 12,
		  "totalStates": 45,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1308,
		  "schedulePercent": 0.573323,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Tiki Bar",
		  "mostGuestCity": "Costa Mesa",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b523a6bbf6427561c795ae95af803c29",
		  
		  "name": "Matt",
		  "createdDate": "2023-01-17 19:26:27",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 257,
		  "totalCountries": 4,
		  "totalStates": 49,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1180,
		  "schedulePercent": 0.542384,
		  "totalGuests": 428,
		  "guestPercent": 0.706029,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "House of Blues Boston",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b53409a00ba989241aa8f8664954b3e1",
		  
		  "name": "Sammy",
		  "createdDate": "2022-07-19 15:46:55",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 291,
		  "totalCountries": 19,
		  "totalStates": 56,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 1981,
		  "schedulePercent": 0.709769,
		  "totalGuests": 835,
		  "guestPercent": 0.816296,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5348ce5df7d9ae2ff789d450958371e",
		  
		  "name": "Michael",
		  "createdDate": "2025-07-31 17:59:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 66,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 299,
		  "schedulePercent": 0.217135,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b53dd5ab7f7f5068c7ba2e9e26e9b987",
		  
		  "name": "Madeleine",
		  "createdDate": "2020-02-24 15:35:02",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5521f0491110d9e41da1a8823e0ad19",
		  
		  "name": "Peter",
		  "createdDate": "2018-02-26 21:49:32",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 634,
		  "totalCountries": 20,
		  "totalStates": 40,
		  "totalEvents": 256,
		  "eventPercent": 0.876927,
		  "totalScheduleItems": 2031,
		  "schedulePercent": 0.719175,
		  "totalGuests": 511,
		  "guestPercent": 0.733454,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Scotiabank Centre",
		  "mostGuestCity": "Halifax",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b55a15d6aef47afa1213573b0973a6a6",
		  
		  "name": "Mitchell",
		  "createdDate": "2023-12-29 15:57:36",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 158,
		  "totalCountries": 13,
		  "totalStates": 33,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1097,
		  "schedulePercent": 0.519266,
		  "totalGuests": 625,
		  "guestPercent": 0.764053,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b56f8a824399bf8f8913e6201098a5a0",
		  
		  "name": "Geret",
		  "createdDate": "2024-10-07 11:57:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 65,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 49,
		  "schedulePercent": 0.0596102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b574659410ce12136cd8079f679581c2",
		  
		  "name": "Lindsey",
		  "createdDate": "2016-01-30 21:50:43",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 175,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 925,
		  "schedulePercent": 0.466908,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "PINE KNOB MUSIC THEATRE",
		  "mostGuestCity": "Independence Township",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b57b6371b38700f13bc60af7a8a2726f",
		  
		  "name": "Alexander ",
		  "createdDate": "2020-02-19 04:06:23",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 307,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 1034,
		  "schedulePercent": 0.499887,
		  "totalGuests": 1224,
		  "guestPercent": 0.8784,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Nashville Yards",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5859aafcf09e3802d01fb149d0aebe2",
		  
		  "name": "Kenneth",
		  "createdDate": "2017-06-19 00:17:13",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 1243,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 528,
		  "schedulePercent": 0.326043,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b58b831e1e78c9ec56a975a6ffcd456e",
		  
		  "name": "Helen",
		  "createdDate": "2022-01-05 20:37:10",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 1735,
		  "totalCountries": 8,
		  "totalStates": 66,
		  "totalEvents": 450,
		  "eventPercent": 0.970875,
		  "totalScheduleItems": 5495,
		  "schedulePercent": 0.967362,
		  "totalGuests": 1206,
		  "guestPercent": 0.87636,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b596cafacbbfce24bbbac31697011221",
		  
		  "name": "Kode",
		  "createdDate": "2021-02-24 03:25:48",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 119,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 784,
		  "schedulePercent": 0.417044,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Fallsview Casino Resort",
		  "mostGuestCity": "Niagara Falls",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5a9552a88afcb563e2d2b22fc4b5578",
		  
		  "name": "Jens",
		  "createdDate": "2018-03-23 08:58:57",
		  "totalOrganizations": 19,
		  "totalTours": 21,
		  "totalDays": 434,
		  "totalCountries": 19,
		  "totalStates": 24,
		  "totalEvents": 317,
		  "eventPercent": 0.923617,
		  "totalScheduleItems": 2746,
		  "schedulePercent": 0.815843,
		  "totalGuests": 564,
		  "guestPercent": 0.747507,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Store Vega",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5b4c37b5a719cab88cc7963c97b7e96",
		  
		  "name": "Jesus Antonio",
		  "createdDate": "2024-08-26 02:56:31",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 798,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 716,
		  "schedulePercent": 0.392339,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5c82a7c94fb35a9f4c2c582660bdd15",
		  
		  "name": "John",
		  "createdDate": "2025-03-19 11:14:12",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 15,
		  "totalStates": 13,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 695,
		  "schedulePercent": 0.384406,
		  "totalGuests": 313,
		  "guestPercent": 0.655372,
		  "mostGuestDate": "2025-06-25 00:00:00",
		  "mostGuestName": "Stockholm Fields",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5c84a05dc2fbec461be3fb775c64f88",
		  
		  "name": "Owen",
		  "createdDate": "2019-12-21 01:21:29",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 483,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 279,
		  "eventPercent": 0.897439,
		  "totalScheduleItems": 2583,
		  "schedulePercent": 0.796011,
		  "totalGuests": 1962,
		  "guestPercent": 0.944356,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Palace Theater",
		  "mostGuestCity": "Waterbury",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5cfa019b240263ec9724dec5605b0d6",
		  
		  "name": "Antoine",
		  "createdDate": "2018-05-14 10:46:59",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 105,
		  "totalCountries": 14,
		  "totalStates": 13,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 755,
		  "schedulePercent": 0.407752,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Paleo Festival Nyon",
		  "mostGuestCity": "Nyon",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5d07025124c09cd7e712d21b5eb3296",
		  
		  "name": "Brett",
		  "createdDate": "2009-09-02 21:26:10",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 242,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 483,
		  "schedulePercent": 0.302924,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Lucas Oil Live at WinStar World Casino",
		  "mostGuestCity": "Thackerville",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5dda063f1afe355a117cb3f968e74d0",
		  
		  "name": "Harry",
		  "createdDate": "2017-01-30 21:24:17",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 729,
		  "totalCountries": 3,
		  "totalStates": 33,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1679,
		  "schedulePercent": 0.654578,
		  "totalGuests": 1513,
		  "guestPercent": 0.911151,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5e2033894121bbd0dd6eeb26698afd0",
		  
		  "name": "rodrigo",
		  "createdDate": "2024-04-09 16:49:34",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 103,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 707,
		  "schedulePercent": 0.389166,
		  "totalGuests": 556,
		  "guestPercent": 0.745354,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5e7e1f6c3f4e77d0107aecf2c830553",
		  
		  "name": "Jamie",
		  "createdDate": "2013-07-25 16:13:25",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 44,
		  "totalCountries": 9,
		  "totalStates": 13,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 350,
		  "schedulePercent": 0.242974,
		  "totalGuests": 110,
		  "guestPercent": 0.528105,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "TSB Bank Arena",
		  "mostGuestCity": "Wellington",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b5ed5d35b72d5fcb15591b88fc6c336c",
		  
		  "name": "Doug",
		  "createdDate": "2011-07-06 08:12:30",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 408,
		  "totalCountries": 29,
		  "totalStates": 51,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 2251,
		  "schedulePercent": 0.7551,
		  "totalGuests": 1446,
		  "guestPercent": 0.904238,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6003d56e7ae7e5e5bcb82c80c6ae18e",
		  
		  "name": "Max",
		  "createdDate": "2020-02-29 20:50:30",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 194,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1735,
		  "schedulePercent": 0.664778,
		  "totalGuests": 1010,
		  "guestPercent": 0.848255,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Analog at Hutton Hotel",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 191,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b60abed271439b1657f7e2dc28b1e406",
		  
		  "name": "Info",
		  "createdDate": "2023-06-16 16:16:02",
		  "totalOrganizations": 141,
		  "totalTours": 82,
		  "totalDays": 1217,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 1217,
		  "eventPercent": 0.997507,
		  "totalScheduleItems": 4334,
		  "schedulePercent": 0.93257,
		  "totalGuests": 126,
		  "guestPercent": 0.541364,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b61157c152260bae503bc0a3d14388f4",
		  
		  "name": "Dean",
		  "createdDate": "2023-12-01 22:05:19",
		  "totalOrganizations": 7,
		  "totalTours": 48,
		  "totalDays": 112,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 472,
		  "schedulePercent": 0.299071,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b619c4fd7764637276deabf2821400cd",
		  
		  "name": "Austin",
		  "createdDate": "2015-08-18 23:26:10",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 790,
		  "totalCountries": 13,
		  "totalStates": 54,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 3284,
		  "schedulePercent": 0.866954,
		  "totalGuests": 504,
		  "guestPercent": 0.732208,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Viejas Arena",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6340b74a5a1769f7271134ece693a25",
		  
		  "name": "Jackson",
		  "createdDate": "2017-10-16 23:08:57",
		  "totalOrganizations": 19,
		  "totalTours": 16,
		  "totalDays": 478,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 3810,
		  "schedulePercent": 0.903105,
		  "totalGuests": 3212,
		  "guestPercent": 0.985381,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b635e7a3d01cfa62afc7adca780125d6",
		  
		  "name": "Dane",
		  "createdDate": "2022-11-03 16:20:09",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 84,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 93,
		  "guestPercent": 0.511786,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Masonic Lodge at Hollywood Forever",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b637b1f64597823383ece4324788630d",
		  
		  "name": "Josef",
		  "createdDate": "2014-08-29 09:53:07",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 756,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1494,
		  "schedulePercent": 0.61616,
		  "totalGuests": 528,
		  "guestPercent": 0.737987,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b63e3746eeb068ad040866569b71bc82",
		  
		  "name": "NICKOS",
		  "createdDate": "2018-12-05 11:07:57",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 360,
		  "totalCountries": 7,
		  "totalStates": 30,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 2546,
		  "schedulePercent": 0.791478,
		  "totalGuests": 1022,
		  "guestPercent": 0.850408,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "Zenith de Toulouse",
		  "mostGuestCity": "Toulouse",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b63f79051474bbc676d1a4172e7d37ac",
		  
		  "name": "Sydney",
		  "createdDate": "2023-09-27 17:11:52",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 500,
		  "totalCountries": 10,
		  "totalStates": 38,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1696,
		  "schedulePercent": 0.657978,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b64310cec6f60b68cffb66a44a703cb9",
		  
		  "name": "Dario",
		  "createdDate": "2025-09-02 17:16:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 95,
		  "schedulePercent": 0.0933817,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Ace of Spades",
		  "mostGuestCity": "Sacramento",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b644d508e96f4c95b9024fe28e97bd33",
		  
		  "name": "Tre",
		  "createdDate": "2010-09-17 04:10:54",
		  "totalOrganizations": 19,
		  "totalTours": 11,
		  "totalDays": 299,
		  "totalCountries": 30,
		  "totalStates": 40,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2116,
		  "schedulePercent": 0.734814,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-06-30 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6467573f414476ea074406983b60f31",
		  
		  "name": "Chris",
		  "createdDate": "2020-01-08 12:59:23",
		  "totalOrganizations": 13,
		  "totalTours": 22,
		  "totalDays": 929,
		  "totalCountries": 26,
		  "totalStates": 32,
		  "totalEvents": 428,
		  "eventPercent": 0.964982,
		  "totalScheduleItems": 7250,
		  "schedulePercent": 0.987987,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b65bede97385c261579b01cff9a1455c",
		  
		  "name": "Anthony",
		  "createdDate": "2024-02-24 03:57:08",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 69,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 10,
		  "schedulePercent": 0.0207389,
		  "totalGuests": 160,
		  "guestPercent": 0.565956,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Singing Bird Studio",
		  "mostGuestCity": "Frankston",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b65eee3e4e2333cd971972b6369b9e13",
		  
		  "name": "Michele",
		  "createdDate": "2015-10-02 20:30:52",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 840,
		  "totalCountries": 25,
		  "totalStates": 61,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2955,
		  "schedulePercent": 0.837375,
		  "totalGuests": 233,
		  "guestPercent": 0.614234,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b66361b1d12412f88a56a93084a5468d",
		  
		  "name": "Cath",
		  "createdDate": "2020-02-26 23:46:25",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 92,
		  "schedulePercent": 0.0911151,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "City Recital Hall",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b667cb0f3ea0c90076cbef84d456c22b",
		  
		  "name": "Michael",
		  "createdDate": "2021-08-19 14:07:59",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 278,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 688,
		  "schedulePercent": 0.3818,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b67d659fe52ce8ae138ef5793af056ae",
		  
		  "name": "Howard",
		  "createdDate": "2016-11-25 16:02:20",
		  "totalOrganizations": 5,
		  "totalTours": 21,
		  "totalDays": 181,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 829,
		  "schedulePercent": 0.434157,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6903a71079c7bcce745b15cddc92de4",
		  
		  "name": "Alexandros",
		  "createdDate": "2019-02-17 23:10:25",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 345,
		  "totalCountries": 38,
		  "totalStates": 77,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2487,
		  "schedulePercent": 0.785358,
		  "totalGuests": 1260,
		  "guestPercent": 0.881573,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "013 Poppodium",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b696966264885a0dca49b1601b7ff3c0",
		  
		  "name": "Josh",
		  "createdDate": "2024-09-06 19:11:26",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 361,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 158,
		  "schedulePercent": 0.134066,
		  "totalGuests": 482,
		  "guestPercent": 0.725181,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "The Academy, Middle Abbey Street",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6b1f9008ed75a50ea64a80d333315d6",
		  
		  "name": "Zachariah",
		  "createdDate": "2011-05-27 00:55:08",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 111,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 695,
		  "schedulePercent": 0.384406,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6ceb543ba381fcccb16e3df2000a928",
		  
		  "name": "CJ ",
		  "createdDate": "2023-04-12 15:23:48",
		  "totalOrganizations": 24,
		  "totalTours": 10,
		  "totalDays": 822,
		  "totalCountries": 15,
		  "totalStates": 48,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 3780,
		  "schedulePercent": 0.901065,
		  "totalGuests": 2515,
		  "guestPercent": 0.968495,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Coca-Cola Roxy",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6cf873a5561f8d531b87f5204dfbfa2",
		  
		  "name": "Elise",
		  "createdDate": "2022-12-05 02:37:49",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 218,
		  "totalCountries": 16,
		  "totalStates": 46,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1368,
		  "schedulePercent": 0.588622,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "Admiralspalast",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6d21163c8fc60e3d51e5dc95328b438",
		  
		  "name": "Gavin",
		  "createdDate": "2015-02-10 19:01:25",
		  "totalOrganizations": 11,
		  "totalTours": 28,
		  "totalDays": 1299,
		  "totalCountries": 49,
		  "totalStates": 116,
		  "totalEvents": 352,
		  "eventPercent": 0.94311,
		  "totalScheduleItems": 5206,
		  "schedulePercent": 0.959655,
		  "totalGuests": 1672,
		  "guestPercent": 0.926224,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6d693cf4b1b1aff55021df7d1d88156",
		  
		  "name": "Bryan",
		  "createdDate": "2012-02-08 23:26:18",
		  "totalOrganizations": 22,
		  "totalTours": 16,
		  "totalDays": 429,
		  "totalCountries": 5,
		  "totalStates": 26,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1359,
		  "schedulePercent": 0.587489,
		  "totalGuests": 652,
		  "guestPercent": 0.772099,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6dd508f4bcc8d777d6a676f119205e2",
		  
		  "name": "Graeme",
		  "createdDate": "2018-11-07 13:56:20",
		  "totalOrganizations": 10,
		  "totalTours": 18,
		  "totalDays": 800,
		  "totalCountries": 40,
		  "totalStates": 50,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2738,
		  "schedulePercent": 0.814597,
		  "totalGuests": 518,
		  "guestPercent": 0.735381,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "Edinburgh Usher Hall",
		  "mostGuestCity": "Edinburgh",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6e1be066ca1576944139371995cac0d",
		  
		  "name": "Pete",
		  "a_nickname": "Pete \"NO RULES\"",
		  "createdDate": "2014-04-23 19:37:15",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 290,
		  "totalCountries": 20,
		  "totalStates": 43,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1270,
		  "schedulePercent": 0.56573,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b6f3b543045d3bccb4d8352425c80f32",
		  
		  "name": "Michael",
		  "createdDate": "2019-04-28 18:22:49",
		  "totalOrganizations": 15,
		  "totalTours": 39,
		  "totalDays": 1237,
		  "totalCountries": 13,
		  "totalStates": 73,
		  "totalEvents": 376,
		  "eventPercent": 0.952629,
		  "totalScheduleItems": 5910,
		  "schedulePercent": 0.974615,
		  "totalGuests": 3332,
		  "guestPercent": 0.987987,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b70151c91e626ac94072a1af34b76606",
		  
		  "name": "Will",
		  "createdDate": "2016-11-17 18:15:22",
		  "totalOrganizations": 25,
		  "totalTours": 19,
		  "totalDays": 500,
		  "totalCountries": 19,
		  "totalStates": 40,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2261,
		  "schedulePercent": 0.7568,
		  "totalGuests": 736,
		  "guestPercent": 0.793291,
		  "mostGuestDate": "2025-03-05 00:00:00",
		  "mostGuestName": "Bristol Beacon",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b70b69e66e6309ba8d3771bfa02f9b51",
		  
		  "name": "Darren",
		  "createdDate": "2024-01-16 20:52:31",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 434,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 915,
		  "schedulePercent": 0.463055,
		  "totalGuests": 105,
		  "guestPercent": 0.524932,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "The Orange Peel",
		  "mostGuestCity": "Asheville",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b718d23469991da26ad1521d42ac1ff0",
		  
		  "name": "Michael",
		  "createdDate": "2017-10-11 00:48:47",
		  "totalOrganizations": 6,
		  "totalTours": 28,
		  "totalDays": 458,
		  "totalCountries": 22,
		  "totalStates": 33,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1947,
		  "schedulePercent": 0.703196,
		  "totalGuests": 451,
		  "guestPercent": 0.713055,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Hitchin Priory",
		  "mostGuestCity": "Hitchin",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b71a01cac146d8befb2b9250def5c713",
		  
		  "name": "Dalton",
		  "createdDate": "2025-02-03 02:29:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 44,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 53,
		  "schedulePercent": 0.0618767,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Cain's Ballroom",
		  "mostGuestCity": "Tulsa",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b71c68778e2abcecb7a0667f273d482f",
		  
		  "name": "Jack",
		  "createdDate": "2022-05-31 17:34:54",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 506,
		  "totalCountries": 14,
		  "totalStates": 59,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 1968,
		  "schedulePercent": 0.707616,
		  "totalGuests": 734,
		  "guestPercent": 0.793064,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b71dca3aa63ddd79f476dcbb615ae9ba",
		  
		  "name": "liv",
		  "createdDate": "2019-03-29 13:33:11",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 411,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 683,
		  "schedulePercent": 0.380326,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rn",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b71e9261854b62b9a5c57223e7b1e16e",
		  
		  "name": "Simon",
		  "createdDate": "2025-05-28 20:55:36",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 155,
		  "totalCountries": 9,
		  "totalStates": 25,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1014,
		  "schedulePercent": 0.494447,
		  "totalGuests": 221,
		  "guestPercent": 0.607774,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Liberty Hall",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b72d17a983cbcf1cc9dade0703da6f51",
		  
		  "name": "Maarten",
		  "createdDate": "2018-12-07 21:09:45",
		  "totalOrganizations": 21,
		  "totalTours": 30,
		  "totalDays": 1314,
		  "totalCountries": 32,
		  "totalStates": 80,
		  "totalEvents": 451,
		  "eventPercent": 0.971215,
		  "totalScheduleItems": 3687,
		  "schedulePercent": 0.895286,
		  "totalGuests": 977,
		  "guestPercent": 0.842588,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b739426257519ab2493341fb7a7462f2",
		  
		  "name": "CCM",
		  "createdDate": "2025-03-31 18:21:27",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 257,
		  "totalCountries": 10,
		  "totalStates": 36,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 930,
		  "schedulePercent": 0.468835,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b741c32dc3727425d22bfb2965d3031b",
		  
		  "name": "Yvetta",
		  "createdDate": "2015-04-30 10:38:28",
		  "totalOrganizations": 9,
		  "totalTours": 2,
		  "totalDays": 319,
		  "totalCountries": 7,
		  "totalStates": 13,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 809,
		  "schedulePercent": 0.426337,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Shenzhen Universiade Sports Centre",
		  "mostGuestCity": "Shen Zhen Shi",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b745d1d28aae4478b601574849446794",
		  
		  "name": "Lisa",
		  "createdDate": "2023-02-15 23:39:13",
		  "totalOrganizations": 2,
		  "totalTours": 18,
		  "totalDays": 209,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 297,
		  "schedulePercent": 0.216342,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-01-28 00:00:00",
		  "mostGuestName": "Maltz Jupiter Theatre Inc",
		  "mostGuestCity": "Jupiter",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b74a5d937158be07018b0d4b821acd49",
		  
		  "name": "Arianna",
		  "createdDate": "2019-08-24 02:27:57",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 56,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 51,
		  "schedulePercent": 0.0606301,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b752b48e8bd1aa3545d08c428d15a581",
		  
		  "name": "James",
		  "createdDate": "2016-09-18 02:34:35",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 224,
		  "totalCountries": 21,
		  "totalStates": 52,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1830,
		  "schedulePercent": 0.681437,
		  "totalGuests": 877,
		  "guestPercent": 0.824229,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b75340911713077aad46254d3bbedc67",
		  
		  "name": "John",
		  "createdDate": "2011-09-28 18:46:43",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 292,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 6,
		  "eventPercent": 0.0499773,
		  "totalScheduleItems": 93,
		  "schedulePercent": 0.0917951,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Logomo",
		  "mostGuestCity": "Ã…bo",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b75afad7cfac9c33f4079bf444fbf310",
		  
		  "name": "Kiley",
		  "createdDate": "2021-10-18 17:37:28",
		  "totalOrganizations": 7,
		  "totalTours": 15,
		  "totalDays": 1410,
		  "totalCountries": 10,
		  "totalStates": 40,
		  "totalEvents": 331,
		  "eventPercent": 0.933364,
		  "totalScheduleItems": 4795,
		  "schedulePercent": 0.947416,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b770be5c7f93e7b65436d96d0ae95878",
		  
		  "name": "Alice",
		  "createdDate": "2025-08-26 12:35:23",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 28,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 79,
		  "schedulePercent": 0.081029,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Scalateatern ",
		  "mostGuestCity": "Karlstad",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b782634c8e0ed0db7814cfb929fe31ba",
		  
		  "name": "Luvanmusiq ",
		  "createdDate": "2016-04-18 17:34:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 59,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 694,
		  "schedulePercent": 0.38418,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Texas Trust CU Theatre at Grand Prairie",
		  "mostGuestCity": "Grand Prairie",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7961e650d933d7bcf8f4f99d9bb539e",
		  
		  "name": "Chris",
		  "createdDate": "2013-08-13 04:46:30",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 295,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1193,
		  "schedulePercent": 0.545898,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Fantasy Springs Casino",
		  "mostGuestCity": "Indio",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b79ff2bb29c3fd8ce0c39a3cfe59c547",
		  
		  "name": "Eric",
		  "createdDate": "2022-05-05 20:59:26",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 439,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 444,
		  "schedulePercent": 0.288078,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Elsewhere",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7a1e9c3ca658a588450f0d781aff295",
		  
		  "name": "Fay ",
		  "createdDate": "2024-05-02 22:47:16",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 69,
		  "totalCountries": 11,
		  "totalStates": 17,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 554,
		  "schedulePercent": 0.335109,
		  "totalGuests": 180,
		  "guestPercent": 0.580009,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Santa Barbara Bowl",
		  "mostGuestCity": "Santa Barbara",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7a8e8dbb53b7317e4c1d94d7c383d36",
		  
		  "name": "Eros",
		  "createdDate": "2024-01-12 19:19:28",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 6,
		  "totalStates": 28,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 113,
		  "schedulePercent": 0.106754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7ab09baf9521ce5cc21794b9a2dbd18",
		  
		  "name": "Mark ",
		  "createdDate": "2014-09-19 05:27:54",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 278,
		  "totalCountries": 23,
		  "totalStates": 36,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1266,
		  "schedulePercent": 0.564937,
		  "totalGuests": 765,
		  "guestPercent": 0.799637,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7c5e624bcd040bb9e37b2ad35c5d741",
		  
		  "name": "Tour",
		  "createdDate": "2023-09-13 16:30:21",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 217,
		  "totalCountries": 4,
		  "totalStates": 46,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1241,
		  "schedulePercent": 0.558024,
		  "totalGuests": 630,
		  "guestPercent": 0.765526,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7dc390f7dfcf1a4814fed38c91d43f5",
		  
		  "name": "Mark",
		  "createdDate": "2010-08-12 03:53:26",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 723,
		  "totalCountries": 20,
		  "totalStates": 57,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 2236,
		  "schedulePercent": 0.753286,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Frederick Brown Jr Amphitheater",
		  "mostGuestCity": "Peachtree City",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7df8d43756502b607d12c1d559b366f",
		  
		  "name": "Alicia",
		  "createdDate": "2022-04-23 21:54:31",
		  "totalOrganizations": 4,
		  "totalTours": 10,
		  "totalDays": 280,
		  "totalCountries": 6,
		  "totalStates": 34,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1337,
		  "schedulePercent": 0.582729,
		  "totalGuests": 221,
		  "guestPercent": 0.607774,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7e0f12485d393084d2248de6120f7a2",
		  
		  "name": "Kamal",
		  "createdDate": "2016-04-14 15:42:18",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 984,
		  "totalCountries": 10,
		  "totalStates": 29,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1114,
		  "schedulePercent": 0.521872,
		  "totalGuests": 214,
		  "guestPercent": 0.604828,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "The Van Buren",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7ee34426efcc6f34db2981efe5c6a6f",
		  
		  "name": "Lexi",
		  "createdDate": "2017-08-24 04:16:36",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 51,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 231,
		  "schedulePercent": 0.178377,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Jackson-Triggs",
		  "mostGuestCity": "Niagara-on-the-Lake",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b7f157805f16549a604c61e62c23c8bb",
		  
		  "name": "Jeff",
		  "createdDate": "2018-06-12 17:33:46",
		  "totalOrganizations": 16,
		  "totalTours": 20,
		  "totalDays": 1853,
		  "totalCountries": 10,
		  "totalStates": 45,
		  "totalEvents": 277,
		  "eventPercent": 0.896079,
		  "totalScheduleItems": 2740,
		  "schedulePercent": 0.814823,
		  "totalGuests": 1173,
		  "guestPercent": 0.87364,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Massey Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b80185a97688485d8a702d4f960c93b9",
		  
		  "name": "Alexander",
		  "createdDate": "2023-09-05 14:17:55",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 153,
		  "totalCountries": 20,
		  "totalStates": 42,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 483,
		  "schedulePercent": 0.302924,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b80463926a2a57ece236271f0df8d1b4",
		  
		  "name": "WAM",
		  "createdDate": "2022-04-05 15:10:02",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 177,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1658,
		  "schedulePercent": 0.651292,
		  "totalGuests": 574,
		  "guestPercent": 0.750567,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "The Walmart AMP",
		  "mostGuestCity": "Rogers",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b809209cdf4cf5adf8fd7c2ad19dc78d",
		  
		  "name": "Craig",
		  "createdDate": "2013-09-24 01:19:26",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 487,
		  "totalCountries": 13,
		  "totalStates": 41,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2367,
		  "schedulePercent": 0.771079,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8128fcc086b8821f1c96279a177b37a",
		  
		  "name": "Cole",
		  "createdDate": "2015-06-21 07:44:14",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 98,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 915,
		  "schedulePercent": 0.463055,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "The Caverns",
		  "mostGuestCity": "Pelham",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b814c4b399a78eed825c02273dc23205",
		  
		  "name": "Andrew",
		  "createdDate": "2015-07-08 19:42:24",
		  "totalOrganizations": 16,
		  "totalTours": 15,
		  "totalDays": 1464,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 278,
		  "eventPercent": 0.896872,
		  "totalScheduleItems": 3598,
		  "schedulePercent": 0.889053,
		  "totalGuests": 1222,
		  "guestPercent": 0.87806,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b81a6137fec3267a80aae31f7fbef88c",
		  
		  "name": "Curtis",
		  "createdDate": "2017-04-17 22:11:08",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 23,
		  "totalStates": 57,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 3361,
		  "schedulePercent": 0.871827,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8262bbc2f58b7c01160045151991a0e",
		  
		  "name": "Deneen ",
		  "createdDate": "2023-08-10 22:58:03",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 182,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 805,
		  "schedulePercent": 0.424524,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b82e39d3b996db1bd69154c6f2451948",
		  
		  "name": "Tom",
		  "createdDate": "2013-09-12 14:04:10",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 645,
		  "totalCountries": 18,
		  "totalStates": 30,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1539,
		  "schedulePercent": 0.625113,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "Governor's Ball Music Festival",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b82e3ae18fbeb64adac25afe3c8bb9c1",
		  
		  "name": "Robert",
		  "createdDate": "2010-02-09 20:36:39",
		  "totalOrganizations": 19,
		  "totalTours": 18,
		  "totalDays": 2519,
		  "totalCountries": 10,
		  "totalStates": 58,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 5580,
		  "schedulePercent": 0.969288,
		  "totalGuests": 3125,
		  "guestPercent": 0.984474,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b83f777fc422041c11ae8ae82c9ec302",
		  
		  "name": "Liam",
		  "createdDate": "2018-10-22 21:40:35",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 439,
		  "totalCountries": 6,
		  "totalStates": 54,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2813,
		  "schedulePercent": 0.824003,
		  "totalGuests": 1164,
		  "guestPercent": 0.872733,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b841cf3105fe83df5389361fdffdd496",
		  
		  "name": "Mathew",
		  "createdDate": "2018-09-05 17:11:23",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 945,
		  "totalCountries": 21,
		  "totalStates": 62,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2646,
		  "schedulePercent": 0.802584,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b84b7dd8bc880490cf133de9b8eb9fc8",
		  
		  "name": "Chris ",
		  "createdDate": "2019-07-30 15:34:38",
		  "totalOrganizations": 11,
		  "totalTours": 19,
		  "totalDays": 2553,
		  "totalCountries": 24,
		  "totalStates": 82,
		  "totalEvents": 509,
		  "eventPercent": 0.980281,
		  "totalScheduleItems": 6303,
		  "schedulePercent": 0.979374,
		  "totalGuests": 1662,
		  "guestPercent": 0.925204,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b84e4fbd82dc5893a0beb79fe6d7206d",
		  
		  "name": "Zouave",
		  "createdDate": "2021-05-31 12:28:11",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 144,
		  "totalCountries": 9,
		  "totalStates": 23,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1194,
		  "schedulePercent": 0.546124,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b85110012850f9313d2567b89f6990f6",
		  
		  "name": "Chris",
		  "createdDate": "2022-03-25 21:14:05",
		  "totalOrganizations": 4,
		  "totalTours": 17,
		  "totalDays": 1959,
		  "totalCountries": 16,
		  "totalStates": 57,
		  "totalEvents": 260,
		  "eventPercent": 0.881573,
		  "totalScheduleItems": 2678,
		  "schedulePercent": 0.806777,
		  "totalGuests": 226,
		  "guestPercent": 0.610607,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b85b558706fa2b0f6777cc3c43d40b43",
		  
		  "name": "Jake",
		  "createdDate": "2010-01-26 17:15:45",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 840,
		  "totalCountries": 14,
		  "totalStates": 47,
		  "totalEvents": 300,
		  "eventPercent": 0.913078,
		  "totalScheduleItems": 6337,
		  "schedulePercent": 0.979714,
		  "totalGuests": 713,
		  "guestPercent": 0.788871,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b85cd60b3d8f63d110ca2d08d251a419",
		  
		  "name": "Big",
		  "createdDate": "2018-03-18 00:27:09",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 50,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 364,
		  "schedulePercent": 0.25,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b86505fa14b091a3f2d4a2b90318a7af",
		  
		  "name": "Kam",
		  "createdDate": "2017-08-17 17:02:27",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 406,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 2983,
		  "schedulePercent": 0.841002,
		  "totalGuests": 1004,
		  "guestPercent": 0.847008,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 177,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b869d109b79f1dd49b5365ce248ccb69",
		  
		  "name": "Ben",
		  "createdDate": "2010-03-18 16:27:23",
		  "totalOrganizations": 21,
		  "totalTours": 9,
		  "totalDays": 1213,
		  "totalCountries": 42,
		  "totalStates": 47,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 3602,
		  "schedulePercent": 0.889506,
		  "totalGuests": 566,
		  "guestPercent": 0.74796,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b86aab9cecc7e2da3d86eb5a23dd92f1",
		  
		  "name": "Jeremiah ",
		  "createdDate": "2025-09-19 17:09:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 28,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 349,
		  "schedulePercent": 0.24252,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-10-06 00:00:00",
		  "mostGuestName": "the orpheum ",
		  "mostGuestCity": "Tampa ",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b86acad978436dae00f603fb776dc410",
		  
		  "name": "Morgan",
		  "createdDate": "2020-01-07 18:08:55",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 222,
		  "totalCountries": 17,
		  "totalStates": 28,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 341,
		  "schedulePercent": 0.239121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b86e4f4bcc30c16aaa361b5f1d5bf071",
		  
		  "name": "Scott",
		  "createdDate": "2010-03-03 23:05:34",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 472,
		  "totalCountries": 12,
		  "totalStates": 47,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 3030,
		  "schedulePercent": 0.844855,
		  "totalGuests": 1716,
		  "guestPercent": 0.92883,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b877c2f92bea9ab9f56564b62ca3256f",
		  
		  "name": "135",
		  "createdDate": "2025-03-27 15:01:40",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 247,
		  "totalCountries": 8,
		  "totalStates": 21,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 853,
		  "schedulePercent": 0.441296,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Rockhal",
		  "mostGuestCity": "Esch-sur-Alzette",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b87b34198864c4a9cb3f7ab05d474995",
		  
		  "name": "Casey",
		  "createdDate": "2017-01-16 06:21:59",
		  "totalOrganizations": 3,
		  "totalTours": 14,
		  "totalDays": 293,
		  "totalCountries": 20,
		  "totalStates": 57,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1070,
		  "schedulePercent": 0.510426,
		  "totalGuests": 908,
		  "guestPercent": 0.831709,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Powerstation",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b894a9ebc8fceb12212103b1c228211f",
		  
		  "name": "John ",
		  "createdDate": "2023-09-28 22:08:07",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 122,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 430,
		  "schedulePercent": 0.281958,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b898b23cf9c57ca9ce0c22135cc9a4d1",
		  
		  "name": "Meg",
		  "createdDate": "2020-03-02 22:46:13",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 416,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 4846,
		  "schedulePercent": 0.948889,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b899fc61ea72ff19a36daa57df4c49bb",
		  
		  "name": "Sam",
		  "createdDate": "2023-10-02 22:42:25",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 154,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 685,
		  "schedulePercent": 0.381006,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b89a5f50709ea5bf0dfe6f0c15ee10c5",
		  
		  "name": "Hayato",
		  "createdDate": "2024-05-21 21:02:09",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 99,
		  "totalCountries": 22,
		  "totalStates": 36,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 710,
		  "schedulePercent": 0.390639,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8ad05e79ad2e50eed77db2aa8ec4b3e",
		  
		  "name": "Phoebe",
		  "createdDate": "2024-05-27 12:28:34",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 226,
		  "totalCountries": 20,
		  "totalStates": 15,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1567,
		  "schedulePercent": 0.63384,
		  "totalGuests": 293,
		  "guestPercent": 0.646306,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8ad16fba7146d2dd8adf5f40b8d0ec1",
		  
		  "name": "Justin",
		  "createdDate": "2025-04-30 22:41:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 244,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 470,
		  "schedulePercent": 0.298277,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8b9b18d5d30a535eef048abf41781a7",
		  
		  "name": "Wojciech",
		  "createdDate": "2016-01-16 23:48:48",
		  "totalOrganizations": 23,
		  "totalTours": 26,
		  "totalDays": 874,
		  "totalCountries": 36,
		  "totalStates": 106,
		  "totalEvents": 348,
		  "eventPercent": 0.941523,
		  "totalScheduleItems": 3784,
		  "schedulePercent": 0.901632,
		  "totalGuests": 882,
		  "guestPercent": 0.825703,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Somerset House",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8bd0e48104c5d6a331d90c446aa6876",
		  
		  "name": "Graham",
		  "createdDate": "2019-12-27 04:02:13",
		  "totalOrganizations": 10,
		  "totalTours": 17,
		  "totalDays": 591,
		  "totalCountries": 18,
		  "totalStates": 65,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 3988,
		  "schedulePercent": 0.912851,
		  "totalGuests": 542,
		  "guestPercent": 0.741387,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "New Jersey Performing Arts Center (NJPAC)",
		  "mostGuestCity": "Newark",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8c69a629862f1cb1313fd8e8120f960",
		  
		  "name": "Nicole",
		  "createdDate": "2018-04-04 23:48:51",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 178,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 951,
		  "schedulePercent": 0.475861,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8d969c999ae8c8a94126861c1006445",
		  
		  "name": "Hanna",
		  "createdDate": "2024-05-16 13:39:33",
		  "totalOrganizations": 1,
		  "totalTours": 24,
		  "totalDays": 141,
		  "totalCountries": 19,
		  "totalStates": 32,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 1378,
		  "guestPercent": 0.897325,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8dbc81194dee3367ee5ef29f650a4d2",
		  
		  "name": "Carson",
		  "createdDate": "2024-06-03 19:35:02",
		  "totalOrganizations": 2,
		  "totalTours": 19,
		  "totalDays": 438,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1768,
		  "schedulePercent": 0.671011,
		  "totalGuests": 1506,
		  "guestPercent": 0.909678,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8de8186533e6a46b60c14e864a4bc08",
		  
		  "name": "Jason ",
		  "createdDate": "2017-05-09 01:32:21",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 291,
		  "totalCountries": 13,
		  "totalStates": 44,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1130,
		  "schedulePercent": 0.528105,
		  "totalGuests": 333,
		  "guestPercent": 0.666931,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8e59b226aef70a7dac555386036043b",
		  
		  "name": "Megan",
		  "createdDate": "2020-02-10 18:43:45",
		  "totalOrganizations": 17,
		  "totalTours": 30,
		  "totalDays": 613,
		  "totalCountries": 14,
		  "totalStates": 55,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 2736,
		  "schedulePercent": 0.813803,
		  "totalGuests": 525,
		  "guestPercent": 0.737307,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "ICON Festival stage at small park",
		  "mostGuestCity": "Cincinnati",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8f670db8ddf23e30d913e1cb132f669",
		  
		  "name": "Toby",
		  "createdDate": "2023-11-12 22:57:10",
		  "totalOrganizations": 20,
		  "totalTours": 19,
		  "totalDays": 277,
		  "totalCountries": 17,
		  "totalStates": 31,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1479,
		  "schedulePercent": 0.612421,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Viejas Arena",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b8fa4bd1c9d0a3bc704714d102566e8d",
		  
		  "name": "Dane",
		  "createdDate": "2025-06-30 19:27:25",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 47,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 250,
		  "schedulePercent": 0.189937,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9026f080290dcd3330e0b5bac53e14e",
		  
		  "name": "John",
		  "createdDate": "2019-01-23 05:08:23",
		  "totalOrganizations": 13,
		  "totalTours": 21,
		  "totalDays": 1073,
		  "totalCountries": 15,
		  "totalStates": 27,
		  "totalEvents": 614,
		  "eventPercent": 0.988101,
		  "totalScheduleItems": 3441,
		  "schedulePercent": 0.878286,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b90e44f770828d599eedff49cbc39387",
		  
		  "name": "Loft",
		  "createdDate": "2023-07-06 12:58:58",
		  "totalOrganizations": 26,
		  "totalTours": 7,
		  "totalDays": 877,
		  "totalCountries": 11,
		  "totalStates": 61,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 1807,
		  "schedulePercent": 0.677244,
		  "totalGuests": 665,
		  "guestPercent": 0.775725,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "The Orpheum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9116bff4109a6dbdac9f548435edb27",
		  
		  "name": "Riina",
		  "createdDate": "2022-10-17 20:42:31",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 51,
		  "totalCountries": 6,
		  "totalStates": 4,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 383,
		  "schedulePercent": 0.259859,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b91410af84fc4b93c073edb27fb1cb27",
		  
		  "name": "Ryan",
		  "createdDate": "2017-11-23 22:08:24",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 140,
		  "totalCountries": 20,
		  "totalStates": 28,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 971,
		  "schedulePercent": 0.481641,
		  "totalGuests": 211,
		  "guestPercent": 0.603128,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Columbia Theater",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9258267749c81892eed8d1474c26876",
		  
		  "name": "Louis",
		  "createdDate": "2018-07-07 00:55:25",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 289,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 270,
		  "schedulePercent": 0.199569,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b925eaeec93cf6b75cb0046ad10c8efa",
		  
		  "name": "Jed",
		  "createdDate": "2025-05-06 00:47:59",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 134,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 239,
		  "schedulePercent": 0.184157,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Fox Cabaret",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b92c08d2f527872c1f8e0de8fc46f58d",
		  
		  "name": "Mookie",
		  "createdDate": "2021-03-26 15:00:33",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 61,
		  "totalCountries": 4,
		  "totalStates": 4,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9309738bf98f3b7abf6e77cbfcf014e",
		  
		  "name": "Chris ",
		  "createdDate": "2016-03-02 23:26:58",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 808,
		  "totalCountries": 13,
		  "totalStates": 57,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 3117,
		  "schedulePercent": 0.852901,
		  "totalGuests": 255,
		  "guestPercent": 0.627493,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b93933b421d27068ad2c288368da7208",
		  
		  "name": "Carsten",
		  "createdDate": "2023-02-01 20:54:13",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 457,
		  "totalCountries": 6,
		  "totalStates": 4,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 82,
		  "schedulePercent": 0.0838622,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b93ee9cc87e0bdefd8966193bf4a0457",
		  
		  "name": "Chris",
		  "createdDate": "2011-06-27 06:12:30",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 682,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 2459,
		  "schedulePercent": 0.782072,
		  "totalGuests": 216,
		  "guestPercent": 0.605961,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Egyptian Room at Old National Centre",
		  "mostGuestCity": "Indianapolis",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b94577d86d194e6cc7f9dee8f9f78625",
		  
		  "name": "James",
		  "createdDate": "2016-07-15 20:46:29",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 798,
		  "totalCountries": 14,
		  "totalStates": 67,
		  "totalEvents": 243,
		  "eventPercent": 0.864347,
		  "totalScheduleItems": 2550,
		  "schedulePercent": 0.792611,
		  "totalGuests": 2263,
		  "guestPercent": 0.960675,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b94ce11f54b29f85cd2edc0925db4777",
		  
		  "name": "Simon",
		  "createdDate": "2022-07-19 01:37:27",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 91,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 468,
		  "schedulePercent": 0.297484,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b95a1440dd72b706a134d2ee05cff257",
		  
		  "name": "Harry",
		  "createdDate": "2023-02-08 10:38:16",
		  "totalOrganizations": 24,
		  "totalTours": 12,
		  "totalDays": 282,
		  "totalCountries": 19,
		  "totalStates": 12,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 768,
		  "schedulePercent": 0.411831,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b95a44e198b673bca4ede7da468cacff",
		  
		  "name": "Leela",
		  "createdDate": "2025-02-13 08:52:13",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 29,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-02-24 00:00:00",
		  "mostGuestName": "The Drive Adelaide",
		  "mostGuestCity": "North Adelaide",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b95fba5779a422b8a0ae3b7554932359",
		  
		  "name": "Charles",
		  "createdDate": "2021-10-22 16:04:54",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 9,
		  "totalStates": 41,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1558,
		  "schedulePercent": 0.632026,
		  "totalGuests": 514,
		  "guestPercent": 0.733908,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Agora Theatre",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b963ddfc1abd8ef648d43134eb19ed6f",
		  
		  "name": "ADAM",
		  "createdDate": "2025-01-10 21:16:10",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 2551,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 689,
		  "schedulePercent": 0.38214,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b96b855fedcd6cd0fadcb6a274ab7f7e",
		  
		  "name": "Tim ",
		  "createdDate": "2018-10-04 03:32:57",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 295,
		  "totalCountries": 13,
		  "totalStates": 47,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1694,
		  "schedulePercent": 0.657525,
		  "totalGuests": 621,
		  "guestPercent": 0.763486,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9714832fe2b98e55e1a864e9c5e3354",
		  
		  "name": "Warren",
		  "createdDate": "2009-10-07 19:38:59",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 365,
		  "totalCountries": 22,
		  "totalStates": 47,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 2179,
		  "schedulePercent": 0.7449,
		  "totalGuests": 1617,
		  "guestPercent": 0.921238,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b976159bcba62396d945297f5885fa53",
		  
		  "name": "Kevin",
		  "createdDate": "2015-06-16 17:51:17",
		  "totalOrganizations": 20,
		  "totalTours": 14,
		  "totalDays": 253,
		  "totalCountries": 18,
		  "totalStates": 27,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1528,
		  "schedulePercent": 0.622733,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b98ff4085632d54ca5128716f572df05",
		  
		  "name": "Demun",
		  "createdDate": "2014-10-09 23:13:25",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 280,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 156,
		  "schedulePercent": 0.132706,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b998bbfb6cd747ee19236f959b718726",
		  
		  "name": "natalie",
		  "createdDate": "2022-08-25 13:49:37",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 416,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 4846,
		  "schedulePercent": 0.948889,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b99add9ae3ba732defcfb6385e0a5023",
		  
		  "name": "Andrew",
		  "createdDate": "2023-02-27 04:14:28",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 121,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 371,
		  "schedulePercent": 0.253853,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b99bf57f8012aecd6f3b8006b3ef4272",
		  
		  "name": "Thomas",
		  "createdDate": "2025-09-11 18:32:41",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 13,
		  "totalStates": 12,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 208,
		  "schedulePercent": 0.165005,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b99d44cddd441a1c37fabee38095ad05",
		  
		  "name": "Sasha",
		  "createdDate": "2017-02-07 01:43:52",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 269,
		  "totalCountries": 14,
		  "totalStates": 20,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9a5c2515802e6f451843bd96e554192",
		  
		  "name": "Tori",
		  "createdDate": "2024-07-09 19:38:30",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 372,
		  "totalCountries": 27,
		  "totalStates": 50,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1681,
		  "schedulePercent": 0.654805,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9a5f23eae4a11f620d89845f726a916",
		  
		  "name": "Lesline",
		  "createdDate": "2024-07-10 11:12:29",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 170,
		  "totalCountries": 22,
		  "totalStates": 53,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1262,
		  "schedulePercent": 0.56335,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "CHALK",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9afc78a31d2c639d74a6c807b46b43e",
		  
		  "name": "Chris",
		  "createdDate": "2025-02-17 23:49:31",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 290,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1155,
		  "schedulePercent": 0.535585,
		  "totalGuests": 111,
		  "guestPercent": 0.529125,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Portland Jazz Festival",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9b49ba78e6449806225d68c5e056b65",
		  
		  "name": "Zane",
		  "createdDate": "2017-08-10 19:19:23",
		  "totalOrganizations": 20,
		  "totalTours": 36,
		  "totalDays": 1059,
		  "totalCountries": 41,
		  "totalStates": 99,
		  "totalEvents": 346,
		  "eventPercent": 0.940503,
		  "totalScheduleItems": 3508,
		  "schedulePercent": 0.88248,
		  "totalGuests": 820,
		  "guestPercent": 0.81301,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9c0608a05d647a7a2aefbb955d4b9a1",
		  
		  "name": "Ethan",
		  "createdDate": "2025-03-27 22:43:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 67,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 191,
		  "schedulePercent": 0.153672,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9c62d73a78a8b3816e510ad2bbd3632",
		  
		  "name": "Katiel",
		  "createdDate": "2017-06-26 21:31:01",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 321,
		  "totalCountries": 26,
		  "totalStates": 73,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 3450,
		  "schedulePercent": 0.878853,
		  "totalGuests": 2482,
		  "guestPercent": 0.967022,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9cbadba0cfab84cd57be79bb6d54442",
		  
		  "name": "Peter",
		  "createdDate": "2009-09-14 22:12:17",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 248,
		  "totalCountries": 16,
		  "totalStates": 17,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 716,
		  "schedulePercent": 0.392339,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9d0517eb8f72f27b5aaf916198590c3",
		  
		  "name": "Adam ",
		  "createdDate": "2013-11-13 20:24:20",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 1072,
		  "totalCountries": 15,
		  "totalStates": 48,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 2315,
		  "schedulePercent": 0.763939,
		  "totalGuests": 1222,
		  "guestPercent": 0.87806,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9d9bee18021a5e114a83165fa01d190",
		  
		  "name": "Vicky",
		  "createdDate": "2024-06-19 21:51:59",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 306,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 383,
		  "schedulePercent": 0.259859,
		  "totalGuests": 110,
		  "guestPercent": 0.528105,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "TSB Bank Arena",
		  "mostGuestCity": "Wellington",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "b9e6350016d42e6514f84321a9ca0814",
		  
		  "name": "Julian",
		  "createdDate": "2017-09-15 18:28:12",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 809,
		  "totalCountries": 10,
		  "totalStates": 47,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1469,
		  "schedulePercent": 0.610947,
		  "totalGuests": 240,
		  "guestPercent": 0.61922,
		  "mostGuestDate": "2025-01-28 00:00:00",
		  "mostGuestName": "Tipitina's Uptown",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba026635846677843d56be89319b46e5",
		  
		  "name": "Tobias",
		  "createdDate": "2013-04-29 14:13:58",
		  "totalOrganizations": 52,
		  "totalTours": 40,
		  "totalDays": 1148,
		  "totalCountries": 20,
		  "totalStates": 24,
		  "totalEvents": 1050,
		  "eventPercent": 0.995807,
		  "totalScheduleItems": 5015,
		  "schedulePercent": 0.954669,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba047553cc0dbe0a6b40fc9dafda1ad8",
		  
		  "name": "Richard",
		  "createdDate": "2024-11-25 16:37:30",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 74,
		  "totalCountries": 10,
		  "totalStates": 9,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 658,
		  "schedulePercent": 0.370807,
		  "totalGuests": 723,
		  "guestPercent": 0.791138,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 91,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba12ca137d67bc84a4e737e7a215d71b",
		  
		  "name": "Alex",
		  "createdDate": "2022-10-23 23:54:36",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 69,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 296,
		  "schedulePercent": 0.215549,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Sandstone Point Hotel",
		  "mostGuestCity": "Sandstone Point",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba140b9016197821bc61ba2afa4d59f4",
		  
		  "name": "Emily ",
		  "createdDate": "2024-03-11 16:45:23",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 364,
		  "schedulePercent": 0.25,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba1a974dea5fde86feec2308e81fe194",
		  
		  "name": "IVAN",
		  "createdDate": "2024-09-12 21:55:20",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 399,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 219,
		  "schedulePercent": 0.171238,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba1b9238c5e1e3561a9f1a317ff5011b",
		  
		  "name": "Ania",
		  "createdDate": "2022-05-23 13:37:17",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 381,
		  "totalCountries": 26,
		  "totalStates": 40,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1649,
		  "schedulePercent": 0.649932,
		  "totalGuests": 723,
		  "guestPercent": 0.791138,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba1cd5ace8f8e5a0f4de38979710f5e1",
		  
		  "name": "Joshua",
		  "createdDate": "2024-04-03 21:49:42",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 747,
		  "totalCountries": 8,
		  "totalStates": 56,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 1860,
		  "schedulePercent": 0.686877,
		  "totalGuests": 220,
		  "guestPercent": 0.607434,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "Phoenix Concert Theatre",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba1f7f2bd97eba7c0ba6a5bffddae172",
		  
		  "name": "Francia",
		  "createdDate": "2023-09-24 21:12:38",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 404,
		  "totalCountries": 19,
		  "totalStates": 28,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1751,
		  "schedulePercent": 0.668858,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba4bd00c5e4ad356edcee12a11c2bc38",
		  
		  "name": "Timo",
		  "createdDate": "2016-10-18 19:58:39",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 94,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 809,
		  "schedulePercent": 0.426337,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba565e17197ab5533a5dfa9f5e754f62",
		  
		  "name": "antoine",
		  "createdDate": "2024-12-27 15:30:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba5692d4709e954ea48b4702cfcbb771",
		  
		  "name": "Ariel",
		  "createdDate": "2013-06-11 15:42:59",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 182,
		  "totalCountries": 6,
		  "totalStates": 36,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 543,
		  "schedulePercent": 0.331369,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-12-12 00:00:00",
		  "mostGuestName": "Chumash Casino",
		  "mostGuestCity": "Santa Ynez",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba57d83da7c549d8d08fc66050fa460a",
		  
		  "name": "Pau",
		  "createdDate": "2024-01-11 11:01:19",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 107,
		  "totalCountries": 8,
		  "totalStates": 6,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 188,
		  "schedulePercent": 0.152085,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba5abaf84ebd85223a32b2ea6f6eeeac",
		  
		  "name": "Dave",
		  "createdDate": "2018-02-13 21:11:22",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 520,
		  "totalCountries": 16,
		  "totalStates": 26,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 2330,
		  "schedulePercent": 0.766206,
		  "totalGuests": 756,
		  "guestPercent": 0.797597,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Watford Colosseum",
		  "mostGuestCity": "Watford",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba5b3114d249cbb1799649519b514feb",
		  
		  "name": "Lindsey",
		  "createdDate": "2010-05-24 15:35:01",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 177,
		  "totalCountries": 20,
		  "totalStates": 61,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1571,
		  "schedulePercent": 0.634973,
		  "totalGuests": 1090,
		  "guestPercent": 0.862307,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba723d9aa571f1c33512049affb12289",
		  
		  "name": "Felix",
		  "createdDate": "2022-09-15 08:11:19",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 365,
		  "totalCountries": 21,
		  "totalStates": 36,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 982,
		  "schedulePercent": 0.485267,
		  "totalGuests": 320,
		  "guestPercent": 0.659791,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba72ff1896b814f96247864b33730e31",
		  
		  "name": "Steev",
		  "createdDate": "2024-07-16 08:41:13",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 266,
		  "totalCountries": 11,
		  "totalStates": 15,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 418,
		  "schedulePercent": 0.277765,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Fox Theater",
		  "mostGuestCity": "Oakland",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba811d6c345774bd5ee222d7f65d96bc",
		  
		  "name": "Jenny",
		  "createdDate": "2025-01-16 05:56:30",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 30,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 107,
		  "schedulePercent": 0.102675,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Old St Pauls",
		  "mostGuestCity": "Wellington",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba83b2f9f9124b2ab2eef899ae84646f",
		  
		  "name": "Felipe",
		  "createdDate": "2025-04-01 17:45:26",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 163,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 804,
		  "schedulePercent": 0.424071,
		  "totalGuests": 545,
		  "guestPercent": 0.74218,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba8b3c8c0eb430d94369df32dd9477a2",
		  
		  "name": "Logan",
		  "createdDate": "2014-04-17 01:10:55",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 222,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 2000,
		  "schedulePercent": 0.713622,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ba9381e90ce7bd9dfcd68eb41e1dbc25",
		  
		  "name": "Projects",
		  "createdDate": "2024-10-28 09:22:34",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 884,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 670,
		  "eventPercent": 0.990367,
		  "totalScheduleItems": 1861,
		  "schedulePercent": 0.687103,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "baac5886294e1d216ffef91c1fd1945c",
		  
		  "name": "Adrian",
		  "createdDate": "2011-05-25 20:20:25",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 152,
		  "totalCountries": 6,
		  "totalStates": 34,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 786,
		  "schedulePercent": 0.417838,
		  "totalGuests": 103,
		  "guestPercent": 0.522779,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "The Orange Peel",
		  "mostGuestCity": "Asheville",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bab0ca0e902b1a4e42ca907bf2d8402d",
		  
		  "name": "Jason",
		  "createdDate": "2017-04-18 12:36:27",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 391,
		  "totalCountries": 6,
		  "totalStates": 18,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 532,
		  "schedulePercent": 0.327969,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "MacKinnon Brothers Brewing Company",
		  "mostGuestCity": "Bath",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "babc1cb4867b735407da77123dcaab74",
		  
		  "name": "Vic",
		  "createdDate": "2025-08-18 00:32:22",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 112,
		  "totalCountries": 17,
		  "totalStates": 23,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1610,
		  "schedulePercent": 0.642226,
		  "totalGuests": 709,
		  "guestPercent": 0.787511,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Jyske Bank BOXEN",
		  "mostGuestCity": "Herning",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "babe82ff6a2957a442326433bb19ce60",
		  
		  "name": "Preston",
		  "createdDate": "2023-12-01 22:07:59",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 1582,
		  "totalCountries": 11,
		  "totalStates": 63,
		  "totalEvents": 353,
		  "eventPercent": 0.94345,
		  "totalScheduleItems": 4713,
		  "schedulePercent": 0.944696,
		  "totalGuests": 1740,
		  "guestPercent": 0.92985,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bace49da84bb66744c10526a98ec2c07",
		  
		  "name": "Brandon",
		  "createdDate": "2024-08-06 22:30:07",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 109,
		  "totalCountries": 4,
		  "totalStates": 20,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 344,
		  "schedulePercent": 0.240254,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Wilshire Ebell Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bad540d3cc2561ae2b99eb752812ff91",
		  
		  "name": "Wedge",
		  "createdDate": "2015-05-11 04:31:08",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 170,
		  "totalCountries": 10,
		  "totalStates": 45,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 967,
		  "schedulePercent": 0.480394,
		  "totalGuests": 296,
		  "guestPercent": 0.647665,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bae1db1ad534c4f85f058e729993ede4",
		  
		  "name": "Andrew",
		  "createdDate": "2021-11-15 21:10:17",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 361,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 661,
		  "schedulePercent": 0.372054,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bae2898608f57c7871b2e8c5c2dec6d1",
		  
		  "name": "Hans Christian ",
		  "createdDate": "2021-06-15 13:00:05",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 53,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 191,
		  "schedulePercent": 0.153672,
		  "totalGuests": 175,
		  "guestPercent": 0.576609,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Posten",
		  "mostGuestCity": "Odense",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "baedf84e918fac1da53828fa09f40bc3",
		  
		  "name": "Carlos",
		  "createdDate": "2010-03-12 08:48:08",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 597,
		  "totalCountries": 20,
		  "totalStates": 25,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 791,
		  "schedulePercent": 0.419311,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Wolf Barcelona",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "baee17bbbfc53171e24d61d3223c5f49",
		  
		  "name": "Mikki",
		  "createdDate": "2024-02-17 00:59:56",
		  "totalOrganizations": 113,
		  "totalTours": 31,
		  "totalDays": 397,
		  "totalCountries": 6,
		  "totalStates": 10,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 1138,
		  "schedulePercent": 0.531165,
		  "totalGuests": 127,
		  "guestPercent": 0.542044,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "The Core at Corby Cube",
		  "mostGuestCity": "Corby",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "baf492f2bc447481b5bb4d7fab71b429",
		  
		  "name": "Jimena",
		  "createdDate": "2025-05-06 17:37:34",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 45,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 211,
		  "schedulePercent": 0.166704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "baf746c80d4d190b32c20340aee67f94",
		  
		  "name": "Jim",
		  "createdDate": "2022-05-23 16:04:15",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 478,
		  "totalCountries": 31,
		  "totalStates": 84,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 3323,
		  "schedulePercent": 0.868994,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The Beacham",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bafb857d5ad1f57948df0def3b03d338",
		  
		  "name": "Jan",
		  "createdDate": "2022-05-17 12:33:53",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 147,
		  "totalCountries": 12,
		  "totalStates": 23,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 538,
		  "schedulePercent": 0.329782,
		  "totalGuests": 165,
		  "guestPercent": 0.56947,
		  "mostGuestDate": "2025-04-07 00:00:00",
		  "mostGuestName": "Alte Oper",
		  "mostGuestCity": "Frankfurt am Main",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bafc9b2d29500e1af26efd6c235acc59",
		  
		  "name": "Scott",
		  "createdDate": "2025-03-17 22:13:23",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 150,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 767,
		  "schedulePercent": 0.410925,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bafe20593690205d75454bacb1a1ac83",
		  
		  "name": "Olivia",
		  "createdDate": "2024-02-26 10:04:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 397,
		  "schedulePercent": 0.268019,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Theater Simone Signoret",
		  "mostGuestCity": "Conflans-Sainte-Honorine",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb0af513741205830bc3028157c78f4f",
		  
		  "name": "Carol",
		  "createdDate": "2022-08-16 00:49:53",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 209,
		  "totalCountries": 9,
		  "totalStates": 40,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 1175,
		  "schedulePercent": 0.541025,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Auditorio Ibirapuera - Oscar Niemeyer",
		  "mostGuestCity": "Sao Paulo",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb0b90ac08ed9e2b4c5e03cf4e97f650",
		  
		  "name": "Jorge",
		  "createdDate": "2015-04-30 04:36:53",
		  "totalOrganizations": 14,
		  "totalTours": 16,
		  "totalDays": 315,
		  "totalCountries": 38,
		  "totalStates": 57,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2932,
		  "schedulePercent": 0.834882,
		  "totalGuests": 877,
		  "guestPercent": 0.824229,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Gothenburg Studios",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb0ffa88ba9893da425c159a8c0510b2",
		  
		  "name": "Lucila",
		  "createdDate": "2024-07-21 19:05:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 362,
		  "totalCountries": 7,
		  "totalStates": 34,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1757,
		  "schedulePercent": 0.669878,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb15b75f0664b130ec2642bea9526bcf",
		  
		  "name": "Chris",
		  "createdDate": "2017-01-27 21:23:29",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 2064,
		  "totalCountries": 28,
		  "totalStates": 61,
		  "totalEvents": 282,
		  "eventPercent": 0.899819,
		  "totalScheduleItems": 2784,
		  "schedulePercent": 0.819923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb160939792209bc388b47374036326e",
		  
		  "name": "BJ",
		  "createdDate": "2020-01-17 16:03:21",
		  "totalOrganizations": 22,
		  "totalTours": 18,
		  "totalDays": 2653,
		  "totalCountries": 25,
		  "totalStates": 66,
		  "totalEvents": 424,
		  "eventPercent": 0.964302,
		  "totalScheduleItems": 5111,
		  "schedulePercent": 0.957502,
		  "totalGuests": 1331,
		  "guestPercent": 0.891319,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb18ff2bc57a53bb6d69dab9bbb17d93",
		  
		  "name": "Remi",
		  "createdDate": "2013-12-23 06:15:20",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 142,
		  "totalCountries": 16,
		  "totalStates": 29,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 828,
		  "schedulePercent": 0.433477,
		  "totalGuests": 255,
		  "guestPercent": 0.627493,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "International de montgolfiÃ¨res de Saint-Jean-Sur-Richelieu",
		  "mostGuestCity": "Saint-Jean-sur-Richelieu",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb1acf8326c26eb53d961c299246ff94",
		  
		  "name": "Joshua",
		  "createdDate": "2025-06-11 03:51:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 70,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 218,
		  "schedulePercent": 0.170558,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb2297066409f2df6bbb976e35649a21",
		  
		  "name": "Mark",
		  "createdDate": "2021-04-13 15:23:01",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 284,
		  "totalCountries": 11,
		  "totalStates": 36,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 709,
		  "schedulePercent": 0.389846,
		  "totalGuests": 106,
		  "guestPercent": 0.525385,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "The Hamilton",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb22d6a6d24acae2d5112d52b54f07d1",
		  
		  "name": "Sean ",
		  "createdDate": "2021-09-09 02:15:56",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 485,
		  "totalCountries": 5,
		  "totalStates": 29,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 2091,
		  "schedulePercent": 0.730734,
		  "totalGuests": 368,
		  "guestPercent": 0.680417,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "AIR Restaurant ",
		  "mostGuestCity": "Washington  ",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb26f58b9655c4437c9a7576eb3d3dd5",
		  
		  "name": "Matt",
		  "createdDate": "2013-09-09 15:53:17",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 546,
		  "totalCountries": 27,
		  "totalStates": 79,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 4077,
		  "schedulePercent": 0.917498,
		  "totalGuests": 1744,
		  "guestPercent": 0.93019,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb3e35cb99356ee3d8f1a9677d3bd797",
		  
		  "name": "Diego",
		  "createdDate": "2023-06-01 22:18:45",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 60,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 172,
		  "schedulePercent": 0.141772,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "ZeyZey Miami",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb3efd6af7f1b0aaccba7b5ccc4a5de4",
		  
		  "name": "Reya",
		  "createdDate": "2021-05-13 19:43:42",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 54,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb44e6028fce81a3915da56054f19cf8",
		  
		  "name": "Jake",
		  "createdDate": "2014-02-13 08:45:40",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 370,
		  "totalCountries": 11,
		  "totalStates": 61,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1497,
		  "schedulePercent": 0.617407,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-07-22 00:00:00",
		  "mostGuestName": "The Theater at Virgin Hotels",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb4575a5b4bd4e1fb40232c42164962f",
		  
		  "name": "Anthony",
		  "createdDate": "2017-06-12 18:01:27",
		  "totalOrganizations": 13,
		  "totalTours": 35,
		  "totalDays": 1661,
		  "totalCountries": 38,
		  "totalStates": 110,
		  "totalEvents": 500,
		  "eventPercent": 0.978808,
		  "totalScheduleItems": 6161,
		  "schedulePercent": 0.977901,
		  "totalGuests": 2281,
		  "guestPercent": 0.961015,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb4998e1dc912538f86490c55df877e8",
		  
		  "name": "Danny",
		  "createdDate": "2014-01-13 20:19:08",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 861,
		  "totalCountries": 31,
		  "totalStates": 79,
		  "totalEvents": 285,
		  "eventPercent": 0.901859,
		  "totalScheduleItems": 4861,
		  "schedulePercent": 0.949909,
		  "totalGuests": 1355,
		  "guestPercent": 0.893812,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb4cb0c2cf3680be18b92ca27d3e648f",
		  
		  "name": "Dysie",
		  "createdDate": "2019-10-30 01:17:26",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 29,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 217,
		  "schedulePercent": 0.170104,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb4e57ac7d5de09bca7e03ca93540a20",
		  
		  "name": "Michelle",
		  "createdDate": "2023-05-17 21:41:14",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb5440cb4d655377bbc4944e85b9835b",
		  
		  "name": "Omar",
		  "createdDate": "2018-01-29 11:35:06",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 320,
		  "totalCountries": 20,
		  "totalStates": 19,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 1151,
		  "schedulePercent": 0.535245,
		  "totalGuests": 123,
		  "guestPercent": 0.539211,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Ladyland Festival",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb5ce0083336ec673f5f2cf69f3b63ed",
		  
		  "name": "Annie",
		  "createdDate": "2025-04-01 14:56:59",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 78,
		  "schedulePercent": 0.0804624,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Shoreline Waterfront",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb6b1dca353483059f17c807336fea11",
		  
		  "name": "Leah",
		  "createdDate": "2024-05-23 21:11:59",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 43,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 348,
		  "schedulePercent": 0.241954,
		  "totalGuests": 584,
		  "guestPercent": 0.75442,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Climate Pledge Arena",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb6df99572235e40cc14bd5a7f852ba4",
		  
		  "name": "Chris",
		  "createdDate": "2022-04-30 23:11:16",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 1157,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 737,
		  "eventPercent": 0.992067,
		  "totalScheduleItems": 5936,
		  "schedulePercent": 0.974955,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb7a60c1cc2e7fc43b26b6cf0f664846",
		  
		  "name": "Andrew",
		  "createdDate": "2015-12-14 23:26:32",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 177,
		  "totalCountries": 12,
		  "totalStates": 27,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "ONE STREET ONE DAY TOWNSVILLE ",
		  "mostGuestCity": "Townsville ",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb983692eeaf5303b15b97a16706a496",
		  
		  "name": "Manuel ",
		  "createdDate": "2025-03-18 19:31:39",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 95,
		  "totalCountries": 9,
		  "totalStates": 18,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 798,
		  "schedulePercent": 0.421804,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Estadi de Son Moix",
		  "mostGuestCity": "Palma",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb98e4087db2c7bd8f3aae9d8c53a65d",
		  
		  "name": "Elisabeth ",
		  "createdDate": "2022-09-15 13:08:25",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 517,
		  "totalCountries": 14,
		  "totalStates": 45,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 880,
		  "schedulePercent": 0.451269,
		  "totalGuests": 297,
		  "guestPercent": 0.648119,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Festival d'ete de Quebec",
		  "mostGuestCity": "Ville de Quebec",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bb9f94c0ee6850b0c2982be39da05a63",
		  
		  "name": "Drew",
		  "createdDate": "2020-03-05 00:29:24",
		  "totalOrganizations": 17,
		  "totalTours": 25,
		  "totalDays": 1123,
		  "totalCountries": 20,
		  "totalStates": 61,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 3418,
		  "schedulePercent": 0.87704,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbac0badc0de0f770c62151032c61805",
		  
		  "name": "Taylor ",
		  "createdDate": "2023-11-16 23:20:18",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 39,
		  "totalCountries": 10,
		  "totalStates": 12,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbad38de40c517314e323f3b2c86063e",
		  
		  "name": "Anna ",
		  "createdDate": "2025-05-02 21:34:36",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 60,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 260,
		  "schedulePercent": 0.194923,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbaf3dcf321dd42a9aa92349e79171da",
		  
		  "name": "Neil",
		  "createdDate": "2022-08-08 16:31:14",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 553,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 363,
		  "schedulePercent": 0.249433,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbbbfd32538796312fc6e817994d7346",
		  
		  "name": "Finn",
		  "createdDate": "2018-04-27 08:15:32",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 30,
		  "totalCountries": 12,
		  "totalStates": 9,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 256,
		  "schedulePercent": 0.193676,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "SaSaZu",
		  "mostGuestCity": "Prague",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbc746853d348ef8fee9123830752503",
		  
		  "name": "Aaron",
		  "createdDate": "2014-10-31 19:30:42",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 886,
		  "totalCountries": 19,
		  "totalStates": 53,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 2866,
		  "schedulePercent": 0.828876,
		  "totalGuests": 1357,
		  "guestPercent": 0.894492,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbca6a9541a54553247a8987afbf64ab",
		  
		  "name": "Maison",
		  "createdDate": "2024-09-25 02:35:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 67,
		  "schedulePercent": 0.0718495,
		  "totalGuests": 67,
		  "guestPercent": 0.480734,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbcef0f53c25a2f1e0592364f68d74bb",
		  
		  "name": "Ian",
		  "createdDate": "2013-12-20 01:02:32",
		  "totalOrganizations": 19,
		  "totalTours": 21,
		  "totalDays": 252,
		  "totalCountries": 16,
		  "totalStates": 49,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1128,
		  "schedulePercent": 0.527425,
		  "totalGuests": 519,
		  "guestPercent": 0.735494,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Electric Ballroom",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbcf49064770e2f57b94d1c3438d38b3",
		  
		  "name": "Tami T",
		  "createdDate": "2013-03-08 00:17:40",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 245,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 183,
		  "guestPercent": 0.581482,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "The National",
		  "mostGuestCity": "Richmond",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbd69f71141c650af220aec5730a8cb4",
		  
		  "name": "Gunhild",
		  "createdDate": "2025-02-10 23:09:43",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 330,
		  "totalCountries": 9,
		  "totalStates": 20,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 47,
		  "schedulePercent": 0.057117,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbdbfd2e91dff862eace7d576b66392b",
		  
		  "name": "Aubrey",
		  "createdDate": "2022-06-10 20:09:07",
		  "totalOrganizations": 8,
		  "totalTours": 18,
		  "totalDays": 843,
		  "totalCountries": 17,
		  "totalStates": 53,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 2086,
		  "schedulePercent": 0.730054,
		  "totalGuests": 969,
		  "guestPercent": 0.841115,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbe61e21c455e0eaff9b260605109141",
		  
		  "name": "Nicolas",
		  "createdDate": "2020-01-31 15:22:52",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 64,
		  "totalCountries": 11,
		  "totalStates": 26,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbf8c7ee7322243a9f19af6978cfdf07",
		  
		  "name": "Meredith",
		  "createdDate": "2011-04-22 01:08:45",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 255,
		  "totalCountries": 9,
		  "totalStates": 44,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1568,
		  "schedulePercent": 0.634406,
		  "totalGuests": 1051,
		  "guestPercent": 0.854374,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bbfe89bc82e647794adc23069a488410",
		  
		  "name": "Nigel",
		  "createdDate": "2015-09-16 13:07:05",
		  "totalOrganizations": 17,
		  "totalTours": 15,
		  "totalDays": 402,
		  "totalCountries": 23,
		  "totalStates": 62,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 2196,
		  "schedulePercent": 0.747507,
		  "totalGuests": 425,
		  "guestPercent": 0.704442,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Lincoln Theatre",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc002d15eb2d687c3a2951fdc6c9ff7b",
		  
		  "name": "Noum",
		  "createdDate": "2022-12-01 03:37:12",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 325,
		  "totalCountries": 5,
		  "totalStates": 14,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1544,
		  "schedulePercent": 0.626247,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc05b844f29a0bb1cba4174d4c9e5a11",
		  
		  "name": "Matt",
		  "createdDate": "2009-08-27 17:56:55",
		  "totalOrganizations": 14,
		  "totalTours": 3,
		  "totalDays": 401,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 3135,
		  "schedulePercent": 0.854374,
		  "totalGuests": 835,
		  "guestPercent": 0.816296,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc1134fd5d2bae273783a0f3b0a60dba",
		  
		  "name": "Aaron",
		  "createdDate": "2020-01-28 19:43:05",
		  "totalOrganizations": 8,
		  "totalTours": 21,
		  "totalDays": 538,
		  "totalCountries": 29,
		  "totalStates": 73,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2756,
		  "schedulePercent": 0.81709,
		  "totalGuests": 1989,
		  "guestPercent": 0.94651,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc263bedbc8bed3e48521ff38d55bc46",
		  
		  "name": "Adriana",
		  "createdDate": "2022-04-05 17:56:32",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 68,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 312,
		  "schedulePercent": 0.223481,
		  "totalGuests": 299,
		  "guestPercent": 0.649139,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Intuit Dome",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc29446f5025c34683fbef92fb0ffd5d",
		  
		  "name": "Joey ",
		  "createdDate": "2017-05-04 19:03:55",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 710,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1218,
		  "schedulePercent": 0.551224,
		  "totalGuests": 515,
		  "guestPercent": 0.734361,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc2ac619b22b20eb145039864b230d8a",
		  
		  "name": "Roxxi ",
		  "createdDate": "2022-11-29 18:31:50",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 116,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 584,
		  "schedulePercent": 0.345535,
		  "totalGuests": 513,
		  "guestPercent": 0.733794,
		  "mostGuestDate": "2025-05-06 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc30ed1991d8c5837a6f08e52f431595",
		  
		  "name": "ALEX",
		  "createdDate": "2012-10-25 22:36:18",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 142,
		  "totalCountries": 17,
		  "totalStates": 44,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 909,
		  "schedulePercent": 0.461242,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-03-05 00:00:00",
		  "mostGuestName": "Whammy Bar",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc33355b9426f1fa68a89934e7cfc9a3",
		  
		  "name": "Kinsey",
		  "createdDate": "2022-06-16 10:47:34",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 232,
		  "totalCountries": 12,
		  "totalStates": 10,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 157,
		  "schedulePercent": 0.13316,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "Dom Kultury Åšwit",
		  "mostGuestCity": "Warsaw",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc48128760d0cb0da752ffbae56fd172",
		  
		  "name": "Andrew ",
		  "createdDate": "2013-10-06 23:50:20",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 716,
		  "totalCountries": 8,
		  "totalStates": 48,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 2366,
		  "schedulePercent": 0.770966,
		  "totalGuests": 580,
		  "guestPercent": 0.752607,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "The Today Show",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc4ed0250f74e466fb5f4c3b53229c5d",
		  
		  "name": "wes",
		  "createdDate": "2013-03-08 13:59:56",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 1026,
		  "totalCountries": 14,
		  "totalStates": 50,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 637,
		  "schedulePercent": 0.363327,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc5008653c0d9583db2d1bad22ad0c34",
		  
		  "name": "Vernon ",
		  "createdDate": "2025-06-15 15:29:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 244,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 25,
		  "schedulePercent": 0.0360381,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc58344cbe480d23deacc5b24da8b301",
		  
		  "name": "Aaron ",
		  "createdDate": "2021-04-23 18:41:36",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 455,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 464,
		  "schedulePercent": 0.296351,
		  "totalGuests": 250,
		  "guestPercent": 0.625113,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "House of Blues Dallas",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc698d01436c03ce2ce4e315f67139d4",
		  
		  "name": "TM",
		  "createdDate": "2022-04-01 00:27:51",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 739,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 983,
		  "schedulePercent": 0.486061,
		  "totalGuests": 170,
		  "guestPercent": 0.574003,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc6c70cbefd4807b546ebd564c4ff7de",
		  
		  "name": "Mitch",
		  "createdDate": "2022-01-18 20:12:12",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 174,
		  "totalCountries": 6,
		  "totalStates": 23,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 861,
		  "schedulePercent": 0.44515,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc6ef112e9a9bb1c60087cbd59bda440",
		  
		  "name": "Bruno",
		  "createdDate": "2014-05-23 01:42:41",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 284,
		  "totalCountries": 29,
		  "totalStates": 58,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 2280,
		  "schedulePercent": 0.759293,
		  "totalGuests": 1094,
		  "guestPercent": 0.862647,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc72728dc6bfcb9b3725605ec351d018",
		  
		  "name": "Micah",
		  "createdDate": "2024-10-24 00:24:00",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 142,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 483,
		  "schedulePercent": 0.302924,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc728f13df72bded08ac658b0c8b763a",
		  
		  "name": "Jyri",
		  "createdDate": "2024-12-11 08:55:07",
		  "totalOrganizations": 36,
		  "totalTours": 36,
		  "totalDays": 733,
		  "totalCountries": 12,
		  "totalStates": 11,
		  "totalEvents": 650,
		  "eventPercent": 0.989914,
		  "totalScheduleItems": 3493,
		  "schedulePercent": 0.8818,
		  "totalGuests": 137,
		  "guestPercent": 0.550204,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Stars am Strand",
		  "mostGuestCity": "Timmendorfer Strand",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc7bca47d9bc6104a6969331739e5380",
		  
		  "name": "Tom",
		  "createdDate": "2018-06-26 13:54:16",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 144,
		  "totalCountries": 6,
		  "totalStates": 22,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1196,
		  "schedulePercent": 0.546691,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "The Low Green",
		  "mostGuestCity": "",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc875424994f483bd769dcb999de8f28",
		  
		  "name": "Matthew",
		  "createdDate": "2025-09-12 17:23:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 539,
		  "schedulePercent": 0.330009,
		  "totalGuests": 503,
		  "guestPercent": 0.731528,
		  "mostGuestDate": "2025-11-13 00:00:00",
		  "mostGuestName": "YouTube Theater",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bc9aae542079933ca2f2b18e266d924c",
		  
		  "name": "Angie",
		  "createdDate": "2021-08-05 00:42:24",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 196,
		  "schedulePercent": 0.158772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bca7c847728a9e4773f7bf32316ee2ad",
		  
		  "name": "Christine",
		  "createdDate": "2022-08-31 12:55:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 279,
		  "schedulePercent": 0.205009,
		  "totalGuests": 170,
		  "guestPercent": 0.574003,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Carre 150 - Salle Les Freres Lemaire",
		  "mostGuestCity": "Victoriaville",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bcb84eede43e4c3ec750d6934d4484e1",
		  
		  "name": "B",
		  "createdDate": "2025-05-05 14:09:19",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 239,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 274,
		  "schedulePercent": 0.202063,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bcbb5627d3634a230aed3c753e8ce180",
		  
		  "name": "Danielle",
		  "createdDate": "2015-01-22 20:07:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 153,
		  "totalCountries": 22,
		  "totalStates": 29,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 800,
		  "schedulePercent": 0.422597,
		  "totalGuests": 345,
		  "guestPercent": 0.672711,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Paramount",
		  "mostGuestCity": "Huntington",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bcc56c7d80d791c87b4fa1e015292e5c",
		  
		  "name": "Sean",
		  "createdDate": "2010-01-25 20:32:39",
		  "totalOrganizations": 24,
		  "totalTours": 17,
		  "totalDays": 2032,
		  "totalCountries": 15,
		  "totalStates": 51,
		  "totalEvents": 268,
		  "eventPercent": 0.888599,
		  "totalScheduleItems": 2900,
		  "schedulePercent": 0.831709,
		  "totalGuests": 669,
		  "guestPercent": 0.777652,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Palladium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bcdc2abb8e081a7eb62107fa77055909",
		  
		  "name": "Hamish",
		  "createdDate": "2021-09-28 14:33:44",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 1210,
		  "totalCountries": 20,
		  "totalStates": 54,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 2353,
		  "schedulePercent": 0.768812,
		  "totalGuests": 738,
		  "guestPercent": 0.793631,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bcdd1ed2d9cece0fe2bdce497ae8670a",
		  
		  "name": "Julian",
		  "createdDate": "2023-02-25 11:57:29",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 220,
		  "totalCountries": 15,
		  "totalStates": 24,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 1669,
		  "schedulePercent": 0.653105,
		  "totalGuests": 635,
		  "guestPercent": 0.766999,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "CCH - Congress Center Hamburg - Saal 1",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 135,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bcf153784c07a0671275898a28673d08",
		  
		  "name": "Darrin ",
		  "createdDate": "2017-10-06 14:02:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 250,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 985,
		  "schedulePercent": 0.486741,
		  "totalGuests": 297,
		  "guestPercent": 0.648119,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Georgia Mountain Fair Inc",
		  "mostGuestCity": "Hiawassee",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd074eba41074795a75f9fd23f75e3a8",
		  
		  "name": "jane",
		  "createdDate": "2025-07-17 22:32:12",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 150,
		  "schedulePercent": 0.129873,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd09a3445c5476b7f18794e9a9de29c8",
		  
		  "name": "Danielle",
		  "createdDate": "2025-03-10 21:48:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 230,
		  "totalCountries": 21,
		  "totalStates": 51,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1,
		  "schedulePercent": 0.00804624,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd1281b1fe708d7f4948205c6224e7c7",
		  
		  "name": "Justin",
		  "createdDate": "2013-07-10 18:43:19",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 681,
		  "totalCountries": 4,
		  "totalStates": 49,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 1472,
		  "schedulePercent": 0.611174,
		  "totalGuests": 83,
		  "guestPercent": 0.499773,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Chautauqua Amphitheater",
		  "mostGuestCity": "Chautauqua",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd135308fe07f6bec51b40eee30cdb81",
		  
		  "name": "Mili",
		  "createdDate": "2022-05-16 09:36:33",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 126,
		  "totalCountries": 7,
		  "totalStates": 18,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 540,
		  "schedulePercent": 0.330349,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-11-19 00:00:00",
		  "mostGuestName": "Festival Hall",
		  "mostGuestCity": "West Melbourne",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd2000e215342244507ee010cbb9a732",
		  
		  "name": "Patricia",
		  "createdDate": "2016-08-17 00:16:38",
		  "totalOrganizations": 9,
		  "totalTours": 48,
		  "totalDays": 898,
		  "totalCountries": 16,
		  "totalStates": 56,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2552,
		  "schedulePercent": 0.793178,
		  "totalGuests": 1303,
		  "guestPercent": 0.886446,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd29133b901e379c92d72f85d6aafb29",
		  
		  "name": "Aaron ",
		  "createdDate": "2024-03-23 18:06:50",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 172,
		  "totalCountries": 4,
		  "totalStates": 44,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1352,
		  "schedulePercent": 0.585449,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Boeing Center at Tech Port",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd2b71e65ac47890b9bc00bbac93a08e",
		  
		  "name": "Sarah",
		  "createdDate": "2017-04-07 16:18:36",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 269,
		  "totalCountries": 4,
		  "totalStates": 27,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 819,
		  "schedulePercent": 0.430304,
		  "totalGuests": 595,
		  "guestPercent": 0.7568,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "HISTORY",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd3d9c10f09a60f5ad9ffb6e9f516d55",
		  
		  "name": "Jacob",
		  "createdDate": "2023-11-14 21:36:22",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 56,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 566,
		  "schedulePercent": 0.339302,
		  "totalGuests": 395,
		  "guestPercent": 0.692203,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Abba's House",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd3dac1b6e5d9450cd4081850359aadc",
		  
		  "name": "Christopher",
		  "createdDate": "2017-03-15 02:48:14",
		  "totalOrganizations": 15,
		  "totalTours": 13,
		  "totalDays": 2830,
		  "totalCountries": 4,
		  "totalStates": 63,
		  "totalEvents": 445,
		  "eventPercent": 0.969288,
		  "totalScheduleItems": 5267,
		  "schedulePercent": 0.961582,
		  "totalGuests": 2235,
		  "guestPercent": 0.959315,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd53ac7790b0dbb85f5b5346f846dbcc",
		  
		  "name": "NICOLAS",
		  "createdDate": "2024-05-31 20:44:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 306,
		  "totalCountries": 5,
		  "totalStates": 24,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 599,
		  "schedulePercent": 0.350975,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd735124653e9ff9cde763306384162e",
		  
		  "name": "Alexander",
		  "createdDate": "2018-10-18 09:09:47",
		  "totalOrganizations": 26,
		  "totalTours": 15,
		  "totalDays": 561,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 240,
		  "eventPercent": 0.861854,
		  "totalScheduleItems": 1884,
		  "schedulePercent": 0.691976,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-11-07 00:00:00",
		  "mostGuestName": "Gustav Adolfs kyrka",
		  "mostGuestCity": "Helsingborg",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd84dd129f7d8aa9d169d38d1fe79c4d",
		  
		  "name": "Matilde",
		  "createdDate": "2019-07-30 07:21:23",
		  "totalOrganizations": 86,
		  "totalTours": 39,
		  "totalDays": 647,
		  "totalCountries": 11,
		  "totalStates": 8,
		  "totalEvents": 585,
		  "eventPercent": 0.986741,
		  "totalScheduleItems": 2988,
		  "schedulePercent": 0.841568,
		  "totalGuests": 343,
		  "guestPercent": 0.671804,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Fredagsrock i Tivoli",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bd9cfdf3e3d4fa8f0308e3fa92918c22",
		  
		  "name": "Kaz",
		  "createdDate": "2016-10-14 18:22:52",
		  "totalOrganizations": 11,
		  "totalTours": 26,
		  "totalDays": 439,
		  "totalCountries": 26,
		  "totalStates": 62,
		  "totalEvents": 221,
		  "eventPercent": 0.835449,
		  "totalScheduleItems": 2734,
		  "schedulePercent": 0.813577,
		  "totalGuests": 759,
		  "guestPercent": 0.798164,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "013 Poppodium",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bda5bd478c7dbde688a624510972433f",
		  
		  "name": "Walter",
		  "createdDate": "2015-03-10 20:22:07",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 728,
		  "totalCountries": 11,
		  "totalStates": 49,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 2113,
		  "schedulePercent": 0.734248,
		  "totalGuests": 327,
		  "guestPercent": 0.664665,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Credit Union 1 Amphitheatre",
		  "mostGuestCity": "Tinley Park",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bda6807f1af6264f69388ef8a8c04ff9",
		  
		  "name": "Shaun",
		  "createdDate": "2014-09-24 20:34:06",
		  "totalOrganizations": 30,
		  "totalTours": 22,
		  "totalDays": 981,
		  "totalCountries": 27,
		  "totalStates": 67,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 3335,
		  "schedulePercent": 0.869674,
		  "totalGuests": 1287,
		  "guestPercent": 0.884066,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Metropolis",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bdac3cc859983037bdebf3d579e173c6",
		  
		  "name": "Adrien",
		  "createdDate": "2019-11-05 06:34:18",
		  "totalOrganizations": 20,
		  "totalTours": 14,
		  "totalDays": 244,
		  "totalCountries": 24,
		  "totalStates": 44,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1734,
		  "schedulePercent": 0.664551,
		  "totalGuests": 597,
		  "guestPercent": 0.757253,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Festung Kufstein",
		  "mostGuestCity": "Kufstein",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bdb1982cb4de695c5032f41f14997837",
		  
		  "name": "Jamela ",
		  "createdDate": "2024-02-22 18:52:46",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 319,
		  "totalCountries": 21,
		  "totalStates": 26,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1532,
		  "schedulePercent": 0.62398,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bdbb099df3e90f3dbf104099d5a510bf",
		  
		  "name": "Cube",
		  "createdDate": "2024-03-13 10:22:35",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 878,
		  "totalCountries": 18,
		  "totalStates": 51,
		  "totalEvents": 301,
		  "eventPercent": 0.913645,
		  "totalScheduleItems": 4013,
		  "schedulePercent": 0.913871,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "L'Olympia Bruno Coquatrix",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bdc4a9a278e63713f5f089bf31d369c9",
		  
		  "name": "Tobias",
		  "createdDate": "2016-01-07 10:33:58",
		  "totalOrganizations": 17,
		  "totalTours": 6,
		  "totalDays": 201,
		  "totalCountries": 8,
		  "totalStates": 2,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 1107,
		  "schedulePercent": 0.520626,
		  "totalGuests": 144,
		  "guestPercent": 0.554624,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "K.B. Hallen",
		  "mostGuestCity": "Frederiksberg",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bddbbd849df5fae449fe3625df2a7047",
		  
		  "name": "Gonzalo ",
		  "createdDate": "2023-12-11 16:11:30",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 332,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 284,
		  "schedulePercent": 0.208862,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bddc8b34f0df8f44ed5e399043466257",
		  
		  "name": "Matt ",
		  "createdDate": "2010-11-05 00:34:59",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 201,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 897,
		  "schedulePercent": 0.457162,
		  "totalGuests": 468,
		  "guestPercent": 0.719515,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bdde034d4d5f4420db1482b918b6770d",
		  
		  "name": "Erin",
		  "createdDate": "2025-06-02 09:51:05",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 54,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 540,
		  "schedulePercent": 0.330349,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Foreztival",
		  "mostGuestCity": "Trelins",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bde2d673644dc03da93e8899793a795a",
		  
		  "name": "Monica",
		  "createdDate": "2025-03-19 10:01:21",
		  "totalOrganizations": 1,
		  "totalTours": 16,
		  "totalDays": 162,
		  "totalCountries": 6,
		  "totalStates": 31,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1240,
		  "schedulePercent": 0.557344,
		  "totalGuests": 384,
		  "guestPercent": 0.68767,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bded39a1ca27d1cee066b8b2b884dd90",
		  
		  "name": "John",
		  "createdDate": "2012-03-09 01:20:33",
		  "totalOrganizations": 13,
		  "totalTours": 12,
		  "totalDays": 452,
		  "totalCountries": 21,
		  "totalStates": 57,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1590,
		  "schedulePercent": 0.638373,
		  "totalGuests": 512,
		  "guestPercent": 0.733568,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bdf565374f2000c1e398b4e23e98d9ae",
		  
		  "name": "Circa",
		  "createdDate": "2024-02-20 15:23:56",
		  "totalOrganizations": 1,
		  "totalTours": 32,
		  "totalDays": 767,
		  "totalCountries": 23,
		  "totalStates": 25,
		  "totalEvents": 487,
		  "eventPercent": 0.976315,
		  "totalScheduleItems": 5374,
		  "schedulePercent": 0.964982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be0c25920cc331e9deffbc23e37d3e6b",
		  
		  "name": "Chris",
		  "createdDate": "2018-01-15 02:59:48",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 408,
		  "totalCountries": 15,
		  "totalStates": 44,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 809,
		  "schedulePercent": 0.426337,
		  "totalGuests": 138,
		  "guestPercent": 0.550997,
		  "mostGuestDate": "2025-07-08 00:00:00",
		  "mostGuestName": "Electric Ballroom",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be10859f05c1d99db35ada84f474baa0",
		  
		  "name": "Colson",
		  "createdDate": "2024-03-09 20:56:44",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 696,
		  "totalCountries": 5,
		  "totalStates": 57,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 3524,
		  "schedulePercent": 0.883386,
		  "totalGuests": 1762,
		  "guestPercent": 0.931324,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be2acd70c41583dc96f567ec093b645d",
		  
		  "name": "Diana",
		  "createdDate": "2016-07-17 07:20:36",
		  "totalOrganizations": 27,
		  "totalTours": 14,
		  "totalDays": 281,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 865,
		  "schedulePercent": 0.446623,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-01-02 00:00:00",
		  "mostGuestName": "Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be34caf9a01dace1dca179348d3da320",
		  
		  "name": "David",
		  "createdDate": "2011-08-08 20:31:56",
		  "totalOrganizations": 15,
		  "totalTours": 12,
		  "totalDays": 674,
		  "totalCountries": 16,
		  "totalStates": 23,
		  "totalEvents": 303,
		  "eventPercent": 0.914665,
		  "totalScheduleItems": 3451,
		  "schedulePercent": 0.87908,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-08-04 00:00:00",
		  "mostGuestName": "Sturgis Buffalo Chip",
		  "mostGuestCity": "Sturgis",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be3b004f7f98c54a2c2db0d0003ebfca",
		  
		  "name": "David",
		  "createdDate": "2023-02-13 17:21:32",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 65,
		  "totalCountries": 5,
		  "totalStates": 26,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 463,
		  "schedulePercent": 0.296124,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre Beanfield",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be3dc45d117efdb4005ba8d37d4f9849",
		  
		  "name": "Christian",
		  "createdDate": "2022-06-16 04:56:48",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 64,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 417,
		  "schedulePercent": 0.276972,
		  "totalGuests": 65,
		  "guestPercent": 0.477675,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Ridgefield Playhouse",
		  "mostGuestCity": "Ridgefield",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be4031643869a44fa5bd1a26fa85c6c0",
		  
		  "name": "Isaac ",
		  "createdDate": "2024-03-07 20:48:12",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 474,
		  "totalCountries": 7,
		  "totalStates": 46,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 640,
		  "schedulePercent": 0.364461,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be49c4689f83a6561f165a5bad65a8a6",
		  
		  "name": "Manami",
		  "createdDate": "2023-05-17 14:10:56",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 176,
		  "totalCountries": 27,
		  "totalStates": 39,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1371,
		  "schedulePercent": 0.589529,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Salle Pleyel",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be5acdb8d502bb9a5a29f5335f655309",
		  
		  "name": "Enas",
		  "createdDate": "2013-07-27 21:49:47",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 478,
		  "totalCountries": 7,
		  "totalStates": 24,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 549,
		  "schedulePercent": 0.334089,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Gainbridge Fieldhouse",
		  "mostGuestCity": "Indianapolis",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be650347f6ddf6d29e6be1351588508c",
		  
		  "name": "Kent",
		  "createdDate": "2019-09-26 15:08:42",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 111,
		  "totalCountries": 13,
		  "totalStates": 18,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 693,
		  "schedulePercent": 0.383613,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Barba Negra Music Club",
		  "mostGuestCity": "Budapest",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be66cb8c4ced2939e71a6d5e62272f28",
		  
		  "name": "Thore",
		  "createdDate": "2022-07-11 13:57:52",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 145,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 753,
		  "schedulePercent": 0.406505,
		  "totalGuests": 80,
		  "guestPercent": 0.49728,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "FZW",
		  "mostGuestCity": "Dortmund",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be6b2d4b1919cef5e438bb9741debe59",
		  
		  "name": "Kit",
		  "createdDate": "2022-04-15 14:42:19",
		  "totalOrganizations": 17,
		  "totalTours": 24,
		  "totalDays": 492,
		  "totalCountries": 43,
		  "totalStates": 82,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1807,
		  "schedulePercent": 0.677244,
		  "totalGuests": 886,
		  "guestPercent": 0.827063,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be6dc04103a687bad697bd11fbd0463a",
		  
		  "name": "Nick",
		  "createdDate": "2024-03-11 10:06:07",
		  "totalOrganizations": 9,
		  "totalTours": 23,
		  "totalDays": 144,
		  "totalCountries": 20,
		  "totalStates": 28,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 1296,
		  "schedulePercent": 0.57049,
		  "totalGuests": 448,
		  "guestPercent": 0.711922,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Bramall Lane",
		  "mostGuestCity": "Sheffield",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be78457d13c12fd705547e02c133328c",
		  
		  "name": "LAURA",
		  "createdDate": "2021-07-16 14:28:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 95,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 567,
		  "schedulePercent": 0.339529,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be84d7050cd78037ea1f580b6c625905",
		  
		  "name": "Mimi",
		  "createdDate": "2019-03-17 19:34:06",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 411,
		  "totalCountries": 6,
		  "totalStates": 24,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 576,
		  "schedulePercent": 0.342022,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "be8e28cd5c1dcebb02dfda05ae37cb65",
		  
		  "name": "Andre",
		  "createdDate": "2011-05-05 02:31:03",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 725,
		  "totalCountries": 25,
		  "totalStates": 89,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 3254,
		  "schedulePercent": 0.864574,
		  "totalGuests": 1137,
		  "guestPercent": 0.870014,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 280,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bea52d83cc2e4b8997194dff92d77c91",
		  
		  "name": "Edward",
		  "createdDate": "2025-06-02 09:06:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 91,
		  "schedulePercent": 0.0902085,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Dingwalls",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "beaf41a617817e33943f537e21687f00",
		  
		  "name": "Brandon",
		  "createdDate": "2018-11-12 19:20:29",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 175,
		  "totalCountries": 13,
		  "totalStates": 39,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 614,
		  "schedulePercent": 0.355394,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "beaf43a465a7218ae7f1e737750866fb",
		  
		  "name": "Caleb",
		  "createdDate": "2022-02-28 00:54:05",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 769,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 447,
		  "schedulePercent": 0.289438,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-12-05 00:00:00",
		  "mostGuestName": "Victory Church Assemblies of God",
		  "mostGuestCity": "Lakeland",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "beafb9551b8f5ab22fbb5bb193925293",
		  
		  "name": "Tom",
		  "createdDate": "2011-01-09 20:30:45",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 21,
		  "totalStates": 37,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1245,
		  "schedulePercent": 0.55927,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "douglass park",
		  "mostGuestCity": "",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "beb14e70a2c8ee6d2b3ad1c75dde68e8",
		  
		  "name": "Matti ",
		  "createdDate": "2016-06-29 08:53:28",
		  "totalOrganizations": 13,
		  "totalTours": 13,
		  "totalDays": 502,
		  "totalCountries": 19,
		  "totalStates": 33,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1388,
		  "schedulePercent": 0.594402,
		  "totalGuests": 674,
		  "guestPercent": 0.779465,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "Vasateatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bec45e29b38a1a65b8bdb556a06f6831",
		  
		  "name": "Vanessa",
		  "createdDate": "2025-04-17 13:03:40",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 159,
		  "totalCountries": 10,
		  "totalStates": 23,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 2666,
		  "schedulePercent": 0.80451,
		  "totalGuests": 336,
		  "guestPercent": 0.668744,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bec4c049fd9a07cd24614b004e385de8",
		  
		  "name": "Steven",
		  "createdDate": "2011-05-27 22:10:41",
		  "totalOrganizations": 51,
		  "totalTours": 23,
		  "totalDays": 1476,
		  "totalCountries": 16,
		  "totalStates": 56,
		  "totalEvents": 434,
		  "eventPercent": 0.967362,
		  "totalScheduleItems": 4974,
		  "schedulePercent": 0.953536,
		  "totalGuests": 198,
		  "guestPercent": 0.593155,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "The Van Buren",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bec7f1a530822dc50d45430550bd4623",
		  
		  "name": "Warrant",
		  "createdDate": "2021-12-02 01:11:55",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 481,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 814,
		  "schedulePercent": 0.42849,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bec7f429d5fdd57c41fadf9fcf33b068",
		  
		  "name": "Monika",
		  "createdDate": "2019-02-17 12:35:16",
		  "totalOrganizations": 19,
		  "totalTours": 54,
		  "totalDays": 951,
		  "totalCountries": 36,
		  "totalStates": 82,
		  "totalEvents": 405,
		  "eventPercent": 0.959995,
		  "totalScheduleItems": 5066,
		  "schedulePercent": 0.956482,
		  "totalGuests": 1653,
		  "guestPercent": 0.924411,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bed86fdfe800ff033a04cd9275a3cd86",
		  
		  "name": "Stefan",
		  "createdDate": "2024-06-04 11:37:44",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 72,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 629,
		  "schedulePercent": 0.360381,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "E-Werk",
		  "mostGuestCity": "Koln",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bedc36aba37b9097639f5221ad08f065",
		  
		  "name": "Patrick",
		  "createdDate": "2017-05-31 16:46:37",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 434,
		  "totalCountries": 15,
		  "totalStates": 39,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 1383,
		  "schedulePercent": 0.593382,
		  "totalGuests": 470,
		  "guestPercent": 0.720422,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "The Great Saltair",
		  "mostGuestCity": "Magna",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bee25ecab8ebded74fd742b842f284da",
		  
		  "name": "Uwe",
		  "createdDate": "2012-03-09 13:53:36",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 187,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 696,
		  "schedulePercent": 0.385313,
		  "totalGuests": 1026,
		  "guestPercent": 0.850748,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 220,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bee7d02038fdc979e2229c2dd938a957",
		  
		  "name": "Colin",
		  "createdDate": "2025-04-03 03:39:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 152,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "beef00eda8863ffcf1a42311ebb3bdf8",
		  
		  "name": "Natasha",
		  "createdDate": "2024-10-01 19:54:01",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 61,
		  "totalCountries": 7,
		  "totalStates": 11,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 381,
		  "schedulePercent": 0.25918,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bef38e1dc676632915b410aefe55951f",
		  
		  "name": "Chris",
		  "createdDate": "2018-06-10 00:48:51",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 238,
		  "totalCountries": 8,
		  "totalStates": 52,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 877,
		  "schedulePercent": 0.450136,
		  "totalGuests": 206,
		  "guestPercent": 0.598821,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Scala",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bef6410de25610893607f2a86781b4f9",
		  
		  "name": "Daryl",
		  "createdDate": "2018-10-05 14:44:36",
		  "totalOrganizations": 5,
		  "totalTours": 16,
		  "totalDays": 47,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 331,
		  "schedulePercent": 0.231754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bef85e8a9a69e41c780eb94f3cbaafdd",
		  
		  "name": "Charlie",
		  "createdDate": "2015-08-16 03:31:31",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1003,
		  "schedulePercent": 0.490934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf034e6387e2927fe433772b0a61e1cd",
		  
		  "name": "Colin",
		  "createdDate": "2016-01-15 19:17:26",
		  "totalOrganizations": 20,
		  "totalTours": 13,
		  "totalDays": 475,
		  "totalCountries": 9,
		  "totalStates": 54,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 3482,
		  "schedulePercent": 0.881006,
		  "totalGuests": 2023,
		  "guestPercent": 0.948776,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf03dac9b24112600b867331c335f080",
		  
		  "name": "Nyla",
		  "createdDate": "2017-05-19 03:03:06",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 405,
		  "totalCountries": 25,
		  "totalStates": 41,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1721,
		  "schedulePercent": 0.662171,
		  "totalGuests": 2964,
		  "guestPercent": 0.981188,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "OVO Arena Wembley",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 401,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf0bef1cdca5d4cfe9a81010f4cff262",
		  
		  "name": "Richard ",
		  "createdDate": "2020-03-10 11:54:33",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 272,
		  "totalCountries": 19,
		  "totalStates": 36,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 621,
		  "schedulePercent": 0.357548,
		  "totalGuests": 137,
		  "guestPercent": 0.550204,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "CHALK",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf0f5e4e31b0f95c9b4ccf4ad2438feb",
		  
		  "name": "Morgan",
		  "createdDate": "2023-07-18 17:46:39",
		  "totalOrganizations": 18,
		  "totalTours": 8,
		  "totalDays": 98,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 370,
		  "schedulePercent": 0.253173,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Shoreline Waterfront",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf14ff8e7e509bbaf356f57e725fdd9b",
		  
		  "name": "Daniel",
		  "createdDate": "2021-08-09 16:23:55",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 57,
		  "totalCountries": 10,
		  "totalStates": 10,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 362,
		  "schedulePercent": 0.249093,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Islington Assembly Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf15ab8cb37d0c5594a7e5045d465517",
		  
		  "name": "Jay",
		  "createdDate": "2022-06-21 16:00:18",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 87,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 341,
		  "schedulePercent": 0.239121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf1a1145645c19f440f7faa5a7b5d028",
		  
		  "name": "Daniela",
		  "createdDate": "2025-10-19 16:21:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 184,
		  "schedulePercent": 0.150272,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf1f952d6f13bfa62503b9a35c604f11",
		  
		  "name": "Zoltan",
		  "createdDate": "2019-02-19 09:53:29",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 149,
		  "totalCountries": 24,
		  "totalStates": 54,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 228,
		  "guestPercent": 0.611514,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Turbina Cultural Center",
		  "mostGuestCity": "Budapest",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf231e3e462c4aa8d336deefe3a1fb74",
		  
		  "name": "Antti",
		  "createdDate": "2019-08-23 12:46:04",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 74,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 307,
		  "schedulePercent": 0.221102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf276bfd3cb960bcaf61b342f9982703",
		  
		  "name": "Keith",
		  "createdDate": "2023-01-13 21:38:32",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 177,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 861,
		  "schedulePercent": 0.44515,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Ogden Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf2b2aaf8f80098d4822bfbb07d7f129",
		  
		  "name": "M",
		  "createdDate": "2022-08-03 15:47:25",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 205,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 1842,
		  "schedulePercent": 0.68393,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Fort Mose Historic State Park",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf349357d974e435ef1bd84a192028c8",
		  
		  "name": "Andrew",
		  "createdDate": "2025-03-31 23:16:53",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 289,
		  "totalCountries": 15,
		  "totalStates": 57,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 2181,
		  "schedulePercent": 0.745127,
		  "totalGuests": 1744,
		  "guestPercent": 0.93019,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "DCU Center",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf35c5603dd5e152ceb05ef59b8df08f",
		  
		  "name": "Hamish",
		  "createdDate": "2019-09-23 12:20:06",
		  "totalOrganizations": 19,
		  "totalTours": 15,
		  "totalDays": 805,
		  "totalCountries": 35,
		  "totalStates": 86,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 3196,
		  "schedulePercent": 0.859248,
		  "totalGuests": 2292,
		  "guestPercent": 0.961469,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "DCU Center",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf3aa4cea89369bfe1cd88b14e194a1c",
		  
		  "name": "Kelly",
		  "createdDate": "2022-08-07 01:28:11",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 248,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2092,
		  "schedulePercent": 0.730961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf46fc7061acb21d3b6ca14c9d019fbd",
		  
		  "name": "Chris ",
		  "createdDate": "2024-12-27 20:10:13",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 591,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 4213,
		  "schedulePercent": 0.926677,
		  "totalGuests": 6201,
		  "guestPercent": 0.998527,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Ak-Chin Pavilion",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 173,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf534b31931e0b11ad0c31406ee565bc",
		  
		  "name": "Stacey ",
		  "createdDate": "2023-02-14 20:56:37",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 501,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 560,
		  "schedulePercent": 0.337375,
		  "totalGuests": 773,
		  "guestPercent": 0.800997,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf5ee647ce47e4e743d07a94c46c3c28",
		  
		  "name": "CÃº",
		  "createdDate": "2022-01-31 11:46:10",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 136,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 1035,
		  "schedulePercent": 0.500227,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf6099f9726d2c64c507af0135ce6634",
		  
		  "name": "Steve",
		  "createdDate": "2022-06-02 20:21:55",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 270,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 281,
		  "schedulePercent": 0.206256,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-12-21 00:00:00",
		  "mostGuestName": "Showplace",
		  "mostGuestCity": "Peterborough",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf6a4f59801e210327d9d585da57e5ab",
		  
		  "name": "Chris ",
		  "createdDate": "2010-01-07 19:25:37",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 421,
		  "totalCountries": 11,
		  "totalStates": 49,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 2050,
		  "schedulePercent": 0.723141,
		  "totalGuests": 93,
		  "guestPercent": 0.511786,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Fortitude Music Hall",
		  "mostGuestCity": "Fortitude Valley",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf6d4b6206f9b7d621138b78bf97c2a7",
		  
		  "name": "Maria",
		  "createdDate": "2018-01-10 10:58:04",
		  "totalOrganizations": 11,
		  "totalTours": 2,
		  "totalDays": 233,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 498,
		  "schedulePercent": 0.31131,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Portalen",
		  "mostGuestCity": "Greve",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf74872bfe11bd2076dd7d341a66f72e",
		  
		  "name": "Melodie",
		  "createdDate": "2016-03-10 17:00:00",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 869,
		  "totalCountries": 12,
		  "totalStates": 44,
		  "totalEvents": 202,
		  "eventPercent": 0.804397,
		  "totalScheduleItems": 2962,
		  "schedulePercent": 0.838282,
		  "totalGuests": 809,
		  "guestPercent": 0.810403,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Champion Forest Baptist Church - Champions Campus",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf7c1bea1fd174a4b3cd4074ad1a8fa0",
		  
		  "name": "Niko",
		  "createdDate": "2020-02-02 16:09:50",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 36,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 131,
		  "schedulePercent": 0.119334,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf87a8050d81a55f8c6b00e92aec89a8",
		  
		  "name": "Don",
		  "createdDate": "2023-05-03 16:21:45",
		  "totalOrganizations": 36,
		  "totalTours": 67,
		  "totalDays": 1757,
		  "totalCountries": 18,
		  "totalStates": 76,
		  "totalEvents": 828,
		  "eventPercent": 0.993654,
		  "totalScheduleItems": 6404,
		  "schedulePercent": 0.980621,
		  "totalGuests": 2288,
		  "guestPercent": 0.961355,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "The Dome",
		  "mostGuestCity": "Virginia Beach",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf8bd1c8a4e9f8b34bad090b82621c48",
		  
		  "name": "Janet",
		  "createdDate": "2018-09-08 02:05:33",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 51,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 546,
		  "schedulePercent": 0.332616,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bf9c09efbe09e80a4d6db959272fd57d",
		  
		  "name": "Finise",
		  "createdDate": "2024-10-24 20:16:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 80,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 223,
		  "schedulePercent": 0.173051,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Pearl Concert Theater",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfa1bc442de97977950491ad3374961e",
		  
		  "name": "Luke",
		  "createdDate": "2015-04-20 15:02:50",
		  "totalOrganizations": 33,
		  "totalTours": 25,
		  "totalDays": 1168,
		  "totalCountries": 27,
		  "totalStates": 83,
		  "totalEvents": 289,
		  "eventPercent": 0.904918,
		  "totalScheduleItems": 2923,
		  "schedulePercent": 0.833182,
		  "totalGuests": 297,
		  "guestPercent": 0.648119,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfa22f4c039af19942c3e78ac5e3c432",
		  
		  "name": "Charles",
		  "createdDate": "2012-05-10 22:02:13",
		  "totalOrganizations": 19,
		  "totalTours": 11,
		  "totalDays": 768,
		  "totalCountries": 8,
		  "totalStates": 59,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 2101,
		  "schedulePercent": 0.732888,
		  "totalGuests": 284,
		  "guestPercent": 0.641206,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfa9f7a300af85ec47804e2f3abc4139",
		  
		  "name": "Trevor",
		  "createdDate": "2021-10-21 06:38:11",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 122,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Thalia Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfc777980aa1418c4d9fe02017ab7ae5",
		  
		  "name": "J&#246;rn",
		  "createdDate": "2022-05-30 14:54:19",
		  "totalOrganizations": 14,
		  "totalTours": 3,
		  "totalDays": 66,
		  "totalCountries": 16,
		  "totalStates": 14,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 1085,
		  "schedulePercent": 0.515979,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfce8c8bddaf43bc80690d373166bd7b",
		  
		  "name": "Benjamin",
		  "createdDate": "2024-09-28 18:49:49",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 63,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 258,
		  "schedulePercent": 0.194016,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Dingwalls",
		  "mostGuestCity": "Camden Lock",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfcf76371430c1d4a3c0a24e968c6776",
		  
		  "name": "Evan",
		  "createdDate": "2015-09-09 16:41:46",
		  "totalOrganizations": 12,
		  "totalTours": 17,
		  "totalDays": 404,
		  "totalCountries": 21,
		  "totalStates": 51,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 3338,
		  "schedulePercent": 0.8699,
		  "totalGuests": 1845,
		  "guestPercent": 0.935857,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfcf8364a29af96740718d85a595fc85",
		  
		  "name": "Darrell",
		  "createdDate": "2010-02-05 20:24:31",
		  "totalOrganizations": 6,
		  "totalTours": 21,
		  "totalDays": 305,
		  "totalCountries": 20,
		  "totalStates": 59,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 2188,
		  "schedulePercent": 0.74626,
		  "totalGuests": 333,
		  "guestPercent": 0.666931,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Scotiabank Saddledome",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfd04e0fd2e5bce18872a4063a04ac95",
		  
		  "name": "Mike",
		  "createdDate": "2022-05-05 04:40:14",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 46,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 449,
		  "schedulePercent": 0.290345,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "The Rock",
		  "mostGuestCity": "Tucson",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfd2366b1889ee1ad1ec186bc4d94942",
		  
		  "name": "Rick",
		  "createdDate": "2018-10-17 12:06:30",
		  "totalOrganizations": 4,
		  "totalTours": 14,
		  "totalDays": 149,
		  "totalCountries": 14,
		  "totalStates": 9,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 493,
		  "schedulePercent": 0.30927,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Centennial Parklands",
		  "mostGuestCity": "Centennial Park",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfd4ef452763d8ce3d72be5ff634e2ae",
		  
		  "name": "Autumn",
		  "createdDate": "2019-04-06 19:21:30",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 199,
		  "totalCountries": 7,
		  "totalStates": 46,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1542,
		  "schedulePercent": 0.62568,
		  "totalGuests": 165,
		  "guestPercent": 0.56947,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfd860476b4474b3d833e3d4d7c651a2",
		  
		  "name": "Natacza",
		  "createdDate": "2025-03-01 15:45:15",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 179,
		  "totalCountries": 28,
		  "totalStates": 52,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1755,
		  "schedulePercent": 0.669311,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfd957940bbd0a63038d561557c96209",
		  
		  "name": "Heather",
		  "createdDate": "2025-09-16 01:54:44",
		  "totalOrganizations": 17,
		  "totalTours": 12,
		  "totalDays": 436,
		  "totalCountries": 10,
		  "totalStates": 28,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 509,
		  "schedulePercent": 0.31505,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfe44b4a9dbcb01747b2cc3aee9e3d8c",
		  
		  "name": "Manon",
		  "createdDate": "2022-09-08 21:24:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 268,
		  "totalCountries": 5,
		  "totalStates": 20,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 1096,
		  "schedulePercent": 0.518926,
		  "totalGuests": 442,
		  "guestPercent": 0.709995,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "LDLC Arena",
		  "mostGuestCity": "DÃ©cines-Charpieu",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfe7c6962800c0b22a0542189829d3ec",
		  
		  "name": "Brian",
		  "createdDate": "2012-05-25 04:50:57",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 406,
		  "totalCountries": 22,
		  "totalStates": 31,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1051,
		  "schedulePercent": 0.504873,
		  "totalGuests": 310,
		  "guestPercent": 0.654352,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bfed1cff9c0fde874954f94222f0a267",
		  
		  "name": "LoÃ¯c",
		  "createdDate": "2023-04-21 16:18:06",
		  "totalOrganizations": 10,
		  "totalTours": 20,
		  "totalDays": 500,
		  "totalCountries": 23,
		  "totalStates": 72,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 2464,
		  "schedulePercent": 0.782865,
		  "totalGuests": 888,
		  "guestPercent": 0.827516,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "bff9f55a48b76ca533bc723cbb7371c1",
		  
		  "name": "GEP",
		  "createdDate": "2025-08-05 18:33:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 99,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 582,
		  "schedulePercent": 0.344515,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c000222fc443eede230e1a575d23f3c1",
		  
		  "name": "Isabelle ",
		  "createdDate": "2023-05-02 10:45:02",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 279,
		  "totalCountries": 20,
		  "totalStates": 29,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 601,
		  "schedulePercent": 0.351315,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c00f40031d42caf8e3e9b4e29f001b87",
		  
		  "name": "Josiah",
		  "createdDate": "2023-04-26 23:23:46",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 574,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 914,
		  "schedulePercent": 0.462942,
		  "totalGuests": 448,
		  "guestPercent": 0.711922,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Soldiers and Sailors Memorial Auditorium",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0102b13f10e5fc53bf242fa3b933d14",
		  
		  "name": "Joel",
		  "createdDate": "2023-11-15 02:17:04",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 202,
		  "totalCountries": 7,
		  "totalStates": 19,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1114,
		  "schedulePercent": 0.521872,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-12-13 00:00:00",
		  "mostGuestName": "Sid Buckwold Theatre at TCU Place",
		  "mostGuestCity": "Saskatoon",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c010e056e8cc2afa71ac1eea3c1ef86c",
		  
		  "name": "Rachel",
		  "createdDate": "2023-07-10 01:52:11",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 380,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 161,
		  "schedulePercent": 0.136333,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c010ef79bfdfac6978162f31742b72d2",
		  
		  "name": "Henry",
		  "createdDate": "2015-07-13 22:16:24",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 631,
		  "totalCountries": 25,
		  "totalStates": 23,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 1387,
		  "schedulePercent": 0.594175,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0179d9eadbe94d21ee46aaad7c41add",
		  
		  "name": "Damon",
		  "createdDate": "2013-01-28 07:05:05",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 398,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1115,
		  "schedulePercent": 0.522439,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Arvada Center",
		  "mostGuestCity": "Arvada",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c021e643cc2183fdefc5e475cf395d1c",
		  
		  "name": "CJ",
		  "createdDate": "2013-07-04 00:16:25",
		  "totalOrganizations": 14,
		  "totalTours": 4,
		  "totalDays": 648,
		  "totalCountries": 36,
		  "totalStates": 66,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 4090,
		  "schedulePercent": 0.918064,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c02324b73ca8df93072ea7073129b8b4",
		  
		  "name": "Chris",
		  "createdDate": "2022-05-15 12:40:41",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 465,
		  "totalCountries": 13,
		  "totalStates": 14,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 528,
		  "schedulePercent": 0.326043,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Chiddfest",
		  "mostGuestCity": "Chiddingly",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c036c1461bf3d48ac786204ae1a5a239",
		  
		  "name": "Chris",
		  "createdDate": "2018-03-30 13:36:52",
		  "totalOrganizations": 10,
		  "totalTours": 20,
		  "totalDays": 611,
		  "totalCountries": 31,
		  "totalStates": 78,
		  "totalEvents": 289,
		  "eventPercent": 0.904918,
		  "totalScheduleItems": 3466,
		  "schedulePercent": 0.88044,
		  "totalGuests": 576,
		  "guestPercent": 0.751587,
		  "mostGuestDate": "2025-08-26 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c03dfd3f9aaa54b399c7c3fc795e9a3d",
		  
		  "name": "Chris",
		  "createdDate": "2025-06-24 18:48:52",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 357,
		  "totalCountries": 12,
		  "totalStates": 50,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 47,
		  "schedulePercent": 0.057117,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c04253faf24d0da4a39ec1e17ce8317a",
		  
		  "name": "Omar",
		  "createdDate": "2025-07-11 16:56:23",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 434,
		  "totalCountries": 16,
		  "totalStates": 25,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1238,
		  "schedulePercent": 0.556664,
		  "totalGuests": 112,
		  "guestPercent": 0.529805,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Bell Centre",
		  "mostGuestCity": "Montreal",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0434911bd8030c58b9c8df643249990",
		  
		  "name": "Evan ",
		  "createdDate": "2014-04-04 20:48:06",
		  "totalOrganizations": 16,
		  "totalTours": 17,
		  "totalDays": 1521,
		  "totalCountries": 6,
		  "totalStates": 70,
		  "totalEvents": 371,
		  "eventPercent": 0.950023,
		  "totalScheduleItems": 4312,
		  "schedulePercent": 0.931324,
		  "totalGuests": 840,
		  "guestPercent": 0.817996,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "The Windjammer",
		  "mostGuestCity": "Isle of Palms",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c04bbd325b879de1d2a5c5c03632dbdd",
		  
		  "name": "Virginia",
		  "createdDate": "2023-06-20 19:14:32",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-03-03 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c04bd23dad7bc6c23a99470b628c3644",
		  
		  "name": "Alina",
		  "createdDate": "2025-10-27 09:56:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c05c9076ae93b24c446222a54e24f3c2",
		  
		  "name": "Joakim",
		  "createdDate": "2017-06-08 07:54:59",
		  "totalOrganizations": 21,
		  "totalTours": 15,
		  "totalDays": 711,
		  "totalCountries": 22,
		  "totalStates": 62,
		  "totalEvents": 288,
		  "eventPercent": 0.904465,
		  "totalScheduleItems": 2769,
		  "schedulePercent": 0.81811,
		  "totalGuests": 626,
		  "guestPercent": 0.764279,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Studenternas Arena",
		  "mostGuestCity": "Uppsala",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c07030589c6f7c9066c6a7f761da69fb",
		  
		  "name": "James",
		  "createdDate": "2024-12-01 14:09:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 81,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 28,
		  "schedulePercent": 0.0396646,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c080b144eaeda01cdf7d72dc0b4be759",
		  
		  "name": "Sebastian",
		  "createdDate": "2019-05-29 13:52:12",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 544,
		  "totalCountries": 27,
		  "totalStates": 87,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 2875,
		  "schedulePercent": 0.829556,
		  "totalGuests": 1452,
		  "guestPercent": 0.905032,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c082a675273074c046d7239f5518d1d3",
		  
		  "name": "Tom",
		  "createdDate": "2022-10-31 17:09:38",
		  "totalOrganizations": 11,
		  "totalTours": 49,
		  "totalDays": 663,
		  "totalCountries": 37,
		  "totalStates": 76,
		  "totalEvents": 341,
		  "eventPercent": 0.936877,
		  "totalScheduleItems": 4054,
		  "schedulePercent": 0.916364,
		  "totalGuests": 648,
		  "guestPercent": 0.771079,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Hitchin Priory",
		  "mostGuestCity": "Hitchin",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0841458e6fb91825fd3ca9856adcbb9",
		  
		  "name": "Frederick",
		  "createdDate": "2024-06-11 15:04:09",
		  "totalOrganizations": 5,
		  "totalTours": 11,
		  "totalDays": 434,
		  "totalCountries": 30,
		  "totalStates": 73,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2922,
		  "schedulePercent": 0.833069,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Tokio Marine Hall",
		  "mostGuestCity": "SÃ£o Paulo",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c08b247dccef9b7f2116b1fda2ca2222",
		  
		  "name": "Josh",
		  "createdDate": "2023-11-14 19:44:43",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 4,
		  "totalStates": 11,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 355,
		  "schedulePercent": 0.245127,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "Boots and Hearts",
		  "mostGuestCity": "Oro",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c09031023e6eb79985f05b85544ce849",
		  
		  "name": "John",
		  "createdDate": "2022-05-12 12:32:38",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 123,
		  "schedulePercent": 0.113327,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0a6ac2d87c8c5b9673ea8afeb386271",
		  
		  "name": "Sheryl",
		  "createdDate": "2019-09-04 11:46:15",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 133,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1106,
		  "schedulePercent": 0.520286,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0a9f020da296bfddadf484b8c77e21a",
		  
		  "name": "Sierra",
		  "createdDate": "2021-10-05 14:54:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1149,
		  "schedulePercent": 0.534338,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-03-04 00:00:00",
		  "mostGuestName": "Cat's Cradle",
		  "mostGuestCity": "Carrboro",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0aa3c6494fafe94d175037b9eadceb4",
		  
		  "name": "Jeremy",
		  "createdDate": "2023-04-18 14:28:20",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 1297,
		  "totalCountries": 19,
		  "totalStates": 77,
		  "totalEvents": 305,
		  "eventPercent": 0.915798,
		  "totalScheduleItems": 3142,
		  "schedulePercent": 0.854828,
		  "totalGuests": 2019,
		  "guestPercent": 0.948549,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0b0bcc6117f33f349461f1730846a9e",
		  
		  "name": "Jake",
		  "createdDate": "2021-04-12 14:09:01",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 1176,
		  "totalCountries": 5,
		  "totalStates": 52,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 2698,
		  "schedulePercent": 0.808364,
		  "totalGuests": 902,
		  "guestPercent": 0.830462,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Luckenbach Texas",
		  "mostGuestCity": "Fredericksburg",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0b41156cbc348b9a1469de5f21626de",
		  
		  "name": "Vincent",
		  "createdDate": "2012-03-02 22:35:58",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 105,
		  "totalCountries": 8,
		  "totalStates": 15,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 438,
		  "schedulePercent": 0.285131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0b55b74fe6f3959133f844ed2ae1102",
		  
		  "name": "Stuart",
		  "createdDate": "2013-03-03 12:06:38",
		  "totalOrganizations": 17,
		  "totalTours": 12,
		  "totalDays": 698,
		  "totalCountries": 18,
		  "totalStates": 33,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2253,
		  "schedulePercent": 0.755213,
		  "totalGuests": 401,
		  "guestPercent": 0.69481,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0bdba990e640ca563c1ebedddf92824",
		  
		  "name": "Camilla",
		  "createdDate": "2025-04-04 15:59:34",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 94,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 450,
		  "schedulePercent": 0.290911,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "The Carolina Opry Theater",
		  "mostGuestCity": "Myrtle Beach",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0e7dcc432ca7f17c5511138731b0b3d",
		  
		  "name": "Geoff",
		  "createdDate": "2010-01-25 05:19:59",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 13,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 663,
		  "schedulePercent": 0.372507,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0edd81ba5a5bfab7f42424f7e0e3cba",
		  
		  "name": "BUFFY",
		  "createdDate": "2015-10-21 22:41:13",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 9,
		  "totalStates": 43,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 1413,
		  "schedulePercent": 0.600748,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "The Basement",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0ee89ca370683ad583f3760db1a39a1",
		  
		  "name": "Gianna",
		  "createdDate": "2024-03-20 15:53:11",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 207,
		  "totalCountries": 14,
		  "totalStates": 23,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 808,
		  "schedulePercent": 0.426111,
		  "totalGuests": 136,
		  "guestPercent": 0.549524,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Palau Sant Jordi",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0ef402cdd0ad0cbf652eb31d59047ba",
		  
		  "name": "Julia",
		  "createdDate": "2023-05-20 11:32:04",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 1621,
		  "totalCountries": 10,
		  "totalStates": 60,
		  "totalEvents": 374,
		  "eventPercent": 0.951609,
		  "totalScheduleItems": 3744,
		  "schedulePercent": 0.898232,
		  "totalGuests": 514,
		  "guestPercent": 0.733908,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Analog at Hutton Hotel",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0f85f3ea5c969bd9571add0b5bac595",
		  
		  "name": "Ryan",
		  "createdDate": "2021-06-30 04:34:37",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 205,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 385,
		  "schedulePercent": 0.260993,
		  "totalGuests": 166,
		  "guestPercent": 0.570263,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Toyota Center",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c0fcac0528e81308172c2be2f0ecefc0",
		  
		  "name": "Rico",
		  "createdDate": "2023-09-17 23:45:39",
		  "totalOrganizations": 9,
		  "totalTours": 60,
		  "totalDays": 742,
		  "totalCountries": 21,
		  "totalStates": 48,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2225,
		  "schedulePercent": 0.752267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1053d034cb75e6d938cf3f6ca892073",
		  
		  "name": "Ian",
		  "createdDate": "2013-11-28 06:02:41",
		  "totalOrganizations": 22,
		  "totalTours": 14,
		  "totalDays": 524,
		  "totalCountries": 11,
		  "totalStates": 30,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 1269,
		  "schedulePercent": 0.565503,
		  "totalGuests": 483,
		  "guestPercent": 0.725635,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Dolby Live",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c113f0b6772f293a70ca9fb46abe1511",
		  
		  "name": "KIM",
		  "createdDate": "2021-07-19 19:49:43",
		  "totalOrganizations": 14,
		  "totalTours": 30,
		  "totalDays": 2772,
		  "totalCountries": 23,
		  "totalStates": 66,
		  "totalEvents": 563,
		  "eventPercent": 0.985154,
		  "totalScheduleItems": 8970,
		  "schedulePercent": 0.993314,
		  "totalGuests": 2492,
		  "guestPercent": 0.967702,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c11c10cbf599909d63b8fa8e86a947c7",
		  
		  "name": "Lidewij",
		  "createdDate": "2025-09-30 08:18:27",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c11fe577c37b4dd009ae68d88b37217b",
		  
		  "name": "Kat",
		  "createdDate": "2015-06-12 05:27:58",
		  "totalOrganizations": 315,
		  "totalTours": 145,
		  "totalDays": 4012,
		  "totalCountries": 45,
		  "totalStates": 70,
		  "totalEvents": 1168,
		  "eventPercent": 0.99694,
		  "totalScheduleItems": 11303,
		  "schedulePercent": 0.99796,
		  "totalGuests": 1134,
		  "guestPercent": 0.86956,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Palais Theatre",
		  "mostGuestCity": "St Kilda",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c129a7f81f14972d5e5c44ed20e6ef85",
		  
		  "name": "Metatone",
		  "createdDate": "2022-08-30 15:22:34",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 179,
		  "totalCountries": 10,
		  "totalStates": 23,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1724,
		  "schedulePercent": 0.662738,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c129a81ed62f520762ee222baa88c5e2",
		  
		  "name": "Fredrik",
		  "createdDate": "2020-01-09 09:19:00",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 166,
		  "totalCountries": 10,
		  "totalStates": 12,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 619,
		  "schedulePercent": 0.356528,
		  "totalGuests": 102,
		  "guestPercent": 0.522325,
		  "mostGuestDate": "2025-08-25 00:00:00",
		  "mostGuestName": "Mosebacketerrassen",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c12f88a1dc702ce3bf51d1adeacbc9c9",
		  
		  "name": "Priscille",
		  "createdDate": "2018-05-06 14:37:24",
		  "totalOrganizations": 19,
		  "totalTours": 12,
		  "totalDays": 1040,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 303,
		  "eventPercent": 0.914665,
		  "totalScheduleItems": 4274,
		  "schedulePercent": 0.93019,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c137416ddbc9de5bb63ba90ac49cb814",
		  
		  "name": "Elliot",
		  "createdDate": "2015-02-28 13:26:16",
		  "totalOrganizations": 12,
		  "totalTours": 20,
		  "totalDays": 825,
		  "totalCountries": 31,
		  "totalStates": 58,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 4171,
		  "schedulePercent": 0.923731,
		  "totalGuests": 646,
		  "guestPercent": 0.770512,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1414e3dbb9085cf03cf1b4e59a1266a",
		  
		  "name": "Collin",
		  "createdDate": "2022-06-23 19:01:31",
		  "totalOrganizations": 10,
		  "totalTours": 18,
		  "totalDays": 643,
		  "totalCountries": 30,
		  "totalStates": 94,
		  "totalEvents": 305,
		  "eventPercent": 0.915798,
		  "totalScheduleItems": 3253,
		  "schedulePercent": 0.864461,
		  "totalGuests": 1658,
		  "guestPercent": 0.924524,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "The Theater at Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1450f6b6fec76afbf3310b43330c754",
		  
		  "name": "Julien",
		  "createdDate": "2021-09-16 03:13:46",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 116,
		  "totalCountries": 16,
		  "totalStates": 23,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c14e1d0b7d8b0c86b2d186c7a2652c44",
		  
		  "name": "Gayle",
		  "createdDate": "2010-10-27 16:03:07",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 481,
		  "totalCountries": 19,
		  "totalStates": 41,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 2379,
		  "schedulePercent": 0.772552,
		  "totalGuests": 699,
		  "guestPercent": 0.785358,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c157ab37a268db34ed683bec9048f59a",
		  
		  "name": "Phillip",
		  "createdDate": "2025-05-16 18:41:04",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 118,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 420,
		  "guestPercent": 0.702289,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Jay and Susie Gogue Performing Arts Center at Auburn University",
		  "mostGuestCity": "Auburn",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c15886fb9e382e5aed8bf03ad9145643",
		  
		  "name": "Andrew",
		  "createdDate": "2013-03-16 18:22:19",
		  "totalOrganizations": 15,
		  "totalTours": 8,
		  "totalDays": 598,
		  "totalCountries": 12,
		  "totalStates": 36,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 3938,
		  "schedulePercent": 0.910698,
		  "totalGuests": 148,
		  "guestPercent": 0.556664,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c17fe1296f801fae4f9ad8c13cf7727b",
		  
		  "name": "Austin",
		  "createdDate": "2025-04-12 01:59:02",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 33,
		  "totalCountries": 11,
		  "totalStates": 9,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 243,
		  "schedulePercent": 0.186083,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c191595da5ad162f069805bd1975334e",
		  
		  "name": "Tyler",
		  "createdDate": "2012-02-07 15:49:43",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 341,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 410,
		  "schedulePercent": 0.273799,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1ab90160567dd4a7550635246778e97",
		  
		  "name": "Anna",
		  "createdDate": "2025-06-18 01:34:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 195,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 354,
		  "schedulePercent": 0.244787,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1b47cd4e08f2cdb9b374c6294a6d7f7",
		  
		  "name": "Nikki",
		  "createdDate": "2016-01-16 02:25:32",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 1167,
		  "totalCountries": 9,
		  "totalStates": 50,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1452,
		  "schedulePercent": 0.608001,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Historic Scoot Inn",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1baa7d4840e052ef18ea73e78ff4dc6",
		  
		  "name": "Simon",
		  "createdDate": "2015-10-24 00:37:01",
		  "totalOrganizations": 15,
		  "totalTours": 15,
		  "totalDays": 314,
		  "totalCountries": 16,
		  "totalStates": 46,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 881,
		  "schedulePercent": 0.451723,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "SO36",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1bb1380fa52b8d9d300e73876ee0bed",
		  
		  "name": "John",
		  "createdDate": "2017-03-27 15:45:20",
		  "totalOrganizations": 14,
		  "totalTours": 9,
		  "totalDays": 447,
		  "totalCountries": 12,
		  "totalStates": 32,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 3316,
		  "schedulePercent": 0.868427,
		  "totalGuests": 1075,
		  "guestPercent": 0.859587,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1c62023257f88921e0d8d885d7561a0",
		  
		  "name": "Stephanie",
		  "createdDate": "2023-08-08 03:44:24",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 249,
		  "totalCountries": 5,
		  "totalStates": 34,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 654,
		  "schedulePercent": 0.368994,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1caa2b2a26891d7303d6db7906566d4",
		  
		  "name": "Jake",
		  "createdDate": "2012-04-03 08:43:05",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 492,
		  "totalCountries": 28,
		  "totalStates": 61,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 1940,
		  "schedulePercent": 0.702289,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Rams Head On Stage",
		  "mostGuestCity": "Annapolis",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1d0f58b930f72e37007f18db03ba10a",
		  
		  "name": "Alison ",
		  "createdDate": "2022-02-27 17:09:38",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 330,
		  "totalCountries": 4,
		  "totalStates": 51,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 434,
		  "schedulePercent": 0.283205,
		  "totalGuests": 110,
		  "guestPercent": 0.528105,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "MGM Springfield",
		  "mostGuestCity": "Springfield",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1d4d6906f594c32774935cfd5467162",
		  
		  "name": "Jeremie",
		  "createdDate": "2019-05-28 17:51:32",
		  "totalOrganizations": 18,
		  "totalTours": 16,
		  "totalDays": 1061,
		  "totalCountries": 27,
		  "totalStates": 41,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2952,
		  "schedulePercent": 0.837035,
		  "totalGuests": 237,
		  "guestPercent": 0.617294,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "SunBet Arena at Time Square Casino",
		  "mostGuestCity": "Pretoria",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1e29d99aa3802e4e1409fccd15e747c",
		  
		  "name": "Josh",
		  "createdDate": "2015-03-04 23:40:12",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 393,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 2503,
		  "schedulePercent": 0.787171,
		  "totalGuests": 1383,
		  "guestPercent": 0.898119,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1ed4f61cca4aa6fba4b1d4a7f57d020",
		  
		  "name": "Marcus ",
		  "createdDate": "2023-03-29 23:27:50",
		  "totalOrganizations": 13,
		  "totalTours": 34,
		  "totalDays": 1404,
		  "totalCountries": 25,
		  "totalStates": 78,
		  "totalEvents": 396,
		  "eventPercent": 0.957956,
		  "totalScheduleItems": 5645,
		  "schedulePercent": 0.970762,
		  "totalGuests": 1255,
		  "guestPercent": 0.88112,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1ee2e9b5b896b779687e7b517c4a330",
		  
		  "name": "Kirvil",
		  "createdDate": "2022-01-31 11:44:29",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 295,
		  "totalCountries": 9,
		  "totalStates": 16,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 805,
		  "guestPercent": 0.80893,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lyse Arena",
		  "mostGuestCity": "Stavanger",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1f11830375d68ae42a3dcbfd5accd9a",
		  
		  "name": "Maximiliano",
		  "createdDate": "2016-10-01 03:37:22",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 492,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1340,
		  "schedulePercent": 0.583749,
		  "totalGuests": 704,
		  "guestPercent": 0.786605,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Orpheum Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1f1453d10ce8d880f05e398ccc3c4b6",
		  
		  "name": "Jack",
		  "createdDate": "2022-09-29 00:41:59",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 196,
		  "totalCountries": 14,
		  "totalStates": 44,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1355,
		  "schedulePercent": 0.586582,
		  "totalGuests": 1010,
		  "guestPercent": 0.848255,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Byline Bank Aragon Ballroom",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1f3adb9f086a8c8bc55950968bc6f73",
		  
		  "name": "Rocky",
		  "createdDate": "2018-02-13 21:34:03",
		  "totalOrganizations": 7,
		  "totalTours": 23,
		  "totalDays": 643,
		  "totalCountries": 17,
		  "totalStates": 74,
		  "totalEvents": 248,
		  "eventPercent": 0.868654,
		  "totalScheduleItems": 3882,
		  "schedulePercent": 0.907185,
		  "totalGuests": 2216,
		  "guestPercent": 0.958522,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c1f95c4221c37409ce5e1f9049bc6b27",
		  
		  "name": "Brandon ",
		  "createdDate": "2015-03-20 16:26:55",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 329,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 834,
		  "schedulePercent": 0.435743,
		  "totalGuests": 169,
		  "guestPercent": 0.573096,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Rocket Mortgage FieldHouse",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c20dc67b9312fc7562479bafcea7188d",
		  
		  "name": "Swin",
		  "createdDate": "2018-02-07 11:32:47",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 338,
		  "totalCountries": 22,
		  "totalStates": 56,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1790,
		  "schedulePercent": 0.674864,
		  "totalGuests": 252,
		  "guestPercent": 0.626247,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c215c6b7bfa22a1df8ec280a7044d889",
		  
		  "name": "Eli",
		  "createdDate": "2011-12-30 02:37:08",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 56,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 314,
		  "schedulePercent": 0.224388,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Honeywell Center",
		  "mostGuestCity": "Wabash",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c226bb84f9cb2592b5dede89242a956e",
		  
		  "name": "Zak",
		  "createdDate": "2018-03-29 15:27:54",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 927,
		  "totalCountries": 29,
		  "totalStates": 94,
		  "totalEvents": 259,
		  "eventPercent": 0.881006,
		  "totalScheduleItems": 2880,
		  "schedulePercent": 0.830236,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c22964e8b6f6580ef94c42b3170ba9eb",
		  
		  "name": "Trevor",
		  "createdDate": "2019-08-06 23:44:44",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 830,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 2008,
		  "schedulePercent": 0.714982,
		  "totalGuests": 642,
		  "guestPercent": 0.769719,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c22ff38084c94784bd7ee6b24fb95217",
		  
		  "name": "Keith",
		  "createdDate": "2023-06-16 14:02:41",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 612,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1838,
		  "schedulePercent": 0.68257,
		  "totalGuests": 634,
		  "guestPercent": 0.766659,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2310462ca77b5fb07a431295b4973d1",
		  
		  "name": "Northern",
		  "createdDate": "2018-08-20 14:55:08",
		  "totalOrganizations": 5,
		  "totalTours": 21,
		  "totalDays": 211,
		  "totalCountries": 39,
		  "totalStates": 55,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1400,
		  "schedulePercent": 0.597801,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "New Century",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c237d65e2a1c75c10ded9323b4c113d0",
		  
		  "name": "Margot",
		  "createdDate": "2023-10-19 08:28:43",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 525,
		  "totalCountries": 10,
		  "totalStates": 24,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1498,
		  "schedulePercent": 0.617747,
		  "totalGuests": 348,
		  "guestPercent": 0.674184,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Arena Montpellier",
		  "mostGuestCity": "PÃ©rols",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c239ea2a9f7edfc0c8b6dd49169d12d3",
		  
		  "name": "Brandon ",
		  "createdDate": "2018-05-31 17:34:37",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 1460,
		  "totalCountries": 33,
		  "totalStates": 68,
		  "totalEvents": 308,
		  "eventPercent": 0.917271,
		  "totalScheduleItems": 4224,
		  "schedulePercent": 0.92781,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c23a3a3cda7c454bdf40d054394b2279",
		  
		  "name": "Henry",
		  "createdDate": "2014-02-22 05:17:44",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 382,
		  "totalCountries": 26,
		  "totalStates": 40,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1649,
		  "schedulePercent": 0.649932,
		  "totalGuests": 723,
		  "guestPercent": 0.791138,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c240c37afd89ed9cc70c12ffe2fac406",
		  
		  "name": "Dewey",
		  "createdDate": "2022-10-06 16:27:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 105,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 685,
		  "schedulePercent": 0.381006,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c243800e8bfb7dffe021d68b8df2cd00",
		  
		  "name": "Robert",
		  "createdDate": "2023-06-07 09:11:29",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 236,
		  "totalCountries": 19,
		  "totalStates": 38,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1308,
		  "schedulePercent": 0.573323,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c24e1848464f9d6873007111c1580ca4",
		  
		  "name": "Mika",
		  "createdDate": "2018-05-09 09:56:52",
		  "totalOrganizations": 65,
		  "totalTours": 58,
		  "totalDays": 1069,
		  "totalCountries": 16,
		  "totalStates": 41,
		  "totalEvents": 501,
		  "eventPercent": 0.978921,
		  "totalScheduleItems": 4085,
		  "schedulePercent": 0.917838,
		  "totalGuests": 982,
		  "guestPercent": 0.843042,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rden Under Bron",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c24ee6e9b47b3970f3ba8d502d998c98",
		  
		  "name": "Patrick",
		  "createdDate": "2017-03-20 17:56:04",
		  "totalOrganizations": 23,
		  "totalTours": 23,
		  "totalDays": 807,
		  "totalCountries": 43,
		  "totalStates": 105,
		  "totalEvents": 333,
		  "eventPercent": 0.934044,
		  "totalScheduleItems": 5154,
		  "schedulePercent": 0.958749,
		  "totalGuests": 1893,
		  "guestPercent": 0.93971,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Hala Stulecia",
		  "mostGuestCity": "WrocÅ‚aw",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2525e3888a0817fe668c2d3ab23eb97",
		  
		  "name": "Calbert",
		  "createdDate": "2016-07-01 00:15:43",
		  "totalOrganizations": 16,
		  "totalTours": 5,
		  "totalDays": 130,
		  "totalCountries": 9,
		  "totalStates": 32,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 788,
		  "schedulePercent": 0.418178,
		  "totalGuests": 671,
		  "guestPercent": 0.778332,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Fillmore Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c25be53fd9d4c9d0e904a2867d53a540",
		  
		  "name": "Sarah",
		  "createdDate": "2024-02-20 18:24:13",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 627,
		  "totalCountries": 10,
		  "totalStates": 49,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 884,
		  "schedulePercent": 0.452176,
		  "totalGuests": 446,
		  "guestPercent": 0.711355,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "The Orpheum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c26e11cb801b64f63773464bdc174591",
		  
		  "name": "marco ",
		  "createdDate": "2024-01-30 17:10:55",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 719,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 677,
		  "schedulePercent": 0.377493,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Monumental Plaza MÃ©xico",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2740d24b056bf9f4946c141d2253dd5",
		  
		  "name": "Lauren",
		  "createdDate": "2023-10-14 00:20:57",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 457,
		  "totalCountries": 12,
		  "totalStates": 54,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2087,
		  "schedulePercent": 0.730281,
		  "totalGuests": 1907,
		  "guestPercent": 0.940277,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c27510d31e9b907cfa3d7fd1e1dc5601",
		  
		  "name": "Jeroen",
		  "createdDate": "2018-06-26 15:43:38",
		  "totalOrganizations": 58,
		  "totalTours": 22,
		  "totalDays": 2089,
		  "totalCountries": 32,
		  "totalStates": 95,
		  "totalEvents": 543,
		  "eventPercent": 0.983681,
		  "totalScheduleItems": 6718,
		  "schedulePercent": 0.984248,
		  "totalGuests": 3217,
		  "guestPercent": 0.985607,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c27f45252a19d72f6e5c6b22d0034ac5",
		  
		  "name": "Neil",
		  "createdDate": "2022-05-28 20:13:26",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 227,
		  "totalCountries": 10,
		  "totalStates": 6,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 722,
		  "schedulePercent": 0.395172,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c285e10537725ae6ff3c28f2729fa8ea",
		  
		  "name": "Brennan",
		  "createdDate": "2022-03-10 13:37:14",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 214,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1234,
		  "schedulePercent": 0.555757,
		  "totalGuests": 135,
		  "guestPercent": 0.548844,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "Phoenix Concert Theatre",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c28c11af86fd91b6ab182069fd170462",
		  
		  "name": "Daniel",
		  "createdDate": "2019-10-31 21:32:26",
		  "totalOrganizations": 31,
		  "totalTours": 33,
		  "totalDays": 1994,
		  "totalCountries": 42,
		  "totalStates": 110,
		  "totalEvents": 505,
		  "eventPercent": 0.979828,
		  "totalScheduleItems": 5493,
		  "schedulePercent": 0.967248,
		  "totalGuests": 383,
		  "guestPercent": 0.68699,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "Planet Hollywood Las Vegas Resort & Casino",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c28dfa9e4e1be7c99828e61cceadb55d",
		  
		  "name": "Paolo",
		  "createdDate": "2018-03-30 11:19:11",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 53,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 431,
		  "schedulePercent": 0.282412,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c28effe8effc5abb5ae0f1b0bc88f2d8",
		  
		  "name": "Aleksander",
		  "createdDate": "2019-06-11 21:18:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 326,
		  "schedulePercent": 0.229601,
		  "totalGuests": 201,
		  "guestPercent": 0.595422,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Hvaler Gjestgiveri",
		  "mostGuestCity": "SkjÃ¦rhalden",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c296a64d94105f80aa300b863c5d2e8e",
		  
		  "name": "Calvin",
		  "createdDate": "2025-06-16 19:17:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 61,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 717,
		  "schedulePercent": 0.393019,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2991fb85ff5d0481126c1d00148ee57",
		  
		  "name": "Chase",
		  "createdDate": "2017-09-06 23:53:17",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 11,
		  "totalStates": 30,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 527,
		  "schedulePercent": 0.325136,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "The Ramkat",
		  "mostGuestCity": "Winston-Salem",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c299c19cdd2d70835aa0b786a2beda11",
		  
		  "name": "Mikhail",
		  "createdDate": "2025-02-25 15:00:59",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 144,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 646,
		  "schedulePercent": 0.36582,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2a14db479b63e0c41efd6e7cbcc26f6",
		  
		  "name": "Jim",
		  "createdDate": "2023-04-25 20:41:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 8,
		  "totalStates": 4,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 121,
		  "schedulePercent": 0.111627,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2acb4bfe4560b3ed3589749874bd394",
		  
		  "name": "Britt",
		  "createdDate": "2023-03-27 20:30:25",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 355,
		  "totalCountries": 20,
		  "totalStates": 66,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 2212,
		  "schedulePercent": 0.750113,
		  "totalGuests": 2156,
		  "guestPercent": 0.956029,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2afd7caff80445b0c689ac08ab77360",
		  
		  "name": "bill",
		  "createdDate": "2023-02-10 05:44:49",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 461,
		  "totalCountries": 26,
		  "totalStates": 42,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1652,
		  "schedulePercent": 0.650612,
		  "totalGuests": 723,
		  "guestPercent": 0.791138,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2b33232a47a5391265ab10c635b27d1",
		  
		  "name": "Soft Play",
		  "createdDate": "2019-06-25 15:57:05",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 130,
		  "totalCountries": 15,
		  "totalStates": 38,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 728,
		  "schedulePercent": 0.397439,
		  "totalGuests": 166,
		  "guestPercent": 0.570263,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Licorice Pizza Records",
		  "mostGuestCity": "Studio City",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2b44e007ba3dd610f3f8e0afca9d2b4",
		  
		  "name": "Tabitha",
		  "createdDate": "2013-09-04 03:24:30",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 79,
		  "totalCountries": 8,
		  "totalStates": 17,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 497,
		  "schedulePercent": 0.310857,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2b7f1f7b7471c33fdff056392a6d76c",
		  
		  "name": "Jimmie",
		  "createdDate": "2020-02-20 03:57:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 524,
		  "schedulePercent": 0.324003,
		  "totalGuests": 445,
		  "guestPercent": 0.710675,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2c9794ca80893df146e7198aa1e6947",
		  
		  "name": "Samantha",
		  "createdDate": "2013-02-15 02:36:20",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 232,
		  "totalCountries": 4,
		  "totalStates": 32,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1058,
		  "schedulePercent": 0.506573,
		  "totalGuests": 656,
		  "guestPercent": 0.772665,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2ce52ad5e2d2e1dbce9dd75bb914e7b",
		  
		  "name": "Pete",
		  "createdDate": "2014-09-11 16:09:49",
		  "totalOrganizations": 19,
		  "totalTours": 6,
		  "totalDays": 423,
		  "totalCountries": 17,
		  "totalStates": 57,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 1955,
		  "schedulePercent": 0.704216,
		  "totalGuests": 542,
		  "guestPercent": 0.741387,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2d14fe2d4557d817b3b7b0a94295fd1",
		  
		  "name": "Jackie",
		  "createdDate": "2019-11-07 22:09:25",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 200,
		  "totalCountries": 8,
		  "totalStates": 32,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1458,
		  "schedulePercent": 0.608908,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-03-31 00:00:00",
		  "mostGuestName": "The Danforth Music Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c2d82490f4758b7e8d2f6a5174008ab8",
		  
		  "name": "Brett",
		  "createdDate": "2011-10-11 15:55:18",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 151,
		  "schedulePercent": 0.130326,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3120f87b89613f3cd9024b529b5c3de",
		  
		  "name": "Leslie",
		  "createdDate": "2019-04-11 21:04:01",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 478,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1513,
		  "schedulePercent": 0.62058,
		  "totalGuests": 755,
		  "guestPercent": 0.797371,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3137ff4c63aa26180f8307f9f53c6b7",
		  
		  "name": "Etjen",
		  "createdDate": "2022-03-27 00:38:48",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 10,
		  "totalStates": 10,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 199,
		  "schedulePercent": 0.160245,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Union Chapel",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3167e37a5b54b37d94521d083c01663",
		  
		  "name": " Nick",
		  "createdDate": "2018-11-12 19:08:16",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 175,
		  "totalCountries": 13,
		  "totalStates": 39,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 614,
		  "schedulePercent": 0.355394,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c31a1a20f61f91e4371664270d704d42",
		  
		  "name": "Steven",
		  "createdDate": "2022-06-07 12:03:49",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 257,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1276,
		  "schedulePercent": 0.566636,
		  "totalGuests": 94,
		  "guestPercent": 0.512693,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Pier Six Pavilion",
		  "mostGuestCity": "Baltimore",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3249746cd2119c7ecfcb9544739ecbe",
		  
		  "name": "Angela",
		  "createdDate": "2023-11-16 21:59:09",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 214,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 772,
		  "schedulePercent": 0.413191,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-03-04 00:00:00",
		  "mostGuestName": "The Eastern",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c32eca23a5de0e700842d93e3b80c39f",
		  
		  "name": "Christina",
		  "createdDate": "2017-11-29 06:54:06",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 139,
		  "totalCountries": 13,
		  "totalStates": 54,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 817,
		  "schedulePercent": 0.429737,
		  "totalGuests": 320,
		  "guestPercent": 0.659791,
		  "mostGuestDate": "2025-07-08 00:00:00",
		  "mostGuestName": "Jannus Live",
		  "mostGuestCity": "St. Petersburg",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c33744c20082cc0a075c9df9e4f2d941",
		  
		  "name": "Meike",
		  "createdDate": "2023-12-04 13:09:03",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 894,
		  "schedulePercent": 0.455802,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c337971a5645dcb2307dbed737c25bc9",
		  
		  "name": "Cat",
		  "createdDate": "2023-03-24 20:33:22",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 143,
		  "totalCountries": 18,
		  "totalStates": 17,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1345,
		  "schedulePercent": 0.584429,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-01-03 00:00:00",
		  "mostGuestName": "The Fleece",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c34678ee5006573fb6fa3fae8d2c820e",
		  
		  "name": "Gabrielle",
		  "createdDate": "2024-09-17 10:35:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 110,
		  "totalCountries": 8,
		  "totalStates": 21,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 688,
		  "schedulePercent": 0.3818,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3552e2b2255f3b3e667c304f6c45d4b",
		  
		  "name": "Helen",
		  "createdDate": "2016-09-20 19:06:41",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 360,
		  "totalCountries": 14,
		  "totalStates": 41,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 1239,
		  "schedulePercent": 0.557004,
		  "totalGuests": 1938,
		  "guestPercent": 0.941636,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3586b36ce049e6acbd7fbd76fd302a8",
		  
		  "name": "Daniela",
		  "createdDate": "2018-05-17 19:56:04",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 694,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1403,
		  "schedulePercent": 0.598368,
		  "totalGuests": 694,
		  "guestPercent": 0.784111,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3606b12ed6988da3f273a3513a4b144",
		  
		  "name": "Noel",
		  "createdDate": "2025-07-01 13:52:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 86,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 859,
		  "schedulePercent": 0.444243,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c362d7af97cf69c25dc63f471dbc94db",
		  
		  "name": "Keith",
		  "createdDate": "2020-02-27 15:59:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 117,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 436,
		  "schedulePercent": 0.284338,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c366881b3fcdce278e278dd31a152499",
		  
		  "name": "",
		  "createdDate": "2022-05-05 16:04:39",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 122,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 222,
		  "schedulePercent": 0.172597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3668b438837011d65bed3b84e2a7d5e",
		  
		  "name": "Mason",
		  "createdDate": "2018-09-05 21:36:11",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 68,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 1044,
		  "schedulePercent": 0.502153,
		  "totalGuests": 1270,
		  "guestPercent": 0.88248,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 203,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3770087a112eb9c0b899e792eab5caf",
		  
		  "name": "Tammi",
		  "createdDate": "2021-09-21 20:46:46",
		  "totalOrganizations": 14,
		  "totalTours": 6,
		  "totalDays": 358,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 242,
		  "schedulePercent": 0.18529,
		  "totalGuests": 33,
		  "guestPercent": 0.424637,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Hollywood Bowl",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c37c8d9beb9706d35936ebf4ab899e10",
		  
		  "name": "Michael",
		  "createdDate": "2024-03-09 13:09:14",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 93,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 320,
		  "schedulePercent": 0.226995,
		  "totalGuests": 232,
		  "guestPercent": 0.614007,
		  "mostGuestDate": "2025-05-13 00:00:00",
		  "mostGuestName": "CMA Theater at the Country Music Hall of Fame and Museum",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c381e708f3f8ab9950fd1587588346c5",
		  
		  "name": "Kevin",
		  "createdDate": "2023-03-06 20:45:41",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 125,
		  "totalCountries": 12,
		  "totalStates": 20,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 391,
		  "schedulePercent": 0.265073,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "ParkbÃ¼hne GeyserHaus e.V.",
		  "mostGuestCity": "Leipzig",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c38801ad014da083c3e47801333cf2c6",
		  
		  "name": "Sebastian",
		  "createdDate": "2012-01-15 11:47:38",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 371,
		  "totalCountries": 10,
		  "totalStates": 9,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 349,
		  "schedulePercent": 0.24252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c38feece6c61f55cd701ab0139be7c34",
		  
		  "name": "Max",
		  "createdDate": "2022-05-24 15:31:39",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 342,
		  "totalCountries": 14,
		  "totalStates": 35,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 859,
		  "schedulePercent": 0.444243,
		  "totalGuests": 283,
		  "guestPercent": 0.640979,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c39dfb0e1ffedd53289b5af8f9d5f856",
		  
		  "name": "Mike",
		  "createdDate": "2016-10-28 17:13:32",
		  "totalOrganizations": 18,
		  "totalTours": 32,
		  "totalDays": 662,
		  "totalCountries": 33,
		  "totalStates": 64,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 2888,
		  "schedulePercent": 0.830916,
		  "totalGuests": 82,
		  "guestPercent": 0.499207,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Cheese & Grain",
		  "mostGuestCity": "Frome",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3a451842b7089fc952844d72fb5a1b6",
		  
		  "name": "Miriam",
		  "createdDate": "2020-02-20 19:40:59",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 334,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1495,
		  "schedulePercent": 0.6165,
		  "totalGuests": 143,
		  "guestPercent": 0.554057,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3a622bab612422cd0a55be357e9aaea",
		  
		  "name": "Jon",
		  "createdDate": "2011-10-06 19:10:07",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 840,
		  "totalCountries": 24,
		  "totalStates": 69,
		  "totalEvents": 332,
		  "eventPercent": 0.933817,
		  "totalScheduleItems": 6057,
		  "schedulePercent": 0.976315,
		  "totalGuests": 2994,
		  "guestPercent": 0.981641,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3a692c06e6e24b02482f8737199a98b",
		  
		  "name": "Christian",
		  "createdDate": "2014-06-03 08:54:15",
		  "totalOrganizations": 24,
		  "totalTours": 13,
		  "totalDays": 444,
		  "totalCountries": 25,
		  "totalStates": 38,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 1742,
		  "schedulePercent": 0.665911,
		  "totalGuests": 270,
		  "guestPercent": 0.634746,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Tivoli",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3b26ffc63960ff68a0154aa5bbb467d",
		  
		  "name": "Michael",
		  "createdDate": "2022-03-23 23:10:49",
		  "totalOrganizations": 15,
		  "totalTours": 19,
		  "totalDays": 1850,
		  "totalCountries": 36,
		  "totalStates": 111,
		  "totalEvents": 418,
		  "eventPercent": 0.963282,
		  "totalScheduleItems": 5080,
		  "schedulePercent": 0.956936,
		  "totalGuests": 1807,
		  "guestPercent": 0.933704,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Majestic Ventura Theater",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3c1fd0788a57bd29ed0d5e6d8008b98",
		  
		  "name": "Autumn ",
		  "createdDate": "2025-02-14 19:15:13",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 322,
		  "totalCountries": 6,
		  "totalStates": 42,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1321,
		  "schedulePercent": 0.576269,
		  "totalGuests": 1067,
		  "guestPercent": 0.857434,
		  "mostGuestDate": "2025-05-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3c4b68ba5619870729f3fe5c5ab27c2",
		  
		  "name": "Devin ",
		  "createdDate": "2018-01-15 16:53:19",
		  "totalOrganizations": 18,
		  "totalTours": 19,
		  "totalDays": 1093,
		  "totalCountries": 10,
		  "totalStates": 50,
		  "totalEvents": 434,
		  "eventPercent": 0.967362,
		  "totalScheduleItems": 6540,
		  "schedulePercent": 0.982434,
		  "totalGuests": 1617,
		  "guestPercent": 0.921238,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3cb26a440a8000853d68a90f0980818",
		  
		  "name": "Jordan",
		  "createdDate": "2017-05-26 17:43:06",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 148,
		  "totalCountries": 2,
		  "totalStates": 37,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1160,
		  "schedulePercent": 0.537511,
		  "totalGuests": 1036,
		  "guestPercent": 0.852221,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Northside Hospital-Cherokee Amphitheater",
		  "mostGuestCity": "Woodstock",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3cdf208cc9df9763c7f65eb51630a8c",
		  
		  "name": "Tim",
		  "createdDate": "2025-03-11 17:14:40",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 150,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 148,
		  "eventPercent": 0.700363,
		  "totalScheduleItems": 767,
		  "schedulePercent": 0.410925,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3d273e47ca109a3504a3f4edbe0b8e1",
		  
		  "name": "Dan",
		  "createdDate": "2015-06-08 17:18:23",
		  "totalOrganizations": 20,
		  "totalTours": 19,
		  "totalDays": 1271,
		  "totalCountries": 11,
		  "totalStates": 58,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 2803,
		  "schedulePercent": 0.822303,
		  "totalGuests": 801,
		  "guestPercent": 0.807684,
		  "mostGuestDate": "2025-08-20 00:00:00",
		  "mostGuestName": "Scotiabank Saddledome",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3d29e435fd0a30e39e0b8ce8ece1d79",
		  
		  "name": "AmÃ©lia",
		  "createdDate": "2024-08-02 13:19:21",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 115,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 498,
		  "schedulePercent": 0.31131,
		  "totalGuests": 170,
		  "guestPercent": 0.574003,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Carre 150 - Salle Les Freres Lemaire",
		  "mostGuestCity": "Victoriaville",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3d396d8b804a29f237a5f29361c4600",
		  
		  "name": "Jeff",
		  "createdDate": "2018-09-05 19:55:21",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 230,
		  "totalCountries": 2,
		  "totalStates": 42,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 2036,
		  "schedulePercent": 0.720082,
		  "totalGuests": 714,
		  "guestPercent": 0.788985,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "The Get Down Music Venue",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3ef32959fbc43e9766bd92915f6e796",
		  
		  "name": "Rodger",
		  "createdDate": "2019-07-01 14:56:41",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 251,
		  "totalCountries": 17,
		  "totalStates": 61,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1372,
		  "schedulePercent": 0.590095,
		  "totalGuests": 161,
		  "guestPercent": 0.56675,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "The King Of Clubs",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3f118904fa26de574916a140aa823e3",
		  
		  "name": "KJ",
		  "createdDate": "2019-01-13 16:51:35",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 224,
		  "totalCountries": 6,
		  "totalStates": 31,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1871,
		  "schedulePercent": 0.689597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3f183fcb9e0ecb38f25754156ad74b7",
		  
		  "name": "Jonas",
		  "createdDate": "2013-11-02 16:19:10",
		  "totalOrganizations": 19,
		  "totalTours": 10,
		  "totalDays": 426,
		  "totalCountries": 10,
		  "totalStates": 4,
		  "totalEvents": 380,
		  "eventPercent": 0.953536,
		  "totalScheduleItems": 2210,
		  "schedulePercent": 0.749093,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3faf9d575c819888309c303a0a907f2",
		  
		  "name": "Derek",
		  "createdDate": "2013-09-21 13:18:23",
		  "totalOrganizations": 17,
		  "totalTours": 12,
		  "totalDays": 398,
		  "totalCountries": 24,
		  "totalStates": 66,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 2031,
		  "schedulePercent": 0.719175,
		  "totalGuests": 730,
		  "guestPercent": 0.792724,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Queenâ€™s Park",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c3fcff12e9b00d631c79668b47239854",
		  
		  "name": "Emily",
		  "createdDate": "2022-04-15 02:08:35",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 544,
		  "totalCountries": 11,
		  "totalStates": 44,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 2618,
		  "schedulePercent": 0.799637,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c413ceb0b3d8b75358a73038891340fc",
		  
		  "name": "Danielle",
		  "createdDate": "2019-03-18 21:00:15",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 473,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 1423,
		  "schedulePercent": 0.602788,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Bayfront Festival Park",
		  "mostGuestCity": "Duluth",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c4211752b5b4134a7f6741726fed33ae",
		  
		  "name": "ANOUAR",
		  "createdDate": "2025-03-25 13:24:41",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 38,
		  "totalCountries": 10,
		  "totalStates": 7,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 320,
		  "schedulePercent": 0.226995,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c42196e9f20e936e76e097075d8b2c23",
		  
		  "name": "Summer",
		  "createdDate": "2021-11-30 17:38:13",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 3,
		  "eventPercent": 0.0250453,
		  "totalScheduleItems": 270,
		  "schedulePercent": 0.199569,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Tulips FTW",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c427163872a3d1ce192c156e464139fd",
		  
		  "name": "Duane",
		  "createdDate": "2013-05-05 01:49:18",
		  "totalOrganizations": 9,
		  "totalTours": 18,
		  "totalDays": 430,
		  "totalCountries": 12,
		  "totalStates": 27,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1248,
		  "schedulePercent": 0.560063,
		  "totalGuests": 760,
		  "guestPercent": 0.798277,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c43171539cbcbb4b27f88d8622fcc639",
		  
		  "name": "Miren ",
		  "createdDate": "2023-06-29 17:58:55",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 608,
		  "totalCountries": 27,
		  "totalStates": 61,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 3664,
		  "schedulePercent": 0.894152,
		  "totalGuests": 1317,
		  "guestPercent": 0.889053,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c432d4439b6cde776476102aa7d03a5f",
		  
		  "name": "Mike",
		  "createdDate": "2023-05-12 20:25:58",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 86,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 652,
		  "schedulePercent": 0.3682,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c43b7ab787a5fdc4c0d0c281dd43ed6b",
		  
		  "name": "Joseph",
		  "createdDate": "2014-10-16 02:51:23",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 160,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 845,
		  "schedulePercent": 0.438803,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Roseland Theater",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c440c870de3b5b24d5bc0c01cdc8ff64",
		  
		  "name": "TCS",
		  "createdDate": "2023-10-18 21:02:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 14,
		  "totalStates": 31,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 1645,
		  "schedulePercent": 0.649139,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c44b2fa46ff62e7b7bc722c2cf9d099c",
		  
		  "name": "Jim",
		  "createdDate": "2014-04-11 10:22:27",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 121,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 475,
		  "schedulePercent": 0.300091,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "White Eagle Hall",
		  "mostGuestCity": "Jersey City",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c469470f758843be4500b20e9f6b610f",
		  
		  "name": "Joe",
		  "createdDate": "2024-01-22 16:35:05",
		  "totalOrganizations": 60,
		  "totalTours": 39,
		  "totalDays": 1958,
		  "totalCountries": 13,
		  "totalStates": 25,
		  "totalEvents": 446,
		  "eventPercent": 0.969968,
		  "totalScheduleItems": 3078,
		  "schedulePercent": 0.849388,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c47b5ba17f860bec066181929b6505f3",
		  
		  "name": "Andre",
		  "createdDate": "2012-12-15 16:31:07",
		  "totalOrganizations": 15,
		  "totalTours": 4,
		  "totalDays": 176,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 1471,
		  "schedulePercent": 0.611061,
		  "totalGuests": 248,
		  "guestPercent": 0.624207,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "The Finsbury",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c48467db7073594fcd4c1011bb7b04d3",
		  
		  "name": "Drew",
		  "createdDate": "2017-11-02 13:40:55",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 845,
		  "totalCountries": 21,
		  "totalStates": 65,
		  "totalEvents": 275,
		  "eventPercent": 0.895059,
		  "totalScheduleItems": 4312,
		  "schedulePercent": 0.931324,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Warner Theatre",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c489905879b64878bd9cf2473a77c2a8",
		  
		  "name": "Tami",
		  "createdDate": "2019-05-02 18:52:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 1557,
		  "schedulePercent": 0.6318,
		  "totalGuests": 1502,
		  "guestPercent": 0.908885,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c495052bb4b13b8e75338ce26c74e3eb",
		  
		  "name": "Jess",
		  "createdDate": "2018-03-08 01:25:27",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 26,
		  "totalStates": 27,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 527,
		  "schedulePercent": 0.325136,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c49d2ac1572d19e81ff0aa088faa7c90",
		  
		  "name": "Gel",
		  "createdDate": "2025-01-27 23:15:00",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 58,
		  "totalCountries": 5,
		  "totalStates": 24,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 40,
		  "schedulePercent": 0.0504306,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c49ef5935e5fb8435908643c109809bb",
		  
		  "name": "Christy",
		  "createdDate": "2022-03-10 14:10:58",
		  "totalOrganizations": 7,
		  "totalTours": 34,
		  "totalDays": 138,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 3976,
		  "schedulePercent": 0.911945,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c4b75b69dc3a6aa73a74d619bd53737f",
		  
		  "name": "Zack",
		  "createdDate": "2018-08-30 00:12:31",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 691,
		  "totalCountries": 4,
		  "totalStates": 51,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 3530,
		  "schedulePercent": 0.88384,
		  "totalGuests": 3151,
		  "guestPercent": 0.984701,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c4bcfdae588392aef4bb1bb01c3f2c45",
		  
		  "name": "Peter",
		  "createdDate": "2022-01-06 14:42:38",
		  "totalOrganizations": 18,
		  "totalTours": 17,
		  "totalDays": 236,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1118,
		  "schedulePercent": 0.524025,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c4c3127f2c1bcbafe020fac101543091",
		  
		  "name": "Mitchell",
		  "createdDate": "2022-07-06 04:08:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 96,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 132,
		  "schedulePercent": 0.119674,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c4c45f1e5fa577336da91231e4f39e0c",
		  
		  "name": "Erkan",
		  "createdDate": "2017-04-06 00:32:05",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 64,
		  "totalCountries": 14,
		  "totalStates": 5,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 147,
		  "schedulePercent": 0.128853,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Ribs & Blues Raalte",
		  "mostGuestCity": "Raalte",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c4d1be00f5b76e05506ee7be580800d9",
		  
		  "name": "Paula",
		  "createdDate": "2014-12-02 20:16:14",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 479,
		  "totalCountries": 22,
		  "totalStates": 43,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1611,
		  "schedulePercent": 0.642339,
		  "totalGuests": 2269,
		  "guestPercent": 0.960902,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Estadio 3 de marzo",
		  "mostGuestCity": "Guadalajara",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c4dfb15a121be2f600b590a949c2f693",
		  
		  "name": "Jamie",
		  "createdDate": "2021-07-12 16:40:04",
		  "totalOrganizations": 16,
		  "totalTours": 22,
		  "totalDays": 2245,
		  "totalCountries": 27,
		  "totalStates": 81,
		  "totalEvents": 363,
		  "eventPercent": 0.947529,
		  "totalScheduleItems": 3984,
		  "schedulePercent": 0.912171,
		  "totalGuests": 723,
		  "guestPercent": 0.791138,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wythenshawe Park and Gardens",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c4f2f6d493e3b85a46dfc8e168a2215f",
		  
		  "name": "dorian",
		  "createdDate": "2025-03-19 13:01:24",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 24,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 208,
		  "schedulePercent": 0.165005,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c504017ba3649faab27f096ec4e28b74",
		  
		  "name": "Brian",
		  "createdDate": "2009-08-14 21:09:53",
		  "totalOrganizations": 28,
		  "totalTours": 6,
		  "totalDays": 714,
		  "totalCountries": 22,
		  "totalStates": 72,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 3384,
		  "schedulePercent": 0.874207,
		  "totalGuests": 457,
		  "guestPercent": 0.714982,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Estadi de Son Moix",
		  "mostGuestCity": "Palma",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c50b1d9d543e240bf9b2c7a454d70048",
		  
		  "name": "Nathan",
		  "createdDate": "2018-01-08 18:03:43",
		  "totalOrganizations": 12,
		  "totalTours": 17,
		  "totalDays": 1784,
		  "totalCountries": 26,
		  "totalStates": 73,
		  "totalEvents": 313,
		  "eventPercent": 0.921351,
		  "totalScheduleItems": 2761,
		  "schedulePercent": 0.817316,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Singing Bird Studio",
		  "mostGuestCity": "Frankston",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c50fc91aab1e0f07aa5031d394d643d0",
		  
		  "name": "LaTisha",
		  "createdDate": "2022-10-07 11:21:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 95,
		  "totalCountries": 7,
		  "totalStates": 11,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 421,
		  "schedulePercent": 0.278672,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "713 Music Hall",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c51604c19dc2f2c02e5a7487dfd70e01",
		  
		  "name": "Carlos",
		  "createdDate": "2013-01-10 10:51:35",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 371,
		  "totalCountries": 4,
		  "totalStates": 24,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Centro de Eventos Pedregal in Heredia",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c51d308d9f28ad02560459c35e8b1a45",
		  
		  "name": "Adam",
		  "createdDate": "2015-09-25 21:55:14",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 702,
		  "totalCountries": 5,
		  "totalStates": 50,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 1959,
		  "schedulePercent": 0.705349,
		  "totalGuests": 357,
		  "guestPercent": 0.677244,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Palais Theatre",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c52d590873798313d349c3aaea8e0358",
		  
		  "name": "Kellye",
		  "createdDate": "2017-09-18 00:55:39",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 271,
		  "totalCountries": 7,
		  "totalStates": 30,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1030,
		  "schedulePercent": 0.498753,
		  "totalGuests": 379,
		  "guestPercent": 0.685403,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c52d7be9d8b4bfcbc0da0baf1dc93d7b",
		  
		  "name": "Carissa",
		  "createdDate": "2014-04-09 20:34:22",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 50,
		  "totalCountries": 10,
		  "totalStates": 10,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Koger Center for the Arts",
		  "mostGuestCity": "Columbia",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c54582ba5f75021db54d5b21d06a024e",
		  
		  "name": "Malcolm",
		  "createdDate": "2016-11-08 04:05:22",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 89,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 585,
		  "schedulePercent": 0.345648,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Bell Centre",
		  "mostGuestCity": "Montreal",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c563a4d3efc72e16646265ffc7e6cc7a",
		  
		  "name": "Charlie",
		  "createdDate": "2022-06-15 15:44:46",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 150,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1248,
		  "schedulePercent": 0.560063,
		  "totalGuests": 645,
		  "guestPercent": 0.770399,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5715b6a073d82f54bb99f51229172ac",
		  
		  "name": "Roberto",
		  "createdDate": "2010-03-22 15:26:54",
		  "totalOrganizations": 28,
		  "totalTours": 6,
		  "totalDays": 538,
		  "totalCountries": 3,
		  "totalStates": 46,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1493,
		  "schedulePercent": 0.615934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c572a178baa202b119e9da8a4c167456",
		  
		  "name": "Lauren",
		  "createdDate": "2024-01-24 23:09:57",
		  "totalOrganizations": 4,
		  "totalTours": 15,
		  "totalDays": 384,
		  "totalCountries": 14,
		  "totalStates": 34,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1557,
		  "schedulePercent": 0.6318,
		  "totalGuests": 231,
		  "guestPercent": 0.613327,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Seascape Resort & Conference Center",
		  "mostGuestCity": "Miramar Beach",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c574487ba71125149683e94bc728d7c2",
		  
		  "name": "James",
		  "createdDate": "2022-05-16 21:08:46",
		  "totalOrganizations": 21,
		  "totalTours": 21,
		  "totalDays": 4683,
		  "totalCountries": 43,
		  "totalStates": 95,
		  "totalEvents": 473,
		  "eventPercent": 0.974275,
		  "totalScheduleItems": 8488,
		  "schedulePercent": 0.991727,
		  "totalGuests": 1834,
		  "guestPercent": 0.935063,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5807340e8bdbd39dffae68aeccdcc2e",
		  
		  "name": "Robert",
		  "createdDate": "2015-06-25 23:49:35",
		  "totalOrganizations": 31,
		  "totalTours": 20,
		  "totalDays": 571,
		  "totalCountries": 23,
		  "totalStates": 71,
		  "totalEvents": 293,
		  "eventPercent": 0.908092,
		  "totalScheduleItems": 3840,
		  "schedulePercent": 0.905258,
		  "totalGuests": 1636,
		  "guestPercent": 0.922937,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c592e20278f509a88c1115a701803cfd",
		  
		  "name": "Paul",
		  "createdDate": "2014-04-22 04:53:46",
		  "totalOrganizations": 16,
		  "totalTours": 27,
		  "totalDays": 845,
		  "totalCountries": 24,
		  "totalStates": 85,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 4990,
		  "schedulePercent": 0.954102,
		  "totalGuests": 2118,
		  "guestPercent": 0.954782,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5948bc0ac86435ef3146b5147196fec",
		  
		  "name": "Lien",
		  "createdDate": "2022-01-11 09:49:15",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 490,
		  "totalCountries": 32,
		  "totalStates": 45,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2893,
		  "schedulePercent": 0.831369,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Auditorium Parco Della Musica - Sala Sinopoli",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c595248cac818a7f6ce34c59601028c1",
		  
		  "name": "Travis",
		  "createdDate": "2012-02-09 07:09:17",
		  "totalOrganizations": 3,
		  "totalTours": 14,
		  "totalDays": 127,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1132,
		  "schedulePercent": 0.528785,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "M Resort Spa Casino",
		  "mostGuestCity": "Henderson",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c595fb273e4ee16abbcf9bae6e81431f",
		  
		  "name": "Eric",
		  "createdDate": "2022-09-23 10:52:13",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 941,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 767,
		  "schedulePercent": 0.410925,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Rose Festival",
		  "mostGuestCity": "Aussonne",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5989b0e76c91048b7d6fadeedae2498",
		  
		  "name": "Erin",
		  "createdDate": "2023-09-21 15:31:44",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 328,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1189,
		  "schedulePercent": 0.544878,
		  "totalGuests": 813,
		  "guestPercent": 0.811763,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c59bed7c08e6d1b321ad178a928f5208",
		  
		  "name": "Rich",
		  "createdDate": "2023-02-21 23:32:47",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 239,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1101,
		  "schedulePercent": 0.519606,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c59d5e7f9aa03fc0ea85755568bb8b9d",
		  
		  "name": "James",
		  "createdDate": "2013-11-09 11:15:25",
		  "totalOrganizations": 13,
		  "totalTours": 3,
		  "totalDays": 718,
		  "totalCountries": 23,
		  "totalStates": 46,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 5636,
		  "schedulePercent": 0.970308,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5a097def27553cbd1272d48a7709ae0",
		  
		  "name": "femi",
		  "createdDate": "2025-11-01 10:25:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 10,
		  "totalStates": 7,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 148,
		  "schedulePercent": 0.129646,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5a19a7f502b9cf36b437a748981deda",
		  
		  "name": "Matt",
		  "createdDate": "2014-01-28 16:18:32",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 505,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 1081,
		  "schedulePercent": 0.514619,
		  "totalGuests": 9103,
		  "guestPercent": 0.99898,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 523,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5ad709aa72ee57dbb7a832e7df68948",
		  
		  "name": "Mike ",
		  "createdDate": "2011-01-29 22:55:55",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 670,
		  "totalCountries": 6,
		  "totalStates": 43,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1065,
		  "schedulePercent": 0.50816,
		  "totalGuests": 112,
		  "guestPercent": 0.529805,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Wooly's",
		  "mostGuestCity": "Des Moines",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5af16fd501608a581cf90d6e3a61227",
		  
		  "name": "James",
		  "createdDate": "2017-05-10 09:14:06",
		  "totalOrganizations": 17,
		  "totalTours": 8,
		  "totalDays": 1241,
		  "totalCountries": 25,
		  "totalStates": 70,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 5014,
		  "schedulePercent": 0.954556,
		  "totalGuests": 112,
		  "guestPercent": 0.529805,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5b28a0df868b708856faccc0f2d72ae",
		  
		  "name": "Craig",
		  "createdDate": "2009-07-27 05:27:10",
		  "totalOrganizations": 11,
		  "totalTours": 8,
		  "totalDays": 1078,
		  "totalCountries": 13,
		  "totalStates": 49,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 2309,
		  "schedulePercent": 0.763033,
		  "totalGuests": 355,
		  "guestPercent": 0.676564,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5b3aa05c5158aa99be28bf94a02b0f4",
		  
		  "name": "Scott",
		  "createdDate": "2011-06-06 16:57:53",
		  "totalOrganizations": 18,
		  "totalTours": 15,
		  "totalDays": 773,
		  "totalCountries": 20,
		  "totalStates": 73,
		  "totalEvents": 261,
		  "eventPercent": 0.88248,
		  "totalScheduleItems": 2730,
		  "schedulePercent": 0.813123,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Foundry",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5cd88e7dd788ba01f57c6abe41b3cc7",
		  
		  "name": "Emily",
		  "createdDate": "2017-04-27 19:47:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5d083b0d0f6bc12ed6dd8bac2a1aaf7",
		  
		  "name": "Jo",
		  "createdDate": "2022-08-17 06:27:31",
		  "totalOrganizations": 48,
		  "totalTours": 48,
		  "totalDays": 1444,
		  "totalCountries": 28,
		  "totalStates": 69,
		  "totalEvents": 615,
		  "eventPercent": 0.988214,
		  "totalScheduleItems": 4421,
		  "schedulePercent": 0.935743,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "Palladium",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5d25bae1e567100557bac7152a3fb4a",
		  
		  "name": "Joshua",
		  "createdDate": "2025-06-30 20:16:51",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 206,
		  "totalCountries": 8,
		  "totalStates": 27,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 779,
		  "schedulePercent": 0.415798,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Bell Centre",
		  "mostGuestCity": "Montreal",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5e2b5876935ef2f79db8e5187e0874d",
		  
		  "name": "Phony",
		  "createdDate": "2024-04-18 19:08:49",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 79,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 107,
		  "schedulePercent": 0.102675,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Cafe Erzulie",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5e74d6a049f398e9b914a0574f9bae6",
		  
		  "name": "Bonvehi ",
		  "createdDate": "2024-03-18 09:43:07",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 44,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 293,
		  "schedulePercent": 0.213849,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5e94b6b1e81487c62843e5ded0a36b3",
		  
		  "name": "Brent",
		  "createdDate": "2014-06-13 19:57:23",
		  "totalOrganizations": 5,
		  "totalTours": 18,
		  "totalDays": 1399,
		  "totalCountries": 27,
		  "totalStates": 71,
		  "totalEvents": 425,
		  "eventPercent": 0.964642,
		  "totalScheduleItems": 6827,
		  "schedulePercent": 0.985041,
		  "totalGuests": 995,
		  "guestPercent": 0.845082,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Analog at Hutton Hotel",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 191,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5eca756b3e904ec32669facfb9ab1fc",
		  
		  "name": "Staffan",
		  "createdDate": "2016-04-13 11:35:23",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 248,
		  "totalCountries": 30,
		  "totalStates": 23,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1601,
		  "schedulePercent": 0.640866,
		  "totalGuests": 388,
		  "guestPercent": 0.68903,
		  "mostGuestDate": "2025-06-25 00:00:00",
		  "mostGuestName": "Stockholm Fields",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5ef7f1d5d0c5361f7682ae503a6c49f",
		  
		  "name": "Salome",
		  "createdDate": "2017-02-11 18:49:03",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 748,
		  "totalCountries": 4,
		  "totalStates": 20,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1304,
		  "schedulePercent": 0.57219,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Palais de la Musique et des CongrÃ¨s",
		  "mostGuestCity": "Strasbourg",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c5f0a97e9630c6e9abaa0d1517ccb7ac",
		  
		  "name": "Jonathan",
		  "createdDate": "2016-02-22 18:09:43",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 1043,
		  "totalCountries": 12,
		  "totalStates": 55,
		  "totalEvents": 285,
		  "eventPercent": 0.901859,
		  "totalScheduleItems": 3309,
		  "schedulePercent": 0.868087,
		  "totalGuests": 896,
		  "guestPercent": 0.828989,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6051a3afbb749c32500f63faccf0af2",
		  
		  "name": "James ",
		  "createdDate": "2023-07-28 21:02:15",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 102,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 554,
		  "schedulePercent": 0.335109,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6151834952513a2fd08d6e8b7c1ad3e",
		  
		  "name": "Cody",
		  "createdDate": "2014-06-09 20:44:56",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 837,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 1923,
		  "schedulePercent": 0.698436,
		  "totalGuests": 1973,
		  "guestPercent": 0.94549,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c616663494e9b49abe1d93c58fcf239f",
		  
		  "name": "matthew",
		  "createdDate": "2012-10-04 21:20:21",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 120,
		  "totalCountries": 10,
		  "totalStates": 17,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 181,
		  "schedulePercent": 0.147212,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Ogden Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c616f3453de0a8173dbbb50909389e83",
		  
		  "name": "Jen",
		  "createdDate": "2019-05-21 07:48:46",
		  "totalOrganizations": 7,
		  "totalTours": 21,
		  "totalDays": 533,
		  "totalCountries": 28,
		  "totalStates": 44,
		  "totalEvents": 242,
		  "eventPercent": 0.863667,
		  "totalScheduleItems": 2335,
		  "schedulePercent": 0.766319,
		  "totalGuests": 1040,
		  "guestPercent": 0.852788,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c61cc6cd96f0f9144da4adb6631bac1d",
		  
		  "name": "Lindsay",
		  "createdDate": "2018-12-16 17:48:47",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 731,
		  "totalCountries": 4,
		  "totalStates": 58,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 2210,
		  "schedulePercent": 0.749093,
		  "totalGuests": 1441,
		  "guestPercent": 0.904012,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c625e8e08cfe5cfe27e9c2dcc76ee722",
		  
		  "name": "Nathan",
		  "createdDate": "2022-06-15 11:28:44",
		  "totalOrganizations": 16,
		  "totalTours": 45,
		  "totalDays": 567,
		  "totalCountries": 26,
		  "totalStates": 69,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 2879,
		  "schedulePercent": 0.830122,
		  "totalGuests": 1109,
		  "guestPercent": 0.865707,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c626a6773c602b9d9216be852d51a290",
		  
		  "name": "Yura",
		  "createdDate": "2025-02-21 19:24:22",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 124,
		  "totalCountries": 18,
		  "totalStates": 29,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 757,
		  "schedulePercent": 0.408658,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Blue Note",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c633b3e62808ec410e35aeacaa02b4fe",
		  
		  "name": "Martin ",
		  "createdDate": "2022-03-26 17:11:54",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 149,
		  "totalCountries": 28,
		  "totalStates": 26,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1331,
		  "schedulePercent": 0.580689,
		  "totalGuests": 476,
		  "guestPercent": 0.722688,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Gothenburg Studios",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6342a25663e8ce7de8204f1f4b777e0",
		  
		  "name": "Stuart",
		  "createdDate": "2019-01-04 03:34:38",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 409,
		  "totalCountries": 15,
		  "totalStates": 23,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 664,
		  "schedulePercent": 0.373073,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6493141086f6f62079d6dabe276b2cd",
		  
		  "name": "Peter",
		  "createdDate": "2019-01-15 06:18:49",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 391,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1117,
		  "schedulePercent": 0.523119,
		  "totalGuests": 566,
		  "guestPercent": 0.74796,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Pitt Street Uniting Church",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c654ca6ada6f7df51820bacc888a6f5f",
		  
		  "name": "Nicholas ",
		  "createdDate": "2018-01-26 02:56:47",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 496,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1705,
		  "schedulePercent": 0.659338,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c66cc0cda421983310814dbad8ae25d0",
		  
		  "name": "Travis ",
		  "createdDate": "2015-11-05 19:44:18",
		  "totalOrganizations": 8,
		  "totalTours": 39,
		  "totalDays": 839,
		  "totalCountries": 11,
		  "totalStates": 57,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 2886,
		  "schedulePercent": 0.830689,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Grand Ballroom at Webster Hall ",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c66e5f1fe19b0a0276feb956c7f0529c",
		  
		  "name": "Christian",
		  "createdDate": "2025-11-03 08:06:23",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c68c3c82fe67d28d5febc2469bb1ab7a",
		  
		  "name": "Jordan",
		  "createdDate": "2019-01-17 05:14:27",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 97,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 492,
		  "schedulePercent": 0.30893,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Cerritos Center for the Performing Arts",
		  "mostGuestCity": "Cerritos",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6bcea68054cfae3e3c0dfe413b0eeba",
		  
		  "name": "Kade ",
		  "createdDate": "2025-03-04 17:43:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 372,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 230,
		  "schedulePercent": 0.177697,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6c4ea0819f26975880d2e71210982c2",
		  
		  "name": "Emily",
		  "createdDate": "2017-02-10 21:19:38",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 88,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 269,
		  "schedulePercent": 0.198889,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Missoula County Fairgrounds",
		  "mostGuestCity": "Missoula",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6cc266196a8a5952ed1f4b974c20224",
		  
		  "name": "Myles",
		  "createdDate": "2015-03-22 19:18:21",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 424,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 2211,
		  "schedulePercent": 0.749433,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6d0fd25b59ccd71ef0432576a791025",
		  
		  "name": "Jon",
		  "createdDate": "2023-09-29 22:26:45",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 58,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 206,
		  "schedulePercent": 0.163871,
		  "totalGuests": 338,
		  "guestPercent": 0.670104,
		  "mostGuestDate": "2025-01-22 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6d121e3653d3834fb1bdaf5b97d56ad",
		  
		  "name": "Sonja",
		  "createdDate": "2020-02-02 15:57:18",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 87,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 512,
		  "schedulePercent": 0.316636,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6d12796fbb6d03cb35d877f96a0cdba",
		  
		  "name": "Mary",
		  "createdDate": "2022-11-11 11:25:28",
		  "totalOrganizations": 19,
		  "totalTours": 19,
		  "totalDays": 586,
		  "totalCountries": 40,
		  "totalStates": 103,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 3094,
		  "schedulePercent": 0.851201,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Borgholms Slott",
		  "mostGuestCity": "Borgholm",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6d12faf8e4b84c3d20e3b54d18acd05",
		  
		  "name": "Michael ",
		  "createdDate": "2023-01-30 18:52:16",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 246,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1845,
		  "schedulePercent": 0.68495,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c6ee2cc5aa9ed38b9c052f6e4ebe1ebd",
		  
		  "name": "Khayla",
		  "createdDate": "2021-09-21 00:16:29",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 380,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c701dc7727d95423a93f9efd4943e615",
		  
		  "name": "Alex",
		  "createdDate": "2015-04-05 15:18:41",
		  "totalOrganizations": 9,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 2,
		  "totalStates": 33,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 716,
		  "schedulePercent": 0.392339,
		  "totalGuests": 872,
		  "guestPercent": 0.823436,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c71510c931e453433c92507453d9fdaf",
		  
		  "name": "Benjamin",
		  "createdDate": "2022-02-16 13:15:07",
		  "totalOrganizations": 2,
		  "totalTours": 13,
		  "totalDays": 116,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 379,
		  "schedulePercent": 0.257026,
		  "totalGuests": 162,
		  "guestPercent": 0.56777,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c71be3cb49e33582744ad3a932fb329e",
		  
		  "name": "Jakob",
		  "createdDate": "2014-05-05 11:51:38",
		  "totalOrganizations": 14,
		  "totalTours": 11,
		  "totalDays": 726,
		  "totalCountries": 17,
		  "totalStates": 47,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 2365,
		  "schedulePercent": 0.770739,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "DjurÃ¶nÃ¤set Konferens & Hotell",
		  "mostGuestCity": "Djurhamn",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c71d70f7377febec72d2bad688241d35",
		  
		  "name": "Justin",
		  "createdDate": "2022-07-28 20:35:50",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 659,
		  "totalCountries": 15,
		  "totalStates": 37,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1306,
		  "schedulePercent": 0.573096,
		  "totalGuests": 602,
		  "guestPercent": 0.75884,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c725982d7321b142353f92120cca3c9f",
		  
		  "name": "Andrea",
		  "createdDate": "2024-12-14 21:47:03",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 180,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 4,
		  "eventPercent": 0.0322983,
		  "totalScheduleItems": 278,
		  "schedulePercent": 0.204216,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c72785e73ff955fcbaeda44e593ca6e1",
		  
		  "name": "Whitney",
		  "createdDate": "2015-05-19 16:14:55",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 501,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1641,
		  "schedulePercent": 0.648005,
		  "totalGuests": 114,
		  "guestPercent": 0.531505,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Neighborhood Theatre",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c73e91a375d1b8be5bb030d22dbf134f",
		  
		  "name": "Rene",
		  "createdDate": "2017-03-21 22:49:13",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 616,
		  "totalCountries": 14,
		  "totalStates": 21,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 258,
		  "schedulePercent": 0.194016,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7523523e7e8169b8732880661622790",
		  
		  "name": "Jensen",
		  "createdDate": "2013-06-25 19:52:34",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 1711,
		  "totalCountries": 8,
		  "totalStates": 64,
		  "totalEvents": 304,
		  "eventPercent": 0.915231,
		  "totalScheduleItems": 5179,
		  "schedulePercent": 0.959202,
		  "totalGuests": 3164,
		  "guestPercent": 0.984927,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7541e72923084c9ea1c4ab2524315a1",
		  
		  "name": "Gary",
		  "createdDate": "2013-01-07 21:27:13",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 451,
		  "totalCountries": 20,
		  "totalStates": 61,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 4417,
		  "schedulePercent": 0.935403,
		  "totalGuests": 1781,
		  "guestPercent": 0.93223,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7569e0a9d55730e965f06f3a3e9ce1f",
		  
		  "name": "Chase",
		  "createdDate": "2021-11-06 18:19:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 80,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 677,
		  "schedulePercent": 0.377493,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "Majestic Theatre",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c758a15a496952f4b49c478f1b59f544",
		  
		  "name": "Devin",
		  "createdDate": "2013-02-24 20:37:34",
		  "totalOrganizations": 19,
		  "totalTours": 27,
		  "totalDays": 1905,
		  "totalCountries": 28,
		  "totalStates": 104,
		  "totalEvents": 600,
		  "eventPercent": 0.987421,
		  "totalScheduleItems": 9537,
		  "schedulePercent": 0.995807,
		  "totalGuests": 2434,
		  "guestPercent": 0.966342,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c76b76f1edb5ad11e9c9a15204e39844",
		  
		  "name": "Jason",
		  "createdDate": "2023-01-04 01:31:42",
		  "totalOrganizations": 1,
		  "totalTours": 21,
		  "totalDays": 123,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 363,
		  "schedulePercent": 0.249433,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c76e0db32cdce5d864c376bb765e436f",
		  
		  "name": "Phillip",
		  "createdDate": "2016-09-15 11:26:26",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 493,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1670,
		  "schedulePercent": 0.653219,
		  "totalGuests": 399,
		  "guestPercent": 0.694016,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7736a18b1a0375a868884332ea88567",
		  
		  "name": "Sarah",
		  "createdDate": "2020-09-03 17:57:03",
		  "totalOrganizations": 32,
		  "totalTours": 16,
		  "totalDays": 757,
		  "totalCountries": 7,
		  "totalStates": 39,
		  "totalEvents": 281,
		  "eventPercent": 0.898912,
		  "totalScheduleItems": 1297,
		  "schedulePercent": 0.57083,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "PEI Brewing Company",
		  "mostGuestCity": "Charlottetown",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c78fd33a2bdfd98d85edd55000d830c8",
		  
		  "name": "Ben ",
		  "createdDate": "2017-01-09 22:40:27",
		  "totalOrganizations": 16,
		  "totalTours": 11,
		  "totalDays": 446,
		  "totalCountries": 9,
		  "totalStates": 14,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2139,
		  "schedulePercent": 0.738214,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-08-26 00:00:00",
		  "mostGuestName": "La Belle Angele",
		  "mostGuestCity": "Edinburgh",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c795cb3814da797ea7e3b773daaaf18d",
		  
		  "name": "Thor-Erik",
		  "createdDate": "2019-12-02 08:34:23",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 62,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 176,
		  "schedulePercent": 0.143699,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Parkbiografen",
		  "mostGuestCity": "Skien",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7964be549b49cdf5cd7e2700458fa9a",
		  
		  "name": "Juliet",
		  "createdDate": "2015-04-18 22:06:25",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 155,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 122,
		  "schedulePercent": 0.112534,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-11-04 00:00:00",
		  "mostGuestName": "La Seine Musicale",
		  "mostGuestCity": "Boulogne-Billancourt",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7a95821c390ecacc8664b8f34c8d328",
		  
		  "name": "Jackson",
		  "createdDate": "2024-06-06 01:56:52",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 57,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 534,
		  "schedulePercent": 0.328762,
		  "totalGuests": 135,
		  "guestPercent": 0.548844,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "170 Russell",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7ad7942ff29f145ee96033e686177e4",
		  
		  "name": "Matt",
		  "createdDate": "2013-10-09 23:37:48",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 265,
		  "totalCountries": 17,
		  "totalStates": 25,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 2418,
		  "schedulePercent": 0.777199,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "100 Club",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7b510837b18856031eb91fe700584d3",
		  
		  "name": "Ryan",
		  "createdDate": "2019-05-03 16:48:19",
		  "totalOrganizations": 14,
		  "totalTours": 3,
		  "totalDays": 632,
		  "totalCountries": 13,
		  "totalStates": 51,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 2271,
		  "schedulePercent": 0.75816,
		  "totalGuests": 95,
		  "guestPercent": 0.513826,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Yaamava' Resort & Casino",
		  "mostGuestCity": "Highland",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7bc53d77822823a9d0acd5986b02c99",
		  
		  "name": "Romain",
		  "createdDate": "2018-06-14 12:30:36",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 206,
		  "totalCountries": 25,
		  "totalStates": 49,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 1489,
		  "schedulePercent": 0.61548,
		  "totalGuests": 584,
		  "guestPercent": 0.75442,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Zenith Paris - La Villette",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 160,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7bd345c0c17075cd969e86da433260d",
		  
		  "name": "Chucky ",
		  "createdDate": "2013-10-15 11:55:01",
		  "totalOrganizations": 30,
		  "totalTours": 25,
		  "totalDays": 779,
		  "totalCountries": 37,
		  "totalStates": 106,
		  "totalEvents": 438,
		  "eventPercent": 0.968495,
		  "totalScheduleItems": 5630,
		  "schedulePercent": 0.970082,
		  "totalGuests": 1130,
		  "guestPercent": 0.868314,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Chelsea Heights Hotel",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7be83c45251f228af4ba1c4727ca6e8",
		  
		  "name": "Christine",
		  "createdDate": "2010-11-01 16:04:04",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 782,
		  "totalCountries": 20,
		  "totalStates": 68,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 2891,
		  "schedulePercent": 0.831256,
		  "totalGuests": 701,
		  "guestPercent": 0.786151,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7f7330f96617e22acebfeb7daad25f0",
		  
		  "name": "ALLEN",
		  "createdDate": "2019-11-29 02:23:40",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 99,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c7f74e9f469f0c0fdf14f05b902c2199",
		  
		  "name": "Kenny",
		  "createdDate": "2025-03-30 22:38:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 95,
		  "totalCountries": 19,
		  "totalStates": 37,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 860,
		  "schedulePercent": 0.44481,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c801aa93afc339bab41bd9015ac021f7",
		  
		  "name": "Ita",
		  "createdDate": "2024-08-12 22:29:48",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 251,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 1093,
		  "schedulePercent": 0.518472,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c80ce8d41e7452f3e2d3db622fcd4d2f",
		  
		  "name": "Russell",
		  "createdDate": "2023-08-19 13:35:50",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 470,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 1590,
		  "schedulePercent": 0.638373,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c80e2006b9bfcfb04209e3862a223a88",
		  
		  "name": "Mark",
		  "createdDate": "2022-07-14 21:03:53",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 112,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 291,
		  "schedulePercent": 0.212602,
		  "totalGuests": 224,
		  "guestPercent": 0.609474,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Gov",
		  "mostGuestCity": "Hindmarsh",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c81ae5d3402302fbd76c35c76b126348",
		  
		  "name": "Camila",
		  "createdDate": "2023-03-27 22:09:17",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 248,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 283,
		  "schedulePercent": 0.207729,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8271615984656c46943259d16cd3201",
		  
		  "name": "Jesse",
		  "createdDate": "2011-10-17 22:53:27",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 907,
		  "totalCountries": 24,
		  "totalStates": 73,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 4061,
		  "schedulePercent": 0.917044,
		  "totalGuests": 1181,
		  "guestPercent": 0.874207,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8344e40d849153902e61d3d97e95c8b",
		  
		  "name": "David ",
		  "createdDate": "2023-04-28 12:46:50",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 78,
		  "totalCountries": 20,
		  "totalStates": 9,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 635,
		  "schedulePercent": 0.362647,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8410e3a6c6284f398bce2ded33cf25d",
		  
		  "name": "Keith",
		  "createdDate": "2014-03-11 13:30:26",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 639,
		  "totalCountries": 36,
		  "totalStates": 56,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 2783,
		  "schedulePercent": 0.81981,
		  "totalGuests": 170,
		  "guestPercent": 0.574003,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c842d577189f46d1aa64d5ed3590b2c3",
		  
		  "name": "Taylor",
		  "createdDate": "2013-08-28 18:05:36",
		  "totalOrganizations": 22,
		  "totalTours": 31,
		  "totalDays": 875,
		  "totalCountries": 38,
		  "totalStates": 96,
		  "totalEvents": 436,
		  "eventPercent": 0.967928,
		  "totalScheduleItems": 8961,
		  "schedulePercent": 0.9932,
		  "totalGuests": 4703,
		  "guestPercent": 0.9966,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c84c2427e8475f8abdf92310165d23ec",
		  
		  "name": "Ninni",
		  "createdDate": "2024-06-05 12:12:33",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 116,
		  "totalCountries": 6,
		  "totalStates": 5,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 459,
		  "schedulePercent": 0.294311,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c84e1e6cbb977da3fa19b12bf6273666",
		  
		  "name": "Zach",
		  "createdDate": "2024-08-27 19:47:24",
		  "totalOrganizations": 1,
		  "totalTours": 96,
		  "totalDays": 487,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 296,
		  "eventPercent": 0.910131,
		  "totalScheduleItems": 1362,
		  "schedulePercent": 0.587942,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c854865fe2d0f0f9f26dfafb8c4741a7",
		  
		  "name": "Britney",
		  "createdDate": "2022-05-14 19:24:24",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 403,
		  "totalCountries": 4,
		  "totalStates": 19,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 227,
		  "schedulePercent": 0.175431,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c854e1a91edc5b7570929f17bd2069d2",
		  
		  "name": "Michael",
		  "createdDate": "2013-01-19 22:38:53",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 172,
		  "schedulePercent": 0.141772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c85a05c9b26590727d55773c87ac762a",
		  
		  "name": "Luis ",
		  "createdDate": "2022-06-19 11:32:32",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 192,
		  "totalCountries": 21,
		  "totalStates": 34,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 682,
		  "schedulePercent": 0.379873,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c865b99cbf6306a93fddc8462b0fb9cc",
		  
		  "name": "Carlos",
		  "createdDate": "2016-01-29 23:09:21",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 72,
		  "totalCountries": 13,
		  "totalStates": 17,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 329,
		  "schedulePercent": 0.230508,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c870bcb1c4ebe68c328ba1a691a115cb",
		  
		  "name": "West",
		  "createdDate": "2023-02-21 17:03:08",
		  "totalOrganizations": 52,
		  "totalTours": 31,
		  "totalDays": 639,
		  "totalCountries": 17,
		  "totalStates": 41,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 2556,
		  "schedulePercent": 0.793631,
		  "totalGuests": 820,
		  "guestPercent": 0.81301,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Stadtpark",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8767bb303f420aa5a77baa0d0ee2c41",
		  
		  "name": "Kate",
		  "createdDate": "2015-04-01 00:48:38",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 1988,
		  "totalCountries": 33,
		  "totalStates": 79,
		  "totalEvents": 366,
		  "eventPercent": 0.948436,
		  "totalScheduleItems": 5874,
		  "schedulePercent": 0.974048,
		  "totalGuests": 1704,
		  "guestPercent": 0.928377,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8797382d958abe21ca3898f1bfc2d6b",
		  
		  "name": "sharin",
		  "createdDate": "2012-06-19 00:54:48",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 32,
		  "totalCountries": 11,
		  "totalStates": 15,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Triennale di Milano",
		  "mostGuestCity": "Milano",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c87ea75ff3475c7c2f47ee0329ac3359",
		  
		  "name": "The",
		  "createdDate": "2022-12-21 16:09:51",
		  "totalOrganizations": 6,
		  "totalTours": 22,
		  "totalDays": 696,
		  "totalCountries": 8,
		  "totalStates": 48,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 3510,
		  "schedulePercent": 0.882706,
		  "totalGuests": 2159,
		  "guestPercent": 0.956256,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c88587dd19c10dbe3835cdc5168c5888",
		  
		  "name": "Brandt",
		  "createdDate": "2016-06-08 18:59:02",
		  "totalOrganizations": 33,
		  "totalTours": 27,
		  "totalDays": 706,
		  "totalCountries": 27,
		  "totalStates": 79,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 3268,
		  "schedulePercent": 0.865594,
		  "totalGuests": 204,
		  "guestPercent": 0.597915,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c886aea2b4bcc0607736dbc85f8dccf6",
		  
		  "name": "Vincent",
		  "createdDate": "2019-05-07 13:21:40",
		  "totalOrganizations": 15,
		  "totalTours": 5,
		  "totalDays": 90,
		  "totalCountries": 7,
		  "totalStates": 14,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 691,
		  "schedulePercent": 0.383273,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "Bizarre ! ScÃ¨ne Hip Hop â€” La Machinerie VÃ©nissieux",
		  "mostGuestCity": "VÃ©nissieux",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c88c898dec454286781f24d4b8ed5691",
		  
		  "name": "Davina",
		  "createdDate": "2024-11-06 07:14:36",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 311,
		  "totalCountries": 12,
		  "totalStates": 10,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 486,
		  "schedulePercent": 0.304397,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c890d38a76521f46dea181b24453a8de",
		  
		  "name": "Hallie",
		  "createdDate": "2022-06-27 18:40:12",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 409,
		  "totalCountries": 9,
		  "totalStates": 41,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1579,
		  "schedulePercent": 0.636559,
		  "totalGuests": 246,
		  "guestPercent": 0.622733,
		  "mostGuestDate": "2025-03-31 00:00:00",
		  "mostGuestName": "The Danforth Music Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c895a85e2a15e4c4ed19018d410a2f27",
		  
		  "name": "Carmen ",
		  "createdDate": "2024-09-18 00:37:45",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 745,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 111,
		  "schedulePercent": 0.106074,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8995fef08ebe4eaea343c2881780b5a",
		  
		  "name": "Maiju",
		  "createdDate": "2023-09-29 07:25:12",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 42,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 275,
		  "schedulePercent": 0.202403,
		  "totalGuests": 184,
		  "guestPercent": 0.582276,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "Nordis Live",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8b7e04efd24bf6ded93aa90881daa3d",
		  
		  "name": "Richard",
		  "createdDate": "2019-10-26 15:10:51",
		  "totalOrganizations": 28,
		  "totalTours": 14,
		  "totalDays": 2689,
		  "totalCountries": 20,
		  "totalStates": 58,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 3866,
		  "schedulePercent": 0.905938,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8bfd041ad63d752274b0b09d3a6f295",
		  
		  "name": "Didi",
		  "createdDate": "2024-06-28 14:21:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 33,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 330,
		  "schedulePercent": 0.230961,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8c0f2e74f2f947060a01f3634db0e57",
		  
		  "name": "Owen",
		  "createdDate": "2012-11-07 05:45:21",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 477,
		  "totalCountries": 6,
		  "totalStates": 23,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1211,
		  "schedulePercent": 0.549524,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-03-11 00:00:00",
		  "mostGuestName": "Melbourne Convention and Exhibition Centre (MCEC)",
		  "mostGuestCity": "South Wharf",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8c6dac187cc07cf5fb2ca0b380ba488",
		  
		  "name": "Jun",
		  "createdDate": "2017-08-15 18:00:33",
		  "totalOrganizations": 25,
		  "totalTours": 18,
		  "totalDays": 259,
		  "totalCountries": 26,
		  "totalStates": 49,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1500,
		  "schedulePercent": 0.618427,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8d3b71fe743020b1e17aa5fdc51ce6d",
		  
		  "name": "Raj",
		  "createdDate": "2011-12-09 21:02:27",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 128,
		  "totalCountries": 12,
		  "totalStates": 25,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 928,
		  "schedulePercent": 0.467928,
		  "totalGuests": 304,
		  "guestPercent": 0.651972,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8e632a63a011902c09f16688ddc2898",
		  
		  "name": "Jonathan",
		  "createdDate": "2015-06-30 00:55:51",
		  "totalOrganizations": 16,
		  "totalTours": 31,
		  "totalDays": 664,
		  "totalCountries": 30,
		  "totalStates": 35,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 1933,
		  "schedulePercent": 0.700476,
		  "totalGuests": 363,
		  "guestPercent": 0.67917,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8e8c32152e5021f2f433a7178bc7448",
		  
		  "name": "Dev",
		  "createdDate": "2024-05-07 15:25:44",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 160,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 304,
		  "schedulePercent": 0.218948,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8f076803bc40ca24324255be8b6cb41",
		  
		  "name": "Philip",
		  "createdDate": "2021-12-09 18:43:14",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 562,
		  "schedulePercent": 0.337942,
		  "totalGuests": 251,
		  "guestPercent": 0.625567,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8f92bf64bb1a40da6d727816623cb54",
		  
		  "name": "Ariana",
		  "createdDate": "2023-08-07 15:09:29",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 341,
		  "totalCountries": 10,
		  "totalStates": 16,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 824,
		  "schedulePercent": 0.43223,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c8fa0953f0c2dcc2cc38f21ece3a2b40",
		  
		  "name": "Rebecca",
		  "createdDate": "2023-10-08 18:28:58",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 37,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 140,
		  "schedulePercent": 0.12432,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c901d3adf7d65e20e381624751bb2e8c",
		  
		  "name": "Martin ",
		  "createdDate": "2022-07-30 03:21:03",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 1045,
		  "totalCountries": 6,
		  "totalStates": 44,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1253,
		  "schedulePercent": 0.561197,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c90fd8a648243f2afb14ab5973e307c5",
		  
		  "name": "Alex",
		  "createdDate": "2024-10-13 01:58:00",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 252,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 396,
		  "schedulePercent": 0.267452,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c910c1982554c88787b7a2ae8024d479",
		  
		  "name": "Jeff",
		  "createdDate": "2015-12-07 12:32:47",
		  "totalOrganizations": 7,
		  "totalTours": 37,
		  "totalDays": 1015,
		  "totalCountries": 27,
		  "totalStates": 65,
		  "totalEvents": 389,
		  "eventPercent": 0.955916,
		  "totalScheduleItems": 4498,
		  "schedulePercent": 0.93835,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c91407f03c8d89a510b6cf34f3268d7c",
		  
		  "name": "Dan",
		  "createdDate": "2019-11-01 00:43:43",
		  "totalOrganizations": 29,
		  "totalTours": 22,
		  "totalDays": 598,
		  "totalCountries": 13,
		  "totalStates": 31,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 2075,
		  "schedulePercent": 0.728241,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Brisbane Convention & Exhibition Centre",
		  "mostGuestCity": "South Brisbane",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c91b1e05de11b07fe9b1b36223476b32",
		  
		  "name": "Rishi",
		  "createdDate": "2021-09-07 14:02:19",
		  "totalOrganizations": 12,
		  "totalTours": 20,
		  "totalDays": 1255,
		  "totalCountries": 37,
		  "totalStates": 72,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 4308,
		  "schedulePercent": 0.93121,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c930aa92ab767d6a5ec6700e573ea24e",
		  
		  "name": "Martin",
		  "createdDate": "2024-05-26 19:58:26",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 79,
		  "totalCountries": 18,
		  "totalStates": 24,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 233,
		  "guestPercent": 0.614234,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Rex Club",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c93724188f3ce73b303453c0e932dcd8",
		  
		  "name": "Eric",
		  "createdDate": "2013-10-09 15:48:15",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 407,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1495,
		  "schedulePercent": 0.6165,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c93c0994f3a14c84841ec651bffd3130",
		  
		  "name": "Adam",
		  "createdDate": "2017-03-28 22:05:25",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 384,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 695,
		  "schedulePercent": 0.384406,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c94d102fc420d4f83740543ea2556083",
		  
		  "name": "Michael",
		  "createdDate": "2017-09-01 22:14:59",
		  "totalOrganizations": 20,
		  "totalTours": 13,
		  "totalDays": 231,
		  "totalCountries": 32,
		  "totalStates": 35,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1378,
		  "schedulePercent": 0.592248,
		  "totalGuests": 676,
		  "guestPercent": 0.780032,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Hala Stulecia",
		  "mostGuestCity": "WrocÅ‚aw",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9541009ee1e8e9808df49021b5ad351",
		  
		  "name": "Ryan",
		  "createdDate": "2014-04-16 19:35:44",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 921,
		  "totalCountries": 24,
		  "totalStates": 83,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 3325,
		  "schedulePercent": 0.86922,
		  "totalGuests": 312,
		  "guestPercent": 0.654918,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "Xfinity Center",
		  "mostGuestCity": "Mansfield",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9550e9f6dc5c105411ecc3a787db00f",
		  
		  "name": "Philippe",
		  "createdDate": "2012-04-06 14:12:27",
		  "totalOrganizations": 7,
		  "totalTours": 20,
		  "totalDays": 533,
		  "totalCountries": 11,
		  "totalStates": 19,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 2779,
		  "schedulePercent": 0.81947,
		  "totalGuests": 268,
		  "guestPercent": 0.6335,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "La Halle aux Grains - Jazz Sur Son 31",
		  "mostGuestCity": "Toulouse",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9620ef2d15ae260aae3e1a0d77c7b0c",
		  
		  "name": "Marcel",
		  "createdDate": "2021-11-13 07:31:25",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 56,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 642,
		  "schedulePercent": 0.364914,
		  "totalGuests": 739,
		  "guestPercent": 0.793858,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Koelnarena",
		  "mostGuestCity": "Cologne",
		  "mostGuestAmount": 256,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c96b8573114f066343bc7916da6b3e90",
		  
		  "name": "Paul",
		  "createdDate": "2023-09-27 15:12:00",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 9,
		  "totalStates": 23,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 521,
		  "schedulePercent": 0.321736,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Tacoma Dome",
		  "mostGuestCity": "Tacoma",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c96d5e2d085bf28c9c05826a2eb449ce",
		  
		  "name": "Arcellas",
		  "createdDate": "2019-05-31 03:48:44",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 516,
		  "totalCountries": 12,
		  "totalStates": 17,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 426,
		  "schedulePercent": 0.280598,
		  "totalGuests": 51,
		  "guestPercent": 0.454329,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9726407cf5f36147bf2345696e5fd98",
		  
		  "name": "Jazmyn",
		  "createdDate": "2016-03-29 22:56:28",
		  "totalOrganizations": 5,
		  "totalTours": 56,
		  "totalDays": 233,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 2131,
		  "schedulePercent": 0.736854,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "First Baptist Church of Charlotte",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c97cd9f4607287ea456234b86545f998",
		  
		  "name": "Jemma",
		  "createdDate": "2023-06-16 15:14:23",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 69,
		  "totalCountries": 7,
		  "totalStates": 11,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 417,
		  "schedulePercent": 0.276972,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9843dd459a9c9a21ee9b5a885c83491",
		  
		  "name": "Kat",
		  "createdDate": "2022-01-07 04:59:18",
		  "totalOrganizations": 36,
		  "totalTours": 18,
		  "totalDays": 538,
		  "totalCountries": 18,
		  "totalStates": 20,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1707,
		  "schedulePercent": 0.660018,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c987506690e305a6c8dfc6538a83918d",
		  
		  "name": "Henry",
		  "createdDate": "2025-09-11 01:21:06",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 99,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1135,
		  "schedulePercent": 0.529805,
		  "totalGuests": 89,
		  "guestPercent": 0.50714,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "Revolution Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c98c46952e166e5aebec2b91ef02b5a7",
		  
		  "name": "MasterTour2",
		  "createdDate": "2017-10-19 14:21:30",
		  "totalOrganizations": 22,
		  "totalTours": 23,
		  "totalDays": 3209,
		  "totalCountries": 13,
		  "totalStates": 28,
		  "totalEvents": 383,
		  "eventPercent": 0.954216,
		  "totalScheduleItems": 4186,
		  "schedulePercent": 0.925431,
		  "totalGuests": 858,
		  "guestPercent": 0.821056,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Paleo Festival Nyon",
		  "mostGuestCity": "Nyon",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c98f90d5862a4afa17daf72c83d74517",
		  
		  "name": "Jaclyn",
		  "createdDate": "2024-02-23 03:56:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 123,
		  "schedulePercent": 0.113327,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Toad's Place",
		  "mostGuestCity": "New Haven",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c99b4dd672f1aed09f55eee48f190b5c",
		  
		  "name": "Alicia",
		  "createdDate": "2017-06-19 22:00:29",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 726,
		  "totalCountries": 25,
		  "totalStates": 26,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 2013,
		  "schedulePercent": 0.715662,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c99ca78d9879d143ad35d0c5f6f29645",
		  
		  "name": "Antonio",
		  "createdDate": "2023-04-27 05:22:09",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 179,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 742,
		  "schedulePercent": 0.401972,
		  "totalGuests": 97,
		  "guestPercent": 0.516092,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "Saint Andrews Hall",
		  "mostGuestCity": "DETRIOT",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c99d6687f8319670a13eda3426c200fb",
		  
		  "name": "Kenny",
		  "createdDate": "2021-08-17 20:33:41",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 287,
		  "totalCountries": 7,
		  "totalStates": 34,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 828,
		  "schedulePercent": 0.433477,
		  "totalGuests": 180,
		  "guestPercent": 0.580009,
		  "mostGuestDate": "2025-09-16 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9a30e4c5d701aa4dd6a7ebacfdaef58",
		  
		  "name": "Tenors",
		  "createdDate": "2015-07-10 16:51:28",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 181,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "McCallum Theatre",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9a64b7c84a633cdff3f4c877e3f4266",
		  
		  "name": "Rich",
		  "createdDate": "2018-05-29 19:42:17",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 177,
		  "totalCountries": 17,
		  "totalStates": 51,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 725,
		  "schedulePercent": 0.396306,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Crystal Bay Casino",
		  "mostGuestCity": "Crystal Bay",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9bc2d36100daf33f5a636819d8e0204",
		  
		  "name": "Rene",
		  "createdDate": "2016-05-28 20:42:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 45,
		  "totalCountries": 5,
		  "totalStates": 24,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 210,
		  "schedulePercent": 0.166251,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9c53f321421d6d0fbfdb2323abeda46",
		  
		  "name": "Lauren",
		  "createdDate": "2022-01-12 00:59:15",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 191,
		  "totalCountries": 8,
		  "totalStates": 29,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 719,
		  "schedulePercent": 0.393586,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "GLC Live at 20 Monroe",
		  "mostGuestCity": "Grand Rapids",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9cb6dd937ffb64aaac9e8ba08b9234e",
		  
		  "name": "Shaina",
		  "createdDate": "2024-07-23 21:54:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 312,
		  "totalCountries": 8,
		  "totalStates": 29,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 403,
		  "schedulePercent": 0.271192,
		  "totalGuests": 295,
		  "guestPercent": 0.647212,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9e559b8bd813c3187e1d51fbf1bf5a6",
		  
		  "name": "Katie",
		  "createdDate": "2017-08-15 03:05:31",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 508,
		  "totalCountries": 6,
		  "totalStates": 33,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1781,
		  "schedulePercent": 0.672711,
		  "totalGuests": 2582,
		  "guestPercent": 0.971328,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9e701281717891a2343065790bdfc2b",
		  
		  "name": "SP",
		  "createdDate": "2025-01-09 20:37:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 219,
		  "totalCountries": 12,
		  "totalStates": 29,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 562,
		  "schedulePercent": 0.337942,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9ec85e81e89e3828487784d5d466353",
		  
		  "name": "Colleen",
		  "createdDate": "2022-03-28 18:24:12",
		  "totalOrganizations": 5,
		  "totalTours": 14,
		  "totalDays": 406,
		  "totalCountries": 15,
		  "totalStates": 54,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 2102,
		  "schedulePercent": 0.733114,
		  "totalGuests": 1937,
		  "guestPercent": 0.94141,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "The Met Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "c9f6623d4b4689dcc3af3c317e835f97",
		  
		  "name": "Martijn",
		  "createdDate": "2015-06-10 13:57:02",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 250,
		  "totalCountries": 24,
		  "totalStates": 33,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1149,
		  "schedulePercent": 0.534338,
		  "totalGuests": 453,
		  "guestPercent": 0.713962,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Forest National",
		  "mostGuestCity": "Forest",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca1025ed17309eab57e6eb70cb1fbe39",
		  
		  "name": "Dany",
		  "createdDate": "2021-04-09 13:40:56",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 621,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 370,
		  "eventPercent": 0.949683,
		  "totalScheduleItems": 416,
		  "schedulePercent": 0.276519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca1117b7a8c2666d1add92907c6d75a2",
		  
		  "name": "Jennifer",
		  "createdDate": "2024-05-21 11:53:27",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 306,
		  "totalCountries": 12,
		  "totalStates": 27,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1136,
		  "schedulePercent": 0.530485,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca2542bdc73680a10d550a72c25de3cf",
		  
		  "name": "Genevieve",
		  "createdDate": "2023-01-10 20:54:19",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 509,
		  "totalCountries": 19,
		  "totalStates": 45,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1816,
		  "schedulePercent": 0.67883,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca4eb7579853f45cf72bb06c0b48893a",
		  
		  "name": "Tim",
		  "createdDate": "2016-02-20 11:55:00",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 151,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1572,
		  "schedulePercent": 0.635199,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Bryce Jordan Center",
		  "mostGuestCity": "University Park",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca4fdf7c7a253ccb264909ef00892c49",
		  
		  "name": "Daniel",
		  "createdDate": "2022-04-27 02:59:35",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 223,
		  "totalCountries": 15,
		  "totalStates": 41,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1808,
		  "schedulePercent": 0.677584,
		  "totalGuests": 1931,
		  "guestPercent": 0.941183,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Marathon Music Works",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 128,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca5600a545d39159378ba4c2ac3c1184",
		  
		  "name": "Adam",
		  "createdDate": "2021-12-05 23:27:39",
		  "totalOrganizations": 33,
		  "totalTours": 39,
		  "totalDays": 1626,
		  "totalCountries": 14,
		  "totalStates": 74,
		  "totalEvents": 424,
		  "eventPercent": 0.964302,
		  "totalScheduleItems": 6469,
		  "schedulePercent": 0.981414,
		  "totalGuests": 4745,
		  "guestPercent": 0.996827,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca613721bf41774edc0bc3d6379697dc",
		  
		  "name": "Brian",
		  "createdDate": "2010-10-19 21:56:44",
		  "totalOrganizations": 92,
		  "totalTours": 39,
		  "totalDays": 805,
		  "totalCountries": 17,
		  "totalStates": 49,
		  "totalEvents": 384,
		  "eventPercent": 0.954782,
		  "totalScheduleItems": 3797,
		  "schedulePercent": 0.902539,
		  "totalGuests": 2309,
		  "guestPercent": 0.962715,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca640e7e2728f10c53c3b36e3a7e1915",
		  
		  "name": "Michael",
		  "createdDate": "2020-01-07 19:19:05",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 344,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 70,
		  "schedulePercent": 0.0746827,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Payson Park",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca6612e857e97ef854e4298807e2693c",
		  
		  "name": "Alistair",
		  "createdDate": "2021-11-24 03:22:53",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 45,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 326,
		  "schedulePercent": 0.229601,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca72afb7050045214d86212542205249",
		  
		  "name": "Cedric",
		  "createdDate": "2018-04-27 10:06:07",
		  "totalOrganizations": 6,
		  "totalTours": 21,
		  "totalDays": 201,
		  "totalCountries": 29,
		  "totalStates": 42,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1831,
		  "schedulePercent": 0.682117,
		  "totalGuests": 391,
		  "guestPercent": 0.690277,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Stone Pony Summer Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca86d1b8617bf53978dda6cab4cc0608",
		  
		  "name": "Hannah",
		  "createdDate": "2017-04-13 19:11:10",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 106,
		  "totalCountries": 16,
		  "totalStates": 23,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 693,
		  "schedulePercent": 0.383613,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca8804b15c09a2e72b5ba75869bdc172",
		  
		  "name": "Tim",
		  "createdDate": "2015-10-04 07:43:39",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 838,
		  "totalCountries": 18,
		  "totalStates": 27,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2671,
		  "schedulePercent": 0.805417,
		  "totalGuests": 143,
		  "guestPercent": 0.554057,
		  "mostGuestDate": "2025-06-10 00:00:00",
		  "mostGuestName": "Empower Field at Mile High",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca956f7d7b1e7570d0f4cd4252ab65d1",
		  
		  "name": "Danny",
		  "createdDate": "2025-04-09 10:04:10",
		  "totalOrganizations": 11,
		  "totalTours": 4,
		  "totalDays": 963,
		  "totalCountries": 22,
		  "totalStates": 26,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 825,
		  "schedulePercent": 0.43257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ca9cc80f189b4fad9bdb0cab41413779",
		  
		  "name": "Natalie",
		  "createdDate": "2025-04-01 17:47:27",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 106,
		  "totalCountries": 12,
		  "totalStates": 18,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 317,
		  "schedulePercent": 0.225635,
		  "totalGuests": 97,
		  "guestPercent": 0.516092,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ancienne Belgique",
		  "mostGuestCity": "Brussel",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cab0ccc5f36fc419926a36cdb1fd4db7",
		  
		  "name": "David",
		  "createdDate": "2014-10-31 19:45:39",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 757,
		  "totalCountries": 11,
		  "totalStates": 41,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1591,
		  "schedulePercent": 0.639053,
		  "totalGuests": 299,
		  "guestPercent": 0.649139,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "AT&T Stadium",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cab9f48bb8a8acef21ca8be10f823f06",
		  
		  "name": "Jared",
		  "createdDate": "2025-07-29 15:30:37",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 293,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 782,
		  "schedulePercent": 0.416591,
		  "totalGuests": 173,
		  "guestPercent": 0.575816,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cac717be887351ebd566fddb6540f67b",
		  
		  "name": "Mitchell",
		  "createdDate": "2020-09-15 22:08:49",
		  "totalOrganizations": 14,
		  "totalTours": 2,
		  "totalDays": 134,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 1232,
		  "schedulePercent": 0.555417,
		  "totalGuests": 1031,
		  "guestPercent": 0.851088,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Signal",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 176,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cad1a2a0b7ed35e615c86e799e222c37",
		  
		  "name": "Marque",
		  "createdDate": "2024-03-04 23:51:05",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 544,
		  "totalCountries": 6,
		  "totalStates": 38,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1335,
		  "schedulePercent": 0.581936,
		  "totalGuests": 1596,
		  "guestPercent": 0.919311,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Ravinia",
		  "mostGuestCity": "Highland Park",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cad7c49f6a7770ef600c3a38716095e6",
		  
		  "name": "Ashley",
		  "createdDate": "2017-08-30 15:07:30",
		  "totalOrganizations": 10,
		  "totalTours": 2,
		  "totalDays": 175,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 819,
		  "schedulePercent": 0.430304,
		  "totalGuests": 595,
		  "guestPercent": 0.7568,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "HISTORY",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cad897b5dfe330a0cf55247303e4e06a",
		  
		  "name": "Mark",
		  "createdDate": "2023-01-03 21:35:58",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 408,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 2441,
		  "schedulePercent": 0.779805,
		  "totalGuests": 519,
		  "guestPercent": 0.735494,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Southern Kentucky Performing Arts Center (SKyPAC)",
		  "mostGuestCity": "Bowling Green",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cad9a54c2663cd3b25f2392544d81b37",
		  
		  "name": "Joe",
		  "createdDate": "2024-03-08 19:28:13",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 362,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 737,
		  "schedulePercent": 0.400272,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Mars Music Hall",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cadacb84d6e72e299a6705a293353daf",
		  
		  "name": "Matt",
		  "createdDate": "2013-01-20 07:18:19",
		  "totalOrganizations": 26,
		  "totalTours": 23,
		  "totalDays": 518,
		  "totalCountries": 23,
		  "totalStates": 66,
		  "totalEvents": 258,
		  "eventPercent": 0.87942,
		  "totalScheduleItems": 2851,
		  "schedulePercent": 0.827856,
		  "totalGuests": 783,
		  "guestPercent": 0.80383,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cadbd09a9c9758c8323954bf4934fce4",
		  
		  "name": "Brian",
		  "createdDate": "2021-09-27 17:55:48",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 140,
		  "totalCountries": 12,
		  "totalStates": 43,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 794,
		  "schedulePercent": 0.420331,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "White Eagle Hall",
		  "mostGuestCity": "Jersey City",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cadd4629dc909a2895b3c7f43d2f9d0d",
		  
		  "name": "John",
		  "createdDate": "2024-01-31 15:51:43",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 632,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1188,
		  "schedulePercent": 0.544084,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Ballroom",
		  "mostGuestCity": "Anderson ",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cadded718909247ceecd9946071eba9f",
		  
		  "name": "Claire",
		  "createdDate": "2011-09-06 13:31:54",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 731,
		  "totalCountries": 9,
		  "totalStates": 19,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1021,
		  "schedulePercent": 0.496374,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Mary's Underground",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cae5c72ace77c625e6406a94f7efe59c",
		  
		  "name": "Jonathon",
		  "createdDate": "2021-07-15 04:33:25",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 469,
		  "totalCountries": 24,
		  "totalStates": 98,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 2741,
		  "schedulePercent": 0.81505,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Desert Diamond Arena",
		  "mostGuestCity": "Glendale",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "caef1c16ed898cf98bb8799a2258f3a1",
		  
		  "name": "Jakob",
		  "createdDate": "2022-07-13 00:07:49",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 52,
		  "totalCountries": 3,
		  "totalStates": 26,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 437,
		  "schedulePercent": 0.284905,
		  "totalGuests": 107,
		  "guestPercent": 0.526292,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Jannus Live",
		  "mostGuestCity": "St. Petersburg",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "caf40164116fbf191d2bbc6c82b06bab",
		  
		  "name": "Scott",
		  "createdDate": "2013-03-21 21:59:32",
		  "totalOrganizations": 40,
		  "totalTours": 38,
		  "totalDays": 727,
		  "totalCountries": 43,
		  "totalStates": 88,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 3185,
		  "schedulePercent": 0.858341,
		  "totalGuests": 1392,
		  "guestPercent": 0.899705,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cafaae5c15d83608ea436579fecbaf46",
		  
		  "name": "Aura",
		  "createdDate": "2018-02-05 13:35:45",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 152,
		  "totalCountries": 17,
		  "totalStates": 23,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 942,
		  "schedulePercent": 0.473028,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cafb59bcb29f5db2cb0c2d2048585d70",
		  
		  "name": "Clay",
		  "createdDate": "2011-10-03 23:15:05",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 204,
		  "totalCountries": 4,
		  "totalStates": 20,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 1044,
		  "schedulePercent": 0.502153,
		  "totalGuests": 1544,
		  "guestPercent": 0.913985,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cafeebaccdb8e8ac4ab57b065682eda3",
		  
		  "name": "BR Admin",
		  "createdDate": "2022-11-29 05:02:15",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 156,
		  "totalCountries": 14,
		  "totalStates": 26,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 590,
		  "schedulePercent": 0.347575,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "King Tut's Wah Wah Hut",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb07867ccb9a90c11f75d27ef39a99c8",
		  
		  "name": "Charline",
		  "createdDate": "2020-02-20 13:05:39",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 490,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 2601,
		  "schedulePercent": 0.797597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb084dff809d9b42e7a31058970af9e1",
		  
		  "name": "Stephen",
		  "createdDate": "2010-02-11 21:00:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 213,
		  "totalCountries": 6,
		  "totalStates": 28,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1745,
		  "schedulePercent": 0.667271,
		  "totalGuests": 2354,
		  "guestPercent": 0.963622,
		  "mostGuestDate": "2025-07-21 00:00:00",
		  "mostGuestName": "Desert 5 Spot",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb0ed17ef807c46c95fb1f95e17871f9",
		  
		  "name": "John",
		  "createdDate": "2010-10-27 17:03:41",
		  "totalOrganizations": 8,
		  "totalTours": 15,
		  "totalDays": 303,
		  "totalCountries": 15,
		  "totalStates": 43,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 2094,
		  "schedulePercent": 0.731754,
		  "totalGuests": 2142,
		  "guestPercent": 0.955236,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb1f9e7a1729021ef2b1b81e01be13f4",
		  
		  "name": "Joan",
		  "createdDate": "2025-01-29 16:25:21",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 636,
		  "totalCountries": 17,
		  "totalStates": 34,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 307,
		  "schedulePercent": 0.221102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb3a748d3c0338ed90d417c0ab4174d8",
		  
		  "name": "Mitchell",
		  "createdDate": "2023-07-23 18:20:55",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 1062,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "The Echo Lounge & Music Hall",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb3e74c1098ee6861227abb141ab564d",
		  
		  "name": "Geoff",
		  "createdDate": "2021-03-29 16:57:36",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 530,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 2317,
		  "schedulePercent": 0.764279,
		  "totalGuests": 1312,
		  "guestPercent": 0.887919,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb42e0e10c6a7902c03f8a2caade61b1",
		  
		  "name": "Anthony",
		  "createdDate": "2023-08-20 05:21:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 42,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 544,
		  "schedulePercent": 0.331709,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Crowbar",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb46aaf9836bce4ae7d313320e0afd1a",
		  
		  "name": "Tom",
		  "createdDate": "2023-07-03 04:41:35",
		  "totalOrganizations": 11,
		  "totalTours": 27,
		  "totalDays": 358,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2016,
		  "schedulePercent": 0.716795,
		  "totalGuests": 805,
		  "guestPercent": 0.80893,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb49e3028429ffd1c0880454b8c63f5b",
		  
		  "name": "Sarah",
		  "createdDate": "2017-01-09 20:50:19",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 54,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb5028c0c211a5b3dc484f121cf9a56e",
		  
		  "name": "Enzo",
		  "createdDate": "2024-12-04 11:03:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 298,
		  "totalCountries": 6,
		  "totalStates": 18,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 951,
		  "schedulePercent": 0.475861,
		  "totalGuests": 421,
		  "guestPercent": 0.702969,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "AmphithÃ©Ã¢tre 3000",
		  "mostGuestCity": "Lyon",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb5940cc7e462dcf82acf5ddfccb7f1b",
		  
		  "name": "Jack",
		  "createdDate": "2019-10-03 12:57:54",
		  "totalOrganizations": 16,
		  "totalTours": 22,
		  "totalDays": 212,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1161,
		  "schedulePercent": 0.537965,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "OMEARA",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb660f42bf190a1ff06b94b8a4157eb2",
		  
		  "name": "Andree-Anne",
		  "createdDate": "2022-09-28 17:22:20",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 317,
		  "totalCountries": 9,
		  "totalStates": 44,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 1085,
		  "schedulePercent": 0.515979,
		  "totalGuests": 355,
		  "guestPercent": 0.676564,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb702debdf077500c00f45cef335bbbb",
		  
		  "name": "Daniel",
		  "createdDate": "2024-08-02 18:44:59",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 78,
		  "totalCountries": 4,
		  "totalStates": 18,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 1017,
		  "schedulePercent": 0.495354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb7678d88bbb54b738b9784d21fef1a7",
		  
		  "name": "Chris",
		  "createdDate": "2019-01-29 18:26:25",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 283,
		  "totalCountries": 23,
		  "totalStates": 33,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1267,
		  "schedulePercent": 0.56505,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "O2 Apollo Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb76db57ad507c1896b898e9c797c424",
		  
		  "name": "Courtney",
		  "createdDate": "2014-04-10 15:24:16",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 471,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1938,
		  "schedulePercent": 0.701836,
		  "totalGuests": 3252,
		  "guestPercent": 0.986514,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Ak-Chin Pavilion",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 173,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb8389d0e9ac305033aa73fccc6e9b3e",
		  
		  "name": "Alyssa",
		  "createdDate": "2024-09-08 21:45:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 179,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 348,
		  "schedulePercent": 0.241954,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb8f6fd5cce6c20768cfd7d4cb5f91b8",
		  
		  "name": "Emma",
		  "createdDate": "2014-06-17 01:44:02",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 96,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 249,
		  "schedulePercent": 0.189483,
		  "totalGuests": 173,
		  "guestPercent": 0.575816,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "The Barracks Precinct",
		  "mostGuestCity": "Manly",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cb9e3b0d5499e4108c6c9755775965f1",
		  
		  "name": "Michael",
		  "createdDate": "2019-04-24 22:55:26",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 705,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 9134,
		  "schedulePercent": 0.993994,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cbafc43be9dc451b214f714483994065",
		  
		  "name": "Niklas",
		  "createdDate": "2022-10-17 12:19:44",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 243,
		  "totalCountries": 22,
		  "totalStates": 58,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1587,
		  "schedulePercent": 0.637806,
		  "totalGuests": 275,
		  "guestPercent": 0.637579,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Columbia Theater",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cbbd4ebab738af12a4b0ea95f9c6411f",
		  
		  "name": "Nicole",
		  "createdDate": "2016-10-26 19:14:50",
		  "totalOrganizations": 22,
		  "totalTours": 3,
		  "totalDays": 203,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 1125,
		  "schedulePercent": 0.526632,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cbcdb32f899e974eb31e80dcf328d8c5",
		  
		  "name": "HELOISE",
		  "createdDate": "2021-07-07 18:49:12",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 283,
		  "totalCountries": 19,
		  "totalStates": 31,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 2036,
		  "schedulePercent": 0.720082,
		  "totalGuests": 1440,
		  "guestPercent": 0.903898,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Zenith Nantes Metropole",
		  "mostGuestCity": "St Herblain",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cbd32118a480e10076a2d86c8be4526f",
		  
		  "name": "Dani",
		  "createdDate": "2022-03-13 21:57:03",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 85,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 255,
		  "schedulePercent": 0.19311,
		  "totalGuests": 106,
		  "guestPercent": 0.525385,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "Lido",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cbe41ac1ae72e3794cc8b5b3c93d9e8c",
		  
		  "name": "Alfredo",
		  "createdDate": "2023-06-30 12:38:51",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 222,
		  "totalCountries": 9,
		  "totalStates": 34,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 610,
		  "schedulePercent": 0.354148,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cbfd9d39c0ac2b69a4dcbb5045b1066f",
		  
		  "name": "Christian",
		  "createdDate": "2024-04-29 10:59:35",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 800,
		  "totalCountries": 13,
		  "totalStates": 20,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 928,
		  "schedulePercent": 0.467928,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-20 00:00:00",
		  "mostGuestName": "Piano'cktail",
		  "mostGuestCity": "Bouguenais",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc00aacb360b8613cb2fb322f6605289",
		  
		  "name": "Ruben",
		  "createdDate": "2023-01-12 23:42:03",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 185,
		  "totalCountries": 17,
		  "totalStates": 38,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1760,
		  "schedulePercent": 0.670444,
		  "totalGuests": 596,
		  "guestPercent": 0.757026,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Estadi de Son Moix",
		  "mostGuestCity": "Palma",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc04cd3e5d3e183787f1b2e386243aed",
		  
		  "name": "Olga",
		  "createdDate": "2018-05-29 01:01:47",
		  "totalOrganizations": 19,
		  "totalTours": 29,
		  "totalDays": 937,
		  "totalCountries": 43,
		  "totalStates": 87,
		  "totalEvents": 381,
		  "eventPercent": 0.953762,
		  "totalScheduleItems": 3594,
		  "schedulePercent": 0.888599,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Stone Pony Summer Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc0d972876cac40a9ba49498075b0e4c",
		  
		  "name": "Rafa",
		  "createdDate": "2024-07-11 04:31:09",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 1616,
		  "totalCountries": 5,
		  "totalStates": 61,
		  "totalEvents": 393,
		  "eventPercent": 0.957162,
		  "totalScheduleItems": 3105,
		  "schedulePercent": 0.852108,
		  "totalGuests": 811,
		  "guestPercent": 0.811083,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Roadrunner",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc1446052a507a09ccb80711897236d9",
		  
		  "name": "Ken",
		  "createdDate": "2017-06-08 23:13:47",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 731,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "Schermerhorn Symphony Hall",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc210b001e7f951bfa68f342b3bb97fd",
		  
		  "name": "Ryan",
		  "createdDate": "2022-08-06 15:44:30",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 361,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 284,
		  "eventPercent": 0.901292,
		  "totalScheduleItems": 3619,
		  "schedulePercent": 0.890752,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc213ecde5aa50a10bf6770199dc96ee",
		  
		  "name": "Ana ",
		  "createdDate": "2024-10-23 14:52:40",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 556,
		  "totalCountries": 22,
		  "totalStates": 67,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 3158,
		  "schedulePercent": 0.856074,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc267a01ec5b765a055f55d3aa033f69",
		  
		  "name": "Peter",
		  "createdDate": "2017-02-22 22:47:54",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 647,
		  "totalCountries": 12,
		  "totalStates": 36,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "The Fillmore New Orleans",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc2bb0a6d21b8ac159dc88bdd51baad5",
		  
		  "name": "Ashraf",
		  "createdDate": "2023-11-14 16:17:51",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 365,
		  "totalCountries": 13,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 144,
		  "schedulePercent": 0.127267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc2e0788ab9c7a6dd4152987d42f5941",
		  
		  "name": "Dean",
		  "createdDate": "2016-12-07 06:33:00",
		  "totalOrganizations": 21,
		  "totalTours": 33,
		  "totalDays": 1051,
		  "totalCountries": 15,
		  "totalStates": 69,
		  "totalEvents": 321,
		  "eventPercent": 0.926904,
		  "totalScheduleItems": 5373,
		  "schedulePercent": 0.964755,
		  "totalGuests": 1824,
		  "guestPercent": 0.934497,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 527,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc37042d30154862816e0c305e8b56f3",
		  
		  "name": "Ian",
		  "createdDate": "2023-07-10 18:38:11",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 489,
		  "totalCountries": 28,
		  "totalStates": 31,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 2172,
		  "schedulePercent": 0.743314,
		  "totalGuests": 156,
		  "guestPercent": 0.563577,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc37cc1c99336f0b1e6c995668058003",
		  
		  "name": "Joe",
		  "createdDate": "2015-04-24 21:36:23",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 122,
		  "totalCountries": 6,
		  "totalStates": 5,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Shacklewell Arms",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc5c4ea09da3ab782b8a9ccc185d6d25",
		  
		  "name": "Emma",
		  "createdDate": "2022-06-01 23:24:41",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 335,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 234,
		  "schedulePercent": 0.18053,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc78afe7589f61bc7d700c9986d2f67c",
		  
		  "name": "Foxing",
		  "createdDate": "2016-10-11 20:33:33",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 7,
		  "totalStates": 9,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 163,
		  "schedulePercent": 0.137579,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Neue Zukunft",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc826ea0256ba157a7bf976a9df46ff8",
		  
		  "name": "Josh",
		  "createdDate": "2022-06-14 20:01:25",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 353,
		  "totalCountries": 20,
		  "totalStates": 31,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 851,
		  "schedulePercent": 0.44039,
		  "totalGuests": 185,
		  "guestPercent": 0.583069,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc866512d463d3499fd23f35206bff56",
		  
		  "name": "Alain",
		  "createdDate": "2013-06-18 16:47:58",
		  "totalOrganizations": 15,
		  "totalTours": 5,
		  "totalDays": 185,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 1308,
		  "schedulePercent": 0.573323,
		  "totalGuests": 2946,
		  "guestPercent": 0.980621,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 391,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc8ebf8ee5432effe2b7eebc80996f4c",
		  
		  "name": "Matt",
		  "createdDate": "2019-01-21 22:07:41",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 374,
		  "totalCountries": 14,
		  "totalStates": 32,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1411,
		  "schedulePercent": 0.600408,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cc8f26b6193d322bafa8795ed93ccf7f",
		  
		  "name": "Magnus",
		  "createdDate": "2013-12-18 23:28:06",
		  "totalOrganizations": 29,
		  "totalTours": 7,
		  "totalDays": 39,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 219,
		  "schedulePercent": 0.171238,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cca2e69414d2a416f887f3dba030c332",
		  
		  "name": "Trevor",
		  "createdDate": "2022-07-26 17:59:41",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 754,
		  "totalCountries": 9,
		  "totalStates": 37,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 778,
		  "schedulePercent": 0.415458,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Palace Theater",
		  "mostGuestCity": "Stamford",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cca8f6e36e9238292c667239c5089e19",
		  
		  "name": "Benjamin",
		  "createdDate": "2016-10-23 06:31:48",
		  "totalOrganizations": 20,
		  "totalTours": 32,
		  "totalDays": 1244,
		  "totalCountries": 42,
		  "totalStates": 85,
		  "totalEvents": 324,
		  "eventPercent": 0.929964,
		  "totalScheduleItems": 3254,
		  "schedulePercent": 0.864574,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Lemon Grove",
		  "mostGuestCity": "Exeter",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccae835b5de29b8c5e812f44c198deee",
		  
		  "name": "John",
		  "createdDate": "2014-02-22 20:16:56",
		  "totalOrganizations": 19,
		  "totalTours": 15,
		  "totalDays": 924,
		  "totalCountries": 19,
		  "totalStates": 69,
		  "totalEvents": 328,
		  "eventPercent": 0.932004,
		  "totalScheduleItems": 4714,
		  "schedulePercent": 0.94481,
		  "totalGuests": 801,
		  "guestPercent": 0.807684,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccbbf4406ed0c6b7bec314a5c884754e",
		  
		  "name": "Adam",
		  "createdDate": "2014-05-06 01:22:25",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 89,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 1105,
		  "schedulePercent": 0.520059,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccc6b5d7353cdc5eaf560a64eb4daa02",
		  
		  "name": "Michael",
		  "createdDate": "2012-04-23 20:49:01",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 6,
		  "totalStates": 33,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 2057,
		  "schedulePercent": 0.725181,
		  "totalGuests": 876,
		  "guestPercent": 0.823889,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "North Nashville-Davidson",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccc713f0bd62a1e399ca64757f6a7a89",
		  
		  "name": "Viviane",
		  "createdDate": "2019-05-27 18:54:01",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 110,
		  "totalCountries": 6,
		  "totalStates": 10,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 821,
		  "schedulePercent": 0.431324,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Grand ThÃ©Ã¢tre de QuÃ©bec",
		  "mostGuestCity": "QuÃ©bec",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cccbbbb1a5c0929ead4fba68b8e3d6f6",
		  
		  "name": "Sean",
		  "createdDate": "2023-05-16 17:30:34",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 121,
		  "totalCountries": 17,
		  "totalStates": 47,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 724,
		  "schedulePercent": 0.395852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccdf1e0117323a1ad52976f778e550e5",
		  
		  "name": "Benjamin",
		  "createdDate": "2023-05-25 02:43:15",
		  "totalOrganizations": 1,
		  "totalTours": 14,
		  "totalDays": 192,
		  "totalCountries": 11,
		  "totalStates": 15,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1000,
		  "schedulePercent": 0.490141,
		  "totalGuests": 107,
		  "guestPercent": 0.526292,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Plenary Theatre",
		  "mostGuestCity": "South Wharf",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccea8e3d476eefd506a4712d6d8f3ec4",
		  
		  "name": "Daniel",
		  "createdDate": "2018-10-13 19:55:43",
		  "totalOrganizations": 5,
		  "totalTours": 16,
		  "totalDays": 327,
		  "totalCountries": 17,
		  "totalStates": 61,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 1463,
		  "schedulePercent": 0.609701,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cceea79ac7f5a5dca496abb722ace688",
		  
		  "name": "Eric",
		  "createdDate": "2009-06-03 22:18:14",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 922,
		  "totalCountries": 20,
		  "totalStates": 53,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2125,
		  "schedulePercent": 0.735947,
		  "totalGuests": 1505,
		  "guestPercent": 0.909565,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "The Salt Shed",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 106,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccf3af467d3088dd31ba108974f94767",
		  
		  "name": "Scott",
		  "createdDate": "2025-05-28 18:20:47",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 94,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 409,
		  "schedulePercent": 0.273459,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccf61ab4fddbe5909820f5e911c72044",
		  
		  "name": "Lindsey",
		  "createdDate": "2020-02-18 16:21:04",
		  "totalOrganizations": 37,
		  "totalTours": 31,
		  "totalDays": 6808,
		  "totalCountries": 28,
		  "totalStates": 102,
		  "totalEvents": 1708,
		  "eventPercent": 0.99932,
		  "totalScheduleItems": 25195,
		  "schedulePercent": 0.99966,
		  "totalGuests": 14411,
		  "guestPercent": 0.999773,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Ak-Chin Pavilion",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 173,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ccfbccd25b55e87df5aa167bd7e7384e",
		  
		  "name": "Samuel",
		  "createdDate": "2016-01-07 11:42:31",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 394,
		  "totalCountries": 31,
		  "totalStates": 71,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 3262,
		  "schedulePercent": 0.86514,
		  "totalGuests": 3348,
		  "guestPercent": 0.988214,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd088abdf1c13ebbf83ee7f08df8c01f",
		  
		  "name": "Chris",
		  "createdDate": "2018-11-29 01:04:13",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 869,
		  "totalCountries": 12,
		  "totalStates": 53,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 1567,
		  "schedulePercent": 0.63384,
		  "totalGuests": 427,
		  "guestPercent": 0.705576,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd19f0569a317fe737c96f14282a4ed6",
		  
		  "name": "Vinnie",
		  "createdDate": "2021-08-11 22:37:51",
		  "totalOrganizations": 55,
		  "totalTours": 26,
		  "totalDays": 1373,
		  "totalCountries": 33,
		  "totalStates": 79,
		  "totalEvents": 374,
		  "eventPercent": 0.951609,
		  "totalScheduleItems": 6879,
		  "schedulePercent": 0.985267,
		  "totalGuests": 3760,
		  "guestPercent": 0.991614,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd1a1a819bc423313c7192cfe4024c3d",
		  
		  "name": "Diego",
		  "createdDate": "2019-09-26 22:11:48",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 605,
		  "totalCountries": 24,
		  "totalStates": 61,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 1932,
		  "schedulePercent": 0.700249,
		  "totalGuests": 594,
		  "guestPercent": 0.756346,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd1abb325094bc7ae5c778864c6cacc0",
		  
		  "name": "Garrett",
		  "createdDate": "2022-04-15 18:37:10",
		  "totalOrganizations": 16,
		  "totalTours": 16,
		  "totalDays": 1944,
		  "totalCountries": 11,
		  "totalStates": 56,
		  "totalEvents": 306,
		  "eventPercent": 0.916251,
		  "totalScheduleItems": 3823,
		  "schedulePercent": 0.904012,
		  "totalGuests": 1187,
		  "guestPercent": 0.874773,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd1f9b36a712ca499f56d64d058ebf4d",
		  
		  "name": "Lauren",
		  "createdDate": "2025-06-14 10:35:32",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 44,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 116,
		  "schedulePercent": 0.108228,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd2fa1a71e1bcc02d732265b530539b9",
		  
		  "name": "CECE",
		  "createdDate": "2025-05-15 19:09:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 145,
		  "totalCountries": 18,
		  "totalStates": 31,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 167,
		  "schedulePercent": 0.138939,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd38f9b5f4e037f7a95713e2ef0df7cb",
		  
		  "name": "Lauren",
		  "createdDate": "2021-03-30 11:42:06",
		  "totalOrganizations": 22,
		  "totalTours": 80,
		  "totalDays": 578,
		  "totalCountries": 27,
		  "totalStates": 59,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 2421,
		  "schedulePercent": 0.777539,
		  "totalGuests": 448,
		  "guestPercent": 0.711922,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Bramall Lane",
		  "mostGuestCity": "Sheffield",
		  "mostGuestAmount": 137,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd54d0311ac76dbafe08d9c2df46594c",
		  
		  "name": "Brandon",
		  "createdDate": "2022-06-03 15:53:37",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 180,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 942,
		  "schedulePercent": 0.473028,
		  "totalGuests": 500,
		  "guestPercent": 0.730734,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd595891a9f26ca0782b179f1fdf784c",
		  
		  "name": "Angela ",
		  "createdDate": "2023-09-13 00:49:43",
		  "totalOrganizations": 5,
		  "totalTours": 18,
		  "totalDays": 511,
		  "totalCountries": 14,
		  "totalStates": 47,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1253,
		  "schedulePercent": 0.561197,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Paradiso",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd5bb8f511e6d75dc2d69ef0ca63b1cf",
		  
		  "name": "Peter",
		  "createdDate": "2023-12-06 09:56:14",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd5d0ba700e74767adb2e458a3a36c6d",
		  
		  "name": "Will",
		  "createdDate": "2025-04-10 16:57:22",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 29,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 200,
		  "schedulePercent": 0.161038,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Paradise Rock Club",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd643b0d337f090f7df20cd357d2f7f5",
		  
		  "name": "Carolyn",
		  "createdDate": "2023-03-27 16:49:10",
		  "totalOrganizations": 20,
		  "totalTours": 15,
		  "totalDays": 3280,
		  "totalCountries": 47,
		  "totalStates": 129,
		  "totalEvents": 573,
		  "eventPercent": 0.986174,
		  "totalScheduleItems": 5882,
		  "schedulePercent": 0.974161,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "la citadelle",
		  "mostGuestCity": "Marseille",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd6d9199db355d579d13a9dc109636c6",
		  
		  "name": "Zack ",
		  "createdDate": "2022-09-15 22:02:54",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 342,
		  "totalCountries": 10,
		  "totalStates": 8,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 531,
		  "schedulePercent": 0.327176,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd6daf00473379125324e5afcea6b024",
		  
		  "name": "Abdella",
		  "createdDate": "2014-03-09 01:45:25",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 157,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1244,
		  "schedulePercent": 0.559044,
		  "totalGuests": 408,
		  "guestPercent": 0.69685,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre de la croisette",
		  "mostGuestCity": "Cannes",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd7065fdc3b0a345e7bb8e72500061f0",
		  
		  "name": "Dave",
		  "createdDate": "2015-11-27 20:17:43",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 286,
		  "totalCountries": 33,
		  "totalStates": 59,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 2153,
		  "schedulePercent": 0.74048,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd75b90ae1c512b708551e4658693429",
		  
		  "name": "Josh",
		  "createdDate": "2023-11-14 17:21:09",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 326,
		  "totalCountries": 6,
		  "totalStates": 22,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1000,
		  "schedulePercent": 0.490141,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Heaton Park",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd7bf267da5a0af59afeef829c595383",
		  
		  "name": "Taste The floor S.L",
		  "createdDate": "2022-03-27 17:51:35",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 34,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 181,
		  "schedulePercent": 0.147212,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd8632e972a3df1b679f5f40d0b86301",
		  
		  "name": "Peter",
		  "createdDate": "2012-01-19 08:37:43",
		  "totalOrganizations": 36,
		  "totalTours": 4,
		  "totalDays": 822,
		  "totalCountries": 28,
		  "totalStates": 46,
		  "totalEvents": 243,
		  "eventPercent": 0.864347,
		  "totalScheduleItems": 6138,
		  "schedulePercent": 0.977675,
		  "totalGuests": 82,
		  "guestPercent": 0.499207,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Old Park Farm",
		  "mostGuestCity": "",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd87405a128f8529d5881bb150c344f9",
		  
		  "name": "Jeff",
		  "createdDate": "2025-05-28 19:41:33",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 296,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 582,
		  "schedulePercent": 0.344515,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Goldfield Trading Post Roseville",
		  "mostGuestCity": "Roseville",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd8c320a42637ae5aef3e303ad9d1389",
		  
		  "name": "Ryle",
		  "createdDate": "2025-08-04 22:42:13",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 107,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 518,
		  "schedulePercent": 0.320603,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Cain's Ballroom",
		  "mostGuestCity": "Tulsa",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd90d534e2a4f0db55c66e40d41dcb51",
		  
		  "name": "Kelley",
		  "createdDate": "2024-01-29 15:57:14",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 180,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 430,
		  "schedulePercent": 0.281958,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-11-05 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd9129113cb031e12ced456c28522046",
		  
		  "name": "Evelina",
		  "createdDate": "2022-12-06 08:01:45",
		  "totalOrganizations": 36,
		  "totalTours": 15,
		  "totalDays": 873,
		  "totalCountries": 23,
		  "totalStates": 54,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 3853,
		  "schedulePercent": 0.905598,
		  "totalGuests": 386,
		  "guestPercent": 0.688463,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Banan-Kompaniet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cd9b57875ecc1c2b09e5fb1a165bcbab",
		  
		  "name": "Cristofer",
		  "createdDate": "2024-03-20 15:13:58",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 272,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2129,
		  "schedulePercent": 0.736514,
		  "totalGuests": 254,
		  "guestPercent": 0.627153,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cda01452fbd687f4d11a821e3b48220d",
		  
		  "name": "Jon",
		  "createdDate": "2011-07-15 01:05:59",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 288,
		  "totalCountries": 4,
		  "totalStates": 62,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1559,
		  "schedulePercent": 0.63248,
		  "totalGuests": 1229,
		  "guestPercent": 0.87874,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cda312a91b6764a1f20dbc617d70b3a8",
		  
		  "name": "Takahiko",
		  "createdDate": "2023-03-16 00:53:13",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 148,
		  "totalCountries": 24,
		  "totalStates": 26,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1025,
		  "schedulePercent": 0.497733,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cda3bf3dacaa411e6a42f168b98769f0",
		  
		  "name": "John",
		  "createdDate": "2023-06-19 16:33:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 99,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 794,
		  "schedulePercent": 0.420331,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cda8487ed76a4cdd1ac6d1aad2400859",
		  
		  "name": "Alice",
		  "createdDate": "2022-09-19 22:04:34",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 564,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1618,
		  "schedulePercent": 0.643586,
		  "totalGuests": 185,
		  "guestPercent": 0.583069,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Les Nuits de FourviÃ¨re",
		  "mostGuestCity": "Lyon",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdad7e6902617f329fca1f49fd3d81a7",
		  
		  "name": "Jacob",
		  "createdDate": "2014-12-04 03:44:57",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 153,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1158,
		  "schedulePercent": 0.536718,
		  "totalGuests": 174,
		  "guestPercent": 0.576156,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Parker Playhouse",
		  "mostGuestCity": "Fort Lauderdale",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdb297c1d1c30de244c4c440595ac626",
		  
		  "name": "Johanna",
		  "createdDate": "2025-02-28 21:21:20",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 57,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 202,
		  "schedulePercent": 0.162058,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdbec7a2c27029a20c7c7b18cf061f7f",
		  
		  "name": "TIFFANY",
		  "createdDate": "2020-01-22 22:09:22",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 392,
		  "totalCountries": 19,
		  "totalStates": 49,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 945,
		  "schedulePercent": 0.473821,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-08-10 00:00:00",
		  "mostGuestName": "CC TEATRO LEGUIA",
		  "mostGuestCity": "LIMA",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdcb1639486372316d388418a82cc8c3",
		  
		  "name": "Tony",
		  "createdDate": "2016-06-28 21:56:19",
		  "totalOrganizations": 8,
		  "totalTours": 21,
		  "totalDays": 566,
		  "totalCountries": 17,
		  "totalStates": 54,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2527,
		  "schedulePercent": 0.789325,
		  "totalGuests": 1114,
		  "guestPercent": 0.866387,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdd6e1b2095155bdb2a475c777d97808",
		  
		  "name": "Danesh",
		  "createdDate": "2019-11-16 21:06:55",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 128,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 387,
		  "schedulePercent": 0.262579,
		  "totalGuests": 150,
		  "guestPercent": 0.55859,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "The King Of Clubs",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdd790db53cc28e5b7da5c0eb8e49369",
		  
		  "name": "Glenn",
		  "createdDate": "2019-04-07 00:21:56",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 296,
		  "totalCountries": 6,
		  "totalStates": 12,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 83,
		  "schedulePercent": 0.0847688,
		  "totalGuests": 302,
		  "guestPercent": 0.650839,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdeb86a5babf8becf906f24f964a8e02",
		  
		  "name": "Johanna",
		  "createdDate": "2019-03-21 15:06:01",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 348,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 3,
		  "eventPercent": 0.0250453,
		  "totalScheduleItems": 271,
		  "schedulePercent": 0.200023,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdefeb302387f6e9b04e77138b807543",
		  
		  "name": "Ernie",
		  "createdDate": "2022-08-15 01:14:51",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 73,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 240,
		  "schedulePercent": 0.184497,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdf118ada970da92232171200dc38218",
		  
		  "name": "Nick",
		  "createdDate": "2012-02-21 17:38:38",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 860,
		  "totalCountries": 8,
		  "totalStates": 49,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 3906,
		  "schedulePercent": 0.908885,
		  "totalGuests": 4000,
		  "guestPercent": 0.993087,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cdf2fab66939094bfbd46df9f4957b79",
		  
		  "name": "Pain",
		  "createdDate": "2021-10-05 01:47:29",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 211,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 56,
		  "schedulePercent": 0.0648232,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce01890c3c7b9bd423e2e5fa17b399d4",
		  
		  "name": "Jimmy",
		  "createdDate": "2022-06-29 23:11:32",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 264,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1217,
		  "schedulePercent": 0.550997,
		  "totalGuests": 349,
		  "guestPercent": 0.674637,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce03799d1be9cc8fe5713062e3c22468",
		  
		  "name": "Nathan",
		  "createdDate": "2024-01-08 21:33:11",
		  "totalOrganizations": 9,
		  "totalTours": 20,
		  "totalDays": 1100,
		  "totalCountries": 3,
		  "totalStates": 49,
		  "totalEvents": 587,
		  "eventPercent": 0.986854,
		  "totalScheduleItems": 6357,
		  "schedulePercent": 0.980054,
		  "totalGuests": 3807,
		  "guestPercent": 0.992067,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce05b330365682b716c2370cff60223a",
		  
		  "name": "Emilienne",
		  "createdDate": "2025-10-10 15:43:13",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 22,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 135,
		  "schedulePercent": 0.121827,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-11-14 00:00:00",
		  "mostGuestName": "OpÃ©ra de Rouen Normandie",
		  "mostGuestCity": "Rouen",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce0bb2924c54a532d9400709e3730b5c",
		  
		  "name": "Luke",
		  "createdDate": "2023-01-19 00:19:49",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 341,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 108,
		  "schedulePercent": 0.103921,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce305c13b3a40d153caab027e389967e",
		  
		  "name": "Seb",
		  "createdDate": "2020-01-30 21:52:54",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 368,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 646,
		  "schedulePercent": 0.36582,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Centre de CongrÃ¨s Les Atlantes",
		  "mostGuestCity": "Les Sables-d'Olonne",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce31dd9efaa14d3c261649df0b0fdae6",
		  
		  "name": "Jesse",
		  "createdDate": "2013-03-15 18:50:21",
		  "totalOrganizations": 22,
		  "totalTours": 21,
		  "totalDays": 1351,
		  "totalCountries": 18,
		  "totalStates": 72,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 4269,
		  "schedulePercent": 0.92985,
		  "totalGuests": 1457,
		  "guestPercent": 0.906278,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "The Great Saltair",
		  "mostGuestCity": "Magna",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce468743cd2cfb26ba8d3a7f8f9c027d",
		  
		  "name": "Jack",
		  "createdDate": "2022-02-27 01:23:34",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 731,
		  "totalCountries": 12,
		  "totalStates": 49,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 2914,
		  "schedulePercent": 0.832729,
		  "totalGuests": 2046,
		  "guestPercent": 0.950249,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Akins Ford Arena",
		  "mostGuestCity": "Athens",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce49600181e6e0e6ce4c649dad782154",
		  
		  "name": "CHAD",
		  "createdDate": "2013-04-26 23:51:34",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 474,
		  "totalCountries": 5,
		  "totalStates": 46,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 2130,
		  "schedulePercent": 0.736741,
		  "totalGuests": 341,
		  "guestPercent": 0.671238,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "State Farm Arena",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce509a1eac72eeca927b7a7f8a92258e",
		  
		  "name": "Robbie",
		  "createdDate": "2018-01-15 16:49:04",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 751,
		  "totalCountries": 6,
		  "totalStates": 51,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2844,
		  "schedulePercent": 0.827289,
		  "totalGuests": 1418,
		  "guestPercent": 0.902085,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The BayCare Sound",
		  "mostGuestCity": "Clearwater",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce56dd89ab050bb3621e8f2dd17de604",
		  
		  "name": "THE WLDLFE",
		  "createdDate": "2020-01-08 00:25:17",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 61,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 539,
		  "schedulePercent": 0.330009,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce5a58989516b260260f231bd7bb84ec",
		  
		  "name": "Stephen",
		  "createdDate": "2019-05-28 14:40:54",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 74,
		  "totalCountries": 4,
		  "totalStates": 37,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 386,
		  "schedulePercent": 0.261673,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Motorco Music Hall",
		  "mostGuestCity": "Durham",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce791a502cf53186259040aeb4c1f76c",
		  
		  "name": "Louise",
		  "createdDate": "2024-11-29 14:18:59",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 110,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 39,
		  "schedulePercent": 0.0497507,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce7b62935c97a7fadec4e882d289de31",
		  
		  "name": "Derek",
		  "createdDate": "2019-05-31 17:21:04",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 630,
		  "totalCountries": 18,
		  "totalStates": 45,
		  "totalEvents": 202,
		  "eventPercent": 0.804397,
		  "totalScheduleItems": 2748,
		  "schedulePercent": 0.816183,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "M&S Bank Arena",
		  "mostGuestCity": "Liverpool",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce7e0dd423179573a85042284e45036f",
		  
		  "name": "John",
		  "createdDate": "2025-09-15 16:13:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 43,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 200,
		  "schedulePercent": 0.161038,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce7e7660877daa9cf104484ffc70cba7",
		  
		  "name": "Ludovic",
		  "createdDate": "2018-10-05 16:52:32",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 664,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 654,
		  "schedulePercent": 0.368994,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-07-08 00:00:00",
		  "mostGuestName": "Fourviere Nights",
		  "mostGuestCity": "Lyon",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce8db585ebcce0a9e0ddcd1dae27418b",
		  
		  "name": "Darren",
		  "createdDate": "2013-06-05 10:47:33",
		  "totalOrganizations": 6,
		  "totalTours": 17,
		  "totalDays": 530,
		  "totalCountries": 14,
		  "totalStates": 37,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 2929,
		  "schedulePercent": 0.834202,
		  "totalGuests": 883,
		  "guestPercent": 0.826269,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ce97dcf2e705e4b6cbc171ec869052b5",
		  
		  "name": "Jonny",
		  "createdDate": "2024-10-26 17:59:00",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 37,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 214,
		  "schedulePercent": 0.168631,
		  "totalGuests": 134,
		  "guestPercent": 0.548164,
		  "mostGuestDate": "2025-05-10 00:00:00",
		  "mostGuestName": "Electric Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cea077c8ec076b9441fb79de84029a94",
		  
		  "name": "Drew",
		  "createdDate": "2011-03-22 18:52:40",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 1367,
		  "totalCountries": 20,
		  "totalStates": 58,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2882,
		  "schedulePercent": 0.830462,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cea3b05553e17d3331e4ac023a088a3c",
		  
		  "name": "Rod",
		  "createdDate": "2022-06-12 15:20:06",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 206,
		  "totalCountries": 5,
		  "totalStates": 21,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 798,
		  "schedulePercent": 0.421804,
		  "totalGuests": 1185,
		  "guestPercent": 0.874433,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Kaseya Arena",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cea63e7ec6b423ee83aacdcd578f9f38",
		  
		  "name": "George",
		  "createdDate": "2014-10-15 07:33:39",
		  "totalOrganizations": 16,
		  "totalTours": 14,
		  "totalDays": 1304,
		  "totalCountries": 37,
		  "totalStates": 64,
		  "totalEvents": 327,
		  "eventPercent": 0.931324,
		  "totalScheduleItems": 5242,
		  "schedulePercent": 0.960562,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cea675806eec9232a23ee4f1ce0e0bd5",
		  
		  "name": "McCrae",
		  "createdDate": "2025-01-23 18:40:53",
		  "totalOrganizations": 18,
		  "totalTours": 11,
		  "totalDays": 2129,
		  "totalCountries": 39,
		  "totalStates": 106,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 4113,
		  "schedulePercent": 0.919764,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Madame Louâ€™s",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cea74bf1d8ef5c92efcb82bf14aedf3a",
		  
		  "name": "Jon",
		  "createdDate": "2019-10-01 14:04:59",
		  "totalOrganizations": 11,
		  "totalTours": 27,
		  "totalDays": 1597,
		  "totalCountries": 21,
		  "totalStates": 64,
		  "totalEvents": 581,
		  "eventPercent": 0.986514,
		  "totalScheduleItems": 6065,
		  "schedulePercent": 0.976655,
		  "totalGuests": 1279,
		  "guestPercent": 0.88316,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cea7e77f02ab0bc3222ffb56da74e010",
		  
		  "name": "Rylan",
		  "createdDate": "2018-10-14 23:48:23",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 908,
		  "totalCountries": 13,
		  "totalStates": 59,
		  "totalEvents": 183,
		  "eventPercent": 0.769946,
		  "totalScheduleItems": 3222,
		  "schedulePercent": 0.861627,
		  "totalGuests": 113,
		  "guestPercent": 0.530598,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cea965a8b7553ff2a73ba2b1f0927cd0",
		  
		  "name": "Lisandra ",
		  "createdDate": "2025-08-03 00:14:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 9,
		  "totalStates": 19,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 254,
		  "schedulePercent": 0.192883,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Hard Rock Cafe",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cea9ad041b0a8e84c21e21e3447031dc",
		  
		  "name": "Miriam",
		  "createdDate": "2023-06-28 23:01:39",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 71,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 245,
		  "schedulePercent": 0.186877,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cead929ee99e6ee0d04055ee7fdbc724",
		  
		  "name": "Miles",
		  "createdDate": "2025-10-26 21:35:15",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 119,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 110,
		  "schedulePercent": 0.105734,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cec8fce86424ba06ace0481a8b9d07b8",
		  
		  "name": "Andrea",
		  "createdDate": "2022-03-06 18:07:33",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 170,
		  "totalCountries": 23,
		  "totalStates": 56,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 868,
		  "schedulePercent": 0.448096,
		  "totalGuests": 930,
		  "guestPercent": 0.835675,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ced8a300a866e84a3196d43ca61797ec",
		  
		  "name": "Sadie",
		  "createdDate": "2024-01-09 20:22:43",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 527,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 746,
		  "schedulePercent": 0.403672,
		  "totalGuests": 482,
		  "guestPercent": 0.725181,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ced9a945f9106bd9f9353aa74b1a7584",
		  
		  "name": "Aaron",
		  "createdDate": "2017-08-09 21:44:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1423,
		  "schedulePercent": 0.602788,
		  "totalGuests": 1325,
		  "guestPercent": 0.890979,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Akins Ford Arena",
		  "mostGuestCity": "Athens",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cee25e46053ebd45ee8008d064358fbf",
		  
		  "name": "Kirk",
		  "createdDate": "2011-11-22 14:28:29",
		  "totalOrganizations": 10,
		  "totalTours": 24,
		  "totalDays": 557,
		  "totalCountries": 17,
		  "totalStates": 68,
		  "totalEvents": 259,
		  "eventPercent": 0.881006,
		  "totalScheduleItems": 3457,
		  "schedulePercent": 0.87976,
		  "totalGuests": 1519,
		  "guestPercent": 0.911831,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cef21e89064c6b7941e6fd5e4569a1ff",
		  
		  "name": "Gheneva-Mae",
		  "createdDate": "2020-03-11 16:01:31",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 325,
		  "totalCountries": 10,
		  "totalStates": 13,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 1089,
		  "schedulePercent": 0.517566,
		  "totalGuests": 670,
		  "guestPercent": 0.777879,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cef806ef54aa08e25f59a2e9654ee934",
		  
		  "name": "Simon",
		  "createdDate": "2018-08-01 06:44:45",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 371,
		  "totalCountries": 18,
		  "totalStates": 51,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1330,
		  "schedulePercent": 0.579896,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "O2 Apollo Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf0af49a63442bd005a59cbd3cae3320",
		  
		  "name": "Michael ",
		  "createdDate": "2023-09-13 13:19:53",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 348,
		  "totalCountries": 19,
		  "totalStates": 57,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2184,
		  "schedulePercent": 0.745467,
		  "totalGuests": 129,
		  "guestPercent": 0.543518,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "Park City Live",
		  "mostGuestCity": "Park City",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf100c91f2fb32aed96e74f06dd39d3a",
		  
		  "name": "Casper",
		  "createdDate": "2021-05-19 01:39:08",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 81,
		  "totalCountries": 1,
		  "totalStates": 21,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 650,
		  "schedulePercent": 0.36752,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf243776cbf35be1e37d820d5db7bc15",
		  
		  "name": "Dan",
		  "createdDate": "2023-05-17 12:54:31",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 437,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1442,
		  "schedulePercent": 0.606188,
		  "totalGuests": 355,
		  "guestPercent": 0.676564,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Commodore Ballroom",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf360fe54b8eaeb61ae38c66716c31cf",
		  
		  "name": "Caroline",
		  "createdDate": "2025-02-10 14:28:08",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 248,
		  "totalCountries": 7,
		  "totalStates": 32,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1144,
		  "schedulePercent": 0.532638,
		  "totalGuests": 898,
		  "guestPercent": 0.829556,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf4070d92966c1cdd6c2ae6302f7ebe6",
		  
		  "name": "Chris",
		  "createdDate": "2019-02-13 05:07:45",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 1106,
		  "totalCountries": 29,
		  "totalStates": 55,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 6924,
		  "schedulePercent": 0.985947,
		  "totalGuests": 466,
		  "guestPercent": 0.718948,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf4890220813b1f7696a173eebc197fc",
		  
		  "name": "Phil",
		  "createdDate": "2017-11-12 17:44:26",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 344,
		  "totalCountries": 24,
		  "totalStates": 15,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 365,
		  "schedulePercent": 0.250907,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf4a41a0d0cb3c338a93689a898eda17",
		  
		  "name": "Chris",
		  "createdDate": "2022-08-27 03:50:19",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 503,
		  "totalCountries": 18,
		  "totalStates": 51,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 1330,
		  "schedulePercent": 0.579896,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The Axis Club Theatre",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf4ac04fcef7f2a62e2b73e302babd93",
		  
		  "name": "Paulo",
		  "createdDate": "2023-04-10 10:34:40",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 818,
		  "totalCountries": 14,
		  "totalStates": 10,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 771,
		  "schedulePercent": 0.412625,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf54f0f05c6871c465faa77238ee02ae",
		  
		  "name": "Chris",
		  "createdDate": "2019-06-19 22:30:40",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 358,
		  "totalCountries": 22,
		  "totalStates": 51,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2165,
		  "schedulePercent": 0.74184,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Prudential Center",
		  "mostGuestCity": "Newark",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf6813cde34554b194bd21a82403f4f4",
		  
		  "name": "Sandra ",
		  "createdDate": "2025-02-15 22:04:16",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 134,
		  "totalCountries": 14,
		  "totalStates": 14,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 360,
		  "schedulePercent": 0.248187,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Headcrash",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf6bf2a4b4a414fff03bdd7ed9f2e2df",
		  
		  "name": "Dwight",
		  "createdDate": "2019-07-12 03:07:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 165,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 512,
		  "schedulePercent": 0.316636,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Steven Tanger Center for the Performing Arts",
		  "mostGuestCity": "Greensboro",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf6ee3431166e2704be07b922a5e2e42",
		  
		  "name": "Lion",
		  "createdDate": "2025-08-26 14:52:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 83,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 457,
		  "schedulePercent": 0.293404,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf702df0f628dfd623ab9e6bc6cce10f",
		  
		  "name": "O&#39;Necean",
		  "createdDate": "2018-09-17 22:02:32",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 174,
		  "totalCountries": 8,
		  "totalStates": 28,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 929,
		  "schedulePercent": 0.468495,
		  "totalGuests": 95,
		  "guestPercent": 0.513826,
		  "mostGuestDate": "2025-04-08 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf74092853de0da0628742e1efde12dd",
		  
		  "name": "Thomas",
		  "createdDate": "2016-05-20 20:58:02",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 21,
		  "totalStates": 37,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 1245,
		  "schedulePercent": 0.55927,
		  "totalGuests": 291,
		  "guestPercent": 0.644719,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "douglass park",
		  "mostGuestCity": "",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf784b1803b1756651cabfd907e7a24d",
		  
		  "name": "Savitri",
		  "createdDate": "2025-07-03 18:51:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 43,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 32,
		  "schedulePercent": 0.042951,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf7a7cf15fe4b39f6d860e978e14af58",
		  
		  "name": "Brooke",
		  "createdDate": "2023-07-27 14:47:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 159,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf82bd17eb86b5030fcae3f730f7ddc1",
		  
		  "name": "Geneva",
		  "createdDate": "2022-03-09 23:41:47",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 29,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf84ac4999f4f5ad48da0a4de97431e5",
		  
		  "name": "Stefan Moritz",
		  "createdDate": "2024-12-09 09:24:56",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 131,
		  "totalCountries": 25,
		  "totalStates": 35,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 959,
		  "schedulePercent": 0.478921,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Warfield",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf8b1bf00e10debe9e1834e256d564f4",
		  
		  "name": "Juan",
		  "createdDate": "2009-12-03 16:56:32",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 268,
		  "totalCountries": 11,
		  "totalStates": 60,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1618,
		  "schedulePercent": 0.643586,
		  "totalGuests": 1047,
		  "guestPercent": 0.853581,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf913789c8dae128a497f037b39cb7ee",
		  
		  "name": "Vic",
		  "createdDate": "2025-02-27 07:13:07",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 2435,
		  "totalCountries": 20,
		  "totalStates": 41,
		  "totalEvents": 297,
		  "eventPercent": 0.910811,
		  "totalScheduleItems": 1697,
		  "schedulePercent": 0.658092,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Unit 13",
		  "mostGuestCity": "Nottingham",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf96b64a858fe31924cb0e7d4d931000",
		  
		  "name": "MTC Education & Families",
		  "createdDate": "2024-05-30 05:08:05",
		  "totalOrganizations": 1,
		  "totalTours": 21,
		  "totalDays": 610,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 291,
		  "eventPercent": 0.906618,
		  "totalScheduleItems": 1867,
		  "schedulePercent": 0.688577,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Dunstan Playhouse",
		  "mostGuestCity": "Adelaide",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cf9efb5932f993a92cbfcc670f933c35",
		  
		  "name": "Lisa",
		  "createdDate": "2018-03-28 13:22:13",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 134,
		  "totalCountries": 8,
		  "totalStates": 22,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 1131,
		  "schedulePercent": 0.528672,
		  "totalGuests": 400,
		  "guestPercent": 0.694583,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Skydeck on Broadway",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cfae259195fe3b75145b6398d0cd4c82",
		  
		  "name": "Callum",
		  "createdDate": "2019-10-16 15:18:48",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 185,
		  "totalCountries": 16,
		  "totalStates": 31,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 813,
		  "schedulePercent": 0.428151,
		  "totalGuests": 247,
		  "guestPercent": 0.623753,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cfba8cc59014461e5bc8e68c204db605",
		  
		  "name": "Roland",
		  "createdDate": "2017-10-14 18:42:19",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 236,
		  "totalCountries": 16,
		  "totalStates": 33,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 1209,
		  "schedulePercent": 0.549184,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cfc2904f8ea18e97fc8b36d5f94d9232",
		  
		  "name": "Sean",
		  "createdDate": "2023-05-30 13:57:04",
		  "totalOrganizations": 10,
		  "totalTours": 17,
		  "totalDays": 287,
		  "totalCountries": 21,
		  "totalStates": 56,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 1519,
		  "schedulePercent": 0.6216,
		  "totalGuests": 402,
		  "guestPercent": 0.695376,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cfc470121f5828a80e5eb033c6fbc105",
		  
		  "name": "Tour",
		  "createdDate": "2025-01-15 20:17:01",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 65,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 152,
		  "schedulePercent": 0.131006,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cfc579cbb8c8ce4e750bebc3b6226114",
		  
		  "name": "Cornelius ",
		  "createdDate": "2014-02-18 09:42:47",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 763,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1316,
		  "schedulePercent": 0.575249,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-08-26 00:00:00",
		  "mostGuestName": "Ludlow Garage",
		  "mostGuestCity": "Cincinnati",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cfc65dcd9c353ee69c59bc3b60e24dc4",
		  
		  "name": "Christian",
		  "createdDate": "2022-01-16 18:11:24",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 1345,
		  "totalCountries": 8,
		  "totalStates": 57,
		  "totalEvents": 536,
		  "eventPercent": 0.982434,
		  "totalScheduleItems": 7560,
		  "schedulePercent": 0.989007,
		  "totalGuests": 779,
		  "guestPercent": 0.802244,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Cynthia Woods Mitchell Pavilion",
		  "mostGuestCity": "The Woodlands",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cfd2f7515467ea65288bb5f544bf4775",
		  
		  "name": "Shane",
		  "createdDate": "2017-02-09 17:38:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "cff5e986516ca284fec7ac3743dfce5e",
		  
		  "name": "Josh",
		  "createdDate": "2023-12-15 17:46:59",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 469,
		  "totalCountries": 24,
		  "totalStates": 98,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 2741,
		  "schedulePercent": 0.81505,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Desert Diamond Arena",
		  "mostGuestCity": "Glendale",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0001d6aaa0b45ad5876ef85a7ff0d85",
		  
		  "name": "Ashley",
		  "createdDate": "2018-11-21 18:11:04",
		  "totalOrganizations": 14,
		  "totalTours": 20,
		  "totalDays": 2549,
		  "totalCountries": 28,
		  "totalStates": 61,
		  "totalEvents": 545,
		  "eventPercent": 0.983908,
		  "totalScheduleItems": 8771,
		  "schedulePercent": 0.99286,
		  "totalGuests": 1355,
		  "guestPercent": 0.893812,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d000c493e65c68a0192f702fb2e8c102",
		  
		  "name": "Fanny ",
		  "createdDate": "2024-02-20 02:13:19",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 636,
		  "totalCountries": 7,
		  "totalStates": 18,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-11-05 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d000fda08d0afa70486eac06781de87d",
		  
		  "name": "Adam",
		  "createdDate": "2022-10-10 08:56:00",
		  "totalOrganizations": 19,
		  "totalTours": 15,
		  "totalDays": 562,
		  "totalCountries": 20,
		  "totalStates": 50,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 2230,
		  "schedulePercent": 0.75272,
		  "totalGuests": 749,
		  "guestPercent": 0.796011,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d00250391a161d82d657fd528d2ba5b2",
		  
		  "name": "Emily",
		  "createdDate": "2025-02-27 00:48:33",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 537,
		  "totalCountries": 23,
		  "totalStates": 56,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 2782,
		  "schedulePercent": 0.819696,
		  "totalGuests": 1502,
		  "guestPercent": 0.908885,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d007bb73992d56bf93e335857686ad62",
		  
		  "name": "Kelsey ",
		  "createdDate": "2016-06-30 16:16:24",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 776,
		  "totalCountries": 12,
		  "totalStates": 58,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 1516,
		  "schedulePercent": 0.620807,
		  "totalGuests": 795,
		  "guestPercent": 0.80689,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d00c7848bf6f4f755d45766cb8ca1cbf",
		  
		  "name": "Brian",
		  "createdDate": "2012-11-01 01:19:17",
		  "totalOrganizations": 15,
		  "totalTours": 28,
		  "totalDays": 841,
		  "totalCountries": 13,
		  "totalStates": 67,
		  "totalEvents": 319,
		  "eventPercent": 0.925204,
		  "totalScheduleItems": 4249,
		  "schedulePercent": 0.92917,
		  "totalGuests": 1973,
		  "guestPercent": 0.94549,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0107871c9bf23257435b0a4fd6f820f",
		  
		  "name": "Jakob",
		  "createdDate": "2025-04-08 13:47:06",
		  "totalOrganizations": 75,
		  "totalTours": 39,
		  "totalDays": 362,
		  "totalCountries": 14,
		  "totalStates": 33,
		  "totalEvents": 256,
		  "eventPercent": 0.876927,
		  "totalScheduleItems": 2044,
		  "schedulePercent": 0.722235,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Estrad",
		  "mostGuestCity": "SÃ¶dertÃ¤lje",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d013f72fb876de991e9703d05c8c7579",
		  
		  "name": "Izabella",
		  "createdDate": "2025-03-03 10:06:23",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 58,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 225,
		  "schedulePercent": 0.174524,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d01703b247c2beb8aa518a2be739c381",
		  
		  "name": "Damien",
		  "createdDate": "2019-05-02 17:11:12",
		  "totalOrganizations": 6,
		  "totalTours": 15,
		  "totalDays": 281,
		  "totalCountries": 21,
		  "totalStates": 50,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 1103,
		  "schedulePercent": 0.519719,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d01f8bd67edf9f0d0edb4158deada8e1",
		  
		  "name": "Dog",
		  "createdDate": "2022-01-02 06:46:27",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 399,
		  "totalCountries": 5,
		  "totalStates": 29,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 298,
		  "schedulePercent": 0.216795,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d025b11df73ed245bd70918f8ff5722a",
		  
		  "name": "Ami",
		  "createdDate": "2024-08-07 09:08:17",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 59,
		  "totalCountries": 10,
		  "totalStates": 22,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 652,
		  "schedulePercent": 0.3682,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "SÃ¶dra Teatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d03048d87ac1c93f60d59ee795db4cf1",
		  
		  "name": "Emilio",
		  "createdDate": "2015-06-11 18:49:26",
		  "totalOrganizations": 12,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "River Cree Casino & Resort",
		  "mostGuestCity": "ENOCH",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d030e359e12136fb796568c5c9167739",
		  
		  "name": "Ann",
		  "createdDate": "2024-06-28 15:24:42",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 270,
		  "totalCountries": 11,
		  "totalStates": 16,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d037ea989e35f756adfa472d593e5618",
		  
		  "name": "Pam",
		  "createdDate": "2016-02-13 15:38:06",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 345,
		  "totalCountries": 5,
		  "totalStates": 52,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 3322,
		  "schedulePercent": 0.86888,
		  "totalGuests": 2420,
		  "guestPercent": 0.965775,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Analog at Hutton Hotel",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 191,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d038df0aac9a23ad2f80d690bb25a729",
		  
		  "name": "Elisa",
		  "createdDate": "2023-04-20 15:59:15",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 307,
		  "totalCountries": 28,
		  "totalStates": 56,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 2464,
		  "schedulePercent": 0.782865,
		  "totalGuests": 457,
		  "guestPercent": 0.714982,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Estadi de Son Moix",
		  "mostGuestCity": "Palma",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d03a56494f39a952670186081c818c7d",
		  
		  "name": "Jess",
		  "createdDate": "2024-08-18 07:03:52",
		  "totalOrganizations": 10,
		  "totalTours": 23,
		  "totalDays": 400,
		  "totalCountries": 19,
		  "totalStates": 58,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2495,
		  "schedulePercent": 0.786378,
		  "totalGuests": 1683,
		  "guestPercent": 0.927244,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d047ea1de44b9703785edf091cb461a6",
		  
		  "name": "Sandra",
		  "createdDate": "2023-06-10 06:22:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 40,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 166,
		  "schedulePercent": 0.138599,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d049a41154dd6161f6bd385b7d26ab2c",
		  
		  "name": "Elyse ",
		  "createdDate": "2024-05-28 15:27:30",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 1974,
		  "totalCountries": 20,
		  "totalStates": 63,
		  "totalEvents": 302,
		  "eventPercent": 0.914211,
		  "totalScheduleItems": 4796,
		  "schedulePercent": 0.947529,
		  "totalGuests": 1369,
		  "guestPercent": 0.896306,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Champion Forest Baptist Church - Champions Campus",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d04a8144b1613f9ce836bdd82a99f00a",
		  
		  "name": "Bas ",
		  "createdDate": "2017-11-07 15:32:59",
		  "totalOrganizations": 18,
		  "totalTours": 17,
		  "totalDays": 254,
		  "totalCountries": 19,
		  "totalStates": 50,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 1215,
		  "schedulePercent": 0.550544,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Black Lodge",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d04eff7d82f4ae103db4fe03d6d7f508",
		  
		  "name": "Robby",
		  "createdDate": "2012-03-27 16:49:00",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 552,
		  "totalCountries": 15,
		  "totalStates": 58,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2397,
		  "schedulePercent": 0.774819,
		  "totalGuests": 1652,
		  "guestPercent": 0.924297,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d058ea0ed83743dfa127d58e9fb36010",
		  
		  "name": "Daniel",
		  "createdDate": "2017-04-24 18:07:23",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 736,
		  "totalCountries": 6,
		  "totalStates": 49,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 4220,
		  "schedulePercent": 0.927471,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0627065dea12b5d555a4d68beb4ea7d",
		  
		  "name": "Mario",
		  "createdDate": "2018-08-10 06:28:16",
		  "totalOrganizations": 23,
		  "totalTours": 27,
		  "totalDays": 1084,
		  "totalCountries": 38,
		  "totalStates": 133,
		  "totalEvents": 521,
		  "eventPercent": 0.980961,
		  "totalScheduleItems": 8510,
		  "schedulePercent": 0.991954,
		  "totalGuests": 4455,
		  "guestPercent": 0.995807,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d062aa27ae30dcbb4799c0d7b5d685da",
		  
		  "name": "Blake",
		  "createdDate": "2022-06-17 22:05:13",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 738,
		  "totalCountries": 33,
		  "totalStates": 55,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 3344,
		  "schedulePercent": 0.870467,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0693b18a36d10a07d73001193bdbbf9",
		  
		  "name": "Madison",
		  "createdDate": "2025-03-18 17:03:39",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 149,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 766,
		  "schedulePercent": 0.410245,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0696d2214db8b8e731652ff008c13bb",
		  
		  "name": "David",
		  "createdDate": "2019-04-03 23:05:19",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 592,
		  "totalCountries": 10,
		  "totalStates": 44,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1068,
		  "schedulePercent": 0.509633,
		  "totalGuests": 576,
		  "guestPercent": 0.751587,
		  "mostGuestDate": "2025-01-15 00:00:00",
		  "mostGuestName": "Lodge Room",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d06c1a303d33ab8ec013830df8c657b5",
		  
		  "name": "Ryan",
		  "createdDate": "2016-10-05 03:17:00",
		  "totalOrganizations": 15,
		  "totalTours": 14,
		  "totalDays": 301,
		  "totalCountries": 4,
		  "totalStates": 54,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 2983,
		  "schedulePercent": 0.841002,
		  "totalGuests": 1971,
		  "guestPercent": 0.945036,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 160,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d06e1091046fef1081348e2189d5bbf2",
		  
		  "name": "Locky",
		  "createdDate": "2024-06-20 03:10:19",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 126,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 652,
		  "schedulePercent": 0.3682,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Young Showground Camping",
		  "mostGuestCity": "Young",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d06e56a2475ea2c4903e03413828b967",
		  
		  "name": "Katrina",
		  "createdDate": "2025-05-17 22:14:24",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 224,
		  "totalCountries": 11,
		  "totalStates": 10,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 341,
		  "schedulePercent": 0.239121,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d087ba1b50f70b7e2e0032fa230f9eee",
		  
		  "name": "Matt",
		  "createdDate": "2021-10-04 13:55:51",
		  "totalOrganizations": 17,
		  "totalTours": 17,
		  "totalDays": 2480,
		  "totalCountries": 26,
		  "totalStates": 62,
		  "totalEvents": 229,
		  "eventPercent": 0.846781,
		  "totalScheduleItems": 3353,
		  "schedulePercent": 0.87126,
		  "totalGuests": 253,
		  "guestPercent": 0.626927,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "The Peppermint Club",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d08d376d2cac2df0ef2b6f2883c66dcf",
		  
		  "name": "Frank",
		  "createdDate": "2019-01-04 13:55:53",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 411,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 724,
		  "schedulePercent": 0.395852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d091f6ebe164cc39df9103dff4e46edf",
		  
		  "name": "Alexandra",
		  "createdDate": "2022-06-17 22:06:14",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 264,
		  "totalCountries": 16,
		  "totalStates": 35,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1901,
		  "schedulePercent": 0.69515,
		  "totalGuests": 2334,
		  "guestPercent": 0.963395,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0925035aa9ccec8f88c1b8dd1ec4294",
		  
		  "name": "Mark",
		  "createdDate": "2012-03-15 21:03:49",
		  "totalOrganizations": 12,
		  "totalTours": 34,
		  "totalDays": 496,
		  "totalCountries": 39,
		  "totalStates": 75,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 2966,
		  "schedulePercent": 0.838962,
		  "totalGuests": 904,
		  "guestPercent": 0.831142,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Max Watts Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d094eb51d0fce8d626ee20fc29c96b84",
		  
		  "name": "Junior ",
		  "createdDate": "2016-06-19 01:38:23",
		  "totalOrganizations": 17,
		  "totalTours": 10,
		  "totalDays": 274,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 731,
		  "schedulePercent": 0.398572,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Watson Lake Park",
		  "mostGuestCity": "Prescott",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d097182b6b7b3eefdba14bf8995e2106",
		  
		  "name": "Jackie",
		  "createdDate": "2023-03-25 00:28:18",
		  "totalOrganizations": 6,
		  "totalTours": 14,
		  "totalDays": 349,
		  "totalCountries": 9,
		  "totalStates": 36,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 1149,
		  "schedulePercent": 0.534338,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-06-15 00:00:00",
		  "mostGuestName": "Sony Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d09c6a8601838ee7b944f5aabae3c30a",
		  
		  "name": "Simon",
		  "createdDate": "2025-05-12 19:56:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 135,
		  "totalCountries": 10,
		  "totalStates": 23,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 238,
		  "schedulePercent": 0.183704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d09f749443ce25699bf2ddaae2b4aa69",
		  
		  "name": "Ulrik",
		  "createdDate": "2019-01-21 12:54:43",
		  "totalOrganizations": 70,
		  "totalTours": 46,
		  "totalDays": 593,
		  "totalCountries": 19,
		  "totalStates": 24,
		  "totalEvents": 395,
		  "eventPercent": 0.957729,
		  "totalScheduleItems": 2173,
		  "schedulePercent": 0.743427,
		  "totalGuests": 184,
		  "guestPercent": 0.582276,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Amager Bio / BETA",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0a38e0fe9daa691ca702fb509f4c326",
		  
		  "name": "Eryn",
		  "createdDate": "2023-01-03 21:37:46",
		  "totalOrganizations": 26,
		  "totalTours": 21,
		  "totalDays": 2115,
		  "totalCountries": 16,
		  "totalStates": 63,
		  "totalEvents": 842,
		  "eventPercent": 0.993994,
		  "totalScheduleItems": 10185,
		  "schedulePercent": 0.997167,
		  "totalGuests": 2254,
		  "guestPercent": 0.960109,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0a8be168a2cfe9080febda9ae7dc123",
		  
		  "name": "Enzo",
		  "createdDate": "2024-07-11 08:58:49",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 96,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 497,
		  "schedulePercent": 0.310857,
		  "totalGuests": 62,
		  "guestPercent": 0.473368,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "APPASSIONATO",
		  "mostGuestCity": "Chambord",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0b31ea53ee9f3354b547390ef1fa465",
		  
		  "name": "William",
		  "createdDate": "2024-01-05 19:54:12",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 127,
		  "totalCountries": 6,
		  "totalStates": 32,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 601,
		  "schedulePercent": 0.351315,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "Ogden Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0ba423dcecfb0d7e1756437307c1d33",
		  
		  "name": "Marty",
		  "createdDate": "2015-10-24 09:42:45",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 74,
		  "totalCountries": 5,
		  "totalStates": 9,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 390,
		  "schedulePercent": 0.264733,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Rockefeller Music Hall",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0bd6a06bf6902ae275ae2528f36f99c",
		  
		  "name": "Chase ",
		  "createdDate": "2016-10-31 18:07:59",
		  "totalOrganizations": 15,
		  "totalTours": 20,
		  "totalDays": 4230,
		  "totalCountries": 41,
		  "totalStates": 72,
		  "totalEvents": 382,
		  "eventPercent": 0.953876,
		  "totalScheduleItems": 5578,
		  "schedulePercent": 0.969175,
		  "totalGuests": 396,
		  "guestPercent": 0.692656,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0c0d879303b84ab112f50b49d59dc36",
		  
		  "name": "Oliver ",
		  "createdDate": "2022-10-05 11:02:55",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 98,
		  "totalCountries": 6,
		  "totalStates": 5,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 574,
		  "schedulePercent": 0.341228,
		  "totalGuests": 83,
		  "guestPercent": 0.499773,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "FjÃ¦reheia",
		  "mostGuestCity": "Grimstad",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0c2cdf693e663c438cd2913579a136e",
		  
		  "name": "Tara",
		  "createdDate": "2011-09-08 02:50:03",
		  "totalOrganizations": 26,
		  "totalTours": 13,
		  "totalDays": 771,
		  "totalCountries": 9,
		  "totalStates": 68,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 3672,
		  "schedulePercent": 0.894379,
		  "totalGuests": 2257,
		  "guestPercent": 0.960222,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0c47a7d0162f1800715eabbec0f3515",
		  
		  "name": "John",
		  "createdDate": "2012-06-12 18:09:34",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 463,
		  "totalCountries": 8,
		  "totalStates": 51,
		  "totalEvents": 231,
		  "eventPercent": 0.849275,
		  "totalScheduleItems": 3821,
		  "schedulePercent": 0.903898,
		  "totalGuests": 1056,
		  "guestPercent": 0.855848,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0c9826dcca6fae3a9f60a5344b92b63",
		  
		  "name": "Noah",
		  "createdDate": "2010-06-06 15:10:07",
		  "totalOrganizations": 14,
		  "totalTours": 2,
		  "totalDays": 411,
		  "totalCountries": 5,
		  "totalStates": 23,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 32,
		  "schedulePercent": 0.042951,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0f4a0a53ad7d1eee0f30837bed13c10",
		  
		  "name": "Steve",
		  "createdDate": "2022-08-17 23:40:42",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 210,
		  "totalCountries": 11,
		  "totalStates": 41,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1048,
		  "schedulePercent": 0.503853,
		  "totalGuests": 199,
		  "guestPercent": 0.594062,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "Lodge Room",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0f4b3b444a9ee9f0c61122130d8e11e",
		  
		  "name": "Jeff",
		  "createdDate": "2019-10-21 19:32:36",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 376,
		  "totalCountries": 7,
		  "totalStates": 25,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 818,
		  "schedulePercent": 0.430077,
		  "totalGuests": 3144,
		  "guestPercent": 0.984587,
		  "mostGuestDate": "2025-05-13 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 176,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0fb2740701f6d39b9e92d5688f5d14f",
		  
		  "name": "Evelina",
		  "createdDate": "2015-09-14 11:14:33",
		  "totalOrganizations": 77,
		  "totalTours": 31,
		  "totalDays": 206,
		  "totalCountries": 9,
		  "totalStates": 32,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 1415,
		  "schedulePercent": 0.601541,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Fasching",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0fd2af7caf8d01bfce51a74275dafc7",
		  
		  "name": "Riley",
		  "createdDate": "2014-01-21 17:16:49",
		  "totalOrganizations": 15,
		  "totalTours": 3,
		  "totalDays": 203,
		  "totalCountries": 6,
		  "totalStates": 31,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 675,
		  "schedulePercent": 0.376473,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d0fead718fe7a6c9282b66e9956795b0",
		  
		  "name": "Darren",
		  "createdDate": "2011-06-22 16:13:30",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 73,
		  "totalCountries": 4,
		  "totalStates": 10,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 440,
		  "schedulePercent": 0.286491,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d100883af2aed0e331e40eb6a94d035e",
		  
		  "name": "Chlo&#233;",
		  "createdDate": "2025-10-03 14:57:46",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 115,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 229,
		  "schedulePercent": 0.177131,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d10493d1054b5f912274a1e70ecd4e8b",
		  
		  "name": "Garrett",
		  "createdDate": "2025-01-10 23:52:16",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 853,
		  "totalCountries": 10,
		  "totalStates": 53,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1433,
		  "schedulePercent": 0.604941,
		  "totalGuests": 360,
		  "guestPercent": 0.67815,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1071a5d932e340ed206a2a963569464",
		  
		  "name": "Andrew",
		  "createdDate": "2010-06-08 17:41:51",
		  "totalOrganizations": 21,
		  "totalTours": 14,
		  "totalDays": 3246,
		  "totalCountries": 23,
		  "totalStates": 102,
		  "totalEvents": 703,
		  "eventPercent": 0.991274,
		  "totalScheduleItems": 10924,
		  "schedulePercent": 0.997507,
		  "totalGuests": 804,
		  "guestPercent": 0.80859,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d109cd913af63f792e0152dded0198f5",
		  
		  "name": "Justin",
		  "createdDate": "2011-02-04 23:43:39",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 849,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 3265,
		  "schedulePercent": 0.86548,
		  "totalGuests": 2886,
		  "guestPercent": 0.979488,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 214,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1132e38d6000347025dbdd0ded7c16d",
		  
		  "name": "John",
		  "createdDate": "2020-08-24 19:02:58",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 231,
		  "totalCountries": 2,
		  "totalStates": 37,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 1960,
		  "schedulePercent": 0.705576,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d115b4b2dea22b284acacba74e5bb145",
		  
		  "name": "Christopher",
		  "createdDate": "2016-02-08 20:52:26",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 584,
		  "totalCountries": 9,
		  "totalStates": 43,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1209,
		  "schedulePercent": 0.549184,
		  "totalGuests": 394,
		  "guestPercent": 0.691976,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d121938376725df7e92a364144da4938",
		  
		  "name": "Chilie",
		  "createdDate": "2016-04-20 11:40:30",
		  "totalOrganizations": 106,
		  "totalTours": 35,
		  "totalDays": 1105,
		  "totalCountries": 19,
		  "totalStates": 19,
		  "totalEvents": 1032,
		  "eventPercent": 0.995694,
		  "totalScheduleItems": 4018,
		  "schedulePercent": 0.914211,
		  "totalGuests": 148,
		  "guestPercent": 0.556664,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "K.B. Hallen",
		  "mostGuestCity": "Frederiksberg",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d12fe3efc687a330bb350be143a38dcd",
		  
		  "name": "Katie",
		  "createdDate": "2025-02-20 21:40:42",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 176,
		  "schedulePercent": 0.143699,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d13100c7f52d6b3d7d13f949f95f1e20",
		  
		  "name": "Lennea",
		  "createdDate": "2016-05-13 09:22:25",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 198,
		  "totalCountries": 22,
		  "totalStates": 25,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1124,
		  "schedulePercent": 0.526179,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d153f11d5d6e07fc27fa80d6567fce3a",
		  
		  "name": "Alisha",
		  "createdDate": "2025-03-03 23:49:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 87,
		  "schedulePercent": 0.0878287,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1549f35cf718e687f682d185600c73d",
		  
		  "name": "Sigurdur",
		  "createdDate": "2025-03-19 14:55:16",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 105,
		  "totalCountries": 12,
		  "totalStates": 34,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 296,
		  "schedulePercent": 0.215549,
		  "totalGuests": 160,
		  "guestPercent": 0.565956,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Pioneer Works",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d168236d55e8d85f1ca5932e650afaa8",
		  
		  "name": "Tom",
		  "createdDate": "2018-05-17 20:56:20",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 55,
		  "totalCountries": 9,
		  "totalStates": 6,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d16e709e523752920d4f7c1ed935432b",
		  
		  "name": "Jake",
		  "createdDate": "2019-05-06 00:44:02",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 145,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 745,
		  "schedulePercent": 0.403445,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Globe Iron",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d16f5e895b8f76dec9d7a2eca414e3df",
		  
		  "name": "Seth",
		  "createdDate": "2022-06-16 02:11:53",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 130,
		  "totalCountries": 13,
		  "totalStates": 35,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1273,
		  "schedulePercent": 0.56607,
		  "totalGuests": 1553,
		  "guestPercent": 0.915345,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d17fc989aba2f6600f5a23f9b73e47d7",
		  
		  "name": "Mark",
		  "createdDate": "2009-06-04 19:59:07",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 336,
		  "totalCountries": 3,
		  "totalStates": 51,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2403,
		  "schedulePercent": 0.775385,
		  "totalGuests": 1756,
		  "guestPercent": 0.93053,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d188f3497b47718869bd492e886e189a",
		  
		  "name": "Bryanna",
		  "createdDate": "2023-08-06 19:21:06",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 157,
		  "schedulePercent": 0.13316,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d197b319f87dbe5dfeacf13dbc276579",
		  
		  "name": "Martin",
		  "createdDate": "2019-06-10 09:33:09",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 167,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1236,
		  "schedulePercent": 0.55621,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d199fb98cf597f904133bc781c1344e3",
		  
		  "name": "Nadine",
		  "createdDate": "2013-09-21 22:07:37",
		  "totalOrganizations": 3,
		  "totalTours": 12,
		  "totalDays": 381,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2775,
		  "schedulePercent": 0.818676,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1a1efb97c6da3409ebe2f61846ef9d7",
		  
		  "name": "Ashley",
		  "createdDate": "2018-05-30 18:10:09",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 107,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 157,
		  "schedulePercent": 0.13316,
		  "totalGuests": 325,
		  "guestPercent": 0.663531,
		  "mostGuestDate": "2025-12-16 00:00:00",
		  "mostGuestName": "Grand Ole Opry",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1a8068c8bc0993a7925c8d212c077f0",
		  
		  "name": "NK",
		  "createdDate": "2017-10-02 17:20:28",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 775,
		  "totalCountries": 10,
		  "totalStates": 33,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1521,
		  "schedulePercent": 0.622054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1b00094e62c5e402882acf5e264c879",
		  
		  "name": "Ezra",
		  "createdDate": "2022-10-17 17:48:44",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 43,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 26,
		  "schedulePercent": 0.0371713,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1b0de7cd0eb147bf820a46ac67ab8c6",
		  
		  "name": "Tobias",
		  "createdDate": "2022-08-09 09:39:46",
		  "totalOrganizations": 46,
		  "totalTours": 28,
		  "totalDays": 476,
		  "totalCountries": 7,
		  "totalStates": 5,
		  "totalEvents": 406,
		  "eventPercent": 0.960335,
		  "totalScheduleItems": 2945,
		  "schedulePercent": 0.836242,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1ba39be474f1a13584a76519e12c1f5",
		  
		  "name": "Raymond",
		  "createdDate": "2015-04-24 19:14:16",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 64,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 392,
		  "schedulePercent": 0.265866,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Christian Cultural Center",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1c8e9d6a1276fb35c1948f33669d76c",
		  
		  "name": "Dale",
		  "createdDate": "2016-12-07 15:33:24",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 443,
		  "totalCountries": 24,
		  "totalStates": 52,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 2286,
		  "schedulePercent": 0.759746,
		  "totalGuests": 1317,
		  "guestPercent": 0.889053,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1e0d1a0fa53c00d64218e6a87196dcc",
		  
		  "name": "Craig",
		  "createdDate": "2010-01-22 16:56:24",
		  "totalOrganizations": 15,
		  "totalTours": 33,
		  "totalDays": 473,
		  "totalCountries": 18,
		  "totalStates": 71,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 3485,
		  "schedulePercent": 0.881233,
		  "totalGuests": 2492,
		  "guestPercent": 0.967702,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1e1d12cea3f6fb003de717c3c583df8",
		  
		  "name": "Stacy",
		  "createdDate": "2023-03-21 17:40:33",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 79,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 674,
		  "schedulePercent": 0.37636,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1e439d3d3d16d903175a78e4f898992",
		  
		  "name": "Ian",
		  "createdDate": "2014-09-11 21:13:51",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 149,
		  "totalCountries": 11,
		  "totalStates": 39,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 452,
		  "schedulePercent": 0.291364,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1e4935a8c3cb1f24edff2039ce5d474",
		  
		  "name": "Christopher",
		  "createdDate": "2013-06-28 02:01:39",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 751,
		  "totalCountries": 5,
		  "totalStates": 20,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 945,
		  "schedulePercent": 0.473821,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Vernon & District Performing Arts Centre",
		  "mostGuestCity": "Vernon",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1eb32487e0472e1e2fa45f2713d0feb",
		  
		  "name": "Mallory",
		  "createdDate": "2018-02-08 19:59:44",
		  "totalOrganizations": 18,
		  "totalTours": 12,
		  "totalDays": 920,
		  "totalCountries": 10,
		  "totalStates": 54,
		  "totalEvents": 244,
		  "eventPercent": 0.86514,
		  "totalScheduleItems": 3101,
		  "schedulePercent": 0.851315,
		  "totalGuests": 1021,
		  "guestPercent": 0.850181,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1eda0c1332cdc560a87bc197a19fe84",
		  
		  "name": "Victoria",
		  "createdDate": "2025-10-28 12:30:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 195,
		  "schedulePercent": 0.156278,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1f1b56c2d97abc377413dd1a271c6dc",
		  
		  "name": "Paul",
		  "createdDate": "2023-11-05 20:54:54",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 121,
		  "totalCountries": 22,
		  "totalStates": 26,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 944,
		  "schedulePercent": 0.473595,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "SO36",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d1f8e0bb93acbfa76d81b23adc36443a",
		  
		  "name": "Jenna",
		  "createdDate": "2023-01-03 23:33:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 74,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 423,
		  "schedulePercent": 0.279578,
		  "totalGuests": 313,
		  "guestPercent": 0.655372,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d206d7be1c251be4ffc3a377767d2738",
		  
		  "name": "Dominic",
		  "createdDate": "2016-03-02 16:59:08",
		  "totalOrganizations": 9,
		  "totalTours": 15,
		  "totalDays": 1231,
		  "totalCountries": 23,
		  "totalStates": 52,
		  "totalEvents": 221,
		  "eventPercent": 0.835449,
		  "totalScheduleItems": 2462,
		  "schedulePercent": 0.782525,
		  "totalGuests": 1209,
		  "guestPercent": 0.8767,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wythenshawe Park and Gardens",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d213d59eec80d57c2fbe129b4b1a7c3c",
		  
		  "name": "E1FX",
		  "createdDate": "2019-11-15 19:57:42",
		  "totalOrganizations": 51,
		  "totalTours": 20,
		  "totalDays": 880,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 450,
		  "eventPercent": 0.970875,
		  "totalScheduleItems": 2428,
		  "schedulePercent": 0.778332,
		  "totalGuests": 2002,
		  "guestPercent": 0.947303,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Globe Life Park in Arlington",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d22295aad43197ebcf51c263fe2b8576",
		  
		  "name": "Anders",
		  "createdDate": "2020-02-13 16:27:40",
		  "totalOrganizations": 13,
		  "totalTours": 6,
		  "totalDays": 120,
		  "totalCountries": 6,
		  "totalStates": 17,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 845,
		  "schedulePercent": 0.438803,
		  "totalGuests": 207,
		  "guestPercent": 0.599388,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Sentrum Scene",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d22f4571e94d227d20e87d2768e194ef",
		  
		  "name": "Jordan",
		  "createdDate": "2019-02-14 18:10:48",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 331,
		  "totalCountries": 24,
		  "totalStates": 18,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 839,
		  "schedulePercent": 0.43699,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d23be85339287d8fb76902956e869ed4",
		  
		  "name": "Joe",
		  "createdDate": "2018-10-15 16:53:34",
		  "totalOrganizations": 15,
		  "totalTours": 18,
		  "totalDays": 276,
		  "totalCountries": 19,
		  "totalStates": 55,
		  "totalEvents": 154,
		  "eventPercent": 0.713735,
		  "totalScheduleItems": 1486,
		  "schedulePercent": 0.615027,
		  "totalGuests": 271,
		  "guestPercent": 0.635653,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d23e9998210a4781938f9b111ee3d879",
		  
		  "name": "Louis",
		  "createdDate": "2014-06-11 04:28:45",
		  "totalOrganizations": 11,
		  "totalTours": 22,
		  "totalDays": 652,
		  "totalCountries": 18,
		  "totalStates": 75,
		  "totalEvents": 294,
		  "eventPercent": 0.908658,
		  "totalScheduleItems": 4167,
		  "schedulePercent": 0.923164,
		  "totalGuests": 1820,
		  "guestPercent": 0.93427,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d24f8751d333866ba9e9c6cb74124200",
		  
		  "name": "Maci",
		  "createdDate": "2025-07-31 17:11:54",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 357,
		  "totalCountries": 6,
		  "totalStates": 53,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2035,
		  "schedulePercent": 0.719855,
		  "totalGuests": 337,
		  "guestPercent": 0.668858,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Fox Performing Arts Center",
		  "mostGuestCity": "Riverside",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2546444ec3dda287e293558f4fccee9",
		  
		  "name": "Asher",
		  "createdDate": "2017-10-30 16:37:51",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 574,
		  "totalCountries": 17,
		  "totalStates": 54,
		  "totalEvents": 269,
		  "eventPercent": 0.889393,
		  "totalScheduleItems": 2227,
		  "schedulePercent": 0.752493,
		  "totalGuests": 1411,
		  "guestPercent": 0.901179,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d25e2b0818d9df5b96b24fc0dd28a954",
		  
		  "name": "Fredrik",
		  "createdDate": "2019-01-09 15:36:03",
		  "totalOrganizations": 21,
		  "totalTours": 8,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d260f6ba2ba50f9f539f1aed547959dd",
		  
		  "name": "John",
		  "createdDate": "2018-03-27 13:04:38",
		  "totalOrganizations": 20,
		  "totalTours": 20,
		  "totalDays": 800,
		  "totalCountries": 21,
		  "totalStates": 73,
		  "totalEvents": 257,
		  "eventPercent": 0.87772,
		  "totalScheduleItems": 2414,
		  "schedulePercent": 0.776632,
		  "totalGuests": 1004,
		  "guestPercent": 0.847008,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d266ae152464e17ac60926123ce17928",
		  
		  "name": "Nate",
		  "createdDate": "2019-09-13 04:27:54",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 521,
		  "totalCountries": 11,
		  "totalStates": 51,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1925,
		  "schedulePercent": 0.699116,
		  "totalGuests": 702,
		  "guestPercent": 0.786265,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "The Fillmore Miami Beach",
		  "mostGuestCity": "Miami Beach",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d275e0f6e661295dbe0f4aeb3de0431e",
		  
		  "name": "Nik",
		  "createdDate": "2010-06-10 21:35:57",
		  "totalOrganizations": 257,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 153,
		  "schedulePercent": 0.131686,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d294cc361690ec70bea7d7cc4e1dca47",
		  
		  "name": "Naomi",
		  "createdDate": "2021-04-02 00:51:24",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 33,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 357,
		  "schedulePercent": 0.246714,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2bc5d8afa5d67c874bad35bdd6ea004",
		  
		  "name": "Amy",
		  "createdDate": "2021-06-14 13:07:46",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 149,
		  "totalCountries": 19,
		  "totalStates": 30,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 852,
		  "schedulePercent": 0.440843,
		  "totalGuests": 398,
		  "guestPercent": 0.692996,
		  "mostGuestDate": "2025-07-15 00:00:00",
		  "mostGuestName": "Auditorium Parco Della Musica - Sala Sinopoli",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2c02210b17e4efa726af7467b8e0ac3",
		  
		  "name": "MAHÃ‰",
		  "createdDate": "2022-05-05 10:03:38",
		  "totalOrganizations": 3,
		  "totalTours": 27,
		  "totalDays": 693,
		  "totalCountries": 29,
		  "totalStates": 85,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 2955,
		  "schedulePercent": 0.837375,
		  "totalGuests": 1378,
		  "guestPercent": 0.897325,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2c8690c42b3b4e617f855b7599305c1",
		  
		  "name": "Brad",
		  "createdDate": "2021-08-29 17:48:37",
		  "totalOrganizations": 11,
		  "totalTours": 15,
		  "totalDays": 204,
		  "totalCountries": 18,
		  "totalStates": 46,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 948,
		  "schedulePercent": 0.474728,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Sydney Opera House",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2cb8966647fe571977056c867883952",
		  
		  "name": "Ana",
		  "createdDate": "2022-09-30 02:20:43",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 476,
		  "totalCountries": 6,
		  "totalStates": 31,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 657,
		  "schedulePercent": 0.370354,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Elsewhere",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2d47bed89cfa125034d3f8ca2ad7359",
		  
		  "name": "test1",
		  "createdDate": "2025-08-12 17:25:47",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 157,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 25,
		  "schedulePercent": 0.0360381,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "The Midway",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2dcc463e7b40a95ff8846492fd355e8",
		  
		  "name": "Production",
		  "createdDate": "2025-08-21 20:43:31",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 192,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1487,
		  "schedulePercent": 0.615367,
		  "totalGuests": 1102,
		  "guestPercent": 0.864461,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2e8701ab7e59493a8f4f0a464933a1d",
		  
		  "name": "Duchess",
		  "createdDate": "2017-02-16 10:07:54",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 611,
		  "totalCountries": 11,
		  "totalStates": 42,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 2171,
		  "schedulePercent": 0.743087,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d2f931b77c1923e041a43f846a4821d3",
		  
		  "name": "Clinton",
		  "createdDate": "2010-06-07 08:02:48",
		  "totalOrganizations": 23,
		  "totalTours": 21,
		  "totalDays": 1539,
		  "totalCountries": 30,
		  "totalStates": 75,
		  "totalEvents": 335,
		  "eventPercent": 0.935063,
		  "totalScheduleItems": 3240,
		  "schedulePercent": 0.862987,
		  "totalGuests": 806,
		  "guestPercent": 0.809384,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3032d3a5bc22a13fa7599bc8b6686cb",
		  
		  "name": "Melanie",
		  "createdDate": "2022-08-31 18:41:11",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 118,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1045,
		  "schedulePercent": 0.502493,
		  "totalGuests": 1343,
		  "guestPercent": 0.892339,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d306ca31aa2046717289768a2eca4bde",
		  
		  "name": "Dan",
		  "createdDate": "2017-06-28 20:51:01",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 150,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1719,
		  "schedulePercent": 0.661945,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "DNA Lounge",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d327519f5b8db0480a32d8701d69a0c1",
		  
		  "name": "Adam",
		  "createdDate": "2012-01-18 18:52:06",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 447,
		  "totalCountries": 12,
		  "totalStates": 31,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 817,
		  "schedulePercent": 0.429737,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d327ff6089d19f6a8fab380bbbff8038",
		  
		  "name": "Ruwan",
		  "createdDate": "2013-09-04 19:52:11",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 138,
		  "totalCountries": 10,
		  "totalStates": 26,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 723,
		  "schedulePercent": 0.395512,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d330310c23b3e275d068c05851b69b8b",
		  
		  "name": "Devin",
		  "createdDate": "2020-11-12 00:09:22",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 154,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 577,
		  "schedulePercent": 0.342362,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d33dd4a971b0a3d667868617a3b01a05",
		  
		  "name": "Will",
		  "createdDate": "2025-04-08 21:42:00",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 531,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 628,
		  "schedulePercent": 0.359927,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Crofoot",
		  "mostGuestCity": "Pontiac",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d34bed0d7559322915cec442a815e9ae",
		  
		  "name": "Nathan",
		  "createdDate": "2013-08-26 15:45:23",
		  "totalOrganizations": 11,
		  "totalTours": 20,
		  "totalDays": 442,
		  "totalCountries": 8,
		  "totalStates": 53,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 3450,
		  "schedulePercent": 0.878853,
		  "totalGuests": 1621,
		  "guestPercent": 0.921578,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d34eeb903d154fd8a8bbe076377a7baa",
		  
		  "name": "Janet",
		  "createdDate": "2025-04-23 17:36:42",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 62,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 15,
		  "schedulePercent": 0.0248187,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d384ba17b20a47cbe690962c7b28c012",
		  
		  "name": "Jenni ",
		  "createdDate": "2013-12-13 15:14:08",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 343,
		  "totalCountries": 21,
		  "totalStates": 35,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2609,
		  "schedulePercent": 0.798844,
		  "totalGuests": 2122,
		  "guestPercent": 0.955009,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The SSE Hydro",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3872e281b30e764cfeaa4fe8a639dc6",
		  
		  "name": "Joel",
		  "createdDate": "2022-04-23 00:03:47",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 33,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 221,
		  "schedulePercent": 0.172257,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d39b5fa8b655d960fc6bb687b5f448f7",
		  
		  "name": "Office Account",
		  "createdDate": "2024-01-15 13:34:00",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 416,
		  "totalCountries": 37,
		  "totalStates": 80,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1769,
		  "schedulePercent": 0.671351,
		  "totalGuests": 112,
		  "guestPercent": 0.529805,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Borgholms Slott",
		  "mostGuestCity": "Borgholm",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3a516b657817868df26d670a19e14f2",
		  
		  "name": "Cl&#233;ment",
		  "createdDate": "2019-10-07 09:55:11",
		  "totalOrganizations": 32,
		  "totalTours": 23,
		  "totalDays": 667,
		  "totalCountries": 27,
		  "totalStates": 69,
		  "totalEvents": 431,
		  "eventPercent": 0.966682,
		  "totalScheduleItems": 5910,
		  "schedulePercent": 0.974615,
		  "totalGuests": 2391,
		  "guestPercent": 0.964982,
		  "mostGuestDate": "2025-06-16 00:00:00",
		  "mostGuestName": "Cavea Auditorium",
		  "mostGuestCity": "Rome",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3aaf102801085853f90f054f47534db",
		  
		  "name": "Christoph",
		  "createdDate": "2023-09-21 06:36:38",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 103,
		  "totalCountries": 21,
		  "totalStates": 27,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 1057,
		  "schedulePercent": 0.506346,
		  "totalGuests": 936,
		  "guestPercent": 0.836582,
		  "mostGuestDate": "2025-02-04 00:00:00",
		  "mostGuestName": "Berliner Philharmonie",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3b55720bd4fdf7559e727208d64dbc0",
		  
		  "name": "Melanie",
		  "createdDate": "2013-04-24 15:11:32",
		  "totalOrganizations": 30,
		  "totalTours": 49,
		  "totalDays": 1533,
		  "totalCountries": 28,
		  "totalStates": 106,
		  "totalEvents": 560,
		  "eventPercent": 0.984814,
		  "totalScheduleItems": 7068,
		  "schedulePercent": 0.986854,
		  "totalGuests": 2101,
		  "guestPercent": 0.954329,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3c896caf140da2d6d25608a35e71830",
		  
		  "name": "Mark",
		  "createdDate": "2016-06-07 18:13:30",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 631,
		  "totalCountries": 16,
		  "totalStates": 46,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 785,
		  "schedulePercent": 0.417384,
		  "totalGuests": 543,
		  "guestPercent": 0.741614,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3d153065ac593890ead3a0970ab1423",
		  
		  "name": "CB",
		  "createdDate": "2024-01-23 23:51:16",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 1219,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 777,
		  "schedulePercent": 0.415231,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3f00feb543f75df4f5cb2848119824f",
		  
		  "name": "Jon",
		  "createdDate": "2019-08-10 16:12:25",
		  "totalOrganizations": 18,
		  "totalTours": 50,
		  "totalDays": 506,
		  "totalCountries": 26,
		  "totalStates": 36,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2440,
		  "schedulePercent": 0.779692,
		  "totalGuests": 455,
		  "guestPercent": 0.714755,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d3fb2b77a5850540277f2a0140a78161",
		  
		  "name": "Mike",
		  "createdDate": "2021-06-20 22:15:13",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 995,
		  "totalCountries": 12,
		  "totalStates": 49,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1821,
		  "schedulePercent": 0.67985,
		  "totalGuests": 432,
		  "guestPercent": 0.706936,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Kia Center",
		  "mostGuestCity": "Orlando",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d405855899327c1f3e0ccb1a090102c3",
		  
		  "name": "Tom",
		  "createdDate": "2014-01-18 16:18:57",
		  "totalOrganizations": 5,
		  "totalTours": 25,
		  "totalDays": 210,
		  "totalCountries": 36,
		  "totalStates": 56,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1414,
		  "schedulePercent": 0.601201,
		  "totalGuests": 1369,
		  "guestPercent": 0.896306,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4094cc15e6beb13970d97ed74b4a3fc",
		  
		  "name": "Lucie",
		  "createdDate": "2010-07-07 21:16:49",
		  "totalOrganizations": 21,
		  "totalTours": 5,
		  "totalDays": 504,
		  "totalCountries": 5,
		  "totalStates": 7,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 159,
		  "schedulePercent": 0.134519,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4129d42b2a2e28411ec05037f2f9fbc",
		  
		  "name": "Chris",
		  "createdDate": "2015-03-13 17:55:27",
		  "totalOrganizations": 17,
		  "totalTours": 3,
		  "totalDays": 559,
		  "totalCountries": 15,
		  "totalStates": 11,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1432,
		  "schedulePercent": 0.604828,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Budapest Park",
		  "mostGuestCity": "Budapest",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d41eaca9e27fa6d92a53e7fc9518bf3d",
		  
		  "name": "Drew",
		  "createdDate": "2022-02-02 05:48:32",
		  "totalOrganizations": 20,
		  "totalTours": 17,
		  "totalDays": 1576,
		  "totalCountries": 14,
		  "totalStates": 32,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 1726,
		  "schedulePercent": 0.663191,
		  "totalGuests": 139,
		  "guestPercent": 0.551677,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "The Imperial Hotel",
		  "mostGuestCity": "Eumundi",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d42046d7561dbdd82223b840cc473a8c",
		  
		  "name": "Tobias",
		  "createdDate": "2020-01-28 20:16:39",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 470,
		  "totalCountries": 31,
		  "totalStates": 24,
		  "totalEvents": 242,
		  "eventPercent": 0.863667,
		  "totalScheduleItems": 2159,
		  "schedulePercent": 0.741047,
		  "totalGuests": 410,
		  "guestPercent": 0.697303,
		  "mostGuestDate": "2025-06-25 00:00:00",
		  "mostGuestName": "Stockholm Fields",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d421fb0851a9191e8cdd71288797f4e3",
		  
		  "name": "Pyry",
		  "createdDate": "2023-04-03 08:40:05",
		  "totalOrganizations": 147,
		  "totalTours": 89,
		  "totalDays": 1068,
		  "totalCountries": 6,
		  "totalStates": 3,
		  "totalEvents": 1065,
		  "eventPercent": 0.996034,
		  "totalScheduleItems": 4474,
		  "schedulePercent": 0.937557,
		  "totalGuests": 126,
		  "guestPercent": 0.541364,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4227e9327f96bf409bd1b343b22849f",
		  
		  "name": "Gina",
		  "createdDate": "2019-03-14 01:08:25",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 704,
		  "totalCountries": 11,
		  "totalStates": 36,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 2438,
		  "schedulePercent": 0.779352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d42631a98fc95f6c532369d0a8676de2",
		  
		  "name": "Pedro",
		  "createdDate": "2015-09-05 17:04:01",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 268,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 213,
		  "schedulePercent": 0.167611,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d42da5843e6543c45b20fe24e49d2384",
		  
		  "name": "Andrew",
		  "createdDate": "2017-12-07 16:20:53",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 105,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 65,
		  "schedulePercent": 0.0703762,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d436637ec50166bb932413103100b984",
		  
		  "name": "Lamar",
		  "createdDate": "2022-04-23 22:17:05",
		  "totalOrganizations": 18,
		  "totalTours": 16,
		  "totalDays": 677,
		  "totalCountries": 17,
		  "totalStates": 54,
		  "totalEvents": 359,
		  "eventPercent": 0.94583,
		  "totalScheduleItems": 5303,
		  "schedulePercent": 0.962262,
		  "totalGuests": 1637,
		  "guestPercent": 0.923277,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d438f1f8f4e3ee3f73ae67b2569236e3",
		  
		  "name": "Corey",
		  "createdDate": "2023-02-07 21:23:48",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 701,
		  "totalCountries": 6,
		  "totalStates": 42,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1347,
		  "schedulePercent": 0.584655,
		  "totalGuests": 51,
		  "guestPercent": 0.454329,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Sonoma County Fairgrounds",
		  "mostGuestCity": "Santa Rosa",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4460200570b8be65994dc29a87b22e3",
		  
		  "name": "Josh",
		  "createdDate": "2022-10-04 04:07:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 221,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Longhorn Ballroom",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d456521b0d7b19b73393fc515cc3088b",
		  
		  "name": "KC",
		  "createdDate": "2015-05-27 01:36:22",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 516,
		  "totalCountries": 8,
		  "totalStates": 40,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 2797,
		  "schedulePercent": 0.821623,
		  "totalGuests": 519,
		  "guestPercent": 0.735494,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d45d34be3e5246ac2469a7fa60d7e2a2",
		  
		  "name": "Hunter",
		  "createdDate": "2023-08-22 05:26:10",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 373,
		  "totalCountries": 7,
		  "totalStates": 42,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 983,
		  "schedulePercent": 0.486061,
		  "totalGuests": 671,
		  "guestPercent": 0.778332,
		  "mostGuestDate": "2025-04-08 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4688233da14146823438c09a65cf038",
		  
		  "name": "Fabricio",
		  "createdDate": "2025-09-01 10:59:39",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 64,
		  "totalCountries": 9,
		  "totalStates": 10,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 128,
		  "schedulePercent": 0.116614,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4762bed952761581401768adf5ae6cd",
		  
		  "name": "David",
		  "createdDate": "2024-07-26 20:03:19",
		  "totalOrganizations": 2,
		  "totalTours": 22,
		  "totalDays": 91,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 207,
		  "schedulePercent": 0.164438,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d47f976eaee89244de9ae295681c002b",
		  
		  "name": "Heath",
		  "createdDate": "2022-04-08 16:23:44",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 396,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 795,
		  "schedulePercent": 0.420784,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Palais Theatre",
		  "mostGuestCity": "St Kilda",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d49767a5acb7a75f1979b190fe6fb609",
		  
		  "name": "Kari",
		  "createdDate": "2019-08-21 07:11:25",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 253,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 625,
		  "schedulePercent": 0.359134,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4997a798ab73cc54fda33c6352abf00",
		  
		  "name": "Edel",
		  "createdDate": "2023-04-11 16:43:12",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 50,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d49a40b2a740fdd43d6f9b2e4fcee597",
		  
		  "name": "Scott",
		  "createdDate": "2022-05-12 09:44:35",
		  "totalOrganizations": 20,
		  "totalTours": 6,
		  "totalDays": 250,
		  "totalCountries": 16,
		  "totalStates": 61,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1611,
		  "schedulePercent": 0.642339,
		  "totalGuests": 1283,
		  "guestPercent": 0.883613,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 122,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4a4776e8074e411c7baa8c9c789838a",
		  
		  "name": "Joshua",
		  "createdDate": "2009-10-05 16:48:20",
		  "totalOrganizations": 23,
		  "totalTours": 5,
		  "totalDays": 916,
		  "totalCountries": 28,
		  "totalStates": 36,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 2905,
		  "schedulePercent": 0.832162,
		  "totalGuests": 239,
		  "guestPercent": 0.618314,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4ae159a3144f5f703c95b3aa53e6518",
		  
		  "name": "Stephen",
		  "createdDate": "2022-01-16 23:26:28",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 568,
		  "totalCountries": 18,
		  "totalStates": 47,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 2257,
		  "schedulePercent": 0.75612,
		  "totalGuests": 433,
		  "guestPercent": 0.707389,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Rooftop at Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4beb46ce4183e90d8245df6ff94716e",
		  
		  "name": "Bryan",
		  "createdDate": "2010-08-31 20:54:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 5,
		  "totalStates": 56,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2527,
		  "schedulePercent": 0.789325,
		  "totalGuests": 4231,
		  "guestPercent": 0.994334,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4c0a2398f126284cc8cae2b04001dd3",
		  
		  "name": "Jaclyn",
		  "createdDate": "2024-07-18 04:00:29",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 139,
		  "totalCountries": 18,
		  "totalStates": 30,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 1075,
		  "schedulePercent": 0.512239,
		  "totalGuests": 567,
		  "guestPercent": 0.748413,
		  "mostGuestDate": "2025-02-10 00:00:00",
		  "mostGuestName": "Tokyo Garden Theater",
		  "mostGuestCity": "",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4c87ed08af6dd7a7a62e8893a3f5903",
		  
		  "name": "Hayes",
		  "createdDate": "2016-03-03 19:11:15",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 396,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 1279,
		  "schedulePercent": 0.567203,
		  "totalGuests": 162,
		  "guestPercent": 0.56777,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Terminal West",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4cc8312d0bb89095d6deef3484ab9bd",
		  
		  "name": "Tyler",
		  "createdDate": "2018-02-02 04:08:06",
		  "totalOrganizations": 12,
		  "totalTours": 29,
		  "totalDays": 639,
		  "totalCountries": 16,
		  "totalStates": 78,
		  "totalEvents": 318,
		  "eventPercent": 0.924411,
		  "totalScheduleItems": 3003,
		  "schedulePercent": 0.842362,
		  "totalGuests": 454,
		  "guestPercent": 0.714302,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Crescent Ballroom",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4d4b7deb1528b56013d0f7381583d2a",
		  
		  "name": "James",
		  "createdDate": "2025-04-03 14:16:19",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 125,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 338,
		  "schedulePercent": 0.236967,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Gamma Ray Bar",
		  "mostGuestCity": "Madison",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4d728a23a765bea8a47694445190306",
		  
		  "name": "Cody ",
		  "createdDate": "2022-09-14 02:43:08",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 1049,
		  "totalCountries": 4,
		  "totalStates": 62,
		  "totalEvents": 484,
		  "eventPercent": 0.976088,
		  "totalScheduleItems": 7020,
		  "schedulePercent": 0.986627,
		  "totalGuests": 792,
		  "guestPercent": 0.805984,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4da6f5cd10aef65fff3f5c4e7a15e39",
		  
		  "name": "Sophie",
		  "createdDate": "2013-11-11 18:21:30",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 588,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 448,
		  "schedulePercent": 0.289778,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Brockwell Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4e56c8bf6902adb062f8616b5ef078f",
		  
		  "name": "Rose",
		  "createdDate": "2021-12-08 13:02:28",
		  "totalOrganizations": 141,
		  "totalTours": 132,
		  "totalDays": 2157,
		  "totalCountries": 9,
		  "totalStates": 23,
		  "totalEvents": 793,
		  "eventPercent": 0.993087,
		  "totalScheduleItems": 7979,
		  "schedulePercent": 0.99048,
		  "totalGuests": 230,
		  "guestPercent": 0.612534,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "The Core at Corby Cube",
		  "mostGuestCity": "Corby",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4e5fc7c9ba2f0b0c3c6698d5cacd9b3",
		  
		  "name": "Rebekah",
		  "createdDate": "2009-09-05 02:11:14",
		  "totalOrganizations": 15,
		  "totalTours": 20,
		  "totalDays": 480,
		  "totalCountries": 5,
		  "totalStates": 33,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 1914,
		  "schedulePercent": 0.69719,
		  "totalGuests": 1178,
		  "guestPercent": 0.874093,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Ravinia",
		  "mostGuestCity": "Highland Park",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4ef01ebbae2a319d5bd67deb082058b",
		  
		  "name": "Natalia",
		  "createdDate": "2024-02-13 17:25:47",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 442,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 3564,
		  "schedulePercent": 0.885879,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4f246d8939df2ae8f4aef9763ddc7d9",
		  
		  "name": "Tim",
		  "createdDate": "2013-09-26 18:24:27",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 408,
		  "totalCountries": 2,
		  "totalStates": 39,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 3017,
		  "schedulePercent": 0.843835,
		  "totalGuests": 2980,
		  "guestPercent": 0.981414,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d4f2c8becbfa5dff5410948d2915daaa",
		  
		  "name": "Scott ",
		  "createdDate": "2024-06-18 15:53:21",
		  "totalOrganizations": 6,
		  "totalTours": 31,
		  "totalDays": 643,
		  "totalCountries": 23,
		  "totalStates": 58,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2526,
		  "schedulePercent": 0.789098,
		  "totalGuests": 325,
		  "guestPercent": 0.663531,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d505412bb9b4a208eab3d87441627b6f",
		  
		  "name": "Brian",
		  "createdDate": "2023-11-03 17:06:22",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 88,
		  "totalCountries": 6,
		  "totalStates": 15,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 511,
		  "schedulePercent": 0.316296,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Quad Theatre",
		  "mostGuestCity": "Plymouth",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d50c02d3f79f951e763bfe992d1ed545",
		  
		  "name": "Connor",
		  "createdDate": "2015-11-21 15:15:12",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 296,
		  "totalCountries": 10,
		  "totalStates": 42,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 1653,
		  "schedulePercent": 0.650725,
		  "totalGuests": 1312,
		  "guestPercent": 0.887919,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d514e7fc37aff7118656d87043622144",
		  
		  "name": "Frankie",
		  "createdDate": "2010-03-30 20:59:14",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 461,
		  "totalCountries": 21,
		  "totalStates": 67,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 3796,
		  "schedulePercent": 0.902425,
		  "totalGuests": 1907,
		  "guestPercent": 0.940277,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d519d45d234afb289f9e9657357e1595",
		  
		  "name": "Sami",
		  "createdDate": "2014-05-17 23:22:15",
		  "totalOrganizations": 8,
		  "totalTours": 17,
		  "totalDays": 758,
		  "totalCountries": 13,
		  "totalStates": 50,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 1308,
		  "schedulePercent": 0.573323,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-06-22 00:00:00",
		  "mostGuestName": "Garcia's",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d51a16085d7518b245fd0e0b2f0f14e2",
		  
		  "name": "Tom",
		  "createdDate": "2024-07-04 19:48:11",
		  "totalOrganizations": 4,
		  "totalTours": 10,
		  "totalDays": 186,
		  "totalCountries": 13,
		  "totalStates": 27,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 754,
		  "schedulePercent": 0.407298,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d51aadee4af2964a14938c3284015132",
		  
		  "name": "Laura",
		  "createdDate": "2015-07-15 17:43:57",
		  "totalOrganizations": 11,
		  "totalTours": 19,
		  "totalDays": 1031,
		  "totalCountries": 30,
		  "totalStates": 57,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 4478,
		  "schedulePercent": 0.93767,
		  "totalGuests": 694,
		  "guestPercent": 0.784111,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Colosseum Theater at Caesars Palace",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d52cad4fbb04fdcba4e99fd90baafb8a",
		  
		  "name": "Michael",
		  "createdDate": "2017-05-15 18:15:12",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 88,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 456,
		  "schedulePercent": 0.293178,
		  "totalGuests": 245,
		  "guestPercent": 0.622167,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Metro",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d556f1dae9c7abc4b98b96d641c55709",
		  
		  "name": "Jennifer",
		  "createdDate": "2021-12-05 03:46:21",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 21,
		  "totalCountries": 1,
		  "totalStates": 4,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 103,
		  "schedulePercent": 0.0988214,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d558c6dd3ba79f3866768b72247f52c9",
		  
		  "name": "Steve",
		  "createdDate": "2014-03-24 16:53:23",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 523,
		  "totalCountries": 19,
		  "totalStates": 54,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 931,
		  "schedulePercent": 0.469402,
		  "totalGuests": 276,
		  "guestPercent": 0.638259,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "Scotiabank Centre",
		  "mostGuestCity": "Halifax",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d559d05322088115e0b1a3c9a6517862",
		  
		  "name": "Mark",
		  "createdDate": "2013-11-04 20:30:54",
		  "totalOrganizations": 24,
		  "totalTours": 8,
		  "totalDays": 639,
		  "totalCountries": 16,
		  "totalStates": 32,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1947,
		  "schedulePercent": 0.703196,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5716f5bb1cbd2b0724de7288bc1f752",
		  
		  "name": "Rob",
		  "createdDate": "2021-05-25 17:14:56",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 663,
		  "totalCountries": 15,
		  "totalStates": 63,
		  "totalEvents": 282,
		  "eventPercent": 0.899819,
		  "totalScheduleItems": 3640,
		  "schedulePercent": 0.891772,
		  "totalGuests": 2625,
		  "guestPercent": 0.973255,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "The Met Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d571e6b36a03638c20bad83a52d1672f",
		  
		  "name": "Corinne",
		  "createdDate": "2022-01-11 23:35:42",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 281,
		  "totalCountries": 7,
		  "totalStates": 41,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 919,
		  "schedulePercent": 0.464415,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "House of Yes",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5741ad48513acf04f64c9bdfdd7ff6b",
		  
		  "name": "Alex",
		  "createdDate": "2024-04-01 22:34:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 132,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 368,
		  "schedulePercent": 0.252153,
		  "totalGuests": 45,
		  "guestPercent": 0.445603,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Greenfield Lake Amphitheatre",
		  "mostGuestCity": "Wilmington",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d588c75973efb6dff5fd29f302381c9e",
		  
		  "name": "Michael",
		  "createdDate": "2025-04-11 08:16:05",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 241,
		  "schedulePercent": 0.184723,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d58e2ef9be94ec740b3d9acf3dcbfe71",
		  
		  "name": "Fabian ",
		  "createdDate": "2015-03-21 01:52:37",
		  "totalOrganizations": 14,
		  "totalTours": 7,
		  "totalDays": 659,
		  "totalCountries": 15,
		  "totalStates": 64,
		  "totalEvents": 245,
		  "eventPercent": 0.866047,
		  "totalScheduleItems": 4370,
		  "schedulePercent": 0.933704,
		  "totalGuests": 3340,
		  "guestPercent": 0.988101,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d59ce7bcfca218fbf756e17279e93e58",
		  
		  "name": "Julia",
		  "createdDate": "2021-10-08 16:43:06",
		  "totalOrganizations": 3,
		  "totalTours": 13,
		  "totalDays": 989,
		  "totalCountries": 25,
		  "totalStates": 55,
		  "totalEvents": 217,
		  "eventPercent": 0.828989,
		  "totalScheduleItems": 4687,
		  "schedulePercent": 0.94345,
		  "totalGuests": 2076,
		  "guestPercent": 0.952176,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d59d7750710271054fcd9512baee1770",
		  
		  "name": "Nestor",
		  "createdDate": "2019-04-12 16:03:22",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 13,
		  "totalStates": 10,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "The Camden Assembly",
		  "mostGuestCity": "Camden",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5a049f17b9ed93ddaeae06c5f5f3337",
		  
		  "name": "Nanpa",
		  "createdDate": "2023-09-13 17:37:55",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 147,
		  "totalCountries": 7,
		  "totalStates": 16,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 253,
		  "schedulePercent": 0.191976,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5af3cdf930d80b64b9830e02180bdc5",
		  
		  "name": "Brandon",
		  "createdDate": "2020-07-01 21:39:20",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 1,
		  "eventPercent": 0.0074796,
		  "totalScheduleItems": 26,
		  "schedulePercent": 0.0371713,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Wild Horse Saloon",
		  "mostGuestCity": "Durango",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5c29d9feaa6ea7db8e9fe48db4a5665",
		  
		  "name": "Mal",
		  "createdDate": "2013-01-03 04:07:28",
		  "totalOrganizations": 12,
		  "totalTours": 26,
		  "totalDays": 231,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1257,
		  "schedulePercent": 0.562103,
		  "totalGuests": 152,
		  "guestPercent": 0.559384,
		  "mostGuestDate": "2025-03-11 00:00:00",
		  "mostGuestName": "Melbourne Convention and Exhibition Centre (MCEC)",
		  "mostGuestCity": "South Wharf",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5d92892f6a6ac1847b09291bd4f17bc",
		  
		  "name": "Lee",
		  "createdDate": "2019-05-17 10:01:20",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 566,
		  "totalCountries": 10,
		  "totalStates": 48,
		  "totalEvents": 260,
		  "eventPercent": 0.881573,
		  "totalScheduleItems": 865,
		  "schedulePercent": 0.446623,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5e08f0bb6294f3c3dca2304c23483e1",
		  
		  "name": "Felix",
		  "createdDate": "2022-08-23 22:46:05",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 218,
		  "totalCountries": 4,
		  "totalStates": 35,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1540,
		  "schedulePercent": 0.625453,
		  "totalGuests": 245,
		  "guestPercent": 0.622167,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "Music Hall of Williamsburg",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5e6425b67d90dfcabdc80a32905dafe",
		  
		  "name": "Susan",
		  "createdDate": "2025-06-26 14:50:41",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5e654bc8342b5610e9b1f8ad4cc9648",
		  
		  "name": "Kate",
		  "createdDate": "2019-02-15 04:09:33",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 157,
		  "totalCountries": 11,
		  "totalStates": 34,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 545,
		  "schedulePercent": 0.332162,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Tangent Gallery & Hastings Street Ballroom",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5e84fb583ad61c7546b52f346d2a901",
		  
		  "name": "Kevin",
		  "createdDate": "2022-01-13 01:09:21",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 1292,
		  "totalCountries": 8,
		  "totalStates": 64,
		  "totalEvents": 279,
		  "eventPercent": 0.897439,
		  "totalScheduleItems": 5116,
		  "schedulePercent": 0.957729,
		  "totalGuests": 3179,
		  "guestPercent": 0.985267,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5f80d0160c391eeb0d4cf08e7c10915",
		  
		  "name": "TH",
		  "createdDate": "2025-03-31 19:24:44",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 144,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "Amphitheater At Quarry Park",
		  "mostGuestCity": "Rocklin",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d5fb3baa231751fc79cefa449462870f",
		  
		  "name": "Alexis",
		  "createdDate": "2021-09-18 20:48:47",
		  "totalOrganizations": 11,
		  "totalTours": 16,
		  "totalDays": 529,
		  "totalCountries": 13,
		  "totalStates": 52,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 1683,
		  "schedulePercent": 0.655598,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Tabernacle",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6000e0ebbf025da75e844b1069c3f5d",
		  
		  "name": "Elliott",
		  "createdDate": "2024-07-01 18:07:57",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 248,
		  "totalCountries": 13,
		  "totalStates": 46,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1877,
		  "schedulePercent": 0.69039,
		  "totalGuests": 238,
		  "guestPercent": 0.617974,
		  "mostGuestDate": "2025-03-11 00:00:00",
		  "mostGuestName": "3 Arena",
		  "mostGuestCity": "Dublin 1",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d600d1c84c22d61629513c6eb3867d65",
		  
		  "name": "Josh",
		  "createdDate": "2022-02-16 16:09:45",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 522,
		  "totalCountries": 6,
		  "totalStates": 43,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1175,
		  "schedulePercent": 0.541025,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d606175caa0347413a82ef1401ce4a0c",
		  
		  "name": "Morgan",
		  "createdDate": "2023-08-30 21:39:27",
		  "totalOrganizations": 18,
		  "totalTours": 9,
		  "totalDays": 120,
		  "totalCountries": 4,
		  "totalStates": 26,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 464,
		  "schedulePercent": 0.296351,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Shoreline Waterfront",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d610cbb5152cfa908d71f063b9b37cf8",
		  
		  "name": "Charles",
		  "createdDate": "2022-12-23 17:43:13",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 630,
		  "totalCountries": 11,
		  "totalStates": 57,
		  "totalEvents": 342,
		  "eventPercent": 0.93767,
		  "totalScheduleItems": 3245,
		  "schedulePercent": 0.863441,
		  "totalGuests": 277,
		  "guestPercent": 0.638599,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Shubert Theatre",
		  "mostGuestCity": "New Haven",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d618158275c2dfd9af6b4a485fa6ae00",
		  
		  "name": "Todd",
		  "createdDate": "2017-08-22 16:31:19",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 738,
		  "totalCountries": 20,
		  "totalStates": 61,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 2463,
		  "schedulePercent": 0.782638,
		  "totalGuests": 765,
		  "guestPercent": 0.799637,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d61be3eca87a18abca50ddb19e87c6c3",
		  
		  "name": "Scott",
		  "createdDate": "2023-09-04 17:44:21",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 424,
		  "totalCountries": 11,
		  "totalStates": 46,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1709,
		  "schedulePercent": 0.660358,
		  "totalGuests": 800,
		  "guestPercent": 0.80757,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d62610f1f0400d69a9e8b0aaf022e636",
		  
		  "name": "Georgie",
		  "createdDate": "2023-09-11 21:36:50",
		  "totalOrganizations": 11,
		  "totalTours": 61,
		  "totalDays": 916,
		  "totalCountries": 24,
		  "totalStates": 60,
		  "totalEvents": 341,
		  "eventPercent": 0.936877,
		  "totalScheduleItems": 3212,
		  "schedulePercent": 0.861061,
		  "totalGuests": 1315,
		  "guestPercent": 0.888713,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6281a0d6f4262f6635a6459928a58b0",
		  
		  "name": "Cole",
		  "createdDate": "2025-04-02 17:20:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Brighton Music Hall",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6402bc813997d7136208ff32c82721a",
		  
		  "name": "Kenneth",
		  "createdDate": "2016-09-16 19:38:26",
		  "totalOrganizations": 8,
		  "totalTours": 18,
		  "totalDays": 333,
		  "totalCountries": 4,
		  "totalStates": 46,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 2547,
		  "schedulePercent": 0.791704,
		  "totalGuests": 1506,
		  "guestPercent": 0.909678,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6600e65b8bfb4596de9de1cfe3f24f1",
		  
		  "name": "Avery",
		  "createdDate": "2022-01-16 23:03:27",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 244,
		  "totalCountries": 5,
		  "totalStates": 39,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1031,
		  "schedulePercent": 0.499207,
		  "totalGuests": 1039,
		  "guestPercent": 0.852561,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d674eb2191e1a2248097fb92dfbb6277",
		  
		  "name": "Ian",
		  "createdDate": "2016-03-17 15:30:10",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 401,
		  "totalCountries": 18,
		  "totalStates": 36,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1296,
		  "schedulePercent": 0.57049,
		  "totalGuests": 308,
		  "guestPercent": 0.653105,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d680744bd684458a13720cb8337efc83",
		  
		  "name": "Ethan",
		  "createdDate": "2023-04-24 20:43:55",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 200,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 44,
		  "guestPercent": 0.44447,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Six String Grill & Stage",
		  "mostGuestCity": "Foxborough",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d689a422e360b0bac3e135a9601b02e2",
		  
		  "name": "Martin",
		  "createdDate": "2013-02-13 18:06:06",
		  "totalOrganizations": 32,
		  "totalTours": 18,
		  "totalDays": 433,
		  "totalCountries": 20,
		  "totalStates": 47,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 2257,
		  "schedulePercent": 0.75612,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Arbis",
		  "mostGuestCity": "NorrkÃ¶ping",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d68c260baa06464673f9e7b726896ffc",
		  
		  "name": "Robert",
		  "createdDate": "2025-08-28 01:56:22",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 135,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1594,
		  "schedulePercent": 0.639393,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d68faa0d40defedfeed32927343a2a1f",
		  
		  "name": "Shannon",
		  "createdDate": "2012-02-27 15:28:01",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 670,
		  "schedulePercent": 0.374773,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Americana Fest @ City Winery",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d699306e4f26a51ab5bdac63bddb45be",
		  
		  "name": "Kelsy",
		  "createdDate": "2024-01-13 22:00:27",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 431,
		  "totalCountries": 16,
		  "totalStates": 37,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 852,
		  "schedulePercent": 0.440843,
		  "totalGuests": 269,
		  "guestPercent": 0.63418,
		  "mostGuestDate": "2025-02-11 00:00:00",
		  "mostGuestName": "Exit/In",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d69fc32a5153c6373aa6dd31871cce19",
		  
		  "name": "Cynthia ",
		  "createdDate": "2014-04-16 22:55:59",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 368,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 269,
		  "schedulePercent": 0.198889,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-06-03 00:00:00",
		  "mostGuestName": "Webster Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6a62f8f2328b705882675334d83c5d2",
		  
		  "name": "Chopper",
		  "createdDate": "2013-05-21 17:43:04",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 504,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 731,
		  "schedulePercent": 0.398572,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6a6f5a429d6ae5ff875418f995cfdd7",
		  
		  "name": "Bonnie",
		  "createdDate": "2023-09-28 16:10:01",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 424,
		  "totalCountries": 8,
		  "totalStates": 20,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 658,
		  "schedulePercent": 0.370807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6b08af7b5898c14b491ec00afad1082",
		  
		  "name": "Annette",
		  "createdDate": "2015-10-20 09:22:19",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 373,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 350,
		  "eventPercent": 0.942316,
		  "totalScheduleItems": 1181,
		  "schedulePercent": 0.542611,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6b0c1ea607bbc12bb22bd827f9a167c",
		  
		  "name": "Dylan",
		  "createdDate": "2021-05-18 16:01:49",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 577,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1067,
		  "schedulePercent": 0.509406,
		  "totalGuests": 248,
		  "guestPercent": 0.624207,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "San Antonio Stock Show & Rodeo",
		  "mostGuestCity": "San Antonio",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6b17b06a908f25e9e82667923242e56",
		  
		  "name": "Eira",
		  "createdDate": "2025-03-03 10:10:12",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 33,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 127,
		  "schedulePercent": 0.116387,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6b7325c86797ca111ef45c243e4c090",
		  
		  "name": "toni",
		  "createdDate": "2014-11-22 16:41:21",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 193,
		  "totalCountries": 7,
		  "totalStates": 41,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1003,
		  "schedulePercent": 0.490934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6bb58521a0734531e54968c598ba1fa",
		  
		  "name": "Steph",
		  "createdDate": "2023-11-01 06:27:32",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 121,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 750,
		  "schedulePercent": 0.405032,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Margaret Court Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6bfe0126c1031e171fcccccd3470572",
		  
		  "name": "Charlotte",
		  "createdDate": "2021-09-21 17:22:35",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 401,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 537,
		  "schedulePercent": 0.329556,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6bff4e9416d5babb4f4dda0f2985a9e",
		  
		  "name": "Myah",
		  "createdDate": "2024-08-09 23:24:35",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 342,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 2314,
		  "schedulePercent": 0.763713,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Dodger Stadium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6cdf797689d0c5918a40429903543a8",
		  
		  "name": "Vittorio",
		  "createdDate": "2011-12-12 18:15:15",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 434,
		  "totalCountries": 22,
		  "totalStates": 42,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1162,
		  "schedulePercent": 0.538531,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6d4c5a440ff6e109f3aeedc35330ac7",
		  
		  "name": "Silvia ",
		  "createdDate": "2025-01-27 14:27:09",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 657,
		  "totalCountries": 15,
		  "totalStates": 48,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 2396,
		  "schedulePercent": 0.774592,
		  "totalGuests": 1979,
		  "guestPercent": 0.94617,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Kaseya Arena",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6d8b179047734a4ee02b86ea6633eae",
		  
		  "name": "Kim",
		  "createdDate": "2025-07-05 19:04:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 96,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 159,
		  "schedulePercent": 0.134519,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Golden Gate Park",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6db65f240bc039e93b6552748162c40",
		  
		  "name": "Emily",
		  "createdDate": "2022-08-17 00:41:23",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 347,
		  "schedulePercent": 0.2415,
		  "totalGuests": 808,
		  "guestPercent": 0.809723,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6f12fe13e44bd86e084e4888c7b6bb6",
		  
		  "name": "Poppy",
		  "createdDate": "2018-08-14 23:39:57",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 223,
		  "totalCountries": 23,
		  "totalStates": 63,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1887,
		  "schedulePercent": 0.692543,
		  "totalGuests": 1092,
		  "guestPercent": 0.862534,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d6f9e327a47d1077c83324801018703b",
		  
		  "name": "Jesse",
		  "createdDate": "2021-09-01 20:32:38",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 518,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 3781,
		  "schedulePercent": 0.901179,
		  "totalGuests": 3214,
		  "guestPercent": 0.985494,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d70f0e28898c07526399838f947d7068",
		  
		  "name": "Nadima",
		  "createdDate": "2017-03-24 13:15:48",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 441,
		  "totalCountries": 4,
		  "totalStates": 11,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 689,
		  "schedulePercent": 0.38214,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d710b15072f45a50fef356b072712038",
		  
		  "name": "Ryan",
		  "createdDate": "2019-02-26 03:52:28",
		  "totalOrganizations": 37,
		  "totalTours": 50,
		  "totalDays": 1646,
		  "totalCountries": 36,
		  "totalStates": 106,
		  "totalEvents": 483,
		  "eventPercent": 0.975861,
		  "totalScheduleItems": 4948,
		  "schedulePercent": 0.952516,
		  "totalGuests": 1595,
		  "guestPercent": 0.919084,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d711193e5d12eae3e37df76f953c4da8",
		  
		  "name": "Todd",
		  "createdDate": "2009-12-03 20:15:43",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 1003,
		  "schedulePercent": 0.490934,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d72159626168d9d4e42decb614ab1a63",
		  
		  "name": "Riku",
		  "createdDate": "2023-04-13 06:19:37",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 80,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 364,
		  "schedulePercent": 0.25,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Ruisrock",
		  "mostGuestCity": "Turku",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d72a09c39284590cc8a84ec93142a314",
		  
		  "name": "Simo",
		  "createdDate": "2019-05-20 10:08:17",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 378,
		  "totalCountries": 18,
		  "totalStates": 29,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1316,
		  "schedulePercent": 0.575249,
		  "totalGuests": 123,
		  "guestPercent": 0.539211,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Liberty Hall",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d736ff64dea1c390af68bac704dcc182",
		  
		  "name": "Mitchell",
		  "createdDate": "2016-02-19 23:19:17",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 1178,
		  "totalCountries": 28,
		  "totalStates": 99,
		  "totalEvents": 342,
		  "eventPercent": 0.93767,
		  "totalScheduleItems": 5266,
		  "schedulePercent": 0.961355,
		  "totalGuests": 2669,
		  "guestPercent": 0.974615,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d742458eb9e64253a2b64f258174c14a",
		  
		  "name": "Phil",
		  "createdDate": "2016-05-13 13:47:34",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1006,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 753,
		  "schedulePercent": 0.406505,
		  "totalGuests": 187,
		  "guestPercent": 0.584202,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "The Canyon Club",
		  "mostGuestCity": "Agoura Hills",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d7487876db890d3fd4a84c3345477ce5",
		  
		  "name": "Will",
		  "createdDate": "2021-07-26 15:41:02",
		  "totalOrganizations": 151,
		  "totalTours": 142,
		  "totalDays": 2252,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 845,
		  "eventPercent": 0.994107,
		  "totalScheduleItems": 8406,
		  "schedulePercent": 0.991387,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "The Core at Corby Cube",
		  "mostGuestCity": "Corby",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d775dd1505604c1984b07992fc95ec17",
		  
		  "name": "Clement",
		  "createdDate": "2021-10-29 13:08:06",
		  "totalOrganizations": 10,
		  "totalTours": 13,
		  "totalDays": 315,
		  "totalCountries": 23,
		  "totalStates": 69,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 2306,
		  "schedulePercent": 0.762353,
		  "totalGuests": 452,
		  "guestPercent": 0.713622,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d77683a0c3f58bcca1b01328f1eb2da3",
		  
		  "name": "Matt",
		  "createdDate": "2018-01-30 22:28:22",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 115,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 68,
		  "eventPercent": 0.416364,
		  "totalScheduleItems": 705,
		  "schedulePercent": 0.388599,
		  "totalGuests": 557,
		  "guestPercent": 0.74558,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The Fillmore Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d7a106ec90afb43f7fd760b41df36664",
		  
		  "name": "Luke",
		  "createdDate": "2015-10-13 02:06:54",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 1849,
		  "totalCountries": 17,
		  "totalStates": 71,
		  "totalEvents": 345,
		  "eventPercent": 0.939937,
		  "totalScheduleItems": 4675,
		  "schedulePercent": 0.943223,
		  "totalGuests": 2402,
		  "guestPercent": 0.965209,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d7a32d44c681e5e35b3e55726b60b02d",
		  
		  "name": "Steven",
		  "createdDate": "2024-09-24 22:48:29",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 527,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 295,
		  "schedulePercent": 0.215095,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d7db4c5a285ba4fb3ccf527074d1918d",
		  
		  "name": "Hayden",
		  "createdDate": "2019-09-10 03:01:46",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 113,
		  "schedulePercent": 0.106754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d7f278e221c586de4ad5a1cc3edc34c1",
		  
		  "name": "Jacob ",
		  "createdDate": "2023-09-21 19:02:50",
		  "totalOrganizations": 8,
		  "totalTours": 12,
		  "totalDays": 837,
		  "totalCountries": 17,
		  "totalStates": 47,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 1781,
		  "schedulePercent": 0.672711,
		  "totalGuests": 440,
		  "guestPercent": 0.709315,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "The Masquerade",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d7f88087a0917a6941cd2650477e7b82",
		  
		  "name": "Jani",
		  "createdDate": "2025-10-02 18:34:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 222,
		  "schedulePercent": 0.172597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d7f8f01999f881d005428d419aece2cb",
		  
		  "name": "Ryan",
		  "createdDate": "2010-01-29 22:50:35",
		  "totalOrganizations": 6,
		  "totalTours": 16,
		  "totalDays": 730,
		  "totalCountries": 22,
		  "totalStates": 49,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 2933,
		  "schedulePercent": 0.834995,
		  "totalGuests": 1435,
		  "guestPercent": 0.903445,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d800ed8b5c7fae06dfcc20cd81c71e36",
		  
		  "name": "Grant",
		  "createdDate": "2012-11-02 20:01:04",
		  "totalOrganizations": 20,
		  "totalTours": 19,
		  "totalDays": 597,
		  "totalCountries": 24,
		  "totalStates": 56,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 2185,
		  "schedulePercent": 0.74592,
		  "totalGuests": 916,
		  "guestPercent": 0.833522,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "The Torch",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d80332cf0f5623728215b493490d6ac8",
		  
		  "name": "Melissa",
		  "createdDate": "2023-09-11 15:30:43",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 336,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 1018,
		  "schedulePercent": 0.49592,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d805545b3514b377baac5ebf8d77cbd0",
		  
		  "name": "Holly",
		  "createdDate": "2024-05-14 18:01:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 43,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 212,
		  "schedulePercent": 0.166931,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Elsewhere",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d80aedc867d774da1668395ae32c52ef",
		  
		  "name": "Freya",
		  "createdDate": "2025-05-21 15:31:37",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 328,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1527,
		  "schedulePercent": 0.62262,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d80e1bf47eaa5be37775915ab0b63679",
		  
		  "name": "Kennedy",
		  "createdDate": "2022-10-24 15:43:57",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 2117,
		  "totalCountries": 17,
		  "totalStates": 77,
		  "totalEvents": 434,
		  "eventPercent": 0.967362,
		  "totalScheduleItems": 6179,
		  "schedulePercent": 0.978015,
		  "totalGuests": 2790,
		  "guestPercent": 0.977675,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8176e8ac63bd76fe185b91cd94a785a",
		  
		  "name": "Marcus ",
		  "createdDate": "2024-03-22 17:57:55",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 111,
		  "totalCountries": 17,
		  "totalStates": 45,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 811,
		  "schedulePercent": 0.427357,
		  "totalGuests": 373,
		  "guestPercent": 0.682457,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "The Van Buren",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8248a1c9fa93d1a9118508b4facfe0a",
		  
		  "name": "Camila",
		  "createdDate": "2025-02-12 23:12:57",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 102,
		  "totalCountries": 7,
		  "totalStates": 22,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 554,
		  "schedulePercent": 0.335109,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d830d8d06ad8e301ef8931ca6eedce97",
		  
		  "name": "Brendan",
		  "createdDate": "2017-01-30 06:31:00",
		  "totalOrganizations": 5,
		  "totalTours": 11,
		  "totalDays": 251,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1781,
		  "schedulePercent": 0.672711,
		  "totalGuests": 368,
		  "guestPercent": 0.680417,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "BOK Center",
		  "mostGuestCity": "Tulsa",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d83451c3366efca6b93617a47e74ee95",
		  
		  "name": "Oliver",
		  "createdDate": "2025-04-10 16:41:05",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 159,
		  "totalCountries": 13,
		  "totalStates": 26,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 598,
		  "schedulePercent": 0.350521,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d83c80d2e85d3bf82dfa15f26459d476",
		  
		  "name": "lindsay",
		  "createdDate": "2023-10-24 23:36:13",
		  "totalOrganizations": 17,
		  "totalTours": 22,
		  "totalDays": 1370,
		  "totalCountries": 26,
		  "totalStates": 94,
		  "totalEvents": 382,
		  "eventPercent": 0.953876,
		  "totalScheduleItems": 4437,
		  "schedulePercent": 0.936083,
		  "totalGuests": 2770,
		  "guestPercent": 0.977448,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "The Stone Pony Summer Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8416b99585c73cb8f307472155c6291",
		  
		  "name": "Peter",
		  "createdDate": "2021-10-11 18:24:17",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 214,
		  "schedulePercent": 0.168631,
		  "totalGuests": 289,
		  "guestPercent": 0.643699,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Fox Performing Arts Center",
		  "mostGuestCity": "Riverside",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d88bc9ecebee57d99ef7f1077aaedd3f",
		  
		  "name": "Jimi",
		  "createdDate": "2013-01-05 03:18:32",
		  "totalOrganizations": 21,
		  "totalTours": 13,
		  "totalDays": 2043,
		  "totalCountries": 27,
		  "totalStates": 61,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 4119,
		  "schedulePercent": 0.920331,
		  "totalGuests": 453,
		  "guestPercent": 0.713962,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Heaton Park",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d88cd435dd89d85cfb9363cbbd7642e9",
		  
		  "name": "Tamika",
		  "createdDate": "2023-02-08 18:22:08",
		  "totalOrganizations": 14,
		  "totalTours": 8,
		  "totalDays": 1239,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 4233,
		  "schedulePercent": 0.928264,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d890cef50d7b8be0f80dd15ebbd9bea5",
		  
		  "name": "Alex",
		  "createdDate": "2019-06-21 19:51:44",
		  "totalOrganizations": 15,
		  "totalTours": 22,
		  "totalDays": 690,
		  "totalCountries": 16,
		  "totalStates": 55,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 3766,
		  "schedulePercent": 0.900159,
		  "totalGuests": 2660,
		  "guestPercent": 0.974275,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d890fd7d93d308cba34ac663232f09ca",
		  
		  "name": "Maxime",
		  "createdDate": "2024-08-28 10:23:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 70,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 569,
		  "schedulePercent": 0.339869,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8a77c06a6f0858e3359ffdd711503ca",
		  
		  "name": "Beatriz",
		  "createdDate": "2022-07-27 21:00:25",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 276,
		  "totalCountries": 6,
		  "totalStates": 19,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 1864,
		  "schedulePercent": 0.687783,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8bd3df7319390ba8781ea3a6bd7f014",
		  
		  "name": "Travis",
		  "createdDate": "2018-07-31 17:20:10",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 1097,
		  "totalCountries": 17,
		  "totalStates": 63,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 3342,
		  "schedulePercent": 0.87024,
		  "totalGuests": 1847,
		  "guestPercent": 0.93597,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8bff2bafbe2bb9765f4096985a0a3ab",
		  
		  "name": "Bree",
		  "createdDate": "2021-09-07 01:01:00",
		  "totalOrganizations": 11,
		  "totalTours": 3,
		  "totalDays": 220,
		  "totalCountries": 11,
		  "totalStates": 49,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1118,
		  "schedulePercent": 0.524025,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-09-15 00:00:00",
		  "mostGuestName": "Les Etoiles",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8c260ad0a4482a82e142e85cbb8b1e8",
		  
		  "name": "Ally",
		  "createdDate": "2022-09-28 02:14:44",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 188,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 730,
		  "schedulePercent": 0.397892,
		  "totalGuests": 436,
		  "guestPercent": 0.707842,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Fox Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8c4967703313e9f390d74b5149f7da6",
		  
		  "name": "Star",
		  "createdDate": "2023-02-06 01:17:55",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 348,
		  "totalCountries": 7,
		  "totalStates": 27,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1229,
		  "schedulePercent": 0.554284,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8cee1921c6f6e43c9f257dc15c9709f",
		  
		  "name": "Cody",
		  "createdDate": "2022-09-05 22:52:47",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 156,
		  "totalCountries": 18,
		  "totalStates": 35,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 481,
		  "schedulePercent": 0.302697,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8cee6515535e77627247318432148f0",
		  
		  "name": "Carson",
		  "createdDate": "2023-04-18 20:47:00",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 1046,
		  "totalCountries": 26,
		  "totalStates": 63,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2720,
		  "schedulePercent": 0.812103,
		  "totalGuests": 425,
		  "guestPercent": 0.704442,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8d4cffcb12b8daf1d7d8e77ed6b5f18",
		  
		  "name": "Aaron",
		  "createdDate": "2016-09-01 18:27:58",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 697,
		  "totalCountries": 3,
		  "totalStates": 51,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 2953,
		  "schedulePercent": 0.837149,
		  "totalGuests": 2998,
		  "guestPercent": 0.981754,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8dfc9fe11d6e60c8af6a78120c680a8",
		  
		  "name": "Luke",
		  "createdDate": "2024-02-06 08:48:47",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 564,
		  "totalCountries": 5,
		  "totalStates": 40,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1659,
		  "schedulePercent": 0.651519,
		  "totalGuests": 196,
		  "guestPercent": 0.591568,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Echo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8e6347bbd8cc8a4f6015eed4d5fe22e",
		  
		  "name": "Garrett",
		  "createdDate": "2025-03-17 14:28:15",
		  "totalOrganizations": 4,
		  "totalTours": 15,
		  "totalDays": 122,
		  "totalCountries": 2,
		  "totalStates": 14,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 426,
		  "schedulePercent": 0.280598,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8e7c7f192c5c106276b19f220e78897",
		  
		  "name": "Petri",
		  "createdDate": "2022-07-07 19:42:17",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 69,
		  "totalCountries": 18,
		  "totalStates": 2,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 915,
		  "schedulePercent": 0.463055,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-04-22 00:00:00",
		  "mostGuestName": "B72",
		  "mostGuestCity": "Wien",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8e8a6131e66b93b1a0a080b43fab727",
		  
		  "name": "Josh",
		  "createdDate": "2019-02-21 16:59:44",
		  "totalOrganizations": 11,
		  "totalTours": 29,
		  "totalDays": 899,
		  "totalCountries": 16,
		  "totalStates": 64,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 5496,
		  "schedulePercent": 0.967475,
		  "totalGuests": 1340,
		  "guestPercent": 0.891999,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Yuengling Center",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8e9346dd4557771fead2d8642e25113",
		  
		  "name": "Andrew",
		  "createdDate": "2017-01-16 23:18:05",
		  "totalOrganizations": 14,
		  "totalTours": 5,
		  "totalDays": 401,
		  "totalCountries": 10,
		  "totalStates": 41,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1208,
		  "schedulePercent": 0.548844,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-05-05 00:00:00",
		  "mostGuestName": "GRAMMY Museum at L.A. LIVE",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d8eb90d89fd0dc0004b682d632de0eaa",
		  
		  "name": "Terrance",
		  "createdDate": "2019-08-22 22:33:34",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1122,
		  "schedulePercent": 0.525499,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "The Windjammer",
		  "mostGuestCity": "Isle of Palms",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d903b4fabef6e8e42f0270e5da8c80bb",
		  
		  "name": "Chris",
		  "createdDate": "2012-07-13 17:31:30",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 361,
		  "totalCountries": 2,
		  "totalStates": 35,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 977,
		  "schedulePercent": 0.483568,
		  "totalGuests": 1510,
		  "guestPercent": 0.910358,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Moody Amphitheater",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 157,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d908229696cb1288a91d3c29afb94080",
		  
		  "name": "Katherine",
		  "createdDate": "2018-09-21 05:15:23",
		  "totalOrganizations": 5,
		  "totalTours": 28,
		  "totalDays": 1244,
		  "totalCountries": 18,
		  "totalStates": 67,
		  "totalEvents": 555,
		  "eventPercent": 0.984474,
		  "totalScheduleItems": 8600,
		  "schedulePercent": 0.992067,
		  "totalGuests": 3386,
		  "guestPercent": 0.988441,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d908442dbcdeaedc877823cb091d5fe3",
		  
		  "name": "Robert",
		  "createdDate": "2022-03-12 17:48:19",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 207,
		  "totalCountries": 12,
		  "totalStates": 36,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1106,
		  "schedulePercent": 0.520286,
		  "totalGuests": 732,
		  "guestPercent": 0.792838,
		  "mostGuestDate": "2025-05-20 00:00:00",
		  "mostGuestName": "place bell",
		  "mostGuestCity": "Laval",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d91974fd6cda41c44c1f7e3e9ce571ae",
		  
		  "name": "Clare",
		  "createdDate": "2023-09-01 03:26:14",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 503,
		  "totalCountries": 23,
		  "totalStates": 72,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 4312,
		  "schedulePercent": 0.931324,
		  "totalGuests": 584,
		  "guestPercent": 0.75442,
		  "mostGuestDate": "2025-10-26 00:00:00",
		  "mostGuestName": "Revolution Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d91b534fa0474947d68b6d3e8f232847",
		  
		  "name": "Joel",
		  "createdDate": "2019-06-13 01:49:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 167,
		  "totalCountries": 8,
		  "totalStates": 11,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 131,
		  "schedulePercent": 0.119334,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d91fe7115f6b2c9dbab3bdcfc1114777",
		  
		  "name": "Miriam",
		  "createdDate": "2021-09-17 12:22:14",
		  "totalOrganizations": 43,
		  "totalTours": 13,
		  "totalDays": 552,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 507,
		  "eventPercent": 0.980168,
		  "totalScheduleItems": 2930,
		  "schedulePercent": 0.834655,
		  "totalGuests": 6189,
		  "guestPercent": 0.998413,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 675,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d92def837ee053db380b9aa41d0789dc",
		  
		  "name": "Brenda",
		  "createdDate": "2022-06-18 20:58:33",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 238,
		  "totalCountries": 19,
		  "totalStates": 46,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 980,
		  "schedulePercent": 0.484587,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Night Club 101",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d92f6d8e58597f94aebc963c5215567d",
		  
		  "name": "Lee",
		  "createdDate": "2021-06-30 00:10:04",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 602,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 314,
		  "schedulePercent": 0.224388,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d939301e5e9f44da5938ec93511fe82c",
		  
		  "name": "Matthieu",
		  "createdDate": "2018-05-21 09:15:51",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 2285,
		  "totalCountries": 12,
		  "totalStates": 19,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1638,
		  "schedulePercent": 0.647325,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-06-30 00:00:00",
		  "mostGuestName": "Jazz in Vienna",
		  "mostGuestCity": "Vienne",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d93c7a4c8bbf858ef502a5892791f2c8",
		  
		  "name": "Kevin",
		  "createdDate": "2024-01-31 22:01:46",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 467,
		  "totalCountries": 17,
		  "totalStates": 46,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1370,
		  "schedulePercent": 0.589415,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d95d1d5c098a019213f0f69103dd2c04",
		  
		  "name": "Coby",
		  "createdDate": "2022-03-18 20:06:05",
		  "totalOrganizations": 5,
		  "totalTours": 17,
		  "totalDays": 385,
		  "totalCountries": 6,
		  "totalStates": 48,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 1912,
		  "schedulePercent": 0.696963,
		  "totalGuests": 386,
		  "guestPercent": 0.688463,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Moody Center",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d969ce73583e10c5a20653bdc22f8ea2",
		  
		  "name": "Ella",
		  "createdDate": "2021-11-02 14:10:59",
		  "totalOrganizations": 15,
		  "totalTours": 6,
		  "totalDays": 149,
		  "totalCountries": 20,
		  "totalStates": 34,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1336,
		  "schedulePercent": 0.582389,
		  "totalGuests": 974,
		  "guestPercent": 0.841568,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d97252ec0be1f00b0ab0e2bfd7e5a623",
		  
		  "name": "Mel",
		  "createdDate": "2024-11-12 23:40:44",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 154,
		  "totalCountries": 9,
		  "totalStates": 12,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 382,
		  "schedulePercent": 0.259406,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d97ee42f37d2f61c32c16c130a14b618",
		  
		  "name": "Amber",
		  "createdDate": "2023-11-15 21:05:59",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 603,
		  "totalCountries": 20,
		  "totalStates": 56,
		  "totalEvents": 200,
		  "eventPercent": 0.800771,
		  "totalScheduleItems": 2980,
		  "schedulePercent": 0.840662,
		  "totalGuests": 1280,
		  "guestPercent": 0.883273,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d97fdf1f5ab6a5fd6df66e1407d9fc98",
		  
		  "name": "Adam",
		  "createdDate": "2011-05-26 03:21:47",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 761,
		  "totalCountries": 12,
		  "totalStates": 49,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1422,
		  "schedulePercent": 0.602561,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9839d70bfa9eaa7303d5225979f2215",
		  
		  "name": "Alex",
		  "createdDate": "2018-09-20 15:52:52",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 1128,
		  "totalCountries": 5,
		  "totalStates": 49,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 3876,
		  "schedulePercent": 0.906732,
		  "totalGuests": 871,
		  "guestPercent": 0.823323,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Knoxville Civic Auditorium and Coliseum",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d985f5b92e894857465def9803af65ff",
		  
		  "name": "Marcella",
		  "createdDate": "2025-04-05 03:42:46",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 193,
		  "totalCountries": 14,
		  "totalStates": 38,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1808,
		  "schedulePercent": 0.677584,
		  "totalGuests": 1574,
		  "guestPercent": 0.916818,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d98e8a94f61aab03725b1d1f0470af31",
		  
		  "name": "Roxanne",
		  "createdDate": "2023-04-20 15:26:29",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 476,
		  "totalCountries": 12,
		  "totalStates": 41,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1048,
		  "schedulePercent": 0.503853,
		  "totalGuests": 136,
		  "guestPercent": 0.549524,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Sultan Room",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9a14da066899cb1eaf37b4dbd5d8b8c",
		  
		  "name": "Cary",
		  "createdDate": "2024-06-17 17:27:04",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 196,
		  "totalCountries": 16,
		  "totalStates": 47,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 821,
		  "schedulePercent": 0.431324,
		  "totalGuests": 170,
		  "guestPercent": 0.574003,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9a15d68a104ccbc2a8cabdf1cd65e19",
		  
		  "name": "Moonshine",
		  "createdDate": "2017-09-09 21:47:32",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 316,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 414,
		  "schedulePercent": 0.275612,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9a4c5ecf1764280ce9aec16279fe42b",
		  
		  "name": "Marko ",
		  "createdDate": "2015-11-29 16:36:14",
		  "totalOrganizations": 12,
		  "totalTours": 22,
		  "totalDays": 496,
		  "totalCountries": 24,
		  "totalStates": 26,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 1419,
		  "schedulePercent": 0.602221,
		  "totalGuests": 235,
		  "guestPercent": 0.616047,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "NORDIS LIVE",
		  "mostGuestCity": "HELSINKI",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9aa02f698a3dba7b350f2fdba0547c3",
		  
		  "name": "Stephen",
		  "createdDate": "2014-02-23 20:40:13",
		  "totalOrganizations": 23,
		  "totalTours": 20,
		  "totalDays": 1808,
		  "totalCountries": 48,
		  "totalStates": 86,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 3553,
		  "schedulePercent": 0.884973,
		  "totalGuests": 285,
		  "guestPercent": 0.641999,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Warfield",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9b2d2cddacd668df10a36efa80c6a5a",
		  
		  "name": "Matt",
		  "createdDate": "2018-01-30 17:37:27",
		  "totalOrganizations": 10,
		  "totalTours": 16,
		  "totalDays": 2265,
		  "totalCountries": 7,
		  "totalStates": 61,
		  "totalEvents": 482,
		  "eventPercent": 0.975635,
		  "totalScheduleItems": 6310,
		  "schedulePercent": 0.979488,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Society Garden Macon",
		  "mostGuestCity": "Macon",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9b52305a43182b7f8945ea9c61921aa",
		  
		  "name": "Rubes",
		  "createdDate": "2013-09-23 01:17:41",
		  "totalOrganizations": 20,
		  "totalTours": 16,
		  "totalDays": 1242,
		  "totalCountries": 22,
		  "totalStates": 59,
		  "totalEvents": 245,
		  "eventPercent": 0.866047,
		  "totalScheduleItems": 4495,
		  "schedulePercent": 0.937897,
		  "totalGuests": 1694,
		  "guestPercent": 0.927924,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9bfdc8410e9d4966a84af0b5c00b262",
		  
		  "name": "Andrea",
		  "createdDate": "2016-01-28 16:13:31",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 692,
		  "totalCountries": 12,
		  "totalStates": 37,
		  "totalEvents": 162,
		  "eventPercent": 0.731754,
		  "totalScheduleItems": 2575,
		  "schedulePercent": 0.795558,
		  "totalGuests": 441,
		  "guestPercent": 0.709769,
		  "mostGuestDate": "2025-07-30 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 188,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9cd7d460d5341dec31c2717d6b2ac33",
		  
		  "name": "Justin",
		  "createdDate": "2016-06-26 04:38:35",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 23,
		  "totalStates": 57,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 3361,
		  "schedulePercent": 0.871827,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9e3db1ad4cc656e67a6e06150309884",
		  
		  "name": "Mike",
		  "createdDate": "2014-04-05 03:58:54",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 1101,
		  "totalCountries": 13,
		  "totalStates": 57,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 3494,
		  "schedulePercent": 0.882026,
		  "totalGuests": 1553,
		  "guestPercent": 0.915345,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9f3f158be2b545ef6fe02b7b94876c4",
		  
		  "name": "Lawson",
		  "createdDate": "2024-07-15 21:39:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 3,
		  "totalStates": 47,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1229,
		  "schedulePercent": 0.554284,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Ford Amphitheater",
		  "mostGuestCity": "Colorado Springs",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "d9fbb2f7c4381652a2d2fe56481a04ed",
		  
		  "name": "Eric",
		  "createdDate": "2013-05-05 20:04:35",
		  "totalOrganizations": 19,
		  "totalTours": 7,
		  "totalDays": 373,
		  "totalCountries": 16,
		  "totalStates": 48,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1524,
		  "schedulePercent": 0.622507,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-06-10 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da353b91a92d3b3fdb1d5202cfed8734",
		  
		  "name": "Melvin",
		  "createdDate": "2016-12-14 00:24:18",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 220,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 756,
		  "schedulePercent": 0.407978,
		  "totalGuests": 168,
		  "guestPercent": 0.572303,
		  "mostGuestDate": "2025-10-07 00:00:00",
		  "mostGuestName": "Neighborhood Theatre",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da406d9ca2ea37103899fe7942a542e4",
		  
		  "name": "Katie",
		  "createdDate": "2012-06-16 17:49:09",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 1323,
		  "totalCountries": 17,
		  "totalStates": 20,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1456,
		  "schedulePercent": 0.608454,
		  "totalGuests": 318,
		  "guestPercent": 0.658772,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Sphere",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da42f6c54d5f710487942f644e93c159",
		  
		  "name": "Edgar",
		  "createdDate": "2019-06-03 23:05:56",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 80,
		  "totalCountries": 7,
		  "totalStates": 27,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 442,
		  "schedulePercent": 0.287738,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da4789799f20ea23cfb21b9764029a4c",
		  
		  "name": "anisia",
		  "createdDate": "2023-08-15 18:51:48",
		  "totalOrganizations": 36,
		  "totalTours": 35,
		  "totalDays": 674,
		  "totalCountries": 4,
		  "totalStates": 73,
		  "totalEvents": 618,
		  "eventPercent": 0.988554,
		  "totalScheduleItems": 2438,
		  "schedulePercent": 0.779352,
		  "totalGuests": 141,
		  "guestPercent": 0.55315,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Tampereen tavara-asema",
		  "mostGuestCity": "Tampere",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da4a8eb97fd75973621da4a4039961f2",
		  
		  "name": "Adriane",
		  "createdDate": "2012-09-07 20:17:34",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 932,
		  "schedulePercent": 0.470082,
		  "totalGuests": 203,
		  "guestPercent": 0.596895,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da4ad653fe38909d93f6cdf95cede73f",
		  
		  "name": "KC",
		  "createdDate": "2016-09-04 19:13:42",
		  "totalOrganizations": 14,
		  "totalTours": 7,
		  "totalDays": 955,
		  "totalCountries": 8,
		  "totalStates": 33,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 807,
		  "schedulePercent": 0.425657,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da4e327a01a5bbe7b4c18d94921ae501",
		  
		  "name": "James",
		  "createdDate": "2023-11-01 21:08:47",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 233,
		  "totalCountries": 22,
		  "totalStates": 25,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1192,
		  "schedulePercent": 0.545444,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da4e8b8ed182c91edf1a1525a933bcc9",
		  
		  "name": "Ross",
		  "createdDate": "2025-07-02 10:51:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 108,
		  "schedulePercent": 0.103921,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da52e06608f07a7fe6e589308433de67",
		  
		  "name": "Joshua",
		  "createdDate": "2017-06-10 05:57:20",
		  "totalOrganizations": 11,
		  "totalTours": 1,
		  "totalDays": 73,
		  "totalCountries": 14,
		  "totalStates": 12,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 184,
		  "schedulePercent": 0.150272,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Creamfields Festival",
		  "mostGuestCity": "Daresbury",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da6cced16c10f3717606806d71d3b272",
		  
		  "name": "Russ",
		  "createdDate": "2023-12-16 05:16:37",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 314,
		  "totalCountries": 12,
		  "totalStates": 28,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 477,
		  "schedulePercent": 0.301677,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da6cd7890e5104c465c830655f66f586",
		  
		  "name": "Aim&#233;e",
		  "createdDate": "2025-08-19 17:37:08",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 128,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 720,
		  "guestPercent": 0.790458,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da70b90bb62e42a70b7d7fe152840901",
		  
		  "name": "Jason",
		  "createdDate": "2019-10-28 03:00:01",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 875,
		  "totalCountries": 30,
		  "totalStates": 66,
		  "totalEvents": 199,
		  "eventPercent": 0.799411,
		  "totalScheduleItems": 3357,
		  "schedulePercent": 0.871487,
		  "totalGuests": 503,
		  "guestPercent": 0.731528,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da7337692ab6bc839a90565e6a0c5c1d",
		  
		  "name": "Stuart",
		  "createdDate": "2011-07-26 23:29:31",
		  "totalOrganizations": 35,
		  "totalTours": 25,
		  "totalDays": 3159,
		  "totalCountries": 39,
		  "totalStates": 96,
		  "totalEvents": 317,
		  "eventPercent": 0.923617,
		  "totalScheduleItems": 4215,
		  "schedulePercent": 0.926904,
		  "totalGuests": 181,
		  "guestPercent": 0.580802,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "Huxleys Neue Welt",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "da8088b4484c8ed1787c3e7347491711",
		  
		  "name": "Simon",
		  "createdDate": "2017-07-20 17:09:40",
		  "totalOrganizations": 21,
		  "totalTours": 4,
		  "totalDays": 314,
		  "totalCountries": 15,
		  "totalStates": 22,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 748,
		  "schedulePercent": 0.404125,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "daa2def24e7163577619ffca54472a93",
		  
		  "name": "Daniel",
		  "createdDate": "2025-10-27 19:26:19",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 37,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 491,
		  "schedulePercent": 0.30791,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "daa7dfc44fe88785e09d33e8b1e44a58",
		  
		  "name": "Juliette",
		  "createdDate": "2024-04-24 03:26:28",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 282,
		  "totalCountries": 7,
		  "totalStates": 23,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 392,
		  "schedulePercent": 0.265866,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dabb609c2cf48388ba5aeb9555fa7963",
		  
		  "name": "Scott",
		  "createdDate": "2016-01-03 10:57:30",
		  "totalOrganizations": 91,
		  "totalTours": 16,
		  "totalDays": 1207,
		  "totalCountries": 30,
		  "totalStates": 31,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2806,
		  "schedulePercent": 0.823209,
		  "totalGuests": 131,
		  "guestPercent": 0.545444,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dabd9024138aa75828d6b204727baeef",
		  
		  "name": "talayeh",
		  "createdDate": "2019-06-08 03:37:37",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 922,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 160,
		  "eventPercent": 0.727108,
		  "totalScheduleItems": 2200,
		  "schedulePercent": 0.747847,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dac8621b6c9e3ad8559039f017668a7f",
		  
		  "name": "Joanne",
		  "createdDate": "2025-02-28 04:53:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 128,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 538,
		  "schedulePercent": 0.329782,
		  "totalGuests": 268,
		  "guestPercent": 0.6335,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The Glasgow Royal Concert Hall",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dad0ab54dad8f345f46278183a40fab3",
		  
		  "name": "Alonzo",
		  "createdDate": "2010-09-24 06:02:16",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 101,
		  "totalCountries": 2,
		  "totalStates": 24,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 1147,
		  "schedulePercent": 0.533545,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dae839bbdb0c0ea83b3d50d6318fbc4c",
		  
		  "name": "Gareth",
		  "createdDate": "2013-12-10 04:14:07",
		  "totalOrganizations": 9,
		  "totalTours": 22,
		  "totalDays": 727,
		  "totalCountries": 26,
		  "totalStates": 44,
		  "totalEvents": 250,
		  "eventPercent": 0.87092,
		  "totalScheduleItems": 3658,
		  "schedulePercent": 0.893472,
		  "totalGuests": 552,
		  "guestPercent": 0.744674,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db035802d7315320b206389a25ae148a",
		  
		  "name": "Travis",
		  "createdDate": "2012-03-24 03:13:23",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 422,
		  "totalCountries": 8,
		  "totalStates": 42,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 1686,
		  "schedulePercent": 0.656052,
		  "totalGuests": 155,
		  "guestPercent": 0.562557,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "San Jose Civic Auditorium",
		  "mostGuestCity": "San Jose",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db07f55ee506d4f425c672551dc58845",
		  
		  "name": "Klas",
		  "createdDate": "2025-08-13 16:26:25",
		  "totalOrganizations": 19,
		  "totalTours": 6,
		  "totalDays": 97,
		  "totalCountries": 12,
		  "totalStates": 32,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 813,
		  "schedulePercent": 0.428151,
		  "totalGuests": 580,
		  "guestPercent": 0.752607,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db10bead880c1f12430264dcbfb00aec",
		  
		  "name": "Shaun",
		  "createdDate": "2015-09-18 12:11:12",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 59,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 455,
		  "schedulePercent": 0.292611,
		  "totalGuests": 491,
		  "guestPercent": 0.727788,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "OVO Arena, Wembley",
		  "mostGuestCity": "Wembley",
		  "mostGuestAmount": 128,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db126cd5d0e4d5fbde333bb9fe1a671a",
		  
		  "name": "John",
		  "createdDate": "2023-02-06 01:59:32",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 569,
		  "totalCountries": 2,
		  "totalStates": 33,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 576,
		  "schedulePercent": 0.342022,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "PBR Baltimore: A Coors Banquet Bar",
		  "mostGuestCity": "Baltimore",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db1ac8918f75709c2ab84c0540829fb8",
		  
		  "name": "Caroline",
		  "createdDate": "2024-02-26 21:47:08",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 1222,
		  "totalCountries": 18,
		  "totalStates": 44,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 3031,
		  "schedulePercent": 0.845195,
		  "totalGuests": 318,
		  "guestPercent": 0.658772,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Sphere",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db2a427412c1d2055c4ca08cca93b6c8",
		  
		  "name": "Emily",
		  "createdDate": "2022-05-06 15:21:16",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 54,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 409,
		  "schedulePercent": 0.273459,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db2cdbc7aa4f61856aeaec831804647d",
		  
		  "name": "Cait ",
		  "createdDate": "2021-06-21 17:58:21",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 1593,
		  "totalCountries": 20,
		  "totalStates": 53,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 1682,
		  "schedulePercent": 0.655032,
		  "totalGuests": 836,
		  "guestPercent": 0.816863,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Footprint Center",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db3c3d52ebaa9db219e21aacc0658823",
		  
		  "name": "Jacob",
		  "createdDate": "2022-04-24 17:17:03",
		  "totalOrganizations": 12,
		  "totalTours": 9,
		  "totalDays": 1563,
		  "totalCountries": 4,
		  "totalStates": 51,
		  "totalEvents": 428,
		  "eventPercent": 0.964982,
		  "totalScheduleItems": 4714,
		  "schedulePercent": 0.94481,
		  "totalGuests": 1953,
		  "guestPercent": 0.94345,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db3f42af1bdfc0919e9e13738f0699aa",
		  
		  "name": "Gully Boys",
		  "createdDate": "2023-07-09 06:14:29",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 273,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 748,
		  "schedulePercent": 0.404125,
		  "totalGuests": 132,
		  "guestPercent": 0.546124,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Mercury Lounge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db4f01b4da5be64dbf897c5a3c24078d",
		  
		  "name": "Ash",
		  "createdDate": "2025-08-21 15:21:27",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 47,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db5c08dafe0e6799ba70e7fc2cbd997d",
		  
		  "name": "Craig",
		  "createdDate": "2014-06-27 18:02:00",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 593,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 1849,
		  "schedulePercent": 0.685743,
		  "totalGuests": 289,
		  "guestPercent": 0.643699,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Branded Theater",
		  "mostGuestCity": "Richmond",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db63d74cf955c2a4f3a91a81caeb36d5",
		  
		  "name": "Jonny",
		  "createdDate": "2015-11-30 20:10:30",
		  "totalOrganizations": 61,
		  "totalTours": 13,
		  "totalDays": 867,
		  "totalCountries": 15,
		  "totalStates": 56,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 3132,
		  "schedulePercent": 0.854034,
		  "totalGuests": 445,
		  "guestPercent": 0.710675,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db65e86eb8e2efcd38d967ef53b652be",
		  
		  "name": "Zach",
		  "createdDate": "2022-09-13 17:37:51",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 360,
		  "totalCountries": 18,
		  "totalStates": 77,
		  "totalEvents": 234,
		  "eventPercent": 0.853241,
		  "totalScheduleItems": 2415,
		  "schedulePercent": 0.776745,
		  "totalGuests": 659,
		  "guestPercent": 0.773572,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db6dde19754853654990e735b658435a",
		  
		  "name": "Tamara",
		  "createdDate": "2025-06-04 14:22:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 11,
		  "totalStates": 22,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 179,
		  "schedulePercent": 0.145852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db75c9176f20a0fdf70b094d757e84e8",
		  
		  "name": "Drew",
		  "createdDate": "2014-11-19 17:50:04",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 68,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 333,
		  "schedulePercent": 0.233454,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "The Palace Theatre",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db7809e82d6f2c6bc292f15589ec5236",
		  
		  "name": "Adrian",
		  "createdDate": "2021-05-21 04:06:32",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 167,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1486,
		  "schedulePercent": 0.615027,
		  "totalGuests": 930,
		  "guestPercent": 0.835675,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 184,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db7b1742158eaef1409736b1fdf256c9",
		  
		  "name": "George",
		  "createdDate": "2022-01-29 16:31:54",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 500,
		  "totalCountries": 22,
		  "totalStates": 41,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 2605,
		  "schedulePercent": 0.798277,
		  "totalGuests": 670,
		  "guestPercent": 0.777879,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db8ad85b556aea74e1d5d5e88753510a",
		  
		  "name": "Jayde",
		  "createdDate": "2018-09-10 23:17:50",
		  "totalOrganizations": 13,
		  "totalTours": 13,
		  "totalDays": 659,
		  "totalCountries": 9,
		  "totalStates": 45,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1575,
		  "schedulePercent": 0.635993,
		  "totalGuests": 780,
		  "guestPercent": 0.80315,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "db9df23c47aa0585ba59412f136405cf",
		  
		  "name": "Tamir",
		  "createdDate": "2016-05-29 05:23:55",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 220,
		  "totalCountries": 16,
		  "totalStates": 34,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1030,
		  "schedulePercent": 0.498753,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Viejas Arena",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dba10c03cad56702b19997d6a43ca558",
		  
		  "name": "William",
		  "createdDate": "2022-04-10 11:29:42",
		  "totalOrganizations": 16,
		  "totalTours": 6,
		  "totalDays": 776,
		  "totalCountries": 19,
		  "totalStates": 46,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 2022,
		  "schedulePercent": 0.717588,
		  "totalGuests": 432,
		  "guestPercent": 0.706936,
		  "mostGuestDate": "2025-04-07 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dba41b88eb37187342071bec3748743e",
		  
		  "name": "Ty",
		  "createdDate": "2025-05-30 19:21:00",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 160,
		  "totalCountries": 10,
		  "totalStates": 23,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 581,
		  "schedulePercent": 0.344402,
		  "totalGuests": 422,
		  "guestPercent": 0.703536,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dba7a772c28f3fbe5ff7d747e1642c80",
		  
		  "name": "Jeff",
		  "createdDate": "2016-03-18 21:31:25",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 2379,
		  "schedulePercent": 0.772552,
		  "totalGuests": 1761,
		  "guestPercent": 0.93087,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dba8b10b5e4143eb2f3b8f46d8cc1d15",
		  
		  "name": "Daniel",
		  "createdDate": "2011-07-07 16:55:07",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 888,
		  "totalCountries": 17,
		  "totalStates": 59,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 3408,
		  "schedulePercent": 0.876247,
		  "totalGuests": 2119,
		  "guestPercent": 0.954896,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Blossom Music Center",
		  "mostGuestCity": "Cuyahoga Falls",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbaa165174764d52d89603b8b3d2dc64",
		  
		  "name": "Diaz",
		  "createdDate": "2024-09-18 19:04:36",
		  "totalOrganizations": 1,
		  "totalTours": 48,
		  "totalDays": 152,
		  "totalCountries": 14,
		  "totalStates": 21,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 266,
		  "schedulePercent": 0.197076,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbac6eac984577f7ecbe788c53086f50",
		  
		  "name": "Pete",
		  "createdDate": "2016-12-01 02:14:58",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 201,
		  "totalCountries": 27,
		  "totalStates": 36,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 1535,
		  "schedulePercent": 0.62432,
		  "totalGuests": 866,
		  "guestPercent": 0.822303,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbbe89325546801696a17650f01d5537",
		  
		  "name": "Timothy",
		  "createdDate": "2011-09-22 20:20:50",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 727,
		  "totalCountries": 12,
		  "totalStates": 54,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 3199,
		  "schedulePercent": 0.859814,
		  "totalGuests": 2848,
		  "guestPercent": 0.979034,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbcc16de469170f3dc4b3ff687ff6317",
		  
		  "name": "Steve",
		  "createdDate": "2014-10-14 15:42:49",
		  "totalOrganizations": 6,
		  "totalTours": 33,
		  "totalDays": 273,
		  "totalCountries": 11,
		  "totalStates": 34,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 774,
		  "schedulePercent": 0.414211,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "eTown Hall",
		  "mostGuestCity": "Boulder",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbd0a99a68957f62c62f591510438051",
		  
		  "name": "Dustin",
		  "createdDate": "2016-08-11 19:41:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 147,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 434,
		  "schedulePercent": 0.283205,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-05-29 00:00:00",
		  "mostGuestName": "The Majestic theater",
		  "mostGuestCity": "Madison",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbd253565176b3fa74fef45658cc9323",
		  
		  "name": "Weston",
		  "createdDate": "2014-10-26 15:59:12",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 554,
		  "totalCountries": 31,
		  "totalStates": 88,
		  "totalEvents": 288,
		  "eventPercent": 0.904465,
		  "totalScheduleItems": 3331,
		  "schedulePercent": 0.869447,
		  "totalGuests": 1428,
		  "guestPercent": 0.903105,
		  "mostGuestDate": "2025-04-15 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbd3b19565665a93f93249832fbe6ec2",
		  
		  "name": "Taylor",
		  "createdDate": "2023-01-17 23:03:44",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 5,
		  "totalStates": 39,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1682,
		  "schedulePercent": 0.655032,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Pier Six Pavilion",
		  "mostGuestCity": "Baltimore",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbd3fac439215080ddf1b13a48bd3ec6",
		  
		  "name": "Line ",
		  "createdDate": "2023-06-15 09:11:59",
		  "totalOrganizations": 29,
		  "totalTours": 26,
		  "totalDays": 576,
		  "totalCountries": 9,
		  "totalStates": 6,
		  "totalEvents": 563,
		  "eventPercent": 0.985154,
		  "totalScheduleItems": 2793,
		  "schedulePercent": 0.821283,
		  "totalGuests": 156,
		  "guestPercent": 0.563577,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Tivoli",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbd91d7a0b04689b69df93e2be782794",
		  
		  "name": "Jeremy",
		  "createdDate": "2021-07-21 02:18:55",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 88,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 575,
		  "schedulePercent": 0.341455,
		  "totalGuests": 67,
		  "guestPercent": 0.480734,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Ridgefield Playhouse",
		  "mostGuestCity": "Ridgefield",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbdeae837830276132ac2f7bd0088290",
		  
		  "name": "Brent",
		  "createdDate": "2018-09-10 15:14:06",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 536,
		  "totalCountries": 15,
		  "totalStates": 45,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1869,
		  "schedulePercent": 0.68903,
		  "totalGuests": 891,
		  "guestPercent": 0.827743,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbf3f00596a9495ce1a3ab5bdd670094",
		  
		  "name": "Richard",
		  "createdDate": "2018-09-27 21:06:16",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 488,
		  "totalCountries": 27,
		  "totalStates": 34,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1968,
		  "schedulePercent": 0.707616,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dbfb16b8c2496457eee343ad944975a8",
		  
		  "name": "Daniella",
		  "createdDate": "2024-06-21 11:44:42",
		  "totalOrganizations": 12,
		  "totalTours": 15,
		  "totalDays": 3444,
		  "totalCountries": 32,
		  "totalStates": 81,
		  "totalEvents": 328,
		  "eventPercent": 0.932004,
		  "totalScheduleItems": 5538,
		  "schedulePercent": 0.968268,
		  "totalGuests": 1993,
		  "guestPercent": 0.946736,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc05e837514f22fe76fa6d95a229f844",
		  
		  "name": "Rachael",
		  "createdDate": "2023-10-09 02:22:38",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 111,
		  "totalCountries": 12,
		  "totalStates": 26,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 454,
		  "schedulePercent": 0.292384,
		  "totalGuests": 430,
		  "guestPercent": 0.706482,
		  "mostGuestDate": "2025-01-16 00:00:00",
		  "mostGuestName": "Place des Arts Salle Wilfrid-Pelletier",
		  "mostGuestCity": "Montreal",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc0e837cfb374bf097b0f23be0861076",
		  
		  "name": "Eric",
		  "createdDate": "2025-04-01 17:24:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 36,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 190,
		  "schedulePercent": 0.153105,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Watson Lake Park",
		  "mostGuestCity": "Prescott",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc160e892545ce036449b9d6e6df2a66",
		  
		  "name": "Michael ",
		  "createdDate": "2016-05-26 16:27:19",
		  "totalOrganizations": 21,
		  "totalTours": 33,
		  "totalDays": 607,
		  "totalCountries": 28,
		  "totalStates": 83,
		  "totalEvents": 311,
		  "eventPercent": 0.919878,
		  "totalScheduleItems": 4209,
		  "schedulePercent": 0.926337,
		  "totalGuests": 3902,
		  "guestPercent": 0.99252,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc2e3798968e724850eea3f4f4507b7d",
		  
		  "name": "Travis",
		  "createdDate": "2022-07-22 05:03:53",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 578,
		  "totalCountries": 22,
		  "totalStates": 55,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 1976,
		  "schedulePercent": 0.708975,
		  "totalGuests": 1452,
		  "guestPercent": 0.905032,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc3e957238433f77e632972ecdc28dc8",
		  
		  "name": "Dave",
		  "createdDate": "2021-11-09 22:01:47",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 261,
		  "totalCountries": 23,
		  "totalStates": 58,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1385,
		  "schedulePercent": 0.593835,
		  "totalGuests": 447,
		  "guestPercent": 0.711695,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 115,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc49c5efd22b51341d1eff6f68dbc87d",
		  
		  "name": "Rachel",
		  "createdDate": "2022-07-28 21:02:55",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 293,
		  "totalCountries": 17,
		  "totalStates": 41,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 670,
		  "schedulePercent": 0.374773,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Cobra Lounge",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc6d51eae0e4e7aca3db92f0d1f7392e",
		  
		  "name": "Tyler",
		  "createdDate": "2017-11-09 19:22:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 213,
		  "totalCountries": 6,
		  "totalStates": 28,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1745,
		  "schedulePercent": 0.667271,
		  "totalGuests": 2354,
		  "guestPercent": 0.963622,
		  "mostGuestDate": "2025-07-21 00:00:00",
		  "mostGuestName": "Desert 5 Spot",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc71b6f42792d9443e76dda3e4a492cb",
		  
		  "name": "Tammy",
		  "createdDate": "2017-02-17 18:04:38",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 124,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 854,
		  "schedulePercent": 0.44141,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "American Music Theatre",
		  "mostGuestCity": "Lancaster",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc71c1589bb59bdcf202a7b916c7eea9",
		  
		  "name": "daniela",
		  "createdDate": "2025-03-19 17:04:46",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 225,
		  "totalCountries": 17,
		  "totalStates": 29,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 389,
		  "schedulePercent": 0.264279,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Institute of Contemporary Arts",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc73119246fd174a72428b370023de47",
		  
		  "name": "Oliver",
		  "createdDate": "2023-06-09 08:36:06",
		  "totalOrganizations": 83,
		  "totalTours": 65,
		  "totalDays": 1960,
		  "totalCountries": 23,
		  "totalStates": 28,
		  "totalEvents": 1854,
		  "eventPercent": 0.999433,
		  "totalScheduleItems": 7876,
		  "schedulePercent": 0.990254,
		  "totalGuests": 14,
		  "guestPercent": 0.380326,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Tivoli Friheden",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc97c7fb41516ed1fd8763e8f6112fa2",
		  
		  "name": "Matthew",
		  "createdDate": "2021-06-10 02:44:56",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 107,
		  "schedulePercent": 0.102675,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dc98980a952659a765375f324fe29729",
		  
		  "name": "Ken",
		  "createdDate": "2013-10-12 20:15:50",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 138,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1437,
		  "schedulePercent": 0.605508,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dca379ddab9201a1656f61ea12cf3499",
		  
		  "name": "Delanie",
		  "createdDate": "2025-04-17 18:21:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 195,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Lake Whelchel",
		  "mostGuestCity": "Gaffney",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dca8a2de5f31f2e7218e68ffee034a05",
		  
		  "name": "Robert",
		  "createdDate": "2018-04-24 15:15:55",
		  "totalOrganizations": 16,
		  "totalTours": 8,
		  "totalDays": 516,
		  "totalCountries": 4,
		  "totalStates": 62,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 2061,
		  "schedulePercent": 0.726541,
		  "totalGuests": 1039,
		  "guestPercent": 0.852561,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dcb0eaa818af48b611db3b61cac63bf8",
		  
		  "name": "Adam",
		  "createdDate": "2025-10-27 23:37:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 22,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-11-29 00:00:00",
		  "mostGuestName": "Kulturwerk Herford",
		  "mostGuestCity": "Herford",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dcb283fc37fd659c1aa163723ea7c6b5",
		  
		  "name": "Cassie",
		  "createdDate": "2014-09-30 15:21:29",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 1079,
		  "totalCountries": 16,
		  "totalStates": 75,
		  "totalEvents": 367,
		  "eventPercent": 0.948663,
		  "totalScheduleItems": 4374,
		  "schedulePercent": 0.93427,
		  "totalGuests": 715,
		  "guestPercent": 0.789325,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "The Fillmore Silver Spring",
		  "mostGuestCity": "Silver Spring",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dcb702ef2fbd134c90d12748d94642c6",
		  
		  "name": "Cat",
		  "createdDate": "2016-11-09 10:16:34",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 96,
		  "totalCountries": 23,
		  "totalStates": 24,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 820,
		  "schedulePercent": 0.430984,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Auditorio BlackBerry",
		  "mostGuestCity": "MÃ©xico D.F.",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dcc7fea10e3aab36996cca9ef5e0cb06",
		  
		  "name": "Sarin",
		  "createdDate": "2020-02-08 03:13:00",
		  "totalOrganizations": 28,
		  "totalTours": 16,
		  "totalDays": 1136,
		  "totalCountries": 28,
		  "totalStates": 55,
		  "totalEvents": 502,
		  "eventPercent": 0.979034,
		  "totalScheduleItems": 7513,
		  "schedulePercent": 0.988554,
		  "totalGuests": 1880,
		  "guestPercent": 0.93869,
		  "mostGuestDate": "2025-03-05 00:00:00",
		  "mostGuestName": "Qudos Bank Arena",
		  "mostGuestCity": "Sydney Olympic Park",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dcd498f534dbcc3879a36afbd74db145",
		  
		  "name": "Chris (T) ",
		  "createdDate": "2013-03-06 20:59:05",
		  "totalOrganizations": 22,
		  "totalTours": 15,
		  "totalDays": 366,
		  "totalCountries": 17,
		  "totalStates": 45,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 890,
		  "schedulePercent": 0.453989,
		  "totalGuests": 242,
		  "guestPercent": 0.62092,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dcd787e588e890160cb135be93764358",
		  
		  "name": "Dan",
		  "createdDate": "2013-10-30 13:05:40",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 90,
		  "totalCountries": 17,
		  "totalStates": 17,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 349,
		  "schedulePercent": 0.24252,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Borgholms Slott",
		  "mostGuestCity": "Borgholm",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dcd9dd553fc4f1f21f9992c1016ddc81",
		  
		  "name": "Alan",
		  "createdDate": "2023-04-18 16:11:56",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 453,
		  "totalCountries": 11,
		  "totalStates": 26,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 143,
		  "schedulePercent": 0.12704,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-01-19 00:00:00",
		  "mostGuestName": "30a Songwriters Festival",
		  "mostGuestCity": "Santa Rosa Beach",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dce722bcf16238564401c20abe70b150",
		  
		  "name": "Hannah",
		  "createdDate": "2024-01-31 19:07:52",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 12,
		  "totalStates": 50,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1989,
		  "schedulePercent": 0.711355,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-12-11 00:00:00",
		  "mostGuestName": "PH Live Theater & Show Venue Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dcf38957d2b2fdaa4432aeb4de0d88a3",
		  
		  "name": "Travis",
		  "createdDate": "2015-11-05 19:08:43",
		  "totalOrganizations": 31,
		  "totalTours": 23,
		  "totalDays": 1431,
		  "totalCountries": 11,
		  "totalStates": 54,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 3350,
		  "schedulePercent": 0.871034,
		  "totalGuests": 2093,
		  "guestPercent": 0.953876,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd0887043342812a93ac7a5bc937dcf5",
		  
		  "name": "JP",
		  "createdDate": "2013-11-24 19:34:08",
		  "totalOrganizations": 15,
		  "totalTours": 9,
		  "totalDays": 1010,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 2726,
		  "schedulePercent": 0.81267,
		  "totalGuests": 350,
		  "guestPercent": 0.675091,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "James H. Clark Auditorium",
		  "mostGuestCity": "Conway",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd1b8f484eeff53ead78eb4bb42207f7",
		  
		  "name": "Charles",
		  "createdDate": "2017-07-13 21:19:28",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 648,
		  "totalCountries": 43,
		  "totalStates": 64,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 2365,
		  "schedulePercent": 0.770739,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-12-02 00:00:00",
		  "mostGuestName": "Toyosu PIT",
		  "mostGuestCity": "",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd24289f7b2f2e44be733e275929a573",
		  
		  "name": "Andrew",
		  "createdDate": "2022-07-27 05:17:45",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 34,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd24a70a1297a13778bdf48bc54e263a",
		  
		  "name": "Kelsey",
		  "createdDate": "2017-02-25 17:13:29",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 1099,
		  "totalCountries": 9,
		  "totalStates": 46,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1879,
		  "schedulePercent": 0.691183,
		  "totalGuests": 483,
		  "guestPercent": 0.725635,
		  "mostGuestDate": "2025-02-04 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd29edfa862d49d0d492f84e8020d1d0",
		  
		  "name": "Tom",
		  "createdDate": "2023-01-18 23:37:14",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 282,
		  "totalCountries": 24,
		  "totalStates": 44,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 974,
		  "schedulePercent": 0.482434,
		  "totalGuests": 401,
		  "guestPercent": 0.69481,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd2af779e4d99697edf51f768368a467",
		  
		  "name": "Gayle",
		  "createdDate": "2022-03-30 21:52:39",
		  "totalOrganizations": 12,
		  "totalTours": 16,
		  "totalDays": 551,
		  "totalCountries": 16,
		  "totalStates": 63,
		  "totalEvents": 267,
		  "eventPercent": 0.888033,
		  "totalScheduleItems": 3038,
		  "schedulePercent": 0.845762,
		  "totalGuests": 2004,
		  "guestPercent": 0.947643,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd2be6fbe93b1d4e64b29949531b28bc",
		  
		  "name": "Aaron",
		  "createdDate": "2017-10-02 13:57:04",
		  "totalOrganizations": 14,
		  "totalTours": 24,
		  "totalDays": 828,
		  "totalCountries": 9,
		  "totalStates": 46,
		  "totalEvents": 221,
		  "eventPercent": 0.835449,
		  "totalScheduleItems": 2963,
		  "schedulePercent": 0.838509,
		  "totalGuests": 468,
		  "guestPercent": 0.719515,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Peacock Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd3078e2b9364df3fe3c913d2e121dc5",
		  
		  "name": "Tore",
		  "createdDate": "2017-09-03 01:09:00",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 103,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 707,
		  "schedulePercent": 0.389166,
		  "totalGuests": 556,
		  "guestPercent": 0.745354,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd3262190f91ed8b67e2dc4652998684",
		  
		  "name": "Kay",
		  "createdDate": "2016-01-22 01:07:13",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 341,
		  "totalCountries": 33,
		  "totalStates": 58,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 1601,
		  "schedulePercent": 0.640866,
		  "totalGuests": 1095,
		  "guestPercent": 0.862874,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd544afab4a698489e43dc531e3472d6",
		  
		  "name": "Whitney",
		  "createdDate": "2010-10-08 16:49:03",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 131,
		  "totalCountries": 19,
		  "totalStates": 36,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 648,
		  "schedulePercent": 0.366614,
		  "totalGuests": 239,
		  "guestPercent": 0.618314,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd58746deb38eb67e6092c480f2e21ed",
		  
		  "name": "Rachel",
		  "createdDate": "2022-07-29 16:09:53",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 407,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 2605,
		  "schedulePercent": 0.798277,
		  "totalGuests": 478,
		  "guestPercent": 0.723255,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Met Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd64c72d1f4f95019de9b5479c1d8dfc",
		  
		  "name": "Helena",
		  "createdDate": "2013-03-15 17:49:31",
		  "totalOrganizations": 10,
		  "totalTours": 23,
		  "totalDays": 1139,
		  "totalCountries": 46,
		  "totalStates": 80,
		  "totalEvents": 481,
		  "eventPercent": 0.975521,
		  "totalScheduleItems": 9237,
		  "schedulePercent": 0.994447,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd70cea8825b65bcdaaeb6334b81813c",
		  
		  "name": "Anna",
		  "createdDate": "2018-10-18 03:16:39",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 70,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 398,
		  "schedulePercent": 0.268586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd7f928883a1ecb3907705b47a8499d3",
		  
		  "name": "Crystal",
		  "createdDate": "2022-05-03 18:09:45",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 406,
		  "totalCountries": 29,
		  "totalStates": 30,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 2059,
		  "schedulePercent": 0.725861,
		  "totalGuests": 851,
		  "guestPercent": 0.819923,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd855a5cf8a6859b98dec05a8029f733",
		  
		  "name": "Chris",
		  "createdDate": "2010-05-13 15:44:48",
		  "totalOrganizations": 11,
		  "totalTours": 12,
		  "totalDays": 352,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 125,
		  "schedulePercent": 0.114914,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "House of Blues Chicago",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd8ab0cf36b6de1e6f24f8837903820b",
		  
		  "name": "Evan",
		  "createdDate": "2015-07-06 08:12:37",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 403,
		  "totalCountries": 9,
		  "totalStates": 20,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 368,
		  "schedulePercent": 0.252153,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd8fb288b9b3391b5785efe6bc9de5a7",
		  
		  "name": "T.",
		  "createdDate": "2022-03-01 20:47:35",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 183,
		  "totalCountries": 6,
		  "totalStates": 27,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 842,
		  "schedulePercent": 0.43801,
		  "totalGuests": 377,
		  "guestPercent": 0.68461,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "The Town Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd8fe1ad85e9bfc96eeeca1c92255ec1",
		  
		  "name": "Rick",
		  "createdDate": "2017-03-09 00:55:18",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 141,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dd9a7a97912ab78ae3cacc56074d0d73",
		  
		  "name": "Davide",
		  "createdDate": "2018-01-31 14:09:19",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 231,
		  "totalCountries": 8,
		  "totalStates": 26,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1641,
		  "schedulePercent": 0.648005,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Charles Krug Winery",
		  "mostGuestCity": "St Helena",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dda33b9e19b700d39488b30dce642b5f",
		  
		  "name": "Savannah",
		  "createdDate": "2021-11-18 17:46:01",
		  "totalOrganizations": 17,
		  "totalTours": 18,
		  "totalDays": 2594,
		  "totalCountries": 18,
		  "totalStates": 74,
		  "totalEvents": 469,
		  "eventPercent": 0.973595,
		  "totalScheduleItems": 5172,
		  "schedulePercent": 0.958975,
		  "totalGuests": 1761,
		  "guestPercent": 0.93087,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ddc48814d09ce2bf98dbd5ea99649462",
		  
		  "name": "Joseph",
		  "createdDate": "2024-10-25 16:52:23",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 49,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 452,
		  "schedulePercent": 0.291364,
		  "totalGuests": 46,
		  "guestPercent": 0.446623,
		  "mostGuestDate": "2025-10-19 00:00:00",
		  "mostGuestName": "Southern Alberta Jubilee Auditorium",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ddc616029d3ad379b3ec5934790dc1d6",
		  
		  "name": "Bobby",
		  "createdDate": "2025-04-09 21:00:53",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 152,
		  "totalCountries": 12,
		  "totalStates": 24,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 515,
		  "schedulePercent": 0.31845,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dde1273cd77a2b51a73ddb5e89b3ecec",
		  
		  "name": "Carl",
		  "createdDate": "2022-09-17 17:26:20",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 369,
		  "totalCountries": 4,
		  "totalStates": 42,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1807,
		  "schedulePercent": 0.677244,
		  "totalGuests": 851,
		  "guestPercent": 0.819923,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "First Bank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dde29b8197bd4537a396ecc3ca92247c",
		  
		  "name": "Maxwell",
		  "createdDate": "2021-08-10 13:52:23",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 195,
		  "totalCountries": 17,
		  "totalStates": 13,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 418,
		  "schedulePercent": 0.277765,
		  "totalGuests": 694,
		  "guestPercent": 0.784111,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 106,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dde2fa25839a2815346d71373ab8aee6",
		  
		  "name": "Jason",
		  "createdDate": "2011-08-02 20:50:56",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 521,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 2604,
		  "schedulePercent": 0.797824,
		  "totalGuests": 2485,
		  "guestPercent": 0.967362,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ddecbaf350cd89c6ce951ec4558537cd",
		  
		  "name": "David",
		  "createdDate": "2014-01-03 01:02:29",
		  "totalOrganizations": 6,
		  "totalTours": 16,
		  "totalDays": 180,
		  "totalCountries": 9,
		  "totalStates": 30,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 726,
		  "schedulePercent": 0.396646,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Division 88",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de082a32b0088ccfa216cd05fc3165d1",
		  
		  "name": "Millan",
		  "createdDate": "2011-09-09 12:53:03",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 741,
		  "totalCountries": 26,
		  "totalStates": 77,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 3492,
		  "schedulePercent": 0.881686,
		  "totalGuests": 457,
		  "guestPercent": 0.714982,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Estadi de Son Moix",
		  "mostGuestCity": "Palma",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de1d2bfab5e3f8a37065947b03e1142d",
		  
		  "name": "Karma",
		  "createdDate": "2023-08-25 22:55:36",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 138,
		  "totalCountries": 7,
		  "totalStates": 10,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 691,
		  "schedulePercent": 0.383273,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Hamer Hall",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de46b55e5b85b8f688315691b2c4e802",
		  
		  "name": "Karina",
		  "createdDate": "2018-06-14 16:24:16",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 366,
		  "totalCountries": 12,
		  "totalStates": 36,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1491,
		  "schedulePercent": 0.615707,
		  "totalGuests": 721,
		  "guestPercent": 0.790571,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de5f59d8bd76744ae5c0e032ad0ae8cf",
		  
		  "name": "Laura",
		  "createdDate": "2019-10-17 20:25:33",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 304,
		  "totalCountries": 8,
		  "totalStates": 42,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 3047,
		  "schedulePercent": 0.846895,
		  "totalGuests": 1952,
		  "guestPercent": 0.942883,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de610d72006e2b445d975cdb80dd54a1",
		  
		  "name": "Rachael",
		  "createdDate": "2014-02-13 00:06:59",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 233,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 788,
		  "schedulePercent": 0.418178,
		  "totalGuests": 217,
		  "guestPercent": 0.606528,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Jacob's Pavilion at Nautica",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de669d257ea48c663f7dc52d65f64b4b",
		  
		  "name": "Adam",
		  "createdDate": "2014-08-12 11:32:26",
		  "totalOrganizations": 14,
		  "totalTours": 20,
		  "totalDays": 525,
		  "totalCountries": 20,
		  "totalStates": 51,
		  "totalEvents": 202,
		  "eventPercent": 0.804397,
		  "totalScheduleItems": 3142,
		  "schedulePercent": 0.854828,
		  "totalGuests": 114,
		  "guestPercent": 0.531505,
		  "mostGuestDate": "2025-01-22 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de6e3ba3247981763b856b498ec18920",
		  
		  "name": "Che",
		  "createdDate": "2011-03-08 05:00:28",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 520,
		  "totalCountries": 23,
		  "totalStates": 64,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 2505,
		  "schedulePercent": 0.787285,
		  "totalGuests": 1954,
		  "guestPercent": 0.94379,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de6f36faaef0e7a1906eb0bb50c8fdcc",
		  
		  "name": "Association",
		  "createdDate": "2019-09-23 09:21:52",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 682,
		  "totalCountries": 24,
		  "totalStates": 50,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2644,
		  "schedulePercent": 0.802244,
		  "totalGuests": 832,
		  "guestPercent": 0.81573,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Zenith Nantes Metropole",
		  "mostGuestCity": "St Herblain",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de75844f2b0977c5a0ef73927de2eac3",
		  
		  "name": "Jason",
		  "createdDate": "2024-05-02 19:26:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 216,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 1230,
		  "schedulePercent": 0.554964,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de7f20d0830cf7cb1d0dd2fa8a7403e6",
		  
		  "name": "Amanda ",
		  "createdDate": "2025-02-11 07:12:22",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 762,
		  "totalCountries": 43,
		  "totalStates": 46,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 4011,
		  "schedulePercent": 0.913645,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Old Park Farm",
		  "mostGuestCity": "",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de893902c2d75db1388898bc9ee51e96",
		  
		  "name": "Ben",
		  "createdDate": "2015-07-23 11:24:38",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 289,
		  "totalCountries": 18,
		  "totalStates": 11,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2131,
		  "schedulePercent": 0.736854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de8c9bd252dfe74b5ebd4448b5b8c29e",
		  
		  "name": "Wyn",
		  "createdDate": "2025-08-31 22:02:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 20,
		  "totalCountries": 4,
		  "totalStates": 2,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 131,
		  "schedulePercent": 0.119334,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de95497cc471972dba1a416258ae7e9f",
		  
		  "name": "Maria",
		  "createdDate": "2017-11-20 14:29:35",
		  "totalOrganizations": 9,
		  "totalTours": 50,
		  "totalDays": 305,
		  "totalCountries": 22,
		  "totalStates": 33,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 1440,
		  "schedulePercent": 0.605961,
		  "totalGuests": 1061,
		  "guestPercent": 0.856528,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de95a83671e7c33ae352c84bc3fcd8d0",
		  
		  "name": "Rodolphe",
		  "createdDate": "2023-01-13 22:31:45",
		  "totalOrganizations": 12,
		  "totalTours": 4,
		  "totalDays": 269,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1980,
		  "schedulePercent": 0.709655,
		  "totalGuests": 1942,
		  "guestPercent": 0.942203,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "La Seine Musicale",
		  "mostGuestCity": "Boulogne-Billancourt",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de9bb0df9297f3e71d3207a1be79cba4",
		  
		  "name": "Chase",
		  "createdDate": "2022-02-28 19:00:44",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 722,
		  "totalCountries": 12,
		  "totalStates": 58,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 2236,
		  "schedulePercent": 0.753286,
		  "totalGuests": 1008,
		  "guestPercent": 0.848028,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de9d2ea69bedc00f794141ddd3a3b53e",
		  
		  "name": "Laura",
		  "createdDate": "2017-03-24 14:43:04",
		  "totalOrganizations": 14,
		  "totalTours": 19,
		  "totalDays": 413,
		  "totalCountries": 18,
		  "totalStates": 47,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 1507,
		  "schedulePercent": 0.618994,
		  "totalGuests": 402,
		  "guestPercent": 0.695376,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Paramount Theatre, VT",
		  "mostGuestCity": "Rutland",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "de9f52294b5b9a2fe14142de3b26bd92",
		  
		  "name": "Jesse ",
		  "createdDate": "2023-06-29 11:25:56",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 47,
		  "totalCountries": 8,
		  "totalStates": 3,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 180,
		  "schedulePercent": 0.146419,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dea50144eccf02b011f6e8e0f0542f31",
		  
		  "name": "Andres",
		  "createdDate": "2016-08-07 21:53:58",
		  "totalOrganizations": 13,
		  "totalTours": 14,
		  "totalDays": 998,
		  "totalCountries": 10,
		  "totalStates": 51,
		  "totalEvents": 225,
		  "eventPercent": 0.840889,
		  "totalScheduleItems": 3198,
		  "schedulePercent": 0.859474,
		  "totalGuests": 1003,
		  "guestPercent": 0.846668,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dea6d687ce43088ab6a4b91add74f6a6",
		  
		  "name": "Kasey",
		  "createdDate": "2017-04-01 10:17:23",
		  "totalOrganizations": 12,
		  "totalTours": 22,
		  "totalDays": 1541,
		  "totalCountries": 38,
		  "totalStates": 85,
		  "totalEvents": 417,
		  "eventPercent": 0.962715,
		  "totalScheduleItems": 6895,
		  "schedulePercent": 0.985494,
		  "totalGuests": 2210,
		  "guestPercent": 0.958296,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 106,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dea705c2a7a0792034c107f1f53d3ab6",
		  
		  "name": "Lightnin&#8217;",
		  "createdDate": "2016-06-06 08:37:14",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 74,
		  "totalCountries": 4,
		  "totalStates": 20,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 475,
		  "schedulePercent": 0.300091,
		  "totalGuests": 226,
		  "guestPercent": 0.610607,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "(Le) Poisson Rouge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "deb1c5812cec3455033296508ce39622",
		  
		  "name": "Mathias",
		  "createdDate": "2023-03-24 15:23:24",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 119,
		  "totalCountries": 21,
		  "totalStates": 7,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 649,
		  "schedulePercent": 0.366954,
		  "totalGuests": 280,
		  "guestPercent": 0.639393,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "QUARTERBACK Immobilien ARENA",
		  "mostGuestCity": "Leipzig",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "deb4620cbc76ce6bf6b0f3dc77a3a54f",
		  
		  "name": "Darren",
		  "createdDate": "2013-11-12 14:44:48",
		  "totalOrganizations": 9,
		  "totalTours": 13,
		  "totalDays": 434,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 2671,
		  "schedulePercent": 0.805417,
		  "totalGuests": 395,
		  "guestPercent": 0.692203,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "City Center Church",
		  "mostGuestCity": "Lenexa",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "deb584d057cabbc5b8bda2b3f89dd42d",
		  
		  "name": "Reuben",
		  "createdDate": "2022-06-12 22:28:10",
		  "totalOrganizations": 12,
		  "totalTours": 15,
		  "totalDays": 286,
		  "totalCountries": 19,
		  "totalStates": 64,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1464,
		  "schedulePercent": 0.609927,
		  "totalGuests": 179,
		  "guestPercent": 0.579556,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 101,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "deba295f6c4310050d5919f2c58d05dc",
		  
		  "name": "Adam",
		  "createdDate": "2016-06-03 06:32:20",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 209,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 285,
		  "schedulePercent": 0.209542,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dec5a2a63b188f2295e6e6694d624219",
		  
		  "name": "Charles",
		  "createdDate": "2013-02-19 04:25:33",
		  "totalOrganizations": 33,
		  "totalTours": 20,
		  "totalDays": 1329,
		  "totalCountries": 13,
		  "totalStates": 59,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 1830,
		  "schedulePercent": 0.681437,
		  "totalGuests": 223,
		  "guestPercent": 0.608568,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "The Theater at Virgin Hotels",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dec64885b175c4299bd56c19938c3553",
		  
		  "name": "Renee",
		  "createdDate": "2023-03-21 06:51:33",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 203,
		  "totalCountries": 5,
		  "totalStates": 30,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 878,
		  "schedulePercent": 0.450589,
		  "totalGuests": 285,
		  "guestPercent": 0.641999,
		  "mostGuestDate": "2025-08-27 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dec9b5415d1dc9aa246bc7a99d25de40",
		  
		  "name": "Inne",
		  "createdDate": "2025-05-07 10:15:45",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 448,
		  "totalCountries": 6,
		  "totalStates": 6,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dee1190457bb5f553983f98a54765e87",
		  
		  "name": "Hoobastank",
		  "createdDate": "2022-09-15 04:26:39",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 87,
		  "totalCountries": 6,
		  "totalStates": 25,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 411,
		  "schedulePercent": 0.274365,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dee63c95407e682e26b270fcdca8cf74",
		  
		  "name": "Amanda",
		  "createdDate": "2023-05-31 18:48:32",
		  "totalOrganizations": 5,
		  "totalTours": 32,
		  "totalDays": 238,
		  "totalCountries": 5,
		  "totalStates": 39,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 2173,
		  "schedulePercent": 0.743427,
		  "totalGuests": 846,
		  "guestPercent": 0.818903,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Germania Insurance Amphitheater",
		  "mostGuestCity": "Del Valle",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "deec55e84cf6d891d5d658466006f6eb",
		  
		  "name": "Brittany",
		  "createdDate": "2022-03-08 20:49:08",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 363,
		  "totalCountries": 3,
		  "totalStates": 42,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 1896,
		  "schedulePercent": 0.693676,
		  "totalGuests": 870,
		  "guestPercent": 0.822983,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "deef629e3a8776b92d0bc60773875a8e",
		  
		  "name": "Brianna",
		  "createdDate": "2025-08-28 15:26:50",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 62,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 427,
		  "schedulePercent": 0.280938,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "Majestic Theatre",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "def45315d1a2727ff9b8e8b4ed18e4e7",
		  
		  "name": "Lauren",
		  "createdDate": "2018-04-10 01:09:07",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 201,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 2093,
		  "schedulePercent": 0.731641,
		  "totalGuests": 2222,
		  "guestPercent": 0.958862,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 203,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "deffa0476d3f3e8e52e7f8feb98185e7",
		  
		  "name": "Ken",
		  "createdDate": "2016-01-23 20:41:24",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 619,
		  "totalCountries": 4,
		  "totalStates": 37,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 2551,
		  "schedulePercent": 0.792838,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df03ed59c9692e2324eb2c9bd57a7070",
		  
		  "name": "Victoria",
		  "createdDate": "2025-02-24 15:47:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 52,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 180,
		  "schedulePercent": 0.146419,
		  "totalGuests": 278,
		  "guestPercent": 0.638939,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "El CorazÃ³n",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df14d42ca25558c4a1199dea6721e8cf",
		  
		  "name": "Rian",
		  "createdDate": "2020-08-22 05:59:57",
		  "totalOrganizations": 5,
		  "totalTours": 11,
		  "totalDays": 471,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1081,
		  "schedulePercent": 0.514619,
		  "totalGuests": 269,
		  "guestPercent": 0.63418,
		  "mostGuestDate": "2025-09-16 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df19eebab5bde7e7e44c258644899d2b",
		  
		  "name": "Taz",
		  "createdDate": "2022-11-29 03:58:54",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 481,
		  "totalCountries": 11,
		  "totalStates": 51,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1736,
		  "schedulePercent": 0.665118,
		  "totalGuests": 1622,
		  "guestPercent": 0.921691,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df1d81d52ed553b018845ac6ffbc5910",
		  
		  "name": "Bligh",
		  "createdDate": "2022-06-01 03:27:25",
		  "totalOrganizations": 15,
		  "totalTours": 15,
		  "totalDays": 292,
		  "totalCountries": 19,
		  "totalStates": 41,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1239,
		  "schedulePercent": 0.557004,
		  "totalGuests": 226,
		  "guestPercent": 0.610607,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df2d70e181d8f79fcde70cead9d97cb9",
		  
		  "name": "Austin",
		  "createdDate": "2019-07-01 22:45:17",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 192,
		  "totalCountries": 5,
		  "totalStates": 45,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1062,
		  "schedulePercent": 0.5068,
		  "totalGuests": 383,
		  "guestPercent": 0.68699,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df31af3cf3cc46f038ac81ef56cf9c4e",
		  
		  "name": "Nicolas",
		  "createdDate": "2025-01-30 15:13:19",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 60,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 490,
		  "schedulePercent": 0.307344,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df3dea3b6dc63c79708f38c5eb1a5a27",
		  
		  "name": "Casey",
		  "createdDate": "2014-07-08 22:11:26",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 328,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 915,
		  "schedulePercent": 0.463055,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df475b2fe35d199f97f7b800da063f07",
		  
		  "name": "Matt",
		  "createdDate": "2016-02-16 18:48:31",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 30,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 156,
		  "schedulePercent": 0.132706,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Sinclair",
		  "mostGuestCity": "Cambridge",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df48996dd112ddd60cb9f1cb6bff23d4",
		  
		  "name": "Bill",
		  "createdDate": "2018-12-05 17:59:23",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 110,
		  "totalCountries": 5,
		  "totalStates": 40,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 948,
		  "schedulePercent": 0.474728,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df4c96206d1c77196aeb83dfc6b6eef8",
		  
		  "name": "Tom",
		  "createdDate": "2021-02-22 21:09:36",
		  "totalOrganizations": 25,
		  "totalTours": 29,
		  "totalDays": 3320,
		  "totalCountries": 14,
		  "totalStates": 71,
		  "totalEvents": 644,
		  "eventPercent": 0.989461,
		  "totalScheduleItems": 8128,
		  "schedulePercent": 0.991047,
		  "totalGuests": 1996,
		  "guestPercent": 0.947076,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df6d0ee9e65ed8c36bd4a93f075dc250",
		  
		  "name": "Jersey",
		  "createdDate": "2025-05-09 19:10:39",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 411,
		  "totalCountries": 2,
		  "totalStates": 44,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 616,
		  "schedulePercent": 0.356188,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df6f2ee0f1b6e405ac0309c13706b197",
		  
		  "name": "Rune",
		  "createdDate": "2016-09-29 17:00:38",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 128,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 750,
		  "schedulePercent": 0.405032,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-01-07 00:00:00",
		  "mostGuestName": "Laeiszhalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df72e555b26e7b41c3d5a91faf052094",
		  
		  "name": "Stella",
		  "createdDate": "2019-08-16 04:00:27",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 387,
		  "totalCountries": 18,
		  "totalStates": 36,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1134,
		  "schedulePercent": 0.529578,
		  "totalGuests": 268,
		  "guestPercent": 0.6335,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Moanalua Gardens",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df79731e9f50419449347c02525503ca",
		  
		  "name": "Debbie",
		  "createdDate": "2013-09-18 21:38:03",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 965,
		  "totalCountries": 19,
		  "totalStates": 55,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1397,
		  "schedulePercent": 0.597235,
		  "totalGuests": 481,
		  "guestPercent": 0.724615,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "House of Yes",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df7a95eb6afcbc167d9e7ff15d72ce5b",
		  
		  "name": "Jase",
		  "createdDate": "2017-05-20 21:41:26",
		  "totalOrganizations": 25,
		  "totalTours": 68,
		  "totalDays": 1261,
		  "totalCountries": 20,
		  "totalStates": 74,
		  "totalEvents": 516,
		  "eventPercent": 0.980734,
		  "totalScheduleItems": 6758,
		  "schedulePercent": 0.984587,
		  "totalGuests": 3654,
		  "guestPercent": 0.99116,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df89221f073e407c6d80f857552ee888",
		  
		  "name": "Zachary",
		  "createdDate": "2025-03-30 01:54:16",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 424,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 2211,
		  "schedulePercent": 0.749433,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df93dfca76071d6beecd138271a18545",
		  
		  "name": "Stephen",
		  "createdDate": "2012-06-25 06:25:26",
		  "totalOrganizations": 35,
		  "totalTours": 33,
		  "totalDays": 981,
		  "totalCountries": 24,
		  "totalStates": 65,
		  "totalEvents": 343,
		  "eventPercent": 0.938463,
		  "totalScheduleItems": 4993,
		  "schedulePercent": 0.954329,
		  "totalGuests": 2301,
		  "guestPercent": 0.962262,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 179,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "df9e4ad4cd641bd12ed25fa1b80058ea",
		  
		  "name": "Chris",
		  "createdDate": "2015-05-02 15:29:41",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 400,
		  "totalCountries": 8,
		  "totalStates": 35,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 651,
		  "schedulePercent": 0.36786,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfb17798a6d8a47c54f4f3429dbd9685",
		  
		  "name": "Nikki",
		  "createdDate": "2022-05-17 23:28:45",
		  "totalOrganizations": 34,
		  "totalTours": 23,
		  "totalDays": 1780,
		  "totalCountries": 11,
		  "totalStates": 14,
		  "totalEvents": 1225,
		  "eventPercent": 0.997847,
		  "totalScheduleItems": 4364,
		  "schedulePercent": 0.933477,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stand Comedy Club Newcastle",
		  "mostGuestCity": "Newcastle upon Tyne",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfb3aa60367e40e8d5cf47476eaf0576",
		  
		  "name": "Jeremy",
		  "createdDate": "2014-08-22 21:50:47",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 73,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 146,
		  "schedulePercent": 0.128173,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfb47fdedefff5f0707f47783a32f27c",
		  
		  "name": "Dieter",
		  "createdDate": "2021-08-08 13:12:06",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 162,
		  "totalCountries": 24,
		  "totalStates": 51,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 365,
		  "schedulePercent": 0.250907,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfccea04507f806204b20684c042c730",
		  
		  "name": "Emilio",
		  "createdDate": "2022-03-09 12:10:01",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 83,
		  "totalCountries": 4,
		  "totalStates": 22,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 549,
		  "schedulePercent": 0.334089,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "El Rey Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfd02d3c5d40eebd8fe4ac36a0eebc10",
		  
		  "name": "Annie",
		  "createdDate": "2016-10-31 00:21:14",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 554,
		  "totalCountries": 6,
		  "totalStates": 47,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 2353,
		  "schedulePercent": 0.768812,
		  "totalGuests": 1521,
		  "guestPercent": 0.912058,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Boettcher Concert Hall",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfd4021a75ebe0d8340a36e10be65679",
		  
		  "name": "Cody",
		  "createdDate": "2016-10-17 17:07:25",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 127,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 292,
		  "schedulePercent": 0.212715,
		  "totalGuests": 43,
		  "guestPercent": 0.44209,
		  "mostGuestDate": "2025-08-04 00:00:00",
		  "mostGuestName": "Sturgis Buffalo Chip",
		  "mostGuestCity": "Sturgis",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfda9d1f5ae3243a22a79c011c520f1c",
		  
		  "name": "William",
		  "createdDate": "2013-10-04 04:35:48",
		  "totalOrganizations": 50,
		  "totalTours": 27,
		  "totalDays": 2180,
		  "totalCountries": 20,
		  "totalStates": 51,
		  "totalEvents": 390,
		  "eventPercent": 0.956029,
		  "totalScheduleItems": 6654,
		  "schedulePercent": 0.983908,
		  "totalGuests": 1418,
		  "guestPercent": 0.902085,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfdff09913a88428323b8db7e9ff2fb7",
		  
		  "name": "Gina",
		  "createdDate": "2024-03-17 17:51:40",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 147,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 467,
		  "schedulePercent": 0.297031,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Middle C Jazz Club",
		  "mostGuestCity": "Charlotte",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfe35a9b8dd29a7d91c93fb0e832a754",
		  
		  "name": "Ruben",
		  "createdDate": "2024-10-14 02:19:25",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 97,
		  "totalCountries": 28,
		  "totalStates": 26,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 815,
		  "schedulePercent": 0.428944,
		  "totalGuests": 90,
		  "guestPercent": 0.50782,
		  "mostGuestDate": "2025-03-16 00:00:00",
		  "mostGuestName": "El Teatro Flores",
		  "mostGuestCity": "DYN",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfe823b8d2281f5275373df488d4487e",
		  
		  "name": "John Bruce",
		  "createdDate": "2014-01-04 12:58:27",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 603,
		  "totalCountries": 35,
		  "totalStates": 83,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 4918,
		  "schedulePercent": 0.951723,
		  "totalGuests": 2827,
		  "guestPercent": 0.978241,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "dfeb49e2af2dffd24e2cc009809f7a84",
		  
		  "name": "Andreas",
		  "createdDate": "2014-12-02 12:32:13",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 67,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 524,
		  "schedulePercent": 0.324003,
		  "totalGuests": 343,
		  "guestPercent": 0.671804,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "Fredagsrock i Tivoli",
		  "mostGuestCity": "KÃ¸benhavn",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0056f86014214a8b0b10de06635d6ec",
		  
		  "name": "Ashton",
		  "createdDate": "2014-09-30 04:40:50",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 1048,
		  "totalCountries": 19,
		  "totalStates": 89,
		  "totalEvents": 322,
		  "eventPercent": 0.92781,
		  "totalScheduleItems": 6405,
		  "schedulePercent": 0.980734,
		  "totalGuests": 2965,
		  "guestPercent": 0.981301,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e009ab7f61c6e8efb67405d8f023032d",
		  
		  "name": "Barbara",
		  "createdDate": "2018-04-19 08:50:56",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 146,
		  "totalCountries": 17,
		  "totalStates": 36,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 679,
		  "schedulePercent": 0.378626,
		  "totalGuests": 377,
		  "guestPercent": 0.68461,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e00cb44b93391c2c7ec90e1b31de27d7",
		  
		  "name": "Evan",
		  "createdDate": "2015-03-01 03:31:07",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 506,
		  "totalCountries": 8,
		  "totalStates": 41,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 2188,
		  "schedulePercent": 0.74626,
		  "totalGuests": 321,
		  "guestPercent": 0.660471,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "Patchogue Theatre for the Performing Arts",
		  "mostGuestCity": "Patchogue",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e014936a666142d55666d5fd47d1387a",
		  
		  "name": "Jason",
		  "createdDate": "2019-08-14 20:26:06",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 545,
		  "totalCountries": 5,
		  "totalStates": 51,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2098,
		  "schedulePercent": 0.732548,
		  "totalGuests": 1149,
		  "guestPercent": 0.871374,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e01d9ddb19f5a256b4024e9354797da6",
		  
		  "name": "Dara",
		  "createdDate": "2025-03-27 12:15:08",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 104,
		  "totalCountries": 10,
		  "totalStates": 2,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 540,
		  "schedulePercent": 0.330349,
		  "totalGuests": 223,
		  "guestPercent": 0.608568,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "The SSE Arena, Wembley",
		  "mostGuestCity": "Wembley",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e024401833c6b3ac1e346e12494ae470",
		  
		  "name": "Sherry",
		  "createdDate": "2022-06-18 11:46:16",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 713,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 489,
		  "schedulePercent": 0.30621,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-03-03 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e02b99d5e9d7a0635b5a8395eef11a54",
		  
		  "name": "Chris",
		  "createdDate": "2013-03-22 12:13:12",
		  "totalOrganizations": 34,
		  "totalTours": 22,
		  "totalDays": 719,
		  "totalCountries": 26,
		  "totalStates": 52,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 3036,
		  "schedulePercent": 0.845648,
		  "totalGuests": 300,
		  "guestPercent": 0.649705,
		  "mostGuestDate": "2025-07-24 00:00:00",
		  "mostGuestName": "The Grace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e02c3ebe6ff88e9130f181fa346b19d1",
		  
		  "name": "Andrea",
		  "createdDate": "2022-09-04 15:25:18",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 221,
		  "totalCountries": 6,
		  "totalStates": 53,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 1882,
		  "schedulePercent": 0.69175,
		  "totalGuests": 882,
		  "guestPercent": 0.825703,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e02d303ceb9b12090215bb282fcddbc5",
		  
		  "name": "Fred",
		  "createdDate": "2009-11-11 19:45:04",
		  "totalOrganizations": 24,
		  "totalTours": 15,
		  "totalDays": 363,
		  "totalCountries": 11,
		  "totalStates": 42,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 2384,
		  "schedulePercent": 0.773119,
		  "totalGuests": 61,
		  "guestPercent": 0.472235,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e02dc76483c942421ae0a634e33a75c2",
		  
		  "name": "Grace",
		  "createdDate": "2022-05-26 13:43:39",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 29,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 184,
		  "schedulePercent": 0.150272,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-03-24 00:00:00",
		  "mostGuestName": "C Art Media",
		  "mostGuestCity": "Cdad. AutÃ³noma de Buenos Aires",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e032807dafd3d1af5ebeb47d9e5dba3f",
		  
		  "name": "Britton",
		  "createdDate": "2025-03-29 00:12:24",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 112,
		  "totalCountries": 13,
		  "totalStates": 33,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e04ed5b495d8566489667047d517d96e",
		  
		  "name": "Natalie",
		  "createdDate": "2015-02-03 04:14:16",
		  "totalOrganizations": 25,
		  "totalTours": 25,
		  "totalDays": 1188,
		  "totalCountries": 4,
		  "totalStates": 55,
		  "totalEvents": 466,
		  "eventPercent": 0.973255,
		  "totalScheduleItems": 6724,
		  "schedulePercent": 0.984361,
		  "totalGuests": 1674,
		  "guestPercent": 0.926451,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e050a639b93dc9006ad3d5e7a05766a1",
		  
		  "name": "Barry",
		  "createdDate": "2024-04-08 03:57:47",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 50,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 510,
		  "schedulePercent": 0.315503,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e050a71273e99db23e38dbb84907d1e4",
		  
		  "name": "Jim",
		  "createdDate": "2021-11-05 05:29:43",
		  "totalOrganizations": 8,
		  "totalTours": 17,
		  "totalDays": 653,
		  "totalCountries": 4,
		  "totalStates": 44,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 1528,
		  "schedulePercent": 0.622733,
		  "totalGuests": 813,
		  "guestPercent": 0.811763,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The Fillmore Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e052fd9c9693d9e0f382cbe934bbdedc",
		  
		  "name": "John",
		  "createdDate": "2023-09-27 15:43:01",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 384,
		  "totalCountries": 7,
		  "totalStates": 32,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 82,
		  "schedulePercent": 0.0838622,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0559ac34c48c4fb848ce6b0e6a39046",
		  
		  "name": "Dom",
		  "createdDate": "2019-03-26 01:17:56",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 608,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 272,
		  "schedulePercent": 0.200929,
		  "totalGuests": 69,
		  "guestPercent": 0.483794,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Mayfair Austin",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e05837b520b58d7fe54b79c535bd6be7",
		  
		  "name": "Hans ",
		  "createdDate": "2020-10-12 23:13:14",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 117,
		  "totalCountries": 12,
		  "totalStates": 22,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 524,
		  "schedulePercent": 0.324003,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-07-09 00:00:00",
		  "mostGuestName": "Wrightegaarden Restaurant",
		  "mostGuestCity": "Langesund",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e058e479d11a73b3514c9991803a5d38",
		  
		  "name": "Stefano",
		  "createdDate": "2015-04-27 09:55:43",
		  "totalOrganizations": 22,
		  "totalTours": 7,
		  "totalDays": 1004,
		  "totalCountries": 10,
		  "totalStates": 50,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1451,
		  "schedulePercent": 0.607548,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e05df64f895c84333e64728abc47ffed",
		  
		  "name": "Rosalinda",
		  "createdDate": "2022-02-28 21:20:35",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 380,
		  "schedulePercent": 0.25816,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0619a3c59e419925e434ea78cdf6d32",
		  
		  "name": "Molly",
		  "createdDate": "2024-07-26 14:37:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 210,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 829,
		  "schedulePercent": 0.434157,
		  "totalGuests": 583,
		  "guestPercent": 0.75408,
		  "mostGuestDate": "2025-07-23 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 91,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e06a5105a808738fe228a864dd3efaee",
		  
		  "name": "Frederik",
		  "createdDate": "2024-05-01 22:32:29",
		  "totalOrganizations": 16,
		  "totalTours": 17,
		  "totalDays": 2712,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1379,
		  "schedulePercent": 0.592362,
		  "totalGuests": 211,
		  "guestPercent": 0.603128,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "Backstage Club",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0796edac5c10a9d58f4dc68a5a0e825",
		  
		  "name": "Geoff",
		  "createdDate": "2013-05-27 18:18:27",
		  "totalOrganizations": 31,
		  "totalTours": 27,
		  "totalDays": 412,
		  "totalCountries": 9,
		  "totalStates": 52,
		  "totalEvents": 197,
		  "eventPercent": 0.795558,
		  "totalScheduleItems": 2245,
		  "schedulePercent": 0.75442,
		  "totalGuests": 740,
		  "guestPercent": 0.794198,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0808ed3b0c3d5fcf1cd5ba9eceec4cc",
		  
		  "name": "Ron",
		  "createdDate": "2014-10-30 02:45:42",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "La Crosse Center",
		  "mostGuestCity": "La Crosse",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e086c7a23857de6b4f5a585e367df888",
		  
		  "name": "Quintin",
		  "createdDate": "2014-12-07 08:26:16",
		  "totalOrganizations": 21,
		  "totalTours": 6,
		  "totalDays": 628,
		  "totalCountries": 9,
		  "totalStates": 53,
		  "totalEvents": 301,
		  "eventPercent": 0.913645,
		  "totalScheduleItems": 2610,
		  "schedulePercent": 0.799184,
		  "totalGuests": 481,
		  "guestPercent": 0.724615,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "The Theater @ MGM National Harbor",
		  "mostGuestCity": "Oxon Hill",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0960f11cd302db59e35282f0bfbd075",
		  
		  "name": "Bella",
		  "createdDate": "2022-07-28 01:03:44",
		  "totalOrganizations": 20,
		  "totalTours": 32,
		  "totalDays": 1460,
		  "totalCountries": 12,
		  "totalStates": 75,
		  "totalEvents": 426,
		  "eventPercent": 0.964755,
		  "totalScheduleItems": 7386,
		  "schedulePercent": 0.988327,
		  "totalGuests": 2020,
		  "guestPercent": 0.948663,
		  "mostGuestDate": "2025-09-09 00:00:00",
		  "mostGuestName": "Radio City Music Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0a23a340ccb6f383b48461f45442097",
		  
		  "name": "Caroline",
		  "createdDate": "2021-11-16 10:31:06",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 296,
		  "totalCountries": 15,
		  "totalStates": 16,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 1114,
		  "schedulePercent": 0.521872,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "ZÃ©nith de Rouen",
		  "mostGuestCity": "Le Grand-Quevilly",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0a6746fb425e2c29d7e857d4be98ccf",
		  
		  "name": "Josh",
		  "createdDate": "2020-01-03 15:13:35",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 127,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "The Ark",
		  "mostGuestCity": "Ann Arbor",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0aaa55a1b4a166c26b1428c4908aad5",
		  
		  "name": "Julien",
		  "createdDate": "2013-09-18 14:45:54",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 97,
		  "totalCountries": 11,
		  "totalStates": 18,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 903,
		  "schedulePercent": 0.459089,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "FESTIVAL LE JARDIN DU MICHEL",
		  "mostGuestCity": "DOMMARTIN LES TOUL",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0acc4ab5a4413551c64d7a268d8594d",
		  
		  "name": "Jenn",
		  "createdDate": "2022-02-09 00:06:31",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 511,
		  "totalCountries": 11,
		  "totalStates": 53,
		  "totalEvents": 123,
		  "eventPercent": 0.633046,
		  "totalScheduleItems": 1856,
		  "schedulePercent": 0.686537,
		  "totalGuests": 827,
		  "guestPercent": 0.81437,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0ae7a2f09395db0d7d7f79ac3d795fb",
		  
		  "name": "John",
		  "createdDate": "2022-05-10 09:26:33",
		  "totalOrganizations": 22,
		  "totalTours": 10,
		  "totalDays": 268,
		  "totalCountries": 15,
		  "totalStates": 65,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 2015,
		  "schedulePercent": 0.716455,
		  "totalGuests": 129,
		  "guestPercent": 0.543518,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "Revolution Hall",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0b1b3650ad693cbafb2abe1742d6cb1",
		  
		  "name": "Kyle",
		  "createdDate": "2015-10-20 02:41:05",
		  "totalOrganizations": 19,
		  "totalTours": 10,
		  "totalDays": 403,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 2398,
		  "schedulePercent": 0.775045,
		  "totalGuests": 1514,
		  "guestPercent": 0.911378,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Alpine Valley Music Theatre",
		  "mostGuestCity": "East Troy",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0bcbf5b09de126f8fc61190d2d28be6",
		  
		  "name": "Camila",
		  "createdDate": "2025-05-07 15:32:11",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 217,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 565,
		  "schedulePercent": 0.338735,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0c31d6cde8f494ab4bc206fcee98eb7",
		  
		  "name": "Gareth",
		  "createdDate": "2016-02-18 19:40:01",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 379,
		  "totalCountries": 17,
		  "totalStates": 39,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 2612,
		  "schedulePercent": 0.799297,
		  "totalGuests": 289,
		  "guestPercent": 0.643699,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "CHALK",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0d06f149528aa3c1f45b424bb687fa7",
		  
		  "name": "Elisa",
		  "createdDate": "2019-10-11 17:43:48",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 167,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 238,
		  "schedulePercent": 0.183704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0d60e449a918a720e87898ca1b471cd",
		  
		  "name": "David",
		  "createdDate": "2010-10-20 17:45:52",
		  "totalOrganizations": 18,
		  "totalTours": 17,
		  "totalDays": 1759,
		  "totalCountries": 32,
		  "totalStates": 58,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 5361,
		  "schedulePercent": 0.964415,
		  "totalGuests": 779,
		  "guestPercent": 0.802244,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0d8e3eff148243a63e97b29935a1f4f",
		  
		  "name": "Anthony",
		  "createdDate": "2022-09-09 19:19:03",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 110,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1317,
		  "schedulePercent": 0.575476,
		  "totalGuests": 814,
		  "guestPercent": 0.812103,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0ee5719a377522e9310d84044413c12",
		  
		  "name": "Meera",
		  "createdDate": "2023-06-01 17:29:24",
		  "totalOrganizations": 16,
		  "totalTours": 21,
		  "totalDays": 3661,
		  "totalCountries": 39,
		  "totalStates": 76,
		  "totalEvents": 391,
		  "eventPercent": 0.956482,
		  "totalScheduleItems": 7189,
		  "schedulePercent": 0.987647,
		  "totalGuests": 1812,
		  "guestPercent": 0.934044,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0ee72259118bfdbb13273856902de9d",
		  
		  "name": "Etjen",
		  "createdDate": "2012-04-22 16:11:10",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 473,
		  "totalCountries": 18,
		  "totalStates": 66,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 2361,
		  "schedulePercent": 0.770059,
		  "totalGuests": 1349,
		  "guestPercent": 0.893019,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e0f35f3784de48e88774c04351784b32",
		  
		  "name": "Parker",
		  "createdDate": "2025-03-31 15:22:33",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 141,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 401,
		  "schedulePercent": 0.269719,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e106909c288e23c178f9f88d6a942ea8",
		  
		  "name": "Julia ",
		  "createdDate": "2024-02-29 20:54:27",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 369,
		  "totalCountries": 12,
		  "totalStates": 29,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1326,
		  "schedulePercent": 0.577743,
		  "totalGuests": 712,
		  "guestPercent": 0.788418,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e107ead36a2765659cb32314ce32ec65",
		  
		  "name": "Steve ",
		  "createdDate": "2023-08-23 06:33:30",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 83,
		  "totalCountries": 7,
		  "totalStates": 20,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 807,
		  "schedulePercent": 0.425657,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e10b12ea02d4dfcdbc4759b5b78628bf",
		  
		  "name": "Candice",
		  "createdDate": "2025-08-23 11:23:20",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 44,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 6,
		  "eventPercent": 0.0499773,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e10e7b26f817df45635fc1c787615b7d",
		  
		  "name": "Eleanor",
		  "createdDate": "2023-08-19 17:16:08",
		  "totalOrganizations": 4,
		  "totalTours": 21,
		  "totalDays": 480,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 2604,
		  "schedulePercent": 0.797824,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e121529bd5e1de9717de03b4493433ed",
		  
		  "name": "Kevin",
		  "createdDate": "2020-02-17 04:53:59",
		  "totalOrganizations": 11,
		  "totalTours": 16,
		  "totalDays": 1517,
		  "totalCountries": 26,
		  "totalStates": 64,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 4321,
		  "schedulePercent": 0.93189,
		  "totalGuests": 784,
		  "guestPercent": 0.80417,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Colosseum Theater at Caesars Palace",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e124847cdd983dfe4a993da93c152491",
		  
		  "name": "Whitney",
		  "createdDate": "2019-04-02 21:46:08",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 1103,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 244,
		  "eventPercent": 0.86514,
		  "totalScheduleItems": 2807,
		  "schedulePercent": 0.823436,
		  "totalGuests": 583,
		  "guestPercent": 0.75408,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Billy Bob's",
		  "mostGuestCity": "Ft. Worth",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e125f272d1eefbb406fbbcdf8425da2d",
		  
		  "name": "Sean",
		  "createdDate": "2009-07-24 00:04:55",
		  "totalOrganizations": 14,
		  "totalTours": 20,
		  "totalDays": 679,
		  "totalCountries": 32,
		  "totalStates": 69,
		  "totalEvents": 271,
		  "eventPercent": 0.891092,
		  "totalScheduleItems": 2680,
		  "schedulePercent": 0.807004,
		  "totalGuests": 308,
		  "guestPercent": 0.653105,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "The O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1408da3c309dec08457529e95ef10a7",
		  
		  "name": "STEPHANE",
		  "createdDate": "2023-09-20 08:15:16",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 722,
		  "totalCountries": 7,
		  "totalStates": 20,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 3247,
		  "schedulePercent": 0.863667,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-07-14 00:00:00",
		  "mostGuestName": "Francofolies",
		  "mostGuestCity": "La Rochelle",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1453269947e1bef6445fc4d4366c3ab",
		  
		  "name": "Tucker",
		  "createdDate": "2017-07-08 22:08:01",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 309,
		  "totalCountries": 11,
		  "totalStates": 31,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1411,
		  "schedulePercent": 0.600408,
		  "totalGuests": 223,
		  "guestPercent": 0.608568,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "ICON Festival stage at small park",
		  "mostGuestCity": "Cincinnati",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e147f5ea52ebf08baa5a1df8132e03df",
		  
		  "name": "Vincent",
		  "createdDate": "2018-09-11 20:18:42",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 572,
		  "totalCountries": 22,
		  "totalStates": 50,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 2317,
		  "schedulePercent": 0.764279,
		  "totalGuests": 318,
		  "guestPercent": 0.658772,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "Sphere",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e153ba53ba4316440fed694c6216315a",
		  
		  "name": "Scott",
		  "createdDate": "2020-03-11 22:13:41",
		  "totalOrganizations": 7,
		  "totalTours": 23,
		  "totalDays": 201,
		  "totalCountries": 5,
		  "totalStates": 15,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1132,
		  "schedulePercent": 0.528785,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Tom Moffatt Waikiki Shell",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e15af1074bf7eec20eeb09a0bd95cb75",
		  
		  "name": "Jackson",
		  "createdDate": "2016-11-14 13:18:19",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 163,
		  "totalCountries": 32,
		  "totalStates": 32,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1026,
		  "schedulePercent": 0.498073,
		  "totalGuests": 259,
		  "guestPercent": 0.628626,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "The Garage",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e15b42d3f62619a01bf35cf033cf6805",
		  
		  "name": "Niki",
		  "createdDate": "2019-08-31 02:51:51",
		  "totalOrganizations": 14,
		  "totalTours": 12,
		  "totalDays": 616,
		  "totalCountries": 17,
		  "totalStates": 45,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 893,
		  "schedulePercent": 0.455576,
		  "totalGuests": 366,
		  "guestPercent": 0.67985,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Danforth Music Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e15b6cb97269fec538658c92d9e6c458",
		  
		  "name": "Christopher",
		  "createdDate": "2015-09-14 23:12:41",
		  "totalOrganizations": 62,
		  "totalTours": 38,
		  "totalDays": 1357,
		  "totalCountries": 29,
		  "totalStates": 66,
		  "totalEvents": 664,
		  "eventPercent": 0.99014,
		  "totalScheduleItems": 4640,
		  "schedulePercent": 0.942316,
		  "totalGuests": 376,
		  "guestPercent": 0.68427,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "Little Caesars Arena",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e163e3bc9593d76835519e7183c3289d",
		  
		  "name": "Serena",
		  "createdDate": "2018-10-30 16:17:25",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 172,
		  "totalCountries": 18,
		  "totalStates": 33,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 864,
		  "schedulePercent": 0.446056,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The Trades Club",
		  "mostGuestCity": "Hebden Bridge",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1677924950d427222a20ddacfd31b30",
		  
		  "name": "Guilhem",
		  "createdDate": "2023-02-03 05:23:21",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 561,
		  "totalCountries": 19,
		  "totalStates": 26,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 995,
		  "schedulePercent": 0.489461,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "YES",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e168f182653bf2000338e20ff3b64958",
		  
		  "name": "Anthony",
		  "createdDate": "2023-07-04 11:35:05",
		  "totalOrganizations": 12,
		  "totalTours": 16,
		  "totalDays": 1204,
		  "totalCountries": 21,
		  "totalStates": 49,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 2151,
		  "schedulePercent": 0.74014,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Fryshuset Klubben",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e16ad3dcc1478caf461ed47b0020bf83",
		  
		  "name": "Louise",
		  "createdDate": "2016-10-16 12:15:27",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 156,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 585,
		  "schedulePercent": 0.345648,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1740c986cdae861389a9bd5b720101a",
		  
		  "name": "Haley",
		  "createdDate": "2022-08-22 19:35:08",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 415,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 2961,
		  "schedulePercent": 0.838055,
		  "totalGuests": 825,
		  "guestPercent": 0.813803,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Abba's House",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e177ba104fa486c2f5a88c01da7f822c",
		  
		  "name": "Deanna",
		  "createdDate": "2014-12-12 16:55:25",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 214,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1117,
		  "schedulePercent": 0.523119,
		  "totalGuests": 2696,
		  "guestPercent": 0.975635,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e17c49c3bfb5a2694988f15c5ac6b0f6",
		  
		  "name": "Zachary",
		  "createdDate": "2025-10-15 19:18:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 133,
		  "schedulePercent": 0.120467,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1852f0240db045c671f92eada7128be",
		  
		  "name": "Andy",
		  "createdDate": "2016-06-28 04:17:04",
		  "totalOrganizations": 14,
		  "totalTours": 28,
		  "totalDays": 1034,
		  "totalCountries": 11,
		  "totalStates": 71,
		  "totalEvents": 305,
		  "eventPercent": 0.915798,
		  "totalScheduleItems": 3765,
		  "schedulePercent": 0.900045,
		  "totalGuests": 1395,
		  "guestPercent": 0.899932,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stone Pony Summer Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e19293908cc6120344649fced8cb156f",
		  
		  "name": "Casey",
		  "createdDate": "2012-07-28 17:52:26",
		  "totalOrganizations": 11,
		  "totalTours": 24,
		  "totalDays": 370,
		  "totalCountries": 11,
		  "totalStates": 52,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 1768,
		  "schedulePercent": 0.671011,
		  "totalGuests": 1251,
		  "guestPercent": 0.88044,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1990f848f29f4115bc10b32aa0824ba",
		  
		  "name": "Kevin",
		  "createdDate": "2025-04-04 17:36:14",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 271,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 1820,
		  "schedulePercent": 0.67951,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1bacbcdddebb21d1da8a025eb8b501e",
		  
		  "name": "Production",
		  "createdDate": "2021-05-03 14:27:18",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 746,
		  "totalCountries": 14,
		  "totalStates": 31,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1c0e09885ce1002ac0e8d95560eab04",
		  
		  "name": "Jordan",
		  "createdDate": "2011-09-09 23:28:10",
		  "totalOrganizations": 17,
		  "totalTours": 19,
		  "totalDays": 696,
		  "totalCountries": 27,
		  "totalStates": 83,
		  "totalEvents": 279,
		  "eventPercent": 0.897439,
		  "totalScheduleItems": 6207,
		  "schedulePercent": 0.978468,
		  "totalGuests": 4021,
		  "guestPercent": 0.993314,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1d2da529922cf81722b50117cfb9a6c",
		  
		  "name": "Max",
		  "createdDate": "2012-02-24 09:31:25",
		  "totalOrganizations": 13,
		  "totalTours": 19,
		  "totalDays": 822,
		  "totalCountries": 26,
		  "totalStates": 68,
		  "totalEvents": 192,
		  "eventPercent": 0.786038,
		  "totalScheduleItems": 2968,
		  "schedulePercent": 0.839189,
		  "totalGuests": 1242,
		  "guestPercent": 0.87976,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 280,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1dc82bef42d033bfbbe8b51e84f5bfb",
		  
		  "name": "Jim",
		  "createdDate": "2017-07-10 12:14:00",
		  "totalOrganizations": 17,
		  "totalTours": 19,
		  "totalDays": 626,
		  "totalCountries": 32,
		  "totalStates": 84,
		  "totalEvents": 375,
		  "eventPercent": 0.952403,
		  "totalScheduleItems": 3122,
		  "schedulePercent": 0.853241,
		  "totalGuests": 2294,
		  "guestPercent": 0.961695,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Utilita Arena Birmingham",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1e2deb628f722b568e9f23326a461f5",
		  
		  "name": "CCM INTL",
		  "createdDate": "2025-04-16 12:42:29",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 251,
		  "totalCountries": 10,
		  "totalStates": 36,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 896,
		  "schedulePercent": 0.456596,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1e9d78a845c525ac802ac42dc9b98f1",
		  
		  "name": "Nicky",
		  "createdDate": "2010-09-17 14:59:15",
		  "totalOrganizations": 24,
		  "totalTours": 26,
		  "totalDays": 919,
		  "totalCountries": 21,
		  "totalStates": 75,
		  "totalEvents": 383,
		  "eventPercent": 0.954216,
		  "totalScheduleItems": 5545,
		  "schedulePercent": 0.968495,
		  "totalGuests": 3475,
		  "guestPercent": 0.989574,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1ee4ffa292d0a8eab9fa9c84510b35d",
		  
		  "name": "Em ",
		  "createdDate": "2023-02-08 05:37:48",
		  "totalOrganizations": 1,
		  "totalTours": 9,
		  "totalDays": 563,
		  "totalCountries": 24,
		  "totalStates": 40,
		  "totalEvents": 280,
		  "eventPercent": 0.898345,
		  "totalScheduleItems": 2184,
		  "schedulePercent": 0.745467,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1f059684b0b266e2bf0101c0f98bbb2",
		  
		  "name": "Scott",
		  "createdDate": "2015-06-06 23:33:26",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 148,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 1051,
		  "schedulePercent": 0.504873,
		  "totalGuests": 23,
		  "guestPercent": 0.404125,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "Nile Theater",
		  "mostGuestCity": "Mesa",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1f5fa349a0f3e26e7b69c55c5c4e053",
		  
		  "name": "Steve",
		  "createdDate": "2022-04-27 16:49:02",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 147,
		  "totalCountries": 18,
		  "totalStates": 41,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1156,
		  "schedulePercent": 0.536151,
		  "totalGuests": 520,
		  "guestPercent": 0.736061,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e1fde615b8256c4b09022cb9a4d8f0cc",
		  
		  "name": "William",
		  "createdDate": "2023-07-07 23:00:13",
		  "totalOrganizations": 15,
		  "totalTours": 16,
		  "totalDays": 2911,
		  "totalCountries": 19,
		  "totalStates": 59,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 3136,
		  "schedulePercent": 0.854488,
		  "totalGuests": 1042,
		  "guestPercent": 0.853015,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e200b5ce36e50a04e71474ee2936fbd1",
		  
		  "name": "Hope",
		  "createdDate": "2017-03-22 13:58:51",
		  "totalOrganizations": 9,
		  "totalTours": 14,
		  "totalDays": 1580,
		  "totalCountries": 31,
		  "totalStates": 75,
		  "totalEvents": 613,
		  "eventPercent": 0.987987,
		  "totalScheduleItems": 9342,
		  "schedulePercent": 0.995354,
		  "totalGuests": 2642,
		  "guestPercent": 0.973708,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2027946ffabdb9679fe09645f1d55fa",
		  
		  "name": "Liv ",
		  "createdDate": "2023-05-04 05:07:22",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 1180,
		  "totalCountries": 9,
		  "totalStates": 48,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 255,
		  "schedulePercent": 0.19311,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Fountain Blues Festival",
		  "mostGuestCity": "San Jose",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2040041aa11df50f0492280d56243e3",
		  
		  "name": "Gabriela ",
		  "createdDate": "2022-08-03 16:07:11",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 655,
		  "totalCountries": 9,
		  "totalStates": 22,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1692,
		  "schedulePercent": 0.657298,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Movistar Arena Madrid",
		  "mostGuestCity": "Madrid",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e20778b2c8e8e9f043c7a0af2b671ed1",
		  
		  "name": "Edd",
		  "createdDate": "2018-02-04 08:59:13",
		  "totalOrganizations": 25,
		  "totalTours": 22,
		  "totalDays": 1513,
		  "totalCountries": 45,
		  "totalStates": 99,
		  "totalEvents": 553,
		  "eventPercent": 0.984361,
		  "totalScheduleItems": 8670,
		  "schedulePercent": 0.992634,
		  "totalGuests": 1774,
		  "guestPercent": 0.93189,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2084ac1a93d46b5bb762cabd6810ffb",
		  
		  "name": "Michelle",
		  "createdDate": "2013-06-28 22:20:21",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 577,
		  "totalCountries": 8,
		  "totalStates": 45,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2525,
		  "schedulePercent": 0.788985,
		  "totalGuests": 2804,
		  "guestPercent": 0.978015,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e219e6515d0d994f73a3c09f2a2166b2",
		  
		  "name": "Aarron",
		  "createdDate": "2014-07-27 00:53:55",
		  "totalOrganizations": 34,
		  "totalTours": 35,
		  "totalDays": 1280,
		  "totalCountries": 15,
		  "totalStates": 73,
		  "totalEvents": 445,
		  "eventPercent": 0.969288,
		  "totalScheduleItems": 5514,
		  "schedulePercent": 0.967702,
		  "totalGuests": 1795,
		  "guestPercent": 0.933024,
		  "mostGuestDate": "2025-08-26 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 77,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e22160c3615d16789af9d2b5e56e69e6",
		  
		  "name": "Andre",
		  "createdDate": "2013-07-04 00:43:15",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 161,
		  "totalCountries": 26,
		  "totalStates": 30,
		  "totalEvents": 89,
		  "eventPercent": 0.508273,
		  "totalScheduleItems": 962,
		  "schedulePercent": 0.479488,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Lollapalooza Festival Argentina",
		  "mostGuestCity": "San Isidro",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e22198cb36f92407874f63a4cb51cc04",
		  
		  "name": "Justin",
		  "createdDate": "2024-06-07 03:23:29",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 170,
		  "totalCountries": 9,
		  "totalStates": 27,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 644,
		  "schedulePercent": 0.365367,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-03-26 00:00:00",
		  "mostGuestName": "Factory Town",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2280d2fe2cfa69e1c16d1bb454f04de",
		  
		  "name": "Ike",
		  "createdDate": "2009-07-16 01:12:11",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 173,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1590,
		  "schedulePercent": 0.638373,
		  "totalGuests": 535,
		  "guestPercent": 0.738894,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 159,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e24b01bd4635c2779af211139940a9db",
		  
		  "name": "Leo",
		  "createdDate": "2023-03-24 15:21:46",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 155,
		  "totalCountries": 21,
		  "totalStates": 7,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 827,
		  "schedulePercent": 0.43325,
		  "totalGuests": 308,
		  "guestPercent": 0.653105,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "QUARTERBACK Immobilien ARENA",
		  "mostGuestCity": "Leipzig",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e254bbba2f616ab518c6c61557c0a63d",
		  
		  "name": "Chris ",
		  "createdDate": "2012-05-11 16:33:58",
		  "totalOrganizations": 24,
		  "totalTours": 2,
		  "totalDays": 151,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1111,
		  "schedulePercent": 0.521079,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e26e39b62ee4052f71592cd83197d998",
		  
		  "name": "Louise",
		  "createdDate": "2019-11-29 13:39:50",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 38,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 54,
		  "schedulePercent": 0.06267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2825148bc804076018f491807466f68",
		  
		  "name": "Tone",
		  "createdDate": "2015-11-02 15:04:57",
		  "totalOrganizations": 87,
		  "totalTours": 45,
		  "totalDays": 1277,
		  "totalCountries": 18,
		  "totalStates": 73,
		  "totalEvents": 488,
		  "eventPercent": 0.977108,
		  "totalScheduleItems": 4844,
		  "schedulePercent": 0.948663,
		  "totalGuests": 924,
		  "guestPercent": 0.834882,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "South Side Ballroom",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e286c10580136449ad54412d84499134",
		  
		  "name": "Chris",
		  "createdDate": "2023-04-17 15:51:36",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 846,
		  "totalCountries": 6,
		  "totalStates": 54,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 3208,
		  "schedulePercent": 0.860607,
		  "totalGuests": 1194,
		  "guestPercent": 0.875453,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Harveys Lake Tahoe Hotel & Casino",
		  "mostGuestCity": "South Lake Tahoe",
		  "mostGuestAmount": 95,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e28b1915880ad401a8380e2d0da4f090",
		  
		  "name": "Lindsay",
		  "createdDate": "2023-02-11 09:05:30",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 258,
		  "totalCountries": 28,
		  "totalStates": 33,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1166,
		  "schedulePercent": 0.539325,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e29ec40baa41fc18b152d6fef025db2b",
		  
		  "name": "Vincent",
		  "createdDate": "2023-05-16 16:22:04",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 117,
		  "schedulePercent": 0.108794,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2aa6020759c4431bc7b9fa4bf828fdc",
		  
		  "name": "Emma",
		  "createdDate": "2024-05-25 02:52:34",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 381,
		  "totalCountries": 24,
		  "totalStates": 33,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2445,
		  "schedulePercent": 0.780372,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2b02599c5c78537025c431054355b85",
		  
		  "name": "Clare",
		  "createdDate": "2025-08-06 15:56:42",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 232,
		  "schedulePercent": 0.17883,
		  "totalGuests": 163,
		  "guestPercent": 0.568223,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Fred Kavli Theater",
		  "mostGuestCity": "Thousand Oaks",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2bc1a8471575541dda5e71c844db6b2",
		  
		  "name": "Sameen",
		  "createdDate": "2020-09-07 15:58:47",
		  "totalOrganizations": 4,
		  "totalTours": 21,
		  "totalDays": 426,
		  "totalCountries": 11,
		  "totalStates": 41,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 4125,
		  "schedulePercent": 0.920784,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2ca73b92ab2a1c0dc5426dfe0b4bd9a",
		  
		  "name": "John",
		  "createdDate": "2017-01-04 18:01:27",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 827,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2735,
		  "schedulePercent": 0.81369,
		  "totalGuests": 2491,
		  "guestPercent": 0.967588,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2cb750ebbdd6ca7e34a3dbfd45f2804",
		  
		  "name": "Jaden",
		  "createdDate": "2025-04-24 02:03:05",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 7,
		  "totalStates": 16,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 305,
		  "schedulePercent": 0.219402,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2d613a7ad6353d9cafb4c7047fa7477",
		  
		  "name": "Joshua",
		  "createdDate": "2015-07-22 11:07:16",
		  "totalOrganizations": 13,
		  "totalTours": 10,
		  "totalDays": 345,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1688,
		  "schedulePercent": 0.656505,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Northcote Social Club",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2e195060d001c28cb22363d03ee973e",
		  
		  "name": "Auguri",
		  "createdDate": "2014-02-01 15:34:31",
		  "totalOrganizations": 19,
		  "totalTours": 11,
		  "totalDays": 1004,
		  "totalCountries": 8,
		  "totalStates": 22,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 2255,
		  "schedulePercent": 0.75578,
		  "totalGuests": 168,
		  "guestPercent": 0.572303,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre National Wallonie-Bruxelles",
		  "mostGuestCity": "Bruxelles",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2f63e3df96888639b0691b9740d2c75",
		  
		  "name": "Kylie",
		  "createdDate": "2022-11-15 13:26:19",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 494,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 432,
		  "eventPercent": 0.966908,
		  "totalScheduleItems": 1620,
		  "schedulePercent": 0.644152,
		  "totalGuests": 166,
		  "guestPercent": 0.570263,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Cannery Ballroom",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e2ff73aa5f2810df7b7800131d48ced3",
		  
		  "name": "Shane",
		  "createdDate": "2025-08-13 21:48:53",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 64,
		  "totalCountries": 10,
		  "totalStates": 4,
		  "totalEvents": 8,
		  "eventPercent": 0.06335,
		  "totalScheduleItems": 145,
		  "schedulePercent": 0.12772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e30e3b1ba22ddacd7e902e3bf9bf8641",
		  
		  "name": "Alf",
		  "createdDate": "2019-02-19 11:12:35",
		  "totalOrganizations": 13,
		  "totalTours": 3,
		  "totalDays": 115,
		  "totalCountries": 7,
		  "totalStates": 5,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 627,
		  "schedulePercent": 0.359701,
		  "totalGuests": 114,
		  "guestPercent": 0.531505,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "Zupermaria // Parkteateret",
		  "mostGuestCity": "",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e31547b198b51117093a35211399f521",
		  
		  "name": "Ollie",
		  "createdDate": "2019-10-11 16:44:32",
		  "totalOrganizations": 52,
		  "totalTours": 40,
		  "totalDays": 1955,
		  "totalCountries": 13,
		  "totalStates": 25,
		  "totalEvents": 447,
		  "eventPercent": 0.970422,
		  "totalScheduleItems": 3091,
		  "schedulePercent": 0.850861,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e321b4a42fc190cfd17b9327a98f0101",
		  
		  "name": "AJ",
		  "createdDate": "2014-10-21 18:53:42",
		  "totalOrganizations": 16,
		  "totalTours": 14,
		  "totalDays": 835,
		  "totalCountries": 18,
		  "totalStates": 44,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 2567,
		  "schedulePercent": 0.794651,
		  "totalGuests": 1450,
		  "guestPercent": 0.904578,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "UBS Arena",
		  "mostGuestCity": "Elmont",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e322e169ff9524b47a85c6ba43760f3d",
		  
		  "name": "Sarah- Anne",
		  "createdDate": "2015-03-16 12:04:11",
		  "totalOrganizations": 17,
		  "totalTours": 13,
		  "totalDays": 1178,
		  "totalCountries": 27,
		  "totalStates": 53,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 2841,
		  "schedulePercent": 0.826949,
		  "totalGuests": 89,
		  "guestPercent": 0.50714,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Cine Joia ",
		  "mostGuestCity": "SÃ£o Paulo",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e32ccce124284ec3a9a1bdb875fab00b",
		  
		  "name": "Sabrina",
		  "createdDate": "2024-12-27 23:57:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 248,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 1955,
		  "schedulePercent": 0.704216,
		  "totalGuests": 2521,
		  "guestPercent": 0.968722,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e32de6ee7044670fc7d0f2a6444a8be1",
		  
		  "name": "Joris",
		  "createdDate": "2025-07-11 20:06:15",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 259,
		  "totalCountries": 20,
		  "totalStates": 18,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1105,
		  "schedulePercent": 0.520059,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e32fdbc308b214bb02682b1d501e0782",
		  
		  "name": "Aoife",
		  "createdDate": "2016-08-02 09:18:35",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 826,
		  "totalCountries": 24,
		  "totalStates": 29,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 2114,
		  "schedulePercent": 0.734474,
		  "totalGuests": 616,
		  "guestPercent": 0.762919,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e334cd67f75b6069c6438935dc81af5f",
		  
		  "name": "Omar",
		  "createdDate": "2017-05-30 01:38:58",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 59,
		  "totalCountries": 7,
		  "totalStates": 5,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 138,
		  "schedulePercent": 0.123527,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e339e823ed7af9fb2811e4429f0a323b",
		  
		  "name": "Rylie",
		  "createdDate": "2025-02-08 02:07:39",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 239,
		  "totalCountries": 5,
		  "totalStates": 53,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1901,
		  "schedulePercent": 0.69515,
		  "totalGuests": 3502,
		  "guestPercent": 0.989687,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e33a120eb8097227d5d69029a16dea3e",
		  
		  "name": "Nash",
		  "createdDate": "2019-05-15 20:41:48",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 71,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 806,
		  "schedulePercent": 0.424751,
		  "totalGuests": 1106,
		  "guestPercent": 0.865027,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Galopprennbahn KÃ¶ln-Weidenpesch",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e34630f4782e9d391456324deba583fc",
		  
		  "name": "Lizzie",
		  "createdDate": "2018-07-31 12:27:26",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 159,
		  "totalCountries": 10,
		  "totalStates": 11,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 1050,
		  "schedulePercent": 0.50442,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e34890840c512438c1cee3f39cf37c8c",
		  
		  "name": "Brody",
		  "createdDate": "2022-10-07 08:02:47",
		  "totalOrganizations": 6,
		  "totalTours": 17,
		  "totalDays": 378,
		  "totalCountries": 10,
		  "totalStates": 59,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 1953,
		  "schedulePercent": 0.703876,
		  "totalGuests": 1568,
		  "guestPercent": 0.916478,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "BRIC",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e34e06545b681f71bec0d407559ec67e",
		  
		  "name": "Jason",
		  "createdDate": "2009-09-16 15:18:10",
		  "totalOrganizations": 6,
		  "totalTours": 22,
		  "totalDays": 553,
		  "totalCountries": 10,
		  "totalStates": 48,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 5373,
		  "schedulePercent": 0.964755,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3539ab8205f9105fc0f4976c75e7d88",
		  
		  "name": "Priscila",
		  "createdDate": "2023-03-30 16:49:10",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3574bc3388e657574ecd2cb3b57abba",
		  
		  "name": "Victoria",
		  "createdDate": "2021-07-25 23:22:10",
		  "totalOrganizations": 8,
		  "totalTours": 28,
		  "totalDays": 748,
		  "totalCountries": 15,
		  "totalStates": 65,
		  "totalEvents": 339,
		  "eventPercent": 0.936537,
		  "totalScheduleItems": 4861,
		  "schedulePercent": 0.949909,
		  "totalGuests": 2462,
		  "guestPercent": 0.966682,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e35e41a37b643d268403ae0044f007a4",
		  
		  "name": "Phil",
		  "createdDate": "2021-08-07 07:57:35",
		  "totalOrganizations": 26,
		  "totalTours": 48,
		  "totalDays": 1030,
		  "totalCountries": 38,
		  "totalStates": 119,
		  "totalEvents": 596,
		  "eventPercent": 0.987307,
		  "totalScheduleItems": 6880,
		  "schedulePercent": 0.985381,
		  "totalGuests": 2145,
		  "guestPercent": 0.955576,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3632cc26ab21a88d4903ee691967346",
		  
		  "name": "Beth",
		  "createdDate": "2022-02-10 15:17:27",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 200,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1087,
		  "schedulePercent": 0.516432,
		  "totalGuests": 411,
		  "guestPercent": 0.697869,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "RADIO/EAST",
		  "mostGuestCity": "Austin",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e376b03a896a222369ef1d065cefe676",
		  
		  "name": "Amelia",
		  "createdDate": "2024-05-02 12:43:38",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 1307,
		  "totalCountries": 28,
		  "totalStates": 35,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 1435,
		  "schedulePercent": 0.605054,
		  "totalGuests": 326,
		  "guestPercent": 0.664211,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Brockwell Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e37e4becdee64017919b8f84d51f3e6f",
		  
		  "name": "Benjamin",
		  "createdDate": "2025-01-08 21:52:17",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 386,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 357,
		  "schedulePercent": 0.246714,
		  "totalGuests": 191,
		  "guestPercent": 0.586582,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e37ff9879b6c5d3f796e75ea940fbc74",
		  
		  "name": "Kelsey",
		  "createdDate": "2022-08-08 18:01:46",
		  "totalOrganizations": 5,
		  "totalTours": 16,
		  "totalDays": 180,
		  "totalCountries": 9,
		  "totalStates": 30,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 726,
		  "schedulePercent": 0.396646,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Division 88",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e390469daa57ea0e7ca0354f9ffaf312",
		  
		  "name": "Castle",
		  "createdDate": "2025-07-17 22:14:52",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 59,
		  "totalCountries": 10,
		  "totalStates": 26,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 420,
		  "schedulePercent": 0.278332,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e39f4a1288e4eadb77f047487c671a17",
		  
		  "name": "Danny",
		  "createdDate": "2015-08-19 15:31:45",
		  "totalOrganizations": 15,
		  "totalTours": 36,
		  "totalDays": 855,
		  "totalCountries": 25,
		  "totalStates": 90,
		  "totalEvents": 471,
		  "eventPercent": 0.973935,
		  "totalScheduleItems": 6479,
		  "schedulePercent": 0.981868,
		  "totalGuests": 3092,
		  "guestPercent": 0.983794,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3ac9715e434b9b55bffa610252836ec",
		  
		  "name": "Nicole",
		  "createdDate": "2023-08-18 14:52:07",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 263,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2673,
		  "schedulePercent": 0.80587,
		  "totalGuests": 571,
		  "guestPercent": 0.750227,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3bc0841295bcf71faa80797db5b5827",
		  
		  "name": "Katie",
		  "createdDate": "2024-02-16 11:10:45",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 225,
		  "totalCountries": 14,
		  "totalStates": 18,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1152,
		  "schedulePercent": 0.535471,
		  "totalGuests": 370,
		  "guestPercent": 0.68121,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "O2 Forum Kentish Town",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3c5e84d85649780527869a2870b0a57",
		  
		  "name": "Macseal",
		  "createdDate": "2022-10-03 20:19:07",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 136,
		  "totalCountries": 12,
		  "totalStates": 51,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1079,
		  "schedulePercent": 0.513826,
		  "totalGuests": 76,
		  "guestPercent": 0.493314,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Tioga-Sequoia Brewing Company Beer Garden",
		  "mostGuestCity": "Fresno",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3c7463be064b40fe33a7c2ee4ead6e8",
		  
		  "name": "Kane",
		  "createdDate": "2018-01-22 01:20:45",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 392,
		  "totalCountries": 27,
		  "totalStates": 37,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 4168,
		  "schedulePercent": 0.923391,
		  "totalGuests": 26,
		  "guestPercent": 0.411151,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Lollapalooza Festival Argentina",
		  "mostGuestCity": "San Isidro",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3ce7da03ac2379b15abe2533814b601",
		  
		  "name": "Nic",
		  "createdDate": "2018-08-01 12:33:20",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 99,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 554,
		  "schedulePercent": 0.335109,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3d0f1b8c1010ff53927c2c2942c7815",
		  
		  "name": "Oleksandr ",
		  "createdDate": "2025-05-09 08:55:50",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 148,
		  "totalCountries": 24,
		  "totalStates": 24,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 650,
		  "schedulePercent": 0.36752,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Progresja",
		  "mostGuestCity": "Warszawa",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3d2d21e4b4700c68158c02b66bd1ef0",
		  
		  "name": "Yanine",
		  "createdDate": "2024-09-28 19:56:59",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 149,
		  "totalCountries": 13,
		  "totalStates": 30,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 692,
		  "schedulePercent": 0.3835,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3d7e953ee8a53eae565f192c38f1352",
		  
		  "name": "Ryan",
		  "createdDate": "2015-09-10 19:36:04",
		  "totalOrganizations": 12,
		  "totalTours": 6,
		  "totalDays": 175,
		  "totalCountries": 20,
		  "totalStates": 44,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1706,
		  "schedulePercent": 0.659451,
		  "totalGuests": 901,
		  "guestPercent": 0.830349,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "Canadian Tire Centre",
		  "mostGuestCity": "Ottawa",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3e5fa2b0a0d023d65c6c2533dc48b91",
		  
		  "name": "Kallie ",
		  "createdDate": "2021-08-24 01:59:34",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 1127,
		  "totalCountries": 2,
		  "totalStates": 45,
		  "totalEvents": 307,
		  "eventPercent": 0.916818,
		  "totalScheduleItems": 3574,
		  "schedulePercent": 0.887239,
		  "totalGuests": 4172,
		  "guestPercent": 0.99422,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3f53b4ed2359f921910a7e210581ec4",
		  
		  "name": "Chris",
		  "createdDate": "2020-01-11 00:36:16",
		  "totalOrganizations": 7,
		  "totalTours": 23,
		  "totalDays": 330,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1439,
		  "schedulePercent": 0.605848,
		  "totalGuests": 603,
		  "guestPercent": 0.759746,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Miami Beach Bandshell",
		  "mostGuestCity": "Miami Beach",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e3f6c769414b94117989ca23c5ab50bc",
		  
		  "name": "Mike",
		  "createdDate": "2019-09-18 03:09:27",
		  "totalOrganizations": 19,
		  "totalTours": 31,
		  "totalDays": 1153,
		  "totalCountries": 28,
		  "totalStates": 90,
		  "totalEvents": 420,
		  "eventPercent": 0.963735,
		  "totalScheduleItems": 6403,
		  "schedulePercent": 0.980508,
		  "totalGuests": 626,
		  "guestPercent": 0.764279,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e400f78f9f480c4c09b210b9c069764e",
		  
		  "name": "Molly",
		  "createdDate": "2024-05-24 23:02:48",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 375,
		  "totalCountries": 23,
		  "totalStates": 39,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2367,
		  "schedulePercent": 0.771079,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e405dd175f4e42208d64f4f5d702df99",
		  
		  "name": "James",
		  "createdDate": "2023-04-05 10:04:32",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 344,
		  "totalCountries": 24,
		  "totalStates": 15,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 365,
		  "schedulePercent": 0.250907,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e413335d654cf300bd716c1a6e6c1c15",
		  
		  "name": "Mitch",
		  "createdDate": "2025-04-10 23:52:15",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 52,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 166,
		  "schedulePercent": 0.138599,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Mile One Centre",
		  "mostGuestCity": "St. John's",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e417472d8cfeb0fac0663fa2cd985724",
		  
		  "name": "Paul ",
		  "createdDate": "2025-05-20 03:29:20",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 171,
		  "totalCountries": 11,
		  "totalStates": 11,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 1148,
		  "schedulePercent": 0.533885,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e41c2b04c385e625a9d69d6ce6732fb4",
		  
		  "name": "Matriz",
		  "createdDate": "2021-05-01 06:34:22",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 916,
		  "totalCountries": 9,
		  "totalStates": 63,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 1371,
		  "schedulePercent": 0.589529,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e41f8766b60bd286818f8b8bc4783515",
		  
		  "name": "Z&#233;lia",
		  "createdDate": "2024-01-16 17:04:45",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 55,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 384,
		  "schedulePercent": 0.260653,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "Festival de Thau",
		  "mostGuestCity": "Meze",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e42a9d146ca16b66a6a784c9843ca196",
		  
		  "name": "Geron",
		  "createdDate": "2014-05-26 21:10:24",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 261,
		  "totalCountries": 25,
		  "totalStates": 37,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 3525,
		  "schedulePercent": 0.8835,
		  "totalGuests": 2708,
		  "guestPercent": 0.976428,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e42aea90c0393cc1f3a47d595554d9de",
		  
		  "name": "Ian",
		  "createdDate": "2013-09-26 10:35:04",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 22,
		  "totalCountries": 5,
		  "totalStates": 10,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 212,
		  "schedulePercent": 0.166931,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e42c5e06a2b5cf0cea168f6dd7dd377f",
		  
		  "name": "Dean",
		  "createdDate": "2010-05-02 01:49:50",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 382,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 154,
		  "schedulePercent": 0.132026,
		  "totalGuests": 11,
		  "guestPercent": 0.374093,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "330 - 11th Avenue SW - Lot #166",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4345be51da07251b52235bcbbff6e67",
		  
		  "name": "Chelsea",
		  "createdDate": "2014-03-13 21:46:44",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 623,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 4373,
		  "schedulePercent": 0.934044,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e43d51f802f3d7d873e9fc9b07889fd2",
		  
		  "name": "Julie",
		  "createdDate": "2022-02-01 22:02:17",
		  "totalOrganizations": 6,
		  "totalTours": 19,
		  "totalDays": 938,
		  "totalCountries": 15,
		  "totalStates": 62,
		  "totalEvents": 283,
		  "eventPercent": 0.900499,
		  "totalScheduleItems": 2626,
		  "schedulePercent": 0.800544,
		  "totalGuests": 1659,
		  "guestPercent": 0.924637,
		  "mostGuestDate": "2025-08-07 00:00:00",
		  "mostGuestName": "Ravinia",
		  "mostGuestCity": "Highland Park",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e44ca99c40b968beccc6d52661dc76da",
		  
		  "name": "Kellan",
		  "createdDate": "2019-07-08 06:04:13",
		  "totalOrganizations": 13,
		  "totalTours": 12,
		  "totalDays": 473,
		  "totalCountries": 13,
		  "totalStates": 56,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 2805,
		  "schedulePercent": 0.822869,
		  "totalGuests": 1359,
		  "guestPercent": 0.894946,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e450ca119ea1cca6c5134a5fdd430d93",
		  
		  "name": "Joseph ",
		  "createdDate": "2017-11-25 19:47:06",
		  "totalOrganizations": 5,
		  "totalTours": 20,
		  "totalDays": 128,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1322,
		  "schedulePercent": 0.576383,
		  "totalGuests": 1794,
		  "guestPercent": 0.932797,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e45505642a96dcdc87c6cf5e7569c9d7",
		  
		  "name": "Anthony",
		  "createdDate": "2025-04-06 01:37:05",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 147,
		  "totalCountries": 9,
		  "totalStates": 35,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 473,
		  "schedulePercent": 0.299637,
		  "totalGuests": 74,
		  "guestPercent": 0.490367,
		  "mostGuestDate": "2025-04-16 00:00:00",
		  "mostGuestName": "The Glass House",
		  "mostGuestCity": "Pomona",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e458df7eeac85803d32ac75237574849",
		  
		  "name": "Coline",
		  "createdDate": "2024-02-06 09:33:06",
		  "totalOrganizations": 1,
		  "totalTours": 23,
		  "totalDays": 716,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 224,
		  "schedulePercent": 0.173844,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "La Place, centre culturel Hip-Hop",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4663c4570af31b59a5df0611f8a1faf",
		  
		  "name": "Kaitlyn",
		  "createdDate": "2022-04-04 21:12:59",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 407,
		  "totalCountries": 8,
		  "totalStates": 30,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 1784,
		  "schedulePercent": 0.673504,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e46aec2e2912344f7ba7b5f27ba1fcb9",
		  
		  "name": "Sean ",
		  "createdDate": "2016-08-17 16:48:38",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 175,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 477,
		  "schedulePercent": 0.301677,
		  "totalGuests": 62,
		  "guestPercent": 0.473368,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "Vogue Theatre",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e46cd3f3c3c4e8e7c3e9c266cfd36421",
		  
		  "name": "Timothy",
		  "createdDate": "2014-08-21 04:28:11",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 1350,
		  "totalCountries": 9,
		  "totalStates": 48,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1638,
		  "schedulePercent": 0.647325,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Harbison Theatre at Midlands Technical College",
		  "mostGuestCity": "Irmo",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e47144d47167da7f91e408e4c805eb81",
		  
		  "name": "Erin ",
		  "createdDate": "2022-06-14 21:33:21",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 1166,
		  "totalCountries": 11,
		  "totalStates": 52,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 2129,
		  "schedulePercent": 0.736514,
		  "totalGuests": 221,
		  "guestPercent": 0.607774,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Goldfield Trading Post",
		  "mostGuestCity": "Roseville",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4759ea6e6d445c5872f934f890170c0",
		  
		  "name": "Alfie ",
		  "createdDate": "2019-02-21 13:08:37",
		  "totalOrganizations": 21,
		  "totalTours": 6,
		  "totalDays": 591,
		  "totalCountries": 6,
		  "totalStates": 10,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1573,
		  "schedulePercent": 0.635539,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e47b7b7cc78dcca3114226ebc87bb1e2",
		  
		  "name": "Josh",
		  "createdDate": "2024-01-19 03:04:36",
		  "totalOrganizations": 30,
		  "totalTours": 41,
		  "totalDays": 1022,
		  "totalCountries": 26,
		  "totalStates": 55,
		  "totalEvents": 291,
		  "eventPercent": 0.906618,
		  "totalScheduleItems": 2961,
		  "schedulePercent": 0.838055,
		  "totalGuests": 115,
		  "guestPercent": 0.532185,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Bellwether",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e47ed47665a1694b58c66890cf7af6cc",
		  
		  "name": "Anthony",
		  "createdDate": "2021-09-27 16:40:21",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 271,
		  "totalCountries": 16,
		  "totalStates": 61,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1846,
		  "schedulePercent": 0.685063,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e47f4a0e028c30c843b476d55964ab48",
		  
		  "name": "Urban",
		  "createdDate": "2013-10-06 16:55:55",
		  "totalOrganizations": 17,
		  "totalTours": 5,
		  "totalDays": 656,
		  "totalCountries": 14,
		  "totalStates": 53,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 1939,
		  "schedulePercent": 0.702063,
		  "totalGuests": 1125,
		  "guestPercent": 0.867407,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e492eb05198bbcb83b8934aa31dfb5b9",
		  
		  "name": "Josh",
		  "createdDate": "2015-10-05 01:53:16",
		  "totalOrganizations": 15,
		  "totalTours": 31,
		  "totalDays": 790,
		  "totalCountries": 15,
		  "totalStates": 54,
		  "totalEvents": 251,
		  "eventPercent": 0.871714,
		  "totalScheduleItems": 1808,
		  "schedulePercent": 0.677584,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "The Mishawaka",
		  "mostGuestCity": "Bellvue",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e496d0f012959084cba23ed5c1af3aa8",
		  
		  "name": "Marcos",
		  "createdDate": "2014-09-27 23:41:15",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 82,
		  "totalCountries": 8,
		  "totalStates": 12,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 145,
		  "schedulePercent": 0.12772,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e49d5b1408010e8824b69148126a1c85",
		  
		  "name": "Gary",
		  "createdDate": "2013-05-15 21:57:51",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 819,
		  "totalCountries": 14,
		  "totalStates": 52,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2568,
		  "schedulePercent": 0.795104,
		  "totalGuests": 1673,
		  "guestPercent": 0.926337,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4a3c9306ea2bf428489791c9cbb271f",
		  
		  "name": "Ian",
		  "createdDate": "2017-07-24 13:07:58",
		  "totalOrganizations": 15,
		  "totalTours": 16,
		  "totalDays": 586,
		  "totalCountries": 16,
		  "totalStates": 49,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 2705,
		  "schedulePercent": 0.80893,
		  "totalGuests": 586,
		  "guestPercent": 0.755213,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "PNE Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4a80231383fe441a09197b49bbd83a0",
		  
		  "name": "Nate",
		  "createdDate": "2014-12-12 17:44:43",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 56,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 634,
		  "schedulePercent": 0.361854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4ac4bcd55d599f968d2279aacccd472",
		  
		  "name": "Mark",
		  "createdDate": "2024-11-19 21:26:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 362,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 913,
		  "schedulePercent": 0.462602,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4ae0882d46788b472443168b8158600",
		  
		  "name": "Tim",
		  "createdDate": "2019-07-17 16:11:13",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 61,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 263,
		  "schedulePercent": 0.196056,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "Rock City",
		  "mostGuestCity": "Nottingham",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4b0c795cc778a6bd2a39086e58f6af0",
		  
		  "name": "Alek",
		  "createdDate": "2022-04-21 20:11:36",
		  "totalOrganizations": 14,
		  "totalTours": 38,
		  "totalDays": 842,
		  "totalCountries": 26,
		  "totalStates": 70,
		  "totalEvents": 431,
		  "eventPercent": 0.966682,
		  "totalScheduleItems": 4271,
		  "schedulePercent": 0.929964,
		  "totalGuests": 1074,
		  "guestPercent": 0.859134,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Dolby Theatre",
		  "mostGuestCity": "Hollywood",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4b5cc31368346cdf7fa30ed7190a489",
		  
		  "name": "Kerry",
		  "createdDate": "2022-02-20 18:51:29",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 352,
		  "totalCountries": 21,
		  "totalStates": 31,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 2041,
		  "schedulePercent": 0.721442,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4e2b2490f3007d8fadd363918fcbb1f",
		  
		  "name": "Ryan",
		  "createdDate": "2012-01-31 00:24:53",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 200,
		  "totalCountries": 9,
		  "totalStates": 34,
		  "totalEvents": 97,
		  "eventPercent": 0.543178,
		  "totalScheduleItems": 1158,
		  "schedulePercent": 0.536718,
		  "totalGuests": 848,
		  "guestPercent": 0.81947,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4e56a7d559ac997d90cfe1100d52a78",
		  
		  "name": "Tiffany",
		  "createdDate": "2017-05-10 18:44:02",
		  "totalOrganizations": 15,
		  "totalTours": 42,
		  "totalDays": 892,
		  "totalCountries": 26,
		  "totalStates": 87,
		  "totalEvents": 407,
		  "eventPercent": 0.960789,
		  "totalScheduleItems": 4170,
		  "schedulePercent": 0.923504,
		  "totalGuests": 1371,
		  "guestPercent": 0.896532,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4f16e4e0c48f5b46c8da756e56c0dde",
		  
		  "name": "Luke",
		  "createdDate": "2021-10-07 03:36:19",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 307,
		  "schedulePercent": 0.221102,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4f1e2e77e3caf1bb639f3eecb6372cb",
		  
		  "name": "Ben",
		  "createdDate": "2011-10-21 15:03:21",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 517,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1635,
		  "schedulePercent": 0.646532,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4f60ccc19e9fbd6283ff51d0495466d",
		  
		  "name": "Roya",
		  "createdDate": "2024-03-01 01:34:06",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 755,
		  "totalCountries": 28,
		  "totalStates": 82,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 3585,
		  "schedulePercent": 0.887919,
		  "totalGuests": 1913,
		  "guestPercent": 0.94073,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e4fe2b21ea8057cbafda2d7d2065e375",
		  
		  "name": "Gareth",
		  "createdDate": "2017-07-04 07:31:00",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 287,
		  "totalCountries": 13,
		  "totalStates": 36,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1078,
		  "schedulePercent": 0.513146,
		  "totalGuests": 284,
		  "guestPercent": 0.641206,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Forest National",
		  "mostGuestCity": "Forest",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e50cb38e79a5961f46c50c847dd24da0",
		  
		  "name": "EJ",
		  "createdDate": "2022-01-12 17:52:59",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 263,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 332,
		  "schedulePercent": 0.232321,
		  "totalGuests": 120,
		  "guestPercent": 0.536945,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "White Oak Music Hall",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5188d383f060c5beb4821a975fe86b0",
		  
		  "name": "Colby",
		  "createdDate": "2023-12-21 21:22:59",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 91,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e520f26977264bdab2301465380aac4a",
		  
		  "name": "Samuel",
		  "createdDate": "2018-05-20 17:45:46",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 729,
		  "totalCountries": 13,
		  "totalStates": 43,
		  "totalEvents": 196,
		  "eventPercent": 0.793404,
		  "totalScheduleItems": 4060,
		  "schedulePercent": 0.916931,
		  "totalGuests": 3568,
		  "guestPercent": 0.990367,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e523786529bdc56666c7fdc6ae87dc84",
		  
		  "name": "DeMartris",
		  "createdDate": "2024-02-02 09:04:25",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 920,
		  "totalCountries": 24,
		  "totalStates": 63,
		  "totalEvents": 240,
		  "eventPercent": 0.861854,
		  "totalScheduleItems": 4510,
		  "schedulePercent": 0.938577,
		  "totalGuests": 1207,
		  "guestPercent": 0.876587,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 113,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e52da6cac9c2c90fed732c5f90be1215",
		  
		  "name": "Justin",
		  "createdDate": "2013-08-02 17:09:36",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 104,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 1244,
		  "schedulePercent": 0.559044,
		  "totalGuests": 637,
		  "guestPercent": 0.767452,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e530bc149cfe521467a773932b0b3c32",
		  
		  "name": "Justine",
		  "createdDate": "2019-06-08 15:34:58",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 273,
		  "totalCountries": 14,
		  "totalStates": 37,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 2204,
		  "schedulePercent": 0.748527,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-02-23 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e537515b62e49b96281e5d7249a59544",
		  
		  "name": "Dave",
		  "createdDate": "2024-06-11 23:48:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 344,
		  "schedulePercent": 0.240254,
		  "totalGuests": 245,
		  "guestPercent": 0.622167,
		  "mostGuestDate": "2025-08-20 00:00:00",
		  "mostGuestName": "Scotiabank Saddledome",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e53f4a0f0e46dd3d64108870ff3382bb",
		  
		  "name": "Cade",
		  "createdDate": "2021-04-19 21:07:24",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 250,
		  "totalCountries": 4,
		  "totalStates": 54,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 1327,
		  "schedulePercent": 0.578309,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Royale",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e54665db180162ae7c5812316712c119",
		  
		  "name": "Suzi",
		  "createdDate": "2016-03-28 11:35:22",
		  "totalOrganizations": 14,
		  "totalTours": 12,
		  "totalDays": 667,
		  "totalCountries": 27,
		  "totalStates": 42,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1963,
		  "schedulePercent": 0.706369,
		  "totalGuests": 1644,
		  "guestPercent": 0.923731,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 204,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e54d22467b63b1a930a68b3e8c130f99",
		  
		  "name": "Tom",
		  "createdDate": "2024-03-26 10:30:04",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 378,
		  "totalCountries": 8,
		  "totalStates": 18,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1046,
		  "schedulePercent": 0.503173,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Northcote Social Club",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e54de989e13c6d10e3c4b390ac10965f",
		  
		  "name": "Eric",
		  "createdDate": "2021-06-21 22:40:44",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 291,
		  "totalCountries": 34,
		  "totalStates": 36,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1574,
		  "schedulePercent": 0.635766,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e54ec2902664cc42f5011317105bd226",
		  
		  "name": "Ollie",
		  "createdDate": "2023-02-22 14:33:23",
		  "totalOrganizations": 5,
		  "totalTours": 26,
		  "totalDays": 565,
		  "totalCountries": 25,
		  "totalStates": 68,
		  "totalEvents": 292,
		  "eventPercent": 0.907185,
		  "totalScheduleItems": 3167,
		  "schedulePercent": 0.856868,
		  "totalGuests": 1388,
		  "guestPercent": 0.899252,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e555213d1bf320181e16c8e0f6b5056b",
		  
		  "name": "Simon",
		  "createdDate": "2021-10-01 10:58:33",
		  "totalOrganizations": 4,
		  "totalTours": 10,
		  "totalDays": 112,
		  "totalCountries": 17,
		  "totalStates": 32,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 954,
		  "schedulePercent": 0.477335,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-03-31 00:00:00",
		  "mostGuestName": "PRYZM Kingston",
		  "mostGuestCity": "Kingston upon Thames",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e55c93d5b0b4935e93f841145029377b",
		  
		  "name": "Trevor",
		  "createdDate": "2016-06-17 01:31:30",
		  "totalOrganizations": 38,
		  "totalTours": 23,
		  "totalDays": 367,
		  "totalCountries": 23,
		  "totalStates": 42,
		  "totalEvents": 161,
		  "eventPercent": 0.729034,
		  "totalScheduleItems": 1755,
		  "schedulePercent": 0.669311,
		  "totalGuests": 151,
		  "guestPercent": 0.558817,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "The Regency Ballroom",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e574c72f0711ef13da63f0dc1ba8ef4c",
		  
		  "name": "Tori ",
		  "createdDate": "2022-02-06 21:22:59",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 442,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 3564,
		  "schedulePercent": 0.885879,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e577e8c977cff7ef6d1d01ef877b8de3",
		  
		  "name": "Scott",
		  "createdDate": "2009-08-20 14:28:33",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 262,
		  "totalCountries": 10,
		  "totalStates": 28,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 660,
		  "schedulePercent": 0.371714,
		  "totalGuests": 196,
		  "guestPercent": 0.591568,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e57e042b55b14ab3873abaefa9cf4cc8",
		  
		  "name": "Marion",
		  "createdDate": "2025-02-24 11:29:02",
		  "totalOrganizations": 12,
		  "totalTours": 44,
		  "totalDays": 849,
		  "totalCountries": 31,
		  "totalStates": 58,
		  "totalEvents": 262,
		  "eventPercent": 0.883273,
		  "totalScheduleItems": 2442,
		  "schedulePercent": 0.780032,
		  "totalGuests": 527,
		  "guestPercent": 0.737647,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Knockdown Center",
		  "mostGuestCity": "Maspeth",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e58db19a0ab66a4035d41441e3279238",
		  
		  "name": "Melissa",
		  "createdDate": "2021-11-10 20:28:54",
		  "totalOrganizations": 20,
		  "totalTours": 33,
		  "totalDays": 832,
		  "totalCountries": 22,
		  "totalStates": 69,
		  "totalEvents": 269,
		  "eventPercent": 0.889393,
		  "totalScheduleItems": 2509,
		  "schedulePercent": 0.787738,
		  "totalGuests": 385,
		  "guestPercent": 0.68801,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e598065e1f9a200520d1af8098f72c74",
		  
		  "name": "Tyler",
		  "createdDate": "2019-04-30 23:01:04",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 736,
		  "totalCountries": 6,
		  "totalStates": 49,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 4220,
		  "schedulePercent": 0.927471,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e59bbfe2e7339b6fa0e6df615ac968b5",
		  
		  "name": "Elodie",
		  "createdDate": "2022-06-03 08:32:16",
		  "totalOrganizations": 10,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 9,
		  "totalStates": 4,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 388,
		  "schedulePercent": 0.263486,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5b3755f28b808425c94647014ca2373",
		  
		  "name": "Maya",
		  "createdDate": "2023-03-30 19:05:16",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 853,
		  "totalCountries": 22,
		  "totalStates": 59,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2227,
		  "schedulePercent": 0.752493,
		  "totalGuests": 197,
		  "guestPercent": 0.592362,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Fallsview Casino Resort",
		  "mostGuestCity": "Niagara Falls",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5bbf512fc931f0fc1b898a8d12706a7",
		  
		  "name": "Sean",
		  "createdDate": "2017-08-14 22:05:07",
		  "totalOrganizations": 26,
		  "totalTours": 49,
		  "totalDays": 2476,
		  "totalCountries": 38,
		  "totalStates": 121,
		  "totalEvents": 811,
		  "eventPercent": 0.993427,
		  "totalScheduleItems": 14665,
		  "schedulePercent": 0.998867,
		  "totalGuests": 5078,
		  "guestPercent": 0.997733,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 172,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5c2855f6cedb2f00a311d1e754c2ad2",
		  
		  "name": "Jody",
		  "createdDate": "2021-08-09 19:49:58",
		  "totalOrganizations": 11,
		  "totalTours": 29,
		  "totalDays": 602,
		  "totalCountries": 15,
		  "totalStates": 59,
		  "totalEvents": 323,
		  "eventPercent": 0.92883,
		  "totalScheduleItems": 3761,
		  "schedulePercent": 0.899479,
		  "totalGuests": 470,
		  "guestPercent": 0.720422,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5cf7224894505fc5c2a8fbc6e36ea01",
		  
		  "name": "Guillaume",
		  "createdDate": "2022-02-21 08:59:32",
		  "totalOrganizations": 20,
		  "totalTours": 30,
		  "totalDays": 755,
		  "totalCountries": 28,
		  "totalStates": 101,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 3651,
		  "schedulePercent": 0.892679,
		  "totalGuests": 1007,
		  "guestPercent": 0.847801,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5d9ebe1f8a3973f7cadd22f39a29ee1",
		  
		  "name": "Josh",
		  "createdDate": "2025-05-27 00:37:26",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 270,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 154,
		  "schedulePercent": 0.132026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5df6c0e0bbca20016d46994cc3aef40",
		  
		  "name": "Chad",
		  "createdDate": "2024-02-07 17:17:56",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 434,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 3181,
		  "schedulePercent": 0.858001,
		  "totalGuests": 1032,
		  "guestPercent": 0.851541,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5e8b4eacd9c237b2a3463960a88891f",
		  
		  "name": "JEFF",
		  "createdDate": "2025-01-09 20:28:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 356,
		  "totalCountries": 10,
		  "totalStates": 47,
		  "totalEvents": 0,
		  "eventPercent": 0,
		  "totalScheduleItems": 1570,
		  "schedulePercent": 0.63486,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5e9969cc3b4d636ca32720050bdbcb3",
		  
		  "name": "Doug",
		  "createdDate": "2009-12-10 14:26:45",
		  "totalOrganizations": 16,
		  "totalTours": 21,
		  "totalDays": 489,
		  "totalCountries": 17,
		  "totalStates": 34,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1270,
		  "schedulePercent": 0.56573,
		  "totalGuests": 113,
		  "guestPercent": 0.530598,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "First Direct Arena",
		  "mostGuestCity": "Leeds",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5f149721c0ebf6b284fdc2e57d79f9b",
		  
		  "name": "Matthew",
		  "createdDate": "2025-06-04 21:27:30",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 191,
		  "totalCountries": 19,
		  "totalStates": 38,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1248,
		  "schedulePercent": 0.560063,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e5fa6286c45e9f24f973c9c82bbb0441",
		  
		  "name": "Kristof",
		  "createdDate": "2015-01-02 04:01:21",
		  "totalOrganizations": 9,
		  "totalTours": 12,
		  "totalDays": 275,
		  "totalCountries": 37,
		  "totalStates": 69,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2125,
		  "schedulePercent": 0.735947,
		  "totalGuests": 563,
		  "guestPercent": 0.747393,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "013 Poppodium",
		  "mostGuestCity": "Tilburg",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e605a0d949aa5f67ff420c4220abdb21",
		  
		  "name": "Jennifer",
		  "createdDate": "2016-06-10 16:04:55",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 395,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1563,
		  "schedulePercent": 0.63316,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e60721274d8e22601743b266b4e1d51b",
		  
		  "name": "Ben ",
		  "createdDate": "2018-09-11 21:03:04",
		  "totalOrganizations": 4,
		  "totalTours": 14,
		  "totalDays": 301,
		  "totalCountries": 15,
		  "totalStates": 52,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1282,
		  "schedulePercent": 0.567996,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-09-09 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e610b86f7acc9c604326e14d60e536e5",
		  
		  "name": "Becky",
		  "createdDate": "2022-02-06 15:05:02",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 121,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 450,
		  "schedulePercent": 0.290911,
		  "totalGuests": 133,
		  "guestPercent": 0.547031,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Mercury Lounge",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6152e7260cc926f2163f986253aaf73",
		  
		  "name": "Dylan",
		  "createdDate": "2019-11-17 12:26:54",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 232,
		  "totalCountries": 13,
		  "totalStates": 56,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1663,
		  "schedulePercent": 0.651745,
		  "totalGuests": 515,
		  "guestPercent": 0.734361,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e61f08377bb5cd92b5b656e3de766cde",
		  
		  "name": "Analoren",
		  "createdDate": "2021-09-28 19:08:42",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 54,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 136,
		  "schedulePercent": 0.122507,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-10-27 00:00:00",
		  "mostGuestName": "House of Blues Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6266dda5501aaaa5a0e25decd36340d",
		  
		  "name": "Alex",
		  "createdDate": "2025-02-10 01:14:04",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 36,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 22,
		  "schedulePercent": 0.0330916,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e62a1260b53efe752b571cb303a82293",
		  
		  "name": "Andrew ",
		  "createdDate": "2025-03-25 23:34:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 121,
		  "totalCountries": 8,
		  "totalStates": 33,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 386,
		  "schedulePercent": 0.261673,
		  "totalGuests": 30,
		  "guestPercent": 0.418178,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "The Academy, Middle Abbey Street",
		  "mostGuestCity": "Dublin 1",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e62dc685fd93d25c275bc2f32c285a83",
		  
		  "name": "Steve",
		  "createdDate": "2024-07-09 15:26:07",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 207,
		  "totalCountries": 20,
		  "totalStates": 34,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 894,
		  "schedulePercent": 0.455802,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Pier15 Skatepark",
		  "mostGuestCity": "Breda",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e63113ca8be5aaa69d8fc91ac29232d0",
		  
		  "name": "rubi",
		  "createdDate": "2025-03-02 02:45:28",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 162,
		  "totalCountries": 9,
		  "totalStates": 33,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 577,
		  "schedulePercent": 0.342362,
		  "totalGuests": 255,
		  "guestPercent": 0.627493,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Gage Roads Freo Brewery",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6379f097747c9d48a5863c1c95f12f1",
		  
		  "name": "Devendra",
		  "createdDate": "2024-03-28 01:32:45",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 24,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 113,
		  "schedulePercent": 0.106754,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6384c76d2304c627bccec5bb6121210",
		  
		  "name": "Billie",
		  "createdDate": "2023-09-01 15:16:29",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 70,
		  "totalCountries": 2,
		  "totalStates": 12,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 101,
		  "schedulePercent": 0.0970082,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Shoreline Waterfront",
		  "mostGuestCity": "Long Beach",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e63c83b5f6dc047b683c11e48b6fbfe1",
		  
		  "name": "Todd",
		  "createdDate": "2014-04-16 21:49:42",
		  "totalOrganizations": 13,
		  "totalTours": 21,
		  "totalDays": 427,
		  "totalCountries": 9,
		  "totalStates": 53,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 2060,
		  "schedulePercent": 0.726088,
		  "totalGuests": 1130,
		  "guestPercent": 0.868314,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Agua Caliente Casino",
		  "mostGuestCity": "Rancho Mirage",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e641074b68dd7b112df15f77de853a0d",
		  
		  "name": "TRACY",
		  "createdDate": "2023-08-08 17:08:16",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 188,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 318,
		  "schedulePercent": 0.225748,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e641fbee410303b1dece408be2eca3d2",
		  
		  "name": "Thomas",
		  "createdDate": "2018-09-10 22:19:31",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 177,
		  "totalCountries": 19,
		  "totalStates": 43,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 903,
		  "schedulePercent": 0.459089,
		  "totalGuests": 361,
		  "guestPercent": 0.678717,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "The Hollywood Avondale",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6428df12eec0f1902f1bbbfd4e19b9e",
		  
		  "name": "Matthew",
		  "createdDate": "2013-07-08 19:49:08",
		  "totalOrganizations": 21,
		  "totalTours": 6,
		  "totalDays": 400,
		  "totalCountries": 11,
		  "totalStates": 47,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2949,
		  "schedulePercent": 0.836695,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-07-03 00:00:00",
		  "mostGuestName": "Shoreline Amphitheatre",
		  "mostGuestCity": "Mountain View",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e64adeccfa0574180e3738189494768c",
		  
		  "name": "Anthony",
		  "createdDate": "2018-02-27 00:46:46",
		  "totalOrganizations": 21,
		  "totalTours": 48,
		  "totalDays": 858,
		  "totalCountries": 18,
		  "totalStates": 57,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 2186,
		  "schedulePercent": 0.746034,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Paradiso",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e656c632b4e4f4a65e3e6ee8123dfa72",
		  
		  "name": "Selena",
		  "createdDate": "2015-03-21 22:21:47",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 20,
		  "totalStates": 64,
		  "totalEvents": 79,
		  "eventPercent": 0.467135,
		  "totalScheduleItems": 1191,
		  "schedulePercent": 0.545218,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e65dcee52e9f684d211b6b27c51b0a0e",
		  
		  "name": "Kristoffer",
		  "createdDate": "2016-10-06 12:46:27",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 207,
		  "totalCountries": 10,
		  "totalStates": 14,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 775,
		  "schedulePercent": 0.414551,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e65f7bfe2c7349ff1de89606cd3020b2",
		  
		  "name": "Mariesha ",
		  "createdDate": "2022-06-15 21:51:53",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 119,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 158,
		  "schedulePercent": 0.134066,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6603069e4f42c6fca44b3eed59de152",
		  
		  "name": "Miguel ",
		  "createdDate": "2018-11-03 14:29:09",
		  "totalOrganizations": 49,
		  "totalTours": 7,
		  "totalDays": 461,
		  "totalCountries": 14,
		  "totalStates": 52,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 2294,
		  "schedulePercent": 0.761106,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e66197091dcfadf643c55934617a2ccc",
		  
		  "name": "Christian",
		  "createdDate": "2014-01-13 21:16:24",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 539,
		  "totalCountries": 9,
		  "totalStates": 43,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1494,
		  "schedulePercent": 0.61616,
		  "totalGuests": 3269,
		  "guestPercent": 0.987081,
		  "mostGuestDate": "2025-05-13 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 176,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e675fc87c5c612ef5a97899c9f3886e8",
		  
		  "name": "Jackson",
		  "createdDate": "2022-12-23 23:33:17",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 510,
		  "totalCountries": 11,
		  "totalStates": 55,
		  "totalEvents": 307,
		  "eventPercent": 0.916818,
		  "totalScheduleItems": 2268,
		  "schedulePercent": 0.757706,
		  "totalGuests": 378,
		  "guestPercent": 0.685063,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6827185c9e9c7b810434df500eab509",
		  
		  "name": "Matthew",
		  "createdDate": "2023-08-24 23:58:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 222,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 103,
		  "schedulePercent": 0.0988214,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "SeatGeek Stadium",
		  "mostGuestCity": "Bridgeview",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e68546fcd15027f088343d45c745c8f2",
		  
		  "name": "Melissa",
		  "createdDate": "2021-09-30 23:23:22",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 1445,
		  "totalCountries": 4,
		  "totalStates": 58,
		  "totalEvents": 938,
		  "eventPercent": 0.995127,
		  "totalScheduleItems": 8378,
		  "schedulePercent": 0.991274,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6aaf35ac38f34813b68bf6949f1ae24",
		  
		  "name": "Kathleen",
		  "createdDate": "2025-03-17 22:05:41",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 399,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 1078,
		  "schedulePercent": 0.513146,
		  "totalGuests": 306,
		  "guestPercent": 0.652539,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6ad57a58e9c13090164f3461f308449",
		  
		  "name": "Stephen",
		  "createdDate": "2022-05-24 17:47:53",
		  "totalOrganizations": 12,
		  "totalTours": 28,
		  "totalDays": 714,
		  "totalCountries": 8,
		  "totalStates": 56,
		  "totalEvents": 402,
		  "eventPercent": 0.958862,
		  "totalScheduleItems": 4561,
		  "schedulePercent": 0.94005,
		  "totalGuests": 3237,
		  "guestPercent": 0.986061,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6b1b167d6a66ff42c91c4c2d863df01",
		  
		  "name": "kiera",
		  "createdDate": "2025-05-12 07:29:15",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 510,
		  "schedulePercent": 0.315503,
		  "totalGuests": 383,
		  "guestPercent": 0.68699,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "Palais Theatre",
		  "mostGuestCity": "St Kilda",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6b9d991a89918ef40352b4883c87af2",
		  
		  "name": "Ander",
		  "createdDate": "2023-12-21 17:34:53",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 268,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 1135,
		  "schedulePercent": 0.529805,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6d09326417923ac10aa50bc20935abd",
		  
		  "name": "Jendrik",
		  "createdDate": "2022-11-29 16:48:57",
		  "totalOrganizations": 12,
		  "totalTours": 16,
		  "totalDays": 251,
		  "totalCountries": 19,
		  "totalStates": 26,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1472,
		  "schedulePercent": 0.611174,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6d53d8ed7a5017fa687b1e00cd3ff3e",
		  
		  "name": "Ben",
		  "createdDate": "2025-03-19 11:02:55",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 20,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 150,
		  "schedulePercent": 0.129873,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6d9705cedcd2aba2db6f39cb02099bf",
		  
		  "name": "Hanna",
		  "createdDate": "2023-05-25 13:13:59",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 356,
		  "totalCountries": 21,
		  "totalStates": 35,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1417,
		  "schedulePercent": 0.601995,
		  "totalGuests": 206,
		  "guestPercent": 0.598821,
		  "mostGuestDate": "2025-05-12 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6e5fe6996ff17bb6415cc7321f9e27c",
		  
		  "name": "Jon",
		  "createdDate": "2012-02-21 20:18:15",
		  "totalOrganizations": 20,
		  "totalTours": 17,
		  "totalDays": 961,
		  "totalCountries": 14,
		  "totalStates": 69,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 3251,
		  "schedulePercent": 0.864007,
		  "totalGuests": 2299,
		  "guestPercent": 0.962035,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Radio City Music Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 191,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6f496e8daa82bb7dfaebe4e21370da5",
		  
		  "name": "Josh",
		  "createdDate": "2015-03-23 20:08:09",
		  "totalOrganizations": 14,
		  "totalTours": 9,
		  "totalDays": 1019,
		  "totalCountries": 24,
		  "totalStates": 75,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 4634,
		  "schedulePercent": 0.94175,
		  "totalGuests": 2606,
		  "guestPercent": 0.972121,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6f84e91ed50fa85cdb90c084f8d157f",
		  
		  "name": "Rhys",
		  "createdDate": "2021-06-07 15:18:41",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 785,
		  "totalCountries": 35,
		  "totalStates": 88,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 3114,
		  "schedulePercent": 0.852561,
		  "totalGuests": 346,
		  "guestPercent": 0.673277,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Chelsea Heights Hotel",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e6fee71938db84ce55a8190f4b1b9841",
		  
		  "name": "Jay",
		  "createdDate": "2013-06-13 18:22:18",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1226,
		  "totalCountries": 7,
		  "totalStates": 49,
		  "totalEvents": 212,
		  "eventPercent": 0.820603,
		  "totalScheduleItems": 2713,
		  "schedulePercent": 0.811083,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e70a8cb068cd03d415297513e94537be",
		  
		  "name": "Connor",
		  "createdDate": "2018-07-09 10:16:30",
		  "totalOrganizations": 15,
		  "totalTours": 6,
		  "totalDays": 449,
		  "totalCountries": 20,
		  "totalStates": 35,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1409,
		  "schedulePercent": 0.599955,
		  "totalGuests": 472,
		  "guestPercent": 0.721328,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "The Pomona Fox Theater",
		  "mostGuestCity": "Pomona",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e716ddd4a577aa8cd549d21bd4bb1feb",
		  
		  "name": "Simon",
		  "createdDate": "2025-05-15 17:12:17",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 90,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "The Wayfarer",
		  "mostGuestCity": "Costa Mesa",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e72003b32d5270e521337bc882743155",
		  
		  "name": "Joseph",
		  "createdDate": "2019-03-02 11:12:30",
		  "totalOrganizations": 57,
		  "totalTours": 38,
		  "totalDays": 5889,
		  "totalCountries": 38,
		  "totalStates": 101,
		  "totalEvents": 524,
		  "eventPercent": 0.981414,
		  "totalScheduleItems": 7155,
		  "schedulePercent": 0.987534,
		  "totalGuests": 1550,
		  "guestPercent": 0.915005,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e728523ec038ed647b758895773f46d4",
		  
		  "name": "Michael",
		  "createdDate": "2019-04-02 11:15:27",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 601,
		  "totalCountries": 18,
		  "totalStates": 25,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 2147,
		  "schedulePercent": 0.739007,
		  "totalGuests": 1210,
		  "guestPercent": 0.876813,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 241,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e72c863e7cedc3463d15208e536db97c",
		  
		  "name": "Gary",
		  "createdDate": "2019-06-20 22:04:02",
		  "totalOrganizations": 5,
		  "totalTours": 12,
		  "totalDays": 592,
		  "totalCountries": 16,
		  "totalStates": 15,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 536,
		  "schedulePercent": 0.329329,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "TRNSMT Festival",
		  "mostGuestCity": "Glasgow Green",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e73f5f90f4d0df7a281e0aee8292bbfe",
		  
		  "name": "Megan",
		  "createdDate": "2016-10-03 21:01:27",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 175,
		  "totalCountries": 16,
		  "totalStates": 45,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1116,
		  "schedulePercent": 0.522892,
		  "totalGuests": 272,
		  "guestPercent": 0.636333,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7489834d814baabe87c2e0197a0f791",
		  
		  "name": "Helen",
		  "createdDate": "2023-05-26 07:01:22",
		  "totalOrganizations": 24,
		  "totalTours": 28,
		  "totalDays": 851,
		  "totalCountries": 10,
		  "totalStates": 30,
		  "totalEvents": 235,
		  "eventPercent": 0.854828,
		  "totalScheduleItems": 1905,
		  "schedulePercent": 0.695716,
		  "totalGuests": 848,
		  "guestPercent": 0.81947,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Koelnarena",
		  "mostGuestCity": "Cologne",
		  "mostGuestAmount": 256,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e75f0df8a8a8a1c33e791e3259488987",
		  
		  "name": "John",
		  "createdDate": "2025-04-10 20:26:32",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 208,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1052,
		  "schedulePercent": 0.505326,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7612594a44eb0f9c67280f66e6e81e1",
		  
		  "name": "Jesus",
		  "createdDate": "2012-10-24 07:39:47",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 147,
		  "totalCountries": 13,
		  "totalStates": 14,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 335,
		  "schedulePercent": 0.234021,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e76c90878a7d2b1622ddcc91c998a58c",
		  
		  "name": "William",
		  "createdDate": "2023-09-21 13:41:16",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 57,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 265,
		  "schedulePercent": 0.196849,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Madame Loyal",
		  "mostGuestCity": "Frejus",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7717d82be9a2e277fc2cd50dbdb2b06",
		  
		  "name": "Matthew",
		  "createdDate": "2025-04-06 03:11:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 126,
		  "totalCountries": 3,
		  "totalStates": 24,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1393,
		  "schedulePercent": 0.596102,
		  "totalGuests": 940,
		  "guestPercent": 0.837262,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Acrisure Arena",
		  "mostGuestCity": "Palm Desert",
		  "mostGuestAmount": 85,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e773e371ea740aa61ce9ea251a8e9f02",
		  
		  "name": "David",
		  "createdDate": "2022-11-27 02:39:15",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 121,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 577,
		  "schedulePercent": 0.342362,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e77b70adcc24bf5354238bd22b63f666",
		  
		  "name": "Lucy",
		  "createdDate": "2022-05-28 05:08:07",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 519,
		  "totalCountries": 10,
		  "totalStates": 31,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 648,
		  "schedulePercent": 0.366614,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "The Glass House",
		  "mostGuestCity": "Pomona",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e77da3be7658c494fe907f804906b064",
		  
		  "name": "Ruby",
		  "createdDate": "2023-04-05 17:56:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 90,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 368,
		  "schedulePercent": 0.252153,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e77e21e3489a7fbd018a313edc41dd6e",
		  
		  "name": "MasterTour1",
		  "createdDate": "2017-10-19 13:15:21",
		  "totalOrganizations": 36,
		  "totalTours": 16,
		  "totalDays": 2883,
		  "totalCountries": 16,
		  "totalStates": 31,
		  "totalEvents": 383,
		  "eventPercent": 0.954216,
		  "totalScheduleItems": 4014,
		  "schedulePercent": 0.913985,
		  "totalGuests": 375,
		  "guestPercent": 0.683477,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Paleo Festival Nyon",
		  "mostGuestCity": "Nyon",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e78d972ccfe284209f134b27290e8301",
		  
		  "name": "Chris",
		  "createdDate": "2014-03-30 10:39:27",
		  "totalOrganizations": 11,
		  "totalTours": 1,
		  "totalDays": 304,
		  "totalCountries": 9,
		  "totalStates": 35,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 1666,
		  "schedulePercent": 0.652312,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e78e2425b1e21010eed5acc2f7a882f0",
		  
		  "name": "Brian",
		  "createdDate": "2024-09-02 04:12:52",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 45,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 258,
		  "schedulePercent": 0.194016,
		  "totalGuests": 19,
		  "guestPercent": 0.392679,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Racket NYC",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e78ffed5793c168f109a746cfb2fe415",
		  
		  "name": "Dougie",
		  "createdDate": "2012-02-02 17:02:50",
		  "totalOrganizations": 25,
		  "totalTours": 13,
		  "totalDays": 327,
		  "totalCountries": 30,
		  "totalStates": 40,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2152,
		  "schedulePercent": 0.740254,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-06-30 00:00:00",
		  "mostGuestName": "Kee to Bala",
		  "mostGuestCity": "Bala",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7a37e1b3ab59d3aa1f26495b577b588",
		  
		  "name": "Yvette",
		  "createdDate": "2018-06-05 15:35:40",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 326,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 2169,
		  "schedulePercent": 0.742634,
		  "totalGuests": 1971,
		  "guestPercent": 0.945036,
		  "mostGuestDate": "2025-07-02 00:00:00",
		  "mostGuestName": "UBS Arena",
		  "mostGuestCity": "Elmont",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7a8372b6ff769c8a4db8cca0c71401c",
		  
		  "name": "Peyton",
		  "createdDate": "2022-02-21 13:36:54",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 146,
		  "totalCountries": 7,
		  "totalStates": 26,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 290,
		  "schedulePercent": 0.212149,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Effenaar",
		  "mostGuestCity": "Eindhoven",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7a866a81ce2f6729c401d9f173d6315",
		  
		  "name": "Jayden ",
		  "createdDate": "2022-08-16 20:58:41",
		  "totalOrganizations": 30,
		  "totalTours": 45,
		  "totalDays": 851,
		  "totalCountries": 18,
		  "totalStates": 73,
		  "totalEvents": 440,
		  "eventPercent": 0.968722,
		  "totalScheduleItems": 5826,
		  "schedulePercent": 0.973028,
		  "totalGuests": 1481,
		  "guestPercent": 0.907525,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Echoplex",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7aa885d68336c6eb9fcda025a8cc3a0",
		  
		  "name": "Abra",
		  "createdDate": "2022-01-14 16:10:36",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 648,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 924,
		  "schedulePercent": 0.466455,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Mahaiwe PAC",
		  "mostGuestCity": "Great Barrington",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7adc0952b78c293a0ea6b4e7f5a4ccb",
		  
		  "name": "Hayden",
		  "createdDate": "2024-07-17 20:38:53",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 628,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1753,
		  "schedulePercent": 0.669084,
		  "totalGuests": 1512,
		  "guestPercent": 0.910925,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7b4d5fe96688ac70a5d4aeb117c0f17",
		  
		  "name": "Malene",
		  "createdDate": "2025-04-08 14:48:52",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 140,
		  "totalCountries": 16,
		  "totalStates": 12,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 353,
		  "schedulePercent": 0.24422,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-11-09 00:00:00",
		  "mostGuestName": "Teatro Armando Cortez",
		  "mostGuestCity": "Lisboa",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7b9393017a8d0649c63a6bd7c7ac0f1",
		  
		  "name": "Ruby",
		  "createdDate": "2022-01-07 01:32:13",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 1307,
		  "totalCountries": 5,
		  "totalStates": 64,
		  "totalEvents": 436,
		  "eventPercent": 0.967928,
		  "totalScheduleItems": 6460,
		  "schedulePercent": 0.981301,
		  "totalGuests": 700,
		  "guestPercent": 0.785925,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7c127d4aa3fa3eb9cd32e0fbe6a80b7",
		  
		  "name": "Wouter",
		  "createdDate": "2025-05-03 14:20:08",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 80,
		  "totalCountries": 11,
		  "totalStates": 13,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 313,
		  "schedulePercent": 0.223935,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "De Oosterpoort",
		  "mostGuestCity": "Groningen",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7caad3f110e0e0f0080648912ae5b30",
		  
		  "name": "Greg",
		  "createdDate": "2013-09-11 16:57:59",
		  "totalOrganizations": 6,
		  "totalTours": 19,
		  "totalDays": 100,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 483,
		  "schedulePercent": 0.302924,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-06-22 00:00:00",
		  "mostGuestName": "Garcia's",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7cfbefc8c6b26d259be18960abc8fda",
		  
		  "name": "Hannah ",
		  "createdDate": "2013-03-31 21:33:37",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 210,
		  "totalCountries": 9,
		  "totalStates": 35,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1010,
		  "schedulePercent": 0.493314,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Belding Theater",
		  "mostGuestCity": "Hartford",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7d23cdf3011cffc18f5acad5a815a32",
		  
		  "name": "Ian Timothy",
		  "createdDate": "2014-01-27 23:26:46",
		  "totalOrganizations": 12,
		  "totalTours": 11,
		  "totalDays": 1014,
		  "totalCountries": 18,
		  "totalStates": 55,
		  "totalEvents": 278,
		  "eventPercent": 0.896872,
		  "totalScheduleItems": 4052,
		  "schedulePercent": 0.916138,
		  "totalGuests": 1094,
		  "guestPercent": 0.862647,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7e332877c109e24d6fcd97ccc03e98e",
		  
		  "name": "Nicole",
		  "createdDate": "2022-12-03 16:43:25",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 334,
		  "totalCountries": 19,
		  "totalStates": 41,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1304,
		  "schedulePercent": 0.57219,
		  "totalGuests": 32,
		  "guestPercent": 0.422824,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Motorco Music Hall",
		  "mostGuestCity": "Durham",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7ec333173fd898e4671802b8830f87c",
		  
		  "name": "Karey",
		  "createdDate": "2015-08-31 15:28:46",
		  "totalOrganizations": 20,
		  "totalTours": 16,
		  "totalDays": 755,
		  "totalCountries": 30,
		  "totalStates": 48,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1559,
		  "schedulePercent": 0.63248,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Elsewhere",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7ed78484e7a4edde1eeaf1a9febb507",
		  
		  "name": "Imad",
		  "createdDate": "2025-03-25 18:43:52",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 277,
		  "totalCountries": 8,
		  "totalStates": 8,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 421,
		  "schedulePercent": 0.278672,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7eda0b765f7a15f049098de1228a9b5",
		  
		  "name": "Sondre",
		  "createdDate": "2023-12-13 13:01:21",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 35,
		  "totalCountries": 4,
		  "totalStates": 4,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 201,
		  "schedulePercent": 0.161491,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7ef2baac2121aae467717e96944177a",
		  
		  "name": "Tanner",
		  "createdDate": "2015-08-18 22:47:10",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 486,
		  "totalCountries": 7,
		  "totalStates": 55,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 2157,
		  "schedulePercent": 0.74082,
		  "totalGuests": 707,
		  "guestPercent": 0.787171,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7f2ac5e335fe31e005e4ee5897ba649",
		  
		  "name": "Nathan",
		  "createdDate": "2025-04-01 22:37:18",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 109,
		  "totalCountries": 5,
		  "totalStates": 31,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1128,
		  "schedulePercent": 0.527425,
		  "totalGuests": 916,
		  "guestPercent": 0.833522,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e7fdb0dff596b8f49b2ab71507f42385",
		  
		  "name": "Bob",
		  "createdDate": "2009-12-01 22:51:33",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 164,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 884,
		  "schedulePercent": 0.452176,
		  "totalGuests": 1082,
		  "guestPercent": 0.861061,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 131,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e807edbfbfd862bf9fc499c0442b448f",
		  
		  "name": "Michael",
		  "createdDate": "2024-02-08 02:15:04",
		  "totalOrganizations": 8,
		  "totalTours": 26,
		  "totalDays": 200,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1074,
		  "schedulePercent": 0.511786,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Tom Moffatt Waikiki Shell",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e80d26a15176496e0f4b14d6ac79b371",
		  
		  "name": "Sam",
		  "createdDate": "2014-06-25 11:01:58",
		  "totalOrganizations": 4,
		  "totalTours": 12,
		  "totalDays": 766,
		  "totalCountries": 32,
		  "totalStates": 70,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 3893,
		  "schedulePercent": 0.907978,
		  "totalGuests": 781,
		  "guestPercent": 0.803377,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Old Royal Naval College",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8127b5b4fbc1d06ec42a05742664f50",
		  
		  "name": "Nick",
		  "createdDate": "2011-07-06 08:04:09",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 103,
		  "totalCountries": 12,
		  "totalStates": 21,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 929,
		  "schedulePercent": 0.468495,
		  "totalGuests": 223,
		  "guestPercent": 0.608568,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "SSE Arena Belfast",
		  "mostGuestCity": "Belfast",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e816fa66f759fe0d9aba6ca98063fcf5",
		  
		  "name": "Ethan",
		  "createdDate": "2015-08-11 21:52:14",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 367,
		  "totalCountries": 9,
		  "totalStates": 55,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 2418,
		  "schedulePercent": 0.777199,
		  "totalGuests": 1632,
		  "guestPercent": 0.922484,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 280,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e81f8389adc6017b459ee79077ed4c8b",
		  
		  "name": "Ollie",
		  "createdDate": "2023-07-10 16:55:39",
		  "totalOrganizations": 2,
		  "totalTours": 7,
		  "totalDays": 400,
		  "totalCountries": 8,
		  "totalStates": 50,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1169,
		  "schedulePercent": 0.539778,
		  "totalGuests": 1255,
		  "guestPercent": 0.88112,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e81fff20206783c19fa620d2efa25cad",
		  
		  "name": "Amanda",
		  "createdDate": "2023-03-10 14:07:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 41,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e82c26b54761f31d37d80161c6d9d3d9",
		  
		  "name": "Karen",
		  "createdDate": "2021-11-25 00:37:31",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 116,
		  "totalCountries": 3,
		  "totalStates": 7,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 440,
		  "schedulePercent": 0.286491,
		  "totalGuests": 198,
		  "guestPercent": 0.593155,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "The Barracks Precinct",
		  "mostGuestCity": "Manly",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8318d0c0e6d2bfc0439267833694a37",
		  
		  "name": "Rachel",
		  "createdDate": "2014-02-26 01:34:31",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 146,
		  "totalCountries": 3,
		  "totalStates": 18,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 530,
		  "schedulePercent": 0.326949,
		  "totalGuests": 1161,
		  "guestPercent": 0.872167,
		  "mostGuestDate": "2025-06-23 00:00:00",
		  "mostGuestName": "Beacon Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e835d6f92830a0def809af32ed341be3",
		  
		  "name": "Adam",
		  "createdDate": "2022-01-13 21:27:15",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 230,
		  "totalCountries": 5,
		  "totalStates": 25,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 988,
		  "schedulePercent": 0.487421,
		  "totalGuests": 876,
		  "guestPercent": 0.823889,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e841d1982e92374d1583a82fd6029c1c",
		  
		  "name": "Noa",
		  "createdDate": "2022-02-04 19:20:14",
		  "totalOrganizations": 20,
		  "totalTours": 27,
		  "totalDays": 743,
		  "totalCountries": 18,
		  "totalStates": 50,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 2721,
		  "schedulePercent": 0.812217,
		  "totalGuests": 392,
		  "guestPercent": 0.690956,
		  "mostGuestDate": "2025-06-01 00:00:00",
		  "mostGuestName": "Ogden Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8432a5141fce08003ee96ade41f2680",
		  
		  "name": "Andrew ",
		  "createdDate": "2019-08-21 12:33:26",
		  "totalOrganizations": 6,
		  "totalTours": 1,
		  "totalDays": 53,
		  "totalCountries": 18,
		  "totalStates": 14,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 344,
		  "schedulePercent": 0.240254,
		  "totalGuests": 217,
		  "guestPercent": 0.606528,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Z-Bau - House of Contemporary Culture",
		  "mostGuestCity": "Nuremberg",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e84751a979cc8ce717a032dca523894a",
		  
		  "name": "BEGUE",
		  "createdDate": "2023-07-22 09:32:32",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 252,
		  "totalCountries": 5,
		  "totalStates": 14,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 785,
		  "schedulePercent": 0.417384,
		  "totalGuests": 172,
		  "guestPercent": 0.575136,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Cepac Silo",
		  "mostGuestCity": "Marseille",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e84a4852aaa910d1365431316a2f8bfd",
		  
		  "name": "michael",
		  "createdDate": "2012-03-20 14:50:53",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 331,
		  "totalCountries": 11,
		  "totalStates": 51,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1765,
		  "schedulePercent": 0.670898,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e84fc55fbcc7e065f612a5a98e26a832",
		  
		  "name": "Scott",
		  "createdDate": "2017-09-07 17:33:47",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 958,
		  "totalCountries": 5,
		  "totalStates": 40,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 1242,
		  "schedulePercent": 0.558364,
		  "totalGuests": 399,
		  "guestPercent": 0.694016,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e852398a3cd2e9d9dfbb6c66fb827eeb",
		  
		  "name": "Daniel",
		  "createdDate": "2025-08-19 18:06:06",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 540,
		  "totalCountries": 9,
		  "totalStates": 34,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 710,
		  "schedulePercent": 0.390639,
		  "totalGuests": 183,
		  "guestPercent": 0.581482,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Stranahan Theatre",
		  "mostGuestCity": "Toledo",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e853eb1efca1e7aeed783269fd70c7e9",
		  
		  "name": "Nick",
		  "createdDate": "2022-03-11 20:52:45",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 102,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 104,
		  "schedulePercent": 0.0999547,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e86742010a833c001e3873ad455d1b48",
		  
		  "name": "Taylor",
		  "createdDate": "2021-09-26 15:58:24",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1206,
		  "totalCountries": 23,
		  "totalStates": 65,
		  "totalEvents": 204,
		  "eventPercent": 0.80723,
		  "totalScheduleItems": 3546,
		  "schedulePercent": 0.884633,
		  "totalGuests": 1254,
		  "guestPercent": 0.88078,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Majestic Ventura Theater",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8681ff988f8f19f4bf83d5f567a5ef1",
		  
		  "name": "JW",
		  "createdDate": "2014-03-05 21:21:07",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 374,
		  "totalCountries": 10,
		  "totalStates": 41,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 1109,
		  "schedulePercent": 0.520739,
		  "totalGuests": 140,
		  "guestPercent": 0.552357,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Symphony Hall",
		  "mostGuestCity": "Springfield",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8840eff05910a7c63175c94f3649bae",
		  
		  "name": "Seb",
		  "createdDate": "2025-08-01 01:48:06",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 40,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 234,
		  "schedulePercent": 0.18053,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e886529212767be15d7c2852d575602b",
		  
		  "name": "Rylan",
		  "createdDate": "2022-08-12 21:55:58",
		  "totalOrganizations": 18,
		  "totalTours": 14,
		  "totalDays": 1672,
		  "totalCountries": 19,
		  "totalStates": 66,
		  "totalEvents": 295,
		  "eventPercent": 0.909678,
		  "totalScheduleItems": 2327,
		  "schedulePercent": 0.765866,
		  "totalGuests": 355,
		  "guestPercent": 0.676564,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Salle Pleyel",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e88a33c1bea0d566b77a91c7345002b2",
		  
		  "name": "Mark",
		  "createdDate": "2012-05-28 13:51:16",
		  "totalOrganizations": 38,
		  "totalTours": 26,
		  "totalDays": 1181,
		  "totalCountries": 28,
		  "totalStates": 52,
		  "totalEvents": 260,
		  "eventPercent": 0.881573,
		  "totalScheduleItems": 3597,
		  "schedulePercent": 0.888939,
		  "totalGuests": 923,
		  "guestPercent": 0.834655,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e891914f826888b4a6680668b55f368d",
		  
		  "name": "Jeri",
		  "createdDate": "2018-04-03 18:29:50",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 98,
		  "totalCountries": 10,
		  "totalStates": 35,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 769,
		  "schedulePercent": 0.411945,
		  "totalGuests": 629,
		  "guestPercent": 0.764959,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "Webster Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e893b69d9feb06b1e363f9ca10dad055",
		  
		  "name": "CCM",
		  "createdDate": "2024-11-12 19:44:15",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 257,
		  "totalCountries": 10,
		  "totalStates": 36,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 930,
		  "schedulePercent": 0.468835,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e89a081e467ec0bf556330be709ebb0e",
		  
		  "name": "JEFFREY",
		  "createdDate": "2016-01-24 14:26:03",
		  "totalOrganizations": 21,
		  "totalTours": 8,
		  "totalDays": 527,
		  "totalCountries": 7,
		  "totalStates": 33,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 704,
		  "schedulePercent": 0.388259,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "The Windjammer",
		  "mostGuestCity": "Isle of Palms",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e89f4ef8ce4650e27a1b71fd49154233",
		  
		  "name": "Eric",
		  "createdDate": "2024-01-12 21:00:59",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 372,
		  "totalCountries": 8,
		  "totalStates": 33,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 613,
		  "schedulePercent": 0.355168,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8b11b8ae36d7742b4130f811068e442",
		  
		  "name": "Michael ",
		  "createdDate": "2023-03-27 18:15:59",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 470,
		  "totalCountries": 7,
		  "totalStates": 26,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1160,
		  "schedulePercent": 0.537511,
		  "totalGuests": 339,
		  "guestPercent": 0.670558,
		  "mostGuestDate": "2025-02-18 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8c8222c17b5cd92c6435724c2a2ad74",
		  
		  "name": "Steven",
		  "createdDate": "2014-11-21 22:07:30",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 43,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 444,
		  "schedulePercent": 0.288078,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "L'Olympia Bruno Coquatrix",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8c9b5f18b791bd45f0b48844562b349",
		  
		  "name": "Sam",
		  "createdDate": "2024-07-24 18:24:33",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 79,
		  "totalCountries": 17,
		  "totalStates": 26,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 311,
		  "schedulePercent": 0.222801,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8cac95cf642204af95e59b68aeb3822",
		  
		  "name": "Mike",
		  "createdDate": "2011-10-20 01:59:35",
		  "totalOrganizations": 15,
		  "totalTours": 13,
		  "totalDays": 662,
		  "totalCountries": 17,
		  "totalStates": 66,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2255,
		  "schedulePercent": 0.75578,
		  "totalGuests": 665,
		  "guestPercent": 0.775725,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Fairview Park",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8cf3a78ab04d0cfb56174f8fe2f2897",
		  
		  "name": "Mark",
		  "createdDate": "2018-05-20 17:50:12",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 458,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1711,
		  "schedulePercent": 0.660585,
		  "totalGuests": 282,
		  "guestPercent": 0.640413,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8d6e199cf3ae54530be94e2dc512b01",
		  
		  "name": "JoeAngel",
		  "createdDate": "2014-02-28 16:22:45",
		  "totalOrganizations": 15,
		  "totalTours": 13,
		  "totalDays": 822,
		  "totalCountries": 5,
		  "totalStates": 47,
		  "totalEvents": 357,
		  "eventPercent": 0.944696,
		  "totalScheduleItems": 6991,
		  "schedulePercent": 0.986287,
		  "totalGuests": 6033,
		  "guestPercent": 0.9983,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8d79df5ed94b94d05a018a59df618b7",
		  
		  "name": "Alec",
		  "createdDate": "2016-03-09 08:06:36",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 300,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 146,
		  "eventPercent": 0.696396,
		  "totalScheduleItems": 2472,
		  "schedulePercent": 0.783885,
		  "totalGuests": 682,
		  "guestPercent": 0.781505,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Deer Valley Music Festival",
		  "mostGuestCity": "Park City",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8dbf211a33ec63c874a286a02d5e3b3",
		  
		  "name": "Keri",
		  "createdDate": "2023-07-12 00:36:45",
		  "totalOrganizations": 6,
		  "totalTours": 15,
		  "totalDays": 1288,
		  "totalCountries": 26,
		  "totalStates": 45,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 3008,
		  "schedulePercent": 0.842815,
		  "totalGuests": 784,
		  "guestPercent": 0.80417,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Colosseum Theater at Caesars Palace",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8e6fe67e6379efdd5850a09073d8d8f",
		  
		  "name": "Linda",
		  "createdDate": "2025-03-01 08:41:30",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 47,
		  "totalCountries": 5,
		  "totalStates": 3,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 120,
		  "schedulePercent": 0.110494,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8f6e258d7ecebea2fd9e6da364f0c6a",
		  
		  "name": "Sean",
		  "createdDate": "2019-01-18 00:55:45",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 345,
		  "totalCountries": 12,
		  "totalStates": 49,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1392,
		  "schedulePercent": 0.595648,
		  "totalGuests": 980,
		  "guestPercent": 0.842815,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Majestic Ventura Theater",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e8fe1d016e23718442defc43c5d45890",
		  
		  "name": "Sam",
		  "createdDate": "2015-10-08 16:02:22",
		  "totalOrganizations": 20,
		  "totalTours": 10,
		  "totalDays": 339,
		  "totalCountries": 22,
		  "totalStates": 29,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1069,
		  "schedulePercent": 0.510199,
		  "totalGuests": 128,
		  "guestPercent": 0.542498,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e90abe2bdeca6a0aeff7c03090f78570",
		  
		  "name": "Berit",
		  "createdDate": "2013-05-24 14:03:17",
		  "totalOrganizations": 82,
		  "totalTours": 38,
		  "totalDays": 679,
		  "totalCountries": 18,
		  "totalStates": 34,
		  "totalEvents": 419,
		  "eventPercent": 0.963509,
		  "totalScheduleItems": 3086,
		  "schedulePercent": 0.850181,
		  "totalGuests": 539,
		  "guestPercent": 0.740367,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "SÃ¶dra Teatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e90d9bcce1f62f7fd028fbe5837b931e",
		  
		  "name": "Peter MÃ¸ller",
		  "createdDate": "2021-09-21 07:25:45",
		  "totalOrganizations": 32,
		  "totalTours": 24,
		  "totalDays": 535,
		  "totalCountries": 7,
		  "totalStates": 7,
		  "totalEvents": 523,
		  "eventPercent": 0.981188,
		  "totalScheduleItems": 3081,
		  "schedulePercent": 0.849728,
		  "totalGuests": 436,
		  "guestPercent": 0.707842,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "Voxhall",
		  "mostGuestCity": "Aarhus",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e90f653ea871344b6f5c329fb546aa1b",
		  
		  "name": "Devin",
		  "createdDate": "2025-03-10 18:43:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 295,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 116,
		  "schedulePercent": 0.108228,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e911bc03173aa192e25d3e1519c75cc3",
		  
		  "name": "Gilbert",
		  "createdDate": "2017-02-08 19:18:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 336,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 294,
		  "schedulePercent": 0.214415,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "The Post OG",
		  "mostGuestCity": "Orange Grove",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e918b0b6ce255cb96fa712c454b546d4",
		  
		  "name": "Walker",
		  "createdDate": "2021-05-21 16:46:33",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1716,
		  "totalCountries": 12,
		  "totalStates": 68,
		  "totalEvents": 348,
		  "eventPercent": 0.941523,
		  "totalScheduleItems": 3584,
		  "schedulePercent": 0.887806,
		  "totalGuests": 1087,
		  "guestPercent": 0.861514,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e91925ba3978a064b9ac90806f7f6b99",
		  
		  "name": "Vernon",
		  "createdDate": "2017-03-10 02:13:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 100,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 519,
		  "schedulePercent": 0.32117,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9224cf4f6a0507434ff8ae72f75ed92",
		  
		  "name": "Richard",
		  "createdDate": "2013-08-20 14:14:09",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 362,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 567,
		  "schedulePercent": 0.339529,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9228ecc7194b851b67e884b842a07d3",
		  
		  "name": "Luis",
		  "createdDate": "2016-08-28 17:24:28",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 377,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 517,
		  "schedulePercent": 0.32015,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Municipal Theater of Guarda - Grand Auditorium",
		  "mostGuestCity": "Guarda",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e92b70825994f41e57cc00730371db09",
		  
		  "name": "Miles",
		  "createdDate": "2024-07-19 20:59:21",
		  "totalOrganizations": 3,
		  "totalTours": 9,
		  "totalDays": 232,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1133,
		  "schedulePercent": 0.529238,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "Lincoln Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e92e892c16a857f67e935229c88e2213",
		  
		  "name": "Megan",
		  "createdDate": "2022-05-18 02:58:05",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 140,
		  "totalCountries": 8,
		  "totalStates": 13,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 253,
		  "schedulePercent": 0.191976,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e936ee7968d5ac238bde65ef5598fba3",
		  
		  "name": "Julia Love",
		  "createdDate": "2019-07-08 08:54:48",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 649,
		  "totalCountries": 21,
		  "totalStates": 36,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 2209,
		  "schedulePercent": 0.748867,
		  "totalGuests": 409,
		  "guestPercent": 0.69719,
		  "mostGuestDate": "2025-05-20 00:00:00",
		  "mostGuestName": "place bell",
		  "mostGuestCity": "Laval",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e939b450a717829611cde9b1a2416ce2",
		  
		  "name": "Sarah",
		  "createdDate": "2024-05-24 10:49:48",
		  "totalOrganizations": 1,
		  "totalTours": 19,
		  "totalDays": 123,
		  "totalCountries": 15,
		  "totalStates": 10,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1336,
		  "schedulePercent": 0.582389,
		  "totalGuests": 60,
		  "guestPercent": 0.470422,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "Lollapalooza",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e94e06e2d4125c4b9533f14c1cedbefc",
		  
		  "name": "Brandon",
		  "createdDate": "2012-04-10 20:17:00",
		  "totalOrganizations": 11,
		  "totalTours": 18,
		  "totalDays": 497,
		  "totalCountries": 46,
		  "totalStates": 104,
		  "totalEvents": 267,
		  "eventPercent": 0.888033,
		  "totalScheduleItems": 3101,
		  "schedulePercent": 0.851315,
		  "totalGuests": 547,
		  "guestPercent": 0.743314,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Chelsea Heights Hotel",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e977b1e09d2a605d337faecacdb193cd",
		  
		  "name": "William",
		  "createdDate": "2021-06-02 10:17:16",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 786,
		  "totalCountries": 3,
		  "totalStates": 46,
		  "totalEvents": 186,
		  "eventPercent": 0.775045,
		  "totalScheduleItems": 1606,
		  "schedulePercent": 0.641319,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e98af0ec126f6305160ef8571d187cbd",
		  
		  "name": "Santiago",
		  "createdDate": "2024-12-03 22:52:11",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 337,
		  "totalCountries": 17,
		  "totalStates": 25,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 720,
		  "schedulePercent": 0.394266,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e98d413941c36cb2194c5e6577a9aa7f",
		  
		  "name": "Siri",
		  "createdDate": "2024-07-31 03:37:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 363,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 518,
		  "schedulePercent": 0.320603,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "Wonder Bar",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e992e582cfd2440da3f7ffd0507a0252",
		  
		  "name": "Marek",
		  "createdDate": "2013-06-16 04:00:17",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 100,
		  "totalCountries": 24,
		  "totalStates": 29,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 704,
		  "schedulePercent": 0.388259,
		  "totalGuests": 811,
		  "guestPercent": 0.811083,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Hala Stulecia",
		  "mostGuestCity": "WrocÅ‚aw",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e99620c3383d6767fd6eb2c8fd645c40",
		  
		  "name": "Tim",
		  "createdDate": "2016-08-19 16:27:54",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 174,
		  "totalCountries": 9,
		  "totalStates": 14,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 606,
		  "schedulePercent": 0.353014,
		  "totalGuests": 314,
		  "guestPercent": 0.656052,
		  "mostGuestDate": "2025-01-25 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 104,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9980760b0e46f96b00078a6fa7b2024",
		  
		  "name": "Joe",
		  "createdDate": "2017-10-06 01:13:06",
		  "totalOrganizations": 57,
		  "totalTours": 9,
		  "totalDays": 161,
		  "totalCountries": 6,
		  "totalStates": 34,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 816,
		  "schedulePercent": 0.42951,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9abbab5c25409f75cfc4b4e75d3c81a",
		  
		  "name": "Elise",
		  "createdDate": "2025-10-06 22:46:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 40,
		  "totalCountries": 11,
		  "totalStates": 10,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 84,
		  "schedulePercent": 0.0851088,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9aed4d2048df7f30f5f355ae581f873",
		  
		  "name": "Leah",
		  "createdDate": "2025-05-12 20:44:34",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 341,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9b6e0e77746aa320375f590339ea33f",
		  
		  "name": "James",
		  "createdDate": "2019-12-27 19:00:07",
		  "totalOrganizations": 10,
		  "totalTours": 24,
		  "totalDays": 574,
		  "totalCountries": 25,
		  "totalStates": 90,
		  "totalEvents": 293,
		  "eventPercent": 0.908092,
		  "totalScheduleItems": 4237,
		  "schedulePercent": 0.92849,
		  "totalGuests": 2563,
		  "guestPercent": 0.970875,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9c2d2ccccfb46f1763cd2692ec7b29a",
		  
		  "name": "Udaravi",
		  "createdDate": "2023-03-14 16:49:25",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 108,
		  "totalCountries": 9,
		  "totalStates": 17,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 152,
		  "schedulePercent": 0.131006,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "Knockdown Center",
		  "mostGuestCity": "Maspeth",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9c5b56fe63b873d23f271eb7379308b",
		  
		  "name": "Jordan",
		  "createdDate": "2024-08-28 19:24:36",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 283,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 278,
		  "schedulePercent": 0.204216,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Site MusiquArt Site",
		  "mostGuestCity": "Dieppe",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9c6a4d926652f37c5167a9fa21ac62a",
		  
		  "name": "Arnaud",
		  "createdDate": "2024-08-18 12:01:03",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 457,
		  "totalCountries": 6,
		  "totalStates": 20,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 767,
		  "schedulePercent": 0.410925,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9cd7b8d8de2dc81ec0b4e2e2c6a4068",
		  
		  "name": "Eleanor",
		  "createdDate": "2025-05-11 19:06:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 104,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 414,
		  "schedulePercent": 0.275612,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9d04a8d132b18a50b545b84ad6dccf2",
		  
		  "name": "Fred",
		  "createdDate": "2025-04-09 13:21:47",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 35,
		  "totalCountries": 5,
		  "totalStates": 1,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 247,
		  "schedulePercent": 0.18835,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9ec5f0769e22bba0693b34a85fd15ab",
		  
		  "name": "Thomas",
		  "createdDate": "2018-10-02 13:03:40",
		  "totalOrganizations": 21,
		  "totalTours": 22,
		  "totalDays": 1264,
		  "totalCountries": 10,
		  "totalStates": 52,
		  "totalEvents": 394,
		  "eventPercent": 0.957389,
		  "totalScheduleItems": 5259,
		  "schedulePercent": 0.961129,
		  "totalGuests": 726,
		  "guestPercent": 0.792044,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The Fisher Center for the Performing Arts",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 214,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "e9efac1b752faeda23ceeb8fcb61045b",
		  
		  "name": "Riley",
		  "createdDate": "2022-04-27 14:36:26",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 673,
		  "totalCountries": 25,
		  "totalStates": 89,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 3173,
		  "schedulePercent": 0.857661,
		  "totalGuests": 1131,
		  "guestPercent": 0.868767,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 280,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea006c41da559165075bfb4af17705e0",
		  
		  "name": "Gabrielle",
		  "createdDate": "2024-09-10 22:41:24",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 243,
		  "totalCountries": 8,
		  "totalStates": 33,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 2354,
		  "schedulePercent": 0.769152,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea0629c1dd77fe97aa703fb7b7d80cd3",
		  
		  "name": "Romain",
		  "createdDate": "2019-07-22 19:32:00",
		  "totalOrganizations": 14,
		  "totalTours": 19,
		  "totalDays": 557,
		  "totalCountries": 29,
		  "totalStates": 70,
		  "totalEvents": 211,
		  "eventPercent": 0.819356,
		  "totalScheduleItems": 2326,
		  "schedulePercent": 0.765752,
		  "totalGuests": 821,
		  "guestPercent": 0.813463,
		  "mostGuestDate": "2025-10-22 00:00:00",
		  "mostGuestName": "O2 Shepherd's Bush Empire",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea07c1bdf50b2c8362cb3e445dd9c350",
		  
		  "name": "Nick",
		  "createdDate": "2012-10-10 06:46:29",
		  "totalOrganizations": 50,
		  "totalTours": 15,
		  "totalDays": 559,
		  "totalCountries": 9,
		  "totalStates": 21,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1007,
		  "schedulePercent": 0.49252,
		  "totalGuests": 37,
		  "guestPercent": 0.433024,
		  "mostGuestDate": "2025-03-05 00:00:00",
		  "mostGuestName": "Whammy Bar",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea08f44e827b60d53c87ac10a1f61251",
		  
		  "name": "Eric",
		  "createdDate": "2023-06-19 19:07:38",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 1096,
		  "totalCountries": 39,
		  "totalStates": 44,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 3749,
		  "schedulePercent": 0.898345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea16aba027fd0315708df5a00e0a6515",
		  
		  "name": "Pekka",
		  "createdDate": "2025-04-16 06:43:19",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 88,
		  "totalCountries": 3,
		  "totalStates": 1,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 202,
		  "schedulePercent": 0.162058,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Tulisuudelma",
		  "mostGuestCity": "Vantaa",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea241e60502fb47d87aa38950064d917",
		  
		  "name": "Yoke",
		  "createdDate": "2023-07-27 19:55:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 428,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1111,
		  "schedulePercent": 0.521079,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea2582f0ec4ab3247f92dbda498f79e4",
		  
		  "name": "Lisa",
		  "createdDate": "2024-04-22 17:28:41",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 409,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-01-14 00:00:00",
		  "mostGuestName": "City Winery",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea25d64674827ec12e5f76ec7457f134",
		  
		  "name": "Laila",
		  "createdDate": "2023-10-11 15:24:23",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 160,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 285,
		  "schedulePercent": 0.209542,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea2665f7a2168bd55afcaa79f4135686",
		  
		  "name": "Shelby",
		  "createdDate": "2023-05-26 15:55:59",
		  "totalOrganizations": 6,
		  "totalTours": 21,
		  "totalDays": 523,
		  "totalCountries": 14,
		  "totalStates": 62,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 2936,
		  "schedulePercent": 0.835789,
		  "totalGuests": 584,
		  "guestPercent": 0.75442,
		  "mostGuestDate": "2025-06-26 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea2b857e87e97eef5d049b579818f3a1",
		  
		  "name": "Gina",
		  "createdDate": "2013-06-04 17:42:15",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 126,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 495,
		  "schedulePercent": 0.310177,
		  "totalGuests": 41,
		  "guestPercent": 0.439937,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "9:30 Club",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea2e58b47d3910f4525c0cdfc1fecb12",
		  
		  "name": "Andras",
		  "createdDate": "2022-10-04 10:09:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 64,
		  "totalCountries": 8,
		  "totalStates": 4,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 297,
		  "schedulePercent": 0.216342,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea34cc69e82a980b5a0b1a5e547e10a6",
		  
		  "name": "Colton",
		  "createdDate": "2024-07-30 05:30:18",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 1022,
		  "totalCountries": 10,
		  "totalStates": 45,
		  "totalEvents": 155,
		  "eventPercent": 0.715889,
		  "totalScheduleItems": 3188,
		  "schedulePercent": 0.858794,
		  "totalGuests": 1509,
		  "guestPercent": 0.910131,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 105,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea48cb107cd8f67b4b1a05f64099d558",
		  
		  "name": "Dan",
		  "createdDate": "2013-05-06 21:56:07",
		  "totalOrganizations": 18,
		  "totalTours": 26,
		  "totalDays": 750,
		  "totalCountries": 30,
		  "totalStates": 84,
		  "totalEvents": 385,
		  "eventPercent": 0.955122,
		  "totalScheduleItems": 4828,
		  "schedulePercent": 0.948209,
		  "totalGuests": 3889,
		  "guestPercent": 0.992407,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 263,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea5aa158764963e4b1674cf74aa687e9",
		  
		  "name": "Matt",
		  "createdDate": "2018-08-01 10:06:13",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 520,
		  "totalCountries": 19,
		  "totalStates": 28,
		  "totalEvents": 250,
		  "eventPercent": 0.87092,
		  "totalScheduleItems": 2929,
		  "schedulePercent": 0.834202,
		  "totalGuests": 748,
		  "guestPercent": 0.795784,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Shrine Auditorium and Expo Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea5ec0c5859af103228ec1b67ff2d13d",
		  
		  "name": "Sofie",
		  "createdDate": "2024-08-30 12:56:50",
		  "totalOrganizations": 14,
		  "totalTours": 12,
		  "totalDays": 312,
		  "totalCountries": 4,
		  "totalStates": 12,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 998,
		  "schedulePercent": 0.489687,
		  "totalGuests": 210,
		  "guestPercent": 0.601881,
		  "mostGuestDate": "2025-11-04 00:00:00",
		  "mostGuestName": "Stadthalle KÃ¶ln",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea6e5df0b859a2a1667272d0ab3d0d67",
		  
		  "name": "Alexandra",
		  "createdDate": "2014-09-22 18:39:18",
		  "totalOrganizations": 8,
		  "totalTours": 18,
		  "totalDays": 742,
		  "totalCountries": 29,
		  "totalStates": 56,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 3755,
		  "schedulePercent": 0.899252,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea72b29cc43c9e7bed55d1da3f43a0ac",
		  
		  "name": "Christine",
		  "createdDate": "2022-11-05 03:51:07",
		  "totalOrganizations": 9,
		  "totalTours": 97,
		  "totalDays": 637,
		  "totalCountries": 29,
		  "totalStates": 77,
		  "totalEvents": 335,
		  "eventPercent": 0.935063,
		  "totalScheduleItems": 2609,
		  "schedulePercent": 0.798844,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea795036a777502796983d0dfbfcfbbd",
		  
		  "name": "Carmen",
		  "createdDate": "2012-10-17 17:38:03",
		  "totalOrganizations": 12,
		  "totalTours": 27,
		  "totalDays": 824,
		  "totalCountries": 10,
		  "totalStates": 56,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 4623,
		  "schedulePercent": 0.94141,
		  "totalGuests": 3020,
		  "guestPercent": 0.982321,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea796e8f8b6b030c3c2fda51c3c0efa5",
		  
		  "name": "blake",
		  "createdDate": "2021-05-05 01:27:09",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 600,
		  "totalCountries": 15,
		  "totalStates": 46,
		  "totalEvents": 113,
		  "eventPercent": 0.599615,
		  "totalScheduleItems": 2604,
		  "schedulePercent": 0.797824,
		  "totalGuests": 36,
		  "guestPercent": 0.43087,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "WestWorld of Scottsdale",
		  "mostGuestCity": "Scottsdale",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea7d9e49deb2bb6e532f03ee2c684c77",
		  
		  "name": "Aaron",
		  "createdDate": "2018-06-05 05:07:54",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 837,
		  "totalCountries": 3,
		  "totalStates": 45,
		  "totalEvents": 336,
		  "eventPercent": 0.93563,
		  "totalScheduleItems": 3677,
		  "schedulePercent": 0.894606,
		  "totalGuests": 4079,
		  "guestPercent": 0.993767,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea80ae98292ff0b8cae4f2613f5997ad",
		  
		  "name": "Will",
		  "createdDate": "2023-06-28 15:52:09",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 1537,
		  "totalCountries": 28,
		  "totalStates": 69,
		  "totalEvents": 209,
		  "eventPercent": 0.81641,
		  "totalScheduleItems": 3351,
		  "schedulePercent": 0.871147,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "The National Stadium",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea851f117f8e3e63199256bc4aec37f9",
		  
		  "name": "Tim ",
		  "createdDate": "2017-05-02 21:28:47",
		  "totalOrganizations": 12,
		  "totalTours": 26,
		  "totalDays": 2519,
		  "totalCountries": 12,
		  "totalStates": 58,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 5567,
		  "schedulePercent": 0.968948,
		  "totalGuests": 712,
		  "guestPercent": 0.788418,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "The Great Saltair",
		  "mostGuestCity": "Magna",
		  "mostGuestAmount": 120,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea8d13fddec1ce1abde556d25243c637",
		  
		  "name": "Charlie",
		  "createdDate": "2010-01-16 06:14:26",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 84,
		  "totalCountries": 5,
		  "totalStates": 22,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 589,
		  "schedulePercent": 0.347235,
		  "totalGuests": 419,
		  "guestPercent": 0.701496,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea8e80bd4fb5a27c1f977f9800490933",
		  
		  "name": "Aaron",
		  "createdDate": "2023-06-11 11:03:11",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 1042,
		  "totalCountries": 11,
		  "totalStates": 54,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 2614,
		  "schedulePercent": 0.799411,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Mohegan Sun Arena",
		  "mostGuestCity": "Uncasville",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea93eaaf498bf473aa92815b6eccfb29",
		  
		  "name": "Megan",
		  "createdDate": "2024-08-25 17:17:17",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 424,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 201,
		  "eventPercent": 0.802697,
		  "totalScheduleItems": 2211,
		  "schedulePercent": 0.749433,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ea96c67768542118e58759c712042557",
		  
		  "name": "Michael",
		  "createdDate": "2017-07-17 22:38:24",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 846,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1253,
		  "schedulePercent": 0.561197,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Analog at Hutton Hotel",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eaab88fa9bc101679cb4db1e6382b791",
		  
		  "name": "Elizabeth",
		  "createdDate": "2022-02-26 08:35:05",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 455,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 467,
		  "schedulePercent": 0.297031,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eab2ac1261bde3c0efce8783c4aeafac",
		  
		  "name": "Amy",
		  "createdDate": "2025-07-08 12:28:18",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 104,
		  "totalCountries": 22,
		  "totalStates": 22,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 858,
		  "schedulePercent": 0.44311,
		  "totalGuests": 360,
		  "guestPercent": 0.67815,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Old Royal Naval College",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eab8066e34ffe2a0a5c9c051058058c3",
		  
		  "name": "Tori",
		  "createdDate": "2017-06-24 01:37:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 17,
		  "totalStates": 23,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 879,
		  "schedulePercent": 0.451043,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eabb51c1c8e1595e96d989e6b7c4eb72",
		  
		  "name": "Scott",
		  "createdDate": "2009-07-17 03:16:15",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 33,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 122,
		  "schedulePercent": 0.112534,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eac8de09cf1942691e01d0aa8ce4cab7",
		  
		  "name": "becky",
		  "createdDate": "2025-04-02 15:44:34",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 44,
		  "totalCountries": 13,
		  "totalStates": 11,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 249,
		  "schedulePercent": 0.189483,
		  "totalGuests": 100,
		  "guestPercent": 0.519832,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "Leeds Irish Centre",
		  "mostGuestCity": "Leeds",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eacfb5331f79a3e00992855b571086ff",
		  
		  "name": "John",
		  "createdDate": "2019-02-27 09:13:17",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 101,
		  "totalCountries": 18,
		  "totalStates": 39,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 579,
		  "schedulePercent": 0.343155,
		  "totalGuests": 843,
		  "guestPercent": 0.818563,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "House of Blues Las Vegas",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ead1e86cf41062f05b4e564314936242",
		  
		  "name": "Beau",
		  "createdDate": "2022-05-11 18:12:06",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 629,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 3538,
		  "schedulePercent": 0.88418,
		  "totalGuests": 3022,
		  "guestPercent": 0.982548,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eae321f0f69eb6c1e9b004277a17317e",
		  
		  "name": "Bernhard",
		  "createdDate": "2024-06-07 10:21:57",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 345,
		  "totalCountries": 34,
		  "totalStates": 61,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 3049,
		  "schedulePercent": 0.847461,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eae74c191139363cca2f8ea8c0250533",
		  
		  "name": "Benjamin",
		  "createdDate": "2013-03-21 16:59:03",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 311,
		  "totalCountries": 7,
		  "totalStates": 48,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 2237,
		  "schedulePercent": 0.753626,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eaecf67aa804a4663983956eb43b7229",
		  
		  "name": "David",
		  "createdDate": "2014-05-11 17:50:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 953,
		  "schedulePercent": 0.477108,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eaf89104221821c1d1d0bf2108e0b5ad",
		  
		  "name": "Dan",
		  "createdDate": "2025-06-26 14:54:50",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eafcfd048ab948a3c875965837869b2c",
		  
		  "name": "Studio",
		  "createdDate": "2021-11-04 10:54:57",
		  "totalOrganizations": 2,
		  "totalTours": 14,
		  "totalDays": 142,
		  "totalCountries": 2,
		  "totalStates": 11,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1392,
		  "schedulePercent": 0.595648,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Zenith Arena Lille",
		  "mostGuestCity": "Lille",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb15c23b3c0f5bc638b89b3b9d2e9f9e",
		  
		  "name": "Greg",
		  "createdDate": "2016-08-20 19:04:53",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 239,
		  "totalCountries": 33,
		  "totalStates": 57,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 1508,
		  "schedulePercent": 0.61956,
		  "totalGuests": 634,
		  "guestPercent": 0.766659,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb19368e7a629c0880300b4bf838a662",
		  
		  "name": "Brooke",
		  "createdDate": "2023-10-23 15:49:06",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 144,
		  "totalCountries": 3,
		  "totalStates": 40,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 928,
		  "schedulePercent": 0.467928,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb1aefd32e3b75b28623ea81d83fc637",
		  
		  "name": "Pal Magnus",
		  "createdDate": "2023-07-29 14:20:02",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 174,
		  "totalCountries": 6,
		  "totalStates": 14,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1297,
		  "schedulePercent": 0.57083,
		  "totalGuests": 425,
		  "guestPercent": 0.704442,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 241,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb21d774aa594a0cb8d32b0d57f8af75",
		  
		  "name": "Gil",
		  "createdDate": "2022-12-07 11:26:03",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 95,
		  "totalCountries": 2,
		  "totalStates": 1,
		  "totalEvents": 6,
		  "eventPercent": 0.0499773,
		  "totalScheduleItems": 6,
		  "schedulePercent": 0.0160925,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-05-08 00:00:00",
		  "mostGuestName": "Zappa Herzliya",
		  "mostGuestCity": "×”×¨×¦×œ×™×”",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb2f9098817b28abdbab6258b18149d1",
		  
		  "name": "Bruna",
		  "createdDate": "2022-06-22 01:56:29",
		  "totalOrganizations": 2,
		  "totalTours": 12,
		  "totalDays": 184,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 317,
		  "eventPercent": 0.923617,
		  "totalScheduleItems": 1212,
		  "schedulePercent": 0.549637,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb314951c0de71ca29a6d69da72fbfbb",
		  
		  "name": "Dylan",
		  "createdDate": "2022-02-02 12:24:11",
		  "totalOrganizations": 36,
		  "totalTours": 59,
		  "totalDays": 1643,
		  "totalCountries": 39,
		  "totalStates": 108,
		  "totalEvents": 600,
		  "eventPercent": 0.987421,
		  "totalScheduleItems": 8044,
		  "schedulePercent": 0.990707,
		  "totalGuests": 3289,
		  "guestPercent": 0.987421,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb360dc149bb9fbb5cdd25da0c75da2c",
		  
		  "name": "Pete",
		  "createdDate": "2021-02-22 21:48:03",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 411,
		  "totalCountries": 2,
		  "totalStates": 19,
		  "totalEvents": 29,
		  "eventPercent": 0.208522,
		  "totalScheduleItems": 287,
		  "schedulePercent": 0.210562,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-04-29 00:00:00",
		  "mostGuestName": "Minglewood Hall",
		  "mostGuestCity": "Memphis",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb39fb3740260d48ed93f3a34723c5d1",
		  
		  "name": "Scooter",
		  "createdDate": "2013-10-02 20:10:32",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 601,
		  "totalCountries": 6,
		  "totalStates": 37,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 1485,
		  "schedulePercent": 0.614687,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "The Van Buren",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb3b0746df48eabaecd7ac4d6e52f49f",
		  
		  "name": "Maria",
		  "createdDate": "2014-05-06 03:38:28",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 595,
		  "totalCountries": 12,
		  "totalStates": 35,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 3476,
		  "schedulePercent": 0.88078,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-11-04 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb3b682a97ba1023ce638349ea84385e",
		  
		  "name": "Makeda",
		  "createdDate": "2024-04-13 00:00:22",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 599,
		  "totalCountries": 12,
		  "totalStates": 53,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1555,
		  "schedulePercent": 0.631573,
		  "totalGuests": 1387,
		  "guestPercent": 0.899139,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Pitt Street Uniting Church",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb4c8237d490b3a0e8d3f07e911e8592",
		  
		  "name": "Barry",
		  "createdDate": "2025-07-27 11:05:27",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 145,
		  "totalCountries": 8,
		  "totalStates": 19,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 304,
		  "schedulePercent": 0.218948,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb4c8cbdff3a792ca767eb178fe0324d",
		  
		  "name": "Theresa",
		  "createdDate": "2021-08-16 21:41:07",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 1410,
		  "totalCountries": 10,
		  "totalStates": 48,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 4158,
		  "schedulePercent": 0.922597,
		  "totalGuests": 1910,
		  "guestPercent": 0.940616,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb4fc7c941a563d4c4c2b720dce94b34",
		  
		  "name": "David",
		  "createdDate": "2011-01-09 00:33:32",
		  "totalOrganizations": 13,
		  "totalTours": 9,
		  "totalDays": 450,
		  "totalCountries": 11,
		  "totalStates": 34,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1243,
		  "schedulePercent": 0.558704,
		  "totalGuests": 249,
		  "guestPercent": 0.624887,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "ICON Festival stage at small park",
		  "mostGuestCity": "Cincinnati",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb52c265eb00e914630efd04f7353a03",
		  
		  "name": "Victor",
		  "createdDate": "2022-09-23 12:09:49",
		  "totalOrganizations": 31,
		  "totalTours": 10,
		  "totalDays": 111,
		  "totalCountries": 6,
		  "totalStates": 18,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 900,
		  "schedulePercent": 0.458409,
		  "totalGuests": 187,
		  "guestPercent": 0.584202,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Le Palais des CongrÃ¨s d'Issy",
		  "mostGuestCity": "Issy-les-Moulineaux",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb5537ab8e53fda0bd477c8f8f73c006",
		  
		  "name": "Tyler",
		  "createdDate": "2025-10-21 21:27:31",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 21,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 302,
		  "schedulePercent": 0.218268,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb58759928e713cc19eaf8dcead48725",
		  
		  "name": "Matthew",
		  "createdDate": "2022-06-29 15:02:12",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 1571,
		  "totalCountries": 15,
		  "totalStates": 54,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 3985,
		  "schedulePercent": 0.912511,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb7f7863d4768f295aca9408ea9754fe",
		  
		  "name": "Caroline",
		  "createdDate": "2024-08-14 09:06:19",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 43,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 129,
		  "schedulePercent": 0.11718,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb88101dacd662529e8454d2e45e6bbb",
		  
		  "name": "Kayla",
		  "createdDate": "2022-08-03 15:45:45",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 205,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 1842,
		  "schedulePercent": 0.68393,
		  "totalGuests": 53,
		  "guestPercent": 0.456482,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "Fort Mose Historic State Park",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb8be49bd847e285aaed8104523478d4",
		  
		  "name": "Jordan",
		  "createdDate": "2019-09-17 01:52:15",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 744,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 185,
		  "eventPercent": 0.773685,
		  "totalScheduleItems": 3638,
		  "schedulePercent": 0.891546,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb92570846c2199d794db4ae4fed7e33",
		  
		  "name": "Christopher",
		  "createdDate": "2021-12-29 01:52:32",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 20,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 9,
		  "eventPercent": 0.0702629,
		  "totalScheduleItems": 191,
		  "schedulePercent": 0.153672,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Waves",
		  "mostGuestCity": "Towradgi",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb9440b70d89e44375c1e58ef015e552",
		  
		  "name": "Joey",
		  "createdDate": "2017-11-28 22:19:41",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 690,
		  "totalCountries": 24,
		  "totalStates": 81,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 4697,
		  "schedulePercent": 0.944016,
		  "totalGuests": 1566,
		  "guestPercent": 0.916364,
		  "mostGuestDate": "2025-05-11 00:00:00",
		  "mostGuestName": "",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb951cbe84aa7fdfea34796136210ee7",
		  
		  "name": "William",
		  "createdDate": "2021-06-05 01:18:06",
		  "totalOrganizations": 3,
		  "totalTours": 20,
		  "totalDays": 158,
		  "totalCountries": 4,
		  "totalStates": 7,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 937,
		  "schedulePercent": 0.471328,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Aotea Centre",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eb9f077a4b6c33026f8ee137d16aaa2f",
		  
		  "name": "Dominik",
		  "createdDate": "2023-12-04 08:54:13",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 49,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 894,
		  "schedulePercent": 0.455802,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eba1057d45aa5f8db923ebd32d20ae37",
		  
		  "name": "Britt",
		  "createdDate": "2024-07-11 20:45:35",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 542,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 318,
		  "schedulePercent": 0.225748,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eba447998d186c0e9b3ccea4601ea1d5",
		  
		  "name": "Libor",
		  "createdDate": "2024-03-11 10:43:03",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 258,
		  "totalCountries": 18,
		  "totalStates": 31,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 894,
		  "schedulePercent": 0.455802,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Carlswerk Victoria",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eba4cba3398930553ec4f36828aa6b1d",
		  
		  "name": "Rocky",
		  "createdDate": "2025-04-01 16:09:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 461,
		  "schedulePercent": 0.294991,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Brighton Music Hall",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eba5c80727d42535361b9bd0960f4fc0",
		  
		  "name": "Mark",
		  "createdDate": "2013-06-29 12:12:35",
		  "totalOrganizations": 9,
		  "totalTours": 6,
		  "totalDays": 426,
		  "totalCountries": 18,
		  "totalStates": 17,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 1139,
		  "schedulePercent": 0.531845,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eba6f17c83ed2a4a0550850f4405fa8d",
		  
		  "name": "Simon",
		  "createdDate": "2014-06-11 08:10:25",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 97,
		  "totalCountries": 10,
		  "totalStates": 14,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 582,
		  "schedulePercent": 0.344515,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eba74472e27d0d29776e3d3d59a00de8",
		  
		  "name": "Paige",
		  "createdDate": "2024-07-15 22:24:35",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 77,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 446,
		  "schedulePercent": 0.289098,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebaf3b44b3e7f9411da4d7a7f6117542",
		  
		  "name": "Bobby",
		  "createdDate": "2014-10-20 20:13:56",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 49,
		  "totalCountries": 8,
		  "totalStates": 19,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 134,
		  "schedulePercent": 0.120807,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebb5a5413418ade87c52614bcefcd548",
		  
		  "name": "Irene",
		  "createdDate": "2021-11-23 12:59:54",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 348,
		  "totalCountries": 9,
		  "totalStates": 26,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1013,
		  "schedulePercent": 0.49422,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebbdfb4fbc116405c2d2fe1fbfedf160",
		  
		  "name": "Samanatha",
		  "createdDate": "2024-03-04 17:52:29",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 530,
		  "totalCountries": 13,
		  "totalStates": 34,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 732,
		  "schedulePercent": 0.399139,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "State Theatre",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebc1b57991c4115eb1caae7148309147",
		  
		  "name": "Christopher",
		  "createdDate": "2021-09-21 05:34:15",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 460,
		  "totalCountries": 16,
		  "totalStates": 52,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2523,
		  "schedulePercent": 0.788645,
		  "totalGuests": 827,
		  "guestPercent": 0.81437,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebcbe92e6fb4b15ba74c35318d6d6548",
		  
		  "name": "RICKY",
		  "createdDate": "2025-05-28 14:17:39",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 542,
		  "totalCountries": 18,
		  "totalStates": 35,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1065,
		  "schedulePercent": 0.50816,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebcf3786c6b888f7cf3bb0c97b597b1d",
		  
		  "name": "Ian ",
		  "createdDate": "2022-11-19 17:30:31",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 1068,
		  "totalCountries": 4,
		  "totalStates": 74,
		  "totalEvents": 394,
		  "eventPercent": 0.957389,
		  "totalScheduleItems": 3566,
		  "schedulePercent": 0.886333,
		  "totalGuests": 738,
		  "guestPercent": 0.793631,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Refinery Charleston",
		  "mostGuestCity": "Charleston",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebdaac937261b7388aed1cd0681b7352",
		  
		  "name": "Mark",
		  "createdDate": "2015-05-02 19:59:16",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 367,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1354,
		  "schedulePercent": 0.586129,
		  "totalGuests": 946,
		  "guestPercent": 0.838962,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Saenger Theatre",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 145,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebdb72022769877b24fcb0ee6aab9fc0",
		  
		  "name": "Tyson",
		  "createdDate": "2024-03-05 12:52:48",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 145,
		  "totalCountries": 15,
		  "totalStates": 44,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 885,
		  "schedulePercent": 0.452403,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Tioga-Sequoia Brewing Company Beer Garden",
		  "mostGuestCity": "Fresno",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebe5bd787cc89783836eeeaa1902ee58",
		  
		  "name": "Jeremy ",
		  "createdDate": "2012-11-11 20:08:26",
		  "totalOrganizations": 28,
		  "totalTours": 14,
		  "totalDays": 489,
		  "totalCountries": 14,
		  "totalStates": 54,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 2448,
		  "schedulePercent": 0.780938,
		  "totalGuests": 413,
		  "guestPercent": 0.698663,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Fallsview Casino Resort",
		  "mostGuestCity": "Niagara Falls",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebeb1cab5c85f406290f1c83ea394de1",
		  
		  "name": "Andy",
		  "createdDate": "2019-10-17 14:11:23",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 110,
		  "totalCountries": 12,
		  "totalStates": 25,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 693,
		  "schedulePercent": 0.383613,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Sand Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebef1197fd6b6cd623e8f009b93c9008",
		  
		  "name": "Melonie",
		  "createdDate": "2013-09-15 22:53:41",
		  "totalOrganizations": 11,
		  "totalTours": 4,
		  "totalDays": 229,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 947,
		  "schedulePercent": 0.474388,
		  "totalGuests": 202,
		  "guestPercent": 0.596328,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Million Dollar Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebf6a8e64ef03e7d7839d826f2fb043c",
		  
		  "name": "Matthew ",
		  "createdDate": "2022-08-07 05:46:34",
		  "totalOrganizations": 10,
		  "totalTours": 40,
		  "totalDays": 863,
		  "totalCountries": 17,
		  "totalStates": 59,
		  "totalEvents": 273,
		  "eventPercent": 0.893699,
		  "totalScheduleItems": 3380,
		  "schedulePercent": 0.873867,
		  "totalGuests": 1682,
		  "guestPercent": 0.926904,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebf8473b07525a152ef0213ca2b8a487",
		  
		  "name": "Philip",
		  "createdDate": "2009-05-05 17:17:18",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 801,
		  "totalCountries": 21,
		  "totalStates": 51,
		  "totalEvents": 289,
		  "eventPercent": 0.904918,
		  "totalScheduleItems": 2971,
		  "schedulePercent": 0.839642,
		  "totalGuests": 1036,
		  "guestPercent": 0.852221,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ebfb346641bd7069a3099c32d1831566",
		  
		  "name": "Abigail",
		  "createdDate": "2016-10-02 12:10:33",
		  "totalOrganizations": 20,
		  "totalTours": 4,
		  "totalDays": 1092,
		  "totalCountries": 30,
		  "totalStates": 54,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 1937,
		  "schedulePercent": 0.701609,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec0bc48dd95116029b3e3c056ef7b641",
		  
		  "name": "Mya",
		  "createdDate": "2018-01-15 20:03:39",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 59,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 923,
		  "schedulePercent": 0.466228,
		  "totalGuests": 178,
		  "guestPercent": 0.579102,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Kauffman Center for the Performing Arts",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec23eb1957e8de7f316831712fa3a3a8",
		  
		  "name": "Claire",
		  "createdDate": "2025-08-28 19:06:04",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 127,
		  "totalCountries": 11,
		  "totalStates": 29,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 671,
		  "schedulePercent": 0.375227,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "The Empty Bottle",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec2a5240b8106732f28be86c5a0cb00f",
		  
		  "name": "John",
		  "createdDate": "2025-06-05 02:30:42",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 207,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 43,
		  "schedulePercent": 0.0541704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec331e364ee3900612360e0e9c6b03c5",
		  
		  "name": "SHANE",
		  "createdDate": "2022-09-20 07:15:06",
		  "totalOrganizations": 31,
		  "totalTours": 9,
		  "totalDays": 222,
		  "totalCountries": 4,
		  "totalStates": 13,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 688,
		  "schedulePercent": 0.3818,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec3489c3a113712621a3c0655bdbaa9b",
		  
		  "name": "Connor",
		  "createdDate": "2022-07-31 16:22:37",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 513,
		  "totalCountries": 15,
		  "totalStates": 60,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2271,
		  "schedulePercent": 0.75816,
		  "totalGuests": 118,
		  "guestPercent": 0.535698,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Pearl Concert Theater",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 84,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec3c218dd8693ee88548bde37fe8926d",
		  
		  "name": "Marcus",
		  "createdDate": "2016-09-20 14:38:59",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 530,
		  "totalCountries": 20,
		  "totalStates": 39,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 2596,
		  "schedulePercent": 0.797031,
		  "totalGuests": 139,
		  "guestPercent": 0.551677,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Stars am Strand",
		  "mostGuestCity": "Timmendorfer Strand",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec3c5f29489964608247d77b173a4e6b",
		  
		  "name": "Carly",
		  "createdDate": "2024-06-21 23:25:12",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 212,
		  "totalCountries": 18,
		  "totalStates": 42,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 1263,
		  "schedulePercent": 0.563803,
		  "totalGuests": 945,
		  "guestPercent": 0.838735,
		  "mostGuestDate": "2025-04-06 00:00:00",
		  "mostGuestName": "EartH (Evolutionary Arts Hackney)",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec3c6efca493aa3b73b5b76143e60179",
		  
		  "name": "Loic",
		  "createdDate": "2023-03-03 09:41:13",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 867,
		  "totalCountries": 24,
		  "totalStates": 50,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 1665,
		  "schedulePercent": 0.652199,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-09-19 00:00:00",
		  "mostGuestName": "STEREOLUX",
		  "mostGuestCity": "Nantes",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec43a6a9aeb074f536cdca14014e7601",
		  
		  "name": "LIAM",
		  "createdDate": "2011-02-19 16:14:34",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 123,
		  "totalCountries": 10,
		  "totalStates": 17,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 457,
		  "schedulePercent": 0.293404,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec484b7e41b52329431b23019dd9f901",
		  
		  "name": "Thomas",
		  "createdDate": "2020-01-10 08:07:31",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 1557,
		  "totalCountries": 11,
		  "totalStates": 27,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2099,
		  "schedulePercent": 0.732774,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "La Maroquinerie",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec514087c232346972b43f33bb2078b4",
		  
		  "name": "Spencer",
		  "createdDate": "2024-05-07 23:20:20",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 147,
		  "totalCountries": 6,
		  "totalStates": 41,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 869,
		  "schedulePercent": 0.448549,
		  "totalGuests": 208,
		  "guestPercent": 0.600521,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "O2 Guildhall",
		  "mostGuestCity": "Southampton",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec5a881afc7f0fdd88e7684320c65e06",
		  
		  "name": "Landon",
		  "createdDate": "2025-09-25 22:13:44",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 38,
		  "totalCountries": 1,
		  "totalStates": 17,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 281,
		  "schedulePercent": 0.206256,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "House of Blues Orlando",
		  "mostGuestCity": "Lake Buena Vista",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec5b3c4521db1a20a9a9c9e915e44798",
		  
		  "name": "Cord",
		  "createdDate": "2024-03-26 14:41:49",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 960,
		  "totalCountries": 6,
		  "totalStates": 47,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 1976,
		  "schedulePercent": 0.708975,
		  "totalGuests": 340,
		  "guestPercent": 0.671011,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "The Van Buren",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec6f95a24acf151ddd1b56d315bbed62",
		  
		  "name": "Erika",
		  "createdDate": "2024-06-12 14:41:02",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 790,
		  "totalCountries": 5,
		  "totalStates": 59,
		  "totalEvents": 335,
		  "eventPercent": 0.935063,
		  "totalScheduleItems": 4550,
		  "schedulePercent": 0.939483,
		  "totalGuests": 423,
		  "guestPercent": 0.704102,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Paramount Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec7089926f680573da2c70982cdedb0a",
		  
		  "name": "Anthony",
		  "createdDate": "2021-02-22 18:49:36",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 768,
		  "totalCountries": 18,
		  "totalStates": 49,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 3882,
		  "schedulePercent": 0.907185,
		  "totalGuests": 1255,
		  "guestPercent": 0.88112,
		  "mostGuestDate": "2025-04-04 00:00:00",
		  "mostGuestName": "Champion Forest Baptist Church - Champions Campus",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 110,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec7b439db90ca1a0ce8269f470b8c611",
		  
		  "name": "Katie",
		  "createdDate": "2012-07-15 16:10:07",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 527,
		  "totalCountries": 29,
		  "totalStates": 49,
		  "totalEvents": 168,
		  "eventPercent": 0.743087,
		  "totalScheduleItems": 2890,
		  "schedulePercent": 0.831142,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec7d6cf8ec505ca1123e20412927aa89",
		  
		  "name": "Matt",
		  "createdDate": "2011-12-13 22:45:16",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 161,
		  "totalCountries": 14,
		  "totalStates": 37,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1324,
		  "schedulePercent": 0.576609,
		  "totalGuests": 1683,
		  "guestPercent": 0.927244,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "The Astro",
		  "mostGuestCity": "La Vista",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec84e6cf5237b13c8dd2d91e014f8a02",
		  
		  "name": "Mike",
		  "createdDate": "2023-04-15 18:56:11",
		  "totalOrganizations": 5,
		  "totalTours": 16,
		  "totalDays": 285,
		  "totalCountries": 13,
		  "totalStates": 6,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 1628,
		  "schedulePercent": 0.645626,
		  "totalGuests": 581,
		  "guestPercent": 0.753286,
		  "mostGuestDate": "2025-05-23 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 80,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ec981cc0c19e8b2bd52f6b2b469cceab",
		  
		  "name": "Mary",
		  "createdDate": "2013-12-24 03:40:21",
		  "totalOrganizations": 20,
		  "totalTours": 15,
		  "totalDays": 2042,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 3383,
		  "schedulePercent": 0.874093,
		  "totalGuests": 675,
		  "guestPercent": 0.779805,
		  "mostGuestDate": "2025-02-21 00:00:00",
		  "mostGuestName": "Abba's House",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecb5a70cee72004540718a51b731489a",
		  
		  "name": "Drake",
		  "createdDate": "2022-07-27 16:05:02",
		  "totalOrganizations": 3,
		  "totalTours": 14,
		  "totalDays": 193,
		  "totalCountries": 2,
		  "totalStates": 36,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 2037,
		  "schedulePercent": 0.720308,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecbc8ebdb59ee90e09f26b2541f10183",
		  
		  "name": "Greyson",
		  "createdDate": "2016-11-04 05:04:21",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 1555,
		  "totalCountries": 5,
		  "totalStates": 58,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 4614,
		  "schedulePercent": 0.941183,
		  "totalGuests": 1897,
		  "guestPercent": 0.939937,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 190,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecc31cf24dd1a485dccf4a20ecd4acc3",
		  
		  "name": "Paul",
		  "createdDate": "2010-06-15 17:46:14",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 194,
		  "totalCountries": 8,
		  "totalStates": 28,
		  "totalEvents": 115,
		  "eventPercent": 0.606188,
		  "totalScheduleItems": 1644,
		  "schedulePercent": 0.648232,
		  "totalGuests": 1051,
		  "guestPercent": 0.854374,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "MGM Grand",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 139,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecc3925035c1ac8df2d15229766cbf5a",
		  
		  "name": "Thomas",
		  "createdDate": "2019-08-12 01:24:59",
		  "totalOrganizations": 10,
		  "totalTours": 15,
		  "totalDays": 1812,
		  "totalCountries": 13,
		  "totalStates": 69,
		  "totalEvents": 419,
		  "eventPercent": 0.963509,
		  "totalScheduleItems": 4200,
		  "schedulePercent": 0.925771,
		  "totalGuests": 891,
		  "guestPercent": 0.827743,
		  "mostGuestDate": "2025-02-26 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecc53e6cd938be0f7e5f8792fecf4110",
		  
		  "name": "Olivia",
		  "createdDate": "2023-01-18 15:54:38",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 66,
		  "totalCountries": 8,
		  "totalStates": 10,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 342,
		  "schedulePercent": 0.239914,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "International de montgolfiÃ¨res de Saint-Jean-Sur-Richelieu",
		  "mostGuestCity": "Saint-Jean-sur-Richelieu",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecddb49cabe983706ea8fca267b75035",
		  
		  "name": "EG",
		  "createdDate": "2014-09-23 17:50:19",
		  "totalOrganizations": 22,
		  "totalTours": 19,
		  "totalDays": 1066,
		  "totalCountries": 31,
		  "totalStates": 52,
		  "totalEvents": 299,
		  "eventPercent": 0.912398,
		  "totalScheduleItems": 4808,
		  "schedulePercent": 0.947983,
		  "totalGuests": 1002,
		  "guestPercent": 0.846442,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "The SSE Hydro",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecef96132278f841ede23cf097be4340",
		  
		  "name": "Katie",
		  "createdDate": "2025-08-26 16:30:43",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 204,
		  "totalCountries": 6,
		  "totalStates": 13,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 449,
		  "schedulePercent": 0.290345,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecf5620fd53d289cbfa208e216aafd01",
		  
		  "name": "Yolanda",
		  "createdDate": "2025-01-14 16:15:10",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 70,
		  "totalCountries": 7,
		  "totalStates": 12,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 76,
		  "schedulePercent": 0.0787625,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Gruenspan",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ecf7962a7839fa65060aeb8aaffd2d48",
		  
		  "name": "Brad",
		  "createdDate": "2024-06-10 20:16:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 72,
		  "totalCountries": 1,
		  "totalStates": 5,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 301,
		  "schedulePercent": 0.217815,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed0aecd9dfdb625b5086c6880bd080f4",
		  
		  "name": "Daniel",
		  "createdDate": "2020-03-04 21:07:26",
		  "totalOrganizations": 15,
		  "totalTours": 32,
		  "totalDays": 1601,
		  "totalCountries": 21,
		  "totalStates": 88,
		  "totalEvents": 335,
		  "eventPercent": 0.935063,
		  "totalScheduleItems": 4372,
		  "schedulePercent": 0.933817,
		  "totalGuests": 898,
		  "guestPercent": 0.829556,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed1a84f95c4c0524fbe48a572299a1ff",
		  
		  "name": "Jack",
		  "createdDate": "2021-06-14 00:18:04",
		  "totalOrganizations": 2,
		  "totalTours": 11,
		  "totalDays": 150,
		  "totalCountries": 11,
		  "totalStates": 8,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed2345872aa32368117810f11c88348d",
		  
		  "name": "Anna",
		  "createdDate": "2021-02-03 04:07:36",
		  "totalOrganizations": 18,
		  "totalTours": 16,
		  "totalDays": 280,
		  "totalCountries": 12,
		  "totalStates": 46,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1006,
		  "schedulePercent": 0.49184,
		  "totalGuests": 34,
		  "guestPercent": 0.426677,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "The Empty Bottle",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed28da3566d25a419c2f1367e47d3837",
		  
		  "name": "Oscar",
		  "createdDate": "2022-12-12 20:42:20",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 150,
		  "totalCountries": 26,
		  "totalStates": 49,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 2043,
		  "schedulePercent": 0.721781,
		  "totalGuests": 230,
		  "guestPercent": 0.612534,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "Escenario GNP Seguros",
		  "mostGuestCity": "Monterrey",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed2dcf883f6834ea796998958cafb77a",
		  
		  "name": "Erin",
		  "createdDate": "2023-04-18 04:42:54",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 377,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1841,
		  "schedulePercent": 0.68359,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed3577a7643c48784577b3ff2424d81c",
		  
		  "name": "sarah ",
		  "createdDate": "2022-10-19 23:48:14",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 251,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 116,
		  "eventPercent": 0.609474,
		  "totalScheduleItems": 1113,
		  "schedulePercent": 0.521645,
		  "totalGuests": 252,
		  "guestPercent": 0.626247,
		  "mostGuestDate": "2025-01-28 00:00:00",
		  "mostGuestName": "Tipitina's Uptown",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed3b6b39dfa5357ae0fdee99ee9e07b2",
		  
		  "name": "David",
		  "createdDate": "2024-07-25 20:37:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 105,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 802,
		  "schedulePercent": 0.423391,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed41ff2f6b57fa13abfd7cc6b7c59e05",
		  
		  "name": "Matthew",
		  "createdDate": "2022-04-07 02:58:13",
		  "totalOrganizations": 37,
		  "totalTours": 42,
		  "totalDays": 740,
		  "totalCountries": 27,
		  "totalStates": 75,
		  "totalEvents": 276,
		  "eventPercent": 0.895626,
		  "totalScheduleItems": 3198,
		  "schedulePercent": 0.859474,
		  "totalGuests": 1285,
		  "guestPercent": 0.88384,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed6180d18bc74befdcd08c5c8bc5e569",
		  
		  "name": "Tom",
		  "createdDate": "2022-06-06 16:22:59",
		  "totalOrganizations": 5,
		  "totalTours": 17,
		  "totalDays": 386,
		  "totalCountries": 20,
		  "totalStates": 34,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 1294,
		  "schedulePercent": 0.570263,
		  "totalGuests": 438,
		  "guestPercent": 0.709089,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed73b3142aa29ab03bd61e3e633e8cc4",
		  
		  "name": "Nick",
		  "createdDate": "2025-10-20 21:27:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 46,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 4,
		  "schedulePercent": 0.0135993,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed75a01f44dcf303d7a622c9b9722ef3",
		  
		  "name": "Chris",
		  "createdDate": "2011-08-15 05:37:55",
		  "totalOrganizations": 17,
		  "totalTours": 2,
		  "totalDays": 96,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 220,
		  "schedulePercent": 0.171578,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Prohibition Kitchen",
		  "mostGuestCity": "St. Augustine",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed78c9bcd56948d4aa8e5e376a38123f",
		  
		  "name": "Henrik",
		  "createdDate": "2022-03-09 08:51:27",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 159,
		  "totalCountries": 7,
		  "totalStates": 9,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 682,
		  "schedulePercent": 0.379873,
		  "totalGuests": 325,
		  "guestPercent": 0.663531,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "MalmÃ¶ Arena",
		  "mostGuestCity": "MalmÃ¶",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed8089391eccd578cd55f4199de64f3c",
		  
		  "name": "Devin",
		  "createdDate": "2022-04-05 23:02:34",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 39,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 754,
		  "schedulePercent": 0.407298,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Mars Music Hall",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed8328be2c8b93fed3104bd11260f669",
		  
		  "name": "Laura",
		  "createdDate": "2024-02-20 15:20:27",
		  "totalOrganizations": 1,
		  "totalTours": 32,
		  "totalDays": 767,
		  "totalCountries": 23,
		  "totalStates": 25,
		  "totalEvents": 487,
		  "eventPercent": 0.976315,
		  "totalScheduleItems": 5374,
		  "schedulePercent": 0.964982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed84784801181075f87ad6f7fb6390ac",
		  
		  "name": "Beau",
		  "createdDate": "2017-09-06 15:50:10",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 53,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 375,
		  "schedulePercent": 0.25544,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-07-17 00:00:00",
		  "mostGuestName": "100 Club",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed868acc95c9a19bd3321058c84b2644",
		  
		  "name": "Joshua",
		  "createdDate": "2016-04-27 14:42:11",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 337,
		  "totalCountries": 15,
		  "totalStates": 39,
		  "totalEvents": 112,
		  "eventPercent": 0.596102,
		  "totalScheduleItems": 1063,
		  "schedulePercent": 0.507253,
		  "totalGuests": 267,
		  "guestPercent": 0.632253,
		  "mostGuestDate": "2025-03-30 00:00:00",
		  "mostGuestName": "Walt Disney Concert Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed8ae96c6a0767fba518df2a067fc8c5",
		  
		  "name": "Taylor",
		  "createdDate": "2018-06-23 12:14:24",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 128,
		  "totalCountries": 24,
		  "totalStates": 28,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 516,
		  "schedulePercent": 0.31947,
		  "totalGuests": 313,
		  "guestPercent": 0.655372,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "Queen Margaret Union",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed97bb0f88d8be1c13a1e3b57ed5d4f7",
		  
		  "name": "Tobias",
		  "createdDate": "2022-04-19 10:41:01",
		  "totalOrganizations": 20,
		  "totalTours": 10,
		  "totalDays": 213,
		  "totalCountries": 6,
		  "totalStates": 16,
		  "totalEvents": 188,
		  "eventPercent": 0.778332,
		  "totalScheduleItems": 1304,
		  "schedulePercent": 0.57219,
		  "totalGuests": 302,
		  "guestPercent": 0.650839,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Mosebacketerrassen",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed9d576a4f85295edff6e1f6485a16ee",
		  
		  "name": "Dennie ",
		  "createdDate": "2014-10-26 06:57:05",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 433,
		  "totalCountries": 21,
		  "totalStates": 58,
		  "totalEvents": 176,
		  "eventPercent": 0.75782,
		  "totalScheduleItems": 3867,
		  "schedulePercent": 0.906052,
		  "totalGuests": 1417,
		  "guestPercent": 0.901972,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Jyske Bank BOXEN",
		  "mostGuestCity": "Herning",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ed9ecfc1382282f267fcb14b4be432ef",
		  
		  "name": "Kate",
		  "createdDate": "2024-02-25 01:26:30",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 142,
		  "totalCountries": 15,
		  "totalStates": 29,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 467,
		  "schedulePercent": 0.297031,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Victoria Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edae26cbbdc22dbc027e5290c101eed2",
		  
		  "name": "Griffin",
		  "createdDate": "2023-09-27 14:47:24",
		  "totalOrganizations": 9,
		  "totalTours": 21,
		  "totalDays": 795,
		  "totalCountries": 19,
		  "totalStates": 60,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 1822,
		  "schedulePercent": 0.680077,
		  "totalGuests": 604,
		  "guestPercent": 0.75986,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edb75ff9705fee0a8bca569e0f5a9725",
		  
		  "name": "Luc",
		  "createdDate": "2018-06-06 16:34:04",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 92,
		  "totalCountries": 4,
		  "totalStates": 14,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 889,
		  "schedulePercent": 0.453649,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edbb5bb281cca61b22aa9a2b6e19494c",
		  
		  "name": "Martin",
		  "createdDate": "2014-02-07 23:12:20",
		  "totalOrganizations": 11,
		  "totalTours": 2,
		  "totalDays": 274,
		  "totalCountries": 18,
		  "totalStates": 23,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 2352,
		  "schedulePercent": 0.768472,
		  "totalGuests": 2611,
		  "guestPercent": 0.972235,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edbb71106f6ebb9c4f88a37a90b6de87",
		  
		  "name": "Sebastien",
		  "createdDate": "2018-02-14 09:59:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 93,
		  "totalCountries": 4,
		  "totalStates": 14,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 1277,
		  "schedulePercent": 0.566976,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edbeeb53a0c51e61b0368e2b614431ac",
		  
		  "name": "Lasse",
		  "createdDate": "2013-12-11 14:40:46",
		  "totalOrganizations": 188,
		  "totalTours": 72,
		  "totalDays": 2178,
		  "totalCountries": 23,
		  "totalStates": 29,
		  "totalEvents": 2041,
		  "eventPercent": 0.999547,
		  "totalScheduleItems": 8835,
		  "schedulePercent": 0.993087,
		  "totalGuests": 168,
		  "guestPercent": 0.572303,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "K.B. Hallen",
		  "mostGuestCity": "Frederiksberg",
		  "mostGuestAmount": 111,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edcc4b4a772f930949e58b104a2792da",
		  
		  "name": "Luke",
		  "createdDate": "2012-10-22 19:58:00",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 1209,
		  "totalCountries": 8,
		  "totalStates": 53,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 2000,
		  "schedulePercent": 0.713622,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Hidden Hall",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edd30c44f24b415baaeb5065c95bbc99",
		  
		  "name": "Mgmt",
		  "createdDate": "2025-01-29 17:32:51",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 110,
		  "totalCountries": 2,
		  "totalStates": 34,
		  "totalEvents": 57,
		  "eventPercent": 0.358001,
		  "totalScheduleItems": 366,
		  "schedulePercent": 0.25136,
		  "totalGuests": 372,
		  "guestPercent": 0.68189,
		  "mostGuestDate": "2025-03-18 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edd4b04b85e831890112885cabaaa320",
		  
		  "name": "Sandy",
		  "createdDate": "2023-01-17 10:05:36",
		  "totalOrganizations": 2,
		  "totalTours": 25,
		  "totalDays": 354,
		  "totalCountries": 10,
		  "totalStates": 41,
		  "totalEvents": 254,
		  "eventPercent": 0.874433,
		  "totalScheduleItems": 1958,
		  "schedulePercent": 0.705122,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Stadttheater Euskirchen",
		  "mostGuestCity": "Euskirchen",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edd4ca16d77c7b209bdc933a09022f0f",
		  
		  "name": "Don",
		  "createdDate": "2013-05-21 17:42:44",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 482,
		  "totalCountries": 26,
		  "totalStates": 35,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 2246,
		  "schedulePercent": 0.754533,
		  "totalGuests": 649,
		  "guestPercent": 0.771306,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Colosseum Theater at Caesars Palace",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ede4fa5a0aa3214bb80932a0f544f1ed",
		  
		  "name": "Chelsea",
		  "createdDate": "2024-05-05 14:28:36",
		  "totalOrganizations": 7,
		  "totalTours": 19,
		  "totalDays": 607,
		  "totalCountries": 23,
		  "totalStates": 76,
		  "totalEvents": 347,
		  "eventPercent": 0.941183,
		  "totalScheduleItems": 3917,
		  "schedulePercent": 0.909678,
		  "totalGuests": 918,
		  "guestPercent": 0.834202,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Myth Live",
		  "mostGuestCity": "Maplewood",
		  "mostGuestAmount": 31,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ede87aac078a5868db1443347ca17896",
		  
		  "name": "Chris",
		  "createdDate": "2021-08-24 02:20:10",
		  "totalOrganizations": 9,
		  "totalTours": 16,
		  "totalDays": 1015,
		  "totalCountries": 32,
		  "totalStates": 75,
		  "totalEvents": 374,
		  "eventPercent": 0.951609,
		  "totalScheduleItems": 6389,
		  "schedulePercent": 0.980281,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edeb0bbeafdafce759d0506b1c3edc9f",
		  
		  "name": "Shawn",
		  "createdDate": "2016-02-11 22:41:39",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 475,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 638,
		  "schedulePercent": 0.363781,
		  "totalGuests": 99,
		  "guestPercent": 0.518019,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Globe Life Field",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edf45172aa9959906a40038db7ba4d4c",
		  
		  "name": "Alexandra",
		  "createdDate": "2019-03-19 19:33:42",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 441,
		  "totalCountries": 11,
		  "totalStates": 49,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 2481,
		  "schedulePercent": 0.784565,
		  "totalGuests": 557,
		  "guestPercent": 0.74558,
		  "mostGuestDate": "2025-10-15 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edfc243a7761eca1c6b0d204ddb35557",
		  
		  "name": "Ilia",
		  "createdDate": "2023-04-25 22:29:10",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 174,
		  "totalCountries": 12,
		  "totalStates": 27,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 629,
		  "schedulePercent": 0.360381,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "Brooklyn Bowl Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "edff0c213489b9a3217e36f855cc6200",
		  
		  "name": "Matt",
		  "createdDate": "2013-08-10 05:12:27",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 228,
		  "totalCountries": 8,
		  "totalStates": 49,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 2373,
		  "schedulePercent": 0.771759,
		  "totalGuests": 497,
		  "guestPercent": 0.729488,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "SSE Arena Belfast",
		  "mostGuestCity": "Belfast",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee04cd52e518d701f7687ca3d6406952",
		  
		  "name": "Brian",
		  "createdDate": "2023-03-13 22:37:22",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 158,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 866,
		  "schedulePercent": 0.447303,
		  "totalGuests": 967,
		  "guestPercent": 0.840889,
		  "mostGuestDate": "2025-08-13 00:00:00",
		  "mostGuestName": "PNC Bank Arts Center",
		  "mostGuestCity": "Holmdel",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee0775dfc6fcc68ad6d3aef4a6220eb4",
		  
		  "name": "Erik",
		  "createdDate": "2024-03-07 23:37:47",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 545,
		  "totalCountries": 2,
		  "totalStates": 16,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 517,
		  "schedulePercent": 0.32015,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee07d0f8df165063c5c3e45ef0c1ed62",
		  
		  "name": "Bryce",
		  "createdDate": "2023-03-28 18:40:50",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 306,
		  "totalCountries": 17,
		  "totalStates": 59,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1756,
		  "schedulePercent": 0.669538,
		  "totalGuests": 256,
		  "guestPercent": 0.62806,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Massey Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee0f59c052d9d98c700037cfa86e0519",
		  
		  "name": "RIAN ",
		  "createdDate": "2025-09-29 23:52:36",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 181,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 238,
		  "schedulePercent": 0.183704,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee11e9d0e38f37c7ce806405110948d8",
		  
		  "name": "Simon",
		  "createdDate": "2010-05-26 10:34:08",
		  "totalOrganizations": 12,
		  "totalTours": 5,
		  "totalDays": 774,
		  "totalCountries": 17,
		  "totalStates": 32,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1259,
		  "schedulePercent": 0.562783,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "Governor's Ball Music Festival",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee141c5f22680e176db77062087aab34",
		  
		  "name": "Toby",
		  "createdDate": "2021-12-28 14:58:48",
		  "totalOrganizations": 10,
		  "totalTours": 12,
		  "totalDays": 405,
		  "totalCountries": 19,
		  "totalStates": 20,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 2315,
		  "schedulePercent": 0.763939,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee1caf36633d11fd9d8de5c9deb15390",
		  
		  "name": "Nolan ",
		  "createdDate": "2011-05-14 14:02:10",
		  "totalOrganizations": 17,
		  "totalTours": 17,
		  "totalDays": 1444,
		  "totalCountries": 5,
		  "totalStates": 64,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 3103,
		  "schedulePercent": 0.851881,
		  "totalGuests": 468,
		  "guestPercent": 0.719515,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee2616e590e8d82c9675c19034685c8b",
		  
		  "name": "Stephen",
		  "createdDate": "2013-07-10 13:26:59",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 607,
		  "totalCountries": 4,
		  "totalStates": 46,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 2102,
		  "schedulePercent": 0.733114,
		  "totalGuests": 744,
		  "guestPercent": 0.794991,
		  "mostGuestDate": "2025-07-12 00:00:00",
		  "mostGuestName": "Northside Hospital-Cherokee Amphitheater",
		  "mostGuestCity": "Woodstock",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee26f1b12337d42d3adad4b34364e273",
		  
		  "name": "Nikita",
		  "createdDate": "2018-04-16 09:38:15",
		  "totalOrganizations": 18,
		  "totalTours": 26,
		  "totalDays": 367,
		  "totalCountries": 15,
		  "totalStates": 50,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1752,
		  "schedulePercent": 0.668971,
		  "totalGuests": 838,
		  "guestPercent": 0.81743,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee27844cdca156ae86fe3813f787e88c",
		  
		  "name": "Misja",
		  "createdDate": "2014-04-28 04:05:13",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 843,
		  "totalCountries": 11,
		  "totalStates": 48,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1458,
		  "schedulePercent": 0.608908,
		  "totalGuests": 424,
		  "guestPercent": 0.704216,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee36e4475fc71c16a88271dd91e280d3",
		  
		  "name": "Kevin",
		  "createdDate": "2013-04-18 05:13:05",
		  "totalOrganizations": 3,
		  "totalTours": 5,
		  "totalDays": 233,
		  "totalCountries": 2,
		  "totalStates": 32,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 572,
		  "schedulePercent": 0.340435,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee45231ca55b2db5018b828b9e9b95a0",
		  
		  "name": "Emma",
		  "createdDate": "2021-10-05 11:37:58",
		  "totalOrganizations": 11,
		  "totalTours": 11,
		  "totalDays": 488,
		  "totalCountries": 14,
		  "totalStates": 52,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 1990,
		  "schedulePercent": 0.711695,
		  "totalGuests": 699,
		  "guestPercent": 0.785358,
		  "mostGuestDate": "2025-05-15 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee46fd72db9cbd7eae4b4f48c264b7b3",
		  
		  "name": "Alexandra",
		  "createdDate": "2012-04-14 23:04:16",
		  "totalOrganizations": 24,
		  "totalTours": 8,
		  "totalDays": 674,
		  "totalCountries": 34,
		  "totalStates": 47,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 3461,
		  "schedulePercent": 0.879986,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee4ee51e5967916e641ac7c7d2161603",
		  
		  "name": "Anne Marit",
		  "createdDate": "2024-04-29 07:56:36",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 119,
		  "totalCountries": 5,
		  "totalStates": 13,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 939,
		  "schedulePercent": 0.472121,
		  "totalGuests": 260,
		  "guestPercent": 0.629873,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "FjÃ¦reheia",
		  "mostGuestCity": "Grimstad",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee6178e88d43d48f8c90ea1cd66e0e53",
		  
		  "name": "Stephen",
		  "createdDate": "2012-10-06 18:40:40",
		  "totalOrganizations": 10,
		  "totalTours": 9,
		  "totalDays": 308,
		  "totalCountries": 20,
		  "totalStates": 40,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 934,
		  "schedulePercent": 0.470648,
		  "totalGuests": 324,
		  "guestPercent": 0.663191,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "Estadio Obras Sanitarias",
		  "mostGuestCity": "Buenos Aires",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee65a880063f8cb924c99e57a737f439",
		  
		  "name": "Myriam",
		  "createdDate": "2025-10-08 08:23:06",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 82,
		  "totalCountries": 14,
		  "totalStates": 1,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 494,
		  "schedulePercent": 0.30995,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Unity Arena",
		  "mostGuestCity": "Fornebu",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee6804dca2874a7ef3ca6bd7b2bc1f11",
		  
		  "name": "Laura",
		  "createdDate": "2025-06-11 09:09:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 38,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 200,
		  "schedulePercent": 0.161038,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee6f4d5894f95c979cf176d84985a56f",
		  
		  "name": "Alexej",
		  "createdDate": "2022-11-07 16:06:44",
		  "totalOrganizations": 31,
		  "totalTours": 35,
		  "totalDays": 1563,
		  "totalCountries": 11,
		  "totalStates": 32,
		  "totalEvents": 297,
		  "eventPercent": 0.910811,
		  "totalScheduleItems": 2463,
		  "schedulePercent": 0.782638,
		  "totalGuests": 996,
		  "guestPercent": 0.845422,
		  "mostGuestDate": "2025-02-12 00:00:00",
		  "mostGuestName": "Koelnarena",
		  "mostGuestCity": "Cologne",
		  "mostGuestAmount": 256,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee741adce6f409c3b3f5b82d7201684a",
		  
		  "name": "Will",
		  "createdDate": "2013-09-09 21:34:55",
		  "totalOrganizations": 15,
		  "totalTours": 20,
		  "totalDays": 547,
		  "totalCountries": 16,
		  "totalStates": 68,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2053,
		  "schedulePercent": 0.723935,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-05-02 00:00:00",
		  "mostGuestName": "Islington Assembly Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee76f66675d8a7f6c943810122c0b4ae",
		  
		  "name": "Nancy",
		  "createdDate": "2012-02-29 19:27:27",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 221,
		  "totalCountries": 29,
		  "totalStates": 58,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1462,
		  "schedulePercent": 0.609474,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Klub Studio",
		  "mostGuestCity": "KrakÃ³w",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee7d089fdec74b5aea1fb50d815150a7",
		  
		  "name": "Christopher ",
		  "createdDate": "2022-10-26 18:34:54",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 352,
		  "totalCountries": 3,
		  "totalStates": 46,
		  "totalEvents": 92,
		  "eventPercent": 0.519606,
		  "totalScheduleItems": 984,
		  "schedulePercent": 0.486401,
		  "totalGuests": 142,
		  "guestPercent": 0.553604,
		  "mostGuestDate": "2025-09-23 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee956685242fa9efe2a8071f6a7e48ee",
		  
		  "name": "Laura",
		  "createdDate": "2022-03-21 14:26:48",
		  "totalOrganizations": 15,
		  "totalTours": 11,
		  "totalDays": 1965,
		  "totalCountries": 7,
		  "totalStates": 29,
		  "totalEvents": 269,
		  "eventPercent": 0.889393,
		  "totalScheduleItems": 3255,
		  "schedulePercent": 0.864801,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee9a04fa7781a0e965c42dc3e72e5306",
		  
		  "name": "PROY",
		  "createdDate": "2023-10-05 10:03:55",
		  "totalOrganizations": 7,
		  "totalTours": 18,
		  "totalDays": 1120,
		  "totalCountries": 14,
		  "totalStates": 31,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 938,
		  "schedulePercent": 0.471895,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ee9fb4dde109ee3d38a6727dbe60f0bc",
		  
		  "name": "Zoe",
		  "createdDate": "2023-12-18 02:35:15",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 297,
		  "totalCountries": 31,
		  "totalStates": 41,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1124,
		  "schedulePercent": 0.526179,
		  "totalGuests": 16,
		  "guestPercent": 0.385879,
		  "mostGuestDate": "2025-08-01 00:00:00",
		  "mostGuestName": "Rock In Roma",
		  "mostGuestCity": "Roma",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eea3d04cfe05a7e90d8555af1eb84009",
		  
		  "name": "Elliot",
		  "createdDate": "2012-09-25 16:36:18",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 819,
		  "totalCountries": 22,
		  "totalStates": 49,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 4614,
		  "schedulePercent": 0.941183,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eea4c70285183d278f386385c558e2bc",
		  
		  "name": "Matthew",
		  "createdDate": "2016-07-10 23:11:49",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 101,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 453,
		  "schedulePercent": 0.291931,
		  "totalGuests": 402,
		  "guestPercent": 0.695376,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eeb3037bdaf152d2d099390940141fa8",
		  
		  "name": "Jarod",
		  "createdDate": "2016-03-11 00:16:59",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 685,
		  "totalCountries": 13,
		  "totalStates": 45,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1511,
		  "schedulePercent": 0.620127,
		  "totalGuests": 316,
		  "guestPercent": 0.656732,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Credit Union 1 Amphitheatre",
		  "mostGuestCity": "Tinley Park",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eec6594a2bbd7fb8d932b3585ed3b3ac",
		  
		  "name": "LOTD",
		  "createdDate": "2024-01-16 22:17:50",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 73,
		  "totalCountries": 10,
		  "totalStates": 12,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 325,
		  "schedulePercent": 0.229034,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-01-17 00:00:00",
		  "mostGuestName": "Bord GÃ¡is Energy Theatre",
		  "mostGuestCity": "Dublin",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eec79f6452f6e4357ccb4d88d27489d4",
		  
		  "name": "Kim",
		  "createdDate": "2011-05-09 06:20:52",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 1133,
		  "totalCountries": 34,
		  "totalStates": 52,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 3457,
		  "schedulePercent": 0.87976,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eed297ad0328ca2462acd4a94361515e",
		  
		  "name": "Greg",
		  "createdDate": "2013-06-12 14:24:02",
		  "totalOrganizations": 16,
		  "totalTours": 5,
		  "totalDays": 870,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1411,
		  "schedulePercent": 0.600408,
		  "totalGuests": 157,
		  "guestPercent": 0.564143,
		  "mostGuestDate": "2025-04-02 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eed7171fc9215ee30817679adb5e9252",
		  
		  "name": "Bonnie",
		  "createdDate": "2025-02-05 19:38:07",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 58,
		  "totalCountries": 14,
		  "totalStates": 39,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 516,
		  "schedulePercent": 0.31947,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "O2 Institute",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eedd6edfc2d37bdba25e8a8c37bd0082",
		  
		  "name": "Warren ",
		  "createdDate": "2010-09-29 21:55:54",
		  "totalOrganizations": 21,
		  "totalTours": 29,
		  "totalDays": 2266,
		  "totalCountries": 36,
		  "totalStates": 118,
		  "totalEvents": 629,
		  "eventPercent": 0.989234,
		  "totalScheduleItems": 11571,
		  "schedulePercent": 0.998073,
		  "totalGuests": 2952,
		  "guestPercent": 0.980848,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eedeb14341130d847e2fb92fef836d35",
		  
		  "name": "ValÃ©rie",
		  "createdDate": "2022-05-10 18:16:56",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 54,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 178,
		  "schedulePercent": 0.144606,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre Petit Champlain",
		  "mostGuestCity": "QuÃ©bec",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eedf772f10fa5fbd104c997746458cda",
		  
		  "name": "Jack",
		  "createdDate": "2018-04-02 22:06:35",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 1279,
		  "totalCountries": 5,
		  "totalStates": 56,
		  "totalEvents": 215,
		  "eventPercent": 0.824909,
		  "totalScheduleItems": 2812,
		  "schedulePercent": 0.823889,
		  "totalGuests": 537,
		  "guestPercent": 0.739914,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eee1a9623a686bf9b6e6995f9b61c93b",
		  
		  "name": "Ben",
		  "createdDate": "2024-05-25 16:28:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 353,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 988,
		  "schedulePercent": 0.487421,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eee9942880c1070ef99a6e161ef6f291",
		  
		  "name": "Luke",
		  "createdDate": "2011-03-16 01:14:18",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 921,
		  "totalCountries": 8,
		  "totalStates": 47,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 1620,
		  "schedulePercent": 0.644152,
		  "totalGuests": 758,
		  "guestPercent": 0.797937,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eeeac9f4973633cf87f73afe6009d10e",
		  
		  "name": "Denis",
		  "createdDate": "2015-06-02 07:59:43",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 767,
		  "schedulePercent": 0.410925,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eeeb662dad6b49a9c75dc62d4d988c3c",
		  
		  "name": "Sergio",
		  "createdDate": "2019-03-14 14:03:54",
		  "totalOrganizations": 10,
		  "totalTours": 8,
		  "totalDays": 268,
		  "totalCountries": 11,
		  "totalStates": 33,
		  "totalEvents": 265,
		  "eventPercent": 0.885993,
		  "totalScheduleItems": 1135,
		  "schedulePercent": 0.529805,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "eef1b849ce2a5ac89fe41608c4fc2816",
		  
		  "name": "Karen",
		  "createdDate": "2019-11-03 15:23:31",
		  "totalOrganizations": 5,
		  "totalTours": 19,
		  "totalDays": 1269,
		  "totalCountries": 5,
		  "totalStates": 57,
		  "totalEvents": 338,
		  "eventPercent": 0.93631,
		  "totalScheduleItems": 4152,
		  "schedulePercent": 0.922371,
		  "totalGuests": 1352,
		  "guestPercent": 0.893246,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Lakefront Arena",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef023ca3caf3cef4dfab40da9b9fbc1a",
		  
		  "name": "Maria",
		  "createdDate": "2016-06-01 19:18:59",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 735,
		  "totalCountries": 19,
		  "totalStates": 43,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 2147,
		  "schedulePercent": 0.739007,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "Palacio de los Deportes",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef04dea01c461a944b058e4b1ec96714",
		  
		  "name": "Kristen",
		  "createdDate": "2024-02-29 18:44:35",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 1864,
		  "totalCountries": 11,
		  "totalStates": 64,
		  "totalEvents": 461,
		  "eventPercent": 0.972801,
		  "totalScheduleItems": 11119,
		  "schedulePercent": 0.997847,
		  "totalGuests": 3635,
		  "guestPercent": 0.990934,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef0d4a0fbd206f87c13db6575b96a342",
		  
		  "name": "Matt",
		  "createdDate": "2024-10-11 16:06:58",
		  "totalOrganizations": 2,
		  "totalTours": 14,
		  "totalDays": 199,
		  "totalCountries": 11,
		  "totalStates": 34,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 556,
		  "schedulePercent": 0.335789,
		  "totalGuests": 388,
		  "guestPercent": 0.68903,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Manning Bar",
		  "mostGuestCity": "Camperdown",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef1068e980e6bdd32cb79117b25a86e3",
		  
		  "name": "Georgia",
		  "createdDate": "2023-08-23 22:45:05",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 201,
		  "totalCountries": 15,
		  "totalStates": 43,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1496,
		  "schedulePercent": 0.616954,
		  "totalGuests": 1056,
		  "guestPercent": 0.855848,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef130d51c3330896a9e9927e512103d3",
		  
		  "name": "Marilou",
		  "createdDate": "2025-03-29 13:25:27",
		  "totalOrganizations": 4,
		  "totalTours": 25,
		  "totalDays": 484,
		  "totalCountries": 6,
		  "totalStates": 19,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 725,
		  "schedulePercent": 0.396306,
		  "totalGuests": 153,
		  "guestPercent": 0.560517,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "B72",
		  "mostGuestCity": "Wien",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef1626295eeda7ac191854982532d836",
		  
		  "name": "Tammy",
		  "createdDate": "2024-05-02 17:56:22",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 518,
		  "totalCountries": 10,
		  "totalStates": 34,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 928,
		  "schedulePercent": 0.467928,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef1aba08c7a86d6bce8c395b07e90697",
		  
		  "name": "Emily",
		  "createdDate": "2025-05-03 20:14:01",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 679,
		  "totalCountries": 11,
		  "totalStates": 47,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 3012,
		  "schedulePercent": 0.843155,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef1cba60a4fe01c3cd64a45189b9da00",
		  
		  "name": "Tarun",
		  "createdDate": "2024-08-09 21:41:00",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 458,
		  "totalCountries": 9,
		  "totalStates": 6,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 138,
		  "schedulePercent": 0.123527,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef1dfd690eb7b198351e86c311b911fe",
		  
		  "name": "Will",
		  "createdDate": "2013-06-06 21:46:12",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 329,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 922,
		  "schedulePercent": 0.465888,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef242cce0999db724e3aaaa742d5e766",
		  
		  "name": "Buddy",
		  "createdDate": "2014-09-03 20:06:23",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 223,
		  "totalCountries": 20,
		  "totalStates": 50,
		  "totalEvents": 98,
		  "eventPercent": 0.545331,
		  "totalScheduleItems": 758,
		  "schedulePercent": 0.408885,
		  "totalGuests": 255,
		  "guestPercent": 0.627493,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "Xfinity Center",
		  "mostGuestCity": "Mansfield",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef3aa5eaf90dfdcb90f5ed139ccd4ee0",
		  
		  "name": "Sophie ",
		  "createdDate": "2023-04-04 19:36:54",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 205,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1466,
		  "schedulePercent": 0.610267,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef5046602bddb03b1db98c9d2e365902",
		  
		  "name": "Megan",
		  "createdDate": "2018-02-22 18:30:14",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 763,
		  "totalCountries": 7,
		  "totalStates": 44,
		  "totalEvents": 178,
		  "eventPercent": 0.762353,
		  "totalScheduleItems": 2950,
		  "schedulePercent": 0.836922,
		  "totalGuests": 3321,
		  "guestPercent": 0.987874,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Ak-Chin Pavilion",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 173,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef5eeabe58eb33d49fc247690aaa15ba",
		  
		  "name": "Ian",
		  "createdDate": "2012-01-23 17:35:35",
		  "totalOrganizations": 15,
		  "totalTours": 19,
		  "totalDays": 289,
		  "totalCountries": 15,
		  "totalStates": 43,
		  "totalEvents": 109,
		  "eventPercent": 0.586695,
		  "totalScheduleItems": 976,
		  "schedulePercent": 0.483114,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "9:30",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef620cd9df3eafff76f9ecc435c104e1",
		  
		  "name": "Max",
		  "createdDate": "2017-03-27 12:03:17",
		  "totalOrganizations": 15,
		  "totalTours": 19,
		  "totalDays": 352,
		  "totalCountries": 19,
		  "totalStates": 41,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2675,
		  "schedulePercent": 0.806324,
		  "totalGuests": 1481,
		  "guestPercent": 0.907525,
		  "mostGuestDate": "2025-10-12 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 158,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef6577d247f298746b88de971b1e4ba8",
		  
		  "name": "Marina",
		  "createdDate": "2018-01-23 22:23:42",
		  "totalOrganizations": 6,
		  "totalTours": 26,
		  "totalDays": 380,
		  "totalCountries": 22,
		  "totalStates": 40,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1223,
		  "schedulePercent": 0.55349,
		  "totalGuests": 41,
		  "guestPercent": 0.439937,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "The Music Center @ Strathmore",
		  "mostGuestCity": "North Bethesda",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef6633f1235d5798b3bf7995893a64b4",
		  
		  "name": "Ryan",
		  "createdDate": "2025-03-28 11:28:12",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 37,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 409,
		  "schedulePercent": 0.273459,
		  "totalGuests": 145,
		  "guestPercent": 0.555077,
		  "mostGuestDate": "2025-04-10 00:00:00",
		  "mostGuestName": "Jannus Live",
		  "mostGuestCity": "St. Petersburg",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef787248c0c9f9312c98e1b543567ae5",
		  
		  "name": "Audrey",
		  "createdDate": "2019-03-11 23:58:37",
		  "totalOrganizations": 14,
		  "totalTours": 22,
		  "totalDays": 524,
		  "totalCountries": 13,
		  "totalStates": 55,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 1983,
		  "schedulePercent": 0.710222,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Whammy",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef7b21b95776faccb2bf6eb47fc8894e",
		  
		  "name": "Noah",
		  "createdDate": "2019-04-19 15:46:00",
		  "totalOrganizations": 4,
		  "totalTours": 16,
		  "totalDays": 350,
		  "totalCountries": 11,
		  "totalStates": 50,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 2050,
		  "schedulePercent": 0.723141,
		  "totalGuests": 840,
		  "guestPercent": 0.817996,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Brooklyn Steel",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef7f1e442db7538caab1fcb7045ea94b",
		  
		  "name": "Denise",
		  "createdDate": "2019-07-15 19:01:51",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 786,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 139,
		  "schedulePercent": 0.123867,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef8408554417acf173196b68046c1ddb",
		  
		  "name": "Bernie",
		  "createdDate": "2023-06-08 03:48:34",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 138,
		  "totalCountries": 3,
		  "totalStates": 9,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef845c8d21f2a3c629ba3c4cc6e509e7",
		  
		  "name": "Joshua",
		  "createdDate": "2018-10-25 19:09:31",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 620,
		  "totalCountries": 3,
		  "totalStates": 52,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 3452,
		  "schedulePercent": 0.879193,
		  "totalGuests": 2661,
		  "guestPercent": 0.974388,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "FirstBank Amphitheater",
		  "mostGuestCity": "Franklin",
		  "mostGuestAmount": 227,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef86034f5cb0e7da7ae81e4332c4f13d",
		  
		  "name": "Dan ",
		  "createdDate": "2011-05-12 05:09:49",
		  "totalOrganizations": 15,
		  "totalTours": 27,
		  "totalDays": 761,
		  "totalCountries": 25,
		  "totalStates": 81,
		  "totalEvents": 296,
		  "eventPercent": 0.910131,
		  "totalScheduleItems": 4271,
		  "schedulePercent": 0.929964,
		  "totalGuests": 2385,
		  "guestPercent": 0.964869,
		  "mostGuestDate": "2025-04-05 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 114,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef90336e593cb9172f36ff0fe587b88f",
		  
		  "name": "Aaron",
		  "createdDate": "2018-03-05 20:12:18",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 502,
		  "totalCountries": 11,
		  "totalStates": 54,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2996,
		  "schedulePercent": 0.841908,
		  "totalGuests": 1347,
		  "guestPercent": 0.892566,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Grand Sierra Theater",
		  "mostGuestCity": "Reno",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef947853cdd1d40da3dcaaaa69277be7",
		  
		  "name": "Jan Tore",
		  "createdDate": "2021-11-04 11:14:08",
		  "totalOrganizations": 1,
		  "totalTours": 10,
		  "totalDays": 75,
		  "totalCountries": 7,
		  "totalStates": 6,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 173,
		  "schedulePercent": 0.142452,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ef9dba89a27c3ca0cc579337442831ee",
		  
		  "name": "Carla",
		  "createdDate": "2025-05-05 15:07:06",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 270,
		  "totalCountries": 10,
		  "totalStates": 30,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 1810,
		  "schedulePercent": 0.678037,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efab4b8d27c96258b636f4e37b7cbebe",
		  
		  "name": "Kaylene",
		  "createdDate": "2021-09-08 15:20:16",
		  "totalOrganizations": 7,
		  "totalTours": 2,
		  "totalDays": 146,
		  "totalCountries": 8,
		  "totalStates": 35,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 690,
		  "schedulePercent": 0.382593,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "The Axis Club Theatre",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efd06ec7cee22f67cb4e390e677caf59",
		  
		  "name": "Edvin",
		  "createdDate": "2018-07-06 10:24:02",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 441,
		  "totalCountries": 5,
		  "totalStates": 27,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 2193,
		  "schedulePercent": 0.747054,
		  "totalGuests": 314,
		  "guestPercent": 0.656052,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rdsfÃ¶reningen",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efdc610175c9e65d3b85a2be540326e0",
		  
		  "name": "Ryan",
		  "createdDate": "2021-09-30 16:08:39",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 119,
		  "totalCountries": 7,
		  "totalStates": 21,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 316,
		  "schedulePercent": 0.225295,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-01-11 00:00:00",
		  "mostGuestName": "Melbourne Recital Centre",
		  "mostGuestCity": "Southbank",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efde05db57c0ca531e678c2b095ca3cd",
		  
		  "name": "Taylor",
		  "createdDate": "2012-06-01 16:34:54",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 258,
		  "totalCountries": 16,
		  "totalStates": 46,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 927,
		  "schedulePercent": 0.467362,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efdeee2197f403a6ac24eb96bb894a01",
		  
		  "name": "Benjamin",
		  "createdDate": "2017-06-05 22:29:41",
		  "totalOrganizations": 11,
		  "totalTours": 21,
		  "totalDays": 853,
		  "totalCountries": 5,
		  "totalStates": 43,
		  "totalEvents": 362,
		  "eventPercent": 0.94719,
		  "totalScheduleItems": 1944,
		  "schedulePercent": 0.702629,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efdff05ac4b3a816b5ca528b87728ef8",
		  
		  "name": "Chris",
		  "createdDate": "2023-03-03 16:26:13",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 913,
		  "totalCountries": 17,
		  "totalStates": 17,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 228,
		  "schedulePercent": 0.176451,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efe2cdbef5e0a7aae8991498ad1e0cef",
		  
		  "name": "Jaclyn",
		  "createdDate": "2017-01-13 18:47:55",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 75,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 41,
		  "eventPercent": 0.278445,
		  "totalScheduleItems": 257,
		  "schedulePercent": 0.193903,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efe516b3706644af1b510ba2f6a76293",
		  
		  "name": "Garvin",
		  "createdDate": "2023-10-03 17:15:54",
		  "totalOrganizations": 3,
		  "totalTours": 21,
		  "totalDays": 182,
		  "totalCountries": 4,
		  "totalStates": 27,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1516,
		  "schedulePercent": 0.620807,
		  "totalGuests": 208,
		  "guestPercent": 0.600521,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Kauffman Center for the Performing Arts",
		  "mostGuestCity": "Kansas City",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "efeb92b56f7a522ccae072a60e0c1c1c",
		  
		  "name": "Quinton",
		  "createdDate": "2025-09-03 22:12:23",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 61,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 417,
		  "schedulePercent": 0.276972,
		  "totalGuests": 282,
		  "guestPercent": 0.640413,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Tarlelton Event Center",
		  "mostGuestCity": "Stephenville",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f005817cbf78c1e057b5b608617f0355",
		  
		  "name": "Q",
		  "createdDate": "2023-01-10 16:44:39",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 481,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 191,
		  "schedulePercent": 0.153672,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Mable House Barnes Amphitheatre",
		  "mostGuestCity": "Mableton",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f00daf82c921d5366ce39acfd72110ef",
		  
		  "name": "Don",
		  "createdDate": "2022-10-22 21:05:19",
		  "totalOrganizations": 8,
		  "totalTours": 13,
		  "totalDays": 230,
		  "totalCountries": 26,
		  "totalStates": 62,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1726,
		  "schedulePercent": 0.663191,
		  "totalGuests": 895,
		  "guestPercent": 0.828536,
		  "mostGuestDate": "2025-03-02 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f010960992ae59686ed82bfec6b59518",
		  
		  "name": "Aldo",
		  "createdDate": "2016-08-03 17:32:20",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 268,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 426,
		  "schedulePercent": 0.280598,
		  "totalGuests": 245,
		  "guestPercent": 0.622167,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "The Fillmore Miami Beach",
		  "mostGuestCity": "Miami Beach",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0131607dc30c3c54fa2df1373d95cd4",
		  
		  "name": "Carly",
		  "createdDate": "2015-09-10 15:25:58",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 255,
		  "totalCountries": 5,
		  "totalStates": 37,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1192,
		  "schedulePercent": 0.545444,
		  "totalGuests": 205,
		  "guestPercent": 0.598368,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "The Brighton Centre",
		  "mostGuestCity": "Brighton",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f013ae54fae541c937e6038da7684f23",
		  
		  "name": "Rhett",
		  "createdDate": "2024-02-09 00:14:08",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 108,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 763,
		  "schedulePercent": 0.409678,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Wonder Ballroom",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f02731560a5e55072fafa0cf56ed33e2",
		  
		  "name": "Rupert",
		  "createdDate": "2009-11-09 12:51:58",
		  "totalOrganizations": 15,
		  "totalTours": 15,
		  "totalDays": 358,
		  "totalCountries": 8,
		  "totalStates": 19,
		  "totalEvents": 140,
		  "eventPercent": 0.679284,
		  "totalScheduleItems": 2206,
		  "schedulePercent": 0.748753,
		  "totalGuests": 149,
		  "guestPercent": 0.557457,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Admiralspalast",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f03e236efa8b11381f15d6b1c697e899",
		  
		  "name": "Ted",
		  "createdDate": "2012-03-28 21:40:13",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 146,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1118,
		  "schedulePercent": 0.524025,
		  "totalGuests": 717,
		  "guestPercent": 0.789665,
		  "mostGuestDate": "2025-10-30 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0530fb217a8b3b679e632996bf853b9",
		  
		  "name": "Jonathan",
		  "createdDate": "2023-05-09 13:48:08",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 212,
		  "totalCountries": 4,
		  "totalStates": 53,
		  "totalEvents": 111,
		  "eventPercent": 0.593042,
		  "totalScheduleItems": 1081,
		  "schedulePercent": 0.514619,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-02-27 00:00:00",
		  "mostGuestName": "Barstool Nashville",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f064606123483c5279ed7cb4255de2c1",
		  
		  "name": "Serene",
		  "createdDate": "2024-09-12 05:25:53",
		  "totalOrganizations": 4,
		  "totalTours": 10,
		  "totalDays": 417,
		  "totalCountries": 10,
		  "totalStates": 6,
		  "totalEvents": 51,
		  "eventPercent": 0.327856,
		  "totalScheduleItems": 516,
		  "schedulePercent": 0.31947,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f068526bd9d8ebec758cbd0ff5d604a3",
		  
		  "name": "Lea",
		  "createdDate": "2025-06-02 14:47:48",
		  "totalOrganizations": 1,
		  "totalTours": 7,
		  "totalDays": 214,
		  "totalCountries": 16,
		  "totalStates": 31,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 621,
		  "schedulePercent": 0.357548,
		  "totalGuests": 80,
		  "guestPercent": 0.49728,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f06c25e37a3d08361407708dd351dde8",
		  
		  "name": "Nate ",
		  "createdDate": "2019-09-25 19:31:52",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 215,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 1847,
		  "schedulePercent": 0.685403,
		  "totalGuests": 25,
		  "guestPercent": 0.409678,
		  "mostGuestDate": "2025-02-22 00:00:00",
		  "mostGuestName": "SweetWater Brewing Company",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f071e3856049f3ee8729d574c06bc385",
		  
		  "name": "Daniel",
		  "createdDate": "2022-02-27 23:59:51",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 333,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 586,
		  "schedulePercent": 0.346442,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0738f90488a88f96ec6193b6f4c2ce3",
		  
		  "name": "Jon",
		  "createdDate": "2022-04-19 04:47:35",
		  "totalOrganizations": 15,
		  "totalTours": 20,
		  "totalDays": 828,
		  "totalCountries": 39,
		  "totalStates": 102,
		  "totalEvents": 342,
		  "eventPercent": 0.93767,
		  "totalScheduleItems": 4987,
		  "schedulePercent": 0.953876,
		  "totalGuests": 2705,
		  "guestPercent": 0.976201,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Hard Rock Live",
		  "mostGuestCity": "Wheatland",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f07e4d994713ac5f9e26ed20c4d851f9",
		  
		  "name": "Casey",
		  "createdDate": "2023-07-01 19:14:02",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 434,
		  "totalCountries": 3,
		  "totalStates": 31,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 2844,
		  "schedulePercent": 0.827289,
		  "totalGuests": 4023,
		  "guestPercent": 0.993427,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f086acbbdf16dc11c014ebec64605842",
		  
		  "name": "Georgia",
		  "createdDate": "2022-03-26 21:36:19",
		  "totalOrganizations": 53,
		  "totalTours": 24,
		  "totalDays": 674,
		  "totalCountries": 12,
		  "totalStates": 39,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 2842,
		  "schedulePercent": 0.827063,
		  "totalGuests": 77,
		  "guestPercent": 0.49456,
		  "mostGuestDate": "2025-05-05 00:00:00",
		  "mostGuestName": "GRAMMY Museum at L.A. LIVE",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f08a35913966259aaf2e06df3162eca7",
		  
		  "name": "Pablo",
		  "createdDate": "2023-04-06 17:35:10",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 48,
		  "totalCountries": 10,
		  "totalStates": 12,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 141,
		  "schedulePercent": 0.12534,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Teatro Cariola",
		  "mostGuestCity": "Santiago",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f08a6fcae55c6e7ffcdb0200058b5187",
		  
		  "name": "Geraldine ",
		  "createdDate": "2019-02-15 05:49:52",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 421,
		  "totalCountries": 24,
		  "totalStates": 65,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 2423,
		  "schedulePercent": 0.777992,
		  "totalGuests": 225,
		  "guestPercent": 0.610041,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Pacific Coliseum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0928e825ee01876ccf2d6d7d2891532",
		  
		  "name": "Bill",
		  "createdDate": "2014-06-12 15:28:00",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 208,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 476,
		  "schedulePercent": 0.300884,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f098d5f3dfd5edf5646b7a41f7b4a3ba",
		  
		  "name": "Robin",
		  "createdDate": "2019-11-11 13:17:02",
		  "totalOrganizations": 22,
		  "totalTours": 27,
		  "totalDays": 585,
		  "totalCountries": 34,
		  "totalStates": 71,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 2107,
		  "schedulePercent": 0.734021,
		  "totalGuests": 1044,
		  "guestPercent": 0.853355,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f09aaed12fbc3d1c785bf52136f3f753",
		  
		  "name": "Jillian",
		  "createdDate": "2025-04-01 15:08:08",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 165,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 35,
		  "eventPercent": 0.24456,
		  "totalScheduleItems": 486,
		  "schedulePercent": 0.304397,
		  "totalGuests": 86,
		  "guestPercent": 0.503853,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "The Chapel",
		  "mostGuestCity": "SF",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0a2e6d84a5496556eccac449135355e",
		  
		  "name": "Jack",
		  "createdDate": "2023-01-26 21:13:47",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 80,
		  "totalCountries": 11,
		  "totalStates": 13,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Hordern Pavilion",
		  "mostGuestCity": "Moore Park",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0a57e57cd08fc6be988dc49764ca169",
		  
		  "name": "Darryl",
		  "createdDate": "2017-12-12 18:09:15",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 401,
		  "totalCountries": 6,
		  "totalStates": 35,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1473,
		  "schedulePercent": 0.611514,
		  "totalGuests": 538,
		  "guestPercent": 0.740027,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 66,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0ae1b51b944b42ca220c3c7005f4927",
		  
		  "name": "MIKE",
		  "createdDate": "2024-07-11 20:14:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 7,
		  "totalStates": 28,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 371,
		  "schedulePercent": 0.253853,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Abundant Life Christian Center",
		  "mostGuestCity": "La Marque",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0b210d9ca7e764f9866affce6a82bc9",
		  
		  "name": "Daniel",
		  "createdDate": "2021-10-12 00:31:31",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 78,
		  "totalCountries": 10,
		  "totalStates": 19,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 323,
		  "schedulePercent": 0.228014,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Mills Hardware",
		  "mostGuestCity": "Hamilton",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0b6c4067333763fd69c8bf7e9634183",
		  
		  "name": "Joanne",
		  "createdDate": "2021-12-01 06:36:06",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 360,
		  "totalCountries": 12,
		  "totalStates": 32,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 1995,
		  "schedulePercent": 0.712829,
		  "totalGuests": 231,
		  "guestPercent": 0.613327,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Twin Towns Services Club",
		  "mostGuestCity": "Tweed Heads",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0b7cbfc63d94ebdeaa9ec11900845ff",
		  
		  "name": "The VANNS",
		  "createdDate": "2023-04-14 01:09:23",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 135,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 252,
		  "schedulePercent": 0.190956,
		  "totalGuests": 70,
		  "guestPercent": 0.484814,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Forum Melbourne",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0c4425cb68957af9299fc69ac5ad158",
		  
		  "name": "Robert",
		  "createdDate": "2019-03-21 22:39:34",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 197,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Lost Lake Lounge",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0d9daf1a3198891363fdc45b4625ab9",
		  
		  "name": "Terrence",
		  "createdDate": "2015-03-16 16:49:04",
		  "totalOrganizations": 14,
		  "totalTours": 31,
		  "totalDays": 1138,
		  "totalCountries": 21,
		  "totalStates": 69,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 3244,
		  "schedulePercent": 0.863214,
		  "totalGuests": 794,
		  "guestPercent": 0.806437,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0dbb78ebf80c41df0b232092f5d8494",
		  
		  "name": "Ben",
		  "createdDate": "2022-07-31 14:13:15",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 93,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 528,
		  "schedulePercent": 0.326043,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Warsaw",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0df39fbf8c30276f033c55adf5eec8a",
		  
		  "name": "Chris",
		  "createdDate": "2024-07-19 10:57:49",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 141,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 878,
		  "schedulePercent": 0.450589,
		  "totalGuests": 365,
		  "guestPercent": 0.679624,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "MGM Music Hall at Fenway",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0e22e3ae2275160bc1029f1e98f8ef7",
		  
		  "name": "Silvia",
		  "createdDate": "2025-08-11 17:41:03",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 166,
		  "totalCountries": 10,
		  "totalStates": 18,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1077,
		  "schedulePercent": 0.512919,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0e652c6e93dfdd5cbe9168ffe711169",
		  
		  "name": "Jonathan",
		  "createdDate": "2022-08-31 04:55:12",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 153,
		  "totalCountries": 3,
		  "totalStates": 34,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1179,
		  "schedulePercent": 0.541931,
		  "totalGuests": 501,
		  "guestPercent": 0.731074,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f0f06db5fd4a54c34e1bdced24121943",
		  
		  "name": "Cori",
		  "createdDate": "2016-09-19 04:17:05",
		  "totalOrganizations": 5,
		  "totalTours": 3,
		  "totalDays": 457,
		  "totalCountries": 12,
		  "totalStates": 25,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 720,
		  "schedulePercent": 0.394266,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f10b96ac8aee4b54f2d991364f074f1b",
		  
		  "name": "James",
		  "createdDate": "2019-06-14 21:25:41",
		  "totalOrganizations": 5,
		  "totalTours": 14,
		  "totalDays": 186,
		  "totalCountries": 14,
		  "totalStates": 36,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 1615,
		  "schedulePercent": 0.643019,
		  "totalGuests": 344,
		  "guestPercent": 0.672144,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "Walt Disney Concert Hall",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f10bdb4967eee955a9ef7eff6a2f0355",
		  
		  "name": "Production",
		  "createdDate": "2024-12-18 10:46:08",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 94,
		  "totalCountries": 22,
		  "totalStates": 24,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 520,
		  "schedulePercent": 0.32151,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "Laurus Nobilis Festival",
		  "mostGuestCity": "Louro",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f117546d3cb1715a165dfefd8e12fa59",
		  
		  "name": "Danielle",
		  "createdDate": "2022-09-05 16:38:11",
		  "totalOrganizations": 7,
		  "totalTours": 36,
		  "totalDays": 1300,
		  "totalCountries": 29,
		  "totalStates": 92,
		  "totalEvents": 414,
		  "eventPercent": 0.961922,
		  "totalScheduleItems": 6900,
		  "schedulePercent": 0.985607,
		  "totalGuests": 1847,
		  "guestPercent": 0.93597,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Wythenshawe Park and Gardens",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f12a5359dd8c99ade453f10616397dd6",
		  
		  "name": "Danny",
		  "createdDate": "2017-08-31 19:51:36",
		  "totalOrganizations": 8,
		  "totalTours": 14,
		  "totalDays": 505,
		  "totalCountries": 11,
		  "totalStates": 55,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 1743,
		  "schedulePercent": 0.666591,
		  "totalGuests": 428,
		  "guestPercent": 0.706029,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "The Fox Theatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f12b4d606ad139ccc183456e3d14ca90",
		  
		  "name": "JP",
		  "createdDate": "2021-10-18 18:46:23",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 349,
		  "totalCountries": 14,
		  "totalStates": 33,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 756,
		  "schedulePercent": 0.407978,
		  "totalGuests": 275,
		  "guestPercent": 0.637579,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f12b857558d52d405c375013639318f7",
		  
		  "name": "Biffen",
		  "createdDate": "2014-11-30 23:26:25",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 381,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 783,
		  "schedulePercent": 0.416704,
		  "totalGuests": 544,
		  "guestPercent": 0.741727,
		  "mostGuestDate": "2025-02-02 00:00:00",
		  "mostGuestName": "Vasateatern",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f12bdf0726a37b8e261e8f2948003f5b",
		  
		  "name": "Maude",
		  "createdDate": "2022-09-19 17:03:16",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 1113,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 808,
		  "schedulePercent": 0.426111,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Theater Simone Signoret",
		  "mostGuestCity": "Conflans-Sainte-Honorine",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f137f619c5111e83eb991db45ee12130",
		  
		  "name": "Iain",
		  "createdDate": "2017-03-10 04:53:58",
		  "totalOrganizations": 19,
		  "totalTours": 13,
		  "totalDays": 747,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1844,
		  "schedulePercent": 0.68461,
		  "totalGuests": 464,
		  "guestPercent": 0.716568,
		  "mostGuestDate": "2025-09-05 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f13c3da28cde3432d5701ed6a8b5e8f3",
		  
		  "name": "Ben",
		  "createdDate": "2018-09-04 09:34:34",
		  "totalOrganizations": 10,
		  "totalTours": 49,
		  "totalDays": 287,
		  "totalCountries": 24,
		  "totalStates": 48,
		  "totalEvents": 139,
		  "eventPercent": 0.677357,
		  "totalScheduleItems": 1742,
		  "schedulePercent": 0.665911,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "9:30",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f13e56568c28ad05e6400fd605abfbe1",
		  
		  "name": "Frankie",
		  "createdDate": "2023-08-04 00:03:53",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 72,
		  "totalCountries": 13,
		  "totalStates": 23,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 113,
		  "schedulePercent": 0.106754,
		  "totalGuests": 241,
		  "guestPercent": 0.619674,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "Gramercy Theatre",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f14103f7f594841d469093093679642c",
		  
		  "name": "Gemma",
		  "createdDate": "2017-04-14 14:00:10",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 116,
		  "totalCountries": 5,
		  "totalStates": 4,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 790,
		  "schedulePercent": 0.418971,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f143561c99817af4167eee1b35301c19",
		  
		  "name": "Drue",
		  "createdDate": "2022-10-05 03:36:11",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 810,
		  "totalCountries": 7,
		  "totalStates": 45,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1361,
		  "schedulePercent": 0.587715,
		  "totalGuests": 93,
		  "guestPercent": 0.511786,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f143ab6a98a2429bca317816ff760d25",
		  
		  "name": "Jill Erin",
		  "createdDate": "2018-08-17 19:06:42",
		  "totalOrganizations": 17,
		  "totalTours": 16,
		  "totalDays": 1088,
		  "totalCountries": 16,
		  "totalStates": 50,
		  "totalEvents": 175,
		  "eventPercent": 0.756346,
		  "totalScheduleItems": 3294,
		  "schedulePercent": 0.867747,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "John Paul Jones Arena",
		  "mostGuestCity": "Charlottesville",
		  "mostGuestAmount": 74,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f144846b2e8e319e9be22d9a17172b80",
		  
		  "name": "Keir",
		  "createdDate": "2017-10-11 00:13:20",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 874,
		  "totalCountries": 15,
		  "totalStates": 64,
		  "totalEvents": 298,
		  "eventPercent": 0.911378,
		  "totalScheduleItems": 5105,
		  "schedulePercent": 0.957389,
		  "totalGuests": 1609,
		  "guestPercent": 0.920784,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f14cb5f4293ee460db98806a6ed99a4e",
		  
		  "name": "Dan",
		  "createdDate": "2021-07-17 15:50:06",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 455,
		  "totalCountries": 24,
		  "totalStates": 58,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2323,
		  "schedulePercent": 0.765526,
		  "totalGuests": 278,
		  "guestPercent": 0.638939,
		  "mostGuestDate": "2025-07-10 00:00:00",
		  "mostGuestName": "National Saloon",
		  "mostGuestCity": "Calgary",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f14d1758f8d30424886bfc61333252ed",
		  
		  "name": "Colin",
		  "createdDate": "2015-06-26 00:04:22",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 169,
		  "totalCountries": 6,
		  "totalStates": 42,
		  "totalEvents": 104,
		  "eventPercent": 0.56573,
		  "totalScheduleItems": 1103,
		  "schedulePercent": 0.519719,
		  "totalGuests": 522,
		  "guestPercent": 0.736627,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Royale",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1629bb2ece341c43beafd0d7f8e9979",
		  
		  "name": "Brian",
		  "createdDate": "2018-06-01 17:49:10",
		  "totalOrganizations": 7,
		  "totalTours": 13,
		  "totalDays": 65,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 394,
		  "schedulePercent": 0.266659,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-03-15 00:00:00",
		  "mostGuestName": "The Capitol Theatre",
		  "mostGuestCity": "Port Chester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f16814bb3d46edf237489e072d1157c5",
		  
		  "name": "Noelle",
		  "createdDate": "2021-10-20 02:14:12",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 78,
		  "totalCountries": 2,
		  "totalStates": 9,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 209,
		  "schedulePercent": 0.165798,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f16e9ce7a13295f39ddee75d8130acd9",
		  
		  "name": "Martin",
		  "createdDate": "2023-12-21 21:03:28",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 151,
		  "totalCountries": 4,
		  "totalStates": 29,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 622,
		  "schedulePercent": 0.358114,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f16f2ceec32b5eea2a2ed225982cc02d",
		  
		  "name": "Jan Eric",
		  "createdDate": "2012-08-30 05:39:45",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 296,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 937,
		  "schedulePercent": 0.471328,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1827e83251c6fdacb571218f2e5e7a9",
		  
		  "name": "Zito",
		  "createdDate": "2014-08-09 03:19:42",
		  "totalOrganizations": 20,
		  "totalTours": 15,
		  "totalDays": 1806,
		  "totalCountries": 34,
		  "totalStates": 72,
		  "totalEvents": 355,
		  "eventPercent": 0.94413,
		  "totalScheduleItems": 5834,
		  "schedulePercent": 0.973255,
		  "totalGuests": 1012,
		  "guestPercent": 0.848708,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f184540424165d09047f00c6e9cf6d23",
		  
		  "name": "Team",
		  "createdDate": "2024-01-08 09:12:51",
		  "totalOrganizations": 74,
		  "totalTours": 75,
		  "totalDays": 1524,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 1524,
		  "eventPercent": 0.999093,
		  "totalScheduleItems": 5134,
		  "schedulePercent": 0.958296,
		  "totalGuests": 9,
		  "guestPercent": 0.367747,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "KesÃ¤rauha",
		  "mostGuestCity": "Turku",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f18756b74bbe2d5d807d3eb0ef048204",
		  
		  "name": "Arno",
		  "createdDate": "2016-09-28 19:21:38",
		  "totalOrganizations": 36,
		  "totalTours": 33,
		  "totalDays": 3945,
		  "totalCountries": 34,
		  "totalStates": 95,
		  "totalEvents": 557,
		  "eventPercent": 0.984587,
		  "totalScheduleItems": 8468,
		  "schedulePercent": 0.991614,
		  "totalGuests": 2374,
		  "guestPercent": 0.964415,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1877190825723297e43350f88ad9461",
		  
		  "name": "Ross",
		  "createdDate": "2016-03-12 20:47:34",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 416,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 4846,
		  "schedulePercent": 0.948889,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1877e7781cc4eacdf560056f4f2a338",
		  
		  "name": "Jim",
		  "createdDate": "2014-07-18 20:25:16",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 542,
		  "totalCountries": 33,
		  "totalStates": 76,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 3562,
		  "schedulePercent": 0.885653,
		  "totalGuests": 451,
		  "guestPercent": 0.713055,
		  "mostGuestDate": "2025-02-06 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f194a333a1a61e9ff7ba819dd7f0243f",
		  
		  "name": "Adam",
		  "createdDate": "2022-04-08 11:54:39",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 101,
		  "totalCountries": 3,
		  "totalStates": 5,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 730,
		  "schedulePercent": 0.397892,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1996f87f4376e8eda8066b50119a5ea",
		  
		  "name": "Eric",
		  "createdDate": "2018-07-04 20:11:11",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 784,
		  "totalCountries": 12,
		  "totalStates": 55,
		  "totalEvents": 213,
		  "eventPercent": 0.822076,
		  "totalScheduleItems": 2550,
		  "schedulePercent": 0.792611,
		  "totalGuests": 870,
		  "guestPercent": 0.822983,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Majestic Ventura Theater",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f19bb0868a21f6778d255471dab730d7",
		  
		  "name": "Robert",
		  "createdDate": "2023-05-01 09:33:20",
		  "totalOrganizations": 4,
		  "totalTours": 44,
		  "totalDays": 201,
		  "totalCountries": 15,
		  "totalStates": 35,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 905,
		  "schedulePercent": 0.460335,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Lemon Grove",
		  "mostGuestCity": "Exeter",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1a5a98f4c7448d7b6de011ef1346708",
		  
		  "name": "Jason",
		  "createdDate": "2011-10-21 16:53:16",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 201,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 743,
		  "schedulePercent": 0.402312,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1abf735cbcbe3bec5556fe34945275a",
		  
		  "name": "christophe",
		  "createdDate": "2021-06-07 11:52:20",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 855,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 1770,
		  "schedulePercent": 0.671464,
		  "totalGuests": 300,
		  "guestPercent": 0.649705,
		  "mostGuestDate": "2025-06-11 00:00:00",
		  "mostGuestName": "Zenith Paris - La Villette",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 35,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1b690972fae313e3cc6fa24ed61d739",
		  
		  "name": "Tristan",
		  "createdDate": "2022-11-02 19:28:07",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 800,
		  "totalCountries": 3,
		  "totalStates": 39,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 959,
		  "schedulePercent": 0.478921,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "The Wave",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1bdfcb2acecb2eb294e7035fabc2d86",
		  
		  "name": "Jeffrey",
		  "createdDate": "2017-07-03 20:20:46",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 40,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Bell House",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1be00cb747e06a6712cbe9ed57b3767",
		  
		  "name": "Emma",
		  "createdDate": "2023-04-05 15:32:29",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 360,
		  "totalCountries": 25,
		  "totalStates": 15,
		  "totalEvents": 150,
		  "eventPercent": 0.705122,
		  "totalScheduleItems": 370,
		  "schedulePercent": 0.253173,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1bf99226d14bb1f3d3065e9f4714f31",
		  
		  "name": "Wonder",
		  "createdDate": "2019-01-08 18:35:26",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 134,
		  "totalCountries": 6,
		  "totalStates": 44,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 827,
		  "schedulePercent": 0.43325,
		  "totalGuests": 445,
		  "guestPercent": 0.710675,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "Keswick Theatre",
		  "mostGuestCity": "Glenside",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1c2247c665762430f8861ca8cff394c",
		  
		  "name": "Marc",
		  "createdDate": "2013-11-07 18:35:47",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 476,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1331,
		  "schedulePercent": 0.580689,
		  "totalGuests": 478,
		  "guestPercent": 0.723255,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Orpheum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1c24633340e02b6eeffb4942c53bbda",
		  
		  "name": "Tim",
		  "createdDate": "2012-08-27 07:38:27",
		  "totalOrganizations": 14,
		  "totalTours": 10,
		  "totalDays": 284,
		  "totalCountries": 19,
		  "totalStates": 39,
		  "totalEvents": 110,
		  "eventPercent": 0.589755,
		  "totalScheduleItems": 2447,
		  "schedulePercent": 0.780825,
		  "totalGuests": 450,
		  "guestPercent": 0.712489,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Empower FCU Amphitheater at Lakeview",
		  "mostGuestCity": "Syracuse",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1c30a419d3dbdbf843ab5853f7abcb2",
		  
		  "name": "Matt",
		  "createdDate": "2014-06-14 20:29:10",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 320,
		  "totalCountries": 11,
		  "totalStates": 51,
		  "totalEvents": 189,
		  "eventPercent": 0.780598,
		  "totalScheduleItems": 2923,
		  "schedulePercent": 0.833182,
		  "totalGuests": 1932,
		  "guestPercent": 0.941296,
		  "mostGuestDate": "2025-07-16 00:00:00",
		  "mostGuestName": "The Criterion",
		  "mostGuestCity": "Oklahoma City",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1cc671955b3789b9e4f9b2d13c429b9",
		  
		  "name": "Andres",
		  "createdDate": "2018-04-16 15:05:21",
		  "totalOrganizations": 13,
		  "totalTours": 7,
		  "totalDays": 1000,
		  "totalCountries": 21,
		  "totalStates": 27,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 971,
		  "schedulePercent": 0.481641,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Le Hasard Ludique",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1ddd5373358f4bb4fce8a075fc05066",
		  
		  "name": "Dane",
		  "createdDate": "2019-08-01 20:03:56",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 633,
		  "totalCountries": 5,
		  "totalStates": 44,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2926,
		  "schedulePercent": 0.833749,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1f35653890a3e329d669862e9e08496",
		  
		  "name": "Jude",
		  "createdDate": "2022-09-28 18:58:39",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 1954,
		  "totalCountries": 11,
		  "totalStates": 63,
		  "totalEvents": 299,
		  "eventPercent": 0.912398,
		  "totalScheduleItems": 1675,
		  "schedulePercent": 0.653898,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "",
		  "mostGuestCity": "Ridgefield",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1f665077190c34006cf417aec24474f",
		  
		  "name": "Finlay",
		  "createdDate": "2022-09-28 19:34:26",
		  "totalOrganizations": 18,
		  "totalTours": 15,
		  "totalDays": 1324,
		  "totalCountries": 23,
		  "totalStates": 57,
		  "totalEvents": 321,
		  "eventPercent": 0.926904,
		  "totalScheduleItems": 2486,
		  "schedulePercent": 0.785018,
		  "totalGuests": 48,
		  "guestPercent": 0.449116,
		  "mostGuestDate": "2025-04-03 00:00:00",
		  "mostGuestName": "Scala",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f1fd2c2ca293edc34fa7ff0397790c4c",
		  
		  "name": "Zack ",
		  "createdDate": "2018-04-05 18:39:39",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 500,
		  "totalCountries": 5,
		  "totalStates": 35,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1065,
		  "schedulePercent": 0.50816,
		  "totalGuests": 166,
		  "guestPercent": 0.570263,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Palais Theatre",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f201fd1a1150afeb69f808a5fc0a719b",
		  
		  "name": "Matthew",
		  "createdDate": "2023-04-25 02:32:43",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 866,
		  "schedulePercent": 0.447303,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-06-22 00:00:00",
		  "mostGuestName": "Tally Ho Theatre",
		  "mostGuestCity": "Leesburg",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f208f39012ea7562c78b11bd5bc4f099",
		  
		  "name": "Benjamin",
		  "createdDate": "2025-04-29 18:02:07",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 36,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 179,
		  "schedulePercent": 0.145852,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f210f3540d0a28df8cbf662b7d12660b",
		  
		  "name": "Dan",
		  "createdDate": "2012-04-02 19:20:35",
		  "totalOrganizations": 14,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 5,
		  "totalStates": 11,
		  "totalEvents": 14,
		  "eventPercent": 0.106981,
		  "totalScheduleItems": 192,
		  "schedulePercent": 0.154352,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2120f91f37d75e2af43d9180173b5cc",
		  
		  "name": "Zeke ",
		  "createdDate": "2014-04-04 20:36:16",
		  "totalOrganizations": 12,
		  "totalTours": 27,
		  "totalDays": 573,
		  "totalCountries": 23,
		  "totalStates": 68,
		  "totalEvents": 264,
		  "eventPercent": 0.885766,
		  "totalScheduleItems": 4061,
		  "schedulePercent": 0.917044,
		  "totalGuests": 2181,
		  "guestPercent": 0.957049,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 163,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2172a7e534465f91ea554114eb815b0",
		  
		  "name": "Jaqueline",
		  "createdDate": "2025-01-20 17:19:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 82,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 20,
		  "eventPercent": 0.150272,
		  "totalScheduleItems": 295,
		  "schedulePercent": 0.215095,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Nuevo recinto Fan Futura",
		  "mostGuestCity": "Los AlcÃ¡zares",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2218b9f411c066ede5eafcaba360688",
		  
		  "name": "Jaakko",
		  "createdDate": "2023-11-09 09:26:23",
		  "totalOrganizations": 39,
		  "totalTours": 36,
		  "totalDays": 466,
		  "totalCountries": 4,
		  "totalStates": 1,
		  "totalEvents": 466,
		  "eventPercent": 0.973255,
		  "totalScheduleItems": 1283,
		  "schedulePercent": 0.568563,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Kaupungin Ã„Ã¤net",
		  "mostGuestCity": "Lahti",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2230566a24ba8229dace2feee378542",
		  
		  "name": "Drift",
		  "createdDate": "2022-04-22 14:41:19",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 650,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 3,
		  "eventPercent": 0.0250453,
		  "totalScheduleItems": 273,
		  "schedulePercent": 0.201609,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f22463726d3ffbae6c605b52a3b43260",
		  
		  "name": "TSSF",
		  "createdDate": "2018-10-30 22:42:55",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 58,
		  "totalCountries": 2,
		  "totalStates": 28,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 434,
		  "schedulePercent": 0.283205,
		  "totalGuests": 601,
		  "guestPercent": 0.758273,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "The Observatory",
		  "mostGuestCity": "Santa Ana",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f227a48c3641465b2f1889a74fa5b607",
		  
		  "name": "Debbie",
		  "createdDate": "2010-06-07 19:02:06",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 80,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 391,
		  "schedulePercent": 0.265073,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-08-29 00:00:00",
		  "mostGuestName": "Parc de la Baie:  Le Festival De Montgolfieres De Gatineau",
		  "mostGuestCity": "Gatineau",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f23b9848d513e2a2947b4eb4aa6e1c3b",
		  
		  "name": "Brian",
		  "createdDate": "2014-06-03 01:23:59",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 118,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 522,
		  "schedulePercent": 0.321963,
		  "totalGuests": 322,
		  "guestPercent": 0.660925,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Rock 'N' Bowl",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f23ef1b115d3e183f52bbb40e448570f",
		  
		  "name": "Reuben",
		  "createdDate": "2020-12-04 02:41:58",
		  "totalOrganizations": 79,
		  "totalTours": 54,
		  "totalDays": 942,
		  "totalCountries": 29,
		  "totalStates": 89,
		  "totalEvents": 369,
		  "eventPercent": 0.949229,
		  "totalScheduleItems": 3928,
		  "schedulePercent": 0.910245,
		  "totalGuests": 1809,
		  "guestPercent": 0.93393,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f24d6be4acd695daaecb4aa24b9bd562",
		  
		  "name": "Ryan",
		  "createdDate": "2023-01-19 15:43:02",
		  "totalOrganizations": 12,
		  "totalTours": 17,
		  "totalDays": 1357,
		  "totalCountries": 16,
		  "totalStates": 45,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1974,
		  "schedulePercent": 0.708522,
		  "totalGuests": 1636,
		  "guestPercent": 0.922937,
		  "mostGuestDate": "2025-08-17 00:00:00",
		  "mostGuestName": "Thompson's Point",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 73,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f24f3b49d204e376313209ddb17555a3",
		  
		  "name": "Bill",
		  "createdDate": "2016-11-23 10:07:20",
		  "totalOrganizations": 5,
		  "totalTours": 16,
		  "totalDays": 113,
		  "totalCountries": 8,
		  "totalStates": 14,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 570,
		  "schedulePercent": 0.339982,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f25ea10c2fd17541ca7f5e28b3d70ab2",
		  
		  "name": "Edvard",
		  "createdDate": "2024-08-01 23:14:58",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 73,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 504,
		  "schedulePercent": 0.313463,
		  "totalGuests": 598,
		  "guestPercent": 0.75748,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "PICA (Port Melbourne Industrial Centre for the Arts)",
		  "mostGuestCity": "Port Melbourne",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f267228e39678e8241a9b5e2b6c44bc2",
		  
		  "name": "Aaron",
		  "createdDate": "2018-11-17 00:29:40",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 451,
		  "totalCountries": 4,
		  "totalStates": 15,
		  "totalEvents": 63,
		  "eventPercent": 0.391319,
		  "totalScheduleItems": 476,
		  "schedulePercent": 0.300884,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Cook County Saloon",
		  "mostGuestCity": "Edmonton",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2686e082658663009ead7c3532a50dc",
		  
		  "name": "Mark ",
		  "createdDate": "2016-05-30 05:40:14",
		  "totalOrganizations": 23,
		  "totalTours": 11,
		  "totalDays": 515,
		  "totalCountries": 17,
		  "totalStates": 33,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1265,
		  "schedulePercent": 0.564597,
		  "totalGuests": 593,
		  "guestPercent": 0.75612,
		  "mostGuestDate": "2025-11-04 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f27894642f8f2c14e8385af1bcfbee21",
		  
		  "name": "Jason",
		  "createdDate": "2013-03-22 15:11:54",
		  "totalOrganizations": 19,
		  "totalTours": 15,
		  "totalDays": 1239,
		  "totalCountries": 5,
		  "totalStates": 56,
		  "totalEvents": 324,
		  "eventPercent": 0.929964,
		  "totalScheduleItems": 3596,
		  "schedulePercent": 0.888826,
		  "totalGuests": 3172,
		  "guestPercent": 0.985154,
		  "mostGuestDate": "2025-03-23 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 224,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f297e41e2dacbd1fc6963a149e913233",
		  
		  "name": "Vanessa",
		  "createdDate": "2016-01-28 20:41:22",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 200,
		  "totalCountries": 9,
		  "totalStates": 39,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 1499,
		  "schedulePercent": 0.618087,
		  "totalGuests": 1036,
		  "guestPercent": 0.852221,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f29a33d67f4df51fe47434ebfbd0e5af",
		  
		  "name": "Przemek",
		  "createdDate": "2018-12-12 05:15:02",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 391,
		  "totalCountries": 37,
		  "totalStates": 51,
		  "totalEvents": 130,
		  "eventPercent": 0.653672,
		  "totalScheduleItems": 1536,
		  "schedulePercent": 0.624547,
		  "totalGuests": 1089,
		  "guestPercent": 0.861967,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "Hala Stulecia",
		  "mostGuestCity": "WrocÅ‚aw",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2a9677f68d6e63fae70721558481e10",
		  
		  "name": "Doug",
		  "createdDate": "2023-08-08 23:12:31",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 33,
		  "totalCountries": 2,
		  "totalStates": 6,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 163,
		  "schedulePercent": 0.137579,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2b82acb5b218ef5499c2f1b9483f2b1",
		  
		  "name": "Viktoria",
		  "createdDate": "2022-09-19 06:49:37",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 183,
		  "totalCountries": 3,
		  "totalStates": 11,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 1539,
		  "schedulePercent": 0.625113,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2c39a0cc9ef5c249ba4cd023e9ac0e6",
		  
		  "name": "David",
		  "createdDate": "2024-02-09 04:23:40",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 139,
		  "totalCountries": 2,
		  "totalStates": 27,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 862,
		  "schedulePercent": 0.445603,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "Southern Kentucky Performing Arts Center (SKyPAC)",
		  "mostGuestCity": "Bowling Green",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2cacdbc082623cbfefa06a213c3393f",
		  
		  "name": "Derek",
		  "createdDate": "2009-05-05 20:59:27",
		  "totalOrganizations": 14,
		  "totalTours": 9,
		  "totalDays": 459,
		  "totalCountries": 13,
		  "totalStates": 48,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2974,
		  "schedulePercent": 0.839982,
		  "totalGuests": 1398,
		  "guestPercent": 0.900159,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "KEMBA Live!",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2d1e0487c0e698cf2b708f0a012a2e5",
		  
		  "name": "Thomas",
		  "createdDate": "2009-11-24 18:08:31",
		  "totalOrganizations": 24,
		  "totalTours": 10,
		  "totalDays": 2459,
		  "totalCountries": 38,
		  "totalStates": 82,
		  "totalEvents": 195,
		  "eventPercent": 0.792158,
		  "totalScheduleItems": 2430,
		  "schedulePercent": 0.778785,
		  "totalGuests": 903,
		  "guestPercent": 0.830689,
		  "mostGuestDate": "2025-08-19 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 133,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2d2dda67a09b620d7f31a6634f6db78",
		  
		  "name": "Overcoat",
		  "createdDate": "2023-05-24 19:43:29",
		  "totalOrganizations": 5,
		  "totalTours": 4,
		  "totalDays": 92,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 868,
		  "schedulePercent": 0.448096,
		  "totalGuests": 163,
		  "guestPercent": 0.568223,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "The Wiltern",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 64,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2d987b14ba6fb87985936021bab4b09",
		  
		  "name": "Management ",
		  "createdDate": "2023-11-27 11:04:29",
		  "totalOrganizations": 1,
		  "totalTours": 24,
		  "totalDays": 141,
		  "totalCountries": 19,
		  "totalStates": 32,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1220,
		  "schedulePercent": 0.551904,
		  "totalGuests": 1378,
		  "guestPercent": 0.897325,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Sporthalle",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 281,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2ef602d8e9cc9432645dfbc5dffee87",
		  
		  "name": "Brian",
		  "createdDate": "2014-07-25 15:21:20",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 551,
		  "totalCountries": 2,
		  "totalStates": 41,
		  "totalEvents": 99,
		  "eventPercent": 0.549411,
		  "totalScheduleItems": 1112,
		  "schedulePercent": 0.521419,
		  "totalGuests": 1353,
		  "guestPercent": 0.893359,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 123,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2ef8daeec42a809557a532b4aa3504f",
		  
		  "name": "Darrion",
		  "createdDate": "2018-11-26 00:53:48",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 486,
		  "totalCountries": 9,
		  "totalStates": 35,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 812,
		  "schedulePercent": 0.427697,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Arizona Federal Theatre",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2f11677c13a4872cbe3bbc0f37eccbf",
		  
		  "name": "Portland'5 Centers for the Arts",
		  "createdDate": "2024-10-17 19:36:47",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 1728,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 1573,
		  "eventPercent": 0.999207,
		  "totalScheduleItems": 1276,
		  "schedulePercent": 0.566636,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2f2e39a17bce2f8fc72f340e009caf7",
		  
		  "name": "LoLo ",
		  "createdDate": "2015-06-25 14:35:47",
		  "totalOrganizations": 7,
		  "totalTours": 14,
		  "totalDays": 2465,
		  "totalCountries": 25,
		  "totalStates": 71,
		  "totalEvents": 538,
		  "eventPercent": 0.982774,
		  "totalScheduleItems": 9431,
		  "schedulePercent": 0.99558,
		  "totalGuests": 4075,
		  "guestPercent": 0.993654,
		  "mostGuestDate": "2025-03-20 00:00:00",
		  "mostGuestName": "Von Braun Center (Probst Arena)",
		  "mostGuestCity": "Huntsville",
		  "mostGuestAmount": 169,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2fd6ed6dc00c68baf8a3cb14c6fa570",
		  
		  "name": "Alex",
		  "createdDate": "2024-07-08 03:17:40",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 318,
		  "totalCountries": 3,
		  "totalStates": 28,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1435,
		  "schedulePercent": 0.605054,
		  "totalGuests": 62,
		  "guestPercent": 0.473368,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Primm Valley Casino Resorts",
		  "mostGuestCity": "Primm",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f2fda72ec5e146d7f5bd81ee13cdfebc",
		  
		  "name": "Diego",
		  "createdDate": "2024-05-14 18:24:37",
		  "totalOrganizations": 2,
		  "totalTours": 13,
		  "totalDays": 105,
		  "totalCountries": 5,
		  "totalStates": 19,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 311,
		  "schedulePercent": 0.222801,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f30737420ebd9741ac679dbd42b49cae",
		  
		  "name": "Efrem",
		  "createdDate": "2019-10-15 19:00:12",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 27,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 222,
		  "schedulePercent": 0.172597,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f30c9e5b2186d1a69da8da334d1f0846",
		  
		  "name": "Cillian",
		  "createdDate": "2019-02-05 03:55:37",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 34,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 169,
		  "schedulePercent": 0.139846,
		  "totalGuests": 28,
		  "guestPercent": 0.414778,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Presidio Theatre",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f31092c2d049f367e7b8ba23336ea91b",
		  
		  "name": "DrÃ¨",
		  "createdDate": "2010-05-27 21:10:19",
		  "totalOrganizations": 43,
		  "totalTours": 11,
		  "totalDays": 795,
		  "totalCountries": 16,
		  "totalStates": 54,
		  "totalEvents": 327,
		  "eventPercent": 0.931324,
		  "totalScheduleItems": 3151,
		  "schedulePercent": 0.855508,
		  "totalGuests": 1080,
		  "guestPercent": 0.860947,
		  "mostGuestDate": "2025-09-30 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3196440b09ce01d41bbe3b61437d029",
		  
		  "name": "Alejandro",
		  "createdDate": "2024-04-05 19:51:33",
		  "totalOrganizations": 7,
		  "totalTours": 5,
		  "totalDays": 804,
		  "totalCountries": 19,
		  "totalStates": 43,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 2147,
		  "schedulePercent": 0.739007,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": "2025-08-06 00:00:00",
		  "mostGuestName": "Palacio de los Deportes",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 0,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f31bd1f70534b7d342c3c7cf4d4772b1",
		  
		  "name": "Gene",
		  "createdDate": "2016-03-10 13:27:56",
		  "totalOrganizations": 16,
		  "totalTours": 13,
		  "totalDays": 875,
		  "totalCountries": 6,
		  "totalStates": 50,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 4558,
		  "schedulePercent": 0.939823,
		  "totalGuests": 2294,
		  "guestPercent": 0.961695,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3231a3c32d8478a5b301de1311f49ea",
		  
		  "name": "Turner",
		  "createdDate": "2017-02-10 19:11:25",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 366,
		  "totalCountries": 26,
		  "totalStates": 27,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 527,
		  "schedulePercent": 0.325136,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f32c977d730274950657c51ca22bff3f",
		  
		  "name": "Matthew",
		  "createdDate": "2016-05-15 04:19:30",
		  "totalOrganizations": 26,
		  "totalTours": 6,
		  "totalDays": 475,
		  "totalCountries": 8,
		  "totalStates": 34,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1414,
		  "schedulePercent": 0.601201,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f33db8b005b138e3f0f0b630fa7ee5ac",
		  
		  "name": "Meg",
		  "createdDate": "2017-04-11 19:36:26",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 40,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 356,
		  "schedulePercent": 0.24558,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Bell House",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f34390220bfbfb8fff27465153fdf8b3",
		  
		  "name": "Dilara",
		  "createdDate": "2025-04-01 21:37:18",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 82,
		  "totalCountries": 8,
		  "totalStates": 20,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 351,
		  "schedulePercent": 0.24354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f34665afb610610781b6ebda83a8feb4",
		  
		  "name": "Hannah",
		  "createdDate": "2013-12-20 00:06:24",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 373,
		  "totalCountries": 2,
		  "totalStates": 33,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 747,
		  "schedulePercent": 0.403785,
		  "totalGuests": 941,
		  "guestPercent": 0.837942,
		  "mostGuestDate": "2025-01-15 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 69,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f352c7db869dce6a03552a7055c7a55d",
		  
		  "name": "Alec",
		  "createdDate": "2015-04-01 22:02:27",
		  "totalOrganizations": 17,
		  "totalTours": 30,
		  "totalDays": 371,
		  "totalCountries": 24,
		  "totalStates": 66,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 2299,
		  "schedulePercent": 0.761673,
		  "totalGuests": 197,
		  "guestPercent": 0.592362,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3533c1652309e524b2b9ca67730cc9c",
		  
		  "name": "BOTTOMLAND",
		  "createdDate": "2025-04-30 19:46:32",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 244,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 470,
		  "schedulePercent": 0.298277,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Basement East",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f35be5feacb163e1ba5ff57c0406f21b",
		  
		  "name": "Janne",
		  "createdDate": "2016-11-11 12:15:53",
		  "totalOrganizations": 7,
		  "totalTours": 28,
		  "totalDays": 653,
		  "totalCountries": 16,
		  "totalStates": 26,
		  "totalEvents": 223,
		  "eventPercent": 0.837489,
		  "totalScheduleItems": 917,
		  "schedulePercent": 0.464075,
		  "totalGuests": 686,
		  "guestPercent": 0.782298,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Tavastia Club",
		  "mostGuestCity": "Helsingfors",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3657eae9f336a371c4fc88816021d01",
		  
		  "name": "Jill",
		  "createdDate": "2024-06-13 14:33:46",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 180,
		  "totalCountries": 19,
		  "totalStates": 53,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1242,
		  "schedulePercent": 0.558364,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "The Mayan",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3665cc5d98af95c9d91b6bb41c604a8",
		  
		  "name": "Josh",
		  "createdDate": "2025-08-05 17:43:20",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 34,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 510,
		  "schedulePercent": 0.315503,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Yuengling Center",
		  "mostGuestCity": "Tampa",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f36be4672c5456b74d812d069d70edc6",
		  
		  "name": "Immy",
		  "createdDate": "2019-06-17 15:44:23",
		  "totalOrganizations": 21,
		  "totalTours": 37,
		  "totalDays": 2504,
		  "totalCountries": 39,
		  "totalStates": 116,
		  "totalEvents": 904,
		  "eventPercent": 0.99456,
		  "totalScheduleItems": 11069,
		  "schedulePercent": 0.997733,
		  "totalGuests": 1583,
		  "guestPercent": 0.917951,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f36cf2731441d67328ddbe85042933b4",
		  
		  "name": "Jessica ",
		  "createdDate": "2023-01-03 04:51:25",
		  "totalOrganizations": 24,
		  "totalTours": 19,
		  "totalDays": 1847,
		  "totalCountries": 11,
		  "totalStates": 15,
		  "totalEvents": 1102,
		  "eventPercent": 0.9966,
		  "totalScheduleItems": 4103,
		  "schedulePercent": 0.919084,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "The Stand Comedy Club Newcastle",
		  "mostGuestCity": "Newcastle upon Tyne",
		  "mostGuestAmount": 10,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3746e9106e6f41b75025e6d10fa3263",
		  
		  "name": "Mike",
		  "createdDate": "2010-06-22 21:46:39",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 290,
		  "totalCountries": 12,
		  "totalStates": 44,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 2032,
		  "schedulePercent": 0.719515,
		  "totalGuests": 1126,
		  "guestPercent": 0.867974,
		  "mostGuestDate": "2025-09-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f375236d175b73131941763c6700d241",
		  
		  "name": "Jermaine",
		  "createdDate": "2013-07-31 21:50:10",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 71,
		  "totalCountries": 11,
		  "totalStates": 13,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 153,
		  "schedulePercent": 0.131686,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f37841e8ac761e7b46a120db14acd664",
		  
		  "name": "Luciana",
		  "createdDate": "2025-05-07 12:48:44",
		  "totalOrganizations": 2,
		  "totalTours": 9,
		  "totalDays": 271,
		  "totalCountries": 11,
		  "totalStates": 22,
		  "totalEvents": 106,
		  "eventPercent": 0.573776,
		  "totalScheduleItems": 2149,
		  "schedulePercent": 0.739461,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f384f08e6c574756500f0e1c17736e3b",
		  
		  "name": "Carlos",
		  "createdDate": "2024-05-29 19:50:55",
		  "totalOrganizations": 3,
		  "totalTours": 7,
		  "totalDays": 238,
		  "totalCountries": 24,
		  "totalStates": 47,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 802,
		  "schedulePercent": 0.423391,
		  "totalGuests": 185,
		  "guestPercent": 0.583069,
		  "mostGuestDate": "2025-07-27 00:00:00",
		  "mostGuestName": "Ogden Theatre",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f38afca94de23ea450075c1acc917ef5",
		  
		  "name": "Kyle",
		  "createdDate": "2022-09-15 01:46:00",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 379,
		  "totalCountries": 24,
		  "totalStates": 58,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 2712,
		  "schedulePercent": 0.810517,
		  "totalGuests": 1356,
		  "guestPercent": 0.894379,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3a883d1f851ca340b1dfd059de99337",
		  
		  "name": "Josh",
		  "createdDate": "2016-07-19 20:42:35",
		  "totalOrganizations": 18,
		  "totalTours": 16,
		  "totalDays": 752,
		  "totalCountries": 38,
		  "totalStates": 80,
		  "totalEvents": 244,
		  "eventPercent": 0.86514,
		  "totalScheduleItems": 3871,
		  "schedulePercent": 0.906392,
		  "totalGuests": 819,
		  "guestPercent": 0.812897,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3af54996dcb2111927da7890378470e",
		  
		  "name": "PRODUSENT",
		  "createdDate": "2024-06-27 14:18:44",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 124,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 324,
		  "schedulePercent": 0.228354,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3b41f75aab445fcb42f7aa574e9e499",
		  
		  "name": "Patrick",
		  "createdDate": "2018-10-30 01:50:50",
		  "totalOrganizations": 1,
		  "totalTours": 8,
		  "totalDays": 363,
		  "totalCountries": 27,
		  "totalStates": 86,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 2867,
		  "schedulePercent": 0.828989,
		  "totalGuests": 1452,
		  "guestPercent": 0.905032,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3b4cf6f23750003ac475d4377281370",
		  
		  "name": "Pauline",
		  "createdDate": "2023-05-03 08:18:06",
		  "totalOrganizations": 11,
		  "totalTours": 22,
		  "totalDays": 390,
		  "totalCountries": 21,
		  "totalStates": 24,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 982,
		  "schedulePercent": 0.485267,
		  "totalGuests": 898,
		  "guestPercent": 0.829556,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Queen Square",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3b4f0c7d845fb967b0ab7c95a5bd16f",
		  
		  "name": "K",
		  "createdDate": "2016-07-10 23:39:10",
		  "totalOrganizations": 4,
		  "totalTours": 15,
		  "totalDays": 324,
		  "totalCountries": 12,
		  "totalStates": 42,
		  "totalEvents": 120,
		  "eventPercent": 0.623527,
		  "totalScheduleItems": 2708,
		  "schedulePercent": 0.80961,
		  "totalGuests": 1454,
		  "guestPercent": 0.905825,
		  "mostGuestDate": "2025-04-28 00:00:00",
		  "mostGuestName": "Arena CDMX",
		  "mostGuestCity": "Ciudad de MÃ©xico",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3b9dbd98b14694e7dde7a4ffc86254d",
		  
		  "name": "Molly",
		  "createdDate": "2022-05-13 16:22:19",
		  "totalOrganizations": 11,
		  "totalTours": 6,
		  "totalDays": 171,
		  "totalCountries": 7,
		  "totalStates": 5,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 441,
		  "schedulePercent": 0.287285,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3ba80e2e10b6a9f2b9a1ea44d80b839",
		  
		  "name": "Andy",
		  "createdDate": "2009-09-30 21:52:33",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 47,
		  "totalCountries": 3,
		  "totalStates": 12,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 359,
		  "schedulePercent": 0.24762,
		  "totalGuests": 632,
		  "guestPercent": 0.765979,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Climate Pledge Arena",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3c73ede00e33eb65e73e61c70607c83",
		  
		  "name": "Summer",
		  "createdDate": "2021-11-08 21:24:10",
		  "totalOrganizations": 6,
		  "totalTours": 5,
		  "totalDays": 1027,
		  "totalCountries": 9,
		  "totalStates": 19,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1237,
		  "schedulePercent": 0.556324,
		  "totalGuests": 440,
		  "guestPercent": 0.709315,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Northcote Theatre",
		  "mostGuestCity": "Northcote",
		  "mostGuestAmount": 109,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3cd6d592d707e5daa9a00b8300a2948",
		  
		  "name": "Gwen",
		  "createdDate": "2016-07-28 15:24:24",
		  "totalOrganizations": 2,
		  "totalTours": 22,
		  "totalDays": 50,
		  "totalCountries": 1,
		  "totalStates": 11,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 0,
		  "schedulePercent": 0,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3d6d7bf7b23a1b4b15d298b9c8371f0",
		  
		  "name": "Caroline",
		  "createdDate": "2019-01-11 00:09:24",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 1495,
		  "schedulePercent": 0.6165,
		  "totalGuests": 270,
		  "guestPercent": 0.634746,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Red Hat Amphitheater",
		  "mostGuestCity": "Raleigh",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3d7bac701c879898d4478ddc1603d09",
		  
		  "name": "Luc",
		  "createdDate": "2025-10-27 22:13:22",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 32,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 5,
		  "schedulePercent": 0.0151859,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3dd05ed491d12c9eac34656be74924c",
		  
		  "name": "Joe",
		  "createdDate": "2023-09-27 14:13:52",
		  "totalOrganizations": 11,
		  "totalTours": 19,
		  "totalDays": 892,
		  "totalCountries": 19,
		  "totalStates": 37,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 1691,
		  "schedulePercent": 0.656958,
		  "totalGuests": 196,
		  "guestPercent": 0.591568,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Ford",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3e3be970d9aa3967d1908a7df98431f",
		  
		  "name": "Joanne",
		  "createdDate": "2019-10-04 11:11:16",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 44,
		  "totalCountries": 9,
		  "totalStates": 13,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 350,
		  "schedulePercent": 0.242974,
		  "totalGuests": 110,
		  "guestPercent": 0.528105,
		  "mostGuestDate": "2025-03-07 00:00:00",
		  "mostGuestName": "TSB Bank Arena",
		  "mostGuestCity": "Wellington",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3e683bf7faf56d5319b3a4f52b400a2",
		  
		  "name": "william",
		  "createdDate": "2015-11-02 19:53:11",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 81,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 269,
		  "schedulePercent": 0.198889,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-06-19 00:00:00",
		  "mostGuestName": "The Music Hall, Portsmouth, NH",
		  "mostGuestCity": "Portsmouth",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3ea0b80c914faacebb49c10a6be916e",
		  
		  "name": "celine",
		  "createdDate": "2023-04-22 23:11:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 64,
		  "totalCountries": 3,
		  "totalStates": 3,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 398,
		  "schedulePercent": 0.268586,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f3fff4ec2cb546d8b53a29c0ebbc0213",
		  
		  "name": "Michael",
		  "createdDate": "2025-02-11 15:51:25",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 107,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 56,
		  "guestPercent": 0.461355,
		  "mostGuestDate": "2025-05-19 00:00:00",
		  "mostGuestName": "The Orange Peel",
		  "mostGuestCity": "Asheville",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4174a838d92d5af78474e354b560149",
		  
		  "name": "Kelly",
		  "createdDate": "2013-01-11 22:24:37",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 116,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 814,
		  "schedulePercent": 0.42849,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f41a52be79ab0986b8e16af224ba70af",
		  
		  "name": "Michael",
		  "createdDate": "2016-10-17 19:13:01",
		  "totalOrganizations": 23,
		  "totalTours": 25,
		  "totalDays": 626,
		  "totalCountries": 15,
		  "totalStates": 27,
		  "totalEvents": 226,
		  "eventPercent": 0.842135,
		  "totalScheduleItems": 1592,
		  "schedulePercent": 0.639279,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-09-21 00:00:00",
		  "mostGuestName": "Canberra Theatre Centre",
		  "mostGuestCity": "Canberra",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f41af30adcca236a4ab673bf89d67310",
		  
		  "name": "Troy",
		  "createdDate": "2011-05-09 06:25:25",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 85,
		  "totalCountries": 5,
		  "totalStates": 16,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 316,
		  "schedulePercent": 0.225295,
		  "totalGuests": 298,
		  "guestPercent": 0.648685,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Louise M. Davies Symphony Hall",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f41b0ccaa76d377c11dff7486bd5b74f",
		  
		  "name": "Dave ",
		  "createdDate": "2021-11-16 00:56:24",
		  "totalOrganizations": 15,
		  "totalTours": 10,
		  "totalDays": 317,
		  "totalCountries": 21,
		  "totalStates": 48,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 3360,
		  "schedulePercent": 0.871714,
		  "totalGuests": 1021,
		  "guestPercent": 0.850181,
		  "mostGuestDate": "2025-03-06 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 146,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f41bbeb62e84787790953be5f6ce3c5d",
		  
		  "name": "Aaron",
		  "createdDate": "2014-03-24 22:13:15",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 523,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 2255,
		  "schedulePercent": 0.75578,
		  "totalGuests": 1475,
		  "guestPercent": 0.906845,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "Camp Randall Stadium",
		  "mostGuestCity": "Madison",
		  "mostGuestAmount": 149,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f41edeea1c97da6b882583f07c66da1a",
		  
		  "name": "C",
		  "createdDate": "2022-04-14 23:50:52",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 10,
		  "totalStates": 24,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1198,
		  "schedulePercent": 0.547031,
		  "totalGuests": 692,
		  "guestPercent": 0.783772,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "The Orpheum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f422f0e9b93c25610f07fb6781709fcb",
		  
		  "name": "Sidney",
		  "createdDate": "2018-12-12 19:25:06",
		  "totalOrganizations": 6,
		  "totalTours": 10,
		  "totalDays": 337,
		  "totalCountries": 6,
		  "totalStates": 42,
		  "totalEvents": 171,
		  "eventPercent": 0.74898,
		  "totalScheduleItems": 2946,
		  "schedulePercent": 0.836469,
		  "totalGuests": 862,
		  "guestPercent": 0.82151,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f44c08d550f662016b7f220d8f5ba749",
		  
		  "name": "Nunya",
		  "createdDate": "2017-10-10 18:05:42",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 348,
		  "totalCountries": 14,
		  "totalStates": 29,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 912,
		  "schedulePercent": 0.462375,
		  "totalGuests": 329,
		  "guestPercent": 0.665685,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 138,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f44e57695504c528793e4bb1db3deb0f",
		  
		  "name": "Stephen",
		  "createdDate": "2019-06-04 16:51:15",
		  "totalOrganizations": 13,
		  "totalTours": 37,
		  "totalDays": 797,
		  "totalCountries": 25,
		  "totalStates": 40,
		  "totalEvents": 238,
		  "eventPercent": 0.859134,
		  "totalScheduleItems": 4716,
		  "schedulePercent": 0.945036,
		  "totalGuests": 698,
		  "guestPercent": 0.785018,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f45aec281a61c028998459e5b29a4079",
		  
		  "name": "Adam",
		  "createdDate": "2017-01-10 19:25:40",
		  "totalOrganizations": 17,
		  "totalTours": 15,
		  "totalDays": 252,
		  "totalCountries": 38,
		  "totalStates": 36,
		  "totalEvents": 147,
		  "eventPercent": 0.698096,
		  "totalScheduleItems": 1654,
		  "schedulePercent": 0.650952,
		  "totalGuests": 763,
		  "guestPercent": 0.798957,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "O2 Academy Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f46e033b312e2efd23d8d5837ab88fa1",
		  
		  "name": "Eddie",
		  "createdDate": "2010-05-11 21:49:44",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 691,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 114,
		  "eventPercent": 0.602448,
		  "totalScheduleItems": 1380,
		  "schedulePercent": 0.592702,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f471ec12c8a6ae9624e31d3134208baf",
		  
		  "name": "James",
		  "createdDate": "2025-09-27 19:31:17",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 51,
		  "totalCountries": 3,
		  "totalStates": 10,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 340,
		  "schedulePercent": 0.238441,
		  "totalGuests": 55,
		  "guestPercent": 0.459542,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "Prudential Hall",
		  "mostGuestCity": "Newark",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4742a28acc724ba495284cb9fd30e0d",
		  
		  "name": "Jacob",
		  "createdDate": "2023-02-13 16:14:49",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 364,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 88,
		  "eventPercent": 0.504873,
		  "totalScheduleItems": 1185,
		  "schedulePercent": 0.543291,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f48171ea3a4533d8cb877f5ef8e124b8",
		  
		  "name": "Oscar",
		  "createdDate": "2025-06-25 17:57:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 60,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 559,
		  "schedulePercent": 0.336809,
		  "totalGuests": 21,
		  "guestPercent": 0.398799,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "The Foundry",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4819235cdb994d599efc49efafc087a",
		  
		  "name": "TJ",
		  "createdDate": "2013-07-01 19:39:59",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 1170,
		  "totalCountries": 24,
		  "totalStates": 47,
		  "totalEvents": 166,
		  "eventPercent": 0.739461,
		  "totalScheduleItems": 2244,
		  "schedulePercent": 0.754193,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f48c34ede448745c1d4ff00e92631ee8",
		  
		  "name": "V",
		  "createdDate": "2024-07-04 20:21:30",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 810,
		  "totalCountries": 33,
		  "totalStates": 74,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 3697,
		  "schedulePercent": 0.895739,
		  "totalGuests": 2398,
		  "guestPercent": 0.965095,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f49002f5467d64e7dc7a04b54222bb78",
		  
		  "name": "Carl",
		  "createdDate": "2022-05-18 22:20:33",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 985,
		  "totalCountries": 8,
		  "totalStates": 35,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 615,
		  "schedulePercent": 0.355734,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-08-30 00:00:00",
		  "mostGuestName": "City National Grove of Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4919878ea8551e76d29a403508c5b2a",
		  
		  "name": "Valerie",
		  "createdDate": "2025-09-30 19:56:20",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 104,
		  "totalCountries": 3,
		  "totalStates": 25,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 271,
		  "schedulePercent": 0.200023,
		  "totalGuests": 35,
		  "guestPercent": 0.427811,
		  "mostGuestDate": "2025-11-23 00:00:00",
		  "mostGuestName": "Goldfield Trading Post Roseville",
		  "mostGuestCity": "Roseville",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f491d14e92ef38656ba51584dc18d57f",
		  
		  "name": "Jon",
		  "createdDate": "2012-05-07 20:33:17",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 53,
		  "totalCountries": 6,
		  "totalStates": 6,
		  "totalEvents": 22,
		  "eventPercent": 0.163078,
		  "totalScheduleItems": 246,
		  "schedulePercent": 0.187217,
		  "totalGuests": 529,
		  "guestPercent": 0.738214,
		  "mostGuestDate": "2025-12-16 00:00:00",
		  "mostGuestName": "Sheffield City Hall",
		  "mostGuestCity": "Sheffield",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f49919103ca0fee7e7c1426bcf0c01ef",
		  
		  "name": "Ben",
		  "createdDate": "2022-04-19 22:23:56",
		  "totalOrganizations": 6,
		  "totalTours": 9,
		  "totalDays": 378,
		  "totalCountries": 12,
		  "totalStates": 48,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1079,
		  "schedulePercent": 0.513826,
		  "totalGuests": 91,
		  "guestPercent": 0.509066,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 42,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f49caa9b0a3fa2ca60a9a286dc891ded",
		  
		  "name": "William",
		  "createdDate": "2016-01-15 00:40:04",
		  "totalOrganizations": 10,
		  "totalTours": 4,
		  "totalDays": 1297,
		  "totalCountries": 17,
		  "totalStates": 22,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 648,
		  "schedulePercent": 0.366614,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4a532e14ef8d8609329fb465d74edee",
		  
		  "name": "Johan",
		  "createdDate": "2018-04-23 20:19:32",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 39,
		  "totalCountries": 6,
		  "totalStates": 3,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 280,
		  "schedulePercent": 0.205576,
		  "totalGuests": 12,
		  "guestPercent": 0.376587,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Hugo Park Festival",
		  "mostGuestCity": "NorrkÃ¶ping",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4adb97ece7d2c7efc8644412b1f2566",
		  
		  "name": "Dave",
		  "createdDate": "2011-10-12 05:39:03",
		  "totalOrganizations": 18,
		  "totalTours": 18,
		  "totalDays": 286,
		  "totalCountries": 23,
		  "totalStates": 47,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1498,
		  "schedulePercent": 0.617747,
		  "totalGuests": 550,
		  "guestPercent": 0.743994,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Electric Ballroom",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4d8fa6aba40299f9b86cb35eebf69f0",
		  
		  "name": "Annie",
		  "createdDate": "2025-03-15 13:02:06",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 1154,
		  "totalCountries": 20,
		  "totalStates": 28,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1921,
		  "schedulePercent": 0.697869,
		  "totalGuests": 224,
		  "guestPercent": 0.609474,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Dreamland Margate - Scenic Stage",
		  "mostGuestCity": "Margate",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4e2bdd45103e753fa0586f35f3ce52d",
		  
		  "name": "Jenna",
		  "createdDate": "2024-05-30 21:17:52",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 442,
		  "totalCountries": 20,
		  "totalStates": 33,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 3564,
		  "schedulePercent": 0.885879,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4e8fe2680ce5d9a32faa15ec2995f11",
		  
		  "name": "Makaela",
		  "createdDate": "2023-01-06 00:37:46",
		  "totalOrganizations": 11,
		  "totalTours": 22,
		  "totalDays": 645,
		  "totalCountries": 22,
		  "totalStates": 79,
		  "totalEvents": 304,
		  "eventPercent": 0.915231,
		  "totalScheduleItems": 5891,
		  "schedulePercent": 0.974275,
		  "totalGuests": 4139,
		  "guestPercent": 0.994107,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4f084e8afc35e77df357842eb8a7a75",
		  
		  "name": "Mek",
		  "createdDate": "2023-03-25 08:14:49",
		  "totalOrganizations": 15,
		  "totalTours": 15,
		  "totalDays": 186,
		  "totalCountries": 10,
		  "totalStates": 6,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 649,
		  "schedulePercent": 0.366954,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f4f2e7c14558b8e6b43226672438e82a",
		  
		  "name": "Josh",
		  "createdDate": "2016-03-28 15:02:41",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 464,
		  "totalCountries": 2,
		  "totalStates": 39,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1454,
		  "schedulePercent": 0.608228,
		  "totalGuests": 582,
		  "guestPercent": 0.753626,
		  "mostGuestDate": "2025-02-08 00:00:00",
		  "mostGuestName": "Soldiers and Sailors Memorial Auditorium",
		  "mostGuestCity": "Chattanooga",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f50e30a0c6ff16010ba899143a711fe4",
		  
		  "name": "Crystal",
		  "createdDate": "2012-03-15 19:43:05",
		  "totalOrganizations": 7,
		  "totalTours": 1,
		  "totalDays": 363,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 2,
		  "eventPercent": 0.0163191,
		  "totalScheduleItems": 121,
		  "schedulePercent": 0.111627,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f511dce21782e628900f30e69f383935",
		  
		  "name": "Aaron",
		  "createdDate": "2022-01-28 10:53:12",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 253,
		  "totalCountries": 14,
		  "totalStates": 27,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 764,
		  "schedulePercent": 0.409905,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f52b94c51e794d3f9a7ca0c44609d77b",
		  
		  "name": "Alex",
		  "createdDate": "2015-11-11 23:38:08",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 1274,
		  "totalCountries": 22,
		  "totalStates": 70,
		  "totalEvents": 282,
		  "eventPercent": 0.899819,
		  "totalScheduleItems": 6032,
		  "schedulePercent": 0.976088,
		  "totalGuests": 1681,
		  "guestPercent": 0.926791,
		  "mostGuestDate": "2025-02-07 00:00:00",
		  "mostGuestName": "Marvel Stadium",
		  "mostGuestCity": "Docklands",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f53381542ccafc4a63bf67a37723a30e",
		  
		  "name": "JH",
		  "createdDate": "2020-01-27 11:05:30",
		  "totalOrganizations": 13,
		  "totalTours": 4,
		  "totalDays": 339,
		  "totalCountries": 20,
		  "totalStates": 22,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1186,
		  "schedulePercent": 0.543518,
		  "totalGuests": 22,
		  "guestPercent": 0.401179,
		  "mostGuestDate": "2025-07-20 00:00:00",
		  "mostGuestName": "Festival de Thau",
		  "mostGuestCity": "Meze",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f533d1cb4f1103ea5ac017ba1ae2005f",
		  
		  "name": "Pete",
		  "createdDate": "2013-07-15 20:38:02",
		  "totalOrganizations": 12,
		  "totalTours": 23,
		  "totalDays": 1338,
		  "totalCountries": 9,
		  "totalStates": 63,
		  "totalEvents": 275,
		  "eventPercent": 0.895059,
		  "totalScheduleItems": 4872,
		  "schedulePercent": 0.950589,
		  "totalGuests": 1204,
		  "guestPercent": 0.876247,
		  "mostGuestDate": "2025-03-29 00:00:00",
		  "mostGuestName": "F&M Bank Arena",
		  "mostGuestCity": "Clarksville",
		  "mostGuestAmount": 119,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f536b40ed307d564655d551c6c9f7f26",
		  
		  "name": "Beth",
		  "createdDate": "2019-11-22 16:47:51",
		  "totalOrganizations": 14,
		  "totalTours": 7,
		  "totalDays": 831,
		  "totalCountries": 13,
		  "totalStates": 31,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 634,
		  "schedulePercent": 0.361854,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f53958d9e9f26535a715865be689b0a5",
		  
		  "name": "Luke",
		  "createdDate": "2012-05-10 19:54:05",
		  "totalOrganizations": 12,
		  "totalTours": 20,
		  "totalDays": 759,
		  "totalCountries": 6,
		  "totalStates": 57,
		  "totalEvents": 277,
		  "eventPercent": 0.896079,
		  "totalScheduleItems": 4831,
		  "schedulePercent": 0.948323,
		  "totalGuests": 2604,
		  "guestPercent": 0.972008,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 112,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f546ccff53f0d00bd32116e5f2e4175d",
		  
		  "name": "Kyle",
		  "createdDate": "2023-01-27 02:50:43",
		  "totalOrganizations": 5,
		  "totalTours": 10,
		  "totalDays": 820,
		  "totalCountries": 15,
		  "totalStates": 66,
		  "totalEvents": 350,
		  "eventPercent": 0.942316,
		  "totalScheduleItems": 4765,
		  "schedulePercent": 0.946623,
		  "totalGuests": 2033,
		  "guestPercent": 0.949229,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f548c3dff2d5b5391f76b244acc11505",
		  
		  "name": "Julie",
		  "createdDate": "2024-07-22 17:22:31",
		  "totalOrganizations": 18,
		  "totalTours": 16,
		  "totalDays": 571,
		  "totalCountries": 3,
		  "totalStates": 8,
		  "totalEvents": 532,
		  "eventPercent": 0.982094,
		  "totalScheduleItems": 2716,
		  "schedulePercent": 0.811197,
		  "totalGuests": 4513,
		  "guestPercent": 0.996147,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "ThÃ©Ã¢tre St-Denis",
		  "mostGuestCity": "MontrÃ©al",
		  "mostGuestAmount": 391,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5494ffa3726f7853a7a9da952254b42",
		  
		  "name": "Rueben",
		  "createdDate": "2012-12-18 16:53:02",
		  "totalOrganizations": 18,
		  "totalTours": 17,
		  "totalDays": 1783,
		  "totalCountries": 16,
		  "totalStates": 74,
		  "totalEvents": 416,
		  "eventPercent": 0.962489,
		  "totalScheduleItems": 2317,
		  "schedulePercent": 0.764279,
		  "totalGuests": 240,
		  "guestPercent": 0.61922,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Hard Rock Rocksino Northfield Park",
		  "mostGuestCity": "Northfield",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f54c2ae64f1369a1dc1849621db8885a",
		  
		  "name": "Matt",
		  "createdDate": "2019-03-08 17:40:45",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 233,
		  "totalCountries": 17,
		  "totalStates": 41,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 989,
		  "schedulePercent": 0.487874,
		  "totalGuests": 263,
		  "guestPercent": 0.63078,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "MGM Music Hall at Fenway",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f54d0ab70be0c80ca57196c38aa77c13",
		  
		  "name": "Angelo",
		  "createdDate": "2019-09-18 13:16:48",
		  "totalOrganizations": 10,
		  "totalTours": 6,
		  "totalDays": 166,
		  "totalCountries": 25,
		  "totalStates": 65,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 1621,
		  "schedulePercent": 0.644719,
		  "totalGuests": 754,
		  "guestPercent": 0.796917,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Columbia Theater",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f558263569f7642fd1bc09124b581056",
		  
		  "name": "Jimmy",
		  "createdDate": "2018-05-29 22:33:11",
		  "totalOrganizations": 15,
		  "totalTours": 18,
		  "totalDays": 1150,
		  "totalCountries": 15,
		  "totalStates": 68,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 4380,
		  "schedulePercent": 0.934384,
		  "totalGuests": 320,
		  "guestPercent": 0.659791,
		  "mostGuestDate": "2025-09-04 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f55d77635812fbbc7024a571d3715cf1",
		  
		  "name": "David",
		  "createdDate": "2012-10-19 04:47:41",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 73,
		  "totalCountries": 6,
		  "totalStates": 19,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 375,
		  "schedulePercent": 0.25544,
		  "totalGuests": 168,
		  "guestPercent": 0.572303,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Rainbow Bar & Grill",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f566abf1185697925ada89a1344309b9",
		  
		  "name": "Gary",
		  "createdDate": "2020-01-15 20:34:30",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 1307,
		  "totalCountries": 19,
		  "totalStates": 72,
		  "totalEvents": 252,
		  "eventPercent": 0.872847,
		  "totalScheduleItems": 2516,
		  "schedulePercent": 0.788078,
		  "totalGuests": 1659,
		  "guestPercent": 0.924637,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f56989d8e67a2860eb982d14b9b3a198",
		  
		  "name": "Tarek",
		  "createdDate": "2014-06-11 17:17:41",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 420,
		  "totalCountries": 4,
		  "totalStates": 47,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 2818,
		  "schedulePercent": 0.824456,
		  "totalGuests": 1188,
		  "guestPercent": 0.875,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f57caef5cca1299df3e42af3337e2516",
		  
		  "name": "Kenny",
		  "createdDate": "2016-10-07 04:24:53",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 257,
		  "totalCountries": 5,
		  "totalStates": 39,
		  "totalEvents": 105,
		  "eventPercent": 0.569243,
		  "totalScheduleItems": 1872,
		  "schedulePercent": 0.689823,
		  "totalGuests": 1088,
		  "guestPercent": 0.861854,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Grand Sierra Theater",
		  "mostGuestCity": "Reno",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5846bcd08ba43c5837cdbcc5e4a5e54",
		  
		  "name": "The Native",
		  "createdDate": "2019-02-23 22:09:30",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 36,
		  "totalCountries": 3,
		  "totalStates": 21,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 284,
		  "schedulePercent": 0.208862,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f58cacc2ba428dba7bf09a99cdd85f31",
		  
		  "name": "Sage",
		  "createdDate": "2025-03-31 22:35:44",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 298,
		  "totalCountries": 19,
		  "totalStates": 20,
		  "totalEvents": 47,
		  "eventPercent": 0.30961,
		  "totalScheduleItems": 340,
		  "schedulePercent": 0.238441,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "Fuford Hall",
		  "mostGuestCity": "Salt spring island ",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5998c63ac91ca730bf5903a7d2ea8a6",
		  
		  "name": "Anthony",
		  "createdDate": "2015-11-07 19:13:40",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 93,
		  "schedulePercent": 0.0917951,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f59f400cabdcc9b892034bf91be2287f",
		  
		  "name": "Alexzandra ",
		  "createdDate": "2022-05-26 01:45:41",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 535,
		  "totalCountries": 10,
		  "totalStates": 15,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 578,
		  "schedulePercent": 0.342702,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5b269211bf8d7ecb09cc8c5b9ddc7ea",
		  
		  "name": "Christopher",
		  "createdDate": "2023-02-17 23:51:52",
		  "totalOrganizations": 8,
		  "totalTours": 11,
		  "totalDays": 109,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 696,
		  "schedulePercent": 0.385313,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": " Everwise Amphitheater at White River State Park",
		  "mostGuestCity": "Indianapolis",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5bfb8c6716d6335cce8a0dd2c8ad7c9",
		  
		  "name": "Manuel",
		  "createdDate": "2025-02-24 10:56:17",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 751,
		  "schedulePercent": 0.405598,
		  "totalGuests": 1476,
		  "guestPercent": 0.906958,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Raiffeisen Halle Gasometer",
		  "mostGuestCity": "Wien",
		  "mostGuestAmount": 228,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5c5f58a21af399b5b087137fb9ed32c",
		  
		  "name": "Jesse",
		  "createdDate": "2022-02-02 03:52:12",
		  "totalOrganizations": 11,
		  "totalTours": 7,
		  "totalDays": 931,
		  "totalCountries": 16,
		  "totalStates": 49,
		  "totalEvents": 172,
		  "eventPercent": 0.75068,
		  "totalScheduleItems": 2658,
		  "schedulePercent": 0.803377,
		  "totalGuests": 912,
		  "guestPercent": 0.832729,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5c9e36fe599fa8d6990014cb8b1185a",
		  
		  "name": "Blaine",
		  "createdDate": "2010-06-25 20:34:39",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 369,
		  "totalCountries": 22,
		  "totalStates": 42,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 4180,
		  "schedulePercent": 0.924637,
		  "totalGuests": 2544,
		  "guestPercent": 0.970195,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Grand Garden Arena",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 155,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5cb4d347836842a81fa30f62fe7eda8",
		  
		  "name": "Katsu",
		  "createdDate": "2015-11-01 17:30:46",
		  "totalOrganizations": 6,
		  "totalTours": 52,
		  "totalDays": 539,
		  "totalCountries": 41,
		  "totalStates": 94,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 3562,
		  "schedulePercent": 0.885653,
		  "totalGuests": 2500,
		  "guestPercent": 0.968042,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Barrowland Ballroom",
		  "mostGuestCity": "Glasgow",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5cbebefa3769f17255d179491ea331d",
		  
		  "name": "Paul",
		  "createdDate": "2011-10-10 22:29:11",
		  "totalOrganizations": 12,
		  "totalTours": 8,
		  "totalDays": 718,
		  "totalCountries": 14,
		  "totalStates": 32,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 809,
		  "schedulePercent": 0.426337,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5d68c73456d653d80f9d075c2bebeef",
		  
		  "name": "Ã‰lise",
		  "createdDate": "2024-04-30 15:23:21",
		  "totalOrganizations": 22,
		  "totalTours": 18,
		  "totalDays": 293,
		  "totalCountries": 29,
		  "totalStates": 33,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 1578,
		  "schedulePercent": 0.636219,
		  "totalGuests": 130,
		  "guestPercent": 0.544311,
		  "mostGuestDate": "2025-02-01 00:00:00",
		  "mostGuestName": "Kollektivet Livet",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5d8448bbb727ec31f44872ca97e0e13",
		  
		  "name": "Simon",
		  "createdDate": "2018-02-28 23:57:58",
		  "totalOrganizations": 3,
		  "totalTours": 13,
		  "totalDays": 61,
		  "totalCountries": 7,
		  "totalStates": 8,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 304,
		  "schedulePercent": 0.218948,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5d916a9faa930464bfe5aa195661227",
		  
		  "name": "Victoria",
		  "createdDate": "2025-04-28 21:56:09",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 186,
		  "totalCountries": 9,
		  "totalStates": 34,
		  "totalEvents": 65,
		  "eventPercent": 0.400725,
		  "totalScheduleItems": 1213,
		  "schedulePercent": 0.550204,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-05-07 00:00:00",
		  "mostGuestName": "The Fonda Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5df2b4058d0e73dbec385b65e5ec09a",
		  
		  "name": "Jessica",
		  "createdDate": "2024-08-02 16:31:20",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 711,
		  "totalCountries": 30,
		  "totalStates": 34,
		  "totalEvents": 75,
		  "eventPercent": 0.448436,
		  "totalScheduleItems": 2022,
		  "schedulePercent": 0.717588,
		  "totalGuests": 425,
		  "guestPercent": 0.704442,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Dreamland Margate - Scenic Stage",
		  "mostGuestCity": "Margate",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5e233db04a98390cebaa75c46224558",
		  
		  "name": "Matt",
		  "createdDate": "2013-10-20 22:47:37",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 88,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 531,
		  "schedulePercent": 0.327176,
		  "totalGuests": 557,
		  "guestPercent": 0.74558,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The Fillmore Philadelphia",
		  "mostGuestCity": "Philadelphia",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5e579409830d6e16291b60cdb79fc4c",
		  
		  "name": "Justin",
		  "createdDate": "2016-06-19 09:50:19",
		  "totalOrganizations": 34,
		  "totalTours": 20,
		  "totalDays": 482,
		  "totalCountries": 8,
		  "totalStates": 63,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 2595,
		  "schedulePercent": 0.796804,
		  "totalGuests": 2091,
		  "guestPercent": 0.953649,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5e81dd2d62a84beef500397ed700b1f",
		  
		  "name": "Bobby",
		  "createdDate": "2025-08-26 03:16:36",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 61,
		  "totalCountries": 3,
		  "totalStates": 20,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 395,
		  "schedulePercent": 0.266772,
		  "totalGuests": 52,
		  "guestPercent": 0.455236,
		  "mostGuestDate": "2025-10-02 00:00:00",
		  "mostGuestName": "Los Angeles Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5eb8ea8d682d5e6230f2e0f03f01b21",
		  
		  "name": "Sam",
		  "createdDate": "2018-03-08 17:58:40",
		  "totalOrganizations": 15,
		  "totalTours": 25,
		  "totalDays": 1114,
		  "totalCountries": 23,
		  "totalStates": 81,
		  "totalEvents": 372,
		  "eventPercent": 0.950363,
		  "totalScheduleItems": 4741,
		  "schedulePercent": 0.94617,
		  "totalGuests": 1523,
		  "guestPercent": 0.912398,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5ebd199d5856f81fff72416db54778f",
		  
		  "name": "Gemma",
		  "createdDate": "2016-09-21 02:44:53",
		  "totalOrganizations": 9,
		  "totalTours": 4,
		  "totalDays": 336,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 1477,
		  "schedulePercent": 0.612194,
		  "totalGuests": 98,
		  "guestPercent": 0.516886,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Somerset House",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5ec953bdcdb5daca2fe7a7f89250822",
		  
		  "name": "Michael",
		  "createdDate": "2018-07-13 14:04:46",
		  "totalOrganizations": 7,
		  "totalTours": 9,
		  "totalDays": 104,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 560,
		  "schedulePercent": 0.337375,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Lodge Room",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5ecdf95005aed75bc4d3f13ce082605",
		  
		  "name": "Cecilia",
		  "createdDate": "2024-06-12 14:07:36",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 74,
		  "totalCountries": 6,
		  "totalStates": 46,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 388,
		  "schedulePercent": 0.263486,
		  "totalGuests": 13,
		  "guestPercent": 0.378513,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "Piazza Ariostea",
		  "mostGuestCity": "Ferrara",
		  "mostGuestAmount": 9,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5f308d63e3cfe316334f5586f80c510",
		  
		  "name": "Matthew",
		  "createdDate": "2021-09-14 15:36:13",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 53,
		  "totalCountries": 3,
		  "totalStates": 16,
		  "totalEvents": 38,
		  "eventPercent": 0.261219,
		  "totalScheduleItems": 422,
		  "schedulePercent": 0.278898,
		  "totalGuests": 234,
		  "guestPercent": 0.615027,
		  "mostGuestDate": "2025-10-14 00:00:00",
		  "mostGuestName": "State Farm Arena",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5f75a93d3e3947100e50d0fa9f104c4",
		  
		  "name": "Dan",
		  "createdDate": "2012-05-10 02:17:32",
		  "totalOrganizations": 16,
		  "totalTours": 10,
		  "totalDays": 661,
		  "totalCountries": 7,
		  "totalStates": 37,
		  "totalEvents": 129,
		  "eventPercent": 0.651405,
		  "totalScheduleItems": 1655,
		  "schedulePercent": 0.651065,
		  "totalGuests": 145,
		  "guestPercent": 0.555077,
		  "mostGuestDate": "2025-05-09 00:00:00",
		  "mostGuestName": "The Mercury Ballroom",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 19,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5f8f2c3c97d7775b1ee617c73845182",
		  
		  "name": "Otto",
		  "createdDate": "2018-01-22 06:24:45",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 1031,
		  "totalCountries": 12,
		  "totalStates": 38,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 2349,
		  "schedulePercent": 0.768019,
		  "totalGuests": 2243,
		  "guestPercent": 0.959655,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Kaseya Arena",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 282,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f5f9d21d18a6326991238b05de842cc2",
		  
		  "name": "Nathan",
		  "createdDate": "2022-09-26 13:23:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 126,
		  "totalCountries": 8,
		  "totalStates": 17,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 264,
		  "schedulePercent": 0.196396,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f601da23cc75d015049a394726f2be81",
		  
		  "name": "John",
		  "createdDate": "2023-03-22 11:36:16",
		  "totalOrganizations": 2,
		  "totalTours": 14,
		  "totalDays": 221,
		  "totalCountries": 6,
		  "totalStates": 30,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 743,
		  "schedulePercent": 0.402312,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f60799c44979589c579aa0c73a1f150e",
		  
		  "name": "Ben ",
		  "createdDate": "2022-08-03 20:29:56",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 1269,
		  "totalCountries": 3,
		  "totalStates": 53,
		  "totalEvents": 237,
		  "eventPercent": 0.858001,
		  "totalScheduleItems": 3339,
		  "schedulePercent": 0.870014,
		  "totalGuests": 64,
		  "guestPercent": 0.475748,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Crystal Grand Music Theatre",
		  "mostGuestCity": "Wisconsin Dells",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f61091a946b5cd283b01c09b5486e5ae",
		  
		  "name": "Josh",
		  "createdDate": "2015-03-25 12:17:22",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 24,
		  "totalCountries": 6,
		  "totalStates": 7,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 117,
		  "schedulePercent": 0.108794,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f615b34d55f686c7115d75097d487b1f",
		  
		  "name": "Gilroy",
		  "createdDate": "2022-06-01 18:27:49",
		  "totalOrganizations": 13,
		  "totalTours": 17,
		  "totalDays": 591,
		  "totalCountries": 28,
		  "totalStates": 76,
		  "totalEvents": 233,
		  "eventPercent": 0.851315,
		  "totalScheduleItems": 2816,
		  "schedulePercent": 0.824343,
		  "totalGuests": 857,
		  "guestPercent": 0.82083,
		  "mostGuestDate": "2025-11-06 00:00:00",
		  "mostGuestName": "Scotiabank Arena",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 107,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6207821ef4d6fbf59892a17dec7b2a7",
		  
		  "name": "Victoria",
		  "createdDate": "2015-02-20 12:37:43",
		  "totalOrganizations": 28,
		  "totalTours": 12,
		  "totalDays": 379,
		  "totalCountries": 21,
		  "totalStates": 34,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 1876,
		  "schedulePercent": 0.690163,
		  "totalGuests": 640,
		  "guestPercent": 0.769266,
		  "mostGuestDate": "2025-01-24 00:00:00",
		  "mostGuestName": "The Masonic",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f620bc06b57c39da27756292dfd4506b",
		  
		  "name": "Jake",
		  "createdDate": "2016-06-21 13:34:06",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 329,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 128,
		  "eventPercent": 0.648685,
		  "totalScheduleItems": 2174,
		  "schedulePercent": 0.743767,
		  "totalGuests": 682,
		  "guestPercent": 0.781505,
		  "mostGuestDate": "2025-10-25 00:00:00",
		  "mostGuestName": "Synovus Bank Amphitheater at Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f626bfaed2a290ddd66eb65e062581c8",
		  
		  "name": "Leander",
		  "createdDate": "2018-06-08 18:50:59",
		  "totalOrganizations": 7,
		  "totalTours": 4,
		  "totalDays": 494,
		  "totalCountries": 16,
		  "totalStates": 59,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2025,
		  "schedulePercent": 0.718495,
		  "totalGuests": 271,
		  "guestPercent": 0.635653,
		  "mostGuestDate": "2025-03-01 00:00:00",
		  "mostGuestName": "Massey Hall",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6297cd45e97b1443fb42193140f84e6",
		  
		  "name": "Peter",
		  "createdDate": "2022-03-08 12:33:27",
		  "totalOrganizations": 8,
		  "totalTours": 7,
		  "totalDays": 503,
		  "totalCountries": 6,
		  "totalStates": 8,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 315,
		  "schedulePercent": 0.224841,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-07-28 00:00:00",
		  "mostGuestName": "Burgsvik GrÃ¥ GÃ¥sen",
		  "mostGuestCity": "Burgsvik",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f62ec1465661646f557626fec9269d3e",
		  
		  "name": "Elena",
		  "createdDate": "2025-02-11 13:34:08",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 45,
		  "totalCountries": 5,
		  "totalStates": 9,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 433,
		  "schedulePercent": 0.282978,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6342eb234374882a0112c9ac7fde62f",
		  
		  "name": "Stu-Nora",
		  "createdDate": "2012-12-12 11:59:46",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 66,
		  "totalCountries": 10,
		  "totalStates": 8,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 390,
		  "schedulePercent": 0.264733,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f63af1b3317d9d0649f502d900b33028",
		  
		  "name": "Chris",
		  "createdDate": "2023-06-28 16:29:50",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 963,
		  "totalCountries": 27,
		  "totalStates": 49,
		  "totalEvents": 271,
		  "eventPercent": 0.891092,
		  "totalScheduleItems": 3045,
		  "schedulePercent": 0.846781,
		  "totalGuests": 930,
		  "guestPercent": 0.835675,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f647deaf959a51318333cf4b80e0cdf9",
		  
		  "name": "Gavin",
		  "createdDate": "2016-10-17 00:59:06",
		  "totalOrganizations": 19,
		  "totalTours": 8,
		  "totalDays": 350,
		  "totalCountries": 11,
		  "totalStates": 27,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1430,
		  "schedulePercent": 0.604714,
		  "totalGuests": 105,
		  "guestPercent": 0.524932,
		  "mostGuestDate": "2025-03-14 00:00:00",
		  "mostGuestName": "Rod Laver Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 21,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f652d58ead28c16fdd88b0ce7c238a64",
		  
		  "name": "Isa",
		  "createdDate": "2017-06-09 20:56:48",
		  "totalOrganizations": 21,
		  "totalTours": 6,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 29,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 174,
		  "schedulePercent": 0.143246,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f65795ad86253c66f844843f0365e331",
		  
		  "name": "Lisa",
		  "createdDate": "2025-01-17 22:01:56",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 325,
		  "totalCountries": 2,
		  "totalStates": 5,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 12,
		  "schedulePercent": 0.0226655,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f65906ccdad0453d2c1377906d71b820",
		  
		  "name": "John",
		  "createdDate": "2021-10-09 17:18:25",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 660,
		  "totalCountries": 23,
		  "totalStates": 37,
		  "totalEvents": 137,
		  "eventPercent": 0.671578,
		  "totalScheduleItems": 1191,
		  "schedulePercent": 0.545218,
		  "totalGuests": 465,
		  "guestPercent": 0.717928,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6655b2f41be5a47b9e691042ef49d67",
		  
		  "name": "Ryan",
		  "createdDate": "2019-03-01 20:51:51",
		  "totalOrganizations": 14,
		  "totalTours": 10,
		  "totalDays": 462,
		  "totalCountries": 28,
		  "totalStates": 60,
		  "totalEvents": 246,
		  "eventPercent": 0.866954,
		  "totalScheduleItems": 2213,
		  "schedulePercent": 0.75034,
		  "totalGuests": 506,
		  "guestPercent": 0.732661,
		  "mostGuestDate": "2025-11-03 00:00:00",
		  "mostGuestName": "Ziggo Dome",
		  "mostGuestCity": "Amsterdam",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f66d4a11284a880785d1c12b90fb7094",
		  
		  "name": "Matt ",
		  "createdDate": "2011-09-03 23:29:18",
		  "totalOrganizations": 11,
		  "totalTours": 9,
		  "totalDays": 320,
		  "totalCountries": 30,
		  "totalStates": 58,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1661,
		  "schedulePercent": 0.651632,
		  "totalGuests": 707,
		  "guestPercent": 0.787171,
		  "mostGuestDate": "2025-08-31 00:00:00",
		  "mostGuestName": "Soldier Field",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f68a579749903d7aa879264f174088e9",
		  
		  "name": "Robin",
		  "createdDate": "2024-10-21 11:35:45",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 114,
		  "totalCountries": 8,
		  "totalStates": 16,
		  "totalEvents": 49,
		  "eventPercent": 0.318676,
		  "totalScheduleItems": 364,
		  "schedulePercent": 0.25,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f68af97464361eef9c0877bfb6704937",
		  
		  "name": "Rob",
		  "createdDate": "2025-04-07 16:59:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 153,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 1302,
		  "schedulePercent": 0.57185,
		  "totalGuests": 536,
		  "guestPercent": 0.739801,
		  "mostGuestDate": "2025-06-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 70,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6929d6a04d6f30e3c38f7a52c585e42",
		  
		  "name": "Jordan",
		  "createdDate": "2017-08-08 12:59:54",
		  "totalOrganizations": 27,
		  "totalTours": 24,
		  "totalDays": 2860,
		  "totalCountries": 25,
		  "totalStates": 67,
		  "totalEvents": 541,
		  "eventPercent": 0.983228,
		  "totalScheduleItems": 7871,
		  "schedulePercent": 0.99014,
		  "totalGuests": 1405,
		  "guestPercent": 0.900499,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f69b0d56dad51a64c567476287c6785a",
		  
		  "name": "Craig A",
		  "createdDate": "2019-07-17 22:08:19",
		  "totalOrganizations": 1,
		  "totalTours": 28,
		  "totalDays": 242,
		  "totalCountries": 28,
		  "totalStates": 16,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 666,
		  "schedulePercent": 0.373413,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "The Carolina Opry",
		  "mostGuestCity": "Myrtle Beach",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6a11133c7f0aca4858ae4b1c177ec8b",
		  
		  "name": "Roni",
		  "createdDate": "2023-10-03 13:02:21",
		  "totalOrganizations": 2,
		  "totalTours": 8,
		  "totalDays": 381,
		  "totalCountries": 26,
		  "totalStates": 40,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1649,
		  "schedulePercent": 0.649932,
		  "totalGuests": 723,
		  "guestPercent": 0.791138,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6a4a352b81243b6fb1acf77d126e67e",
		  
		  "name": "Nick",
		  "createdDate": "2013-06-28 07:50:14",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 614,
		  "totalCountries": 4,
		  "totalStates": 46,
		  "totalEvents": 134,
		  "eventPercent": 0.663418,
		  "totalScheduleItems": 1839,
		  "schedulePercent": 0.683024,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6aa2d59826fa34ff694bfa73a3f7fe4",
		  
		  "name": "Kevin",
		  "createdDate": "2018-05-15 00:31:14",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 367,
		  "totalCountries": 5,
		  "totalStates": 56,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2527,
		  "schedulePercent": 0.789325,
		  "totalGuests": 4231,
		  "guestPercent": 0.994334,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6aa6cbadd1c1c38561f796038ba4d88",
		  
		  "name": "Craig",
		  "createdDate": "2021-05-26 15:30:32",
		  "totalOrganizations": 6,
		  "totalTours": 19,
		  "totalDays": 100,
		  "totalCountries": 2,
		  "totalStates": 26,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 483,
		  "schedulePercent": 0.302924,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-06-22 00:00:00",
		  "mostGuestName": "Garcia's",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6b0f96d596a4f12e3fa3c931ab11ab2",
		  
		  "name": "David",
		  "createdDate": "2014-01-10 16:56:29",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 1328,
		  "totalCountries": 33,
		  "totalStates": 52,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 3548,
		  "schedulePercent": 0.884746,
		  "totalGuests": 515,
		  "guestPercent": 0.734361,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "O2 Arena",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6ca08b82e93167eb56443a5c4ca0fe5",
		  
		  "name": "Austin",
		  "createdDate": "2015-04-17 22:44:03",
		  "totalOrganizations": 18,
		  "totalTours": 28,
		  "totalDays": 1066,
		  "totalCountries": 20,
		  "totalStates": 63,
		  "totalEvents": 243,
		  "eventPercent": 0.864347,
		  "totalScheduleItems": 3428,
		  "schedulePercent": 0.877607,
		  "totalGuests": 195,
		  "guestPercent": 0.590549,
		  "mostGuestDate": "2025-02-13 00:00:00",
		  "mostGuestName": "Brooklyn Bowl",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6ca92acb3b4f4ee158b71e2e93246fa",
		  
		  "name": "Charlie",
		  "createdDate": "2012-03-12 03:36:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 27,
		  "totalCountries": 2,
		  "totalStates": 15,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 232,
		  "guestPercent": 0.614007,
		  "mostGuestDate": "2025-06-07 00:00:00",
		  "mostGuestName": "The Wharf Amphitheater",
		  "mostGuestCity": "Orange Beach",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6cc2f1237667bf7a4e78b3e98964fff",
		  
		  "name": "Meredith",
		  "createdDate": "2017-03-08 18:36:51",
		  "totalOrganizations": 3,
		  "totalTours": 16,
		  "totalDays": 163,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 789,
		  "schedulePercent": 0.418631,
		  "totalGuests": 95,
		  "guestPercent": 0.513826,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "The Hotel Cafe",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 13,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6ce6806b4f34b02f86d4f66a6543fe8",
		  
		  "name": "Steve",
		  "createdDate": "2022-04-04 00:50:14",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 781,
		  "totalCountries": 9,
		  "totalStates": 52,
		  "totalEvents": 428,
		  "eventPercent": 0.964982,
		  "totalScheduleItems": 4052,
		  "schedulePercent": 0.916138,
		  "totalGuests": 494,
		  "guestPercent": 0.728694,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Knoxville Civic Auditorium and Coliseum",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6d44ef4a2fd5a3aa170f4b30853ad80",
		  
		  "name": "Will",
		  "createdDate": "2019-03-31 16:56:41",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 149,
		  "totalCountries": 13,
		  "totalStates": 43,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 891,
		  "schedulePercent": 0.454442,
		  "totalGuests": 1139,
		  "guestPercent": 0.87024,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "The Fillmore",
		  "mostGuestCity": "Detroit",
		  "mostGuestAmount": 122,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6df9a10678ab6fe637c1bb4dac4be00",
		  
		  "name": "Kristopher",
		  "createdDate": "2018-03-31 05:42:46",
		  "totalOrganizations": 17,
		  "totalTours": 8,
		  "totalDays": 65,
		  "totalCountries": 5,
		  "totalStates": 8,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 531,
		  "schedulePercent": 0.327176,
		  "totalGuests": 200,
		  "guestPercent": 0.594855,
		  "mostGuestDate": "2025-02-20 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6e84f998fef47fdade272ba7666bfb6",
		  
		  "name": "Hannah",
		  "createdDate": "2024-09-08 01:14:49",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 838,
		  "totalCountries": 8,
		  "totalStates": 61,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2789,
		  "schedulePercent": 0.82083,
		  "totalGuests": 2075,
		  "guestPercent": 0.952063,
		  "mostGuestDate": "2025-08-25 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 176,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6fc263bf4a5a283bde32870b0a63602",
		  
		  "name": "Tali",
		  "createdDate": "2023-04-12 14:23:51",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 354,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 667,
		  "schedulePercent": 0.373867,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f6fcbdfb1646f90ebfdd455e20894ded",
		  
		  "name": "William",
		  "createdDate": "2024-11-07 15:42:15",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 364,
		  "totalCountries": 14,
		  "totalStates": 21,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 295,
		  "schedulePercent": 0.215095,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f70399e22fee80ba32725478bd0ebfd7",
		  
		  "name": "Julie",
		  "createdDate": "2025-05-08 18:40:53",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 724,
		  "totalCountries": 14,
		  "totalStates": 53,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 5535,
		  "schedulePercent": 0.968155,
		  "totalGuests": 660,
		  "guestPercent": 0.774252,
		  "mostGuestDate": "2025-09-11 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f70628bf1137e74097d40772401c54a6",
		  
		  "name": "Jess",
		  "createdDate": "2022-12-20 12:59:01",
		  "totalOrganizations": 18,
		  "totalTours": 11,
		  "totalDays": 1093,
		  "totalCountries": 22,
		  "totalStates": 38,
		  "totalEvents": 152,
		  "eventPercent": 0.708749,
		  "totalScheduleItems": 2040,
		  "schedulePercent": 0.720875,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-04-07 00:00:00",
		  "mostGuestName": "Ebisu Garden Hall",
		  "mostGuestCity": "Tokyo",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f710c4ac8ab805b30476df9a548c6834",
		  
		  "name": "George",
		  "createdDate": "2024-04-13 17:16:57",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 106,
		  "totalCountries": 2,
		  "totalStates": 21,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 70,
		  "schedulePercent": 0.0746827,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f71783a4ba401f67cedabb18205bb0ab",
		  
		  "name": "Amy",
		  "createdDate": "2023-08-06 19:20:35",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 57,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 389,
		  "schedulePercent": 0.264279,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f71850063b90d8b00739ae8c12b47eee",
		  
		  "name": "Shawn",
		  "createdDate": "2011-11-05 02:15:11",
		  "totalOrganizations": 19,
		  "totalTours": 14,
		  "totalDays": 472,
		  "totalCountries": 4,
		  "totalStates": 43,
		  "totalEvents": 290,
		  "eventPercent": 0.905598,
		  "totalScheduleItems": 3775,
		  "schedulePercent": 0.900612,
		  "totalGuests": 3372,
		  "guestPercent": 0.988327,
		  "mostGuestDate": "2025-02-16 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f72d5d264e9e0f1042218b4b70be12c8",
		  
		  "name": "Danielle",
		  "createdDate": "2025-04-07 08:23:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 37,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 182,
		  "schedulePercent": 0.148232,
		  "totalGuests": 8,
		  "guestPercent": 0.363101,
		  "mostGuestDate": "2025-04-18 00:00:00",
		  "mostGuestName": "Bayou Music Center",
		  "mostGuestCity": "Houston",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f730b2ff2ff3cd65fc7044b9e34a27b0",
		  
		  "name": "Paul ",
		  "createdDate": "2023-02-22 14:08:07",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 363,
		  "totalCountries": 22,
		  "totalStates": 28,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 596,
		  "schedulePercent": 0.349841,
		  "totalGuests": 347,
		  "guestPercent": 0.673844,
		  "mostGuestDate": "2025-02-14 00:00:00",
		  "mostGuestName": "UBS Arena",
		  "mostGuestCity": "Elmont",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f73d0e2052b596bde066e7e5e1320ea0",
		  
		  "name": "Gabriel ",
		  "createdDate": "2015-08-11 14:20:08",
		  "totalOrganizations": 10,
		  "totalTours": 7,
		  "totalDays": 898,
		  "totalCountries": 17,
		  "totalStates": 24,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 968,
		  "schedulePercent": 0.480621,
		  "totalGuests": 359,
		  "guestPercent": 0.677924,
		  "mostGuestDate": "2025-06-25 00:00:00",
		  "mostGuestName": "Stockholm Fields",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f73fbc6f2e6c0bc846a7e788fc18c270",
		  
		  "name": "William",
		  "createdDate": "2024-08-20 17:03:33",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 584,
		  "totalCountries": 10,
		  "totalStates": 35,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 888,
		  "schedulePercent": 0.453083,
		  "totalGuests": 441,
		  "guestPercent": 0.709769,
		  "mostGuestDate": "2025-10-05 00:00:00",
		  "mostGuestName": "Troubadour",
		  "mostGuestCity": "West Hollywood",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f74fe4bbf6d2a090f34161674197ab5d",
		  
		  "name": "Kenzie",
		  "createdDate": "2023-07-26 19:51:09",
		  "totalOrganizations": 6,
		  "totalTours": 18,
		  "totalDays": 698,
		  "totalCountries": 10,
		  "totalStates": 48,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 2687,
		  "schedulePercent": 0.80757,
		  "totalGuests": 1418,
		  "guestPercent": 0.902085,
		  "mostGuestDate": "2025-02-25 00:00:00",
		  "mostGuestName": "Dickies Arena",
		  "mostGuestCity": "Fort Worth",
		  "mostGuestAmount": 167,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f75b6f991c4f14286bbc26cbc593ce7a",
		  
		  "name": "Duschan ",
		  "createdDate": "2025-03-06 13:04:14",
		  "totalOrganizations": 26,
		  "totalTours": 25,
		  "totalDays": 390,
		  "totalCountries": 30,
		  "totalStates": 42,
		  "totalEvents": 222,
		  "eventPercent": 0.836242,
		  "totalScheduleItems": 1725,
		  "schedulePercent": 0.663078,
		  "totalGuests": 226,
		  "guestPercent": 0.610607,
		  "mostGuestDate": "2025-09-29 00:00:00",
		  "mostGuestName": "Folketeateret",
		  "mostGuestCity": "Oslo",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f75dd251139635ecf9af306b55031d2d",
		  
		  "name": "Robert",
		  "createdDate": "2025-08-27 13:43:49",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 38,
		  "totalCountries": 18,
		  "totalStates": 10,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 130,
		  "schedulePercent": 0.11786,
		  "totalGuests": 31,
		  "guestPercent": 0.419424,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "Arena Riga",
		  "mostGuestCity": "Riga",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f766ee406c5ceecaf55cd33b931df23b",
		  
		  "name": "Rob",
		  "createdDate": "2015-10-16 00:53:27",
		  "totalOrganizations": 9,
		  "totalTours": 7,
		  "totalDays": 57,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 136,
		  "schedulePercent": 0.122507,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f76b8cfba63c3f95807c70fcb2836481",
		  
		  "name": "Richard",
		  "createdDate": "2011-08-15 22:42:54",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 271,
		  "totalCountries": 10,
		  "totalStates": 39,
		  "totalEvents": 127,
		  "eventPercent": 0.645512,
		  "totalScheduleItems": 2793,
		  "schedulePercent": 0.821283,
		  "totalGuests": 10,
		  "guestPercent": 0.370354,
		  "mostGuestDate": "2025-07-16 00:00:00",
		  "mostGuestName": "Stadtpark",
		  "mostGuestCity": "Hamburg",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f777709541c139c6a392bea8df573a57",
		  
		  "name": "Chigo",
		  "createdDate": "2019-05-22 16:05:57",
		  "totalOrganizations": 24,
		  "totalTours": 25,
		  "totalDays": 725,
		  "totalCountries": 35,
		  "totalStates": 52,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 2176,
		  "schedulePercent": 0.744674,
		  "totalGuests": 276,
		  "guestPercent": 0.638259,
		  "mostGuestDate": "2025-05-25 00:00:00",
		  "mostGuestName": "Brockwell Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f77851227f6865ab0c02ef8a32bbd981",
		  
		  "name": "Amanda",
		  "createdDate": "2019-04-24 02:17:16",
		  "totalOrganizations": 9,
		  "totalTours": 11,
		  "totalDays": 718,
		  "totalCountries": 20,
		  "totalStates": 64,
		  "totalEvents": 236,
		  "eventPercent": 0.856188,
		  "totalScheduleItems": 3233,
		  "schedulePercent": 0.862421,
		  "totalGuests": 520,
		  "guestPercent": 0.736061,
		  "mostGuestDate": "2025-10-29 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 45,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7868da312cbe2f374afd791437fc66e",
		  
		  "name": "Camilla",
		  "createdDate": "2012-07-23 15:19:22",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 76,
		  "totalCountries": 12,
		  "totalStates": 11,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 359,
		  "schedulePercent": 0.24762,
		  "totalGuests": 2,
		  "guestPercent": 0.323776,
		  "mostGuestDate": "2025-05-08 00:00:00",
		  "mostGuestName": "El Cid",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f78e202487a32118465ff67ce8589186",
		  
		  "name": "Harper ",
		  "createdDate": "2023-11-28 22:02:26",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 722,
		  "totalCountries": 10,
		  "totalStates": 33,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 611,
		  "schedulePercent": 0.354374,
		  "totalGuests": 3,
		  "guestPercent": 0.333749,
		  "mostGuestDate": "2025-01-16 00:00:00",
		  "mostGuestName": "The Atlantis",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7964be4f3d32dbf39ddba13f05ed6bc",
		  
		  "name": "Christopher",
		  "createdDate": "2019-08-23 08:24:41",
		  "totalOrganizations": 12,
		  "totalTours": 18,
		  "totalDays": 452,
		  "totalCountries": 22,
		  "totalStates": 27,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 2837,
		  "schedulePercent": 0.826496,
		  "totalGuests": 51,
		  "guestPercent": 0.454329,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "Sidney Myer Music Bowl",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f79c18d34e7bf6fc59be8c42a46a8d02",
		  
		  "name": "Kristina",
		  "createdDate": "2021-06-06 18:43:52",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 87,
		  "totalCountries": 18,
		  "totalStates": 8,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 698,
		  "schedulePercent": 0.385993,
		  "totalGuests": 132,
		  "guestPercent": 0.546124,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "X-tra",
		  "mostGuestCity": "Zurich",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7aba140cf4d99c140dbdd4cee96039b",
		  
		  "name": "Elin",
		  "createdDate": "2019-10-09 11:39:10",
		  "totalOrganizations": 9,
		  "totalTours": 3,
		  "totalDays": 132,
		  "totalCountries": 6,
		  "totalStates": 17,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 659,
		  "schedulePercent": 0.37126,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rden Under Bron",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7abfeef6cbea1be0be69015713c75e0",
		  
		  "name": "Kathrine",
		  "createdDate": "2020-02-25 23:13:28",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 423,
		  "totalCountries": 18,
		  "totalStates": 45,
		  "totalEvents": 121,
		  "eventPercent": 0.6267,
		  "totalScheduleItems": 2203,
		  "schedulePercent": 0.748187,
		  "totalGuests": 913,
		  "guestPercent": 0.832956,
		  "mostGuestDate": "2025-09-18 00:00:00",
		  "mostGuestName": "Jyske Bank BOXEN",
		  "mostGuestCity": "Herning",
		  "mostGuestAmount": 117,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7ac1d83d5a7082eb3c55ccce56c08ca",
		  
		  "name": "Marly",
		  "createdDate": "2022-08-08 17:51:47",
		  "totalOrganizations": 2,
		  "totalTours": 10,
		  "totalDays": 1141,
		  "totalCountries": 25,
		  "totalStates": 49,
		  "totalEvents": 318,
		  "eventPercent": 0.924411,
		  "totalScheduleItems": 5326,
		  "schedulePercent": 0.963282,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7afc668bad7b95a0e3d447c400dac83",
		  
		  "name": "Shana",
		  "createdDate": "2019-12-02 16:47:28",
		  "totalOrganizations": 4,
		  "totalTours": 7,
		  "totalDays": 137,
		  "totalCountries": 25,
		  "totalStates": 32,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 876,
		  "schedulePercent": 0.449683,
		  "totalGuests": 101,
		  "guestPercent": 0.520966,
		  "mostGuestDate": "2025-06-04 00:00:00",
		  "mostGuestName": "Zepp Shinjuku (TOKYO)",
		  "mostGuestCity": "",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7b55b444620a165c5a4f030777a70f1",
		  
		  "name": "Suzanne ",
		  "createdDate": "2022-02-16 18:34:11",
		  "totalOrganizations": 32,
		  "totalTours": 60,
		  "totalDays": 1569,
		  "totalCountries": 23,
		  "totalStates": 93,
		  "totalEvents": 648,
		  "eventPercent": 0.989801,
		  "totalScheduleItems": 6341,
		  "schedulePercent": 0.979828,
		  "totalGuests": 2173,
		  "guestPercent": 0.956709,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Surly Brewing Co.",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7bee6a3987e4c42871b083cc1e3b79d",
		  
		  "name": "Sarah",
		  "createdDate": "2019-05-03 17:01:34",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 1642,
		  "totalCountries": 8,
		  "totalStates": 56,
		  "totalEvents": 418,
		  "eventPercent": 0.963282,
		  "totalScheduleItems": 5943,
		  "schedulePercent": 0.975068,
		  "totalGuests": 1722,
		  "guestPercent": 0.929057,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Eventim Apollo",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 129,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7c9ac44c44543b60b0469df5f632489",
		  
		  "name": "Becca",
		  "createdDate": "2022-07-17 23:58:08",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 1216,
		  "totalCountries": 7,
		  "totalStates": 59,
		  "totalEvents": 177,
		  "eventPercent": 0.75986,
		  "totalScheduleItems": 2567,
		  "schedulePercent": 0.794651,
		  "totalGuests": 557,
		  "guestPercent": 0.74558,
		  "mostGuestDate": "2025-09-08 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7ca5935819b3af312fdc67bbc0c72fa",
		  
		  "name": "Mitchell",
		  "createdDate": "2011-01-25 22:30:57",
		  "totalOrganizations": 16,
		  "totalTours": 17,
		  "totalDays": 1453,
		  "totalCountries": 23,
		  "totalStates": 82,
		  "totalEvents": 309,
		  "eventPercent": 0.918178,
		  "totalScheduleItems": 4630,
		  "schedulePercent": 0.941636,
		  "totalGuests": 1975,
		  "guestPercent": 0.94583,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 124,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7cc2105ba77b0a9a5fc1adef7a02ca6",
		  
		  "name": "Chloe",
		  "createdDate": "2012-02-23 20:45:00",
		  "totalOrganizations": 25,
		  "totalTours": 15,
		  "totalDays": 138,
		  "totalCountries": 27,
		  "totalStates": 26,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 558,
		  "schedulePercent": 0.336582,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7ce719b06f41e3429f1fd3fe66f38db",
		  
		  "name": "Alvaro",
		  "createdDate": "2023-09-12 22:53:28",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 21,
		  "totalCountries": 5,
		  "totalStates": 4,
		  "totalEvents": 15,
		  "eventPercent": 0.114914,
		  "totalScheduleItems": 185,
		  "schedulePercent": 0.150725,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7d1eb54131cfa25b736959f3f078d46",
		  
		  "name": "Yann",
		  "createdDate": "2017-10-15 15:44:11",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 50,
		  "totalCountries": 5,
		  "totalStates": 12,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 181,
		  "schedulePercent": 0.147212,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Bohemian National Cemetary",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 27,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7d3d53f5d47006a3d6f71a22be59ed6",
		  
		  "name": "Corey",
		  "createdDate": "2025-06-26 02:44:59",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 84,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7dfd2bf5412a4a2216074cc1d1ff71c",
		  
		  "name": "Bree",
		  "createdDate": "2019-08-29 09:08:28",
		  "totalOrganizations": 5,
		  "totalTours": 14,
		  "totalDays": 923,
		  "totalCountries": 29,
		  "totalStates": 61,
		  "totalEvents": 277,
		  "eventPercent": 0.896079,
		  "totalScheduleItems": 5542,
		  "schedulePercent": 0.968382,
		  "totalGuests": 623,
		  "guestPercent": 0.763826,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7e4f6ba43c1b09e0863a55314450822",
		  
		  "name": "QC",
		  "createdDate": "2024-08-28 16:08:11",
		  "totalOrganizations": 14,
		  "totalTours": 15,
		  "totalDays": 4758,
		  "totalCountries": 24,
		  "totalStates": 46,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 473,
		  "schedulePercent": 0.299637,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7e4f9ac5ff01a40bf07f4c01f6af718",
		  
		  "name": "Ilijah",
		  "createdDate": "2016-10-08 19:00:05",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 20,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 16,
		  "eventPercent": 0.122167,
		  "totalScheduleItems": 146,
		  "schedulePercent": 0.128173,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7f570699b81ed940dec99f0b123030e",
		  
		  "name": "Andrew",
		  "createdDate": "2025-03-10 19:22:43",
		  "totalOrganizations": 4,
		  "totalTours": 8,
		  "totalDays": 198,
		  "totalCountries": 12,
		  "totalStates": 54,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 1304,
		  "schedulePercent": 0.57219,
		  "totalGuests": 549,
		  "guestPercent": 0.74388,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Fox Theater",
		  "mostGuestCity": "Oakland",
		  "mostGuestAmount": 79,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f7fa0d48b4d0f29369e93091407c7bc4",
		  
		  "name": "Chris",
		  "createdDate": "2015-11-03 21:02:44",
		  "totalOrganizations": 17,
		  "totalTours": 17,
		  "totalDays": 819,
		  "totalCountries": 33,
		  "totalStates": 77,
		  "totalEvents": 267,
		  "eventPercent": 0.888033,
		  "totalScheduleItems": 3272,
		  "schedulePercent": 0.86616,
		  "totalGuests": 717,
		  "guestPercent": 0.789665,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "The Salt Shed",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8027a951663af02be73d9f15282a3a4",
		  
		  "name": "Mollis",
		  "createdDate": "2025-01-27 17:37:28",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 60,
		  "totalCountries": 4,
		  "totalStates": 5,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 490,
		  "schedulePercent": 0.307344,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f80ee1030baf1c002dc06b0d5ab8bea6",
		  
		  "name": "Igz",
		  "createdDate": "2025-05-21 20:54:22",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 521,
		  "totalCountries": 6,
		  "totalStates": 35,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1583,
		  "schedulePercent": 0.637126,
		  "totalGuests": 622,
		  "guestPercent": 0.763713,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Miami Beach Bandshell",
		  "mostGuestCity": "Miami Beach",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8107a1a4a938709290a0ae807880a00",
		  
		  "name": "Will",
		  "createdDate": "2015-07-23 14:11:13",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 579,
		  "totalCountries": 7,
		  "totalStates": 62,
		  "totalEvents": 350,
		  "eventPercent": 0.942316,
		  "totalScheduleItems": 5050,
		  "schedulePercent": 0.955576,
		  "totalGuests": 908,
		  "guestPercent": 0.831709,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Mayo Performing Arts Center",
		  "mostGuestCity": "Morristown",
		  "mostGuestAmount": 37,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8221b71982573ec49087c7b12751eb9",
		  
		  "name": "ERIC",
		  "createdDate": "2021-07-09 19:16:07",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 633,
		  "totalCountries": 14,
		  "totalStates": 42,
		  "totalEvents": 133,
		  "eventPercent": 0.661378,
		  "totalScheduleItems": 1675,
		  "schedulePercent": 0.653898,
		  "totalGuests": 119,
		  "guestPercent": 0.535925,
		  "mostGuestDate": "2025-10-18 00:00:00",
		  "mostGuestName": "Downtown Las Vegas Events Center",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f82a33525976c2539083180e4ac37b91",
		  
		  "name": "Brandon",
		  "createdDate": "2024-04-21 20:26:20",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 13,
		  "totalStates": 57,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2309,
		  "schedulePercent": 0.763033,
		  "totalGuests": 1592,
		  "guestPercent": 0.918631,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f83be48070332bcd2fecdae846065961",
		  
		  "name": "Signe",
		  "createdDate": "2023-06-02 13:52:43",
		  "totalOrganizations": 15,
		  "totalTours": 7,
		  "totalDays": 161,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 149,
		  "eventPercent": 0.702176,
		  "totalScheduleItems": 897,
		  "schedulePercent": 0.457162,
		  "totalGuests": 73,
		  "guestPercent": 0.488781,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Vega",
		  "mostGuestCity": "Copenhagen",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f849ece22d34baee90f948619f3539a6",
		  
		  "name": "David",
		  "createdDate": "2014-10-09 20:41:55",
		  "totalOrganizations": 29,
		  "totalTours": 3,
		  "totalDays": 111,
		  "totalCountries": 7,
		  "totalStates": 28,
		  "totalEvents": 31,
		  "eventPercent": 0.220762,
		  "totalScheduleItems": 250,
		  "schedulePercent": 0.189937,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f84f7d2c1652f1e60f0bdea3442d4c2c",
		  
		  "name": "Emmyn",
		  "createdDate": "2022-05-31 23:41:59",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 31,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 154,
		  "schedulePercent": 0.132026,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f85aa0f7e41e8493b8ce3213eebc3834",
		  
		  "name": "Brandon",
		  "createdDate": "2013-08-01 02:49:31",
		  "totalOrganizations": 5,
		  "totalTours": 9,
		  "totalDays": 210,
		  "totalCountries": 5,
		  "totalStates": 28,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1071,
		  "schedulePercent": 0.511106,
		  "totalGuests": 235,
		  "guestPercent": 0.616047,
		  "mostGuestDate": "2025-11-02 00:00:00",
		  "mostGuestName": "The lot at creekside",
		  "mostGuestCity": "San Jose",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f85f9dc10433f7ea3573dabe0a3e8ae8",
		  
		  "name": "Paul",
		  "createdDate": "2022-08-22 05:38:41",
		  "totalOrganizations": 7,
		  "totalTours": 8,
		  "totalDays": 1042,
		  "totalCountries": 6,
		  "totalStates": 36,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 737,
		  "schedulePercent": 0.400272,
		  "totalGuests": 49,
		  "guestPercent": 0.450816,
		  "mostGuestDate": "2025-08-08 00:00:00",
		  "mostGuestName": "Public Works",
		  "mostGuestCity": "San Francisco",
		  "mostGuestAmount": 39,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f865ab5f15cc0f90863730efc66e63c1",
		  
		  "name": "Anthony",
		  "createdDate": "2014-11-06 20:15:47",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 36,
		  "totalCountries": 2,
		  "totalStates": 23,
		  "totalEvents": 27,
		  "eventPercent": 0.19549,
		  "totalScheduleItems": 325,
		  "schedulePercent": 0.229034,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f86cfd0b032f68fef1a47fc82670192f",
		  
		  "name": "Carlota",
		  "createdDate": "2025-05-19 23:06:53",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 44,
		  "totalCountries": 3,
		  "totalStates": 6,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 135,
		  "schedulePercent": 0.121827,
		  "totalGuests": 191,
		  "guestPercent": 0.586582,
		  "mostGuestDate": "2025-06-04 00:00:00",
		  "mostGuestName": "Palau Sant Jordi",
		  "mostGuestCity": "Barcelona",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f86fc3f7c79d63274fcd9ac3650755cc",
		  
		  "name": "Sophie",
		  "createdDate": "2017-10-06 21:10:01",
		  "totalOrganizations": 34,
		  "totalTours": 12,
		  "totalDays": 559,
		  "totalCountries": 13,
		  "totalStates": 29,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 2786,
		  "schedulePercent": 0.820376,
		  "totalGuests": 349,
		  "guestPercent": 0.674637,
		  "mostGuestDate": "2025-03-28 00:00:00",
		  "mostGuestName": "Roundhouse",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f86fec5e0e4581e0b22d281d866e8c18",
		  
		  "name": "Roni",
		  "createdDate": "2016-05-11 13:56:35",
		  "totalOrganizations": 4,
		  "totalTours": 11,
		  "totalDays": 419,
		  "totalCountries": 26,
		  "totalStates": 42,
		  "totalEvents": 138,
		  "eventPercent": 0.675204,
		  "totalScheduleItems": 1777,
		  "schedulePercent": 0.672031,
		  "totalGuests": 723,
		  "guestPercent": 0.791138,
		  "mostGuestDate": "2025-05-28 00:00:00",
		  "mostGuestName": "Alexandra Palace",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f876d5a879b2e58ab00a670899345b71",
		  
		  "name": "Tina Tour",
		  "createdDate": "2024-07-31 16:35:02",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 688,
		  "totalCountries": 4,
		  "totalStates": 50,
		  "totalEvents": 502,
		  "eventPercent": 0.979034,
		  "totalScheduleItems": 4020,
		  "schedulePercent": 0.914551,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f877073d0ad9bc42019cc1d3c7bd7ce1",
		  
		  "name": "Kurt",
		  "createdDate": "2014-03-18 00:33:43",
		  "totalOrganizations": 55,
		  "totalTours": 11,
		  "totalDays": 1278,
		  "totalCountries": 18,
		  "totalStates": 48,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 4018,
		  "schedulePercent": 0.914211,
		  "totalGuests": 294,
		  "guestPercent": 0.646532,
		  "mostGuestDate": "2025-06-10 00:00:00",
		  "mostGuestName": "Empower Field at Mile High",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 34,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f87b84e4f35fdad2a37fc17d8f195bcf",
		  
		  "name": "Joel",
		  "createdDate": "2017-06-13 04:46:59",
		  "totalOrganizations": 22,
		  "totalTours": 4,
		  "totalDays": 125,
		  "totalCountries": 17,
		  "totalStates": 45,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1162,
		  "schedulePercent": 0.538531,
		  "totalGuests": 854,
		  "guestPercent": 0.82049,
		  "mostGuestDate": "2025-01-30 00:00:00",
		  "mostGuestName": "Electric Brixton",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f880be42de9f922bd9ce5e7fa97c3d68",
		  
		  "name": "Brock",
		  "createdDate": "2024-04-28 14:46:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 13,
		  "totalStates": 57,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 2309,
		  "schedulePercent": 0.763033,
		  "totalGuests": 1592,
		  "guestPercent": 0.918631,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "The Novo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8834e96e7e386cf54c6ec48829e6f03",
		  
		  "name": "Kristian",
		  "createdDate": "2017-12-20 20:43:45",
		  "totalOrganizations": 9,
		  "totalTours": 8,
		  "totalDays": 480,
		  "totalCountries": 4,
		  "totalStates": 45,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1996,
		  "schedulePercent": 0.713055,
		  "totalGuests": 2619,
		  "guestPercent": 0.972688,
		  "mostGuestDate": "2025-10-03 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f887a241a67b68373983c31b6e231f73",
		  
		  "name": "Rebecca",
		  "createdDate": "2012-07-16 17:39:02",
		  "totalOrganizations": 10,
		  "totalTours": 18,
		  "totalDays": 1817,
		  "totalCountries": 15,
		  "totalStates": 67,
		  "totalEvents": 340,
		  "eventPercent": 0.93665,
		  "totalScheduleItems": 3270,
		  "schedulePercent": 0.86582,
		  "totalGuests": 915,
		  "guestPercent": 0.833296,
		  "mostGuestDate": "2025-09-13 00:00:00",
		  "mostGuestName": "The Van Buren",
		  "mostGuestCity": "Phoenix",
		  "mostGuestAmount": 81,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f88ba608e6e780c06137d081be206426",
		  
		  "name": "JJ",
		  "createdDate": "2019-04-22 16:28:15",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 78,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 436,
		  "schedulePercent": 0.284338,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f88d7f84d418ea54414ebf20ba464ed7",
		  
		  "name": "Ashley",
		  "createdDate": "2019-01-13 20:49:06",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 269,
		  "totalCountries": 2,
		  "totalStates": 25,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1045,
		  "schedulePercent": 0.502493,
		  "totalGuests": 104,
		  "guestPercent": 0.523572,
		  "mostGuestDate": "2025-05-20 00:00:00",
		  "mostGuestName": "The Birchmere",
		  "mostGuestCity": "Alexandria",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f891e31f942b9092c1f559779e0cee90",
		  
		  "name": "Fritz",
		  "createdDate": "2024-07-09 13:24:11",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 373,
		  "schedulePercent": 0.254646,
		  "totalGuests": 252,
		  "guestPercent": 0.626247,
		  "mostGuestDate": "2025-03-08 00:00:00",
		  "mostGuestName": "Olympiahalle",
		  "mostGuestCity": "MÃ¼nchen",
		  "mostGuestAmount": 53,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f895048f4061b5822a6ba516de1d2f45",
		  
		  "name": "TDC",
		  "createdDate": "2024-10-22 16:27:18",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 39,
		  "totalCountries": 6,
		  "totalStates": 9,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 319,
		  "schedulePercent": 0.226541,
		  "totalGuests": 247,
		  "guestPercent": 0.623753,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Crane",
		  "mostGuestCity": "Bristol",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8ac5de114d056a3b8c682f25e21cbb7",
		  
		  "name": "CHENEY",
		  "createdDate": "2020-12-12 18:11:05",
		  "totalOrganizations": 6,
		  "totalTours": 11,
		  "totalDays": 546,
		  "totalCountries": 12,
		  "totalStates": 56,
		  "totalEvents": 224,
		  "eventPercent": 0.838735,
		  "totalScheduleItems": 4144,
		  "schedulePercent": 0.921691,
		  "totalGuests": 2681,
		  "guestPercent": 0.975295,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 97,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8ae8bdb8ebcf9e586f3f7e2c242db29",
		  
		  "name": "Sarah",
		  "createdDate": "2019-03-12 09:40:20",
		  "totalOrganizations": 24,
		  "totalTours": 66,
		  "totalDays": 1057,
		  "totalCountries": 28,
		  "totalStates": 75,
		  "totalEvents": 336,
		  "eventPercent": 0.93563,
		  "totalScheduleItems": 4176,
		  "schedulePercent": 0.924524,
		  "totalGuests": 473,
		  "guestPercent": 0.721668,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8c350bcbf05863d5d7cde7e344e1edb",
		  
		  "name": "Martin",
		  "createdDate": "2010-01-07 21:38:43",
		  "totalOrganizations": 26,
		  "totalTours": 9,
		  "totalDays": 449,
		  "totalCountries": 23,
		  "totalStates": 50,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 2770,
		  "schedulePercent": 0.818223,
		  "totalGuests": 454,
		  "guestPercent": 0.714302,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "First Direct Arena",
		  "mostGuestCity": "Leeds",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8d3da7ef21558ce9f83f5c4e3165fb6",
		  
		  "name": "Guido",
		  "createdDate": "2022-11-11 00:01:47",
		  "totalOrganizations": 18,
		  "totalTours": 14,
		  "totalDays": 253,
		  "totalCountries": 18,
		  "totalStates": 27,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 1528,
		  "schedulePercent": 0.622733,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8dbabb9294092a7b07ddb8b1722d51e",
		  
		  "name": "Nadia",
		  "createdDate": "2021-07-15 03:04:11",
		  "totalOrganizations": 7,
		  "totalTours": 19,
		  "totalDays": 666,
		  "totalCountries": 6,
		  "totalStates": 16,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 978,
		  "schedulePercent": 0.484021,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8f0b7fcfc908f213e95d1bc1ce4e9c5",
		  
		  "name": "Devin",
		  "createdDate": "2022-01-14 18:38:23",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 511,
		  "totalCountries": 12,
		  "totalStates": 37,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1507,
		  "schedulePercent": 0.618994,
		  "totalGuests": 431,
		  "guestPercent": 0.706709,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Electric Ballroom",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8f67a040019853af01bebcf6abf1170",
		  
		  "name": "Eve",
		  "createdDate": "2024-04-02 09:56:37",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 24,
		  "totalStates": 32,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 689,
		  "schedulePercent": 0.38214,
		  "totalGuests": 29,
		  "guestPercent": 0.416478,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "Solidays",
		  "mostGuestCity": "Paris",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f8f86c399b0efb8d596a9c2a7ad68796",
		  
		  "name": "Phoneboy",
		  "createdDate": "2022-10-19 00:09:06",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 150,
		  "totalCountries": 3,
		  "totalStates": 43,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1036,
		  "schedulePercent": 0.500567,
		  "totalGuests": 273,
		  "guestPercent": 0.636899,
		  "mostGuestDate": "2025-06-14 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9154105e33eebcd24cbe7cb62c37d8b",
		  
		  "name": "Elizabeth",
		  "createdDate": "2024-08-17 01:51:04",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 127,
		  "totalCountries": 8,
		  "totalStates": 39,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 907,
		  "schedulePercent": 0.460789,
		  "totalGuests": 84,
		  "guestPercent": 0.50034,
		  "mostGuestDate": "2025-04-28 00:00:00",
		  "mostGuestName": "House of Blues Chicago",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f92829befcea7201d79807a887e3b26a",
		  
		  "name": "Henry",
		  "createdDate": "2025-07-22 10:12:02",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 165,
		  "totalCountries": 3,
		  "totalStates": 2,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 505,
		  "schedulePercent": 0.31369,
		  "totalGuests": 145,
		  "guestPercent": 0.555077,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Worcester Cathedral",
		  "mostGuestCity": "Worcester",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9289377e2a05bce630a4935669dd305",
		  
		  "name": "Ella",
		  "createdDate": "2022-11-29 07:08:53",
		  "totalOrganizations": 3,
		  "totalTours": 10,
		  "totalDays": 79,
		  "totalCountries": 4,
		  "totalStates": 8,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 635,
		  "schedulePercent": 0.362647,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9380f04d459c2e25a06f03e7ac49aec",
		  
		  "name": "Finn",
		  "createdDate": "2022-01-07 13:16:13",
		  "totalOrganizations": 28,
		  "totalTours": 13,
		  "totalDays": 570,
		  "totalCountries": 12,
		  "totalStates": 28,
		  "totalEvents": 145,
		  "eventPercent": 0.69413,
		  "totalScheduleItems": 1647,
		  "schedulePercent": 0.649705,
		  "totalGuests": 288,
		  "guestPercent": 0.643246,
		  "mostGuestDate": "2025-05-27 00:00:00",
		  "mostGuestName": "The Echo",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 68,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f93a9a2e551509eeaf19dd6ee8b94548",
		  
		  "name": "Heather ",
		  "createdDate": "2023-01-20 22:45:01",
		  "totalOrganizations": 15,
		  "totalTours": 18,
		  "totalDays": 777,
		  "totalCountries": 15,
		  "totalStates": 43,
		  "totalEvents": 214,
		  "eventPercent": 0.823549,
		  "totalScheduleItems": 4706,
		  "schedulePercent": 0.94447,
		  "totalGuests": 1495,
		  "guestPercent": 0.908658,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 90,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f93f707c4244e22a314f8ba499d3d59b",
		  
		  "name": "moomba",
		  "createdDate": "2024-04-09 10:51:19",
		  "totalOrganizations": 6,
		  "totalTours": 35,
		  "totalDays": 337,
		  "totalCountries": 27,
		  "totalStates": 37,
		  "totalEvents": 179,
		  "eventPercent": 0.763486,
		  "totalScheduleItems": 2567,
		  "schedulePercent": 0.794651,
		  "totalGuests": 116,
		  "guestPercent": 0.533545,
		  "mostGuestDate": "2025-04-20 00:00:00",
		  "mostGuestName": "Etihad Park",
		  "mostGuestCity": "Abu Dhabi",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9494142f224af898d94da3ea343e49d",
		  
		  "name": "Monica",
		  "createdDate": "2025-04-03 15:16:59",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 99,
		  "totalCountries": 3,
		  "totalStates": 22,
		  "totalEvents": 28,
		  "eventPercent": 0.202516,
		  "totalScheduleItems": 462,
		  "schedulePercent": 0.296011,
		  "totalGuests": 921,
		  "guestPercent": 0.834429,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 82,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f94a9f8ee36b5dba13c8bc227b2b1857",
		  
		  "name": "Company",
		  "createdDate": "2023-09-20 00:30:09",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 154,
		  "totalCountries": 3,
		  "totalStates": 15,
		  "totalEvents": 136,
		  "eventPercent": 0.668858,
		  "totalScheduleItems": 1352,
		  "schedulePercent": 0.585449,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9502d40715159d7a43a2e232f750496",
		  
		  "name": "Andrew",
		  "createdDate": "2021-08-27 15:50:44",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 965,
		  "totalCountries": 6,
		  "totalStates": 52,
		  "totalEvents": 194,
		  "eventPercent": 0.789551,
		  "totalScheduleItems": 2561,
		  "schedulePercent": 0.794084,
		  "totalGuests": 1242,
		  "guestPercent": 0.87976,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f954a262e1479bce7d662eb791cc6b35",
		  
		  "name": "Pepe",
		  "createdDate": "2023-04-03 18:34:48",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 181,
		  "totalCountries": 5,
		  "totalStates": 6,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 132,
		  "schedulePercent": 0.119674,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f962a60408a4d328eb5d73f4a6dd22b4",
		  
		  "name": "Tina",
		  "createdDate": "2024-04-30 22:59:00",
		  "totalOrganizations": 6,
		  "totalTours": 8,
		  "totalDays": 297,
		  "totalCountries": 22,
		  "totalStates": 52,
		  "totalEvents": 135,
		  "eventPercent": 0.665231,
		  "totalScheduleItems": 1399,
		  "schedulePercent": 0.597575,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f97613945e3640a8e88752707d998f39",
		  
		  "name": "John",
		  "createdDate": "2019-05-29 01:57:23",
		  "totalOrganizations": 7,
		  "totalTours": 16,
		  "totalDays": 177,
		  "totalCountries": 17,
		  "totalStates": 41,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 641,
		  "schedulePercent": 0.364687,
		  "totalGuests": 79,
		  "guestPercent": 0.496147,
		  "mostGuestDate": "2025-07-13 00:00:00",
		  "mostGuestName": "Regent Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f97698001712a792742c1ca9b36e6def",
		  
		  "name": "Max",
		  "createdDate": "2023-05-22 10:13:56",
		  "totalOrganizations": 6,
		  "totalTours": 16,
		  "totalDays": 381,
		  "totalCountries": 29,
		  "totalStates": 85,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 2354,
		  "schedulePercent": 0.769152,
		  "totalGuests": 362,
		  "guestPercent": 0.67883,
		  "mostGuestDate": "2025-04-19 00:00:00",
		  "mostGuestName": "The Belasco Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 96,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f97c45a40120bc981877f26d289f9a17",
		  
		  "name": "Isaac",
		  "createdDate": "2023-08-01 15:55:01",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 65,
		  "totalCountries": 2,
		  "totalStates": 30,
		  "totalEvents": 32,
		  "eventPercent": 0.226541,
		  "totalScheduleItems": 183,
		  "schedulePercent": 0.149252,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Public Records",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 43,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f98d930afd5fdf8ee37d71ffeb439658",
		  
		  "name": "Brett",
		  "createdDate": "2012-10-02 06:46:31",
		  "totalOrganizations": 16,
		  "totalTours": 17,
		  "totalDays": 412,
		  "totalCountries": 17,
		  "totalStates": 38,
		  "totalEvents": 210,
		  "eventPercent": 0.817656,
		  "totalScheduleItems": 2205,
		  "schedulePercent": 0.74864,
		  "totalGuests": 265,
		  "guestPercent": 0.631686,
		  "mostGuestDate": "2025-07-18 00:00:00",
		  "mostGuestName": "Somerset House",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f998cb1138f3348d0c515acd634fb71f",
		  
		  "name": "Grant",
		  "createdDate": "2015-09-23 00:21:41",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 96,
		  "totalCountries": 10,
		  "totalStates": 14,
		  "totalEvents": 43,
		  "eventPercent": 0.287398,
		  "totalScheduleItems": 214,
		  "schedulePercent": 0.168631,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f99f5e56bbb23ad32125133eb394bbe5",
		  
		  "name": "Steve",
		  "createdDate": "2014-09-11 10:23:24",
		  "totalOrganizations": 61,
		  "totalTours": 5,
		  "totalDays": 353,
		  "totalCountries": 15,
		  "totalStates": 15,
		  "totalEvents": 58,
		  "eventPercent": 0.362307,
		  "totalScheduleItems": 1869,
		  "schedulePercent": 0.68903,
		  "totalGuests": 683,
		  "guestPercent": 0.781845,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 99,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9abf59666af47523add72197f512bd0",
		  
		  "name": "Greta",
		  "createdDate": "2025-04-11 15:53:02",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 25,
		  "totalCountries": 4,
		  "totalStates": 4,
		  "totalEvents": 18,
		  "eventPercent": 0.136219,
		  "totalScheduleItems": 167,
		  "schedulePercent": 0.138939,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9ae40652b7d243024deb766f64d32aa",
		  
		  "name": "Nicholas",
		  "createdDate": "2025-02-11 18:07:24",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 323,
		  "totalCountries": 2,
		  "totalStates": 2,
		  "totalEvents": 7,
		  "eventPercent": 0.056097,
		  "totalScheduleItems": 386,
		  "schedulePercent": 0.261673,
		  "totalGuests": 71,
		  "guestPercent": 0.486174,
		  "mostGuestDate": "2025-04-24 00:00:00",
		  "mostGuestName": "National Museum of African American Music ",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 71,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9ba7d9146101cdfcbf0a94a45ec49ef",
		  
		  "name": "Brodie",
		  "createdDate": "2023-08-23 17:47:41",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 480,
		  "totalCountries": 4,
		  "totalStates": 40,
		  "totalEvents": 103,
		  "eventPercent": 0.563577,
		  "totalScheduleItems": 1282,
		  "schedulePercent": 0.567996,
		  "totalGuests": 57,
		  "guestPercent": 0.463395,
		  "mostGuestDate": "2025-05-22 00:00:00",
		  "mostGuestName": "Waywards at The Bank",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9c8dc42f3891bcaa6647cf0b622f685",
		  
		  "name": "Justine",
		  "createdDate": "2022-09-26 17:55:11",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 393,
		  "totalCountries": 29,
		  "totalStates": 76,
		  "totalEvents": 205,
		  "eventPercent": 0.809157,
		  "totalScheduleItems": 2665,
		  "schedulePercent": 0.804397,
		  "totalGuests": 1200,
		  "guestPercent": 0.87602,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9d6b9b0f51f10fec66c08b14097254a",
		  
		  "name": "Ryan",
		  "createdDate": "2018-08-01 04:01:17",
		  "totalOrganizations": 8,
		  "totalTours": 2,
		  "totalDays": 122,
		  "totalCountries": 3,
		  "totalStates": 36,
		  "totalEvents": 81,
		  "eventPercent": 0.475181,
		  "totalScheduleItems": 1253,
		  "schedulePercent": 0.561197,
		  "totalGuests": 1050,
		  "guestPercent": 0.854261,
		  "mostGuestDate": "2025-07-11 00:00:00",
		  "mostGuestName": "Ascend Amphitheater",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 160,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9d74d598ed2367b9dd71405f9fb8590",
		  
		  "name": "Tony",
		  "createdDate": "2018-06-29 00:57:47",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 93,
		  "totalCountries": 18,
		  "totalStates": 28,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 896,
		  "schedulePercent": 0.456596,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9f0a8fa0761ea6caf0f0793da77f334",
		  
		  "name": "Jordan",
		  "createdDate": "2023-11-21 19:30:32",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 107,
		  "totalCountries": 8,
		  "totalStates": 29,
		  "totalEvents": 61,
		  "eventPercent": 0.38078,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 24,
		  "guestPercent": 0.406505,
		  "mostGuestDate": "2025-07-24 00:00:00",
		  "mostGuestName": "Scala",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 18,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9f2323770f6e7ea25d6242f2aacbc09",
		  
		  "name": "David",
		  "createdDate": "2013-10-02 11:54:17",
		  "totalOrganizations": 3,
		  "totalTours": 16,
		  "totalDays": 367,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 2743,
		  "schedulePercent": 0.815616,
		  "totalGuests": 1506,
		  "guestPercent": 0.909678,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9fcdfdd30b79dac57b8c5a43ab1d66e",
		  
		  "name": "Karen",
		  "createdDate": "2017-02-23 20:30:06",
		  "totalOrganizations": 12,
		  "totalTours": 12,
		  "totalDays": 645,
		  "totalCountries": 14,
		  "totalStates": 14,
		  "totalEvents": 125,
		  "eventPercent": 0.638939,
		  "totalScheduleItems": 2092,
		  "schedulePercent": 0.730961,
		  "totalGuests": 165,
		  "guestPercent": 0.56947,
		  "mostGuestDate": "2025-04-13 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "f9fda6243a4198dd6fc8c1497daca8e3",
		  
		  "name": "Dustin",
		  "createdDate": "2012-03-21 03:06:27",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 1030,
		  "totalCountries": 5,
		  "totalStates": 41,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 3783,
		  "schedulePercent": 0.901292,
		  "totalGuests": 421,
		  "guestPercent": 0.702969,
		  "mostGuestDate": "2025-03-11 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa00ba5a42f3115d513b614144965c42",
		  
		  "name": "Didier",
		  "createdDate": "2022-02-26 17:53:55",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 519,
		  "totalCountries": 12,
		  "totalStates": 21,
		  "totalEvents": 90,
		  "eventPercent": 0.511333,
		  "totalScheduleItems": 1198,
		  "schedulePercent": 0.547031,
		  "totalGuests": 443,
		  "guestPercent": 0.710109,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Zenith Nantes Metropole",
		  "mostGuestCity": "St Herblain",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa0390ddd2b35dc60e1481f96c06c524",
		  
		  "name": "ANNA",
		  "createdDate": "2022-11-23 02:59:31",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 577,
		  "totalCountries": 17,
		  "totalStates": 12,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 498,
		  "schedulePercent": 0.31131,
		  "totalGuests": 92,
		  "guestPercent": 0.510426,
		  "mostGuestDate": "2025-05-30 00:00:00",
		  "mostGuestName": "Arena Opus",
		  "mostGuestCity": "SÃ£o JosÃ©",
		  "mostGuestAmount": 54,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa19189d4ca9c0c0e8ba52b1199bfc35",
		  
		  "name": "Cyndi",
		  "createdDate": "2024-06-10 17:36:30",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 304,
		  "totalCountries": 8,
		  "totalStates": 42,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 3047,
		  "schedulePercent": 0.846895,
		  "totalGuests": 1952,
		  "guestPercent": 0.942883,
		  "mostGuestDate": "2025-09-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 60,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa1b2f13a2acf6478e671a73d617651a",
		  
		  "name": "Naavin",
		  "createdDate": "2022-03-27 22:40:13",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 46,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 40,
		  "eventPercent": 0.273119,
		  "totalScheduleItems": 369,
		  "schedulePercent": 0.252946,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa211fe78a1a3c12dada02e124a57671",
		  
		  "name": "MaryKate",
		  "createdDate": "2025-09-19 22:42:54",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 45,
		  "totalCountries": 1,
		  "totalStates": 20,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 359,
		  "schedulePercent": 0.24762,
		  "totalGuests": 127,
		  "guestPercent": 0.542044,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa26e278937c0d874e99656e9c23f4dd",
		  
		  "name": "Madison",
		  "createdDate": "2020-03-07 20:42:22",
		  "totalOrganizations": 3,
		  "totalTours": 1,
		  "totalDays": 23,
		  "totalCountries": 1,
		  "totalStates": 1,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 230,
		  "schedulePercent": 0.177697,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa2747342cc17f5033125d29b36989cd",
		  
		  "name": "Julia",
		  "createdDate": "2025-03-20 01:00:57",
		  "totalOrganizations": 1,
		  "totalTours": 6,
		  "totalDays": 133,
		  "totalCountries": 19,
		  "totalStates": 44,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 75,
		  "guestPercent": 0.49184,
		  "mostGuestDate": "2025-08-12 00:00:00",
		  "mostGuestName": "Gebr. de Nobel",
		  "mostGuestCity": "Leiden",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa2937bf83beaaeaf0aa090ab27f60f0",
		  
		  "name": "Pamela",
		  "createdDate": "2017-02-26 13:12:00",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 195,
		  "totalCountries": 10,
		  "totalStates": 12,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 861,
		  "schedulePercent": 0.44515,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa2c479de95a6ab5a42860c0f8c8379e",
		  
		  "name": "Allan",
		  "createdDate": "2014-06-25 13:55:31",
		  "totalOrganizations": 14,
		  "totalTours": 3,
		  "totalDays": 433,
		  "totalCountries": 25,
		  "totalStates": 10,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 732,
		  "schedulePercent": 0.399139,
		  "totalGuests": 78,
		  "guestPercent": 0.495014,
		  "mostGuestDate": "2025-01-16 00:00:00",
		  "mostGuestName": "Fremantle Prison",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa2df4c9b98d84abfbff2c1717887645",
		  
		  "name": "Earl",
		  "createdDate": "2011-12-24 21:36:06",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 139,
		  "totalCountries": 4,
		  "totalStates": 41,
		  "totalEvents": 82,
		  "eventPercent": 0.480621,
		  "totalScheduleItems": 1481,
		  "schedulePercent": 0.612987,
		  "totalGuests": 2526,
		  "guestPercent": 0.969402,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa30a43110cc26713f2a0fafceff4da3",
		  
		  "name": "Dalal",
		  "createdDate": "2022-02-22 09:12:05",
		  "totalOrganizations": 39,
		  "totalTours": 32,
		  "totalDays": 950,
		  "totalCountries": 38,
		  "totalStates": 77,
		  "totalEvents": 232,
		  "eventPercent": 0.850408,
		  "totalScheduleItems": 2964,
		  "schedulePercent": 0.838622,
		  "totalGuests": 251,
		  "guestPercent": 0.625567,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Lincoln Hall",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa40b8438a2ddf0d109d4379f371a5fb",
		  
		  "name": "Patchwork ",
		  "createdDate": "2018-08-02 14:37:24",
		  "totalOrganizations": 47,
		  "totalTours": 34,
		  "totalDays": 1409,
		  "totalCountries": 40,
		  "totalStates": 98,
		  "totalEvents": 451,
		  "eventPercent": 0.971215,
		  "totalScheduleItems": 6948,
		  "schedulePercent": 0.986174,
		  "totalGuests": 1955,
		  "guestPercent": 0.943903,
		  "mostGuestDate": "2025-04-21 00:00:00",
		  "mostGuestName": "Co-op Live",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa47f3ee2942726dc9a51cf07de88ba6",
		  
		  "name": "Tuyet",
		  "createdDate": "2014-04-04 20:39:09",
		  "totalOrganizations": 13,
		  "totalTours": 19,
		  "totalDays": 795,
		  "totalCountries": 12,
		  "totalStates": 59,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 3559,
		  "schedulePercent": 0.885539,
		  "totalGuests": 1444,
		  "guestPercent": 0.904125,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa4b3b9c6c21e5035992d57c0bea3293",
		  
		  "name": "Gustaf",
		  "createdDate": "2025-03-06 09:42:20",
		  "totalOrganizations": 12,
		  "totalTours": 14,
		  "totalDays": 67,
		  "totalCountries": 5,
		  "totalStates": 1,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 264,
		  "schedulePercent": 0.196396,
		  "totalGuests": 81,
		  "guestPercent": 0.498187,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa546367306bd1044e64dc240f6d3f7a",
		  
		  "name": "Victor",
		  "createdDate": "2025-04-02 02:46:59",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 74,
		  "totalCountries": 3,
		  "totalStates": 17,
		  "totalEvents": 62,
		  "eventPercent": 0.385766,
		  "totalScheduleItems": 1563,
		  "schedulePercent": 0.63316,
		  "totalGuests": 1051,
		  "guestPercent": 0.854374,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 140,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa657ad4a00d5d259359aae531d4dd33",
		  
		  "name": "Graham ",
		  "createdDate": "2023-06-12 15:52:09",
		  "totalOrganizations": 4,
		  "totalTours": 13,
		  "totalDays": 458,
		  "totalCountries": 26,
		  "totalStates": 41,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 1421,
		  "schedulePercent": 0.602335,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa757c619855eecb88de32b8cf8a6de7",
		  
		  "name": "Karen",
		  "createdDate": "2024-11-20 01:58:30",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 139,
		  "totalCountries": 2,
		  "totalStates": 7,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 744,
		  "schedulePercent": 0.403105,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa823474d930a428ad87a0cab01a9cec",
		  
		  "name": "Haley",
		  "createdDate": "2022-02-03 16:12:52",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 236,
		  "totalCountries": 23,
		  "totalStates": 61,
		  "totalEvents": 124,
		  "eventPercent": 0.635993,
		  "totalScheduleItems": 2048,
		  "schedulePercent": 0.722801,
		  "totalGuests": 1701,
		  "guestPercent": 0.92815,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Deer Lake Park",
		  "mostGuestCity": "Burnaby",
		  "mostGuestAmount": 234,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa933b1a95daf1eb2d8a6f1e06a1feca",
		  
		  "name": "Chris",
		  "createdDate": "2012-03-28 20:10:07",
		  "totalOrganizations": 6,
		  "totalTours": 3,
		  "totalDays": 182,
		  "totalCountries": 10,
		  "totalStates": 20,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 805,
		  "schedulePercent": 0.424524,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fa9780b6e4f887c7d9430732877da3f5",
		  
		  "name": "Bradley",
		  "createdDate": "2022-09-22 13:59:22",
		  "totalOrganizations": 15,
		  "totalTours": 6,
		  "totalDays": 163,
		  "totalCountries": 9,
		  "totalStates": 8,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 231,
		  "schedulePercent": 0.178377,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-07-25 00:00:00",
		  "mostGuestName": "Truck Festival",
		  "mostGuestCity": "Steventon",
		  "mostGuestAmount": 3,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "faa2447ca9bd0990f9d41233bb354b3e",
		  
		  "name": "Nathan",
		  "createdDate": "2024-08-01 14:47:55",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 81,
		  "totalCountries": 16,
		  "totalStates": 28,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 617,
		  "schedulePercent": 0.356301,
		  "totalGuests": 213,
		  "guestPercent": 0.604261,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "O2 Ritz Manchester",
		  "mostGuestCity": "Manchester",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "faa6f67dfca996be7af5fbac3f269208",
		  
		  "name": "Julie",
		  "createdDate": "2018-11-14 20:09:28",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 258,
		  "totalCountries": 28,
		  "totalStates": 33,
		  "totalEvents": 108,
		  "eventPercent": 0.582729,
		  "totalScheduleItems": 1166,
		  "schedulePercent": 0.539325,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "faaed3e13137d2792579d7c84ed51778",
		  
		  "name": "Simon",
		  "createdDate": "2018-06-06 19:17:47",
		  "totalOrganizations": 13,
		  "totalTours": 33,
		  "totalDays": 350,
		  "totalCountries": 30,
		  "totalStates": 72,
		  "totalEvents": 187,
		  "eventPercent": 0.776405,
		  "totalScheduleItems": 3030,
		  "schedulePercent": 0.844855,
		  "totalGuests": 1248,
		  "guestPercent": 0.880326,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "Royal Albert Hall",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 89,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fab0f4a9ca6cd8a649f5c78bb1607b00",
		  
		  "name": "Ben",
		  "createdDate": "2017-03-15 20:47:11",
		  "totalOrganizations": 12,
		  "totalTours": 19,
		  "totalDays": 471,
		  "totalCountries": 23,
		  "totalStates": 60,
		  "totalEvents": 216,
		  "eventPercent": 0.826836,
		  "totalScheduleItems": 3172,
		  "schedulePercent": 0.857548,
		  "totalGuests": 263,
		  "guestPercent": 0.63078,
		  "mostGuestDate": "2025-01-22 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fabd5f1fbf8d1ebe45f162bf2bde8517",
		  
		  "name": "Jon",
		  "createdDate": "2017-04-13 20:51:17",
		  "totalOrganizations": 18,
		  "totalTours": 15,
		  "totalDays": 847,
		  "totalCountries": 23,
		  "totalStates": 56,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 1706,
		  "schedulePercent": 0.659451,
		  "totalGuests": 197,
		  "guestPercent": 0.592362,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "Koko",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fabddede98bbb2591d3890e0c1d35194",
		  
		  "name": "Mariana",
		  "createdDate": "2025-08-04 22:41:26",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 124,
		  "totalCountries": 3,
		  "totalStates": 32,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 635,
		  "schedulePercent": 0.362647,
		  "totalGuests": 7,
		  "guestPercent": 0.360041,
		  "mostGuestDate": "2025-09-20 00:00:00",
		  "mostGuestName": "Cain's Ballroom",
		  "mostGuestCity": "Tulsa",
		  "mostGuestAmount": 5,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fac17f0830befcded6953420df7518ae",
		  
		  "name": "Stephanie",
		  "createdDate": "2019-02-07 15:50:43",
		  "totalOrganizations": 8,
		  "totalTours": 31,
		  "totalDays": 805,
		  "totalCountries": 28,
		  "totalStates": 53,
		  "totalEvents": 218,
		  "eventPercent": 0.830349,
		  "totalScheduleItems": 1740,
		  "schedulePercent": 0.665571,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-02-28 00:00:00",
		  "mostGuestName": "Thomas Jefferson Library of Congress",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fad0c90feb419bfc4eb1742fa2d03ff0",
		  
		  "name": "Esteban",
		  "createdDate": "2024-12-11 08:22:39",
		  "totalOrganizations": 5,
		  "totalTours": 5,
		  "totalDays": 236,
		  "totalCountries": 15,
		  "totalStates": 47,
		  "totalEvents": 59,
		  "eventPercent": 0.368427,
		  "totalScheduleItems": 872,
		  "schedulePercent": 0.449229,
		  "totalGuests": 5,
		  "guestPercent": 0.348595,
		  "mostGuestDate": "2025-01-23 00:00:00",
		  "mostGuestName": "Palau Alameda - Music Resort",
		  "mostGuestCity": "ValÃ¨ncia",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fad1d654850198e17bec7340c615fd65",
		  
		  "name": "Tori",
		  "createdDate": "2022-05-02 17:43:57",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 608,
		  "totalCountries": 4,
		  "totalStates": 52,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 1799,
		  "schedulePercent": 0.675884,
		  "totalGuests": 1131,
		  "guestPercent": 0.868767,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Riverfront Park",
		  "mostGuestCity": "Charelston",
		  "mostGuestAmount": 189,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fad4c684ed5ca3339eed1d74aa959c9a",
		  
		  "name": "Sven",
		  "createdDate": "2022-11-03 11:14:29",
		  "totalOrganizations": 7,
		  "totalTours": 3,
		  "totalDays": 99,
		  "totalCountries": 22,
		  "totalStates": 20,
		  "totalEvents": 54,
		  "eventPercent": 0.341342,
		  "totalScheduleItems": 793,
		  "schedulePercent": 0.419991,
		  "totalGuests": 66,
		  "guestPercent": 0.479148,
		  "mostGuestDate": "2025-01-18 00:00:00",
		  "mostGuestName": "Huxleys Neue Welt",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 38,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fadc50f04468caa8a90232e86a183f9f",
		  
		  "name": "Julie",
		  "createdDate": "2025-05-13 22:46:31",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 92,
		  "totalCountries": 3,
		  "totalStates": 4,
		  "totalEvents": 2,
		  "eventPercent": 0.0163191,
		  "totalScheduleItems": 76,
		  "schedulePercent": 0.0787625,
		  "totalGuests": 15,
		  "guestPercent": 0.382933,
		  "mostGuestDate": "2025-05-24 00:00:00",
		  "mostGuestName": "Auditorio Ibirapuera - Oscar Niemeyer",
		  "mostGuestCity": "Sao Paulo",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "faf7857ff3245b9d1df5f7dde9fa24bf",
		  
		  "name": "Konsta",
		  "createdDate": "2016-06-24 10:46:52",
		  "totalOrganizations": 142,
		  "totalTours": 87,
		  "totalDays": 1192,
		  "totalCountries": 6,
		  "totalStates": 3,
		  "totalEvents": 1189,
		  "eventPercent": 0.997054,
		  "totalScheduleItems": 4244,
		  "schedulePercent": 0.92883,
		  "totalGuests": 126,
		  "guestPercent": 0.541364,
		  "mostGuestDate": "2025-10-24 00:00:00",
		  "mostGuestName": "Tavastia",
		  "mostGuestCity": "Helsinki",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb05ac57ee4b408907949b6a03fca67c",
		  
		  "name": "Alastair",
		  "createdDate": "2012-03-31 02:17:02",
		  "totalOrganizations": 18,
		  "totalTours": 15,
		  "totalDays": 230,
		  "totalCountries": 22,
		  "totalStates": 41,
		  "totalEvents": 118,
		  "eventPercent": 0.616954,
		  "totalScheduleItems": 2012,
		  "schedulePercent": 0.715435,
		  "totalGuests": 1240,
		  "guestPercent": 0.87942,
		  "mostGuestDate": "2025-05-17 00:00:00",
		  "mostGuestName": "Dolby Live",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 92,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb10a493e316797d564aafbcfa5e44be",
		  
		  "name": "Jessica",
		  "createdDate": "2010-04-23 13:11:29",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 679,
		  "totalCountries": 2,
		  "totalStates": 20,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 960,
		  "schedulePercent": 0.479148,
		  "totalGuests": 38,
		  "guestPercent": 0.43461,
		  "mostGuestDate": "2025-08-28 00:00:00",
		  "mostGuestName": "Evans Towne Center Park",
		  "mostGuestCity": "Evans",
		  "mostGuestAmount": 11,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb134b1974878bc14cf48369ce14cfe5",
		  
		  "name": "Alex",
		  "createdDate": "2022-10-13 04:48:45",
		  "totalOrganizations": 8,
		  "totalTours": 23,
		  "totalDays": 580,
		  "totalCountries": 24,
		  "totalStates": 93,
		  "totalEvents": 320,
		  "eventPercent": 0.925657,
		  "totalScheduleItems": 4303,
		  "schedulePercent": 0.93087,
		  "totalGuests": 527,
		  "guestPercent": 0.737647,
		  "mostGuestDate": "2025-10-01 00:00:00",
		  "mostGuestName": "Varsity Theater",
		  "mostGuestCity": "Minneapolis",
		  "mostGuestAmount": 41,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb270f92d322ac35c9973c5647177ff5",
		  
		  "name": "Glyn ",
		  "createdDate": "2011-08-30 22:29:07",
		  "totalOrganizations": 16,
		  "totalTours": 33,
		  "totalDays": 299,
		  "totalCountries": 20,
		  "totalStates": 41,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 1132,
		  "schedulePercent": 0.528785,
		  "totalGuests": 27,
		  "guestPercent": 0.413418,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Fremantle Prison",
		  "mostGuestCity": "Fremantle",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb2d800a0d4880b1499301ba1bda5ab6",
		  
		  "name": "Quinton",
		  "createdDate": "2015-10-28 02:29:32",
		  "totalOrganizations": 6,
		  "totalTours": 2,
		  "totalDays": 730,
		  "totalCountries": 4,
		  "totalStates": 48,
		  "totalEvents": 153,
		  "eventPercent": 0.711242,
		  "totalScheduleItems": 1281,
		  "schedulePercent": 0.567656,
		  "totalGuests": 411,
		  "guestPercent": 0.697869,
		  "mostGuestDate": "2025-10-23 00:00:00",
		  "mostGuestName": "Murat Theatre @ Old National Centre",
		  "mostGuestCity": "Indianapolis",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb2ee23797fd9f3b1e62172de16dd35c",
		  
		  "name": "Paula",
		  "createdDate": "2025-04-11 00:39:51",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 49,
		  "totalCountries": 4,
		  "totalStates": 17,
		  "totalEvents": 23,
		  "eventPercent": 0.169198,
		  "totalScheduleItems": 289,
		  "schedulePercent": 0.211809,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb3f865057edf2e29b7e6de90c0cd053",
		  
		  "name": "Richard",
		  "createdDate": "2014-11-12 20:56:58",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 733,
		  "totalCountries": 28,
		  "totalStates": 71,
		  "totalEvents": 173,
		  "eventPercent": 0.753173,
		  "totalScheduleItems": 4637,
		  "schedulePercent": 0.94209,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb426e583b42617590aaf1294c64931c",
		  
		  "name": "Rose",
		  "createdDate": "2016-07-26 01:55:40",
		  "totalOrganizations": 9,
		  "totalTours": 25,
		  "totalDays": 536,
		  "totalCountries": 22,
		  "totalStates": 71,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 2459,
		  "schedulePercent": 0.782072,
		  "totalGuests": 1154,
		  "guestPercent": 0.8716,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb47b69140a9e3f059890f0c4250f4e4",
		  
		  "name": "Scooter",
		  "createdDate": "2023-02-14 22:07:44",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 75,
		  "totalCountries": 2,
		  "totalStates": 31,
		  "totalEvents": 53,
		  "eventPercent": 0.335789,
		  "totalScheduleItems": 502,
		  "schedulePercent": 0.312783,
		  "totalGuests": 167,
		  "guestPercent": 0.570943,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "Brighton Music Hall",
		  "mostGuestCity": "Boston",
		  "mostGuestAmount": 16,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb4848059aeea77e9718f84fb725ee2a",
		  
		  "name": "Didi",
		  "createdDate": "2021-09-06 23:52:11",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 397,
		  "totalCountries": 28,
		  "totalStates": 29,
		  "totalEvents": 143,
		  "eventPercent": 0.68699,
		  "totalScheduleItems": 2262,
		  "schedulePercent": 0.757026,
		  "totalGuests": 546,
		  "guestPercent": 0.742634,
		  "mostGuestDate": "2025-04-30 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb532edf8796b75939710d0fc18c61b5",
		  
		  "name": "Tess",
		  "createdDate": "2022-02-16 20:34:18",
		  "totalOrganizations": 15,
		  "totalTours": 30,
		  "totalDays": 567,
		  "totalCountries": 15,
		  "totalStates": 66,
		  "totalEvents": 300,
		  "eventPercent": 0.913078,
		  "totalScheduleItems": 4206,
		  "schedulePercent": 0.926111,
		  "totalGuests": 1354,
		  "guestPercent": 0.893472,
		  "mostGuestDate": "2025-04-14 00:00:00",
		  "mostGuestName": "The Roxy",
		  "mostGuestCity": "Lakewood",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb53c85560d8ddbec99f3c55c0b8a554",
		  
		  "name": "Mike",
		  "createdDate": "2014-06-19 18:35:22",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 169,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 55,
		  "eventPercent": 0.347801,
		  "totalScheduleItems": 1073,
		  "schedulePercent": 0.511673,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb53cdb8d06bc54586cd711d765eef69",
		  
		  "name": "Jesus",
		  "createdDate": "2022-10-05 12:34:06",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 243,
		  "totalCountries": 17,
		  "totalStates": 44,
		  "totalEvents": 70,
		  "eventPercent": 0.423617,
		  "totalScheduleItems": 769,
		  "schedulePercent": 0.411945,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb5a7b20bfa1344d1ce4a053c87f1526",
		  
		  "name": "Christophe",
		  "createdDate": "2017-10-03 04:17:28",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 161,
		  "totalCountries": 9,
		  "totalStates": 30,
		  "totalEvents": 46,
		  "eventPercent": 0.304624,
		  "totalScheduleItems": 589,
		  "schedulePercent": 0.347235,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb6372b6dcbef93e7437a9fa8054c009",
		  
		  "name": "Marcelo",
		  "createdDate": "2023-04-13 15:13:36",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 352,
		  "totalCountries": 4,
		  "totalStates": 38,
		  "totalEvents": 117,
		  "eventPercent": 0.613327,
		  "totalScheduleItems": 1911,
		  "schedulePercent": 0.696736,
		  "totalGuests": 2530,
		  "guestPercent": 0.969628,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 153,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb6f1d63aed9df7c416e464d5a3eb0c2",
		  
		  "name": "Jouman",
		  "createdDate": "2025-04-17 11:17:36",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 38,
		  "totalCountries": 8,
		  "totalStates": 5,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 235,
		  "schedulePercent": 0.181324,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb72bf5dbe4397dc6ef8160be1fccf65",
		  
		  "name": "Don",
		  "createdDate": "2016-02-11 16:51:14",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 448,
		  "totalCountries": 5,
		  "totalStates": 42,
		  "totalEvents": 119,
		  "eventPercent": 0.619447,
		  "totalScheduleItems": 1299,
		  "schedulePercent": 0.57117,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Tennessee Theatre",
		  "mostGuestCity": "Knoxville",
		  "mostGuestAmount": 14,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb857a2088fef41f641b6876a21612ec",
		  
		  "name": "Amery",
		  "createdDate": "2009-08-19 22:16:25",
		  "totalOrganizations": 26,
		  "totalTours": 9,
		  "totalDays": 199,
		  "totalCountries": 18,
		  "totalStates": 30,
		  "totalEvents": 85,
		  "eventPercent": 0.494447,
		  "totalScheduleItems": 1330,
		  "schedulePercent": 0.579896,
		  "totalGuests": 749,
		  "guestPercent": 0.796011,
		  "mostGuestDate": "2025-09-28 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 103,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb8e21927b4eba61433a16abc2f85dc7",
		  
		  "name": "John",
		  "createdDate": "2019-02-21 08:12:06",
		  "totalOrganizations": 7,
		  "totalTours": 17,
		  "totalDays": 394,
		  "totalCountries": 23,
		  "totalStates": 67,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2565,
		  "schedulePercent": 0.794424,
		  "totalGuests": 489,
		  "guestPercent": 0.727448,
		  "mostGuestDate": "2025-05-14 00:00:00",
		  "mostGuestName": "Kings Theatre",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 49,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fb9858e6fa3cda3e625d5d1192089aca",
		  
		  "name": "Courtney",
		  "createdDate": "2012-07-05 23:58:58",
		  "totalOrganizations": 5,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 2,
		  "totalStates": 10,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 194,
		  "schedulePercent": 0.155712,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fba8880c7fc1263407a6cb71ae4cda73",
		  
		  "name": "Birger",
		  "createdDate": "2015-07-23 10:17:28",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 197,
		  "totalCountries": 16,
		  "totalStates": 36,
		  "totalEvents": 87,
		  "eventPercent": 0.501473,
		  "totalScheduleItems": 1357,
		  "schedulePercent": 0.586809,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Greek Theatre",
		  "mostGuestCity": "Berkeley",
		  "mostGuestAmount": 2,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbb8960359131e735885a3995a1cd93b",
		  
		  "name": "Sean",
		  "createdDate": "2016-07-25 21:05:41",
		  "totalOrganizations": 18,
		  "totalTours": 17,
		  "totalDays": 3772,
		  "totalCountries": 18,
		  "totalStates": 75,
		  "totalEvents": 504,
		  "eventPercent": 0.979714,
		  "totalScheduleItems": 6589,
		  "schedulePercent": 0.982774,
		  "totalGuests": 3010,
		  "guestPercent": 0.982094,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Cadence Bank Amphitheatre At Chastain Park",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbc17e95f6eaf8db3724d27e6f5960a0",
		  
		  "name": "Aubrey",
		  "createdDate": "2019-02-10 20:18:38",
		  "totalOrganizations": 11,
		  "totalTours": 25,
		  "totalDays": 1282,
		  "totalCountries": 21,
		  "totalStates": 51,
		  "totalEvents": 535,
		  "eventPercent": 0.982208,
		  "totalScheduleItems": 6258,
		  "schedulePercent": 0.978808,
		  "totalGuests": 828,
		  "guestPercent": 0.814937,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "Pier 17",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbc3e1060a6f12243d5780575de0daba",
		  
		  "name": "Luke",
		  "createdDate": "2021-03-15 06:28:52",
		  "totalOrganizations": 43,
		  "totalTours": 31,
		  "totalDays": 707,
		  "totalCountries": 19,
		  "totalStates": 33,
		  "totalEvents": 227,
		  "eventPercent": 0.843268,
		  "totalScheduleItems": 2834,
		  "schedulePercent": 0.826156,
		  "totalGuests": 1419,
		  "guestPercent": 0.902425,
		  "mostGuestDate": "2025-04-12 00:00:00",
		  "mostGuestName": "Margaret Court Arena",
		  "mostGuestCity": "Melbourne",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbc5f9a3e884bd9822060e3a30ea3cf4",
		  
		  "name": "Ian",
		  "createdDate": "2015-11-04 00:15:23",
		  "totalOrganizations": 9,
		  "totalTours": 10,
		  "totalDays": 678,
		  "totalCountries": 29,
		  "totalStates": 40,
		  "totalEvents": 219,
		  "eventPercent": 0.831936,
		  "totalScheduleItems": 3039,
		  "schedulePercent": 0.845988,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbd127d61d7aaf7369dd43e4c9188252",
		  
		  "name": "Michael",
		  "createdDate": "2024-03-12 16:23:43",
		  "totalOrganizations": 5,
		  "totalTours": 15,
		  "totalDays": 260,
		  "totalCountries": 7,
		  "totalStates": 46,
		  "totalEvents": 167,
		  "eventPercent": 0.741387,
		  "totalScheduleItems": 1529,
		  "schedulePercent": 0.623527,
		  "totalGuests": 424,
		  "guestPercent": 0.704216,
		  "mostGuestDate": "2025-06-12 00:00:00",
		  "mostGuestName": "Tiki Bar",
		  "mostGuestCity": "Costa Mesa",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbd31476645896cb8a774e1ad09eac60",
		  
		  "name": "Danielle",
		  "createdDate": "2023-05-28 15:21:53",
		  "totalOrganizations": 3,
		  "totalTours": 18,
		  "totalDays": 806,
		  "totalCountries": 6,
		  "totalStates": 55,
		  "totalEvents": 247,
		  "eventPercent": 0.867634,
		  "totalScheduleItems": 523,
		  "schedulePercent": 0.322983,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbd4bf0ec3c87f282769c92b1bf248c4",
		  
		  "name": "Maria",
		  "createdDate": "2024-10-11 17:23:47",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 172,
		  "totalCountries": 18,
		  "totalStates": 43,
		  "totalEvents": 94,
		  "eventPercent": 0.530145,
		  "totalScheduleItems": 1580,
		  "schedulePercent": 0.636673,
		  "totalGuests": 1240,
		  "guestPercent": 0.87942,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbd5ddb6dec208981e08e5cd21bbcf69",
		  
		  "name": "Nathaniel",
		  "createdDate": "2014-10-16 23:30:48",
		  "totalOrganizations": 12,
		  "totalTours": 3,
		  "totalDays": 904,
		  "totalCountries": 15,
		  "totalStates": 11,
		  "totalEvents": 42,
		  "eventPercent": 0.283545,
		  "totalScheduleItems": 540,
		  "schedulePercent": 0.330349,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Queen's Royal College",
		  "mostGuestCity": "Port of Spain",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbe972e6cb73a7926b7b803f8cff6438",
		  
		  "name": "Shane",
		  "createdDate": "2011-02-19 18:10:49",
		  "totalOrganizations": 9,
		  "totalTours": 9,
		  "totalDays": 1336,
		  "totalCountries": 22,
		  "totalStates": 32,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 2667,
		  "schedulePercent": 0.804737,
		  "totalGuests": 20,
		  "guestPercent": 0.394492,
		  "mostGuestDate": "2025-05-31 00:00:00",
		  "mostGuestName": "Brockwell Park",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fbed746f5aa50ba687701c7aa140e190",
		  
		  "name": "Cyril",
		  "createdDate": "2019-10-27 11:31:10",
		  "totalOrganizations": 8,
		  "totalTours": 3,
		  "totalDays": 121,
		  "totalCountries": 14,
		  "totalStates": 26,
		  "totalEvents": 48,
		  "eventPercent": 0.313577,
		  "totalScheduleItems": 611,
		  "schedulePercent": 0.354374,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-07-26 00:00:00",
		  "mostGuestName": "Nuevo recinto Fan Futura",
		  "mostGuestCity": "Los AlcÃ¡zares",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc009935b6c74a40d7dea7897148a21f",
		  
		  "name": "Angel David",
		  "createdDate": "2025-03-03 10:06:28",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 32,
		  "totalCountries": 5,
		  "totalStates": 1,
		  "totalEvents": 12,
		  "eventPercent": 0.0930417,
		  "totalScheduleItems": 108,
		  "schedulePercent": 0.103921,
		  "totalGuests": 58,
		  "guestPercent": 0.466228,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "Lafayette",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 29,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc0b3e4096c863d7343d1db022771f43",
		  
		  "name": "Dan",
		  "createdDate": "2017-09-05 20:53:34",
		  "totalOrganizations": 8,
		  "totalTours": 17,
		  "totalDays": 1205,
		  "totalCountries": 3,
		  "totalStates": 38,
		  "totalEvents": 428,
		  "eventPercent": 0.964982,
		  "totalScheduleItems": 3754,
		  "schedulePercent": 0.899139,
		  "totalGuests": 857,
		  "guestPercent": 0.82083,
		  "mostGuestDate": "2025-03-11 00:00:00",
		  "mostGuestName": "The Bowery Ballroom",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc0c0298188c142aee8426c2252319d7",
		  
		  "name": "Mike",
		  "createdDate": "2009-08-30 22:33:22",
		  "totalOrganizations": 12,
		  "totalTours": 4,
		  "totalDays": 701,
		  "totalCountries": 11,
		  "totalStates": 26,
		  "totalEvents": 84,
		  "eventPercent": 0.490367,
		  "totalScheduleItems": 1403,
		  "schedulePercent": 0.598368,
		  "totalGuests": 4,
		  "guestPercent": 0.339415,
		  "mostGuestDate": "2025-07-06 00:00:00",
		  "mostGuestName": "Shenzhen Universiade Sports Centre",
		  "mostGuestCity": "Shen Zhen Shi",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc0f1f097c372d2adb64c2b2637f80bf",
		  
		  "name": "Matthew",
		  "createdDate": "2016-05-27 06:46:19",
		  "totalOrganizations": 12,
		  "totalTours": 2,
		  "totalDays": 29,
		  "totalCountries": 2,
		  "totalStates": 4,
		  "totalEvents": 10,
		  "eventPercent": 0.0774025,
		  "totalScheduleItems": 109,
		  "schedulePercent": 0.105054,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc12022fd804cab850992686e9f3ab17",
		  
		  "name": "Donna",
		  "createdDate": "2023-05-03 22:49:24",
		  "totalOrganizations": 6,
		  "totalTours": 23,
		  "totalDays": 690,
		  "totalCountries": 6,
		  "totalStates": 49,
		  "totalEvents": 190,
		  "eventPercent": 0.782412,
		  "totalScheduleItems": 2815,
		  "schedulePercent": 0.824229,
		  "totalGuests": 1534,
		  "guestPercent": 0.913531,
		  "mostGuestDate": "2025-03-27 00:00:00",
		  "mostGuestName": "Madison Square Garden",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 386,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc21677c618657dd7ce07078cda428fb",
		  
		  "name": "Johanna",
		  "createdDate": "2022-05-23 12:07:05",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 58,
		  "totalCountries": 5,
		  "totalStates": 5,
		  "totalEvents": 36,
		  "eventPercent": 0.249207,
		  "totalScheduleItems": 277,
		  "schedulePercent": 0.203196,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc29ca99f4968386d963198d728bfa49",
		  
		  "name": "Petrus",
		  "createdDate": "2024-08-18 06:37:58",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 153,
		  "totalCountries": 4,
		  "totalStates": 3,
		  "totalEvents": 83,
		  "eventPercent": 0.485721,
		  "totalScheduleItems": 968,
		  "schedulePercent": 0.480621,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc2b45dae32bf870b4d9b5cbee8d5d71",
		  
		  "name": "Karen",
		  "createdDate": "2013-09-06 07:48:02",
		  "totalOrganizations": 6,
		  "totalTours": 13,
		  "totalDays": 181,
		  "totalCountries": 12,
		  "totalStates": 9,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 528,
		  "schedulePercent": 0.326043,
		  "totalGuests": 317,
		  "guestPercent": 0.657752,
		  "mostGuestDate": "2025-06-27 00:00:00",
		  "mostGuestName": "The State Theatre",
		  "mostGuestCity": "Sydney",
		  "mostGuestAmount": 86,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc2c29d72553d407b1916c4a4f323066",
		  
		  "name": "Lou",
		  "createdDate": "2019-09-05 19:00:48",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 25,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 5,
		  "eventPercent": 0.0407978,
		  "totalScheduleItems": 107,
		  "schedulePercent": 0.102675,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc33d85f93afa3055993ddef83268633",
		  
		  "name": "Andrew",
		  "createdDate": "2013-07-09 02:27:45",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 629,
		  "totalCountries": 5,
		  "totalStates": 18,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 668,
		  "schedulePercent": 0.374207,
		  "totalGuests": 564,
		  "guestPercent": 0.747507,
		  "mostGuestDate": "2025-09-17 00:00:00",
		  "mostGuestName": "Forest Hills Stadium",
		  "mostGuestCity": "Forest Hills",
		  "mostGuestAmount": 106,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc35ac8d69c7c63b867673eac5bf7628",
		  
		  "name": "Petr",
		  "createdDate": "2015-05-11 08:49:10",
		  "totalOrganizations": 5,
		  "totalTours": 2,
		  "totalDays": 33,
		  "totalCountries": 13,
		  "totalStates": 8,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 198,
		  "schedulePercent": 0.159451,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc50638e055e8d936917b49c7459b885",
		  
		  "name": "Margaret",
		  "createdDate": "2016-10-19 22:45:36",
		  "totalOrganizations": 9,
		  "totalTours": 18,
		  "totalDays": 190,
		  "totalCountries": 14,
		  "totalStates": 32,
		  "totalEvents": 100,
		  "eventPercent": 0.55315,
		  "totalScheduleItems": 857,
		  "schedulePercent": 0.442656,
		  "totalGuests": 54,
		  "guestPercent": 0.458296,
		  "mostGuestDate": "2025-10-16 00:00:00",
		  "mostGuestName": "LPR",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc51369d03023d09f57a70b2b92be844",
		  
		  "name": "Todd",
		  "createdDate": "2016-01-23 22:05:31",
		  "totalOrganizations": 13,
		  "totalTours": 3,
		  "totalDays": 232,
		  "totalCountries": 6,
		  "totalStates": 43,
		  "totalEvents": 101,
		  "eventPercent": 0.556324,
		  "totalScheduleItems": 1169,
		  "schedulePercent": 0.539778,
		  "totalGuests": 747,
		  "guestPercent": 0.795558,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc5639b729a046d37304e61f4f8f3285",
		  
		  "name": "Lotte",
		  "createdDate": "2016-10-07 08:54:40",
		  "totalOrganizations": 9,
		  "totalTours": 2,
		  "totalDays": 72,
		  "totalCountries": 4,
		  "totalStates": 6,
		  "totalEvents": 50,
		  "eventPercent": 0.324003,
		  "totalScheduleItems": 534,
		  "schedulePercent": 0.328762,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc621168eb60fbd3d847d7f96ab600fb",
		  
		  "name": "Alex",
		  "createdDate": "2023-02-23 16:39:34",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 424,
		  "totalCountries": 19,
		  "totalStates": 61,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2516,
		  "schedulePercent": 0.788078,
		  "totalGuests": 124,
		  "guestPercent": 0.539891,
		  "mostGuestDate": "2025-09-10 00:00:00",
		  "mostGuestName": "100 Club",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 20,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc69441b2154d4d8b0b507ed6f374c60",
		  
		  "name": "Julie",
		  "createdDate": "2010-03-10 19:56:39",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 167,
		  "totalCountries": 15,
		  "totalStates": 39,
		  "totalEvents": 80,
		  "eventPercent": 0.471215,
		  "totalScheduleItems": 904,
		  "schedulePercent": 0.459882,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc7eda4fb361479298f71a9766cbd1fd",
		  
		  "name": "Phil",
		  "createdDate": "2019-09-16 18:16:24",
		  "totalOrganizations": 34,
		  "totalTours": 27,
		  "totalDays": 3779,
		  "totalCountries": 4,
		  "totalStates": 52,
		  "totalEvents": 396,
		  "eventPercent": 0.957956,
		  "totalScheduleItems": 3008,
		  "schedulePercent": 0.842815,
		  "totalGuests": 40,
		  "guestPercent": 0.437897,
		  "mostGuestDate": "2025-03-22 00:00:00",
		  "mostGuestName": "Wonder Ballroom",
		  "mostGuestCity": "Portland",
		  "mostGuestAmount": 23,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc892cf3304c543fef34647803d93239",
		  
		  "name": "Seth",
		  "createdDate": "2022-04-11 13:40:01",
		  "totalOrganizations": 21,
		  "totalTours": 67,
		  "totalDays": 1168,
		  "totalCountries": 16,
		  "totalStates": 59,
		  "totalEvents": 303,
		  "eventPercent": 0.914665,
		  "totalScheduleItems": 3808,
		  "schedulePercent": 0.902992,
		  "totalGuests": 1056,
		  "guestPercent": 0.855848,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 156,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc8a5cc1209476a82325d79c7a5e3a94",
		  
		  "name": "Nikki ",
		  "createdDate": "2019-08-01 06:20:15",
		  "totalOrganizations": 12,
		  "totalTours": 13,
		  "totalDays": 438,
		  "totalCountries": 25,
		  "totalStates": 56,
		  "totalEvents": 174,
		  "eventPercent": 0.75476,
		  "totalScheduleItems": 1626,
		  "schedulePercent": 0.645399,
		  "totalGuests": 438,
		  "guestPercent": 0.709089,
		  "mostGuestDate": "2025-06-05 00:00:00",
		  "mostGuestName": "Echo-Plex",
		  "mostGuestCity": "Echo Park",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc928f56a6d2d5e02fbf080bdbc462cf",
		  
		  "name": "Russell",
		  "createdDate": "2014-02-24 22:54:43",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 1024,
		  "totalCountries": 12,
		  "totalStates": 50,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 2568,
		  "schedulePercent": 0.795104,
		  "totalGuests": 425,
		  "guestPercent": 0.704442,
		  "mostGuestDate": "2025-06-17 00:00:00",
		  "mostGuestName": "Electric Ballroom",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc96f6bebe76db08f3320b12fa873216",
		  
		  "name": "Matt",
		  "createdDate": "2011-09-26 19:20:39",
		  "totalOrganizations": 12,
		  "totalTours": 7,
		  "totalDays": 1539,
		  "totalCountries": 27,
		  "totalStates": 66,
		  "totalEvents": 255,
		  "eventPercent": 0.875567,
		  "totalScheduleItems": 3707,
		  "schedulePercent": 0.896759,
		  "totalGuests": 121,
		  "guestPercent": 0.537738,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "San Jose Civic Auditorium",
		  "mostGuestCity": "San Jose",
		  "mostGuestAmount": 44,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc9a005f2968ae7e26518a2bd9558a3f",
		  
		  "name": "Steve",
		  "createdDate": "2022-02-07 22:18:29",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 95,
		  "totalCountries": 3,
		  "totalStates": 35,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 936,
		  "schedulePercent": 0.471215,
		  "totalGuests": 1051,
		  "guestPercent": 0.854374,
		  "mostGuestDate": "2025-08-15 00:00:00",
		  "mostGuestName": "Byline Bank Aragon Ballroom",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 102,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fc9e9b40be5b06300dbbbe2bee8ab630",
		  
		  "name": "Maik",
		  "createdDate": "2014-09-09 15:27:30",
		  "totalOrganizations": 10,
		  "totalTours": 10,
		  "totalDays": 235,
		  "totalCountries": 20,
		  "totalStates": 32,
		  "totalEvents": 142,
		  "eventPercent": 0.684497,
		  "totalScheduleItems": 2362,
		  "schedulePercent": 0.770286,
		  "totalGuests": 3158,
		  "guestPercent": 0.984814,
		  "mostGuestDate": "2025-10-13 00:00:00",
		  "mostGuestName": "Uber Eats Music Hall",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 405,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fca7a740846efb9c0767c9fceb8c6e35",
		  
		  "name": "Del",
		  "createdDate": "2025-10-31 12:25:23",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 23,
		  "totalCountries": 4,
		  "totalStates": 9,
		  "totalEvents": 13,
		  "eventPercent": 0.0996147,
		  "totalScheduleItems": 228,
		  "schedulePercent": 0.176451,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fcb0009cb8ac13514a2429c772d49019",
		  
		  "name": "Keenan",
		  "createdDate": "2016-07-11 04:00:28",
		  "totalOrganizations": 7,
		  "totalTours": 10,
		  "totalDays": 403,
		  "totalCountries": 24,
		  "totalStates": 85,
		  "totalEvents": 232,
		  "eventPercent": 0.850408,
		  "totalScheduleItems": 3900,
		  "schedulePercent": 0.908318,
		  "totalGuests": 1590,
		  "guestPercent": 0.918518,
		  "mostGuestDate": "2025-08-03 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fcc080521131af68bc1694c4fe7a6d97",
		  
		  "name": "UNIFIED",
		  "createdDate": "2017-11-13 04:46:13",
		  "totalOrganizations": 11,
		  "totalTours": 17,
		  "totalDays": 316,
		  "totalCountries": 11,
		  "totalStates": 34,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1074,
		  "schedulePercent": 0.511786,
		  "totalGuests": 564,
		  "guestPercent": 0.747507,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "The Enmore Theatre",
		  "mostGuestCity": "Newtown",
		  "mostGuestAmount": 156,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fcc90f8fd917a6b226aaec3523c3e89c",
		  
		  "name": "Niki",
		  "createdDate": "2018-11-06 12:12:42",
		  "totalOrganizations": 10,
		  "totalTours": 19,
		  "totalDays": 256,
		  "totalCountries": 11,
		  "totalStates": 22,
		  "totalEvents": 203,
		  "eventPercent": 0.805304,
		  "totalScheduleItems": 843,
		  "schedulePercent": 0.438237,
		  "totalGuests": 85,
		  "guestPercent": 0.502493,
		  "mostGuestDate": "2025-06-29 00:00:00",
		  "mostGuestName": "The Stone Pony Summer Stage",
		  "mostGuestCity": "Asbury Park",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fcd37643197a8e8ff26861a205ba1b85",
		  
		  "name": "Brayden",
		  "createdDate": "2021-10-11 04:11:16",
		  "totalOrganizations": 3,
		  "totalTours": 4,
		  "totalDays": 753,
		  "totalCountries": 4,
		  "totalStates": 57,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 2417,
		  "schedulePercent": 0.776972,
		  "totalGuests": 1488,
		  "guestPercent": 0.908432,
		  "mostGuestDate": "2025-03-21 00:00:00",
		  "mostGuestName": "Akins Ford Arena",
		  "mostGuestCity": "Athens",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fcdf30cf54a9f3084c822577536d029c",
		  
		  "name": "Ania",
		  "createdDate": "2018-12-06 21:58:09",
		  "totalOrganizations": 4,
		  "totalTours": 3,
		  "totalDays": 128,
		  "totalCountries": 3,
		  "totalStates": 29,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 387,
		  "schedulePercent": 0.262579,
		  "totalGuests": 150,
		  "guestPercent": 0.55859,
		  "mostGuestDate": "2025-04-25 00:00:00",
		  "mostGuestName": "The King Of Clubs",
		  "mostGuestCity": "Columbus",
		  "mostGuestAmount": 24,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fce2d5f199971d741aea88f7a0d0cf1b",
		  
		  "name": "Paolo",
		  "createdDate": "2012-07-13 08:55:59",
		  "totalOrganizations": 11,
		  "totalTours": 13,
		  "totalDays": 1459,
		  "totalCountries": 35,
		  "totalStates": 82,
		  "totalEvents": 377,
		  "eventPercent": 0.952969,
		  "totalScheduleItems": 5753,
		  "schedulePercent": 0.971895,
		  "totalGuests": 535,
		  "guestPercent": 0.738894,
		  "mostGuestDate": "2025-04-17 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 51,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fcedf272ee741ee23669c30796230284",
		  
		  "name": "Yunie",
		  "createdDate": "2023-03-30 16:48:06",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 391,
		  "totalCountries": 2,
		  "totalStates": 3,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 1553,
		  "schedulePercent": 0.627607,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fcf27088ac6358550871c708bbf3558d",
		  
		  "name": "Caleb",
		  "createdDate": "2017-09-14 01:02:16",
		  "totalOrganizations": 12,
		  "totalTours": 10,
		  "totalDays": 224,
		  "totalCountries": 5,
		  "totalStates": 36,
		  "totalEvents": 122,
		  "eventPercent": 0.629986,
		  "totalScheduleItems": 1700,
		  "schedulePercent": 0.658545,
		  "totalGuests": 1126,
		  "guestPercent": 0.867974,
		  "mostGuestDate": "2025-10-04 00:00:00",
		  "mostGuestName": "Gas South Arena",
		  "mostGuestCity": "Duluth",
		  "mostGuestAmount": 93,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fcf52a27ebff4b97659bbca8cc896b8c",
		  
		  "name": "Michael",
		  "createdDate": "2016-02-06 09:29:06",
		  "totalOrganizations": 14,
		  "totalTours": 40,
		  "totalDays": 910,
		  "totalCountries": 38,
		  "totalStates": 122,
		  "totalEvents": 458,
		  "eventPercent": 0.972461,
		  "totalScheduleItems": 4954,
		  "schedulePercent": 0.952743,
		  "totalGuests": 1550,
		  "guestPercent": 0.915005,
		  "mostGuestDate": "2025-08-21 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd07c126fd9adfe6d482d940600421f4",
		  
		  "name": "Ali",
		  "createdDate": "2023-03-06 22:25:04",
		  "totalOrganizations": 6,
		  "totalTours": 23,
		  "totalDays": 183,
		  "totalCountries": 7,
		  "totalStates": 16,
		  "totalEvents": 77,
		  "eventPercent": 0.457049,
		  "totalScheduleItems": 622,
		  "schedulePercent": 0.358114,
		  "totalGuests": 550,
		  "guestPercent": 0.743994,
		  "mostGuestDate": "2025-06-21 00:00:00",
		  "mostGuestName": "Spark Arena",
		  "mostGuestCity": "Auckland",
		  "mostGuestAmount": 118,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd0ecf37d831cb772fb55d887aefa075",
		  
		  "name": "Jesse",
		  "createdDate": "2025-10-28 13:49:07",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 26,
		  "totalCountries": 3,
		  "totalStates": 19,
		  "totalEvents": 17,
		  "eventPercent": 0.12874,
		  "totalScheduleItems": 308,
		  "schedulePercent": 0.221782,
		  "totalGuests": 50,
		  "guestPercent": 0.452289,
		  "mostGuestDate": "2025-11-01 00:00:00",
		  "mostGuestName": "The Observatory North Park",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 15,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd11bdafab7e3f4b4417677cb2bce0f8",
		  
		  "name": "Cathy",
		  "createdDate": "2014-05-14 17:16:31",
		  "totalOrganizations": 12,
		  "totalTours": 23,
		  "totalDays": 609,
		  "totalCountries": 4,
		  "totalStates": 36,
		  "totalEvents": 91,
		  "eventPercent": 0.514166,
		  "totalScheduleItems": 1595,
		  "schedulePercent": 0.639733,
		  "totalGuests": 495,
		  "guestPercent": 0.729034,
		  "mostGuestDate": "2025-07-19 00:00:00",
		  "mostGuestName": "  5004 National Western Drive   ",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 46,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd1589418e549c3f969e5b18fc86db2c",
		  
		  "name": "HUET",
		  "createdDate": "2023-11-01 11:17:20",
		  "totalOrganizations": 7,
		  "totalTours": 7,
		  "totalDays": 749,
		  "totalCountries": 8,
		  "totalStates": 19,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 1423,
		  "schedulePercent": 0.602788,
		  "totalGuests": 540,
		  "guestPercent": 0.740594,
		  "mostGuestDate": "2025-10-09 00:00:00",
		  "mostGuestName": "La CarriÃ¨re",
		  "mostGuestCity": "Saint-Herblain",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd1aab3f681e7f330bf42c29d2029bf9",
		  
		  "name": "Nicholas",
		  "createdDate": "2019-08-02 07:43:48",
		  "totalOrganizations": 12,
		  "totalTours": 27,
		  "totalDays": 411,
		  "totalCountries": 20,
		  "totalStates": 50,
		  "totalEvents": 157,
		  "eventPercent": 0.720082,
		  "totalScheduleItems": 2672,
		  "schedulePercent": 0.805757,
		  "totalGuests": 1563,
		  "guestPercent": 0.916138,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Crypto.com Arena",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 134,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd1c707425f42379537806d348de9ff3",
		  
		  "name": "Sarah",
		  "createdDate": "2025-04-02 11:17:18",
		  "totalOrganizations": 34,
		  "totalTours": 38,
		  "totalDays": 549,
		  "totalCountries": 12,
		  "totalStates": 24,
		  "totalEvents": 382,
		  "eventPercent": 0.953876,
		  "totalScheduleItems": 3023,
		  "schedulePercent": 0.844288,
		  "totalGuests": 618,
		  "guestPercent": 0.763259,
		  "mostGuestDate": "2025-09-06 00:00:00",
		  "mostGuestName": "Studenternas Arena",
		  "mostGuestCity": "Uppsala",
		  "mostGuestAmount": 65,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd1d34ab1a2dbc07546734ec64c78661",
		  
		  "name": "Elliott",
		  "createdDate": "2022-07-05 16:09:09",
		  "totalOrganizations": 2,
		  "totalTours": 3,
		  "totalDays": 238,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 337,
		  "schedulePercent": 0.235041,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd27407c1afd632f8cdfab77ff7193ab",
		  
		  "name": "Melinda",
		  "createdDate": "2024-09-17 12:12:04",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 299,
		  "totalCountries": 3,
		  "totalStates": 50,
		  "totalEvents": 169,
		  "eventPercent": 0.745354,
		  "totalScheduleItems": 2352,
		  "schedulePercent": 0.768472,
		  "totalGuests": 3224,
		  "guestPercent": 0.985834,
		  "mostGuestDate": "2025-08-09 00:00:00",
		  "mostGuestName": "Coca-Cola Amphitheater",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 253,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd31b8fbfa0f2cde814164b245eedc12",
		  
		  "name": "Jenn",
		  "createdDate": "2013-12-05 19:28:52",
		  "totalOrganizations": 8,
		  "totalTours": 5,
		  "totalDays": 475,
		  "totalCountries": 11,
		  "totalStates": 23,
		  "totalEvents": 151,
		  "eventPercent": 0.706596,
		  "totalScheduleItems": 1288,
		  "schedulePercent": 0.568903,
		  "totalGuests": 194,
		  "guestPercent": 0.588735,
		  "mostGuestDate": "2025-06-06 00:00:00",
		  "mostGuestName": "Budweiser Stage",
		  "mostGuestCity": "Toronto",
		  "mostGuestAmount": 55,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd3a2e90eedcc83144c27f9a9165ae41",
		  
		  "name": "Darrick",
		  "createdDate": "2015-11-04 16:52:19",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 700,
		  "totalCountries": 3,
		  "totalStates": 30,
		  "totalEvents": 76,
		  "eventPercent": 0.452516,
		  "totalScheduleItems": 425,
		  "schedulePercent": 0.280032,
		  "totalGuests": 202,
		  "guestPercent": 0.596328,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "The Caverns",
		  "mostGuestCity": "Pelham",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd3a7e22b7a7c459521700d61d5183db",
		  
		  "name": "Kieran",
		  "createdDate": "2022-12-23 20:04:08",
		  "totalOrganizations": 19,
		  "totalTours": 22,
		  "totalDays": 1862,
		  "totalCountries": 21,
		  "totalStates": 71,
		  "totalEvents": 461,
		  "eventPercent": 0.972801,
		  "totalScheduleItems": 7999,
		  "schedulePercent": 0.990594,
		  "totalGuests": 2564,
		  "guestPercent": 0.970988,
		  "mostGuestDate": "2025-10-08 00:00:00",
		  "mostGuestName": "Hollywood Palladium",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 116,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd3f7e94d1c0f7440e9fdae05d3cbc55",
		  
		  "name": "Juliun ",
		  "createdDate": "2025-06-04 20:25:15",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 968,
		  "totalCountries": 8,
		  "totalStates": 50,
		  "totalEvents": 184,
		  "eventPercent": 0.771645,
		  "totalScheduleItems": 957,
		  "schedulePercent": 0.478014,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd44d4230f28cd931c7af64b4a9eef43",
		  
		  "name": "John",
		  "createdDate": "2022-03-20 02:16:33",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 280,
		  "totalCountries": 3,
		  "totalStates": 44,
		  "totalEvents": 126,
		  "eventPercent": 0.642112,
		  "totalScheduleItems": 2101,
		  "schedulePercent": 0.732888,
		  "totalGuests": 2722,
		  "guestPercent": 0.976881,
		  "mostGuestDate": "2025-07-05 00:00:00",
		  "mostGuestName": "Great Park Live",
		  "mostGuestCity": "Irvine",
		  "mostGuestAmount": 168,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd4bfb0e47544691b25a9d3ff7e06254",
		  
		  "name": "Sam",
		  "createdDate": "2023-11-07 23:30:18",
		  "totalOrganizations": 13,
		  "totalTours": 5,
		  "totalDays": 154,
		  "totalCountries": 5,
		  "totalStates": 23,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 745,
		  "schedulePercent": 0.403445,
		  "totalGuests": 89,
		  "guestPercent": 0.50714,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Bryce Jordan Center",
		  "mostGuestCity": "University Park",
		  "mostGuestAmount": 22,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd4d3562725b7826f80d1c2d4b274a1d",
		  
		  "name": "Chad",
		  "createdDate": "2012-02-15 19:48:24",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 368,
		  "totalCountries": 4,
		  "totalStates": 16,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 2080,
		  "schedulePercent": 0.729034,
		  "totalGuests": 2521,
		  "guestPercent": 0.968722,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "Cleveland Browns Stadium",
		  "mostGuestCity": "Cleveland",
		  "mostGuestAmount": 186,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd539ab22c6bf11e39b912f24ab0c701",
		  
		  "name": "Andrew",
		  "createdDate": "2015-11-25 14:40:01",
		  "totalOrganizations": 7,
		  "totalTours": 12,
		  "totalDays": 664,
		  "totalCountries": 14,
		  "totalStates": 66,
		  "totalEvents": 259,
		  "eventPercent": 0.881006,
		  "totalScheduleItems": 3725,
		  "schedulePercent": 0.897552,
		  "totalGuests": 1740,
		  "guestPercent": 0.92985,
		  "mostGuestDate": "2025-05-01 00:00:00",
		  "mostGuestName": "The Factory in Deep Ellum",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd8f282e30ee4606d2eb086d5cd29208",
		  
		  "name": "Tim",
		  "createdDate": "2025-07-07 19:01:30",
		  "totalOrganizations": 8,
		  "totalTours": 9,
		  "totalDays": 548,
		  "totalCountries": 3,
		  "totalStates": 41,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 1127,
		  "schedulePercent": 0.527085,
		  "totalGuests": 72,
		  "guestPercent": 0.487081,
		  "mostGuestDate": "2025-09-07 00:00:00",
		  "mostGuestName": "Velvet Elk Lounge",
		  "mostGuestCity": "Boulder",
		  "mostGuestAmount": 8,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd9c5637c794a5c382c39c8661bff872",
		  
		  "name": "Amber",
		  "createdDate": "2022-06-23 00:29:55",
		  "totalOrganizations": 5,
		  "totalTours": 7,
		  "totalDays": 936,
		  "totalCountries": 3,
		  "totalStates": 27,
		  "totalEvents": 428,
		  "eventPercent": 0.964982,
		  "totalScheduleItems": 2680,
		  "schedulePercent": 0.807004,
		  "totalGuests": 9915,
		  "guestPercent": 0.999433,
		  "mostGuestDate": "2025-06-28 00:00:00",
		  "mostGuestName": "SoFi Stadium",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 523,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fd9c6c951c2a2acad96c6e52234726af",
		  
		  "name": "Timothy",
		  "createdDate": "2011-07-28 16:18:17",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 111,
		  "totalCountries": 2,
		  "totalStates": 18,
		  "totalEvents": 56,
		  "eventPercent": 0.352901,
		  "totalScheduleItems": 1586,
		  "schedulePercent": 0.637579,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fda2ef546d46bf9926bea339c2d9cff1",
		  
		  "name": "Madeleine",
		  "createdDate": "2022-09-07 21:32:11",
		  "totalOrganizations": 2,
		  "totalTours": 4,
		  "totalDays": 127,
		  "totalCountries": 14,
		  "totalStates": 41,
		  "totalEvents": 52,
		  "eventPercent": 0.331709,
		  "totalScheduleItems": 488,
		  "schedulePercent": 0.30519,
		  "totalGuests": 18,
		  "guestPercent": 0.390413,
		  "mostGuestDate": "2025-05-26 00:00:00",
		  "mostGuestName": "Esplanade Annexe Studio",
		  "mostGuestCity": "",
		  "mostGuestAmount": 7,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fda4e313cdab1552ef74dde1b0585060",
		  
		  "name": "Jan-Christoph",
		  "createdDate": "2023-08-15 18:31:29",
		  "totalOrganizations": 3,
		  "totalTours": 8,
		  "totalDays": 561,
		  "totalCountries": 21,
		  "totalStates": 29,
		  "totalEvents": 132,
		  "eventPercent": 0.659451,
		  "totalScheduleItems": 2044,
		  "schedulePercent": 0.722235,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdaa72c97b7f44b638a0be81de229582",
		  
		  "name": "Holli",
		  "createdDate": "2017-02-01 00:39:20",
		  "totalOrganizations": 13,
		  "totalTours": 16,
		  "totalDays": 517,
		  "totalCountries": 16,
		  "totalStates": 34,
		  "totalEvents": 156,
		  "eventPercent": 0.718042,
		  "totalScheduleItems": 1828,
		  "schedulePercent": 0.68121,
		  "totalGuests": 334,
		  "guestPercent": 0.667384,
		  "mostGuestDate": "2025-11-08 00:00:00",
		  "mostGuestName": "Park Theater",
		  "mostGuestCity": "Las Vegas",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdac310534e73c1d28df8243c4f14daa",
		  
		  "name": "Mark",
		  "createdDate": "2009-09-02 21:43:51",
		  "totalOrganizations": 8,
		  "totalTours": 10,
		  "totalDays": 1141,
		  "totalCountries": 25,
		  "totalStates": 49,
		  "totalEvents": 318,
		  "eventPercent": 0.924411,
		  "totalScheduleItems": 5326,
		  "schedulePercent": 0.963282,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdb31b4c05904686ea8ec7b7c03bec8b",
		  
		  "name": "Emily",
		  "createdDate": "2025-06-05 17:46:38",
		  "totalOrganizations": 1,
		  "totalTours": 3,
		  "totalDays": 128,
		  "totalCountries": 14,
		  "totalStates": 32,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 638,
		  "schedulePercent": 0.363781,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdc364d045ab3a6f1b2545971580b48c",
		  
		  "name": "GEMMA",
		  "createdDate": "2024-03-16 19:22:22",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 46,
		  "totalCountries": 3,
		  "totalStates": 13,
		  "totalEvents": 30,
		  "eventPercent": 0.215095,
		  "totalScheduleItems": 249,
		  "schedulePercent": 0.189483,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdcb9ceb9520216a89dfad0aa7944799",
		  
		  "name": "Nick",
		  "createdDate": "2017-09-12 18:04:20",
		  "totalOrganizations": 4,
		  "totalTours": 1,
		  "totalDays": 345,
		  "totalCountries": 12,
		  "totalStates": 49,
		  "totalEvents": 96,
		  "eventPercent": 0.539098,
		  "totalScheduleItems": 1392,
		  "schedulePercent": 0.595648,
		  "totalGuests": 980,
		  "guestPercent": 0.842815,
		  "mostGuestDate": "2025-03-19 00:00:00",
		  "mostGuestName": "The Majestic Ventura Theater",
		  "mostGuestCity": "Ventura",
		  "mostGuestAmount": 67,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdcd11460abb6b86e4aed740c67c3b34",
		  
		  "name": "Matt",
		  "createdDate": "2013-08-22 13:43:06",
		  "totalOrganizations": 9,
		  "totalTours": 13,
		  "totalDays": 363,
		  "totalCountries": 12,
		  "totalStates": 63,
		  "totalEvents": 144,
		  "eventPercent": 0.690843,
		  "totalScheduleItems": 2598,
		  "schedulePercent": 0.797144,
		  "totalGuests": 2177,
		  "guestPercent": 0.956822,
		  "mostGuestDate": "2025-08-02 00:00:00",
		  "mostGuestName": "Climate Pledge Arena",
		  "mostGuestCity": "Seattle",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fddea58defbc112037418619eb18a37d",
		  
		  "name": "Karina",
		  "createdDate": "2023-10-19 08:56:28",
		  "totalOrganizations": 4,
		  "totalTours": 4,
		  "totalDays": 337,
		  "totalCountries": 8,
		  "totalStates": 22,
		  "totalEvents": 158,
		  "eventPercent": 0.722235,
		  "totalScheduleItems": 2056,
		  "schedulePercent": 0.724841,
		  "totalGuests": 2259,
		  "guestPercent": 0.960335,
		  "mostGuestDate": "2025-10-31 00:00:00",
		  "mostGuestName": "Wiener Stadthalle",
		  "mostGuestCity": "Vienna",
		  "mostGuestAmount": 175,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdeeba1337010d8935e4bcee14fadf7d",
		  
		  "name": "Edie",
		  "createdDate": "2021-10-15 19:01:00",
		  "totalOrganizations": 1,
		  "totalTours": 5,
		  "totalDays": 123,
		  "totalCountries": 10,
		  "totalStates": 17,
		  "totalEvents": 33,
		  "eventPercent": 0.232548,
		  "totalScheduleItems": 457,
		  "schedulePercent": 0.293404,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "The O2",
		  "mostGuestCity": "London",
		  "mostGuestAmount": 4,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdf1eef85fe19c2c52fd2bc6762499e9",
		  
		  "name": "Shelley",
		  "createdDate": "2023-11-09 23:35:55",
		  "totalOrganizations": 8,
		  "totalTours": 16,
		  "totalDays": 956,
		  "totalCountries": 33,
		  "totalStates": 78,
		  "totalEvents": 361,
		  "eventPercent": 0.946963,
		  "totalScheduleItems": 5955,
		  "schedulePercent": 0.975295,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fdf32a44fd73053224f3f6d32b519976",
		  
		  "name": "Jack + Courtney",
		  "createdDate": "2024-08-08 19:27:33",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 60,
		  "totalCountries": 9,
		  "totalStates": 11,
		  "totalEvents": 21,
		  "eventPercent": 0.157185,
		  "totalScheduleItems": 382,
		  "schedulePercent": 0.259406,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe0fdf7cf31dbc8d331e67744e76ac59",
		  
		  "name": "Ronnie",
		  "createdDate": "2017-03-05 09:47:42",
		  "totalOrganizations": 3,
		  "totalTours": 2,
		  "totalDays": 50,
		  "totalCountries": 9,
		  "totalStates": 25,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 441,
		  "schedulePercent": 0.287285,
		  "totalGuests": 411,
		  "guestPercent": 0.697869,
		  "mostGuestDate": "2025-04-09 00:00:00",
		  "mostGuestName": "The Kia Forum",
		  "mostGuestCity": "Inglewood",
		  "mostGuestAmount": 48,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe19f77df4e6855517a9597dbaa5fc9a",
		  
		  "name": "Scott",
		  "createdDate": "2024-02-01 07:50:07",
		  "totalOrganizations": 3,
		  "totalTours": 6,
		  "totalDays": 72,
		  "totalCountries": 10,
		  "totalStates": 28,
		  "totalEvents": 39,
		  "eventPercent": 0.268019,
		  "totalScheduleItems": 499,
		  "schedulePercent": 0.311763,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-06-13 00:00:00",
		  "mostGuestName": "Tom Moffatt Waikiki Shell",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe201a94d1ed1f7192cd221258b7167e",
		  
		  "name": "Sebastian",
		  "createdDate": "2017-08-09 15:11:00",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 71,
		  "totalCountries": 5,
		  "totalStates": 2,
		  "totalEvents": 34,
		  "eventPercent": 0.238554,
		  "totalScheduleItems": 806,
		  "schedulePercent": 0.424751,
		  "totalGuests": 1106,
		  "guestPercent": 0.865027,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Galopprennbahn KÃ¶ln-Weidenpesch",
		  "mostGuestCity": "KÃ¶ln",
		  "mostGuestAmount": 170,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe240e918f76056777a097a371d5215e",
		  
		  "name": "Emile",
		  "createdDate": "2025-02-09 05:51:02",
		  "totalOrganizations": 2,
		  "totalTours": 5,
		  "totalDays": 379,
		  "totalCountries": 4,
		  "totalStates": 47,
		  "totalEvents": 131,
		  "eventPercent": 0.655598,
		  "totalScheduleItems": 812,
		  "schedulePercent": 0.427697,
		  "totalGuests": 636,
		  "guestPercent": 0.767226,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "The Orpheum",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 94,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe3c87045ef10257f301619f0acce6c1",
		  
		  "name": "Carmen",
		  "createdDate": "2012-10-03 01:13:46",
		  "totalOrganizations": 11,
		  "totalTours": 5,
		  "totalDays": 341,
		  "totalCountries": 4,
		  "totalStates": 23,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 1327,
		  "schedulePercent": 0.578309,
		  "totalGuests": 162,
		  "guestPercent": 0.56777,
		  "mostGuestDate": "2025-07-31 00:00:00",
		  "mostGuestName": "Mississippi Valley Fairgrounds",
		  "mostGuestCity": "Davenport",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe416d8afab0cb33362cb412a2af65e2",
		  
		  "name": "Corban",
		  "createdDate": "2024-04-29 11:12:00",
		  "totalOrganizations": 10,
		  "totalTours": 11,
		  "totalDays": 843,
		  "totalCountries": 20,
		  "totalStates": 57,
		  "totalEvents": 228,
		  "eventPercent": 0.845195,
		  "totalScheduleItems": 3439,
		  "schedulePercent": 0.877946,
		  "totalGuests": 1025,
		  "guestPercent": 0.850521,
		  "mostGuestDate": "2025-07-29 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 98,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe49e007a9753b6d92a37dbf6c579c7e",
		  
		  "name": "Chris",
		  "createdDate": "2013-01-14 20:22:27",
		  "totalOrganizations": 10,
		  "totalTours": 3,
		  "totalDays": 370,
		  "totalCountries": 4,
		  "totalStates": 21,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1305,
		  "schedulePercent": 0.572756,
		  "totalGuests": 269,
		  "guestPercent": 0.63418,
		  "mostGuestDate": "2025-08-05 00:00:00",
		  "mostGuestName": "Red Rocks Amphitheatre",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe57bfa6e4cc7329f76e56c64a86139d",
		  
		  "name": "Matrix",
		  "createdDate": "2011-08-23 18:13:47",
		  "totalOrganizations": 7,
		  "totalTours": 11,
		  "totalDays": 705,
		  "totalCountries": 19,
		  "totalStates": 74,
		  "totalEvents": 206,
		  "eventPercent": 0.811083,
		  "totalScheduleItems": 2956,
		  "schedulePercent": 0.837602,
		  "totalGuests": 1015,
		  "guestPercent": 0.849501,
		  "mostGuestDate": "2025-08-24 00:00:00",
		  "mostGuestName": "Orpheum Theater",
		  "mostGuestCity": "Los Angeles",
		  "mostGuestAmount": 126,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe5c3442030f5855ba0242c436fc31b7",
		  
		  "name": "Carimei",
		  "createdDate": "2022-01-19 23:26:31",
		  "totalOrganizations": 12,
		  "totalTours": 24,
		  "totalDays": 1868,
		  "totalCountries": 28,
		  "totalStates": 65,
		  "totalEvents": 272,
		  "eventPercent": 0.891999,
		  "totalScheduleItems": 3089,
		  "schedulePercent": 0.850635,
		  "totalGuests": 631,
		  "guestPercent": 0.765639,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Irving Plaza",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 50,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe6b285283717bcdd4ac7821010285b3",
		  
		  "name": "John",
		  "createdDate": "2023-03-16 19:58:16",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 181,
		  "totalCountries": 2,
		  "totalStates": 38,
		  "totalEvents": 180,
		  "eventPercent": 0.765413,
		  "totalScheduleItems": 732,
		  "schedulePercent": 0.399139,
		  "totalGuests": 177,
		  "guestPercent": 0.577969,
		  "mostGuestDate": "2025-04-11 00:00:00",
		  "mostGuestName": "The Grizzly Rose",
		  "mostGuestCity": "Denver",
		  "mostGuestAmount": 52,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe6eaeda35633ce86e67a4d703475376",
		  
		  "name": "Alexis ",
		  "createdDate": "2024-11-13 07:59:08",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 714,
		  "totalCountries": 29,
		  "totalStates": 45,
		  "totalEvents": 93,
		  "eventPercent": 0.523459,
		  "totalScheduleItems": 756,
		  "schedulePercent": 0.407978,
		  "totalGuests": 6,
		  "guestPercent": 0.353014,
		  "mostGuestDate": "2025-08-23 00:00:00",
		  "mostGuestName": "Creamfields Festival",
		  "mostGuestCity": "Daresbury",
		  "mostGuestAmount": 6,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe71060ddf8a942fffa068d7d71a8f1c",
		  
		  "name": "Derek",
		  "createdDate": "2010-08-04 01:03:41",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 679,
		  "totalCountries": 5,
		  "totalStates": 32,
		  "totalEvents": 72,
		  "eventPercent": 0.432684,
		  "totalScheduleItems": 1328,
		  "schedulePercent": 0.578989,
		  "totalGuests": 47,
		  "guestPercent": 0.447303,
		  "mostGuestDate": "2025-02-15 00:00:00",
		  "mostGuestName": "Tahoe Blue Event Center",
		  "mostGuestCity": "Stateline",
		  "mostGuestAmount": 40,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe7234b915eed2879fe698fa3a77427a",
		  
		  "name": "Caroline",
		  "createdDate": "2013-11-11 03:04:18",
		  "totalOrganizations": 16,
		  "totalTours": 9,
		  "totalDays": 126,
		  "totalCountries": 8,
		  "totalStates": 15,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 1159,
		  "schedulePercent": 0.537171,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe744e9706bf76a96cf713d275e24aa7",
		  
		  "name": "Gabriella Gale",
		  "createdDate": "2022-02-14 21:39:51",
		  "totalOrganizations": 9,
		  "totalTours": 5,
		  "totalDays": 1461,
		  "totalCountries": 15,
		  "totalStates": 32,
		  "totalEvents": 182,
		  "eventPercent": 0.768812,
		  "totalScheduleItems": 2445,
		  "schedulePercent": 0.780372,
		  "totalGuests": 1290,
		  "guestPercent": 0.884406,
		  "mostGuestDate": "2025-09-14 00:00:00",
		  "mostGuestName": "Uber Arena",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 130,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe74d4502635e3ab950c4ebb4ac68033",
		  
		  "name": "Nate",
		  "createdDate": "2010-11-05 20:28:41",
		  "totalOrganizations": 11,
		  "totalTours": 14,
		  "totalDays": 1803,
		  "totalCountries": 21,
		  "totalStates": 63,
		  "totalEvents": 239,
		  "eventPercent": 0.860154,
		  "totalScheduleItems": 3789,
		  "schedulePercent": 0.901972,
		  "totalGuests": 159,
		  "guestPercent": 0.56573,
		  "mostGuestDate": "2025-10-20 00:00:00",
		  "mostGuestName": "Dos Equis Pavilion",
		  "mostGuestCity": "Dallas",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe85cd280e222362c107daab947dd80d",
		  
		  "name": "Mike",
		  "createdDate": "2014-09-11 20:57:05",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 644,
		  "totalCountries": 21,
		  "totalStates": 51,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1921,
		  "schedulePercent": 0.697869,
		  "totalGuests": 1162,
		  "guestPercent": 0.87228,
		  "mostGuestDate": "2025-10-10 00:00:00",
		  "mostGuestName": "Huntington Bank Pavilion at Northerly Island",
		  "mostGuestCity": "Chicago",
		  "mostGuestAmount": 272,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe8942c2943354b251361e99044af28c",
		  
		  "name": "Stuart",
		  "createdDate": "2022-07-14 19:40:29",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 384,
		  "totalCountries": 8,
		  "totalStates": 19,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 1372,
		  "schedulePercent": 0.590095,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe8bc096d99bd3186d869cc2abf99e17",
		  
		  "name": "Alexander",
		  "createdDate": "2019-08-29 20:50:11",
		  "totalOrganizations": 6,
		  "totalTours": 7,
		  "totalDays": 540,
		  "totalCountries": 20,
		  "totalStates": 37,
		  "totalEvents": 67,
		  "eventPercent": 0.412511,
		  "totalScheduleItems": 829,
		  "schedulePercent": 0.434157,
		  "totalGuests": 39,
		  "guestPercent": 0.436197,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Wonderfront Festival",
		  "mostGuestCity": "San Diego",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe8ee55d3e120535e4a21d67cf8499c5",
		  
		  "name": "Emelie",
		  "createdDate": "2022-08-08 06:47:27",
		  "totalOrganizations": 5,
		  "totalTours": 6,
		  "totalDays": 174,
		  "totalCountries": 16,
		  "totalStates": 30,
		  "totalEvents": 71,
		  "eventPercent": 0.427924,
		  "totalScheduleItems": 708,
		  "schedulePercent": 0.389506,
		  "totalGuests": 313,
		  "guestPercent": 0.655372,
		  "mostGuestDate": "2025-08-16 00:00:00",
		  "mostGuestName": "TrÃ¤dgÃ¥rdsfÃ¶reningen",
		  "mostGuestCity": "GÃ¶teborg",
		  "mostGuestAmount": 32,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe94484a8409e7c42fa6e886fd45ff34",
		  
		  "name": "Jake ",
		  "createdDate": "2022-05-13 20:10:50",
		  "totalOrganizations": 6,
		  "totalTours": 12,
		  "totalDays": 369,
		  "totalCountries": 9,
		  "totalStates": 43,
		  "totalEvents": 164,
		  "eventPercent": 0.735267,
		  "totalScheduleItems": 1538,
		  "schedulePercent": 0.624887,
		  "totalGuests": 117,
		  "guestPercent": 0.534678,
		  "mostGuestDate": "2025-11-12 00:00:00",
		  "mostGuestName": "9:30 Club",
		  "mostGuestCity": "Washington",
		  "mostGuestAmount": 12,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe95eee92ffc6a9b5ecdd74a685ebc96",
		  
		  "name": "Brent",
		  "createdDate": "2023-01-21 09:37:25",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 244,
		  "totalCountries": 16,
		  "totalStates": 20,
		  "totalEvents": 26,
		  "eventPercent": 0.188917,
		  "totalScheduleItems": 678,
		  "schedulePercent": 0.377946,
		  "totalGuests": 131,
		  "guestPercent": 0.545444,
		  "mostGuestDate": "2025-02-19 00:00:00",
		  "mostGuestName": "Huxleys Neue Welt",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 25,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fe9e07a487323c0cd8778699905e4117",
		  
		  "name": "Cameron",
		  "createdDate": "2022-07-26 00:23:24",
		  "totalOrganizations": 4,
		  "totalTours": 9,
		  "totalDays": 979,
		  "totalCountries": 12,
		  "totalStates": 54,
		  "totalEvents": 220,
		  "eventPercent": 0.833749,
		  "totalScheduleItems": 2234,
		  "schedulePercent": 0.753173,
		  "totalGuests": 180,
		  "guestPercent": 0.580009,
		  "mostGuestDate": "2025-05-04 00:00:00",
		  "mostGuestName": "AT&T Stadium",
		  "mostGuestCity": "Arlington",
		  "mostGuestAmount": 30,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fea79c246e9731a052af30ada06a4761",
		  
		  "name": "William ",
		  "createdDate": "2010-06-15 22:41:36",
		  "totalOrganizations": 8,
		  "totalTours": 1,
		  "totalDays": 73,
		  "totalCountries": 2,
		  "totalStates": 17,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 667,
		  "schedulePercent": 0.373867,
		  "totalGuests": 1002,
		  "guestPercent": 0.846442,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "KFC Yum! Center",
		  "mostGuestCity": "Louisville",
		  "mostGuestAmount": 100,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fea7db41b2cbcf81cd709c4f4da9e3e4",
		  
		  "name": "Cody",
		  "createdDate": "2024-01-03 20:16:35",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 366,
		  "totalCountries": 4,
		  "totalStates": 34,
		  "totalEvents": 78,
		  "eventPercent": 0.462942,
		  "totalScheduleItems": 177,
		  "schedulePercent": 0.144266,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "febf63c7112fe0749cf3f023fabed7d2",
		  
		  "name": "Joshua",
		  "createdDate": "2019-07-13 16:33:49",
		  "totalOrganizations": 8,
		  "totalTours": 8,
		  "totalDays": 1687,
		  "totalCountries": 25,
		  "totalStates": 59,
		  "totalEvents": 263,
		  "eventPercent": 0.88452,
		  "totalScheduleItems": 3413,
		  "schedulePercent": 0.876587,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fec196642ee38d5b9d5914896b7a0719",
		  
		  "name": "Alex",
		  "createdDate": "2019-06-28 08:44:01",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 452,
		  "totalCountries": 18,
		  "totalStates": 31,
		  "totalEvents": 181,
		  "eventPercent": 0.766659,
		  "totalScheduleItems": 3387,
		  "schedulePercent": 0.87432,
		  "totalGuests": 68,
		  "guestPercent": 0.481528,
		  "mostGuestDate": "2025-05-03 00:00:00",
		  "mostGuestName": "Club Space",
		  "mostGuestCity": "Miami",
		  "mostGuestAmount": 47,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fec910fde5a13f36d8b590a63d787d59",
		  
		  "name": "Dominque",
		  "createdDate": "2023-04-25 00:20:02",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 565,
		  "totalCountries": 4,
		  "totalStates": 51,
		  "totalEvents": 191,
		  "eventPercent": 0.784338,
		  "totalScheduleItems": 3774,
		  "schedulePercent": 0.900499,
		  "totalGuests": 1841,
		  "guestPercent": 0.935517,
		  "mostGuestDate": "2025-04-27 00:00:00",
		  "mostGuestName": "Bridgestone Arena",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 108,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fed71851dc1c51612b323d6c3e9cb83e",
		  
		  "name": "Juan Carlos ",
		  "createdDate": "2023-07-06 21:39:43",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 365,
		  "totalCountries": 7,
		  "totalStates": 15,
		  "totalEvents": 19,
		  "eventPercent": 0.142112,
		  "totalScheduleItems": 619,
		  "schedulePercent": 0.356528,
		  "totalGuests": 59,
		  "guestPercent": 0.468155,
		  "mostGuestDate": "2025-05-18 00:00:00",
		  "mostGuestName": "Movistar Arena Madrid",
		  "mostGuestCity": "Madrid",
		  "mostGuestAmount": 36,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fed7d7718bdfc50cc3602d2536166e48",
		  
		  "name": "Ricardo",
		  "createdDate": "2023-07-29 16:47:36",
		  "totalOrganizations": 2,
		  "totalTours": 6,
		  "totalDays": 330,
		  "totalCountries": 8,
		  "totalStates": 47,
		  "totalEvents": 102,
		  "eventPercent": 0.55961,
		  "totalScheduleItems": 705,
		  "schedulePercent": 0.388599,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fedbfca3349515da6152f8f5a12dde4d",
		  
		  "name": "KENANIAH",
		  "createdDate": "2025-02-10 15:45:50",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 87,
		  "totalCountries": 2,
		  "totalStates": 22,
		  "totalEvents": 44,
		  "eventPercent": 0.293631,
		  "totalScheduleItems": 813,
		  "schedulePercent": 0.428151,
		  "totalGuests": 42,
		  "guestPercent": 0.44039,
		  "mostGuestDate": "2025-03-13 00:00:00",
		  "mostGuestName": "The Junction Center",
		  "mostGuestCity": "Manheim",
		  "mostGuestAmount": 26,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "feed2d02fa6d6f37ae407121d7f579be",
		  
		  "name": "Joel",
		  "createdDate": "2017-02-26 02:00:55",
		  "totalOrganizations": 10,
		  "totalTours": 5,
		  "totalDays": 1155,
		  "totalCountries": 22,
		  "totalStates": 61,
		  "totalEvents": 193,
		  "eventPercent": 0.787851,
		  "totalScheduleItems": 3488,
		  "schedulePercent": 0.88146,
		  "totalGuests": 2148,
		  "guestPercent": 0.955689,
		  "mostGuestDate": "2025-06-08 00:00:00",
		  "mostGuestName": "House of Blues Anaheim",
		  "mostGuestCity": "Anaheim",
		  "mostGuestAmount": 78,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fef614cf47a09adaeb5805b3b27d283e",
		  
		  "name": "Dylan",
		  "createdDate": "2023-09-05 01:02:29",
		  "totalOrganizations": 1,
		  "totalTours": 1,
		  "totalDays": 284,
		  "totalCountries": 3,
		  "totalStates": 37,
		  "totalEvents": 73,
		  "eventPercent": 0.437443,
		  "totalScheduleItems": 1140,
		  "schedulePercent": 0.531958,
		  "totalGuests": 374,
		  "guestPercent": 0.683137,
		  "mostGuestDate": "2025-09-26 00:00:00",
		  "mostGuestName": "The Pinnacle",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 56,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fef946127b6ef5aa75c158abff7a1201",
		  
		  "name": "Lisa",
		  "createdDate": "2022-02-02 12:35:32",
		  "totalOrganizations": 5,
		  "totalTours": 13,
		  "totalDays": 468,
		  "totalCountries": 21,
		  "totalStates": 61,
		  "totalEvents": 198,
		  "eventPercent": 0.796578,
		  "totalScheduleItems": 2014,
		  "schedulePercent": 0.716342,
		  "totalGuests": 1001,
		  "guestPercent": 0.846102,
		  "mostGuestDate": "2025-04-23 00:00:00",
		  "mostGuestName": "Terminal 5",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 83,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff01aca5c48ddb71e478fd57408225e3",
		  
		  "name": "Dustin",
		  "createdDate": "2022-02-08 19:55:56",
		  "totalOrganizations": 8,
		  "totalTours": 6,
		  "totalDays": 567,
		  "totalCountries": 10,
		  "totalStates": 46,
		  "totalEvents": 170,
		  "eventPercent": 0.747167,
		  "totalScheduleItems": 2718,
		  "schedulePercent": 0.811537,
		  "totalGuests": 497,
		  "guestPercent": 0.729488,
		  "mostGuestDate": "2025-10-21 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 57,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff0b0a5ca08da7077e0d206123303f5c",
		  
		  "name": "Joseph",
		  "createdDate": "2019-10-24 02:02:12",
		  "totalOrganizations": 1,
		  "totalTours": 4,
		  "totalDays": 184,
		  "totalCountries": 12,
		  "totalStates": 23,
		  "totalEvents": 37,
		  "eventPercent": 0.254873,
		  "totalScheduleItems": 250,
		  "schedulePercent": 0.189937,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff10e427cb0850866a16f645036bbcf1",
		  
		  "name": "Mike ",
		  "createdDate": "2016-07-05 04:52:39",
		  "totalOrganizations": 14,
		  "totalTours": 7,
		  "totalDays": 583,
		  "totalCountries": 25,
		  "totalStates": 67,
		  "totalEvents": 159,
		  "eventPercent": 0.724728,
		  "totalScheduleItems": 2393,
		  "schedulePercent": 0.774139,
		  "totalGuests": 601,
		  "guestPercent": 0.758273,
		  "mostGuestDate": "2025-01-31 00:00:00",
		  "mostGuestName": "Fox Cabaret",
		  "mostGuestCity": "Vancouver",
		  "mostGuestAmount": 76,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff14e6cb520356d7f617e9df98c6092b",
		  
		  "name": "Ashley",
		  "createdDate": "2023-11-22 19:14:48",
		  "totalOrganizations": 4,
		  "totalTours": 2,
		  "totalDays": 126,
		  "totalCountries": 3,
		  "totalStates": 23,
		  "totalEvents": 64,
		  "eventPercent": 0.395059,
		  "totalScheduleItems": 513,
		  "schedulePercent": 0.317316,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff197967caf31490e4a7ace8ec7020f4",
		  
		  "name": "Stick",
		  "createdDate": "2019-10-03 00:14:25",
		  "totalOrganizations": 3,
		  "totalTours": 3,
		  "totalDays": 172,
		  "totalCountries": 4,
		  "totalStates": 33,
		  "totalEvents": 45,
		  "eventPercent": 0.299411,
		  "totalScheduleItems": 842,
		  "schedulePercent": 0.43801,
		  "totalGuests": 164,
		  "guestPercent": 0.569016,
		  "mostGuestDate": "2025-07-01 00:00:00",
		  "mostGuestName": "Ameris Bank Amphitheatre",
		  "mostGuestCity": "Alpharetta",
		  "mostGuestAmount": 88,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff27cf2a4f3f76faab6a404617378934",
		  
		  "name": "Ashley ",
		  "createdDate": "2018-05-18 22:02:13",
		  "totalOrganizations": 17,
		  "totalTours": 4,
		  "totalDays": 522,
		  "totalCountries": 20,
		  "totalStates": 38,
		  "totalEvents": 107,
		  "eventPercent": 0.579442,
		  "totalScheduleItems": 2022,
		  "schedulePercent": 0.717588,
		  "totalGuests": 422,
		  "guestPercent": 0.703536,
		  "mostGuestDate": "2025-06-20 00:00:00",
		  "mostGuestName": "Smart Financial Centre at Sugar Land",
		  "mostGuestCity": "Sugar Land",
		  "mostGuestAmount": 75,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff425fbf8805c7c370b7269639600a41",
		  
		  "name": "Ash",
		  "createdDate": "2024-02-23 04:55:10",
		  "totalOrganizations": 4,
		  "totalTours": 5,
		  "totalDays": 469,
		  "totalCountries": 5,
		  "totalStates": 38,
		  "totalEvents": 69,
		  "eventPercent": 0.419198,
		  "totalScheduleItems": 1188,
		  "schedulePercent": 0.544084,
		  "totalGuests": 436,
		  "guestPercent": 0.707842,
		  "mostGuestDate": "2025-05-16 00:00:00",
		  "mostGuestName": "Ryman Auditorium",
		  "mostGuestCity": "Nashville",
		  "mostGuestAmount": 87,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff441924ade2dd2c94867de34752fe3f",
		  
		  "name": "David",
		  "createdDate": "2013-10-02 01:37:09",
		  "totalOrganizations": 24,
		  "totalTours": 10,
		  "totalDays": 495,
		  "totalCountries": 10,
		  "totalStates": 31,
		  "totalEvents": 95,
		  "eventPercent": 0.534565,
		  "totalScheduleItems": 1508,
		  "schedulePercent": 0.61956,
		  "totalGuests": 491,
		  "guestPercent": 0.727788,
		  "mostGuestDate": "2025-08-14 00:00:00",
		  "mostGuestName": "Tom Moffatt Waikiki Shell",
		  "mostGuestCity": "Honolulu",
		  "mostGuestAmount": 72,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff4e8b5e479d10a83e87dccdcec3bb8d",
		  
		  "name": "Nils",
		  "createdDate": "2018-01-11 20:55:08",
		  "totalOrganizations": 16,
		  "totalTours": 6,
		  "totalDays": 402,
		  "totalCountries": 14,
		  "totalStates": 13,
		  "totalEvents": 163,
		  "eventPercent": 0.733454,
		  "totalScheduleItems": 1543,
		  "schedulePercent": 0.625907,
		  "totalGuests": 296,
		  "guestPercent": 0.647665,
		  "mostGuestDate": "2025-07-04 00:00:00",
		  "mostGuestName": "Tivoli",
		  "mostGuestCity": "KÃ¸benhavn V",
		  "mostGuestAmount": 33,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff54eff17e06ab98dc0edd4395b63b6e",
		  
		  "name": "John ",
		  "createdDate": "2015-03-19 22:39:55",
		  "totalOrganizations": 21,
		  "totalTours": 24,
		  "totalDays": 1505,
		  "totalCountries": 32,
		  "totalStates": 96,
		  "totalEvents": 377,
		  "eventPercent": 0.952969,
		  "totalScheduleItems": 5606,
		  "schedulePercent": 0.969855,
		  "totalGuests": 2556,
		  "guestPercent": 0.970648,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff58aa373b4f38f0a1f46ff283fcdff1",
		  
		  "name": "Matthias",
		  "createdDate": "2024-01-22 13:49:20",
		  "totalOrganizations": 1,
		  "totalTours": 2,
		  "totalDays": 123,
		  "totalCountries": 22,
		  "totalStates": 25,
		  "totalEvents": 60,
		  "eventPercent": 0.37466,
		  "totalScheduleItems": 1205,
		  "schedulePercent": 0.548051,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff71decec63c2aca1564cbb58165f6fc",
		  
		  "name": "Jessica",
		  "createdDate": "2014-10-01 17:32:11",
		  "totalOrganizations": 11,
		  "totalTours": 10,
		  "totalDays": 465,
		  "totalCountries": 13,
		  "totalStates": 48,
		  "totalEvents": 165,
		  "eventPercent": 0.737307,
		  "totalScheduleItems": 2566,
		  "schedulePercent": 0.794538,
		  "totalGuests": 544,
		  "guestPercent": 0.741727,
		  "mostGuestDate": "2025-10-17 00:00:00",
		  "mostGuestName": "Avondale Brewing Company",
		  "mostGuestCity": "Birmingham",
		  "mostGuestAmount": 59,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff791707133cab44a8ef1c767e67ef7d",
		  
		  "name": "Emma",
		  "createdDate": "2023-01-18 23:51:46",
		  "totalOrganizations": 25,
		  "totalTours": 47,
		  "totalDays": 1208,
		  "totalCountries": 33,
		  "totalStates": 84,
		  "totalEvents": 367,
		  "eventPercent": 0.948663,
		  "totalScheduleItems": 4541,
		  "schedulePercent": 0.939257,
		  "totalGuests": 1818,
		  "guestPercent": 0.934157,
		  "mostGuestDate": "2025-10-28 00:00:00",
		  "mostGuestName": "Atlanta Symphony Hall",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 62,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff87c2cd3279d1b6d1b190bcfe403ad5",
		  
		  "name": "Gabriel",
		  "createdDate": "2024-04-07 18:51:04",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 707,
		  "totalCountries": 5,
		  "totalStates": 63,
		  "totalEvents": 208,
		  "eventPercent": 0.814483,
		  "totalScheduleItems": 1897,
		  "schedulePercent": 0.693903,
		  "totalGuests": 274,
		  "guestPercent": 0.637353,
		  "mostGuestDate": "2025-03-10 00:00:00",
		  "mostGuestName": "Factory Theatre",
		  "mostGuestCity": "Marrickville",
		  "mostGuestAmount": 28,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ff9c88c41a0497c63180a59c155a096b",
		  
		  "name": "Adam",
		  "createdDate": "2010-08-30 17:29:49",
		  "totalOrganizations": 8,
		  "totalTours": 4,
		  "totalDays": 795,
		  "totalCountries": 13,
		  "totalStates": 57,
		  "totalEvents": 207,
		  "eventPercent": 0.81267,
		  "totalScheduleItems": 2831,
		  "schedulePercent": 0.825929,
		  "totalGuests": 1224,
		  "guestPercent": 0.8784,
		  "mostGuestDate": "2025-04-26 00:00:00",
		  "mostGuestName": "Saenger Theatre",
		  "mostGuestCity": "New Orleans",
		  "mostGuestAmount": 145,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffa1572d06ce7af4c8d73b66b1d9b112",
		  
		  "name": "Chadrick",
		  "createdDate": "2013-11-29 23:56:05",
		  "totalOrganizations": 36,
		  "totalTours": 16,
		  "totalDays": 2243,
		  "totalCountries": 13,
		  "totalStates": 49,
		  "totalEvents": 249,
		  "eventPercent": 0.86956,
		  "totalScheduleItems": 3252,
		  "schedulePercent": 0.864234,
		  "totalGuests": 1616,
		  "guestPercent": 0.921011,
		  "mostGuestDate": "2025-10-11 00:00:00",
		  "mostGuestName": "Barclays Center",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 144,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffa2a43e6f3e74bef0391421e64a9d24",
		  
		  "name": "Kevin",
		  "createdDate": "2025-08-26 16:12:22",
		  "totalOrganizations": 2,
		  "totalTours": 1,
		  "totalDays": 48,
		  "totalCountries": 2,
		  "totalStates": 8,
		  "totalEvents": 11,
		  "eventPercent": 0.0844288,
		  "totalScheduleItems": 160,
		  "schedulePercent": 0.135313,
		  "totalGuests": 190,
		  "guestPercent": 0.585902,
		  "mostGuestDate": "2025-09-24 00:00:00",
		  "mostGuestName": "Brooklyn Paramount",
		  "mostGuestCity": "Brooklyn",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffa3c1acb2fe168e43c53a702b3b24ea",
		  
		  "name": "Alice",
		  "createdDate": "2012-10-23 12:46:50",
		  "totalOrganizations": 5,
		  "totalTours": 8,
		  "totalDays": 143,
		  "totalCountries": 19,
		  "totalStates": 42,
		  "totalEvents": 66,
		  "eventPercent": 0.406732,
		  "totalScheduleItems": 1326,
		  "schedulePercent": 0.577743,
		  "totalGuests": 403,
		  "guestPercent": 0.69583,
		  "mostGuestDate": "2025-06-24 00:00:00",
		  "mostGuestName": "Radio City Music Hall",
		  "mostGuestCity": "New York",
		  "mostGuestAmount": 58,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffaa88e33758636c88f9ec0ac15eb6be",
		  
		  "name": "Kaj-Even",
		  "createdDate": "2019-04-05 11:19:43",
		  "totalOrganizations": 4,
		  "totalTours": 6,
		  "totalDays": 40,
		  "totalCountries": 10,
		  "totalStates": 9,
		  "totalEvents": 25,
		  "eventPercent": 0.182004,
		  "totalScheduleItems": 226,
		  "schedulePercent": 0.174977,
		  "totalGuests": 1,
		  "guestPercent": 0.31743,
		  "mostGuestDate": "2025-03-25 00:00:00",
		  "mostGuestName": "Kesselhaus",
		  "mostGuestCity": "Berlin",
		  "mostGuestAmount": 1,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffae39cb5b35da45a4b487321be4e4a4",
		  
		  "name": "x",
		  "createdDate": "2021-09-08 10:27:30",
		  "totalOrganizations": 6,
		  "totalTours": 6,
		  "totalDays": 148,
		  "totalCountries": 14,
		  "totalStates": 13,
		  "totalEvents": 74,
		  "eventPercent": 0.443223,
		  "totalScheduleItems": 591,
		  "schedulePercent": 0.347915,
		  "totalGuests": 63,
		  "guestPercent": 0.474275,
		  "mostGuestDate": "2025-08-22 00:00:00",
		  "mostGuestName": "Mosebacketerrassen",
		  "mostGuestCity": "Stockholm",
		  "mostGuestAmount": 63,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffb27bae49431b11994c72cc075682ef",
		  
		  "name": "Ian",
		  "createdDate": "2022-05-28 00:06:18",
		  "totalOrganizations": 2,
		  "totalTours": 2,
		  "totalDays": 483,
		  "totalCountries": 6,
		  "totalStates": 51,
		  "totalEvents": 141,
		  "eventPercent": 0.68257,
		  "totalScheduleItems": 1923,
		  "schedulePercent": 0.698436,
		  "totalGuests": 0,
		  "guestPercent": 0,
		  "mostGuestDate": null,
		  "mostGuestName": null,
		  "mostGuestCity": null,
		  "mostGuestAmount": null,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffc68a2f345c4bea7b464ce5d0318e40",
		  
		  "name": "Eric",
		  "createdDate": "2014-05-27 20:35:22",
		  "totalOrganizations": 31,
		  "totalTours": 18,
		  "totalDays": 1261,
		  "totalCountries": 20,
		  "totalStates": 86,
		  "totalEvents": 417,
		  "eventPercent": 0.962715,
		  "totalScheduleItems": 5466,
		  "schedulePercent": 0.966908,
		  "totalGuests": 2553,
		  "guestPercent": 0.970535,
		  "mostGuestDate": "2025-04-01 00:00:00",
		  "mostGuestName": "Save On Foods Centre",
		  "mostGuestCity": "Victoria",
		  "mostGuestAmount": 127,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffdd912db573be1f37d4b455f56fda56",
		  
		  "name": "Chance",
		  "createdDate": "2022-02-22 01:15:15",
		  "totalOrganizations": 6,
		  "totalTours": 4,
		  "totalDays": 1125,
		  "totalCountries": 9,
		  "totalStates": 39,
		  "totalEvents": 86,
		  "eventPercent": 0.498073,
		  "totalScheduleItems": 781,
		  "schedulePercent": 0.416251,
		  "totalGuests": 87,
		  "guestPercent": 0.504873,
		  "mostGuestDate": "2025-08-20 00:00:00",
		  "mostGuestName": "Red Rocks",
		  "mostGuestCity": "Morrison",
		  "mostGuestAmount": 61,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "ffe2e95ebc6dc575ba2d7cbb8714e33f",
		  
		  "name": "Jason",
		  "createdDate": "2023-06-30 20:32:06",
		  "totalOrganizations": 12,
		  "totalTours": 29,
		  "totalDays": 1467,
		  "totalCountries": 31,
		  "totalStates": 94,
		  "totalEvents": 360,
		  "eventPercent": 0.94617,
		  "totalScheduleItems": 5604,
		  "schedulePercent": 0.969742,
		  "totalGuests": 2960,
		  "guestPercent": 0.980961,
		  "mostGuestDate": "2025-09-12 00:00:00",
		  "mostGuestName": "Lakewood Amphitheatre",
		  "mostGuestCity": "Atlanta",
		  "mostGuestAmount": 247,
		  "sent": 0,
		  "hash": null
		},
		{
		  "id": "fffcd8d8788e3882af51dbbdeae1bf1d",
		  
		  "name": "Nadine",
		  "createdDate": "2014-09-08 10:38:09",
		  "totalOrganizations": 7,
		  "totalTours": 6,
		  "totalDays": 95,
		  "totalCountries": 8,
		  "totalStates": 1,
		  "totalEvents": 24,
		  "eventPercent": 0.175771,
		  "totalScheduleItems": 284,
		  "schedulePercent": 0.208862,
		  "totalGuests": 17,
		  "guestPercent": 0.388033,
		  "mostGuestDate": "2025-06-18 00:00:00",
		  "mostGuestName": "Budapest Park",
		  "mostGuestCity": "Budapest",
		  "mostGuestAmount": 17,
		  "sent": 0,
		  "hash": null
		}
	  ],
}
